// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fomantic-ui-sass/src/themes/default/assets/images/flags.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/outline-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/outline-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/outline-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/outline-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/outline-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/brand-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/brand-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/brand-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/brand-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("fomantic-ui-sass/src/themes/default/assets/fonts/brand-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAAoUAA4AAAAAEPQAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAABRAAAAEQAAABWPeFJAWNtYXAAAAGIAAAAOgAAAUrQEhm3Y3Z0IAAAAcQAAAAUAAAAHAZJ/5RmcGdtAAAB2AAABPkAAAmRigp4O2dhc3AAAAbUAAAACAAAAAgAAAAQZ2x5ZgAABtwAAACuAAAAtt9nBHZoZWFkAAAHjAAAADUAAAA2ASs8e2hoZWEAAAfEAAAAIAAAACQHUwNNaG10eAAAB+QAAAAMAAAADAspAABsb2NhAAAH8AAAAAgAAAAIADgAW21heHAAAAf4AAAAIAAAACAApgm8bmFtZQAACBgAAAF3AAACzcydGhxwb3N0AAAJkAAAACoAAAA7rr1AmHByZXAAAAm8AAAAVgAAAFaSoZr/eJxjYGTewTiBgZWBg6mKaQ8DA0MPhGZ8wGDIyMTAwMTAysyAFQSkuaYwOLxgeMHIHPQ/iyGKmZvBHyjMCJIDAPe9C2B4nGNgYGBmgGAZBkYGEHAB8hjBfBYGDSDNBqQZGZgYGF4w/v8PUvCCAURLMELVAwEjG8OIBwBk5AavAAB4nGNgQANGDEbM3P83gjAAELQD4XicnVXZdtNWFJU8ZHASOmSgoA7X3DhQ68qEKRgwaSrFdiEdHAitBB2kDHTkncc+62uOQrtWH/m07n09JLR0rbYsls++R1tn2DrnRhwjKn0aiGvUoZKXA6msPZZK90lc13Uvj5UMBnFdthJPSZuonSRKat3sUC7xWOsqWSdYJ+PlIFZPVZ5noAziFB5lSUQbRBuplyZJ4onjJ4kWZxAfJUkgJaMQp9LIUEI1GsRS1aFM6dCr1xNx00DKRqMedVhU90PFJ8c1p9SsA0YqVznCFevVRr4bpwMve5DEOsGzrYcxHnisfpQqkIqR6cg/dkpOlIaBVHHUoVbi6DCTX/eRTCrNQKaMYkWl7oG43f102xYxPXQ6vi5KlUaqurnOKJrt0fGogygP2cbppNzQ2fbw5RlTVKtdcbPtQGYNXErJbHSfRAAdJlLj6QFONZwCqRn1R8XZ588BEslclKo8VTKHegOZMzt7cTHtbiersnCknwcyb3Z2452HQ6dXh3/R+hdM4cxHj+Jifj5C+lBqfiJOJKVGWMzyp4YfcVcgQrkxiAsXyuBThDl0RdrZZl3jtTH2hs/5SqlhPQna6KP4fgr9TiQrHGdRo/VInM1j13Wt3GdQS7W7Fzsyr0OVIu7vCwuuM+eEYZ4WC1VfnvneBTT/Bohn/EDeNIVL+5YpSrRvm6JMu2iKCu0SVKVdNsUU7YoppmnPmmKG9h1TzNKeMzLj/8vc55H7HN7xkJv2XeSmfQ+5ad9HbtoPkJtWITdtHblpLyA3rUZu2lWjOnYEGgZpF1IVQdA0svph3Fab9UDWjDR8aWDyLmLI+upER521tcofxX914gsHcmmip7siF5viLq/bFj483e6rj5pG3bDV+MaR8jAeRnocmtBZ+c3hv+1N3S6a7jKqMugBFUwKwABl7UAC0zrbCaT1mqf48gdgXIZ4zkpDtVSfO4am7+V5X/exOfG+x+3GLrdcd3kJWdYNcmP28N9SZKrrH+UtrVQnR6wrJ49VaxhDKrwour6SlHu0tRu/KKmy8l6U1srnk5CbPYMbQlu27mGwI0xpyiUeXlOlKD3UUo6yQyxvKco84JSLC1qGxLgOdQ9qa8TpoXoYGwshhqG0vRBwSCldFd+0ynfxHqtr2Oj4xRXh6XpyEhGf4ir7UfBU10b96A7avGbdMoMpVaqn+4xPsa/b9lFZaaSOsxe3VAfXNOsaORXTT+Rr4HRvOGjdAz1UfDRBI1U1x+jGKGM0ljXl3wR0MVZ+w2jVYvs93E+dpFWsuUuY7JsT9+C0u/0q+7WcW0bW/dcGvW3kip8jMb8tCvw7B2K3ZA3UO5OBGAvIWdAYxhYmdxiug23EbfY/Jqf/34aFRXJXOxq7eerD1ZNRJXfZ8rjLTXZZ16M2R9VOGvsIjS0PN+bY4XIstsRgQbb+wf8x7gF3aVEC4NDIZZiI2nShnurh6h6rsW04VxIBds2x43QAegAuQd8cu9bzCYD13CPnLsB9cgh2yCH4lByCz8i5BfA5OQRfkEMwIIdgl5w7AA/IIXhIDsEeOQSPyNkE+JIcgq/IIYjJIUjIuQ3wmByCJ+QQfE0OwTdGrk5k/pYH2QD6zqKbQKmdGhzaOGRGrk3Y+zxY9oFFZB9aROqRkesT6lMeLPV7i0j9wSJSfzRyY0L9iQdL/dkiUn+xiNRnxpeZIymvDp7zjg7+BJfqrV4AAAAAAQAB//8AD3icY2BkAALmJUwzGEQZZBwk+RkZGBmdGJgYmbIYgMwsoGSiiLgIs5A2owg7I5uSOqOaiT2jmZE8I5gQY17C/09BQEfg3yt+fh8gvYQxD0j68DOJiQn8U+DnZxQDcQUEljLmCwBpBgbG/3//b2SOZ+Zm4GEQcuAH2sblDLSEm8FFVJhJEGgLH6OSHpMdo5EcI3Nk0bEXJ/LYqvZ82VXHGFd6pKTkyCsQwQAAq+QkqAAAeJxjYGRgYADiw5VSsfH8Nl8ZuJlfAEUYzpvO6IXQCb7///7fyLyEmRvI5WBgAokCAFb/DJAAAAB4nGNgZGBgDvqfxRDF/IKB4f935iUMQBEUwAwAi5YFpgPoAAAD6AAAA1kAAAAAAAAAOABbAAEAAAADABYAAQAAAAAAAgAGABMAbgAAAC0JkQAAAAB4nHWQy2rCQBSG//HSi0JbWui2sypKabxgN4IgWHTTbqS4LTHGJBIzMhkFX6Pv0IfpS/RZ+puMpShNmMx3vjlz5mQAXOMbAvnzxJGzwBmjnAs4Rc9ykf7Zcon8YrmMKt4sn9C/W67gAYHlKm7wwQqidM5ogU/LAlfi0nIBF+LOcpH+0XKJ3LNcxq14tXxC71muYCJSy1Xci6+BWm11FIRG1gZ12W62OnK6lYoqStxYumsTKp3KvpyrxPhxrBxPLfc89oN17Op9uJ8nvk4jlciW09yrkZ/42jX+bFc93QRtY+ZyrtVSDm2GXGm18D3jhMasuo3G3/MwgMIKW2hEvKoQBhI12jrnNppooUOaMkMyM8+KkMBFTONizR1htpIy7nPMGSW0PjNisgOP3+WRH5MC7o9ZRR+tHsYT0u6MKPOSfTns7jBrREqyTDezs9/eU2x4WpvWcNeuS511JTE8qCF5H7u1BY1H72S3Ymi7aPD95/9+AN1fhEsAeJxjYGKAAC4G7ICZgYGRiZGZMzkjNTk7N7Eomy05syg5J5WBAQBE1QZBAABLuADIUlixAQGOWbkIAAgAYyCwASNEsAMjcLIEKAlFUkSyCgIHKrEGAUSxJAGIUViwQIhYsQYDRLEmAYhRWLgEAIhYsQYBRFlZWVm4Af+FsASNsQUARAAA", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfOIKAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zryj6HgAAAFwAAAAyGhlYWT/0IhHAAACOAAAADZoaGVhApkB5wAAAnAAAAAkaG10eAJuABIAAAKUAAAAGGxvY2EAjABWAAACrAAAAA5tYXhwAAgAFgAAArwAAAAgbmFtZfC1n04AAALcAAABPHBvc3QAAwAAAAAEGAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQASAEkAtwFuABMAADc0PwE2FzYXFh0BFAcGJwYvASY1EgaABQgHBQYGBQcIBYAG2wcGfwcBAQcECf8IBAcBAQd/BgYAAAAAAQAAAEkApQFuABMAADcRNDc2MzIfARYVFA8BBiMiJyY1AAUGBwgFgAYGgAUIBwYFWwEACAUGBoAFCAcFgAYGBQcAAAABAAAAAQAAqWYls18PPPUACwIAAAAAAM/9o+4AAAAAz/2j7gAAAAAAtwFuAAAACAACAAAAAAAAAAEAAAHg/+AAAAIAAAAAAAC3AAEAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAQAAAAC3ABIAtwAAAAAAAAAKABQAHgBCAGQAAAABAAAABgAUAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAASwAAoAAAAABGgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAS0AAAEtFpovuE9TLzIAAAIkAAAAYAAAAGAIIweQY21hcAAAAoQAAABMAAAATA984gpnYXNwAAAC0AAAAAgAAAAIAAAAEGhlYWQAAALYAAAANgAAADb/0IhHaGhlYQAAAxAAAAAkAAAAJAKZAedobXR4AAADNAAAABgAAAAYAm4AEm1heHAAAANMAAAABgAAAAYABlAAbmFtZQAAA1QAAAE8AAABPPC1n05wb3N0AAAEkAAAACAAAAAgAAMAAAEABAQAAQEBB3JhdGluZwABAgABADr4HAL4GwP4GAQeCgAZU/+Lix4KABlT/4uLDAeLa/iU+HQFHQAAAHkPHQAAAH4RHQAAAAkdAAABJBIABwEBBw0PERQZHnJhdGluZ3JhdGluZ3UwdTF1MjB1RjBEOXVGMERBAAACAYkABAAGAQEEBwoNVp38lA78lA78lA77lA773Z33bxWLkI2Qj44I9xT3FAWOj5CNkIuQi4+JjoePiI2Gi4YIi/uUBYuGiYeHiIiHh4mGi4aLho2Ijwj7FPcUBYeOiY+LkAgO+92L5hWL95QFi5CNkI6Oj4+PjZCLkIuQiY6HCPcU+xQFj4iNhouGi4aJh4eICPsU+xQFiIeGiYaLhouHjYePiI6Jj4uQCA74lBT4lBWLDAoAAAAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAEAADfYOJZfDzz1AAsCAAAAAADP/aPuAAAAAM/9o+4AAAAAALcBbgAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAAAtwABAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAEAAAAAtwASALcAAAAAUAAABgAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBD8AAAC8AAAAYGNtYXAYVtCJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5Zn4huwUAAAF4AAABYGhlYWQGPe1ZAAAC2AAAADZoaGVhB30DyAAAAxAAAAAkaG10eBBKAEUAAAM0AAAAHGxvY2EAmgESAAADUAAAABBtYXhwAAkALwAAA2AAAAAgbmFtZSC8IugAAAOAAAABknBvc3QAAwAAAAAFFAAAACAAAwMTAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADoAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6AL//f//AAAAAAAg6AD//f//AAH/4xgEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAEUAUQO7AvgAGgAAARQHAQYjIicBJjU0PwE2MzIfAQE2MzIfARYVA7sQ/hQQFhcQ/uMQEE4QFxcQqAF2EBcXEE4QAnMWEP4UEBABHRAXFhBOEBCoAXcQEE4QFwAAAAABAAABbgMlAkkAFAAAARUUBwYjISInJj0BNDc2MyEyFxYVAyUQEBf9SRcQEBAQFwK3FxAQAhJtFxAQEBAXbRcQEBAQFwAAAAABAAAASQMlA24ALAAAARUUBwYrARUUBwYrASInJj0BIyInJj0BNDc2OwE1NDc2OwEyFxYdATMyFxYVAyUQEBfuEBAXbhYQEO4XEBAQEBfuEBAWbhcQEO4XEBACEm0XEBDuFxAQEBAX7hAQF20XEBDuFxAQEBAX7hAQFwAAAQAAAAIAAHRSzT9fDzz1AAsEAAAAAADRsdR3AAAAANGx1HcAAAAAA7sDbgAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADuwABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABFAyUAAAMlAAAAAAAAAAoAFAAeAE4AcgCwAAEAAAAHAC0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhWZXJzaW9uIDIuMABWAGUAcgBzAGkAbwBuACAAMgAuADBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhDaGVja2JveABDAGgAZQBjAGsAYgBvAHhSZWd1bGFyAFIAZQBnAHUAbABhAHJDaGVja2JveABDAGgAZQBjAGsAYgBvAHhGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfuIIAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zjo82LgAAAFwAAABVGhlYWQAQ88bAAACxAAAADZoaGVhAwcB6QAAAvwAAAAkaG10eAS4ABIAAAMgAAAAIGxvY2EBNgDeAAADQAAAABJtYXhwAAoAFgAAA1QAAAAgbmFtZVcZpu4AAAN0AAABRXBvc3QAAwAAAAAEvAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDX//3//wAB/+MPLQADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAIABJQElABMAABM0NzY3BTYXFhUUDwEGJwYvASY1AAUGBwEACAUGBoAFCAcGgAUBEgcGBQEBAQcECQYHfwYBAQZ/BwYAAQAAAG4BJQESABMAADc0PwE2MzIfARYVFAcGIyEiJyY1AAWABgcIBYAGBgUI/wAHBgWABwaABQWABgcHBgUFBgcAAAABABIASQC3AW4AEwAANzQ/ATYXNhcWHQEUBwYnBi8BJjUSBoAFCAcFBgYFBwgFgAbbBwZ/BwEBBwQJ/wgEBwEBB38GBgAAAAABAAAASQClAW4AEwAANxE0NzYzMh8BFhUUDwEGIyInJjUABQYHCAWABgaABQgHBgVbAQAIBQYGgAUIBwWABgYFBwAAAAEAAAABAADZuaKOXw889QALAgAAAAAA0ABHWAAAAADQAEdYAAAAAAElAW4AAAAIAAIAAAAAAAAAAQAAAeD/4AAAAgAAAAAAASUAAQAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAABAAAAASUAAAElAAAAtwASALcAAAAAAAAACgAUAB4AQgBkAIgAqgAAAAEAAAAIABQAAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAOAAAAAQAAAAAAAgAOAEcAAQAAAAAAAwAOACQAAQAAAAAABAAOAFUAAQAAAAAABQAWAA4AAQAAAAAABgAHADIAAQAAAAAACgA0AGMAAwABBAkAAQAOAAAAAwABBAkAAgAOAEcAAwABBAkAAwAOACQAAwABBAkABAAOAFUAAwABBAkABQAWAA4AAwABBAkABgAOADkAAwABBAkACgA0AGMAaQBjAG8AbQBvAG8AbgBWAGUAcgBzAGkAbwBuACAAMQAuADAAaQBjAG8AbQBvAG8Abmljb21vb24AaQBjAG8AbQBvAG8AbgBSAGUAZwB1AGwAYQByAGkAYwBvAG0AbwBvAG4ARgBvAG4AdAAgAGcAZQBuAGUAcgBhAHQAZQBkACAAYgB5ACAASQBjAG8ATQBvAG8AbgAuAAAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAAVwAAoAAAAABSgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAdkAAAHZLDXE/09TLzIAAALQAAAAYAAAAGAIIweQY21hcAAAAzAAAABMAAAATA9+4ghnYXNwAAADfAAAAAgAAAAIAAAAEGhlYWQAAAOEAAAANgAAADYAQ88baGhlYQAAA7wAAAAkAAAAJAMHAelobXR4AAAD4AAAACAAAAAgBLgAEm1heHAAAAQAAAAABgAAAAYACFAAbmFtZQAABAgAAAFFAAABRVcZpu5wb3N0AAAFUAAAACAAAAAgAAMAAAEABAQAAQEBCGljb21vb24AAQIAAQA6+BwC+BsD+BgEHgoAGVP/i4seCgAZU/+LiwwHi2v4lPh0BR0AAACIDx0AAACNER0AAAAJHQAAAdASAAkBAQgPERMWGyAlKmljb21vb25pY29tb29udTB1MXUyMHVGMEQ3dUYwRDh1RjBEOXVGMERBAAACAYkABgAIAgABAAQABwAKAA0AVgCfAOgBL/yUDvyUDvyUDvuUDvtvi/emFYuQjZCOjo+Pj42Qiwj3lIsFkIuQiY6Hj4iNhouGi4aJh4eHCPsU+xQFiIiGiYaLhouHjYeOCPsU9xQFiI+Jj4uQCA77b4v3FBWLkI2Pjo8I9xT3FAWPjo+NkIuQi5CJjogI9xT7FAWPh42Hi4aLhomHh4eIiIaJhosI+5SLBYaLh42HjoiPiY+LkAgO+92d928Vi5CNkI+OCPcU9xQFjo+QjZCLkIuPiY6Hj4iNhouGCIv7lAWLhomHh4iIh4eJhouGi4aNiI8I+xT3FAWHjomPi5AIDvvdi+YVi/eUBYuQjZCOjo+Pj42Qi5CLkImOhwj3FPsUBY+IjYaLhouGiYeHiAj7FPsUBYiHhomGi4aLh42Hj4iOiY+LkAgO+JQU+JQViwwKAAAAAAMCAAGQAAUAAAFMAWYAAABHAUwBZgAAAPUAGQCEAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAA8NoB4P/g/+AB4AAgAAAAAQAAAAAAAAAAAAAAIAAAAAAAAgAAAAMAAAAUAAMAAQAAABQABAA4AAAACgAIAAIAAgABACDw2v/9//8AAAAAACDw1//9//8AAf/jDy0AAwABAAAAAAAAAAAAAAABAAH//wAPAAEAAAABAAA5emozXw889QALAgAAAAAA0ABHWAAAAADQAEdYAAAAAAElAW4AAAAIAAIAAAAAAAAAAQAAAeD/4AAAAgAAAAAAASUAAQAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAABAAAAASUAAAElAAAAtwASALcAAAAAUAAACAAAAAAADgCuAAEAAAAAAAEADgAAAAEAAAAAAAIADgBHAAEAAAAAAAMADgAkAAEAAAAAAAQADgBVAAEAAAAAAAUAFgAOAAEAAAAAAAYABwAyAAEAAAAAAAoANABjAAMAAQQJAAEADgAAAAMAAQQJAAIADgBHAAMAAQQJAAMADgAkAAMAAQQJAAQADgBVAAMAAQQJAAUAFgAOAAMAAQQJAAYADgA5AAMAAQQJAAoANABjAGkAYwBvAG0AbwBvAG4AVgBlAHIAcwBpAG8AbgAgADEALgAwAGkAYwBvAG0AbwBvAG5pY29tb29uAGkAYwBvAG0AbwBvAG4AUgBlAGcAdQBsAGEAcgBpAGMAbwBtAG8AbwBuAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiBmaWxsPSJub25lIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTU5Nl8yKSI+PHBhdGggZD0iTTkuNDExNzYgOS43MjY3NUM5LjQxMTc2IDEwLjIwMzIgOS4wMjM1MyAxMC41OTE1IDguNTQ3MDYgMTAuNTkxNUgyLjI3NjQ3QzEuOCAxMC41OTE1IDEuNDExNzYgMTAuMjAzMiAxLjQxMTc2IDkuNzI2NzVWMy40NTYxNkMxLjQxMTc2IDIuOTc5NjkgMS44IDIuNTkxNDUgMi4yNzY0NyAyLjU5MTQ1SDQuMDU4ODJWMS4xNzk2OUgyLjI3NjQ3QzEuMDIzNTMgMS4xNzk2OSAwIDIuMTk3MzMgMCAzLjQ1NjE2VjkuNzMyNjNDMCAxMC45ODU2IDEuMDIzNTMgMTIuMDA5MSAyLjI3NjQ3IDEyLjAwOTFIOC41NTI5NEM5LjgwNTg4IDEyLjAwOTEgMTAuODI5NCAxMC45OTE1IDEwLjgyOTQgOS43MzI2M1Y3Ljk1MDI4SDkuNDE3NjVWOS43MzI2M0w5LjQxMTc2IDkuNzI2NzVaIiBmaWxsPSIjZmZmZmZmIi8+PHBhdGggZD0iTTYuMTc3NjIgMFYxLjQxMTc2SDkuNTg5MzhMMy43MDcwMyA3LjI5NDEyTDQuNzA3MDMgOC4yOTQxMkwxMC41ODk0IDIuNDExNzZWNS44MjM1M0gxMi4wMDExVjBINi4xNzc2MloiIGZpbGw9IiNmZmZmZmYiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJjbGlwMF8xNTk2XzIiPjxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0id2hpdGUiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4K", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "#icons" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "#icons" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "#icons" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --kr-mobile-width: 960px;
  --kr-tablet-width: 1200px;
  --ui-grid-breakpoint: 768px;
  --kr-max-content-width: 1156px;
}

/* Reset Labrador's default table styling */
html {
  font-size: 16px !important;
}

.main.front figure, .main.front h1, .main.front h2, .main.front h3, .main.front h4, .main.front h5 {
  margin: initial;
}

/* Bugfix for clearable dropdown lists */
.kb-labfront.container .ui.dropdown > .dropdown.icon.clear:before {
  content: "\\f00d" !important;
  font-family: "Icons" !important;
}

.kb-labfront.container .ui.dropdown .menu > .item > .text {
  font-family: "Amplitude Wide", "Lato", sans-serif;
  letter-spacing: -0.3px;
  font-weight: 300;
  line-height: 142%;
  letter-spacing: -0.48px;
  font-size: 16px;
}
.kb-labfront.container .ui.dropdown .menu > .item.selected {
  font-weight: 400 !important;
}

.kb-labfront.container .ui.selection.dropdown > .text {
  font-family: "Amplitude Wide", "Lato", sans-serif;
  letter-spacing: -0.3px;
  font-weight: 300;
  line-height: 142%;
  letter-spacing: -0.48px;
  font-size: 16px;
}

.kb-labfront.container .ui.selection.visible.dropdown > .text:not(.default) {
  font-weight: 200 !important;
}

.kb-labfront.container .ui.dropdown.selection .divider.default.text {
  color: #000;
}

header.pageHeader {
  display: none;
}

.page-content > .row:first-child {
  margin: 0px !important;
  max-width: none !important;
}

section.main.front .page-content > .row:first-child {
  margin-top: 0px !important;
}

@media (max-width: 960px) {
  .front > .page-content > .row {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.kb-labfront.container {
  /*******************************
               Reset
  *******************************/
  /* Border-Box */
  /* iPad Input Shadows */
  /*******************************
               Page
  *******************************/
  @import url("https://fonts.googleapis.com/css?family=Amplitude Wide:400,700,400italic,700italic&subset=latin");
  /*******************************
               Headers
  *******************************/
  /*******************************
               Text
  *******************************/
  /*-------------------
          Links
  --------------------*/
  /*******************************
           Scrollbars
  *******************************/
  /* Force Simple Scrollbars */
  /* Inverted UI */
  /*******************************
            Highlighting
  *******************************/
  /* Site */
  /* Form */
  /*******************************
  //@-        Button
  *******************************/
  /*******************************
              States
  *******************************/
  /*--------------
        Hover
  ---------------*/
  /*--------------
        Focus
  ---------------*/
  /*--------------
        Down
  ---------------*/
  /*--------------
       Active
  ---------------*/
  /*--------------
      Loading
  ---------------*/
  /* Specificity hack */
  /*-------------------
        Disabled
  --------------------*/
  /* Basic Group With Disabled */
  /*******************************
               Types
  *******************************/
  /*-------------------
         Animated
  --------------------*/
  /* Horizontal */
  /* Vertical */
  /* Fade */
  /*-------------------
         Inverted
  --------------------*/
  /* Group */
  /* States */
  /* Hover */
  /* Active / Focus */
  /* Active Focus */
  /*-------------------
      Labeled Button
  --------------------*/
  /* Tag */
  /* Right */
  /* Left Side */
  /*-------------------
         Social
  --------------------*/
  /* Facebook */
  /* Twitter */
  /* Google Plus */
  /* Linked In */
  /* YouTube */
  /* Instagram */
  /* Pinterest */
  /* VK */
  /* WhatsApp */
  /* Telegram */
  /*--------------
       Icon
  ---------------*/
  /*******************************
             Variations
  *******************************/
  /*-------------------
         Floated
  --------------------*/
  /*-------------------
         Compact
  --------------------*/
  /*-------------------
          Sizes
  --------------------*/
  /* Dropdown coupled buttons sizes */
  /*--------------
      Icon Only
  ---------------*/
  /*-------------------
          Basic
  --------------------*/
  /* Vertical */
  /* Standard Basic Inverted */
  /* Basic Group */
  /*-------------------
         Tertiary
  --------------------*/
  /*--------------
    Labeled Icon
  ---------------*/
  /* Left Labeled */
  /* Right Labeled */
  /* Loading Icon in Labeled Button */
  /*--------------
       Toggle
  ---------------*/
  /* Toggle (Modifies active state to give affordances) */
  /*--------------
      Circular
  ---------------*/
  /*-------------------
        Or Buttons
  --------------------*/
  /* Fluid Or */
  /*-------------------
         Attached
  --------------------*/
  /* Singular */
  /* Top / Bottom */
  /* Left / Right */
  /* Plural */
  /* Top / Bottom */
  /* Left / Right */
  /*-------------------
          Fluid
  --------------------*/
  /* Fluid Vertical Buttons */
  /*-------------------
         Colors
  --------------------*/
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /* Basic */
  /* Inverted */
  /* Inverted Basic */
  /* Tertiary */
  /*---------------
      Positive
  ----------------*/
  /* Standard */
  /* Basic */
  /*---------------
      Negative
  ----------------*/
  /* Standard */
  /* Basic */
  /*******************************
              Groups
  *******************************/
  /* Clearfix */
  /* Standard Group */
  /* Vertical  Style */
  /*******************************
  //@-        Container
  *******************************/
  /* All Sizes */
  /* Mobile */
  /* Tablet */
  /* Small Monitor */
  /* Large Monitor */
  /*******************************
               Types
  *******************************/
  /* Text Container */
  /* Fluid */
  /*******************************
             Variations
  *******************************/
  /*******************************
  //@-        Divider
  *******************************/
  /*--------------
        Basic
  ---------------*/
  /*--------------
      Coupling
  ---------------*/
  /* Allow divider between each column row */
  /*--------------
     Horizontal
  ---------------*/
  /*--------------
      Vertical
  ---------------*/
  /* Inside grid */
  /*--------------
        Icon
  ---------------*/
  /*--------------
       Header
  ---------------*/
  /*******************************
            Variations
  *******************************/
  /*--------------
      Hidden
  ---------------*/
  /*--------------
      Inverted
  ---------------*/
  /*--------------
      Fitted
  ---------------*/
  /*--------------
      Clearing
  ---------------*/
  /*--------------
      Section
  ---------------*/
  /*--------------
       Sizes
  ---------------*/
  /*******************************
  //@-         Flag
  *******************************/
  /* Sprite */
  /* Flag Sprite Based On http://www.famfamfam.com/lab/icons/flags/ */
  /*rtl:begin:ignore*/
  /*rtl:end:ignore*/
  /*******************************
  //@-        Header
  *******************************/
  /* Standard */
  /*--------------
     Sub Header
  ---------------*/
  /*--------------
        Icon
  ---------------*/
  /* With Text Node */
  /*-------------------
          Image
  --------------------*/
  /*--------------
       Content
  ---------------*/
  /* After Image */
  /* After Icon */
  /*--------------
   Loose Coupling
  ---------------*/
  /* Positioning */
  /*******************************
              Types
  *******************************/
  /*--------------
       Page
  ---------------*/
  /* Sub Header */
  /*--------------
   Content Heading
  ---------------*/
  /* Sub Header */
  /*--------------
     Sub Heading
  ---------------*/
  /*-------------------
          Icon
  --------------------*/
  /*******************************
              States
  *******************************/
  /*******************************
             Variations
  *******************************/
  /*-------------------
        Inverted
  --------------------*/
  /*-------------------
         Colors
  --------------------*/
  /*-------------------
         Aligned
  --------------------*/
  /*-------------------
         Floated
  --------------------*/
  /*-------------------
         Fitted
  --------------------*/
  /*-------------------
        Dividing
  --------------------*/
  /*-------------------
          Block
  --------------------*/
  /*-------------------
         Attached
  --------------------*/
  /* Attached Sizes */
  /*-------------------
          Sizing
  --------------------*/
  /*******************************
  //@-         Icon
  *******************************/
  /*******************************
               Types
  *******************************/
  /*--------------
      Loading
  ---------------*/
  /*******************************
               States
  *******************************/
  /*******************************
             Variations
  *******************************/
  /*-------------------
          Fitted
  --------------------*/
  /*-------------------
           Link
  --------------------*/
  /*-------------------
        Circular
  --------------------*/
  /*-------------------
        Flipped
  --------------------*/
  /*-------------------
        Rotated
  --------------------*/
  /*--------------------------
        Flipped & Rotated
  ---------------------------*/
  /*-------------------
        Bordered
  --------------------*/
  /*-------------------
        Inverted
  --------------------*/
  /* Inverted Shapes */
  /*-------------------
         Colors
  --------------------*/
  /*-------------------
          Sizes
  --------------------*/
  /*******************************
              Groups
  *******************************/
  /* Corner Icon */
  /*
  * Font Awesome 5.9.0 by @fontawesome [https://fontawesome.com]
  * License - https://fontawesome.com/license (Icons: CC BY 4.0 License, Fonts: SIL OFL 1.1 License, CSS: MIT License)
  */
  /*******************************

  Fomantic-UI integration of FontAwesome :

  // class names are separated
  i.icon.angle-left  =>  i.icon.angle.left

  // variations are extracted
  i.icon.circle      =>  i.icon.circle
  i.icon.circle-o    =>  i.icon.circle.outline

  // abbreviation are replaced by full words
  i.icon.*-h         =>  i.icon.*.horizontal
  i.icon.*-v         =>  i.icon.*.vertical
  i.icon.alpha       =>  i.icon.alphabet
  i.icon.asc         =>  i.icon.ascending
  i.icon.desc        =>  i.icon.descending
  i.icon.alt         =>  i.icon.alternate


  Icons are order A-Z in their group, Solid, Outline, Thin (Pro only) and Brand

  *******************************/
  /*******************************
              Icons
  *******************************/
  /* Deprecated *In/Out Naming Conflict) */
  /*******************************
            Solid Icons
  *******************************/
  /* Icons */
  /* Aliases */
  /*******************************
          Outline Icons
  *******************************/
  /* Outline Icon */
  /* Load & Define Icon Font */
  /* Icons */
  /*******************************
            Brand Icons
  *******************************/
  /* Load & Define Brand Font */
  /* Icons */
  /* Aliases */
  /*******************************
  //@-         Image
  *******************************/
  /*******************************
              States
  *******************************/
  /*******************************
            Variations
  *******************************/
  /*--------------
       Inline
  ---------------*/
  /*------------------
    Vertical Aligned
  -------------------*/
  /*--------------
       Rounded
  ---------------*/
  /*--------------
      Bordered
  ---------------*/
  /*--------------
      Circular
  ---------------*/
  /*--------------
       Fluid
  ---------------*/
  /*--------------
       Avatar
  ---------------*/
  /*-------------------
         Spaced
  --------------------*/
  /*-------------------
         Floated
  --------------------*/
  /*--------------
       Sizes
  ---------------*/
  /*******************************
                Groups
  *******************************/
  /*******************************
  //@-       Standard
  *******************************/
  /*--------------------
          Inputs
  ---------------------*/
  /*--------------------
        Placeholder
  ---------------------*/
  /* browsers require these rules separate */
  /*******************************
              States
  *******************************/
  /*--------------------
          Disabled
  ---------------------*/
  /*--------------------
          Active
  ---------------------*/
  /*--------------------
         Loading
  ---------------------*/
  /*--------------------
          Focus
  ---------------------*/
  /*--------------------
          Error
  ---------------------*/
  /* Error Placeholder */
  /* Focused Error Placeholder */
  /*******************************
             Variations
  *******************************/
  /*--------------------
        Transparent
  ---------------------*/
  /* Transparent Icon */
  /* Transparent Inverted */
  /*--------------------
          Icon
  ---------------------*/
  /* Left Icon Input */
  /* Focus */
  /*--------------------
          Labeled
  ---------------------*/
  /* Adjacent Label */
  /* Regular Label on Left */
  /* Regular Label on Right */
  /* Corner Label */
  /* Spacing with corner label */
  /* Left Labeled */
  /* Corner Label Position  */
  /* Labeled and action input error */
  /*--------------------
          Action
  ---------------------*/
  /* Button on Right */
  /* Input Focus */
  /* Button on Left */
  /* Input Focus */
  /*--------------------
         Inverted
  ---------------------*/
  /* Standard */
  /*--------------------
          Fluid
  ---------------------*/
  /*--------------------
          Size
  ---------------------*/
  /*******************************
  //@-        Label
  *******************************/
  /* Link */
  /* Inside Link */
  /* Image */
  /* Icon */
  /* Detail */
  /* Removable label */
  /* Backward compatible positioning */
  /* Label for only an icon */
  /* Right Side Icon */
  /*-------------------
         Group
  --------------------*/
  /*-------------------
         Coupling
  --------------------*/
  /* Remove border radius on attached segment */
  /* Padding on next content after a label */
  /*******************************
               Types
  *******************************/
  /*-------------------
          Tag
  --------------------*/
  /*-------------------
      Corner Label
  --------------------*/
  /* Icon Label */
  /* Left Corner */
  /* Segment */
  /*-------------------
        Ribbon
  --------------------*/
  /* Positioning */
  /* Right Ribbon */
  /* Inside Table */
  /* Inside Table */
  /*-------------------
        Attached
  --------------------*/
  /*******************************
               States
  *******************************/
  /*-------------------
        Disabled
  --------------------*/
  /*-------------------
          Hover
  --------------------*/
  /*-------------------
          Active
  --------------------*/
  /*-------------------
       Active Hover
  --------------------*/
  /*-------------------
        Visible
  --------------------*/
  /*-------------------
        Hidden
  --------------------*/
  /*******************************
             Variations
  *******************************/
  /*-------------------
          Basic
  --------------------*/
  /* Link */
  /*-------------------
         Fluid
  --------------------*/
  /*-------------------
        Inverted
  --------------------*/
  /*-------------------
         Colors
  --------------------*/
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /* Link */
  /* Ribbon */
  /* Basic */
  /* Inverted */
  /* Inverted Link */
  /* Inverted Ribbon */
  /* Inverted Basic */
  /* Inverted Basic Tags */
  /*-------------------
      Horizontal
  --------------------*/
  /*-------------------
        Circular
  --------------------*/
  /*-------------------
        Pointing
  --------------------*/
  /* Arrow */
  /*--- Above ---*/
  /*--- Below ---*/
  /*--- Left ---*/
  /*--- Right ---*/
  /* Basic Pointing */
  /* Pointing */
  /*--- Above ---*/
  /*--- Below ---*/
  /*--- Left ---*/
  /*--- Right ---*/
  /*------------------
    Floating Label
  -------------------*/
  /*-------------------
          Sizes
  --------------------*/
  /*******************************
  //@-        List
  *******************************/
  /*******************************
              Content
  *******************************/
  /* List Item */
  /* Child List */
  /* Child Item */
  /* Icon */
  /* Image */
  /* Content */
  /* Header */
  /* Description */
  /* Child Link */
  /* Linking Item */
  /* Linked Item Icons */
  /* Header Link */
  /* Floated Content */
  /*******************************
              Coupling
  *******************************/
  /*******************************
              Types
  *******************************/
  /*-------------------
        Horizontal
  --------------------*/
  /* Padding on all elements */
  /* Horizontal List */
  /*******************************
              States
  *******************************/
  /*-------------------
        Disabled
  --------------------*/
  /*-------------------
          Hover
  --------------------*/
  /*******************************
            Variations
  *******************************/
  /*-------------------
        Inverted
  --------------------*/
  /* Item Link */
  /* Linking Content */
  /*-------------------
        Aligned
  --------------------*/
  /*-------------------
        Link
  --------------------*/
  /* Inverted */
  /*-------------------
        Selection
  --------------------*/
  /* Inverted */
  /* Celled / Divided Selection List */
  /*-------------------
        Animated
  --------------------*/
  /*-------------------
        Fitted
  --------------------*/
  /*-------------------
        Bulleted
  --------------------*/
  /* Horizontal Bulleted */
  /*-------------------
        Ordered
  --------------------*/
  /* Value */
  /* Child Lists */
  /* Horizontal Ordered */
  /* Suffixed Ordered */
  /*-------------------
        Divided
  --------------------*/
  /* Sub Menu */
  /* Divided bulleted */
  /* Divided Ordered */
  /* Divided Selection */
  /* Divided horizontal */
  /* Inverted */
  /*-------------------
          Celled
  --------------------*/
  /* Padding on all elements */
  /* Sub Menu */
  /* Celled Bulleted */
  /* Celled Ordered */
  /* Celled Horizontal */
  /* Inverted */
  /*-------------------
        Relaxed
  --------------------*/
  /* Very Relaxed */
  /*-------------------
        Sizes
  --------------------*/
  /*******************************
  //@-        Loader
  *******************************/
  /* Standard Size */
  /* Static Shape */
  /* Active Shape */
  /* Speeds */
  /* Active Animation */
  /* Sizes */
  /*-------------------
        Coupling
  --------------------*/
  /* Show inside active dimmer */
  /* Black Dimmer */
  /* White Dimmer (Inverted) */
  /*******************************
              Types
  *******************************/
  /*-------------------
          Text
  --------------------*/
  /*******************************
              States
  *******************************/
  /*******************************
              Variations
  *******************************/
  /*-------------------
          Sizes
  --------------------*/
  /* Loader */
  /* Text Loader */
  /*-------------------
        Colors
  --------------------*/
  /*-------------------
        Inline
  --------------------*/
  /* Centered Inline */
  /*-------------------
        Elastic
  --------------------*/
  /*-------------------
  //@-    Content
  --------------------*/
  /* Image */
  /* Lines */
  /* Any Lines */
  /* Header Image + 2 Lines */
  /* Line Outdent */
  /* Header Line 1 & 2*/
  /* Image Header */
  /* Spacing */
  /* Inverted Content Loader */
  /*******************************
              Variations
  *******************************/
  /*-------------------
          Sizes
  --------------------*/
  /*-------------------
          Fluid
  --------------------*/
  /*******************************
  //@-         Rails
  *******************************/
  /*******************************
            Variations
  *******************************/
  /*--------------
      Internal
  ---------------*/
  /*--------------
      Dividing
  ---------------*/
  /*--------------
      Distance
  ---------------*/
  /*--------------
      Attached
  ---------------*/
  /*--------------
      Sizing
  ---------------*/
  /*******************************
  //@-        Reveal
  *******************************/
  /* Make sure hovered element is on top of other reveal */
  /*******************************
                Types
  *******************************/
  /*--------------
        Slide
  ---------------*/
  /*--------------
        Fade
  ---------------*/
  /*--------------
        Move
  ---------------*/
  /*--------------
      Rotate
  ---------------*/
  /*******************************
                States
  *******************************/
  /*******************************
            Coupling
  *******************************/
  /*******************************
            Variations
  *******************************/
  /*--------------
      Visible
  ---------------*/
  /*--------------
      Instant
  ---------------*/
  /*--------------
      Sizing
  ---------------*/
  /*******************************
  //@-        Segment
  *******************************/
  /* Vertical */
  /*-------------------
      Loose Coupling
  --------------------*/
  /* Header */
  /* Label */
  /* Grid */
  /* Table */
  /* Tab */
  /*******************************
              Types
  *******************************/
  /*-------------------
      Placeholder
  --------------------*/
  /*-------------------
          Piled
  --------------------*/
  /* Piled Attached */
  /*-------------------
        Stacked
  --------------------*/
  /* Add additional page */
  /* Inverted */
  /*-------------------
        Padded
  --------------------*/
  /* Padded vertical */
  /*-------------------
        Compact
  --------------------*/
  /* Compact Group */
  /*-------------------
        Circular
  --------------------*/
  /*-------------------
        Raised
  --------------------*/
  /*******************************
              Groups
  *******************************/
  /* Group */
  /* Nested Segment */
  /* Bottom */
  /* Only */
  /* Nested Group */
  /* Horizontal Group */
  /* Nested Horizontal Group */
  /* Horizontal Segment */
  /* Border Fixes */
  /*******************************
              States
  *******************************/
  /*--------------
      Disabled
  ---------------*/
  /*--------------
      Loading
  ---------------*/
  /*******************************
            Variations
  *******************************/
  /*-------------------
        Basic
  --------------------*/
  /*-------------------
        Clearing
  --------------------*/
  /*-------------------
        Colors
  --------------------*/
  /*-------------------
        Aligned
  --------------------*/
  /*-------------------
        Floated
  --------------------*/
  /*-------------------
        Inverted
  --------------------*/
  /* Nested */
  /* Attached */
  /* Loading */
  /*-------------------
      Emphasis
  --------------------*/
  /* Secondary */
  /* Tertiary */
  /*-------------------
        Attached
  --------------------*/
  /* Middle */
  /* Top */
  /* Bottom */
  /*--------------
      Fitted
  ---------------*/
  /*-------------------
          Size
  --------------------*/
  /*******************************
  //@-        Step
  *******************************/
  /* First Steps */
  /* Last Steps */
  /*******************************
            Singular
  *******************************/
  /* Arrow */
  /* First Step */
  /* Last Step */
  /* Only Step */
  /*******************************
              Content
  *******************************/
  /* Title */
  /* Description */
  /* Icon */
  /* Horizontal Icon */
  /* Link */
  /*******************************
              Types
  *******************************/
  /*--------------
      Ordered
  ---------------*/
  /*--------------
      Vertical
  ---------------*/
  /* Arrow */
  /*---------------
      Responsive
  ----------------*/
  /* Mobile (Default) */
  /*******************************
              States
  *******************************/
  /* Link Hover */
  /* Link Down */
  /* Active */
  /* Active Arrow */
  /* Active Hover */
  /* Completed */
  /* Disabled */
  /*******************************
            Variations
  *******************************/
  /*--------------
    Stackable
  ---------------*/
  /* Tablet Or Below */
  /*--------------
        Fluid
  ---------------*/
  /* Fluid */
  /*--------------
      Attached
  ---------------*/
  /* Top */
  /* Bottom */
  /*-------------------
      Evenly Divided
  --------------------*/
  /*-------------------
        Sizes
  --------------------*/
  /*--------------
      Inverted
  ---------------*/
  /* Active */
  /* Disabled */
  /* Link Hover */
  /* Link Down */
  /*******************************
  //@-         Text
  *******************************/
  /* Sizes */
  /*******************************
  //@-       Breadcrumb
  *******************************/
  /*******************************
            Content
  *******************************/
  /* Divider */
  /* Link */
  /* Icon Divider */
  /* Section */
  /* Loose Coupling */
  /* Inverted */
  /*******************************
              States
  *******************************/
  /*******************************
            Variations
  *******************************/
  /*--------------------
  //@-     Form
  ---------------------*/
  /*--------------------
          Content
  ---------------------*/
  /*--------------------
          Field
  ---------------------*/
  /*--------------------
          Labels
  ---------------------*/
  /*--------------------
      Standard Inputs
  ---------------------*/
  /* Set max height on unusual input */
  /* Text Area */
  /*--------------------
      Checkbox margin
  ---------------------*/
  /*--------------------
        Transparent
  ---------------------*/
  /*--------------------------
    Input w/ attached Button
  ---------------------------*/
  /*--------------------
      Basic Select
  ---------------------*/
  /*--------------------
        Dropdown
  ---------------------*/
  /* Block */
  /* Inline */
  /*--------------------
        UI Input
  ---------------------*/
  /* Block */
  /* Inline  */
  /* Auto Input */
  /* Full Width Input */
  /*--------------------
    Types of Messages
  ---------------------*/
  /* Assumptions */
  /*--------------------
    Validation Prompt
  ---------------------*/
  /*******************************
              States
  *******************************/
  /*--------------------
        Autofilled
  ---------------------*/
  /* Focus */
  /* Error */
  /*--------------------
        Placeholder
  ---------------------*/
  /* browsers require these rules separate */
  /* Error Placeholder */
  /*--------------------
          Focus
  ---------------------*/
  /*--------------------
          Success
  ---------------------*/
  /* On Form */
  /*--------------------
          Warning
  ---------------------*/
  /* On Form */
  /*--------------------
          Error
  ---------------------*/
  /* On Form */
  /* On Field(s) */
  /* Preserve Native Select Stylings */
  /*------------------
      Dropdown Error
  --------------------*/
  /* Hover */
  /* Selected */
  /* Active */
  /*--------------------
      Checkbox Error
  ---------------------*/
  /*--------------------
        Disabled
  ---------------------*/
  /*--------------
      Loading
  ---------------*/
  /*******************************
          Element Types
  *******************************/
  /*--------------------
      Required Field
  ---------------------*/
  /*******************************
            Variations
  *******************************/
  /*--------------------
      Inverted Colors
  ---------------------*/
  /* Inverted Field */
  /*--------------------
      Field Groups
  ---------------------*/
  /* Grouped Vertically */
  /*--------------------
          Fields
  ---------------------*/
  /* Split fields */
  /* Other Combinations */
  /* Swap to full width on mobile */
  /* Sizing Combinations */
  /* Swap to full width on mobile */
  /*--------------------
      Equal Width
  ---------------------*/
  /*--------------------
      Inline Fields
  ---------------------*/
  /* Inline Label */
  /* Grouped Inline Label */
  /* Inline Input */
  /* Label */
  /* Wide */
  /*--------------------
          Sizes
  ---------------------*/
  /* Dropdown */
  /* Dropdown Items */
  /*******************************
  //@-        Standard
  *******************************/
  /*----------------------
        Remove Gutters
  -----------------------*/
  /* Preserve Rows Spacing on Consecutive Grids */
  /*-------------------
        Columns
  --------------------*/
  /* Standard 16 column */
  /*-------------------
          Rows
  --------------------*/
  /*-------------------
        Columns
  --------------------*/
  /* Vertical padding when no rows */
  /*-------------------
        Content
  --------------------*/
  /*-------------------
      Loose Coupling
  --------------------*/
  /* Collapse Margin on Consecutive Grid */
  /* Segment inside Aligned Grid */
  /* Align Dividers with Gutter */
  /* Remove Border on Last Horizontal Segment */
  /*******************************
            Variations
  *******************************/
  /*-----------------------
        Page Grid
  -------------------------*/
  /*-------------------
      Column Count
  --------------------*/
  /* Assume full width with one column */
  /* Grid Based */
  /* Row Based Overrides */
  /* Celled Page */
  /*-------------------
      Column Width
  --------------------*/
  /* Sizing Combinations */
  /*----------------------
      Width per Device
  -----------------------*/
  /* Mobile Sizing Combinations */
  /* Tablet Sizing Combinations */
  /* Computer/Desktop Sizing Combinations */
  /* Large Monitor Sizing Combinations */
  /* Widescreen Sizing Combinations */
  /*----------------------
          Centered
  -----------------------*/
  /*----------------------
          Relaxed
  -----------------------*/
  /* Coupling with UI Divider */
  /*----------------------
          Padded
  -----------------------*/
  /*----------------------
        "Floated"
  -----------------------*/
  /*----------------------
          Divided
  -----------------------*/
  /* Swap from padding to margin on columns to have dividers align */
  /* No divider on first column on row */
  /* No space on top of first row */
  /* Divided Row */
  /* Vertically Divided */
  /* Padded Horizontally Divided */
  /* First Row Vertically Divided */
  /* Inverted Divided */
  /* Relaxed */
  /*----------------------
          Celled
  -----------------------*/
  /* Internally Celled */
  /*----------------------
    Vertically Aligned
  -----------------------*/
  /* Top Aligned */
  /* Middle Aligned */
  /* Bottom Aligned */
  /* Stretched */
  /*----------------------
    Horizontally Centered
  -----------------------*/
  /* Left Aligned */
  /* Center Aligned */
  /* Right Aligned */
  /* Justified */
  /*----------------------
          Colored
  -----------------------*/
  /*----------------------
        Equal Width
  -----------------------*/
  /*----------------------
          Reverse
  -----------------------*/
  /* Mobile */
  /* Tablet */
  /* Computer */
  /*-------------------
        Doubling
  --------------------*/
  /* Tablet Only */
  /* Mobile Only */
  /*-------------------
        Stackable
  --------------------*/
  /*----------------------
      Only (Device)
  -----------------------*/
  /* These include arbitrary class repetitions for forced specificity */
  /* Mobile Only Hide */
  /* Tablet Only Hide */
  /* Computer Only Hide */
  /* Large Screen Only Hide */
  /* Widescreen Only Hide */
  /*-----------------
        Compact
  -----------------*/
  /* Row */
  /* Columns */
  /* Relaxed + Celled */
  /*-----------------
      Very compact
  -----------------*/
  /* Row */
  /* Columns */
  /* Relaxed + Celled */
  /*--------------
  //@-  Menu
  ---------------*/
  /*--------------
      Sub-Menu
  ---------------*/
  /*--------------
        Item
  ---------------*/
  /* Border */
  /*--------------
    Text Content
  ---------------*/
  /*--------------
        Icons
  ---------------*/
  /*--------------
      Button
  ---------------*/
  /*----------------
  Grid / Container
  -----------------*/
  /*--------------
      Inputs
  ---------------*/
  /*--------------
      Header
  ---------------*/
  /*--------------
      Dropdowns
  ---------------*/
  /* Dropdown Icon */
  /* Menu */
  /* Menu Items */
  /* Secondary */
  /* Pointing */
  /* Inverted */
  /* Vertical */
  /* Evenly Divided */
  /*--------------
      Labels
  ---------------*/
  /*--------------
      Images
  ---------------*/
  /*******************************
            Coupling
  *******************************/
  /*--------------
      List
  ---------------*/
  /* Menu divider shouldnt apply */
  /*--------------
      Sidebar
  ---------------*/
  /* Show vertical dividers below last */
  /*--------------
      Container
  ---------------*/
  /*******************************
              States
  *******************************/
  /*--------------
        Hover
  ---------------*/
  /*--------------
      Pressed
  ---------------*/
  /*--------------
      Active
  ---------------*/
  /*--------------
    Active Hover
  ---------------*/
  /*--------------
      Disabled
  ---------------*/
  /*******************************
              Types
  *******************************/
  /*------------------
  Floated Menu / Item
  -------------------*/
  /* Left Floated */
  /* Right Floated */
  /* Center */
  /* Swapped Borders */
  /* Remove Outer Borders */
  /*--------------
      Vertical
  ---------------*/
  /*--- Item ---*/
  /*--- Label ---*/
  /*--- Icon ---*/
  /*--- Border ---*/
  /*--- Sub Menu ---*/
  /* Vertical Active */
  /*--------------
      Tabular
  ---------------*/
  /* Hover */
  /* Active */
  /* Coupling with segment for attachment */
  /* Vertical Tabular (Left) */
  /* Vertical Right Tabular */
  /* Dropdown */
  /*--------------
    Pagination
  ---------------*/
  /* Active */
  /*--------------
    Secondary
  ---------------*/
  /* Item */
  /* No Divider */
  /* Header */
  /* Image */
  /* Hover */
  /* Active */
  /* Active Hover */
  /* Inverted */
  /* Fix item margins */
  /*---------------------
  Secondary Vertical
  -----------------------*/
  /* Sub Menu */
  /* Sub Menu */
  /* Inverted */
  /*---------------------
    Secondary Pointing
  -----------------------*/
  /* Item Types */
  /* Hover */
  /* Pressed */
  /* Active */
  /* Active Hover */
  /* Active Dropdown */
  /* Vertical Pointing */
  /* Vertical Active */
  /* Inverted */
  /* Hover */
  /* Active */
  /*--------------
      Text Menu
  ---------------*/
  /* Border */
  /* Header */
  /* Image */
  /*--- fluid text ---*/
  /*--- vertical text ---*/
  /* Vertical Sub Menu */
  /*--- hover ---*/
  /*--- active ---*/
  /*--- active hover ---*/
  /* Disable Bariations */
  /* Inverted */
  /* Fluid */
  /*--------------
      Icon Only
  ---------------*/
  /* Vertical Menu */
  /* Item */
  /* Icon */
  /* Icon Gylph */
  /* (x) Item Icon */
  /* Vertical Icon */
  /*--------------
    Labeled Icon
  ---------------*/
  /* Menu */
  /* Item */
  /* Icon */
  /* Fluid */
  /*******************************
            Variations
  *******************************/
  /*--------------
      Stackable
  ---------------*/
  /*--------------
      Colors
  ---------------*/
  /*--------------
      Inverted
  ---------------*/
  /* Menu Item */
  /*--- Border ---*/
  /* Sub Menu */
  /* Header */
  /* Disabled */
  /*--- Hover ---*/
  /*--- Pressed ---*/
  /*--- Active ---*/
  /*--- Active Hover ---*/
  /*--------------
      Floated
  ---------------*/
  /*--------------
      Inverted
  ---------------*/
  /*--------------
      Fitted
  ---------------*/
  /*--------------
    Borderless
  ---------------*/
  /*-------------------
        Compact
  --------------------*/
  /*-------------------
          Fluid
  --------------------*/
  /*-------------------
        Evenly Sized
  --------------------*/
  /*--------------
      Fixed
  ---------------*/
  /* Coupling with Grid */
  /*-------------------
        Pointing
  --------------------*/
  /* Active */
  /* Don't double up pointers */
  /* Colors */
  /*--------------
      Attached
  ---------------*/
  /* Middle */
  /* Top */
  /* Bottom */
  /* Attached Menu Item */
  /* Tabular Attached */
  /*--------------
      Sizes
  ---------------*/
  /* Mini */
  /* Tiny */
  /* Small */
  /* Medium */
  /* Large */
  /* Huge */
  /* Big */
  /* Massive */
  /*-------------------
    Inverted dropdowns
  --------------------*/
  /* Vertical */
  /*******************************
  //@-        Message
  *******************************/
  /*--------------
      Content
  ---------------*/
  /* Header */
  /* Default font size */
  /* Paragraph */
  /* List */
  /* Icon */
  /* Close Icon */
  /* First / Last Element */
  /*******************************
              Coupling
  *******************************/
  /*******************************
              States
  *******************************/
  /*--------------
      Visible
  ---------------*/
  /*--------------
      Hidden
  ---------------*/
  /*******************************
              Variations
  *******************************/
  /*--------------
      Compact
  ---------------*/
  /*--------------
      Attached
  ---------------*/
  /*--------------
        Icon
  ---------------*/
  /*--------------
      Floating
  ---------------*/
  /*--------------
      Colors
  ---------------*/
  /*--------------
      Sizes
  ---------------*/
  /*******************************
  //@-         Table
  *******************************/
  /* Prototype */
  /*******************************
              Parts
  *******************************/
  /* Table Content */
  /* Headers */
  /* Footer */
  /* Table Row */
  /* Repeated tbody */
  /* Table Cells */
  /* Icons */
  /* Table Segment */
  /* Responsive */
  /*******************************
              Coupling
  *******************************/
  /* UI Image */
  /*******************************
              Types
  *******************************/
  /*--------------
      Complex
  ---------------*/
  /*--------------
    Definition
  ---------------*/
  /* Highlight Defining Column */
  /* Fix 2nd Column */
  /*******************************
              States
  *******************************/
  /*--------------
      Positive
  ---------------*/
  /*--------------
      Negative
  ---------------*/
  /*--------------
        Error
  ---------------*/
  /*--------------
      Warning
  ---------------*/
  /*--------------
      Active
  ---------------*/
  /*--------------
      Disabled
  ---------------*/
  /*******************************
            Variations
  *******************************/
  /*--------------
      Stackable
  ---------------*/
  /*--------------
  Text Alignment
  ---------------*/
  /*------------------
  Vertical Alignment
  ------------------*/
  /*--------------
      Collapsing
  ---------------*/
  /*--------------
      Fixed
  ---------------*/
  /*--------------
    Selectable
  ---------------*/
  /* Selectable Cell Link */
  /* Other States */
  /*-------------------
        Attached
  --------------------*/
  /* Middle */
  /* Top */
  /* Bottom */
  /*--------------
      Striped
  ---------------*/
  /* Table Striping */
  /* Stripes */
  /* Allow striped active hover */
  /*--------------
    Single Line
  ---------------*/
  /*-------------------
        Colors
  --------------------*/
  /*--------------
    Column Count
  ---------------*/
  /* Grid Based */
  /* Column Width */
  /*--------------
      Sortable
  ---------------*/
  /* Hover */
  /* Sorted */
  /* Sorted Hover */
  /* Inverted */
  /*--------------
      Inverted
  ---------------*/
  /* Text Color */
  /* Definition */
  /*--------------
    Collapsing
  ---------------*/
  /*--------------
        Basic
  ---------------*/
  /*! .ui.basic.table > tbody > tr {
    border-bottom: \$table-basic-cell-border;
  } */
  /* Very Basic */
  /*--------------
      Celled
  ---------------*/
  /*--------------
      Padded
  ---------------*/
  /* Very */
  /*--------------
      Compact
  ---------------*/
  /* Very */
  /*--------------
        Sizes
  ---------------*/
  /* Small */
  /* Standard */
  /* Large */
  /*******************************
  //@-     Advertisement
  *******************************/
  /*--------------
      Common
  ---------------*/
  /* Leaderboard */
  /* Medium Rectangle */
  /* Large Rectangle */
  /* Half Page */
  /*--------------
      Square
  ---------------*/
  /* Square */
  /* Small Square */
  /*--------------
      Rectangle
  ---------------*/
  /* Small Rectangle */
  /* Vertical Rectangle */
  /*--------------
      Button
  ---------------*/
  /*--------------
    Skyscrapers
  ---------------*/
  /* Skyscraper */
  /* Wide Skyscraper */
  /*--------------
      Banners
  ---------------*/
  /* Banner */
  /* Vertical Banner */
  /* Top Banner */
  /* Half Banner */
  /*--------------
      Boards
  ---------------*/
  /* Leaderboard */
  /* Billboard */
  /*--------------
      Panorama
  ---------------*/
  /* Panorama */
  /*--------------
      Netboard
  ---------------*/
  /* Netboard */
  /*--------------
      Mobile
  ---------------*/
  /* Large Mobile Banner */
  /* Mobile Leaderboard */
  /*******************************
              Types
  *******************************/
  /* Mobile Sizes */
  /*******************************
            Variations
  *******************************/
  /*******************************
  //@-        Standard
  *******************************/
  /*--------------
        Card
  ---------------*/
  /*--------------
        Cards
  ---------------*/
  /* Clearing */
  /* Consecutive Card Groups Preserve Row Spacing */
  /*--------------
    Rounded Edges
  ---------------*/
  /*--------------
      Images
  ---------------*/
  /*--------------
      Content
  ---------------*/
  /* Default Header Size */
  /*----------------
  Floated Content
  -----------------*/
  /*--------------
      Aligned
  ---------------*/
  /*--------------
    Content Image
  ---------------*/
  /*--------------
    Description
  ---------------*/
  /*--------------
      Paragraph
  ---------------*/
  /*--------------
        Meta
  ---------------*/
  /*--------------
        Links
  ---------------*/
  /* Generic */
  /* Header */
  /* Meta */
  /*--------------
      Buttons
  ---------------*/
  /*--------------
        Dimmer
  ---------------*/
  /*--------------
      Labels
  ---------------*/
  /*-----Star----- */
  /* Icon */
  /*-----Like----- */
  /* Icon */
  /*----------------
    Extra Content
  -----------------*/
  /*******************************
            Variations
  *******************************/
  /*-------------------
        Horizontal
  --------------------*/
  /*-------------------
        Raised
  --------------------*/
  /*-------------------
        Centered
  --------------------*/
  /*-------------------
          Fluid
  --------------------*/
  /*-------------------
          Link
  --------------------*/
  /*-------------------
        Colors
  --------------------*/
  /*--------------
    Card Count
  ---------------*/
  /*-------------------
        Doubling
  --------------------*/
  /* Mobile Only */
  /* Tablet Only */
  /*-------------------
        Stackable
  --------------------*/
  /*--------------
        Size
  ---------------*/
  /*-----------------
        Inverted
  ------------------*/
  /* Content */
  /* Header */
  /* Description */
  /* Meta */
  /* Extra */
  /* Link card(s) */
  /*******************************
  //@-        Standard
  *******************************/
  /*--------------
      Comments
  ---------------*/
  /*--------------
      Comment
  ---------------*/
  /*--------------------
      Nested Comments
  ---------------------*/
  /*--------------
      Avatar
  ---------------*/
  /*--------------
      Content
  ---------------*/
  /* If there is an avatar move content over */
  /*--------------
      Author
  ---------------*/
  /*--------------
      Metadata
  ---------------*/
  /*--------------------
      Comment Text
  ---------------------*/
  /*--------------------
      User Actions
  ---------------------*/
  /*--------------------
        Reply Form
  ---------------------*/
  /*******************************
              State
  *******************************/
  /*******************************
            Variations
  *******************************/
  /*--------------------
          Threaded
  ---------------------*/
  /*--------------------
          Minimal
  ---------------------*/
  /*-------------------
          Sizes
  --------------------*/
  /*-------------------
          Inverted
  --------------------*/
  /*******************************
  //@-      Activity Feed
  *******************************/
  /*******************************
              Content
  *******************************/
  /* Event */
  /* Event Label */
  /*--------------
      Content
  ---------------*/
  /* Content */
  /* Link */
  /*--------------
        Date
  ---------------*/
  /*--------------
      Summary
  ---------------*/
  /* Summary Image */
  /*--------------
        User
  ---------------*/
  /*--------------
    Inline Date
  ---------------*/
  /* Date inside Summary */
  /*--------------
    Extra Summary
  ---------------*/
  /* Images */
  /* Text */
  /*--------------
        Meta
  ---------------*/
  /* First element */
  /* Action */
  /*******************************
              Variations
  *******************************/
  /*------------------
        Inverted
  -------------------*/
  /*******************************
  //@-        Standard
  *******************************/
  /*--------------
        Item
  ---------------*/
  /*--------------
        Items
  ---------------*/
  /*--------------
        Item
  ---------------*/
  /*--------------
      Images
  ---------------*/
  /*--------------
      Content
  ---------------*/
  /* Default Header Size */
  /*--------------
      Floated
  ---------------*/
  /*--------------
    Content Image
  ---------------*/
  /*--------------
    Description
  ---------------*/
  /*--------------
      Paragraph
  ---------------*/
  /*--------------
        Meta
  ---------------*/
  /*--------------
        Links
  ---------------*/
  /* Generic */
  /* Header */
  /* Meta */
  /*--------------
      Labels
  ---------------*/
  /*-----Star----- */
  /* Icon */
  /*-----Like----- */
  /* Icon */
  /*----------------
    Extra Content
  -----------------*/
  /*******************************
            Responsive
  *******************************/
  /* Default Image Width */
  /* Tablet Only */
  /* Mobile Only */
  /*******************************
            Variations
  *******************************/
  /*-------------------
        Aligned
  --------------------*/
  /*--------------
      Relaxed
  ---------------*/
  /*-------------------
        Divided
  --------------------*/
  /* Relaxed Divided */
  /*-------------------
          Link
  --------------------*/
  /*--------------
        Size
  ---------------*/
  /*---------------
    Unstackable
  ----------------*/
  /*--------------
      Inverted
  ---------------*/
  /*******************************
  //@-       Statistic
  *******************************/
  /* Standalone */
  /*******************************
              Group
  *******************************/
  /* Grouped */
  /* Clearing */
  /*******************************
              Content
  *******************************/
  /*--------------
        Value
  ---------------*/
  /*--------------
      Label
  ---------------*/
  /* Top Label */
  /* Bottom Label */
  /*******************************
              Types
  *******************************/
  /*--------------
    Icon Value
  ---------------*/
  /*--------------
    Text Value
  ---------------*/
  /*--------------
    Image Value
  ---------------*/
  /*******************************
              Variations
  *******************************/
  /*--------------
        Count
  ---------------*/
  /*--------------
    Horizontal
  ---------------*/
  /*--------------
      Inverted
  ---------------*/
  /*--------------
      Colors
  ---------------*/
  /*--------------
      Floated
  ---------------*/
  /*--------------
      Stackable
  ---------------*/
  /*--------------
      Sizes
  ---------------*/
  /* Mini */
  /* Tiny */
  /* Small */
  /* Medium */
  /* Large */
  /* Huge */
  /*******************************
  //@-        Accordion
  *******************************/
  /* Title */
  /* Default Styling */
  /* Default Styling */
  /* Arrow */
  /*--------------
      Coupling
  ---------------*/
  /* Menu */
  /* Header */
  /*******************************
              States
  *******************************/
  /*******************************
              Types
  *******************************/
  /*--------------
      Styled
  ---------------*/
  /* Content */
  /* Hover */
  /* Active */
  /*******************************
              States
  *******************************/
  /*--------------
    Not Active
  ---------------*/
  /*******************************
            Variations
  *******************************/
  /*--------------
      Fluid
  ---------------*/
  /*--------------
      Inverted
  ---------------*/
  /* Dropdown Icon */
  /*******************************
  //@-        Popup
  *******************************/
  /*******************************
              Calendar
  *******************************/
  /*******************************
              Grid
  *******************************/
  /*******************************
              Table
  *******************************/
  /*--------------
      States
  ---------------*/
  /*******************************
              States
  *******************************/
  /*--------------------
          Disabled
  ---------------------*/
  /*******************************
  //@-       Checkbox
  *******************************/
  /*--------------
      Content
  ---------------*/
  /* HTML Checkbox */
  /*--------------
        Box
  ---------------*/
  /*--------------
      Checkmark
  ---------------*/
  /*--------------
        Label
  ---------------*/
  /* Inside */
  /* Outside */
  /*******************************
            States
  *******************************/
  /*--------------
        Hover
  ---------------*/
  /*--------------
        Down
  ---------------*/
  /*--------------
      Focus
  ---------------*/
  /*--------------
      Active
  ---------------*/
  /*--------------
    Indeterminate
  ---------------*/
  /*--------------
    Active Focus
  ---------------*/
  /*--------------
      Read-Only
  ---------------*/
  /*--------------
      Disabled
  ---------------*/
  /*--------------
      Hidden
  ---------------*/
  /* Initialized checkbox moves input below element
  to prevent manually triggering */
  /* Selectable Label */
  /*******************************
              Types
  *******************************/
  /*--------------
      Radio
  ---------------*/
  /* Box */
  /* Bullet */
  /* Radio Checkbox */
  /* Focus */
  /* Indeterminate */
  /* Active */
  /* Active Focus */
  /*--------------
      Slider
  ---------------*/
  /* Input */
  /* Label */
  /* Line */
  /* Handle */
  /* Focus */
  /* Hover */
  /* Active */
  /* Active Focus */
  /*--------------
      Toggle
  ---------------*/
  /* Input */
  /* Label */
  /* Switch */
  /* Handle */
  /* Focus */
  /* Hover */
  /* Active */
  /* Active Focus */
  /*******************************
              Variations
  *******************************/
  /*--------------
      Fitted
  ---------------*/
  /*--------------
      Inverted
  ---------------*/
  /* Hover */
  /*Slider Label */
  /* Slider Line */
  /* Slider Hover */
  /* Slider Active */
  /* Slider Active Focus */
  /* Toggle Switch */
  /* Toggle Hover */
  /* Toggle Active */
  /* Toggle Active Focus */
  /*--------------------
          Size
  ---------------------*/
  /* Checkmark */
  /* Checked */
  /* Indeterminate */
  /*  UTF Reference
  .check:before { content: '\\e800'; }
  .dash:before  { content: '\\e801'; }
  .plus:before { content: '\\e802'; }
  */
  /*******************************
  //@-        Dimmer
  *******************************/
  /* Dimmer Content */
  /* Loose Coupling */
  /* Scrollbars */
  /*******************************
              States
  *******************************/
  /* Animating */
  /* Animating / Active / Visible */
  /* Disabled */
  /*******************************
            Variations
  *******************************/
  /*--------------
      Legacy
  ---------------*/
  /* Animating / Active / Visible */
  /*--------------
      Alignment
  ---------------*/
  /*--------------
        Page
  ---------------*/
  /*--------------
      Blurring
  ---------------*/
  /* Dimmer Color */
  /*--------------
      Aligned
  ---------------*/
  /*--------------
      Shades
  ---------------*/
  /*--------------
      Inverted
  ---------------*/
  /*--------------
  Inverted Shades
  ---------------*/
  /*--------------
      Simple
  ---------------*/
  /* Displays without javascript */
  /*--------------
      Partially
  ----------------*/
  /*******************************
  //@-        Dropdown
  *******************************/
  /*******************************
              Content
  *******************************/
  /*--------------
        Menu
  ---------------*/
  /*--------------
    Hidden Input
  ---------------*/
  /*--------------
  Dropdown Icon
  ---------------*/
  /*--------------
        Text
  ---------------*/
  /*--------------
      Menu Item
  ---------------*/
  /*--------------
    Floated Content
  ---------------*/
  /*--------------
    Menu Divider
  ---------------*/
  /*-----------------
    Item Description
  -------------------*/
  /*-----------------
        Message
  -------------------*/
  /*--------------
      Sub Menu
  ---------------*/
  /* Hide Arrow */
  /*--------------
    Sub Elements
  ---------------*/
  /* Icons / Flags / Labels / Image */
  /*--------------
      Image
  ---------------*/
  /*******************************
              Coupling
  *******************************/
  /*--------------
        Menu
  ---------------*/
  /* Remove Menu Item Divider */
  /* Prevent Menu Item Border */
  /* Automatically float dropdown menu right on last menu item */
  /*--------------
        Label
  ---------------*/
  /* Dropdown Menu */
  /*--------------
      Button
  ---------------*/
  /* No Margin On Icon Button */
  /*******************************
                Types
  *******************************/
  /*--------------
      Selection
  ---------------*/
  /* Displays like a select box */
  /* Compact */
  /*  Selection Menu */
  /*--------------
      Message
  ---------------*/
  /* Menu Item */
  /* User Item */
  /* Hover */
  /* Active */
  /* Focus */
  /* Visible */
  /* Visible Hover */
  /* Dropdown Icon */
  /* Connecting Border */
  /* Empty Connecting Border */
  /*--------------
    Searchable
  ---------------*/
  /* Search Selection */
  /* Search Dropdown */
  /* Text Layering */
  /* Search Selection */
  /* Used to size multi select input to character width */
  /* Active/Visible Search */
  /* Filtered Text */
  /* Search Menu */
  /* Clearable Selection */
  /*--------------
      Multiple
  ---------------*/
  /* Multiple Selection */
  /* Multiple Search Selection */
  /* Selection Label */
  /* Dropdown Icon */
  /* Text */
  /*-----------------
    Multiple Search
  -----------------*/
  /* Prompt Text */
  /* Search */
  /*--------------
      Inline
  ---------------*/
  /*******************************
              States
  *******************************/
  /*--------------------
          Active
  ----------------------*/
  /* Menu Item Active */
  /*--------------------
          Hover
  ----------------------*/
  /* Menu Item Hover */
  /*--------------------
        Loading
  ---------------------*/
  /* Coupling */
  /*--------------------
      Default Text
  ----------------------*/
  /*--------------------
          Loading
  ----------------------*/
  /* Used To Check Position */
  /*--------------------
      Keyboard Select
  ----------------------*/
  /* Selected Item */
  /*--------------------
      Search Filtered
  ----------------------*/
  /* Filtered Item */
  /*--------------------
          Error
  ----------------------*/
  /* Item Hover */
  /* Item Active */
  /*--------------------
          Clear
  ----------------------*/
  /*--------------------
          Disabled
  ----------------------*/
  /* Disabled */
  /*******************************
            Variations
  *******************************/
  /*--------------
      Direction
  ---------------*/
  /* Flyout Direction */
  /* Default Side (Right) */
  /* Leftward Opening Menu */
  /*--------------
      Upward
  ---------------*/
  /* Upward Main Menu */
  /* Upward Sub Menu */
  /* Active Upward */
  /* Selection */
  /* Active Upward */
  /* Visible Upward */
  /* Visible Hover Upward */
  /*--------------
      Scrolling
  ---------------*/
  /*  Selection Menu */
  /* Scrollbar in IE */
  /*--------------
      Columnar
  ---------------*/
  /*--------------
      Simple
  ---------------*/
  /* Displays without javascript */
  /* Visible */
  /* Scrolling */
  /*--------------
        Fluid
  ---------------*/
  /*--------------
      Floating
  ---------------*/
  /*--------------
      Pointing
  ---------------*/
  /* Top Left Pointing */
  /* Top Right Pointing */
  /* Left Pointing */
  /* Right Pointing */
  /* Bottom Pointing */
  /* Reverse Sub-Menu Direction */
  /* Bottom Left */
  /* Bottom Right */
  /* Upward pointing */
  /* Right Pointing Upward */
  /* Left Pointing Upward */
  /*--------------------
          Sizes
  ---------------------*/
  /* Dropdown Size */
  /* Dropdown Item Size */
  /*--------------
      Inverted
  ---------------*/
  /* General rules and basic dropdowns */
  /* Selection */
  /* Fixing the border */
  /* Labels */
  /* Selection for form elements */
  /* Scrollbars */
  /* Dropdown Carets */
  /* Sub Menu */
  /* Vertical Menu Dropdown */
  /* Icons for Reference
  .dropdown.down.icon {
    content: "\\f0d7";
  }
  .dropdown.up.icon {
    content: "\\f0d8";
  }
  .dropdown.left.icon {
    content: "\\f0d9";
  }
  .dropdown.icon.icon {
    content: "\\f0da";
  }
  */
  /*******************************
  //@-        Types
  *******************************/
  /*-----------------
    Embedded Content
  ------------------*/
  /*-----------------
        Embed
  ------------------*/
  /*--------------
    Placeholder
  ---------------*/
  /*--------------
        Icon
  ---------------*/
  /*******************************
              States
  *******************************/
  /*--------------
      Hover
  ---------------*/
  /*--------------
      Active
  ---------------*/
  /*******************************
            Variations
  *******************************/
  /*******************************
  //@-         Modal
  *******************************/
  /*******************************
              Content
  *******************************/
  /*--------------
      Close
  ---------------*/
  /*--------------
      Header
  ---------------*/
  /*--------------
      Content
  ---------------*/
  /* Image */
  /* Description */
  /*rtl:ignore*/
  /*--------------
      Actions
  ---------------*/
  /*-------------------
        Responsive
  --------------------*/
  /* Modal Width */
  /* Tablet and Mobile */
  /* Mobile */
  /*--------------
      Coupling
  ---------------*/
  /*******************************
              Types
  *******************************/
  /* Resort to margin positioning if legacy */
  /*******************************
              States
  *******************************/
  /*******************************
            Variations
  *******************************/
  /*--------------
    Aligned
  ---------------*/
  /*--------------
      Scrolling
  ---------------*/
  /* Scrolling Dimmer */
  /* Undetached Scrolling */
  /* Scrolling Content */
  /*--------------
    Full Screen
  ---------------*/
  /*--------------
        Size
  ---------------*/
  /* Mini */
  /* Mini Modal Width */
  /* Tiny */
  /* Tiny Modal Width */
  /* Small */
  /* Small Modal Width */
  /* Large Modal Width */
  /*****************************
            Inverted
  *******************************/
  /*******************************
  //@-         Nag
  *******************************/
  /*******************************
              States
  *******************************/
  /* Hover */
  /*******************************
            Variations
  *******************************/
  /*--------------
      Static
  ---------------*/
  /*--------------
      Fixed
  ---------------*/
  /*--------------
      Bottom
  ---------------*/
  /*--------------
      White
  ---------------*/
  /*******************************
            Groups
  *******************************/
  /*******************************
  //@-        Popup
  *******************************/
  /*******************************
              Types
  *******************************/
  /*--------------
      Tooltip
  ---------------*/
  /* Content */
  /* Arrow */
  /* Popup */
  /* Default Position (Top Center) */
  /* Animation */
  /* Animation Position */
  /*--------------
      Inverted
  ---------------*/
  /* Arrow */
  /* Arrow Position */
  /* Popup  */
  /*--------------
      Position
  ---------------*/
  /* Top Center */
  /* Top Left */
  /* Top Right */
  /* Bottom Center */
  /* Bottom Left */
  /* Bottom Right */
  /* Left Center */
  /* Right Center */
  /* Arrow */
  /* Inverted Arrow Color */
  /*--------------
      Size
  ---------------*/
  /*--------------
      Basic
  ---------------*/
  /*--------------
      Spacing
  ---------------*/
  /* Extending from Top */
  /* Extending from Vertical Center */
  /* Extending from Bottom */
  /*--------------
      Pointer
  ---------------*/
  /*--- Below ---*/
  /*rtl:rename*/
  /*rtl:rename*/
  /*--- Above ---*/
  /*rtl:rename*/
  /*rtl:rename*/
  /*--- Left Center ---*/
  /*rtl:rename*/
  /*--- Right Center  ---*/
  /*rtl:rename*/
  /* Arrow Color By Location */
  /* Inverted Arrow Color */
  /*******************************
              Coupling
  *******************************/
  /* Immediate Nested Grid */
  /*******************************
              States
  *******************************/
  /*******************************
              Variations
  *******************************/
  /*--------------
      Basic
  ---------------*/
  /*--------------
      Wide
  ---------------*/
  /*--------------
      Fluid
  ---------------*/
  /*--------------
      Colors
  ---------------*/
  /* Inverted colors  */
  /*--------------
      Flowing
  ---------------*/
  /*--------------
      Sizes
  ---------------*/
  /*******************************
  //@-       Progress
  *******************************/
  /*******************************
              Content
  *******************************/
  /* Activity Bar */
  /* Percent Complete */
  /* Label */
  /*******************************
              Types
  *******************************/
  /* Indicating */
  /* Indicating Label */
  /* Inverted Indicating Label */
  /* Single Digits */
  /* Indicating Success */
  /* Multiple */
  /*******************************
              States
  *******************************/
  /*--------------
      Success
  ---------------*/
  /*--------------
      Warning
  ---------------*/
  /*--------------
      Error
  ---------------*/
  /*--------------
      Active
  ---------------*/
  /*--------------
      Disabled
  ---------------*/
  /*******************************
            Variations
  *******************************/
  /*--------------
      Inverted
  ---------------*/
  /*--------------
      Attached
  ---------------*/
  /* bottom attached */
  /* top attached */
  /* Coupling */
  /*--------------
      Colors
  ---------------*/
  /*--------------
      Sizes
  ---------------*/
  /*---------------
    Indeterminate
  ----------------*/
  /*******************************
  //@-       Rating
  *******************************/
  /* Icon */
  /*******************************
              Types
  *******************************/
  /*-------------------
        Standard
  --------------------*/
  /* Inactive Icon */
  /* Active Icon */
  /* Selected Icon */
  /*--------------
      Colors
  -------------- */
  /*******************************
              States
  *******************************/
  /*-------------------
        Disabled
  --------------------*/
  /* disabled rating */
  /*-------------------
    User Interactive
  --------------------*/
  /* Selected Rating */
  /*******************************
            Variations
  *******************************/
  /*******************************
  //@-         Search
  *******************************/
  /*--------------
      Icon
  ---------------*/
  /*--------------
      Results
  ---------------*/
  /*--------------
      Result
  ---------------*/
  /* Image */
  /*--------------
        Info
  ---------------*/
  /*--------------
      Message
  ---------------*/
  /* View All Results */
  /*******************************
              States
  *******************************/
  /*--------------------
        Focus
  ---------------------*/
  /*--------------------
        Loading
  ---------------------*/
  /*--------------
        Hover
  ---------------*/
  /*--------------
        Active
  ---------------*/
  /*--------------------
          Disabled
  ----------------------*/
  /* Disabled */
  /*******************************
            Types
  *******************************/
  /*--------------
      Selection
  ---------------*/
  /* Remove input */
  /*--------------
      Category
  ---------------*/
  /* Category */
  /* Last Category */
  /* First / Last */
  /* Category Result Name */
  /* Category Result */
  /*******************************
            Variations
  *******************************/
  /*-------------------
      Left / Right
  --------------------*/
  /*--------------
      Fluid
  ---------------*/
  /*--------------
        Sizes
  ---------------*/
  /*--------------
        Mobile
  ---------------*/
  /*******************************
  //@-          Shape
  *******************************/
  /*******************************
              Types
  *******************************/
  /*******************************
            Variations
  *******************************/
  /*******************************
              States
  *******************************/
  /*--------------
      Loading
  ---------------*/
  /*--------------
      Animating
  ---------------*/
  /*--------------
        CSS
  ---------------*/
  /*--------------
      Active
  ---------------*/
  /*******************************
  //@-        Sidebar
  *******************************/
  /* Sidebar Menu */
  /* GPU Layers for Child Elements */
  /*--------------
    Direction
  ---------------*/
  /*--------------
      Pushable
  ---------------*/
  /* Whole Page */
  /* Page Context */
  /*--------------
      Fixed
  ---------------*/
  /*--------------
      Page
  ---------------*/
  /*--------------
      Dimmer
  ---------------*/
  /*--------------
      Coupling
  ---------------*/
  /*******************************
              States
  *******************************/
  /*--------------
      Dimmed
  ---------------*/
  /*--------------
      Animating
  ---------------*/
  /*--------------
      Visible
  ---------------*/
  /* Shadow Direction */
  /* Visible On Load */
  /* opposite sides visible forces content overlay */
  /*--------------
        iOS
  ---------------*/
  /*******************************
            Variations
  *******************************/
  /*--------------
      Width
  ---------------*/
  /* Left / Right */
  /* Left Visible */
  /* Right Visible */
  /*******************************
            Animations
  *******************************/
  /*--------------
      Overlay
  ---------------*/
  /* Set-up */
  /* Initial */
  /* Animation */
  /* End - Sidebar */
  /* End - Pusher */
  /*--------------
        Push
  ---------------*/
  /* Initial */
  /* Sidebar - Initial */
  /* End */
  /*--------------
      Uncover
  ---------------*/
  /* Initial */
  /* End */
  /*--------------
    Slide Along
  ---------------*/
  /* Initial */
  /* Sidebar - Initial */
  /* Animation */
  /* End */
  /*--------------
    Slide Out
  ---------------*/
  /* Initial */
  /* Sidebar - Initial */
  /* Animation */
  /* End */
  /*--------------
    Scale Down
  ---------------*/
  /* Initial */
  /* Sidebar - Initial  */
  /* Pusher - Initial */
  /* Animation */
  /* End */
  /*******************************
              States
  *******************************/
  /*--------------
      Disabled
  ---------------*/
  /*--------------
      Reversed
  ---------------*/
  /*******************************
            Variations
  *******************************/
  /*--------------
      Vertical
  ---------------*/
  /* Vertical Reversed */
  /* Vertical Reversed Labels */
  /* Vertical Labels */
  /* Small Vertical */
  /* Large Vertical */
  /* Big Vertical */
  /*--------------
      Labeled
  ---------------*/
  /*--------------
      Hover
  ---------------*/
  /*--------------
      Inverted
  ---------------*/
  /*--------------
      Colors
  ---------------*/
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /* Standard */
  /* Basic */
  /* Basic Inverted */
  /*--------------
      Basic
  ---------------*/
  /* Standard */
  /*--------------
    Basic Inverted
  ---------------*/
  /* Standard */
  /*--------------
      Sizing
  ---------------*/
  /* Small */
  /* Large */
  /* Big */
  /*******************************
  //@-        Sticky
  *******************************/
  /*******************************
              States
  *******************************/
  /* Bound */
  /* Fixed */
  /* Bound/Fixed Position */
  /*******************************
              Types
  *******************************/
  /*******************************
  //@-       UI Tabs
  *******************************/
  /*******************************
              States
  *******************************/
  /*--------------------
        Active
  ---------------------*/
  /*--------------------
        Loading
  ---------------------*/
  /*******************************
  //@-    Toast container
  *******************************/
  /*******************************
              Toast
  *******************************/
  /*--------------
      Colors
  -------------- */
  /*--------------
        Icon
  ---------------*/
  /*---------------
    Progress Bar
  ----------------*/
  /* --------
  Close Icon
  -----------*/
  /*******************************
  //@-      Transitions
  *******************************/
  /*******************************
              States
  *******************************/
  /* Animating */
  /* Loading */
  /* Hidden */
  /* Visible */
  /* Disabled */
  /*******************************
            Variations
  *******************************/
  /*******************************
            Transitions
  *******************************/
  /*
    Some transitions adapted from Animate CSS
    https://github.com/daneden/animate.css

    Additional transitions adapted from Glide
    by Nick Pettit - https://github.com/nickpettit/glide
  */
  /*--------------
      Browse
  ---------------*/
  /* In */
  /* Out */
  /*--------------
      Drop
  ---------------*/
  /* Drop */
  /*--------------
        Fade
  ---------------*/
  /* In */
  /* Out */
  /*--------------
      Flips
  ---------------*/
  /* In */
  /* Out */
  /*--------------
        Scale
  ---------------*/
  /* Out */
  /*--------------
        Fly
  ---------------*/
  /* Inward */
  /* Outward */
  /* In */
  /* Out */
  /*--------------
      Slide
  ---------------*/
  /* In */
  /* Out */
  /*--------------
      Swing
  ---------------*/
  /* In */
  /* Out */
  /*--------------
        Zoom
  ---------------*/
  /*******************************
        Static Animations
  *******************************/
  /*--------------
      Emphasis
  ---------------*/
  /* Flash */
  /* Shake */
  /* Bounce */
  /* Tada */
  /* Pulse */
  /* Jiggle */
  /* Glow */
  margin-bottom: 50px;
}
.kb-labfront.container table .even,
.kb-labfront.container table .alt,
.kb-labfront.container table :nth-of-type(even),
.kb-labfront.container table :last-child {
  border-right: none;
}
.kb-labfront.container table .even,
.kb-labfront.container table .alt,
.kb-labfront.container table :nth-of-type(even) {
  background-color: inherit;
}
.kb-labfront.container *,
.kb-labfront.container *:before,
.kb-labfront.container *:after {
  box-sizing: inherit;
}
.kb-labfront.container html {
  box-sizing: border-box;
}
.kb-labfront.container input[type=text],
.kb-labfront.container input[type=email],
.kb-labfront.container input[type=search],
.kb-labfront.container input[type=password] {
  -webkit-appearance: none;
  -moz-appearance: none; /* mobile firefox too! */
}
.kb-labfront.container html,
.kb-labfront.container body {
  height: 100%;
}
.kb-labfront.container html {
  font-size: 14px;
}
.kb-labfront.container body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  min-width: 320px;
  background: #ffffff;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 1.4285em;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container h1,
.kb-labfront.container h2,
.kb-labfront.container h3,
.kb-labfront.container h4,
.kb-labfront.container h5 {
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  line-height: 1.2857142857em;
  margin: calc(2rem - 0.1428571429em) 0 1rem;
  font-weight: bold;
  padding: 0;
}
.kb-labfront.container h1 {
  min-height: 1rem;
  font-size: 2rem;
}
.kb-labfront.container h2 {
  font-size: 1.7142857143rem;
}
.kb-labfront.container h3 {
  font-size: 1.2857142857rem;
}
.kb-labfront.container h4 {
  font-size: 1.0714285714rem;
}
.kb-labfront.container h5 {
  font-size: 1rem;
}
.kb-labfront.container h1:first-child,
.kb-labfront.container h2:first-child,
.kb-labfront.container h3:first-child,
.kb-labfront.container h4:first-child,
.kb-labfront.container h5:first-child {
  margin-top: 0;
}
.kb-labfront.container h1:last-child,
.kb-labfront.container h2:last-child,
.kb-labfront.container h3:last-child,
.kb-labfront.container h4:last-child,
.kb-labfront.container h5:last-child {
  margin-bottom: 0;
}
.kb-labfront.container p {
  margin: 0 0 1em;
  line-height: 1.4285em;
}
.kb-labfront.container p:first-child {
  margin-top: 0;
}
.kb-labfront.container p:last-child {
  margin-bottom: 0;
}
.kb-labfront.container a {
  color: #4183c4;
  text-decoration: none;
}
.kb-labfront.container a:hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
  text-decoration: none;
}
.kb-labfront.container body ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 5px;
  height: 5px;
}
.kb-labfront.container body ::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 0;
}
.kb-labfront.container body ::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.1);
  transition: color 0.2s ease;
}
.kb-labfront.container body ::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(0, 0, 0, 0.15);
}
.kb-labfront.container body ::-webkit-scrollbar-thumb:hover {
  background: rgba(128, 135, 139, 0.8);
}
.kb-labfront.container body .ui.inverted:not(.dimmer)::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container body .ui.inverted:not(.dimmer)::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}
.kb-labfront.container body .ui.inverted:not(.dimmer)::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.15);
}
.kb-labfront.container body .ui.inverted:not(.dimmer)::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}
.kb-labfront.container ::-webkit-selection {
  background-color: #cce2ff;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container ::-moz-selection {
  background-color: #cce2ff;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container ::selection {
  background-color: #cce2ff;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container textarea::-webkit-selection,
.kb-labfront.container input::-webkit-selection {
  background-color: rgba(100, 100, 100, 0.4);
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container textarea::-moz-selection,
.kb-labfront.container input::-moz-selection {
  background-color: rgba(100, 100, 100, 0.4);
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container textarea::selection,
.kb-labfront.container input::selection {
  background-color: rgba(100, 100, 100, 0.4);
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.button {
  cursor: pointer;
  display: inline-block;
  min-height: 1em;
  outline: none;
  border: none;
  vertical-align: baseline;
  background: #E0E1E2 none;
  color: rgba(0, 0, 0, 0.6);
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  margin: 0 0.25em 0 0;
  padding: 0.7857142857em 1.5em 0.7857142857em;
  text-transform: none;
  text-shadow: none;
  font-weight: bold;
  line-height: 1em;
  font-style: normal;
  text-align: center;
  text-decoration: none;
  border-radius: 0.2857142857rem;
  box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
  user-select: none;
  transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, background 0.1s ease;
  will-change: auto;
  -webkit-tap-highlight-color: transparent;
}
.kb-labfront.container .ui.button:hover {
  background-color: #CACBCD;
  background-image: none;
  box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.button:hover .icon {
  opacity: 0.85;
}
.kb-labfront.container .ui.button:focus {
  background-color: #CACBCD;
  color: rgba(0, 0, 0, 0.8);
  background-image: none;
  box-shadow: "";
}
.kb-labfront.container .ui.button:focus .icon {
  opacity: 0.85;
}
.kb-labfront.container .ui.button:active,
.kb-labfront.container .ui.active.button:active {
  background-color: #BABBBC;
  background-image: "";
  color: rgba(0, 0, 0, 0.9);
  box-shadow: 0 0 0 1px transparent inset, none;
}
.kb-labfront.container .ui.active.button {
  background-color: #C0C1C2;
  background-image: none;
  box-shadow: 0 0 0 1px transparent inset;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.active.button:hover {
  background-color: #C0C1C2;
  background-image: none;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.active.button:active {
  background-color: #C0C1C2;
  background-image: none;
}
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading.button {
  position: relative;
  cursor: default;
  text-shadow: none !important;
  color: transparent;
  opacity: 1;
  pointer-events: auto;
  transition: all 0s linear, opacity 0.1s ease;
}
.kb-labfront.container .ui.loading.button:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 1.2857142857em;
  height: 1.2857142857em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.15);
}
.kb-labfront.container .ui.loading.button:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 1.2857142857em;
  height: 1.2857142857em;
  border-radius: 500rem;
  animation: loader 0.6s infinite linear;
  border: 0.2em solid currentColor;
  color: #ffffff;
  box-shadow: 0 0 0 1px transparent;
}
.kb-labfront.container .ui.labeled.icon.loading.button .icon {
  background-color: transparent;
  box-shadow: none;
}
.kb-labfront.container .ui.basic.loading.button:not(.inverted):before {
  border-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.basic.loading.button:not(.inverted):after {
  border-color: #767676;
}
.kb-labfront.container .ui.buttons .disabled.button:not(.basic),
.kb-labfront.container .ui.disabled.button,
.kb-labfront.container .ui.button:disabled,
.kb-labfront.container .ui.disabled.button:hover,
.kb-labfront.container .ui.disabled.active.button {
  cursor: default;
  opacity: 0.45 !important;
  background-image: none;
  box-shadow: none;
  pointer-events: none !important;
}
.kb-labfront.container .ui.basic.buttons .ui.disabled.button {
  border-color: rgba(34, 36, 38, 0.5);
}
.kb-labfront.container .ui.animated.button {
  position: relative;
  overflow: hidden;
  padding-right: 0 !important;
  vertical-align: middle;
  z-index: 1;
}
.kb-labfront.container .ui.animated.button .content {
  will-change: transform, opacity;
}
.kb-labfront.container .ui.animated.button .visible.content {
  position: relative;
  margin-right: 1.5em;
}
.kb-labfront.container .ui.animated.button .hidden.content {
  position: absolute;
  width: 100%;
}
.kb-labfront.container .ui.animated.button .visible.content,
.kb-labfront.container .ui.animated.button .hidden.content {
  transition: right 0.3s ease 0s;
}
.kb-labfront.container .ui.animated.button .visible.content {
  left: auto;
  right: 0;
}
.kb-labfront.container .ui.animated.button .hidden.content {
  top: 50%;
  left: auto;
  right: -100%;
  margin-top: -0.5em;
}
.kb-labfront.container .ui.animated.button:focus .visible.content,
.kb-labfront.container .ui.animated.button:hover .visible.content {
  left: auto;
  right: 200%;
}
.kb-labfront.container .ui.animated.button:focus .hidden.content,
.kb-labfront.container .ui.animated.button:hover .hidden.content {
  left: auto;
  right: 0;
}
.kb-labfront.container .ui.vertical.animated.button .visible.content,
.kb-labfront.container .ui.vertical.animated.button .hidden.content {
  transition: top 0.3s ease, transform 0.3s ease;
}
.kb-labfront.container .ui.vertical.animated.button .visible.content {
  transform: translateY(0%);
  right: auto;
}
.kb-labfront.container .ui.vertical.animated.button .hidden.content {
  top: -50%;
  left: 0;
  right: auto;
}
.kb-labfront.container .ui.vertical.animated.button:focus .visible.content,
.kb-labfront.container .ui.vertical.animated.button:hover .visible.content {
  transform: translateY(200%);
  right: auto;
}
.kb-labfront.container .ui.vertical.animated.button:focus .hidden.content,
.kb-labfront.container .ui.vertical.animated.button:hover .hidden.content {
  top: 50%;
  right: auto;
}
.kb-labfront.container .ui.fade.animated.button .visible.content,
.kb-labfront.container .ui.fade.animated.button .hidden.content {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.kb-labfront.container .ui.fade.animated.button .visible.content {
  left: auto;
  right: auto;
  opacity: 1;
  transform: scale(1);
}
.kb-labfront.container .ui.fade.animated.button .hidden.content {
  opacity: 0;
  left: 0;
  right: auto;
  transform: scale(1.5);
}
.kb-labfront.container .ui.fade.animated.button:focus .visible.content,
.kb-labfront.container .ui.fade.animated.button:hover .visible.content {
  left: auto;
  right: auto;
  opacity: 0;
  transform: scale(0.75);
}
.kb-labfront.container .ui.fade.animated.button:focus .hidden.content,
.kb-labfront.container .ui.fade.animated.button:hover .hidden.content {
  left: 0;
  right: auto;
  opacity: 1;
  transform: scale(1);
}
.kb-labfront.container .ui.inverted.button {
  box-shadow: 0 0 0 2px #ffffff inset;
  background: transparent none;
  color: #ffffff;
  text-shadow: none !important;
}
.kb-labfront.container .ui.inverted.buttons .button {
  margin: 0 0 0 -2px;
}
.kb-labfront.container .ui.inverted.buttons .button:first-child {
  margin-left: 0;
}
.kb-labfront.container .ui.inverted.vertical.buttons .button {
  margin: 0 0 -2px 0;
}
.kb-labfront.container .ui.inverted.vertical.buttons .button:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.inverted.button:hover {
  background: #ffffff;
  box-shadow: 0 0 0 2px #ffffff inset;
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.inverted.button:focus,
.kb-labfront.container .ui.inverted.button.active {
  background: #ffffff;
  box-shadow: 0 0 0 2px #ffffff inset;
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.inverted.button.active:focus {
  background: #dcddde;
  box-shadow: 0 0 0 2px #dcddde inset;
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.labeled.button:not(.icon) {
  display: inline-flex;
  flex-direction: row;
  background: none;
  padding: 0 !important;
  border: none;
  box-shadow: none;
}
.kb-labfront.container .ui.labeled.button > .button {
  margin: 0;
}
.kb-labfront.container .ui.labeled.button > .label {
  display: flex;
  align-items: center;
  margin: 0 0 0 -1px !important;
  font-size: 1rem;
  padding: "";
  border-color: rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.labeled.button > .tag.label:before {
  width: 1.85em;
  height: 1.85em;
}
.kb-labfront.container .ui.labeled.button:not([class*="left labeled"]) > .button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.kb-labfront.container .ui.labeled.button:not([class*="left labeled"]) > .label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.kb-labfront.container .ui[class*="left labeled"].button > .button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.kb-labfront.container .ui[class*="left labeled"].button > .label {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.kb-labfront.container .ui.facebook.button {
  background-color: #3b5998;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.facebook.button:hover {
  background-color: rgb(42.5946682464, 74.9529467971, 142.9053317536);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.facebook.button:active {
  background-color: rgb(44.7393364929, 67.4881516588, 115.2606635071);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.twitter.button {
  background-color: #1da1f2;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.twitter.button:hover {
  background-color: rgb(1.0785564854, 151.8825991514, 244.4214435146);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.twitter.button:active {
  background-color: rgb(11.9665271967, 133.4728033473, 208.0334728033);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.google.plus.button {
  background-color: #dd4b39;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.google.plus.button:hover {
  background-color: rgb(228.1206896552, 46.7411690496, 24.3793103448);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.google.plus.button:active {
  background-color: rgb(193.7327586207, 50.8793103448, 33.2672413793);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.linkedin.button {
  background-color: #0077b5;
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.linkedin.button:hover {
  background-color: rgb(0, 102.2348066298, 155.5);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.linkedin.button:active {
  background-color: rgb(0, 85.4696132597, 130);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.youtube.button {
  background-color: #ff0000;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.youtube.button:hover {
  background-color: rgb(229.5, 0, 0);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.youtube.button:active {
  background-color: #cc0000;
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.instagram.button {
  background-color: #49769c;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.instagram.button:hover {
  background-color: rgb(54.6961790393, 105.7183945389, 148.8038209607);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.instagram.button:active {
  background-color: rgb(56.7423580786, 91.7205240175, 121.2576419214);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.pinterest.button {
  background-color: #bd081c;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.pinterest.button:hover {
  background-color: rgb(171.5, 0, 18.9502762431);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.pinterest.button:active {
  background-color: rgb(140.0710659898, 5.9289340102, 20.7512690355);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.vk.button {
  background-color: #45668e;
  color: #ffffff;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.vk.button:hover {
  background-color: rgb(51.3861374408, 88.7836022203, 134.1138625592);
  color: #ffffff;
}
.kb-labfront.container .ui.vk.button:active {
  background-color: rgb(52.3222748815, 77.345971564, 107.6777251185);
  color: #ffffff;
}
.kb-labfront.container .ui.whatsapp.button {
  background-color: #25d366;
  color: #ffffff;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.whatsapp.button:hover {
  background-color: rgb(22.0705645161, 200.4294354839, 88.6988783834);
  color: #ffffff;
}
.kb-labfront.container .ui.whatsapp.button:active {
  background-color: rgb(29.3911290323, 167.6088709677, 81.0241935484);
  color: #ffffff;
}
.kb-labfront.container .ui.telegram.button {
  background-color: #0088cc;
  color: #ffffff;
  background-image: none;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.telegram.button:hover {
  background-color: rgb(0, 119, 178.5);
  color: #ffffff;
}
.kb-labfront.container .ui.telegram.button:active {
  background-color: #006699;
  color: #ffffff;
}
.kb-labfront.container .ui.button > .icon:not(.button) {
  height: auto;
  opacity: 0.8;
  margin: 0 0.4285714286em 0 -0.2142857143em;
  transition: opacity 0.1s ease;
  vertical-align: "";
  color: "";
}
.kb-labfront.container .ui.button:not(.icon) > .icon:not(.button):not(.dropdown),
.kb-labfront.container .ui.button:not(.icon) > .icons:not(.button):not(.dropdown) {
  margin: 0 0.4285714286em 0 -0.2142857143em;
}
.kb-labfront.container .ui.button:not(.icon) > .right.icon:not(.button):not(.dropdown) {
  margin: 0 -0.2142857143em 0 0.4285714286em;
}
.kb-labfront.container .ui[class*="left floated"].buttons,
.kb-labfront.container .ui[class*="left floated"].button {
  float: left;
  margin-left: 0;
  margin-right: 0.25em;
}
.kb-labfront.container .ui[class*="right floated"].buttons,
.kb-labfront.container .ui[class*="right floated"].button {
  float: right;
  margin-right: 0;
  margin-left: 0.25em;
}
.kb-labfront.container .ui.compact.buttons .button,
.kb-labfront.container .ui.compact.button {
  padding: 0.5892857143em 1.125em 0.5892857143em;
}
.kb-labfront.container .ui.compact.icon.buttons .button,
.kb-labfront.container .ui.compact.icon.button {
  padding: 0.5892857143em 0.5892857143em 0.5892857143em;
}
.kb-labfront.container .ui.compact.labeled.icon.buttons .button,
.kb-labfront.container .ui.compact.labeled.icon.button {
  padding: 0.5892857143em 3.6964285714em 0.5892857143em;
}
.kb-labfront.container .ui.compact.labeled.icon.buttons .button > .icon,
.kb-labfront.container .ui.compact.labeled.icon.button > .icon {
  padding: 0.5892857143em 0 0.5892857143em 0;
}
.kb-labfront.container .ui.mini.buttons .button,
.kb-labfront.container .ui.mini.buttons .or,
.kb-labfront.container .ui.ui.ui.ui.mini.button {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.buttons .button,
.kb-labfront.container .ui.tiny.buttons .or,
.kb-labfront.container .ui.ui.ui.ui.tiny.button {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.buttons .button,
.kb-labfront.container .ui.small.buttons .or,
.kb-labfront.container .ui.ui.ui.ui.small.button {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.buttons .button,
.kb-labfront.container .ui.buttons .or,
.kb-labfront.container .ui.button {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.buttons .button,
.kb-labfront.container .ui.large.buttons .or,
.kb-labfront.container .ui.ui.ui.ui.large.button {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.buttons .button,
.kb-labfront.container .ui.big.buttons .or,
.kb-labfront.container .ui.ui.ui.ui.big.button {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.buttons .button,
.kb-labfront.container .ui.huge.buttons .or,
.kb-labfront.container .ui.ui.ui.ui.huge.button {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.buttons .button,
.kb-labfront.container .ui.massive.buttons .or,
.kb-labfront.container .ui.ui.ui.ui.massive.button {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.mini.buttons .dropdown {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.mini.buttons .dropdown .menu > .item {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.buttons .dropdown {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.tiny.buttons .dropdown .menu > .item {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.buttons .dropdown {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.small.buttons .dropdown .menu > .item {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.large.buttons .dropdown {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.large.buttons .dropdown .menu > .item {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.buttons .dropdown {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.big.buttons .dropdown .menu > .item {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.buttons .dropdown {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.huge.buttons .dropdown .menu > .item {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.buttons .dropdown {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.massive.buttons .dropdown .menu > .item {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.icon.buttons .button,
.kb-labfront.container .ui.icon.button {
  padding: 0.7857142857em 0.7857142857em 0.7857142857em;
}
.kb-labfront.container .ui.icon.buttons .button > .icon,
.kb-labfront.container .ui.icon.button > .icon {
  opacity: 0.9;
  margin: 0 !important;
  vertical-align: top;
}
.kb-labfront.container .ui.basic.buttons .button,
.kb-labfront.container .ui.basic.button {
  background: transparent none;
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
  border-radius: 0.2857142857rem;
  text-transform: none;
  text-shadow: none !important;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.basic.buttons {
  box-shadow: none;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.basic.buttons .button {
  border-radius: 0;
}
.kb-labfront.container .ui.basic.buttons .button:hover,
.kb-labfront.container .ui.basic.button:hover {
  background: #FFFFFF;
  color: rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.35) inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.basic.buttons .button:focus,
.kb-labfront.container .ui.basic.button:focus {
  background: #FFFFFF;
  color: rgba(0, 0, 0, 0.8);
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.35) inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.basic.buttons .button:active,
.kb-labfront.container .ui.basic.button:active {
  background: #F8F8F8;
  color: rgba(0, 0, 0, 0.9);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15) inset, 0 1px 4px 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.basic.buttons .active.button,
.kb-labfront.container .ui.basic.active.button {
  background: rgba(0, 0, 0, 0.05);
  box-shadow: "";
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.basic.buttons .active.button:hover,
.kb-labfront.container .ui.basic.active.button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.kb-labfront.container .ui.basic.buttons .button:hover {
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.35) inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset inset;
}
.kb-labfront.container .ui.basic.buttons .button:active {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15) inset, 0 1px 4px 0 rgba(34, 36, 38, 0.15) inset inset;
}
.kb-labfront.container .ui.basic.buttons .active.button {
  box-shadow: "";
}
.kb-labfront.container .ui.basic.inverted.buttons .button,
.kb-labfront.container .ui.basic.inverted.button {
  background-color: transparent;
  color: #f9fafb;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
}
.kb-labfront.container .ui.basic.inverted.buttons .button:hover,
.kb-labfront.container .ui.basic.inverted.button:hover {
  color: #ffffff;
  box-shadow: 0 0 0 2px rgb(255, 255, 255) inset;
}
.kb-labfront.container .ui.basic.inverted.buttons .button:focus,
.kb-labfront.container .ui.basic.inverted.button:focus {
  color: #ffffff;
  box-shadow: 0 0 0 2px rgb(255, 255, 255) inset;
}
.kb-labfront.container .ui.basic.inverted.buttons .button:active,
.kb-labfront.container .ui.basic.inverted.button:active {
  background-color: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9) inset;
}
.kb-labfront.container .ui.basic.inverted.buttons .active.button,
.kb-labfront.container .ui.basic.inverted.active.button {
  background-color: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  text-shadow: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.7) inset;
}
.kb-labfront.container .ui.basic.inverted.buttons .active.button:hover,
.kb-labfront.container .ui.basic.inverted.active.button:hover {
  background-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 2px rgb(255, 255, 255) inset;
}
.kb-labfront.container .ui.basic.buttons .button {
  border-left: 1px solid rgba(34, 36, 38, 0.15);
  box-shadow: none;
}
.kb-labfront.container .ui.basic.vertical.buttons .button {
  border-left: none;
  border-left-width: 0;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.basic.vertical.buttons .button:first-child {
  border-top-width: 0;
}
.kb-labfront.container .ui.tertiary.button {
  transition: color 0.1s ease !important;
  border-radius: 0;
  margin: 0.2857142857em 0.25em 0.2857142857em 0 !important;
  padding: 0.5em !important;
  box-shadow: none;
  color: rgba(0, 0, 0, 0.6);
  background: none;
}
.kb-labfront.container .ui.tertiary.button:hover {
  box-shadow: inset 0 -0.2em 0 #666666;
  color: #333333;
  background: none;
}
.kb-labfront.container .ui.tertiary.button:focus {
  box-shadow: inset 0 -0.2em 0 #666666;
  color: #333333;
  background: none;
}
.kb-labfront.container .ui.tertiary.button:active {
  box-shadow: inset 0 -0.2em 0 #999999;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
  color: #666666;
  background: none;
}
.kb-labfront.container .ui.labeled.icon.buttons .button,
.kb-labfront.container .ui.labeled.icon.button {
  position: relative;
  padding-left: 4.0714285714em !important;
  padding-right: 1.5em !important;
}
.kb-labfront.container .ui.labeled.icon.buttons > .button > .icon,
.kb-labfront.container .ui.labeled.icon.button > .icon {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  line-height: 1;
  border-radius: 0;
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
  text-align: center;
  animation: none;
  padding: 0.7857142857em 0 0.7857142857em 0;
  margin: 0;
  width: 2.5714285714em;
  background-color: rgba(0, 0, 0, 0.05);
  color: "";
  box-shadow: -1px 0 0 0 transparent inset;
}
.kb-labfront.container .ui[class*="right labeled"].icon.button {
  padding-right: 4.0714285714em !important;
  padding-left: 1.5em !important;
}
.kb-labfront.container .ui[class*="right labeled"].icon.button > .icon {
  left: auto;
  right: 0;
  border-radius: 0;
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
  box-shadow: 1px 0 0 0 transparent inset;
}
.kb-labfront.container .ui.labeled.icon.buttons > .button > .icon:before,
.kb-labfront.container .ui.labeled.icon.button > .icon:before,
.kb-labfront.container .ui.labeled.icon.buttons > .button > .icon:after,
.kb-labfront.container .ui.labeled.icon.button > .icon:after {
  display: block;
  position: relative;
  width: 100%;
  top: 0;
  text-align: center;
}
.kb-labfront.container .ui.labeled.icon.buttons .button > .icon {
  border-radius: 0;
}
.kb-labfront.container .ui.labeled.icon.buttons .button:first-child > .icon {
  border-top-left-radius: 0.2857142857rem;
  border-bottom-left-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.labeled.icon.buttons .button:last-child > .icon {
  border-top-right-radius: 0.2857142857rem;
  border-bottom-right-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.labeled.icon.buttons .button:first-child > .icon {
  border-radius: 0;
  border-top-left-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.labeled.icon.buttons .button:last-child > .icon {
  border-radius: 0;
  border-bottom-left-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.labeled.icon.button > .loading.icon:before {
  animation: loader 2s linear infinite;
}
.kb-labfront.container .ui.toggle.buttons .active.button,
.kb-labfront.container .ui.buttons .button.toggle.active,
.kb-labfront.container .ui.button.toggle.active {
  background-color: #21ba45;
  box-shadow: none;
  text-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.button.toggle.active:hover {
  background-color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
  text-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.circular.button {
  border-radius: 10em;
}
.kb-labfront.container .ui.circular.button > .icon {
  width: 1em;
  vertical-align: baseline;
}
.kb-labfront.container .ui.buttons .or {
  position: relative;
  width: 0.3em;
  height: 2.5714285714em;
  z-index: 3;
}
.kb-labfront.container .ui.buttons .or:before {
  position: absolute;
  text-align: center;
  border-radius: 500rem;
  content: "or";
  top: 50%;
  left: 50%;
  background-color: #ffffff;
  text-shadow: none;
  margin-top: -0.8928571429em;
  margin-left: -0.8928571429em;
  width: 1.7857142857em;
  height: 1.7857142857em;
  line-height: 1.7857142857em;
  color: rgba(0, 0, 0, 0.4);
  font-style: normal;
  font-weight: bold;
  box-shadow: 0 0 0 1px transparent inset;
}
.kb-labfront.container .ui.buttons .or[data-text]:before {
  content: attr(data-text);
}
.kb-labfront.container .ui.fluid.buttons .or {
  width: 0 !important;
}
.kb-labfront.container .ui.fluid.buttons .or:after {
  display: none;
}
.kb-labfront.container .ui.attached.button {
  position: relative;
  display: block;
  margin: 0;
  border-radius: 0;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.attached.top.button {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.attached.bottom.button {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.left.attached.button {
  display: inline-block;
  border-left: none;
  text-align: right;
  padding-right: 0.75em;
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.right.attached.button {
  display: inline-block;
  text-align: left;
  padding-left: 0.75em;
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
}
.kb-labfront.container .ui.attached.buttons {
  position: relative;
  display: flex;
  border-radius: 0;
  width: auto !important;
  z-index: auto;
  margin-left: -1px;
  margin-right: -1px;
}
.kb-labfront.container .ui.attached.buttons .button {
  margin: 0;
}
.kb-labfront.container .ui.attached.buttons .button:first-child {
  border-radius: 0;
}
.kb-labfront.container .ui.attached.buttons .button:last-child {
  border-radius: 0;
}
.kb-labfront.container .ui[class*="top attached"].buttons {
  margin-bottom: -1px;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui[class*="top attached"].buttons .button:first-child {
  border-radius: 0.2857142857rem 0 0 0;
}
.kb-labfront.container .ui[class*="top attached"].buttons .button:last-child {
  border-radius: 0 0.2857142857rem 0 0;
}
.kb-labfront.container .ui[class*="bottom attached"].buttons {
  margin-top: -1px;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui[class*="bottom attached"].buttons .button:first-child {
  border-radius: 0 0 0 0.2857142857rem;
}
.kb-labfront.container .ui[class*="bottom attached"].buttons .button:last-child {
  border-radius: 0 0 0.2857142857rem 0;
}
.kb-labfront.container .ui[class*="left attached"].buttons {
  display: inline-flex;
  margin-right: 0;
  margin-left: -1px;
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
}
.kb-labfront.container .ui[class*="left attached"].buttons .button:first-child {
  margin-left: -1px;
  border-radius: 0 0.2857142857rem 0 0;
}
.kb-labfront.container .ui[class*="left attached"].buttons .button:last-child {
  margin-left: -1px;
  border-radius: 0 0 0.2857142857rem 0;
}
.kb-labfront.container .ui[class*="right attached"].buttons {
  display: inline-flex;
  margin-left: 0;
  margin-right: -1px;
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui[class*="right attached"].buttons .button:first-child {
  margin-left: -1px;
  border-radius: 0.2857142857rem 0 0 0;
}
.kb-labfront.container .ui[class*="right attached"].buttons .button:last-child {
  margin-left: -1px;
  border-radius: 0 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.fluid.buttons,
.kb-labfront.container .ui.fluid.button {
  width: 100%;
}
.kb-labfront.container .ui.fluid.button {
  display: block;
}
.kb-labfront.container .ui.two.buttons {
  width: 100%;
}
.kb-labfront.container .ui.two.buttons > .button {
  width: 50%;
}
.kb-labfront.container .ui.three.buttons {
  width: 100%;
}
.kb-labfront.container .ui.three.buttons > .button {
  width: 33.333%;
}
.kb-labfront.container .ui.four.buttons {
  width: 100%;
}
.kb-labfront.container .ui.four.buttons > .button {
  width: 25%;
}
.kb-labfront.container .ui.five.buttons {
  width: 100%;
}
.kb-labfront.container .ui.five.buttons > .button {
  width: 20%;
}
.kb-labfront.container .ui.six.buttons {
  width: 100%;
}
.kb-labfront.container .ui.six.buttons > .button {
  width: 16.666%;
}
.kb-labfront.container .ui.seven.buttons {
  width: 100%;
}
.kb-labfront.container .ui.seven.buttons > .button {
  width: 14.285%;
}
.kb-labfront.container .ui.eight.buttons {
  width: 100%;
}
.kb-labfront.container .ui.eight.buttons > .button {
  width: 12.5%;
}
.kb-labfront.container .ui.nine.buttons {
  width: 100%;
}
.kb-labfront.container .ui.nine.buttons > .button {
  width: 11.11%;
}
.kb-labfront.container .ui.ten.buttons {
  width: 100%;
}
.kb-labfront.container .ui.ten.buttons > .button {
  width: 10%;
}
.kb-labfront.container .ui.eleven.buttons {
  width: 100%;
}
.kb-labfront.container .ui.eleven.buttons > .button {
  width: 9.09%;
}
.kb-labfront.container .ui.twelve.buttons {
  width: 100%;
}
.kb-labfront.container .ui.twelve.buttons > .button {
  width: 8.3333%;
}
.kb-labfront.container .ui.fluid.vertical.buttons,
.kb-labfront.container .ui.fluid.vertical.buttons > .button {
  display: flex;
  width: auto;
  justify-content: center;
}
.kb-labfront.container .ui.two.vertical.buttons > .button {
  height: 50%;
}
.kb-labfront.container .ui.three.vertical.buttons > .button {
  height: 33.333%;
}
.kb-labfront.container .ui.four.vertical.buttons > .button {
  height: 25%;
}
.kb-labfront.container .ui.five.vertical.buttons > .button {
  height: 20%;
}
.kb-labfront.container .ui.six.vertical.buttons > .button {
  height: 16.666%;
}
.kb-labfront.container .ui.seven.vertical.buttons > .button {
  height: 14.285%;
}
.kb-labfront.container .ui.eight.vertical.buttons > .button {
  height: 12.5%;
}
.kb-labfront.container .ui.nine.vertical.buttons > .button {
  height: 11.11%;
}
.kb-labfront.container .ui.ten.vertical.buttons > .button {
  height: 10%;
}
.kb-labfront.container .ui.eleven.vertical.buttons > .button {
  height: 9.09%;
}
.kb-labfront.container .ui.twelve.vertical.buttons > .button {
  height: 8.3333%;
}
.kb-labfront.container .ui.primary.buttons .button,
.kb-labfront.container .ui.primary.button {
  background-color: #2185d0;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.primary.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.primary.buttons .button:hover,
.kb-labfront.container .ui.primary.button:hover {
  background-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.primary.buttons .button:focus,
.kb-labfront.container .ui.primary.button:focus {
  background-color: rgb(7.3932780083, 113.3438174274, 192.8067219917);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.primary.buttons .button:active,
.kb-labfront.container .ui.primary.button:active {
  background-color: rgb(26.0165975104, 104.8547717842, 163.9834024896);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.primary.buttons .active.button,
.kb-labfront.container .ui.primary.buttons .active.button:active,
.kb-labfront.container .ui.primary.active.button,
.kb-labfront.container .ui.primary.button .active.button:active {
  background-color: rgb(13.3457987552, 121.2363144635, 202.1542012448);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.primary.buttons .button,
.kb-labfront.container .ui.basic.primary.button {
  background: transparent;
  box-shadow: 0 0 0 1px #2185d0 inset;
  color: #2185d0;
}
.kb-labfront.container .ui.basic.primary.buttons .button:hover,
.kb-labfront.container .ui.basic.primary.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(18.7332987552, 120.4666716064, 196.7667012448) inset;
  color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.basic.primary.buttons .button:focus,
.kb-labfront.container .ui.basic.primary.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(7.3932780083, 113.3438174274, 192.8067219917) inset;
  color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.basic.primary.buttons .active.button,
.kb-labfront.container .ui.basic.primary.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(13.3457987552, 121.2363144635, 202.1542012448) inset;
  color: rgb(26.0165975104, 104.8547717842, 163.9834024896);
}
.kb-labfront.container .ui.basic.primary.buttons .button:active,
.kb-labfront.container .ui.basic.primary.button:active {
  box-shadow: 0 0 0 1px rgb(26.0165975104, 104.8547717842, 163.9834024896) inset;
  color: rgb(26.0165975104, 104.8547717842, 163.9834024896);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.primary.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.primary.buttons .button,
.kb-labfront.container .ui.inverted.primary.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #54c8ff inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.primary.buttons .button:hover,
.kb-labfront.container .ui.inverted.primary.button:hover,
.kb-labfront.container .ui.inverted.primary.buttons .button:focus,
.kb-labfront.container .ui.inverted.primary.button:focus,
.kb-labfront.container .ui.inverted.primary.buttons .button.active,
.kb-labfront.container .ui.inverted.primary.button.active,
.kb-labfront.container .ui.inverted.primary.buttons .button:active,
.kb-labfront.container .ui.inverted.primary.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.primary.buttons .button:hover,
.kb-labfront.container .ui.inverted.primary.button:hover {
  background-color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.primary.buttons .button:focus,
.kb-labfront.container .ui.inverted.primary.button:focus {
  background-color: rgb(43.2, 186.8771929825, 255);
}
.kb-labfront.container .ui.inverted.primary.buttons .active.button,
.kb-labfront.container .ui.inverted.primary.active.button {
  background-color: rgb(58.5, 191.798245614, 255);
}
.kb-labfront.container .ui.inverted.primary.buttons .button:active,
.kb-labfront.container .ui.inverted.primary.button:active {
  background-color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.primary.basic.buttons .button,
.kb-labfront.container .ui.inverted.primary.buttons .basic.button,
.kb-labfront.container .ui.inverted.primary.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.primary.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.primary.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.primary.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(33, 183.5964912281, 255) inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.primary.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.primary.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.primary.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(43.2, 186.8771929825, 255) inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.primary.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.primary.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.primary.basic.active.button {
  box-shadow: 0 0 0 2px rgb(58.5, 191.798245614, 255) inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.primary.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.primary.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.primary.basic.button:active {
  box-shadow: 0 0 0 2px rgb(33, 183.5964912281, 255) inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.tertiary.primary.buttons .button,
.kb-labfront.container .ui.tertiary.primary.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.primary.button {
  background: transparent;
  box-shadow: none;
  color: #2185d0;
}
.kb-labfront.container .ui.tertiary.primary.buttons .button:hover,
.kb-labfront.container .ui.tertiary.primary.buttons button:hover,
.kb-labfront.container .ui.tertiary.primary.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(8.9, 136.4428571429, 232.1);
  color: rgb(8.9, 136.4428571429, 232.1);
}
.kb-labfront.container .ui.tertiary.primary.buttons .button:focus,
.kb-labfront.container .ui.tertiary.primary.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.primary.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(27.4132780083, 110.4838174274, 172.7867219917);
  color: rgb(27.4132780083, 110.4838174274, 172.7867219917);
}
.kb-labfront.container .ui.tertiary.primary.buttons .active.button,
.kb-labfront.container .ui.tertiary.primary.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.primary.active.button,
.kb-labfront.container .ui.tertiary.primary.buttons .button:active,
.kb-labfront.container .ui.tertiary.primary.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.primary.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(0, 123.1428571429, 215.5);
  color: rgb(13.3457987552, 121.2363144635, 202.1542012448);
}
.kb-labfront.container .ui.secondary.buttons .button,
.kb-labfront.container .ui.secondary.button {
  background-color: #1b1c1d;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.secondary.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.secondary.buttons .button:hover,
.kb-labfront.container .ui.secondary.button:hover {
  background-color: rgb(35.2196428571, 40.75, 46.2803571429);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.secondary.buttons .button:focus,
.kb-labfront.container .ui.secondary.button:focus {
  background-color: rgb(36.9914285714, 48.4, 59.8085714286);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.secondary.buttons .button:active,
.kb-labfront.container .ui.secondary.button:active {
  background-color: rgb(51.5892857143, 53.5, 55.4107142857);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.secondary.buttons .active.button,
.kb-labfront.container .ui.secondary.buttons .active.button:active,
.kb-labfront.container .ui.secondary.active.button,
.kb-labfront.container .ui.secondary.button .active.button:active {
  background-color: rgb(33.1821428571, 40.75, 48.3178571429);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.secondary.buttons .button,
.kb-labfront.container .ui.basic.secondary.button {
  background: transparent;
  box-shadow: 0 0 0 1px #1b1c1d inset;
  color: #1b1c1d;
}
.kb-labfront.container .ui.basic.secondary.buttons .button:hover,
.kb-labfront.container .ui.basic.secondary.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(35.2196428571, 40.75, 46.2803571429) inset;
  color: rgb(35.2196428571, 40.75, 46.2803571429);
}
.kb-labfront.container .ui.basic.secondary.buttons .button:focus,
.kb-labfront.container .ui.basic.secondary.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(36.9914285714, 48.4, 59.8085714286) inset;
  color: rgb(35.2196428571, 40.75, 46.2803571429);
}
.kb-labfront.container .ui.basic.secondary.buttons .active.button,
.kb-labfront.container .ui.basic.secondary.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(33.1821428571, 40.75, 48.3178571429) inset;
  color: rgb(51.5892857143, 53.5, 55.4107142857);
}
.kb-labfront.container .ui.basic.secondary.buttons .button:active,
.kb-labfront.container .ui.basic.secondary.button:active {
  box-shadow: 0 0 0 1px rgb(51.5892857143, 53.5, 55.4107142857) inset;
  color: rgb(51.5892857143, 53.5, 55.4107142857);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.secondary.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.secondary.buttons .button,
.kb-labfront.container .ui.inverted.secondary.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #545454 inset;
  color: #545454;
}
.kb-labfront.container .ui.inverted.secondary.buttons .button:hover,
.kb-labfront.container .ui.inverted.secondary.button:hover,
.kb-labfront.container .ui.inverted.secondary.buttons .button:focus,
.kb-labfront.container .ui.inverted.secondary.button:focus,
.kb-labfront.container .ui.inverted.secondary.buttons .button.active,
.kb-labfront.container .ui.inverted.secondary.button.active,
.kb-labfront.container .ui.inverted.secondary.buttons .button:active,
.kb-labfront.container .ui.inverted.secondary.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.secondary.buttons .button:hover,
.kb-labfront.container .ui.inverted.secondary.button:hover {
  background-color: rgb(120.45, 98.55, 98.55);
}
.kb-labfront.container .ui.inverted.secondary.buttons .button:focus,
.kb-labfront.container .ui.inverted.secondary.button:focus {
  background-color: rgb(125.28, 83.52, 83.52);
}
.kb-labfront.container .ui.inverted.secondary.buttons .active.button,
.kb-labfront.container .ui.inverted.secondary.active.button {
  background-color: rgb(111.2625, 82.2375, 82.2375);
}
.kb-labfront.container .ui.inverted.secondary.buttons .button:active,
.kb-labfront.container .ui.inverted.secondary.button:active {
  background-color: rgb(109.5, 109.5, 109.5);
}
.kb-labfront.container .ui.inverted.secondary.basic.buttons .button,
.kb-labfront.container .ui.inverted.secondary.buttons .basic.button,
.kb-labfront.container .ui.inverted.secondary.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.secondary.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.secondary.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.secondary.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(120.45, 98.55, 98.55) inset;
  color: #545454;
}
.kb-labfront.container .ui.inverted.secondary.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.secondary.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.secondary.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(125.28, 83.52, 83.52) inset;
  color: #545454;
}
.kb-labfront.container .ui.inverted.secondary.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.secondary.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.secondary.basic.active.button {
  box-shadow: 0 0 0 2px rgb(111.2625, 82.2375, 82.2375) inset;
  color: #545454;
}
.kb-labfront.container .ui.inverted.secondary.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.secondary.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.secondary.basic.button:active {
  box-shadow: 0 0 0 2px rgb(109.5, 109.5, 109.5) inset;
  color: #545454;
}
.kb-labfront.container .ui.tertiary.secondary.buttons .button,
.kb-labfront.container .ui.tertiary.secondary.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.secondary.button {
  background: transparent;
  box-shadow: none;
  color: #1b1c1d;
}
.kb-labfront.container .ui.tertiary.secondary.buttons .button:hover,
.kb-labfront.container .ui.tertiary.secondary.buttons button:hover,
.kb-labfront.container .ui.tertiary.secondary.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(21.4, 28, 34.6);
  color: rgb(21.4, 28, 34.6);
}
.kb-labfront.container .ui.tertiary.secondary.buttons .button:focus,
.kb-labfront.container .ui.tertiary.secondary.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.secondary.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(46.6714285714, 48.4, 50.1285714286);
  color: rgb(46.6714285714, 48.4, 50.1285714286);
}
.kb-labfront.container .ui.tertiary.secondary.buttons .active.button,
.kb-labfront.container .ui.tertiary.secondary.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.secondary.active.button,
.kb-labfront.container .ui.tertiary.secondary.buttons .button:active,
.kb-labfront.container .ui.tertiary.secondary.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.secondary.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(25.0321428571, 40.75, 56.4678571429);
  color: rgb(33.1821428571, 40.75, 48.3178571429);
}
.kb-labfront.container .ui.red.buttons .button,
.kb-labfront.container .ui.red.button {
  background-color: #db2828;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.red.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.red.buttons .button:hover,
.kb-labfront.container .ui.red.button:hover {
  background-color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.red.buttons .button:focus,
.kb-labfront.container .ui.red.button:focus {
  background-color: rgb(208.7243824701, 9.4756175299, 9.4756175299);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.red.buttons .button:active,
.kb-labfront.container .ui.red.button:active {
  background-color: rgb(178.1673306773, 29.8326693227, 29.8326693227);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.red.buttons .active.button,
.kb-labfront.container .ui.red.buttons .active.button:active,
.kb-labfront.container .ui.red.active.button,
.kb-labfront.container .ui.red.button .active.button:active {
  background-color: rgb(217.5224601594, 15.9775398406, 15.9775398406);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.red.buttons .button,
.kb-labfront.container .ui.basic.red.button {
  background: transparent;
  box-shadow: 0 0 0 1px #db2828 inset;
  color: #db2828;
}
.kb-labfront.container .ui.basic.red.buttons .button:hover,
.kb-labfront.container .ui.basic.red.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(211.6849601594, 21.8150398406, 21.8150398406) inset;
  color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.basic.red.buttons .button:focus,
.kb-labfront.container .ui.basic.red.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(208.7243824701, 9.4756175299, 9.4756175299) inset;
  color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.basic.red.buttons .active.button,
.kb-labfront.container .ui.basic.red.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(217.5224601594, 15.9775398406, 15.9775398406) inset;
  color: rgb(178.1673306773, 29.8326693227, 29.8326693227);
}
.kb-labfront.container .ui.basic.red.buttons .button:active,
.kb-labfront.container .ui.basic.red.button:active {
  box-shadow: 0 0 0 1px rgb(178.1673306773, 29.8326693227, 29.8326693227) inset;
  color: rgb(178.1673306773, 29.8326693227, 29.8326693227);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.red.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.red.buttons .button,
.kb-labfront.container .ui.inverted.red.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #ff695e inset;
  color: #ff695e;
}
.kb-labfront.container .ui.inverted.red.buttons .button:hover,
.kb-labfront.container .ui.inverted.red.button:hover,
.kb-labfront.container .ui.inverted.red.buttons .button:focus,
.kb-labfront.container .ui.inverted.red.button:focus,
.kb-labfront.container .ui.inverted.red.buttons .button.active,
.kb-labfront.container .ui.inverted.red.button.active,
.kb-labfront.container .ui.inverted.red.buttons .button:active,
.kb-labfront.container .ui.inverted.red.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.red.buttons .button:hover,
.kb-labfront.container .ui.inverted.red.button:hover {
  background-color: rgb(255, 57.4844720497, 43);
}
.kb-labfront.container .ui.inverted.red.buttons .button:focus,
.kb-labfront.container .ui.inverted.red.button:focus {
  background-color: rgb(255, 66.9875776398, 53.2);
}
.kb-labfront.container .ui.inverted.red.buttons .active.button,
.kb-labfront.container .ui.inverted.red.active.button {
  background-color: rgb(255, 81.2422360248, 68.5);
}
.kb-labfront.container .ui.inverted.red.buttons .button:active,
.kb-labfront.container .ui.inverted.red.button:active {
  background-color: rgb(255, 57.4844720497, 43);
}
.kb-labfront.container .ui.inverted.red.basic.buttons .button,
.kb-labfront.container .ui.inverted.red.buttons .basic.button,
.kb-labfront.container .ui.inverted.red.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.red.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.red.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.red.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(255, 57.4844720497, 43) inset;
  color: #ff695e;
}
.kb-labfront.container .ui.inverted.red.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.red.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.red.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(255, 66.9875776398, 53.2) inset;
  color: #ff695e;
}
.kb-labfront.container .ui.inverted.red.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.red.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.red.basic.active.button {
  box-shadow: 0 0 0 2px rgb(255, 81.2422360248, 68.5) inset;
  color: #ff695e;
}
.kb-labfront.container .ui.inverted.red.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.red.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.red.basic.button:active {
  box-shadow: 0 0 0 2px rgb(255, 57.4844720497, 43) inset;
  color: #ff695e;
}
.kb-labfront.container .ui.tertiary.red.buttons .button,
.kb-labfront.container .ui.tertiary.red.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.red.button {
  background: transparent;
  box-shadow: none;
  color: #db2828;
}
.kb-labfront.container .ui.tertiary.red.buttons .button:hover,
.kb-labfront.container .ui.tertiary.red.buttons button:hover,
.kb-labfront.container .ui.tertiary.red.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(244.1, 14.9, 14.9);
  color: rgb(244.1, 14.9, 14.9);
}
.kb-labfront.container .ui.tertiary.red.buttons .button:focus,
.kb-labfront.container .ui.tertiary.red.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.red.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(186.9043824701, 31.2956175299, 31.2956175299);
  color: rgb(186.9043824701, 31.2956175299, 31.2956175299);
}
.kb-labfront.container .ui.tertiary.red.buttons .active.button,
.kb-labfront.container .ui.tertiary.red.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.red.active.button,
.kb-labfront.container .ui.tertiary.red.buttons .button:active,
.kb-labfront.container .ui.tertiary.red.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.red.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(233.5, 0, 0);
  color: rgb(217.5224601594, 15.9775398406, 15.9775398406);
}
.kb-labfront.container .ui.orange.buttons .button,
.kb-labfront.container .ui.orange.button {
  background-color: #f2711c;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.orange.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.orange.buttons .button:hover,
.kb-labfront.container .ui.orange.button:hover {
  background-color: rgb(243.48125, 97.3239485981, 1.01875);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.orange.buttons .button:focus,
.kb-labfront.container .ui.orange.button:focus {
  background-color: rgb(229.2, 91.0373831776, 0);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.orange.buttons .button:active,
.kb-labfront.container .ui.orange.button:active {
  background-color: rgb(207.1375, 89.425, 11.8625);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.orange.buttons .active.button,
.kb-labfront.container .ui.orange.buttons .active.button:active,
.kb-labfront.container .ui.orange.active.button,
.kb-labfront.container .ui.orange.button .active.button:active {
  background-color: rgb(244.5, 97.1144859813, 0);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.orange.buttons .button,
.kb-labfront.container .ui.basic.orange.button {
  background: transparent;
  box-shadow: 0 0 0 1px #f2711c inset;
  color: #f2711c;
}
.kb-labfront.container .ui.basic.orange.buttons .button:hover,
.kb-labfront.container .ui.basic.orange.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(243.48125, 97.3239485981, 1.01875) inset;
  color: rgb(243.48125, 97.3239485981, 1.01875);
}
.kb-labfront.container .ui.basic.orange.buttons .button:focus,
.kb-labfront.container .ui.basic.orange.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(229.2, 91.0373831776, 0) inset;
  color: rgb(243.48125, 97.3239485981, 1.01875);
}
.kb-labfront.container .ui.basic.orange.buttons .active.button,
.kb-labfront.container .ui.basic.orange.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(244.5, 97.1144859813, 0) inset;
  color: rgb(207.1375, 89.425, 11.8625);
}
.kb-labfront.container .ui.basic.orange.buttons .button:active,
.kb-labfront.container .ui.basic.orange.button:active {
  box-shadow: 0 0 0 1px rgb(207.1375, 89.425, 11.8625) inset;
  color: rgb(207.1375, 89.425, 11.8625);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.orange.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.orange.buttons .button,
.kb-labfront.container .ui.inverted.orange.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #ff851b inset;
  color: #ff851b;
}
.kb-labfront.container .ui.inverted.orange.buttons .button:hover,
.kb-labfront.container .ui.inverted.orange.button:hover,
.kb-labfront.container .ui.inverted.orange.buttons .button:focus,
.kb-labfront.container .ui.inverted.orange.button:focus,
.kb-labfront.container .ui.inverted.orange.buttons .button.active,
.kb-labfront.container .ui.inverted.orange.button.active,
.kb-labfront.container .ui.inverted.orange.buttons .button:active,
.kb-labfront.container .ui.inverted.orange.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.orange.buttons .button:hover,
.kb-labfront.container .ui.inverted.orange.button:hover {
  background-color: rgb(231, 107.3947368421, 0);
}
.kb-labfront.container .ui.inverted.orange.buttons .button:focus,
.kb-labfront.container .ui.inverted.orange.button:focus {
  background-color: rgb(241.2, 112.1368421053, 0);
}
.kb-labfront.container .ui.inverted.orange.buttons .active.button,
.kb-labfront.container .ui.inverted.orange.active.button {
  background-color: rgb(255, 119.3552631579, 1.5);
}
.kb-labfront.container .ui.inverted.orange.buttons .button:active,
.kb-labfront.container .ui.inverted.orange.button:active {
  background-color: rgb(231, 107.3947368421, 0);
}
.kb-labfront.container .ui.inverted.orange.basic.buttons .button,
.kb-labfront.container .ui.inverted.orange.buttons .basic.button,
.kb-labfront.container .ui.inverted.orange.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.orange.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.orange.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.orange.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(231, 107.3947368421, 0) inset;
  color: #ff851b;
}
.kb-labfront.container .ui.inverted.orange.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.orange.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.orange.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(241.2, 112.1368421053, 0) inset;
  color: #ff851b;
}
.kb-labfront.container .ui.inverted.orange.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.orange.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.orange.basic.active.button {
  box-shadow: 0 0 0 2px rgb(255, 119.3552631579, 1.5) inset;
  color: #ff851b;
}
.kb-labfront.container .ui.inverted.orange.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.orange.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.orange.basic.button:active {
  box-shadow: 0 0 0 2px rgb(231, 107.3947368421, 0) inset;
  color: #ff851b;
}
.kb-labfront.container .ui.tertiary.orange.buttons .button,
.kb-labfront.container .ui.tertiary.orange.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.orange.button {
  background: transparent;
  box-shadow: none;
  color: #f2711c;
}
.kb-labfront.container .ui.tertiary.orange.buttons .button:hover,
.kb-labfront.container .ui.tertiary.orange.buttons button:hover,
.kb-labfront.container .ui.tertiary.orange.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(255, 110.3271028037, 15);
  color: rgb(255, 110.3271028037, 15);
}
.kb-labfront.container .ui.tertiary.orange.buttons .button:focus,
.kb-labfront.container .ui.tertiary.orange.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.orange.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(206.28, 95.7499065421, 22.92);
  color: rgb(206.28, 95.7499065421, 22.92);
}
.kb-labfront.container .ui.tertiary.orange.buttons .active.button,
.kb-labfront.container .ui.tertiary.orange.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.orange.active.button,
.kb-labfront.container .ui.tertiary.orange.buttons .button:active,
.kb-labfront.container .ui.tertiary.orange.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.orange.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(244.5, 97.1144859813, 0);
  color: rgb(244.5, 97.1144859813, 0);
}
.kb-labfront.container .ui.yellow.buttons .button,
.kb-labfront.container .ui.yellow.button {
  background-color: #fbbd08;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.yellow.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.yellow.buttons .button:hover,
.kb-labfront.container .ui.yellow.button:hover {
  background-color: rgb(233.5, 173.9238683128, 0);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.yellow.buttons .button:focus,
.kb-labfront.container .ui.yellow.button:focus {
  background-color: rgb(218.2, 162.5275720165, 0);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.yellow.buttons .button:active,
.kb-labfront.container .ui.yellow.button:active {
  background-color: rgb(204.6852589641, 153.3067729084, 3.3147410359);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.yellow.buttons .active.button,
.kb-labfront.container .ui.yellow.buttons .active.button:active,
.kb-labfront.container .ui.yellow.active.button,
.kb-labfront.container .ui.yellow.button .active.button:active {
  background-color: rgb(233.5, 173.9238683128, 0);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.yellow.buttons .button,
.kb-labfront.container .ui.basic.yellow.button {
  background: transparent;
  box-shadow: 0 0 0 1px #fbbd08 inset;
  color: #fbbd08;
}
.kb-labfront.container .ui.basic.yellow.buttons .button:hover,
.kb-labfront.container .ui.basic.yellow.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(233.5, 173.9238683128, 0) inset;
  color: rgb(233.5, 173.9238683128, 0);
}
.kb-labfront.container .ui.basic.yellow.buttons .button:focus,
.kb-labfront.container .ui.basic.yellow.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(218.2, 162.5275720165, 0) inset;
  color: rgb(233.5, 173.9238683128, 0);
}
.kb-labfront.container .ui.basic.yellow.buttons .active.button,
.kb-labfront.container .ui.basic.yellow.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(233.5, 173.9238683128, 0) inset;
  color: rgb(204.6852589641, 153.3067729084, 3.3147410359);
}
.kb-labfront.container .ui.basic.yellow.buttons .button:active,
.kb-labfront.container .ui.basic.yellow.button:active {
  box-shadow: 0 0 0 1px rgb(204.6852589641, 153.3067729084, 3.3147410359) inset;
  color: rgb(204.6852589641, 153.3067729084, 3.3147410359);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.yellow.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.yellow.buttons .button,
.kb-labfront.container .ui.inverted.yellow.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #ffe21f inset;
  color: #ffe21f;
}
.kb-labfront.container .ui.inverted.yellow.buttons .button:hover,
.kb-labfront.container .ui.inverted.yellow.button:hover,
.kb-labfront.container .ui.inverted.yellow.buttons .button:focus,
.kb-labfront.container .ui.inverted.yellow.button:focus,
.kb-labfront.container .ui.inverted.yellow.buttons .button.active,
.kb-labfront.container .ui.inverted.yellow.button.active,
.kb-labfront.container .ui.inverted.yellow.buttons .button:active,
.kb-labfront.container .ui.inverted.yellow.button:active {
  box-shadow: none;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.inverted.yellow.buttons .button:hover,
.kb-labfront.container .ui.inverted.yellow.button:hover {
  background-color: rgb(235, 204.5758928571, 0);
}
.kb-labfront.container .ui.inverted.yellow.buttons .button:focus,
.kb-labfront.container .ui.inverted.yellow.button:focus {
  background-color: rgb(245.2, 213.4553571429, 0);
}
.kb-labfront.container .ui.inverted.yellow.buttons .active.button,
.kb-labfront.container .ui.inverted.yellow.active.button {
  background-color: rgb(255, 222.6986607143, 5.5);
}
.kb-labfront.container .ui.inverted.yellow.buttons .button:active,
.kb-labfront.container .ui.inverted.yellow.button:active {
  background-color: rgb(235, 204.5758928571, 0);
}
.kb-labfront.container .ui.inverted.yellow.basic.buttons .button,
.kb-labfront.container .ui.inverted.yellow.buttons .basic.button,
.kb-labfront.container .ui.inverted.yellow.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.yellow.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.yellow.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.yellow.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(235, 204.5758928571, 0) inset;
  color: #ffe21f;
}
.kb-labfront.container .ui.inverted.yellow.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.yellow.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.yellow.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(245.2, 213.4553571429, 0) inset;
  color: #ffe21f;
}
.kb-labfront.container .ui.inverted.yellow.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.yellow.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.yellow.basic.active.button {
  box-shadow: 0 0 0 2px rgb(255, 222.6986607143, 5.5) inset;
  color: #ffe21f;
}
.kb-labfront.container .ui.inverted.yellow.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.yellow.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.yellow.basic.button:active {
  box-shadow: 0 0 0 2px rgb(235, 204.5758928571, 0) inset;
  color: #ffe21f;
}
.kb-labfront.container .ui.tertiary.yellow.buttons .button,
.kb-labfront.container .ui.tertiary.yellow.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.yellow.button {
  background: transparent;
  box-shadow: none;
  color: #fbbd08;
}
.kb-labfront.container .ui.tertiary.yellow.buttons .button:hover,
.kb-labfront.container .ui.tertiary.yellow.buttons button:hover,
.kb-labfront.container .ui.tertiary.yellow.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(255, 190.9588477366, 4);
  color: rgb(255, 190.9588477366, 4);
}
.kb-labfront.container .ui.tertiary.yellow.buttons .button:focus,
.kb-labfront.container .ui.tertiary.yellow.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.yellow.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(196.38, 151.8420576132, 21.82);
  color: rgb(196.38, 151.8420576132, 21.82);
}
.kb-labfront.container .ui.tertiary.yellow.buttons .active.button,
.kb-labfront.container .ui.tertiary.yellow.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.yellow.active.button,
.kb-labfront.container .ui.tertiary.yellow.buttons .button:active,
.kb-labfront.container .ui.tertiary.yellow.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.yellow.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(233.5, 173.9238683128, 0);
  color: rgb(233.5, 173.9238683128, 0);
}
.kb-labfront.container .ui.olive.buttons .button,
.kb-labfront.container .ui.olive.button {
  background-color: #b5cc18;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.olive.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.olive.buttons .button:hover,
.kb-labfront.container .ui.olive.button:hover {
  background-color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.olive.buttons .button:focus,
.kb-labfront.container .ui.olive.button:focus {
  background-color: rgb(162.5465263158, 186.2147368421, 0.9852631579);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.olive.buttons .button:active,
.kb-labfront.container .ui.olive.button:active {
  background-color: rgb(140.5131578947, 158.3684210526, 18.6315789474);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.olive.buttons .active.button,
.kb-labfront.container .ui.olive.buttons .active.button:active,
.kb-labfront.container .ui.olive.active.button,
.kb-labfront.container .ui.olive.button .active.button:active {
  background-color: rgb(172.0628289474, 196.3717105263, 6.1282894737);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.olive.buttons .button,
.kb-labfront.container .ui.basic.olive.button {
  background: transparent;
  box-shadow: 0 0 0 1px #b5cc18 inset;
  color: #b5cc18;
}
.kb-labfront.container .ui.basic.olive.buttons .button:hover,
.kb-labfront.container .ui.basic.olive.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(168.2940789474, 191.3092105263, 11.1907894737) inset;
  color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
}
.kb-labfront.container .ui.basic.olive.buttons .button:focus,
.kb-labfront.container .ui.basic.olive.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(162.5465263158, 186.2147368421, 0.9852631579) inset;
  color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
}
.kb-labfront.container .ui.basic.olive.buttons .active.button,
.kb-labfront.container .ui.basic.olive.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(172.0628289474, 196.3717105263, 6.1282894737) inset;
  color: rgb(140.5131578947, 158.3684210526, 18.6315789474);
}
.kb-labfront.container .ui.basic.olive.buttons .button:active,
.kb-labfront.container .ui.basic.olive.button:active {
  box-shadow: 0 0 0 1px rgb(140.5131578947, 158.3684210526, 18.6315789474) inset;
  color: rgb(140.5131578947, 158.3684210526, 18.6315789474);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.olive.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.olive.buttons .button,
.kb-labfront.container .ui.inverted.olive.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #d9e778 inset;
  color: #d9e778;
}
.kb-labfront.container .ui.inverted.olive.buttons .button:hover,
.kb-labfront.container .ui.inverted.olive.button:hover,
.kb-labfront.container .ui.inverted.olive.buttons .button:focus,
.kb-labfront.container .ui.inverted.olive.button:focus,
.kb-labfront.container .ui.inverted.olive.buttons .button.active,
.kb-labfront.container .ui.inverted.olive.button.active,
.kb-labfront.container .ui.inverted.olive.buttons .button:active,
.kb-labfront.container .ui.inverted.olive.button:active {
  box-shadow: none;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.inverted.olive.buttons .button:hover,
.kb-labfront.container .ui.inverted.olive.button:hover {
  background-color: rgb(212.6626721061, 233.8018867925, 66.1981132075);
}
.kb-labfront.container .ui.inverted.olive.buttons .button:focus,
.kb-labfront.container .ui.inverted.olive.button:focus {
  background-color: rgb(222.1890566038, 244.821509434, 65.378490566);
}
.kb-labfront.container .ui.inverted.olive.buttons .active.button,
.kb-labfront.container .ui.inverted.olive.active.button {
  background-color: rgb(221.2526198368, 240.9884433962, 84.5115566038);
}
.kb-labfront.container .ui.inverted.olive.buttons .button:active,
.kb-labfront.container .ui.inverted.olive.button:active {
  background-color: rgb(204.8113207547, 223.3018867925, 76.6981132075);
}
.kb-labfront.container .ui.inverted.olive.basic.buttons .button,
.kb-labfront.container .ui.inverted.olive.buttons .basic.button,
.kb-labfront.container .ui.inverted.olive.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.olive.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.olive.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.olive.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(212.6626721061, 233.8018867925, 66.1981132075) inset;
  color: #d9e778;
}
.kb-labfront.container .ui.inverted.olive.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.olive.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.olive.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(222.1890566038, 244.821509434, 65.378490566) inset;
  color: #d9e778;
}
.kb-labfront.container .ui.inverted.olive.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.olive.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.olive.basic.active.button {
  box-shadow: 0 0 0 2px rgb(221.2526198368, 240.9884433962, 84.5115566038) inset;
  color: #d9e778;
}
.kb-labfront.container .ui.inverted.olive.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.olive.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.olive.basic.button:active {
  box-shadow: 0 0 0 2px rgb(204.8113207547, 223.3018867925, 76.6981132075) inset;
  color: #d9e778;
}
.kb-labfront.container .ui.tertiary.olive.buttons .button,
.kb-labfront.container .ui.tertiary.olive.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.olive.button {
  background: transparent;
  box-shadow: none;
  color: #b5cc18;
}
.kb-labfront.container .ui.tertiary.olive.buttons .button:hover,
.kb-labfront.container .ui.tertiary.olive.buttons button:hover,
.kb-labfront.container .ui.tertiary.olive.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(197.9733333333, 226.8, 1.2);
  color: rgb(197.9733333333, 226.8, 1.2);
}
.kb-labfront.container .ui.tertiary.olive.buttons .button:focus,
.kb-labfront.container .ui.tertiary.olive.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.olive.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(148.6105263158, 167.4947368421, 19.7052631579);
  color: rgb(148.6105263158, 167.4947368421, 19.7052631579);
}
.kb-labfront.container .ui.tertiary.olive.buttons .active.button,
.kb-labfront.container .ui.tertiary.olive.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.olive.active.button,
.kb-labfront.container .ui.tertiary.olive.buttons .button:active,
.kb-labfront.container .ui.tertiary.olive.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.olive.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(176.625, 202.5, 0);
  color: rgb(172.0628289474, 196.3717105263, 6.1282894737);
}
.kb-labfront.container .ui.green.buttons .button,
.kb-labfront.container .ui.green.button {
  background-color: #21ba45;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.green.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.green.buttons .button:hover,
.kb-labfront.container .ui.green.button:hover {
  background-color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.green.buttons .button:focus,
.kb-labfront.container .ui.green.button:focus {
  background-color: rgb(9.0320547945, 169.1679452055, 46.7110878324);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.green.buttons .button:active,
.kb-labfront.container .ui.green.button:active {
  background-color: rgb(25.3150684932, 142.6849315068, 52.9315068493);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.green.buttons .active.button,
.kb-labfront.container .ui.green.buttons .active.button:active,
.kb-labfront.container .ui.green.active.button,
.kb-labfront.container .ui.green.button .active.button:active {
  background-color: rgb(14.6450342466, 178.8549657534, 53.2826651894);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.green.buttons .button,
.kb-labfront.container .ui.basic.green.button {
  background: transparent;
  box-shadow: 0 0 0 1px #21ba45 inset;
  color: #21ba45;
}
.kb-labfront.container .ui.basic.green.buttons .button:hover,
.kb-labfront.container .ui.basic.green.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(19.4825342466, 174.0174657534, 55.8436946011) inset;
  color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.basic.green.buttons .button:focus,
.kb-labfront.container .ui.basic.green.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(9.0320547945, 169.1679452055, 46.7110878324) inset;
  color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.basic.green.buttons .active.button,
.kb-labfront.container .ui.basic.green.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(14.6450342466, 178.8549657534, 53.2826651894) inset;
  color: rgb(25.3150684932, 142.6849315068, 52.9315068493);
}
.kb-labfront.container .ui.basic.green.buttons .button:active,
.kb-labfront.container .ui.basic.green.button:active {
  box-shadow: 0 0 0 1px rgb(25.3150684932, 142.6849315068, 52.9315068493) inset;
  color: rgb(25.3150684932, 142.6849315068, 52.9315068493);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.green.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.green.buttons .button,
.kb-labfront.container .ui.inverted.green.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #2ecc40 inset;
  color: #2ecc40;
}
.kb-labfront.container .ui.inverted.green.buttons .button:hover,
.kb-labfront.container .ui.inverted.green.button:hover,
.kb-labfront.container .ui.inverted.green.buttons .button:focus,
.kb-labfront.container .ui.inverted.green.button:focus,
.kb-labfront.container .ui.inverted.green.buttons .button.active,
.kb-labfront.container .ui.inverted.green.button.active,
.kb-labfront.container .ui.inverted.green.buttons .button:active,
.kb-labfront.container .ui.inverted.green.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.green.buttons .button:hover,
.kb-labfront.container .ui.inverted.green.button:hover {
  background-color: rgb(26.666, 172.334, 43.2610886076);
}
.kb-labfront.container .ui.inverted.green.buttons .button:focus,
.kb-labfront.container .ui.inverted.green.button:focus {
  background-color: rgb(17.5728, 191.6272, 37.4017822785);
}
.kb-labfront.container .ui.inverted.green.buttons .active.button,
.kb-labfront.container .ui.inverted.green.active.button {
  background-color: rgb(24.4705, 200.0295, 44.4708924051);
}
.kb-labfront.container .ui.inverted.green.buttons .button:active,
.kb-labfront.container .ui.inverted.green.button:active {
  background-color: rgb(36.616, 162.384, 50.944);
}
.kb-labfront.container .ui.inverted.green.basic.buttons .button,
.kb-labfront.container .ui.inverted.green.buttons .basic.button,
.kb-labfront.container .ui.inverted.green.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.green.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.green.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.green.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(26.666, 172.334, 43.2610886076) inset;
  color: #2ecc40;
}
.kb-labfront.container .ui.inverted.green.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.green.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.green.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(17.5728, 191.6272, 37.4017822785) inset;
  color: #2ecc40;
}
.kb-labfront.container .ui.inverted.green.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.green.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.green.basic.active.button {
  box-shadow: 0 0 0 2px rgb(24.4705, 200.0295, 44.4708924051) inset;
  color: #2ecc40;
}
.kb-labfront.container .ui.inverted.green.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.green.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.green.basic.button:active {
  box-shadow: 0 0 0 2px rgb(36.616, 162.384, 50.944) inset;
  color: #2ecc40;
}
.kb-labfront.container .ui.tertiary.green.buttons .button,
.kb-labfront.container .ui.tertiary.green.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.green.button {
  background: transparent;
  box-shadow: none;
  color: #21ba45;
}
.kb-labfront.container .ui.tertiary.green.buttons .button:hover,
.kb-labfront.container .ui.tertiary.green.buttons button:hover,
.kb-labfront.container .ui.tertiary.green.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(11.1, 207.9, 57.4058823529);
  color: rgb(11.1, 207.9, 57.4058823529);
}
.kb-labfront.container .ui.tertiary.green.buttons .button:focus,
.kb-labfront.container .ui.tertiary.green.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.green.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(26.8520547945, 151.3479452055, 56.1452054795);
  color: rgb(26.8520547945, 151.3479452055, 56.1452054795);
}
.kb-labfront.container .ui.tertiary.green.buttons .active.button,
.kb-labfront.container .ui.tertiary.green.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.green.active.button,
.kb-labfront.container .ui.tertiary.green.buttons .button:active,
.kb-labfront.container .ui.tertiary.green.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.green.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(0, 193.5, 45.5294117647);
  color: rgb(14.6450342466, 178.8549657534, 53.2826651894);
}
.kb-labfront.container .ui.teal.buttons .button,
.kb-labfront.container .ui.teal.button {
  background-color: #00b5ad;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.teal.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.teal.buttons .button:hover,
.kb-labfront.container .ui.teal.button:hover {
  background-color: rgb(0, 155.5, 148.6270718232);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.teal.buttons .button:focus,
.kb-labfront.container .ui.teal.button:focus {
  background-color: rgb(0, 140.2, 134.0033149171);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.teal.buttons .button:active,
.kb-labfront.container .ui.teal.button:active {
  background-color: rgb(0, 130, 124.2541436464);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.teal.buttons .active.button,
.kb-labfront.container .ui.teal.buttons .active.button:active,
.kb-labfront.container .ui.teal.active.button,
.kb-labfront.container .ui.teal.button .active.button:active {
  background-color: rgb(0, 155.5, 148.6270718232);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.teal.buttons .button,
.kb-labfront.container .ui.basic.teal.button {
  background: transparent;
  box-shadow: 0 0 0 1px #00b5ad inset;
  color: #00b5ad;
}
.kb-labfront.container .ui.basic.teal.buttons .button:hover,
.kb-labfront.container .ui.basic.teal.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(0, 155.5, 148.6270718232) inset;
  color: rgb(0, 155.5, 148.6270718232);
}
.kb-labfront.container .ui.basic.teal.buttons .button:focus,
.kb-labfront.container .ui.basic.teal.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(0, 140.2, 134.0033149171) inset;
  color: rgb(0, 155.5, 148.6270718232);
}
.kb-labfront.container .ui.basic.teal.buttons .active.button,
.kb-labfront.container .ui.basic.teal.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(0, 155.5, 148.6270718232) inset;
  color: rgb(0, 130, 124.2541436464);
}
.kb-labfront.container .ui.basic.teal.buttons .button:active,
.kb-labfront.container .ui.basic.teal.button:active {
  box-shadow: 0 0 0 1px rgb(0, 130, 124.2541436464) inset;
  color: rgb(0, 130, 124.2541436464);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.teal.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.teal.buttons .button,
.kb-labfront.container .ui.inverted.teal.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #6dffff inset;
  color: #6dffff;
}
.kb-labfront.container .ui.inverted.teal.buttons .button:hover,
.kb-labfront.container .ui.inverted.teal.button:hover,
.kb-labfront.container .ui.inverted.teal.buttons .button:focus,
.kb-labfront.container .ui.inverted.teal.button:focus,
.kb-labfront.container .ui.inverted.teal.buttons .button.active,
.kb-labfront.container .ui.inverted.teal.button.active,
.kb-labfront.container .ui.inverted.teal.buttons .button:active,
.kb-labfront.container .ui.inverted.teal.button:active {
  box-shadow: none;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.inverted.teal.buttons .button:hover,
.kb-labfront.container .ui.inverted.teal.button:hover {
  background-color: #3affff;
}
.kb-labfront.container .ui.inverted.teal.buttons .button:focus,
.kb-labfront.container .ui.inverted.teal.button:focus {
  background-color: rgb(68.2, 255, 255);
}
.kb-labfront.container .ui.inverted.teal.buttons .active.button,
.kb-labfront.container .ui.inverted.teal.active.button {
  background-color: rgb(83.5, 255, 255);
}
.kb-labfront.container .ui.inverted.teal.buttons .button:active,
.kb-labfront.container .ui.inverted.teal.button:active {
  background-color: #3affff;
}
.kb-labfront.container .ui.inverted.teal.basic.buttons .button,
.kb-labfront.container .ui.inverted.teal.buttons .basic.button,
.kb-labfront.container .ui.inverted.teal.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.teal.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.teal.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.teal.basic.button:hover {
  box-shadow: 0 0 0 2px #3affff inset;
  color: #6dffff;
}
.kb-labfront.container .ui.inverted.teal.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.teal.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.teal.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(68.2, 255, 255) inset;
  color: #6dffff;
}
.kb-labfront.container .ui.inverted.teal.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.teal.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.teal.basic.active.button {
  box-shadow: 0 0 0 2px rgb(83.5, 255, 255) inset;
  color: #6dffff;
}
.kb-labfront.container .ui.inverted.teal.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.teal.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.teal.basic.button:active {
  box-shadow: 0 0 0 2px #3affff inset;
  color: #6dffff;
}
.kb-labfront.container .ui.tertiary.teal.buttons .button,
.kb-labfront.container .ui.tertiary.teal.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.teal.button {
  background: transparent;
  box-shadow: none;
  color: #00b5ad;
}
.kb-labfront.container .ui.tertiary.teal.buttons .button:hover,
.kb-labfront.container .ui.tertiary.teal.buttons button:hover,
.kb-labfront.container .ui.tertiary.teal.button:hover {
  box-shadow: inset 0 -0.2em 0 #00b5ad;
  color: #00b5ad;
}
.kb-labfront.container .ui.tertiary.teal.buttons .button:focus,
.kb-labfront.container .ui.tertiary.teal.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.teal.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(14.02, 126.18, 121.2226519337);
  color: rgb(14.02, 126.18, 121.2226519337);
}
.kb-labfront.container .ui.tertiary.teal.buttons .active.button,
.kb-labfront.container .ui.tertiary.teal.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.teal.active.button,
.kb-labfront.container .ui.tertiary.teal.buttons .button:active,
.kb-labfront.container .ui.tertiary.teal.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.teal.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(0, 155.5, 148.6270718232);
  color: rgb(0, 155.5, 148.6270718232);
}
.kb-labfront.container .ui.blue.buttons .button,
.kb-labfront.container .ui.blue.button {
  background-color: #2185d0;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.blue.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.blue.buttons .button:hover,
.kb-labfront.container .ui.blue.button:hover {
  background-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.blue.buttons .button:focus,
.kb-labfront.container .ui.blue.button:focus {
  background-color: rgb(7.3932780083, 113.3438174274, 192.8067219917);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.blue.buttons .button:active,
.kb-labfront.container .ui.blue.button:active {
  background-color: rgb(26.0165975104, 104.8547717842, 163.9834024896);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.blue.buttons .active.button,
.kb-labfront.container .ui.blue.buttons .active.button:active,
.kb-labfront.container .ui.blue.active.button,
.kb-labfront.container .ui.blue.button .active.button:active {
  background-color: rgb(13.3457987552, 121.2363144635, 202.1542012448);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.blue.buttons .button,
.kb-labfront.container .ui.basic.blue.button {
  background: transparent;
  box-shadow: 0 0 0 1px #2185d0 inset;
  color: #2185d0;
}
.kb-labfront.container .ui.basic.blue.buttons .button:hover,
.kb-labfront.container .ui.basic.blue.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(18.7332987552, 120.4666716064, 196.7667012448) inset;
  color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.basic.blue.buttons .button:focus,
.kb-labfront.container .ui.basic.blue.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(7.3932780083, 113.3438174274, 192.8067219917) inset;
  color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.basic.blue.buttons .active.button,
.kb-labfront.container .ui.basic.blue.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(13.3457987552, 121.2363144635, 202.1542012448) inset;
  color: rgb(26.0165975104, 104.8547717842, 163.9834024896);
}
.kb-labfront.container .ui.basic.blue.buttons .button:active,
.kb-labfront.container .ui.basic.blue.button:active {
  box-shadow: 0 0 0 1px rgb(26.0165975104, 104.8547717842, 163.9834024896) inset;
  color: rgb(26.0165975104, 104.8547717842, 163.9834024896);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.blue.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.blue.buttons .button,
.kb-labfront.container .ui.inverted.blue.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #54c8ff inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.blue.buttons .button:hover,
.kb-labfront.container .ui.inverted.blue.button:hover,
.kb-labfront.container .ui.inverted.blue.buttons .button:focus,
.kb-labfront.container .ui.inverted.blue.button:focus,
.kb-labfront.container .ui.inverted.blue.buttons .button.active,
.kb-labfront.container .ui.inverted.blue.button.active,
.kb-labfront.container .ui.inverted.blue.buttons .button:active,
.kb-labfront.container .ui.inverted.blue.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.blue.buttons .button:hover,
.kb-labfront.container .ui.inverted.blue.button:hover {
  background-color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.blue.buttons .button:focus,
.kb-labfront.container .ui.inverted.blue.button:focus {
  background-color: rgb(43.2, 186.8771929825, 255);
}
.kb-labfront.container .ui.inverted.blue.buttons .active.button,
.kb-labfront.container .ui.inverted.blue.active.button {
  background-color: rgb(58.5, 191.798245614, 255);
}
.kb-labfront.container .ui.inverted.blue.buttons .button:active,
.kb-labfront.container .ui.inverted.blue.button:active {
  background-color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.blue.basic.buttons .button,
.kb-labfront.container .ui.inverted.blue.buttons .basic.button,
.kb-labfront.container .ui.inverted.blue.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.blue.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.blue.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.blue.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(33, 183.5964912281, 255) inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.blue.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.blue.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.blue.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(43.2, 186.8771929825, 255) inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.blue.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.blue.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.blue.basic.active.button {
  box-shadow: 0 0 0 2px rgb(58.5, 191.798245614, 255) inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.blue.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.blue.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.blue.basic.button:active {
  box-shadow: 0 0 0 2px rgb(33, 183.5964912281, 255) inset;
  color: #54c8ff;
}
.kb-labfront.container .ui.tertiary.blue.buttons .button,
.kb-labfront.container .ui.tertiary.blue.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.blue.button {
  background: transparent;
  box-shadow: none;
  color: #2185d0;
}
.kb-labfront.container .ui.tertiary.blue.buttons .button:hover,
.kb-labfront.container .ui.tertiary.blue.buttons button:hover,
.kb-labfront.container .ui.tertiary.blue.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(8.9, 136.4428571429, 232.1);
  color: rgb(8.9, 136.4428571429, 232.1);
}
.kb-labfront.container .ui.tertiary.blue.buttons .button:focus,
.kb-labfront.container .ui.tertiary.blue.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.blue.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(27.4132780083, 110.4838174274, 172.7867219917);
  color: rgb(27.4132780083, 110.4838174274, 172.7867219917);
}
.kb-labfront.container .ui.tertiary.blue.buttons .active.button,
.kb-labfront.container .ui.tertiary.blue.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.blue.active.button,
.kb-labfront.container .ui.tertiary.blue.buttons .button:active,
.kb-labfront.container .ui.tertiary.blue.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.blue.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(0, 123.1428571429, 215.5);
  color: rgb(13.3457987552, 121.2363144635, 202.1542012448);
}
.kb-labfront.container .ui.violet.buttons .button,
.kb-labfront.container .ui.violet.button {
  background-color: #6435c9;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.violet.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.violet.buttons .button:hover,
.kb-labfront.container .ui.violet.button:hover {
  background-color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.violet.buttons .button:focus,
.kb-labfront.container .ui.violet.button:focus {
  background-color: rgb(76.1580889551, 23.1666141732, 190.0333858268);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.violet.buttons .button:active,
.kb-labfront.container .ui.violet.button:active {
  background-color: rgb(79.9212598425, 42.3582677165, 160.6417322835);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.violet.buttons .active.button,
.kb-labfront.container .ui.violet.buttons .active.button:active,
.kb-labfront.container .ui.violet.active.button,
.kb-labfront.container .ui.violet.button .active.button:active {
  background-color: rgb(83.7077582996, 30.5416338583, 197.9583661417);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.violet.buttons .button,
.kb-labfront.container .ui.basic.violet.button {
  background: transparent;
  box-shadow: 0 0 0 1px #6435c9 inset;
  color: #6435c9;
}
.kb-labfront.container .ui.basic.violet.buttons .button:hover,
.kb-labfront.container .ui.basic.violet.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(85.7920488402, 36.2541338583, 192.2458661417) inset;
  color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
}
.kb-labfront.container .ui.basic.violet.buttons .button:focus,
.kb-labfront.container .ui.basic.violet.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(76.1580889551, 23.1666141732, 190.0333858268) inset;
  color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
}
.kb-labfront.container .ui.basic.violet.buttons .active.button,
.kb-labfront.container .ui.basic.violet.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(83.7077582996, 30.5416338583, 197.9583661417) inset;
  color: rgb(79.9212598425, 42.3582677165, 160.6417322835);
}
.kb-labfront.container .ui.basic.violet.buttons .button:active,
.kb-labfront.container .ui.basic.violet.button:active {
  box-shadow: 0 0 0 1px rgb(79.9212598425, 42.3582677165, 160.6417322835) inset;
  color: rgb(79.9212598425, 42.3582677165, 160.6417322835);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.violet.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.violet.buttons .button,
.kb-labfront.container .ui.inverted.violet.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #a291fb inset;
  color: #a291fb;
}
.kb-labfront.container .ui.inverted.violet.buttons .button:hover,
.kb-labfront.container .ui.inverted.violet.button:hover,
.kb-labfront.container .ui.inverted.violet.buttons .button:focus,
.kb-labfront.container .ui.inverted.violet.button:focus,
.kb-labfront.container .ui.inverted.violet.buttons .button.active,
.kb-labfront.container .ui.inverted.violet.button.active,
.kb-labfront.container .ui.inverted.violet.buttons .button:active,
.kb-labfront.container .ui.inverted.violet.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.violet.buttons .button:hover,
.kb-labfront.container .ui.inverted.violet.button:hover {
  background-color: rgb(116.4622641509, 90, 255);
}
.kb-labfront.container .ui.inverted.violet.buttons .button:focus,
.kb-labfront.container .ui.inverted.violet.button:focus {
  background-color: rgb(125.0264150943, 100.2, 255);
}
.kb-labfront.container .ui.inverted.violet.buttons .active.button,
.kb-labfront.container .ui.inverted.violet.active.button {
  background-color: rgb(137.8726415094, 115.5, 255);
}
.kb-labfront.container .ui.inverted.violet.buttons .button:active,
.kb-labfront.container .ui.inverted.violet.button:active {
  background-color: rgb(120.3947368421, 95.7894736842, 249.2105263158);
}
.kb-labfront.container .ui.inverted.violet.basic.buttons .button,
.kb-labfront.container .ui.inverted.violet.buttons .basic.button,
.kb-labfront.container .ui.inverted.violet.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.violet.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.violet.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.violet.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(116.4622641509, 90, 255) inset;
  color: #a291fb;
}
.kb-labfront.container .ui.inverted.violet.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.violet.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.violet.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(125.0264150943, 100.2, 255) inset;
  color: #a291fb;
}
.kb-labfront.container .ui.inverted.violet.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.violet.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.violet.basic.active.button {
  box-shadow: 0 0 0 2px rgb(137.8726415094, 115.5, 255) inset;
  color: #a291fb;
}
.kb-labfront.container .ui.inverted.violet.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.violet.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.violet.basic.button:active {
  box-shadow: 0 0 0 2px rgb(120.3947368421, 95.7894736842, 249.2105263158) inset;
  color: #a291fb;
}
.kb-labfront.container .ui.tertiary.violet.buttons .button,
.kb-labfront.container .ui.tertiary.violet.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.violet.button {
  background: transparent;
  box-shadow: none;
  color: #6435c9;
}
.kb-labfront.container .ui.tertiary.violet.buttons .button:hover,
.kb-labfront.container .ui.tertiary.violet.buttons button:hover,
.kb-labfront.container .ui.tertiary.violet.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(90.7324324324, 27.6, 226.4);
  color: rgb(90.7324324324, 27.6, 226.4);
}
.kb-labfront.container .ui.tertiary.violet.buttons .button:focus,
.kb-labfront.container .ui.tertiary.violet.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.violet.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(83.937007874, 44.4866141732, 168.7133858268);
  color: rgb(83.937007874, 44.4866141732, 168.7133858268);
}
.kb-labfront.container .ui.tertiary.violet.buttons .active.button,
.kb-labfront.container .ui.tertiary.violet.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.violet.active.button,
.kb-labfront.container .ui.tertiary.violet.buttons .button:active,
.kb-labfront.container .ui.tertiary.violet.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.violet.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(75.3705961375, 7.6916338583, 220.8083661417);
  color: rgb(83.7077582996, 30.5416338583, 197.9583661417);
}
.kb-labfront.container .ui.purple.buttons .button,
.kb-labfront.container .ui.purple.button {
  background-color: #a333c8;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.purple.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.purple.buttons .button:hover,
.kb-labfront.container .ui.purple.button:hover {
  background-color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.purple.buttons .button:focus,
.kb-labfront.container .ui.purple.button:focus {
  background-color: rgb(147.0849193829, 21.6899601594, 188.5100398406);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.purple.buttons .button:active,
.kb-labfront.container .ui.purple.button:active {
  background-color: rgb(129.8804780876, 40.6374501992, 159.3625498008);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.purple.buttons .active.button,
.kb-labfront.container .ui.purple.buttons .active.button:active,
.kb-labfront.container .ui.purple.active.button,
.kb-labfront.container .ui.purple.button .active.button:active {
  background-color: rgb(154.9532423995, 28.9062250996, 196.5937749004);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.purple.buttons .button,
.kb-labfront.container .ui.basic.purple.button {
  background: transparent;
  box-shadow: 0 0 0 1px #a333c8 inset;
  color: #a333c8;
}
.kb-labfront.container .ui.basic.purple.buttons .button:hover,
.kb-labfront.container .ui.basic.purple.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(152.1155746143, 34.5437250996, 190.9562749004) inset;
  color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
}
.kb-labfront.container .ui.basic.purple.buttons .button:focus,
.kb-labfront.container .ui.basic.purple.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(147.0849193829, 21.6899601594, 188.5100398406) inset;
  color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
}
.kb-labfront.container .ui.basic.purple.buttons .active.button,
.kb-labfront.container .ui.basic.purple.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(154.9532423995, 28.9062250996, 196.5937749004) inset;
  color: rgb(129.8804780876, 40.6374501992, 159.3625498008);
}
.kb-labfront.container .ui.basic.purple.buttons .button:active,
.kb-labfront.container .ui.basic.purple.button:active {
  box-shadow: 0 0 0 1px rgb(129.8804780876, 40.6374501992, 159.3625498008) inset;
  color: rgb(129.8804780876, 40.6374501992, 159.3625498008);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.purple.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.purple.buttons .button,
.kb-labfront.container .ui.inverted.purple.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #dc73ff inset;
  color: #dc73ff;
}
.kb-labfront.container .ui.inverted.purple.buttons .button:hover,
.kb-labfront.container .ui.inverted.purple.button:hover,
.kb-labfront.container .ui.inverted.purple.buttons .button:focus,
.kb-labfront.container .ui.inverted.purple.button:focus,
.kb-labfront.container .ui.inverted.purple.buttons .button.active,
.kb-labfront.container .ui.inverted.purple.button.active,
.kb-labfront.container .ui.inverted.purple.buttons .button:active,
.kb-labfront.container .ui.inverted.purple.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.purple.buttons .button:hover,
.kb-labfront.container .ui.inverted.purple.button:hover {
  background-color: rgb(207.25, 64, 255);
}
.kb-labfront.container .ui.inverted.purple.buttons .button:focus,
.kb-labfront.container .ui.inverted.purple.button:focus {
  background-color: rgb(209.8, 74.2, 255);
}
.kb-labfront.container .ui.inverted.purple.buttons .active.button,
.kb-labfront.container .ui.inverted.purple.active.button {
  background-color: rgb(213.625, 89.5, 255);
}
.kb-labfront.container .ui.inverted.purple.buttons .button:active,
.kb-labfront.container .ui.inverted.purple.button:active {
  background-color: rgb(207.25, 64, 255);
}
.kb-labfront.container .ui.inverted.purple.basic.buttons .button,
.kb-labfront.container .ui.inverted.purple.buttons .basic.button,
.kb-labfront.container .ui.inverted.purple.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.purple.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.purple.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.purple.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(207.25, 64, 255) inset;
  color: #dc73ff;
}
.kb-labfront.container .ui.inverted.purple.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.purple.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.purple.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(209.8, 74.2, 255) inset;
  color: #dc73ff;
}
.kb-labfront.container .ui.inverted.purple.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.purple.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.purple.basic.active.button {
  box-shadow: 0 0 0 2px rgb(213.625, 89.5, 255) inset;
  color: #dc73ff;
}
.kb-labfront.container .ui.inverted.purple.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.purple.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.purple.basic.button:active {
  box-shadow: 0 0 0 2px rgb(207.25, 64, 255) inset;
  color: #dc73ff;
}
.kb-labfront.container .ui.tertiary.purple.buttons .button,
.kb-labfront.container .ui.tertiary.purple.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.purple.button {
  background: transparent;
  box-shadow: none;
  color: #a333c8;
}
.kb-labfront.container .ui.tertiary.purple.buttons .button:hover,
.kb-labfront.container .ui.tertiary.purple.buttons button:hover,
.kb-labfront.container .ui.tertiary.purple.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(175.6342281879, 25.9, 225.1);
  color: rgb(175.6342281879, 25.9, 225.1);
}
.kb-labfront.container .ui.tertiary.purple.buttons .button:focus,
.kb-labfront.container .ui.tertiary.purple.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.purple.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(136.5043824701, 42.7099601594, 167.4900398406);
  color: rgb(136.5043824701, 42.7099601594, 167.4900398406);
}
.kb-labfront.container .ui.tertiary.purple.buttons .active.button,
.kb-labfront.container .ui.tertiary.purple.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.purple.active.button,
.kb-labfront.container .ui.tertiary.purple.buttons .button:active,
.kb-labfront.container .ui.tertiary.purple.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.purple.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(166.3039135405, 6.3562250996, 219.1437749004);
  color: rgb(154.9532423995, 28.9062250996, 196.5937749004);
}
.kb-labfront.container .ui.pink.buttons .button,
.kb-labfront.container .ui.pink.button {
  background-color: #e03997;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.pink.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.pink.buttons .button:hover,
.kb-labfront.container .ui.pink.button:hover {
  background-color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.pink.buttons .button:focus,
.kb-labfront.container .ui.pink.button:focus {
  background-color: rgb(231.7038427948, 8.4961572052, 134.1340161598);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.pink.buttons .button:active,
.kb-labfront.container .ui.pink.button:active {
  background-color: rgb(198.864628821, 31.135371179, 125.5458515284);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.pink.buttons .active.button,
.kb-labfront.container .ui.pink.buttons .active.button:active,
.kb-labfront.container .ui.pink.active.button,
.kb-labfront.container .ui.pink.button .active.button:active {
  background-color: rgb(239.6355349345, 15.8644650655, 141.8194385247);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.pink.buttons .button,
.kb-labfront.container .ui.basic.pink.button {
  background: transparent;
  box-shadow: 0 0 0 1px #e03997 inset;
  color: #e03997;
}
.kb-labfront.container .ui.basic.pink.buttons .button:hover,
.kb-labfront.container .ui.basic.pink.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(233.2730349345, 22.2269650655, 141.0193636744) inset;
  color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
}
.kb-labfront.container .ui.basic.pink.buttons .button:focus,
.kb-labfront.container .ui.basic.pink.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(231.7038427948, 8.4961572052, 134.1340161598) inset;
  color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
}
.kb-labfront.container .ui.basic.pink.buttons .active.button,
.kb-labfront.container .ui.basic.pink.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(239.6355349345, 15.8644650655, 141.8194385247) inset;
  color: rgb(198.864628821, 31.135371179, 125.5458515284);
}
.kb-labfront.container .ui.basic.pink.buttons .button:active,
.kb-labfront.container .ui.basic.pink.button:active {
  box-shadow: 0 0 0 1px rgb(198.864628821, 31.135371179, 125.5458515284) inset;
  color: rgb(198.864628821, 31.135371179, 125.5458515284);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.pink.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.pink.buttons .button,
.kb-labfront.container .ui.inverted.pink.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #ff8edf inset;
  color: #ff8edf;
}
.kb-labfront.container .ui.inverted.pink.buttons .button:hover,
.kb-labfront.container .ui.inverted.pink.button:hover,
.kb-labfront.container .ui.inverted.pink.buttons .button:focus,
.kb-labfront.container .ui.inverted.pink.button:focus,
.kb-labfront.container .ui.inverted.pink.buttons .button.active,
.kb-labfront.container .ui.inverted.pink.button.active,
.kb-labfront.container .ui.inverted.pink.buttons .button:active,
.kb-labfront.container .ui.inverted.pink.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.pink.buttons .button:hover,
.kb-labfront.container .ui.inverted.pink.button:hover {
  background-color: rgb(255, 91, 208.5575221239);
}
.kb-labfront.container .ui.inverted.pink.buttons .button:focus,
.kb-labfront.container .ui.inverted.pink.button:focus {
  background-color: rgb(255, 101.2, 211.4460176991);
}
.kb-labfront.container .ui.inverted.pink.buttons .active.button,
.kb-labfront.container .ui.inverted.pink.active.button {
  background-color: rgb(255, 116.5, 215.7787610619);
}
.kb-labfront.container .ui.inverted.pink.buttons .button:active,
.kb-labfront.container .ui.inverted.pink.button:active {
  background-color: rgb(255, 91, 208.5575221239);
}
.kb-labfront.container .ui.inverted.pink.basic.buttons .button,
.kb-labfront.container .ui.inverted.pink.buttons .basic.button,
.kb-labfront.container .ui.inverted.pink.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.pink.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.pink.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.pink.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(255, 91, 208.5575221239) inset;
  color: #ff8edf;
}
.kb-labfront.container .ui.inverted.pink.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.pink.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.pink.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(255, 101.2, 211.4460176991) inset;
  color: #ff8edf;
}
.kb-labfront.container .ui.inverted.pink.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.pink.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.pink.basic.active.button {
  box-shadow: 0 0 0 2px rgb(255, 116.5, 215.7787610619) inset;
  color: #ff8edf;
}
.kb-labfront.container .ui.inverted.pink.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.pink.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.pink.basic.button:active {
  box-shadow: 0 0 0 2px rgb(255, 91, 208.5575221239) inset;
  color: #ff8edf;
}
.kb-labfront.container .ui.tertiary.pink.buttons .button,
.kb-labfront.container .ui.tertiary.pink.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.pink.button {
  background: transparent;
  box-shadow: none;
  color: #e03997;
}
.kb-labfront.container .ui.tertiary.pink.buttons .button:hover,
.kb-labfront.container .ui.tertiary.pink.buttons button:hover,
.kb-labfront.container .ui.tertiary.pink.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(246.9, 34.1, 153.8796407186);
  color: rgb(246.9, 34.1, 153.8796407186);
}
.kb-labfront.container .ui.tertiary.pink.buttons .button:focus,
.kb-labfront.container .ui.tertiary.pink.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.pink.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(207.6838427948, 32.5161572052, 131.1135371179);
  color: rgb(207.6838427948, 32.5161572052, 131.1135371179);
}
.kb-labfront.container .ui.tertiary.pink.buttons .active.button,
.kb-labfront.container .ui.tertiary.pink.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.pink.active.button,
.kb-labfront.container .ui.tertiary.pink.buttons .button:active,
.kb-labfront.container .ui.tertiary.pink.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.pink.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(255, 0.5, 143.751497006);
  color: rgb(239.6355349345, 15.8644650655, 141.8194385247);
}
.kb-labfront.container .ui.brown.buttons .button,
.kb-labfront.container .ui.brown.button {
  background-color: #a5673f;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.brown.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.brown.buttons .button:hover,
.kb-labfront.container .ui.brown.button:hover {
  background-color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.brown.buttons .button:focus,
.kb-labfront.container .ui.brown.button:focus {
  background-color: rgb(154.1936842105, 80.5307739938, 33.0063157895);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.brown.buttons .button:active,
.kb-labfront.container .ui.brown.button:active {
  background-color: rgb(128.0921052632, 79.9605263158, 48.9078947368);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.brown.buttons .active.button,
.kb-labfront.container .ui.brown.buttons .active.button:active,
.kb-labfront.container .ui.brown.active.button,
.kb-labfront.container .ui.brown.button .active.button:active {
  background-color: rgb(161.7335526316, 88.2045278638, 40.7664473684);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.brown.buttons .button,
.kb-labfront.container .ui.basic.brown.button {
  background: transparent;
  box-shadow: 0 0 0 1px #a5673f inset;
  color: #a5673f;
}
.kb-labfront.container .ui.basic.brown.buttons .button:hover,
.kb-labfront.container .ui.basic.brown.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(156.6710526316, 89.2964396285, 45.8289473684) inset;
  color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
}
.kb-labfront.container .ui.basic.brown.buttons .button:focus,
.kb-labfront.container .ui.basic.brown.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(154.1936842105, 80.5307739938, 33.0063157895) inset;
  color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
}
.kb-labfront.container .ui.basic.brown.buttons .active.button,
.kb-labfront.container .ui.basic.brown.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(161.7335526316, 88.2045278638, 40.7664473684) inset;
  color: rgb(128.0921052632, 79.9605263158, 48.9078947368);
}
.kb-labfront.container .ui.basic.brown.buttons .button:active,
.kb-labfront.container .ui.basic.brown.button:active {
  box-shadow: 0 0 0 1px rgb(128.0921052632, 79.9605263158, 48.9078947368) inset;
  color: rgb(128.0921052632, 79.9605263158, 48.9078947368);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.brown.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.brown.buttons .button,
.kb-labfront.container .ui.inverted.brown.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #d67c1c inset;
  color: #d67c1c;
}
.kb-labfront.container .ui.inverted.brown.buttons .button:hover,
.kb-labfront.container .ui.inverted.brown.button:hover,
.kb-labfront.container .ui.inverted.brown.buttons .button:focus,
.kb-labfront.container .ui.inverted.brown.button:focus,
.kb-labfront.container .ui.inverted.brown.buttons .button.active,
.kb-labfront.container .ui.inverted.brown.button.active,
.kb-labfront.container .ui.inverted.brown.buttons .button:active,
.kb-labfront.container .ui.inverted.brown.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.brown.buttons .button:hover,
.kb-labfront.container .ui.inverted.brown.button:hover {
  background-color: rgb(178.4508264463, 98.1758331112, 12.5491735537);
}
.kb-labfront.container .ui.inverted.brown.buttons .button:focus,
.kb-labfront.container .ui.inverted.brown.button:focus {
  background-color: rgb(198.040661157, 103.7432471341, 3.159338843);
}
.kb-labfront.container .ui.inverted.brown.buttons .active.button,
.kb-labfront.container .ui.inverted.brown.active.button {
  background-color: rgb(207.6879132231, 111.4576746201, 8.8120867769);
}
.kb-labfront.container .ui.inverted.brown.buttons .button:active,
.kb-labfront.container .ui.inverted.brown.button:active {
  background-color: rgb(168.9008264463, 97.867768595, 22.0991735537);
}
.kb-labfront.container .ui.inverted.brown.basic.buttons .button,
.kb-labfront.container .ui.inverted.brown.buttons .basic.button,
.kb-labfront.container .ui.inverted.brown.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.brown.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.brown.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.brown.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(178.4508264463, 98.1758331112, 12.5491735537) inset;
  color: #d67c1c;
}
.kb-labfront.container .ui.inverted.brown.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.brown.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.brown.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(198.040661157, 103.7432471341, 3.159338843) inset;
  color: #d67c1c;
}
.kb-labfront.container .ui.inverted.brown.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.brown.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.brown.basic.active.button {
  box-shadow: 0 0 0 2px rgb(207.6879132231, 111.4576746201, 8.8120867769) inset;
  color: #d67c1c;
}
.kb-labfront.container .ui.inverted.brown.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.brown.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.brown.basic.button:active {
  box-shadow: 0 0 0 2px rgb(168.9008264463, 97.867768595, 22.0991735537) inset;
  color: #d67c1c;
}
.kb-labfront.container .ui.tertiary.brown.buttons .button,
.kb-labfront.container .ui.tertiary.brown.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.brown.button {
  background: transparent;
  box-shadow: none;
  color: #a5673f;
}
.kb-labfront.container .ui.tertiary.brown.buttons .button:hover,
.kb-labfront.container .ui.tertiary.brown.buttons button:hover,
.kb-labfront.container .ui.tertiary.brown.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(187.8, 98.0823529412, 40.2);
  color: rgb(187.8, 98.0823529412, 40.2);
}
.kb-labfront.container .ui.tertiary.brown.buttons .button:focus,
.kb-labfront.container .ui.tertiary.brown.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.brown.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(135.4736842105, 84.5684210526, 51.7263157895);
  color: rgb(135.4736842105, 84.5684210526, 51.7263157895);
}
.kb-labfront.container .ui.tertiary.brown.buttons .active.button,
.kb-labfront.container .ui.tertiary.brown.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.brown.active.button,
.kb-labfront.container .ui.tertiary.brown.buttons .button:active,
.kb-labfront.container .ui.tertiary.brown.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.brown.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(181.9835526316, 83.836880805, 20.5164473684);
  color: rgb(161.7335526316, 88.2045278638, 40.7664473684);
}
.kb-labfront.container .ui.grey.buttons .button,
.kb-labfront.container .ui.grey.button {
  background-color: #767676;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.grey.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.grey.buttons .button:hover,
.kb-labfront.container .ui.grey.button:hover {
  background-color: rgb(115.775, 94.725, 94.725);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.grey.buttons .button:focus,
.kb-labfront.container .ui.grey.button:focus {
  background-color: rgb(138.4, 138.4, 138.4);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.grey.buttons .button:active,
.kb-labfront.container .ui.grey.button:active {
  background-color: rgb(143.5, 143.5, 143.5);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.grey.buttons .active.button,
.kb-labfront.container .ui.grey.buttons .active.button:active,
.kb-labfront.container .ui.grey.active.button,
.kb-labfront.container .ui.grey.button .active.button:active {
  background-color: rgb(105.25, 105.25, 105.25);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.grey.buttons .button,
.kb-labfront.container .ui.basic.grey.button {
  background: transparent;
  box-shadow: 0 0 0 1px #767676 inset;
  color: #767676;
}
.kb-labfront.container .ui.basic.grey.buttons .button:hover,
.kb-labfront.container .ui.basic.grey.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(115.775, 94.725, 94.725) inset;
  color: rgb(115.775, 94.725, 94.725);
}
.kb-labfront.container .ui.basic.grey.buttons .button:focus,
.kb-labfront.container .ui.basic.grey.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(138.4, 138.4, 138.4) inset;
  color: rgb(115.775, 94.725, 94.725);
}
.kb-labfront.container .ui.basic.grey.buttons .active.button,
.kb-labfront.container .ui.basic.grey.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(105.25, 105.25, 105.25) inset;
  color: rgb(143.5, 143.5, 143.5);
}
.kb-labfront.container .ui.basic.grey.buttons .button:active,
.kb-labfront.container .ui.basic.grey.button:active {
  box-shadow: 0 0 0 1px rgb(143.5, 143.5, 143.5) inset;
  color: rgb(143.5, 143.5, 143.5);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.grey.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.grey.buttons .button,
.kb-labfront.container .ui.inverted.grey.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #d4d4d5 inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.grey.buttons .button:hover,
.kb-labfront.container .ui.inverted.grey.button:hover,
.kb-labfront.container .ui.inverted.grey.buttons .button:focus,
.kb-labfront.container .ui.inverted.grey.button:focus,
.kb-labfront.container .ui.inverted.grey.buttons .button.active,
.kb-labfront.container .ui.inverted.grey.button.active,
.kb-labfront.container .ui.inverted.grey.buttons .button:active,
.kb-labfront.container .ui.inverted.grey.button:active {
  box-shadow: none;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.inverted.grey.buttons .button:hover,
.kb-labfront.container .ui.inverted.grey.button:hover {
  background-color: rgb(187.8, 195.5, 203.2);
}
.kb-labfront.container .ui.inverted.grey.buttons .button:focus,
.kb-labfront.container .ui.inverted.grey.button:focus {
  background-color: rgb(188.12, 200.6, 213.08);
}
.kb-labfront.container .ui.inverted.grey.buttons .active.button,
.kb-labfront.container .ui.inverted.grey.active.button {
  background-color: rgb(199.8625, 208.25, 216.6375);
}
.kb-labfront.container .ui.inverted.grey.buttons .button:active,
.kb-labfront.container .ui.inverted.grey.button:active {
  background-color: rgb(193.75, 195.5, 197.25);
}
.kb-labfront.container .ui.inverted.grey.basic.buttons .button,
.kb-labfront.container .ui.inverted.grey.buttons .basic.button,
.kb-labfront.container .ui.inverted.grey.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.grey.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.grey.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.grey.basic.button:hover {
  box-shadow: 0 0 0 2px rgb(187.8, 195.5, 203.2) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.grey.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.grey.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.grey.basic.button:focus {
  box-shadow: 0 0 0 2px rgb(188.12, 200.6, 213.08) inset;
  color: #dcddde;
}
.kb-labfront.container .ui.inverted.grey.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.grey.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.grey.basic.active.button {
  box-shadow: 0 0 0 2px rgb(199.8625, 208.25, 216.6375) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.grey.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.grey.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.grey.basic.button:active {
  box-shadow: 0 0 0 2px rgb(193.75, 195.5, 197.25) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.tertiary.grey.buttons .button,
.kb-labfront.container .ui.tertiary.grey.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.grey.button {
  background: transparent;
  box-shadow: none;
  color: #767676;
}
.kb-labfront.container .ui.tertiary.grey.buttons .button:hover,
.kb-labfront.container .ui.tertiary.grey.buttons button:hover,
.kb-labfront.container .ui.tertiary.grey.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(141.6, 94.4, 94.4);
  color: rgb(141.6, 94.4, 94.4);
}
.kb-labfront.container .ui.tertiary.grey.buttons .button:focus,
.kb-labfront.container .ui.tertiary.grey.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.grey.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(138.4, 138.4, 138.4);
  color: rgb(138.4, 138.4, 138.4);
}
.kb-labfront.container .ui.tertiary.grey.buttons .active.button,
.kb-labfront.container .ui.tertiary.grey.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.grey.active.button,
.kb-labfront.container .ui.tertiary.grey.buttons .button:active,
.kb-labfront.container .ui.tertiary.grey.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.grey.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(126.3, 84.2, 84.2);
  color: rgb(105.25, 105.25, 105.25);
}
.kb-labfront.container .ui.black.buttons .button,
.kb-labfront.container .ui.black.button {
  background-color: #1b1c1d;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.black.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.black.buttons .button:hover,
.kb-labfront.container .ui.black.button:hover {
  background-color: rgb(13.1803571429, 15.25, 17.3196428571);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.black.buttons .button:focus,
.kb-labfront.container .ui.black.button:focus {
  background-color: rgb(46.6714285714, 48.4, 50.1285714286);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.black.buttons .button:active,
.kb-labfront.container .ui.black.button:active {
  background-color: rgb(51.5892857143, 53.5, 55.4107142857);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.black.buttons .active.button,
.kb-labfront.container .ui.black.buttons .active.button:active,
.kb-labfront.container .ui.black.active.button,
.kb-labfront.container .ui.black.button .active.button:active {
  background-color: rgb(14.7053571429, 15.25, 15.7946428571);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.black.buttons .button,
.kb-labfront.container .ui.basic.black.button {
  background: transparent;
  box-shadow: 0 0 0 1px #1b1c1d inset;
  color: #1b1c1d;
}
.kb-labfront.container .ui.basic.black.buttons .button:hover,
.kb-labfront.container .ui.basic.black.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(13.1803571429, 15.25, 17.3196428571) inset;
  color: rgb(13.1803571429, 15.25, 17.3196428571);
}
.kb-labfront.container .ui.basic.black.buttons .button:focus,
.kb-labfront.container .ui.basic.black.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(46.6714285714, 48.4, 50.1285714286) inset;
  color: rgb(13.1803571429, 15.25, 17.3196428571);
}
.kb-labfront.container .ui.basic.black.buttons .active.button,
.kb-labfront.container .ui.basic.black.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(14.7053571429, 15.25, 15.7946428571) inset;
  color: rgb(51.5892857143, 53.5, 55.4107142857);
}
.kb-labfront.container .ui.basic.black.buttons .button:active,
.kb-labfront.container .ui.basic.black.button:active {
  box-shadow: 0 0 0 1px rgb(51.5892857143, 53.5, 55.4107142857) inset;
  color: rgb(51.5892857143, 53.5, 55.4107142857);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.black.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.inverted.black.buttons .button,
.kb-labfront.container .ui.inverted.black.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px #d4d4d5 inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.black.buttons .button:hover,
.kb-labfront.container .ui.inverted.black.button:hover,
.kb-labfront.container .ui.inverted.black.buttons .button:focus,
.kb-labfront.container .ui.inverted.black.button:focus,
.kb-labfront.container .ui.inverted.black.buttons .button.active,
.kb-labfront.container .ui.inverted.black.button.active,
.kb-labfront.container .ui.inverted.black.buttons .button:active,
.kb-labfront.container .ui.inverted.black.button:active {
  box-shadow: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.black.buttons .button:hover,
.kb-labfront.container .ui.inverted.black.button:hover {
  background-color: black;
}
.kb-labfront.container .ui.inverted.black.buttons .button:focus,
.kb-labfront.container .ui.inverted.black.button:focus {
  background-color: black;
}
.kb-labfront.container .ui.inverted.black.buttons .active.button,
.kb-labfront.container .ui.inverted.black.active.button {
  background-color: black;
}
.kb-labfront.container .ui.inverted.black.buttons .button:active,
.kb-labfront.container .ui.inverted.black.button:active {
  background-color: black;
}
.kb-labfront.container .ui.inverted.black.basic.buttons .button,
.kb-labfront.container .ui.inverted.black.buttons .basic.button,
.kb-labfront.container .ui.inverted.black.basic.button {
  background-color: transparent;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5) inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.black.basic.buttons .button:hover,
.kb-labfront.container .ui.inverted.black.buttons .basic.button:hover,
.kb-labfront.container .ui.inverted.black.basic.button:hover {
  box-shadow: 0 0 0 2px black inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.black.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.black.basic.buttons .button:focus,
.kb-labfront.container .ui.inverted.black.basic.button:focus {
  box-shadow: 0 0 0 2px black inset;
  color: #545454;
}
.kb-labfront.container .ui.inverted.black.basic.buttons .active.button,
.kb-labfront.container .ui.inverted.black.buttons .basic.active.button,
.kb-labfront.container .ui.inverted.black.basic.active.button {
  box-shadow: 0 0 0 2px black inset;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.black.basic.buttons .button:active,
.kb-labfront.container .ui.inverted.black.buttons .basic.button:active,
.kb-labfront.container .ui.inverted.black.basic.button:active {
  box-shadow: 0 0 0 2px black inset;
  color: #ffffff;
}
.kb-labfront.container .ui.tertiary.black.buttons .button,
.kb-labfront.container .ui.tertiary.black.buttons .tertiary.button,
.kb-labfront.container .ui.tertiary.black.button {
  background: transparent;
  box-shadow: none;
  color: #1b1c1d;
}
.kb-labfront.container .ui.tertiary.black.buttons .button:hover,
.kb-labfront.container .ui.tertiary.black.buttons button:hover,
.kb-labfront.container .ui.tertiary.black.button:hover {
  box-shadow: inset 0 -0.2em 0 rgb(76.1785714286, 79, 81.8214285714);
  color: rgb(76.1785714286, 79, 81.8214285714);
}
.kb-labfront.container .ui.tertiary.black.buttons .button:focus,
.kb-labfront.container .ui.tertiary.black.buttons .tertiary.button:focus,
.kb-labfront.container .ui.tertiary.black.button:focus {
  box-shadow: inset 0 -0.2em 0 rgb(146.6642857143, 150.4, 154.1357142857);
  color: rgb(146.6642857143, 150.4, 154.1357142857);
}
.kb-labfront.container .ui.tertiary.black.buttons .active.button,
.kb-labfront.container .ui.tertiary.black.buttons .tertiary.active.button,
.kb-labfront.container .ui.tertiary.black.active.button,
.kb-labfront.container .ui.tertiary.black.buttons .button:active,
.kb-labfront.container .ui.tertiary.black.buttons .tertiary.button:active,
.kb-labfront.container .ui.tertiary.black.button:active {
  box-shadow: inset 0 -0.2em 0 rgb(63.8839285714, 66.25, 68.6160714286);
  color: rgb(14.7053571429, 15.25, 15.7946428571);
}
.kb-labfront.container .ui.positive.buttons .button,
.kb-labfront.container .ui.positive.button {
  background-color: #21ba45;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.positive.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.positive.buttons .button:hover,
.kb-labfront.container .ui.positive.button:hover {
  background-color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.positive.buttons .button:focus,
.kb-labfront.container .ui.positive.button:focus {
  background-color: rgb(9.0320547945, 169.1679452055, 46.7110878324);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.positive.buttons .button:active,
.kb-labfront.container .ui.positive.button:active {
  background-color: rgb(25.3150684932, 142.6849315068, 52.9315068493);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.positive.buttons .active.button,
.kb-labfront.container .ui.positive.buttons .active.button:active,
.kb-labfront.container .ui.positive.active.button,
.kb-labfront.container .ui.positive.button .active.button:active {
  background-color: rgb(14.6450342466, 178.8549657534, 53.2826651894);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.positive.buttons .button,
.kb-labfront.container .ui.basic.positive.button {
  background: transparent;
  box-shadow: 0 0 0 1px #21ba45 inset;
  color: #21ba45;
}
.kb-labfront.container .ui.basic.positive.buttons .button:hover,
.kb-labfront.container .ui.basic.positive.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(19.4825342466, 174.0174657534, 55.8436946011) inset;
  color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.basic.positive.buttons .button:focus,
.kb-labfront.container .ui.basic.positive.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(9.0320547945, 169.1679452055, 46.7110878324) inset;
  color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.basic.positive.buttons .active.button,
.kb-labfront.container .ui.basic.positive.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(14.6450342466, 178.8549657534, 53.2826651894) inset;
  color: rgb(25.3150684932, 142.6849315068, 52.9315068493);
}
.kb-labfront.container .ui.basic.positive.buttons .button:active,
.kb-labfront.container .ui.basic.positive.button:active {
  box-shadow: 0 0 0 1px rgb(25.3150684932, 142.6849315068, 52.9315068493) inset;
  color: rgb(25.3150684932, 142.6849315068, 52.9315068493);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.positive.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.negative.buttons .button,
.kb-labfront.container .ui.negative.button {
  background-color: #db2828;
  color: #ffffff;
  text-shadow: none;
  background-image: none;
}
.kb-labfront.container .ui.negative.button {
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.negative.buttons .button:hover,
.kb-labfront.container .ui.negative.button:hover {
  background-color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.negative.buttons .button:focus,
.kb-labfront.container .ui.negative.button:focus {
  background-color: rgb(208.7243824701, 9.4756175299, 9.4756175299);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.negative.buttons .button:active,
.kb-labfront.container .ui.negative.button:active {
  background-color: rgb(178.1673306773, 29.8326693227, 29.8326693227);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.negative.buttons .active.button,
.kb-labfront.container .ui.negative.buttons .active.button:active,
.kb-labfront.container .ui.negative.active.button,
.kb-labfront.container .ui.negative.button .active.button:active {
  background-color: rgb(217.5224601594, 15.9775398406, 15.9775398406);
  color: #ffffff;
  text-shadow: none;
}
.kb-labfront.container .ui.basic.negative.buttons .button,
.kb-labfront.container .ui.basic.negative.button {
  background: transparent;
  box-shadow: 0 0 0 1px #db2828 inset;
  color: #db2828;
}
.kb-labfront.container .ui.basic.negative.buttons .button:hover,
.kb-labfront.container .ui.basic.negative.button:hover {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(211.6849601594, 21.8150398406, 21.8150398406) inset;
  color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.basic.negative.buttons .button:focus,
.kb-labfront.container .ui.basic.negative.button:focus {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(208.7243824701, 9.4756175299, 9.4756175299) inset;
  color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.basic.negative.buttons .active.button,
.kb-labfront.container .ui.basic.negative.active.button {
  background: transparent;
  box-shadow: 0 0 0 1px rgb(217.5224601594, 15.9775398406, 15.9775398406) inset;
  color: rgb(178.1673306773, 29.8326693227, 29.8326693227);
}
.kb-labfront.container .ui.basic.negative.buttons .button:active,
.kb-labfront.container .ui.basic.negative.button:active {
  box-shadow: 0 0 0 1px rgb(178.1673306773, 29.8326693227, 29.8326693227) inset;
  color: rgb(178.1673306773, 29.8326693227, 29.8326693227);
}
.kb-labfront.container .ui.buttons:not(.vertical) > .basic.negative.button:not(:first-child) {
  margin-left: -1px;
}
.kb-labfront.container .ui.buttons {
  display: inline-flex;
  flex-direction: row;
  font-size: 0;
  vertical-align: baseline;
  margin: 0 0.25em 0 0;
}
.kb-labfront.container .ui.buttons:not(.basic):not(.inverted) {
  box-shadow: none;
}
.kb-labfront.container .ui.buttons:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.kb-labfront.container .ui.buttons .button {
  flex: 1 0 auto;
  border-radius: 0;
  margin: 0 0 0 0;
}
.kb-labfront.container .ui.buttons:not(.basic):not(.inverted) > .button:not(.basic):not(.inverted) {
  box-shadow: 0 0 0 1px transparent inset, 0 0 0 0 rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.buttons .button:first-child {
  border-left: none;
  margin-left: 0;
  border-top-left-radius: 0.2857142857rem;
  border-bottom-left-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.buttons .button:last-child {
  border-top-right-radius: 0.2857142857rem;
  border-bottom-right-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.buttons {
  display: inline-flex;
  flex-direction: column;
}
.kb-labfront.container .ui.vertical.buttons .button {
  display: block;
  float: none;
  width: 100%;
  margin: 0 0 0 0;
  box-shadow: none;
  border-radius: 0;
}
.kb-labfront.container .ui.vertical.buttons .button:first-child {
  border-top-left-radius: 0.2857142857rem;
  border-top-right-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.buttons .button:last-child {
  margin-bottom: 0;
  border-bottom-left-radius: 0.2857142857rem;
  border-bottom-right-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.buttons .button:only-child {
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.container {
  display: block;
  max-width: 100%;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.ui.ui.container:not(.fluid) {
    width: auto;
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.ui.grid.container {
    width: auto;
  }
  .kb-labfront.container .ui.ui.relaxed.grid.container {
    width: auto;
  }
  .kb-labfront.container .ui.ui.very.relaxed.grid.container {
    width: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .kb-labfront.container .ui.ui.ui.container:not(.fluid) {
    width: 723px;
    margin-left: auto;
    margin-right: auto;
  }
  .kb-labfront.container .ui.ui.grid.container {
    width: calc(723px + 2rem);
  }
  .kb-labfront.container .ui.ui.relaxed.grid.container {
    width: calc(723px + 3rem);
  }
  .kb-labfront.container .ui.ui.very.relaxed.grid.container {
    width: calc(723px + 5rem);
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199.98px) {
  .kb-labfront.container .ui.ui.ui.container:not(.fluid) {
    width: 933px;
    margin-left: auto;
    margin-right: auto;
  }
  .kb-labfront.container .ui.ui.grid.container {
    width: calc(933px + 2rem);
  }
  .kb-labfront.container .ui.ui.relaxed.grid.container {
    width: calc(933px + 3rem);
  }
  .kb-labfront.container .ui.ui.very.relaxed.grid.container {
    width: calc(933px + 5rem);
  }
}
@media only screen and (min-width: 1200px) {
  .kb-labfront.container .ui.ui.ui.container:not(.fluid) {
    width: 1127px;
    margin-left: auto;
    margin-right: auto;
  }
  .kb-labfront.container .ui.ui.grid.container {
    width: calc(1127px + 2rem);
  }
  .kb-labfront.container .ui.ui.relaxed.grid.container {
    width: calc(1127px + 3rem);
  }
  .kb-labfront.container .ui.ui.very.relaxed.grid.container {
    width: calc(1127px + 5rem);
  }
}
.kb-labfront.container .ui.text.container {
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  max-width: 700px;
  line-height: 1.5;
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.fluid.container {
  width: 100%;
}
.kb-labfront.container .ui[class*="left aligned"].container {
  text-align: left;
}
.kb-labfront.container .ui[class*="center aligned"].container {
  text-align: center;
}
.kb-labfront.container .ui[class*="right aligned"].container {
  text-align: right;
}
.kb-labfront.container .ui.justified.container {
  text-align: justify;
  hyphens: auto;
}
.kb-labfront.container .ui.divider {
  margin: 1rem 0;
  line-height: 1;
  height: 0;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(0, 0, 0, 0.85);
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.divider:not(.vertical):not(.horizontal) {
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.grid > .column + .divider,
.kb-labfront.container .ui.grid > .row > .column + .divider {
  left: auto;
}
.kb-labfront.container .ui.horizontal.divider {
  display: table;
  white-space: nowrap;
  height: auto;
  margin: "";
  line-height: 1;
  text-align: center;
}
.kb-labfront.container .ui.horizontal.divider:before,
.kb-labfront.container .ui.horizontal.divider:after {
  content: "";
  display: table-cell;
  position: relative;
  top: 50%;
  width: 50%;
  background-repeat: no-repeat;
}
.kb-labfront.container .ui.horizontal.divider:before {
  background-position: right 1em top 50%;
}
.kb-labfront.container .ui.horizontal.divider:after {
  background-position: left 1em top 50%;
}
.kb-labfront.container .ui.vertical.divider {
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  margin: 0;
  padding: 0;
  width: auto;
  height: 50%;
  line-height: 0;
  text-align: center;
  transform: translateX(-50%);
}
.kb-labfront.container .ui.vertical.divider:before,
.kb-labfront.container .ui.vertical.divider:after {
  position: absolute;
  left: 50%;
  content: "";
  z-index: 3;
  border-left: 1px solid rgba(34, 36, 38, 0.15);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  width: 0;
  height: calc(100% - 1rem);
}
.kb-labfront.container .ui.vertical.divider:before {
  top: -100%;
}
.kb-labfront.container .ui.vertical.divider:after {
  top: auto;
  bottom: 0;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.stackable.grid .ui.vertical.divider,
  .kb-labfront.container .ui.grid .stackable.row .ui.vertical.divider {
    display: table;
    white-space: nowrap;
    height: auto;
    margin: "";
    overflow: hidden;
    line-height: 1;
    text-align: center;
    position: static;
    top: 0;
    left: 0;
    transform: none;
  }
  .kb-labfront.container .ui.stackable.grid .ui.vertical.divider:before,
  .kb-labfront.container .ui.grid .stackable.row .ui.vertical.divider:before,
  .kb-labfront.container .ui.stackable.grid .ui.vertical.divider:after,
  .kb-labfront.container .ui.grid .stackable.row .ui.vertical.divider:after {
    left: 0;
    border-left: none;
    border-right: none;
    content: "";
    display: table-cell;
    position: relative;
    top: 50%;
    width: 50%;
    background-repeat: no-repeat;
  }
  .kb-labfront.container .ui.stackable.grid .ui.vertical.divider:before,
  .kb-labfront.container .ui.grid .stackable.row .ui.vertical.divider:before {
    background-position: right 1em top 50%;
  }
  .kb-labfront.container .ui.stackable.grid .ui.vertical.divider:after,
  .kb-labfront.container .ui.grid .stackable.row .ui.vertical.divider:after {
    background-position: left 1em top 50%;
  }
}
.kb-labfront.container .ui.divider > .icon {
  margin: 0;
  font-size: 1rem;
  height: 1em;
  vertical-align: middle;
}
.kb-labfront.container .ui.horizontal.divider[class*="left aligned"]:before {
  display: none;
}
.kb-labfront.container .ui.horizontal.divider[class*="left aligned"]:after {
  width: 100%;
}
.kb-labfront.container .ui.horizontal.divider[class*="right aligned"]:before {
  width: 100%;
}
.kb-labfront.container .ui.horizontal.divider[class*="right aligned"]:after {
  display: none;
}
.kb-labfront.container .ui.hidden.divider {
  border-color: transparent !important;
}
.kb-labfront.container .ui.hidden.divider:before,
.kb-labfront.container .ui.hidden.divider:after {
  display: none;
}
.kb-labfront.container .ui.divider.inverted,
.kb-labfront.container .ui.vertical.inverted.divider,
.kb-labfront.container .ui.horizontal.inverted.divider {
  color: #ffffff;
}
.kb-labfront.container .ui.divider.inverted,
.kb-labfront.container .ui.divider.inverted:after,
.kb-labfront.container .ui.divider.inverted:before {
  border-top-color: rgba(34, 36, 38, 0.15) !important;
  border-left-color: rgba(34, 36, 38, 0.15) !important;
  border-bottom-color: rgba(255, 255, 255, 0.15) !important;
  border-right-color: rgba(255, 255, 255, 0.15) !important;
}
.kb-labfront.container .ui.fitted.divider {
  margin: 0;
}
.kb-labfront.container .ui.clearing.divider {
  clear: both;
}
.kb-labfront.container .ui.section.divider {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.kb-labfront.container .ui.divider {
  font-size: 1rem;
}
.kb-labfront.container .ui.horizontal.divider:before,
.kb-labfront.container .ui.horizontal.divider:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@media only screen and (max-width: 767px) {
  .kb-labfront.container .ui.stackable.grid .ui.vertical.divider:before,
  .kb-labfront.container .ui.grid .stackable.row .ui.vertical.divider:before,
  .kb-labfront.container .ui.stackable.grid .ui.vertical.divider:after,
  .kb-labfront.container .ui.grid .stackable.row .ui.vertical.divider:after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
}
.kb-labfront.container i.flag:not(.icon) {
  display: inline-block;
  width: 16px;
  height: 11px;
  line-height: 11px;
  vertical-align: baseline;
  margin: 0 0.5em 0 0;
  text-decoration: inherit;
  speak: none;
  -webkit-font-smoothing: antialiased;
  backface-visibility: hidden;
}
.kb-labfront.container i.flag:not(.icon):before {
  display: inline-block;
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat -108px -1976px;
  width: 16px;
  height: 11px;
}
.kb-labfront.container i.flag.ad:before,
.kb-labfront.container i.flag.andorra:before {
  background-position: 0 0;
}
.kb-labfront.container i.flag.ae:before,
.kb-labfront.container i.flag.united.arab.emirates:before,
.kb-labfront.container i.flag.uae:before {
  background-position: 0 -26px;
}
.kb-labfront.container i.flag.af:before,
.kb-labfront.container i.flag.afghanistan:before {
  background-position: 0 -52px;
}
.kb-labfront.container i.flag.ag:before,
.kb-labfront.container i.flag.antigua:before {
  background-position: 0 -78px;
}
.kb-labfront.container i.flag.ai:before,
.kb-labfront.container i.flag.anguilla:before {
  background-position: 0 -104px;
}
.kb-labfront.container i.flag.al:before,
.kb-labfront.container i.flag.albania:before {
  background-position: 0 -130px;
}
.kb-labfront.container i.flag.am:before,
.kb-labfront.container i.flag.armenia:before {
  background-position: 0 -156px;
}
.kb-labfront.container i.flag.an:before,
.kb-labfront.container i.flag.netherlands.antilles:before {
  background-position: 0 -182px;
}
.kb-labfront.container i.flag.ao:before,
.kb-labfront.container i.flag.angola:before {
  background-position: 0 -208px;
}
.kb-labfront.container i.flag.ar:before,
.kb-labfront.container i.flag.argentina:before {
  background-position: 0 -234px;
}
.kb-labfront.container i.flag.as:before,
.kb-labfront.container i.flag.american.samoa:before {
  background-position: 0 -260px;
}
.kb-labfront.container i.flag.at:before,
.kb-labfront.container i.flag.austria:before {
  background-position: 0 -286px;
}
.kb-labfront.container i.flag.au:before,
.kb-labfront.container i.flag.australia:before {
  background-position: 0 -312px;
}
.kb-labfront.container i.flag.aw:before,
.kb-labfront.container i.flag.aruba:before {
  background-position: 0 -338px;
}
.kb-labfront.container i.flag.ax:before,
.kb-labfront.container i.flag.aland.islands:before {
  background-position: 0 -364px;
}
.kb-labfront.container i.flag.az:before,
.kb-labfront.container i.flag.azerbaijan:before {
  background-position: 0 -390px;
}
.kb-labfront.container i.flag.ba:before,
.kb-labfront.container i.flag.bosnia:before {
  background-position: 0 -416px;
}
.kb-labfront.container i.flag.bb:before,
.kb-labfront.container i.flag.barbados:before {
  background-position: 0 -442px;
}
.kb-labfront.container i.flag.bd:before,
.kb-labfront.container i.flag.bangladesh:before {
  background-position: 0 -468px;
}
.kb-labfront.container i.flag.be:before,
.kb-labfront.container i.flag.belgium:before {
  background-position: 0 -494px;
}
.kb-labfront.container i.flag.bf:before,
.kb-labfront.container i.flag.burkina.faso:before {
  background-position: 0 -520px;
}
.kb-labfront.container i.flag.bg:before,
.kb-labfront.container i.flag.bulgaria:before {
  background-position: 0 -546px;
}
.kb-labfront.container i.flag.bh:before,
.kb-labfront.container i.flag.bahrain:before {
  background-position: 0 -572px;
}
.kb-labfront.container i.flag.bi:before,
.kb-labfront.container i.flag.burundi:before {
  background-position: 0 -598px;
}
.kb-labfront.container i.flag.bj:before,
.kb-labfront.container i.flag.benin:before {
  background-position: 0 -624px;
}
.kb-labfront.container i.flag.bm:before,
.kb-labfront.container i.flag.bermuda:before {
  background-position: 0 -650px;
}
.kb-labfront.container i.flag.bn:before,
.kb-labfront.container i.flag.brunei:before {
  background-position: 0 -676px;
}
.kb-labfront.container i.flag.bo:before,
.kb-labfront.container i.flag.bolivia:before {
  background-position: 0 -702px;
}
.kb-labfront.container i.flag.br:before,
.kb-labfront.container i.flag.brazil:before {
  background-position: 0 -728px;
}
.kb-labfront.container i.flag.bs:before,
.kb-labfront.container i.flag.bahamas:before {
  background-position: 0 -754px;
}
.kb-labfront.container i.flag.bt:before,
.kb-labfront.container i.flag.bhutan:before {
  background-position: 0 -780px;
}
.kb-labfront.container i.flag.bv:before,
.kb-labfront.container i.flag.bouvet.island:before {
  background-position: 0 -806px;
}
.kb-labfront.container i.flag.bw:before,
.kb-labfront.container i.flag.botswana:before {
  background-position: 0 -832px;
}
.kb-labfront.container i.flag.by:before,
.kb-labfront.container i.flag.belarus:before {
  background-position: 0 -858px;
}
.kb-labfront.container i.flag.bz:before,
.kb-labfront.container i.flag.belize:before {
  background-position: 0 -884px;
}
.kb-labfront.container i.flag.ca:before,
.kb-labfront.container i.flag.canada:before {
  background-position: 0 -910px;
}
.kb-labfront.container i.flag.cc:before,
.kb-labfront.container i.flag.cocos.islands:before {
  background-position: 0 -962px;
}
.kb-labfront.container i.flag.cd:before,
.kb-labfront.container i.flag.congo:before {
  background-position: 0 -988px;
}
.kb-labfront.container i.flag.cf:before,
.kb-labfront.container i.flag.central.african.republic:before {
  background-position: 0 -1014px;
}
.kb-labfront.container i.flag.cg:before,
.kb-labfront.container i.flag.congo.brazzaville:before {
  background-position: 0 -1040px;
}
.kb-labfront.container i.flag.ch:before,
.kb-labfront.container i.flag.switzerland:before {
  background-position: 0 -1066px;
}
.kb-labfront.container i.flag.ci:before,
.kb-labfront.container i.flag.cote.divoire:before {
  background-position: 0 -1092px;
}
.kb-labfront.container i.flag.ck:before,
.kb-labfront.container i.flag.cook.islands:before {
  background-position: 0 -1118px;
}
.kb-labfront.container i.flag.cl:before,
.kb-labfront.container i.flag.chile:before {
  background-position: 0 -1144px;
}
.kb-labfront.container i.flag.cm:before,
.kb-labfront.container i.flag.cameroon:before {
  background-position: 0 -1170px;
}
.kb-labfront.container i.flag.cn:before,
.kb-labfront.container i.flag.china:before {
  background-position: 0 -1196px;
}
.kb-labfront.container i.flag.co:before,
.kb-labfront.container i.flag.colombia:before {
  background-position: 0 -1222px;
}
.kb-labfront.container i.flag.cr:before,
.kb-labfront.container i.flag.costa.rica:before {
  background-position: 0 -1248px;
}
.kb-labfront.container i.flag.cs:before,
.kb-labfront.container i.flag.serbia:before {
  background-position: 0 -1274px;
}
.kb-labfront.container i.flag.cu:before,
.kb-labfront.container i.flag.cuba:before {
  background-position: 0 -1300px;
}
.kb-labfront.container i.flag.cv:before,
.kb-labfront.container i.flag.cape.verde:before {
  background-position: 0 -1326px;
}
.kb-labfront.container i.flag.cx:before,
.kb-labfront.container i.flag.christmas.island:before {
  background-position: 0 -1352px;
}
.kb-labfront.container i.flag.cy:before,
.kb-labfront.container i.flag.cyprus:before {
  background-position: 0 -1378px;
}
.kb-labfront.container i.flag.cz:before,
.kb-labfront.container i.flag.czech.republic:before {
  background-position: 0 -1404px;
}
.kb-labfront.container i.flag.de:before,
.kb-labfront.container i.flag.germany:before {
  background-position: 0 -1430px;
}
.kb-labfront.container i.flag.dj:before,
.kb-labfront.container i.flag.djibouti:before {
  background-position: 0 -1456px;
}
.kb-labfront.container i.flag.dk:before,
.kb-labfront.container i.flag.denmark:before {
  background-position: 0 -1482px;
}
.kb-labfront.container i.flag.dm:before,
.kb-labfront.container i.flag.dominica:before {
  background-position: 0 -1508px;
}
.kb-labfront.container i.flag.do:before,
.kb-labfront.container i.flag.dominican.republic:before {
  background-position: 0 -1534px;
}
.kb-labfront.container i.flag.dz:before,
.kb-labfront.container i.flag.algeria:before {
  background-position: 0 -1560px;
}
.kb-labfront.container i.flag.ec:before,
.kb-labfront.container i.flag.ecuador:before {
  background-position: 0 -1586px;
}
.kb-labfront.container i.flag.ee:before,
.kb-labfront.container i.flag.estonia:before {
  background-position: 0 -1612px;
}
.kb-labfront.container i.flag.eg:before,
.kb-labfront.container i.flag.egypt:before {
  background-position: 0 -1638px;
}
.kb-labfront.container i.flag.eh:before,
.kb-labfront.container i.flag.western.sahara:before {
  background-position: 0 -1664px;
}
.kb-labfront.container i.flag.gb.eng:before,
.kb-labfront.container i.flag.england:before {
  background-position: 0 -1690px;
}
.kb-labfront.container i.flag.er:before,
.kb-labfront.container i.flag.eritrea:before {
  background-position: 0 -1716px;
}
.kb-labfront.container i.flag.es:before,
.kb-labfront.container i.flag.spain:before {
  background-position: 0 -1742px;
}
.kb-labfront.container i.flag.et:before,
.kb-labfront.container i.flag.ethiopia:before {
  background-position: 0 -1768px;
}
.kb-labfront.container i.flag.eu:before,
.kb-labfront.container i.flag.european.union:before {
  background-position: 0 -1794px;
}
.kb-labfront.container i.flag.fi:before,
.kb-labfront.container i.flag.finland:before {
  background-position: 0 -1846px;
}
.kb-labfront.container i.flag.fj:before,
.kb-labfront.container i.flag.fiji:before {
  background-position: 0 -1872px;
}
.kb-labfront.container i.flag.fk:before,
.kb-labfront.container i.flag.falkland.islands:before {
  background-position: 0 -1898px;
}
.kb-labfront.container i.flag.fm:before,
.kb-labfront.container i.flag.micronesia:before {
  background-position: 0 -1924px;
}
.kb-labfront.container i.flag.fo:before,
.kb-labfront.container i.flag.faroe.islands:before {
  background-position: 0 -1950px;
}
.kb-labfront.container i.flag.fr:before,
.kb-labfront.container i.flag.france:before {
  background-position: 0 -1976px;
}
.kb-labfront.container i.flag.ga:before,
.kb-labfront.container i.flag.gabon:before {
  background-position: -36px 0;
}
.kb-labfront.container i.flag.gb:before,
.kb-labfront.container i.flag.uk:before,
.kb-labfront.container i.flag.united.kingdom:before {
  background-position: -36px -26px;
}
.kb-labfront.container i.flag.gd:before,
.kb-labfront.container i.flag.grenada:before {
  background-position: -36px -52px;
}
.kb-labfront.container i.flag.ge:before,
.kb-labfront.container i.flag.georgia:before {
  background-position: -36px -78px;
}
.kb-labfront.container i.flag.gf:before,
.kb-labfront.container i.flag.french.guiana:before {
  background-position: -36px -104px;
}
.kb-labfront.container i.flag.gh:before,
.kb-labfront.container i.flag.ghana:before {
  background-position: -36px -130px;
}
.kb-labfront.container i.flag.gi:before,
.kb-labfront.container i.flag.gibraltar:before {
  background-position: -36px -156px;
}
.kb-labfront.container i.flag.gl:before,
.kb-labfront.container i.flag.greenland:before {
  background-position: -36px -182px;
}
.kb-labfront.container i.flag.gm:before,
.kb-labfront.container i.flag.gambia:before {
  background-position: -36px -208px;
}
.kb-labfront.container i.flag.gn:before,
.kb-labfront.container i.flag.guinea:before {
  background-position: -36px -234px;
}
.kb-labfront.container i.flag.gp:before,
.kb-labfront.container i.flag.guadeloupe:before {
  background-position: -36px -260px;
}
.kb-labfront.container i.flag.gq:before,
.kb-labfront.container i.flag.equatorial.guinea:before {
  background-position: -36px -286px;
}
.kb-labfront.container i.flag.gr:before,
.kb-labfront.container i.flag.greece:before {
  background-position: -36px -312px;
}
.kb-labfront.container i.flag.gs:before,
.kb-labfront.container i.flag.sandwich.islands:before {
  background-position: -36px -338px;
}
.kb-labfront.container i.flag.gt:before,
.kb-labfront.container i.flag.guatemala:before {
  background-position: -36px -364px;
}
.kb-labfront.container i.flag.gu:before,
.kb-labfront.container i.flag.guam:before {
  background-position: -36px -390px;
}
.kb-labfront.container i.flag.gw:before,
.kb-labfront.container i.flag.guinea-bissau:before {
  background-position: -36px -416px;
}
.kb-labfront.container i.flag.gy:before,
.kb-labfront.container i.flag.guyana:before {
  background-position: -36px -442px;
}
.kb-labfront.container i.flag.hk:before,
.kb-labfront.container i.flag.hong.kong:before {
  background-position: -36px -468px;
}
.kb-labfront.container i.flag.hm:before,
.kb-labfront.container i.flag.heard.island:before {
  background-position: -36px -494px;
}
.kb-labfront.container i.flag.hn:before,
.kb-labfront.container i.flag.honduras:before {
  background-position: -36px -520px;
}
.kb-labfront.container i.flag.hr:before,
.kb-labfront.container i.flag.croatia:before {
  background-position: -36px -546px;
}
.kb-labfront.container i.flag.ht:before,
.kb-labfront.container i.flag.haiti:before {
  background-position: -36px -572px;
}
.kb-labfront.container i.flag.hu:before,
.kb-labfront.container i.flag.hungary:before {
  background-position: -36px -598px;
}
.kb-labfront.container i.flag.id:before,
.kb-labfront.container i.flag.indonesia:before {
  background-position: -36px -624px;
}
.kb-labfront.container i.flag.ie:before,
.kb-labfront.container i.flag.ireland:before {
  background-position: -36px -650px;
}
.kb-labfront.container i.flag.il:before,
.kb-labfront.container i.flag.israel:before {
  background-position: -36px -676px;
}
.kb-labfront.container i.flag.in:before,
.kb-labfront.container i.flag.india:before {
  background-position: -36px -702px;
}
.kb-labfront.container i.flag.io:before,
.kb-labfront.container i.flag.indian.ocean.territory:before {
  background-position: -36px -728px;
}
.kb-labfront.container i.flag.iq:before,
.kb-labfront.container i.flag.iraq:before {
  background-position: -36px -754px;
}
.kb-labfront.container i.flag.ir:before,
.kb-labfront.container i.flag.iran:before {
  background-position: -36px -780px;
}
.kb-labfront.container i.flag.is:before,
.kb-labfront.container i.flag.iceland:before {
  background-position: -36px -806px;
}
.kb-labfront.container i.flag.it:before,
.kb-labfront.container i.flag.italy:before {
  background-position: -36px -832px;
}
.kb-labfront.container i.flag.jm:before,
.kb-labfront.container i.flag.jamaica:before {
  background-position: -36px -858px;
}
.kb-labfront.container i.flag.jo:before,
.kb-labfront.container i.flag.jordan:before {
  background-position: -36px -884px;
}
.kb-labfront.container i.flag.jp:before,
.kb-labfront.container i.flag.japan:before {
  background-position: -36px -910px;
}
.kb-labfront.container i.flag.ke:before,
.kb-labfront.container i.flag.kenya:before {
  background-position: -36px -936px;
}
.kb-labfront.container i.flag.kg:before,
.kb-labfront.container i.flag.kyrgyzstan:before {
  background-position: -36px -962px;
}
.kb-labfront.container i.flag.kh:before,
.kb-labfront.container i.flag.cambodia:before {
  background-position: -36px -988px;
}
.kb-labfront.container i.flag.ki:before,
.kb-labfront.container i.flag.kiribati:before {
  background-position: -36px -1014px;
}
.kb-labfront.container i.flag.km:before,
.kb-labfront.container i.flag.comoros:before {
  background-position: -36px -1040px;
}
.kb-labfront.container i.flag.kn:before,
.kb-labfront.container i.flag.saint.kitts.and.nevis:before {
  background-position: -36px -1066px;
}
.kb-labfront.container i.flag.kp:before,
.kb-labfront.container i.flag.north.korea:before {
  background-position: -36px -1092px;
}
.kb-labfront.container i.flag.kr:before,
.kb-labfront.container i.flag.south.korea:before {
  background-position: -36px -1118px;
}
.kb-labfront.container i.flag.kw:before,
.kb-labfront.container i.flag.kuwait:before {
  background-position: -36px -1144px;
}
.kb-labfront.container i.flag.ky:before,
.kb-labfront.container i.flag.cayman.islands:before {
  background-position: -36px -1170px;
}
.kb-labfront.container i.flag.kz:before,
.kb-labfront.container i.flag.kazakhstan:before {
  background-position: -36px -1196px;
}
.kb-labfront.container i.flag.la:before,
.kb-labfront.container i.flag.laos:before {
  background-position: -36px -1222px;
}
.kb-labfront.container i.flag.lb:before,
.kb-labfront.container i.flag.lebanon:before {
  background-position: -36px -1248px;
}
.kb-labfront.container i.flag.lc:before,
.kb-labfront.container i.flag.saint.lucia:before {
  background-position: -36px -1274px;
}
.kb-labfront.container i.flag.li:before,
.kb-labfront.container i.flag.liechtenstein:before {
  background-position: -36px -1300px;
}
.kb-labfront.container i.flag.lk:before,
.kb-labfront.container i.flag.sri.lanka:before {
  background-position: -36px -1326px;
}
.kb-labfront.container i.flag.lr:before,
.kb-labfront.container i.flag.liberia:before {
  background-position: -36px -1352px;
}
.kb-labfront.container i.flag.ls:before,
.kb-labfront.container i.flag.lesotho:before {
  background-position: -36px -1378px;
}
.kb-labfront.container i.flag.lt:before,
.kb-labfront.container i.flag.lithuania:before {
  background-position: -36px -1404px;
}
.kb-labfront.container i.flag.lu:before,
.kb-labfront.container i.flag.luxembourg:before {
  background-position: -36px -1430px;
}
.kb-labfront.container i.flag.lv:before,
.kb-labfront.container i.flag.latvia:before {
  background-position: -36px -1456px;
}
.kb-labfront.container i.flag.ly:before,
.kb-labfront.container i.flag.libya:before {
  background-position: -36px -1482px;
}
.kb-labfront.container i.flag.ma:before,
.kb-labfront.container i.flag.morocco:before {
  background-position: -36px -1508px;
}
.kb-labfront.container i.flag.mc:before,
.kb-labfront.container i.flag.monaco:before {
  background-position: -36px -1534px;
}
.kb-labfront.container i.flag.md:before,
.kb-labfront.container i.flag.moldova:before {
  background-position: -36px -1560px;
}
.kb-labfront.container i.flag.me:before,
.kb-labfront.container i.flag.montenegro:before {
  background-position: -36px -1586px;
}
.kb-labfront.container i.flag.mg:before,
.kb-labfront.container i.flag.madagascar:before {
  background-position: -36px -1613px;
}
.kb-labfront.container i.flag.mh:before,
.kb-labfront.container i.flag.marshall.islands:before {
  background-position: -36px -1639px;
}
.kb-labfront.container i.flag.mk:before,
.kb-labfront.container i.flag.macedonia:before {
  background-position: -36px -1665px;
}
.kb-labfront.container i.flag.ml:before,
.kb-labfront.container i.flag.mali:before {
  background-position: -36px -1691px;
}
.kb-labfront.container i.flag.mm:before,
.kb-labfront.container i.flag.myanmar:before,
.kb-labfront.container i.flag.burma:before {
  background-position: -36px -1717px;
}
.kb-labfront.container i.flag.mn:before,
.kb-labfront.container i.flag.mongolia:before {
  background-position: -36px -1743px;
}
.kb-labfront.container i.flag.mo:before,
.kb-labfront.container i.flag.macau:before {
  background-position: -36px -1769px;
}
.kb-labfront.container i.flag.mp:before,
.kb-labfront.container i.flag.northern.mariana.islands:before {
  background-position: -36px -1795px;
}
.kb-labfront.container i.flag.mq:before,
.kb-labfront.container i.flag.martinique:before {
  background-position: -36px -1821px;
}
.kb-labfront.container i.flag.mr:before,
.kb-labfront.container i.flag.mauritania:before {
  background-position: -36px -1847px;
}
.kb-labfront.container i.flag.ms:before,
.kb-labfront.container i.flag.montserrat:before {
  background-position: -36px -1873px;
}
.kb-labfront.container i.flag.mt:before,
.kb-labfront.container i.flag.malta:before {
  background-position: -36px -1899px;
}
.kb-labfront.container i.flag.mu:before,
.kb-labfront.container i.flag.mauritius:before {
  background-position: -36px -1925px;
}
.kb-labfront.container i.flag.mv:before,
.kb-labfront.container i.flag.maldives:before {
  background-position: -36px -1951px;
}
.kb-labfront.container i.flag.mw:before,
.kb-labfront.container i.flag.malawi:before {
  background-position: -36px -1977px;
}
.kb-labfront.container i.flag.mx:before,
.kb-labfront.container i.flag.mexico:before {
  background-position: -72px 0;
}
.kb-labfront.container i.flag.my:before,
.kb-labfront.container i.flag.malaysia:before {
  background-position: -72px -26px;
}
.kb-labfront.container i.flag.mz:before,
.kb-labfront.container i.flag.mozambique:before {
  background-position: -72px -52px;
}
.kb-labfront.container i.flag.na:before,
.kb-labfront.container i.flag.namibia:before {
  background-position: -72px -78px;
}
.kb-labfront.container i.flag.nc:before,
.kb-labfront.container i.flag.new.caledonia:before {
  background-position: -72px -104px;
}
.kb-labfront.container i.flag.ne:before,
.kb-labfront.container i.flag.niger:before {
  background-position: -72px -130px;
}
.kb-labfront.container i.flag.nf:before,
.kb-labfront.container i.flag.norfolk.island:before {
  background-position: -72px -156px;
}
.kb-labfront.container i.flag.ng:before,
.kb-labfront.container i.flag.nigeria:before {
  background-position: -72px -182px;
}
.kb-labfront.container i.flag.ni:before,
.kb-labfront.container i.flag.nicaragua:before {
  background-position: -72px -208px;
}
.kb-labfront.container i.flag.nl:before,
.kb-labfront.container i.flag.netherlands:before {
  background-position: -72px -234px;
}
.kb-labfront.container i.flag.no:before,
.kb-labfront.container i.flag.norway:before {
  background-position: -72px -260px;
}
.kb-labfront.container i.flag.np:before,
.kb-labfront.container i.flag.nepal:before {
  background-position: -72px -286px;
}
.kb-labfront.container i.flag.nr:before,
.kb-labfront.container i.flag.nauru:before {
  background-position: -72px -312px;
}
.kb-labfront.container i.flag.nu:before,
.kb-labfront.container i.flag.niue:before {
  background-position: -72px -338px;
}
.kb-labfront.container i.flag.nz:before,
.kb-labfront.container i.flag.new.zealand:before {
  background-position: -72px -364px;
}
.kb-labfront.container i.flag.om:before,
.kb-labfront.container i.flag.oman:before {
  background-position: -72px -390px;
}
.kb-labfront.container i.flag.pa:before,
.kb-labfront.container i.flag.panama:before {
  background-position: -72px -416px;
}
.kb-labfront.container i.flag.pe:before,
.kb-labfront.container i.flag.peru:before {
  background-position: -72px -442px;
}
.kb-labfront.container i.flag.pf:before,
.kb-labfront.container i.flag.french.polynesia:before {
  background-position: -72px -468px;
}
.kb-labfront.container i.flag.pg:before,
.kb-labfront.container i.flag.new.guinea:before {
  background-position: -72px -494px;
}
.kb-labfront.container i.flag.ph:before,
.kb-labfront.container i.flag.philippines:before {
  background-position: -72px -520px;
}
.kb-labfront.container i.flag.pk:before,
.kb-labfront.container i.flag.pakistan:before {
  background-position: -72px -546px;
}
.kb-labfront.container i.flag.pl:before,
.kb-labfront.container i.flag.poland:before {
  background-position: -72px -572px;
}
.kb-labfront.container i.flag.pm:before,
.kb-labfront.container i.flag.saint.pierre:before {
  background-position: -72px -598px;
}
.kb-labfront.container i.flag.pn:before,
.kb-labfront.container i.flag.pitcairn.islands:before {
  background-position: -72px -624px;
}
.kb-labfront.container i.flag.pr:before,
.kb-labfront.container i.flag.puerto.rico:before {
  background-position: -72px -650px;
}
.kb-labfront.container i.flag.ps:before,
.kb-labfront.container i.flag.palestine:before {
  background-position: -72px -676px;
}
.kb-labfront.container i.flag.pt:before,
.kb-labfront.container i.flag.portugal:before {
  background-position: -72px -702px;
}
.kb-labfront.container i.flag.pw:before,
.kb-labfront.container i.flag.palau:before {
  background-position: -72px -728px;
}
.kb-labfront.container i.flag.py:before,
.kb-labfront.container i.flag.paraguay:before {
  background-position: -72px -754px;
}
.kb-labfront.container i.flag.qa:before,
.kb-labfront.container i.flag.qatar:before {
  background-position: -72px -780px;
}
.kb-labfront.container i.flag.re:before,
.kb-labfront.container i.flag.reunion:before {
  background-position: -72px -806px;
}
.kb-labfront.container i.flag.ro:before,
.kb-labfront.container i.flag.romania:before {
  background-position: -72px -832px;
}
.kb-labfront.container i.flag.rs:before,
.kb-labfront.container i.flag.serbia:before {
  background-position: -72px -858px;
}
.kb-labfront.container i.flag.ru:before,
.kb-labfront.container i.flag.russia:before {
  background-position: -72px -884px;
}
.kb-labfront.container i.flag.rw:before,
.kb-labfront.container i.flag.rwanda:before {
  background-position: -72px -910px;
}
.kb-labfront.container i.flag.sa:before,
.kb-labfront.container i.flag.saudi.arabia:before {
  background-position: -72px -936px;
}
.kb-labfront.container i.flag.sb:before,
.kb-labfront.container i.flag.solomon.islands:before {
  background-position: -72px -962px;
}
.kb-labfront.container i.flag.sc:before,
.kb-labfront.container i.flag.seychelles:before {
  background-position: -72px -988px;
}
.kb-labfront.container i.flag.gb.sct:before,
.kb-labfront.container i.flag.scotland:before {
  background-position: -72px -1014px;
}
.kb-labfront.container i.flag.sd:before,
.kb-labfront.container i.flag.sudan:before {
  background-position: -72px -1040px;
}
.kb-labfront.container i.flag.se:before,
.kb-labfront.container i.flag.sweden:before {
  background-position: -72px -1066px;
}
.kb-labfront.container i.flag.sg:before,
.kb-labfront.container i.flag.singapore:before {
  background-position: -72px -1092px;
}
.kb-labfront.container i.flag.sh:before,
.kb-labfront.container i.flag.saint.helena:before {
  background-position: -72px -1118px;
}
.kb-labfront.container i.flag.si:before,
.kb-labfront.container i.flag.slovenia:before {
  background-position: -72px -1144px;
}
.kb-labfront.container i.flag.sj:before,
.kb-labfront.container i.flag.svalbard:before,
.kb-labfront.container i.flag.jan.mayen:before {
  background-position: -72px -1170px;
}
.kb-labfront.container i.flag.sk:before,
.kb-labfront.container i.flag.slovakia:before {
  background-position: -72px -1196px;
}
.kb-labfront.container i.flag.sl:before,
.kb-labfront.container i.flag.sierra.leone:before {
  background-position: -72px -1222px;
}
.kb-labfront.container i.flag.sm:before,
.kb-labfront.container i.flag.san.marino:before {
  background-position: -72px -1248px;
}
.kb-labfront.container i.flag.sn:before,
.kb-labfront.container i.flag.senegal:before {
  background-position: -72px -1274px;
}
.kb-labfront.container i.flag.so:before,
.kb-labfront.container i.flag.somalia:before {
  background-position: -72px -1300px;
}
.kb-labfront.container i.flag.sr:before,
.kb-labfront.container i.flag.suriname:before {
  background-position: -72px -1326px;
}
.kb-labfront.container i.flag.st:before,
.kb-labfront.container i.flag.sao.tome:before {
  background-position: -72px -1352px;
}
.kb-labfront.container i.flag.sv:before,
.kb-labfront.container i.flag.el.salvador:before {
  background-position: -72px -1378px;
}
.kb-labfront.container i.flag.sy:before,
.kb-labfront.container i.flag.syria:before {
  background-position: -72px -1404px;
}
.kb-labfront.container i.flag.sz:before,
.kb-labfront.container i.flag.swaziland:before {
  background-position: -72px -1430px;
}
.kb-labfront.container i.flag.tc:before,
.kb-labfront.container i.flag.caicos.islands:before {
  background-position: -72px -1456px;
}
.kb-labfront.container i.flag.td:before,
.kb-labfront.container i.flag.chad:before {
  background-position: -72px -1482px;
}
.kb-labfront.container i.flag.tf:before,
.kb-labfront.container i.flag.french.territories:before {
  background-position: -72px -1508px;
}
.kb-labfront.container i.flag.tg:before,
.kb-labfront.container i.flag.togo:before {
  background-position: -72px -1534px;
}
.kb-labfront.container i.flag.th:before,
.kb-labfront.container i.flag.thailand:before {
  background-position: -72px -1560px;
}
.kb-labfront.container i.flag.tj:before,
.kb-labfront.container i.flag.tajikistan:before {
  background-position: -72px -1586px;
}
.kb-labfront.container i.flag.tk:before,
.kb-labfront.container i.flag.tokelau:before {
  background-position: -72px -1612px;
}
.kb-labfront.container i.flag.tl:before,
.kb-labfront.container i.flag.timorleste:before {
  background-position: -72px -1638px;
}
.kb-labfront.container i.flag.tm:before,
.kb-labfront.container i.flag.turkmenistan:before {
  background-position: -72px -1664px;
}
.kb-labfront.container i.flag.tn:before,
.kb-labfront.container i.flag.tunisia:before {
  background-position: -72px -1690px;
}
.kb-labfront.container i.flag.to:before,
.kb-labfront.container i.flag.tonga:before {
  background-position: -72px -1716px;
}
.kb-labfront.container i.flag.tr:before,
.kb-labfront.container i.flag.turkey:before {
  background-position: -72px -1742px;
}
.kb-labfront.container i.flag.tt:before,
.kb-labfront.container i.flag.trinidad:before {
  background-position: -72px -1768px;
}
.kb-labfront.container i.flag.tv:before,
.kb-labfront.container i.flag.tuvalu:before {
  background-position: -72px -1794px;
}
.kb-labfront.container i.flag.tw:before,
.kb-labfront.container i.flag.taiwan:before {
  background-position: -72px -1820px;
}
.kb-labfront.container i.flag.tz:before,
.kb-labfront.container i.flag.tanzania:before {
  background-position: -72px -1846px;
}
.kb-labfront.container i.flag.ua:before,
.kb-labfront.container i.flag.ukraine:before {
  background-position: -72px -1872px;
}
.kb-labfront.container i.flag.ug:before,
.kb-labfront.container i.flag.uganda:before {
  background-position: -72px -1898px;
}
.kb-labfront.container i.flag.um:before,
.kb-labfront.container i.flag.us.minor.islands:before {
  background-position: -72px -1924px;
}
.kb-labfront.container i.flag.us:before,
.kb-labfront.container i.flag.america:before,
.kb-labfront.container i.flag.united.states:before {
  background-position: -72px -1950px;
}
.kb-labfront.container i.flag.uy:before,
.kb-labfront.container i.flag.uruguay:before {
  background-position: -72px -1976px;
}
.kb-labfront.container i.flag.uz:before,
.kb-labfront.container i.flag.uzbekistan:before {
  background-position: -108px 0;
}
.kb-labfront.container i.flag.va:before,
.kb-labfront.container i.flag.vatican.city:before {
  background-position: -108px -26px;
}
.kb-labfront.container i.flag.vc:before,
.kb-labfront.container i.flag.saint.vincent:before {
  background-position: -108px -52px;
}
.kb-labfront.container i.flag.ve:before,
.kb-labfront.container i.flag.venezuela:before {
  background-position: -108px -78px;
}
.kb-labfront.container i.flag.vg:before,
.kb-labfront.container i.flag.british.virgin.islands:before {
  background-position: -108px -104px;
}
.kb-labfront.container i.flag.vi:before,
.kb-labfront.container i.flag.us.virgin.islands:before {
  background-position: -108px -130px;
}
.kb-labfront.container i.flag.vn:before,
.kb-labfront.container i.flag.vietnam:before {
  background-position: -108px -156px;
}
.kb-labfront.container i.flag.vu:before,
.kb-labfront.container i.flag.vanuatu:before {
  background-position: -108px -182px;
}
.kb-labfront.container i.flag.gb.wls:before,
.kb-labfront.container i.flag.wales:before {
  background-position: -108px -208px;
}
.kb-labfront.container i.flag.wf:before,
.kb-labfront.container i.flag.wallis.and.futuna:before {
  background-position: -108px -234px;
}
.kb-labfront.container i.flag.ws:before,
.kb-labfront.container i.flag.samoa:before {
  background-position: -108px -260px;
}
.kb-labfront.container i.flag.ye:before,
.kb-labfront.container i.flag.yemen:before {
  background-position: -108px -286px;
}
.kb-labfront.container i.flag.yt:before,
.kb-labfront.container i.flag.mayotte:before {
  background-position: -108px -312px;
}
.kb-labfront.container i.flag.za:before,
.kb-labfront.container i.flag.south.africa:before {
  background-position: -108px -338px;
}
.kb-labfront.container i.flag.zm:before,
.kb-labfront.container i.flag.zambia:before {
  background-position: -108px -364px;
}
.kb-labfront.container i.flag.zw:before,
.kb-labfront.container i.flag.zimbabwe:before {
  background-position: -108px -390px;
}
.kb-labfront.container .ui.header {
  border: none;
  margin: calc(2rem - 0.1428571429em) 0 1rem;
  padding: 0 0;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: bold;
  line-height: 1.2857142857em;
  text-transform: none;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.header:first-child {
  margin-top: -0.1428571429em;
}
.kb-labfront.container .ui.header:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.header .sub.header {
  display: block;
  font-weight: normal;
  padding: 0;
  margin: 0;
  font-size: 1rem;
  line-height: 1.2em;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.header > .icon {
  display: table-cell;
  opacity: 1;
  font-size: 1.5em;
  padding-top: 0;
  vertical-align: middle;
}
.kb-labfront.container .ui.header .icon:only-child {
  display: inline-block;
  padding: 0;
  margin-right: 0.75rem;
}
.kb-labfront.container .ui.header > .image:not(.icon),
.kb-labfront.container .ui.header > img {
  display: inline-block;
  margin-top: 0.1428571429em;
  width: 2.5em;
  height: auto;
  vertical-align: middle;
}
.kb-labfront.container .ui.header > .image:not(.icon):only-child,
.kb-labfront.container .ui.header > img:only-child {
  margin-right: 0.75rem;
}
.kb-labfront.container .ui.header .content {
  display: inline-block;
  vertical-align: top;
}
.kb-labfront.container .ui.header > img + .content,
.kb-labfront.container .ui.header > .image + .content {
  padding-left: 0.75rem;
  vertical-align: middle;
}
.kb-labfront.container .ui.header > .icon + .content {
  padding-left: 0.75rem;
  display: table-cell;
  vertical-align: middle;
}
.kb-labfront.container .ui.header .ui.label {
  font-size: "";
  margin-left: 0.5rem;
  vertical-align: middle;
}
.kb-labfront.container .ui.header + p {
  margin-top: 0;
}
.kb-labfront.container h1.ui.header {
  font-size: 2rem;
}
.kb-labfront.container h2.ui.header {
  font-size: 1.7142857143rem;
}
.kb-labfront.container h3.ui.header {
  font-size: 1.2857142857rem;
}
.kb-labfront.container h4.ui.header {
  font-size: 1.0714285714rem;
}
.kb-labfront.container h5.ui.header {
  font-size: 1rem;
}
.kb-labfront.container h1.ui.header .sub.header {
  font-size: 1.1428571429rem;
}
.kb-labfront.container h2.ui.header .sub.header {
  font-size: 1.1428571429rem;
}
.kb-labfront.container h3.ui.header .sub.header {
  font-size: 1rem;
}
.kb-labfront.container h4.ui.header .sub.header {
  font-size: 1rem;
}
.kb-labfront.container h5.ui.header .sub.header {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.huge.header {
  min-height: 1em;
  font-size: 2em;
}
.kb-labfront.container .ui.large.header {
  font-size: 1.7142857143em;
}
.kb-labfront.container .ui.medium.header {
  font-size: 1.2857142857em;
}
.kb-labfront.container .ui.small.header {
  font-size: 1.0714285714em;
}
.kb-labfront.container .ui.tiny.header {
  font-size: 1em;
}
.kb-labfront.container .ui.huge.header .sub.header {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.large.header .sub.header {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.header .sub.header {
  font-size: 1rem;
}
.kb-labfront.container .ui.small.header .sub.header {
  font-size: 1rem;
}
.kb-labfront.container .ui.tiny.header .sub.header {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.sub.header {
  padding: 0;
  margin-bottom: 0.1428571429rem;
  font-weight: bold;
  font-size: 0.8571428571em;
  text-transform: uppercase;
  color: "";
}
.kb-labfront.container .ui.small.sub.header {
  font-size: 0.7857142857em;
}
.kb-labfront.container .ui.large.sub.header {
  font-size: 0.9285714286em;
}
.kb-labfront.container .ui.huge.sub.header {
  font-size: 1em;
}
.kb-labfront.container .ui.icon.header {
  display: inline-block;
  text-align: center;
  margin: 2rem 0 1rem;
}
.kb-labfront.container .ui.icon.header:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.kb-labfront.container .ui.icon.header:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.icon.header .icon {
  float: none;
  display: block;
  width: auto;
  height: auto;
  line-height: 1;
  padding: 0;
  font-size: 3em;
  margin: 0 auto 0.5rem;
  opacity: 1;
}
.kb-labfront.container .ui.icon.header .corner.icon {
  font-size: calc(3em * 0.45);
}
.kb-labfront.container .ui.icon.header .content {
  display: block;
  padding: 0;
}
.kb-labfront.container .ui.icon.header .circular.icon {
  font-size: 2em;
}
.kb-labfront.container .ui.icon.header .square.icon {
  font-size: 2em;
}
.kb-labfront.container .ui.block.icon.header .icon {
  margin-bottom: 0;
}
.kb-labfront.container .ui.icon.header.aligned {
  margin-left: auto;
  margin-right: auto;
  display: block;
}
.kb-labfront.container .ui.disabled.header {
  opacity: 0.45;
}
.kb-labfront.container .ui.inverted.header {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.header .sub.header {
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.attached.header {
  background: #1b1c1d;
  box-shadow: none;
  border-color: transparent;
}
.kb-labfront.container .ui.inverted.block.header {
  background: #545454 linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  box-shadow: none;
  border-bottom: none;
}
.kb-labfront.container .ui.primary.header {
  color: #2185d0;
}
.kb-labfront.container a.ui.primary.header:hover {
  color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.primary.dividing.header {
  border-bottom: 2px solid #2185d0;
}
.kb-labfront.container .ui.inverted.primary.header.header.header {
  color: #54c8ff;
}
.kb-labfront.container a.ui.inverted.primary.header.header.header:hover {
  color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.primary.dividing.header {
  border-bottom: 2px solid #54c8ff;
}
.kb-labfront.container .ui.secondary.header {
  color: #1b1c1d;
}
.kb-labfront.container a.ui.secondary.header:hover {
  color: rgb(35.2196428571, 40.75, 46.2803571429);
}
.kb-labfront.container .ui.secondary.dividing.header {
  border-bottom: 2px solid #1b1c1d;
}
.kb-labfront.container .ui.inverted.secondary.header.header.header {
  color: #545454;
}
.kb-labfront.container a.ui.inverted.secondary.header.header.header:hover {
  color: rgb(120.45, 98.55, 98.55);
}
.kb-labfront.container .ui.inverted.secondary.dividing.header {
  border-bottom: 2px solid #545454;
}
.kb-labfront.container .ui.red.header {
  color: #db2828;
}
.kb-labfront.container a.ui.red.header:hover {
  color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.red.dividing.header {
  border-bottom: 2px solid #db2828;
}
.kb-labfront.container .ui.inverted.red.header.header.header {
  color: #ff695e;
}
.kb-labfront.container a.ui.inverted.red.header.header.header:hover {
  color: rgb(255, 57.4844720497, 43);
}
.kb-labfront.container .ui.inverted.red.dividing.header {
  border-bottom: 2px solid #ff695e;
}
.kb-labfront.container .ui.orange.header {
  color: #f2711c;
}
.kb-labfront.container a.ui.orange.header:hover {
  color: rgb(243.48125, 97.3239485981, 1.01875);
}
.kb-labfront.container .ui.orange.dividing.header {
  border-bottom: 2px solid #f2711c;
}
.kb-labfront.container .ui.inverted.orange.header.header.header {
  color: #ff851b;
}
.kb-labfront.container a.ui.inverted.orange.header.header.header:hover {
  color: rgb(231, 107.3947368421, 0);
}
.kb-labfront.container .ui.inverted.orange.dividing.header {
  border-bottom: 2px solid #ff851b;
}
.kb-labfront.container .ui.yellow.header {
  color: #fbbd08;
}
.kb-labfront.container a.ui.yellow.header:hover {
  color: rgb(233.5, 173.9238683128, 0);
}
.kb-labfront.container .ui.yellow.dividing.header {
  border-bottom: 2px solid #fbbd08;
}
.kb-labfront.container .ui.inverted.yellow.header.header.header {
  color: #ffe21f;
}
.kb-labfront.container a.ui.inverted.yellow.header.header.header:hover {
  color: rgb(235, 204.5758928571, 0);
}
.kb-labfront.container .ui.inverted.yellow.dividing.header {
  border-bottom: 2px solid #ffe21f;
}
.kb-labfront.container .ui.olive.header {
  color: #b5cc18;
}
.kb-labfront.container a.ui.olive.header:hover {
  color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
}
.kb-labfront.container .ui.olive.dividing.header {
  border-bottom: 2px solid #b5cc18;
}
.kb-labfront.container .ui.inverted.olive.header.header.header {
  color: #d9e778;
}
.kb-labfront.container a.ui.inverted.olive.header.header.header:hover {
  color: rgb(212.6626721061, 233.8018867925, 66.1981132075);
}
.kb-labfront.container .ui.inverted.olive.dividing.header {
  border-bottom: 2px solid #d9e778;
}
.kb-labfront.container .ui.green.header {
  color: #21ba45;
}
.kb-labfront.container a.ui.green.header:hover {
  color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.green.dividing.header {
  border-bottom: 2px solid #21ba45;
}
.kb-labfront.container .ui.inverted.green.header.header.header {
  color: #2ecc40;
}
.kb-labfront.container a.ui.inverted.green.header.header.header:hover {
  color: rgb(26.666, 172.334, 43.2610886076);
}
.kb-labfront.container .ui.inverted.green.dividing.header {
  border-bottom: 2px solid #2ecc40;
}
.kb-labfront.container .ui.teal.header {
  color: #00b5ad;
}
.kb-labfront.container a.ui.teal.header:hover {
  color: rgb(0, 155.5, 148.6270718232);
}
.kb-labfront.container .ui.teal.dividing.header {
  border-bottom: 2px solid #00b5ad;
}
.kb-labfront.container .ui.inverted.teal.header.header.header {
  color: #6dffff;
}
.kb-labfront.container a.ui.inverted.teal.header.header.header:hover {
  color: #3affff;
}
.kb-labfront.container .ui.inverted.teal.dividing.header {
  border-bottom: 2px solid #6dffff;
}
.kb-labfront.container .ui.blue.header {
  color: #2185d0;
}
.kb-labfront.container a.ui.blue.header:hover {
  color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.blue.dividing.header {
  border-bottom: 2px solid #2185d0;
}
.kb-labfront.container .ui.inverted.blue.header.header.header {
  color: #54c8ff;
}
.kb-labfront.container a.ui.inverted.blue.header.header.header:hover {
  color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.blue.dividing.header {
  border-bottom: 2px solid #54c8ff;
}
.kb-labfront.container .ui.violet.header {
  color: #6435c9;
}
.kb-labfront.container a.ui.violet.header:hover {
  color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
}
.kb-labfront.container .ui.violet.dividing.header {
  border-bottom: 2px solid #6435c9;
}
.kb-labfront.container .ui.inverted.violet.header.header.header {
  color: #a291fb;
}
.kb-labfront.container a.ui.inverted.violet.header.header.header:hover {
  color: rgb(116.4622641509, 90, 255);
}
.kb-labfront.container .ui.inverted.violet.dividing.header {
  border-bottom: 2px solid #a291fb;
}
.kb-labfront.container .ui.purple.header {
  color: #a333c8;
}
.kb-labfront.container a.ui.purple.header:hover {
  color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
}
.kb-labfront.container .ui.purple.dividing.header {
  border-bottom: 2px solid #a333c8;
}
.kb-labfront.container .ui.inverted.purple.header.header.header {
  color: #dc73ff;
}
.kb-labfront.container a.ui.inverted.purple.header.header.header:hover {
  color: rgb(207.25, 64, 255);
}
.kb-labfront.container .ui.inverted.purple.dividing.header {
  border-bottom: 2px solid #dc73ff;
}
.kb-labfront.container .ui.pink.header {
  color: #e03997;
}
.kb-labfront.container a.ui.pink.header:hover {
  color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
}
.kb-labfront.container .ui.pink.dividing.header {
  border-bottom: 2px solid #e03997;
}
.kb-labfront.container .ui.inverted.pink.header.header.header {
  color: #ff8edf;
}
.kb-labfront.container a.ui.inverted.pink.header.header.header:hover {
  color: rgb(255, 91, 208.5575221239);
}
.kb-labfront.container .ui.inverted.pink.dividing.header {
  border-bottom: 2px solid #ff8edf;
}
.kb-labfront.container .ui.brown.header {
  color: #a5673f;
}
.kb-labfront.container a.ui.brown.header:hover {
  color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
}
.kb-labfront.container .ui.brown.dividing.header {
  border-bottom: 2px solid #a5673f;
}
.kb-labfront.container .ui.inverted.brown.header.header.header {
  color: #d67c1c;
}
.kb-labfront.container a.ui.inverted.brown.header.header.header:hover {
  color: rgb(178.4508264463, 98.1758331112, 12.5491735537);
}
.kb-labfront.container .ui.inverted.brown.dividing.header {
  border-bottom: 2px solid #d67c1c;
}
.kb-labfront.container .ui.grey.header {
  color: #767676;
}
.kb-labfront.container a.ui.grey.header:hover {
  color: rgb(115.775, 94.725, 94.725);
}
.kb-labfront.container .ui.grey.dividing.header {
  border-bottom: 2px solid #767676;
}
.kb-labfront.container .ui.inverted.grey.header.header.header {
  color: #dcddde;
}
.kb-labfront.container a.ui.inverted.grey.header.header.header:hover {
  color: rgb(187.8, 195.5, 203.2);
}
.kb-labfront.container .ui.inverted.grey.dividing.header {
  border-bottom: 2px solid #dcddde;
}
.kb-labfront.container .ui.black.header {
  color: #1b1c1d;
}
.kb-labfront.container a.ui.black.header:hover {
  color: rgb(13.1803571429, 15.25, 17.3196428571);
}
.kb-labfront.container .ui.black.dividing.header {
  border-bottom: 2px solid #1b1c1d;
}
.kb-labfront.container .ui.inverted.black.header.header.header {
  color: #545454;
}
.kb-labfront.container a.ui.inverted.black.header.header.header:hover {
  color: black;
}
.kb-labfront.container .ui.inverted.black.dividing.header {
  border-bottom: 2px solid #545454;
}
.kb-labfront.container .ui.left.aligned.header {
  text-align: left;
}
.kb-labfront.container .ui.right.aligned.header {
  text-align: right;
}
.kb-labfront.container .ui.centered.header,
.kb-labfront.container .ui.center.aligned.header {
  text-align: center;
}
.kb-labfront.container .ui.justified.header {
  text-align: justify;
}
.kb-labfront.container .ui.justified.header:after {
  display: inline-block;
  content: "";
  width: 100%;
}
.kb-labfront.container .ui.floated.header,
.kb-labfront.container .ui[class*="left floated"].header {
  float: left;
  margin-top: 0;
  margin-right: 0.5em;
}
.kb-labfront.container .ui[class*="right floated"].header {
  float: right;
  margin-top: 0;
  margin-left: 0.5em;
}
.kb-labfront.container .ui.fitted.header {
  padding: 0;
}
.kb-labfront.container .ui.dividing.header {
  padding-bottom: 0.2142857143rem;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.dividing.header .sub.header {
  padding-bottom: 0.2142857143rem;
}
.kb-labfront.container .ui.dividing.header .icon {
  margin-bottom: 0;
}
.kb-labfront.container .ui.inverted.dividing.header {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.block.header {
  background: #f3f4f5;
  padding: 0.7857142857rem 1rem;
  box-shadow: none;
  border: 1px solid #d4d4d5;
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.tiny.block.header {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.block.header {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.block.header {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.huge.block.header {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.attached.header {
  background: #ffffff;
  padding: 0.7857142857rem 1rem;
  margin: 0 -1px 0 -1px;
  box-shadow: none;
  border: 1px solid #d4d4d5;
  border-radius: 0;
}
.kb-labfront.container .ui.attached.block.header {
  background: #f3f4f5;
}
.kb-labfront.container .ui.attached:not(.top).header {
  border-top: none;
}
.kb-labfront.container .ui.top.attached.header {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.bottom.attached.header {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.tiny.attached.header {
  font-size: 0.8571428571em;
}
.kb-labfront.container .ui.small.attached.header {
  font-size: 0.9285714286em;
}
.kb-labfront.container .ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
  font-size: 1em;
}
.kb-labfront.container .ui.large.attached.header {
  font-size: 1.1428571429em;
}
.kb-labfront.container .ui.huge.attached.header {
  font-size: 1.4285714286em;
}
.kb-labfront.container .ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {
  font-size: 1.2857142857em;
}
@font-face {
  font-family: "Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("svg");
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-decoration: inherit;
  text-transform: none;
}
.kb-labfront.container i.icon {
  display: inline-block;
  opacity: 1;
  margin: 0 0.25rem 0 0;
  width: 1.18em;
  height: 1em;
  font-family: "Icons";
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  text-align: center;
  speak: none;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  backface-visibility: hidden;
}
.kb-labfront.container i.icon:before {
  background: none !important;
}
.kb-labfront.container i.icon.loading {
  height: 1em;
  line-height: 1;
  animation: loader 2s linear infinite;
}
.kb-labfront.container i.icon:hover, .kb-labfront.container i.icons:hover,
.kb-labfront.container i.icon:active, .kb-labfront.container i.icons:active,
.kb-labfront.container i.emphasized.icon:not(.disabled), .kb-labfront.container i.emphasized.icons:not(.disabled) {
  opacity: 1;
}
.kb-labfront.container i.disabled.icon, .kb-labfront.container i.disabled.icons {
  opacity: 0.45;
  cursor: default;
  pointer-events: none;
}
.kb-labfront.container i.fitted.icon {
  width: auto;
  margin: 0 !important;
}
.kb-labfront.container i.link.icon:not(.disabled), .kb-labfront.container i.link.icons:not(.disabled) {
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.1s ease;
}
.kb-labfront.container i.link.icon:hover, .kb-labfront.container i.link.icons:hover {
  opacity: 1;
}
.kb-labfront.container i.circular.icon {
  border-radius: 500em !important;
  line-height: 1 !important;
  padding: 0.5em 0 !important;
  box-shadow: 0 0 0 0.1em rgba(0, 0, 0, 0.1) inset;
  width: 2em !important;
  height: 2em !important;
}
.kb-labfront.container i.circular.inverted.icon {
  border: none;
  box-shadow: none;
}
.kb-labfront.container i.flipped.icon,
.kb-labfront.container i.horizontally.flipped.icon {
  transform: scale(-1, 1);
}
.kb-labfront.container i.vertically.flipped.icon {
  transform: scale(1, -1);
}
.kb-labfront.container i.rotated.icon,
.kb-labfront.container i.right.rotated.icon,
.kb-labfront.container i.clockwise.rotated.icon {
  transform: rotate(90deg);
}
.kb-labfront.container i.left.rotated.icon,
.kb-labfront.container i.counterclockwise.rotated.icon {
  transform: rotate(-90deg);
}
.kb-labfront.container i.halfway.rotated.icon {
  transform: rotate(180deg);
}
.kb-labfront.container i.rotated.flipped.icon,
.kb-labfront.container i.right.rotated.flipped.icon,
.kb-labfront.container i.clockwise.rotated.flipped.icon {
  transform: scale(-1, 1) rotate(90deg);
}
.kb-labfront.container i.left.rotated.flipped.icon,
.kb-labfront.container i.counterclockwise.rotated.flipped.icon {
  transform: scale(-1, 1) rotate(-90deg);
}
.kb-labfront.container i.halfway.rotated.flipped.icon {
  transform: scale(-1, 1) rotate(180deg);
}
.kb-labfront.container i.rotated.vertically.flipped.icon,
.kb-labfront.container i.right.rotated.vertically.flipped.icon,
.kb-labfront.container i.clockwise.rotated.vertically.flipped.icon {
  transform: scale(1, -1) rotate(90deg);
}
.kb-labfront.container i.left.rotated.vertically.flipped.icon,
.kb-labfront.container i.counterclockwise.rotated.vertically.flipped.icon {
  transform: scale(1, -1) rotate(-90deg);
}
.kb-labfront.container i.halfway.rotated.vertically.flipped.icon {
  transform: scale(1, -1) rotate(180deg);
}
.kb-labfront.container i.bordered.icon {
  line-height: 1;
  vertical-align: baseline;
  width: 2em;
  height: 2em;
  padding: 0.5em 0 !important;
  box-shadow: 0 0 0 0.1em rgba(0, 0, 0, 0.1) inset;
}
.kb-labfront.container i.bordered.inverted.icon {
  border: none;
  box-shadow: none;
}
.kb-labfront.container i.inverted.bordered.icon,
.kb-labfront.container i.inverted.circular.icon {
  background-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container i.inverted.icon {
  color: #ffffff;
}
.kb-labfront.container i.primary.icon.icon.icon.icon {
  color: #2185d0;
}
.kb-labfront.container i.inverted.primary.icon.icon.icon.icon {
  color: #54c8ff;
}
.kb-labfront.container i.inverted.bordered.primary.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.primary.icon.icon.icon.icon {
  background-color: #2185d0;
  color: #ffffff;
}
.kb-labfront.container i.secondary.icon.icon.icon.icon {
  color: #1b1c1d;
}
.kb-labfront.container i.inverted.secondary.icon.icon.icon.icon {
  color: #545454;
}
.kb-labfront.container i.inverted.bordered.secondary.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.secondary.icon.icon.icon.icon {
  background-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container i.red.icon.icon.icon.icon {
  color: #db2828;
}
.kb-labfront.container i.inverted.red.icon.icon.icon.icon {
  color: #ff695e;
}
.kb-labfront.container i.inverted.bordered.red.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.red.icon.icon.icon.icon {
  background-color: #db2828;
  color: #ffffff;
}
.kb-labfront.container i.orange.icon.icon.icon.icon {
  color: #f2711c;
}
.kb-labfront.container i.inverted.orange.icon.icon.icon.icon {
  color: #ff851b;
}
.kb-labfront.container i.inverted.bordered.orange.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.orange.icon.icon.icon.icon {
  background-color: #f2711c;
  color: #ffffff;
}
.kb-labfront.container i.yellow.icon.icon.icon.icon {
  color: #fbbd08;
}
.kb-labfront.container i.inverted.yellow.icon.icon.icon.icon {
  color: #ffe21f;
}
.kb-labfront.container i.inverted.bordered.yellow.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.yellow.icon.icon.icon.icon {
  background-color: #fbbd08;
  color: #ffffff;
}
.kb-labfront.container i.olive.icon.icon.icon.icon {
  color: #b5cc18;
}
.kb-labfront.container i.inverted.olive.icon.icon.icon.icon {
  color: #d9e778;
}
.kb-labfront.container i.inverted.bordered.olive.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.olive.icon.icon.icon.icon {
  background-color: #b5cc18;
  color: #ffffff;
}
.kb-labfront.container i.green.icon.icon.icon.icon {
  color: #21ba45;
}
.kb-labfront.container i.inverted.green.icon.icon.icon.icon {
  color: #2ecc40;
}
.kb-labfront.container i.inverted.bordered.green.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.green.icon.icon.icon.icon {
  background-color: #21ba45;
  color: #ffffff;
}
.kb-labfront.container i.teal.icon.icon.icon.icon {
  color: #00b5ad;
}
.kb-labfront.container i.inverted.teal.icon.icon.icon.icon {
  color: #6dffff;
}
.kb-labfront.container i.inverted.bordered.teal.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.teal.icon.icon.icon.icon {
  background-color: #00b5ad;
  color: #ffffff;
}
.kb-labfront.container i.blue.icon.icon.icon.icon {
  color: #2185d0;
}
.kb-labfront.container i.inverted.blue.icon.icon.icon.icon {
  color: #54c8ff;
}
.kb-labfront.container i.inverted.bordered.blue.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.blue.icon.icon.icon.icon {
  background-color: #2185d0;
  color: #ffffff;
}
.kb-labfront.container i.violet.icon.icon.icon.icon {
  color: #6435c9;
}
.kb-labfront.container i.inverted.violet.icon.icon.icon.icon {
  color: #a291fb;
}
.kb-labfront.container i.inverted.bordered.violet.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.violet.icon.icon.icon.icon {
  background-color: #6435c9;
  color: #ffffff;
}
.kb-labfront.container i.purple.icon.icon.icon.icon {
  color: #a333c8;
}
.kb-labfront.container i.inverted.purple.icon.icon.icon.icon {
  color: #dc73ff;
}
.kb-labfront.container i.inverted.bordered.purple.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.purple.icon.icon.icon.icon {
  background-color: #a333c8;
  color: #ffffff;
}
.kb-labfront.container i.pink.icon.icon.icon.icon {
  color: #e03997;
}
.kb-labfront.container i.inverted.pink.icon.icon.icon.icon {
  color: #ff8edf;
}
.kb-labfront.container i.inverted.bordered.pink.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.pink.icon.icon.icon.icon {
  background-color: #e03997;
  color: #ffffff;
}
.kb-labfront.container i.brown.icon.icon.icon.icon {
  color: #a5673f;
}
.kb-labfront.container i.inverted.brown.icon.icon.icon.icon {
  color: #d67c1c;
}
.kb-labfront.container i.inverted.bordered.brown.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.brown.icon.icon.icon.icon {
  background-color: #a5673f;
  color: #ffffff;
}
.kb-labfront.container i.grey.icon.icon.icon.icon {
  color: #767676;
}
.kb-labfront.container i.inverted.grey.icon.icon.icon.icon {
  color: #dcddde;
}
.kb-labfront.container i.inverted.bordered.grey.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.grey.icon.icon.icon.icon {
  background-color: #767676;
  color: #ffffff;
}
.kb-labfront.container i.black.icon.icon.icon.icon {
  color: #1b1c1d;
}
.kb-labfront.container i.inverted.black.icon.icon.icon.icon {
  color: #545454;
}
.kb-labfront.container i.inverted.bordered.black.icon.icon.icon.icon,
.kb-labfront.container i.inverted.circular.black.icon.icon.icon.icon {
  background-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container i.mini.mini.mini.icon,
.kb-labfront.container i.mini.mini.mini.icons {
  line-height: 1;
  font-size: 0.4em;
}
.kb-labfront.container i.tiny.tiny.tiny.icon,
.kb-labfront.container i.tiny.tiny.tiny.icons {
  line-height: 1;
  font-size: 0.5em;
}
.kb-labfront.container i.small.small.small.icon,
.kb-labfront.container i.small.small.small.icons {
  line-height: 1;
  font-size: 0.75em;
}
.kb-labfront.container i.icon,
.kb-labfront.container i.icons {
  font-size: 1em;
}
.kb-labfront.container i.large.large.large.icon,
.kb-labfront.container i.large.large.large.icons {
  line-height: 1;
  vertical-align: middle;
  font-size: 1.5em;
}
.kb-labfront.container i.big.big.big.icon,
.kb-labfront.container i.big.big.big.icons {
  line-height: 1;
  vertical-align: middle;
  font-size: 2em;
}
.kb-labfront.container i.huge.huge.huge.icon,
.kb-labfront.container i.huge.huge.huge.icons {
  line-height: 1;
  vertical-align: middle;
  font-size: 4em;
}
.kb-labfront.container i.massive.massive.massive.icon,
.kb-labfront.container i.massive.massive.massive.icons {
  line-height: 1;
  vertical-align: middle;
  font-size: 8em;
}
.kb-labfront.container i.icons {
  display: inline-block;
  position: relative;
  line-height: 1;
}
.kb-labfront.container i.icons .icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  margin: 0;
}
.kb-labfront.container i.icons .icon:first-child {
  position: static;
  width: auto;
  height: auto;
  vertical-align: top;
  transform: none;
}
.kb-labfront.container i.icons .corner.icon {
  top: auto;
  left: auto;
  right: 0;
  bottom: 0;
  transform: none;
  font-size: 0.45em;
  text-shadow: -1px -1px 0 #ffffff, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff;
}
.kb-labfront.container i.icons .icon.corner[class*="top right"] {
  top: 0;
  left: auto;
  right: 0;
  bottom: auto;
}
.kb-labfront.container i.icons .icon.corner[class*="top left"] {
  top: 0;
  left: 0;
  right: auto;
  bottom: auto;
}
.kb-labfront.container i.icons .icon.corner[class*="bottom left"] {
  top: auto;
  left: 0;
  right: auto;
  bottom: 0;
}
.kb-labfront.container i.icons .icon.corner[class*="bottom right"] {
  top: auto;
  left: auto;
  right: 0;
  bottom: 0;
}
.kb-labfront.container i.icons .inverted.corner.icon {
  text-shadow: -1px -1px 0 #1b1c1d, 1px -1px 0 #1b1c1d, -1px 1px 0 #1b1c1d, 1px 1px 0 #1b1c1d;
}
.kb-labfront.container i.icon.linkedin.in:before {
  content: "\\f0e1";
}
.kb-labfront.container i.icon.zoom.in:before {
  content: "\\f00e";
}
.kb-labfront.container i.icon.zoom.out:before {
  content: "\\f010";
}
.kb-labfront.container i.icon.sign.in:before {
  content: "\\f2f6";
}
.kb-labfront.container i.icon.in.cart:before {
  content: "\\f218";
}
.kb-labfront.container i.icon.log.out:before {
  content: "\\f2f5";
}
.kb-labfront.container i.icon.sign.out:before {
  content: "\\f2f5";
}
.kb-labfront.container i.icon.ad:before {
  content: "\\f641";
}
.kb-labfront.container i.icon.address.book:before {
  content: "\\f2b9";
}
.kb-labfront.container i.icon.address.card:before {
  content: "\\f2bb";
}
.kb-labfront.container i.icon.adjust:before {
  content: "\\f042";
}
.kb-labfront.container i.icon.air.freshener:before {
  content: "\\f5d0";
}
.kb-labfront.container i.icon.align.center:before {
  content: "\\f037";
}
.kb-labfront.container i.icon.align.justify:before {
  content: "\\f039";
}
.kb-labfront.container i.icon.align.left:before {
  content: "\\f036";
}
.kb-labfront.container i.icon.align.right:before {
  content: "\\f038";
}
.kb-labfront.container i.icon.allergies:before {
  content: "\\f461";
}
.kb-labfront.container i.icon.ambulance:before {
  content: "\\f0f9";
}
.kb-labfront.container i.icon.american.sign.language.interpreting:before {
  content: "\\f2a3";
}
.kb-labfront.container i.icon.anchor:before {
  content: "\\f13d";
}
.kb-labfront.container i.icon.angle.double.down:before {
  content: "\\f103";
}
.kb-labfront.container i.icon.angle.double.left:before {
  content: "\\f100";
}
.kb-labfront.container i.icon.angle.double.right:before {
  content: "\\f101";
}
.kb-labfront.container i.icon.angle.double.up:before {
  content: "\\f102";
}
.kb-labfront.container i.icon.angle.left:before {
  content: "\\f104";
}
.kb-labfront.container i.icon.angle.right:before {
  content: "\\f105";
}
.kb-labfront.container i.icon.angle.up:before {
  content: "\\f106";
}
.kb-labfront.container i.icon.angle.down:before {
  content: "\\f107";
}
.kb-labfront.container i.icon.angry:before {
  content: "\\f556";
}
.kb-labfront.container i.icon.ankh:before {
  content: "\\f644";
}
.kb-labfront.container i.icon.archive:before {
  content: "\\f187";
}
.kb-labfront.container i.icon.archway:before {
  content: "\\f557";
}
.kb-labfront.container i.icon.arrow.alternate.circle.down:before {
  content: "\\f358";
}
.kb-labfront.container i.icon.arrow.alternate.circle.left:before {
  content: "\\f359";
}
.kb-labfront.container i.icon.arrow.alternate.circle.right:before {
  content: "\\f35a";
}
.kb-labfront.container i.icon.arrow.alternate.circle.up:before {
  content: "\\f35b";
}
.kb-labfront.container i.icon.arrow.circle.down:before {
  content: "\\f0ab";
}
.kb-labfront.container i.icon.arrow.circle.left:before {
  content: "\\f0a8";
}
.kb-labfront.container i.icon.arrow.circle.right:before {
  content: "\\f0a9";
}
.kb-labfront.container i.icon.arrow.circle.up:before {
  content: "\\f0aa";
}
.kb-labfront.container i.icon.arrow.down:before {
  content: "\\f063";
}
.kb-labfront.container i.icon.arrow.left:before {
  content: "\\f060";
}
.kb-labfront.container i.icon.arrow.right:before {
  content: "\\f061";
}
.kb-labfront.container i.icon.arrow.up:before {
  content: "\\f062";
}
.kb-labfront.container i.icon.arrows.alternate:before {
  content: "\\f0b2";
}
.kb-labfront.container i.icon.arrows.alternate.horizontal:before {
  content: "\\f337";
}
.kb-labfront.container i.icon.arrows.alternate.vertical:before {
  content: "\\f338";
}
.kb-labfront.container i.icon.assistive.listening.systems:before {
  content: "\\f2a2";
}
.kb-labfront.container i.icon.asterisk:before {
  content: "\\f069";
}
.kb-labfront.container i.icon.at:before {
  content: "\\f1fa";
}
.kb-labfront.container i.icon.atlas:before {
  content: "\\f558";
}
.kb-labfront.container i.icon.atom:before {
  content: "\\f5d2";
}
.kb-labfront.container i.icon.audio.description:before {
  content: "\\f29e";
}
.kb-labfront.container i.icon.award:before {
  content: "\\f559";
}
.kb-labfront.container i.icon.baby:before {
  content: "\\f77c";
}
.kb-labfront.container i.icon.baby.carriage:before {
  content: "\\f77d";
}
.kb-labfront.container i.icon.backspace:before {
  content: "\\f55a";
}
.kb-labfront.container i.icon.backward:before {
  content: "\\f04a";
}
.kb-labfront.container i.icon.bacon:before {
  content: "\\f7e5";
}
.kb-labfront.container i.icon.balance.scale:before {
  content: "\\f24e";
}
.kb-labfront.container i.icon.balance.scale.left:before {
  content: "\\f515";
}
.kb-labfront.container i.icon.balance.scale.right:before {
  content: "\\f516";
}
.kb-labfront.container i.icon.ban:before {
  content: "\\f05e";
}
.kb-labfront.container i.icon.band.aid:before {
  content: "\\f462";
}
.kb-labfront.container i.icon.barcode:before {
  content: "\\f02a";
}
.kb-labfront.container i.icon.bars:before {
  content: "\\f0c9";
}
.kb-labfront.container i.icon.baseball.ball:before {
  content: "\\f433";
}
.kb-labfront.container i.icon.basketball.ball:before {
  content: "\\f434";
}
.kb-labfront.container i.icon.bath:before {
  content: "\\f2cd";
}
.kb-labfront.container i.icon.battery.empty:before {
  content: "\\f244";
}
.kb-labfront.container i.icon.battery.full:before {
  content: "\\f240";
}
.kb-labfront.container i.icon.battery.half:before {
  content: "\\f242";
}
.kb-labfront.container i.icon.battery.quarter:before {
  content: "\\f243";
}
.kb-labfront.container i.icon.battery.three.quarters:before {
  content: "\\f241";
}
.kb-labfront.container i.icon.bed:before {
  content: "\\f236";
}
.kb-labfront.container i.icon.beer:before {
  content: "\\f0fc";
}
.kb-labfront.container i.icon.bell:before {
  content: "\\f0f3";
}
.kb-labfront.container i.icon.bell.slash:before {
  content: "\\f1f6";
}
.kb-labfront.container i.icon.bezier.curve:before {
  content: "\\f55b";
}
.kb-labfront.container i.icon.bible:before {
  content: "\\f647";
}
.kb-labfront.container i.icon.bicycle:before {
  content: "\\f206";
}
.kb-labfront.container i.icon.biking:before {
  content: "\\f84a";
}
.kb-labfront.container i.icon.binoculars:before {
  content: "\\f1e5";
}
.kb-labfront.container i.icon.biohazard:before {
  content: "\\f780";
}
.kb-labfront.container i.icon.birthday.cake:before {
  content: "\\f1fd";
}
.kb-labfront.container i.icon.blender:before {
  content: "\\f517";
}
.kb-labfront.container i.icon.blender.phone:before {
  content: "\\f6b6";
}
.kb-labfront.container i.icon.blind:before {
  content: "\\f29d";
}
.kb-labfront.container i.icon.blog:before {
  content: "\\f781";
}
.kb-labfront.container i.icon.bold:before {
  content: "\\f032";
}
.kb-labfront.container i.icon.bolt:before {
  content: "\\f0e7";
}
.kb-labfront.container i.icon.bomb:before {
  content: "\\f1e2";
}
.kb-labfront.container i.icon.bone:before {
  content: "\\f5d7";
}
.kb-labfront.container i.icon.bong:before {
  content: "\\f55c";
}
.kb-labfront.container i.icon.book:before {
  content: "\\f02d";
}
.kb-labfront.container i.icon.book.dead:before {
  content: "\\f6b7";
}
.kb-labfront.container i.icon.book.medical:before {
  content: "\\f7e6";
}
.kb-labfront.container i.icon.book.open:before {
  content: "\\f518";
}
.kb-labfront.container i.icon.book.reader:before {
  content: "\\f5da";
}
.kb-labfront.container i.icon.bookmark:before {
  content: "\\f02e";
}
.kb-labfront.container i.icon.border.all:before {
  content: "\\f84c";
}
.kb-labfront.container i.icon.border.none:before {
  content: "\\f850";
}
.kb-labfront.container i.icon.border.style:before {
  content: "\\f853";
}
.kb-labfront.container i.icon.bowling.ball:before {
  content: "\\f436";
}
.kb-labfront.container i.icon.box:before {
  content: "\\f466";
}
.kb-labfront.container i.icon.box.open:before {
  content: "\\f49e";
}
.kb-labfront.container i.icon.boxes:before {
  content: "\\f468";
}
.kb-labfront.container i.icon.braille:before {
  content: "\\f2a1";
}
.kb-labfront.container i.icon.brain:before {
  content: "\\f5dc";
}
.kb-labfront.container i.icon.bread.slice:before {
  content: "\\f7ec";
}
.kb-labfront.container i.icon.briefcase:before {
  content: "\\f0b1";
}
.kb-labfront.container i.icon.briefcase.medical:before {
  content: "\\f469";
}
.kb-labfront.container i.icon.broadcast.tower:before {
  content: "\\f519";
}
.kb-labfront.container i.icon.broom:before {
  content: "\\f51a";
}
.kb-labfront.container i.icon.brush:before {
  content: "\\f55d";
}
.kb-labfront.container i.icon.bug:before {
  content: "\\f188";
}
.kb-labfront.container i.icon.building:before {
  content: "\\f1ad";
}
.kb-labfront.container i.icon.bullhorn:before {
  content: "\\f0a1";
}
.kb-labfront.container i.icon.bullseye:before {
  content: "\\f140";
}
.kb-labfront.container i.icon.burn:before {
  content: "\\f46a";
}
.kb-labfront.container i.icon.bus:before {
  content: "\\f207";
}
.kb-labfront.container i.icon.bus.alternate:before {
  content: "\\f55e";
}
.kb-labfront.container i.icon.business.time:before {
  content: "\\f64a";
}
.kb-labfront.container i.icon.calculator:before {
  content: "\\f1ec";
}
.kb-labfront.container i.icon.calendar:before {
  content: "\\f133";
}
.kb-labfront.container i.icon.calendar.alternate:before {
  content: "\\f073";
}
.kb-labfront.container i.icon.calendar.check:before {
  content: "\\f274";
}
.kb-labfront.container i.icon.calendar.day:before {
  content: "\\f783";
}
.kb-labfront.container i.icon.calendar.minus:before {
  content: "\\f272";
}
.kb-labfront.container i.icon.calendar.plus:before {
  content: "\\f271";
}
.kb-labfront.container i.icon.calendar.times:before {
  content: "\\f273";
}
.kb-labfront.container i.icon.calendar.week:before {
  content: "\\f784";
}
.kb-labfront.container i.icon.camera:before {
  content: "\\f030";
}
.kb-labfront.container i.icon.camera.retro:before {
  content: "\\f083";
}
.kb-labfront.container i.icon.campground:before {
  content: "\\f6bb";
}
.kb-labfront.container i.icon.candy.cane:before {
  content: "\\f786";
}
.kb-labfront.container i.icon.cannabis:before {
  content: "\\f55f";
}
.kb-labfront.container i.icon.capsules:before {
  content: "\\f46b";
}
.kb-labfront.container i.icon.car:before {
  content: "\\f1b9";
}
.kb-labfront.container i.icon.car.alternate:before {
  content: "\\f5de";
}
.kb-labfront.container i.icon.car.battery:before {
  content: "\\f5df";
}
.kb-labfront.container i.icon.car.crash:before {
  content: "\\f5e1";
}
.kb-labfront.container i.icon.car.side:before {
  content: "\\f5e4";
}
.kb-labfront.container i.icon.caret.down:before {
  content: "\\f0d7";
}
.kb-labfront.container i.icon.caret.left:before {
  content: "\\f0d9";
}
.kb-labfront.container i.icon.caret.right:before {
  content: "\\f0da";
}
.kb-labfront.container i.icon.caret.square.down:before {
  content: "\\f150";
}
.kb-labfront.container i.icon.caret.square.left:before {
  content: "\\f191";
}
.kb-labfront.container i.icon.caret.square.right:before {
  content: "\\f152";
}
.kb-labfront.container i.icon.caret.square.up:before {
  content: "\\f151";
}
.kb-labfront.container i.icon.caret.up:before {
  content: "\\f0d8";
}
.kb-labfront.container i.icon.carrot:before {
  content: "\\f787";
}
.kb-labfront.container i.icon.cart.arrow.down:before {
  content: "\\f218";
}
.kb-labfront.container i.icon.cart.plus:before {
  content: "\\f217";
}
.kb-labfront.container i.icon.cash.register:before {
  content: "\\f788";
}
.kb-labfront.container i.icon.cat:before {
  content: "\\f6be";
}
.kb-labfront.container i.icon.certificate:before {
  content: "\\f0a3";
}
.kb-labfront.container i.icon.chair:before {
  content: "\\f6c0";
}
.kb-labfront.container i.icon.chalkboard:before {
  content: "\\f51b";
}
.kb-labfront.container i.icon.chalkboard.teacher:before {
  content: "\\f51c";
}
.kb-labfront.container i.icon.charging.station:before {
  content: "\\f5e7";
}
.kb-labfront.container i.icon.chart.area:before {
  content: "\\f1fe";
}
.kb-labfront.container i.icon.chart.bar:before {
  content: "\\f080";
}
.kb-labfront.container i.icon.chart.line:before {
  content: "\\f201";
}
.kb-labfront.container i.icon.chart.pie:before {
  content: "\\f200";
}
.kb-labfront.container i.icon.check:before {
  content: "\\f00c";
}
.kb-labfront.container i.icon.check.circle:before {
  content: "\\f058";
}
.kb-labfront.container i.icon.check.double:before {
  content: "\\f560";
}
.kb-labfront.container i.icon.check.square:before {
  content: "\\f14a";
}
.kb-labfront.container i.icon.cheese:before {
  content: "\\f7ef";
}
.kb-labfront.container i.icon.chess:before {
  content: "\\f439";
}
.kb-labfront.container i.icon.chess.bishop:before {
  content: "\\f43a";
}
.kb-labfront.container i.icon.chess.board:before {
  content: "\\f43c";
}
.kb-labfront.container i.icon.chess.king:before {
  content: "\\f43f";
}
.kb-labfront.container i.icon.chess.knight:before {
  content: "\\f441";
}
.kb-labfront.container i.icon.chess.pawn:before {
  content: "\\f443";
}
.kb-labfront.container i.icon.chess.queen:before {
  content: "\\f445";
}
.kb-labfront.container i.icon.chess.rook:before {
  content: "\\f447";
}
.kb-labfront.container i.icon.chevron.circle.down:before {
  content: "\\f13a";
}
.kb-labfront.container i.icon.chevron.circle.left:before {
  content: "\\f137";
}
.kb-labfront.container i.icon.chevron.circle.right:before {
  content: "\\f138";
}
.kb-labfront.container i.icon.chevron.circle.up:before {
  content: "\\f139";
}
.kb-labfront.container i.icon.chevron.down:before {
  content: "\\f078";
}
.kb-labfront.container i.icon.chevron.left:before {
  content: "\\f053";
}
.kb-labfront.container i.icon.chevron.right:before {
  content: "\\f054";
}
.kb-labfront.container i.icon.chevron.up:before {
  content: "\\f077";
}
.kb-labfront.container i.icon.child:before {
  content: "\\f1ae";
}
.kb-labfront.container i.icon.church:before {
  content: "\\f51d";
}
.kb-labfront.container i.icon.circle:before {
  content: "\\f111";
}
.kb-labfront.container i.icon.circle.notch:before {
  content: "\\f1ce";
}
.kb-labfront.container i.icon.city:before {
  content: "\\f64f";
}
.kb-labfront.container i.icon.clinic.medical:before {
  content: "\\f7f2";
}
.kb-labfront.container i.icon.clipboard:before {
  content: "\\f328";
}
.kb-labfront.container i.icon.clipboard.check:before {
  content: "\\f46c";
}
.kb-labfront.container i.icon.clipboard.list:before {
  content: "\\f46d";
}
.kb-labfront.container i.icon.clock:before {
  content: "\\f017";
}
.kb-labfront.container i.icon.clone:before {
  content: "\\f24d";
}
.kb-labfront.container i.icon.closed.captioning:before {
  content: "\\f20a";
}
.kb-labfront.container i.icon.cloud:before {
  content: "\\f0c2";
}
.kb-labfront.container i.icon.cloud.download.alternate:before {
  content: "\\f381";
}
.kb-labfront.container i.icon.cloud.meatball:before {
  content: "\\f73b";
}
.kb-labfront.container i.icon.cloud.moon:before {
  content: "\\f6c3";
}
.kb-labfront.container i.icon.cloud.moon.rain:before {
  content: "\\f73c";
}
.kb-labfront.container i.icon.cloud.rain:before {
  content: "\\f73d";
}
.kb-labfront.container i.icon.cloud.showers.heavy:before {
  content: "\\f740";
}
.kb-labfront.container i.icon.cloud.sun:before {
  content: "\\f6c4";
}
.kb-labfront.container i.icon.cloud.sun.rain:before {
  content: "\\f743";
}
.kb-labfront.container i.icon.cloud.upload.alternate:before {
  content: "\\f382";
}
.kb-labfront.container i.icon.cocktail:before {
  content: "\\f561";
}
.kb-labfront.container i.icon.code:before {
  content: "\\f121";
}
.kb-labfront.container i.icon.code.branch:before {
  content: "\\f126";
}
.kb-labfront.container i.icon.coffee:before {
  content: "\\f0f4";
}
.kb-labfront.container i.icon.cog:before {
  content: "\\f013";
}
.kb-labfront.container i.icon.cogs:before {
  content: "\\f085";
}
.kb-labfront.container i.icon.coins:before {
  content: "\\f51e";
}
.kb-labfront.container i.icon.columns:before {
  content: "\\f0db";
}
.kb-labfront.container i.icon.comment:before {
  content: "\\f075";
}
.kb-labfront.container i.icon.comment.alternate:before {
  content: "\\f27a";
}
.kb-labfront.container i.icon.comment.dollar:before {
  content: "\\f651";
}
.kb-labfront.container i.icon.comment.dots:before {
  content: "\\f4ad";
}
.kb-labfront.container i.icon.comment.medical:before {
  content: "\\f7f5";
}
.kb-labfront.container i.icon.comment.slash:before {
  content: "\\f4b3";
}
.kb-labfront.container i.icon.comments:before {
  content: "\\f086";
}
.kb-labfront.container i.icon.comments.dollar:before {
  content: "\\f653";
}
.kb-labfront.container i.icon.compact.disc:before {
  content: "\\f51f";
}
.kb-labfront.container i.icon.compass:before {
  content: "\\f14e";
}
.kb-labfront.container i.icon.compress:before {
  content: "\\f066";
}
.kb-labfront.container i.icon.compress.arrows.alternate:before {
  content: "\\f78c";
}
.kb-labfront.container i.icon.concierge.bell:before {
  content: "\\f562";
}
.kb-labfront.container i.icon.cookie:before {
  content: "\\f563";
}
.kb-labfront.container i.icon.cookie.bite:before {
  content: "\\f564";
}
.kb-labfront.container i.icon.copy:before {
  content: "\\f0c5";
}
.kb-labfront.container i.icon.copyright:before {
  content: "\\f1f9";
}
.kb-labfront.container i.icon.couch:before {
  content: "\\f4b8";
}
.kb-labfront.container i.icon.credit.card:before {
  content: "\\f09d";
}
.kb-labfront.container i.icon.crop:before {
  content: "\\f125";
}
.kb-labfront.container i.icon.crop.alternate:before {
  content: "\\f565";
}
.kb-labfront.container i.icon.cross:before {
  content: "\\f654";
}
.kb-labfront.container i.icon.crosshairs:before {
  content: "\\f05b";
}
.kb-labfront.container i.icon.crow:before {
  content: "\\f520";
}
.kb-labfront.container i.icon.crown:before {
  content: "\\f521";
}
.kb-labfront.container i.icon.crutch:before {
  content: "\\f7f7";
}
.kb-labfront.container i.icon.cube:before {
  content: "\\f1b2";
}
.kb-labfront.container i.icon.cubes:before {
  content: "\\f1b3";
}
.kb-labfront.container i.icon.cut:before {
  content: "\\f0c4";
}
.kb-labfront.container i.icon.database:before {
  content: "\\f1c0";
}
.kb-labfront.container i.icon.deaf:before {
  content: "\\f2a4";
}
.kb-labfront.container i.icon.democrat:before {
  content: "\\f747";
}
.kb-labfront.container i.icon.desktop:before {
  content: "\\f108";
}
.kb-labfront.container i.icon.dharmachakra:before {
  content: "\\f655";
}
.kb-labfront.container i.icon.diagnoses:before {
  content: "\\f470";
}
.kb-labfront.container i.icon.dice:before {
  content: "\\f522";
}
.kb-labfront.container i.icon.dice.d20:before {
  content: "\\f6cf";
}
.kb-labfront.container i.icon.dice.d6:before {
  content: "\\f6d1";
}
.kb-labfront.container i.icon.dice.five:before {
  content: "\\f523";
}
.kb-labfront.container i.icon.dice.four:before {
  content: "\\f524";
}
.kb-labfront.container i.icon.dice.one:before {
  content: "\\f525";
}
.kb-labfront.container i.icon.dice.six:before {
  content: "\\f526";
}
.kb-labfront.container i.icon.dice.three:before {
  content: "\\f527";
}
.kb-labfront.container i.icon.dice.two:before {
  content: "\\f528";
}
.kb-labfront.container i.icon.digital.tachograph:before {
  content: "\\f566";
}
.kb-labfront.container i.icon.directions:before {
  content: "\\f5eb";
}
.kb-labfront.container i.icon.divide:before {
  content: "\\f529";
}
.kb-labfront.container i.icon.dizzy:before {
  content: "\\f567";
}
.kb-labfront.container i.icon.dna:before {
  content: "\\f471";
}
.kb-labfront.container i.icon.dog:before {
  content: "\\f6d3";
}
.kb-labfront.container i.icon.dollar.sign:before {
  content: "\\f155";
}
.kb-labfront.container i.icon.dolly:before {
  content: "\\f472";
}
.kb-labfront.container i.icon.dolly.flatbed:before {
  content: "\\f474";
}
.kb-labfront.container i.icon.donate:before {
  content: "\\f4b9";
}
.kb-labfront.container i.icon.door.closed:before {
  content: "\\f52a";
}
.kb-labfront.container i.icon.door.open:before {
  content: "\\f52b";
}
.kb-labfront.container i.icon.dot.circle:before {
  content: "\\f192";
}
.kb-labfront.container i.icon.dove:before {
  content: "\\f4ba";
}
.kb-labfront.container i.icon.download:before {
  content: "\\f019";
}
.kb-labfront.container i.icon.drafting.compass:before {
  content: "\\f568";
}
.kb-labfront.container i.icon.dragon:before {
  content: "\\f6d5";
}
.kb-labfront.container i.icon.draw.polygon:before {
  content: "\\f5ee";
}
.kb-labfront.container i.icon.drum:before {
  content: "\\f569";
}
.kb-labfront.container i.icon.drum.steelpan:before {
  content: "\\f56a";
}
.kb-labfront.container i.icon.drumstick.bite:before {
  content: "\\f6d7";
}
.kb-labfront.container i.icon.dumbbell:before {
  content: "\\f44b";
}
.kb-labfront.container i.icon.dumpster:before {
  content: "\\f793";
}
.kb-labfront.container i.icon.dumpster.fire:before {
  content: "\\f794";
}
.kb-labfront.container i.icon.dungeon:before {
  content: "\\f6d9";
}
.kb-labfront.container i.icon.edit:before {
  content: "\\f044";
}
.kb-labfront.container i.icon.egg:before {
  content: "\\f7fb";
}
.kb-labfront.container i.icon.eject:before {
  content: "\\f052";
}
.kb-labfront.container i.icon.ellipsis.horizontal:before {
  content: "\\f141";
}
.kb-labfront.container i.icon.ellipsis.vertical:before {
  content: "\\f142";
}
.kb-labfront.container i.icon.envelope:before {
  content: "\\f0e0";
}
.kb-labfront.container i.icon.envelope.open:before {
  content: "\\f2b6";
}
.kb-labfront.container i.icon.envelope.open.text:before {
  content: "\\f658";
}
.kb-labfront.container i.icon.envelope.square:before {
  content: "\\f199";
}
.kb-labfront.container i.icon.equals:before {
  content: "\\f52c";
}
.kb-labfront.container i.icon.eraser:before {
  content: "\\f12d";
}
.kb-labfront.container i.icon.ethernet:before {
  content: "\\f796";
}
.kb-labfront.container i.icon.euro.sign:before {
  content: "\\f153";
}
.kb-labfront.container i.icon.exchange.alternate:before {
  content: "\\f362";
}
.kb-labfront.container i.icon.exclamation:before {
  content: "\\f12a";
}
.kb-labfront.container i.icon.exclamation.circle:before {
  content: "\\f06a";
}
.kb-labfront.container i.icon.exclamation.triangle:before {
  content: "\\f071";
}
.kb-labfront.container i.icon.expand:before {
  content: "\\f065";
}
.kb-labfront.container i.icon.expand.arrows.alternate:before {
  content: "\\f31e";
}
.kb-labfront.container i.icon.external.alternate:before {
  content: "\\f35d";
}
.kb-labfront.container i.icon.external.link.square.alternate:before {
  content: "\\f360";
}
.kb-labfront.container i.icon.eye:before {
  content: "\\f06e";
}
.kb-labfront.container i.icon.eye.dropper:before {
  content: "\\f1fb";
}
.kb-labfront.container i.icon.eye.slash:before {
  content: "\\f070";
}
.kb-labfront.container i.icon.fan:before {
  content: "\\f863";
}
.kb-labfront.container i.icon.fast.backward:before {
  content: "\\f049";
}
.kb-labfront.container i.icon.fast.forward:before {
  content: "\\f050";
}
.kb-labfront.container i.icon.fax:before {
  content: "\\f1ac";
}
.kb-labfront.container i.icon.feather:before {
  content: "\\f52d";
}
.kb-labfront.container i.icon.feather.alternate:before {
  content: "\\f56b";
}
.kb-labfront.container i.icon.female:before {
  content: "\\f182";
}
.kb-labfront.container i.icon.fighter.jet:before {
  content: "\\f0fb";
}
.kb-labfront.container i.icon.file:before {
  content: "\\f15b";
}
.kb-labfront.container i.icon.file.alternate:before {
  content: "\\f15c";
}
.kb-labfront.container i.icon.file.archive:before {
  content: "\\f1c6";
}
.kb-labfront.container i.icon.file.audio:before {
  content: "\\f1c7";
}
.kb-labfront.container i.icon.file.code:before {
  content: "\\f1c9";
}
.kb-labfront.container i.icon.file.contract:before {
  content: "\\f56c";
}
.kb-labfront.container i.icon.file.csv:before {
  content: "\\f6dd";
}
.kb-labfront.container i.icon.file.download:before {
  content: "\\f56d";
}
.kb-labfront.container i.icon.file.excel:before {
  content: "\\f1c3";
}
.kb-labfront.container i.icon.file.export:before {
  content: "\\f56e";
}
.kb-labfront.container i.icon.file.image:before {
  content: "\\f1c5";
}
.kb-labfront.container i.icon.file.import:before {
  content: "\\f56f";
}
.kb-labfront.container i.icon.file.invoice:before {
  content: "\\f570";
}
.kb-labfront.container i.icon.file.invoice.dollar:before {
  content: "\\f571";
}
.kb-labfront.container i.icon.file.medical:before {
  content: "\\f477";
}
.kb-labfront.container i.icon.file.medical.alternate:before {
  content: "\\f478";
}
.kb-labfront.container i.icon.file.pdf:before {
  content: "\\f1c1";
}
.kb-labfront.container i.icon.file.powerpoint:before {
  content: "\\f1c4";
}
.kb-labfront.container i.icon.file.prescription:before {
  content: "\\f572";
}
.kb-labfront.container i.icon.file.signature:before {
  content: "\\f573";
}
.kb-labfront.container i.icon.file.upload:before {
  content: "\\f574";
}
.kb-labfront.container i.icon.file.video:before {
  content: "\\f1c8";
}
.kb-labfront.container i.icon.file.word:before {
  content: "\\f1c2";
}
.kb-labfront.container i.icon.fill:before {
  content: "\\f575";
}
.kb-labfront.container i.icon.fill.drip:before {
  content: "\\f576";
}
.kb-labfront.container i.icon.film:before {
  content: "\\f008";
}
.kb-labfront.container i.icon.filter:before {
  content: "\\f0b0";
}
.kb-labfront.container i.icon.fingerprint:before {
  content: "\\f577";
}
.kb-labfront.container i.icon.fire:before {
  content: "\\f06d";
}
.kb-labfront.container i.icon.fire.alternate:before {
  content: "\\f7e4";
}
.kb-labfront.container i.icon.fire.extinguisher:before {
  content: "\\f134";
}
.kb-labfront.container i.icon.first.aid:before {
  content: "\\f479";
}
.kb-labfront.container i.icon.fish:before {
  content: "\\f578";
}
.kb-labfront.container i.icon.fist.raised:before {
  content: "\\f6de";
}
.kb-labfront.container i.icon.flag:before {
  content: "\\f024";
}
.kb-labfront.container i.icon.flag.checkered:before {
  content: "\\f11e";
}
.kb-labfront.container i.icon.flag.usa:before {
  content: "\\f74d";
}
.kb-labfront.container i.icon.flask:before {
  content: "\\f0c3";
}
.kb-labfront.container i.icon.flushed:before {
  content: "\\f579";
}
.kb-labfront.container i.icon.folder:before {
  content: "\\f07b";
}
.kb-labfront.container i.icon.folder.minus:before {
  content: "\\f65d";
}
.kb-labfront.container i.icon.folder.open:before {
  content: "\\f07c";
}
.kb-labfront.container i.icon.folder.plus:before {
  content: "\\f65e";
}
.kb-labfront.container i.icon.font:before {
  content: "\\f031";
}
.kb-labfront.container i.icon.football.ball:before {
  content: "\\f44e";
}
.kb-labfront.container i.icon.forward:before {
  content: "\\f04e";
}
.kb-labfront.container i.icon.frog:before {
  content: "\\f52e";
}
.kb-labfront.container i.icon.frown:before {
  content: "\\f119";
}
.kb-labfront.container i.icon.frown.open:before {
  content: "\\f57a";
}
.kb-labfront.container i.icon.fruit-apple:before {
  content: "\\f5d1";
}
.kb-labfront.container i.icon.funnel.dollar:before {
  content: "\\f662";
}
.kb-labfront.container i.icon.futbol:before {
  content: "\\f1e3";
}
.kb-labfront.container i.icon.gamepad:before {
  content: "\\f11b";
}
.kb-labfront.container i.icon.gas.pump:before {
  content: "\\f52f";
}
.kb-labfront.container i.icon.gavel:before {
  content: "\\f0e3";
}
.kb-labfront.container i.icon.gem:before {
  content: "\\f3a5";
}
.kb-labfront.container i.icon.genderless:before {
  content: "\\f22d";
}
.kb-labfront.container i.icon.ghost:before {
  content: "\\f6e2";
}
.kb-labfront.container i.icon.gift:before {
  content: "\\f06b";
}
.kb-labfront.container i.icon.gifts:before {
  content: "\\f79c";
}
.kb-labfront.container i.icon.glass.cheers:before {
  content: "\\f79f";
}
.kb-labfront.container i.icon.glass.martini:before {
  content: "\\f000";
}
.kb-labfront.container i.icon.glass.martini.alternate:before {
  content: "\\f57b";
}
.kb-labfront.container i.icon.glass.whiskey:before {
  content: "\\f7a0";
}
.kb-labfront.container i.icon.glasses:before {
  content: "\\f530";
}
.kb-labfront.container i.icon.globe:before {
  content: "\\f0ac";
}
.kb-labfront.container i.icon.globe.africa:before {
  content: "\\f57c";
}
.kb-labfront.container i.icon.globe.americas:before {
  content: "\\f57d";
}
.kb-labfront.container i.icon.globe.asia:before {
  content: "\\f57e";
}
.kb-labfront.container i.icon.globe.europe:before {
  content: "\\f7a2";
}
.kb-labfront.container i.icon.golf.ball:before {
  content: "\\f450";
}
.kb-labfront.container i.icon.gopuram:before {
  content: "\\f664";
}
.kb-labfront.container i.icon.graduation.cap:before {
  content: "\\f19d";
}
.kb-labfront.container i.icon.greater.than:before {
  content: "\\f531";
}
.kb-labfront.container i.icon.greater.than.equal:before {
  content: "\\f532";
}
.kb-labfront.container i.icon.grimace:before {
  content: "\\f57f";
}
.kb-labfront.container i.icon.grin:before {
  content: "\\f580";
}
.kb-labfront.container i.icon.grin.alternate:before {
  content: "\\f581";
}
.kb-labfront.container i.icon.grin.beam:before {
  content: "\\f582";
}
.kb-labfront.container i.icon.grin.beam.sweat:before {
  content: "\\f583";
}
.kb-labfront.container i.icon.grin.hearts:before {
  content: "\\f584";
}
.kb-labfront.container i.icon.grin.squint:before {
  content: "\\f585";
}
.kb-labfront.container i.icon.grin.squint.tears:before {
  content: "\\f586";
}
.kb-labfront.container i.icon.grin.stars:before {
  content: "\\f587";
}
.kb-labfront.container i.icon.grin.tears:before {
  content: "\\f588";
}
.kb-labfront.container i.icon.grin.tongue:before {
  content: "\\f589";
}
.kb-labfront.container i.icon.grin.tongue.squint:before {
  content: "\\f58a";
}
.kb-labfront.container i.icon.grin.tongue.wink:before {
  content: "\\f58b";
}
.kb-labfront.container i.icon.grin.wink:before {
  content: "\\f58c";
}
.kb-labfront.container i.icon.grip.horizontal:before {
  content: "\\f58d";
}
.kb-labfront.container i.icon.grip.lines:before {
  content: "\\f7a4";
}
.kb-labfront.container i.icon.grip.lines.vertical:before {
  content: "\\f7a5";
}
.kb-labfront.container i.icon.grip.vertical:before {
  content: "\\f58e";
}
.kb-labfront.container i.icon.guitar:before {
  content: "\\f7a6";
}
.kb-labfront.container i.icon.h.square:before {
  content: "\\f0fd";
}
.kb-labfront.container i.icon.hamburger:before {
  content: "\\f805";
}
.kb-labfront.container i.icon.hammer:before {
  content: "\\f6e3";
}
.kb-labfront.container i.icon.hamsa:before {
  content: "\\f665";
}
.kb-labfront.container i.icon.hand.holding:before {
  content: "\\f4bd";
}
.kb-labfront.container i.icon.hand.holding.heart:before {
  content: "\\f4be";
}
.kb-labfront.container i.icon.hand.holding.usd:before {
  content: "\\f4c0";
}
.kb-labfront.container i.icon.hand.lizard:before {
  content: "\\f258";
}
.kb-labfront.container i.icon.hand.middle.finger:before {
  content: "\\f806";
}
.kb-labfront.container i.icon.hand.paper:before {
  content: "\\f256";
}
.kb-labfront.container i.icon.hand.peace:before {
  content: "\\f25b";
}
.kb-labfront.container i.icon.hand.point.down:before {
  content: "\\f0a7";
}
.kb-labfront.container i.icon.hand.point.left:before {
  content: "\\f0a5";
}
.kb-labfront.container i.icon.hand.point.right:before {
  content: "\\f0a4";
}
.kb-labfront.container i.icon.hand.point.up:before {
  content: "\\f0a6";
}
.kb-labfront.container i.icon.hand.pointer:before {
  content: "\\f25a";
}
.kb-labfront.container i.icon.hand.rock:before {
  content: "\\f255";
}
.kb-labfront.container i.icon.hand.scissors:before {
  content: "\\f257";
}
.kb-labfront.container i.icon.hand.spock:before {
  content: "\\f259";
}
.kb-labfront.container i.icon.hands:before {
  content: "\\f4c2";
}
.kb-labfront.container i.icon.hands.helping:before {
  content: "\\f4c4";
}
.kb-labfront.container i.icon.handshake:before {
  content: "\\f2b5";
}
.kb-labfront.container i.icon.hanukiah:before {
  content: "\\f6e6";
}
.kb-labfront.container i.icon.hard.hat:before {
  content: "\\f807";
}
.kb-labfront.container i.icon.hashtag:before {
  content: "\\f292";
}
.kb-labfront.container i.icon.hat.wizard:before {
  content: "\\f6e8";
}
.kb-labfront.container i.icon.haykal:before {
  content: "\\f666";
}
.kb-labfront.container i.icon.hdd:before {
  content: "\\f0a0";
}
.kb-labfront.container i.icon.heading:before {
  content: "\\f1dc";
}
.kb-labfront.container i.icon.headphones:before {
  content: "\\f025";
}
.kb-labfront.container i.icon.headphones.alternate:before {
  content: "\\f58f";
}
.kb-labfront.container i.icon.headset:before {
  content: "\\f590";
}
.kb-labfront.container i.icon.heart:before {
  content: "\\f004";
}
.kb-labfront.container i.icon.heart.broken:before {
  content: "\\f7a9";
}
.kb-labfront.container i.icon.heartbeat:before {
  content: "\\f21e";
}
.kb-labfront.container i.icon.helicopter:before {
  content: "\\f533";
}
.kb-labfront.container i.icon.highlighter:before {
  content: "\\f591";
}
.kb-labfront.container i.icon.hiking:before {
  content: "\\f6ec";
}
.kb-labfront.container i.icon.hippo:before {
  content: "\\f6ed";
}
.kb-labfront.container i.icon.history:before {
  content: "\\f1da";
}
.kb-labfront.container i.icon.hockey.puck:before {
  content: "\\f453";
}
.kb-labfront.container i.icon.holly.berry:before {
  content: "\\f7aa";
}
.kb-labfront.container i.icon.home:before {
  content: "\\f015";
}
.kb-labfront.container i.icon.horse:before {
  content: "\\f6f0";
}
.kb-labfront.container i.icon.horse.head:before {
  content: "\\f7ab";
}
.kb-labfront.container i.icon.hospital:before {
  content: "\\f0f8";
}
.kb-labfront.container i.icon.hospital.alternate:before {
  content: "\\f47d";
}
.kb-labfront.container i.icon.hospital.symbol:before {
  content: "\\f47e";
}
.kb-labfront.container i.icon.hot.tub:before {
  content: "\\f593";
}
.kb-labfront.container i.icon.hotdog:before {
  content: "\\f80f";
}
.kb-labfront.container i.icon.hotel:before {
  content: "\\f594";
}
.kb-labfront.container i.icon.hourglass:before {
  content: "\\f254";
}
.kb-labfront.container i.icon.hourglass.end:before {
  content: "\\f253";
}
.kb-labfront.container i.icon.hourglass.half:before {
  content: "\\f252";
}
.kb-labfront.container i.icon.hourglass.start:before {
  content: "\\f251";
}
.kb-labfront.container i.icon.house.damage:before {
  content: "\\f6f1";
}
.kb-labfront.container i.icon.hryvnia:before {
  content: "\\f6f2";
}
.kb-labfront.container i.icon.i.cursor:before {
  content: "\\f246";
}
.kb-labfront.container i.icon.ice.cream:before {
  content: "\\f810";
}
.kb-labfront.container i.icon.icicles:before {
  content: "\\f7ad";
}
.kb-labfront.container i.icon.icons:before {
  content: "\\f86d";
}
.kb-labfront.container i.icon.id.badge:before {
  content: "\\f2c1";
}
.kb-labfront.container i.icon.id.card:before {
  content: "\\f2c2";
}
.kb-labfront.container i.icon.id.card.alternate:before {
  content: "\\f47f";
}
.kb-labfront.container i.icon.igloo:before {
  content: "\\f7ae";
}
.kb-labfront.container i.icon.image:before {
  content: "\\f03e";
}
.kb-labfront.container i.icon.images:before {
  content: "\\f302";
}
.kb-labfront.container i.icon.inbox:before {
  content: "\\f01c";
}
.kb-labfront.container i.icon.indent:before {
  content: "\\f03c";
}
.kb-labfront.container i.icon.industry:before {
  content: "\\f275";
}
.kb-labfront.container i.icon.infinity:before {
  content: "\\f534";
}
.kb-labfront.container i.icon.info:before {
  content: "\\f129";
}
.kb-labfront.container i.icon.info.circle:before {
  content: "\\f05a";
}
.kb-labfront.container i.icon.italic:before {
  content: "\\f033";
}
.kb-labfront.container i.icon.jedi:before {
  content: "\\f669";
}
.kb-labfront.container i.icon.joint:before {
  content: "\\f595";
}
.kb-labfront.container i.icon.journal.whills:before {
  content: "\\f66a";
}
.kb-labfront.container i.icon.kaaba:before {
  content: "\\f66b";
}
.kb-labfront.container i.icon.key:before {
  content: "\\f084";
}
.kb-labfront.container i.icon.keyboard:before {
  content: "\\f11c";
}
.kb-labfront.container i.icon.khanda:before {
  content: "\\f66d";
}
.kb-labfront.container i.icon.kiss:before {
  content: "\\f596";
}
.kb-labfront.container i.icon.kiss.beam:before {
  content: "\\f597";
}
.kb-labfront.container i.icon.kiss.wink.heart:before {
  content: "\\f598";
}
.kb-labfront.container i.icon.kiwi.bird:before {
  content: "\\f535";
}
.kb-labfront.container i.icon.landmark:before {
  content: "\\f66f";
}
.kb-labfront.container i.icon.language:before {
  content: "\\f1ab";
}
.kb-labfront.container i.icon.laptop:before {
  content: "\\f109";
}
.kb-labfront.container i.icon.laptop.code:before {
  content: "\\f5fc";
}
.kb-labfront.container i.icon.laptop.medical:before {
  content: "\\f812";
}
.kb-labfront.container i.icon.laugh:before {
  content: "\\f599";
}
.kb-labfront.container i.icon.laugh.beam:before {
  content: "\\f59a";
}
.kb-labfront.container i.icon.laugh.squint:before {
  content: "\\f59b";
}
.kb-labfront.container i.icon.laugh.wink:before {
  content: "\\f59c";
}
.kb-labfront.container i.icon.layer.group:before {
  content: "\\f5fd";
}
.kb-labfront.container i.icon.leaf:before {
  content: "\\f06c";
}
.kb-labfront.container i.icon.lemon:before {
  content: "\\f094";
}
.kb-labfront.container i.icon.less.than:before {
  content: "\\f536";
}
.kb-labfront.container i.icon.less.than.equal:before {
  content: "\\f537";
}
.kb-labfront.container i.icon.level.down.alternate:before {
  content: "\\f3be";
}
.kb-labfront.container i.icon.level.up.alternate:before {
  content: "\\f3bf";
}
.kb-labfront.container i.icon.life.ring:before {
  content: "\\f1cd";
}
.kb-labfront.container i.icon.lightbulb:before {
  content: "\\f0eb";
}
.kb-labfront.container i.icon.linkify:before {
  content: "\\f0c1";
}
.kb-labfront.container i.icon.lira.sign:before {
  content: "\\f195";
}
.kb-labfront.container i.icon.list:before {
  content: "\\f03a";
}
.kb-labfront.container i.icon.list.alternate:before {
  content: "\\f022";
}
.kb-labfront.container i.icon.list.ol:before {
  content: "\\f0cb";
}
.kb-labfront.container i.icon.list.ul:before {
  content: "\\f0ca";
}
.kb-labfront.container i.icon.location.arrow:before {
  content: "\\f124";
}
.kb-labfront.container i.icon.lock:before {
  content: "\\f023";
}
.kb-labfront.container i.icon.lock.open:before {
  content: "\\f3c1";
}
.kb-labfront.container i.icon.long.arrow.alternate.down:before {
  content: "\\f309";
}
.kb-labfront.container i.icon.long.arrow.alternate.left:before {
  content: "\\f30a";
}
.kb-labfront.container i.icon.long.arrow.alternate.right:before {
  content: "\\f30b";
}
.kb-labfront.container i.icon.long.arrow.alternate.up:before {
  content: "\\f30c";
}
.kb-labfront.container i.icon.low.vision:before {
  content: "\\f2a8";
}
.kb-labfront.container i.icon.luggage.cart:before {
  content: "\\f59d";
}
.kb-labfront.container i.icon.magic:before {
  content: "\\f0d0";
}
.kb-labfront.container i.icon.magnet:before {
  content: "\\f076";
}
.kb-labfront.container i.icon.mail.bulk:before {
  content: "\\f674";
}
.kb-labfront.container i.icon.male:before {
  content: "\\f183";
}
.kb-labfront.container i.icon.map:before {
  content: "\\f279";
}
.kb-labfront.container i.icon.map.marked:before {
  content: "\\f59f";
}
.kb-labfront.container i.icon.map.marked.alternate:before {
  content: "\\f5a0";
}
.kb-labfront.container i.icon.map.marker:before {
  content: "\\f041";
}
.kb-labfront.container i.icon.map.marker.alternate:before {
  content: "\\f3c5";
}
.kb-labfront.container i.icon.map.pin:before {
  content: "\\f276";
}
.kb-labfront.container i.icon.map.signs:before {
  content: "\\f277";
}
.kb-labfront.container i.icon.marker:before {
  content: "\\f5a1";
}
.kb-labfront.container i.icon.mars:before {
  content: "\\f222";
}
.kb-labfront.container i.icon.mars.double:before {
  content: "\\f227";
}
.kb-labfront.container i.icon.mars.stroke:before {
  content: "\\f229";
}
.kb-labfront.container i.icon.mars.stroke.horizontal:before {
  content: "\\f22b";
}
.kb-labfront.container i.icon.mars.stroke.vertical:before {
  content: "\\f22a";
}
.kb-labfront.container i.icon.mask:before {
  content: "\\f6fa";
}
.kb-labfront.container i.icon.medal:before {
  content: "\\f5a2";
}
.kb-labfront.container i.icon.medkit:before {
  content: "\\f0fa";
}
.kb-labfront.container i.icon.meh:before {
  content: "\\f11a";
}
.kb-labfront.container i.icon.meh.blank:before {
  content: "\\f5a4";
}
.kb-labfront.container i.icon.meh.rolling.eyes:before {
  content: "\\f5a5";
}
.kb-labfront.container i.icon.memory:before {
  content: "\\f538";
}
.kb-labfront.container i.icon.menorah:before {
  content: "\\f676";
}
.kb-labfront.container i.icon.mercury:before {
  content: "\\f223";
}
.kb-labfront.container i.icon.meteor:before {
  content: "\\f753";
}
.kb-labfront.container i.icon.microchip:before {
  content: "\\f2db";
}
.kb-labfront.container i.icon.microphone:before {
  content: "\\f130";
}
.kb-labfront.container i.icon.microphone.alternate:before {
  content: "\\f3c9";
}
.kb-labfront.container i.icon.microphone.alternate.slash:before {
  content: "\\f539";
}
.kb-labfront.container i.icon.microphone.slash:before {
  content: "\\f131";
}
.kb-labfront.container i.icon.microscope:before {
  content: "\\f610";
}
.kb-labfront.container i.icon.minus:before {
  content: "\\f068";
}
.kb-labfront.container i.icon.minus.circle:before {
  content: "\\f056";
}
.kb-labfront.container i.icon.minus.square:before {
  content: "\\f146";
}
.kb-labfront.container i.icon.mitten:before {
  content: "\\f7b5";
}
.kb-labfront.container i.icon.mobile:before {
  content: "\\f10b";
}
.kb-labfront.container i.icon.mobile.alternate:before {
  content: "\\f3cd";
}
.kb-labfront.container i.icon.money.bill:before {
  content: "\\f0d6";
}
.kb-labfront.container i.icon.money.bill.alternate:before {
  content: "\\f3d1";
}
.kb-labfront.container i.icon.money.bill.wave:before {
  content: "\\f53a";
}
.kb-labfront.container i.icon.money.bill.wave.alternate:before {
  content: "\\f53b";
}
.kb-labfront.container i.icon.money.check:before {
  content: "\\f53c";
}
.kb-labfront.container i.icon.money.check.alternate:before {
  content: "\\f53d";
}
.kb-labfront.container i.icon.monument:before {
  content: "\\f5a6";
}
.kb-labfront.container i.icon.moon:before {
  content: "\\f186";
}
.kb-labfront.container i.icon.mortar.pestle:before {
  content: "\\f5a7";
}
.kb-labfront.container i.icon.mosque:before {
  content: "\\f678";
}
.kb-labfront.container i.icon.motorcycle:before {
  content: "\\f21c";
}
.kb-labfront.container i.icon.mountain:before {
  content: "\\f6fc";
}
.kb-labfront.container i.icon.mouse.pointer:before {
  content: "\\f245";
}
.kb-labfront.container i.icon.mug.hot:before {
  content: "\\f7b6";
}
.kb-labfront.container i.icon.music:before {
  content: "\\f001";
}
.kb-labfront.container i.icon.network.wired:before {
  content: "\\f6ff";
}
.kb-labfront.container i.icon.neuter:before {
  content: "\\f22c";
}
.kb-labfront.container i.icon.newspaper:before {
  content: "\\f1ea";
}
.kb-labfront.container i.icon.not.equal:before {
  content: "\\f53e";
}
.kb-labfront.container i.icon.notes.medical:before {
  content: "\\f481";
}
.kb-labfront.container i.icon.object.group:before {
  content: "\\f247";
}
.kb-labfront.container i.icon.object.ungroup:before {
  content: "\\f248";
}
.kb-labfront.container i.icon.oil.can:before {
  content: "\\f613";
}
.kb-labfront.container i.icon.om:before {
  content: "\\f679";
}
.kb-labfront.container i.icon.otter:before {
  content: "\\f700";
}
.kb-labfront.container i.icon.outdent:before {
  content: "\\f03b";
}
.kb-labfront.container i.icon.pager:before {
  content: "\\f815";
}
.kb-labfront.container i.icon.paint.brush:before {
  content: "\\f1fc";
}
.kb-labfront.container i.icon.paint.roller:before {
  content: "\\f5aa";
}
.kb-labfront.container i.icon.palette:before {
  content: "\\f53f";
}
.kb-labfront.container i.icon.pallet:before {
  content: "\\f482";
}
.kb-labfront.container i.icon.paper.plane:before {
  content: "\\f1d8";
}
.kb-labfront.container i.icon.paperclip:before {
  content: "\\f0c6";
}
.kb-labfront.container i.icon.parachute.box:before {
  content: "\\f4cd";
}
.kb-labfront.container i.icon.paragraph:before {
  content: "\\f1dd";
}
.kb-labfront.container i.icon.parking:before {
  content: "\\f540";
}
.kb-labfront.container i.icon.passport:before {
  content: "\\f5ab";
}
.kb-labfront.container i.icon.pastafarianism:before {
  content: "\\f67b";
}
.kb-labfront.container i.icon.paste:before {
  content: "\\f0ea";
}
.kb-labfront.container i.icon.pause:before {
  content: "\\f04c";
}
.kb-labfront.container i.icon.pause.circle:before {
  content: "\\f28b";
}
.kb-labfront.container i.icon.paw:before {
  content: "\\f1b0";
}
.kb-labfront.container i.icon.peace:before {
  content: "\\f67c";
}
.kb-labfront.container i.icon.pen:before {
  content: "\\f304";
}
.kb-labfront.container i.icon.pen.alternate:before {
  content: "\\f305";
}
.kb-labfront.container i.icon.pen.fancy:before {
  content: "\\f5ac";
}
.kb-labfront.container i.icon.pen.nib:before {
  content: "\\f5ad";
}
.kb-labfront.container i.icon.pen.square:before {
  content: "\\f14b";
}
.kb-labfront.container i.icon.pencil.alternate:before {
  content: "\\f303";
}
.kb-labfront.container i.icon.pencil.ruler:before {
  content: "\\f5ae";
}
.kb-labfront.container i.icon.people.carry:before {
  content: "\\f4ce";
}
.kb-labfront.container i.icon.pepper.hot:before {
  content: "\\f816";
}
.kb-labfront.container i.icon.percent:before {
  content: "\\f295";
}
.kb-labfront.container i.icon.percentage:before {
  content: "\\f541";
}
.kb-labfront.container i.icon.person.booth:before {
  content: "\\f756";
}
.kb-labfront.container i.icon.phone:before {
  content: "\\f095";
}
.kb-labfront.container i.icon.phone.alternate:before {
  content: "\\f879";
}
.kb-labfront.container i.icon.phone.slash:before {
  content: "\\f3dd";
}
.kb-labfront.container i.icon.phone.square:before {
  content: "\\f098";
}
.kb-labfront.container i.icon.phone.square.alternate:before {
  content: "\\f87b";
}
.kb-labfront.container i.icon.phone.volume:before {
  content: "\\f2a0";
}
.kb-labfront.container i.icon.photo.video:before {
  content: "\\f87c";
}
.kb-labfront.container i.icon.piggy.bank:before {
  content: "\\f4d3";
}
.kb-labfront.container i.icon.pills:before {
  content: "\\f484";
}
.kb-labfront.container i.icon.pizza.slice:before {
  content: "\\f818";
}
.kb-labfront.container i.icon.place.of.worship:before {
  content: "\\f67f";
}
.kb-labfront.container i.icon.plane:before {
  content: "\\f072";
}
.kb-labfront.container i.icon.plane.arrival:before {
  content: "\\f5af";
}
.kb-labfront.container i.icon.plane.departure:before {
  content: "\\f5b0";
}
.kb-labfront.container i.icon.play:before {
  content: "\\f04b";
}
.kb-labfront.container i.icon.play.circle:before {
  content: "\\f144";
}
.kb-labfront.container i.icon.plug:before {
  content: "\\f1e6";
}
.kb-labfront.container i.icon.plus:before {
  content: "\\f067";
}
.kb-labfront.container i.icon.plus.circle:before {
  content: "\\f055";
}
.kb-labfront.container i.icon.plus.square:before {
  content: "\\f0fe";
}
.kb-labfront.container i.icon.podcast:before {
  content: "\\f2ce";
}
.kb-labfront.container i.icon.poll:before {
  content: "\\f681";
}
.kb-labfront.container i.icon.poll.horizontal:before {
  content: "\\f682";
}
.kb-labfront.container i.icon.poo:before {
  content: "\\f2fe";
}
.kb-labfront.container i.icon.poo.storm:before {
  content: "\\f75a";
}
.kb-labfront.container i.icon.poop:before {
  content: "\\f619";
}
.kb-labfront.container i.icon.portrait:before {
  content: "\\f3e0";
}
.kb-labfront.container i.icon.pound.sign:before {
  content: "\\f154";
}
.kb-labfront.container i.icon.power.off:before {
  content: "\\f011";
}
.kb-labfront.container i.icon.pray:before {
  content: "\\f683";
}
.kb-labfront.container i.icon.praying.hands:before {
  content: "\\f684";
}
.kb-labfront.container i.icon.prescription:before {
  content: "\\f5b1";
}
.kb-labfront.container i.icon.prescription.bottle:before {
  content: "\\f485";
}
.kb-labfront.container i.icon.prescription.bottle.alternate:before {
  content: "\\f486";
}
.kb-labfront.container i.icon.print:before {
  content: "\\f02f";
}
.kb-labfront.container i.icon.procedures:before {
  content: "\\f487";
}
.kb-labfront.container i.icon.project.diagram:before {
  content: "\\f542";
}
.kb-labfront.container i.icon.puzzle.piece:before {
  content: "\\f12e";
}
.kb-labfront.container i.icon.qrcode:before {
  content: "\\f029";
}
.kb-labfront.container i.icon.question:before {
  content: "\\f128";
}
.kb-labfront.container i.icon.question.circle:before {
  content: "\\f059";
}
.kb-labfront.container i.icon.quidditch:before {
  content: "\\f458";
}
.kb-labfront.container i.icon.quote.left:before {
  content: "\\f10d";
}
.kb-labfront.container i.icon.quote.right:before {
  content: "\\f10e";
}
.kb-labfront.container i.icon.quran:before {
  content: "\\f687";
}
.kb-labfront.container i.icon.radiation:before {
  content: "\\f7b9";
}
.kb-labfront.container i.icon.radiation.alternate:before {
  content: "\\f7ba";
}
.kb-labfront.container i.icon.rainbow:before {
  content: "\\f75b";
}
.kb-labfront.container i.icon.random:before {
  content: "\\f074";
}
.kb-labfront.container i.icon.receipt:before {
  content: "\\f543";
}
.kb-labfront.container i.icon.recycle:before {
  content: "\\f1b8";
}
.kb-labfront.container i.icon.redo:before {
  content: "\\f01e";
}
.kb-labfront.container i.icon.redo.alternate:before {
  content: "\\f2f9";
}
.kb-labfront.container i.icon.registered:before {
  content: "\\f25d";
}
.kb-labfront.container i.icon.remove.format:before {
  content: "\\f87d";
}
.kb-labfront.container i.icon.reply:before {
  content: "\\f3e5";
}
.kb-labfront.container i.icon.reply.all:before {
  content: "\\f122";
}
.kb-labfront.container i.icon.republican:before {
  content: "\\f75e";
}
.kb-labfront.container i.icon.restroom:before {
  content: "\\f7bd";
}
.kb-labfront.container i.icon.retweet:before {
  content: "\\f079";
}
.kb-labfront.container i.icon.ribbon:before {
  content: "\\f4d6";
}
.kb-labfront.container i.icon.ring:before {
  content: "\\f70b";
}
.kb-labfront.container i.icon.road:before {
  content: "\\f018";
}
.kb-labfront.container i.icon.robot:before {
  content: "\\f544";
}
.kb-labfront.container i.icon.rocket:before {
  content: "\\f135";
}
.kb-labfront.container i.icon.route:before {
  content: "\\f4d7";
}
.kb-labfront.container i.icon.rss:before {
  content: "\\f09e";
}
.kb-labfront.container i.icon.rss.square:before {
  content: "\\f143";
}
.kb-labfront.container i.icon.ruble.sign:before {
  content: "\\f158";
}
.kb-labfront.container i.icon.ruler:before {
  content: "\\f545";
}
.kb-labfront.container i.icon.ruler.combined:before {
  content: "\\f546";
}
.kb-labfront.container i.icon.ruler.horizontal:before {
  content: "\\f547";
}
.kb-labfront.container i.icon.ruler.vertical:before {
  content: "\\f548";
}
.kb-labfront.container i.icon.running:before {
  content: "\\f70c";
}
.kb-labfront.container i.icon.rupee.sign:before {
  content: "\\f156";
}
.kb-labfront.container i.icon.sad.cry:before {
  content: "\\f5b3";
}
.kb-labfront.container i.icon.sad.tear:before {
  content: "\\f5b4";
}
.kb-labfront.container i.icon.satellite:before {
  content: "\\f7bf";
}
.kb-labfront.container i.icon.satellite.dish:before {
  content: "\\f7c0";
}
.kb-labfront.container i.icon.save:before {
  content: "\\f0c7";
}
.kb-labfront.container i.icon.school:before {
  content: "\\f549";
}
.kb-labfront.container i.icon.screwdriver:before {
  content: "\\f54a";
}
.kb-labfront.container i.icon.scroll:before {
  content: "\\f70e";
}
.kb-labfront.container i.icon.sd.card:before {
  content: "\\f7c2";
}
.kb-labfront.container i.icon.search:before {
  content: "\\f002";
}
.kb-labfront.container i.icon.search.dollar:before {
  content: "\\f688";
}
.kb-labfront.container i.icon.search.location:before {
  content: "\\f689";
}
.kb-labfront.container i.icon.search.minus:before {
  content: "\\f010";
}
.kb-labfront.container i.icon.search.plus:before {
  content: "\\f00e";
}
.kb-labfront.container i.icon.seedling:before {
  content: "\\f4d8";
}
.kb-labfront.container i.icon.server:before {
  content: "\\f233";
}
.kb-labfront.container i.icon.shapes:before {
  content: "\\f61f";
}
.kb-labfront.container i.icon.share:before {
  content: "\\f064";
}
.kb-labfront.container i.icon.share.alternate:before {
  content: "\\f1e0";
}
.kb-labfront.container i.icon.share.alternate.square:before {
  content: "\\f1e1";
}
.kb-labfront.container i.icon.share.square:before {
  content: "\\f14d";
}
.kb-labfront.container i.icon.shekel.sign:before {
  content: "\\f20b";
}
.kb-labfront.container i.icon.shield.alternate:before {
  content: "\\f3ed";
}
.kb-labfront.container i.icon.ship:before {
  content: "\\f21a";
}
.kb-labfront.container i.icon.shipping.fast:before {
  content: "\\f48b";
}
.kb-labfront.container i.icon.shoe.prints:before {
  content: "\\f54b";
}
.kb-labfront.container i.icon.shopping.bag:before {
  content: "\\f290";
}
.kb-labfront.container i.icon.shopping.basket:before {
  content: "\\f291";
}
.kb-labfront.container i.icon.shopping.cart:before {
  content: "\\f07a";
}
.kb-labfront.container i.icon.shower:before {
  content: "\\f2cc";
}
.kb-labfront.container i.icon.shuttle.van:before {
  content: "\\f5b6";
}
.kb-labfront.container i.icon.sign:before {
  content: "\\f4d9";
}
.kb-labfront.container i.icon.sign.in.alternate:before {
  content: "\\f2f6";
}
.kb-labfront.container i.icon.sign.language:before {
  content: "\\f2a7";
}
.kb-labfront.container i.icon.sign.out.alternate:before {
  content: "\\f2f5";
}
.kb-labfront.container i.icon.signal:before {
  content: "\\f012";
}
.kb-labfront.container i.icon.signature:before {
  content: "\\f5b7";
}
.kb-labfront.container i.icon.sim.card:before {
  content: "\\f7c4";
}
.kb-labfront.container i.icon.sitemap:before {
  content: "\\f0e8";
}
.kb-labfront.container i.icon.skating:before {
  content: "\\f7c5";
}
.kb-labfront.container i.icon.skiing:before {
  content: "\\f7c9";
}
.kb-labfront.container i.icon.skiing.nordic:before {
  content: "\\f7ca";
}
.kb-labfront.container i.icon.skull:before {
  content: "\\f54c";
}
.kb-labfront.container i.icon.skull.crossbones:before {
  content: "\\f714";
}
.kb-labfront.container i.icon.slash:before {
  content: "\\f715";
}
.kb-labfront.container i.icon.sleigh:before {
  content: "\\f7cc";
}
.kb-labfront.container i.icon.sliders.horizontal:before {
  content: "\\f1de";
}
.kb-labfront.container i.icon.smile:before {
  content: "\\f118";
}
.kb-labfront.container i.icon.smile.beam:before {
  content: "\\f5b8";
}
.kb-labfront.container i.icon.smile.wink:before {
  content: "\\f4da";
}
.kb-labfront.container i.icon.smog:before {
  content: "\\f75f";
}
.kb-labfront.container i.icon.smoking:before {
  content: "\\f48d";
}
.kb-labfront.container i.icon.smoking.ban:before {
  content: "\\f54d";
}
.kb-labfront.container i.icon.sms:before {
  content: "\\f7cd";
}
.kb-labfront.container i.icon.snowboarding:before {
  content: "\\f7ce";
}
.kb-labfront.container i.icon.snowflake:before {
  content: "\\f2dc";
}
.kb-labfront.container i.icon.snowman:before {
  content: "\\f7d0";
}
.kb-labfront.container i.icon.snowplow:before {
  content: "\\f7d2";
}
.kb-labfront.container i.icon.socks:before {
  content: "\\f696";
}
.kb-labfront.container i.icon.solar.panel:before {
  content: "\\f5ba";
}
.kb-labfront.container i.icon.sort:before {
  content: "\\f0dc";
}
.kb-labfront.container i.icon.sort.alphabet.down:before {
  content: "\\f15d";
}
.kb-labfront.container i.icon.sort.alphabet.down.alternate:before {
  content: "\\f881";
}
.kb-labfront.container i.icon.sort.alphabet.up:before {
  content: "\\f15e";
}
.kb-labfront.container i.icon.sort.alphabet.up.alternate:before {
  content: "\\f882";
}
.kb-labfront.container i.icon.sort.amount.down:before {
  content: "\\f160";
}
.kb-labfront.container i.icon.sort.amount.down.alternate:before {
  content: "\\f884";
}
.kb-labfront.container i.icon.sort.amount.up:before {
  content: "\\f161";
}
.kb-labfront.container i.icon.sort.amount.up.alternate:before {
  content: "\\f885";
}
.kb-labfront.container i.icon.sort.down:before {
  content: "\\f0dd";
}
.kb-labfront.container i.icon.sort.numeric.down:before {
  content: "\\f162";
}
.kb-labfront.container i.icon.sort.numeric.down.alternate:before {
  content: "\\f886";
}
.kb-labfront.container i.icon.sort.numeric.up:before {
  content: "\\f163";
}
.kb-labfront.container i.icon.sort.numeric.up.alternate:before {
  content: "\\f887";
}
.kb-labfront.container i.icon.sort.up:before {
  content: "\\f0de";
}
.kb-labfront.container i.icon.spa:before {
  content: "\\f5bb";
}
.kb-labfront.container i.icon.space.shuttle:before {
  content: "\\f197";
}
.kb-labfront.container i.icon.spell.check:before {
  content: "\\f891";
}
.kb-labfront.container i.icon.spider:before {
  content: "\\f717";
}
.kb-labfront.container i.icon.spinner:before {
  content: "\\f110";
}
.kb-labfront.container i.icon.splotch:before {
  content: "\\f5bc";
}
.kb-labfront.container i.icon.spray.can:before {
  content: "\\f5bd";
}
.kb-labfront.container i.icon.square:before {
  content: "\\f0c8";
}
.kb-labfront.container i.icon.square.full:before {
  content: "\\f45c";
}
.kb-labfront.container i.icon.square.root.alternate:before {
  content: "\\f698";
}
.kb-labfront.container i.icon.stamp:before {
  content: "\\f5bf";
}
.kb-labfront.container i.icon.star:before {
  content: "\\f005";
}
.kb-labfront.container i.icon.star.and.crescent:before {
  content: "\\f699";
}
.kb-labfront.container i.icon.star.half:before {
  content: "\\f089";
}
.kb-labfront.container i.icon.star.half.alternate:before {
  content: "\\f5c0";
}
.kb-labfront.container i.icon.star.of.david:before {
  content: "\\f69a";
}
.kb-labfront.container i.icon.star.of.life:before {
  content: "\\f621";
}
.kb-labfront.container i.icon.step.backward:before {
  content: "\\f048";
}
.kb-labfront.container i.icon.step.forward:before {
  content: "\\f051";
}
.kb-labfront.container i.icon.stethoscope:before {
  content: "\\f0f1";
}
.kb-labfront.container i.icon.sticky.note:before {
  content: "\\f249";
}
.kb-labfront.container i.icon.stop:before {
  content: "\\f04d";
}
.kb-labfront.container i.icon.stop.circle:before {
  content: "\\f28d";
}
.kb-labfront.container i.icon.stopwatch:before {
  content: "\\f2f2";
}
.kb-labfront.container i.icon.store:before {
  content: "\\f54e";
}
.kb-labfront.container i.icon.store.alternate:before {
  content: "\\f54f";
}
.kb-labfront.container i.icon.stream:before {
  content: "\\f550";
}
.kb-labfront.container i.icon.street.view:before {
  content: "\\f21d";
}
.kb-labfront.container i.icon.strikethrough:before {
  content: "\\f0cc";
}
.kb-labfront.container i.icon.stroopwafel:before {
  content: "\\f551";
}
.kb-labfront.container i.icon.subscript:before {
  content: "\\f12c";
}
.kb-labfront.container i.icon.subway:before {
  content: "\\f239";
}
.kb-labfront.container i.icon.suitcase:before {
  content: "\\f0f2";
}
.kb-labfront.container i.icon.suitcase.rolling:before {
  content: "\\f5c1";
}
.kb-labfront.container i.icon.sun:before {
  content: "\\f185";
}
.kb-labfront.container i.icon.superscript:before {
  content: "\\f12b";
}
.kb-labfront.container i.icon.surprise:before {
  content: "\\f5c2";
}
.kb-labfront.container i.icon.swatchbook:before {
  content: "\\f5c3";
}
.kb-labfront.container i.icon.swimmer:before {
  content: "\\f5c4";
}
.kb-labfront.container i.icon.swimming.pool:before {
  content: "\\f5c5";
}
.kb-labfront.container i.icon.synagogue:before {
  content: "\\f69b";
}
.kb-labfront.container i.icon.sync:before {
  content: "\\f021";
}
.kb-labfront.container i.icon.sync.alternate:before {
  content: "\\f2f1";
}
.kb-labfront.container i.icon.syringe:before {
  content: "\\f48e";
}
.kb-labfront.container i.icon.table:before {
  content: "\\f0ce";
}
.kb-labfront.container i.icon.table.tennis:before {
  content: "\\f45d";
}
.kb-labfront.container i.icon.tablet:before {
  content: "\\f10a";
}
.kb-labfront.container i.icon.tablet.alternate:before {
  content: "\\f3fa";
}
.kb-labfront.container i.icon.tablets:before {
  content: "\\f490";
}
.kb-labfront.container i.icon.tachometer.alternate:before {
  content: "\\f3fd";
}
.kb-labfront.container i.icon.tag:before {
  content: "\\f02b";
}
.kb-labfront.container i.icon.tags:before {
  content: "\\f02c";
}
.kb-labfront.container i.icon.tape:before {
  content: "\\f4db";
}
.kb-labfront.container i.icon.tasks:before {
  content: "\\f0ae";
}
.kb-labfront.container i.icon.taxi:before {
  content: "\\f1ba";
}
.kb-labfront.container i.icon.teeth:before {
  content: "\\f62e";
}
.kb-labfront.container i.icon.teeth.open:before {
  content: "\\f62f";
}
.kb-labfront.container i.icon.temperature.high:before {
  content: "\\f769";
}
.kb-labfront.container i.icon.temperature.low:before {
  content: "\\f76b";
}
.kb-labfront.container i.icon.tenge:before {
  content: "\\f7d7";
}
.kb-labfront.container i.icon.terminal:before {
  content: "\\f120";
}
.kb-labfront.container i.icon.text.height:before {
  content: "\\f034";
}
.kb-labfront.container i.icon.text.width:before {
  content: "\\f035";
}
.kb-labfront.container i.icon.th:before {
  content: "\\f00a";
}
.kb-labfront.container i.icon.th.large:before {
  content: "\\f009";
}
.kb-labfront.container i.icon.th.list:before {
  content: "\\f00b";
}
.kb-labfront.container i.icon.theater.masks:before {
  content: "\\f630";
}
.kb-labfront.container i.icon.thermometer:before {
  content: "\\f491";
}
.kb-labfront.container i.icon.thermometer.empty:before {
  content: "\\f2cb";
}
.kb-labfront.container i.icon.thermometer.full:before {
  content: "\\f2c7";
}
.kb-labfront.container i.icon.thermometer.half:before {
  content: "\\f2c9";
}
.kb-labfront.container i.icon.thermometer.quarter:before {
  content: "\\f2ca";
}
.kb-labfront.container i.icon.thermometer.three.quarters:before {
  content: "\\f2c8";
}
.kb-labfront.container i.icon.thumbs.down:before {
  content: "\\f165";
}
.kb-labfront.container i.icon.thumbs.up:before {
  content: "\\f164";
}
.kb-labfront.container i.icon.thumbtack:before {
  content: "\\f08d";
}
.kb-labfront.container i.icon.ticket.alternate:before {
  content: "\\f3ff";
}
.kb-labfront.container i.icon.times:before {
  content: "\\f00d";
}
.kb-labfront.container i.icon.times.circle:before {
  content: "\\f057";
}
.kb-labfront.container i.icon.tint:before {
  content: "\\f043";
}
.kb-labfront.container i.icon.tint.slash:before {
  content: "\\f5c7";
}
.kb-labfront.container i.icon.tired:before {
  content: "\\f5c8";
}
.kb-labfront.container i.icon.toggle.off:before {
  content: "\\f204";
}
.kb-labfront.container i.icon.toggle.on:before {
  content: "\\f205";
}
.kb-labfront.container i.icon.toilet:before {
  content: "\\f7d8";
}
.kb-labfront.container i.icon.toilet.paper:before {
  content: "\\f71e";
}
.kb-labfront.container i.icon.toolbox:before {
  content: "\\f552";
}
.kb-labfront.container i.icon.tools:before {
  content: "\\f7d9";
}
.kb-labfront.container i.icon.tooth:before {
  content: "\\f5c9";
}
.kb-labfront.container i.icon.torah:before {
  content: "\\f6a0";
}
.kb-labfront.container i.icon.torii.gate:before {
  content: "\\f6a1";
}
.kb-labfront.container i.icon.tractor:before {
  content: "\\f722";
}
.kb-labfront.container i.icon.trademark:before {
  content: "\\f25c";
}
.kb-labfront.container i.icon.traffic.light:before {
  content: "\\f637";
}
.kb-labfront.container i.icon.train:before {
  content: "\\f238";
}
.kb-labfront.container i.icon.tram:before {
  content: "\\f7da";
}
.kb-labfront.container i.icon.transgender:before {
  content: "\\f224";
}
.kb-labfront.container i.icon.transgender.alternate:before {
  content: "\\f225";
}
.kb-labfront.container i.icon.trash:before {
  content: "\\f1f8";
}
.kb-labfront.container i.icon.trash.alternate:before {
  content: "\\f2ed";
}
.kb-labfront.container i.icon.trash.restore:before {
  content: "\\f829";
}
.kb-labfront.container i.icon.trash.restore.alternate:before {
  content: "\\f82a";
}
.kb-labfront.container i.icon.tree:before {
  content: "\\f1bb";
}
.kb-labfront.container i.icon.trophy:before {
  content: "\\f091";
}
.kb-labfront.container i.icon.truck:before {
  content: "\\f0d1";
}
.kb-labfront.container i.icon.truck.monster:before {
  content: "\\f63b";
}
.kb-labfront.container i.icon.truck.moving:before {
  content: "\\f4df";
}
.kb-labfront.container i.icon.truck.packing:before {
  content: "\\f4de";
}
.kb-labfront.container i.icon.truck.pickup:before {
  content: "\\f63c";
}
.kb-labfront.container i.icon.tshirt:before {
  content: "\\f553";
}
.kb-labfront.container i.icon.tty:before {
  content: "\\f1e4";
}
.kb-labfront.container i.icon.tv:before {
  content: "\\f26c";
}
.kb-labfront.container i.icon.umbrella:before {
  content: "\\f0e9";
}
.kb-labfront.container i.icon.umbrella.beach:before {
  content: "\\f5ca";
}
.kb-labfront.container i.icon.underline:before {
  content: "\\f0cd";
}
.kb-labfront.container i.icon.undo:before {
  content: "\\f0e2";
}
.kb-labfront.container i.icon.undo.alternate:before {
  content: "\\f2ea";
}
.kb-labfront.container i.icon.universal.access:before {
  content: "\\f29a";
}
.kb-labfront.container i.icon.university:before {
  content: "\\f19c";
}
.kb-labfront.container i.icon.unlink:before {
  content: "\\f127";
}
.kb-labfront.container i.icon.unlock:before {
  content: "\\f09c";
}
.kb-labfront.container i.icon.unlock.alternate:before {
  content: "\\f13e";
}
.kb-labfront.container i.icon.upload:before {
  content: "\\f093";
}
.kb-labfront.container i.icon.user:before {
  content: "\\f007";
}
.kb-labfront.container i.icon.user.alternate:before {
  content: "\\f406";
}
.kb-labfront.container i.icon.user.alternate.slash:before {
  content: "\\f4fa";
}
.kb-labfront.container i.icon.user.astronaut:before {
  content: "\\f4fb";
}
.kb-labfront.container i.icon.user.check:before {
  content: "\\f4fc";
}
.kb-labfront.container i.icon.user.circle:before {
  content: "\\f2bd";
}
.kb-labfront.container i.icon.user.clock:before {
  content: "\\f4fd";
}
.kb-labfront.container i.icon.user.cog:before {
  content: "\\f4fe";
}
.kb-labfront.container i.icon.user.edit:before {
  content: "\\f4ff";
}
.kb-labfront.container i.icon.user.friends:before {
  content: "\\f500";
}
.kb-labfront.container i.icon.user.graduate:before {
  content: "\\f501";
}
.kb-labfront.container i.icon.user.injured:before {
  content: "\\f728";
}
.kb-labfront.container i.icon.user.lock:before {
  content: "\\f502";
}
.kb-labfront.container i.icon.user.md:before {
  content: "\\f0f0";
}
.kb-labfront.container i.icon.user.minus:before {
  content: "\\f503";
}
.kb-labfront.container i.icon.user.ninja:before {
  content: "\\f504";
}
.kb-labfront.container i.icon.user.nurse:before {
  content: "\\f82f";
}
.kb-labfront.container i.icon.user.plus:before {
  content: "\\f234";
}
.kb-labfront.container i.icon.user.secret:before {
  content: "\\f21b";
}
.kb-labfront.container i.icon.user.shield:before {
  content: "\\f505";
}
.kb-labfront.container i.icon.user.slash:before {
  content: "\\f506";
}
.kb-labfront.container i.icon.user.tag:before {
  content: "\\f507";
}
.kb-labfront.container i.icon.user.tie:before {
  content: "\\f508";
}
.kb-labfront.container i.icon.user.times:before {
  content: "\\f235";
}
.kb-labfront.container i.icon.users:before {
  content: "\\f0c0";
}
.kb-labfront.container i.icon.users.cog:before {
  content: "\\f509";
}
.kb-labfront.container i.icon.utensil.spoon:before {
  content: "\\f2e5";
}
.kb-labfront.container i.icon.utensils:before {
  content: "\\f2e7";
}
.kb-labfront.container i.icon.vector.square:before {
  content: "\\f5cb";
}
.kb-labfront.container i.icon.venus:before {
  content: "\\f221";
}
.kb-labfront.container i.icon.venus.double:before {
  content: "\\f226";
}
.kb-labfront.container i.icon.venus.mars:before {
  content: "\\f228";
}
.kb-labfront.container i.icon.vial:before {
  content: "\\f492";
}
.kb-labfront.container i.icon.vials:before {
  content: "\\f493";
}
.kb-labfront.container i.icon.video:before {
  content: "\\f03d";
}
.kb-labfront.container i.icon.video.slash:before {
  content: "\\f4e2";
}
.kb-labfront.container i.icon.vihara:before {
  content: "\\f6a7";
}
.kb-labfront.container i.icon.voicemail:before {
  content: "\\f897";
}
.kb-labfront.container i.icon.volleyball.ball:before {
  content: "\\f45f";
}
.kb-labfront.container i.icon.volume.down:before {
  content: "\\f027";
}
.kb-labfront.container i.icon.volume.mute:before {
  content: "\\f6a9";
}
.kb-labfront.container i.icon.volume.off:before {
  content: "\\f026";
}
.kb-labfront.container i.icon.volume.up:before {
  content: "\\f028";
}
.kb-labfront.container i.icon.vote.yea:before {
  content: "\\f772";
}
.kb-labfront.container i.icon.vr.cardboard:before {
  content: "\\f729";
}
.kb-labfront.container i.icon.walking:before {
  content: "\\f554";
}
.kb-labfront.container i.icon.wallet:before {
  content: "\\f555";
}
.kb-labfront.container i.icon.warehouse:before {
  content: "\\f494";
}
.kb-labfront.container i.icon.water:before {
  content: "\\f773";
}
.kb-labfront.container i.icon.wave.square:before {
  content: "\\f83e";
}
.kb-labfront.container i.icon.weight:before {
  content: "\\f496";
}
.kb-labfront.container i.icon.weight.hanging:before {
  content: "\\f5cd";
}
.kb-labfront.container i.icon.wheelchair:before {
  content: "\\f193";
}
.kb-labfront.container i.icon.wifi:before {
  content: "\\f1eb";
}
.kb-labfront.container i.icon.wind:before {
  content: "\\f72e";
}
.kb-labfront.container i.icon.window.close:before {
  content: "\\f410";
}
.kb-labfront.container i.icon.window.maximize:before {
  content: "\\f2d0";
}
.kb-labfront.container i.icon.window.minimize:before {
  content: "\\f2d1";
}
.kb-labfront.container i.icon.window.restore:before {
  content: "\\f2d2";
}
.kb-labfront.container i.icon.wine.bottle:before {
  content: "\\f72f";
}
.kb-labfront.container i.icon.wine.glass:before {
  content: "\\f4e3";
}
.kb-labfront.container i.icon.wine.glass.alternate:before {
  content: "\\f5ce";
}
.kb-labfront.container i.icon.won.sign:before {
  content: "\\f159";
}
.kb-labfront.container i.icon.wrench:before {
  content: "\\f0ad";
}
.kb-labfront.container i.icon.x.ray:before {
  content: "\\f497";
}
.kb-labfront.container i.icon.yen.sign:before {
  content: "\\f157";
}
.kb-labfront.container i.icon.yin.yang:before {
  content: "\\f6ad";
}
.kb-labfront.container i.icon.add:before {
  content: "\\f067";
}
.kb-labfront.container i.icon.add.circle:before {
  content: "\\f055";
}
.kb-labfront.container i.icon.add.square:before {
  content: "\\f0fe";
}
.kb-labfront.container i.icon.add.to.calendar:before {
  content: "\\f271";
}
.kb-labfront.container i.icon.add.to.cart:before {
  content: "\\f217";
}
.kb-labfront.container i.icon.add.user:before {
  content: "\\f234";
}
.kb-labfront.container i.icon.alarm:before {
  content: "\\f0f3";
}
.kb-labfront.container i.icon.alarm.mute:before {
  content: "\\f1f6";
}
.kb-labfront.container i.icon.ald:before {
  content: "\\f2a2";
}
.kb-labfront.container i.icon.als:before {
  content: "\\f2a2";
}
.kb-labfront.container i.icon.announcement:before {
  content: "\\f0a1";
}
.kb-labfront.container i.icon.area.chart:before {
  content: "\\f1fe";
}
.kb-labfront.container i.icon.area.graph:before {
  content: "\\f1fe";
}
.kb-labfront.container i.icon.arrow.down.cart:before {
  content: "\\f218";
}
.kb-labfront.container i.icon.asexual:before {
  content: "\\f22d";
}
.kb-labfront.container i.icon.asl:before {
  content: "\\f2a3";
}
.kb-labfront.container i.icon.asl.interpreting:before {
  content: "\\f2a3";
}
.kb-labfront.container i.icon.assistive.listening.devices:before {
  content: "\\f2a2";
}
.kb-labfront.container i.icon.attach:before {
  content: "\\f0c6";
}
.kb-labfront.container i.icon.attention:before {
  content: "\\f06a";
}
.kb-labfront.container i.icon.balance:before {
  content: "\\f24e";
}
.kb-labfront.container i.icon.bar:before {
  content: "\\f0fc";
}
.kb-labfront.container i.icon.bathtub:before {
  content: "\\f2cd";
}
.kb-labfront.container i.icon.battery.four:before {
  content: "\\f240";
}
.kb-labfront.container i.icon.battery.high:before {
  content: "\\f241";
}
.kb-labfront.container i.icon.battery.low:before {
  content: "\\f243";
}
.kb-labfront.container i.icon.battery.medium:before {
  content: "\\f242";
}
.kb-labfront.container i.icon.battery.one:before {
  content: "\\f243";
}
.kb-labfront.container i.icon.battery.three:before {
  content: "\\f241";
}
.kb-labfront.container i.icon.battery.two:before {
  content: "\\f242";
}
.kb-labfront.container i.icon.battery.zero:before {
  content: "\\f244";
}
.kb-labfront.container i.icon.birthday:before {
  content: "\\f1fd";
}
.kb-labfront.container i.icon.block.layout:before {
  content: "\\f009";
}
.kb-labfront.container i.icon.broken.chain:before {
  content: "\\f127";
}
.kb-labfront.container i.icon.browser:before {
  content: "\\f022";
}
.kb-labfront.container i.icon.call:before {
  content: "\\f095";
}
.kb-labfront.container i.icon.call.square:before {
  content: "\\f098";
}
.kb-labfront.container i.icon.cancel:before {
  content: "\\f00d";
}
.kb-labfront.container i.icon.cart:before {
  content: "\\f07a";
}
.kb-labfront.container i.icon.cc:before {
  content: "\\f20a";
}
.kb-labfront.container i.icon.chain:before {
  content: "\\f0c1";
}
.kb-labfront.container i.icon.chat:before {
  content: "\\f075";
}
.kb-labfront.container i.icon.checked.calendar:before {
  content: "\\f274";
}
.kb-labfront.container i.icon.checkmark:before {
  content: "\\f00c";
}
.kb-labfront.container i.icon.checkmark.box:before {
  content: "\\f14a";
}
.kb-labfront.container i.icon.chess.rock:before {
  content: "\\f447";
}
.kb-labfront.container i.icon.circle.notched:before {
  content: "\\f1ce";
}
.kb-labfront.container i.icon.circle.thin:before {
  content: "\\f111";
}
.kb-labfront.container i.icon.close:before {
  content: "\\f00d";
}
.kb-labfront.container i.icon.cloud.download:before {
  content: "\\f381";
}
.kb-labfront.container i.icon.cloud.upload:before {
  content: "\\f382";
}
.kb-labfront.container i.icon.cny:before {
  content: "\\f157";
}
.kb-labfront.container i.icon.cocktail:before {
  content: "\\f000";
}
.kb-labfront.container i.icon.commenting:before {
  content: "\\f27a";
}
.kb-labfront.container i.icon.compose:before {
  content: "\\f303";
}
.kb-labfront.container i.icon.computer:before {
  content: "\\f108";
}
.kb-labfront.container i.icon.configure:before {
  content: "\\f0ad";
}
.kb-labfront.container i.icon.content:before {
  content: "\\f0c9";
}
.kb-labfront.container i.icon.conversation:before {
  content: "\\f086";
}
.kb-labfront.container i.icon.credit.card.alternative:before {
  content: "\\f09d";
}
.kb-labfront.container i.icon.currency:before {
  content: "\\f3d1";
}
.kb-labfront.container i.icon.dashboard:before {
  content: "\\f3fd";
}
.kb-labfront.container i.icon.deafness:before {
  content: "\\f2a4";
}
.kb-labfront.container i.icon.delete:before {
  content: "\\f00d";
}
.kb-labfront.container i.icon.delete.calendar:before {
  content: "\\f273";
}
.kb-labfront.container i.icon.detective:before {
  content: "\\f21b";
}
.kb-labfront.container i.icon.diamond:before {
  content: "\\f3a5";
}
.kb-labfront.container i.icon.discussions:before {
  content: "\\f086";
}
.kb-labfront.container i.icon.disk:before {
  content: "\\f0a0";
}
.kb-labfront.container i.icon.doctor:before {
  content: "\\f0f0";
}
.kb-labfront.container i.icon.dollar:before {
  content: "\\f155";
}
.kb-labfront.container i.icon.dont:before {
  content: "\\f05e";
}
.kb-labfront.container i.icon.drivers.license:before {
  content: "\\f2c2";
}
.kb-labfront.container i.icon.dropdown:before {
  content: "\\f0d7";
}
.kb-labfront.container i.icon.emergency:before {
  content: "\\f0f9";
}
.kb-labfront.container i.icon.erase:before {
  content: "\\f12d";
}
.kb-labfront.container i.icon.eur:before {
  content: "\\f153";
}
.kb-labfront.container i.icon.euro:before {
  content: "\\f153";
}
.kb-labfront.container i.icon.exchange:before {
  content: "\\f362";
}
.kb-labfront.container i.icon.external:before {
  content: "\\f35d";
}
.kb-labfront.container i.icon.external.share:before {
  content: "\\f14d";
}
.kb-labfront.container i.icon.external.square:before {
  content: "\\f360";
}
.kb-labfront.container i.icon.eyedropper:before {
  content: "\\f1fb";
}
.kb-labfront.container i.icon.factory:before {
  content: "\\f275";
}
.kb-labfront.container i.icon.favorite:before {
  content: "\\f005";
}
.kb-labfront.container i.icon.feed:before {
  content: "\\f09e";
}
.kb-labfront.container i.icon.female.homosexual:before {
  content: "\\f226";
}
.kb-labfront.container i.icon.file.text:before {
  content: "\\f15c";
}
.kb-labfront.container i.icon.find:before {
  content: "\\f1e5";
}
.kb-labfront.container i.icon.first.aid:before {
  content: "\\f0fa";
}
.kb-labfront.container i.icon.food:before {
  content: "\\f2e7";
}
.kb-labfront.container i.icon.fork:before {
  content: "\\f126";
}
.kb-labfront.container i.icon.game:before {
  content: "\\f11b";
}
.kb-labfront.container i.icon.gay:before {
  content: "\\f227";
}
.kb-labfront.container i.icon.gbp:before {
  content: "\\f154";
}
.kb-labfront.container i.icon.grab:before {
  content: "\\f255";
}
.kb-labfront.container i.icon.graduation:before {
  content: "\\f19d";
}
.kb-labfront.container i.icon.grid.layout:before {
  content: "\\f00a";
}
.kb-labfront.container i.icon.group:before {
  content: "\\f0c0";
}
.kb-labfront.container i.icon.h:before {
  content: "\\f0fd";
}
.kb-labfront.container i.icon.hamburger:before {
  content: "\\f0c9";
}
.kb-labfront.container i.icon.hand.victory:before {
  content: "\\f25b";
}
.kb-labfront.container i.icon.handicap:before {
  content: "\\f193";
}
.kb-labfront.container i.icon.hard.of.hearing:before {
  content: "\\f2a4";
}
.kb-labfront.container i.icon.header:before {
  content: "\\f1dc";
}
.kb-labfront.container i.icon.heart.empty:before {
  content: "\\f004";
}
.kb-labfront.container i.icon.help:before {
  content: "\\f128";
}
.kb-labfront.container i.icon.help.circle:before {
  content: "\\f059";
}
.kb-labfront.container i.icon.heterosexual:before {
  content: "\\f228";
}
.kb-labfront.container i.icon.hide:before {
  content: "\\f070";
}
.kb-labfront.container i.icon.hotel:before {
  content: "\\f236";
}
.kb-labfront.container i.icon.hourglass.four:before {
  content: "\\f254";
}
.kb-labfront.container i.icon.hourglass.full:before {
  content: "\\f254";
}
.kb-labfront.container i.icon.hourglass.one:before {
  content: "\\f251";
}
.kb-labfront.container i.icon.hourglass.three:before {
  content: "\\f253";
}
.kb-labfront.container i.icon.hourglass.two:before {
  content: "\\f252";
}
.kb-labfront.container i.icon.hourglass.zero:before {
  content: "\\f253";
}
.kb-labfront.container i.icon.idea:before {
  content: "\\f0eb";
}
.kb-labfront.container i.icon.ils:before {
  content: "\\f20b";
}
.kb-labfront.container i.icon.in.cart:before {
  content: "\\f218";
}
.kb-labfront.container i.icon.inr:before {
  content: "\\f156";
}
.kb-labfront.container i.icon.intergender:before {
  content: "\\f224";
}
.kb-labfront.container i.icon.intersex:before {
  content: "\\f224";
}
.kb-labfront.container i.icon.jpy:before {
  content: "\\f157";
}
.kb-labfront.container i.icon.krw:before {
  content: "\\f159";
}
.kb-labfront.container i.icon.lab:before {
  content: "\\f0c3";
}
.kb-labfront.container i.icon.law:before {
  content: "\\f24e";
}
.kb-labfront.container i.icon.legal:before {
  content: "\\f0e3";
}
.kb-labfront.container i.icon.lesbian:before {
  content: "\\f226";
}
.kb-labfront.container i.icon.level.down:before {
  content: "\\f3be";
}
.kb-labfront.container i.icon.level.up:before {
  content: "\\f3bf";
}
.kb-labfront.container i.icon.lightning:before {
  content: "\\f0e7";
}
.kb-labfront.container i.icon.like:before {
  content: "\\f004";
}
.kb-labfront.container i.icon.line.graph:before {
  content: "\\f201";
}
.kb-labfront.container i.icon.linkify:before {
  content: "\\f0c1";
}
.kb-labfront.container i.icon.lira:before {
  content: "\\f195";
}
.kb-labfront.container i.icon.list.layout:before {
  content: "\\f00b";
}
.kb-labfront.container i.icon.log.out:before {
  content: "\\f2f5";
}
.kb-labfront.container i.icon.magnify:before {
  content: "\\f00e";
}
.kb-labfront.container i.icon.mail:before {
  content: "\\f0e0";
}
.kb-labfront.container i.icon.mail.forward:before {
  content: "\\f064";
}
.kb-labfront.container i.icon.mail.square:before {
  content: "\\f199";
}
.kb-labfront.container i.icon.male.homosexual:before {
  content: "\\f227";
}
.kb-labfront.container i.icon.man:before {
  content: "\\f222";
}
.kb-labfront.container i.icon.marker:before {
  content: "\\f041";
}
.kb-labfront.container i.icon.mars.alternate:before {
  content: "\\f229";
}
.kb-labfront.container i.icon.mars.horizontal:before {
  content: "\\f22b";
}
.kb-labfront.container i.icon.mars.vertical:before {
  content: "\\f22a";
}
.kb-labfront.container i.icon.meanpath:before {
  content: "\\f0c8";
}
.kb-labfront.container i.icon.military:before {
  content: "\\f0fb";
}
.kb-labfront.container i.icon.money:before {
  content: "\\f3d1";
}
.kb-labfront.container i.icon.move:before {
  content: "\\f0b2";
}
.kb-labfront.container i.icon.mute:before {
  content: "\\f131";
}
.kb-labfront.container i.icon.non.binary.transgender:before {
  content: "\\f223";
}
.kb-labfront.container i.icon.numbered.list:before {
  content: "\\f0cb";
}
.kb-labfront.container i.icon.options:before {
  content: "\\f1de";
}
.kb-labfront.container i.icon.ordered.list:before {
  content: "\\f0cb";
}
.kb-labfront.container i.icon.other.gender:before {
  content: "\\f229";
}
.kb-labfront.container i.icon.other.gender.horizontal:before {
  content: "\\f22b";
}
.kb-labfront.container i.icon.other.gender.vertical:before {
  content: "\\f22a";
}
.kb-labfront.container i.icon.payment:before {
  content: "\\f09d";
}
.kb-labfront.container i.icon.pencil:before {
  content: "\\f303";
}
.kb-labfront.container i.icon.pencil.square:before {
  content: "\\f14b";
}
.kb-labfront.container i.icon.photo:before {
  content: "\\f030";
}
.kb-labfront.container i.icon.picture:before {
  content: "\\f03e";
}
.kb-labfront.container i.icon.pie.chart:before {
  content: "\\f200";
}
.kb-labfront.container i.icon.pie.graph:before {
  content: "\\f200";
}
.kb-labfront.container i.icon.pin:before {
  content: "\\f08d";
}
.kb-labfront.container i.icon.plus.cart:before {
  content: "\\f217";
}
.kb-labfront.container i.icon.point:before {
  content: "\\f041";
}
.kb-labfront.container i.icon.pointing.down:before {
  content: "\\f0a7";
}
.kb-labfront.container i.icon.pointing.left:before {
  content: "\\f0a5";
}
.kb-labfront.container i.icon.pointing.right:before {
  content: "\\f0a4";
}
.kb-labfront.container i.icon.pointing.up:before {
  content: "\\f0a6";
}
.kb-labfront.container i.icon.pound:before {
  content: "\\f154";
}
.kb-labfront.container i.icon.power:before {
  content: "\\f011";
}
.kb-labfront.container i.icon.power.cord:before {
  content: "\\f1e6";
}
.kb-labfront.container i.icon.privacy:before {
  content: "\\f084";
}
.kb-labfront.container i.icon.protect:before {
  content: "\\f023";
}
.kb-labfront.container i.icon.puzzle:before {
  content: "\\f12e";
}
.kb-labfront.container i.icon.r.circle:before {
  content: "\\f25d";
}
.kb-labfront.container i.icon.radio:before {
  content: "\\f192";
}
.kb-labfront.container i.icon.rain:before {
  content: "\\f0e9";
}
.kb-labfront.container i.icon.record:before {
  content: "\\f03d";
}
.kb-labfront.container i.icon.refresh:before {
  content: "\\f021";
}
.kb-labfront.container i.icon.remove:before {
  content: "\\f00d";
}
.kb-labfront.container i.icon.remove.bookmark:before {
  content: "\\f02e";
}
.kb-labfront.container i.icon.remove.circle:before {
  content: "\\f057";
}
.kb-labfront.container i.icon.remove.from.calendar:before {
  content: "\\f272";
}
.kb-labfront.container i.icon.remove.user:before {
  content: "\\f235";
}
.kb-labfront.container i.icon.repeat:before {
  content: "\\f01e";
}
.kb-labfront.container i.icon.resize.horizontal:before {
  content: "\\f337";
}
.kb-labfront.container i.icon.resize.vertical:before {
  content: "\\f338";
}
.kb-labfront.container i.icon.rmb:before {
  content: "\\f157";
}
.kb-labfront.container i.icon.rouble:before {
  content: "\\f158";
}
.kb-labfront.container i.icon.rub:before {
  content: "\\f158";
}
.kb-labfront.container i.icon.ruble:before {
  content: "\\f158";
}
.kb-labfront.container i.icon.rupee:before {
  content: "\\f156";
}
.kb-labfront.container i.icon.s15:before {
  content: "\\f2cd";
}
.kb-labfront.container i.icon.selected.radio:before {
  content: "\\f192";
}
.kb-labfront.container i.icon.send:before {
  content: "\\f1d8";
}
.kb-labfront.container i.icon.setting:before {
  content: "\\f013";
}
.kb-labfront.container i.icon.settings:before {
  content: "\\f085";
}
.kb-labfront.container i.icon.shekel:before {
  content: "\\f20b";
}
.kb-labfront.container i.icon.sheqel:before {
  content: "\\f20b";
}
.kb-labfront.container i.icon.shield:before {
  content: "\\f3ed";
}
.kb-labfront.container i.icon.shipping:before {
  content: "\\f0d1";
}
.kb-labfront.container i.icon.shop:before {
  content: "\\f07a";
}
.kb-labfront.container i.icon.shuffle:before {
  content: "\\f074";
}
.kb-labfront.container i.icon.shutdown:before {
  content: "\\f011";
}
.kb-labfront.container i.icon.sidebar:before {
  content: "\\f0c9";
}
.kb-labfront.container i.icon.sign.in:before {
  content: "\\f2f6";
}
.kb-labfront.container i.icon.sign.out:before {
  content: "\\f2f5";
}
.kb-labfront.container i.icon.signing:before {
  content: "\\f2a7";
}
.kb-labfront.container i.icon.signup:before {
  content: "\\f044";
}
.kb-labfront.container i.icon.sliders:before {
  content: "\\f1de";
}
.kb-labfront.container i.icon.soccer:before {
  content: "\\f1e3";
}
.kb-labfront.container i.icon.sort.alphabet.ascending:before {
  content: "\\f15d";
}
.kb-labfront.container i.icon.sort.alphabet.descending:before {
  content: "\\f15e";
}
.kb-labfront.container i.icon.sort.ascending:before {
  content: "\\f0de";
}
.kb-labfront.container i.icon.sort.content.ascending:before {
  content: "\\f160";
}
.kb-labfront.container i.icon.sort.content.descending:before {
  content: "\\f161";
}
.kb-labfront.container i.icon.sort.descending:before {
  content: "\\f0dd";
}
.kb-labfront.container i.icon.sort.numeric.ascending:before {
  content: "\\f162";
}
.kb-labfront.container i.icon.sort.numeric.descending:before {
  content: "\\f163";
}
.kb-labfront.container i.icon.sound:before {
  content: "\\f025";
}
.kb-labfront.container i.icon.spoon:before {
  content: "\\f2e5";
}
.kb-labfront.container i.icon.spy:before {
  content: "\\f21b";
}
.kb-labfront.container i.icon.star.empty:before {
  content: "\\f005";
}
.kb-labfront.container i.icon.star.half.empty:before {
  content: "\\f089";
}
.kb-labfront.container i.icon.star.half.full:before {
  content: "\\f089";
}
.kb-labfront.container i.icon.student:before {
  content: "\\f19d";
}
.kb-labfront.container i.icon.talk:before {
  content: "\\f27a";
}
.kb-labfront.container i.icon.target:before {
  content: "\\f140";
}
.kb-labfront.container i.icon.teletype:before {
  content: "\\f1e4";
}
.kb-labfront.container i.icon.television:before {
  content: "\\f26c";
}
.kb-labfront.container i.icon.text.cursor:before {
  content: "\\f246";
}
.kb-labfront.container i.icon.text.telephone:before {
  content: "\\f1e4";
}
.kb-labfront.container i.icon.theme:before {
  content: "\\f043";
}
.kb-labfront.container i.icon.thermometer:before {
  content: "\\f2c7";
}
.kb-labfront.container i.icon.thumb.tack:before {
  content: "\\f08d";
}
.kb-labfront.container i.icon.ticket:before {
  content: "\\f3ff";
}
.kb-labfront.container i.icon.time:before {
  content: "\\f017";
}
.kb-labfront.container i.icon.times.rectangle:before {
  content: "\\f410";
}
.kb-labfront.container i.icon.tm:before {
  content: "\\f25c";
}
.kb-labfront.container i.icon.toggle.down:before {
  content: "\\f150";
}
.kb-labfront.container i.icon.toggle.left:before {
  content: "\\f191";
}
.kb-labfront.container i.icon.toggle.right:before {
  content: "\\f152";
}
.kb-labfront.container i.icon.toggle.up:before {
  content: "\\f151";
}
.kb-labfront.container i.icon.translate:before {
  content: "\\f1ab";
}
.kb-labfront.container i.icon.travel:before {
  content: "\\f0b1";
}
.kb-labfront.container i.icon.treatment:before {
  content: "\\f0f1";
}
.kb-labfront.container i.icon.triangle.down:before {
  content: "\\f0d7";
}
.kb-labfront.container i.icon.triangle.left:before {
  content: "\\f0d9";
}
.kb-labfront.container i.icon.triangle.right:before {
  content: "\\f0da";
}
.kb-labfront.container i.icon.triangle.up:before {
  content: "\\f0d8";
}
.kb-labfront.container i.icon.try:before {
  content: "\\f195";
}
.kb-labfront.container i.icon.unhide:before {
  content: "\\f06e";
}
.kb-labfront.container i.icon.unlinkify:before {
  content: "\\f127";
}
.kb-labfront.container i.icon.unmute:before {
  content: "\\f130";
}
.kb-labfront.container i.icon.unordered.list:before {
  content: "\\f0ca";
}
.kb-labfront.container i.icon.usd:before {
  content: "\\f155";
}
.kb-labfront.container i.icon.user.cancel:before {
  content: "\\f235";
}
.kb-labfront.container i.icon.user.close:before {
  content: "\\f235";
}
.kb-labfront.container i.icon.user.delete:before {
  content: "\\f235";
}
.kb-labfront.container i.icon.user.doctor:before {
  content: "\\f0f0";
}
.kb-labfront.container i.icon.user.x:before {
  content: "\\f235";
}
.kb-labfront.container i.icon.vcard:before {
  content: "\\f2bb";
}
.kb-labfront.container i.icon.video.camera:before {
  content: "\\f03d";
}
.kb-labfront.container i.icon.video.play:before {
  content: "\\f144";
}
.kb-labfront.container i.icon.volume.control.phone:before {
  content: "\\f2a0";
}
.kb-labfront.container i.icon.wait:before {
  content: "\\f017";
}
.kb-labfront.container i.icon.warning:before {
  content: "\\f12a";
}
.kb-labfront.container i.icon.warning.circle:before {
  content: "\\f06a";
}
.kb-labfront.container i.icon.warning.sign:before {
  content: "\\f071";
}
.kb-labfront.container i.icon.wi.fi:before {
  content: "\\f1eb";
}
.kb-labfront.container i.icon.winner:before {
  content: "\\f091";
}
.kb-labfront.container i.icon.wizard:before {
  content: "\\f0d0";
}
.kb-labfront.container i.icon.woman:before {
  content: "\\f221";
}
.kb-labfront.container i.icon.won:before {
  content: "\\f159";
}
.kb-labfront.container i.icon.world:before {
  content: "\\f0ac";
}
.kb-labfront.container i.icon.write:before {
  content: "\\f303";
}
.kb-labfront.container i.icon.write.square:before {
  content: "\\f14b";
}
.kb-labfront.container i.icon.x:before {
  content: "\\f00d";
}
.kb-labfront.container i.icon.yen:before {
  content: "\\f157";
}
.kb-labfront.container i.icon.zip:before {
  content: "\\f187";
}
.kb-labfront.container i.icon.zoom:before {
  content: "\\f00e";
}
.kb-labfront.container i.icon.zoom.in:before {
  content: "\\f00e";
}
.kb-labfront.container i.icon.zoom.out:before {
  content: "\\f010";
}
@font-face {
  font-family: "outline-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("svg");
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-decoration: inherit;
  text-transform: none;
}
.kb-labfront.container i.icon.outline {
  font-family: "outline-icons";
}
.kb-labfront.container i.icon.address.book.outline:before {
  content: "\\f2b9";
}
.kb-labfront.container i.icon.address.card.outline:before {
  content: "\\f2bb";
}
.kb-labfront.container i.icon.angry.outline:before {
  content: "\\f556";
}
.kb-labfront.container i.icon.arrow.alternate.circle.down.outline:before {
  content: "\\f358";
}
.kb-labfront.container i.icon.arrow.alternate.circle.left.outline:before {
  content: "\\f359";
}
.kb-labfront.container i.icon.arrow.alternate.circle.right.outline:before {
  content: "\\f35a";
}
.kb-labfront.container i.icon.arrow.alternate.circle.up.outline:before {
  content: "\\f35b";
}
.kb-labfront.container i.icon.bell.outline:before {
  content: "\\f0f3";
}
.kb-labfront.container i.icon.bell.slash.outline:before {
  content: "\\f1f6";
}
.kb-labfront.container i.icon.bookmark.outline:before {
  content: "\\f02e";
}
.kb-labfront.container i.icon.building.outline:before {
  content: "\\f1ad";
}
.kb-labfront.container i.icon.calendar.alternate.outline:before {
  content: "\\f073";
}
.kb-labfront.container i.icon.calendar.check.outline:before {
  content: "\\f274";
}
.kb-labfront.container i.icon.calendar.minus.outline:before {
  content: "\\f272";
}
.kb-labfront.container i.icon.calendar.outline:before {
  content: "\\f133";
}
.kb-labfront.container i.icon.calendar.plus.outline:before {
  content: "\\f271";
}
.kb-labfront.container i.icon.calendar.times.outline:before {
  content: "\\f273";
}
.kb-labfront.container i.icon.caret.square.down.outline:before {
  content: "\\f150";
}
.kb-labfront.container i.icon.caret.square.left.outline:before {
  content: "\\f191";
}
.kb-labfront.container i.icon.caret.square.right.outline:before {
  content: "\\f152";
}
.kb-labfront.container i.icon.caret.square.up.outline:before {
  content: "\\f151";
}
.kb-labfront.container i.icon.chart.bar.outline:before {
  content: "\\f080";
}
.kb-labfront.container i.icon.check.circle.outline:before {
  content: "\\f058";
}
.kb-labfront.container i.icon.check.square.outline:before {
  content: "\\f14a";
}
.kb-labfront.container i.icon.circle.outline:before {
  content: "\\f111";
}
.kb-labfront.container i.icon.clipboard.outline:before {
  content: "\\f328";
}
.kb-labfront.container i.icon.clock.outline:before {
  content: "\\f017";
}
.kb-labfront.container i.icon.clone.outline:before {
  content: "\\f24d";
}
.kb-labfront.container i.icon.closed.captioning.outline:before {
  content: "\\f20a";
}
.kb-labfront.container i.icon.comment.alternate.outline:before {
  content: "\\f27a";
}
.kb-labfront.container i.icon.comment.dots.outline:before {
  content: "\\f4ad";
}
.kb-labfront.container i.icon.comment.outline:before {
  content: "\\f075";
}
.kb-labfront.container i.icon.comments.outline:before {
  content: "\\f086";
}
.kb-labfront.container i.icon.compass.outline:before {
  content: "\\f14e";
}
.kb-labfront.container i.icon.copy.outline:before {
  content: "\\f0c5";
}
.kb-labfront.container i.icon.copyright.outline:before {
  content: "\\f1f9";
}
.kb-labfront.container i.icon.credit.card.outline:before {
  content: "\\f09d";
}
.kb-labfront.container i.icon.dizzy.outline:before {
  content: "\\f567";
}
.kb-labfront.container i.icon.dot.circle.outline:before {
  content: "\\f192";
}
.kb-labfront.container i.icon.edit.outline:before {
  content: "\\f044";
}
.kb-labfront.container i.icon.envelope.open.outline:before {
  content: "\\f2b6";
}
.kb-labfront.container i.icon.envelope.outline:before {
  content: "\\f0e0";
}
.kb-labfront.container i.icon.eye.outline:before {
  content: "\\f06e";
}
.kb-labfront.container i.icon.eye.slash.outline:before {
  content: "\\f070";
}
.kb-labfront.container i.icon.file.alternate.outline:before {
  content: "\\f15c";
}
.kb-labfront.container i.icon.file.archive.outline:before {
  content: "\\f1c6";
}
.kb-labfront.container i.icon.file.audio.outline:before {
  content: "\\f1c7";
}
.kb-labfront.container i.icon.file.code.outline:before {
  content: "\\f1c9";
}
.kb-labfront.container i.icon.file.excel.outline:before {
  content: "\\f1c3";
}
.kb-labfront.container i.icon.file.image.outline:before {
  content: "\\f1c5";
}
.kb-labfront.container i.icon.file.outline:before {
  content: "\\f15b";
}
.kb-labfront.container i.icon.file.pdf.outline:before {
  content: "\\f1c1";
}
.kb-labfront.container i.icon.file.powerpoint.outline:before {
  content: "\\f1c4";
}
.kb-labfront.container i.icon.file.video.outline:before {
  content: "\\f1c8";
}
.kb-labfront.container i.icon.file.word.outline:before {
  content: "\\f1c2";
}
.kb-labfront.container i.icon.flag.outline:before {
  content: "\\f024";
}
.kb-labfront.container i.icon.flushed.outline:before {
  content: "\\f579";
}
.kb-labfront.container i.icon.folder.open.outline:before {
  content: "\\f07c";
}
.kb-labfront.container i.icon.folder.outline:before {
  content: "\\f07b";
}
.kb-labfront.container i.icon.frown.open.outline:before {
  content: "\\f57a";
}
.kb-labfront.container i.icon.frown.outline:before {
  content: "\\f119";
}
.kb-labfront.container i.icon.futbol.outline:before {
  content: "\\f1e3";
}
.kb-labfront.container i.icon.gem.outline:before {
  content: "\\f3a5";
}
.kb-labfront.container i.icon.grimace.outline:before {
  content: "\\f57f";
}
.kb-labfront.container i.icon.grin.alternate.outline:before {
  content: "\\f581";
}
.kb-labfront.container i.icon.grin.beam.outline:before {
  content: "\\f582";
}
.kb-labfront.container i.icon.grin.beam.sweat.outline:before {
  content: "\\f583";
}
.kb-labfront.container i.icon.grin.hearts.outline:before {
  content: "\\f584";
}
.kb-labfront.container i.icon.grin.outline:before {
  content: "\\f580";
}
.kb-labfront.container i.icon.grin.squint.outline:before {
  content: "\\f585";
}
.kb-labfront.container i.icon.grin.squint.tears.outline:before {
  content: "\\f586";
}
.kb-labfront.container i.icon.grin.stars.outline:before {
  content: "\\f587";
}
.kb-labfront.container i.icon.grin.tears.outline:before {
  content: "\\f588";
}
.kb-labfront.container i.icon.grin.tongue.outline:before {
  content: "\\f589";
}
.kb-labfront.container i.icon.grin.tongue.squint.outline:before {
  content: "\\f58a";
}
.kb-labfront.container i.icon.grin.tongue.wink.outline:before {
  content: "\\f58b";
}
.kb-labfront.container i.icon.grin.wink.outline:before {
  content: "\\f58c";
}
.kb-labfront.container i.icon.hand.lizard.outline:before {
  content: "\\f258";
}
.kb-labfront.container i.icon.hand.paper.outline:before {
  content: "\\f256";
}
.kb-labfront.container i.icon.hand.peace.outline:before {
  content: "\\f25b";
}
.kb-labfront.container i.icon.hand.point.down.outline:before {
  content: "\\f0a7";
}
.kb-labfront.container i.icon.hand.point.left.outline:before {
  content: "\\f0a5";
}
.kb-labfront.container i.icon.hand.point.right.outline:before {
  content: "\\f0a4";
}
.kb-labfront.container i.icon.hand.point.up.outline:before {
  content: "\\f0a6";
}
.kb-labfront.container i.icon.hand.pointer.outline:before {
  content: "\\f25a";
}
.kb-labfront.container i.icon.hand.rock.outline:before {
  content: "\\f255";
}
.kb-labfront.container i.icon.hand.scissors.outline:before {
  content: "\\f257";
}
.kb-labfront.container i.icon.hand.spock.outline:before {
  content: "\\f259";
}
.kb-labfront.container i.icon.handshake.outline:before {
  content: "\\f2b5";
}
.kb-labfront.container i.icon.hdd.outline:before {
  content: "\\f0a0";
}
.kb-labfront.container i.icon.heart.outline:before {
  content: "\\f004";
}
.kb-labfront.container i.icon.hospital.outline:before {
  content: "\\f0f8";
}
.kb-labfront.container i.icon.hourglass.outline:before {
  content: "\\f254";
}
.kb-labfront.container i.icon.id.badge.outline:before {
  content: "\\f2c1";
}
.kb-labfront.container i.icon.id.card.outline:before {
  content: "\\f2c2";
}
.kb-labfront.container i.icon.image.outline:before {
  content: "\\f03e";
}
.kb-labfront.container i.icon.images.outline:before {
  content: "\\f302";
}
.kb-labfront.container i.icon.keyboard.outline:before {
  content: "\\f11c";
}
.kb-labfront.container i.icon.kiss.beam.outline:before {
  content: "\\f597";
}
.kb-labfront.container i.icon.kiss.outline:before {
  content: "\\f596";
}
.kb-labfront.container i.icon.kiss.wink.heart.outline:before {
  content: "\\f598";
}
.kb-labfront.container i.icon.laugh.beam.outline:before {
  content: "\\f59a";
}
.kb-labfront.container i.icon.laugh.outline:before {
  content: "\\f599";
}
.kb-labfront.container i.icon.laugh.squint.outline:before {
  content: "\\f59b";
}
.kb-labfront.container i.icon.laugh.wink.outline:before {
  content: "\\f59c";
}
.kb-labfront.container i.icon.lemon.outline:before {
  content: "\\f094";
}
.kb-labfront.container i.icon.life.ring.outline:before {
  content: "\\f1cd";
}
.kb-labfront.container i.icon.lightbulb.outline:before {
  content: "\\f0eb";
}
.kb-labfront.container i.icon.list.alternate.outline:before {
  content: "\\f022";
}
.kb-labfront.container i.icon.map.outline:before {
  content: "\\f279";
}
.kb-labfront.container i.icon.meh.blank.outline:before {
  content: "\\f5a4";
}
.kb-labfront.container i.icon.meh.outline:before {
  content: "\\f11a";
}
.kb-labfront.container i.icon.meh.rolling.eyes.outline:before {
  content: "\\f5a5";
}
.kb-labfront.container i.icon.minus.square.outline:before {
  content: "\\f146";
}
.kb-labfront.container i.icon.money.bill.alternate.outline:before {
  content: "\\f3d1";
}
.kb-labfront.container i.icon.moon.outline:before {
  content: "\\f186";
}
.kb-labfront.container i.icon.newspaper.outline:before {
  content: "\\f1ea";
}
.kb-labfront.container i.icon.object.group.outline:before {
  content: "\\f247";
}
.kb-labfront.container i.icon.object.ungroup.outline:before {
  content: "\\f248";
}
.kb-labfront.container i.icon.paper.plane.outline:before {
  content: "\\f1d8";
}
.kb-labfront.container i.icon.pause.circle.outline:before {
  content: "\\f28b";
}
.kb-labfront.container i.icon.play.circle.outline:before {
  content: "\\f144";
}
.kb-labfront.container i.icon.plus.square.outline:before {
  content: "\\f0fe";
}
.kb-labfront.container i.icon.question.circle.outline:before {
  content: "\\f059";
}
.kb-labfront.container i.icon.registered.outline:before {
  content: "\\f25d";
}
.kb-labfront.container i.icon.sad.cry.outline:before {
  content: "\\f5b3";
}
.kb-labfront.container i.icon.sad.tear.outline:before {
  content: "\\f5b4";
}
.kb-labfront.container i.icon.save.outline:before {
  content: "\\f0c7";
}
.kb-labfront.container i.icon.share.square.outline:before {
  content: "\\f14d";
}
.kb-labfront.container i.icon.smile.beam.outline:before {
  content: "\\f5b8";
}
.kb-labfront.container i.icon.smile.outline:before {
  content: "\\f118";
}
.kb-labfront.container i.icon.smile.wink.outline:before {
  content: "\\f4da";
}
.kb-labfront.container i.icon.snowflake.outline:before {
  content: "\\f2dc";
}
.kb-labfront.container i.icon.square.outline:before {
  content: "\\f0c8";
}
.kb-labfront.container i.icon.star.half.outline:before {
  content: "\\f089";
}
.kb-labfront.container i.icon.star.outline:before {
  content: "\\f005";
}
.kb-labfront.container i.icon.sticky.note.outline:before {
  content: "\\f249";
}
.kb-labfront.container i.icon.stop.circle.outline:before {
  content: "\\f28d";
}
.kb-labfront.container i.icon.sun.outline:before {
  content: "\\f185";
}
.kb-labfront.container i.icon.surprise.outline:before {
  content: "\\f5c2";
}
.kb-labfront.container i.icon.thumbs.down.outline:before {
  content: "\\f165";
}
.kb-labfront.container i.icon.thumbs.up.outline:before {
  content: "\\f164";
}
.kb-labfront.container i.icon.times.circle.outline:before {
  content: "\\f057";
}
.kb-labfront.container i.icon.tired.outline:before {
  content: "\\f5c8";
}
.kb-labfront.container i.icon.trash.alternate.outline:before {
  content: "\\f2ed";
}
.kb-labfront.container i.icon.user.circle.outline:before {
  content: "\\f2bd";
}
.kb-labfront.container i.icon.user.outline:before {
  content: "\\f007";
}
.kb-labfront.container i.icon.window.close.outline:before {
  content: "\\f410";
}
.kb-labfront.container i.icon.window.maximize.outline:before {
  content: "\\f2d0";
}
.kb-labfront.container i.icon.window.minimize.outline:before {
  content: "\\f2d1";
}
.kb-labfront.container i.icon.window.restore.outline:before {
  content: "\\f2d2";
}
@font-face {
  font-family: "brand-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("svg");
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-decoration: inherit;
  text-transform: none;
}
.kb-labfront.container i.icon.\\35 00px:before {
  content: "\\f26e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.accessible:before {
  content: "\\f368";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.accusoft:before {
  content: "\\f369";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.acquisitions.incorporated:before {
  content: "\\f6af";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.adn:before {
  content: "\\f170";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.adobe:before {
  content: "\\f778";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.adversal:before {
  content: "\\f36a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.affiliatetheme:before {
  content: "\\f36b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.airbnb:before {
  content: "\\f834";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.algolia:before {
  content: "\\f36c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.alipay:before {
  content: "\\f642";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.amazon:before {
  content: "\\f270";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.amazon.pay:before {
  content: "\\f42c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.amilia:before {
  content: "\\f36d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.android:before {
  content: "\\f17b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.angellist:before {
  content: "\\f209";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.angrycreative:before {
  content: "\\f36e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.angular:before {
  content: "\\f420";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.app.store:before {
  content: "\\f36f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.app.store.ios:before {
  content: "\\f370";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.apper:before {
  content: "\\f371";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.apple:before {
  content: "\\f179";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.apple.pay:before {
  content: "\\f415";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.artstation:before {
  content: "\\f77a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.asymmetrik:before {
  content: "\\f372";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.atlassian:before {
  content: "\\f77b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.audible:before {
  content: "\\f373";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.autoprefixer:before {
  content: "\\f41c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.avianex:before {
  content: "\\f374";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.aviato:before {
  content: "\\f421";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.aws:before {
  content: "\\f375";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bandcamp:before {
  content: "\\f2d5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.battle.net:before {
  content: "\\f835";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.behance:before {
  content: "\\f1b4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.behance.square:before {
  content: "\\f1b5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bimobject:before {
  content: "\\f378";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bitbucket:before {
  content: "\\f171";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bitcoin:before {
  content: "\\f379";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bity:before {
  content: "\\f37a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.black.tie:before {
  content: "\\f27e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.blackberry:before {
  content: "\\f37b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.blogger:before {
  content: "\\f37c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.blogger.b:before {
  content: "\\f37d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bluetooth:before {
  content: "\\f293";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bluetooth.b:before {
  content: "\\f294";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bootstrap:before {
  content: "\\f836";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.btc:before {
  content: "\\f15a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.buffer:before {
  content: "\\f837";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.buromobelexperte:before {
  content: "\\f37f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.buysellads:before {
  content: "\\f20d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.canadian.maple.leaf:before {
  content: "\\f785";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.amazon.pay:before {
  content: "\\f42d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.amex:before {
  content: "\\f1f3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.apple.pay:before {
  content: "\\f416";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.diners.club:before {
  content: "\\f24c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.discover:before {
  content: "\\f1f2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.jcb:before {
  content: "\\f24b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.mastercard:before {
  content: "\\f1f1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.paypal:before {
  content: "\\f1f4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.stripe:before {
  content: "\\f1f5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cc.visa:before {
  content: "\\f1f0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.centercode:before {
  content: "\\f380";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.centos:before {
  content: "\\f789";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.chrome:before {
  content: "\\f268";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.chromecast:before {
  content: "\\f838";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cloudscale:before {
  content: "\\f383";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cloudsmith:before {
  content: "\\f384";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cloudversify:before {
  content: "\\f385";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.codepen:before {
  content: "\\f1cb";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.codiepie:before {
  content: "\\f284";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.confluence:before {
  content: "\\f78d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.connectdevelop:before {
  content: "\\f20e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.contao:before {
  content: "\\f26d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cpanel:before {
  content: "\\f388";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons:before {
  content: "\\f25e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.by:before {
  content: "\\f4e7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.nc:before {
  content: "\\f4e8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.nc.eu:before {
  content: "\\f4e9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.nc.jp:before {
  content: "\\f4ea";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.nd:before {
  content: "\\f4eb";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.pd:before {
  content: "\\f4ec";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.pd.alternate:before {
  content: "\\f4ed";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.remix:before {
  content: "\\f4ee";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.sa:before {
  content: "\\f4ef";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.sampling:before {
  content: "\\f4f0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.sampling.plus:before {
  content: "\\f4f1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.share:before {
  content: "\\f4f2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.creative.commons.zero:before {
  content: "\\f4f3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.critical.role:before {
  content: "\\f6c9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.css3:before {
  content: "\\f13c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.css3.alternate:before {
  content: "\\f38b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.cuttlefish:before {
  content: "\\f38c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.d.and.d:before {
  content: "\\f38d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.d.and.d.beyond:before {
  content: "\\f6ca";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dashcube:before {
  content: "\\f210";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.delicious:before {
  content: "\\f1a5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.deploydog:before {
  content: "\\f38e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.deskpro:before {
  content: "\\f38f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dev:before {
  content: "\\f6cc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.deviantart:before {
  content: "\\f1bd";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dhl:before {
  content: "\\f790";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.diaspora:before {
  content: "\\f791";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.digg:before {
  content: "\\f1a6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.digital.ocean:before {
  content: "\\f391";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.discord:before {
  content: "\\f392";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.discourse:before {
  content: "\\f393";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dochub:before {
  content: "\\f394";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.docker:before {
  content: "\\f395";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.draft2digital:before {
  content: "\\f396";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dribbble:before {
  content: "\\f17d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dribbble.square:before {
  content: "\\f397";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dropbox:before {
  content: "\\f16b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.drupal:before {
  content: "\\f1a9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dyalog:before {
  content: "\\f399";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.earlybirds:before {
  content: "\\f39a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ebay:before {
  content: "\\f4f4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.edge:before {
  content: "\\f282";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.elementor:before {
  content: "\\f430";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ello:before {
  content: "\\f5f1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ember:before {
  content: "\\f423";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.empire:before {
  content: "\\f1d1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.envira:before {
  content: "\\f299";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.erlang:before {
  content: "\\f39d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ethereum:before {
  content: "\\f42e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.etsy:before {
  content: "\\f2d7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.evernote:before {
  content: "\\f839";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.expeditedssl:before {
  content: "\\f23e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.facebook:before {
  content: "\\f09a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.facebook.f:before {
  content: "\\f39e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.facebook.messenger:before {
  content: "\\f39f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.facebook.square:before {
  content: "\\f082";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fantasy.flight.games:before {
  content: "\\f6dc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fedex:before {
  content: "\\f797";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fedora:before {
  content: "\\f798";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.figma:before {
  content: "\\f799";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.firefox:before {
  content: "\\f269";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.first.order:before {
  content: "\\f2b0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.first.order.alternate:before {
  content: "\\f50a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.firstdraft:before {
  content: "\\f3a1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.flickr:before {
  content: "\\f16e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.flipboard:before {
  content: "\\f44d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fly:before {
  content: "\\f417";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.font.awesome:before {
  content: "\\f2b4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.font.awesome.alternate:before {
  content: "\\f35c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.font.awesome.flag:before {
  content: "\\f425";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fonticons:before {
  content: "\\f280";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fonticons.fi:before {
  content: "\\f3a2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fort.awesome:before {
  content: "\\f286";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fort.awesome.alternate:before {
  content: "\\f3a3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.forumbee:before {
  content: "\\f211";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.foursquare:before {
  content: "\\f180";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.free.code.camp:before {
  content: "\\f2c5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.freebsd:before {
  content: "\\f3a4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fulcrum:before {
  content: "\\f50b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.galactic.republic:before {
  content: "\\f50c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.galactic.senate:before {
  content: "\\f50d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.get.pocket:before {
  content: "\\f265";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gg:before {
  content: "\\f260";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gg.circle:before {
  content: "\\f261";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.git:before {
  content: "\\f1d3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.git.alternate:before {
  content: "\\f841";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.git.square:before {
  content: "\\f1d2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.github:before {
  content: "\\f09b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.github.alternate:before {
  content: "\\f113";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.github.square:before {
  content: "\\f092";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gitkraken:before {
  content: "\\f3a6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gitlab:before {
  content: "\\f296";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gitter:before {
  content: "\\f426";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.glide:before {
  content: "\\f2a5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.glide.g:before {
  content: "\\f2a6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gofore:before {
  content: "\\f3a7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.goodreads:before {
  content: "\\f3a8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.goodreads.g:before {
  content: "\\f3a9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google:before {
  content: "\\f1a0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google.drive:before {
  content: "\\f3aa";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google.play:before {
  content: "\\f3ab";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google.plus:before {
  content: "\\f2b3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google.plus.g:before {
  content: "\\f0d5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google.plus.square:before {
  content: "\\f0d4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google.wallet:before {
  content: "\\f1ee";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gratipay:before {
  content: "\\f184";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.grav:before {
  content: "\\f2d6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gripfire:before {
  content: "\\f3ac";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.grunt:before {
  content: "\\f3ad";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gulp:before {
  content: "\\f3ae";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hacker.news:before {
  content: "\\f1d4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hacker.news.square:before {
  content: "\\f3af";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hackerrank:before {
  content: "\\f5f7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hips:before {
  content: "\\f452";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hire.a.helper:before {
  content: "\\f3b0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hooli:before {
  content: "\\f427";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hornbill:before {
  content: "\\f592";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hotjar:before {
  content: "\\f3b1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.houzz:before {
  content: "\\f27c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.html5:before {
  content: "\\f13b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.hubspot:before {
  content: "\\f3b2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.imdb:before {
  content: "\\f2d8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.instagram:before {
  content: "\\f16d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.intercom:before {
  content: "\\f7af";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.internet.explorer:before {
  content: "\\f26b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.invision:before {
  content: "\\f7b0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ioxhost:before {
  content: "\\f208";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.itch.io:before {
  content: "\\f83a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.itunes:before {
  content: "\\f3b4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.itunes.note:before {
  content: "\\f3b5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.java:before {
  content: "\\f4e4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.jedi.order:before {
  content: "\\f50e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.jenkins:before {
  content: "\\f3b6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.jira:before {
  content: "\\f7b1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.joget:before {
  content: "\\f3b7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.joomla:before {
  content: "\\f1aa";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.js:before {
  content: "\\f3b8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.js.square:before {
  content: "\\f3b9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.jsfiddle:before {
  content: "\\f1cc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.kaggle:before {
  content: "\\f5fa";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.keybase:before {
  content: "\\f4f5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.keycdn:before {
  content: "\\f3ba";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.kickstarter:before {
  content: "\\f3bb";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.kickstarter.k:before {
  content: "\\f3bc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.korvue:before {
  content: "\\f42f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.laravel:before {
  content: "\\f3bd";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.lastfm:before {
  content: "\\f202";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.lastfm.square:before {
  content: "\\f203";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.leanpub:before {
  content: "\\f212";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.lesscss:before {
  content: "\\f41d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.linechat:before {
  content: "\\f3c0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.linkedin:before {
  content: "\\f08c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.linkedin.in:before {
  content: "\\f0e1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.linode:before {
  content: "\\f2b8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.linux:before {
  content: "\\f17c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.lyft:before {
  content: "\\f3c3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.magento:before {
  content: "\\f3c4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mailchimp:before {
  content: "\\f59e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mandalorian:before {
  content: "\\f50f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.markdown:before {
  content: "\\f60f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mastodon:before {
  content: "\\f4f6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.maxcdn:before {
  content: "\\f136";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.medapps:before {
  content: "\\f3c6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.medium:before {
  content: "\\f23a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.medium.m:before {
  content: "\\f3c7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.medrt:before {
  content: "\\f3c8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.meetup:before {
  content: "\\f2e0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.megaport:before {
  content: "\\f5a3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mendeley:before {
  content: "\\f7b3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.microsoft:before {
  content: "\\f3ca";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mix:before {
  content: "\\f3cb";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mixcloud:before {
  content: "\\f289";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mizuni:before {
  content: "\\f3cc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.modx:before {
  content: "\\f285";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.monero:before {
  content: "\\f3d0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.napster:before {
  content: "\\f3d2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.neos:before {
  content: "\\f612";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.nimblr:before {
  content: "\\f5a8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.node:before {
  content: "\\f419";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.node.js:before {
  content: "\\f3d3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.npm:before {
  content: "\\f3d4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ns8:before {
  content: "\\f3d5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.nutritionix:before {
  content: "\\f3d6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.odnoklassniki:before {
  content: "\\f263";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.odnoklassniki.square:before {
  content: "\\f264";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.old.republic:before {
  content: "\\f510";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.opencart:before {
  content: "\\f23d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.openid:before {
  content: "\\f19b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.opera:before {
  content: "\\f26a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.optin.monster:before {
  content: "\\f23c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.osi:before {
  content: "\\f41a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.page4:before {
  content: "\\f3d7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pagelines:before {
  content: "\\f18c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.palfed:before {
  content: "\\f3d8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.patreon:before {
  content: "\\f3d9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.paypal:before {
  content: "\\f1ed";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.penny.arcade:before {
  content: "\\f704";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.periscope:before {
  content: "\\f3da";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.phabricator:before {
  content: "\\f3db";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.phoenix.framework:before {
  content: "\\f3dc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.phoenix.squadron:before {
  content: "\\f511";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.php:before {
  content: "\\f457";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pied.piper:before {
  content: "\\f2ae";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pied.piper.alternate:before {
  content: "\\f1a8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pied.piper.hat:before {
  content: "\\f4e5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pied.piper.pp:before {
  content: "\\f1a7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pinterest:before {
  content: "\\f0d2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pinterest.p:before {
  content: "\\f231";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pinterest.square:before {
  content: "\\f0d3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.playstation:before {
  content: "\\f3df";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.product.hunt:before {
  content: "\\f288";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pushed:before {
  content: "\\f3e1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.python:before {
  content: "\\f3e2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.qq:before {
  content: "\\f1d6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.quinscape:before {
  content: "\\f459";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.quora:before {
  content: "\\f2c4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.r.project:before {
  content: "\\f4f7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.raspberry.pi:before {
  content: "\\f7bb";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ravelry:before {
  content: "\\f2d9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.react:before {
  content: "\\f41b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.reacteurope:before {
  content: "\\f75d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.readme:before {
  content: "\\f4d5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.rebel:before {
  content: "\\f1d0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.reddit:before {
  content: "\\f1a1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.reddit.alien:before {
  content: "\\f281";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.reddit.square:before {
  content: "\\f1a2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.redhat:before {
  content: "\\f7bc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.redriver:before {
  content: "\\f3e3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.redyeti:before {
  content: "\\f69d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.renren:before {
  content: "\\f18b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.replyd:before {
  content: "\\f3e6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.researchgate:before {
  content: "\\f4f8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.resolving:before {
  content: "\\f3e7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.rev:before {
  content: "\\f5b2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.rocketchat:before {
  content: "\\f3e8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.rockrms:before {
  content: "\\f3e9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.safari:before {
  content: "\\f267";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.salesforce:before {
  content: "\\f83b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.sass:before {
  content: "\\f41e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.schlix:before {
  content: "\\f3ea";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.scribd:before {
  content: "\\f28a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.searchengin:before {
  content: "\\f3eb";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.sellcast:before {
  content: "\\f2da";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.sellsy:before {
  content: "\\f213";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.servicestack:before {
  content: "\\f3ec";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.shirtsinbulk:before {
  content: "\\f214";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.shopware:before {
  content: "\\f5b5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.simplybuilt:before {
  content: "\\f215";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.sistrix:before {
  content: "\\f3ee";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.sith:before {
  content: "\\f512";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.sketch:before {
  content: "\\f7c6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.skyatlas:before {
  content: "\\f216";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.skype:before {
  content: "\\f17e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.slack:before {
  content: "\\f198";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.slack.hash:before {
  content: "\\f3ef";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.slideshare:before {
  content: "\\f1e7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.snapchat:before {
  content: "\\f2ab";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.snapchat.ghost:before {
  content: "\\f2ac";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.snapchat.square:before {
  content: "\\f2ad";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.soundcloud:before {
  content: "\\f1be";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.sourcetree:before {
  content: "\\f7d3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.speakap:before {
  content: "\\f3f3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.speaker.deck:before {
  content: "\\f83c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.spotify:before {
  content: "\\f1bc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.squarespace:before {
  content: "\\f5be";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.stack.exchange:before {
  content: "\\f18d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.stack.overflow:before {
  content: "\\f16c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.stackpath:before {
  content: "\\f842";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.staylinked:before {
  content: "\\f3f5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.steam:before {
  content: "\\f1b6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.steam.square:before {
  content: "\\f1b7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.steam.symbol:before {
  content: "\\f3f6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.sticker.mule:before {
  content: "\\f3f7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.strava:before {
  content: "\\f428";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.stripe:before {
  content: "\\f429";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.stripe.s:before {
  content: "\\f42a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.studiovinari:before {
  content: "\\f3f8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.stumbleupon:before {
  content: "\\f1a4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.stumbleupon.circle:before {
  content: "\\f1a3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.superpowers:before {
  content: "\\f2dd";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.supple:before {
  content: "\\f3f9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.suse:before {
  content: "\\f7d6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.symfony:before {
  content: "\\f83d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.teamspeak:before {
  content: "\\f4f9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.telegram:before {
  content: "\\f2c6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.telegram.plane:before {
  content: "\\f3fe";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.tencent.weibo:before {
  content: "\\f1d5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.themeco:before {
  content: "\\f5c6";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.themeisle:before {
  content: "\\f2b2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.think.peaks:before {
  content: "\\f731";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.trade.federation:before {
  content: "\\f513";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.trello:before {
  content: "\\f181";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.tripadvisor:before {
  content: "\\f262";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.tumblr:before {
  content: "\\f173";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.tumblr.square:before {
  content: "\\f174";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.twitch:before {
  content: "\\f1e8";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.twitter:before {
  content: "\\f099";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.twitter.square:before {
  content: "\\f081";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.typo3:before {
  content: "\\f42b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.uber:before {
  content: "\\f402";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ubuntu:before {
  content: "\\f7df";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.uikit:before {
  content: "\\f403";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.uniregistry:before {
  content: "\\f404";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.untappd:before {
  content: "\\f405";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ups:before {
  content: "\\f7e0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.usb:before {
  content: "\\f287";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.usps:before {
  content: "\\f7e1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ussunnah:before {
  content: "\\f407";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.vaadin:before {
  content: "\\f408";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.viacoin:before {
  content: "\\f237";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.viadeo:before {
  content: "\\f2a9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.viadeo.square:before {
  content: "\\f2aa";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.viber:before {
  content: "\\f409";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.vimeo:before {
  content: "\\f40a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.vimeo.square:before {
  content: "\\f194";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.vimeo.v:before {
  content: "\\f27d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.vine:before {
  content: "\\f1ca";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.vk:before {
  content: "\\f189";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.vnv:before {
  content: "\\f40b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.vuejs:before {
  content: "\\f41f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.waze:before {
  content: "\\f83f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.weebly:before {
  content: "\\f5cc";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.weibo:before {
  content: "\\f18a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.weixin:before {
  content: "\\f1d7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.whatsapp:before {
  content: "\\f232";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.whatsapp.square:before {
  content: "\\f40c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.whmcs:before {
  content: "\\f40d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wikipedia.w:before {
  content: "\\f266";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.windows:before {
  content: "\\f17a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wix:before {
  content: "\\f5cf";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wizards.of.the.coast:before {
  content: "\\f730";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wolf.pack.battalion:before {
  content: "\\f514";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wordpress:before {
  content: "\\f19a";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wordpress.simple:before {
  content: "\\f411";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wpbeginner:before {
  content: "\\f297";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wpexplorer:before {
  content: "\\f2de";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wpforms:before {
  content: "\\f298";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wpressr:before {
  content: "\\f3e4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.xbox:before {
  content: "\\f412";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.xing:before {
  content: "\\f168";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.xing.square:before {
  content: "\\f169";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.y.combinator:before {
  content: "\\f23b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.yahoo:before {
  content: "\\f19e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.yammer:before {
  content: "\\f840";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.yandex:before {
  content: "\\f413";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.yandex.international:before {
  content: "\\f414";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.yarn:before {
  content: "\\f7e3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.yelp:before {
  content: "\\f1e9";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.yoast:before {
  content: "\\f2b1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.youtube:before {
  content: "\\f167";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.youtube.square:before {
  content: "\\f431";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.zhihu:before {
  content: "\\f63f";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.american.express:before {
  content: "\\f1f3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.american.express.card:before {
  content: "\\f1f3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.amex:before {
  content: "\\f1f3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bitbucket.square:before {
  content: "\\f171";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.bluetooth.alternative:before {
  content: "\\f294";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.amazon.pay:before {
  content: "\\f42d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.american.express:before {
  content: "\\f1f3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.diners.club:before {
  content: "\\f24c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.discover:before {
  content: "\\f1f2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.jcb:before {
  content: "\\f24b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.mastercard:before {
  content: "\\f1f1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.paypal:before {
  content: "\\f1f4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.stripe:before {
  content: "\\f1f5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.credit.card.visa:before {
  content: "\\f1f0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.diners.club:before {
  content: "\\f24c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.diners.club.card:before {
  content: "\\f24c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.discover:before {
  content: "\\f1f2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.discover.card:before {
  content: "\\f1f2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.disk.outline:before {
  content: "\\f369";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.dribble:before {
  content: "\\f17d";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.eercast:before {
  content: "\\f2da";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.envira.gallery:before {
  content: "\\f299";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.fa:before {
  content: "\\f2b4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.facebook.official:before {
  content: "\\f082";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.five.hundred.pixels:before {
  content: "\\f26e";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.gittip:before {
  content: "\\f184";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google.plus.circle:before {
  content: "\\f2b3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.google.plus.official:before {
  content: "\\f2b3";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.japan.credit.bureau:before {
  content: "\\f24b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.japan.credit.bureau.card:before {
  content: "\\f24b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.jcb:before {
  content: "\\f24b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.linkedin.square:before {
  content: "\\f08c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mastercard:before {
  content: "\\f1f1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.mastercard.card:before {
  content: "\\f1f1";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.microsoft.edge:before {
  content: "\\f282";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ms.edge:before {
  content: "\\f282";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.new.pied.piper:before {
  content: "\\f2ae";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.optinmonster:before {
  content: "\\f23c";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.paypal.card:before {
  content: "\\f1f4";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pied.piper.hat:before {
  content: "\\f2ae";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.pocket:before {
  content: "\\f265";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.stripe.card:before {
  content: "\\f1f5";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.theme.isle:before {
  content: "\\f2b2";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.visa:before {
  content: "\\f1f0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.visa.card:before {
  content: "\\f1f0";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wechat:before {
  content: "\\f1d7";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wikipedia:before {
  content: "\\f266";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wordpress.beginner:before {
  content: "\\f297";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.wordpress.forms:before {
  content: "\\f298";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.yc:before {
  content: "\\f23b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.ycombinator:before {
  content: "\\f23b";
  font-family: "brand-icons";
}
.kb-labfront.container i.icon.youtube.play:before {
  content: "\\f167";
  font-family: "brand-icons";
}
.kb-labfront.container .ui.image {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  max-width: 100%;
  background-color: transparent;
}
.kb-labfront.container img.ui.image {
  display: block;
}
.kb-labfront.container .ui.image svg,
.kb-labfront.container .ui.image img {
  display: block;
  max-width: 100%;
  height: auto;
}
.kb-labfront.container .ui.hidden.images,
.kb-labfront.container .ui.ui.hidden.image {
  display: none;
}
.kb-labfront.container .ui.hidden.transition.images,
.kb-labfront.container .ui.hidden.transition.image {
  display: block;
  visibility: hidden;
}
.kb-labfront.container .ui.images > .hidden.transition {
  display: inline-block;
  visibility: hidden;
}
.kb-labfront.container .ui.disabled.images,
.kb-labfront.container .ui.disabled.image {
  cursor: default;
  opacity: 0.45;
}
.kb-labfront.container .ui.inline.image,
.kb-labfront.container .ui.inline.image svg,
.kb-labfront.container .ui.inline.image img {
  display: inline-block;
}
.kb-labfront.container .ui.top.aligned.images .image,
.kb-labfront.container .ui.top.aligned.image,
.kb-labfront.container .ui.top.aligned.image svg,
.kb-labfront.container .ui.top.aligned.image img {
  display: inline-block;
  vertical-align: top;
}
.kb-labfront.container .ui.middle.aligned.images .image,
.kb-labfront.container .ui.middle.aligned.image,
.kb-labfront.container .ui.middle.aligned.image svg,
.kb-labfront.container .ui.middle.aligned.image img {
  display: inline-block;
  vertical-align: middle;
}
.kb-labfront.container .ui.bottom.aligned.images .image,
.kb-labfront.container .ui.bottom.aligned.image,
.kb-labfront.container .ui.bottom.aligned.image svg,
.kb-labfront.container .ui.bottom.aligned.image img {
  display: inline-block;
  vertical-align: bottom;
}
.kb-labfront.container .ui.rounded.images .image,
.kb-labfront.container .ui.rounded.image,
.kb-labfront.container .ui.rounded.images .image > *,
.kb-labfront.container .ui.rounded.image > * {
  border-radius: 0.3125em;
}
.kb-labfront.container .ui.bordered.images .image,
.kb-labfront.container .ui.bordered.images img,
.kb-labfront.container .ui.bordered.images svg,
.kb-labfront.container .ui.bordered.image img,
.kb-labfront.container .ui.bordered.image svg,
.kb-labfront.container img.ui.bordered.image {
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.circular.images,
.kb-labfront.container .ui.circular.image {
  overflow: hidden;
}
.kb-labfront.container .ui.circular.images .image,
.kb-labfront.container .ui.circular.image,
.kb-labfront.container .ui.circular.images .image > *,
.kb-labfront.container .ui.circular.image > * {
  -webkit-border-radius: 500rem;
  -moz-border-radius: 500rem;
  border-radius: 500rem;
}
.kb-labfront.container .ui.fluid.images,
.kb-labfront.container .ui.fluid.image,
.kb-labfront.container .ui.fluid.images img,
.kb-labfront.container .ui.fluid.images svg,
.kb-labfront.container .ui.fluid.image svg,
.kb-labfront.container .ui.fluid.image img {
  display: block;
  width: 100%;
  height: auto;
}
.kb-labfront.container .ui.avatar.images .image,
.kb-labfront.container .ui.avatar.images img,
.kb-labfront.container .ui.avatar.images svg,
.kb-labfront.container .ui.avatar.image img,
.kb-labfront.container .ui.avatar.image svg,
.kb-labfront.container .ui.avatar.image {
  margin-right: 0.25em;
  display: inline-block;
  width: 2em;
  height: 2em;
  -webkit-border-radius: 500rem;
  -moz-border-radius: 500rem;
  border-radius: 500rem;
}
.kb-labfront.container .ui.spaced.image {
  display: inline-block !important;
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.kb-labfront.container .ui[class*="left spaced"].image {
  margin-left: 0.5em;
  margin-right: 0;
}
.kb-labfront.container .ui[class*="right spaced"].image {
  margin-left: 0;
  margin-right: 0.5em;
}
.kb-labfront.container .ui.floated.image,
.kb-labfront.container .ui.floated.images {
  float: left;
  margin-right: 1em;
  margin-bottom: 1em;
}
.kb-labfront.container .ui.right.floated.images,
.kb-labfront.container .ui.right.floated.image {
  float: right;
  margin-right: 0;
  margin-bottom: 1em;
  margin-left: 1em;
}
.kb-labfront.container .ui.floated.images:last-child,
.kb-labfront.container .ui.floated.image:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.centered.images,
.kb-labfront.container .ui.centered.image {
  margin-left: auto;
  margin-right: auto;
}
.kb-labfront.container .ui.mini.images .image,
.kb-labfront.container .ui.mini.images img,
.kb-labfront.container .ui.mini.images svg,
.kb-labfront.container .ui.mini.image {
  width: 35px;
  height: auto;
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.images .image,
.kb-labfront.container .ui.tiny.images img,
.kb-labfront.container .ui.tiny.images svg,
.kb-labfront.container .ui.tiny.image {
  width: 80px;
  height: auto;
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.images .image,
.kb-labfront.container .ui.small.images img,
.kb-labfront.container .ui.small.images svg,
.kb-labfront.container .ui.small.image {
  width: 150px;
  height: auto;
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.medium.images .image,
.kb-labfront.container .ui.medium.images img,
.kb-labfront.container .ui.medium.images svg,
.kb-labfront.container .ui.medium.image {
  width: 300px;
  height: auto;
  font-size: 1rem;
}
.kb-labfront.container .ui.large.images .image,
.kb-labfront.container .ui.large.images img,
.kb-labfront.container .ui.large.images svg,
.kb-labfront.container .ui.large.image {
  width: 450px;
  height: auto;
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.images .image,
.kb-labfront.container .ui.big.images img,
.kb-labfront.container .ui.big.images svg,
.kb-labfront.container .ui.big.image {
  width: 600px;
  height: auto;
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.images .image,
.kb-labfront.container .ui.huge.images img,
.kb-labfront.container .ui.huge.images svg,
.kb-labfront.container .ui.huge.image {
  width: 800px;
  height: auto;
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.images .image,
.kb-labfront.container .ui.massive.images img,
.kb-labfront.container .ui.massive.images svg,
.kb-labfront.container .ui.massive.image {
  width: 960px;
  height: auto;
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.images {
  font-size: 0;
  margin: 0 -0.25rem 0;
}
.kb-labfront.container .ui.images .image,
.kb-labfront.container .ui.images > img,
.kb-labfront.container .ui.images > svg {
  display: inline-block;
  margin: 0 0.25rem 0.5rem;
}
.kb-labfront.container .ui.input {
  position: relative;
  font-weight: normal;
  font-style: normal;
  display: inline-flex;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.input > input {
  margin: 0;
  max-width: 100%;
  flex: 1 0 auto;
  outline: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  text-align: left;
  line-height: 1.2142857143em;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  padding: 0.7857142857em 1em;
  background: #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.2857142857rem;
  transition: box-shadow 0.1s ease, border-color 0.1s ease;
  box-shadow: none;
}
.kb-labfront.container .ui.input > input::-webkit-input-placeholder {
  color: rgba(191.25, 191.25, 191.25, 0.87);
}
.kb-labfront.container .ui.input > input::-moz-placeholder {
  color: rgba(191.25, 191.25, 191.25, 0.87);
}
.kb-labfront.container .ui.input > input:-ms-input-placeholder {
  color: rgba(191.25, 191.25, 191.25, 0.87);
}
.kb-labfront.container .ui.disabled.input,
.kb-labfront.container .ui.input:not(.disabled) input[disabled] {
  opacity: 0.45;
}
.kb-labfront.container .ui.disabled.input > input,
.kb-labfront.container .ui.input:not(.disabled) input[disabled] {
  pointer-events: none;
}
.kb-labfront.container .ui.input > input:active,
.kb-labfront.container .ui.input.down input {
  border-color: rgba(0, 0, 0, 0.3);
  background: #FAFAFA;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
}
.kb-labfront.container .ui.loading.loading.input > i.icon:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 1.2857142857em;
  height: 1.2857142857em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.loading.loading.input > i.icon:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 1.2857142857em;
  height: 1.2857142857em;
  animation: loader 0.6s infinite linear;
  border: 0.2em solid #767676;
  border-radius: 500rem;
  box-shadow: 0 0 0 1px transparent;
}
.kb-labfront.container .ui.input.focus > input,
.kb-labfront.container .ui.input > input:focus {
  border-color: #85b7d9;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.8);
  box-shadow: none;
}
.kb-labfront.container .ui.input.focus > input::-webkit-input-placeholder,
.kb-labfront.container .ui.input > input:focus::-webkit-input-placeholder {
  color: rgba(114.75, 114.75, 114.75, 0.87);
}
.kb-labfront.container .ui.input.focus > input::-moz-placeholder,
.kb-labfront.container .ui.input > input:focus::-moz-placeholder {
  color: rgba(114.75, 114.75, 114.75, 0.87);
}
.kb-labfront.container .ui.input.focus > input:-ms-input-placeholder,
.kb-labfront.container .ui.input > input:focus:-ms-input-placeholder {
  color: rgba(114.75, 114.75, 114.75, 0.87);
}
.kb-labfront.container .ui.input.error > input {
  background-color: #fff6f6;
  border-color: #e0b4b4;
  color: #9f3a38;
  box-shadow: none;
}
.kb-labfront.container .ui.input.error > input::-webkit-input-placeholder {
  color: rgb(231.2976744186, 188.5488372093, 187.7023255814);
}
.kb-labfront.container .ui.input.error > input::-moz-placeholder {
  color: rgb(231.2976744186, 188.5488372093, 187.7023255814);
}
.kb-labfront.container .ui.input.error > input:-ms-input-placeholder {
  color: rgb(231.2976744186, 188.5488372093, 187.7023255814) !important;
}
.kb-labfront.container .ui.input.error > input:focus::-webkit-input-placeholder {
  color: rgb(218.0139534884, 151.3069767442, 149.9860465116);
}
.kb-labfront.container .ui.input.error > input:focus::-moz-placeholder {
  color: rgb(218.0139534884, 151.3069767442, 149.9860465116);
}
.kb-labfront.container .ui.input.error > input:focus:-ms-input-placeholder {
  color: rgb(218.0139534884, 151.3069767442, 149.9860465116) !important;
}
.kb-labfront.container .ui.transparent.input > textarea,
.kb-labfront.container .ui.transparent.input > input {
  border-color: transparent !important;
  background-color: transparent !important;
  padding: 0;
  box-shadow: none !important;
  border-radius: 0 !important;
}
.kb-labfront.container .field .ui.transparent.input > textarea {
  padding: 0.7857142857em 1em;
}
.kb-labfront.container :not(.field) > .ui.transparent.icon.input > i.icon {
  width: 1.1em;
}
.kb-labfront.container :not(.field) > .ui.transparent.icon.input > input {
  padding-left: 0;
  padding-right: 2em;
}
.kb-labfront.container :not(.field) > .ui.transparent[class*="left icon"].input > input {
  padding-left: 2em;
  padding-right: 0;
}
.kb-labfront.container .ui.transparent.inverted.input {
  color: #ffffff;
}
.kb-labfront.container .ui.ui.transparent.inverted.input > textarea,
.kb-labfront.container .ui.ui.transparent.inverted.input > input {
  color: inherit;
}
.kb-labfront.container .ui.transparent.inverted.input > input::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.transparent.inverted.input > input::-moz-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.transparent.inverted.input > input:-ms-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.icon.input > i.icon {
  cursor: default;
  position: absolute;
  line-height: 1;
  text-align: center;
  top: 0;
  right: 0;
  margin: 0;
  height: 100%;
  width: 2.6714285714em;
  opacity: 0.5;
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
  transition: opacity 0.3s ease;
}
.kb-labfront.container .ui.icon.input > i.icon:not(.link) {
  pointer-events: none;
}
.kb-labfront.container .ui.ui.icon.input > textarea,
.kb-labfront.container .ui.ui.icon.input > input {
  padding-right: 2.6714285714em;
}
.kb-labfront.container .ui.icon.input > i.icon:before,
.kb-labfront.container .ui.icon.input > i.icon:after {
  left: 0;
  position: absolute;
  text-align: center;
  top: 50%;
  width: 100%;
  margin-top: -0.5em;
}
.kb-labfront.container .ui.icon.input > i.link.icon {
  cursor: pointer;
}
.kb-labfront.container .ui.icon.input > i.circular.icon {
  top: 0.35em;
  right: 0.5em;
}
.kb-labfront.container .ui[class*="left icon"].input > i.icon {
  right: auto;
  left: 1px;
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui[class*="left icon"].input > i.circular.icon {
  right: auto;
  left: 0.5em;
}
.kb-labfront.container .ui.ui[class*="left icon"].input > textarea,
.kb-labfront.container .ui.ui[class*="left icon"].input > input {
  padding-left: 2.6714285714em;
  padding-right: 1em;
}
.kb-labfront.container .ui.icon.input > textarea:focus ~ i.icon,
.kb-labfront.container .ui.icon.input > input:focus ~ i.icon {
  opacity: 1;
}
.kb-labfront.container .ui.labeled.input > .label {
  flex: 0 0 auto;
  margin: 0;
  font-size: 1em;
}
.kb-labfront.container .ui.labeled.input > .label:not(.corner) {
  padding-top: 0.7857142857em;
  padding-bottom: 0.7857142857em;
}
.kb-labfront.container .ui.labeled.input:not([class*="corner labeled"]) .label:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.kb-labfront.container .ui.labeled.input:not([class*="corner labeled"]) .label:first-child + input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left-color: transparent;
}
.kb-labfront.container .ui.labeled.input:not([class*="corner labeled"]) .label:first-child + input:focus {
  border-left-color: #85b7d9;
}
.kb-labfront.container .ui[class*="right labeled"].input > input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right-color: transparent !important;
}
.kb-labfront.container .ui[class*="right labeled"].input > input + .label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.kb-labfront.container .ui[class*="right labeled"].input > input:focus {
  border-right-color: #85b7d9 !important;
}
.kb-labfront.container .ui.labeled.input .corner.label {
  top: 1px;
  right: 1px;
  font-size: 0.6428571429em;
  border-radius: 0 0.2857142857rem 0 0;
}
.kb-labfront.container .ui[class*="corner labeled"]:not([class*="left corner labeled"]).labeled.input > textarea,
.kb-labfront.container .ui[class*="corner labeled"]:not([class*="left corner labeled"]).labeled.input > input {
  padding-right: 2.5em !important;
}
.kb-labfront.container .ui[class*="corner labeled"].icon.input:not([class*="left corner labeled"]) > textarea,
.kb-labfront.container .ui[class*="corner labeled"].icon.input:not([class*="left corner labeled"]) > input {
  padding-right: 3.25em !important;
}
.kb-labfront.container .ui[class*="corner labeled"].icon.input:not([class*="left corner labeled"]) > .icon {
  margin-right: 1.25em;
}
.kb-labfront.container .ui[class*="left corner labeled"].labeled.input > textarea,
.kb-labfront.container .ui[class*="left corner labeled"].labeled.input > input {
  padding-left: 2.5em !important;
}
.kb-labfront.container .ui[class*="left corner labeled"].icon.input > textarea,
.kb-labfront.container .ui[class*="left corner labeled"].icon.input > input {
  padding-left: 3.25em !important;
}
.kb-labfront.container .ui[class*="left corner labeled"].icon.input > .icon {
  margin-left: 1.25em;
}
.kb-labfront.container .ui.icon.input > textarea ~ .icon {
  height: 3em;
}
.kb-labfront.container :not(.field) > .ui.transparent.icon.input > textarea ~ .icon {
  height: 1.3em;
}
.kb-labfront.container .ui.input > .ui.corner.label {
  top: 1px;
  right: 1px;
}
.kb-labfront.container .ui.input > .ui.left.corner.label {
  right: auto;
  left: 1px;
}
.kb-labfront.container .ui.form > .field.error > .ui.action.input > .ui.button,
.kb-labfront.container .ui.form > .field.error > .ui.labeled.input:not([class*="corner labeled"]) > .ui.label,
.kb-labfront.container .ui.action.input.error > .ui.button,
.kb-labfront.container .ui.labeled.input.error:not([class*="corner labeled"]) > .ui.label {
  border-top: 1px solid #e0b4b4;
  border-bottom: 1px solid #e0b4b4;
}
.kb-labfront.container .ui.form > .field.error > .ui.left.action.input > .ui.button,
.kb-labfront.container .ui.form > .field.error > .ui.labeled.input:not(.right):not([class*="corner labeled"]) > .ui.label,
.kb-labfront.container .ui.left.action.input.error > .ui.button,
.kb-labfront.container .ui.labeled.input.error:not(.right):not([class*="corner labeled"]) > .ui.label {
  border-left: 1px solid #e0b4b4;
}
.kb-labfront.container .ui.form > .field.error > .ui.action.input:not(.left) > input + .ui.button,
.kb-labfront.container .ui.form > .field.error > .ui.right.labeled.input:not([class*="corner labeled"]) > input + .ui.label,
.kb-labfront.container .ui.action.input.error:not(.left) > input + .ui.button,
.kb-labfront.container .ui.right.labeled.input.error:not([class*="corner labeled"]) > input + .ui.label {
  border-right: 1px solid #e0b4b4;
}
.kb-labfront.container .ui.form > .field.error > .ui.right.labeled.input:not([class*="corner labeled"]) > .ui.label:first-child,
.kb-labfront.container .ui.right.labeled.input.error:not([class*="corner labeled"]) > .ui.label:first-child {
  border-left: 1px solid #e0b4b4;
}
.kb-labfront.container .ui.action.input > .button,
.kb-labfront.container .ui.action.input > .buttons {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
}
.kb-labfront.container .ui.action.input > .button,
.kb-labfront.container .ui.action.input > .buttons > .button {
  padding-top: 0.7857142857em;
  padding-bottom: 0.7857142857em;
  margin: 0;
}
.kb-labfront.container .ui.action.input:not([class*="left action"]) > input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right-color: transparent !important;
}
.kb-labfront.container .ui.action.input:not([class*="left action"]) > .dropdown:not(:first-child),
.kb-labfront.container .ui.action.input:not([class*="left action"]) > .button:not(:first-child),
.kb-labfront.container .ui.action.input:not([class*="left action"]) > .buttons:not(:first-child) > .button {
  border-radius: 0;
}
.kb-labfront.container .ui.action.input:not([class*="left action"]) > .dropdown:last-child,
.kb-labfront.container .ui.action.input:not([class*="left action"]) > .button:last-child,
.kb-labfront.container .ui.action.input:not([class*="left action"]) > .buttons:last-child > .button {
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
}
.kb-labfront.container .ui.action.input:not([class*="left action"]) > input:focus {
  border-right-color: #85b7d9 !important;
}
.kb-labfront.container .ui[class*="left action"].input > input {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-left-color: transparent !important;
}
.kb-labfront.container .ui[class*="left action"].input > .dropdown,
.kb-labfront.container .ui[class*="left action"].input > .button,
.kb-labfront.container .ui[class*="left action"].input > .buttons > .button {
  border-radius: 0;
}
.kb-labfront.container .ui[class*="left action"].input > .dropdown:first-child,
.kb-labfront.container .ui[class*="left action"].input > .button:first-child,
.kb-labfront.container .ui[class*="left action"].input > .buttons:first-child > .button {
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui[class*="left action"].input > input:focus {
  border-left-color: #85b7d9 !important;
}
.kb-labfront.container .ui.inverted.input > input {
  border: none;
}
.kb-labfront.container .ui.fluid.input {
  display: flex;
}
.kb-labfront.container .ui.fluid.input > input {
  width: 0 !important;
}
.kb-labfront.container .ui.mini.input {
  font-size: 0.7857142857em;
}
.kb-labfront.container .ui.tiny.input {
  font-size: 0.8571428571em;
}
.kb-labfront.container .ui.small.input {
  font-size: 0.9285714286em;
}
.kb-labfront.container .ui.input {
  font-size: 1em;
}
.kb-labfront.container .ui.large.input {
  font-size: 1.1428571429em;
}
.kb-labfront.container .ui.big.input {
  font-size: 1.2857142857em;
}
.kb-labfront.container .ui.huge.input {
  font-size: 1.4285714286em;
}
.kb-labfront.container .ui.massive.input {
  font-size: 1.7142857143em;
}
.kb-labfront.container .ui.label {
  display: inline-block;
  line-height: 1;
  vertical-align: baseline;
  margin: 0 0.1428571429em;
  background-color: #E8E8E8;
  background-image: none;
  padding: 0.5833em 0.833em;
  color: rgba(0, 0, 0, 0.6);
  text-transform: none;
  font-weight: bold;
  border: 0 solid transparent;
  border-radius: 0.2857142857rem;
  transition: background 0.1s ease;
}
.kb-labfront.container .ui.label:first-child {
  margin-left: 0;
}
.kb-labfront.container .ui.label:last-child {
  margin-right: 0;
}
.kb-labfront.container a.ui.label {
  cursor: pointer;
}
.kb-labfront.container .ui.label > a {
  cursor: pointer;
  color: inherit;
  opacity: 0.5;
  transition: 0.1s opacity ease;
}
.kb-labfront.container .ui.label > a:hover {
  opacity: 1;
}
.kb-labfront.container .ui.label > img {
  width: auto !important;
  vertical-align: middle;
  height: 2.1666em;
}
.kb-labfront.container .ui.left.icon.label > .icon,
.kb-labfront.container .ui.label > .icon {
  width: auto;
  margin: 0 0.75em 0 0;
}
.kb-labfront.container .ui.label > .detail {
  display: inline-block;
  vertical-align: top;
  font-weight: bold;
  margin-left: 1em;
  opacity: 0.8;
}
.kb-labfront.container .ui.label > .detail .icon {
  margin: 0 0.25em 0 0;
}
.kb-labfront.container .ui.label > .close.icon,
.kb-labfront.container .ui.label > .delete.icon {
  cursor: pointer;
  font-size: 0.9285714286em;
  opacity: 0.5;
  transition: background 0.1s ease;
}
.kb-labfront.container .ui.label > .close.icon:hover,
.kb-labfront.container .ui.label > .delete.icon:hover {
  opacity: 1;
}
.kb-labfront.container .ui.label.left.icon > .close.icon,
.kb-labfront.container .ui.label.left.icon > .delete.icon {
  margin: 0 0.5em 0 0;
}
.kb-labfront.container .ui.label:not(.icon) > .close.icon,
.kb-labfront.container .ui.label:not(.icon) > .delete.icon {
  margin: 0 0 0 0.5em;
}
.kb-labfront.container .ui.icon.label > .icon {
  margin: 0 auto;
}
.kb-labfront.container .ui.right.icon.label > .icon {
  margin: 0 0 0 0.75em;
}
.kb-labfront.container .ui.labels > .label {
  margin: 0 0.5em 0.5em 0;
}
.kb-labfront.container .ui.header > .ui.label {
  margin-top: -0.29165em;
}
.kb-labfront.container .ui.attached.segment > .ui.top.left.attached.label,
.kb-labfront.container .ui.bottom.attached.segment > .ui.top.left.attached.label {
  border-top-left-radius: 0;
}
.kb-labfront.container .ui.attached.segment > .ui.top.right.attached.label,
.kb-labfront.container .ui.bottom.attached.segment > .ui.top.right.attached.label {
  border-top-right-radius: 0;
}
.kb-labfront.container .ui.top.attached.segment > .ui.bottom.left.attached.label {
  border-bottom-left-radius: 0;
}
.kb-labfront.container .ui.top.attached.segment > .ui.bottom.right.attached.label {
  border-bottom-right-radius: 0;
}
.kb-labfront.container .ui.top.attached.label ~ .ui.bottom.attached.label + :not(.attached),
.kb-labfront.container .ui.top.attached.label + :not(.attached) {
  margin-top: 2rem !important;
}
.kb-labfront.container .ui.bottom.attached.label ~ :last-child:not(.attached) {
  margin-top: 0;
  margin-bottom: 2rem !important;
}
.kb-labfront.container .ui.image.label {
  width: auto !important;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 9999px;
  vertical-align: baseline;
  text-transform: none;
  background: #E8E8E8;
  padding: 0.5833em 0.833em 0.5833em 0.5em;
  border-radius: 0.2857142857rem;
  box-shadow: none;
}
.kb-labfront.container .ui.image.label img {
  display: inline-block;
  vertical-align: top;
  height: 2.1666em;
  margin: -0.5833em 0.5em -0.5833em -0.5em;
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.image.label .detail {
  background: rgba(0, 0, 0, 0.1);
  margin: -0.5833em -0.833em -0.5833em 0.5em;
  padding: 0.5833em 0.833em;
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
}
.kb-labfront.container .ui.tag.labels .label,
.kb-labfront.container .ui.tag.label {
  margin-left: 1em;
  position: relative;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
  transition: none;
}
.kb-labfront.container .ui.tag.labels .label:before,
.kb-labfront.container .ui.tag.label:before {
  position: absolute;
  transform: translateY(-50%) translateX(50%) rotate(-45deg);
  top: 50%;
  right: 100%;
  content: "";
  background-color: inherit;
  background-image: none;
  width: 1.56em;
  height: 1.56em;
  transition: none;
}
.kb-labfront.container .ui.tag.labels .label:after,
.kb-labfront.container .ui.tag.label:after {
  position: absolute;
  content: "";
  top: 50%;
  left: -0.25em;
  margin-top: -0.25em;
  background-color: #ffffff;
  width: 0.5em;
  height: 0.5em;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.3);
  border-radius: 500rem;
}
.kb-labfront.container .ui.basic.tag.labels .label:before,
.kb-labfront.container .ui.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.basic.tag.labels .label:after,
.kb-labfront.container .ui.basic.tag.label:after {
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.corner.label {
  position: absolute;
  top: 0;
  right: 0;
  margin: 0;
  padding: 0;
  text-align: center;
  border-color: #E8E8E8;
  width: 4em;
  height: 4em;
  z-index: 1;
  transition: border-color 0.1s ease;
}
.kb-labfront.container .ui.corner.label {
  background-color: transparent !important;
}
.kb-labfront.container .ui.corner.label:after {
  position: absolute;
  content: "";
  right: 0;
  top: 0;
  z-index: -1;
  width: 0;
  height: 0;
  background-color: transparent;
  border-top: 0 solid transparent;
  border-right: 4em solid transparent;
  border-bottom: 4em solid transparent;
  border-left: 0 solid transparent;
  border-right-color: inherit;
  transition: border-color 0.1s ease;
}
.kb-labfront.container .ui.corner.label .icon {
  cursor: inherit;
  position: absolute;
  top: 0.6428571429em;
  left: auto;
  right: 0.5714285714em;
  font-size: 1.1428571429em;
  margin: 0;
}
.kb-labfront.container .ui.left.corner.label,
.kb-labfront.container .ui.left.corner.label:after {
  right: auto;
  left: 0;
}
.kb-labfront.container .ui.left.corner.label:after {
  border-top: 4em solid transparent;
  border-right: 4em solid transparent;
  border-bottom: 0 solid transparent;
  border-left: 0 solid transparent;
  border-top-color: inherit;
}
.kb-labfront.container .ui.left.corner.label .icon {
  left: 0.5714285714em;
  right: auto;
}
.kb-labfront.container .ui.segment > .ui.corner.label {
  top: -1px;
  right: -1px;
}
.kb-labfront.container .ui.segment > .ui.left.corner.label {
  right: auto;
  left: -1px;
}
.kb-labfront.container .ui.ribbon.label {
  position: relative;
  margin: 0;
  min-width: max-content;
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
  border-color: rgba(0, 0, 0, 0.15);
}
.kb-labfront.container .ui.ribbon.label:after {
  position: absolute;
  content: "";
  top: 100%;
  left: 0;
  background-color: transparent;
  border-style: solid;
  border-width: 0 1.2em 1.2em 0;
  border-color: transparent;
  border-right-color: inherit;
  width: 0;
  height: 0;
}
.kb-labfront.container .ui.ribbon.label {
  left: calc(-1rem - 1.2em);
  margin-right: -1.2em;
  padding-left: calc(1rem + 1.2em);
  padding-right: 1.2em;
}
.kb-labfront.container .ui[class*="right ribbon"].label {
  left: calc(100% + 1rem + 1.2em);
  padding-left: 1.2em;
  padding-right: calc(1rem + 1.2em);
}
.kb-labfront.container .ui.basic.ribbon.label {
  padding-top: calc(0.5833em - 1px);
  padding-bottom: calc(0.5833em - 1px);
}
.kb-labfront.container .ui.basic.ribbon.label:not([class*="right ribbon"]) {
  padding-left: calc(1rem + 1.2em - 1px);
  padding-right: calc(1.2em - 1px);
}
.kb-labfront.container .ui.basic[class*="right ribbon"].label {
  padding-left: calc(1.2em - 1px);
  padding-right: calc(1rem + 1.2em - 1px);
}
.kb-labfront.container .ui.basic.ribbon.label::after {
  top: calc(100% + 1px);
}
.kb-labfront.container .ui.basic.ribbon.label:not([class*="right ribbon"])::after {
  left: -1px;
}
.kb-labfront.container .ui.basic[class*="right ribbon"].label::after {
  right: -1px;
}
.kb-labfront.container .ui[class*="right ribbon"].label {
  text-align: left;
  transform: translateX(-100%);
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui[class*="right ribbon"].label:after {
  left: auto;
  right: 0;
  border-style: solid;
  border-width: 1.2em 1.2em 0 0;
  border-color: transparent;
  border-top-color: inherit;
}
.kb-labfront.container .ui.image > .ribbon.label,
.kb-labfront.container .ui.card .image > .ribbon.label {
  position: absolute;
  top: 1rem;
}
.kb-labfront.container .ui.card .image > .ui.ribbon.label,
.kb-labfront.container .ui.image > .ui.ribbon.label {
  left: calc(0.05rem - 1.2em);
}
.kb-labfront.container .ui.card .image > .ui[class*="right ribbon"].label,
.kb-labfront.container .ui.image > .ui[class*="right ribbon"].label {
  left: calc(100% + -0.05rem + 1.2em);
  padding-left: 0.833em;
}
.kb-labfront.container .ui.table td > .ui.ribbon.label {
  left: calc(-1em - 1.2em);
}
.kb-labfront.container .ui.table td > .ui[class*="right ribbon"].label {
  left: calc(100% + 1em + 1.2em);
  padding-left: 0.833em;
}
.kb-labfront.container .ui[class*="top attached"].label,
.kb-labfront.container .ui.attached.label {
  width: 100%;
  position: absolute;
  margin: 0;
  top: 0;
  left: 0;
  padding: 0.75em 1em;
  border-radius: 0.2142857143rem 0.2142857143rem 0 0;
}
.kb-labfront.container .ui[class*="bottom attached"].label {
  top: auto;
  bottom: 0;
  border-radius: 0 0 0.2142857143rem 0.2142857143rem;
}
.kb-labfront.container .ui[class*="top left attached"].label {
  width: auto;
  margin-top: 0 !important;
  border-radius: 0.2142857143rem 0 0.2857142857rem 0;
}
.kb-labfront.container .ui[class*="top right attached"].label {
  width: auto;
  left: auto;
  right: 0;
  border-radius: 0 0.2142857143rem 0 0.2857142857rem;
}
.kb-labfront.container .ui[class*="bottom left attached"].label {
  width: auto;
  top: auto;
  bottom: 0;
  border-radius: 0 0.2857142857rem 0 0.2142857143rem;
}
.kb-labfront.container .ui[class*="bottom right attached"].label {
  top: auto;
  bottom: 0;
  left: auto;
  right: 0;
  width: auto;
  border-radius: 0.2857142857rem 0 0.2142857143rem 0;
}
.kb-labfront.container .ui.label.disabled {
  opacity: 0.5;
}
.kb-labfront.container .ui.labels a.label:hover,
.kb-labfront.container a.ui.label:hover {
  background-color: #E0E0E0;
  border-color: #E0E0E0;
  background-image: none;
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.labels a.label:hover:before,
.kb-labfront.container a.ui.label:hover:before {
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.active.label {
  background-color: #D0D0D0;
  border-color: #D0D0D0;
  background-image: none;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.active.label:before {
  background-color: #D0D0D0;
  background-image: none;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.labels a.active.label:hover,
.kb-labfront.container a.ui.active.label:hover {
  background-color: #C8C8C8;
  border-color: #C8C8C8;
  background-image: none;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.labels a.active.label:hover:before,
.kb-labfront.container a.ui.active.label:hover:before {
  background-color: #C8C8C8;
  background-image: none;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.labels.visible .label,
.kb-labfront.container .ui.label.visible:not(.dropdown) {
  display: inline-block !important;
}
.kb-labfront.container .ui.labels.hidden .label,
.kb-labfront.container .ui.label.hidden {
  display: none !important;
}
.kb-labfront.container .ui.basic.labels .label,
.kb-labfront.container .ui.basic.label {
  background: none #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
}
.kb-labfront.container .ui.basic.labels a.label:hover,
.kb-labfront.container a.ui.basic.label:hover {
  text-decoration: none;
  background: none #ffffff;
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
  box-shadow: none;
}
.kb-labfront.container .ui.label.fluid,
.kb-labfront.container .ui.fluid.labels > .label {
  width: 100%;
  box-sizing: border-box;
}
.kb-labfront.container .ui.inverted.labels .label,
.kb-labfront.container .ui.inverted.label {
  color: rgba(255, 255, 255, 0.9);
  background-color: #b5b5b5;
}
.kb-labfront.container .ui.inverted.corner.label {
  border-color: #b5b5b5;
}
.kb-labfront.container .ui.inverted.corner.label:hover {
  border-color: #E8E8E8;
  transition: none;
}
.kb-labfront.container .ui.inverted.basic.labels .label,
.kb-labfront.container .ui.inverted.basic.label,
.kb-labfront.container .ui.inverted.basic.label:hover {
  border-color: rgba(255, 255, 255, 0.5);
  background: #1b1c1d;
}
.kb-labfront.container .ui.inverted.basic.label:hover {
  color: #4183c4;
}
.kb-labfront.container .ui.primary.labels .label,
.kb-labfront.container .ui.ui.ui.primary.label {
  background-color: #2185d0;
  border-color: #2185d0;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.primary.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.primary.label:hover {
  background-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
  border-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.primary.ribbon.label {
  border-color: rgb(26.0165975104, 104.8547717842, 163.9834024896);
}
.kb-labfront.container .ui.basic.labels .primary.label,
.kb-labfront.container .ui.ui.ui.basic.primary.label {
  background: none #ffffff;
  border-color: #2185d0;
  color: #2185d0;
}
.kb-labfront.container .ui.basic.labels a.primary.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.primary.label:hover {
  background: none #ffffff;
  border-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
  color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.inverted.labels .primary.label,
.kb-labfront.container .ui.ui.ui.inverted.primary.label {
  background-color: #54c8ff;
  border-color: #54c8ff;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.primary.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.primary.label:hover {
  background-color: rgb(33, 183.5964912281, 255);
  border-color: rgb(33, 183.5964912281, 255);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.primary.ribbon.label {
  border-color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.basic.labels .primary.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.primary.label {
  background-color: #1b1c1d;
  border-color: #54c8ff;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.basic.labels a.primary.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.primary.label:hover {
  border-color: rgb(33, 183.5964912281, 255);
  background-color: #1b1c1d;
  color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .primary.label,
.kb-labfront.container .ui.ui.ui.inverted.primary.basic.tag.label {
  border: 1px solid #54c8ff;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .primary.label:before,
.kb-labfront.container .ui.ui.ui.inverted.primary.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.secondary.labels .label,
.kb-labfront.container .ui.ui.ui.secondary.label {
  background-color: #1b1c1d;
  border-color: #1b1c1d;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.secondary.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.secondary.label:hover {
  background-color: rgb(35.2196428571, 40.75, 46.2803571429);
  border-color: rgb(35.2196428571, 40.75, 46.2803571429);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.secondary.ribbon.label {
  border-color: rgb(2.4107142857, 2.5, 2.5892857143);
}
.kb-labfront.container .ui.basic.labels .secondary.label,
.kb-labfront.container .ui.ui.ui.basic.secondary.label {
  background: none #ffffff;
  border-color: #1b1c1d;
  color: #1b1c1d;
}
.kb-labfront.container .ui.basic.labels a.secondary.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.secondary.label:hover {
  background: none #ffffff;
  border-color: rgb(35.2196428571, 40.75, 46.2803571429);
  color: rgb(35.2196428571, 40.75, 46.2803571429);
}
.kb-labfront.container .ui.inverted.labels .secondary.label,
.kb-labfront.container .ui.ui.ui.inverted.secondary.label {
  background-color: #545454;
  border-color: #545454;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.secondary.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.secondary.label:hover {
  background-color: rgb(120.45, 98.55, 98.55);
  border-color: rgb(120.45, 98.55, 98.55);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.secondary.ribbon.label {
  border-color: rgb(58.5, 58.5, 58.5);
}
.kb-labfront.container .ui.inverted.basic.labels .secondary.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.secondary.label {
  background-color: #1b1c1d;
  border-color: #545454;
  color: #545454;
}
.kb-labfront.container .ui.inverted.basic.labels a.secondary.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.secondary.label:hover {
  border-color: rgb(120.45, 98.55, 98.55);
  background-color: #1b1c1d;
  color: rgb(120.45, 98.55, 98.55);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .secondary.label,
.kb-labfront.container .ui.ui.ui.inverted.secondary.basic.tag.label {
  border: 1px solid #545454;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .secondary.label:before,
.kb-labfront.container .ui.ui.ui.inverted.secondary.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.red.labels .label,
.kb-labfront.container .ui.ui.ui.red.label {
  background-color: #db2828;
  border-color: #db2828;
  color: #ffffff;
}
.kb-labfront.container .ui.red.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.red.label:hover {
  background-color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
  border-color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.red.ribbon.label {
  border-color: rgb(178.1673306773, 29.8326693227, 29.8326693227);
}
.kb-labfront.container .ui.basic.labels .red.label,
.kb-labfront.container .ui.ui.ui.basic.red.label {
  background: none #ffffff;
  border-color: #db2828;
  color: #db2828;
}
.kb-labfront.container .ui.basic.labels a.red.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.red.label:hover {
  background: none #ffffff;
  border-color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
  color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.inverted.labels .red.label,
.kb-labfront.container .ui.ui.ui.inverted.red.label {
  background-color: #ff695e;
  border-color: #ff695e;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.red.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.red.label:hover {
  background-color: rgb(255, 57.4844720497, 43);
  border-color: rgb(255, 57.4844720497, 43);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.red.ribbon.label {
  border-color: rgb(255, 57.4844720497, 43);
}
.kb-labfront.container .ui.inverted.basic.labels .red.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.red.label {
  background-color: #1b1c1d;
  border-color: #ff695e;
  color: #ff695e;
}
.kb-labfront.container .ui.inverted.basic.labels a.red.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.red.label:hover {
  border-color: rgb(255, 57.4844720497, 43);
  background-color: #1b1c1d;
  color: rgb(255, 57.4844720497, 43);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .red.label,
.kb-labfront.container .ui.ui.ui.inverted.red.basic.tag.label {
  border: 1px solid #ff695e;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .red.label:before,
.kb-labfront.container .ui.ui.ui.inverted.red.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.orange.labels .label,
.kb-labfront.container .ui.ui.ui.orange.label {
  background-color: #f2711c;
  border-color: #f2711c;
  color: #ffffff;
}
.kb-labfront.container .ui.orange.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.orange.label:hover {
  background-color: rgb(243.48125, 97.3239485981, 1.01875);
  border-color: rgb(243.48125, 97.3239485981, 1.01875);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.orange.ribbon.label {
  border-color: rgb(207.1375, 89.425, 11.8625);
}
.kb-labfront.container .ui.basic.labels .orange.label,
.kb-labfront.container .ui.ui.ui.basic.orange.label {
  background: none #ffffff;
  border-color: #f2711c;
  color: #f2711c;
}
.kb-labfront.container .ui.basic.labels a.orange.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.orange.label:hover {
  background: none #ffffff;
  border-color: rgb(243.48125, 97.3239485981, 1.01875);
  color: rgb(243.48125, 97.3239485981, 1.01875);
}
.kb-labfront.container .ui.inverted.labels .orange.label,
.kb-labfront.container .ui.ui.ui.inverted.orange.label {
  background-color: #ff851b;
  border-color: #ff851b;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.orange.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.orange.label:hover {
  background-color: rgb(231, 107.3947368421, 0);
  border-color: rgb(231, 107.3947368421, 0);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.orange.ribbon.label {
  border-color: rgb(231, 107.3947368421, 0);
}
.kb-labfront.container .ui.inverted.basic.labels .orange.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.orange.label {
  background-color: #1b1c1d;
  border-color: #ff851b;
  color: #ff851b;
}
.kb-labfront.container .ui.inverted.basic.labels a.orange.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.orange.label:hover {
  border-color: rgb(231, 107.3947368421, 0);
  background-color: #1b1c1d;
  color: rgb(231, 107.3947368421, 0);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .orange.label,
.kb-labfront.container .ui.ui.ui.inverted.orange.basic.tag.label {
  border: 1px solid #ff851b;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .orange.label:before,
.kb-labfront.container .ui.ui.ui.inverted.orange.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.yellow.labels .label,
.kb-labfront.container .ui.ui.ui.yellow.label {
  background-color: #fbbd08;
  border-color: #fbbd08;
  color: #ffffff;
}
.kb-labfront.container .ui.yellow.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.yellow.label:hover {
  background-color: rgb(233.5, 173.9238683128, 0);
  border-color: rgb(233.5, 173.9238683128, 0);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.yellow.ribbon.label {
  border-color: rgb(204.6852589641, 153.3067729084, 3.3147410359);
}
.kb-labfront.container .ui.basic.labels .yellow.label,
.kb-labfront.container .ui.ui.ui.basic.yellow.label {
  background: none #ffffff;
  border-color: #fbbd08;
  color: #fbbd08;
}
.kb-labfront.container .ui.basic.labels a.yellow.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.yellow.label:hover {
  background: none #ffffff;
  border-color: rgb(233.5, 173.9238683128, 0);
  color: rgb(233.5, 173.9238683128, 0);
}
.kb-labfront.container .ui.inverted.labels .yellow.label,
.kb-labfront.container .ui.ui.ui.inverted.yellow.label {
  background-color: #ffe21f;
  border-color: #ffe21f;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.yellow.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.yellow.label:hover {
  background-color: rgb(235, 204.5758928571, 0);
  border-color: rgb(235, 204.5758928571, 0);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.yellow.ribbon.label {
  border-color: rgb(235, 204.5758928571, 0);
}
.kb-labfront.container .ui.inverted.basic.labels .yellow.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.yellow.label {
  background-color: #1b1c1d;
  border-color: #ffe21f;
  color: #ffe21f;
}
.kb-labfront.container .ui.inverted.basic.labels a.yellow.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.yellow.label:hover {
  border-color: rgb(235, 204.5758928571, 0);
  background-color: #1b1c1d;
  color: rgb(235, 204.5758928571, 0);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .yellow.label,
.kb-labfront.container .ui.ui.ui.inverted.yellow.basic.tag.label {
  border: 1px solid #ffe21f;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .yellow.label:before,
.kb-labfront.container .ui.ui.ui.inverted.yellow.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.olive.labels .label,
.kb-labfront.container .ui.ui.ui.olive.label {
  background-color: #b5cc18;
  border-color: #b5cc18;
  color: #ffffff;
}
.kb-labfront.container .ui.olive.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.olive.label:hover {
  background-color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
  border-color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.olive.ribbon.label {
  border-color: rgb(140.5131578947, 158.3684210526, 18.6315789474);
}
.kb-labfront.container .ui.basic.labels .olive.label,
.kb-labfront.container .ui.ui.ui.basic.olive.label {
  background: none #ffffff;
  border-color: #b5cc18;
  color: #b5cc18;
}
.kb-labfront.container .ui.basic.labels a.olive.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.olive.label:hover {
  background: none #ffffff;
  border-color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
  color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
}
.kb-labfront.container .ui.inverted.labels .olive.label,
.kb-labfront.container .ui.ui.ui.inverted.olive.label {
  background-color: #d9e778;
  border-color: #d9e778;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.olive.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.olive.label:hover {
  background-color: rgb(212.6626721061, 233.8018867925, 66.1981132075);
  border-color: rgb(212.6626721061, 233.8018867925, 66.1981132075);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.olive.ribbon.label {
  border-color: rgb(204.8113207547, 223.3018867925, 76.6981132075);
}
.kb-labfront.container .ui.inverted.basic.labels .olive.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.olive.label {
  background-color: #1b1c1d;
  border-color: #d9e778;
  color: #d9e778;
}
.kb-labfront.container .ui.inverted.basic.labels a.olive.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.olive.label:hover {
  border-color: rgb(212.6626721061, 233.8018867925, 66.1981132075);
  background-color: #1b1c1d;
  color: rgb(212.6626721061, 233.8018867925, 66.1981132075);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .olive.label,
.kb-labfront.container .ui.ui.ui.inverted.olive.basic.tag.label {
  border: 1px solid #d9e778;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .olive.label:before,
.kb-labfront.container .ui.ui.ui.inverted.olive.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.green.labels .label,
.kb-labfront.container .ui.ui.ui.green.label {
  background-color: #21ba45;
  border-color: #21ba45;
  color: #ffffff;
}
.kb-labfront.container .ui.green.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.green.label:hover {
  background-color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
  border-color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.green.ribbon.label {
  border-color: rgb(25.3150684932, 142.6849315068, 52.9315068493);
}
.kb-labfront.container .ui.basic.labels .green.label,
.kb-labfront.container .ui.ui.ui.basic.green.label {
  background: none #ffffff;
  border-color: #21ba45;
  color: #21ba45;
}
.kb-labfront.container .ui.basic.labels a.green.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.green.label:hover {
  background: none #ffffff;
  border-color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
  color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.inverted.labels .green.label,
.kb-labfront.container .ui.ui.ui.inverted.green.label {
  background-color: #2ecc40;
  border-color: #2ecc40;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.green.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.green.label:hover {
  background-color: rgb(26.666, 172.334, 43.2610886076);
  border-color: rgb(26.666, 172.334, 43.2610886076);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.green.ribbon.label {
  border-color: rgb(36.616, 162.384, 50.944);
}
.kb-labfront.container .ui.inverted.basic.labels .green.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.green.label {
  background-color: #1b1c1d;
  border-color: #2ecc40;
  color: #2ecc40;
}
.kb-labfront.container .ui.inverted.basic.labels a.green.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.green.label:hover {
  border-color: rgb(26.666, 172.334, 43.2610886076);
  background-color: #1b1c1d;
  color: rgb(26.666, 172.334, 43.2610886076);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .green.label,
.kb-labfront.container .ui.ui.ui.inverted.green.basic.tag.label {
  border: 1px solid #2ecc40;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .green.label:before,
.kb-labfront.container .ui.ui.ui.inverted.green.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.teal.labels .label,
.kb-labfront.container .ui.ui.ui.teal.label {
  background-color: #00b5ad;
  border-color: #00b5ad;
  color: #ffffff;
}
.kb-labfront.container .ui.teal.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.teal.label:hover {
  background-color: rgb(0, 155.5, 148.6270718232);
  border-color: rgb(0, 155.5, 148.6270718232);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.teal.ribbon.label {
  border-color: rgb(0, 130, 124.2541436464);
}
.kb-labfront.container .ui.basic.labels .teal.label,
.kb-labfront.container .ui.ui.ui.basic.teal.label {
  background: none #ffffff;
  border-color: #00b5ad;
  color: #00b5ad;
}
.kb-labfront.container .ui.basic.labels a.teal.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.teal.label:hover {
  background: none #ffffff;
  border-color: rgb(0, 155.5, 148.6270718232);
  color: rgb(0, 155.5, 148.6270718232);
}
.kb-labfront.container .ui.inverted.labels .teal.label,
.kb-labfront.container .ui.ui.ui.inverted.teal.label {
  background-color: #6dffff;
  border-color: #6dffff;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.teal.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.teal.label:hover {
  background-color: #3affff;
  border-color: #3affff;
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.teal.ribbon.label {
  border-color: #3affff;
}
.kb-labfront.container .ui.inverted.basic.labels .teal.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.teal.label {
  background-color: #1b1c1d;
  border-color: #6dffff;
  color: #6dffff;
}
.kb-labfront.container .ui.inverted.basic.labels a.teal.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.teal.label:hover {
  border-color: #3affff;
  background-color: #1b1c1d;
  color: #3affff;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .teal.label,
.kb-labfront.container .ui.ui.ui.inverted.teal.basic.tag.label {
  border: 1px solid #6dffff;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .teal.label:before,
.kb-labfront.container .ui.ui.ui.inverted.teal.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.blue.labels .label,
.kb-labfront.container .ui.ui.ui.blue.label {
  background-color: #2185d0;
  border-color: #2185d0;
  color: #ffffff;
}
.kb-labfront.container .ui.blue.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.blue.label:hover {
  background-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
  border-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.blue.ribbon.label {
  border-color: rgb(26.0165975104, 104.8547717842, 163.9834024896);
}
.kb-labfront.container .ui.basic.labels .blue.label,
.kb-labfront.container .ui.ui.ui.basic.blue.label {
  background: none #ffffff;
  border-color: #2185d0;
  color: #2185d0;
}
.kb-labfront.container .ui.basic.labels a.blue.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.blue.label:hover {
  background: none #ffffff;
  border-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
  color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.inverted.labels .blue.label,
.kb-labfront.container .ui.ui.ui.inverted.blue.label {
  background-color: #54c8ff;
  border-color: #54c8ff;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.blue.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.blue.label:hover {
  background-color: rgb(33, 183.5964912281, 255);
  border-color: rgb(33, 183.5964912281, 255);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.blue.ribbon.label {
  border-color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.basic.labels .blue.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.blue.label {
  background-color: #1b1c1d;
  border-color: #54c8ff;
  color: #54c8ff;
}
.kb-labfront.container .ui.inverted.basic.labels a.blue.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.blue.label:hover {
  border-color: rgb(33, 183.5964912281, 255);
  background-color: #1b1c1d;
  color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .blue.label,
.kb-labfront.container .ui.ui.ui.inverted.blue.basic.tag.label {
  border: 1px solid #54c8ff;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .blue.label:before,
.kb-labfront.container .ui.ui.ui.inverted.blue.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.violet.labels .label,
.kb-labfront.container .ui.ui.ui.violet.label {
  background-color: #6435c9;
  border-color: #6435c9;
  color: #ffffff;
}
.kb-labfront.container .ui.violet.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.violet.label:hover {
  background-color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
  border-color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.violet.ribbon.label {
  border-color: rgb(79.9212598425, 42.3582677165, 160.6417322835);
}
.kb-labfront.container .ui.basic.labels .violet.label,
.kb-labfront.container .ui.ui.ui.basic.violet.label {
  background: none #ffffff;
  border-color: #6435c9;
  color: #6435c9;
}
.kb-labfront.container .ui.basic.labels a.violet.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.violet.label:hover {
  background: none #ffffff;
  border-color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
  color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
}
.kb-labfront.container .ui.inverted.labels .violet.label,
.kb-labfront.container .ui.ui.ui.inverted.violet.label {
  background-color: #a291fb;
  border-color: #a291fb;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.violet.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.violet.label:hover {
  background-color: rgb(116.4622641509, 90, 255);
  border-color: rgb(116.4622641509, 90, 255);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.violet.ribbon.label {
  border-color: rgb(120.3947368421, 95.7894736842, 249.2105263158);
}
.kb-labfront.container .ui.inverted.basic.labels .violet.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.violet.label {
  background-color: #1b1c1d;
  border-color: #a291fb;
  color: #a291fb;
}
.kb-labfront.container .ui.inverted.basic.labels a.violet.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.violet.label:hover {
  border-color: rgb(116.4622641509, 90, 255);
  background-color: #1b1c1d;
  color: rgb(116.4622641509, 90, 255);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .violet.label,
.kb-labfront.container .ui.ui.ui.inverted.violet.basic.tag.label {
  border: 1px solid #a291fb;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .violet.label:before,
.kb-labfront.container .ui.ui.ui.inverted.violet.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.purple.labels .label,
.kb-labfront.container .ui.ui.ui.purple.label {
  background-color: #a333c8;
  border-color: #a333c8;
  color: #ffffff;
}
.kb-labfront.container .ui.purple.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.purple.label:hover {
  background-color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
  border-color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.purple.ribbon.label {
  border-color: rgb(129.8804780876, 40.6374501992, 159.3625498008);
}
.kb-labfront.container .ui.basic.labels .purple.label,
.kb-labfront.container .ui.ui.ui.basic.purple.label {
  background: none #ffffff;
  border-color: #a333c8;
  color: #a333c8;
}
.kb-labfront.container .ui.basic.labels a.purple.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.purple.label:hover {
  background: none #ffffff;
  border-color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
  color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
}
.kb-labfront.container .ui.inverted.labels .purple.label,
.kb-labfront.container .ui.ui.ui.inverted.purple.label {
  background-color: #dc73ff;
  border-color: #dc73ff;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.purple.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.purple.label:hover {
  background-color: rgb(207.25, 64, 255);
  border-color: rgb(207.25, 64, 255);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.purple.ribbon.label {
  border-color: rgb(207.25, 64, 255);
}
.kb-labfront.container .ui.inverted.basic.labels .purple.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.purple.label {
  background-color: #1b1c1d;
  border-color: #dc73ff;
  color: #dc73ff;
}
.kb-labfront.container .ui.inverted.basic.labels a.purple.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.purple.label:hover {
  border-color: rgb(207.25, 64, 255);
  background-color: #1b1c1d;
  color: rgb(207.25, 64, 255);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .purple.label,
.kb-labfront.container .ui.ui.ui.inverted.purple.basic.tag.label {
  border: 1px solid #dc73ff;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .purple.label:before,
.kb-labfront.container .ui.ui.ui.inverted.purple.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.pink.labels .label,
.kb-labfront.container .ui.ui.ui.pink.label {
  background-color: #e03997;
  border-color: #e03997;
  color: #ffffff;
}
.kb-labfront.container .ui.pink.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.pink.label:hover {
  background-color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
  border-color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.pink.ribbon.label {
  border-color: rgb(198.864628821, 31.135371179, 125.5458515284);
}
.kb-labfront.container .ui.basic.labels .pink.label,
.kb-labfront.container .ui.ui.ui.basic.pink.label {
  background: none #ffffff;
  border-color: #e03997;
  color: #e03997;
}
.kb-labfront.container .ui.basic.labels a.pink.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.pink.label:hover {
  background: none #ffffff;
  border-color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
  color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
}
.kb-labfront.container .ui.inverted.labels .pink.label,
.kb-labfront.container .ui.ui.ui.inverted.pink.label {
  background-color: #ff8edf;
  border-color: #ff8edf;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.pink.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.pink.label:hover {
  background-color: rgb(255, 91, 208.5575221239);
  border-color: rgb(255, 91, 208.5575221239);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.pink.ribbon.label {
  border-color: rgb(255, 91, 208.5575221239);
}
.kb-labfront.container .ui.inverted.basic.labels .pink.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.pink.label {
  background-color: #1b1c1d;
  border-color: #ff8edf;
  color: #ff8edf;
}
.kb-labfront.container .ui.inverted.basic.labels a.pink.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.pink.label:hover {
  border-color: rgb(255, 91, 208.5575221239);
  background-color: #1b1c1d;
  color: rgb(255, 91, 208.5575221239);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .pink.label,
.kb-labfront.container .ui.ui.ui.inverted.pink.basic.tag.label {
  border: 1px solid #ff8edf;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .pink.label:before,
.kb-labfront.container .ui.ui.ui.inverted.pink.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.brown.labels .label,
.kb-labfront.container .ui.ui.ui.brown.label {
  background-color: #a5673f;
  border-color: #a5673f;
  color: #ffffff;
}
.kb-labfront.container .ui.brown.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.brown.label:hover {
  background-color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
  border-color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.brown.ribbon.label {
  border-color: rgb(128.0921052632, 79.9605263158, 48.9078947368);
}
.kb-labfront.container .ui.basic.labels .brown.label,
.kb-labfront.container .ui.ui.ui.basic.brown.label {
  background: none #ffffff;
  border-color: #a5673f;
  color: #a5673f;
}
.kb-labfront.container .ui.basic.labels a.brown.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.brown.label:hover {
  background: none #ffffff;
  border-color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
  color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
}
.kb-labfront.container .ui.inverted.labels .brown.label,
.kb-labfront.container .ui.ui.ui.inverted.brown.label {
  background-color: #d67c1c;
  border-color: #d67c1c;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.brown.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.brown.label:hover {
  background-color: rgb(178.4508264463, 98.1758331112, 12.5491735537);
  border-color: rgb(178.4508264463, 98.1758331112, 12.5491735537);
  color: #1b1c1d;
}
.kb-labfront.container .ui.ui.ui.inverted.brown.ribbon.label {
  border-color: rgb(168.9008264463, 97.867768595, 22.0991735537);
}
.kb-labfront.container .ui.inverted.basic.labels .brown.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.brown.label {
  background-color: #1b1c1d;
  border-color: #d67c1c;
  color: #d67c1c;
}
.kb-labfront.container .ui.inverted.basic.labels a.brown.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.brown.label:hover {
  border-color: rgb(178.4508264463, 98.1758331112, 12.5491735537);
  background-color: #1b1c1d;
  color: rgb(178.4508264463, 98.1758331112, 12.5491735537);
}
.kb-labfront.container .ui.inverted.basic.tag.labels .brown.label,
.kb-labfront.container .ui.ui.ui.inverted.brown.basic.tag.label {
  border: 1px solid #d67c1c;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .brown.label:before,
.kb-labfront.container .ui.ui.ui.inverted.brown.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.grey.labels .label,
.kb-labfront.container .ui.ui.ui.grey.label {
  background-color: #767676;
  border-color: #767676;
  color: #ffffff;
}
.kb-labfront.container .ui.grey.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.grey.label:hover {
  background-color: rgb(115.775, 94.725, 94.725);
  border-color: rgb(115.775, 94.725, 94.725);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.grey.ribbon.label {
  border-color: rgb(92.5, 92.5, 92.5);
}
.kb-labfront.container .ui.basic.labels .grey.label,
.kb-labfront.container .ui.ui.ui.basic.grey.label {
  background: none #ffffff;
  border-color: #767676;
  color: #767676;
}
.kb-labfront.container .ui.basic.labels a.grey.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.grey.label:hover {
  background: none #ffffff;
  border-color: rgb(115.775, 94.725, 94.725);
  color: rgb(115.775, 94.725, 94.725);
}
.kb-labfront.container .ui.inverted.labels .grey.label,
.kb-labfront.container .ui.ui.ui.inverted.grey.label {
  background-color: #dcddde;
  border-color: #dcddde;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.grey.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.grey.label:hover {
  background-color: rgb(187.8, 195.5, 203.2);
  border-color: rgb(187.8, 195.5, 203.2);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.inverted.grey.ribbon.label {
  border-color: rgb(233.125, 233.75, 234.375);
}
.kb-labfront.container .ui.inverted.basic.labels .grey.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.grey.label {
  background-color: #1b1c1d;
  border-color: #dcddde;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.basic.labels a.grey.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.grey.label:hover {
  border-color: rgb(187.8, 195.5, 203.2);
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .grey.label,
.kb-labfront.container .ui.ui.ui.inverted.grey.basic.tag.label {
  border: 1px solid #dcddde;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .grey.label:before,
.kb-labfront.container .ui.ui.ui.inverted.grey.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.black.labels .label,
.kb-labfront.container .ui.ui.ui.black.label {
  background-color: #1b1c1d;
  border-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container .ui.black.labels a.label:hover,
.kb-labfront.container a.ui.ui.ui.black.label:hover {
  background-color: rgb(13.1803571429, 15.25, 17.3196428571);
  border-color: rgb(13.1803571429, 15.25, 17.3196428571);
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.black.ribbon.label {
  border-color: rgb(2.4107142857, 2.5, 2.5892857143);
}
.kb-labfront.container .ui.basic.labels .black.label,
.kb-labfront.container .ui.ui.ui.basic.black.label {
  background: none #ffffff;
  border-color: #1b1c1d;
  color: #1b1c1d;
}
.kb-labfront.container .ui.basic.labels a.black.label:hover,
.kb-labfront.container a.ui.ui.ui.basic.black.label:hover {
  background: none #ffffff;
  border-color: rgb(13.1803571429, 15.25, 17.3196428571);
  color: rgb(13.1803571429, 15.25, 17.3196428571);
}
.kb-labfront.container .ui.inverted.labels .black.label,
.kb-labfront.container .ui.ui.ui.inverted.black.label {
  background-color: #545454;
  border-color: #545454;
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.labels a.black.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.black.label:hover {
  background-color: black;
  border-color: black;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.inverted.black.ribbon.label {
  border-color: rgb(96.75, 96.75, 96.75);
}
.kb-labfront.container .ui.inverted.basic.labels .black.label,
.kb-labfront.container .ui.ui.ui.inverted.basic.black.label {
  background-color: #1b1c1d;
  border-color: #545454;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.basic.labels a.black.label:hover,
.kb-labfront.container a.ui.ui.ui.inverted.basic.black.label:hover {
  border-color: black;
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .black.label,
.kb-labfront.container .ui.ui.ui.inverted.black.basic.tag.label {
  border: 1px solid #545454;
}
.kb-labfront.container .ui.inverted.basic.tag.labels .black.label:before,
.kb-labfront.container .ui.ui.ui.inverted.black.basic.tag.label:before {
  border-color: inherit;
  border-width: 1px 0 0 1px;
  border-style: inherit;
  background-color: #1b1c1d;
  right: calc(100% + 1px);
}
.kb-labfront.container .ui.horizontal.labels .label,
.kb-labfront.container .ui.horizontal.label {
  margin: 0 0.5em 0 0;
  padding: 0.4em 0.833em;
  min-width: 3em;
  text-align: center;
}
.kb-labfront.container .ui.circular.labels .label,
.kb-labfront.container .ui.circular.label {
  min-width: 2em;
  min-height: 2em;
  padding: 0.5em !important;
  line-height: 1em;
  text-align: center;
  border-radius: 500rem;
}
.kb-labfront.container .ui.empty.circular.labels .label,
.kb-labfront.container .ui.empty.circular.label {
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  width: 0.5em;
  height: 0.5em;
  vertical-align: baseline;
}
.kb-labfront.container .ui.pointing.label {
  position: relative;
}
.kb-labfront.container .ui.attached.pointing.label {
  position: absolute;
}
.kb-labfront.container .ui.pointing.label:before {
  background-color: inherit;
  background-image: inherit;
  border-width: 0;
  border-style: solid;
  border-color: inherit;
}
.kb-labfront.container .ui.pointing.label:before {
  position: absolute;
  content: "";
  transform: rotate(45deg);
  background-image: none;
  z-index: 2;
  width: 0.6666em;
  height: 0.6666em;
  transition: none;
}
.kb-labfront.container .ui.pointing.label,
.kb-labfront.container .ui[class*="pointing above"].label {
  margin-top: 1em;
}
.kb-labfront.container .ui.pointing.label:before,
.kb-labfront.container .ui[class*="pointing above"].label:before {
  border-width: 1px 0 0 1px;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  top: 0;
  left: 50%;
}
.kb-labfront.container .ui[class*="bottom pointing"].label,
.kb-labfront.container .ui[class*="pointing below"].label {
  margin-top: 0;
  margin-bottom: 1em;
}
.kb-labfront.container .ui[class*="bottom pointing"].label:before,
.kb-labfront.container .ui[class*="pointing below"].label:before {
  border-width: 0 1px 1px 0;
  top: auto;
  right: auto;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  top: 100%;
  left: 50%;
}
.kb-labfront.container .ui[class*="left pointing"].label {
  margin-top: 0;
  margin-left: 0.6666em;
}
.kb-labfront.container .ui[class*="left pointing"].label:before {
  border-width: 0 0 1px 1px;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  bottom: auto;
  right: auto;
  top: 50%;
  left: 0;
}
.kb-labfront.container .ui[class*="right pointing"].label {
  margin-top: 0;
  margin-right: 0.6666em;
}
.kb-labfront.container .ui[class*="right pointing"].label:before {
  border-width: 1px 1px 0 0;
  transform: translateX(50%) translateY(-50%) rotate(45deg);
  top: 50%;
  right: 0;
  bottom: auto;
  left: auto;
}
.kb-labfront.container .ui.basic.pointing.label:before {
  border-color: inherit;
}
.kb-labfront.container .ui.basic.pointing.label:before,
.kb-labfront.container .ui.basic[class*="pointing above"].label:before {
  margin-top: -1px;
}
.kb-labfront.container .ui.basic[class*="bottom pointing"].label:before,
.kb-labfront.container .ui.basic[class*="pointing below"].label:before {
  bottom: auto;
  top: 100%;
  margin-top: 1px;
}
.kb-labfront.container .ui.basic[class*="left pointing"].label:before {
  top: 50%;
  left: -1px;
}
.kb-labfront.container .ui.basic[class*="right pointing"].label:before {
  top: 50%;
  right: -1px;
}
.kb-labfront.container .ui.floating.label {
  position: absolute;
  z-index: 100;
  top: -1em;
  right: 0;
  white-space: nowrap;
  transform: translateX(50%);
}
.kb-labfront.container .ui.right.aligned.floating.label {
  transform: translateX(1.2em);
}
.kb-labfront.container .ui.left.floating.label {
  left: 0;
  right: auto;
  transform: translateX(-50%);
}
.kb-labfront.container .ui.left.aligned.floating.label {
  transform: translateX(-1.2em);
}
.kb-labfront.container .ui.bottom.floating.label {
  top: auto;
  bottom: -1em;
}
.kb-labfront.container .ui.mini.labels .label,
.kb-labfront.container .ui.mini.label {
  font-size: 0.6428571429rem;
}
.kb-labfront.container .ui.tiny.labels .label,
.kb-labfront.container .ui.tiny.label {
  font-size: 0.7142857143rem;
}
.kb-labfront.container .ui.small.labels .label,
.kb-labfront.container .ui.small.label {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.labels .label,
.kb-labfront.container .ui.label {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.large.labels .label,
.kb-labfront.container .ui.large.label {
  font-size: 1rem;
}
.kb-labfront.container .ui.big.labels .label,
.kb-labfront.container .ui.big.label {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.labels .label,
.kb-labfront.container .ui.huge.label {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.labels .label,
.kb-labfront.container .ui.massive.label {
  font-size: 1.7142857143rem;
}
.kb-labfront.container ul.ui.list,
.kb-labfront.container ol.ui.list,
.kb-labfront.container .ui.list {
  list-style-type: none;
  margin: 1em 0;
  padding: 0 0;
}
.kb-labfront.container ul.ui.list:first-child,
.kb-labfront.container ol.ui.list:first-child,
.kb-labfront.container .ui.list:first-child {
  margin-top: 0;
  padding-top: 0;
}
.kb-labfront.container ul.ui.list:last-child,
.kb-labfront.container ol.ui.list:last-child,
.kb-labfront.container .ui.list:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}
.kb-labfront.container ul.ui.list li,
.kb-labfront.container ol.ui.list li,
.kb-labfront.container .ui.list > .item,
.kb-labfront.container .ui.list .list > .item {
  display: list-item;
  table-layout: fixed;
  list-style-type: none;
  list-style-position: outside;
  padding: 0.2142857143em 0;
  line-height: 1.1428571429em;
}
.kb-labfront.container ul.ui.list > li:first-child:after,
.kb-labfront.container ol.ui.list > li:first-child:after,
.kb-labfront.container .ui.list > .list > .item:after,
.kb-labfront.container .ui.list > .item:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.kb-labfront.container ul.ui.list li:first-child,
.kb-labfront.container ol.ui.list li:first-child,
.kb-labfront.container .ui.list .list > .item:first-child,
.kb-labfront.container .ui.list > .item:first-child {
  padding-top: 0;
}
.kb-labfront.container ul.ui.list li:last-child,
.kb-labfront.container ol.ui.list li:last-child,
.kb-labfront.container .ui.list .list > .item:last-child,
.kb-labfront.container .ui.list > .item:last-child {
  padding-bottom: 0;
}
.kb-labfront.container ul.ui.list ul,
.kb-labfront.container ol.ui.list ol,
.kb-labfront.container .ui.list .list:not(.icon) {
  clear: both;
  margin: 0;
  padding: 0.75em 0 0.25em 0.5em;
}
.kb-labfront.container ul.ui.list ul li,
.kb-labfront.container ol.ui.list ol li,
.kb-labfront.container .ui.list .list > .item {
  padding: 0.1428571429em 0;
  line-height: inherit;
}
.kb-labfront.container .ui.list .list > .item > i.icon,
.kb-labfront.container .ui.list > .item > i.icon {
  display: table-cell;
  min-width: 1.55em;
  margin: 0;
  padding-top: 0;
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.list .list > .item > i.icon:not(.loading),
.kb-labfront.container .ui.list > .item > i.icon:not(.loading) {
  padding-right: 0.2857142857em;
  vertical-align: top;
}
.kb-labfront.container .ui.list .list > .item > i.icon:only-child,
.kb-labfront.container .ui.list > .item > i.icon:only-child {
  display: inline-block;
  min-width: auto;
  vertical-align: top;
}
.kb-labfront.container .ui.list .list > .item > .image,
.kb-labfront.container .ui.list > .item > .image {
  display: table-cell;
  background-color: transparent;
  margin: 0;
  vertical-align: top;
}
.kb-labfront.container .ui.list .list > .item > .image:not(:only-child):not(img),
.kb-labfront.container .ui.list > .item > .image:not(:only-child):not(img) {
  padding-right: 0.5em;
}
.kb-labfront.container .ui.list .list > .item > .image img,
.kb-labfront.container .ui.list > .item > .image img {
  vertical-align: top;
}
.kb-labfront.container .ui.list .list > .item > img.image,
.kb-labfront.container .ui.list .list > .item > .image:only-child,
.kb-labfront.container .ui.list > .item > img.image,
.kb-labfront.container .ui.list > .item > .image:only-child {
  display: inline-block;
}
.kb-labfront.container .ui.list .list > .item > .content,
.kb-labfront.container .ui.list > .item > .content {
  line-height: 1.1428571429em;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.list .list > .item > .image + .content,
.kb-labfront.container .ui.list .list > .item > .icon + .content,
.kb-labfront.container .ui.list > .item > .image + .content,
.kb-labfront.container .ui.list > .item > .icon + .content {
  display: table-cell;
  width: 100%;
  padding: 0 0 0 0.5em;
  vertical-align: top;
}
.kb-labfront.container .ui.list .list > .item > .loading.icon + .content,
.kb-labfront.container .ui.list > .item > .loading.icon + .content {
  padding-left: calc(0.2857142857em + 0.5em);
}
.kb-labfront.container .ui.list .list > .item > img.image + .content,
.kb-labfront.container .ui.list > .item > img.image + .content {
  display: inline-block;
  width: auto;
}
.kb-labfront.container .ui.list .list > .item > .content > .list,
.kb-labfront.container .ui.list > .item > .content > .list {
  margin-left: 0;
  padding-left: 0;
}
.kb-labfront.container .ui.list .list > .item .header,
.kb-labfront.container .ui.list > .item .header {
  display: block;
  margin: 0;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.list .list > .item .description,
.kb-labfront.container .ui.list > .item .description {
  display: block;
  color: rgba(0, 0, 0, 0.7);
}
.kb-labfront.container .ui.list > .item a,
.kb-labfront.container .ui.list .list > .item a {
  cursor: pointer;
}
.kb-labfront.container .ui.list .list > a.item,
.kb-labfront.container .ui.list > a.item {
  cursor: pointer;
  color: #4183c4;
}
.kb-labfront.container .ui.list .list > a.item:hover,
.kb-labfront.container .ui.list > a.item:hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.list .list > a.item > i.icon,
.kb-labfront.container .ui.list > a.item > i.icon {
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.list .list > .item a.header,
.kb-labfront.container .ui.list > .item a.header {
  cursor: pointer;
  color: #4183c4 !important;
}
.kb-labfront.container .ui.list .list > .item > a.header:hover,
.kb-labfront.container .ui.list > .item > a.header:hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301) !important;
}
.kb-labfront.container .ui[class*="left floated"].list {
  float: left;
}
.kb-labfront.container .ui[class*="right floated"].list {
  float: right;
}
.kb-labfront.container .ui.list .list > .item [class*="left floated"],
.kb-labfront.container .ui.list > .item [class*="left floated"] {
  float: left;
  margin: 0 1em 0 0;
}
.kb-labfront.container .ui.list .list > .item [class*="right floated"],
.kb-labfront.container .ui.list > .item [class*="right floated"] {
  float: right;
  margin: 0 0 0 1em;
}
.kb-labfront.container .ui.menu .ui.list > .item,
.kb-labfront.container .ui.menu .ui.list .list > .item {
  display: list-item;
  table-layout: fixed;
  background-color: transparent;
  list-style-type: none;
  list-style-position: outside;
  padding: 0.2142857143em 0;
  line-height: 1.1428571429em;
}
.kb-labfront.container .ui.menu .ui.list .list > .item:before,
.kb-labfront.container .ui.menu .ui.list > .item:before {
  border: none;
  background: none;
}
.kb-labfront.container .ui.menu .ui.list .list > .item:first-child,
.kb-labfront.container .ui.menu .ui.list > .item:first-child {
  padding-top: 0;
}
.kb-labfront.container .ui.menu .ui.list .list > .item:last-child,
.kb-labfront.container .ui.menu .ui.list > .item:last-child {
  padding-bottom: 0;
}
.kb-labfront.container .ui.horizontal.list {
  display: inline-block;
  font-size: 0;
}
.kb-labfront.container .ui.horizontal.list > .item {
  display: inline-block;
  margin-right: 1em;
  font-size: 1rem;
}
.kb-labfront.container .ui.horizontal.list:not(.celled) > .item:last-child {
  margin-right: 0;
  padding-right: 0;
}
.kb-labfront.container .ui.horizontal.list .list:not(.icon) {
  padding-left: 0;
  padding-bottom: 0;
}
.kb-labfront.container .ui.horizontal.list > .item > .image,
.kb-labfront.container .ui.horizontal.list .list > .item > .image,
.kb-labfront.container .ui.horizontal.list > .item > .icon,
.kb-labfront.container .ui.horizontal.list .list > .item > .icon,
.kb-labfront.container .ui.horizontal.list > .item > .content,
.kb-labfront.container .ui.horizontal.list .list > .item > .content {
  vertical-align: middle;
}
.kb-labfront.container .ui.horizontal.list > .item:first-child,
.kb-labfront.container .ui.horizontal.list > .item:last-child {
  padding-top: 0.2142857143em;
  padding-bottom: 0.2142857143em;
}
.kb-labfront.container .ui.horizontal.list > .item > i.icon {
  margin: 0;
  padding: 0 0.25em 0 0;
}
.kb-labfront.container .ui.horizontal.list > .item > .image + .content,
.kb-labfront.container .ui.horizontal.list > .item > .icon,
.kb-labfront.container .ui.horizontal.list > .item > .icon + .content {
  float: none;
  display: inline-block;
  width: auto;
}
.kb-labfront.container .ui.horizontal.list > .item > .image {
  display: inline-block;
}
.kb-labfront.container .ui.list .list > .disabled.item,
.kb-labfront.container .ui.list > .disabled.item {
  pointer-events: none;
  color: rgba(0, 0, 0, 0.2) !important;
}
.kb-labfront.container .ui.inverted.list .list > .disabled.item,
.kb-labfront.container .ui.inverted.list > .disabled.item {
  color: rgba(255, 255, 255, 0.2) !important;
}
.kb-labfront.container .ui.list .list > a.item:hover > .icon,
.kb-labfront.container .ui.list > a.item:hover > .icon {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.inverted.list .list > a.item > .icon,
.kb-labfront.container .ui.inverted.list > a.item > .icon {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.list .list > .item .header,
.kb-labfront.container .ui.inverted.list > .item .header {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.list .list > .item .description,
.kb-labfront.container .ui.inverted.list > .item .description {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.list .list > .item > .content,
.kb-labfront.container .ui.inverted.list > .item > .content {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.list .list > a.item,
.kb-labfront.container .ui.inverted.list > a.item {
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.list .list > a.item:hover,
.kb-labfront.container .ui.inverted.list > a.item:hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.inverted.list .item a:not(.ui) {
  color: rgba(255, 255, 255, 0.9) !important;
}
.kb-labfront.container .ui.inverted.list .item a:not(.ui):hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301) !important;
}
.kb-labfront.container .ui.list[class*="top aligned"] .image,
.kb-labfront.container .ui.list[class*="top aligned"] .content,
.kb-labfront.container .ui.list [class*="top aligned"] {
  vertical-align: top !important;
}
.kb-labfront.container .ui.list[class*="middle aligned"] .image,
.kb-labfront.container .ui.list[class*="middle aligned"] .content,
.kb-labfront.container .ui.list [class*="middle aligned"] {
  vertical-align: middle !important;
}
.kb-labfront.container .ui.list[class*="bottom aligned"] .image,
.kb-labfront.container .ui.list[class*="bottom aligned"] .content,
.kb-labfront.container .ui.list [class*="bottom aligned"] {
  vertical-align: bottom !important;
}
.kb-labfront.container .ui.link.list .item,
.kb-labfront.container .ui.link.list a.item,
.kb-labfront.container .ui.link.list .item a:not(.ui) {
  color: rgba(0, 0, 0, 0.4);
  transition: 0.1s color ease;
}
.kb-labfront.container .ui.link.list.list a.item:hover,
.kb-labfront.container .ui.link.list.list .item a:not(.ui):hover {
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.link.list.list a.item:active,
.kb-labfront.container .ui.link.list.list .item a:not(.ui):active {
  color: rgba(0, 0, 0, 0.9);
}
.kb-labfront.container .ui.link.list.list .active.item,
.kb-labfront.container .ui.link.list.list .active.item a:not(.ui) {
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.inverted.link.list .item,
.kb-labfront.container .ui.inverted.link.list a.item,
.kb-labfront.container .ui.inverted.link.list .item a:not(.ui) {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.inverted.link.list.list a.item:hover,
.kb-labfront.container .ui.inverted.link.list.list .item a:not(.ui):hover {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.link.list.list a.item:active,
.kb-labfront.container .ui.inverted.link.list.list .item a:not(.ui):active {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.link.list.list a.active.item,
.kb-labfront.container .ui.inverted.link.list.list .active.item a:not(.ui) {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.selection.list .list > .item,
.kb-labfront.container .ui.selection.list > .item {
  cursor: pointer;
  background: transparent;
  padding: 0.5em 0.5em;
  margin: 0;
  color: rgba(0, 0, 0, 0.4);
  border-radius: 0.5em;
  transition: 0.1s color ease, 0.1s padding-left ease, 0.1s background-color ease;
}
.kb-labfront.container .ui.selection.list .list > .item:last-child,
.kb-labfront.container .ui.selection.list > .item:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.selection.list .list > .item:hover,
.kb-labfront.container .ui.selection.list > .item:hover {
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.selection.list .list > .item:active,
.kb-labfront.container .ui.selection.list > .item:active {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.9);
}
.kb-labfront.container .ui.selection.list .list > .item.active,
.kb-labfront.container .ui.selection.list > .item.active {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.inverted.selection.list > .item {
  background: transparent;
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.inverted.selection.list > .item:hover {
  background: rgba(255, 255, 255, 0.02);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.selection.list > .item:active {
  background: rgba(255, 255, 255, 0.08);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.selection.list > .item.active {
  background: rgba(255, 255, 255, 0.08);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.celled.selection.list .list > .item,
.kb-labfront.container .ui.divided.selection.list .list > .item,
.kb-labfront.container .ui.celled.selection.list > .item,
.kb-labfront.container .ui.divided.selection.list > .item {
  border-radius: 0;
}
.kb-labfront.container .ui.animated.list > .item {
  transition: 0.25s color ease 0.1s, 0.25s padding-left ease 0.1s, 0.25s background-color ease 0.1s;
}
.kb-labfront.container .ui.animated.list:not(.horizontal) > .item:hover {
  padding-left: 1em;
}
.kb-labfront.container .ui.fitted.list:not(.selection) .list > .item,
.kb-labfront.container .ui.fitted.list:not(.selection) > .item {
  padding-left: 0;
  padding-right: 0;
}
.kb-labfront.container .ui.fitted.selection.list .list > .item,
.kb-labfront.container .ui.fitted.selection.list > .item {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.kb-labfront.container ul.ui.list,
.kb-labfront.container .ui.bulleted.list {
  margin-left: 1.25rem;
}
.kb-labfront.container ul.ui.list li,
.kb-labfront.container .ui.bulleted.list .list > .item,
.kb-labfront.container .ui.bulleted.list > .item {
  position: relative;
}
.kb-labfront.container ul.ui.list li:before,
.kb-labfront.container .ui.bulleted.list .list > .item:before,
.kb-labfront.container .ui.bulleted.list > .item:before {
  user-select: none;
  pointer-events: none;
  position: absolute;
  top: auto;
  left: auto;
  font-weight: normal;
  margin-left: -1.25rem;
  content: "•";
  opacity: 1;
  color: inherit;
  vertical-align: top;
}
.kb-labfront.container ul.ui.list li:before,
.kb-labfront.container .ui.bulleted.list .list > a.item:before,
.kb-labfront.container .ui.bulleted.list > a.item:before {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container ul.ui.list ul,
.kb-labfront.container .ui.bulleted.list .list:not(.icon) {
  padding-left: 1.25rem;
}
.kb-labfront.container ul.ui.horizontal.bulleted.list,
.kb-labfront.container .ui.horizontal.bulleted.list {
  margin-left: 0;
}
.kb-labfront.container ul.ui.horizontal.bulleted.list li,
.kb-labfront.container .ui.horizontal.bulleted.list > .item {
  margin-left: 1.75em;
}
.kb-labfront.container ul.ui.horizontal.bulleted.list li:first-child,
.kb-labfront.container .ui.horizontal.bulleted.list > .item:first-child {
  margin-left: 0;
}
.kb-labfront.container ul.ui.horizontal.bulleted.list li::before,
.kb-labfront.container .ui.horizontal.bulleted.list > .item::before {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container ul.ui.horizontal.bulleted.list li:first-child::before,
.kb-labfront.container .ui.horizontal.bulleted.list > .item:first-child::before {
  display: none;
}
.kb-labfront.container ol.ui.list,
.kb-labfront.container .ui.ordered.list,
.kb-labfront.container .ui.ordered.list .list:not(.icon),
.kb-labfront.container ol.ui.list ol {
  counter-reset: ordered;
  margin-left: 1.25rem;
  list-style-type: none;
}
.kb-labfront.container ol.ui.list li,
.kb-labfront.container .ui.ordered.list .list > .item,
.kb-labfront.container .ui.ordered.list > .item {
  list-style-type: none;
  position: relative;
}
.kb-labfront.container ol.ui.list li:before,
.kb-labfront.container .ui.ordered.list .list > .item:before,
.kb-labfront.container .ui.ordered.list > .item:before {
  position: absolute;
  top: auto;
  left: auto;
  user-select: none;
  pointer-events: none;
  margin-left: -1.25rem;
  counter-increment: ordered;
  content: counters(ordered, ".") " ";
  text-align: right;
  color: rgba(0, 0, 0, 0.87);
  vertical-align: middle;
  opacity: 0.8;
}
.kb-labfront.container ol.ui.inverted.list li:before,
.kb-labfront.container .ui.ordered.inverted.list .list > .item:before,
.kb-labfront.container .ui.ordered.inverted.list > .item:before {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.ordered.list .list > .item[data-value]:before,
.kb-labfront.container .ui.ordered.list > .item[data-value]:before {
  content: attr(data-value);
}
.kb-labfront.container ol.ui.list li[value]:before {
  content: attr(value);
}
.kb-labfront.container ol.ui.list ol,
.kb-labfront.container .ui.ordered.list .list:not(.icon) {
  margin-left: 1em;
}
.kb-labfront.container ol.ui.list ol li:before,
.kb-labfront.container .ui.ordered.list .list > .item:before {
  margin-left: -2em;
}
.kb-labfront.container ol.ui.horizontal.list,
.kb-labfront.container .ui.ordered.horizontal.list {
  margin-left: 0;
}
.kb-labfront.container ol.ui.horizontal.list li:before,
.kb-labfront.container .ui.ordered.horizontal.list .list > .item:before,
.kb-labfront.container .ui.ordered.horizontal.list > .item:before {
  position: static;
  margin: 0 0.5em 0 0;
}
.kb-labfront.container ol.ui.suffixed.list li:before,
.kb-labfront.container .ui.suffixed.ordered.list .list > .item:before,
.kb-labfront.container .ui.suffixed.ordered.list > .item:before {
  content: counters(ordered, ".") ".";
}
.kb-labfront.container .ui.divided.list > .item {
  border-top: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.divided.list .list > .item {
  border-top: none;
}
.kb-labfront.container .ui.divided.list .item .list > .item {
  border-top: none;
}
.kb-labfront.container .ui.divided.list .list > .item:first-child,
.kb-labfront.container .ui.divided.list > .item:first-child {
  border-top: none;
}
.kb-labfront.container .ui.divided.list:not(.horizontal) .list > .item:first-child {
  border-top-width: 1px;
}
.kb-labfront.container .ui.divided.bulleted.list:not(.horizontal),
.kb-labfront.container .ui.divided.bulleted.list .list:not(.icon) {
  margin-left: 0;
  padding-left: 0;
}
.kb-labfront.container .ui.divided.bulleted.list > .item:not(.horizontal) {
  padding-left: 1.25rem;
}
.kb-labfront.container .ui.divided.ordered.list {
  margin-left: 0;
}
.kb-labfront.container .ui.divided.ordered.list .list > .item,
.kb-labfront.container .ui.divided.ordered.list > .item {
  padding-left: 1.25rem;
}
.kb-labfront.container .ui.divided.ordered.list .item .list:not(.icon) {
  margin-left: 0;
  margin-right: 0;
  padding-bottom: 0.2142857143em;
}
.kb-labfront.container .ui.divided.ordered.list .item .list > .item {
  padding-left: 1em;
}
.kb-labfront.container .ui.divided.selection.list .list > .item,
.kb-labfront.container .ui.divided.selection.list > .item {
  margin: 0;
  border-radius: 0;
}
.kb-labfront.container .ui.divided.horizontal.list {
  margin-left: 0;
}
.kb-labfront.container .ui.divided.horizontal.list > .item {
  padding-left: 0.5em;
}
.kb-labfront.container .ui.divided.horizontal.list > .item:not(:last-child) {
  padding-right: 0.5em;
}
.kb-labfront.container .ui.divided.horizontal.list > .item {
  border-top: none;
  border-right: 1px solid rgba(34, 36, 38, 0.15);
  margin: 0;
  line-height: 0.6;
}
.kb-labfront.container .ui.horizontal.divided.list > .item:last-child {
  border-right: none;
}
.kb-labfront.container .ui.divided.inverted.list > .item,
.kb-labfront.container .ui.divided.inverted.list > .list,
.kb-labfront.container .ui.divided.inverted.horizontal.list > .item {
  border-color: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.celled.list > .item,
.kb-labfront.container .ui.celled.list > .list {
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.kb-labfront.container .ui.celled.list > .item:last-child {
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.celled.list > .item:first-child,
.kb-labfront.container .ui.celled.list > .item:last-child {
  padding-top: 0.2142857143em;
  padding-bottom: 0.2142857143em;
}
.kb-labfront.container .ui.celled.list .item .list > .item {
  border-width: 0;
}
.kb-labfront.container .ui.celled.list .list > .item:first-child {
  border-top-width: 0;
}
.kb-labfront.container .ui.celled.bulleted.list {
  margin-left: 0;
}
.kb-labfront.container .ui.celled.bulleted.list .list > .item,
.kb-labfront.container .ui.celled.bulleted.list > .item {
  padding-left: 1.25rem;
}
.kb-labfront.container .ui.celled.bulleted.list .item .list:not(.icon) {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  padding-bottom: 0.2142857143em;
}
.kb-labfront.container .ui.celled.ordered.list {
  margin-left: 0;
}
.kb-labfront.container .ui.celled.ordered.list .list > .item,
.kb-labfront.container .ui.celled.ordered.list > .item {
  padding-left: 1.25rem;
}
.kb-labfront.container .ui.celled.ordered.list .item .list:not(.icon) {
  margin-left: 0;
  margin-right: 0;
  padding-bottom: 0.2142857143em;
}
.kb-labfront.container .ui.celled.ordered.list .list > .item {
  padding-left: 1em;
}
.kb-labfront.container .ui.horizontal.celled.list {
  margin-left: 0;
}
.kb-labfront.container .ui.horizontal.celled.list .list > .item,
.kb-labfront.container .ui.horizontal.celled.list > .item {
  border-top: none;
  border-left: 1px solid rgba(34, 36, 38, 0.15);
  margin: 0;
  padding-left: 0.5em;
  padding-right: 0.5em;
  line-height: 0.6;
}
.kb-labfront.container .ui.horizontal.celled.list .list > .item:last-child,
.kb-labfront.container .ui.horizontal.celled.list > .item:last-child {
  border-bottom: none;
  border-right: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.celled.inverted.list > .item,
.kb-labfront.container .ui.celled.inverted.list > .list {
  border-color: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.celled.inverted.horizontal.list .list > .item,
.kb-labfront.container .ui.celled.inverted.horizontal.list > .item {
  border-color: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.relaxed.list:not(.horizontal) > .item:not(:first-child) {
  padding-top: 0.4285714286em;
}
.kb-labfront.container .ui.relaxed.list:not(.horizontal) > .item:not(:last-child) {
  padding-bottom: 0.4285714286em;
}
.kb-labfront.container .ui.horizontal.relaxed.list .list > .item:not(:first-child),
.kb-labfront.container .ui.horizontal.relaxed.list > .item:not(:first-child) {
  padding-left: 1rem;
}
.kb-labfront.container .ui.horizontal.relaxed.list .list > .item:not(:last-child),
.kb-labfront.container .ui.horizontal.relaxed.list > .item:not(:last-child) {
  padding-right: 1rem;
}
.kb-labfront.container .ui[class*="very relaxed"].list:not(.horizontal) > .item:not(:first-child) {
  padding-top: 0.8571428571em;
}
.kb-labfront.container .ui[class*="very relaxed"].list:not(.horizontal) > .item:not(:last-child) {
  padding-bottom: 0.8571428571em;
}
.kb-labfront.container .ui.horizontal[class*="very relaxed"].list .list > .item:not(:first-child),
.kb-labfront.container .ui.horizontal[class*="very relaxed"].list > .item:not(:first-child) {
  padding-left: 1.5rem;
}
.kb-labfront.container .ui.horizontal[class*="very relaxed"].list .list > .item:not(:last-child),
.kb-labfront.container .ui.horizontal[class*="very relaxed"].list > .item:not(:last-child) {
  padding-right: 1.5rem;
}
.kb-labfront.container .ui.mini.list {
  font-size: 0.7857142857em;
}
.kb-labfront.container .ui.tiny.list {
  font-size: 0.8571428571em;
}
.kb-labfront.container .ui.small.list {
  font-size: 0.9285714286em;
}
.kb-labfront.container .ui.list {
  font-size: 1em;
}
.kb-labfront.container .ui.large.list {
  font-size: 1.1428571429em;
}
.kb-labfront.container .ui.big.list {
  font-size: 1.2857142857em;
}
.kb-labfront.container .ui.huge.list {
  font-size: 1.4285714286em;
}
.kb-labfront.container .ui.massive.list {
  font-size: 1.7142857143em;
}
.kb-labfront.container .ui.mini.horizontal.list .list > .item,
.kb-labfront.container .ui.mini.horizontal.list > .item {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.horizontal.list .list > .item,
.kb-labfront.container .ui.tiny.horizontal.list > .item {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.horizontal.list .list > .item,
.kb-labfront.container .ui.small.horizontal.list > .item {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.horizontal.list .list > .item,
.kb-labfront.container .ui.horizontal.list > .item {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.horizontal.list .list > .item,
.kb-labfront.container .ui.large.horizontal.list > .item {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.horizontal.list .list > .item,
.kb-labfront.container .ui.big.horizontal.list > .item {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.horizontal.list .list > .item,
.kb-labfront.container .ui.huge.horizontal.list > .item {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.horizontal.list .list > .item,
.kb-labfront.container .ui.massive.horizontal.list > .item {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.loader {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0;
  text-align: center;
  z-index: 1000;
  transform: translateX(-50%) translateY(-50%);
}
.kb-labfront.container .ui.loader:before {
  position: absolute;
  content: "";
  top: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.loader:after {
  position: absolute;
  content: "";
  top: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  animation: loader 0.6s infinite linear;
  border: 0.2em solid #767676;
  border-radius: 500rem;
  box-shadow: 0 0 0 1px transparent;
}
.kb-labfront.container .ui.fast.loading.loading:after,
.kb-labfront.container .ui.fast.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.fast.loading.loading > i.icon:after,
.kb-labfront.container .ui.fast.loader:after {
  animation-duration: 0.3s;
}
.kb-labfront.container .ui.slow.loading.loading:after,
.kb-labfront.container .ui.slow.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.slow.loading.loading > i.icon:after,
.kb-labfront.container .ui.slow.loader:after {
  animation-duration: 0.9s;
}
@keyframes loader {
  100% {
    transform: rotate(360deg);
  }
}
.kb-labfront.container .ui.mini.loader:before,
.kb-labfront.container .ui.mini.loader:after {
  width: 1rem;
  height: 1rem;
  margin: 0 0 0 -0.5rem;
}
.kb-labfront.container .ui.tiny.loader:before,
.kb-labfront.container .ui.tiny.loader:after {
  width: 1.1428571429rem;
  height: 1.1428571429rem;
  margin: 0 0 0 -0.5714285714rem;
}
.kb-labfront.container .ui.small.loader:before,
.kb-labfront.container .ui.small.loader:after {
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  margin: 0 0 0 -0.8571428571rem;
}
.kb-labfront.container .ui.loader:before,
.kb-labfront.container .ui.loader:after {
  width: 2.2857142857rem;
  height: 2.2857142857rem;
  margin: 0 0 0 -1.1428571429rem;
}
.kb-labfront.container .ui.large.loader:before,
.kb-labfront.container .ui.large.loader:after {
  width: 3.4285714286rem;
  height: 3.4285714286rem;
  margin: 0 0 0 -1.7142857143rem;
}
.kb-labfront.container .ui.big.loader:before,
.kb-labfront.container .ui.big.loader:after {
  width: 3.7142857143rem;
  height: 3.7142857143rem;
  margin: 0 0 0 -1.8571428571rem;
}
.kb-labfront.container .ui.huge.loader:before,
.kb-labfront.container .ui.huge.loader:after {
  width: 4.1428571429rem;
  height: 4.1428571429rem;
  margin: 0 0 0 -2.0714285714rem;
}
.kb-labfront.container .ui.massive.loader:before,
.kb-labfront.container .ui.massive.loader:after {
  width: 4.5714285714rem;
  height: 4.5714285714rem;
  margin: 0 0 0 -2.2857142857rem;
}
.kb-labfront.container .ui.dimmer > .loader {
  display: block;
}
.kb-labfront.container .ui.dimmer > .ui.loader {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.dimmer > .ui.loader:not(.elastic):before {
  border-color: rgba(255, 255, 255, 0.15);
}
.kb-labfront.container .ui.inverted.dimmer > .ui.loader {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.inverted.dimmer > .ui.loader:not(.elastic):before {
  border-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.ui.ui.ui.text.loader {
  width: auto;
  height: auto;
  text-align: center;
  font-style: normal;
}
.kb-labfront.container .ui.indeterminate.loader:after {
  animation-direction: reverse;
  animation-duration: 1.2s;
}
.kb-labfront.container .ui.loader.active,
.kb-labfront.container .ui.loader.visible {
  display: block;
}
.kb-labfront.container .ui.loader.disabled,
.kb-labfront.container .ui.loader.hidden {
  display: none;
}
.kb-labfront.container .ui.mini.loader {
  width: 1rem;
  height: 1rem;
  font-size: 0.7857142857em;
}
.kb-labfront.container .ui.tiny.loader {
  width: 1.1428571429rem;
  height: 1.1428571429rem;
  font-size: 0.8571428571em;
}
.kb-labfront.container .ui.small.loader {
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  font-size: 0.9285714286em;
}
.kb-labfront.container .ui.loader {
  width: 2.2857142857rem;
  height: 2.2857142857rem;
  font-size: 1em;
}
.kb-labfront.container .ui.large.loader {
  width: 3.4285714286rem;
  height: 3.4285714286rem;
  font-size: 1.1428571429em;
}
.kb-labfront.container .ui.big.loader {
  width: 3.7142857143rem;
  height: 3.7142857143rem;
  font-size: 1.2857142857em;
}
.kb-labfront.container .ui.huge.loader {
  width: 4.1428571429rem;
  height: 4.1428571429rem;
  font-size: 1.4285714286em;
}
.kb-labfront.container .ui.massive.loader {
  width: 4.5714285714rem;
  height: 4.5714285714rem;
  font-size: 1.7142857143em;
}
.kb-labfront.container .ui.mini.text.loader {
  min-width: 1rem;
  padding-top: 1.7857142857em;
}
.kb-labfront.container .ui.tiny.text.loader {
  min-width: 1.1428571429rem;
  padding-top: 1.9285714286em;
}
.kb-labfront.container .ui.small.text.loader {
  min-width: 1.7142857143rem;
  padding-top: 2.5em;
}
.kb-labfront.container .ui.text.loader {
  min-width: 2.2857142857rem;
  padding-top: 3.0714285714em;
}
.kb-labfront.container .ui.large.text.loader {
  min-width: 3.4285714286rem;
  padding-top: 4.2142857143em;
}
.kb-labfront.container .ui.big.text.loader {
  min-width: 3.7142857143rem;
  padding-top: 4.5em;
}
.kb-labfront.container .ui.huge.text.loader {
  min-width: 4.1428571429rem;
  padding-top: 4.9285714286em;
}
.kb-labfront.container .ui.massive.text.loader {
  min-width: 4.5714285714rem;
  padding-top: 5.3571428571em;
}
.kb-labfront.container .ui.primary.elastic.loader.loader:before,
.kb-labfront.container .ui.primary.basic.elastic.loading.button:before,
.kb-labfront.container .ui.primary.basic.elastic.loading.button:after,
.kb-labfront.container .ui.primary.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.primary.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.primary.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.primary.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.primary.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.primary.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.primary.loader.loader.loader:after {
  color: #2185d0;
}
.kb-labfront.container .ui.inverted.primary.elastic.loader:before,
.kb-labfront.container .ui.inverted.primary.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.primary.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.primary.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.primary.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.primary.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.primary.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.primary.loader.loader.loader:after {
  color: #54c8ff;
}
.kb-labfront.container .ui.secondary.elastic.loader.loader:before,
.kb-labfront.container .ui.secondary.basic.elastic.loading.button:before,
.kb-labfront.container .ui.secondary.basic.elastic.loading.button:after,
.kb-labfront.container .ui.secondary.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.secondary.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.secondary.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.secondary.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.secondary.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.secondary.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.secondary.loader.loader.loader:after {
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.secondary.elastic.loader:before,
.kb-labfront.container .ui.inverted.secondary.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.secondary.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.secondary.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.secondary.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.secondary.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.secondary.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.secondary.loader.loader.loader:after {
  color: #545454;
}
.kb-labfront.container .ui.red.elastic.loader.loader:before,
.kb-labfront.container .ui.red.basic.elastic.loading.button:before,
.kb-labfront.container .ui.red.basic.elastic.loading.button:after,
.kb-labfront.container .ui.red.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.red.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.red.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.red.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.red.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.red.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.red.loader.loader.loader:after {
  color: #db2828;
}
.kb-labfront.container .ui.inverted.red.elastic.loader:before,
.kb-labfront.container .ui.inverted.red.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.red.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.red.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.red.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.red.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.red.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.red.loader.loader.loader:after {
  color: #ff695e;
}
.kb-labfront.container .ui.orange.elastic.loader.loader:before,
.kb-labfront.container .ui.orange.basic.elastic.loading.button:before,
.kb-labfront.container .ui.orange.basic.elastic.loading.button:after,
.kb-labfront.container .ui.orange.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.orange.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.orange.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.orange.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.orange.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.orange.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.orange.loader.loader.loader:after {
  color: #f2711c;
}
.kb-labfront.container .ui.inverted.orange.elastic.loader:before,
.kb-labfront.container .ui.inverted.orange.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.orange.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.orange.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.orange.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.orange.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.orange.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.orange.loader.loader.loader:after {
  color: #ff851b;
}
.kb-labfront.container .ui.yellow.elastic.loader.loader:before,
.kb-labfront.container .ui.yellow.basic.elastic.loading.button:before,
.kb-labfront.container .ui.yellow.basic.elastic.loading.button:after,
.kb-labfront.container .ui.yellow.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.yellow.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.yellow.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.yellow.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.yellow.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.yellow.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.yellow.loader.loader.loader:after {
  color: #fbbd08;
}
.kb-labfront.container .ui.inverted.yellow.elastic.loader:before,
.kb-labfront.container .ui.inverted.yellow.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.yellow.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.yellow.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.yellow.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.yellow.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.yellow.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.yellow.loader.loader.loader:after {
  color: #ffe21f;
}
.kb-labfront.container .ui.olive.elastic.loader.loader:before,
.kb-labfront.container .ui.olive.basic.elastic.loading.button:before,
.kb-labfront.container .ui.olive.basic.elastic.loading.button:after,
.kb-labfront.container .ui.olive.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.olive.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.olive.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.olive.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.olive.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.olive.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.olive.loader.loader.loader:after {
  color: #b5cc18;
}
.kb-labfront.container .ui.inverted.olive.elastic.loader:before,
.kb-labfront.container .ui.inverted.olive.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.olive.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.olive.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.olive.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.olive.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.olive.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.olive.loader.loader.loader:after {
  color: #d9e778;
}
.kb-labfront.container .ui.green.elastic.loader.loader:before,
.kb-labfront.container .ui.green.basic.elastic.loading.button:before,
.kb-labfront.container .ui.green.basic.elastic.loading.button:after,
.kb-labfront.container .ui.green.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.green.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.green.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.green.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.green.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.green.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.green.loader.loader.loader:after {
  color: #21ba45;
}
.kb-labfront.container .ui.inverted.green.elastic.loader:before,
.kb-labfront.container .ui.inverted.green.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.green.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.green.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.green.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.green.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.green.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.green.loader.loader.loader:after {
  color: #2ecc40;
}
.kb-labfront.container .ui.teal.elastic.loader.loader:before,
.kb-labfront.container .ui.teal.basic.elastic.loading.button:before,
.kb-labfront.container .ui.teal.basic.elastic.loading.button:after,
.kb-labfront.container .ui.teal.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.teal.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.teal.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.teal.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.teal.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.teal.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.teal.loader.loader.loader:after {
  color: #00b5ad;
}
.kb-labfront.container .ui.inverted.teal.elastic.loader:before,
.kb-labfront.container .ui.inverted.teal.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.teal.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.teal.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.teal.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.teal.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.teal.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.teal.loader.loader.loader:after {
  color: #6dffff;
}
.kb-labfront.container .ui.blue.elastic.loader.loader:before,
.kb-labfront.container .ui.blue.basic.elastic.loading.button:before,
.kb-labfront.container .ui.blue.basic.elastic.loading.button:after,
.kb-labfront.container .ui.blue.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.blue.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.blue.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.blue.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.blue.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.blue.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.blue.loader.loader.loader:after {
  color: #2185d0;
}
.kb-labfront.container .ui.inverted.blue.elastic.loader:before,
.kb-labfront.container .ui.inverted.blue.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.blue.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.blue.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.blue.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.blue.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.blue.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.blue.loader.loader.loader:after {
  color: #54c8ff;
}
.kb-labfront.container .ui.violet.elastic.loader.loader:before,
.kb-labfront.container .ui.violet.basic.elastic.loading.button:before,
.kb-labfront.container .ui.violet.basic.elastic.loading.button:after,
.kb-labfront.container .ui.violet.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.violet.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.violet.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.violet.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.violet.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.violet.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.violet.loader.loader.loader:after {
  color: #6435c9;
}
.kb-labfront.container .ui.inverted.violet.elastic.loader:before,
.kb-labfront.container .ui.inverted.violet.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.violet.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.violet.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.violet.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.violet.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.violet.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.violet.loader.loader.loader:after {
  color: #a291fb;
}
.kb-labfront.container .ui.purple.elastic.loader.loader:before,
.kb-labfront.container .ui.purple.basic.elastic.loading.button:before,
.kb-labfront.container .ui.purple.basic.elastic.loading.button:after,
.kb-labfront.container .ui.purple.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.purple.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.purple.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.purple.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.purple.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.purple.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.purple.loader.loader.loader:after {
  color: #a333c8;
}
.kb-labfront.container .ui.inverted.purple.elastic.loader:before,
.kb-labfront.container .ui.inverted.purple.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.purple.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.purple.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.purple.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.purple.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.purple.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.purple.loader.loader.loader:after {
  color: #dc73ff;
}
.kb-labfront.container .ui.pink.elastic.loader.loader:before,
.kb-labfront.container .ui.pink.basic.elastic.loading.button:before,
.kb-labfront.container .ui.pink.basic.elastic.loading.button:after,
.kb-labfront.container .ui.pink.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.pink.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.pink.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.pink.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.pink.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.pink.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.pink.loader.loader.loader:after {
  color: #e03997;
}
.kb-labfront.container .ui.inverted.pink.elastic.loader:before,
.kb-labfront.container .ui.inverted.pink.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.pink.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.pink.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.pink.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.pink.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.pink.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.pink.loader.loader.loader:after {
  color: #ff8edf;
}
.kb-labfront.container .ui.brown.elastic.loader.loader:before,
.kb-labfront.container .ui.brown.basic.elastic.loading.button:before,
.kb-labfront.container .ui.brown.basic.elastic.loading.button:after,
.kb-labfront.container .ui.brown.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.brown.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.brown.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.brown.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.brown.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.brown.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.brown.loader.loader.loader:after {
  color: #a5673f;
}
.kb-labfront.container .ui.inverted.brown.elastic.loader:before,
.kb-labfront.container .ui.inverted.brown.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.brown.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.brown.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.brown.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.brown.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.brown.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.brown.loader.loader.loader:after {
  color: #d67c1c;
}
.kb-labfront.container .ui.grey.elastic.loader.loader:before,
.kb-labfront.container .ui.grey.basic.elastic.loading.button:before,
.kb-labfront.container .ui.grey.basic.elastic.loading.button:after,
.kb-labfront.container .ui.grey.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.grey.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.grey.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.grey.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.grey.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.grey.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.grey.loader.loader.loader:after {
  color: #767676;
}
.kb-labfront.container .ui.inverted.grey.elastic.loader:before,
.kb-labfront.container .ui.inverted.grey.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.grey.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.grey.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.grey.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.grey.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.grey.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.grey.loader.loader.loader:after {
  color: #dcddde;
}
.kb-labfront.container .ui.black.elastic.loader.loader:before,
.kb-labfront.container .ui.black.basic.elastic.loading.button:before,
.kb-labfront.container .ui.black.basic.elastic.loading.button:after,
.kb-labfront.container .ui.black.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.black.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.black.elastic.loading.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.black.loading.loading.loading.loading:not(.usual):not(.button):after,
.kb-labfront.container .ui.black.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.black.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.black.loader.loader.loader:after {
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.black.elastic.loader:before,
.kb-labfront.container .ui.inverted.black.elastic.loading.loading.loading:not(.segment):before,
.kb-labfront.container .ui.inverted.black.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.inverted.black.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.inverted.black.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.inverted.black.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.inverted.black.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.inverted.black.loader.loader.loader:after {
  color: #545454;
}
.kb-labfront.container .ui.elastic.loader.loader:before,
.kb-labfront.container .ui.elastic.loading.loading.loading:before,
.kb-labfront.container .ui.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.loading.loading.loading.loading:not(.usual):after,
.kb-labfront.container .ui.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.loader.loader.loader:after {
  border-color: currentColor;
}
.kb-labfront.container .ui.elastic.loading.loading.loading.loading.button:not(.inverted):not(.basic):before {
  color: #ffffff;
}
.kb-labfront.container .ui.elastic.basic.loading.button:before,
.kb-labfront.container .ui.elastic.basic.loading.button:after {
  color: #767676;
}
.kb-labfront.container .ui.double.loading.loading.loading.loading.button:after {
  border-bottom-color: currentColor;
}
.kb-labfront.container .ui.inline.loader {
  position: relative;
  vertical-align: middle;
  margin: 0;
  left: 0;
  top: 0;
  transform: none;
}
.kb-labfront.container .ui.inline.loader.active,
.kb-labfront.container .ui.inline.loader.visible {
  display: inline-block;
}
.kb-labfront.container .ui.centered.inline.loader.active,
.kb-labfront.container .ui.centered.inline.loader.visible {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading:after,
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading > i.icon:after,
.kb-labfront.container .ui.loader.loader.loader.loader.loader:after {
  border-left-color: transparent;
  border-right-color: transparent;
}
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading.loading:not(.double):after,
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading.loading:not(.double) .input > i.icon:after,
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading.loading:not(.double) > i.icon:after,
.kb-labfront.container .ui.loader.loader.loader.loader.loader.loader:not(.double):after {
  border-bottom-color: transparent;
}
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading.segment:after,
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading.form:after {
  border-left-color: rgba(0, 0, 0, 0.1);
  border-right-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading.segment:not(.double):after,
.kb-labfront.container .ui.loading.loading.loading.loading.loading.loading.form:not(.double):after {
  border-bottom-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.dimmer > .ui.elastic.loader {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.dimmer > .ui.elastic.loader {
  color: #767676;
}
.kb-labfront.container .ui.elastic.loading.loading:not(.form):not(.segment):after,
.kb-labfront.container .ui.elastic.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.elastic.loading.loading > i.icon:after,
.kb-labfront.container .ui.elastic.loader.loader:after {
  animation: loader 1s infinite cubic-bezier(0.27, 1.05, 0.92, 0.61);
  animation-delay: 0.3s;
}
.kb-labfront.container .ui.elastic.loading.loading.loading:not(.form):not(.segment):before,
.kb-labfront.container .ui.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.elastic.loader.loader:before {
  animation: elastic-loader 1s infinite cubic-bezier(0.27, 1.05, 0.92, 0.61);
  -moz-animation: currentcolor-elastic-loader 1s infinite cubic-bezier(0.27, 1.05, 0.92, 0.61);
  border-right-color: transparent;
}
.kb-labfront.container .ui.elastic.inline.loader:empty {
  animation: loader 8s infinite linear;
}
.kb-labfront.container .ui.slow.elastic.loading.loading:not(.form):not(.segment):after,
.kb-labfront.container .ui.slow.elastic.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.slow.elastic.loading.loading > i.icon:after,
.kb-labfront.container .ui.slow.elastic.loader.loader:after {
  animation-duration: 1.5s;
  animation-delay: 0.45s;
}
.kb-labfront.container .ui.slow.elastic.loading.loading.loading:not(.form):not(.segment):before,
.kb-labfront.container .ui.slow.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.slow.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.slow.elastic.loader.loader:before {
  animation-duration: 1.5s;
}
.kb-labfront.container .ui.fast.elastic.loading.loading:not(.form):not(.segment):after,
.kb-labfront.container .ui.fast.elastic.loading.loading .input > i.icon:after,
.kb-labfront.container .ui.fast.elastic.loading.loading > i.icon:after,
.kb-labfront.container .ui.fast.elastic.loader.loader:after {
  animation-duration: 0.66s;
  animation-delay: 0.2s;
}
.kb-labfront.container .ui.fast.elastic.loading.loading.loading:not(.form):not(.segment):before,
.kb-labfront.container .ui.fast.elastic.loading.loading.loading .input > i.icon:before,
.kb-labfront.container .ui.fast.elastic.loading.loading.loading > i.icon:before,
.kb-labfront.container .ui.fast.elastic.loader.loader:before {
  animation-duration: 0.66s;
}
@keyframes elastic-loader {
  0%, 1% {
    border-left-color: transparent;
    border-bottom-color: transparent;
  }
  1.1%, 50% {
    border-left-color: inherit;
  }
  10%, 35.1% {
    border-bottom-color: transparent;
  }
  10.1%, 35% {
    border-bottom-color: inherit;
  }
  50.1% {
    border-left-color: transparent;
  }
  100% {
    border-left-color: transparent;
    border-bottom-color: transparent;
    transform: rotate(360deg);
  }
}
@keyframes currentcolor-elastic-loader {
  0%, 1% {
    border-left-color: transparent;
    border-bottom-color: transparent;
  }
  1.1%, 50% {
    border-left-color: currentColor;
  }
  10%, 35.1% {
    border-bottom-color: transparent;
  }
  10.1%, 35% {
    border-bottom-color: currentColor;
  }
  50.1% {
    border-left-color: transparent;
  }
  100% {
    border-left-color: transparent;
    border-bottom-color: transparent;
    transform: rotate(360deg);
  }
}
.kb-labfront.container .ui.placeholder {
  position: static;
  overflow: hidden;
  animation: placeholderShimmer 2s linear;
  animation-iteration-count: infinite;
  background-color: #ffffff;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.08) 0, rgba(0, 0, 0, 0.15) 15%, rgba(0, 0, 0, 0.08) 30%);
  background-size: 1200px 100%;
  max-width: 30rem;
}
@keyframes placeholderShimmer {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}
.kb-labfront.container .ui.placeholder + .ui.placeholder {
  margin-top: 2rem;
}
.kb-labfront.container .ui.placeholder + .ui.placeholder {
  animation-delay: 0.15s;
}
.kb-labfront.container .ui.placeholder + .ui.placeholder + .ui.placeholder {
  animation-delay: 0.3s;
}
.kb-labfront.container .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {
  animation-delay: 0.45s;
}
.kb-labfront.container .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {
  animation-delay: 0.6s;
}
.kb-labfront.container .ui.placeholder,
.kb-labfront.container .ui.placeholder > :before,
.kb-labfront.container .ui.placeholder .image.header:after,
.kb-labfront.container .ui.placeholder .line,
.kb-labfront.container .ui.placeholder .line:after {
  background-color: #ffffff;
}
.kb-labfront.container .ui.placeholder.hidden {
  display: none;
}
.kb-labfront.container .ui.placeholder .image:not(.header):not(.ui):not(.icon) {
  height: 100px;
}
.kb-labfront.container .ui.placeholder .square.image:not(.header) {
  height: 0;
  overflow: hidden;
  /* 1/1 aspect ratio */
  padding-top: 100%;
}
.kb-labfront.container .ui.placeholder .rectangular.image:not(.header) {
  height: 0;
  overflow: hidden;
  /* 4/3 aspect ratio */
  padding-top: 75%;
}
.kb-labfront.container .ui.placeholder .line {
  position: relative;
  height: 0.8571428571em;
}
.kb-labfront.container .ui.placeholder .line:before,
.kb-labfront.container .ui.placeholder .line:after {
  top: 100%;
  position: absolute;
  content: "";
  background-color: inherit;
}
.kb-labfront.container .ui.placeholder .line:before {
  left: 0;
}
.kb-labfront.container .ui.placeholder .line:after {
  right: 0;
}
.kb-labfront.container .ui.placeholder .line {
  margin-bottom: 0.5em;
}
.kb-labfront.container .ui.placeholder .line:before,
.kb-labfront.container .ui.placeholder .line:after {
  height: 0.5em;
}
.kb-labfront.container .ui.placeholder .line:not(:first-child) {
  margin-top: 0.5em;
}
.kb-labfront.container .ui.placeholder .header {
  position: relative;
  overflow: hidden;
}
.kb-labfront.container .ui.placeholder .line:nth-child(1):after {
  width: 0;
}
.kb-labfront.container .ui.placeholder .line:nth-child(2):after {
  width: 50%;
}
.kb-labfront.container .ui.placeholder .line:nth-child(3):after {
  width: 10%;
}
.kb-labfront.container .ui.placeholder .line:nth-child(4):after {
  width: 35%;
}
.kb-labfront.container .ui.placeholder .line:nth-child(5):after {
  width: 65%;
}
.kb-labfront.container .ui.placeholder .header .line {
  margin-bottom: 0.6428571429em;
}
.kb-labfront.container .ui.placeholder .header .line:before,
.kb-labfront.container .ui.placeholder .header .line:after {
  height: 0.6428571429em;
}
.kb-labfront.container .ui.placeholder .header .line:not(:first-child) {
  margin-top: 0.6428571429em;
}
.kb-labfront.container .ui.placeholder .header .line:after {
  width: 20%;
}
.kb-labfront.container .ui.placeholder .header .line:nth-child(2):after {
  width: 60%;
}
.kb-labfront.container .ui.placeholder .image.header .line {
  margin-left: 3em;
}
.kb-labfront.container .ui.placeholder .image.header .line:before {
  width: 0.7142857143rem;
}
.kb-labfront.container .ui.placeholder .image.header:after {
  display: block;
  height: 0.8571428571em;
  content: "";
  margin-left: 3em;
}
.kb-labfront.container .ui.placeholder .image .line:first-child,
.kb-labfront.container .ui.placeholder .paragraph .line:first-child,
.kb-labfront.container .ui.placeholder .header .line:first-child {
  height: 0.01px;
}
.kb-labfront.container .ui.placeholder .image:not(:first-child):before,
.kb-labfront.container .ui.placeholder .paragraph:not(:first-child):before,
.kb-labfront.container .ui.placeholder .header:not(:first-child):before {
  height: 1.4285714286em;
  content: "";
  display: block;
}
.kb-labfront.container .ui.inverted.placeholder {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.08) 0, rgba(255, 255, 255, 0.14) 15%, rgba(255, 255, 255, 0.08) 30%);
}
.kb-labfront.container .ui.inverted.placeholder,
.kb-labfront.container .ui.inverted.placeholder > :before,
.kb-labfront.container .ui.inverted.placeholder .image.header:after,
.kb-labfront.container .ui.inverted.placeholder .line,
.kb-labfront.container .ui.inverted.placeholder .line:after {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.placeholder .full.line.line.line:after {
  width: 0;
}
.kb-labfront.container .ui.placeholder .very.long.line.line.line:after {
  width: 10%;
}
.kb-labfront.container .ui.placeholder .long.line.line.line:after {
  width: 35%;
}
.kb-labfront.container .ui.placeholder .medium.line.line.line:after {
  width: 50%;
}
.kb-labfront.container .ui.placeholder .short.line.line.line:after {
  width: 65%;
}
.kb-labfront.container .ui.placeholder .very.short.line.line.line:after {
  width: 80%;
}
.kb-labfront.container .ui.fluid.placeholder {
  max-width: none;
}
.kb-labfront.container .ui.rail {
  position: absolute;
  top: 0;
  width: 300px;
  height: 100%;
}
.kb-labfront.container .ui.left.rail {
  left: auto;
  right: 100%;
  padding: 0 2rem 0 0;
  margin: 0 2rem 0 0;
}
.kb-labfront.container .ui.right.rail {
  left: 100%;
  right: auto;
  padding: 0 0 0 2rem;
  margin: 0 0 0 2rem;
}
.kb-labfront.container .ui.left.internal.rail {
  left: 0;
  right: auto;
  padding: 0 0 0 2rem;
  margin: 0 0 0 2rem;
}
.kb-labfront.container .ui.right.internal.rail {
  left: auto;
  right: 0;
  padding: 0 2rem 0 0;
  margin: 0 2rem 0 0;
}
.kb-labfront.container .ui.dividing.rail {
  width: 302.5px;
}
.kb-labfront.container .ui.left.dividing.rail {
  padding: 0 2.5rem 0 0;
  margin: 0 2.5rem 0 0;
  border-right: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.right.dividing.rail {
  border-left: 1px solid rgba(34, 36, 38, 0.15);
  padding: 0 0 0 2.5rem;
  margin: 0 0 0 2.5rem;
}
.kb-labfront.container .ui.close.rail {
  width: calc(300px + 1em);
}
.kb-labfront.container .ui.close.left.rail {
  padding: 0 1em 0 0;
  margin: 0 1em 0 0;
}
.kb-labfront.container .ui.close.right.rail {
  padding: 0 0 0 1em;
  margin: 0 0 0 1em;
}
.kb-labfront.container .ui.very.close.rail {
  width: calc(300px + 0.5em);
}
.kb-labfront.container .ui.very.close.left.rail {
  padding: 0 0.5em 0 0;
  margin: 0 0.5em 0 0;
}
.kb-labfront.container .ui.very.close.right.rail {
  padding: 0 0 0 0.5em;
  margin: 0 0 0 0.5em;
}
.kb-labfront.container .ui.attached.left.rail,
.kb-labfront.container .ui.attached.right.rail {
  padding: 0;
  margin: 0;
}
.kb-labfront.container .ui.mini.rail {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.rail {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.rail {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.rail {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.rail {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.rail {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.rail {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.rail {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.reveal {
  display: inherit;
  position: relative !important;
  font-size: 0 !important;
}
.kb-labfront.container .ui.reveal > .visible.content {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 3 !important;
  transition: all 0.5s ease 0.1s;
}
.kb-labfront.container .ui.reveal > .hidden.content {
  position: relative !important;
  z-index: 2 !important;
}
.kb-labfront.container .ui.active.reveal .visible.content,
.kb-labfront.container .ui.reveal:hover .visible.content {
  z-index: 4 !important;
}
.kb-labfront.container .ui.slide.reveal {
  position: relative !important;
  overflow: hidden !important;
  white-space: nowrap;
}
.kb-labfront.container .ui.slide.reveal > .content {
  display: block;
  width: 100%;
  white-space: normal;
  float: left;
  margin: 0;
  transition: transform 0.5s ease 0.1s;
}
.kb-labfront.container .ui.slide.reveal > .visible.content {
  position: relative !important;
}
.kb-labfront.container .ui.slide.reveal > .hidden.content {
  position: absolute !important;
  left: 0 !important;
  width: 100% !important;
  transform: translateX(100%) !important;
}
.kb-labfront.container .ui.slide.active.reveal > .visible.content,
.kb-labfront.container .ui.slide.reveal:hover > .visible.content {
  transform: translateX(-100%) !important;
}
.kb-labfront.container .ui.slide.active.reveal > .hidden.content,
.kb-labfront.container .ui.slide.reveal:hover > .hidden.content {
  transform: translateX(0%) !important;
}
.kb-labfront.container .ui.slide.right.reveal > .visible.content {
  transform: translateX(0%) !important;
}
.kb-labfront.container .ui.slide.right.reveal > .hidden.content {
  transform: translateX(-100%) !important;
}
.kb-labfront.container .ui.slide.right.active.reveal > .visible.content,
.kb-labfront.container .ui.slide.right.reveal:hover > .visible.content {
  transform: translateX(100%) !important;
}
.kb-labfront.container .ui.slide.right.active.reveal > .hidden.content,
.kb-labfront.container .ui.slide.right.reveal:hover > .hidden.content {
  transform: translateX(0%) !important;
}
.kb-labfront.container .ui.slide.up.reveal > .hidden.content {
  transform: translateY(100%) !important;
}
.kb-labfront.container .ui.slide.up.active.reveal > .visible.content,
.kb-labfront.container .ui.slide.up.reveal:hover > .visible.content {
  transform: translateY(-100%) !important;
}
.kb-labfront.container .ui.slide.up.active.reveal > .hidden.content,
.kb-labfront.container .ui.slide.up.reveal:hover > .hidden.content {
  transform: translateY(0%) !important;
}
.kb-labfront.container .ui.slide.down.reveal > .hidden.content {
  transform: translateY(-100%) !important;
}
.kb-labfront.container .ui.slide.down.active.reveal > .visible.content,
.kb-labfront.container .ui.slide.down.reveal:hover > .visible.content {
  transform: translateY(100%) !important;
}
.kb-labfront.container .ui.slide.down.active.reveal > .hidden.content,
.kb-labfront.container .ui.slide.down.reveal:hover > .hidden.content {
  transform: translateY(0%) !important;
}
.kb-labfront.container .ui.fade.reveal > .visible.content {
  opacity: 1;
}
.kb-labfront.container .ui.fade.active.reveal > .visible.content,
.kb-labfront.container .ui.fade.reveal:hover > .visible.content {
  opacity: 0;
}
.kb-labfront.container .ui.move.reveal {
  position: relative !important;
  overflow: hidden !important;
  white-space: nowrap;
}
.kb-labfront.container .ui.move.reveal > .content {
  display: block;
  float: left;
  white-space: normal;
  margin: 0;
  transition: transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1) 0.1s;
}
.kb-labfront.container .ui.move.reveal > .visible.content {
  position: relative !important;
}
.kb-labfront.container .ui.move.reveal > .hidden.content {
  position: absolute !important;
  left: 0 !important;
  width: 100% !important;
}
.kb-labfront.container .ui.move.active.reveal > .visible.content,
.kb-labfront.container .ui.move.reveal:hover > .visible.content {
  transform: translateX(-100%) !important;
}
.kb-labfront.container .ui.move.right.active.reveal > .visible.content,
.kb-labfront.container .ui.move.right.reveal:hover > .visible.content {
  transform: translateX(100%) !important;
}
.kb-labfront.container .ui.move.up.active.reveal > .visible.content,
.kb-labfront.container .ui.move.up.reveal:hover > .visible.content {
  transform: translateY(-100%) !important;
}
.kb-labfront.container .ui.move.down.active.reveal > .visible.content,
.kb-labfront.container .ui.move.down.reveal:hover > .visible.content {
  transform: translateY(100%) !important;
}
.kb-labfront.container .ui.rotate.reveal > .visible.content {
  transition-duration: 0.5s;
  transform: rotate(0deg);
}
.kb-labfront.container .ui.rotate.reveal > .visible.content,
.kb-labfront.container .ui.rotate.right.reveal > .visible.content {
  transform-origin: bottom right;
}
.kb-labfront.container .ui.rotate.active.reveal > .visible.content,
.kb-labfront.container .ui.rotate.reveal:hover > .visible.content,
.kb-labfront.container .ui.rotate.right.active.reveal > .visible.content,
.kb-labfront.container .ui.rotate.right.reveal:hover > .visible.content {
  transform: rotate(110deg);
}
.kb-labfront.container .ui.rotate.left.reveal > .visible.content {
  transform-origin: bottom left;
}
.kb-labfront.container .ui.rotate.left.active.reveal > .visible.content,
.kb-labfront.container .ui.rotate.left.reveal:hover > .visible.content {
  transform: rotate(-110deg);
}
.kb-labfront.container .ui.disabled.reveal:hover > .visible.visible.content {
  position: static !important;
  display: block !important;
  opacity: 1 !important;
  top: 0 !important;
  left: 0 !important;
  right: auto !important;
  bottom: auto !important;
  transform: none !important;
}
.kb-labfront.container .ui.disabled.reveal:hover > .hidden.hidden.content {
  display: none !important;
}
.kb-labfront.container .ui.reveal > .ui.ribbon.label {
  z-index: 5;
}
.kb-labfront.container .ui.visible.reveal {
  overflow: visible;
}
.kb-labfront.container .ui.instant.reveal > .content {
  transition-delay: 0s !important;
}
.kb-labfront.container .ui.reveal > .content {
  font-size: 1rem !important;
}
.kb-labfront.container .ui.segment {
  position: relative;
  background: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
  margin: 1rem 0;
  padding: 1em 1em;
  border-radius: 0.2857142857rem;
  border: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.segment:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.segment:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.vertical.segment {
  margin: 0;
  padding-left: 0;
  padding-right: 0;
  background: none transparent;
  border-radius: 0;
  box-shadow: none;
  border: none;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.vertical.segment:last-child {
  border-bottom: none;
}
.kb-labfront.container .ui.inverted.segment > .ui.header > .sub.header,
.kb-labfront.container .ui.inverted.segment > .ui.header {
  color: #ffffff;
}
.kb-labfront.container .ui[class*="bottom attached"].segment > [class*="top attached"].label {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.kb-labfront.container .ui[class*="top attached"].segment > [class*="bottom attached"].label {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.kb-labfront.container .ui.attached.segment:not(.top):not(.bottom) > [class*="top attached"].label {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.kb-labfront.container .ui.attached.segment:not(.top):not(.bottom) > [class*="bottom attached"].label {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.kb-labfront.container .ui.page.grid.segment,
.kb-labfront.container .ui.grid > .row > .ui.segment.column,
.kb-labfront.container .ui.grid > .ui.segment.column {
  padding-top: 2em;
  padding-bottom: 2em;
}
.kb-labfront.container .ui.grid.segment {
  margin: 1rem 0;
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.basic.table.segment {
  background: #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui[class*="very basic"].table.segment {
  padding: 1em 1em;
}
.kb-labfront.container .ui.segment.tab:last-child {
  margin-bottom: 1rem;
}
.kb-labfront.container .ui.placeholder.segment {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  max-width: initial;
  animation: none;
  overflow: visible;
  padding: 1em 1em;
  min-height: 18rem;
  background: #f9fafb;
  border-color: rgba(34, 36, 38, 0.15);
  box-shadow: 0 2px 25px 0 rgba(34, 36, 38, 0.05) inset;
}
.kb-labfront.container .ui.placeholder.segment .button,
.kb-labfront.container .ui.placeholder.segment textarea {
  display: block;
}
.kb-labfront.container .ui.placeholder.segment .field,
.kb-labfront.container .ui.placeholder.segment textarea,
.kb-labfront.container .ui.placeholder.segment > .ui.input,
.kb-labfront.container .ui.placeholder.segment .button {
  max-width: 15rem;
  margin-left: auto;
  margin-right: auto;
}
.kb-labfront.container .ui.placeholder.segment .column .button,
.kb-labfront.container .ui.placeholder.segment .column .field,
.kb-labfront.container .ui.placeholder.segment .column textarea,
.kb-labfront.container .ui.placeholder.segment .column > .ui.input {
  max-width: 15rem;
  margin-left: auto;
  margin-right: auto;
}
.kb-labfront.container .ui.placeholder.segment > .inline {
  align-self: center;
}
.kb-labfront.container .ui.placeholder.segment > .inline > .button {
  display: inline-block;
  width: auto;
  margin: 0 0.3571428571rem 0 0;
}
.kb-labfront.container .ui.placeholder.segment > .inline > .button:last-child {
  margin-right: 0;
}
.kb-labfront.container .ui.piled.segments,
.kb-labfront.container .ui.piled.segment {
  margin: 3em 0;
  box-shadow: "";
  z-index: auto;
}
.kb-labfront.container .ui.piled.segment:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.piled.segment:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.piled.segments:after,
.kb-labfront.container .ui.piled.segments:before,
.kb-labfront.container .ui.piled.segment:after,
.kb-labfront.container .ui.piled.segment:before {
  background-color: #ffffff;
  visibility: visible;
  content: "";
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  width: 100%;
  border: 1px solid rgba(34, 36, 38, 0.15);
  box-shadow: "";
}
.kb-labfront.container .ui.piled.segments:before,
.kb-labfront.container .ui.piled.segment:before {
  transform: rotate(-1.2deg);
  top: 0;
  z-index: -2;
}
.kb-labfront.container .ui.piled.segments:after,
.kb-labfront.container .ui.piled.segment:after {
  transform: rotate(1.2deg);
  top: 0;
  z-index: -1;
}
.kb-labfront.container .ui[class*="top attached"].piled.segment {
  margin-top: 3em;
  margin-bottom: 0;
}
.kb-labfront.container .ui.piled.segment[class*="top attached"]:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.piled.segment[class*="bottom attached"] {
  margin-top: 0;
  margin-bottom: 3em;
}
.kb-labfront.container .ui.piled.segment[class*="bottom attached"]:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.stacked.segment {
  padding-bottom: 1.4em;
}
.kb-labfront.container .ui.stacked.segments:before,
.kb-labfront.container .ui.stacked.segments:after,
.kb-labfront.container .ui.stacked.segment:before,
.kb-labfront.container .ui.stacked.segment:after {
  content: "";
  position: absolute;
  bottom: -3px;
  left: 0;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  background: rgba(0, 0, 0, 0.03);
  width: 100%;
  height: 6px;
  visibility: visible;
}
.kb-labfront.container .ui.stacked.segments:before,
.kb-labfront.container .ui.stacked.segment:before {
  display: none;
}
.kb-labfront.container .ui.tall.stacked.segments:before,
.kb-labfront.container .ui.tall.stacked.segment:before {
  display: block;
  bottom: 0;
}
.kb-labfront.container .ui.stacked.inverted.segments:before,
.kb-labfront.container .ui.stacked.inverted.segments:after,
.kb-labfront.container .ui.stacked.inverted.segment:before,
.kb-labfront.container .ui.stacked.inverted.segment:after {
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(34, 36, 38, 0.35);
}
.kb-labfront.container .ui.padded.segment {
  padding: 1.5em;
}
.kb-labfront.container .ui[class*="very padded"].segment {
  padding: 3em;
}
.kb-labfront.container .ui.padded.segment.vertical.segment,
.kb-labfront.container .ui[class*="very padded"].vertical.segment {
  padding-left: 0;
  padding-right: 0;
}
.kb-labfront.container .ui.compact.segment {
  display: table;
}
.kb-labfront.container .ui.compact.segments {
  display: inline-flex;
}
.kb-labfront.container .ui.compact.segments .segment,
.kb-labfront.container .ui.segments .compact.segment {
  display: block;
  flex: 0 1 auto;
}
.kb-labfront.container .ui.circular.segment {
  display: table-cell;
  padding: 2em;
  text-align: center;
  vertical-align: middle;
  border-radius: 500em;
}
.kb-labfront.container .ui.raised.raised.segments,
.kb-labfront.container .ui.raised.raised.segment {
  box-shadow: 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.segments {
  flex-direction: column;
  position: relative;
  margin: 1rem 0;
  border: 1px solid rgba(34, 36, 38, 0.15);
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.segments:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.segments:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.segments > .segment {
  top: 0;
  bottom: 0;
  border-radius: 0;
  margin: 0;
  width: auto;
  box-shadow: none;
  border: none;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.segments:not(.horizontal) > .segment:first-child {
  top: 0;
  bottom: 0;
  border-top: none;
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.segments:not(.horizontal) > .segment:last-child {
  top: 0;
  bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), none;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.segments:not(.horizontal) > .segment:only-child {
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.segments > .ui.segments {
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  margin: 1rem 1rem;
}
.kb-labfront.container .ui.segments > .segments:first-child {
  border-top: none;
}
.kb-labfront.container .ui.segments > .segment + .segments:not(.horizontal) {
  margin-top: 0;
}
.kb-labfront.container .ui.horizontal.segments {
  display: flex;
  flex-direction: row;
  background-color: transparent;
  padding: 0;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
  margin: 1rem 0;
  border-radius: 0.2857142857rem;
  border: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.stackable.horizontal.segments {
  flex-wrap: wrap;
}
.kb-labfront.container .ui.segments > .horizontal.segments {
  margin: 0;
  background-color: transparent;
  border-radius: 0;
  border: none;
  box-shadow: none;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.horizontal.segments:not(.compact) > .segment:not(.compact) {
  flex: 1 1 auto;
  -ms-flex: 1 1 0; /* Solves #2550 MS Flex */
}
.kb-labfront.container .ui.horizontal.segments > .segment {
  margin: 0;
  min-width: 0;
  border-radius: 0;
  border: none;
  box-shadow: none;
  border-left: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.segments > .horizontal.segments:first-child {
  border-top: none;
}
.kb-labfront.container .ui.horizontal.segments:not(.stackable) > .segment:first-child {
  border-left: none;
}
.kb-labfront.container .ui.disabled.segment {
  opacity: 0.45;
  color: rgba(0, 0, 0, 0.2);
}
.kb-labfront.container .ui.loading.segment {
  position: relative;
  cursor: default;
  pointer-events: none;
  text-shadow: none !important;
  transition: all 0s linear;
}
.kb-labfront.container .ui.loading.segment:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  border-radius: 0.2857142857rem;
  z-index: 100;
}
.kb-labfront.container .ui.loading.segment:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 3em;
  height: 3em;
  animation: loader 0.6s infinite linear;
  border: 0.2em solid #767676;
  border-radius: 500rem;
  box-shadow: 0 0 0 1px transparent;
  visibility: visible;
  z-index: 101;
}
.kb-labfront.container .ui.basic.segment,
.kb-labfront.container .ui.segments .ui.basic.segment,
.kb-labfront.container .ui.basic.segments {
  background: none transparent;
  box-shadow: none;
  border: none;
  border-radius: 0;
}
.kb-labfront.container .ui.clearing.segment:after {
  content: "";
  display: block;
  clear: both;
}
.kb-labfront.container .ui.red.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #db2828;
}
.kb-labfront.container .ui.inverted.red.segment.segment.segment.segment.segment {
  background-color: #db2828;
  color: #ffffff;
}
.kb-labfront.container .ui.orange.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #f2711c;
}
.kb-labfront.container .ui.inverted.orange.segment.segment.segment.segment.segment {
  background-color: #f2711c;
  color: #ffffff;
}
.kb-labfront.container .ui.yellow.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #fbbd08;
}
.kb-labfront.container .ui.inverted.yellow.segment.segment.segment.segment.segment {
  background-color: #fbbd08;
  color: #ffffff;
}
.kb-labfront.container .ui.olive.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #b5cc18;
}
.kb-labfront.container .ui.inverted.olive.segment.segment.segment.segment.segment {
  background-color: #b5cc18;
  color: #ffffff;
}
.kb-labfront.container .ui.green.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #21ba45;
}
.kb-labfront.container .ui.inverted.green.segment.segment.segment.segment.segment {
  background-color: #21ba45;
  color: #ffffff;
}
.kb-labfront.container .ui.teal.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #00b5ad;
}
.kb-labfront.container .ui.inverted.teal.segment.segment.segment.segment.segment {
  background-color: #00b5ad;
  color: #ffffff;
}
.kb-labfront.container .ui.blue.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #2185d0;
}
.kb-labfront.container .ui.inverted.blue.segment.segment.segment.segment.segment {
  background-color: #2185d0;
  color: #ffffff;
}
.kb-labfront.container .ui.violet.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #6435c9;
}
.kb-labfront.container .ui.inverted.violet.segment.segment.segment.segment.segment {
  background-color: #6435c9;
  color: #ffffff;
}
.kb-labfront.container .ui.purple.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #a333c8;
}
.kb-labfront.container .ui.inverted.purple.segment.segment.segment.segment.segment {
  background-color: #a333c8;
  color: #ffffff;
}
.kb-labfront.container .ui.pink.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #e03997;
}
.kb-labfront.container .ui.inverted.pink.segment.segment.segment.segment.segment {
  background-color: #e03997;
  color: #ffffff;
}
.kb-labfront.container .ui.brown.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #a5673f;
}
.kb-labfront.container .ui.inverted.brown.segment.segment.segment.segment.segment {
  background-color: #a5673f;
  color: #ffffff;
}
.kb-labfront.container .ui.grey.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #767676;
}
.kb-labfront.container .ui.inverted.grey.segment.segment.segment.segment.segment {
  background-color: #767676;
  color: #ffffff;
}
.kb-labfront.container .ui.black.segment.segment.segment.segment.segment:not(.inverted) {
  border-top: 2px solid #1b1c1d;
}
.kb-labfront.container .ui.inverted.black.segment.segment.segment.segment.segment {
  background-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container .ui[class*="left aligned"].segment {
  text-align: left;
}
.kb-labfront.container .ui[class*="right aligned"].segment {
  text-align: right;
}
.kb-labfront.container .ui[class*="center aligned"].segment {
  text-align: center;
}
.kb-labfront.container .ui.floated.segment,
.kb-labfront.container .ui[class*="left floated"].segment {
  float: left;
  margin-right: 1em;
}
.kb-labfront.container .ui[class*="right floated"].segment {
  float: right;
  margin-left: 1em;
}
.kb-labfront.container .ui.inverted.segment {
  border: none;
  box-shadow: none;
}
.kb-labfront.container .ui.inverted.segment,
.kb-labfront.container .ui.primary.inverted.segment {
  background: #1b1c1d;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.segment .segment {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.inverted.segment .inverted.segment {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.attached.segment {
  border-color: #555555;
}
.kb-labfront.container .ui.inverted.loading.segment {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.loading.segment:before {
  background: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.secondary.inverted.segment {
  background: rgb(76.1785714286, 79, 81.8214285714) linear-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.2) 100%);
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.tertiary.inverted.segment {
  background: rgb(113.0625, 117.25, 121.4375) linear-gradient(rgba(255, 255, 255, 0.35) 0, rgba(255, 255, 255, 0.35) 100%);
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.secondary.segment {
  background: #f3f4f5;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.tertiary.segment {
  background: #dcddde;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.attached.segment {
  top: 0;
  bottom: 0;
  border-radius: 0;
  margin: 0 -1px;
  width: calc(100% + 2px);
  max-width: calc(100% + 2px);
  box-shadow: none;
  border: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.attached:not(.message) + .ui.attached.segment:not(.top) {
  border-top: none;
}
.kb-labfront.container .ui[class*="top attached"].segment {
  bottom: 0;
  margin-bottom: 0;
  top: 0;
  margin-top: 1rem;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.segment[class*="top attached"]:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.segment[class*="bottom attached"] {
  bottom: 0;
  margin-top: 0;
  top: 0;
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), none;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.segment[class*="bottom attached"]:last-child {
  margin-bottom: 1rem;
}
.kb-labfront.container .ui.fitted.segment:not(.horizontally) {
  padding-top: 0;
  padding-bottom: 0;
}
.kb-labfront.container .ui.fitted.segment:not(.vertically) {
  padding-left: 0;
  padding-right: 0;
}
.kb-labfront.container .ui.mini.segments .segment,
.kb-labfront.container .ui.mini.segment {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.segments .segment,
.kb-labfront.container .ui.tiny.segment {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.segments .segment,
.kb-labfront.container .ui.small.segment {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.segments .segment,
.kb-labfront.container .ui.segment {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.segments .segment,
.kb-labfront.container .ui.large.segment {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.segments .segment,
.kb-labfront.container .ui.big.segment {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.segments .segment,
.kb-labfront.container .ui.huge.segment {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.segments .segment,
.kb-labfront.container .ui.massive.segment {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.steps {
  display: inline-flex;
  flex-direction: row;
  align-items: stretch;
  margin: 1em 0;
  background: "";
  box-shadow: none;
  line-height: 1.1428571429em;
  border-radius: 0.2857142857rem;
  border: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.steps:not(.unstackable) {
  flex-wrap: wrap;
}
.kb-labfront.container .ui.steps:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.steps:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.steps .step {
  position: relative;
  display: flex;
  flex: 1 0 auto;
  flex-wrap: wrap;
  flex-direction: row;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  margin: 0 0;
  padding: 1.1428571429em 2em;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
  border-radius: 0;
  border: none;
  border-right: 1px solid rgba(34, 36, 38, 0.15);
  transition: background-color 0.1s ease, opacity 0.1s ease, color 0.1s ease, box-shadow 0.1s ease;
}
.kb-labfront.container .ui.steps .step:after {
  display: none;
  position: absolute;
  z-index: 2;
  content: "";
  top: 50%;
  right: 0;
  border: medium none;
  background-color: #ffffff;
  width: 1.1428571429em;
  height: 1.1428571429em;
  border-style: solid;
  border-color: rgba(34, 36, 38, 0.15);
  border-width: 0 1px 1px 0;
  transition: background-color 0.1s ease, opacity 0.1s ease, color 0.1s ease, box-shadow 0.1s ease;
  transform: translateY(-50%) translateX(50%) rotate(-45deg);
}
.kb-labfront.container .ui.steps .step:first-child {
  padding-left: 2em;
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.steps .step:last-child {
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
  border-right: none;
  margin-right: 0;
}
.kb-labfront.container .ui.steps .step:only-child {
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.steps .step .title {
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 1.1428571429em;
  font-weight: bold;
}
.kb-labfront.container .ui.steps .step > .title {
  width: 100%;
}
.kb-labfront.container .ui.steps .step .description {
  font-weight: normal;
  font-size: 0.9285714286em;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.steps .step > .description {
  width: 100%;
}
.kb-labfront.container .ui.steps .step .title ~ .description {
  margin-top: 0.25em;
}
.kb-labfront.container .ui.steps .step > .icon {
  line-height: 1;
  font-size: 2.5em;
  margin: 0 1rem 0 0;
}
.kb-labfront.container .ui.steps .step > .icon,
.kb-labfront.container .ui.steps .step > .icon ~ .content {
  display: block;
  flex: 0 1 auto;
  align-self: middle;
}
.kb-labfront.container .ui.steps:not(.vertical) .step > .icon {
  width: auto;
}
.kb-labfront.container .ui.steps .link.step,
.kb-labfront.container .ui.steps a.step {
  cursor: pointer;
}
.kb-labfront.container .ui.ordered.steps {
  counter-reset: ordered;
}
.kb-labfront.container .ui.ordered.steps .step:before {
  display: block;
  position: static;
  text-align: center;
  content: counter(ordered);
  align-self: middle;
  margin-right: 1rem;
  font-size: 2.5em;
  counter-increment: ordered;
  font-family: inherit;
  font-weight: bold;
}
.kb-labfront.container .ui.ordered.steps .step > * {
  display: block;
  align-self: middle;
}
.kb-labfront.container .ui.vertical.steps {
  display: inline-flex;
  flex-direction: column;
  overflow: visible;
}
.kb-labfront.container .ui.vertical.steps .step {
  justify-content: flex-start;
  border-radius: 0;
  padding: 1.1428571429em 2em;
  border-right: none;
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.vertical.steps .step:first-child {
  padding: 1.1428571429em 2em;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.vertical.steps .step:last-child {
  border-bottom: none;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.steps .step:only-child {
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.steps .step:after {
  top: 50%;
  right: 0;
  border-width: 0 1px 1px 0;
  display: none;
}
.kb-labfront.container .ui.vertical.steps .active.step:after {
  display: block;
}
.kb-labfront.container .ui.vertical.steps .step:last-child:after {
  display: none;
}
.kb-labfront.container .ui.vertical.steps .active.step:last-child:after {
  display: block;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container {
    /* Arrow */
    /* Content */
    /* Icon */
  }
  .kb-labfront.container .ui.steps:not(.unstackable) {
    display: inline-flex;
    overflow: visible;
    flex-direction: column;
  }
  .kb-labfront.container .ui.steps:not(.unstackable) .step {
    width: 100% !important;
    flex-direction: column;
    border-radius: 0;
    padding: 1.1428571429em 2em;
    border-right: none;
    border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  }
  .kb-labfront.container .ui.steps:not(.unstackable) .step:first-child {
    padding: 1.1428571429em 2em;
    border-radius: 0.2857142857rem 0.2857142857rem 0 0;
  }
  .kb-labfront.container .ui.steps:not(.unstackable) .step:last-child {
    border-radius: 0 0 0.2857142857rem 0.2857142857rem;
    border-bottom: none;
  }
  .kb-labfront.container .ui.steps:not(.unstackable) .step:after {
    top: unset;
    bottom: -1.1428571429em;
    right: 50%;
    transform: translateY(-50%) translateX(50%) rotate(45deg);
  }
  .kb-labfront.container .ui.vertical.steps .active.step:last-child:after {
    display: none;
  }
  .kb-labfront.container .ui.steps:not(.unstackable) .step .content {
    text-align: center;
  }
  .kb-labfront.container .ui.steps:not(.unstackable) .step > .icon,
  .kb-labfront.container .ui.ordered.steps:not(.unstackable) .step:before {
    margin: 0 0 1rem 0;
  }
}
.kb-labfront.container .ui.steps .link.step:hover::after,
.kb-labfront.container .ui.steps .link.step:hover,
.kb-labfront.container .ui.steps a.step:hover::after,
.kb-labfront.container .ui.steps a.step:hover {
  background: #f9fafb;
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.steps .link.step:active::after,
.kb-labfront.container .ui.steps .link.step:active,
.kb-labfront.container .ui.steps a.step:active::after,
.kb-labfront.container .ui.steps a.step:active {
  background: #f3f4f5;
  color: rgba(0, 0, 0, 0.9);
}
.kb-labfront.container .ui.steps .step.active {
  cursor: auto;
  background: #f3f4f5;
}
.kb-labfront.container .ui.steps .step.active:after {
  background: #f3f4f5;
}
.kb-labfront.container .ui.steps .step.active .title {
  color: #4183c4;
}
.kb-labfront.container .ui.ordered.steps .step.active:before,
.kb-labfront.container .ui.steps .active.step .icon {
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.steps .step:after {
  display: block;
}
.kb-labfront.container .ui.steps .active.step:after {
  display: block;
}
.kb-labfront.container .ui.steps .step:last-child:after {
  display: none;
}
.kb-labfront.container .ui.steps .active.step:last-child:after {
  display: none;
}
.kb-labfront.container .ui.steps .link.active.step:hover::after,
.kb-labfront.container .ui.steps .link.active.step:hover,
.kb-labfront.container .ui.steps a.active.step:hover::after,
.kb-labfront.container .ui.steps a.active.step:hover {
  cursor: pointer;
  background: #dcddde;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.steps .step.completed > .icon:before,
.kb-labfront.container .ui.ordered.steps .step.completed:before {
  color: #21ba45;
}
.kb-labfront.container .ui.steps .disabled.step {
  cursor: auto;
  background: #ffffff;
  pointer-events: none;
}
.kb-labfront.container .ui.steps .disabled.step,
.kb-labfront.container .ui.steps .disabled.step .title,
.kb-labfront.container .ui.steps .disabled.step .description {
  color: rgba(0, 0, 0, 0.2);
}
.kb-labfront.container .ui.steps .disabled.step:after {
  background: #ffffff;
}
@media only screen and (max-width: 991.98px) {
  .kb-labfront.container {
    /* Steps */
    /* Arrow */
    /* Content */
    /* Icon */
  }
  .kb-labfront.container .ui[class*="tablet stackable"].steps {
    display: inline-flex;
    overflow: visible;
    flex-direction: column;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].steps .step {
    flex-direction: column;
    border-radius: 0;
    padding: 1.1428571429em 2em;
    border-right: none;
    border-bottom: 1px solid rgba(34, 36, 38, 0.15);
  }
  .kb-labfront.container .ui[class*="tablet stackable"].steps .step:first-child {
    padding: 1.1428571429em 2em;
    border-radius: 0.2857142857rem 0.2857142857rem 0 0;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].steps .step:last-child {
    border-radius: 0 0 0.2857142857rem 0.2857142857rem;
    border-bottom: none;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].steps .step:after {
    top: unset;
    bottom: -1.1428571429em;
    right: 50%;
    transform: translateY(-50%) translateX(50%) rotate(45deg);
  }
  .kb-labfront.container .ui[class*="tablet stackable"].steps .step .content {
    text-align: center;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].steps .step > .icon,
  .kb-labfront.container .ui[class*="tablet stackable"].ordered.steps .step:before {
    margin: 0 0 1rem 0;
  }
}
.kb-labfront.container .ui.fluid.steps {
  display: flex;
  width: 100%;
}
.kb-labfront.container .ui.attached.steps {
  width: calc(100% + 2px) !important;
  margin: 0 -1px 0;
  max-width: calc(100% + 2px);
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.attached.steps .step:first-child {
  border-radius: 0.2857142857rem 0 0 0;
}
.kb-labfront.container .ui.attached.steps .step:last-child {
  border-radius: 0 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.bottom.attached.steps {
  margin: 0 -1px 0;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.bottom.attached.steps .step:first-child {
  border-radius: 0 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.bottom.attached.steps .step:last-child {
  border-radius: 0 0 0.2857142857rem 0;
}
.kb-labfront.container .ui.one.steps,
.kb-labfront.container .ui.two.steps,
.kb-labfront.container .ui.three.steps,
.kb-labfront.container .ui.four.steps,
.kb-labfront.container .ui.five.steps,
.kb-labfront.container .ui.six.steps,
.kb-labfront.container .ui.seven.steps,
.kb-labfront.container .ui.eight.steps {
  width: 100%;
}
.kb-labfront.container .ui.one.steps > .step,
.kb-labfront.container .ui.two.steps > .step,
.kb-labfront.container .ui.three.steps > .step,
.kb-labfront.container .ui.four.steps > .step,
.kb-labfront.container .ui.five.steps > .step,
.kb-labfront.container .ui.six.steps > .step,
.kb-labfront.container .ui.seven.steps > .step,
.kb-labfront.container .ui.eight.steps > .step {
  flex-wrap: nowrap;
}
.kb-labfront.container .ui.one.steps > .step {
  width: 100%;
}
.kb-labfront.container .ui.two.steps > .step {
  width: 50%;
}
.kb-labfront.container .ui.three.steps > .step {
  width: 33.333%;
}
.kb-labfront.container .ui.four.steps > .step {
  width: 25%;
}
.kb-labfront.container .ui.five.steps > .step {
  width: 20%;
}
.kb-labfront.container .ui.six.steps > .step {
  width: 16.666%;
}
.kb-labfront.container .ui.seven.steps > .step {
  width: 14.285%;
}
.kb-labfront.container .ui.eight.steps > .step {
  width: 12.5%;
}
.kb-labfront.container .ui.mini.steps .step,
.kb-labfront.container .ui.mini.step {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.steps .step,
.kb-labfront.container .ui.tiny.step {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.steps .step,
.kb-labfront.container .ui.small.step {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.steps .step,
.kb-labfront.container .ui.step {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.steps .step,
.kb-labfront.container .ui.large.step {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.steps .step,
.kb-labfront.container .ui.big.step {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.steps .step,
.kb-labfront.container .ui.huge.step {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.steps .step,
.kb-labfront.container .ui.massive.step {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.inverted.steps {
  border: 1px solid #555555;
}
.kb-labfront.container .ui.inverted.steps .step {
  color: rgba(255, 255, 255, 0.9);
  background: #1b1c1d;
  border-color: #555555;
}
.kb-labfront.container .ui.inverted.steps .step:after {
  background-color: #1b1c1d;
  border-color: #555555;
}
.kb-labfront.container .ui.inverted.steps .step .description {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.steps .step.active,
.kb-labfront.container .ui.inverted.steps .step.active:after {
  background: #333333;
}
.kb-labfront.container .ui.inverted.ordered.steps .step.active:before,
.kb-labfront.container .ui.inverted.steps .active.step .icon {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.steps .disabled.step,
.kb-labfront.container .ui.inverted.steps .disabled.step:after {
  background: #222222;
}
.kb-labfront.container .ui.inverted.steps .disabled.step,
.kb-labfront.container .ui.inverted.steps .disabled.step .title,
.kb-labfront.container .ui.inverted.steps .disabled.step .description {
  color: rgba(255, 255, 255, 0.2);
}
.kb-labfront.container .ui.inverted.steps .link.step:hover::after,
.kb-labfront.container .ui.inverted.steps .link.step:hover,
.kb-labfront.container .ui.inverted.steps a.step:hover::after,
.kb-labfront.container .ui.inverted.steps a.step:hover {
  background: #3F3F3F;
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.steps .link.step:active::after,
.kb-labfront.container .ui.inverted.steps .link.step:active,
.kb-labfront.container .ui.inverted.steps a.step:active::after,
.kb-labfront.container .ui.inverted.steps a.step:active {
  background: #444444;
  color: rgb(255, 255, 255);
}
@font-face {
  font-family: "Step";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff");
}
.kb-labfront.container .ui.steps .step.completed > .icon:before,
.kb-labfront.container .ui.ordered.steps .step.completed:before {
  font-family: "Step";
  content: "\\e800"; /* '' */
}
.kb-labfront.container span.ui.primary.text {
  color: #2185d0;
}
.kb-labfront.container span.ui.inverted.primary.text {
  color: #54c8ff;
}
.kb-labfront.container span.ui.secondary.text {
  color: #1b1c1d;
}
.kb-labfront.container span.ui.inverted.secondary.text {
  color: #545454;
}
.kb-labfront.container span.ui.red.text {
  color: #db2828;
}
.kb-labfront.container span.ui.inverted.red.text {
  color: #ff695e;
}
.kb-labfront.container span.ui.orange.text {
  color: #f2711c;
}
.kb-labfront.container span.ui.inverted.orange.text {
  color: #ff851b;
}
.kb-labfront.container span.ui.yellow.text {
  color: #fbbd08;
}
.kb-labfront.container span.ui.inverted.yellow.text {
  color: #ffe21f;
}
.kb-labfront.container span.ui.olive.text {
  color: #b5cc18;
}
.kb-labfront.container span.ui.inverted.olive.text {
  color: #d9e778;
}
.kb-labfront.container span.ui.green.text {
  color: #21ba45;
}
.kb-labfront.container span.ui.inverted.green.text {
  color: #2ecc40;
}
.kb-labfront.container span.ui.teal.text {
  color: #00b5ad;
}
.kb-labfront.container span.ui.inverted.teal.text {
  color: #6dffff;
}
.kb-labfront.container span.ui.blue.text {
  color: #2185d0;
}
.kb-labfront.container span.ui.inverted.blue.text {
  color: #54c8ff;
}
.kb-labfront.container span.ui.violet.text {
  color: #6435c9;
}
.kb-labfront.container span.ui.inverted.violet.text {
  color: #a291fb;
}
.kb-labfront.container span.ui.purple.text {
  color: #a333c8;
}
.kb-labfront.container span.ui.inverted.purple.text {
  color: #dc73ff;
}
.kb-labfront.container span.ui.pink.text {
  color: #e03997;
}
.kb-labfront.container span.ui.inverted.pink.text {
  color: #ff8edf;
}
.kb-labfront.container span.ui.brown.text {
  color: #a5673f;
}
.kb-labfront.container span.ui.inverted.brown.text {
  color: #d67c1c;
}
.kb-labfront.container span.ui.grey.text {
  color: #767676;
}
.kb-labfront.container span.ui.inverted.grey.text {
  color: #dcddde;
}
.kb-labfront.container span.ui.black.text {
  color: #1b1c1d;
}
.kb-labfront.container span.ui.inverted.black.text {
  color: #545454;
}
.kb-labfront.container span.ui.disabled.text {
  opacity: 0.45;
}
.kb-labfront.container span.ui.mini.text {
  font-size: 0.4em;
}
.kb-labfront.container span.ui.tiny.text {
  font-size: 0.5em;
}
.kb-labfront.container span.ui.small.text {
  font-size: 0.75em;
}
.kb-labfront.container span.ui.medium.text {
  font-size: 1em;
}
.kb-labfront.container span.ui.large.text {
  font-size: 1.5em;
}
.kb-labfront.container span.ui.big.text {
  font-size: 2em;
}
.kb-labfront.container span.ui.huge.text {
  font-size: 4em;
}
.kb-labfront.container span.ui.massive.text {
  font-size: 8em;
}
.kb-labfront.container .ui.breadcrumb {
  line-height: 1.4285em;
  display: inline-block;
  margin: 0 0;
  vertical-align: middle;
}
.kb-labfront.container .ui.breadcrumb:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.breadcrumb:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.breadcrumb .divider {
  display: inline-block;
  opacity: 0.7;
  margin: 0 0.2142857143rem 0;
  font-size: 0.9285714286em;
  color: rgba(0, 0, 0, 0.4);
  vertical-align: baseline;
}
.kb-labfront.container .ui.breadcrumb a {
  color: #4183c4;
}
.kb-labfront.container .ui.breadcrumb a:hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.breadcrumb .icon.divider {
  font-size: 0.8571428571em;
  vertical-align: baseline;
}
.kb-labfront.container .ui.breadcrumb a.section {
  cursor: pointer;
}
.kb-labfront.container .ui.breadcrumb .section {
  display: inline-block;
  margin: 0;
  padding: 0;
}
.kb-labfront.container .ui.breadcrumb.segment {
  display: inline-block;
  padding: 0.7857142857em 1em;
}
.kb-labfront.container .ui.inverted.breadcrumb {
  color: #dcddde;
}
.kb-labfront.container .ui.inverted.breadcrumb > .active.section {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.breadcrumb > .divider {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.breadcrumb .active.section {
  font-weight: bold;
}
.kb-labfront.container .ui.mini.breadcrumb {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.breadcrumb {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.breadcrumb {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.breadcrumb {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.breadcrumb {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.breadcrumb {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.breadcrumb {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.breadcrumb {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.form {
  position: relative;
  max-width: 100%;
}
.kb-labfront.container .ui.form > p {
  margin: 1em 0;
}
.kb-labfront.container .ui.form .field {
  clear: both;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.form .field:last-child,
.kb-labfront.container .ui.form .fields:last-child .field {
  margin-bottom: 0;
}
.kb-labfront.container .ui.form .fields .field {
  clear: both;
  margin: 0;
}
.kb-labfront.container .ui.form .field > label {
  display: block;
  margin: 0 0 0.2857142857rem 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.9285714286em;
  font-weight: bold;
  text-transform: none;
}
.kb-labfront.container .ui.form textarea,
.kb-labfront.container .ui.form input:not([type]),
.kb-labfront.container .ui.form input[type=date],
.kb-labfront.container .ui.form input[type=datetime-local],
.kb-labfront.container .ui.form input[type=email],
.kb-labfront.container .ui.form input[type=number],
.kb-labfront.container .ui.form input[type=password],
.kb-labfront.container .ui.form input[type=search],
.kb-labfront.container .ui.form input[type=tel],
.kb-labfront.container .ui.form input[type=time],
.kb-labfront.container .ui.form input[type=text],
.kb-labfront.container .ui.form input[type=file],
.kb-labfront.container .ui.form input[type=url] {
  width: 100%;
  vertical-align: top;
}
.kb-labfront.container .ui.form ::-webkit-datetime-edit,
.kb-labfront.container .ui.form ::-webkit-inner-spin-button {
  height: 1.2142857143em;
}
.kb-labfront.container .ui.form input:not([type]),
.kb-labfront.container .ui.form input[type=date],
.kb-labfront.container .ui.form input[type=datetime-local],
.kb-labfront.container .ui.form input[type=email],
.kb-labfront.container .ui.form input[type=number],
.kb-labfront.container .ui.form input[type=password],
.kb-labfront.container .ui.form input[type=search],
.kb-labfront.container .ui.form input[type=tel],
.kb-labfront.container .ui.form input[type=time],
.kb-labfront.container .ui.form input[type=text],
.kb-labfront.container .ui.form input[type=file],
.kb-labfront.container .ui.form input[type=url] {
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  margin: 0;
  outline: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  line-height: 1.2142857143em;
  padding: 0.6785714286em 1em;
  font-size: 1em;
  background: #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.2857142857rem;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
}
.kb-labfront.container .ui.input textarea,
.kb-labfront.container .ui.form textarea {
  margin: 0;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  padding: 0.7857142857em 1em;
  background: #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  outline: none;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.2857142857rem;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
  font-size: 1em;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  line-height: 1.2857;
  resize: vertical;
}
.kb-labfront.container .ui.form textarea:not([rows]) {
  height: 12em;
  min-height: 8em;
  max-height: 24em;
}
.kb-labfront.container .ui.form textarea,
.kb-labfront.container .ui.form input[type=checkbox] {
  vertical-align: top;
}
.kb-labfront.container .ui.form .fields:not(.grouped):not(.inline) .field:not(:only-child) label + .ui.ui.checkbox {
  margin-top: 0.7em;
}
.kb-labfront.container .ui.form .fields:not(.grouped):not(.inline) .field:not(:only-child) .ui.checkbox {
  margin-top: 2.4142857143em;
}
.kb-labfront.container .ui.form .fields:not(.grouped):not(.inline) .field:not(:only-child) .ui.toggle.checkbox {
  margin-top: 2.2142857143em;
}
.kb-labfront.container .ui.form .fields:not(.grouped):not(.inline) .field:not(:only-child) .ui.slider.checkbox {
  margin-top: 2.6142857143em;
}
.kb-labfront.container .ui.ui.form .field .fields .field:not(:only-child) .ui.checkbox {
  margin-top: 0.6em;
}
.kb-labfront.container .ui.ui.form .field .fields .field:not(:only-child) .ui.toggle.checkbox {
  margin-top: 0.5em;
}
.kb-labfront.container .ui.ui.form .field .fields .field:not(:only-child) .ui.slider.checkbox {
  margin-top: 0.7em;
}
.kb-labfront.container .ui.form .field .transparent.input:not(.icon) input,
.kb-labfront.container .ui.form .field input.transparent,
.kb-labfront.container .ui.form .field textarea.transparent {
  padding: 0.6785714286em 1em;
}
.kb-labfront.container .ui.form .field input.transparent,
.kb-labfront.container .ui.form .field textarea.transparent {
  border-color: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}
.kb-labfront.container .ui.form .field.error .transparent.input input,
.kb-labfront.container .ui.form .field.error .transparent.input textarea,
.kb-labfront.container .ui.form .field.error input.transparent,
.kb-labfront.container .ui.form .field.error textarea.transparent {
  background-color: #fff6f6 !important;
  color: #9f3a38 !important;
}
.kb-labfront.container .ui.form input.attached {
  width: auto;
}
.kb-labfront.container .ui.form select {
  display: block;
  height: auto;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.2857142857rem;
  box-shadow: 0 0 0 0 transparent inset;
  padding: 0.62em 1em;
  color: rgba(0, 0, 0, 0.87);
  transition: color 0.1s ease, border-color 0.1s ease;
}
.kb-labfront.container .ui.form .field > .selection.dropdown {
  min-width: auto;
  width: 100%;
}
.kb-labfront.container .ui.form .field > .selection.dropdown > .dropdown.icon {
  float: right;
}
.kb-labfront.container .ui.form .inline.fields .field > .selection.dropdown,
.kb-labfront.container .ui.form .inline.field > .selection.dropdown {
  width: auto;
}
.kb-labfront.container .ui.form .inline.fields .field > .selection.dropdown > .dropdown.icon,
.kb-labfront.container .ui.form .inline.field > .selection.dropdown > .dropdown.icon {
  float: none;
}
.kb-labfront.container .ui.form .field .ui.input,
.kb-labfront.container .ui.form .fields .field .ui.input,
.kb-labfront.container .ui.form .wide.field .ui.input {
  width: 100%;
}
.kb-labfront.container .ui.form .inline.fields .field:not(.wide) .ui.input,
.kb-labfront.container .ui.form .inline.field:not(.wide) .ui.input {
  width: auto;
  vertical-align: middle;
}
.kb-labfront.container .ui.form .fields .field .ui.input input,
.kb-labfront.container .ui.form .field .ui.input input {
  width: auto;
}
.kb-labfront.container .ui.form .ten.fields .ui.input input,
.kb-labfront.container .ui.form .nine.fields .ui.input input,
.kb-labfront.container .ui.form .eight.fields .ui.input input,
.kb-labfront.container .ui.form .seven.fields .ui.input input,
.kb-labfront.container .ui.form .six.fields .ui.input input,
.kb-labfront.container .ui.form .five.fields .ui.input input,
.kb-labfront.container .ui.form .four.fields .ui.input input,
.kb-labfront.container .ui.form .three.fields .ui.input input,
.kb-labfront.container .ui.form .two.fields .ui.input input,
.kb-labfront.container .ui.form .wide.field .ui.input input {
  flex: 1 0 auto;
  width: 0;
}
.kb-labfront.container .ui.form .success.message,
.kb-labfront.container .ui.form .warning.message,
.kb-labfront.container .ui.form .error.message,
.kb-labfront.container .ui.form .error.message:empty {
  display: none;
}
.kb-labfront.container .ui.form .message:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.form .field .prompt.label {
  white-space: normal;
  background: #ffffff !important;
  border: 1px solid #e0b4b4 !important;
  color: #9f3a38 !important;
}
.kb-labfront.container .ui.form .inline.fields .field .prompt,
.kb-labfront.container .ui.form .inline.field .prompt {
  vertical-align: top;
  margin: -0.25em 0 -0.5em 0.5em;
}
.kb-labfront.container .ui.form .inline.fields .field .prompt:before,
.kb-labfront.container .ui.form .inline.field .prompt:before {
  border-width: 0 0 1px 1px;
  bottom: auto;
  right: auto;
  top: 50%;
  left: 0;
}
.kb-labfront.container .ui.form .field.field input:-webkit-autofill {
  box-shadow: 0 0 0 100px #FFFFF0 inset !important;
  border-color: #E5DFA1 !important;
}
.kb-labfront.container .ui.form .field.field input:-webkit-autofill:focus {
  box-shadow: 0 0 0 100px #FFFFF0 inset !important;
  border-color: #D5C315 !important;
}
.kb-labfront.container .ui.form .error.error input:-webkit-autofill {
  box-shadow: 0 0 0 100px #FFFAF0 inset !important;
  border-color: #E0B4B4 !important;
}
.kb-labfront.container .ui.form ::-webkit-input-placeholder {
  color: rgba(191.25, 191.25, 191.25, 0.87);
}
.kb-labfront.container .ui.form :-ms-input-placeholder {
  color: rgba(191.25, 191.25, 191.25, 0.87) !important;
}
.kb-labfront.container .ui.form ::-moz-placeholder {
  color: rgba(191.25, 191.25, 191.25, 0.87);
}
.kb-labfront.container .ui.form :focus::-webkit-input-placeholder {
  color: rgba(114.75, 114.75, 114.75, 0.87);
}
.kb-labfront.container .ui.form :focus:-ms-input-placeholder {
  color: rgba(114.75, 114.75, 114.75, 0.87) !important;
}
.kb-labfront.container .ui.form :focus::-moz-placeholder {
  color: rgba(114.75, 114.75, 114.75, 0.87);
}
.kb-labfront.container .ui.form .error ::-webkit-input-placeholder {
  color: rgb(231.2976744186, 188.5488372093, 187.7023255814);
}
.kb-labfront.container .ui.form .error :-ms-input-placeholder {
  color: rgb(231.2976744186, 188.5488372093, 187.7023255814) !important;
}
.kb-labfront.container .ui.form .error ::-moz-placeholder {
  color: rgb(231.2976744186, 188.5488372093, 187.7023255814);
}
.kb-labfront.container .ui.form .error :focus::-webkit-input-placeholder {
  color: rgb(218.0139534884, 151.3069767442, 149.9860465116);
}
.kb-labfront.container .ui.form .error :focus:-ms-input-placeholder {
  color: rgb(218.0139534884, 151.3069767442, 149.9860465116) !important;
}
.kb-labfront.container .ui.form .error :focus::-moz-placeholder {
  color: rgb(218.0139534884, 151.3069767442, 149.9860465116);
}
.kb-labfront.container .ui.form input:not([type]):focus,
.kb-labfront.container .ui.form input[type=date]:focus,
.kb-labfront.container .ui.form input[type=datetime-local]:focus,
.kb-labfront.container .ui.form input[type=email]:focus,
.kb-labfront.container .ui.form input[type=number]:focus,
.kb-labfront.container .ui.form input[type=password]:focus,
.kb-labfront.container .ui.form input[type=search]:focus,
.kb-labfront.container .ui.form input[type=tel]:focus,
.kb-labfront.container .ui.form input[type=time]:focus,
.kb-labfront.container .ui.form input[type=text]:focus,
.kb-labfront.container .ui.form input[type=file]:focus,
.kb-labfront.container .ui.form input[type=url]:focus {
  color: rgba(0, 0, 0, 0.95);
  border-color: #85b7d9;
  border-radius: 0.2857142857rem;
  background: #ffffff;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.35) inset;
}
.kb-labfront.container .ui.form textarea:focus {
  color: rgba(0, 0, 0, 0.95);
  border-color: #85b7d9;
  border-radius: 0.2857142857rem;
  background: #ffffff;
  box-shadow: 0 0 0 0 rgba(34, 36, 38, 0.35) inset;
  -webkit-appearance: none;
}
.kb-labfront.container .ui.form.success .success.message:not(:empty) {
  display: block;
}
.kb-labfront.container .ui.form.success .compact.success.message:not(:empty) {
  display: inline-block;
}
.kb-labfront.container .ui.form.success .icon.success.message:not(:empty) {
  display: flex;
}
.kb-labfront.container .ui.form.warning .warning.message:not(:empty) {
  display: block;
}
.kb-labfront.container .ui.form.warning .compact.warning.message:not(:empty) {
  display: inline-block;
}
.kb-labfront.container .ui.form.warning .icon.warning.message:not(:empty) {
  display: flex;
}
.kb-labfront.container .ui.form.error .error.message:not(:empty) {
  display: block;
}
.kb-labfront.container .ui.form.error .compact.error.message:not(:empty) {
  display: inline-block;
}
.kb-labfront.container .ui.form.error .icon.error.message:not(:empty) {
  display: flex;
}
.kb-labfront.container .ui.ui.form .fields.error .field label,
.kb-labfront.container .ui.ui.form .field.error label,
.kb-labfront.container .ui.ui.form .fields.error .field .input,
.kb-labfront.container .ui.ui.form .field.error .input {
  color: #9f3a38;
}
.kb-labfront.container .ui.form .fields.error .field .corner.label,
.kb-labfront.container .ui.form .field.error .corner.label {
  border-color: #9f3a38;
  color: #ffffff;
}
.kb-labfront.container .ui.form .fields.error .field textarea,
.kb-labfront.container .ui.form .fields.error .field select,
.kb-labfront.container .ui.form .fields.error .field input:not([type]),
.kb-labfront.container .ui.form .fields.error .field input[type=date],
.kb-labfront.container .ui.form .fields.error .field input[type=datetime-local],
.kb-labfront.container .ui.form .fields.error .field input[type=email],
.kb-labfront.container .ui.form .fields.error .field input[type=number],
.kb-labfront.container .ui.form .fields.error .field input[type=password],
.kb-labfront.container .ui.form .fields.error .field input[type=search],
.kb-labfront.container .ui.form .fields.error .field input[type=tel],
.kb-labfront.container .ui.form .fields.error .field input[type=time],
.kb-labfront.container .ui.form .fields.error .field input[type=text],
.kb-labfront.container .ui.form .fields.error .field input[type=file],
.kb-labfront.container .ui.form .fields.error .field input[type=url],
.kb-labfront.container .ui.form .field.error textarea,
.kb-labfront.container .ui.form .field.error select,
.kb-labfront.container .ui.form .field.error input:not([type]),
.kb-labfront.container .ui.form .field.error input[type=date],
.kb-labfront.container .ui.form .field.error input[type=datetime-local],
.kb-labfront.container .ui.form .field.error input[type=email],
.kb-labfront.container .ui.form .field.error input[type=number],
.kb-labfront.container .ui.form .field.error input[type=password],
.kb-labfront.container .ui.form .field.error input[type=search],
.kb-labfront.container .ui.form .field.error input[type=tel],
.kb-labfront.container .ui.form .field.error input[type=time],
.kb-labfront.container .ui.form .field.error input[type=text],
.kb-labfront.container .ui.form .field.error input[type=file],
.kb-labfront.container .ui.form .field.error input[type=url] {
  background: #fff6f6;
  border-color: #e0b4b4;
  color: #9f3a38;
  border-radius: "";
  box-shadow: none;
}
.kb-labfront.container .ui.form .field.error textarea:focus,
.kb-labfront.container .ui.form .field.error select:focus,
.kb-labfront.container .ui.form .field.error input:not([type]):focus,
.kb-labfront.container .ui.form .field.error input[type=date]:focus,
.kb-labfront.container .ui.form .field.error input[type=datetime-local]:focus,
.kb-labfront.container .ui.form .field.error input[type=email]:focus,
.kb-labfront.container .ui.form .field.error input[type=number]:focus,
.kb-labfront.container .ui.form .field.error input[type=password]:focus,
.kb-labfront.container .ui.form .field.error input[type=search]:focus,
.kb-labfront.container .ui.form .field.error input[type=tel]:focus,
.kb-labfront.container .ui.form .field.error input[type=time]:focus,
.kb-labfront.container .ui.form .field.error input[type=text]:focus,
.kb-labfront.container .ui.form .field.error input[type=file]:focus,
.kb-labfront.container .ui.form .field.error input[type=url]:focus {
  background: #fff6f6;
  border-color: #e0b4b4;
  color: #9f3a38;
  box-shadow: none;
}
.kb-labfront.container .ui.form .field.error select {
  -webkit-appearance: menulist-button;
}
.kb-labfront.container .ui.form .fields.error .field .ui.dropdown,
.kb-labfront.container .ui.form .fields.error .field .ui.dropdown .item,
.kb-labfront.container .ui.form .field.error .ui.dropdown,
.kb-labfront.container .ui.form .field.error .ui.dropdown .text,
.kb-labfront.container .ui.form .field.error .ui.dropdown .item {
  background: #fff6f6;
  color: #9f3a38;
}
.kb-labfront.container .ui.form .fields.error .field .ui.dropdown,
.kb-labfront.container .ui.form .field.error .ui.dropdown {
  border-color: #e0b4b4 !important;
}
.kb-labfront.container .ui.form .fields.error .field .ui.dropdown:hover,
.kb-labfront.container .ui.form .field.error .ui.dropdown:hover {
  border-color: #e0b4b4 !important;
}
.kb-labfront.container .ui.form .fields.error .field .ui.dropdown:hover .menu,
.kb-labfront.container .ui.form .field.error .ui.dropdown:hover .menu {
  border-color: #e0b4b4;
}
.kb-labfront.container .ui.form .fields.error .field .ui.multiple.selection.dropdown > .label,
.kb-labfront.container .ui.form .field.error .ui.multiple.selection.dropdown > .label {
  background-color: #EACBCB;
  color: #9f3a38;
}
.kb-labfront.container .ui.form .fields.error .field .ui.dropdown .menu .item:hover,
.kb-labfront.container .ui.form .field.error .ui.dropdown .menu .item:hover {
  background-color: #FBE7E7;
}
.kb-labfront.container .ui.form .fields.error .field .ui.dropdown .menu .selected.item,
.kb-labfront.container .ui.form .field.error .ui.dropdown .menu .selected.item {
  background-color: #FBE7E7;
}
.kb-labfront.container .ui.form .fields.error .field .ui.dropdown .menu .active.item,
.kb-labfront.container .ui.form .field.error .ui.dropdown .menu .active.item {
  background-color: #FDCFCF !important;
}
.kb-labfront.container .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label,
.kb-labfront.container .ui.form .field.error .checkbox:not(.toggle):not(.slider) label,
.kb-labfront.container .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box,
.kb-labfront.container .ui.form .field.error .checkbox:not(.toggle):not(.slider) .box {
  color: #9f3a38;
}
.kb-labfront.container .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label:before,
.kb-labfront.container .ui.form .field.error .checkbox:not(.toggle):not(.slider) label:before,
.kb-labfront.container .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box:before,
.kb-labfront.container .ui.form .field.error .checkbox:not(.toggle):not(.slider) .box:before {
  background: #fff6f6;
  border-color: #e0b4b4;
}
.kb-labfront.container .ui.form .fields.error .field .checkbox label:after,
.kb-labfront.container .ui.form .field.error .checkbox label:after,
.kb-labfront.container .ui.form .fields.error .field .checkbox .box:after,
.kb-labfront.container .ui.form .field.error .checkbox .box:after {
  color: #9f3a38;
}
.kb-labfront.container .ui.form .disabled.fields .field,
.kb-labfront.container .ui.form .disabled.field,
.kb-labfront.container .ui.form .field :disabled {
  pointer-events: none;
  opacity: 0.45;
}
.kb-labfront.container .ui.form .field.disabled > label,
.kb-labfront.container .ui.form .fields.disabled > label {
  opacity: 0.45;
}
.kb-labfront.container .ui.form .field.disabled :disabled {
  opacity: 1;
}
.kb-labfront.container .ui.loading.form {
  position: relative;
  cursor: default;
  pointer-events: none;
}
.kb-labfront.container .ui.loading.form:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 100;
}
.kb-labfront.container .ui.loading.form.segments:before {
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.loading.form:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 3em;
  height: 3em;
  animation: loader 0.6s infinite linear;
  border: 0.2em solid #767676;
  border-radius: 500rem;
  box-shadow: 0 0 0 1px transparent;
  visibility: visible;
  z-index: 101;
}
.kb-labfront.container .ui.form .required.fields:not(.grouped) > .field > label:after,
.kb-labfront.container .ui.form .required.fields.grouped > label:after,
.kb-labfront.container .ui.form .required.field > label:after,
.kb-labfront.container .ui.form .required.fields:not(.grouped) > .field > .checkbox:after,
.kb-labfront.container .ui.form .required.field > .checkbox:after,
.kb-labfront.container .ui.form label.required:after {
  margin: -0.2em 0 0 0.2em;
  content: "*";
  color: #db2828;
}
.kb-labfront.container .ui.form .required.fields:not(.grouped) > .field > label:after,
.kb-labfront.container .ui.form .required.fields.grouped > label:after,
.kb-labfront.container .ui.form .required.field > label:after,
.kb-labfront.container .ui.form label.required:after {
  display: inline-block;
  vertical-align: top;
}
.kb-labfront.container .ui.form .required.fields:not(.grouped) > .field > .checkbox:after,
.kb-labfront.container .ui.form .required.field > .checkbox:after {
  position: absolute;
  top: 0;
  left: 100%;
}
.kb-labfront.container .ui.inverted.form label,
.kb-labfront.container .ui.form .inverted.segment label,
.kb-labfront.container .ui.form .inverted.segment .ui.checkbox label,
.kb-labfront.container .ui.form .inverted.segment .ui.checkbox .box,
.kb-labfront.container .ui.inverted.form .ui.checkbox label,
.kb-labfront.container .ui.inverted.form .ui.checkbox .box,
.kb-labfront.container .ui.inverted.form .inline.fields > label,
.kb-labfront.container .ui.inverted.form .inline.fields .field > label,
.kb-labfront.container .ui.inverted.form .inline.fields .field > p,
.kb-labfront.container .ui.inverted.form .inline.field > label,
.kb-labfront.container .ui.inverted.form .inline.field > p {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.loading.form {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.loading.form:before {
  background: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.inverted.form input:not([type]),
.kb-labfront.container .ui.inverted.form input[type=date],
.kb-labfront.container .ui.inverted.form input[type=datetime-local],
.kb-labfront.container .ui.inverted.form input[type=email],
.kb-labfront.container .ui.inverted.form input[type=number],
.kb-labfront.container .ui.inverted.form input[type=password],
.kb-labfront.container .ui.inverted.form input[type=search],
.kb-labfront.container .ui.inverted.form input[type=tel],
.kb-labfront.container .ui.inverted.form input[type=time],
.kb-labfront.container .ui.inverted.form input[type=text],
.kb-labfront.container .ui.inverted.form input[type=file],
.kb-labfront.container .ui.inverted.form input[type=url] {
  background: #ffffff;
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(0, 0, 0, 0.87);
  box-shadow: 0 0 0 0 transparent inset;
}
.kb-labfront.container .ui.form .grouped.fields {
  display: block;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.form .grouped.fields:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.form .grouped.fields > label {
  margin: 0 0 0.2857142857rem 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 0.9285714286em;
  font-weight: bold;
  text-transform: none;
}
.kb-labfront.container .ui.form .grouped.fields .field,
.kb-labfront.container .ui.form .grouped.inline.fields .field {
  display: block;
  margin: 0.5em 0;
  padding: 0;
}
.kb-labfront.container .ui.form .fields {
  display: flex;
  flex-direction: row;
  margin: 0 -0.5em 1em;
}
.kb-labfront.container .ui.form .fields > .field {
  flex: 0 1 auto;
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.kb-labfront.container .ui.form .fields > .field:first-child {
  border-left: none;
  box-shadow: none;
}
.kb-labfront.container .ui.form .two.fields > .fields,
.kb-labfront.container .ui.form .two.fields > .field {
  width: 50%;
}
.kb-labfront.container .ui.form .three.fields > .fields,
.kb-labfront.container .ui.form .three.fields > .field {
  width: 33.3333333333%;
}
.kb-labfront.container .ui.form .four.fields > .fields,
.kb-labfront.container .ui.form .four.fields > .field {
  width: 25%;
}
.kb-labfront.container .ui.form .five.fields > .fields,
.kb-labfront.container .ui.form .five.fields > .field {
  width: 20%;
}
.kb-labfront.container .ui.form .six.fields > .fields,
.kb-labfront.container .ui.form .six.fields > .field {
  width: 16.6666666667%;
}
.kb-labfront.container .ui.form .seven.fields > .fields,
.kb-labfront.container .ui.form .seven.fields > .field {
  width: 14.2857142857%;
}
.kb-labfront.container .ui.form .eight.fields > .fields,
.kb-labfront.container .ui.form .eight.fields > .field {
  width: 12.5%;
}
.kb-labfront.container .ui.form .nine.fields > .fields,
.kb-labfront.container .ui.form .nine.fields > .field {
  width: 11.1111111111%;
}
.kb-labfront.container .ui.form .ten.fields > .fields,
.kb-labfront.container .ui.form .ten.fields > .field {
  width: 10%;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.form .fields {
    flex-wrap: wrap;
  }
  .kb-labfront.container .ui[class*="equal width"].form:not(.unstackable) .fields > .field,
  .kb-labfront.container .ui.form:not(.unstackable) [class*="equal width"].fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .field {
    width: 100% !important;
    margin: 0 0 1em;
  }
}
.kb-labfront.container .ui.form .fields .wide.field {
  width: 6.25%;
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.kb-labfront.container .ui.form .one.wide.field {
  width: 6.25% !important;
}
.kb-labfront.container .ui.form .two.wide.field {
  width: 12.5% !important;
}
.kb-labfront.container .ui.form .three.wide.field {
  width: 18.75% !important;
}
.kb-labfront.container .ui.form .four.wide.field {
  width: 25% !important;
}
.kb-labfront.container .ui.form .five.wide.field {
  width: 31.25% !important;
}
.kb-labfront.container .ui.form .six.wide.field {
  width: 37.5% !important;
}
.kb-labfront.container .ui.form .seven.wide.field {
  width: 43.75% !important;
}
.kb-labfront.container .ui.form .eight.wide.field {
  width: 50% !important;
}
.kb-labfront.container .ui.form .nine.wide.field {
  width: 56.25% !important;
}
.kb-labfront.container .ui.form .ten.wide.field {
  width: 62.5% !important;
}
.kb-labfront.container .ui.form .eleven.wide.field {
  width: 68.75% !important;
}
.kb-labfront.container .ui.form .twelve.wide.field {
  width: 75% !important;
}
.kb-labfront.container .ui.form .thirteen.wide.field {
  width: 81.25% !important;
}
.kb-labfront.container .ui.form .fourteen.wide.field {
  width: 87.5% !important;
}
.kb-labfront.container .ui.form .fifteen.wide.field {
  width: 93.75% !important;
}
.kb-labfront.container .ui.form .sixteen.wide.field {
  width: 100% !important;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,
  .kb-labfront.container .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .two.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .three.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .four.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .five.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .six.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .seven.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .eight.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .nine.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .ten.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .eleven.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .twelve.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .thirteen.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .fourteen.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .fifteen.wide.field,
  .kb-labfront.container .ui.form:not(.unstackable) .fields:not(.unstackable) > .sixteen.wide.field {
    width: 100% !important;
  }
  .kb-labfront.container .ui.form .fields {
    margin-bottom: 0;
  }
}
.kb-labfront.container .ui[class*="equal width"].form .fields > .field,
.kb-labfront.container .ui.form [class*="equal width"].fields > .field {
  width: 100%;
  flex: 1 1 auto;
}
.kb-labfront.container .ui.form .inline.fields {
  margin: 0 0 1em;
  align-items: center;
}
.kb-labfront.container .ui.form .inline.fields .field {
  margin: 0;
  padding: 0 1em 0 0;
}
.kb-labfront.container .ui.form .inline.fields > label,
.kb-labfront.container .ui.form .inline.fields .field > label,
.kb-labfront.container .ui.form .inline.fields .field > p,
.kb-labfront.container .ui.form .inline.field > label,
.kb-labfront.container .ui.form .inline.field > p {
  display: inline-block;
  width: auto;
  margin-top: 0;
  margin-bottom: 0;
  vertical-align: baseline;
  font-size: 0.9285714286em;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.87);
  text-transform: none;
}
.kb-labfront.container .ui.form .inline.fields > label {
  margin: 0.035714em 1em 0 0;
}
.kb-labfront.container .ui.form .inline.fields .field > input,
.kb-labfront.container .ui.form .inline.fields .field > select,
.kb-labfront.container .ui.form .inline.field > input,
.kb-labfront.container .ui.form .inline.field > select {
  display: inline-block;
  width: auto;
  margin-top: 0;
  margin-bottom: 0;
  vertical-align: middle;
  font-size: 1em;
}
.kb-labfront.container .ui.form .inline.fields .field > :first-child,
.kb-labfront.container .ui.form .inline.field > :first-child {
  margin: 0 0.8571428571em 0 0;
}
.kb-labfront.container .ui.form .inline.fields .field > :only-child,
.kb-labfront.container .ui.form .inline.field > :only-child {
  margin: 0;
}
.kb-labfront.container .ui.form .inline.fields .wide.field {
  display: flex;
  align-items: center;
}
.kb-labfront.container .ui.form .inline.fields .wide.field > input,
.kb-labfront.container .ui.form .inline.fields .wide.field > select {
  width: 100%;
}
.kb-labfront.container .ui.mini.form {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.form {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.form {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.form {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.form {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.form {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.form {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.form {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.mini.form .field .dropdown {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.form .field .dropdown {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.form .field .dropdown {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.form .field .dropdown {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.form .field .dropdown {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.form .field .dropdown {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.form .field .dropdown {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.form .field .dropdown {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.mini.form .field .dropdown .menu > .item {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.form .field .dropdown .menu > .item {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.form .field .dropdown .menu > .item {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.form .field .dropdown .menu > .item {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.form .field .dropdown .menu > .item {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.form .field .dropdown .menu > .item {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.form .field .dropdown .menu > .item {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.form .field .dropdown .menu > .item {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  padding: 0;
}
.kb-labfront.container .ui.grid {
  margin-top: -1rem;
  margin-bottom: -1rem;
  margin-left: -1rem;
  margin-right: -1rem;
}
.kb-labfront.container .ui.relaxed.grid {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.kb-labfront.container .ui[class*="very relaxed"].grid {
  margin-left: -2.5rem;
  margin-right: -2.5rem;
}
.kb-labfront.container .ui.grid + .grid {
  margin-top: 1rem;
}
.kb-labfront.container .ui.grid > .column:not(.row),
.kb-labfront.container .ui.grid > .row > .column {
  position: relative;
  display: inline-block;
  width: 6.25%;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: top;
}
.kb-labfront.container .ui.grid > * {
  padding-left: 1rem;
  padding-right: 1rem;
}
.kb-labfront.container .ui.grid > .row {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: inherit;
  align-items: stretch;
  width: 100% !important;
  padding: 0;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.kb-labfront.container .ui.grid > .column:not(.row) {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.kb-labfront.container .ui.grid > .row > .column {
  margin-top: 0;
  margin-bottom: 0;
}
.kb-labfront.container .ui.grid > .row > img,
.kb-labfront.container .ui.grid > .row > .column > img {
  max-width: 100%;
}
.kb-labfront.container .ui.grid > .ui.grid:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.grid > .ui.grid:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.grid .aligned.row > .column > .segment:not(.compact):not(.attached),
.kb-labfront.container .ui.aligned.grid .column > .segment:not(.compact):not(.attached) {
  width: 100%;
}
.kb-labfront.container .ui.grid .row + .ui.divider {
  flex-grow: 1;
  margin: 1rem 1rem;
}
.kb-labfront.container .ui.grid .column + .ui.vertical.divider {
  height: calc(50% - 1rem);
}
.kb-labfront.container .ui.grid > .row > .column:last-child > .horizontal.segment,
.kb-labfront.container .ui.grid > .column:last-child > .horizontal.segment {
  box-shadow: none;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.page.grid {
    width: auto;
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
    margin-right: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .kb-labfront.container .ui.page.grid {
    width: auto;
    margin-left: 0;
    margin-right: 0;
    padding-left: 2em;
    padding-right: 2em;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199.98px) {
  .kb-labfront.container .ui.page.grid {
    width: auto;
    margin-left: 0;
    margin-right: 0;
    padding-left: 3%;
    padding-right: 3%;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1919.98px) {
  .kb-labfront.container .ui.page.grid {
    width: auto;
    margin-left: 0;
    margin-right: 0;
    padding-left: 15%;
    padding-right: 15%;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.page.grid {
    width: auto;
    margin-left: 0;
    margin-right: 0;
    padding-left: 23%;
    padding-right: 23%;
  }
}
.kb-labfront.container .ui.grid > .column:only-child,
.kb-labfront.container .ui.grid > .row > .column:only-child {
  width: 100%;
}
.kb-labfront.container .ui[class*="one column"].grid > .row > .column,
.kb-labfront.container .ui[class*="one column"].grid > .column:not(.row) {
  width: 100%;
}
.kb-labfront.container .ui[class*="two column"].grid > .row > .column,
.kb-labfront.container .ui[class*="two column"].grid > .column:not(.row) {
  width: 50%;
}
.kb-labfront.container .ui[class*="three column"].grid > .row > .column,
.kb-labfront.container .ui[class*="three column"].grid > .column:not(.row) {
  width: 33.3333333333%;
}
.kb-labfront.container .ui[class*="four column"].grid > .row > .column,
.kb-labfront.container .ui[class*="four column"].grid > .column:not(.row) {
  width: 25%;
}
.kb-labfront.container .ui[class*="five column"].grid > .row > .column,
.kb-labfront.container .ui[class*="five column"].grid > .column:not(.row) {
  width: 20%;
}
.kb-labfront.container .ui[class*="six column"].grid > .row > .column,
.kb-labfront.container .ui[class*="six column"].grid > .column:not(.row) {
  width: 16.6666666667%;
}
.kb-labfront.container .ui[class*="seven column"].grid > .row > .column,
.kb-labfront.container .ui[class*="seven column"].grid > .column:not(.row) {
  width: 14.2857142857%;
}
.kb-labfront.container .ui[class*="eight column"].grid > .row > .column,
.kb-labfront.container .ui[class*="eight column"].grid > .column:not(.row) {
  width: 12.5%;
}
.kb-labfront.container .ui[class*="nine column"].grid > .row > .column,
.kb-labfront.container .ui[class*="nine column"].grid > .column:not(.row) {
  width: 11.1111111111%;
}
.kb-labfront.container .ui[class*="ten column"].grid > .row > .column,
.kb-labfront.container .ui[class*="ten column"].grid > .column:not(.row) {
  width: 10%;
}
.kb-labfront.container .ui[class*="eleven column"].grid > .row > .column,
.kb-labfront.container .ui[class*="eleven column"].grid > .column:not(.row) {
  width: 9.0909090909%;
}
.kb-labfront.container .ui[class*="twelve column"].grid > .row > .column,
.kb-labfront.container .ui[class*="twelve column"].grid > .column:not(.row) {
  width: 8.3333333333%;
}
.kb-labfront.container .ui[class*="thirteen column"].grid > .row > .column,
.kb-labfront.container .ui[class*="thirteen column"].grid > .column:not(.row) {
  width: 7.6923076923%;
}
.kb-labfront.container .ui[class*="fourteen column"].grid > .row > .column,
.kb-labfront.container .ui[class*="fourteen column"].grid > .column:not(.row) {
  width: 7.1428571429%;
}
.kb-labfront.container .ui[class*="fifteen column"].grid > .row > .column,
.kb-labfront.container .ui[class*="fifteen column"].grid > .column:not(.row) {
  width: 6.6666666667%;
}
.kb-labfront.container .ui[class*="sixteen column"].grid > .row > .column,
.kb-labfront.container .ui[class*="sixteen column"].grid > .column:not(.row) {
  width: 6.25%;
}
.kb-labfront.container .ui.grid > [class*="one column"].row > .column {
  width: 100% !important;
}
.kb-labfront.container .ui.grid > [class*="two column"].row > .column {
  width: 50% !important;
}
.kb-labfront.container .ui.grid > [class*="three column"].row > .column {
  width: 33.3333333333% !important;
}
.kb-labfront.container .ui.grid > [class*="four column"].row > .column {
  width: 25% !important;
}
.kb-labfront.container .ui.grid > [class*="five column"].row > .column {
  width: 20% !important;
}
.kb-labfront.container .ui.grid > [class*="six column"].row > .column {
  width: 16.6666666667% !important;
}
.kb-labfront.container .ui.grid > [class*="seven column"].row > .column {
  width: 14.2857142857% !important;
}
.kb-labfront.container .ui.grid > [class*="eight column"].row > .column {
  width: 12.5% !important;
}
.kb-labfront.container .ui.grid > [class*="nine column"].row > .column {
  width: 11.1111111111% !important;
}
.kb-labfront.container .ui.grid > [class*="ten column"].row > .column {
  width: 10% !important;
}
.kb-labfront.container .ui.grid > [class*="eleven column"].row > .column {
  width: 9.0909090909% !important;
}
.kb-labfront.container .ui.grid > [class*="twelve column"].row > .column {
  width: 8.3333333333% !important;
}
.kb-labfront.container .ui.grid > [class*="thirteen column"].row > .column {
  width: 7.6923076923% !important;
}
.kb-labfront.container .ui.grid > [class*="fourteen column"].row > .column {
  width: 7.1428571429% !important;
}
.kb-labfront.container .ui.grid > [class*="fifteen column"].row > .column {
  width: 6.6666666667% !important;
}
.kb-labfront.container .ui.grid > [class*="sixteen column"].row > .column {
  width: 6.25% !important;
}
.kb-labfront.container .ui.celled.page.grid {
  box-shadow: none;
}
.kb-labfront.container .ui.grid > .row > [class*="one wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="one wide"].column,
.kb-labfront.container .ui.grid > [class*="one wide"].column,
.kb-labfront.container .ui.column.grid > [class*="one wide"].column {
  width: 6.25% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="two wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="two wide"].column,
.kb-labfront.container .ui.grid > [class*="two wide"].column,
.kb-labfront.container .ui.column.grid > [class*="two wide"].column {
  width: 12.5% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="three wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="three wide"].column,
.kb-labfront.container .ui.grid > [class*="three wide"].column,
.kb-labfront.container .ui.column.grid > [class*="three wide"].column {
  width: 18.75% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="four wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="four wide"].column,
.kb-labfront.container .ui.grid > [class*="four wide"].column,
.kb-labfront.container .ui.column.grid > [class*="four wide"].column {
  width: 25% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="five wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="five wide"].column,
.kb-labfront.container .ui.grid > [class*="five wide"].column,
.kb-labfront.container .ui.column.grid > [class*="five wide"].column {
  width: 31.25% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="six wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="six wide"].column,
.kb-labfront.container .ui.grid > [class*="six wide"].column,
.kb-labfront.container .ui.column.grid > [class*="six wide"].column {
  width: 37.5% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="seven wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="seven wide"].column,
.kb-labfront.container .ui.grid > [class*="seven wide"].column,
.kb-labfront.container .ui.column.grid > [class*="seven wide"].column {
  width: 43.75% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="eight wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="eight wide"].column,
.kb-labfront.container .ui.grid > [class*="eight wide"].column,
.kb-labfront.container .ui.column.grid > [class*="eight wide"].column {
  width: 50% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="nine wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="nine wide"].column,
.kb-labfront.container .ui.grid > [class*="nine wide"].column,
.kb-labfront.container .ui.column.grid > [class*="nine wide"].column {
  width: 56.25% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="ten wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="ten wide"].column,
.kb-labfront.container .ui.grid > [class*="ten wide"].column,
.kb-labfront.container .ui.column.grid > [class*="ten wide"].column {
  width: 62.5% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="eleven wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="eleven wide"].column,
.kb-labfront.container .ui.grid > [class*="eleven wide"].column,
.kb-labfront.container .ui.column.grid > [class*="eleven wide"].column {
  width: 68.75% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="twelve wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="twelve wide"].column,
.kb-labfront.container .ui.grid > [class*="twelve wide"].column,
.kb-labfront.container .ui.column.grid > [class*="twelve wide"].column {
  width: 75% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="thirteen wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="thirteen wide"].column,
.kb-labfront.container .ui.grid > [class*="thirteen wide"].column,
.kb-labfront.container .ui.column.grid > [class*="thirteen wide"].column {
  width: 81.25% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="fourteen wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="fourteen wide"].column,
.kb-labfront.container .ui.grid > [class*="fourteen wide"].column,
.kb-labfront.container .ui.column.grid > [class*="fourteen wide"].column {
  width: 87.5% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="fifteen wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="fifteen wide"].column,
.kb-labfront.container .ui.grid > [class*="fifteen wide"].column,
.kb-labfront.container .ui.column.grid > [class*="fifteen wide"].column {
  width: 93.75% !important;
}
.kb-labfront.container .ui.grid > .row > [class*="sixteen wide"].column,
.kb-labfront.container .ui.grid > .column.row > [class*="sixteen wide"].column,
.kb-labfront.container .ui.grid > [class*="sixteen wide"].column,
.kb-labfront.container .ui.column.grid > [class*="sixteen wide"].column {
  width: 100% !important;
}
@media only screen and (min-width: 320px) and (max-width: 767.98px) {
  .kb-labfront.container .ui.grid > .row > [class*="one wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="one wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="one wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="one wide mobile"].column {
    width: 6.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="two wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="two wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="two wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="two wide mobile"].column {
    width: 12.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="three wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="three wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="three wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="three wide mobile"].column {
    width: 18.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="four wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="four wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="four wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="four wide mobile"].column {
    width: 25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="five wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="five wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="five wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="five wide mobile"].column {
    width: 31.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="six wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="six wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="six wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="six wide mobile"].column {
    width: 37.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="seven wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="seven wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="seven wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="seven wide mobile"].column {
    width: 43.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eight wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eight wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="eight wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="eight wide mobile"].column {
    width: 50% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="nine wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="nine wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="nine wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="nine wide mobile"].column {
    width: 56.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="ten wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="ten wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="ten wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="ten wide mobile"].column {
    width: 62.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eleven wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eleven wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="eleven wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="eleven wide mobile"].column {
    width: 68.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="twelve wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="twelve wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="twelve wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="twelve wide mobile"].column {
    width: 75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="thirteen wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="thirteen wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="thirteen wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="thirteen wide mobile"].column {
    width: 81.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fourteen wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fourteen wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="fourteen wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="fourteen wide mobile"].column {
    width: 87.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fifteen wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fifteen wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="fifteen wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="fifteen wide mobile"].column {
    width: 93.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="sixteen wide mobile"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="sixteen wide mobile"].column,
  .kb-labfront.container .ui.grid > [class*="sixteen wide mobile"].column,
  .kb-labfront.container .ui.column.grid > [class*="sixteen wide mobile"].column {
    width: 100% !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .kb-labfront.container .ui.grid > .row > [class*="one wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="one wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="one wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="one wide tablet"].column {
    width: 6.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="two wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="two wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="two wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="two wide tablet"].column {
    width: 12.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="three wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="three wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="three wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="three wide tablet"].column {
    width: 18.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="four wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="four wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="four wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="four wide tablet"].column {
    width: 25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="five wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="five wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="five wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="five wide tablet"].column {
    width: 31.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="six wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="six wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="six wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="six wide tablet"].column {
    width: 37.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="seven wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="seven wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="seven wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="seven wide tablet"].column {
    width: 43.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eight wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eight wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="eight wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="eight wide tablet"].column {
    width: 50% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="nine wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="nine wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="nine wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="nine wide tablet"].column {
    width: 56.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="ten wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="ten wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="ten wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="ten wide tablet"].column {
    width: 62.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eleven wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eleven wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="eleven wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="eleven wide tablet"].column {
    width: 68.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="twelve wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="twelve wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="twelve wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="twelve wide tablet"].column {
    width: 75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="thirteen wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="thirteen wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="thirteen wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="thirteen wide tablet"].column {
    width: 81.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fourteen wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fourteen wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="fourteen wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="fourteen wide tablet"].column {
    width: 87.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fifteen wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fifteen wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="fifteen wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="fifteen wide tablet"].column {
    width: 93.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="sixteen wide tablet"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="sixteen wide tablet"].column,
  .kb-labfront.container .ui.grid > [class*="sixteen wide tablet"].column,
  .kb-labfront.container .ui.column.grid > [class*="sixteen wide tablet"].column {
    width: 100% !important;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.grid > .row > [class*="one wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="one wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="one wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="one wide computer"].column {
    width: 6.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="two wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="two wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="two wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="two wide computer"].column {
    width: 12.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="three wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="three wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="three wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="three wide computer"].column {
    width: 18.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="four wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="four wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="four wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="four wide computer"].column {
    width: 25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="five wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="five wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="five wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="five wide computer"].column {
    width: 31.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="six wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="six wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="six wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="six wide computer"].column {
    width: 37.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="seven wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="seven wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="seven wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="seven wide computer"].column {
    width: 43.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eight wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eight wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="eight wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="eight wide computer"].column {
    width: 50% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="nine wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="nine wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="nine wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="nine wide computer"].column {
    width: 56.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="ten wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="ten wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="ten wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="ten wide computer"].column {
    width: 62.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eleven wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eleven wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="eleven wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="eleven wide computer"].column {
    width: 68.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="twelve wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="twelve wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="twelve wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="twelve wide computer"].column {
    width: 75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="thirteen wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="thirteen wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="thirteen wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="thirteen wide computer"].column {
    width: 81.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fourteen wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fourteen wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="fourteen wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="fourteen wide computer"].column {
    width: 87.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fifteen wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fifteen wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="fifteen wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="fifteen wide computer"].column {
    width: 93.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="sixteen wide computer"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="sixteen wide computer"].column,
  .kb-labfront.container .ui.grid > [class*="sixteen wide computer"].column,
  .kb-labfront.container .ui.column.grid > [class*="sixteen wide computer"].column {
    width: 100% !important;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1919.98px) {
  .kb-labfront.container .ui.grid > .row > [class*="one wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="one wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="one wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="one wide large screen"].column {
    width: 6.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="two wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="two wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="two wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="two wide large screen"].column {
    width: 12.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="three wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="three wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="three wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="three wide large screen"].column {
    width: 18.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="four wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="four wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="four wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="four wide large screen"].column {
    width: 25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="five wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="five wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="five wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="five wide large screen"].column {
    width: 31.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="six wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="six wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="six wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="six wide large screen"].column {
    width: 37.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="seven wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="seven wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="seven wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="seven wide large screen"].column {
    width: 43.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eight wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eight wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="eight wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="eight wide large screen"].column {
    width: 50% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="nine wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="nine wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="nine wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="nine wide large screen"].column {
    width: 56.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="ten wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="ten wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="ten wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="ten wide large screen"].column {
    width: 62.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eleven wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eleven wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="eleven wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="eleven wide large screen"].column {
    width: 68.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="twelve wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="twelve wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="twelve wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="twelve wide large screen"].column {
    width: 75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="thirteen wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="thirteen wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="thirteen wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="thirteen wide large screen"].column {
    width: 81.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fourteen wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fourteen wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="fourteen wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="fourteen wide large screen"].column {
    width: 87.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fifteen wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fifteen wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="fifteen wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="fifteen wide large screen"].column {
    width: 93.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="sixteen wide large screen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="sixteen wide large screen"].column,
  .kb-labfront.container .ui.grid > [class*="sixteen wide large screen"].column,
  .kb-labfront.container .ui.column.grid > [class*="sixteen wide large screen"].column {
    width: 100% !important;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.grid > .row > [class*="one wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="one wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="one wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="one wide widescreen"].column {
    width: 6.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="two wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="two wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="two wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="two wide widescreen"].column {
    width: 12.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="three wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="three wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="three wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="three wide widescreen"].column {
    width: 18.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="four wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="four wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="four wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="four wide widescreen"].column {
    width: 25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="five wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="five wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="five wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="five wide widescreen"].column {
    width: 31.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="six wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="six wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="six wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="six wide widescreen"].column {
    width: 37.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="seven wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="seven wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="seven wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="seven wide widescreen"].column {
    width: 43.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eight wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eight wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="eight wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="eight wide widescreen"].column {
    width: 50% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="nine wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="nine wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="nine wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="nine wide widescreen"].column {
    width: 56.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="ten wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="ten wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="ten wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="ten wide widescreen"].column {
    width: 62.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="eleven wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="eleven wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="eleven wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="eleven wide widescreen"].column {
    width: 68.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="twelve wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="twelve wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="twelve wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="twelve wide widescreen"].column {
    width: 75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="thirteen wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="thirteen wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="thirteen wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="thirteen wide widescreen"].column {
    width: 81.25% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fourteen wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fourteen wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="fourteen wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="fourteen wide widescreen"].column {
    width: 87.5% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="fifteen wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="fifteen wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="fifteen wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="fifteen wide widescreen"].column {
    width: 93.75% !important;
  }
  .kb-labfront.container .ui.grid > .row > [class*="sixteen wide widescreen"].column,
  .kb-labfront.container .ui.grid > .column.row > [class*="sixteen wide widescreen"].column,
  .kb-labfront.container .ui.grid > [class*="sixteen wide widescreen"].column,
  .kb-labfront.container .ui.column.grid > [class*="sixteen wide widescreen"].column {
    width: 100% !important;
  }
}
.kb-labfront.container .ui.centered.grid,
.kb-labfront.container .ui.centered.grid > .row,
.kb-labfront.container .ui.grid > .centered.row {
  text-align: center;
  justify-content: center;
}
.kb-labfront.container .ui.centered.grid > .column:not(.aligned):not(.justified):not(.row),
.kb-labfront.container .ui.centered.grid > .row > .column:not(.aligned):not(.justified),
.kb-labfront.container .ui.grid .centered.row > .column:not(.aligned):not(.justified) {
  text-align: left;
}
.kb-labfront.container .ui.grid > .centered.column,
.kb-labfront.container .ui.grid > .row > .centered.column {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.kb-labfront.container .ui.relaxed.grid > .column:not(.row),
.kb-labfront.container .ui.relaxed.grid > .row > .column,
.kb-labfront.container .ui.grid > .relaxed.row > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.kb-labfront.container .ui[class*="very relaxed"].grid > .column:not(.row),
.kb-labfront.container .ui[class*="very relaxed"].grid > .row > .column,
.kb-labfront.container .ui.grid > [class*="very relaxed"].row > .column {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.kb-labfront.container .ui.relaxed.grid .row + .ui.divider,
.kb-labfront.container .ui.grid .relaxed.row + .ui.divider {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.kb-labfront.container .ui[class*="very relaxed"].grid .row + .ui.divider,
.kb-labfront.container .ui.grid [class*="very relaxed"].row + .ui.divider {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.kb-labfront.container .ui.padded.grid:not(.vertically):not(.horizontally) {
  margin: 0 !important;
}
.kb-labfront.container [class*="horizontally padded"].ui.grid {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.kb-labfront.container [class*="vertically padded"].ui.grid {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.kb-labfront.container .ui.grid [class*="left floated"].column {
  margin-right: auto;
}
.kb-labfront.container .ui.grid [class*="right floated"].column {
  margin-left: auto;
}
.kb-labfront.container .ui.divided.grid:not([class*="vertically divided"]) > .column:not(.row),
.kb-labfront.container .ui.divided.grid:not([class*="vertically divided"]) > .row > .column {
  box-shadow: -1px 0 0 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui[class*="vertically divided"].grid > .column:not(.row),
.kb-labfront.container .ui[class*="vertically divided"].grid > .row > .column {
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding-top: 0;
  padding-bottom: 0;
}
.kb-labfront.container .ui[class*="vertically divided"].grid > .row {
  margin-top: 0;
  margin-bottom: 0;
}
.kb-labfront.container .ui.divided.grid:not([class*="vertically divided"]) > .column:first-child,
.kb-labfront.container .ui.divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
  box-shadow: none;
}
.kb-labfront.container .ui[class*="vertically divided"].grid > .row:first-child > .column {
  margin-top: 0;
}
.kb-labfront.container .ui.grid > .divided.row > .column {
  box-shadow: -1px 0 0 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.grid > .divided.row > .column:first-child {
  box-shadow: none;
}
.kb-labfront.container .ui[class*="vertically divided"].grid > .row {
  position: relative;
}
.kb-labfront.container .ui[class*="vertically divided"].grid > .row:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: calc(100% - 2rem);
  height: 1px;
  margin: 0 1rem;
  box-shadow: 0 -1px 0 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container [class*="horizontally padded"].ui.divided.grid,
.kb-labfront.container .ui.padded.divided.grid:not(.vertically):not(.horizontally) {
  width: 100%;
}
.kb-labfront.container .ui[class*="vertically divided"].grid > .row:first-child:before {
  box-shadow: none;
}
.kb-labfront.container .ui.inverted.divided.grid:not([class*="vertically divided"]) > .column:not(.row),
.kb-labfront.container .ui.inverted.divided.grid:not([class*="vertically divided"]) > .row > .column {
  box-shadow: -1px 0 0 0 rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.inverted.divided.grid:not([class*="vertically divided"]) > .column:not(.row):first-child,
.kb-labfront.container .ui.inverted.divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
  box-shadow: none;
}
.kb-labfront.container .ui.inverted[class*="vertically divided"].grid > .row:before {
  box-shadow: 0 -1px 0 0 rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.relaxed[class*="vertically divided"].grid > .row:before {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  width: calc(100% - 3rem);
}
.kb-labfront.container .ui[class*="very relaxed"][class*="vertically divided"].grid > .row:before {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
  width: calc(100% - 5rem);
}
.kb-labfront.container .ui.celled.grid {
  width: 100%;
  margin: 1em 0;
  box-shadow: 0 0 0 1px #d4d4d5;
}
.kb-labfront.container .ui.celled.grid > .row {
  width: 100% !important;
  margin: 0;
  padding: 0;
  box-shadow: 0 -1px 0 0 #d4d4d5;
}
.kb-labfront.container .ui.celled.grid > .column:not(.row),
.kb-labfront.container .ui.celled.grid > .row > .column {
  box-shadow: -1px 0 0 0 #d4d4d5;
}
.kb-labfront.container .ui.celled.grid > .column:first-child,
.kb-labfront.container .ui.celled.grid > .row > .column:first-child {
  box-shadow: none;
}
.kb-labfront.container .ui.celled.grid > .column:not(.row),
.kb-labfront.container .ui.celled.grid > .row > .column {
  padding: 1em;
}
.kb-labfront.container .ui.relaxed.celled.grid > .column:not(.row),
.kb-labfront.container .ui.relaxed.celled.grid > .row > .column {
  padding: 1.5em;
}
.kb-labfront.container .ui[class*="very relaxed"].celled.grid > .column:not(.row),
.kb-labfront.container .ui[class*="very relaxed"].celled.grid > .row > .column {
  padding: 2em;
}
.kb-labfront.container .ui[class*="internally celled"].grid {
  box-shadow: none;
  margin: 0;
}
.kb-labfront.container .ui[class*="internally celled"].grid > .row:first-child {
  box-shadow: none;
}
.kb-labfront.container .ui[class*="internally celled"].grid > .row > .column:first-child {
  box-shadow: none;
}
.kb-labfront.container .ui[class*="top aligned"].grid > .column:not(.row),
.kb-labfront.container .ui[class*="top aligned"].grid > .row > .column,
.kb-labfront.container .ui.grid > [class*="top aligned"].row > .column,
.kb-labfront.container .ui.grid > [class*="top aligned"].column:not(.row),
.kb-labfront.container .ui.grid > .row > [class*="top aligned"].column {
  flex-direction: column;
  vertical-align: top;
  align-self: flex-start !important;
}
.kb-labfront.container .ui[class*="middle aligned"].grid > .column:not(.row),
.kb-labfront.container .ui[class*="middle aligned"].grid > .row > .column,
.kb-labfront.container .ui.grid > [class*="middle aligned"].row > .column,
.kb-labfront.container .ui.grid > [class*="middle aligned"].column:not(.row),
.kb-labfront.container .ui.grid > .row > [class*="middle aligned"].column {
  flex-direction: column;
  vertical-align: middle;
  align-self: center !important;
}
.kb-labfront.container .ui[class*="bottom aligned"].grid > .column:not(.row),
.kb-labfront.container .ui[class*="bottom aligned"].grid > .row > .column,
.kb-labfront.container .ui.grid > [class*="bottom aligned"].row > .column,
.kb-labfront.container .ui.grid > [class*="bottom aligned"].column:not(.row),
.kb-labfront.container .ui.grid > .row > [class*="bottom aligned"].column {
  flex-direction: column;
  vertical-align: bottom;
  align-self: flex-end !important;
}
.kb-labfront.container .ui.stretched.grid > .row > .column,
.kb-labfront.container .ui.stretched.grid > .column,
.kb-labfront.container .ui.grid > .stretched.row > .column,
.kb-labfront.container .ui.grid > .stretched.column:not(.row),
.kb-labfront.container .ui.grid > .row > .stretched.column {
  display: inline-flex !important;
  align-self: stretch;
  flex-direction: column;
}
.kb-labfront.container .ui.stretched.grid > .row > .column > *,
.kb-labfront.container .ui.stretched.grid > .column > *,
.kb-labfront.container .ui.grid > .stretched.row > .column > *,
.kb-labfront.container .ui.grid > .stretched.column:not(.row) > *,
.kb-labfront.container .ui.grid > .row > .stretched.column > * {
  flex-grow: 1;
}
.kb-labfront.container .ui[class*="left aligned"].grid > .column,
.kb-labfront.container .ui[class*="left aligned"].grid > .row > .column,
.kb-labfront.container .ui.grid > [class*="left aligned"].row > .column,
.kb-labfront.container .ui.grid > [class*="left aligned"].column.column,
.kb-labfront.container .ui.grid > .row > [class*="left aligned"].column.column {
  text-align: left;
  align-self: inherit;
}
.kb-labfront.container .ui[class*="center aligned"].grid > .column,
.kb-labfront.container .ui[class*="center aligned"].grid > .row > .column,
.kb-labfront.container .ui.grid > [class*="center aligned"].row > .column,
.kb-labfront.container .ui.grid > [class*="center aligned"].column.column,
.kb-labfront.container .ui.grid > .row > [class*="center aligned"].column.column {
  text-align: center;
  align-self: inherit;
}
.kb-labfront.container .ui[class*="center aligned"].grid {
  justify-content: center;
}
.kb-labfront.container .ui[class*="right aligned"].grid > .column,
.kb-labfront.container .ui[class*="right aligned"].grid > .row > .column,
.kb-labfront.container .ui.grid > [class*="right aligned"].row > .column,
.kb-labfront.container .ui.grid > [class*="right aligned"].column.column,
.kb-labfront.container .ui.grid > .row > [class*="right aligned"].column.column {
  text-align: right;
  align-self: inherit;
}
.kb-labfront.container .ui.justified.grid > .column,
.kb-labfront.container .ui.justified.grid > .row > .column,
.kb-labfront.container .ui.grid > .justified.row > .column,
.kb-labfront.container .ui.grid > .justified.column.column,
.kb-labfront.container .ui.grid > .row > .justified.column.column {
  text-align: justify;
  hyphens: auto;
}
.kb-labfront.container .ui.grid > .primary.row,
.kb-labfront.container .ui.grid > .primary.column,
.kb-labfront.container .ui.grid > .row > .primary.column {
  background-color: #2185d0;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .secondary.row,
.kb-labfront.container .ui.grid > .secondary.column,
.kb-labfront.container .ui.grid > .row > .secondary.column {
  background-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .red.row,
.kb-labfront.container .ui.grid > .red.column,
.kb-labfront.container .ui.grid > .row > .red.column {
  background-color: #db2828;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .orange.row,
.kb-labfront.container .ui.grid > .orange.column,
.kb-labfront.container .ui.grid > .row > .orange.column {
  background-color: #f2711c;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .yellow.row,
.kb-labfront.container .ui.grid > .yellow.column,
.kb-labfront.container .ui.grid > .row > .yellow.column {
  background-color: #fbbd08;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .olive.row,
.kb-labfront.container .ui.grid > .olive.column,
.kb-labfront.container .ui.grid > .row > .olive.column {
  background-color: #b5cc18;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .green.row,
.kb-labfront.container .ui.grid > .green.column,
.kb-labfront.container .ui.grid > .row > .green.column {
  background-color: #21ba45;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .teal.row,
.kb-labfront.container .ui.grid > .teal.column,
.kb-labfront.container .ui.grid > .row > .teal.column {
  background-color: #00b5ad;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .blue.row,
.kb-labfront.container .ui.grid > .blue.column,
.kb-labfront.container .ui.grid > .row > .blue.column {
  background-color: #2185d0;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .violet.row,
.kb-labfront.container .ui.grid > .violet.column,
.kb-labfront.container .ui.grid > .row > .violet.column {
  background-color: #6435c9;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .purple.row,
.kb-labfront.container .ui.grid > .purple.column,
.kb-labfront.container .ui.grid > .row > .purple.column {
  background-color: #a333c8;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .pink.row,
.kb-labfront.container .ui.grid > .pink.column,
.kb-labfront.container .ui.grid > .row > .pink.column {
  background-color: #e03997;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .brown.row,
.kb-labfront.container .ui.grid > .brown.column,
.kb-labfront.container .ui.grid > .row > .brown.column {
  background-color: #a5673f;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .grey.row,
.kb-labfront.container .ui.grid > .grey.column,
.kb-labfront.container .ui.grid > .row > .grey.column {
  background-color: #767676;
  color: #ffffff;
}
.kb-labfront.container .ui.grid > .black.row,
.kb-labfront.container .ui.grid > .black.column,
.kb-labfront.container .ui.grid > .row > .black.column {
  background-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container .ui[class*="equal width"].grid > .column:not(.row),
.kb-labfront.container .ui[class*="equal width"].grid > .row > .column,
.kb-labfront.container .ui.grid > [class*="equal width"].row > .column {
  display: inline-block;
  flex-grow: 1;
}
.kb-labfront.container .ui[class*="equal width"].grid > .wide.column,
.kb-labfront.container .ui[class*="equal width"].grid > .row > .wide.column,
.kb-labfront.container .ui.grid > [class*="equal width"].row > .wide.column {
  flex-grow: 0;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container {
    /* Divided Reversed */
    /* Vertically Divided Reversed */
    /* Celled Reversed */
  }
  .kb-labfront.container .ui[class*="mobile reversed"].grid,
  .kb-labfront.container .ui[class*="mobile reversed"].grid > .row,
  .kb-labfront.container .ui.grid > [class*="mobile reversed"].row {
    flex-direction: row-reverse;
  }
  .kb-labfront.container .ui[class*="mobile vertically reversed"].grid,
  .kb-labfront.container .ui.stackable[class*="mobile reversed"] {
    flex-direction: column-reverse;
  }
  .kb-labfront.container .ui[class*="mobile reversed"].divided.grid:not([class*="vertically divided"]) > .column:first-child,
  .kb-labfront.container .ui[class*="mobile reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
    box-shadow: -1px 0 0 0 rgba(34, 36, 38, 0.15);
  }
  .kb-labfront.container .ui[class*="mobile reversed"].divided.grid:not([class*="vertically divided"]) > .column:last-child,
  .kb-labfront.container .ui[class*="mobile reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:last-child {
    box-shadow: none;
  }
  .kb-labfront.container .ui.grid[class*="vertically divided"][class*="mobile vertically reversed"] > .row:first-child:before {
    box-shadow: 0 -1px 0 0 rgba(34, 36, 38, 0.15);
  }
  .kb-labfront.container .ui.grid[class*="vertically divided"][class*="mobile vertically reversed"] > .row:last-child:before {
    box-shadow: none;
  }
  .kb-labfront.container .ui[class*="mobile reversed"].celled.grid > .row > .column:first-child {
    box-shadow: -1px 0 0 0 #d4d4d5;
  }
  .kb-labfront.container .ui[class*="mobile reversed"].celled.grid > .row > .column:last-child {
    box-shadow: none;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .kb-labfront.container {
    /* Divided Reversed */
    /* Vertically Divided Reversed */
    /* Celled Reversed */
  }
  .kb-labfront.container .ui[class*="tablet reversed"].grid,
  .kb-labfront.container .ui[class*="tablet reversed"].grid > .row,
  .kb-labfront.container .ui.grid > [class*="tablet reversed"].row {
    flex-direction: row-reverse;
  }
  .kb-labfront.container .ui[class*="tablet vertically reversed"].grid {
    flex-direction: column-reverse;
  }
  .kb-labfront.container .ui[class*="tablet reversed"].divided.grid:not([class*="vertically divided"]) > .column:first-child,
  .kb-labfront.container .ui[class*="tablet reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
    box-shadow: -1px 0 0 0 rgba(34, 36, 38, 0.15);
  }
  .kb-labfront.container .ui[class*="tablet reversed"].divided.grid:not([class*="vertically divided"]) > .column:last-child,
  .kb-labfront.container .ui[class*="tablet reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:last-child {
    box-shadow: none;
  }
  .kb-labfront.container .ui.grid[class*="vertically divided"][class*="tablet vertically reversed"] > .row:first-child:before {
    box-shadow: 0 -1px 0 0 rgba(34, 36, 38, 0.15);
  }
  .kb-labfront.container .ui.grid[class*="vertically divided"][class*="tablet vertically reversed"] > .row:last-child:before {
    box-shadow: none;
  }
  .kb-labfront.container .ui[class*="tablet reversed"].celled.grid > .row > .column:first-child {
    box-shadow: -1px 0 0 0 #d4d4d5;
  }
  .kb-labfront.container .ui[class*="tablet reversed"].celled.grid > .row > .column:last-child {
    box-shadow: none;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container {
    /* Divided Reversed */
    /* Vertically Divided Reversed */
    /* Celled Reversed */
  }
  .kb-labfront.container .ui[class*="computer reversed"].grid,
  .kb-labfront.container .ui[class*="computer reversed"].grid > .row,
  .kb-labfront.container .ui.grid > [class*="computer reversed"].row {
    flex-direction: row-reverse;
  }
  .kb-labfront.container .ui[class*="computer vertically reversed"].grid {
    flex-direction: column-reverse;
  }
  .kb-labfront.container .ui[class*="computer reversed"].divided.grid:not([class*="vertically divided"]) > .column:first-child,
  .kb-labfront.container .ui[class*="computer reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:first-child {
    box-shadow: -1px 0 0 0 rgba(34, 36, 38, 0.15);
  }
  .kb-labfront.container .ui[class*="computer reversed"].divided.grid:not([class*="vertically divided"]) > .column:last-child,
  .kb-labfront.container .ui[class*="computer reversed"].divided.grid:not([class*="vertically divided"]) > .row > .column:last-child {
    box-shadow: none;
  }
  .kb-labfront.container .ui.grid[class*="vertically divided"][class*="computer vertically reversed"] > .row:first-child:before {
    box-shadow: 0 -1px 0 0 rgba(34, 36, 38, 0.15);
  }
  .kb-labfront.container .ui.grid[class*="vertically divided"][class*="computer vertically reversed"] > .row:last-child:before {
    box-shadow: none;
  }
  .kb-labfront.container .ui[class*="computer reversed"].celled.grid > .row > .column:first-child {
    box-shadow: -1px 0 0 0 #d4d4d5;
  }
  .kb-labfront.container .ui[class*="computer reversed"].celled.grid > .row > .column:last-child {
    box-shadow: none;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .kb-labfront.container .ui.doubling.grid {
    width: auto;
  }
  .kb-labfront.container .ui.grid > .doubling.row,
  .kb-labfront.container .ui.doubling.grid > .row {
    margin: 0 !important;
    padding: 0 !important;
  }
  .kb-labfront.container .ui.grid > .doubling.row > .column,
  .kb-labfront.container .ui.doubling.grid > .row > .column {
    display: inline-block !important;
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    box-shadow: none !important;
    margin: 0;
  }
  .kb-labfront.container .ui[class*="two column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="two column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="two column"].doubling.row.row > .column {
    width: 100% !important;
  }
  .kb-labfront.container .ui[class*="three column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="three column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="three column"].doubling.row.row > .column {
    width: 50% !important;
  }
  .kb-labfront.container .ui[class*="four column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="four column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="four column"].doubling.row.row > .column {
    width: 50% !important;
  }
  .kb-labfront.container .ui[class*="five column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="five column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="five column"].doubling.row.row > .column {
    width: 33.3333333333% !important;
  }
  .kb-labfront.container .ui[class*="six column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="six column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="six column"].doubling.row.row > .column {
    width: 33.3333333333% !important;
  }
  .kb-labfront.container .ui[class*="seven column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="seven column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="seven column"].doubling.row.row > .column {
    width: 33.3333333333% !important;
  }
  .kb-labfront.container .ui[class*="eight column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="eight column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="eight column"].doubling.row.row > .column {
    width: 25% !important;
  }
  .kb-labfront.container .ui[class*="nine column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="nine column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="nine column"].doubling.row.row > .column {
    width: 25% !important;
  }
  .kb-labfront.container .ui[class*="ten column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="ten column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="ten column"].doubling.row.row > .column {
    width: 20% !important;
  }
  .kb-labfront.container .ui[class*="eleven column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="eleven column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="eleven column"].doubling.row.row > .column {
    width: 20% !important;
  }
  .kb-labfront.container .ui[class*="twelve column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="twelve column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="twelve column"].doubling.row.row > .column {
    width: 16.6666666667% !important;
  }
  .kb-labfront.container .ui[class*="thirteen column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="thirteen column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="thirteen column"].doubling.row.row > .column {
    width: 16.6666666667% !important;
  }
  .kb-labfront.container .ui[class*="fourteen column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="fourteen column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="fourteen column"].doubling.row.row > .column {
    width: 14.2857142857% !important;
  }
  .kb-labfront.container .ui[class*="fifteen column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="fifteen column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="fifteen column"].doubling.row.row > .column {
    width: 14.2857142857% !important;
  }
  .kb-labfront.container .ui[class*="sixteen column"].doubling.grid > .row > .column,
  .kb-labfront.container .ui[class*="sixteen column"].doubling.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="sixteen column"].doubling.row.row > .column {
    width: 12.5% !important;
  }
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.grid > .doubling.row,
  .kb-labfront.container .ui.doubling.grid > .row {
    margin: 0 !important;
    padding: 0 !important;
  }
  .kb-labfront.container .ui.grid > .doubling.row > .column,
  .kb-labfront.container .ui.doubling.grid > .row > .column {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    margin: 0 !important;
    box-shadow: none !important;
  }
  .kb-labfront.container .ui[class*="two column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="two column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="two column"].doubling:not(.stackable).row.row > .column {
    width: 100% !important;
  }
  .kb-labfront.container .ui[class*="three column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="three column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="three column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .kb-labfront.container .ui[class*="four column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="four column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="four column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .kb-labfront.container .ui[class*="five column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="five column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="five column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .kb-labfront.container .ui[class*="six column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="six column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="six column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .kb-labfront.container .ui[class*="seven column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="seven column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="seven column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .kb-labfront.container .ui[class*="eight column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="eight column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="eight column"].doubling:not(.stackable).row.row > .column {
    width: 50% !important;
  }
  .kb-labfront.container .ui[class*="nine column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="nine column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="nine column"].doubling:not(.stackable).row.row > .column {
    width: 33.3333333333% !important;
  }
  .kb-labfront.container .ui[class*="ten column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="ten column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="ten column"].doubling:not(.stackable).row.row > .column {
    width: 33.3333333333% !important;
  }
  .kb-labfront.container .ui[class*="eleven column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="eleven column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="eleven column"].doubling:not(.stackable).row.row > .column {
    width: 33.3333333333% !important;
  }
  .kb-labfront.container .ui[class*="twelve column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="twelve column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="twelve column"].doubling:not(.stackable).row.row > .column {
    width: 33.3333333333% !important;
  }
  .kb-labfront.container .ui[class*="thirteen column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="thirteen column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="thirteen column"].doubling:not(.stackable).row.row > .column {
    width: 33.3333333333% !important;
  }
  .kb-labfront.container .ui[class*="fourteen column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="fourteen column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="fourteen column"].doubling:not(.stackable).row.row > .column {
    width: 25% !important;
  }
  .kb-labfront.container .ui[class*="fifteen column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="fifteen column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="fifteen column"].doubling:not(.stackable).row.row > .column {
    width: 25% !important;
  }
  .kb-labfront.container .ui[class*="sixteen column"].doubling:not(.stackable).grid > .row > .column,
  .kb-labfront.container .ui[class*="sixteen column"].doubling:not(.stackable).grid > .column:not(.row),
  .kb-labfront.container .ui.grid > [class*="sixteen column"].doubling:not(.stackable).row.row > .column {
    width: 25% !important;
  }
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container {
    /* Coupling */
    /* Don't pad inside segment or nested grid */
    /* Divided Stackable */
  }
  .kb-labfront.container .ui.stackable.grid {
    width: auto;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .kb-labfront.container .ui.stackable.grid > .row > .wide.column,
  .kb-labfront.container .ui.stackable.grid > .wide.column,
  .kb-labfront.container .ui.stackable.grid > .column.grid > .column,
  .kb-labfront.container .ui.stackable.grid > .column.row > .column,
  .kb-labfront.container .ui.stackable.grid > .row > .column,
  .kb-labfront.container .ui.stackable.grid > .column:not(.row),
  .kb-labfront.container .ui.grid > .stackable.stackable.row > .column {
    width: 100% !important;
    margin: 0 0 !important;
    box-shadow: none !important;
    padding: 1rem 1rem !important;
  }
  .kb-labfront.container .ui.stackable.grid:not(.vertically) > .row {
    margin: 0;
    padding: 0;
  }
  .kb-labfront.container .ui.container > .ui.stackable.grid > .column,
  .kb-labfront.container .ui.container > .ui.stackable.grid > .row > .column {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .kb-labfront.container .ui.grid .ui.stackable.grid,
  .kb-labfront.container .ui.segment:not(.vertical) .ui.stackable.page.grid {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }
  .kb-labfront.container .ui.stackable.divided.grid > .row:first-child > .column:first-child,
  .kb-labfront.container .ui.stackable.celled.grid > .row:first-child > .column:first-child,
  .kb-labfront.container .ui.stackable.divided.grid > .column:not(.row):first-child,
  .kb-labfront.container .ui.stackable.celled.grid > .column:not(.row):first-child {
    border-top: none !important;
  }
  .kb-labfront.container .ui.inverted.stackable.celled.grid > .column:not(.row),
  .kb-labfront.container .ui.inverted.stackable.divided.grid > .column:not(.row),
  .kb-labfront.container .ui.inverted.stackable.celled.grid > .row > .column,
  .kb-labfront.container .ui.inverted.stackable.divided.grid > .row > .column {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  .kb-labfront.container .ui.stackable.celled.grid > .column:not(.row),
  .kb-labfront.container .ui.stackable.divided:not(.vertically).grid > .column:not(.row),
  .kb-labfront.container .ui.stackable.celled.grid > .row > .column,
  .kb-labfront.container .ui.stackable.divided:not(.vertically).grid > .row > .column {
    border-top: 1px solid rgba(34, 36, 38, 0.15);
    box-shadow: none !important;
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .kb-labfront.container .ui.stackable.celled.grid > .row {
    box-shadow: none !important;
  }
  .kb-labfront.container .ui.stackable.divided:not(.vertically).grid > .column:not(.row),
  .kb-labfront.container .ui.stackable.divided:not(.vertically).grid > .row > .column {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui[class*="tablet only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="tablet only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="tablet only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="tablet only"].column:not(.mobile) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="computer only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="computer only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="computer only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="computer only"].column:not(.mobile) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="large screen only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="large screen only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="large screen only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="large screen only"].column:not(.mobile) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="widescreen only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="widescreen only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="widescreen only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="widescreen only"].column:not(.mobile) {
    display: none !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .kb-labfront.container .ui[class*="mobile only"].grid.grid.grid:not(.tablet),
  .kb-labfront.container .ui.grid.grid.grid > [class*="mobile only"].row:not(.tablet),
  .kb-labfront.container .ui.grid.grid.grid > [class*="mobile only"].column:not(.tablet),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="mobile only"].column:not(.tablet) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="computer only"].grid.grid.grid:not(.tablet),
  .kb-labfront.container .ui.grid.grid.grid > [class*="computer only"].row:not(.tablet),
  .kb-labfront.container .ui.grid.grid.grid > [class*="computer only"].column:not(.tablet),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="computer only"].column:not(.tablet) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="large screen only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="large screen only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="large screen only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="large screen only"].column:not(.mobile) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="widescreen only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="widescreen only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="widescreen only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="widescreen only"].column:not(.mobile) {
    display: none !important;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199.98px) {
  .kb-labfront.container .ui[class*="mobile only"].grid.grid.grid:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="mobile only"].row:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="mobile only"].column:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="mobile only"].column:not(.computer) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="tablet only"].grid.grid.grid:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="tablet only"].row:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="tablet only"].column:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="tablet only"].column:not(.computer) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="large screen only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="large screen only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="large screen only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="large screen only"].column:not(.mobile) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="widescreen only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="widescreen only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="widescreen only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="widescreen only"].column:not(.mobile) {
    display: none !important;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1919.98px) {
  .kb-labfront.container .ui[class*="mobile only"].grid.grid.grid:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="mobile only"].row:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="mobile only"].column:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="mobile only"].column:not(.computer) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="tablet only"].grid.grid.grid:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="tablet only"].row:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="tablet only"].column:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="tablet only"].column:not(.computer) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="widescreen only"].grid.grid.grid:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="widescreen only"].row:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > [class*="widescreen only"].column:not(.mobile),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="widescreen only"].column:not(.mobile) {
    display: none !important;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui[class*="mobile only"].grid.grid.grid:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="mobile only"].row:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="mobile only"].column:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="mobile only"].column:not(.computer) {
    display: none !important;
  }
  .kb-labfront.container .ui[class*="tablet only"].grid.grid.grid:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="tablet only"].row:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > [class*="tablet only"].column:not(.computer),
  .kb-labfront.container .ui.grid.grid.grid > .row > [class*="tablet only"].column:not(.computer) {
    display: none !important;
  }
}
.kb-labfront.container .ui.compact.grid > .column:not(.row),
.kb-labfront.container .ui.compact.grid > .row > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.kb-labfront.container .ui.compact.grid > * {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.kb-labfront.container .ui.compact.grid > .row {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.kb-labfront.container .ui.compact.grid > .column:not(.row) {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.kb-labfront.container .ui.compact.relaxed.celled.grid > .column:not(.row),
.kb-labfront.container .ui.compact.relaxed.celled.grid > .row > .column {
  padding: 0.75em;
}
.kb-labfront.container .ui.compact[class*="very relaxed"].celled.grid > .column:not(.row),
.kb-labfront.container .ui.compact[class*="very relaxed"].celled.grid > .row > .column {
  padding: 1em;
}
.kb-labfront.container .ui[class*="very compact"].grid > .column:not(.row),
.kb-labfront.container .ui[class*="very compact"].grid > .row > .column {
  padding-left: 0.25rem;
  padding-right: 0.5rem;
}
.kb-labfront.container .ui[class*="very compact"].grid > * {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.kb-labfront.container .ui[class*="very compact"].grid > .row {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.kb-labfront.container .ui[class*="very compact"].grid > .column:not(.row) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.kb-labfront.container .ui[class*="very compact"].relaxed.celled.grid > .column:not(.row),
.kb-labfront.container .ui[class*="very compact"].relaxed.celled.grid > .row > .column {
  padding: 0.375em;
}
.kb-labfront.container .ui[class*="very compact"][class*="very relaxed"].celled.grid > .column:not(.row),
.kb-labfront.container .ui[class*="very compact"][class*="very relaxed"].celled.grid > .row > .column {
  padding: 0.5em;
}
.kb-labfront.container .ui.menu {
  display: flex;
  margin: 1rem 0;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  background: #FFFFFF;
  font-weight: normal;
  border: 1px solid rgba(34, 36, 38, 0.15);
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
  border-radius: 0.2857142857rem;
  min-height: 2.8571428571em;
}
.kb-labfront.container .ui.menu:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.kb-labfront.container .ui.menu:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.menu:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.menu .menu {
  margin: 0;
}
.kb-labfront.container .ui.menu:not(.vertical) > .menu {
  display: flex;
}
.kb-labfront.container .ui.menu:not(.vertical) .item {
  display: flex;
  align-items: center;
}
.kb-labfront.container .ui.menu .item {
  position: relative;
  vertical-align: middle;
  line-height: 1;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent;
  flex: 0 0 auto;
  user-select: none;
  background: none;
  padding: 0.9285714286em 1.1428571429em;
  text-transform: none;
  color: rgba(0, 0, 0, 0.87);
  font-weight: normal;
  transition: background 0.1s ease, box-shadow 0.1s ease, color 0.1s ease;
}
.kb-labfront.container .ui.menu > .item:first-child {
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.menu .item:before {
  position: absolute;
  content: "";
  top: 0;
  right: 0;
  height: 100%;
  width: 1px;
  background: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.menu .text.item > *,
.kb-labfront.container .ui.menu .item > a:not(.ui),
.kb-labfront.container .ui.menu .item > p:only-child {
  user-select: text;
  line-height: 1.3;
}
.kb-labfront.container .ui.menu .item > p:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.menu .item > p:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.menu .item > i.icon {
  opacity: 0.9;
  float: none;
  margin: 0 0.3571428571em 0 0;
}
.kb-labfront.container .ui.menu:not(.vertical) .item > .button {
  position: relative;
  top: 0;
  margin: -0.5em 0;
  padding-bottom: 0.7857142857em;
  padding-top: 0.7857142857em;
  font-size: 1em;
}
.kb-labfront.container .ui.menu > .grid,
.kb-labfront.container .ui.menu > .container {
  display: flex;
  align-items: inherit;
  flex-direction: inherit;
}
.kb-labfront.container .ui.menu .item > .input {
  width: 100%;
}
.kb-labfront.container .ui.menu:not(.vertical) .item > .input {
  position: relative;
  top: 0;
  margin: -0.5em 0;
}
.kb-labfront.container .ui.menu .item > .input input {
  font-size: 1em;
  padding-top: 0.5714285714em;
  padding-bottom: 0.5714285714em;
}
.kb-labfront.container .ui.menu .header.item,
.kb-labfront.container .ui.vertical.menu .header.item {
  margin: 0;
  background: "";
  text-transform: normal;
  font-weight: bold;
}
.kb-labfront.container .ui.vertical.menu .item > .header:not(.ui) {
  margin: 0 0 0.5em;
  font-size: 1em;
  font-weight: bold;
}
.kb-labfront.container .ui.menu .item > i.dropdown.icon {
  padding: 0;
  float: right;
  margin: 0 0 0 1em;
}
.kb-labfront.container .ui.menu .dropdown.item .menu {
  min-width: calc(100% - 1px);
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
  background: #FFFFFF;
  margin: 0 0 0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
  flex-direction: column !important;
}
.kb-labfront.container .ui.menu .ui.dropdown .menu > .item {
  margin: 0;
  text-align: left;
  font-size: 1em !important;
  padding: 0.7857142857em 1.1428571429em !important;
  background: transparent !important;
  color: rgba(0, 0, 0, 0.87) !important;
  text-transform: none !important;
  font-weight: normal !important;
  box-shadow: none !important;
  transition: none !important;
}
.kb-labfront.container .ui.menu .ui.dropdown .menu > .item:hover {
  background: rgba(0, 0, 0, 0.05) !important;
  color: rgba(0, 0, 0, 0.95) !important;
}
.kb-labfront.container .ui.menu .ui.dropdown .menu > .selected.item {
  background: rgba(0, 0, 0, 0.05) !important;
  color: rgba(0, 0, 0, 0.95) !important;
}
.kb-labfront.container .ui.menu .ui.dropdown .menu > .active.item {
  background: rgba(0, 0, 0, 0.03) !important;
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.95) !important;
}
.kb-labfront.container .ui.menu .ui.dropdown.item .menu .item:not(.filtered) {
  display: block;
}
.kb-labfront.container .ui.menu .ui.dropdown .menu > .item .icon:not(.dropdown) {
  display: inline-block;
  font-size: 1em !important;
  float: none;
  margin: 0 0.75em 0 0 !important;
}
.kb-labfront.container .ui.secondary.menu .dropdown.item > .menu,
.kb-labfront.container .ui.text.menu .dropdown.item > .menu {
  border-radius: 0.2857142857rem;
  margin-top: 0.3571428571em;
}
.kb-labfront.container .ui.menu .pointing.dropdown.item .menu {
  margin-top: 0.75em;
}
.kb-labfront.container .ui.inverted.menu .search.dropdown.item > .search,
.kb-labfront.container .ui.inverted.menu .search.dropdown.item > .text {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.vertical.menu .dropdown.item > .icon {
  float: right;
  content: "\\f0da";
  margin-left: 1em;
}
.kb-labfront.container .ui.vertical.menu .dropdown.item .menu {
  left: 100%;
  /* IE needs 0, all others support max-content to show dropdown icon inline, so keep both settings! */
  min-width: 0;
  min-width: max-content;
  margin: 0 0 0 0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
  border-radius: 0 0.2857142857rem 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.menu .dropdown.item.upward .menu {
  bottom: 0;
}
.kb-labfront.container .ui.vertical.menu .dropdown.item:not(.upward) .menu {
  top: 0;
}
.kb-labfront.container .ui.vertical.menu .active.dropdown.item {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.kb-labfront.container .ui.vertical.menu .dropdown.active.item {
  box-shadow: none;
}
.kb-labfront.container .ui.item.menu .dropdown .menu .item {
  width: 100%;
}
.kb-labfront.container .ui.menu .item > .label:not(.floating) {
  margin-left: 1em;
  padding: 0.3em 0.7857142857em;
}
.kb-labfront.container .ui.vertical.menu .item > .label {
  margin-top: -0.15em;
  margin-bottom: -0.15em;
  padding: 0.3em 0.7857142857em;
}
.kb-labfront.container .ui.menu .item > .floating.label {
  padding: 0.3em 0.7857142857em;
}
.kb-labfront.container .ui.menu .item > .label {
  background: #999999;
  color: #ffffff;
}
.kb-labfront.container .ui.menu .item > .image.label img {
  margin: -0.2833em 0.8em -0.2833em -0.8em;
  height: 1.5666em;
}
.kb-labfront.container .ui.menu .item > img:not(.ui) {
  display: inline-block;
  vertical-align: middle;
  margin: -0.3em 0;
  width: 2.5em;
}
.kb-labfront.container .ui.vertical.menu .item > img:not(.ui):only-child {
  display: block;
  max-width: 100%;
  width: auto;
}
.kb-labfront.container .ui.menu .list .item:before {
  background: none !important;
}
.kb-labfront.container .ui.vertical.sidebar.menu > .item:first-child:before {
  display: block !important;
}
.kb-labfront.container .ui.vertical.sidebar.menu > .item::before {
  top: auto;
  bottom: 0;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.menu > .ui.container {
    width: 100% !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .item:not(.right):not(.borderless):first-child {
    border-left: 1px solid rgba(34, 36, 38, 0.1);
  }
  .kb-labfront.container .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .right.item:not(.borderless):last-child,
  .kb-labfront.container .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .right.menu > .item:not(.borderless):last-child {
    border-right: 1px solid rgba(34, 36, 38, 0.1);
  }
}
.kb-labfront.container .ui.link.menu .item:hover,
.kb-labfront.container .ui.menu .dropdown.item:hover,
.kb-labfront.container .ui.menu .link.item:hover,
.kb-labfront.container .ui.menu a.item:hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.link.menu .item:active,
.kb-labfront.container .ui.menu .link.item:active,
.kb-labfront.container .ui.menu a.item:active {
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.menu .active.item {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
  font-weight: normal;
  box-shadow: none;
}
.kb-labfront.container .ui.menu .active.item > i.icon {
  opacity: 1;
}
.kb-labfront.container .ui.menu .active.item:hover,
.kb-labfront.container .ui.vertical.menu .active.item:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.ui.menu .item.disabled {
  cursor: default;
  background-color: transparent;
  color: rgba(0, 0, 0, 0.2);
  pointer-events: none;
}
.kb-labfront.container .ui.menu:not(.vertical) .left.item,
.kb-labfront.container .ui.menu:not(.vertical) .left.menu {
  display: flex;
  margin-right: auto !important;
}
.kb-labfront.container .ui.menu:not(.vertical) .right.item,
.kb-labfront.container .ui.menu:not(.vertical) .right.menu {
  display: flex;
  margin-left: auto !important;
}
.kb-labfront.container .ui.menu:not(.vertical) :not(.dropdown) > .left.menu,
.kb-labfront.container .ui.menu:not(.vertical) :not(.dropdown) > .right.menu {
  display: inherit;
}
.kb-labfront.container .ui.menu:not(.vertical) .center.item,
.kb-labfront.container .ui.menu:not(.vertical) .center.menu {
  display: flex;
  margin-left: auto !important;
  margin-right: auto !important;
}
.kb-labfront.container .ui.menu .right.item::before,
.kb-labfront.container .ui.menu .right.menu > .item::before {
  right: auto;
  left: 0;
}
.kb-labfront.container .ui.menu .center.item:last-child::before,
.kb-labfront.container .ui.menu .center.menu > .item:last-child::before {
  display: none;
}
.kb-labfront.container .ui.vertical.menu {
  display: block;
  flex-direction: column;
  background: #FFFFFF;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.vertical.menu .item {
  display: block;
  background: none;
  border-top: none;
  border-right: none;
}
.kb-labfront.container .ui.vertical.menu > .item:first-child {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.vertical.menu > .item:last-child {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.menu .item > .label {
  float: right;
  text-align: center;
}
.kb-labfront.container .ui.vertical.menu .item > i.icon,
.kb-labfront.container .ui.vertical.menu .item > i.icons {
  width: 1.18em;
  float: right;
  margin: 0 0 0 0.5em;
}
.kb-labfront.container .ui.vertical.menu .item > .label + i.icon {
  float: none;
  margin: 0 0.5em 0 0;
}
.kb-labfront.container .ui.vertical.menu .item:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.vertical.menu .item:first-child:before {
  display: none !important;
}
.kb-labfront.container .ui.vertical.menu .item > .menu {
  margin: 0.5em -1.1428571429em 0;
}
.kb-labfront.container .ui.vertical.menu .menu .item {
  background: none;
  padding: 0.5em 1.3333333333em;
  font-size: 0.8571428571em;
  color: rgba(0, 0, 0, 0.5);
}
.kb-labfront.container .ui.vertical.menu .item .menu a.item:hover,
.kb-labfront.container .ui.vertical.menu .item .menu .link.item:hover {
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.vertical.menu .menu .item:before {
  display: none;
}
.kb-labfront.container .ui.vertical.menu .active.item {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 0;
  box-shadow: none;
}
.kb-labfront.container .ui.vertical.menu > .active.item:first-child {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.vertical.menu > .active.item:last-child {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.menu > .active.item:only-child {
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.vertical.menu .active.item .menu .active.item {
  border-left: none;
}
.kb-labfront.container .ui.vertical.menu .item .menu .active.item {
  background-color: transparent;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.tabular.menu {
  border-radius: 0;
  box-shadow: none !important;
  border: none;
  background: none transparent;
  border-bottom: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.tabular.fluid.menu {
  width: calc(100% + 2px) !important;
}
.kb-labfront.container .ui.tabular.menu .item {
  background: transparent;
  border-bottom: none;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-top: 2px solid transparent;
  padding: 0.9285714286em 1.4285714286em;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.tabular.menu .item:before {
  display: none;
}
.kb-labfront.container .ui.tabular.menu .item:hover {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.tabular.menu .active.item {
  background: none #ffffff;
  color: rgba(0, 0, 0, 0.95);
  border-top-width: 1px;
  border-color: #d4d4d5;
  font-weight: bold;
  margin-bottom: -1px;
  box-shadow: none;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0 !important;
}
.kb-labfront.container .ui.tabular.menu + .attached:not(.top).segment,
.kb-labfront.container .ui.tabular.menu + .attached:not(.top).segment + .attached:not(.top).segment {
  border-top: none;
  margin-left: 0;
  margin-top: 0;
  margin-right: 0;
  width: 100%;
}
.kb-labfront.container .top.attached.segment + .ui.bottom.tabular.menu {
  position: relative;
  width: calc(100% + 2px);
  left: -1px;
}
.kb-labfront.container .ui.bottom.tabular.menu {
  background: none transparent;
  border-radius: 0;
  box-shadow: none !important;
  border-bottom: none;
  border-top: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.bottom.tabular.menu .item {
  background: none;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: none;
}
.kb-labfront.container .ui.bottom.tabular.menu .active.item {
  background: none #ffffff;
  color: rgba(0, 0, 0, 0.95);
  border-color: #d4d4d5;
  margin: -1px 0 0 0;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem !important;
}
.kb-labfront.container .ui.vertical.tabular.menu {
  background: none transparent;
  border-radius: 0;
  box-shadow: none !important;
  border-bottom: none;
  border-right: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.vertical.tabular.menu .item {
  background: none;
  border-left: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  border-right: none;
}
.kb-labfront.container .ui.vertical.tabular.menu .active.item {
  background: none #ffffff;
  color: rgba(0, 0, 0, 0.95);
  border-color: #d4d4d5;
  margin: 0 -1px 0 0;
  border-radius: 0.2857142857rem 0 0 0.2857142857rem !important;
}
.kb-labfront.container .ui.vertical.right.tabular.menu {
  background: none transparent;
  border-radius: 0;
  box-shadow: none !important;
  border-bottom: none;
  border-right: none;
  border-left: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.vertical.right.tabular.menu .item {
  background: none;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  border-left: none;
}
.kb-labfront.container .ui.vertical.right.tabular.menu .active.item {
  background: none #ffffff;
  color: rgba(0, 0, 0, 0.95);
  border-color: #d4d4d5;
  margin: 0 0 0 -1px;
  border-radius: 0 0.2857142857rem 0.2857142857rem 0 !important;
}
.kb-labfront.container .ui.tabular.menu .active.dropdown.item {
  margin-bottom: 0;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-top: 2px solid transparent;
  border-bottom: none;
}
.kb-labfront.container .ui.pagination.menu {
  margin: 0;
  display: inline-flex;
  vertical-align: middle;
}
.kb-labfront.container .ui.pagination.menu .item:last-child {
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
}
.kb-labfront.container .ui.compact.menu .item:last-child {
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
}
.kb-labfront.container .ui.pagination.menu .item:last-child:before {
  display: none;
}
.kb-labfront.container .ui.pagination.menu .item {
  min-width: 3em;
  text-align: center;
}
.kb-labfront.container .ui.pagination.menu .icon.item i.icon {
  vertical-align: top;
}
.kb-labfront.container .ui.pagination.menu .active.item {
  border-top: none;
  padding-top: 0.9285714286em;
  background-color: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
  box-shadow: none;
}
.kb-labfront.container .ui.secondary.menu {
  background: none;
  margin-left: -0.3571428571em;
  margin-right: -0.3571428571em;
  border-radius: 0;
  border: none;
  box-shadow: none;
}
.kb-labfront.container .ui.secondary.menu .item {
  align-self: center;
  box-shadow: none;
  border: none;
  padding: 0.7857142857em 0.9285714286em;
  margin: 0 0.3571428571em;
  background: none;
  transition: color 0.1s ease;
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.secondary.menu .item:before {
  display: none !important;
}
.kb-labfront.container .ui.secondary.menu .header.item {
  border-radius: 0;
  border-right: none;
  background: none transparent;
}
.kb-labfront.container .ui.secondary.menu .item > img:not(.ui) {
  margin: 0;
}
.kb-labfront.container .ui.secondary.menu .dropdown.item:hover,
.kb-labfront.container .ui.secondary.menu .link.item:hover,
.kb-labfront.container .ui.secondary.menu a.item:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.secondary.menu .active.item {
  box-shadow: none;
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.secondary.menu .active.item:hover {
  box-shadow: none;
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.secondary.inverted.menu .link.item:not(.disabled),
.kb-labfront.container .ui.secondary.inverted.menu a.item:not(.disabled) {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.secondary.inverted.menu .dropdown.item:hover,
.kb-labfront.container .ui.secondary.inverted.menu .link.item:hover,
.kb-labfront.container .ui.secondary.inverted.menu a.item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.secondary.inverted.menu .active.item {
  background: rgba(255, 255, 255, 0.15);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.secondary.item.menu {
  margin-left: 0;
  margin-right: 0;
}
.kb-labfront.container .ui.secondary.item.menu .item:last-child {
  margin-right: 0;
}
.kb-labfront.container .ui.secondary.attached.menu {
  box-shadow: none;
}
.kb-labfront.container .ui.vertical.secondary.menu .item:not(.dropdown) > .menu {
  margin: 0 -0.9285714286em;
}
.kb-labfront.container .ui.vertical.secondary.menu .item:not(.dropdown) > .menu > .item {
  margin: 0;
  padding: 0.5em 1.3333333333em;
}
.kb-labfront.container .ui.secondary.vertical.menu > .item {
  border: none;
  margin: 0 0 0.3571428571em;
  border-radius: 0.2857142857rem !important;
}
.kb-labfront.container .ui.secondary.vertical.menu > .header.item {
  border-radius: 0;
}
.kb-labfront.container .ui.vertical.secondary.menu .item > .menu .item {
  background-color: transparent;
}
.kb-labfront.container .ui.secondary.inverted.menu {
  background-color: transparent;
}
.kb-labfront.container .ui.secondary.pointing.menu {
  margin-left: 0;
  margin-right: 0;
  border-bottom: 2px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.secondary.pointing.menu .item {
  border-bottom-color: transparent;
  border-bottom-style: solid;
  border-radius: 0;
  align-self: flex-end;
  margin: 0 0 -2px;
  padding: 0.8571428571em 1.1428571429em;
  border-bottom-width: 2px;
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.secondary.pointing.menu .ui.dropdown .menu .item {
  border-bottom-width: 0;
}
.kb-labfront.container .ui.secondary.pointing.menu .item > .label:not(.floating) {
  margin-top: -0.3em;
  margin-bottom: -0.3em;
}
.kb-labfront.container .ui.secondary.pointing.menu .item > .circular.label {
  margin-top: -0.5em;
  margin-bottom: -0.5em;
}
.kb-labfront.container .ui.secondary.pointing.menu .header.item {
  color: rgba(0, 0, 0, 0.85) !important;
}
.kb-labfront.container .ui.secondary.pointing.menu .text.item {
  box-shadow: none !important;
}
.kb-labfront.container .ui.secondary.pointing.menu .item:after {
  display: none;
}
.kb-labfront.container .ui.secondary.pointing.menu .dropdown.item:hover,
.kb-labfront.container .ui.secondary.pointing.menu .link.item:hover,
.kb-labfront.container .ui.secondary.pointing.menu a.item:hover {
  background-color: transparent;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.secondary.pointing.menu .dropdown.item:active,
.kb-labfront.container .ui.secondary.pointing.menu .link.item:active,
.kb-labfront.container .ui.secondary.pointing.menu a.item:active {
  background-color: transparent;
  border-color: rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.secondary.pointing.menu .active.item {
  background-color: transparent;
  box-shadow: none;
  border-color: currentColor;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.secondary.pointing.menu .active.item:hover {
  border-color: currentColor;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.secondary.pointing.menu .active.dropdown.item {
  border-color: transparent;
}
.kb-labfront.container .ui.secondary.vertical.pointing.menu {
  border-bottom-width: 0;
  border-right-width: 2px;
  border-right-style: solid;
  border-right-color: rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.secondary.vertical.pointing.menu .item {
  border-bottom: none;
  border-right-style: solid;
  border-right-color: transparent;
  border-radius: 0 !important;
  margin: 0 -2px 0 0;
  border-right-width: 2px;
}
.kb-labfront.container .ui.secondary.vertical.pointing.menu .active.item {
  border-color: currentColor;
}
.kb-labfront.container .ui.secondary.inverted.pointing.menu {
  border-color: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.secondary.inverted.pointing.menu .item:not(.disabled) {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.secondary.inverted.pointing.menu .header.item {
  color: #ffffff !important;
}
.kb-labfront.container .ui.secondary.inverted.pointing.menu .link.item:hover,
.kb-labfront.container .ui.secondary.inverted.pointing.menu a.item:hover {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.ui.secondary.inverted.pointing.menu .active.item {
  border-color: #ffffff;
  color: rgb(255, 255, 255);
  background-color: transparent;
}
.kb-labfront.container .ui.text.menu {
  background: none transparent;
  border-radius: 0;
  box-shadow: none;
  border: none;
  margin: 0.5em;
}
.kb-labfront.container .ui.text.menu .item {
  border-radius: 0;
  box-shadow: none;
  align-self: center;
  margin: 0 0;
  padding: 0.3571428571em 0.5em;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.6);
  transition: opacity 0.1s ease;
}
.kb-labfront.container .ui.text.menu .item:before,
.kb-labfront.container .ui.text.menu .menu .item:before {
  display: none !important;
}
.kb-labfront.container .ui.text.menu .header.item {
  background-color: transparent;
  opacity: 1;
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.9285714286em;
  text-transform: uppercase;
  font-weight: bold;
}
.kb-labfront.container .ui.text.menu .item > img:not(.ui) {
  margin: 0;
}
.kb-labfront.container .ui.text.item.menu .item {
  margin: 0;
}
.kb-labfront.container .ui.vertical.text.menu {
  margin: 1em 0;
}
.kb-labfront.container .ui.vertical.text.menu:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.vertical.text.menu:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.vertical.text.menu .item {
  margin: 0.5714285714em 0;
  padding-left: 0;
  padding-right: 0;
}
.kb-labfront.container .ui.vertical.text.menu .item > i.icon {
  float: none;
  margin: 0 0.3571428571em 0 0;
}
.kb-labfront.container .ui.vertical.text.menu .header.item {
  margin: 0.5714285714em 0 0.7142857143em;
}
.kb-labfront.container .ui.vertical.text.menu .item:not(.dropdown) > .menu {
  margin: 0;
}
.kb-labfront.container .ui.vertical.text.menu .item:not(.dropdown) > .menu > .item {
  margin: 0;
  padding: 0.5em 0;
}
.kb-labfront.container .ui.text.menu .item:hover {
  opacity: 1;
  background-color: transparent;
}
.kb-labfront.container .ui.text.menu .active.item {
  background-color: transparent;
  border: none;
  box-shadow: none;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.text.menu .active.item:hover {
  background-color: transparent;
}
.kb-labfront.container .ui.text.pointing.menu .active.item:after {
  box-shadow: none;
}
.kb-labfront.container .ui.text.attached.menu {
  box-shadow: none;
}
.kb-labfront.container .ui.inverted.text.menu,
.kb-labfront.container .ui.inverted.text.menu .item,
.kb-labfront.container .ui.inverted.text.menu .item:hover,
.kb-labfront.container .ui.inverted.text.menu .active.item {
  background-color: transparent;
}
.kb-labfront.container .ui.inverted.icon.menu .item {
  color: #ffffff;
}
.kb-labfront.container .ui.fluid.text.menu {
  margin-left: 0;
  margin-right: 0;
}
.kb-labfront.container .ui.vertical.icon.menu {
  display: inline-block;
  width: auto;
}
.kb-labfront.container .ui.icon.menu .item {
  height: auto;
  text-align: center;
  color: #1b1c1d;
}
.kb-labfront.container .ui.icon.menu .item > .icon:not(.dropdown) {
  margin: 0;
  opacity: 1;
}
.kb-labfront.container .ui.icon.menu .icon:before {
  opacity: 1;
}
.kb-labfront.container .ui.menu .icon.item > .icon {
  width: auto;
  margin: 0 auto;
}
.kb-labfront.container .ui.vertical.icon.menu .item > .icon:not(.dropdown) {
  display: block;
  opacity: 1;
  margin: 0 auto;
  float: none;
}
.kb-labfront.container .ui.labeled.icon.menu {
  text-align: center;
}
.kb-labfront.container .ui.labeled.icon.menu .item {
  min-width: 6em;
  flex-direction: column;
}
.kb-labfront.container .ui.labeled.icon.menu > .item > .icon:not(.dropdown) {
  height: 1em;
  display: block;
  font-size: 1.7142857143em !important;
  margin: 0 auto 0.5rem !important;
}
.kb-labfront.container .ui.fluid.labeled.icon.menu > .item {
  min-width: 0;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.stackable.menu {
    flex-direction: column;
  }
  .kb-labfront.container .ui.stackable.menu .item {
    width: 100% !important;
  }
  .kb-labfront.container .ui.stackable.menu .item:before {
    position: absolute;
    content: "";
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: rgba(34, 36, 38, 0.1);
  }
  .kb-labfront.container .ui.stackable.menu .left.menu,
  .kb-labfront.container .ui.stackable.menu .left.item {
    margin-right: 0 !important;
  }
  .kb-labfront.container .ui.stackable.menu .right.menu,
  .kb-labfront.container .ui.stackable.menu .right.item {
    margin-left: 0 !important;
  }
  .kb-labfront.container .ui.stackable.menu .center.menu,
  .kb-labfront.container .ui.stackable.menu .center.item {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .kb-labfront.container .ui.stackable.menu .right.menu,
  .kb-labfront.container .ui.stackable.menu .center.menu,
  .kb-labfront.container .ui.stackable.menu .left.menu {
    flex-direction: column;
  }
}
.kb-labfront.container .ui.ui.menu .primary.active.active.active.item,
.kb-labfront.container .ui.ui.primary.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.primary.menu .active.active.active.item {
  color: #2185d0;
}
.kb-labfront.container .ui.ui.menu .red.active.active.active.item,
.kb-labfront.container .ui.ui.red.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.red.menu .active.active.active.item {
  color: #db2828;
}
.kb-labfront.container .ui.ui.menu .orange.active.active.active.item,
.kb-labfront.container .ui.ui.orange.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.orange.menu .active.active.active.item {
  color: #f2711c;
}
.kb-labfront.container .ui.ui.menu .yellow.active.active.active.item,
.kb-labfront.container .ui.ui.yellow.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.yellow.menu .active.active.active.item {
  color: #fbbd08;
}
.kb-labfront.container .ui.ui.menu .olive.active.active.active.item,
.kb-labfront.container .ui.ui.olive.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.olive.menu .active.active.active.item {
  color: #b5cc18;
}
.kb-labfront.container .ui.ui.menu .green.active.active.active.item,
.kb-labfront.container .ui.ui.green.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.green.menu .active.active.active.item {
  color: #21ba45;
}
.kb-labfront.container .ui.ui.menu .teal.active.active.active.item,
.kb-labfront.container .ui.ui.teal.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.teal.menu .active.active.active.item {
  color: #00b5ad;
}
.kb-labfront.container .ui.ui.menu .blue.active.active.active.item,
.kb-labfront.container .ui.ui.blue.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.blue.menu .active.active.active.item {
  color: #2185d0;
}
.kb-labfront.container .ui.ui.menu .violet.active.active.active.item,
.kb-labfront.container .ui.ui.violet.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.violet.menu .active.active.active.item {
  color: #6435c9;
}
.kb-labfront.container .ui.ui.menu .purple.active.active.active.item,
.kb-labfront.container .ui.ui.purple.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.purple.menu .active.active.active.item {
  color: #a333c8;
}
.kb-labfront.container .ui.ui.menu .pink.active.active.active.item,
.kb-labfront.container .ui.ui.pink.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.pink.menu .active.active.active.item {
  color: #e03997;
}
.kb-labfront.container .ui.ui.menu .brown.active.active.active.item,
.kb-labfront.container .ui.ui.brown.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.brown.menu .active.active.active.item {
  color: #a5673f;
}
.kb-labfront.container .ui.ui.menu .grey.active.active.active.item,
.kb-labfront.container .ui.ui.grey.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.grey.menu .active.active.active.item {
  color: #767676;
}
.kb-labfront.container .ui.ui.menu .black.active.active.active.item,
.kb-labfront.container .ui.ui.black.menu .active.active.active.item:hover,
.kb-labfront.container .ui.ui.black.menu .active.active.active.item {
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.menu {
  border: 0 solid transparent;
  background: #1b1c1d;
  box-shadow: none;
}
.kb-labfront.container .ui.inverted.menu .item,
.kb-labfront.container .ui.inverted.menu .item > a:not(.ui) {
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.menu .item.menu {
  background: transparent;
}
.kb-labfront.container .ui.inverted.menu .item:before {
  background: rgba(255, 255, 255, 0.08);
}
.kb-labfront.container .ui.vertical.inverted.menu .item:before {
  background: rgba(255, 255, 255, 0.08);
}
.kb-labfront.container .ui.vertical.inverted.menu .menu .item,
.kb-labfront.container .ui.vertical.inverted.menu .menu .item a:not(.ui) {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.inverted.menu .header.item {
  margin: 0;
  background: transparent;
  box-shadow: none;
}
.kb-labfront.container .ui.ui.inverted.menu .item.disabled {
  color: rgba(255, 255, 255, 0.2);
}
.kb-labfront.container .ui.link.inverted.menu .item:hover,
.kb-labfront.container .ui.inverted.menu .dropdown.item:hover,
.kb-labfront.container .ui.inverted.menu .link.item:hover,
.kb-labfront.container .ui.inverted.menu a.item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.vertical.inverted.menu .item .menu a.item:hover,
.kb-labfront.container .ui.vertical.inverted.menu .item .menu .link.item:hover {
  background: transparent;
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.menu a.item:active,
.kb-labfront.container .ui.inverted.menu .link.item:active {
  background: rgba(255, 255, 255, 0.08);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.menu .active.item {
  background: #3D3E3F;
  color: rgb(255, 255, 255) !important;
}
.kb-labfront.container .ui.inverted.vertical.menu .item .menu .active.item {
  background: transparent;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.pointing.menu .active.item:after {
  background: #3D3E3F;
  margin: 0 !important;
  box-shadow: none !important;
  border: none !important;
}
.kb-labfront.container .ui.inverted.menu .active.item:hover {
  background: #3D3E3F;
  color: #ffffff !important;
}
.kb-labfront.container .ui.inverted.pointing.menu .active.item:hover:after {
  background: #3D3E3F;
}
.kb-labfront.container .ui.ui.ui.inverted.pointing.menu .active.item:after {
  background-color: inherit;
}
.kb-labfront.container .ui.floated.menu {
  float: left;
  margin: 0 0.5rem 0 0;
}
.kb-labfront.container .ui.floated.menu .item:last-child:before {
  display: none;
}
.kb-labfront.container .ui.right.floated.menu {
  float: right;
  margin: 0 0 0 0.5rem;
}
.kb-labfront.container .ui.ui.inverted.menu .primary.active.item,
.kb-labfront.container .ui.ui.inverted.primary.menu {
  background-color: #2185d0;
}
.kb-labfront.container .ui.inverted.primary.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.primary.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.primary.menu .active.item {
  background-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.ui.inverted.menu .red.active.item,
.kb-labfront.container .ui.ui.inverted.red.menu {
  background-color: #db2828;
}
.kb-labfront.container .ui.inverted.red.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.red.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.red.menu .active.item {
  background-color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.ui.inverted.menu .orange.active.item,
.kb-labfront.container .ui.ui.inverted.orange.menu {
  background-color: #f2711c;
}
.kb-labfront.container .ui.inverted.orange.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.orange.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.orange.menu .active.item {
  background-color: rgb(243.48125, 97.3239485981, 1.01875);
}
.kb-labfront.container .ui.ui.inverted.menu .yellow.active.item,
.kb-labfront.container .ui.ui.inverted.yellow.menu {
  background-color: #fbbd08;
}
.kb-labfront.container .ui.inverted.yellow.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.yellow.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.yellow.menu .active.item {
  background-color: rgb(233.5, 173.9238683128, 0);
}
.kb-labfront.container .ui.ui.inverted.menu .olive.active.item,
.kb-labfront.container .ui.ui.inverted.olive.menu {
  background-color: #b5cc18;
}
.kb-labfront.container .ui.inverted.olive.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.olive.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.olive.menu .active.item {
  background-color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
}
.kb-labfront.container .ui.ui.inverted.menu .green.active.item,
.kb-labfront.container .ui.ui.inverted.green.menu {
  background-color: #21ba45;
}
.kb-labfront.container .ui.inverted.green.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.green.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.green.menu .active.item {
  background-color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.ui.inverted.menu .teal.active.item,
.kb-labfront.container .ui.ui.inverted.teal.menu {
  background-color: #00b5ad;
}
.kb-labfront.container .ui.inverted.teal.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.teal.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.teal.menu .active.item {
  background-color: rgb(0, 155.5, 148.6270718232);
}
.kb-labfront.container .ui.ui.inverted.menu .blue.active.item,
.kb-labfront.container .ui.ui.inverted.blue.menu {
  background-color: #2185d0;
}
.kb-labfront.container .ui.inverted.blue.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.blue.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.blue.menu .active.item {
  background-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.ui.inverted.menu .violet.active.item,
.kb-labfront.container .ui.ui.inverted.violet.menu {
  background-color: #6435c9;
}
.kb-labfront.container .ui.inverted.violet.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.violet.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.violet.menu .active.item {
  background-color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
}
.kb-labfront.container .ui.ui.inverted.menu .purple.active.item,
.kb-labfront.container .ui.ui.inverted.purple.menu {
  background-color: #a333c8;
}
.kb-labfront.container .ui.inverted.purple.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.purple.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.purple.menu .active.item {
  background-color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
}
.kb-labfront.container .ui.ui.inverted.menu .pink.active.item,
.kb-labfront.container .ui.ui.inverted.pink.menu {
  background-color: #e03997;
}
.kb-labfront.container .ui.inverted.pink.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.pink.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.pink.menu .active.item {
  background-color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
}
.kb-labfront.container .ui.ui.inverted.menu .brown.active.item,
.kb-labfront.container .ui.ui.inverted.brown.menu {
  background-color: #a5673f;
}
.kb-labfront.container .ui.inverted.brown.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.brown.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.brown.menu .active.item {
  background-color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
}
.kb-labfront.container .ui.ui.inverted.menu .grey.active.item,
.kb-labfront.container .ui.ui.inverted.grey.menu {
  background-color: #767676;
}
.kb-labfront.container .ui.inverted.grey.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.grey.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.grey.menu .active.item {
  background-color: rgb(115.775, 94.725, 94.725);
}
.kb-labfront.container .ui.ui.inverted.menu .black.active.item,
.kb-labfront.container .ui.ui.inverted.black.menu {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.black.menu .item:before {
  background-color: rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.ui.inverted.black.menu .active.item {
  background-color: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.pointing.black.menu .active.item {
  background-color: rgb(13.1803571429, 15.25, 17.3196428571);
}
.kb-labfront.container .ui.fitted.menu .item,
.kb-labfront.container .ui.fitted.menu .item .menu .item,
.kb-labfront.container .ui.menu .fitted.item {
  padding: 0;
}
.kb-labfront.container .ui.horizontally.fitted.menu .item,
.kb-labfront.container .ui.horizontally.fitted.menu .item .menu .item,
.kb-labfront.container .ui.menu .horizontally.fitted.item {
  padding-top: 0.9285714286em;
  padding-bottom: 0.9285714286em;
}
.kb-labfront.container .ui.vertically.fitted.menu .item,
.kb-labfront.container .ui.vertically.fitted.menu .item .menu .item,
.kb-labfront.container .ui.menu .vertically.fitted.item {
  padding-left: 1.1428571429em;
  padding-right: 1.1428571429em;
}
.kb-labfront.container .ui.borderless.menu .item:before,
.kb-labfront.container .ui.borderless.menu .item .menu .item:before,
.kb-labfront.container .ui.menu .borderless.item:before {
  background: none !important;
}
.kb-labfront.container .ui.compact.menu {
  display: inline-flex;
  margin: 0;
  vertical-align: middle;
}
.kb-labfront.container .ui.compact.vertical.menu {
  /* IE hack to make dropdown icons appear inline */
  display: -ms-inline-flexbox !important;
  display: inline-block;
}
.kb-labfront.container .ui.compact.menu:not(.secondary) .item:last-child {
  border-radius: 0 0.2857142857rem 0.2857142857rem 0;
}
.kb-labfront.container .ui.compact.menu .item:last-child:before {
  display: none;
}
.kb-labfront.container .ui.compact.vertical.menu {
  width: auto !important;
}
.kb-labfront.container .ui.compact.vertical.menu .item:last-child::before {
  display: block;
}
.kb-labfront.container .ui.menu.fluid,
.kb-labfront.container .ui.vertical.menu.fluid {
  width: 100% !important;
}
.kb-labfront.container .ui.item.menu,
.kb-labfront.container .ui.item.menu .item {
  width: 100%;
  padding-left: 0 !important;
  padding-right: 0 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  text-align: center;
  justify-content: center;
}
.kb-labfront.container .ui.attached.item.menu:not(.tabular) {
  margin: 0 -1px !important;
}
.kb-labfront.container .ui.item.menu .item:last-child:before {
  display: none;
}
.kb-labfront.container .ui.menu.two.item .item {
  width: 50%;
}
.kb-labfront.container .ui.menu.three.item .item {
  width: 33.333%;
}
.kb-labfront.container .ui.menu.four.item .item {
  width: 25%;
}
.kb-labfront.container .ui.menu.five.item .item {
  width: 20%;
}
.kb-labfront.container .ui.menu.six.item .item {
  width: 16.666%;
}
.kb-labfront.container .ui.menu.seven.item .item {
  width: 14.285%;
}
.kb-labfront.container .ui.menu.eight.item .item {
  width: 12.5%;
}
.kb-labfront.container .ui.menu.nine.item .item {
  width: 11.11%;
}
.kb-labfront.container .ui.menu.ten.item .item {
  width: 10%;
}
.kb-labfront.container .ui.menu.eleven.item .item {
  width: 9.09%;
}
.kb-labfront.container .ui.menu.twelve.item .item {
  width: 8.333%;
}
.kb-labfront.container .ui.menu.fixed {
  position: fixed;
  z-index: 101;
  margin: 0;
  width: 100%;
}
.kb-labfront.container .ui.menu.fixed,
.kb-labfront.container .ui.menu.fixed .item:first-child,
.kb-labfront.container .ui.menu.fixed .item:last-child {
  border-radius: 0 !important;
}
.kb-labfront.container .ui.fixed.menu,
.kb-labfront.container .ui[class*="top fixed"].menu {
  top: 0;
  left: 0;
  right: auto;
  bottom: auto;
}
.kb-labfront.container .ui[class*="top fixed"].menu {
  border-top: none;
  border-left: none;
  border-right: none;
}
.kb-labfront.container .ui[class*="right fixed"].menu {
  border-top: none;
  border-bottom: none;
  border-right: none;
  top: 0;
  right: 0;
  left: auto;
  bottom: auto;
  width: auto;
  height: 100%;
}
.kb-labfront.container .ui[class*="bottom fixed"].menu {
  border-bottom: none;
  border-left: none;
  border-right: none;
  bottom: 0;
  left: 0;
  top: auto;
  right: auto;
}
.kb-labfront.container .ui[class*="left fixed"].menu {
  border-top: none;
  border-bottom: none;
  border-left: none;
  top: 0;
  left: 0;
  right: auto;
  bottom: auto;
  width: auto;
  height: 100%;
}
.kb-labfront.container .ui.fixed.menu + .ui.grid {
  padding-top: 2.75rem;
}
.kb-labfront.container .ui.pointing.menu .item:after {
  visibility: hidden;
  position: absolute;
  content: "";
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
  background: none;
  margin: 0.5px 0 0;
  width: 0.5714285714em;
  height: 0.5714285714em;
  border: none;
  border-bottom: 1px solid #d4d4d5;
  border-right: 1px solid #d4d4d5;
  z-index: 2;
  transition: background 0.1s ease;
}
.kb-labfront.container .ui.vertical.pointing.menu .item:after {
  position: absolute;
  top: 50%;
  right: 0;
  bottom: auto;
  left: auto;
  transform: translateX(50%) translateY(-50%) rotate(45deg);
  margin: 0 -0.5px 0 0;
  border: none;
  border-top: 1px solid #d4d4d5;
  border-right: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.pointing.menu .ui.dropdown .menu .item:after,
.kb-labfront.container .ui.vertical.pointing.menu .ui.dropdown .menu .item:after {
  display: none;
}
.kb-labfront.container .ui.pointing.menu .active.item:after {
  visibility: visible;
}
.kb-labfront.container .ui.pointing.menu .active.dropdown.item:after {
  visibility: hidden;
}
.kb-labfront.container .ui.pointing.menu .dropdown.active.item:after,
.kb-labfront.container .ui.pointing.menu .active.item .menu .active.item:after {
  display: none;
}
.kb-labfront.container .ui.pointing.menu .active.item:hover:after {
  background-color: #F2F2F2;
}
.kb-labfront.container .ui.pointing.menu .active.item:after {
  background-color: #F2F2F2;
}
.kb-labfront.container .ui.pointing.menu .active.item:hover:after {
  background-color: #F2F2F2;
}
.kb-labfront.container .ui.vertical.pointing.menu .active.item:hover:after {
  background-color: #F2F2F2;
}
.kb-labfront.container .ui.vertical.pointing.menu .active.item:after {
  background-color: #F2F2F2;
}
.kb-labfront.container .ui.vertical.pointing.menu .menu .active.item:after {
  background-color: #ffffff;
}
.kb-labfront.container .ui.inverted.pointing.menu .primary.active.item:after {
  background-color: #2185d0;
}
.kb-labfront.container .ui.inverted.pointing.menu .secondary.active.item:after {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.pointing.menu .red.active.item:after {
  background-color: #db2828;
}
.kb-labfront.container .ui.inverted.pointing.menu .orange.active.item:after {
  background-color: #f2711c;
}
.kb-labfront.container .ui.inverted.pointing.menu .yellow.active.item:after {
  background-color: #fbbd08;
}
.kb-labfront.container .ui.inverted.pointing.menu .olive.active.item:after {
  background-color: #b5cc18;
}
.kb-labfront.container .ui.inverted.pointing.menu .green.active.item:after {
  background-color: #21ba45;
}
.kb-labfront.container .ui.inverted.pointing.menu .teal.active.item:after {
  background-color: #00b5ad;
}
.kb-labfront.container .ui.inverted.pointing.menu .blue.active.item:after {
  background-color: #2185d0;
}
.kb-labfront.container .ui.inverted.pointing.menu .violet.active.item:after {
  background-color: #6435c9;
}
.kb-labfront.container .ui.inverted.pointing.menu .purple.active.item:after {
  background-color: #a333c8;
}
.kb-labfront.container .ui.inverted.pointing.menu .pink.active.item:after {
  background-color: #e03997;
}
.kb-labfront.container .ui.inverted.pointing.menu .brown.active.item:after {
  background-color: #a5673f;
}
.kb-labfront.container .ui.inverted.pointing.menu .grey.active.item:after {
  background-color: #767676;
}
.kb-labfront.container .ui.inverted.pointing.menu .black.active.item:after {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.attached.menu {
  top: 0;
  bottom: 0;
  border-radius: 0;
  margin: 0 -1px;
  width: calc(100% + 2px);
  max-width: calc(100% + 2px);
  box-shadow: none;
}
.kb-labfront.container .ui.attached + .ui.attached.menu:not(.top) {
  border-top: none;
}
.kb-labfront.container .ui[class*="top attached"].menu {
  bottom: 0;
  margin-bottom: 0;
  top: 0;
  margin-top: 1rem;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.menu[class*="top attached"]:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui[class*="bottom attached"].menu {
  bottom: 0;
  margin-top: 0;
  top: 0;
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), none;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui[class*="bottom attached"].menu:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.top.attached.menu > .item:first-child {
  border-radius: 0.2857142857rem 0 0 0;
}
.kb-labfront.container .ui.bottom.attached.menu > .item:first-child {
  border-radius: 0 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.attached.menu:not(.tabular) {
  border: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.attached.inverted.menu {
  border: none;
}
.kb-labfront.container .ui.attached.tabular.menu {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}
.kb-labfront.container .ui.mini.menu {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.mini.vertical.menu:not(.icon) {
  width: 9rem;
}
.kb-labfront.container .ui.mini.menu .dropdown {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.mini.menu .dropdown .menu > .item {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.menu {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.tiny.vertical.menu:not(.icon) {
  width: 11rem;
}
.kb-labfront.container .ui.tiny.menu .dropdown {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.tiny.menu .dropdown .menu > .item {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.menu {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.small.vertical.menu:not(.icon) {
  width: 13rem;
}
.kb-labfront.container .ui.small.menu .dropdown {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.small.menu .dropdown .menu > .item {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.menu {
  font-size: 1rem;
}
.kb-labfront.container .ui.vertical.menu {
  width: 15rem;
}
.kb-labfront.container .ui.large.menu {
  font-size: 1.0714285714rem;
}
.kb-labfront.container .ui.large.vertical.menu:not(.icon) {
  width: 18rem;
}
.kb-labfront.container .ui.large.menu .dropdown {
  font-size: 1.0714285714rem;
}
.kb-labfront.container .ui.large.menu .dropdown .menu > .item {
  font-size: 1.0714285714rem;
}
.kb-labfront.container .ui.huge.menu {
  font-size: 1.2142857143rem;
}
.kb-labfront.container .ui.huge.vertical.menu:not(.icon) {
  width: 22rem;
}
.kb-labfront.container .ui.huge.menu .dropdown {
  font-size: 1.2142857143rem;
}
.kb-labfront.container .ui.huge.menu .dropdown .menu > .item {
  font-size: 1.2142857143rem;
}
.kb-labfront.container .ui.big.menu {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.vertical.menu:not(.icon) {
  width: 20rem;
}
.kb-labfront.container .ui.big.menu .dropdown {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.menu .dropdown .menu > .item {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.massive.menu {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.massive.vertical.menu:not(.icon) {
  width: 25rem;
}
.kb-labfront.container .ui.massive.menu .dropdown {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.massive.menu .dropdown .menu > .item {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.menu .ui.inverted.inverted.dropdown.item .menu {
  background: #1b1c1d;
  box-shadow: none;
}
.kb-labfront.container .ui.menu .ui.inverted.dropdown .menu > .item {
  color: rgba(255, 255, 255, 0.8) !important;
}
.kb-labfront.container .ui.menu .ui.inverted.dropdown .menu > .active.item {
  background: transparent !important;
  color: rgba(255, 255, 255, 0.8) !important;
}
.kb-labfront.container .ui.menu .ui.inverted.dropdown .menu > .item:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  color: rgba(255, 255, 255, 0.8) !important;
}
.kb-labfront.container .ui.menu .ui.inverted.dropdown .menu > .selected.item {
  background: rgba(255, 255, 255, 0.15) !important;
  color: rgba(255, 255, 255, 0.8) !important;
}
.kb-labfront.container .ui.vertical.menu .inverted.dropdown.item .menu {
  box-shadow: none;
}
.kb-labfront.container .ui.message {
  position: relative;
  min-height: 1em;
  margin: 1em 0;
  background: #F8F8F9;
  padding: 1em 1.5em;
  line-height: 1.4285em;
  color: rgba(0, 0, 0, 0.87);
  transition: opacity 0.1s ease, color 0.1s ease, background 0.1s ease, box-shadow 0.1s ease;
  border-radius: 0.2857142857rem;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.22) inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.message:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.message:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.message .header {
  display: block;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: bold;
  margin: -0.1428571429em 0 0 0;
}
.kb-labfront.container .ui.message .header:not(.ui) {
  font-size: 1.1428571429em;
}
.kb-labfront.container .ui.message p {
  opacity: 0.85;
  margin: 0.75em 0;
}
.kb-labfront.container .ui.message p:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.message p:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.message .header + p {
  margin-top: 0.25em;
}
.kb-labfront.container .ui.message .list:not(.ui) {
  text-align: left;
  padding: 0;
  opacity: 0.85;
  list-style-position: inside;
  margin: 0.5em 0 0;
}
.kb-labfront.container .ui.message .list:not(.ui):first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.message .list:not(.ui):last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.message .list:not(.ui) li {
  position: relative;
  list-style-type: none;
  margin: 0 0 0.3em 1em;
  padding: 0;
}
.kb-labfront.container .ui.message .list:not(.ui) li:before {
  position: absolute;
  content: "•";
  left: -1em;
  height: 100%;
  vertical-align: baseline;
}
.kb-labfront.container .ui.message .list:not(.ui) li:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.message > .icon {
  margin-right: 0.6em;
}
.kb-labfront.container .ui.message > .close.icon {
  cursor: pointer;
  position: absolute;
  margin: 0;
  top: 0.78575em;
  right: 0.5em;
  opacity: 0.7;
  transition: opacity 0.1s ease;
}
.kb-labfront.container .ui.message > .close.icon:hover {
  opacity: 1;
}
.kb-labfront.container .ui.message > :first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.message > :last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.dropdown .menu > .message {
  margin: 0 -1px;
}
.kb-labfront.container .ui.visible.visible.visible.visible.message {
  display: block;
}
.kb-labfront.container .ui.icon.visible.visible.visible.visible.message {
  display: flex;
}
.kb-labfront.container .ui.hidden.hidden.hidden.hidden.message {
  display: none;
}
.kb-labfront.container .ui.compact.message {
  display: inline-block;
}
.kb-labfront.container .ui.compact.icon.message {
  display: inline-flex;
  width: auto;
}
.kb-labfront.container .ui.attached.message {
  margin-bottom: -1px;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
  margin-left: -1px;
  margin-right: -1px;
}
.kb-labfront.container .ui.attached + .ui.attached.message:not(.top):not(.bottom) {
  margin-top: -1px;
  border-radius: 0;
}
.kb-labfront.container .ui.bottom.attached.message {
  margin-top: -1px;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15) inset, 0 1px 2px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.bottom.attached.message:not(:last-child) {
  margin-bottom: 1em;
}
.kb-labfront.container .ui.attached.icon.message {
  width: auto;
}
.kb-labfront.container .ui.icon.message {
  display: flex;
  width: 100%;
  align-items: center;
}
.kb-labfront.container .ui.icon.message > .icon:not(.close) {
  display: block;
  flex: 0 0 auto;
  width: auto;
  line-height: 1;
  vertical-align: middle;
  font-size: 3em;
  opacity: 0.8;
}
.kb-labfront.container .ui.icon.message > .content {
  display: block;
  flex: 1 1 auto;
  vertical-align: middle;
}
.kb-labfront.container .ui.icon.message .icon:not(.close) + .content {
  padding-left: 0;
}
.kb-labfront.container .ui.icon.message .circular.icon {
  width: 1em;
}
.kb-labfront.container .ui.floating.message {
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.22) inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.positive.message {
  background-color: #fcfff5;
  color: #2c662d;
}
.kb-labfront.container .ui.positive.message,
.kb-labfront.container .ui.attached.positive.message {
  box-shadow: 0 0 0 1px #a3c293 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.positive.message {
  box-shadow: 0 0 0 1px #a3c293 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.positive.message .header {
  color: #1a531b;
}
.kb-labfront.container .ui.negative.message {
  background-color: #fff6f6;
  color: #9f3a38;
}
.kb-labfront.container .ui.negative.message,
.kb-labfront.container .ui.attached.negative.message {
  box-shadow: 0 0 0 1px #e0b4b4 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.negative.message {
  box-shadow: 0 0 0 1px #e0b4b4 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.negative.message .header {
  color: #912d2b;
}
.kb-labfront.container .ui.primary.message {
  background-color: #dff0ff;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.primary.message,
.kb-labfront.container .ui.attached.primary.message {
  box-shadow: 0 0 0 1px #2185d0 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.primary.message {
  box-shadow: 0 0 0 1px #2185d0 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.primary.message .header {
  color: rgba(242.25, 242.25, 242.25, 0.9);
}
.kb-labfront.container .ui.secondary.message {
  background-color: #f4f4f4;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.secondary.message,
.kb-labfront.container .ui.attached.secondary.message {
  box-shadow: 0 0 0 1px #1b1c1d inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.secondary.message {
  box-shadow: 0 0 0 1px #1b1c1d inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.secondary.message .header {
  color: rgba(242.25, 242.25, 242.25, 0.9);
}
.kb-labfront.container .ui.red.message {
  background-color: #ffe8e6;
  color: #db2828;
}
.kb-labfront.container .ui.red.message,
.kb-labfront.container .ui.attached.red.message {
  box-shadow: 0 0 0 1px #db2828 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.red.message {
  box-shadow: 0 0 0 1px #db2828 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.red.message .header {
  color: rgb(200.0099601594, 33.4900398406, 33.4900398406);
}
.kb-labfront.container .ui.orange.message {
  background-color: #ffedde;
  color: #f2711c;
}
.kb-labfront.container .ui.orange.message,
.kb-labfront.container .ui.attached.orange.message {
  box-shadow: 0 0 0 1px #f2711c inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.orange.message {
  box-shadow: 0 0 0 1px #f2711c inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.orange.message .header {
  color: rgb(231.25625, 99.8375, 13.24375);
}
.kb-labfront.container .ui.yellow.message {
  background-color: #fff8db;
  color: #b58105;
}
.kb-labfront.container .ui.yellow.message,
.kb-labfront.container .ui.attached.yellow.message {
  box-shadow: 0 0 0 1px #b58105 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.yellow.message {
  box-shadow: 0 0 0 1px #b58105 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.yellow.message .header {
  color: rgb(156.185483871, 111.314516129, 4.314516129);
}
.kb-labfront.container .ui.olive.message {
  background-color: #fbfdef;
  color: #8abc1e;
}
.kb-labfront.container .ui.olive.message,
.kb-labfront.container .ui.attached.olive.message {
  box-shadow: 0 0 0 1px #8abc1e inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.olive.message {
  box-shadow: 0 0 0 1px #8abc1e inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.olive.message .header {
  color: rgb(121.8577981651, 166.0091743119, 26.4908256881);
}
.kb-labfront.container .ui.green.message {
  background-color: #e5f9e7;
  color: #1ebc30;
}
.kb-labfront.container .ui.green.message,
.kb-labfront.container .ui.attached.green.message {
  box-shadow: 0 0 0 1px #1ebc30 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.green.message {
  box-shadow: 0 0 0 1px #1ebc30 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.green.message .header {
  color: rgb(26.4908256881, 166.0091743119, 42.3853211009);
}
.kb-labfront.container .ui.teal.message {
  background-color: #e1f7f7;
  color: #10a3a3;
}
.kb-labfront.container .ui.teal.message,
.kb-labfront.container .ui.attached.teal.message {
  box-shadow: 0 0 0 1px #10a3a3 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.teal.message {
  box-shadow: 0 0 0 1px #10a3a3 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.teal.message .header {
  color: rgb(13.7206703911, 139.7793296089, 139.7793296089);
}
.kb-labfront.container .ui.blue.message {
  background-color: #dff0ff;
  color: #2185d0;
}
.kb-labfront.container .ui.blue.message,
.kb-labfront.container .ui.attached.blue.message {
  box-shadow: 0 0 0 1px #2185d0 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.blue.message {
  box-shadow: 0 0 0 1px #2185d0 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.blue.message .header {
  color: rgb(29.5082987552, 118.9273858921, 185.9917012448);
}
.kb-labfront.container .ui.violet.message {
  background-color: #eae7ff;
  color: #6435c9;
}
.kb-labfront.container .ui.violet.message,
.kb-labfront.container .ui.attached.violet.message {
  box-shadow: 0 0 0 1px #6435c9 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.violet.message {
  box-shadow: 0 0 0 1px #6435c9 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.violet.message .header {
  color: rgb(89.9606299213, 47.6791338583, 180.8208661417);
}
.kb-labfront.container .ui.purple.message {
  background-color: #f6e7ff;
  color: #a333c8;
}
.kb-labfront.container .ui.purple.message,
.kb-labfront.container .ui.attached.purple.message {
  box-shadow: 0 0 0 1px #a333c8 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.purple.message {
  box-shadow: 0 0 0 1px #a333c8 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.purple.message .header {
  color: rgb(146.4402390438, 45.8187250996, 179.6812749004);
}
.kb-labfront.container .ui.pink.message {
  background-color: #ffe3fb;
  color: #e03997;
}
.kb-labfront.container .ui.pink.message,
.kb-labfront.container .ui.attached.pink.message {
  box-shadow: 0 0 0 1px #e03997 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.pink.message {
  box-shadow: 0 0 0 1px #e03997 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.pink.message .header {
  color: rgb(220.5480349345, 34.9519650655, 139.4192139738);
}
.kb-labfront.container .ui.brown.message {
  background-color: #f1e2d3;
  color: #a5673f;
}
.kb-labfront.container .ui.brown.message,
.kb-labfront.container .ui.attached.brown.message {
  box-shadow: 0 0 0 1px #a5673f inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.brown.message {
  box-shadow: 0 0 0 1px #a5673f inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.brown.message .header {
  color: rgb(146.5460526316, 91.4802631579, 55.9539473684);
}
.kb-labfront.container .ui.grey.message {
  background-color: #f4f4f4;
  color: #767676;
}
.kb-labfront.container .ui.grey.message,
.kb-labfront.container .ui.attached.grey.message {
  box-shadow: 0 0 0 1px #767676 inset, 0 0 0 0 rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.floating.grey.message {
  box-shadow: 0 0 0 1px #767676 inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.grey.message .header {
  color: rgb(105.25, 105.25, 105.25);
}
.kb-labfront.container .ui.black.message {
  background-color: #1b1c1d;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.black.message .header {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.message {
  background-color: #1b1c1d;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.mini.message {
  font-size: 0.7857142857em;
}
.kb-labfront.container .ui.tiny.message {
  font-size: 0.8571428571em;
}
.kb-labfront.container .ui.small.message {
  font-size: 0.9285714286em;
}
.kb-labfront.container .ui.message {
  font-size: 1em;
}
.kb-labfront.container .ui.large.message {
  font-size: 1.1428571429em;
}
.kb-labfront.container .ui.big.message {
  font-size: 1.2857142857em;
}
.kb-labfront.container .ui.huge.message {
  font-size: 1.4285714286em;
}
.kb-labfront.container .ui.massive.message {
  font-size: 1.7142857143em;
}
.kb-labfront.container .ui.table {
  width: 100%;
  background: #ffffff;
  margin: 1em 0;
  border: 1px solid rgba(34, 36, 38, 0.15);
  box-shadow: none;
  border-radius: 0.2857142857rem;
  text-align: left;
  vertical-align: middle;
  color: rgba(0, 0, 0, 0.87);
  border-collapse: separate;
  border-spacing: 0;
}
.kb-labfront.container .ui.table:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.table:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.table > thead,
.kb-labfront.container .ui.table > tbody {
  text-align: inherit;
  vertical-align: inherit;
}
.kb-labfront.container .ui.table th,
.kb-labfront.container .ui.table td {
  transition: background 0.1s ease, color 0.1s ease;
}
.kb-labfront.container .ui.table > thead {
  box-shadow: none;
}
.kb-labfront.container .ui.table > thead > tr > th {
  cursor: auto;
  background: #f9fafb;
  text-align: inherit;
  color: rgba(0, 0, 0, 0.87);
  padding: 0.9285714286em 0.7857142857em;
  vertical-align: inherit;
  font-style: none;
  font-weight: bold;
  text-transform: none;
  border-bottom: 1px solid rgba(34, 36, 38, 0.1);
  border-left: none;
}
.kb-labfront.container .ui.table > thead > tr > th:first-child {
  border-left: none;
}
.kb-labfront.container .ui.table > thead > tr:first-child > th:first-child {
  border-radius: 0.2857142857rem 0 0 0;
}
.kb-labfront.container .ui.table > thead > tr:first-child > th:last-child {
  border-radius: 0 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.table > thead > tr:first-child > th:only-child {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.table > tfoot {
  box-shadow: none;
}
.kb-labfront.container .ui.table > tfoot > tr > th {
  cursor: auto;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  background: #f9fafb;
  text-align: inherit;
  color: rgba(0, 0, 0, 0.87);
  padding: 0.7857142857em 0.7857142857em;
  vertical-align: middle;
  font-style: normal;
  font-weight: normal;
  text-transform: none;
}
.kb-labfront.container .ui.table > tfoot > tr > th:first-child {
  border-left: none;
}
.kb-labfront.container .ui.table > tfoot > tr:first-child > th:first-child {
  border-radius: 0 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.table > tfoot > tr:first-child > th:last-child {
  border-radius: 0 0 0.2857142857rem 0;
}
.kb-labfront.container .ui.table > tfoot > tr:first-child > th:only-child {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.table > tr > td,
.kb-labfront.container .ui.table > tbody > tr > td {
  border-top: 1px solid rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.table > tr:first-child > td,
.kb-labfront.container .ui.table > tbody > tr:first-child > td {
  border-top: none;
}
.kb-labfront.container .ui.table > tbody + tbody tr:first-child > td {
  border-top: 1px solid rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.table > tbody > tr > td,
.kb-labfront.container .ui.table > tr > td {
  padding: 0.7857142857em 0.7857142857em;
  text-align: inherit;
}
.kb-labfront.container .ui.table > .icon {
  vertical-align: baseline;
}
.kb-labfront.container .ui.table > .icon:only-child {
  margin: 0;
}
.kb-labfront.container .ui.table.segment {
  padding: 0;
}
.kb-labfront.container .ui.table.segment:after {
  display: none;
}
.kb-labfront.container .ui.table.segment.stacked:after {
  display: block;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container {
    /* Definition Table */
  }
  .kb-labfront.container .ui.table:not(.unstackable) {
    width: 100%;
    padding: 0;
  }
  .kb-labfront.container .ui.table:not(.unstackable) > thead,
  .kb-labfront.container .ui.table:not(.unstackable) > thead > tr,
  .kb-labfront.container .ui.table:not(.unstackable) > tfoot,
  .kb-labfront.container .ui.table:not(.unstackable) > tfoot > tr,
  .kb-labfront.container .ui.table:not(.unstackable) > tbody,
  .kb-labfront.container .ui.table:not(.unstackable) > tr,
  .kb-labfront.container .ui.table:not(.unstackable) > tbody > tr,
  .kb-labfront.container .ui.table:not(.unstackable) > tr > th,
  .kb-labfront.container .ui.table:not(.unstackable) > thead > tr > th,
  .kb-labfront.container .ui.table:not(.unstackable) > tbody > tr > th,
  .kb-labfront.container .ui.table:not(.unstackable) > tfoot > tr > th,
  .kb-labfront.container .ui.table:not(.unstackable) > tr > td,
  .kb-labfront.container .ui.table:not(.unstackable) > tbody > tr > td {
    display: block !important;
    width: auto !important;
  }
  .kb-labfront.container .ui.table:not(.unstackable) > thead {
    display: block;
  }
  .kb-labfront.container .ui.table:not(.unstackable) > tfoot {
    display: block;
  }
  .kb-labfront.container .ui.table:not(.unstackable) > tr,
  .kb-labfront.container .ui.table:not(.unstackable) > thead > tr,
  .kb-labfront.container .ui.table:not(.unstackable) > tbody > tr,
  .kb-labfront.container .ui.table:not(.unstackable) > tfoot > tr {
    padding-top: 1em;
    padding-bottom: 1em;
    box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1) inset !important;
  }
  .kb-labfront.container .ui.ui.ui.ui.table:not(.unstackable) > tr > th,
  .kb-labfront.container .ui.ui.ui.ui.table:not(.unstackable) > thead > tr > th,
  .kb-labfront.container .ui.ui.ui.ui.table:not(.unstackable) > tbody > tr > th,
  .kb-labfront.container .ui.ui.ui.ui.table:not(.unstackable) > tfoot > tr > th,
  .kb-labfront.container .ui.ui.ui.ui.table:not(.unstackable) > tr > td,
  .kb-labfront.container .ui.ui.ui.ui.table:not(.unstackable) > tbody > tr > td {
    background: none;
    border: none;
    padding: 0.25em 0.75em;
    box-shadow: none !important;
  }
  .kb-labfront.container .ui.table:not(.unstackable) > tr > th:first-child,
  .kb-labfront.container .ui.table:not(.unstackable) > thead > tr > th:first-child,
  .kb-labfront.container .ui.table:not(.unstackable) > tbody > tr > th:first-child,
  .kb-labfront.container .ui.table:not(.unstackable) > tfoot > tr > th:first-child,
  .kb-labfront.container .ui.table:not(.unstackable) > tr > td:first-child,
  .kb-labfront.container .ui.table:not(.unstackable) > tbody > tr > td:first-child {
    font-weight: bold;
  }
  .kb-labfront.container .ui.definition.table:not(.unstackable) > thead > tr > th:first-child {
    box-shadow: none !important;
  }
}
.kb-labfront.container .ui.table .collapsing .image,
.kb-labfront.container .ui.table .collapsing .image img {
  max-width: none;
}
.kb-labfront.container .ui.structured.table {
  border-collapse: collapse;
}
.kb-labfront.container .ui.structured.table > thead > tr > th {
  border-left: none;
  border-right: none;
}
.kb-labfront.container .ui.structured.sortable.table > thead > tr > th {
  border-left: 1px solid rgba(34, 36, 38, 0.15);
  border-right: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.structured.basic.table > tr > th,
.kb-labfront.container .ui.structured.basic.table > thead > tr > th,
.kb-labfront.container .ui.structured.basic.table > tbody > tr > th,
.kb-labfront.container .ui.structured.basic.table > tfoot > tr > th {
  border-left: none;
  border-right: none;
}
.kb-labfront.container .ui.structured.celled.table > tr > th,
.kb-labfront.container .ui.structured.celled.table > thead > tr > th,
.kb-labfront.container .ui.structured.celled.table > tbody > tr > th,
.kb-labfront.container .ui.structured.celled.table > tfoot > tr > th,
.kb-labfront.container .ui.structured.celled.table > tr > td,
.kb-labfront.container .ui.structured.celled.table > tbody > tr > td {
  border-left: 1px solid rgba(34, 36, 38, 0.1);
  border-right: 1px solid rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.definition.table > thead:not(.full-width) > tr > th:first-child {
  pointer-events: none;
  background: #ffffff;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.4);
  box-shadow: -0.1em -0.2em 0 0.1em #ffffff;
  -moz-transform: scale(1);
}
.kb-labfront.container .ui.definition.table > tfoot:not(.full-width) > tr > th:first-child {
  pointer-events: none;
  background: #ffffff;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.4);
  box-shadow: -0.1em 0.2em 0 0.1em #ffffff;
  -moz-transform: scale(1);
}
.kb-labfront.container .ui.definition.table > tr > td:first-child:not(.ignored),
.kb-labfront.container .ui.definition.table > tbody > tr > td:first-child:not(.ignored),
.kb-labfront.container .ui.definition.table tr td.definition {
  background: rgba(0, 0, 0, 0.03);
  font-weight: bold;
  color: rgba(0, 0, 0, 0.95);
  text-transform: "";
  box-shadow: "";
  text-align: "";
  font-size: 1em;
  padding-left: "";
  padding-right: "";
}
.kb-labfront.container .ui.definition.table > thead:not(.full-width) > tr > th:nth-child(2) {
  border-left: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.definition.table > tfoot:not(.full-width) > tr > th:nth-child(2) {
  border-left: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.definition.table > tr > td:nth-child(2),
.kb-labfront.container .ui.definition.table > tbody > tr > td:nth-child(2) {
  border-left: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.ui.ui.ui.table tr.positive,
.kb-labfront.container .ui.ui.table td.positive {
  box-shadow: 0 0 0 #a3c293 inset;
  background: #fcfff5;
  color: #2c662d;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.negative,
.kb-labfront.container .ui.ui.table td.negative {
  box-shadow: 0 0 0 #e0b4b4 inset;
  background: #fff6f6;
  color: #9f3a38;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.error,
.kb-labfront.container .ui.ui.table td.error {
  box-shadow: 0 0 0 #e0b4b4 inset;
  background: #fff6f6;
  color: #9f3a38;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.warning,
.kb-labfront.container .ui.ui.table td.warning {
  box-shadow: 0 0 0 #c9ba9b inset;
  background: #fffaf3;
  color: #573a08;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.active,
.kb-labfront.container .ui.ui.table td.active {
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.87) inset;
  background: #E0E0E0;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.table tr.disabled td,
.kb-labfront.container .ui.table tr td.disabled,
.kb-labfront.container .ui.table tr.disabled:hover,
.kb-labfront.container .ui.table tr:hover td.disabled {
  pointer-events: none;
  color: rgba(0, 0, 0, 0.2);
}
@media only screen and (max-width: 991.98px) {
  .kb-labfront.container {
    /* Definition Table */
  }
  .kb-labfront.container .ui[class*="tablet stackable"].table,
  .kb-labfront.container .ui[class*="tablet stackable"].table > thead,
  .kb-labfront.container .ui[class*="tablet stackable"].table > thead > tr,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tfoot,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tfoot > tr,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tbody,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tbody > tr,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tr,
  .kb-labfront.container .ui[class*="tablet stackable"].table > thead > tr > th,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tbody > tr > th,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tfoot > tr > th,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tr > th,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tbody > tr > td,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tr > td {
    display: block !important;
    width: 100% !important;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].table {
    padding: 0;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].table > thead {
    display: block;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].table > tfoot {
    display: block;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].table > thead > tr,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tbody > tr,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tfoot > tr,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tr {
    padding-top: 1em;
    padding-bottom: 1em;
    box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1) inset !important;
  }
  .kb-labfront.container .ui[class*="tablet stackable"].table > thead > tr > th,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tbody > tr > th,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tfoot > tr > th,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tr > th,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tbody > tr > td,
  .kb-labfront.container .ui[class*="tablet stackable"].table > tr > td {
    background: none;
    border: none !important;
    padding: 0.25em 0.75em;
    box-shadow: none !important;
  }
  .kb-labfront.container .ui.definition[class*="tablet stackable"].table > thead > tr > th:first-child {
    box-shadow: none !important;
  }
}
.kb-labfront.container .ui.table[class*="left aligned"],
.kb-labfront.container .ui.table [class*="left aligned"] {
  text-align: left;
}
.kb-labfront.container .ui.table[class*="center aligned"],
.kb-labfront.container .ui.table [class*="center aligned"] {
  text-align: center;
}
.kb-labfront.container .ui.table[class*="right aligned"],
.kb-labfront.container .ui.table [class*="right aligned"] {
  text-align: right;
}
.kb-labfront.container .ui.table[class*="top aligned"],
.kb-labfront.container .ui.table [class*="top aligned"] {
  vertical-align: top;
}
.kb-labfront.container .ui.table[class*="middle aligned"],
.kb-labfront.container .ui.table [class*="middle aligned"] {
  vertical-align: middle;
}
.kb-labfront.container .ui.table[class*="bottom aligned"],
.kb-labfront.container .ui.table [class*="bottom aligned"] {
  vertical-align: bottom;
}
.kb-labfront.container .ui.table th.collapsing,
.kb-labfront.container .ui.table td.collapsing {
  width: 1px;
  white-space: nowrap;
}
.kb-labfront.container .ui.fixed.table {
  table-layout: fixed;
}
.kb-labfront.container .ui.fixed.table th,
.kb-labfront.container .ui.fixed.table td {
  overflow: hidden;
  text-overflow: ellipsis;
}
.kb-labfront.container .ui.ui.selectable.table > tbody > tr:hover,
.kb-labfront.container .ui.table tbody tr td.selectable:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.ui.selectable.inverted.table > tbody > tr:hover,
.kb-labfront.container .ui.inverted.table tbody tr td.selectable:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.table tbody tr td.selectable {
  padding: 0;
}
.kb-labfront.container .ui.table tbody tr td.selectable > a:not(.ui) {
  display: block;
  color: inherit;
  padding: 0.7857142857em 0.7857142857em;
}
.kb-labfront.container .ui.table > tr > td.selectable,
.kb-labfront.container .ui.table > tbody > tr > td.selectable,
.kb-labfront.container .ui.selectable.table > tbody > tr,
.kb-labfront.container .ui.selectable.table > tr {
  cursor: pointer;
}
.kb-labfront.container .ui.ui.selectable.table tr.error:hover,
.kb-labfront.container .ui.table tr td.selectable.error:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.error {
  background: rgb(255, 230.7, 230.7);
  color: rgb(147.6851162791, 53.8725581395, 52.0148837209);
}
.kb-labfront.container .ui.ui.selectable.table tr.warning:hover,
.kb-labfront.container .ui.table tr td.selectable.warning:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.warning {
  background: rgb(255, 243.625, 227.7);
  color: rgb(72.9884210526, 48.6589473684, 6.7115789474);
}
.kb-labfront.container .ui.ui.selectable.table tr.active:hover,
.kb-labfront.container .ui.table tr td.selectable.active:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.active {
  background: #E0E0E0;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.ui.selectable.table tr.positive:hover,
.kb-labfront.container .ui.table tr td.selectable.positive:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.positive {
  background: rgb(247.41, 255, 229.7);
  color: rgb(39.3890410959, 91.3109589041, 40.2842465753);
}
.kb-labfront.container .ui.ui.selectable.table tr.negative:hover,
.kb-labfront.container .ui.table tr td.selectable.negative:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.negative {
  background: rgb(255, 230.7, 230.7);
  color: rgb(147.6851162791, 53.8725581395, 52.0148837209);
}
.kb-labfront.container .ui.attached.table {
  top: 0;
  bottom: 0;
  border-radius: 0;
  margin: 0 -1px;
  width: calc(100% + 2px);
  max-width: calc(100% + 2px);
  box-shadow: none;
  border: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.attached + .ui.attached.table:not(.top) {
  border-top: none;
}
.kb-labfront.container .ui[class*="top attached"].table {
  bottom: 0;
  margin-bottom: 0;
  top: 0;
  margin-top: 1em;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.table[class*="top attached"]:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui[class*="bottom attached"].table {
  bottom: 0;
  margin-top: 0;
  top: 0;
  margin-bottom: 1em;
  box-shadow: none, none;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui[class*="bottom attached"].table:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.striped.table > tr:nth-child(2n),
.kb-labfront.container .ui.striped.table > tbody > tr:nth-child(2n) {
  background-color: rgba(0, 0, 50, 0.02);
}
.kb-labfront.container .ui.inverted.striped.table > tr:nth-child(2n),
.kb-labfront.container .ui.inverted.striped.table > tbody > tr:nth-child(2n) {
  background-color: rgba(255, 255, 255, 0.05);
}
.kb-labfront.container .ui.striped.selectable.selectable.selectable.table tbody tr.active:hover {
  background: #EFEFEF;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.table[class*="single line"],
.kb-labfront.container .ui.table [class*="single line"] {
  white-space: nowrap;
}
.kb-labfront.container .ui.primary.table {
  border-top: 0.2em solid #2185d0;
}
.kb-labfront.container .ui.inverted.primary.table {
  background-color: #2185d0;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.primary,
.kb-labfront.container .ui.ui.table td.primary {
  box-shadow: 0 0 0 rgb(26.0165975104, 104.8547717842, 163.9834024896) inset;
  background: #dff0ff;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.ui.selectable.table tr.primary:hover,
.kb-labfront.container .ui.table tr td.selectable.primary:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.primary {
  background: screen(#54c8ff, #cccccc);
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.secondary.table {
  border-top: 0.2em solid #1b1c1d;
}
.kb-labfront.container .ui.inverted.secondary.table {
  background-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.secondary,
.kb-labfront.container .ui.ui.table td.secondary {
  box-shadow: 0 0 0 rgb(2.4107142857, 2.5, 2.5892857143) inset;
  background: #f4f4f4;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.ui.selectable.table tr.secondary:hover,
.kb-labfront.container .ui.table tr td.selectable.secondary:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.secondary {
  background: screen(#545454, #cccccc);
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.red.table {
  border-top: 0.2em solid #db2828;
}
.kb-labfront.container .ui.inverted.red.table {
  background-color: #db2828;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.red,
.kb-labfront.container .ui.ui.table td.red {
  box-shadow: 0 0 0 rgb(178.1673306773, 29.8326693227, 29.8326693227) inset;
  background: #ffe8e6;
  color: #db2828;
}
.kb-labfront.container .ui.ui.selectable.table tr.red:hover,
.kb-labfront.container .ui.table tr td.selectable.red:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.red {
  background: screen(#ff695e, #cccccc);
  color: #db2828;
}
.kb-labfront.container .ui.orange.table {
  border-top: 0.2em solid #f2711c;
}
.kb-labfront.container .ui.inverted.orange.table {
  background-color: #f2711c;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.orange,
.kb-labfront.container .ui.ui.table td.orange {
  box-shadow: 0 0 0 rgb(207.1375, 89.425, 11.8625) inset;
  background: #ffedde;
  color: #f2711c;
}
.kb-labfront.container .ui.ui.selectable.table tr.orange:hover,
.kb-labfront.container .ui.table tr td.selectable.orange:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.orange {
  background: screen(#ff851b, #cccccc);
  color: #f2711c;
}
.kb-labfront.container .ui.yellow.table {
  border-top: 0.2em solid #fbbd08;
}
.kb-labfront.container .ui.inverted.yellow.table {
  background-color: #fbbd08;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.yellow,
.kb-labfront.container .ui.ui.table td.yellow {
  box-shadow: 0 0 0 rgb(204.6852589641, 153.3067729084, 3.3147410359) inset;
  background: #fff8db;
  color: #b58105;
}
.kb-labfront.container .ui.ui.selectable.table tr.yellow:hover,
.kb-labfront.container .ui.table tr td.selectable.yellow:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.yellow {
  background: screen(#ffe21f, #cccccc);
  color: #b58105;
}
.kb-labfront.container .ui.olive.table {
  border-top: 0.2em solid #b5cc18;
}
.kb-labfront.container .ui.inverted.olive.table {
  background-color: #b5cc18;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.olive,
.kb-labfront.container .ui.ui.table td.olive {
  box-shadow: 0 0 0 rgb(140.5131578947, 158.3684210526, 18.6315789474) inset;
  background: #fbfdef;
  color: #8abc1e;
}
.kb-labfront.container .ui.ui.selectable.table tr.olive:hover,
.kb-labfront.container .ui.table tr td.selectable.olive:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.olive {
  background: screen(#d9e778, #cccccc);
  color: #8abc1e;
}
.kb-labfront.container .ui.green.table {
  border-top: 0.2em solid #21ba45;
}
.kb-labfront.container .ui.inverted.green.table {
  background-color: #21ba45;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.green,
.kb-labfront.container .ui.ui.table td.green {
  box-shadow: 0 0 0 rgb(25.3150684932, 142.6849315068, 52.9315068493) inset;
  background: #e5f9e7;
  color: #1ebc30;
}
.kb-labfront.container .ui.ui.selectable.table tr.green:hover,
.kb-labfront.container .ui.table tr td.selectable.green:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.green {
  background: screen(#2ecc40, #cccccc);
  color: #1ebc30;
}
.kb-labfront.container .ui.teal.table {
  border-top: 0.2em solid #00b5ad;
}
.kb-labfront.container .ui.inverted.teal.table {
  background-color: #00b5ad;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.teal,
.kb-labfront.container .ui.ui.table td.teal {
  box-shadow: 0 0 0 rgb(0, 130, 124.2541436464) inset;
  background: #e1f7f7;
  color: #10a3a3;
}
.kb-labfront.container .ui.ui.selectable.table tr.teal:hover,
.kb-labfront.container .ui.table tr td.selectable.teal:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.teal {
  background: screen(#6dffff, #cccccc);
  color: #10a3a3;
}
.kb-labfront.container .ui.blue.table {
  border-top: 0.2em solid #2185d0;
}
.kb-labfront.container .ui.inverted.blue.table {
  background-color: #2185d0;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.blue,
.kb-labfront.container .ui.ui.table td.blue {
  box-shadow: 0 0 0 rgb(26.0165975104, 104.8547717842, 163.9834024896) inset;
  background: #dff0ff;
  color: #2185d0;
}
.kb-labfront.container .ui.ui.selectable.table tr.blue:hover,
.kb-labfront.container .ui.table tr td.selectable.blue:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.blue {
  background: screen(#54c8ff, #cccccc);
  color: #2185d0;
}
.kb-labfront.container .ui.violet.table {
  border-top: 0.2em solid #6435c9;
}
.kb-labfront.container .ui.inverted.violet.table {
  background-color: #6435c9;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.violet,
.kb-labfront.container .ui.ui.table td.violet {
  box-shadow: 0 0 0 rgb(79.9212598425, 42.3582677165, 160.6417322835) inset;
  background: #eae7ff;
  color: #6435c9;
}
.kb-labfront.container .ui.ui.selectable.table tr.violet:hover,
.kb-labfront.container .ui.table tr td.selectable.violet:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.violet {
  background: screen(#a291fb, #cccccc);
  color: #6435c9;
}
.kb-labfront.container .ui.purple.table {
  border-top: 0.2em solid #a333c8;
}
.kb-labfront.container .ui.inverted.purple.table {
  background-color: #a333c8;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.purple,
.kb-labfront.container .ui.ui.table td.purple {
  box-shadow: 0 0 0 rgb(129.8804780876, 40.6374501992, 159.3625498008) inset;
  background: #f6e7ff;
  color: #a333c8;
}
.kb-labfront.container .ui.ui.selectable.table tr.purple:hover,
.kb-labfront.container .ui.table tr td.selectable.purple:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.purple {
  background: screen(#dc73ff, #cccccc);
  color: #a333c8;
}
.kb-labfront.container .ui.pink.table {
  border-top: 0.2em solid #e03997;
}
.kb-labfront.container .ui.inverted.pink.table {
  background-color: #e03997;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.pink,
.kb-labfront.container .ui.ui.table td.pink {
  box-shadow: 0 0 0 rgb(198.864628821, 31.135371179, 125.5458515284) inset;
  background: #ffe3fb;
  color: #e03997;
}
.kb-labfront.container .ui.ui.selectable.table tr.pink:hover,
.kb-labfront.container .ui.table tr td.selectable.pink:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.pink {
  background: screen(#ff8edf, #cccccc);
  color: #e03997;
}
.kb-labfront.container .ui.brown.table {
  border-top: 0.2em solid #a5673f;
}
.kb-labfront.container .ui.inverted.brown.table {
  background-color: #a5673f;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.brown,
.kb-labfront.container .ui.ui.table td.brown {
  box-shadow: 0 0 0 rgb(128.0921052632, 79.9605263158, 48.9078947368) inset;
  background: #f1e2d3;
  color: #a5673f;
}
.kb-labfront.container .ui.ui.selectable.table tr.brown:hover,
.kb-labfront.container .ui.table tr td.selectable.brown:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.brown {
  background: screen(#d67c1c, #cccccc);
  color: #a5673f;
}
.kb-labfront.container .ui.grey.table {
  border-top: 0.2em solid #767676;
}
.kb-labfront.container .ui.inverted.grey.table {
  background-color: #767676;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.grey,
.kb-labfront.container .ui.ui.table td.grey {
  box-shadow: 0 0 0 rgb(92.5, 92.5, 92.5) inset;
  background: #dcddde;
  color: #767676;
}
.kb-labfront.container .ui.ui.selectable.table tr.grey:hover,
.kb-labfront.container .ui.table tr td.selectable.grey:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.grey {
  background: rgb(187.8, 195.5, 203.2);
  color: #767676;
}
.kb-labfront.container .ui.black.table {
  border-top: 0.2em solid #1b1c1d;
}
.kb-labfront.container .ui.inverted.black.table {
  background-color: #1b1c1d;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.ui.ui.table tr.black,
.kb-labfront.container .ui.ui.table td.black {
  box-shadow: 0 0 0 rgb(2.4107142857, 2.5, 2.5892857143) inset;
  background: #545454;
  color: #ffffff;
}
.kb-labfront.container .ui.ui.selectable.table tr.black:hover,
.kb-labfront.container .ui.table tr td.selectable.black:hover,
.kb-labfront.container .ui.selectable.table tr:hover td.black {
  background: black;
  color: #ffffff;
}
.kb-labfront.container .ui.one.column.table td {
  width: 100%;
}
.kb-labfront.container .ui.two.column.table td {
  width: 50%;
}
.kb-labfront.container .ui.three.column.table td {
  width: 33.3333333333%;
}
.kb-labfront.container .ui.four.column.table td {
  width: 25%;
}
.kb-labfront.container .ui.five.column.table td {
  width: 20%;
}
.kb-labfront.container .ui.six.column.table td {
  width: 16.6666666667%;
}
.kb-labfront.container .ui.seven.column.table td {
  width: 14.2857142857%;
}
.kb-labfront.container .ui.eight.column.table td {
  width: 12.5%;
}
.kb-labfront.container .ui.nine.column.table td {
  width: 11.1111111111%;
}
.kb-labfront.container .ui.ten.column.table td {
  width: 10%;
}
.kb-labfront.container .ui.eleven.column.table td {
  width: 9.0909090909%;
}
.kb-labfront.container .ui.twelve.column.table td {
  width: 8.3333333333%;
}
.kb-labfront.container .ui.thirteen.column.table td {
  width: 7.6923076923%;
}
.kb-labfront.container .ui.fourteen.column.table td {
  width: 7.1428571429%;
}
.kb-labfront.container .ui.fifteen.column.table td {
  width: 6.6666666667%;
}
.kb-labfront.container .ui.sixteen.column.table td {
  width: 6.25%;
}
.kb-labfront.container .ui.table th.one.wide,
.kb-labfront.container .ui.table td.one.wide {
  width: 6.25%;
}
.kb-labfront.container .ui.table th.two.wide,
.kb-labfront.container .ui.table td.two.wide {
  width: 12.5%;
}
.kb-labfront.container .ui.table th.three.wide,
.kb-labfront.container .ui.table td.three.wide {
  width: 18.75%;
}
.kb-labfront.container .ui.table th.four.wide,
.kb-labfront.container .ui.table td.four.wide {
  width: 25%;
}
.kb-labfront.container .ui.table th.five.wide,
.kb-labfront.container .ui.table td.five.wide {
  width: 31.25%;
}
.kb-labfront.container .ui.table th.six.wide,
.kb-labfront.container .ui.table td.six.wide {
  width: 37.5%;
}
.kb-labfront.container .ui.table th.seven.wide,
.kb-labfront.container .ui.table td.seven.wide {
  width: 43.75%;
}
.kb-labfront.container .ui.table th.eight.wide,
.kb-labfront.container .ui.table td.eight.wide {
  width: 50%;
}
.kb-labfront.container .ui.table th.nine.wide,
.kb-labfront.container .ui.table td.nine.wide {
  width: 56.25%;
}
.kb-labfront.container .ui.table th.ten.wide,
.kb-labfront.container .ui.table td.ten.wide {
  width: 62.5%;
}
.kb-labfront.container .ui.table th.eleven.wide,
.kb-labfront.container .ui.table td.eleven.wide {
  width: 68.75%;
}
.kb-labfront.container .ui.table th.twelve.wide,
.kb-labfront.container .ui.table td.twelve.wide {
  width: 75%;
}
.kb-labfront.container .ui.table th.thirteen.wide,
.kb-labfront.container .ui.table td.thirteen.wide {
  width: 81.25%;
}
.kb-labfront.container .ui.table th.fourteen.wide,
.kb-labfront.container .ui.table td.fourteen.wide {
  width: 87.5%;
}
.kb-labfront.container .ui.table th.fifteen.wide,
.kb-labfront.container .ui.table td.fifteen.wide {
  width: 93.75%;
}
.kb-labfront.container .ui.table th.sixteen.wide,
.kb-labfront.container .ui.table td.sixteen.wide {
  width: 100%;
}
.kb-labfront.container .ui.sortable.table > thead > tr > th {
  cursor: pointer;
  white-space: nowrap;
  border-left: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.sortable.table > thead > tr > th:first-child {
  border-left: none;
}
.kb-labfront.container .ui.sortable.table thead th.sorted,
.kb-labfront.container .ui.sortable.table thead th.sorted:hover {
  user-select: none;
}
.kb-labfront.container .ui.sortable.table > thead > tr > th:after {
  display: none;
  font-style: normal;
  font-weight: normal;
  text-decoration: inherit;
  content: "";
  height: 1em;
  width: auto;
  opacity: 0.8;
  margin: 0 0 0 0.5em;
  font-family: "Icons";
}
.kb-labfront.container .ui.sortable.table thead th.ascending:after {
  content: "\\f0d8";
}
.kb-labfront.container .ui.sortable.table thead th.descending:after {
  content: "\\f0d7";
}
.kb-labfront.container .ui.sortable.table th.disabled:hover {
  cursor: auto;
  color: rgba(0, 0, 0, 0.2);
}
.kb-labfront.container .ui.sortable.table > thead > tr > th:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.sortable.table thead th.sorted {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.sortable.table thead th.sorted:after {
  display: inline-block;
}
.kb-labfront.container .ui.sortable.table thead th.sorted:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.inverted.sortable.table thead th.sorted {
  background: rgba(255, 255, 255, 0.15) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.sortable.table > thead > tr > th:hover {
  background: rgba(255, 255, 255, 0.08) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.sortable.table > thead > tr > th {
  border-left-color: transparent;
  border-right-color: transparent;
}
.kb-labfront.container .ui.inverted.table {
  background: #333333;
  color: rgba(255, 255, 255, 0.9);
  border: none;
}
.kb-labfront.container .ui.ui.inverted.table > thead > tr > th,
.kb-labfront.container .ui.ui.inverted.table > tbody > tr > th,
.kb-labfront.container .ui.ui.inverted.table > tfoot > tr > th,
.kb-labfront.container .ui.ui.inverted.table > tr > th {
  background-color: rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.table > tbody > tr > td,
.kb-labfront.container .ui.inverted.table > tr > td {
  border-color: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.inverted.table tr.disabled td,
.kb-labfront.container .ui.inverted.table tr td.disabled,
.kb-labfront.container .ui.inverted.table tr.disabled:hover td,
.kb-labfront.container .ui.inverted.table tr:hover td.disabled {
  pointer-events: none;
  color: rgba(255, 255, 255, 0.2);
}
.kb-labfront.container .ui.inverted.table tr td.disabled:not([class=disabled]),
.kb-labfront.container .ui.inverted.table tr.disabled:not([class=disabled]) td,
.kb-labfront.container .ui.inverted.table tr.disabled td[class]:not(.disabled),
.kb-labfront.container .ui.inverted.table tr:hover td.disabled:not([class=disabled]) {
  color: rgba(0, 0, 0, 0.2);
}
.kb-labfront.container .ui.inverted.definition.table > tfoot:not(.full-width) > tr > th:first-child,
.kb-labfront.container .ui.inverted.definition.table > thead:not(.full-width) > tr > th:first-child {
  background: #ffffff;
}
.kb-labfront.container .ui.inverted.definition.table > tbody > tr > td:first-child,
.kb-labfront.container .ui.inverted.definition.table > tr > td:first-child {
  background: rgba(255, 255, 255, 0.02);
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.collapsing.table {
  width: auto;
}
.kb-labfront.container .ui.basic.table {
  background: transparent;
  border: rgba(34, 36, 38, 0.15);
  box-shadow: none;
}
.kb-labfront.container .ui.basic.table > thead,
.kb-labfront.container .ui.basic.table > tfoot {
  box-shadow: none;
}
.kb-labfront.container .ui.basic.table > thead > tr > th,
.kb-labfront.container .ui.basic.table > tbody > tr > th,
.kb-labfront.container .ui.basic.table > tfoot > tr > th,
.kb-labfront.container .ui.basic.table > tr > th {
  background: transparent;
  border-left: none;
}
.kb-labfront.container .ui.basic.table > tbody > tr > td,
.kb-labfront.container .ui.basic.table > tr > td {
  background: transparent;
}
.kb-labfront.container .ui.basic.striped.table > tbody > tr:nth-child(2n) {
  background-color: rgba(0, 0, 0, 0.05);
}
.kb-labfront.container .ui[class*="very basic"].table {
  border: none;
}
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tr > th,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > thead > tr > th,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tbody > tr > th,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tfoot > tr > th,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tr > td,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tbody > tr > td {
  padding: "";
}
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tr > th:first-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > thead > tr > th:first-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tbody > tr > th:first-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tfoot > tr > th:first-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tr > td:first-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tbody > tr > td:first-child {
  padding-left: 0;
}
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tr > th:last-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > thead > tr > th:last-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tbody > tr > th:last-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tfoot > tr > th:last-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tr > td:last-child,
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > tbody > tr > td:last-child {
  padding-right: 0;
}
.kb-labfront.container .ui[class*="very basic"].table:not(.sortable):not(.striped) > thead > tr:first-child > th {
  padding-top: 0;
}
.kb-labfront.container .ui.celled.table > tr > th,
.kb-labfront.container .ui.celled.table > thead > tr > th,
.kb-labfront.container .ui.celled.table > tbody > tr > th,
.kb-labfront.container .ui.celled.table > tfoot > tr > th,
.kb-labfront.container .ui.celled.table > tr > td,
.kb-labfront.container .ui.celled.table > tbody > tr > td {
  border-left: 1px solid rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.inverted.celled.table > tbody > tr > td,
.kb-labfront.container .ui.inverted.celled.table > tr > td {
  border-left: 1px solid rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.celled.table > tr > th:first-child,
.kb-labfront.container .ui.celled.table > thead > tr > th:first-child,
.kb-labfront.container .ui.celled.table > tbody > tr > th:first-child,
.kb-labfront.container .ui.celled.table > tfoot > tr > th:first-child,
.kb-labfront.container .ui.celled.table > tr > td:first-child,
.kb-labfront.container .ui.celled.table > tbody > tr > td:first-child {
  border-left: none;
}
.kb-labfront.container .ui.padded.table > tr > th,
.kb-labfront.container .ui.padded.table > thead > tr > th,
.kb-labfront.container .ui.padded.table > tbody > tr > th,
.kb-labfront.container .ui.padded.table > tfoot > tr > th {
  padding-left: 1em;
  padding-right: 1em;
}
.kb-labfront.container .ui.padded.table > tr > th,
.kb-labfront.container .ui.padded.table > thead > tr > th,
.kb-labfront.container .ui.padded.table > tbody > tr > th,
.kb-labfront.container .ui.padded.table > tfoot > tr > th,
.kb-labfront.container .ui.padded.table > tr > td,
.kb-labfront.container .ui.padded.table > tbody > tr > td {
  padding: 1em 1em;
}
.kb-labfront.container .ui[class*="very padded"].table > tr > th,
.kb-labfront.container .ui[class*="very padded"].table > thead > tr > th,
.kb-labfront.container .ui[class*="very padded"].table > tbody > tr > th,
.kb-labfront.container .ui[class*="very padded"].table > tfoot > tr > th {
  padding-left: 1.5em;
  padding-right: 1.5em;
}
.kb-labfront.container .ui[class*="very padded"].table > tr > td,
.kb-labfront.container .ui[class*="very padded"].table > tbody > tr > td {
  padding: 1.5em 1.5em;
}
.kb-labfront.container .ui.compact.table > tr > th,
.kb-labfront.container .ui.compact.table > thead > tr > th,
.kb-labfront.container .ui.compact.table > tbody > tr > th,
.kb-labfront.container .ui.compact.table > tfoot > tr > th {
  padding-left: 0.7em;
  padding-right: 0.7em;
}
.kb-labfront.container .ui.compact.table > tr > td,
.kb-labfront.container .ui.compact.table > tbody > tr > td {
  padding: 0.5em 0.7em;
}
.kb-labfront.container .ui[class*="very compact"].table > tr > th,
.kb-labfront.container .ui[class*="very compact"].table > thead > tr > th,
.kb-labfront.container .ui[class*="very compact"].table > tbody > tr > th,
.kb-labfront.container .ui[class*="very compact"].table > tfoot > tr > th {
  padding-left: 0.6em;
  padding-right: 0.6em;
}
.kb-labfront.container .ui[class*="very compact"].table > tr > td,
.kb-labfront.container .ui[class*="very compact"].table > tbody > tr > td {
  padding: 0.4em 0.6em;
}
.kb-labfront.container .ui.small.table {
  font-size: 0.9em;
}
.kb-labfront.container .ui.table {
  font-size: 1em;
}
.kb-labfront.container .ui.large.table {
  font-size: 1.1em;
}
.kb-labfront.container .ui.ad {
  display: block;
  overflow: hidden;
  margin: 1em 0;
}
.kb-labfront.container .ui.ad:first-child {
  margin: 0;
}
.kb-labfront.container .ui.ad:last-child {
  margin: 0;
}
.kb-labfront.container .ui.ad iframe {
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
}
.kb-labfront.container .ui.leaderboard.ad {
  width: 728px;
  height: 90px;
}
.kb-labfront.container .ui[class*="medium rectangle"].ad {
  width: 300px;
  height: 250px;
}
.kb-labfront.container .ui[class*="large rectangle"].ad {
  width: 336px;
  height: 280px;
}
.kb-labfront.container .ui[class*="half page"].ad {
  width: 300px;
  height: 600px;
}
.kb-labfront.container .ui.square.ad {
  width: 250px;
  height: 250px;
}
.kb-labfront.container .ui[class*="small square"].ad {
  width: 200px;
  height: 200px;
}
.kb-labfront.container .ui[class*="small rectangle"].ad {
  width: 180px;
  height: 150px;
}
.kb-labfront.container .ui[class*="vertical rectangle"].ad {
  width: 240px;
  height: 400px;
}
.kb-labfront.container .ui.button.ad {
  width: 120px;
  height: 90px;
}
.kb-labfront.container .ui[class*="square button"].ad {
  width: 125px;
  height: 125px;
}
.kb-labfront.container .ui[class*="small button"].ad {
  width: 120px;
  height: 60px;
}
.kb-labfront.container .ui.skyscraper.ad {
  width: 120px;
  height: 600px;
}
.kb-labfront.container .ui[class*="wide skyscraper"].ad {
  width: 160px;
}
.kb-labfront.container .ui.banner.ad {
  width: 468px;
  height: 60px;
}
.kb-labfront.container .ui[class*="vertical banner"].ad {
  width: 120px;
  height: 240px;
}
.kb-labfront.container .ui[class*="top banner"].ad {
  width: 930px;
  height: 180px;
}
.kb-labfront.container .ui[class*="half banner"].ad {
  width: 234px;
  height: 60px;
}
.kb-labfront.container .ui[class*="large leaderboard"].ad {
  width: 970px;
  height: 90px;
}
.kb-labfront.container .ui.billboard.ad {
  width: 970px;
  height: 250px;
}
.kb-labfront.container .ui.panorama.ad {
  width: 980px;
  height: 120px;
}
.kb-labfront.container .ui.netboard.ad {
  width: 580px;
  height: 400px;
}
.kb-labfront.container .ui[class*="large mobile banner"].ad {
  width: 320px;
  height: 100px;
}
.kb-labfront.container .ui[class*="mobile leaderboard"].ad {
  width: 320px;
  height: 50px;
}
.kb-labfront.container .ui.mobile.ad {
  display: none;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.mobile.ad {
    display: block;
  }
}
.kb-labfront.container .ui.centered.ad {
  margin-left: auto;
  margin-right: auto;
}
.kb-labfront.container .ui.test.ad {
  position: relative;
  background: #545454;
}
.kb-labfront.container .ui.test.ad:after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  transform: translateX(-50%) translateY(-50%);
  content: "Ad";
  color: #ffffff;
  font-size: 1em;
  font-weight: bold;
}
.kb-labfront.container .ui.mobile.test.ad:after {
  font-size: 0.8571428571em;
}
.kb-labfront.container .ui.test.ad[data-text]:after {
  content: attr(data-text);
}
.kb-labfront.container .ui.cards > .card,
.kb-labfront.container .ui.card {
  max-width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 290px;
  min-height: 0;
  background: #ffffff;
  padding: 0;
  border: none;
  border-radius: 0.2857142857rem;
  box-shadow: 0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5;
  transition: box-shadow 0.1s ease, transform 0.1s ease;
  z-index: "";
  word-wrap: break-word;
}
.kb-labfront.container .ui.card {
  margin: 1em 0;
}
.kb-labfront.container .ui.cards > .card a,
.kb-labfront.container .ui.card a {
  cursor: pointer;
}
.kb-labfront.container .ui.card:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.card:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.cards {
  display: flex;
  margin: -0.875em -0.5em;
  flex-wrap: wrap;
}
.kb-labfront.container .ui.cards > .card {
  display: flex;
  margin: 0.875em 0.5em;
  float: none;
}
.kb-labfront.container .ui.cards:after,
.kb-labfront.container .ui.card:after {
  display: block;
  content: " ";
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.kb-labfront.container .ui.cards ~ .ui.cards {
  margin-top: 0.875em;
}
.kb-labfront.container .ui.cards > .card > :first-child,
.kb-labfront.container .ui.card > :first-child {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0 !important;
  border-top: none !important;
}
.kb-labfront.container .ui.cards > .card > :last-child,
.kb-labfront.container .ui.card > :last-child {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem !important;
}
.kb-labfront.container .ui.cards > .card > :only-child,
.kb-labfront.container .ui.card > :only-child {
  border-radius: 0.2857142857rem !important;
}
.kb-labfront.container .ui.cards > .card > .image,
.kb-labfront.container .ui.card > .image {
  position: relative;
  display: block;
  flex: 0 0 auto;
  padding: 0;
  background: rgba(0, 0, 0, 0.05);
}
.kb-labfront.container .ui.cards > .card > .image > img,
.kb-labfront.container .ui.card > .image > img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: inherit;
}
.kb-labfront.container .ui.cards > .card > .image:not(.ui) > img,
.kb-labfront.container .ui.card > .image:not(.ui) > img {
  border: none;
}
.kb-labfront.container .ui.cards > .card > .content,
.kb-labfront.container .ui.card > .content {
  flex-grow: 1;
  border: none;
  border-top: 1px solid rgba(34, 36, 38, 0.1);
  background: none;
  margin: 0;
  padding: 1em 1em;
  box-shadow: none;
  font-size: 1em;
  border-radius: 0;
}
.kb-labfront.container .ui.cards > .card > .content:after,
.kb-labfront.container .ui.card > .content:after {
  display: block;
  content: " ";
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.kb-labfront.container .ui.cards > .card > .content > .header,
.kb-labfront.container .ui.card > .content > .header {
  display: block;
  margin: "";
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.cards > .card > .content > .header:not(.ui),
.kb-labfront.container .ui.card > .content > .header:not(.ui) {
  font-weight: bold;
  font-size: 1.2857142857em;
  margin-top: -0.21425em;
  line-height: 1.2857142857em;
}
.kb-labfront.container .ui.cards > .card > .content > .meta + .description,
.kb-labfront.container .ui.cards > .card > .content > .header + .description,
.kb-labfront.container .ui.card > .content > .meta + .description,
.kb-labfront.container .ui.card > .content > .header + .description {
  margin-top: 0.5em;
}
.kb-labfront.container .ui.cards > .card [class*="left floated"],
.kb-labfront.container .ui.card [class*="left floated"] {
  float: left;
}
.kb-labfront.container .ui.cards > .card [class*="right floated"],
.kb-labfront.container .ui.card [class*="right floated"] {
  float: right;
}
.kb-labfront.container .ui.cards > .card [class*="left aligned"],
.kb-labfront.container .ui.card [class*="left aligned"] {
  text-align: left;
}
.kb-labfront.container .ui.cards > .card [class*="center aligned"],
.kb-labfront.container .ui.card [class*="center aligned"] {
  text-align: center;
}
.kb-labfront.container .ui.cards > .card [class*="right aligned"],
.kb-labfront.container .ui.card [class*="right aligned"] {
  text-align: right;
}
.kb-labfront.container .ui.cards > .card .content img,
.kb-labfront.container .ui.card .content img {
  display: inline-block;
  vertical-align: middle;
  width: "";
}
.kb-labfront.container .ui.cards > .card img.avatar,
.kb-labfront.container .ui.cards > .card .avatar img,
.kb-labfront.container .ui.card img.avatar,
.kb-labfront.container .ui.card .avatar img {
  width: 2em;
  height: 2em;
  border-radius: 500rem;
}
.kb-labfront.container .ui.cards > .card > .content > .description,
.kb-labfront.container .ui.card > .content > .description {
  clear: both;
  color: rgba(0, 0, 0, 0.68);
}
.kb-labfront.container .ui.cards > .card > .content p,
.kb-labfront.container .ui.card > .content p {
  margin: 0 0 0.5em;
}
.kb-labfront.container .ui.cards > .card > .content p:last-child,
.kb-labfront.container .ui.card > .content p:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.cards > .card .meta,
.kb-labfront.container .ui.card .meta {
  font-size: 1em;
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.cards > .card .meta *,
.kb-labfront.container .ui.card .meta * {
  margin-right: 0.3em;
}
.kb-labfront.container .ui.cards > .card .meta :last-child,
.kb-labfront.container .ui.card .meta :last-child {
  margin-right: 0;
}
.kb-labfront.container .ui.cards > .card .meta [class*="right floated"],
.kb-labfront.container .ui.card .meta [class*="right floated"] {
  margin-right: 0;
  margin-left: 0.3em;
}
.kb-labfront.container .ui.cards > .card > .content a:not(.ui),
.kb-labfront.container .ui.card > .content a:not(.ui) {
  color: "";
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.cards > .card > .content a:not(.ui):hover,
.kb-labfront.container .ui.card > .content a:not(.ui):hover {
  color: "";
}
.kb-labfront.container .ui.cards > .card > .content > a.header,
.kb-labfront.container .ui.card > .content > a.header {
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.cards > .card > .content > a.header:hover,
.kb-labfront.container .ui.card > .content > a.header:hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.cards > .card .meta > a:not(.ui),
.kb-labfront.container .ui.card .meta > a:not(.ui) {
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.cards > .card .meta > a:not(.ui):hover,
.kb-labfront.container .ui.card .meta > a:not(.ui):hover {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.cards > .card > .buttons,
.kb-labfront.container .ui.card > .buttons,
.kb-labfront.container .ui.cards > .card > .button,
.kb-labfront.container .ui.card > .button {
  margin: 0 -1px;
  width: calc(100% + 2px);
}
.kb-labfront.container .ui.cards > .card > .buttons:last-child,
.kb-labfront.container .ui.card > .buttons:last-child,
.kb-labfront.container .ui.cards > .card > .button:last-child,
.kb-labfront.container .ui.card > .button:last-child {
  margin-bottom: -1px;
}
.kb-labfront.container .ui.cards > .card .dimmer,
.kb-labfront.container .ui.card .dimmer {
  background-color: "";
  z-index: 10;
}
.kb-labfront.container .ui.cards > .card > .content .star.icon,
.kb-labfront.container .ui.card > .content .star.icon {
  cursor: pointer;
  opacity: 0.75;
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.cards > .card > .content .star.icon:hover,
.kb-labfront.container .ui.card > .content .star.icon:hover {
  opacity: 1;
  color: #FFB70A;
}
.kb-labfront.container .ui.cards > .card > .content .active.star.icon,
.kb-labfront.container .ui.card > .content .active.star.icon {
  color: #FFE623;
}
.kb-labfront.container .ui.cards > .card > .content .like.icon,
.kb-labfront.container .ui.card > .content .like.icon {
  cursor: pointer;
  opacity: 0.75;
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.cards > .card > .content .like.icon:hover,
.kb-labfront.container .ui.card > .content .like.icon:hover {
  opacity: 1;
  color: #FF2733;
}
.kb-labfront.container .ui.cards > .card > .content .active.like.icon,
.kb-labfront.container .ui.card > .content .active.like.icon {
  color: #FF2733;
}
.kb-labfront.container .ui.cards > .card > .extra,
.kb-labfront.container .ui.card > .extra {
  max-width: 100%;
  min-height: 0 !important;
  flex-grow: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.05) !important;
  position: static;
  background: none;
  width: auto;
  margin: 0 0;
  padding: 0.75em 1em;
  top: 0;
  left: 0;
  color: rgba(0, 0, 0, 0.4);
  box-shadow: none;
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.cards > .card > .extra a:not(.ui),
.kb-labfront.container .ui.card > .extra a:not(.ui) {
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.cards > .card > .extra a:not(.ui):hover,
.kb-labfront.container .ui.card > .extra a:not(.ui):hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.horizontal.cards > .card,
.kb-labfront.container .ui.card.horizontal {
  flex-direction: row;
  flex-wrap: wrap;
  min-width: 400px;
  width: 400px;
  max-width: 100%;
}
.kb-labfront.container .ui.horizontal.cards > .card > .image,
.kb-labfront.container .ui.card.horizontal > .image {
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
  width: 150px;
}
.kb-labfront.container .ui.horizontal.cards > .card > .image > img,
.kb-labfront.container .ui.card.horizontal > .image > img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  justify-content: center;
  align-items: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: 0.2857142857rem 0 0 0.2857142857rem;
}
.kb-labfront.container .ui.horizontal.cards > .card > .content, .kb-labfront.container .ui.horizontal.card > .content {
  flex-basis: 1px;
}
.kb-labfront.container .ui.horizontal.cards > .card > .extra, .kb-labfront.container .ui.horizontal.card > .extra {
  flex-basis: 100%;
}
.kb-labfront.container .ui.raised.cards > .card,
.kb-labfront.container .ui.raised.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.raised.cards a.card:hover,
.kb-labfront.container .ui.link.cards .raised.card:hover,
.kb-labfront.container a.ui.raised.card:hover,
.kb-labfront.container .ui.link.raised.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 4px 0 rgba(34, 36, 38, 0.15), 0 2px 10px 0 rgba(34, 36, 38, 0.25);
}
.kb-labfront.container .ui.centered.cards {
  justify-content: center;
}
.kb-labfront.container .ui.centered.card {
  margin-left: auto;
  margin-right: auto;
}
.kb-labfront.container .ui.fluid.card {
  width: 100%;
  max-width: 9999px;
}
.kb-labfront.container .ui.cards a.card,
.kb-labfront.container .ui.link.cards .card,
.kb-labfront.container a.ui.card,
.kb-labfront.container .ui.link.card {
  transform: none;
}
.kb-labfront.container .ui.cards a.card:hover,
.kb-labfront.container .ui.link.cards .card:not(.icon):hover,
.kb-labfront.container a.ui.card:hover,
.kb-labfront.container .ui.link.card:hover {
  cursor: pointer;
  z-index: 5;
  background: #ffffff;
  border: none;
  box-shadow: 0 1px 3px 0 #bcbdbd, 0 0 0 1px #d4d4d5;
  transform: translateY(-3px);
}
.kb-labfront.container .ui.primary.cards > .card,
.kb-labfront.container .ui.cards > .primary.card,
.kb-labfront.container .ui.primary.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #2185d0, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.primary.cards > .card:hover,
.kb-labfront.container .ui.cards > .primary.card:hover,
.kb-labfront.container .ui.primary.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(18.7332987552, 120.4666716064, 196.7667012448), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.primary.cards > .card,
.kb-labfront.container .ui.inverted.cards > .primary.card,
.kb-labfront.container .ui.inverted.primary.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #54c8ff, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.primary.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .primary.card:hover,
.kb-labfront.container .ui.inverted.primary.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(33, 183.5964912281, 255), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.secondary.cards > .card,
.kb-labfront.container .ui.cards > .secondary.card,
.kb-labfront.container .ui.secondary.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #1b1c1d, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.secondary.cards > .card:hover,
.kb-labfront.container .ui.cards > .secondary.card:hover,
.kb-labfront.container .ui.secondary.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(35.2196428571, 40.75, 46.2803571429), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.secondary.cards > .card,
.kb-labfront.container .ui.inverted.cards > .secondary.card,
.kb-labfront.container .ui.inverted.secondary.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #545454, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.secondary.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .secondary.card:hover,
.kb-labfront.container .ui.inverted.secondary.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(120.45, 98.55, 98.55), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.red.cards > .card,
.kb-labfront.container .ui.cards > .red.card,
.kb-labfront.container .ui.red.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #db2828, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.red.cards > .card:hover,
.kb-labfront.container .ui.cards > .red.card:hover,
.kb-labfront.container .ui.red.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(211.6849601594, 21.8150398406, 21.8150398406), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.red.cards > .card,
.kb-labfront.container .ui.inverted.cards > .red.card,
.kb-labfront.container .ui.inverted.red.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #ff695e, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.red.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .red.card:hover,
.kb-labfront.container .ui.inverted.red.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(255, 57.4844720497, 43), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.orange.cards > .card,
.kb-labfront.container .ui.cards > .orange.card,
.kb-labfront.container .ui.orange.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #f2711c, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.orange.cards > .card:hover,
.kb-labfront.container .ui.cards > .orange.card:hover,
.kb-labfront.container .ui.orange.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(243.48125, 97.3239485981, 1.01875), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.orange.cards > .card,
.kb-labfront.container .ui.inverted.cards > .orange.card,
.kb-labfront.container .ui.inverted.orange.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #ff851b, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.orange.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .orange.card:hover,
.kb-labfront.container .ui.inverted.orange.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(231, 107.3947368421, 0), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.yellow.cards > .card,
.kb-labfront.container .ui.cards > .yellow.card,
.kb-labfront.container .ui.yellow.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #fbbd08, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.yellow.cards > .card:hover,
.kb-labfront.container .ui.cards > .yellow.card:hover,
.kb-labfront.container .ui.yellow.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(233.5, 173.9238683128, 0), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.yellow.cards > .card,
.kb-labfront.container .ui.inverted.cards > .yellow.card,
.kb-labfront.container .ui.inverted.yellow.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #ffe21f, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.yellow.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .yellow.card:hover,
.kb-labfront.container .ui.inverted.yellow.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(235, 204.5758928571, 0), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.olive.cards > .card,
.kb-labfront.container .ui.cards > .olive.card,
.kb-labfront.container .ui.olive.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #b5cc18, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.olive.cards > .card:hover,
.kb-labfront.container .ui.cards > .olive.card:hover,
.kb-labfront.container .ui.olive.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(168.2940789474, 191.3092105263, 11.1907894737), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.olive.cards > .card,
.kb-labfront.container .ui.inverted.cards > .olive.card,
.kb-labfront.container .ui.inverted.olive.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #d9e778, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.olive.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .olive.card:hover,
.kb-labfront.container .ui.inverted.olive.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(212.6626721061, 233.8018867925, 66.1981132075), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.green.cards > .card,
.kb-labfront.container .ui.cards > .green.card,
.kb-labfront.container .ui.green.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #21ba45, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.green.cards > .card:hover,
.kb-labfront.container .ui.cards > .green.card:hover,
.kb-labfront.container .ui.green.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(19.4825342466, 174.0174657534, 55.8436946011), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.green.cards > .card,
.kb-labfront.container .ui.inverted.cards > .green.card,
.kb-labfront.container .ui.inverted.green.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #2ecc40, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.green.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .green.card:hover,
.kb-labfront.container .ui.inverted.green.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(26.666, 172.334, 43.2610886076), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.teal.cards > .card,
.kb-labfront.container .ui.cards > .teal.card,
.kb-labfront.container .ui.teal.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #00b5ad, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.teal.cards > .card:hover,
.kb-labfront.container .ui.cards > .teal.card:hover,
.kb-labfront.container .ui.teal.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(0, 155.5, 148.6270718232), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.teal.cards > .card,
.kb-labfront.container .ui.inverted.cards > .teal.card,
.kb-labfront.container .ui.inverted.teal.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #6dffff, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.teal.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .teal.card:hover,
.kb-labfront.container .ui.inverted.teal.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #3affff, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.blue.cards > .card,
.kb-labfront.container .ui.cards > .blue.card,
.kb-labfront.container .ui.blue.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #2185d0, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.blue.cards > .card:hover,
.kb-labfront.container .ui.cards > .blue.card:hover,
.kb-labfront.container .ui.blue.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(18.7332987552, 120.4666716064, 196.7667012448), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.blue.cards > .card,
.kb-labfront.container .ui.inverted.cards > .blue.card,
.kb-labfront.container .ui.inverted.blue.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #54c8ff, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.blue.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .blue.card:hover,
.kb-labfront.container .ui.inverted.blue.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(33, 183.5964912281, 255), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.violet.cards > .card,
.kb-labfront.container .ui.cards > .violet.card,
.kb-labfront.container .ui.violet.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #6435c9, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.violet.cards > .card:hover,
.kb-labfront.container .ui.cards > .violet.card:hover,
.kb-labfront.container .ui.violet.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(85.7920488402, 36.2541338583, 192.2458661417), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.violet.cards > .card,
.kb-labfront.container .ui.inverted.cards > .violet.card,
.kb-labfront.container .ui.inverted.violet.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #a291fb, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.violet.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .violet.card:hover,
.kb-labfront.container .ui.inverted.violet.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(116.4622641509, 90, 255), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.purple.cards > .card,
.kb-labfront.container .ui.cards > .purple.card,
.kb-labfront.container .ui.purple.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #a333c8, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.purple.cards > .card:hover,
.kb-labfront.container .ui.cards > .purple.card:hover,
.kb-labfront.container .ui.purple.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(152.1155746143, 34.5437250996, 190.9562749004), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.purple.cards > .card,
.kb-labfront.container .ui.inverted.cards > .purple.card,
.kb-labfront.container .ui.inverted.purple.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #dc73ff, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.purple.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .purple.card:hover,
.kb-labfront.container .ui.inverted.purple.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(207.25, 64, 255), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.pink.cards > .card,
.kb-labfront.container .ui.cards > .pink.card,
.kb-labfront.container .ui.pink.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #e03997, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.pink.cards > .card:hover,
.kb-labfront.container .ui.cards > .pink.card:hover,
.kb-labfront.container .ui.pink.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(233.2730349345, 22.2269650655, 141.0193636744), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.pink.cards > .card,
.kb-labfront.container .ui.inverted.cards > .pink.card,
.kb-labfront.container .ui.inverted.pink.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #ff8edf, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.pink.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .pink.card:hover,
.kb-labfront.container .ui.inverted.pink.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(255, 91, 208.5575221239), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.brown.cards > .card,
.kb-labfront.container .ui.cards > .brown.card,
.kb-labfront.container .ui.brown.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #a5673f, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.brown.cards > .card:hover,
.kb-labfront.container .ui.cards > .brown.card:hover,
.kb-labfront.container .ui.brown.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(156.6710526316, 89.2964396285, 45.8289473684), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.brown.cards > .card,
.kb-labfront.container .ui.inverted.cards > .brown.card,
.kb-labfront.container .ui.inverted.brown.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #d67c1c, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.brown.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .brown.card:hover,
.kb-labfront.container .ui.inverted.brown.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(178.4508264463, 98.1758331112, 12.5491735537), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.grey.cards > .card,
.kb-labfront.container .ui.cards > .grey.card,
.kb-labfront.container .ui.grey.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #767676, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.grey.cards > .card:hover,
.kb-labfront.container .ui.cards > .grey.card:hover,
.kb-labfront.container .ui.grey.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(115.775, 94.725, 94.725), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.grey.cards > .card,
.kb-labfront.container .ui.inverted.cards > .grey.card,
.kb-labfront.container .ui.inverted.grey.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #dcddde, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.grey.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .grey.card:hover,
.kb-labfront.container .ui.inverted.grey.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 rgb(187.8, 195.5, 203.2), 0 0 0 1px #555555;
}
.kb-labfront.container .ui.black.cards > .card,
.kb-labfront.container .ui.cards > .black.card,
.kb-labfront.container .ui.black.card {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 #1b1c1d, 0 1px 3px 0 #d4d4d5;
}
.kb-labfront.container .ui.black.cards > .card:hover,
.kb-labfront.container .ui.cards > .black.card:hover,
.kb-labfront.container .ui.black.card:hover {
  box-shadow: 0 0 0 1px #d4d4d5, 0 2px 0 0 rgb(13.1803571429, 15.25, 17.3196428571), 0 1px 3px 0 #bcbdbd;
}
.kb-labfront.container .ui.inverted.black.cards > .card,
.kb-labfront.container .ui.inverted.cards > .black.card,
.kb-labfront.container .ui.inverted.black.card {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 #545454, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.black.cards > .card:hover,
.kb-labfront.container .ui.inverted.cards > .black.card:hover,
.kb-labfront.container .ui.inverted.black.card:hover {
  box-shadow: 0 1px 3px 0 #555555, 0 2px 0 0 black, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.one.cards {
  margin-left: 0;
  margin-right: 0;
}
.kb-labfront.container .ui.one.cards > .card {
  width: 100%;
}
.kb-labfront.container .ui.two.cards {
  margin-left: -1em;
  margin-right: -1em;
}
.kb-labfront.container .ui.two.cards > .card {
  width: calc(50% - 2em);
  margin-left: 1em;
  margin-right: 1em;
}
.kb-labfront.container .ui.three.cards {
  margin-left: -1em;
  margin-right: -1em;
}
.kb-labfront.container .ui.three.cards > .card {
  width: calc(33.3333333333% - 2em);
  margin-left: 1em;
  margin-right: 1em;
}
.kb-labfront.container .ui.four.cards {
  margin-left: -0.75em;
  margin-right: -0.75em;
}
.kb-labfront.container .ui.four.cards > .card {
  width: calc(25% - 1.5em);
  margin-left: 0.75em;
  margin-right: 0.75em;
}
.kb-labfront.container .ui.five.cards {
  margin-left: -0.75em;
  margin-right: -0.75em;
}
.kb-labfront.container .ui.five.cards > .card {
  width: calc(20% - 1.5em);
  margin-left: 0.75em;
  margin-right: 0.75em;
}
.kb-labfront.container .ui.six.cards {
  margin-left: -0.75em;
  margin-right: -0.75em;
}
.kb-labfront.container .ui.six.cards > .card {
  width: calc(16.6666666667% - 1.5em);
  margin-left: 0.75em;
  margin-right: 0.75em;
}
.kb-labfront.container .ui.seven.cards {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.kb-labfront.container .ui.seven.cards > .card {
  width: calc(14.2857142857% - 1em);
  margin-left: 0.5em;
  margin-right: 0.5em;
}
.kb-labfront.container .ui.eight.cards {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.kb-labfront.container .ui.eight.cards > .card {
  width: calc(12.5% - 1em);
  margin-left: 0.5em;
  margin-right: 0.5em;
  font-size: 11px;
}
.kb-labfront.container .ui.nine.cards {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.kb-labfront.container .ui.nine.cards > .card {
  width: calc(11.1111111111% - 1em);
  margin-left: 0.5em;
  margin-right: 0.5em;
  font-size: 10px;
}
.kb-labfront.container .ui.ten.cards {
  margin-left: -0.5em;
  margin-right: -0.5em;
}
.kb-labfront.container .ui.ten.cards > .card {
  width: calc(10% - 1em);
  margin-left: 0.5em;
  margin-right: 0.5em;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.two.doubling.cards {
    margin-left: 0;
    margin-right: 0;
  }
  .kb-labfront.container .ui.two.doubling.cards > .card {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
  .kb-labfront.container .ui.three.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.three.doubling.cards > .card {
    width: calc(50% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.four.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.four.doubling.cards > .card {
    width: calc(50% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.five.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.five.doubling.cards > .card {
    width: calc(50% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.six.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.six.doubling.cards > .card {
    width: calc(50% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.seven.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.seven.doubling.cards > .card {
    width: calc(33.3333333333% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.eight.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.eight.doubling.cards > .card {
    width: calc(33.3333333333% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.nine.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.nine.doubling.cards > .card {
    width: calc(33.3333333333% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.ten.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.ten.doubling.cards > .card {
    width: calc(33.3333333333% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .kb-labfront.container .ui.two.doubling.cards {
    margin-left: 0;
    margin-right: 0;
  }
  .kb-labfront.container .ui.two.doubling.cards > .card {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
  .kb-labfront.container .ui.three.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.three.doubling.cards > .card {
    width: calc(50% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.four.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.four.doubling.cards > .card {
    width: calc(50% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.five.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.five.doubling.cards > .card {
    width: calc(33.3333333333% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.six.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.six.doubling.cards > .card {
    width: calc(33.3333333333% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.eight.doubling.cards {
    margin-left: -1em;
    margin-right: -1em;
  }
  .kb-labfront.container .ui.eight.doubling.cards > .card {
    width: calc(33.3333333333% - 2em);
    margin-left: 1em;
    margin-right: 1em;
  }
  .kb-labfront.container .ui.eight.doubling.cards {
    margin-left: -0.75em;
    margin-right: -0.75em;
  }
  .kb-labfront.container .ui.eight.doubling.cards > .card {
    width: calc(25% - 1.5em);
    margin-left: 0.75em;
    margin-right: 0.75em;
  }
  .kb-labfront.container .ui.nine.doubling.cards {
    margin-left: -0.75em;
    margin-right: -0.75em;
  }
  .kb-labfront.container .ui.nine.doubling.cards > .card {
    width: calc(25% - 1.5em);
    margin-left: 0.75em;
    margin-right: 0.75em;
  }
  .kb-labfront.container .ui.ten.doubling.cards {
    margin-left: -0.75em;
    margin-right: -0.75em;
  }
  .kb-labfront.container .ui.ten.doubling.cards > .card {
    width: calc(20% - 1.5em);
    margin-left: 0.75em;
    margin-right: 0.75em;
  }
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.stackable.cards {
    display: block !important;
  }
  .kb-labfront.container .ui.stackable.cards .card:first-child {
    margin-top: 0 !important;
  }
  .kb-labfront.container .ui.stackable.cards > .card {
    display: block !important;
    height: auto !important;
    margin: 1em 1em;
    padding: 0 !important;
    width: calc(100% - 2em) !important;
  }
}
.kb-labfront.container .ui.cards > .card {
  font-size: 1em;
}
.kb-labfront.container .ui.inverted.cards > .card,
.kb-labfront.container .ui.inverted.card {
  background: #1b1c1d;
  box-shadow: 0 1px 3px 0 #555555, 0 0 0 1px #555555;
}
.kb-labfront.container .ui.inverted.cards > .card > .content,
.kb-labfront.container .ui.inverted.card > .content {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.kb-labfront.container .ui.inverted.cards > .card > .content > .header,
.kb-labfront.container .ui.inverted.card > .content > .header {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.cards > .card > .content > .description,
.kb-labfront.container .ui.inverted.card > .content > .description {
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.cards > .card .meta,
.kb-labfront.container .ui.inverted.card .meta {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.cards > .card .meta > a:not(.ui),
.kb-labfront.container .ui.inverted.card .meta > a:not(.ui) {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.cards > .card .meta > a:not(.ui):hover,
.kb-labfront.container .ui.inverted.card .meta > a:not(.ui):hover {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.cards > .card > .extra,
.kb-labfront.container .ui.inverted.card > .extra {
  border-top: 1px solid rgba(255, 255, 255, 0.15) !important;
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.cards > .card > .extra a:not(.ui),
.kb-labfront.container .ui.inverted.card > .extra a:not(.ui) {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.inverted.cards > .card > .extra a:not(.ui):hover,
.kb-labfront.container .ui.inverted.card > .extra a:not(.ui):hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.inverted.cards a.card:hover,
.kb-labfront.container .ui.inverted.link.cards .card:not(.icon):hover,
.kb-labfront.container a.inverted.ui.card:hover,
.kb-labfront.container .ui.inverted.link.card:hover {
  background: #1b1c1d;
}
.kb-labfront.container .ui.comments {
  margin: 1.5em 0;
  max-width: 650px;
}
.kb-labfront.container .ui.comments:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.comments:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.comments .comment {
  position: relative;
  background: none;
  margin: 0.5em 0 0;
  padding: 0.5em 0 0;
  border: none;
  border-top: none;
  line-height: 1.2;
}
.kb-labfront.container .ui.comments .comment:first-child {
  margin-top: 0;
  padding-top: 0;
}
.kb-labfront.container .ui.comments .comment > .comments {
  margin: 0 0 0.5em 0.5em;
  padding: 1em 0 1em 1em;
}
.kb-labfront.container .ui.comments .comment > .comments:before {
  position: absolute;
  top: 0;
  left: 0;
}
.kb-labfront.container .ui.comments .comment > .comments .comment {
  border: none;
  border-top: none;
  background: none;
}
.kb-labfront.container .ui.comments .comment .avatar {
  display: block;
  width: 2.5em;
  height: auto;
  float: left;
  margin: 0.2em 0 0;
}
.kb-labfront.container .ui.comments .comment img.avatar,
.kb-labfront.container .ui.comments .comment .avatar img {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  border-radius: 0.25rem;
}
.kb-labfront.container .ui.comments .comment > .content {
  display: block;
}
.kb-labfront.container .ui.comments .comment > .avatar ~ .content {
  margin-left: 3.5em;
}
.kb-labfront.container .ui.comments .comment .author {
  font-size: 1em;
  color: rgba(0, 0, 0, 0.87);
  font-weight: bold;
}
.kb-labfront.container .ui.comments .comment a.author {
  cursor: pointer;
}
.kb-labfront.container .ui.comments .comment a.author:hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.comments .comment .metadata {
  display: inline-block;
  margin-left: 0.5em;
  color: rgba(0, 0, 0, 0.4);
  font-size: 0.875em;
}
.kb-labfront.container .ui.comments .comment .metadata > * {
  display: inline-block;
  margin: 0 0.5em 0 0;
}
.kb-labfront.container .ui.comments .comment .metadata > :last-child {
  margin-right: 0;
}
.kb-labfront.container .ui.comments .comment .text {
  margin: 0.25em 0 0.5em;
  font-size: 1em;
  word-wrap: break-word;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.3;
}
.kb-labfront.container .ui.comments .comment .actions {
  font-size: 0.875em;
}
.kb-labfront.container .ui.comments .comment .actions a {
  cursor: pointer;
  display: inline-block;
  margin: 0 0.75em 0 0;
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.comments .comment .actions a:last-child {
  margin-right: 0;
}
.kb-labfront.container .ui.comments .comment .actions a.active,
.kb-labfront.container .ui.comments .comment .actions a:hover {
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.comments > .reply.form {
  margin-top: 1em;
}
.kb-labfront.container .ui.comments .comment .reply.form {
  width: 100%;
  margin-top: 1em;
}
.kb-labfront.container .ui.comments .reply.form textarea {
  font-size: 1em;
  height: 12em;
}
.kb-labfront.container .ui.collapsed.comments,
.kb-labfront.container .ui.comments .collapsed.comments,
.kb-labfront.container .ui.comments .collapsed.comment {
  display: none;
}
.kb-labfront.container .ui.threaded.comments .comment > .comments {
  margin: -1.5em 0 -1em 1.25em;
  padding: 3em 0 2em 2.25em;
  box-shadow: -1px 0 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.minimal.comments .comment .actions {
  opacity: 0;
  position: absolute;
  top: 0;
  right: 0;
  left: auto;
  transition: opacity 0.2s ease;
  transition-delay: 0.1s;
}
.kb-labfront.container .ui.minimal.comments .comment > .content:hover > .actions {
  opacity: 1;
}
.kb-labfront.container .ui.mini.comments {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.comments {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.comments {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.comments {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.comments {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.comments {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.comments {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.comments {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.inverted.comments .comment {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.comments .comment .author,
.kb-labfront.container .ui.inverted.comments .comment .text {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.comments .comment .metadata,
.kb-labfront.container .ui.inverted.comments .comment .actions a {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.comments .comment a.author:hover,
.kb-labfront.container .ui.inverted.comments .comment .actions a.active,
.kb-labfront.container .ui.inverted.comments .comment .actions a:hover {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.threaded.comments .comment > .comments {
  box-shadow: -1px 0 0 #555555;
}
.kb-labfront.container .ui.feed {
  margin: 1em 0;
}
.kb-labfront.container .ui.feed:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.feed:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.feed > .event {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0.2142857143rem 0;
  margin: 0;
  background: none;
  border-top: none;
}
.kb-labfront.container .ui.feed > .event:first-child {
  border-top: 0;
  padding-top: 0;
}
.kb-labfront.container .ui.feed > .event:last-child {
  padding-bottom: 0;
}
.kb-labfront.container .ui.feed > .event > .label {
  display: block;
  flex: 0 0 auto;
  width: 2.5em;
  height: auto;
  align-self: stretch;
  text-align: left;
}
.kb-labfront.container .ui.feed > .event > .label .icon {
  opacity: 1;
  font-size: 1.5em;
  width: 100%;
  padding: 0.25em;
  background: none;
  border: none;
  border-radius: none;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.feed > .event > .label img {
  width: 100%;
  height: auto;
  border-radius: 500rem;
}
.kb-labfront.container .ui.feed > .event > .label + .content {
  margin: 0.5em 0 0.3571428571em 1.1428571429em;
}
.kb-labfront.container .ui.feed > .event > .content {
  display: block;
  flex: 1 1 auto;
  align-self: stretch;
  text-align: left;
  word-wrap: break-word;
}
.kb-labfront.container .ui.feed > .event:last-child > .content {
  padding-bottom: 0;
}
.kb-labfront.container .ui.feed > .event > .content a {
  cursor: pointer;
}
.kb-labfront.container .ui.feed > .event > .content .date {
  margin: -0.5rem 0 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.4);
  font-weight: normal;
  font-size: 1em;
  font-style: normal;
}
.kb-labfront.container .ui.feed > .event > .content .summary {
  margin: 0;
  font-size: 1em;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.feed > .event > .content .summary img {
  display: inline-block;
  width: auto;
  height: 10em;
  margin: -0.25em 0.25em 0 0;
  border-radius: 0.25em;
  vertical-align: middle;
}
.kb-labfront.container .ui.feed > .event > .content .user {
  display: inline-block;
  font-weight: bold;
  margin-right: 0;
  vertical-align: baseline;
}
.kb-labfront.container .ui.feed > .event > .content .user img {
  margin: -0.25em 0.25em 0 0;
  width: auto;
  height: 10em;
  vertical-align: middle;
}
.kb-labfront.container .ui.feed > .event > .content .summary > .date {
  display: inline-block;
  float: none;
  font-weight: normal;
  font-size: 0.8571428571em;
  font-style: normal;
  margin: 0 0 0 0.5em;
  padding: 0;
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.feed > .event > .content .extra {
  margin: 0.5em 0 0;
  background: none;
  padding: 0;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.feed > .event > .content .extra.images img {
  display: inline-block;
  margin: 0 0.25em 0 0;
  width: 6em;
}
.kb-labfront.container .ui.feed > .event > .content .extra.text {
  padding: 0;
  border-left: none;
  font-size: 1em;
  max-width: 500px;
  line-height: 1.4285em;
}
.kb-labfront.container .ui.feed > .event > .content .meta {
  display: inline-block;
  font-size: 0.8571428571em;
  margin: 0.5em 0 0;
  background: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.feed > .event > .content .meta > * {
  position: relative;
  margin-left: 0.75em;
}
.kb-labfront.container .ui.feed > .event > .content .meta > *:after {
  content: "";
  color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: -1em;
  opacity: 1;
  position: absolute;
  vertical-align: top;
}
.kb-labfront.container .ui.feed > .event > .content .meta .like {
  color: "";
  transition: 0.2s color ease;
}
.kb-labfront.container .ui.feed > .event > .content .meta .like:hover .icon {
  color: #FF2733;
}
.kb-labfront.container .ui.feed > .event > .content .meta .active.like .icon {
  color: #EF404A;
}
.kb-labfront.container .ui.feed > .event > .content .meta > :first-child {
  margin-left: 0;
}
.kb-labfront.container .ui.feed > .event > .content .meta > :first-child::after {
  display: none;
}
.kb-labfront.container .ui.feed > .event > .content .meta a,
.kb-labfront.container .ui.feed > .event > .content .meta > .icon {
  cursor: pointer;
  opacity: 1;
  color: rgba(0, 0, 0, 0.5);
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.feed > .event > .content .meta a:hover,
.kb-labfront.container .ui.feed > .event > .content .meta a:hover .icon,
.kb-labfront.container .ui.feed > .event > .content .meta > .icon:hover {
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.small.feed {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.feed {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.feed {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.inverted.feed > .event {
  background: #1b1c1d;
}
.kb-labfront.container .ui.inverted.feed > .event > .content .date,
.kb-labfront.container .ui.inverted.feed > .event > .content .meta .like {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.feed > .event > .content .summary,
.kb-labfront.container .ui.inverted.feed > .event > .content .extra.text {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.feed > .event > .content .meta .like:hover {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.items > .item {
  display: flex;
  margin: 1em 0;
  width: 100%;
  min-height: 0;
  background: transparent;
  padding: 0;
  border: none;
  border-radius: 0;
  box-shadow: none;
  transition: box-shadow 0.1s ease;
  z-index: "";
}
.kb-labfront.container .ui.items > .item a {
  cursor: pointer;
}
.kb-labfront.container .ui.items {
  margin: 1.5em 0;
}
.kb-labfront.container .ui.items:first-child {
  margin-top: 0 !important;
}
.kb-labfront.container .ui.items:last-child {
  margin-bottom: 0 !important;
}
.kb-labfront.container .ui.items > .item:after {
  display: block;
  content: " ";
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.kb-labfront.container .ui.items > .item:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.items > .item:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.items > .item > .image {
  position: relative;
  flex: 0 0 auto;
  display: block;
  float: none;
  margin: 0;
  padding: 0;
  max-height: "";
  align-self: start;
}
.kb-labfront.container .ui.items > .item > .image > img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 0.125rem;
  border: none;
}
.kb-labfront.container .ui.items > .item > .image:only-child > img {
  border-radius: 0;
}
.kb-labfront.container .ui.items > .item > .content {
  display: block;
  flex: 1 1 auto;
  background: none;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
  padding: 0;
  box-shadow: none;
  font-size: 1em;
  border: none;
  border-radius: 0;
}
.kb-labfront.container .ui.items > .item > .content:after {
  display: block;
  content: " ";
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.kb-labfront.container .ui.items > .item > .image + .content {
  min-width: 0;
  width: auto;
  display: block;
  margin-left: 0;
  align-self: start;
  padding-left: 1.5em;
}
.kb-labfront.container .ui.items > .item > .content > .header {
  display: inline-block;
  margin: -0.21425em 0 0;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.items > .item > .content > .header:not(.ui) {
  font-size: 1.2857142857em;
}
.kb-labfront.container .ui.items > .item [class*="left floated"] {
  float: left;
}
.kb-labfront.container .ui.items > .item [class*="right floated"] {
  float: right;
}
.kb-labfront.container .ui.items > .item .content img {
  align-self: center;
  width: "";
}
.kb-labfront.container .ui.items > .item img.avatar,
.kb-labfront.container .ui.items > .item .avatar img {
  width: "";
  height: "";
  border-radius: 500rem;
}
.kb-labfront.container .ui.items > .item > .content > .description {
  margin-top: 0.6em;
  max-width: auto;
  font-size: 1em;
  line-height: 1.4285em;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.items > .item > .content p {
  margin: 0 0 0.5em;
}
.kb-labfront.container .ui.items > .item > .content p:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.items > .item .meta {
  margin: 0.5em 0 0.5em;
  font-size: 1em;
  line-height: 1em;
  color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .ui.items > .item .meta * {
  margin-right: 0.3em;
}
.kb-labfront.container .ui.items > .item .meta :last-child {
  margin-right: 0;
}
.kb-labfront.container .ui.items > .item .meta [class*="right floated"] {
  margin-right: 0;
  margin-left: 0.3em;
}
.kb-labfront.container .ui.items > .item > .content a:not(.ui) {
  color: "";
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.items > .item > .content a:not(.ui):hover {
  color: "";
}
.kb-labfront.container .ui.items > .item > .content > a.header {
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.items > .item > .content > a.header:hover {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.items > .item .meta > a:not(.ui) {
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.items > .item .meta > a:not(.ui):hover {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.items > .item > .content .favorite.icon {
  cursor: pointer;
  opacity: 0.75;
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.items > .item > .content .favorite.icon:hover {
  opacity: 1;
  color: #FFB70A;
}
.kb-labfront.container .ui.items > .item > .content .active.favorite.icon {
  color: #FFE623;
}
.kb-labfront.container .ui.items > .item > .content .like.icon {
  cursor: pointer;
  opacity: 0.75;
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.items > .item > .content .like.icon:hover {
  opacity: 1;
  color: #FF2733;
}
.kb-labfront.container .ui.items > .item > .content .active.like.icon {
  color: #FF2733;
}
.kb-labfront.container .ui.items > .item .extra {
  display: block;
  position: relative;
  background: none;
  margin: 0.5rem 0 0;
  width: 100%;
  padding: 0 0 0;
  top: 0;
  left: 0;
  color: rgba(0, 0, 0, 0.4);
  box-shadow: none;
  transition: color 0.1s ease;
  border-top: none;
}
.kb-labfront.container .ui.items > .item .extra > * {
  margin: 0.25rem 0.5rem 0.25rem 0;
}
.kb-labfront.container .ui.items > .item .extra > [class*="right floated"] {
  margin: 0.25rem 0 0.25rem 0.5rem;
}
.kb-labfront.container .ui.items > .item .extra:after {
  display: block;
  content: " ";
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.kb-labfront.container .ui.items > .item > .image:not(.ui) {
  width: 175px;
}
@media only screen and (min-width: 768px) and (max-width: 991.98px) {
  .kb-labfront.container .ui.items > .item {
    margin: 1em 0;
  }
  .kb-labfront.container .ui.items > .item > .image:not(.ui) {
    width: 150px;
  }
  .kb-labfront.container .ui.items > .item > .image + .content {
    display: block;
    padding: 0 0 0 1em;
  }
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.items:not(.unstackable) > .item {
    flex-direction: column;
    margin: 2em 0;
  }
  .kb-labfront.container .ui.items:not(.unstackable) > .item > .image {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .kb-labfront.container .ui.items:not(.unstackable) > .item > .image,
  .kb-labfront.container .ui.items:not(.unstackable) > .item > .image > img {
    max-width: 100% !important;
    width: auto !important;
    max-height: 250px !important;
  }
  .kb-labfront.container .ui.items:not(.unstackable) > .item > .image + .content {
    display: block;
    padding: 1.5em 0 0;
  }
}
.kb-labfront.container .ui.items > .item > .image + [class*="top aligned"].content {
  align-self: flex-start;
}
.kb-labfront.container .ui.items > .item > .image + [class*="middle aligned"].content {
  align-self: center;
}
.kb-labfront.container .ui.items > .item > .image + [class*="bottom aligned"].content {
  align-self: flex-end;
}
.kb-labfront.container .ui.relaxed.items > .item {
  margin: 1.5em 0;
}
.kb-labfront.container .ui[class*="very relaxed"].items > .item {
  margin: 2em 0;
}
.kb-labfront.container .ui.divided.items > .item {
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  margin: 0;
  padding: 1em 0;
}
.kb-labfront.container .ui.divided.items > .item:first-child {
  border-top: none;
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.kb-labfront.container .ui.divided.items > .item:last-child {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
.kb-labfront.container .ui.relaxed.divided.items > .item {
  margin: 0;
  padding: 1.5em 0;
}
.kb-labfront.container .ui[class*="very relaxed"].divided.items > .item {
  margin: 0;
  padding: 2em 0;
}
.kb-labfront.container .ui.items a.item:hover,
.kb-labfront.container .ui.link.items > .item:hover {
  cursor: pointer;
}
.kb-labfront.container .ui.items a.item:hover .content .header,
.kb-labfront.container .ui.link.items > .item:hover .content .header {
  color: rgb(25.2668674699, 92.7613216224, 159.2331325301);
}
.kb-labfront.container .ui.items > .item {
  font-size: 1em;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.unstackable.items > .item > .image,
  .kb-labfront.container .ui.unstackable.items > .item > .image > img {
    width: 125px !important;
  }
}
.kb-labfront.container .ui.inverted.items > .item {
  background: transparent;
}
.kb-labfront.container .ui.inverted.items > .item > .content {
  background: none;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.items > .item .extra {
  background: none;
}
.kb-labfront.container .ui.inverted.items > .item > .content > .header {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.items > .item > .content > .description {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.items > .item .meta {
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.items > .item > .content a:not(.ui) {
  color: rgb(144.0641566265, 194.633098041, 244.4358433735);
}
.kb-labfront.container .ui.inverted.items > .item > .content a:not(.ui):hover {
  color: #4183c4;
}
.kb-labfront.container .ui.inverted.items > .item > .content > a.header {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.items > .item > .content > a.header:hover {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.items > .item .meta > a:not(.ui) {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.items > .item .meta > a:not(.ui):hover {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.items > .item > .content .favorite.icon:hover {
  color: rgb(255, 197.987755102, 61);
}
.kb-labfront.container .ui.inverted.items > .item > .content .active.favorite.icon {
  color: rgb(255, 235.7954545455, 86);
}
.kb-labfront.container .ui.inverted.items > .item > .content .like.icon:hover {
  color: rgb(255, 90, 99.1666666667);
}
.kb-labfront.container .ui.inverted.items > .item > .content .active.like.icon {
  color: rgb(255, 90, 99.1666666667);
}
.kb-labfront.container .ui.inverted.items > .item .extra {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.items a.item:hover .content .header,
.kb-labfront.container .ui.inverted.link.items > .item:hover .content .header {
  color: rgb(255, 255, 255);
}
.kb-labfront.container .ui.inverted.divided.items > .item {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.inverted.divided.items > .item:first-child {
  border-top: none;
}
.kb-labfront.container .ui.statistic {
  display: inline-flex;
  flex-direction: column;
  margin: 1em 0;
  max-width: none;
}
.kb-labfront.container .ui.statistic + .ui.statistic {
  margin: 0 0 0 1.5em;
}
.kb-labfront.container .ui.statistic:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.statistic:last-child {
  margin-bottom: 0;
}
.kb-labfront.container .ui.statistics {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.kb-labfront.container .ui.statistics > .statistic {
  display: inline-flex;
  flex: 0 1 auto;
  flex-direction: column;
  margin: 0 1.5em 1em;
  max-width: none;
}
.kb-labfront.container .ui.statistics {
  display: flex;
  margin: 1em -1.5em -1em;
}
.kb-labfront.container .ui.statistics:after {
  display: block;
  content: " ";
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.kb-labfront.container .ui.statistics:first-child {
  margin-top: 0;
}
.kb-labfront.container .ui.statistics .statistic > .value,
.kb-labfront.container .ui.statistic > .value {
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 4rem;
  font-weight: normal;
  line-height: 1em;
  color: #1b1c1d;
  text-transform: uppercase;
  text-align: center;
}
.kb-labfront.container .ui.statistics .statistic > .label,
.kb-labfront.container .ui.statistic > .label {
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 1em;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.87);
  text-transform: uppercase;
  text-align: center;
}
.kb-labfront.container .ui.statistics .statistic > .label ~ .value,
.kb-labfront.container .ui.statistic > .label ~ .value {
  margin-top: 0;
}
.kb-labfront.container .ui.statistics .statistic > .value ~ .label,
.kb-labfront.container .ui.statistic > .value ~ .label {
  margin-top: 0;
}
.kb-labfront.container .ui.statistics .statistic > .value .icon,
.kb-labfront.container .ui.statistic > .value .icon {
  opacity: 1;
  width: auto;
  margin: 0;
}
.kb-labfront.container .ui.statistics .statistic > .text.value,
.kb-labfront.container .ui.statistic > .text.value {
  line-height: 1em;
  min-height: 2em;
  font-weight: bold;
  text-align: center;
}
.kb-labfront.container .ui.statistics .statistic > .text.value + .label,
.kb-labfront.container .ui.statistic > .text.value + .label {
  text-align: center;
}
.kb-labfront.container .ui.statistics .statistic > .value img,
.kb-labfront.container .ui.statistic > .value img {
  max-height: 3rem;
  vertical-align: baseline;
}
.kb-labfront.container .ui.ten.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.ten.statistics .statistic {
  min-width: 10%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.nine.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.nine.statistics .statistic {
  min-width: 11.1111111111%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.eight.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.eight.statistics .statistic {
  min-width: 12.5%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.seven.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.seven.statistics .statistic {
  min-width: 14.2857142857%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.six.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.six.statistics .statistic {
  min-width: 16.6666666667%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.five.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.five.statistics .statistic {
  min-width: 20%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.four.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.four.statistics .statistic {
  min-width: 25%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.three.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.three.statistics .statistic {
  min-width: 33.3333333333%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.two.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.two.statistics .statistic {
  min-width: 50%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.one.statistics {
  margin: 0 0 -1em;
}
.kb-labfront.container .ui.one.statistics .statistic {
  min-width: 100%;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.horizontal.statistic {
  flex-direction: row;
  align-items: center;
}
.kb-labfront.container .ui.horizontal.statistics {
  flex-direction: column;
  margin: 0;
  max-width: none;
}
.kb-labfront.container .ui.horizontal.statistics .statistic {
  flex-direction: row;
  align-items: center;
  max-width: none;
  margin: 1em 0;
}
.kb-labfront.container .ui.horizontal.statistic > .text.value,
.kb-labfront.container .ui.horizontal.statistics > .statistic > .text.value {
  min-height: 0 !important;
}
.kb-labfront.container .ui.horizontal.statistics .statistic > .value .icon,
.kb-labfront.container .ui.horizontal.statistic > .value .icon {
  width: 1.18em;
}
.kb-labfront.container .ui.horizontal.statistics .statistic > .value,
.kb-labfront.container .ui.horizontal.statistic > .value {
  display: inline-block;
  vertical-align: middle;
}
.kb-labfront.container .ui.horizontal.statistics .statistic > .label,
.kb-labfront.container .ui.horizontal.statistic > .label {
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 0.75em;
}
.kb-labfront.container .ui.inverted.statistics .statistic > .value,
.kb-labfront.container .ui.inverted.statistic .value {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.statistics .statistic > .label,
.kb-labfront.container .ui.inverted.statistic .label {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.primary.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .primary.statistic > .value,
.kb-labfront.container .ui.primary.statistic > .value {
  color: #2185d0;
}
.kb-labfront.container .ui.inverted.primary.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.primary.statistic > .value,
.kb-labfront.container .ui.inverted.primary.statistic > .value {
  color: #54c8ff;
}
.kb-labfront.container .ui.secondary.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .secondary.statistic > .value,
.kb-labfront.container .ui.secondary.statistic > .value {
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.secondary.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.secondary.statistic > .value,
.kb-labfront.container .ui.inverted.secondary.statistic > .value {
  color: #545454;
}
.kb-labfront.container .ui.red.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .red.statistic > .value,
.kb-labfront.container .ui.red.statistic > .value {
  color: #db2828;
}
.kb-labfront.container .ui.inverted.red.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.red.statistic > .value,
.kb-labfront.container .ui.inverted.red.statistic > .value {
  color: #ff695e;
}
.kb-labfront.container .ui.orange.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .orange.statistic > .value,
.kb-labfront.container .ui.orange.statistic > .value {
  color: #f2711c;
}
.kb-labfront.container .ui.inverted.orange.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.orange.statistic > .value,
.kb-labfront.container .ui.inverted.orange.statistic > .value {
  color: #ff851b;
}
.kb-labfront.container .ui.yellow.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .yellow.statistic > .value,
.kb-labfront.container .ui.yellow.statistic > .value {
  color: #fbbd08;
}
.kb-labfront.container .ui.inverted.yellow.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.yellow.statistic > .value,
.kb-labfront.container .ui.inverted.yellow.statistic > .value {
  color: #ffe21f;
}
.kb-labfront.container .ui.olive.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .olive.statistic > .value,
.kb-labfront.container .ui.olive.statistic > .value {
  color: #b5cc18;
}
.kb-labfront.container .ui.inverted.olive.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.olive.statistic > .value,
.kb-labfront.container .ui.inverted.olive.statistic > .value {
  color: #d9e778;
}
.kb-labfront.container .ui.green.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .green.statistic > .value,
.kb-labfront.container .ui.green.statistic > .value {
  color: #21ba45;
}
.kb-labfront.container .ui.inverted.green.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.green.statistic > .value,
.kb-labfront.container .ui.inverted.green.statistic > .value {
  color: #2ecc40;
}
.kb-labfront.container .ui.teal.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .teal.statistic > .value,
.kb-labfront.container .ui.teal.statistic > .value {
  color: #00b5ad;
}
.kb-labfront.container .ui.inverted.teal.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.teal.statistic > .value,
.kb-labfront.container .ui.inverted.teal.statistic > .value {
  color: #6dffff;
}
.kb-labfront.container .ui.blue.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .blue.statistic > .value,
.kb-labfront.container .ui.blue.statistic > .value {
  color: #2185d0;
}
.kb-labfront.container .ui.inverted.blue.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.blue.statistic > .value,
.kb-labfront.container .ui.inverted.blue.statistic > .value {
  color: #54c8ff;
}
.kb-labfront.container .ui.violet.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .violet.statistic > .value,
.kb-labfront.container .ui.violet.statistic > .value {
  color: #6435c9;
}
.kb-labfront.container .ui.inverted.violet.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.violet.statistic > .value,
.kb-labfront.container .ui.inverted.violet.statistic > .value {
  color: #a291fb;
}
.kb-labfront.container .ui.purple.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .purple.statistic > .value,
.kb-labfront.container .ui.purple.statistic > .value {
  color: #a333c8;
}
.kb-labfront.container .ui.inverted.purple.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.purple.statistic > .value,
.kb-labfront.container .ui.inverted.purple.statistic > .value {
  color: #dc73ff;
}
.kb-labfront.container .ui.pink.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .pink.statistic > .value,
.kb-labfront.container .ui.pink.statistic > .value {
  color: #e03997;
}
.kb-labfront.container .ui.inverted.pink.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.pink.statistic > .value,
.kb-labfront.container .ui.inverted.pink.statistic > .value {
  color: #ff8edf;
}
.kb-labfront.container .ui.brown.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .brown.statistic > .value,
.kb-labfront.container .ui.brown.statistic > .value {
  color: #a5673f;
}
.kb-labfront.container .ui.inverted.brown.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.brown.statistic > .value,
.kb-labfront.container .ui.inverted.brown.statistic > .value {
  color: #d67c1c;
}
.kb-labfront.container .ui.grey.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .grey.statistic > .value,
.kb-labfront.container .ui.grey.statistic > .value {
  color: #767676;
}
.kb-labfront.container .ui.inverted.grey.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.grey.statistic > .value,
.kb-labfront.container .ui.inverted.grey.statistic > .value {
  color: #dcddde;
}
.kb-labfront.container .ui.black.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .black.statistic > .value,
.kb-labfront.container .ui.black.statistic > .value {
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.black.statistics .statistic > .value,
.kb-labfront.container .ui.statistics .inverted.black.statistic > .value,
.kb-labfront.container .ui.inverted.black.statistic > .value {
  color: #545454;
}
.kb-labfront.container .ui[class*="left floated"].statistic {
  float: left;
  margin: 0 2em 1em 0;
}
.kb-labfront.container .ui[class*="right floated"].statistic {
  float: right;
  margin: 0 0 1em 2em;
}
.kb-labfront.container .ui.floated.statistic:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.stackable.statistics {
    width: auto;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .kb-labfront.container .ui.stackable.statistics > .statistic {
    width: 100% !important;
    margin: 0 0 !important;
    padding: 1rem 1rem !important;
  }
}
.kb-labfront.container .ui.mini.statistics .statistic > .value,
.kb-labfront.container .ui.mini.statistic > .value {
  font-size: 1.5rem !important;
}
.kb-labfront.container .ui.mini.horizontal.statistics .statistic > .value,
.kb-labfront.container .ui.mini.horizontal.statistic > .value {
  font-size: 1.5rem !important;
}
.kb-labfront.container .ui.mini.statistics .statistic > .text.value,
.kb-labfront.container .ui.mini.statistic > .text.value {
  font-size: 1rem !important;
}
.kb-labfront.container .ui.tiny.statistics .statistic > .value,
.kb-labfront.container .ui.tiny.statistic > .value {
  font-size: 2rem !important;
}
.kb-labfront.container .ui.tiny.horizontal.statistics .statistic > .value,
.kb-labfront.container .ui.tiny.horizontal.statistic > .value {
  font-size: 2rem !important;
}
.kb-labfront.container .ui.tiny.statistics .statistic > .text.value,
.kb-labfront.container .ui.tiny.statistic > .text.value {
  font-size: 1rem !important;
}
.kb-labfront.container .ui.small.statistics .statistic > .value,
.kb-labfront.container .ui.small.statistic > .value {
  font-size: 3rem !important;
}
.kb-labfront.container .ui.small.horizontal.statistics .statistic > .value,
.kb-labfront.container .ui.small.horizontal.statistic > .value {
  font-size: 2rem !important;
}
.kb-labfront.container .ui.small.statistics .statistic > .text.value,
.kb-labfront.container .ui.small.statistic > .text.value {
  font-size: 1rem !important;
}
.kb-labfront.container .ui.statistics .statistic > .value,
.kb-labfront.container .ui.statistic > .value {
  font-size: 4rem !important;
}
.kb-labfront.container .ui.horizontal.statistics .statistic > .value,
.kb-labfront.container .ui.horizontal.statistic > .value {
  font-size: 3rem !important;
}
.kb-labfront.container .ui.statistics .statistic > .text.value,
.kb-labfront.container .ui.statistic > .text.value {
  font-size: 2rem !important;
}
.kb-labfront.container .ui.large.statistics .statistic > .value,
.kb-labfront.container .ui.large.statistic > .value {
  font-size: 5rem !important;
}
.kb-labfront.container .ui.large.horizontal.statistics .statistic > .value,
.kb-labfront.container .ui.large.horizontal.statistic > .value {
  font-size: 4rem !important;
}
.kb-labfront.container .ui.large.statistics .statistic > .text.value,
.kb-labfront.container .ui.large.statistic > .text.value {
  font-size: 2.5rem !important;
}
.kb-labfront.container .ui.huge.statistics .statistic > .value,
.kb-labfront.container .ui.huge.statistic > .value {
  font-size: 6rem !important;
}
.kb-labfront.container .ui.huge.horizontal.statistics .statistic > .value,
.kb-labfront.container .ui.huge.horizontal.statistic > .value {
  font-size: 5rem !important;
}
.kb-labfront.container .ui.huge.statistics .statistic > .text.value,
.kb-labfront.container .ui.huge.statistic > .text.value {
  font-size: 2.5rem !important;
}
.kb-labfront.container .ui.accordion,
.kb-labfront.container .ui.accordion .accordion {
  max-width: 100%;
}
.kb-labfront.container .ui.accordion .accordion {
  margin: 1em 0 0;
  padding: 0;
}
.kb-labfront.container .ui.accordion .title,
.kb-labfront.container .ui.accordion .accordion .title {
  cursor: pointer;
}
.kb-labfront.container .ui.accordion .title:not(.ui) {
  padding: 0.5em 0;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.accordion:not(.styled) .title ~ .content:not(.ui),
.kb-labfront.container .ui.accordion:not(.styled) .accordion .title ~ .content:not(.ui) {
  margin: "";
  padding: 0.5em 0 1em;
}
.kb-labfront.container .ui.accordion:not(.styled) .title ~ .content:not(.ui):last-child {
  padding-bottom: 0;
}
.kb-labfront.container .ui.accordion .title .dropdown.icon,
.kb-labfront.container .ui.accordion .accordion .title .dropdown.icon {
  display: inline-block;
  float: none;
  opacity: 1;
  width: 1.25em;
  height: 1em;
  margin: 0 0.25rem 0 0;
  padding: 0;
  font-size: 1em;
  transition: transform 0.1s ease, opacity 0.1s ease;
  vertical-align: baseline;
  transform: none;
}
.kb-labfront.container .ui.accordion.menu .item .title {
  display: block;
  padding: 0;
}
.kb-labfront.container .ui.accordion.menu .item .title > .dropdown.icon {
  float: right;
  margin: 0.21425em 0 0 1em;
  transform: rotate(180deg);
}
.kb-labfront.container .ui.accordion .ui.header .dropdown.icon {
  font-size: 1em;
  margin: 0 0.25rem 0 0;
}
.kb-labfront.container .ui.accordion .active.title .dropdown.icon,
.kb-labfront.container .ui.accordion .accordion .active.title .dropdown.icon {
  transform: rotate(90deg);
}
.kb-labfront.container .ui.accordion.menu .item .active.title > .dropdown.icon {
  transform: rotate(90deg);
}
.kb-labfront.container .ui.styled.accordion {
  width: 600px;
}
.kb-labfront.container .ui.styled.accordion,
.kb-labfront.container .ui.styled.accordion .accordion {
  border-radius: 0.2857142857rem;
  background: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), 0 0 0 1px rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.styled.accordion .title,
.kb-labfront.container .ui.styled.accordion .accordion .title {
  margin: 0;
  padding: 0.75em 1em;
  color: rgba(0, 0, 0, 0.4);
  font-weight: bold;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  transition: background-color 0.1s ease;
}
.kb-labfront.container .ui.styled.accordion > .title:first-child,
.kb-labfront.container .ui.styled.accordion .accordion .title:first-child {
  border-top: none;
}
.kb-labfront.container .ui.styled.accordion .content,
.kb-labfront.container .ui.styled.accordion .accordion .content {
  margin: 0;
  padding: 0.5em 1em 1.5em;
}
.kb-labfront.container .ui.styled.accordion .accordion .content {
  margin: 0;
  padding: 0.5em 1em 1.5em;
}
.kb-labfront.container .ui.styled.accordion .title:hover,
.kb-labfront.container .ui.styled.accordion .active.title,
.kb-labfront.container .ui.styled.accordion .accordion .title:hover,
.kb-labfront.container .ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.styled.accordion .accordion .title:hover,
.kb-labfront.container .ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.styled.accordion .active.title {
  background: transparent;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.accordion .title ~ .content:not(.active),
.kb-labfront.container .ui.accordion .accordion .title ~ .content:not(.active) {
  display: none;
}
.kb-labfront.container .ui.fluid.accordion,
.kb-labfront.container .ui.fluid.accordion .accordion {
  width: 100%;
}
.kb-labfront.container .ui.inverted.accordion .title:not(.ui) {
  color: rgba(255, 255, 255, 0.9);
}
@font-face {
  font-family: "Accordion";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
.kb-labfront.container .ui.accordion .title .dropdown.icon,
.kb-labfront.container .ui.accordion .accordion .title .dropdown.icon {
  font-family: Accordion;
  line-height: 1;
  backface-visibility: hidden;
  font-weight: normal;
  font-style: normal;
  text-align: center;
}
.kb-labfront.container .ui.accordion .title .dropdown.icon:before,
.kb-labfront.container .ui.accordion .accordion .title .dropdown.icon:before {
  content: "\\f0da";
}
.kb-labfront.container .ui.calendar .ui.popup {
  max-width: none;
  padding: 0;
  border: none;
  user-select: none;
}
.kb-labfront.container .ui.calendar .calendar:focus {
  outline: 0;
}
.kb-labfront.container .ui.calendar .ui.popup .ui.grid {
  display: block;
  white-space: nowrap;
}
.kb-labfront.container .ui.calendar .ui.popup .ui.grid > .column {
  width: auto;
}
.kb-labfront.container .ui.calendar .ui.table.year,
.kb-labfront.container .ui.calendar .ui.table.month,
.kb-labfront.container .ui.calendar .ui.table.minute {
  min-width: 15em;
}
.kb-labfront.container .ui.calendar .ui.table.day {
  min-width: 18em;
}
.kb-labfront.container .ui.calendar .ui.table.day.andweek {
  min-width: 22em;
}
.kb-labfront.container .ui.calendar .ui.table.hour {
  min-width: 20em;
}
.kb-labfront.container .ui.calendar .ui.table tr th,
.kb-labfront.container .ui.calendar .ui.table tr td {
  padding: 0.5em;
  white-space: nowrap;
}
.kb-labfront.container .ui.calendar .ui.table tr th {
  border-left: none;
}
.kb-labfront.container .ui.calendar .ui.table tr th .icon {
  margin: 0;
}
.kb-labfront.container .ui.calendar .ui.table tr:first-child th {
  position: relative;
  padding-left: 0;
  padding-right: 0;
}
.kb-labfront.container .ui.calendar .ui.table.day tr:first-child th {
  border: none;
}
.kb-labfront.container .ui.calendar .ui.table.day tr:nth-child(2) th {
  padding-top: 0.2em;
  padding-bottom: 0.3em;
}
.kb-labfront.container .ui.calendar .ui.table tr td {
  padding-left: 0.1em;
  padding-right: 0.1em;
}
.kb-labfront.container .ui.calendar .ui.table tr .link {
  cursor: pointer;
}
.kb-labfront.container .ui.calendar .ui.table tr .prev.link {
  width: 14.28571429%;
  position: absolute;
  left: 0;
}
.kb-labfront.container .ui.calendar .ui.table tr .next.link {
  width: 14.28571429%;
  position: absolute;
  right: 0;
}
.kb-labfront.container .ui.calendar .ui.table tr .disabled {
  pointer-events: auto;
  cursor: default;
  color: rgba(0, 0, 0, 0.2);
}
.kb-labfront.container .ui.calendar .ui.table tr .adjacent:not(.disabled) {
  color: rgba(0, 0, 0, 0.6);
  background: rgba(0, 0, 0, 0.03);
}
.kb-labfront.container .ui.calendar .ui.table tr td.today {
  font-weight: bold;
}
.kb-labfront.container .ui.calendar .ui.table tr td.range {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
  box-shadow: none;
}
.kb-labfront.container .ui.calendar .ui.table.inverted tr td.range {
  background: rgba(255, 255, 255, 0.08);
  color: rgb(255, 255, 255);
  box-shadow: none;
}
.kb-labfront.container .ui.calendar:not(.disabled) .calendar:focus .ui.table tbody tr td.focus,
.kb-labfront.container .ui.calendar:not(.disabled) .calendar.active .ui.table tbody tr td.focus {
  box-shadow: inset 0 0 0 1px #85b7d9;
}
.kb-labfront.container .ui.calendar:not(.disabled) .calendar:focus .ui.table.inverted tbody tr td.focus,
.kb-labfront.container .ui.calendar:not(.disabled) .calendar.active .ui.table.inverted tbody tr td.focus {
  box-shadow: inset 0 0 0 1px #85b7d9;
}
.kb-labfront.container .ui.disabled.calendar {
  opacity: 0.45;
}
.kb-labfront.container .ui.disabled.calendar > .input,
.kb-labfront.container .ui.disabled.calendar .ui.table tr .link {
  pointer-events: none;
}
.kb-labfront.container .ui.checkbox {
  position: relative;
  display: inline-block;
  backface-visibility: hidden;
  outline: none;
  vertical-align: baseline;
  font-style: normal;
  min-height: 17px;
  font-size: 1em;
  line-height: 17px;
  min-width: 17px;
}
.kb-labfront.container .ui.checkbox input[type=checkbox],
.kb-labfront.container .ui.checkbox input[type=radio] {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0 !important;
  outline: none;
  z-index: 3;
  width: 17px;
  height: 17px;
}
.kb-labfront.container .ui.checkbox .box,
.kb-labfront.container .ui.checkbox label {
  cursor: auto;
  position: relative;
  display: block;
  padding-left: 1.85714em;
  outline: none;
  font-size: 1em;
}
.kb-labfront.container .ui.checkbox .box:before,
.kb-labfront.container .ui.checkbox label:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 17px;
  height: 17px;
  content: "";
  background: #ffffff;
  border-radius: 0.2142857143rem;
  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease;
  border: 1px solid #d4d4d5;
}
.kb-labfront.container .ui.checkbox .box:after,
.kb-labfront.container .ui.checkbox label:after {
  position: absolute;
  font-size: 14px;
  top: 0;
  left: 0;
  width: 17px;
  height: 17px;
  text-align: center;
  opacity: 0;
  color: rgba(0, 0, 0, 0.87);
  transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease, box-shadow 0.1s ease;
}
.kb-labfront.container .ui.checkbox label,
.kb-labfront.container .ui.checkbox + label {
  color: rgba(0, 0, 0, 0.87);
  transition: color 0.1s ease;
}
.kb-labfront.container .ui.checkbox + label {
  vertical-align: middle;
}
.kb-labfront.container .ui.checkbox .box:hover::before,
.kb-labfront.container .ui.checkbox label:hover::before {
  background: #ffffff;
  border-color: rgba(34, 36, 38, 0.35);
}
.kb-labfront.container .ui.checkbox label:hover,
.kb-labfront.container .ui.checkbox + label:hover {
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.checkbox .box:active::before,
.kb-labfront.container .ui.checkbox label:active::before {
  background: #f9fafb;
  border-color: rgba(34, 36, 38, 0.35);
}
.kb-labfront.container .ui.checkbox .box:active::after,
.kb-labfront.container .ui.checkbox label:active::after {
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.checkbox input:active ~ label {
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.checkbox input:focus ~ .box:before,
.kb-labfront.container .ui.checkbox input:focus ~ label:before {
  background: #ffffff;
  border-color: #96c8da;
}
.kb-labfront.container .ui.checkbox input:focus ~ .box:after,
.kb-labfront.container .ui.checkbox input:focus ~ label:after {
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.checkbox input:focus ~ label {
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.checkbox input:checked ~ .box:before,
.kb-labfront.container .ui.checkbox input:checked ~ label:before {
  background: #ffffff;
  border-color: rgba(34, 36, 38, 0.35);
}
.kb-labfront.container .ui.checkbox input:checked ~ .box:after,
.kb-labfront.container .ui.checkbox input:checked ~ label:after {
  opacity: 1;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.checkbox input:not([type=radio]):indeterminate ~ .box:before,
.kb-labfront.container .ui.checkbox input:not([type=radio]):indeterminate ~ label:before {
  background: #ffffff;
  border-color: rgba(34, 36, 38, 0.35);
}
.kb-labfront.container .ui.checkbox input:not([type=radio]):indeterminate ~ .box:after,
.kb-labfront.container .ui.checkbox input:not([type=radio]):indeterminate ~ label:after {
  opacity: 1;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.indeterminate.toggle.checkbox input:not([type=radio]):indeterminate ~ label:before {
  background: rgba(0, 0, 0, 0.15);
}
.kb-labfront.container .ui.indeterminate.toggle.checkbox input:not([type=radio]) ~ label:after {
  left: 1.075rem;
}
.kb-labfront.container .ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:before,
.kb-labfront.container .ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:before,
.kb-labfront.container .ui.checkbox input:checked:focus ~ .box:before,
.kb-labfront.container .ui.checkbox input:checked:focus ~ label:before {
  background: #ffffff;
  border-color: #96c8da;
}
.kb-labfront.container .ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:after,
.kb-labfront.container .ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:after,
.kb-labfront.container .ui.checkbox input:checked:focus ~ .box:after,
.kb-labfront.container .ui.checkbox input:checked:focus ~ label:after {
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.read-only.checkbox,
.kb-labfront.container .ui.read-only.checkbox label {
  cursor: default;
}
.kb-labfront.container .ui.disabled.checkbox .box:after,
.kb-labfront.container .ui.disabled.checkbox label,
.kb-labfront.container .ui.checkbox input[disabled] ~ .box:after,
.kb-labfront.container .ui.checkbox input[disabled] ~ label {
  cursor: default !important;
  opacity: 0.5;
  color: rgb(0, 0, 0);
}
.kb-labfront.container .ui.checkbox input.hidden {
  z-index: -1;
}
.kb-labfront.container .ui.checkbox input.hidden + label {
  cursor: pointer;
  user-select: none;
}
.kb-labfront.container .ui.radio.checkbox {
  min-height: 15px;
}
.kb-labfront.container .ui.radio.checkbox .box,
.kb-labfront.container .ui.radio.checkbox label {
  padding-left: 1.85714em;
}
.kb-labfront.container .ui.radio.checkbox .box:before,
.kb-labfront.container .ui.radio.checkbox label:before {
  content: "";
  transform: none;
  width: 15px;
  height: 15px;
  border-radius: 500rem;
  top: 1px;
  left: 0;
}
.kb-labfront.container .ui.radio.checkbox .box:after,
.kb-labfront.container .ui.radio.checkbox label:after {
  border: none;
  content: "" !important;
  width: 15px;
  height: 15px;
  line-height: 15px;
}
.kb-labfront.container .ui.radio.checkbox .box:after,
.kb-labfront.container .ui.radio.checkbox label:after {
  top: 1px;
  left: 0;
  width: 15px;
  height: 15px;
  border-radius: 500rem;
  transform: scale(0.4666666667);
  background-color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.radio.checkbox input:focus ~ .box:before,
.kb-labfront.container .ui.radio.checkbox input:focus ~ label:before {
  background-color: #ffffff;
}
.kb-labfront.container .ui.radio.checkbox input:focus ~ .box:after,
.kb-labfront.container .ui.radio.checkbox input:focus ~ label:after {
  background-color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.radio.checkbox input:indeterminate ~ .box:after,
.kb-labfront.container .ui.radio.checkbox input:indeterminate ~ label:after {
  opacity: 0;
}
.kb-labfront.container .ui.radio.checkbox input:checked ~ .box:before,
.kb-labfront.container .ui.radio.checkbox input:checked ~ label:before {
  background-color: #ffffff;
}
.kb-labfront.container .ui.radio.checkbox input:checked ~ .box:after,
.kb-labfront.container .ui.radio.checkbox input:checked ~ label:after {
  background-color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.radio.checkbox input:focus:checked ~ .box:before,
.kb-labfront.container .ui.radio.checkbox input:focus:checked ~ label:before {
  background-color: #ffffff;
}
.kb-labfront.container .ui.radio.checkbox input:focus:checked ~ .box:after,
.kb-labfront.container .ui.radio.checkbox input:focus:checked ~ label:after {
  background-color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.slider.checkbox {
  min-height: 1.25rem;
}
.kb-labfront.container .ui.slider.checkbox input {
  width: 3.5rem;
  height: 1.25rem;
}
.kb-labfront.container .ui.slider.checkbox .box,
.kb-labfront.container .ui.slider.checkbox label {
  padding-left: 4.5rem;
  line-height: 1rem;
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.slider.checkbox .box:before,
.kb-labfront.container .ui.slider.checkbox label:before {
  display: block;
  position: absolute;
  content: "";
  transform: none;
  border: none !important;
  left: 0;
  z-index: 1;
  top: 0.4rem;
  background-color: rgba(0, 0, 0, 0.05);
  width: 3.5rem;
  height: 0.2142857143rem;
  border-radius: 500rem;
  transition: background 0.3s ease;
}
.kb-labfront.container .ui.slider.checkbox .box:after,
.kb-labfront.container .ui.slider.checkbox label:after {
  background: #ffffff linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  position: absolute;
  content: "" !important;
  opacity: 1;
  z-index: 2;
  border: none;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
  width: 1.5rem;
  height: 1.5rem;
  top: -0.25rem;
  left: 0;
  transform: none;
  border-radius: 500rem;
  transition: left 0.3s ease;
}
.kb-labfront.container .ui.slider.checkbox input:focus ~ .box:before,
.kb-labfront.container .ui.slider.checkbox input:focus ~ label:before {
  background-color: rgba(0, 0, 0, 0.15);
  border: none;
}
.kb-labfront.container .ui.slider.checkbox .box:hover,
.kb-labfront.container .ui.slider.checkbox label:hover {
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.slider.checkbox .box:hover::before,
.kb-labfront.container .ui.slider.checkbox label:hover::before {
  background: rgba(0, 0, 0, 0.15);
}
.kb-labfront.container .ui.slider.checkbox input:checked ~ .box,
.kb-labfront.container .ui.slider.checkbox input:checked ~ label {
  color: rgba(0, 0, 0, 0.95) !important;
}
.kb-labfront.container .ui.slider.checkbox input:checked ~ .box:before,
.kb-labfront.container .ui.slider.checkbox input:checked ~ label:before {
  background-color: #545454 !important;
}
.kb-labfront.container .ui.slider.checkbox input:checked ~ .box:after,
.kb-labfront.container .ui.slider.checkbox input:checked ~ label:after {
  left: 2rem;
}
.kb-labfront.container .ui.slider.checkbox input:focus:checked ~ .box,
.kb-labfront.container .ui.slider.checkbox input:focus:checked ~ label {
  color: rgba(0, 0, 0, 0.95) !important;
}
.kb-labfront.container .ui.slider.checkbox input:focus:checked ~ .box:before,
.kb-labfront.container .ui.slider.checkbox input:focus:checked ~ label:before {
  background-color: black !important;
}
.kb-labfront.container .ui.toggle.checkbox {
  min-height: 1.5rem;
}
.kb-labfront.container .ui.toggle.checkbox input {
  width: 3.5rem;
  height: 1.5rem;
}
.kb-labfront.container .ui.toggle.checkbox .box,
.kb-labfront.container .ui.toggle.checkbox label {
  min-height: 1.5rem;
  padding-left: 4.5rem;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.toggle.checkbox label {
  padding-top: 0.15em;
}
.kb-labfront.container .ui.toggle.checkbox .box:before,
.kb-labfront.container .ui.toggle.checkbox label:before {
  display: block;
  position: absolute;
  content: "";
  z-index: 1;
  transform: none;
  border: none;
  top: 0;
  background: rgba(0, 0, 0, 0.05);
  box-shadow: none;
  width: 3.5rem;
  height: 1.5rem;
  border-radius: 500rem;
}
.kb-labfront.container .ui.toggle.checkbox .box:after,
.kb-labfront.container .ui.toggle.checkbox label:after {
  background: #ffffff linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  position: absolute;
  content: "" !important;
  opacity: 1;
  z-index: 2;
  border: none;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
  width: 1.5rem;
  height: 1.5rem;
  top: 0;
  left: 0;
  border-radius: 500rem;
  transition: background 0.3s ease, left 0.3s ease;
}
.kb-labfront.container .ui.toggle.checkbox input ~ .box:after,
.kb-labfront.container .ui.toggle.checkbox input ~ label:after {
  left: -0.05rem;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.toggle.checkbox input:focus ~ .box:before,
.kb-labfront.container .ui.toggle.checkbox input:focus ~ label:before {
  background-color: rgba(0, 0, 0, 0.15);
  border: none;
}
.kb-labfront.container .ui.toggle.checkbox .box:hover::before,
.kb-labfront.container .ui.toggle.checkbox label:hover::before {
  background-color: rgba(0, 0, 0, 0.15);
  border: none;
}
.kb-labfront.container .ui.toggle.checkbox input:checked ~ .box,
.kb-labfront.container .ui.toggle.checkbox input:checked ~ label {
  color: rgba(0, 0, 0, 0.95) !important;
}
.kb-labfront.container .ui.toggle.checkbox input:checked ~ .box:before,
.kb-labfront.container .ui.toggle.checkbox input:checked ~ label:before {
  background-color: #2185d0 !important;
}
.kb-labfront.container .ui.toggle.checkbox input:checked ~ .box:after,
.kb-labfront.container .ui.toggle.checkbox input:checked ~ label:after {
  left: 2.15rem;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.toggle.checkbox input:focus:checked ~ .box,
.kb-labfront.container .ui.toggle.checkbox input:focus:checked ~ label {
  color: rgba(0, 0, 0, 0.95) !important;
}
.kb-labfront.container .ui.toggle.checkbox input:focus:checked ~ .box:before,
.kb-labfront.container .ui.toggle.checkbox input:focus:checked ~ label:before {
  background-color: rgb(7.3932780083, 113.3438174274, 192.8067219917) !important;
}
.kb-labfront.container .ui.fitted.checkbox .box,
.kb-labfront.container .ui.fitted.checkbox label {
  padding-left: 0 !important;
}
.kb-labfront.container .ui.fitted.toggle.checkbox {
  width: 3.5rem;
}
.kb-labfront.container .ui.fitted.slider.checkbox {
  width: 3.5rem;
}
.kb-labfront.container .ui.inverted.checkbox label,
.kb-labfront.container .ui.inverted.checkbox + label {
  color: rgba(255, 255, 255, 0.9) !important;
}
.kb-labfront.container .ui.inverted.checkbox .box:hover,
.kb-labfront.container .ui.inverted.checkbox label:hover {
  color: rgb(255, 255, 255) !important;
}
.kb-labfront.container .ui.inverted.checkbox .box:hover::before,
.kb-labfront.container .ui.inverted.checkbox label:hover::before {
  border-color: rgba(34, 36, 38, 0.5);
}
.kb-labfront.container .ui.inverted.slider.checkbox .box,
.kb-labfront.container .ui.inverted.slider.checkbox label {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.inverted.slider.checkbox .box:before,
.kb-labfront.container .ui.inverted.slider.checkbox label:before {
  background-color: rgba(255, 255, 255, 0.5) !important;
}
.kb-labfront.container .ui.inverted.slider.checkbox .box:hover::before,
.kb-labfront.container .ui.inverted.slider.checkbox label:hover::before {
  background: rgba(255, 255, 255, 0.7) !important;
}
.kb-labfront.container .ui.inverted.slider.checkbox input:checked ~ .box,
.kb-labfront.container .ui.inverted.slider.checkbox input:checked ~ label {
  color: rgb(255, 255, 255) !important;
}
.kb-labfront.container .ui.inverted.slider.checkbox input:checked ~ .box:before,
.kb-labfront.container .ui.inverted.slider.checkbox input:checked ~ label:before {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.kb-labfront.container .ui.inverted.slider.checkbox input:focus:checked ~ .box,
.kb-labfront.container .ui.inverted.slider.checkbox input:focus:checked ~ label {
  color: rgb(255, 255, 255) !important;
}
.kb-labfront.container .ui.inverted.slider.checkbox input:focus:checked ~ .box:before,
.kb-labfront.container .ui.inverted.slider.checkbox input:focus:checked ~ label:before {
  background-color: rgba(255, 255, 255, 0.8) !important;
}
.kb-labfront.container .ui.inverted.toggle.checkbox .box:before,
.kb-labfront.container .ui.inverted.toggle.checkbox label:before {
  background-color: rgba(255, 255, 255, 0.9) !important;
}
.kb-labfront.container .ui.inverted.toggle.checkbox .box:hover::before,
.kb-labfront.container .ui.inverted.toggle.checkbox label:hover::before {
  background: rgb(255, 255, 255) !important;
}
.kb-labfront.container .ui.inverted.toggle.checkbox input:checked ~ .box,
.kb-labfront.container .ui.inverted.toggle.checkbox input:checked ~ label {
  color: rgb(255, 255, 255) !important;
}
.kb-labfront.container .ui.inverted.toggle.checkbox input:checked ~ .box:before,
.kb-labfront.container .ui.inverted.toggle.checkbox input:checked ~ label:before {
  background-color: #2185d0 !important;
}
.kb-labfront.container .ui.inverted.toggle.checkbox input:focus:checked ~ .box,
.kb-labfront.container .ui.inverted.toggle.checkbox input:focus:checked ~ label {
  color: rgb(255, 255, 255) !important;
}
.kb-labfront.container .ui.inverted.toggle.checkbox input:focus:checked ~ .box:before,
.kb-labfront.container .ui.inverted.toggle.checkbox input:focus:checked ~ label:before {
  background-color: rgb(7.3932780083, 113.3438174274, 192.8067219917) !important;
}
.kb-labfront.container .ui.mini.checkbox {
  font-size: 0.7857142857em;
}
.kb-labfront.container .ui.tiny.checkbox {
  font-size: 0.8571428571em;
}
.kb-labfront.container .ui.small.checkbox {
  font-size: 0.9285714286em;
}
.kb-labfront.container .ui.large.checkbox {
  font-size: 1.1428571429em;
}
.kb-labfront.container .ui.large.form .checkbox:not(.slider):not(.toggle):not(.radio) .box:after,
.kb-labfront.container .ui.large.form .checkbox:not(.slider):not(.toggle):not(.radio) .box:before,
.kb-labfront.container .ui.large.form .checkbox:not(.slider):not(.toggle):not(.radio) label:after,
.kb-labfront.container .ui.large.form .checkbox:not(.slider):not(.toggle):not(.radio) label:before,
.kb-labfront.container .ui.large.checkbox:not(.slider):not(.toggle):not(.radio) .box:after,
.kb-labfront.container .ui.large.checkbox:not(.slider):not(.toggle):not(.radio) .box:before,
.kb-labfront.container .ui.large.checkbox:not(.slider):not(.toggle):not(.radio) label:after,
.kb-labfront.container .ui.large.checkbox:not(.slider):not(.toggle):not(.radio) label:before {
  transform: scale(1.1428571429);
  transform-origin: left;
}
.kb-labfront.container .ui.large.form .checkbox.radio .box:before,
.kb-labfront.container .ui.large.form .checkbox.radio label:before,
.kb-labfront.container .ui.large.checkbox.radio .box:before,
.kb-labfront.container .ui.large.checkbox.radio label:before {
  transform: scale(1.1428571429);
  transform-origin: left;
}
.kb-labfront.container .ui.large.form .checkbox.radio .box:after,
.kb-labfront.container .ui.large.form .checkbox.radio label:after,
.kb-labfront.container .ui.large.checkbox.radio .box:after,
.kb-labfront.container .ui.large.checkbox.radio label:after {
  transform: scale(0.5714285714);
  transform-origin: left;
  left: 0.3357142857em;
}
.kb-labfront.container .ui.big.checkbox {
  font-size: 1.2857142857em;
}
.kb-labfront.container .ui.big.form .checkbox:not(.slider):not(.toggle):not(.radio) .box:after,
.kb-labfront.container .ui.big.form .checkbox:not(.slider):not(.toggle):not(.radio) .box:before,
.kb-labfront.container .ui.big.form .checkbox:not(.slider):not(.toggle):not(.radio) label:after,
.kb-labfront.container .ui.big.form .checkbox:not(.slider):not(.toggle):not(.radio) label:before,
.kb-labfront.container .ui.big.checkbox:not(.slider):not(.toggle):not(.radio) .box:after,
.kb-labfront.container .ui.big.checkbox:not(.slider):not(.toggle):not(.radio) .box:before,
.kb-labfront.container .ui.big.checkbox:not(.slider):not(.toggle):not(.radio) label:after,
.kb-labfront.container .ui.big.checkbox:not(.slider):not(.toggle):not(.radio) label:before {
  transform: scale(1.2857142857);
  transform-origin: left;
}
.kb-labfront.container .ui.big.form .checkbox.radio .box:before,
.kb-labfront.container .ui.big.form .checkbox.radio label:before,
.kb-labfront.container .ui.big.checkbox.radio .box:before,
.kb-labfront.container .ui.big.checkbox.radio label:before {
  transform: scale(1.2857142857);
  transform-origin: left;
}
.kb-labfront.container .ui.big.form .checkbox.radio .box:after,
.kb-labfront.container .ui.big.form .checkbox.radio label:after,
.kb-labfront.container .ui.big.checkbox.radio .box:after,
.kb-labfront.container .ui.big.checkbox.radio label:after {
  transform: scale(0.6428571429);
  transform-origin: left;
  left: 0.3714285714em;
}
.kb-labfront.container .ui.huge.checkbox {
  font-size: 1.4285714286em;
}
.kb-labfront.container .ui.huge.form .checkbox:not(.slider):not(.toggle):not(.radio) .box:after,
.kb-labfront.container .ui.huge.form .checkbox:not(.slider):not(.toggle):not(.radio) .box:before,
.kb-labfront.container .ui.huge.form .checkbox:not(.slider):not(.toggle):not(.radio) label:after,
.kb-labfront.container .ui.huge.form .checkbox:not(.slider):not(.toggle):not(.radio) label:before,
.kb-labfront.container .ui.huge.checkbox:not(.slider):not(.toggle):not(.radio) .box:after,
.kb-labfront.container .ui.huge.checkbox:not(.slider):not(.toggle):not(.radio) .box:before,
.kb-labfront.container .ui.huge.checkbox:not(.slider):not(.toggle):not(.radio) label:after,
.kb-labfront.container .ui.huge.checkbox:not(.slider):not(.toggle):not(.radio) label:before {
  transform: scale(1.4285714286);
  transform-origin: left;
}
.kb-labfront.container .ui.huge.form .checkbox.radio .box:before,
.kb-labfront.container .ui.huge.form .checkbox.radio label:before,
.kb-labfront.container .ui.huge.checkbox.radio .box:before,
.kb-labfront.container .ui.huge.checkbox.radio label:before {
  transform: scale(1.4285714286);
  transform-origin: left;
}
.kb-labfront.container .ui.huge.form .checkbox.radio .box:after,
.kb-labfront.container .ui.huge.form .checkbox.radio label:after,
.kb-labfront.container .ui.huge.checkbox.radio .box:after,
.kb-labfront.container .ui.huge.checkbox.radio label:after {
  transform: scale(0.7142857143);
  transform-origin: left;
  left: 0.4071428571em;
}
.kb-labfront.container .ui.massive.checkbox {
  font-size: 1.7142857143em;
}
.kb-labfront.container .ui.massive.form .checkbox:not(.slider):not(.toggle):not(.radio) .box:after,
.kb-labfront.container .ui.massive.form .checkbox:not(.slider):not(.toggle):not(.radio) .box:before,
.kb-labfront.container .ui.massive.form .checkbox:not(.slider):not(.toggle):not(.radio) label:after,
.kb-labfront.container .ui.massive.form .checkbox:not(.slider):not(.toggle):not(.radio) label:before,
.kb-labfront.container .ui.massive.checkbox:not(.slider):not(.toggle):not(.radio) .box:after,
.kb-labfront.container .ui.massive.checkbox:not(.slider):not(.toggle):not(.radio) .box:before,
.kb-labfront.container .ui.massive.checkbox:not(.slider):not(.toggle):not(.radio) label:after,
.kb-labfront.container .ui.massive.checkbox:not(.slider):not(.toggle):not(.radio) label:before {
  transform: scale(1.7142857143);
  transform-origin: left;
}
.kb-labfront.container .ui.massive.form .checkbox.radio .box:before,
.kb-labfront.container .ui.massive.form .checkbox.radio label:before,
.kb-labfront.container .ui.massive.checkbox.radio .box:before,
.kb-labfront.container .ui.massive.checkbox.radio label:before {
  transform: scale(1.7142857143);
  transform-origin: left;
}
.kb-labfront.container .ui.massive.form .checkbox.radio .box:after,
.kb-labfront.container .ui.massive.form .checkbox.radio label:after,
.kb-labfront.container .ui.massive.checkbox.radio .box:after,
.kb-labfront.container .ui.massive.checkbox.radio label:after {
  transform: scale(0.8571428571);
  transform-origin: left;
  left: 0.4785714286em;
}
@font-face {
  font-family: "Checkbox";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("truetype");
}
.kb-labfront.container .ui.checkbox label:after,
.kb-labfront.container .ui.checkbox .box:after {
  font-family: "Checkbox";
}
.kb-labfront.container .ui.checkbox input:checked ~ .box:after,
.kb-labfront.container .ui.checkbox input:checked ~ label:after {
  content: "\\e800";
}
.kb-labfront.container .ui.checkbox input:indeterminate ~ .box:after,
.kb-labfront.container .ui.checkbox input:indeterminate ~ label:after {
  font-size: 12px;
  content: "\\e801";
}
.kb-labfront.container .dimmable:not(body) {
  position: relative;
}
.kb-labfront.container .ui.dimmer {
  display: none;
  position: absolute;
  top: 0 !important;
  left: 0 !important;
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  padding: 1em;
  background-color: rgba(0, 0, 0, 0.85);
  opacity: 0;
  line-height: 1;
  animation-fill-mode: both;
  animation-duration: 0.5s;
  transition: background-color 0.5s linear;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
  will-change: opacity;
  z-index: 1000;
}
.kb-labfront.container .ui.dimmer > .content {
  user-select: text;
  color: #ffffff;
}
.kb-labfront.container .ui.segment > .ui.dimmer:not(.page) {
  border-radius: inherit !important;
}
.kb-labfront.container .ui.dimmer:not(.inverted)::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}
.kb-labfront.container .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.15);
}
.kb-labfront.container .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}
.kb-labfront.container .animating.dimmable:not(body),
.kb-labfront.container .dimmed.dimmable:not(body) {
  overflow: hidden;
}
.kb-labfront.container .dimmed.dimmable > .ui.animating.dimmer,
.kb-labfront.container .dimmed.dimmable > .ui.visible.dimmer,
.kb-labfront.container .ui.active.dimmer {
  display: flex;
  opacity: 1;
}
.kb-labfront.container .ui.disabled.dimmer {
  width: 0 !important;
  height: 0 !important;
}
.kb-labfront.container .dimmed.dimmable > .ui.animating.legacy.dimmer,
.kb-labfront.container .dimmed.dimmable > .ui.visible.legacy.dimmer,
.kb-labfront.container .ui.active.legacy.dimmer {
  display: block;
}
.kb-labfront.container .ui[class*="top aligned"].dimmer {
  justify-content: flex-start;
}
.kb-labfront.container .ui[class*="bottom aligned"].dimmer {
  justify-content: flex-end;
}
.kb-labfront.container .ui.page.dimmer {
  position: fixed;
  transform-style: "";
  perspective: 2000px;
  transform-origin: center center;
}
.kb-labfront.container body.animating.in.dimmable,
.kb-labfront.container body.dimmed.dimmable {
  overflow: hidden;
}
.kb-labfront.container body.dimmable > .dimmer {
  position: fixed;
}
.kb-labfront.container .blurring.dimmable > :not(.dimmer) {
  filter: initial;
  transition: 800ms filter ease;
}
.kb-labfront.container .blurring.dimmed.dimmable > :not(.dimmer):not(.popup) {
  filter: blur(5px) grayscale(0.7);
}
.kb-labfront.container .blurring.dimmable > .dimmer {
  background-color: rgba(0, 0, 0, 0.6);
}
.kb-labfront.container .blurring.dimmable > .inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.6);
}
.kb-labfront.container .ui.dimmer > .top.aligned.content > * {
  vertical-align: top;
}
.kb-labfront.container .ui.dimmer > .bottom.aligned.content > * {
  vertical-align: bottom;
}
.kb-labfront.container .medium.medium.medium.medium.medium.dimmer {
  background-color: rgba(0, 0, 0, 0.65);
}
.kb-labfront.container .light.light.light.light.light.dimmer {
  background-color: rgba(0, 0, 0, 0.45);
}
.kb-labfront.container .very.light.light.light.light.dimmer {
  background-color: rgba(0, 0, 0, 0.25);
}
.kb-labfront.container .ui.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.85);
}
.kb-labfront.container .ui.inverted.dimmer > .content,
.kb-labfront.container .ui.inverted.dimmer > .content > * {
  color: #000000;
}
.kb-labfront.container .medium.medium.medium.medium.medium.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.65);
}
.kb-labfront.container .light.light.light.light.light.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.45);
}
.kb-labfront.container .very.light.light.light.light.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.25);
}
.kb-labfront.container .ui.simple.dimmer {
  display: block;
  overflow: hidden;
  opacity: 0;
  width: 0;
  height: 0;
  z-index: -100;
  background-color: rgba(0, 0, 0, 0);
}
.kb-labfront.container .dimmed.dimmable > .ui.simple.dimmer {
  overflow: visible;
  opacity: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  z-index: 1;
}
.kb-labfront.container .ui.simple.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0);
}
.kb-labfront.container .dimmed.dimmable > .ui.simple.inverted.dimmer {
  background-color: rgba(255, 255, 255, 0.85);
}
.kb-labfront.container .ui[class*="top dimmer"],
.kb-labfront.container .ui[class*="center dimmer"],
.kb-labfront.container .ui[class*="bottom dimmer"] {
  height: auto;
}
.kb-labfront.container .ui[class*="bottom dimmer"] {
  top: auto !important;
  bottom: 0;
}
.kb-labfront.container .ui[class*="center dimmer"] {
  top: 50% !important;
  transform: translateY(-50%);
  -webkit-transform: translateY(calc(-50% - 0.5px));
}
.kb-labfront.container .ui.segment > .ui[class*="top dimmer"] {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.kb-labfront.container .ui.segment > .ui[class*="center dimmer"] {
  border-radius: 0 !important;
}
.kb-labfront.container .ui.segment > .ui[class*="bottom dimmer"] {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.kb-labfront.container .ui[class*="center dimmer"].transition[class*="fade up"].in {
  animation-name: fadeInUpCenter;
}
.kb-labfront.container .ui[class*="center dimmer"].transition[class*="fade down"].in {
  animation-name: fadeInDownCenter;
}
.kb-labfront.container .ui[class*="center dimmer"].transition[class*="fade up"].out {
  animation-name: fadeOutUpCenter;
}
.kb-labfront.container .ui[class*="center dimmer"].transition[class*="fade down"].out {
  animation-name: fadeOutDownCenter;
}
.kb-labfront.container .ui[class*="center dimmer"].bounce.transition {
  animation-name: bounceCenter;
}
@keyframes fadeInUpCenter {
  0% {
    opacity: 0;
    transform: translateY(-40%);
    -webkit-transform: translateY(calc(-40% - 0.5px));
  }
  100% {
    opacity: 1;
    transform: translateY(-50%);
    -webkit-transform: translateY(calc(-50% - 0.5px));
  }
}
@keyframes fadeInDownCenter {
  0% {
    opacity: 0;
    transform: translateY(-60%);
    -webkit-transform: translateY(calc(-60% - 0.5px));
  }
  100% {
    opacity: 1;
    transform: translateY(-50%);
    -webkit-transform: translateY(calc(-50% - 0.5px));
  }
}
@keyframes fadeOutUpCenter {
  0% {
    opacity: 1;
    transform: translateY(-50%);
    -webkit-transform: translateY(calc(-50% - 0.5px));
  }
  100% {
    opacity: 0;
    transform: translateY(-45%);
    -webkit-transform: translateY(calc(-45% - 0.5px));
  }
}
@keyframes fadeOutDownCenter {
  0% {
    opacity: 1;
    transform: translateY(-50%);
    -webkit-transform: translateY(calc(-50% - 0.5px));
  }
  100% {
    opacity: 0;
    transform: translateY(-55%);
    -webkit-transform: translateY(calc(-55% - 0.5px));
  }
}
@keyframes bounceCenter {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(-50%);
    -webkit-transform: translateY(calc(-50% - 0.5px));
  }
  40% {
    transform: translateY(calc(-50% - 30px));
  }
  60% {
    transform: translateY(calc(-50% - 15px));
  }
}
.kb-labfront.container .ui.dropdown {
  cursor: pointer;
  position: relative;
  display: inline-block;
  outline: none;
  text-align: left;
  transition: box-shadow 0.1s ease, width 0.1s ease;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.kb-labfront.container .ui.dropdown .menu {
  cursor: auto;
  position: absolute;
  display: none;
  outline: none;
  top: 100%;
  min-width: max-content;
  margin: 0;
  padding: 0 0;
  background: #ffffff;
  font-size: 1em;
  text-shadow: none;
  text-align: left;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, 0.15);
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.2857142857rem;
  transition: opacity 0.1s ease;
  z-index: 11;
  will-change: transform, opacity;
}
.kb-labfront.container .ui.dropdown .menu > * {
  white-space: nowrap;
}
.kb-labfront.container .ui.dropdown > input:not(.search):first-child,
.kb-labfront.container .ui.dropdown > select {
  display: none !important;
}
.kb-labfront.container .ui.dropdown > .dropdown.icon.icon {
  position: relative;
  width: auto;
  font-size: 0.8571428571em;
  margin: 0 0 0 1em;
}
.kb-labfront.container .ui.dropdown .menu > .item .dropdown.icon {
  width: auto;
  float: right;
  margin: 0em 0 0 1em;
}
.kb-labfront.container .ui.dropdown .menu > .item .dropdown.icon + .text {
  margin-right: 1em;
}
.kb-labfront.container .ui.dropdown > .text {
  display: inline-block;
  transition: none;
}
.kb-labfront.container .ui.dropdown .menu > .item {
  position: relative;
  cursor: pointer;
  display: block;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1em;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  padding: 0.7857142857rem 1.1428571429rem !important;
  text-transform: none;
  font-weight: normal;
  box-shadow: none;
  -webkit-touch-callout: none;
}
.kb-labfront.container .ui.dropdown .menu > .item:first-child {
  border-top-width: 0;
}
.kb-labfront.container .ui.dropdown > .text > [class*="right floated"],
.kb-labfront.container .ui.dropdown .menu .item > [class*="right floated"] {
  float: right !important;
  margin-right: 0 !important;
  margin-left: 1em !important;
}
.kb-labfront.container .ui.dropdown > .text > [class*="left floated"],
.kb-labfront.container .ui.dropdown .menu .item > [class*="left floated"] {
  float: left !important;
  margin-left: 0 !important;
  margin-right: 1em !important;
}
.kb-labfront.container .ui.dropdown .menu .item > .icon.floated,
.kb-labfront.container .ui.dropdown .menu .item > .flag.floated,
.kb-labfront.container .ui.dropdown .menu .item > .image.floated,
.kb-labfront.container .ui.dropdown .menu .item > img.floated {
  margin-top: 0em;
}
.kb-labfront.container .ui.dropdown .menu > .header {
  margin: 1rem 0 0.75rem;
  padding: 0 1.1428571429rem;
  font-weight: bold;
  text-transform: uppercase;
}
.kb-labfront.container .ui.dropdown .menu > .header:not(.ui) {
  color: rgba(0, 0, 0, 0.85);
  font-size: 0.7857142857em;
}
.kb-labfront.container .ui.dropdown .menu > .divider {
  border-top: 1px solid rgba(34, 36, 38, 0.1);
  height: 0;
  margin: 0.5em 0;
}
.kb-labfront.container .ui.dropdown .menu > .horizontal.divider {
  border-top: none;
}
.kb-labfront.container .ui.dropdown.dropdown .menu > .input {
  width: auto;
  display: flex;
  margin: 1.1428571429rem 0.7857142857rem;
  min-width: 10rem;
}
.kb-labfront.container .ui.dropdown .menu > .header + .input {
  margin-top: 0;
}
.kb-labfront.container .ui.dropdown .menu > .input:not(.transparent) input {
  padding: 0.5em 1em;
}
.kb-labfront.container .ui.dropdown .menu > .input:not(.transparent) .button,
.kb-labfront.container .ui.dropdown .menu > .input:not(.transparent) .icon,
.kb-labfront.container .ui.dropdown .menu > .input:not(.transparent) .label {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.kb-labfront.container .ui.dropdown > .text > .description,
.kb-labfront.container .ui.dropdown .menu > .item > .description {
  float: right;
  margin: 0 0 0 1em;
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.dropdown .menu > .message {
  padding: 0.7857142857rem 1.1428571429rem;
  font-weight: normal;
}
.kb-labfront.container .ui.dropdown .menu > .message:not(.ui) {
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.dropdown .menu .menu {
  top: 0;
  left: 100%;
  right: auto;
  margin: 0 0 0 -0.5em !important;
  border-radius: 0.2857142857rem !important;
  z-index: 21 !important;
}
.kb-labfront.container .ui.dropdown .menu .menu:after {
  display: none;
}
.kb-labfront.container .ui.dropdown > .text > .icon,
.kb-labfront.container .ui.dropdown > .text > .label,
.kb-labfront.container .ui.dropdown > .text > .flag,
.kb-labfront.container .ui.dropdown > .text > img,
.kb-labfront.container .ui.dropdown > .text > .image {
  margin-top: 0em;
}
.kb-labfront.container .ui.dropdown .menu > .item > .icon,
.kb-labfront.container .ui.dropdown .menu > .item > .label,
.kb-labfront.container .ui.dropdown .menu > .item > .flag,
.kb-labfront.container .ui.dropdown .menu > .item > .image,
.kb-labfront.container .ui.dropdown .menu > .item > img {
  margin-top: 0em;
}
.kb-labfront.container .ui.dropdown > .text > .icon,
.kb-labfront.container .ui.dropdown > .text > .label,
.kb-labfront.container .ui.dropdown > .text > .flag,
.kb-labfront.container .ui.dropdown > .text > img,
.kb-labfront.container .ui.dropdown > .text > .image,
.kb-labfront.container .ui.dropdown .menu > .item > .icon,
.kb-labfront.container .ui.dropdown .menu > .item > .label,
.kb-labfront.container .ui.dropdown .menu > .item > .flag,
.kb-labfront.container .ui.dropdown .menu > .item > .image,
.kb-labfront.container .ui.dropdown .menu > .item > img {
  margin-left: 0;
  float: none;
  margin-right: 0.7857142857rem;
}
.kb-labfront.container .ui.dropdown > .text > img,
.kb-labfront.container .ui.dropdown > .text > .image:not(.icon),
.kb-labfront.container .ui.dropdown .menu > .item > .image:not(.icon),
.kb-labfront.container .ui.dropdown .menu > .item > img {
  display: inline-block;
  vertical-align: top;
  width: auto;
  margin-top: -0.5em;
  margin-bottom: -0.5em;
  max-height: 2em;
}
.kb-labfront.container .ui.dropdown .ui.menu > .item:before,
.kb-labfront.container .ui.menu .ui.dropdown .menu > .item:before {
  display: none;
}
.kb-labfront.container .ui.menu .ui.dropdown .menu .active.item {
  border-left: none;
}
.kb-labfront.container .ui.menu .right.menu .dropdown:last-child .menu,
.kb-labfront.container .ui.menu .right.dropdown.item .menu,
.kb-labfront.container .ui.buttons > .ui.dropdown:last-child .menu {
  left: auto;
  right: 0;
}
.kb-labfront.container .ui.label.dropdown .menu {
  min-width: 100%;
}
.kb-labfront.container .ui.dropdown.icon.button > .dropdown.icon {
  margin: 0;
}
.kb-labfront.container .ui.button.dropdown .menu {
  min-width: 100%;
}
.kb-labfront.container .ui.selection.dropdown {
  cursor: pointer;
  word-wrap: break-word;
  line-height: 1em;
  white-space: normal;
  outline: 0;
  transform: rotateZ(0deg);
  min-width: 14em;
  min-height: 2.7142857143em;
  background: #ffffff;
  display: inline-block;
  padding: 0.7857142857em 3.2em 0.7857142857em 1em;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: none;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 0.2857142857rem;
  transition: box-shadow 0.1s ease, width 0.1s ease;
}
.kb-labfront.container .ui.selection.dropdown.visible,
.kb-labfront.container .ui.selection.dropdown.active {
  z-index: 10;
}
.kb-labfront.container select.ui.dropdown {
  height: 38px;
  padding: 0.5em;
  border: 1px solid rgba(34, 36, 38, 0.15);
  visibility: visible;
}
.kb-labfront.container .ui.selection.dropdown > .search.icon,
.kb-labfront.container .ui.selection.dropdown > .delete.icon,
.kb-labfront.container .ui.selection.dropdown > .dropdown.icon {
  cursor: pointer;
  position: absolute;
  width: auto;
  height: auto;
  line-height: 1.2142857143em;
  top: 0.7857142857em;
  right: 1em;
  z-index: 3;
  margin: -0.7857142857em;
  padding: 0.9166666667em;
  opacity: 0.8;
  transition: opacity 0.1s ease;
}
.kb-labfront.container .ui.compact.selection.dropdown {
  min-width: 0;
}
.kb-labfront.container .ui.selection.dropdown .menu {
  overflow-x: hidden;
  overflow-y: auto;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
  border-top-width: 0 !important;
  width: auto;
  outline: none;
  margin: 0 -1px;
  min-width: calc(100% + 2px);
  width: calc(100% + 2px);
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, 0.15);
  transition: opacity 0.1s ease;
}
.kb-labfront.container .ui.selection.dropdown .menu:after,
.kb-labfront.container .ui.selection.dropdown .menu:before {
  display: none;
}
.kb-labfront.container .ui.selection.dropdown .menu > .message {
  padding: 0.7857142857rem 1.1428571429rem;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.selection.dropdown[class*="very short"] .menu {
    max-height: 4.0071428571em;
  }
  .kb-labfront.container .ui.selection.dropdown.short .menu {
    max-height: 6.0107142857em;
  }
  .kb-labfront.container .ui.selection.dropdown .menu {
    max-height: 8.0142857143em;
  }
  .kb-labfront.container .ui.selection.dropdown.long .menu {
    max-height: 16.0285714286em;
  }
  .kb-labfront.container .ui.selection.dropdown[class*="very long"] .menu {
    max-height: 24.0428571429em;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.selection.dropdown[class*="very short"] .menu {
    max-height: 5.3428571429em;
  }
  .kb-labfront.container .ui.selection.dropdown.short .menu {
    max-height: 8.0142857143em;
  }
  .kb-labfront.container .ui.selection.dropdown .menu {
    max-height: 10.6857142857em;
  }
  .kb-labfront.container .ui.selection.dropdown.long .menu {
    max-height: 21.3714285714em;
  }
  .kb-labfront.container .ui.selection.dropdown[class*="very long"] .menu {
    max-height: 32.0571428571em;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.selection.dropdown[class*="very short"] .menu {
    max-height: 8.0142857143em;
  }
  .kb-labfront.container .ui.selection.dropdown.short .menu {
    max-height: 12.0214285714em;
  }
  .kb-labfront.container .ui.selection.dropdown .menu {
    max-height: 16.0285714286em;
  }
  .kb-labfront.container .ui.selection.dropdown.long .menu {
    max-height: 32.0571428571em;
  }
  .kb-labfront.container .ui.selection.dropdown[class*="very long"] .menu {
    max-height: 48.0857142857em;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.selection.dropdown[class*="very short"] .menu {
    max-height: 10.6857142857em;
  }
  .kb-labfront.container .ui.selection.dropdown.short .menu {
    max-height: 16.0285714286em;
  }
  .kb-labfront.container .ui.selection.dropdown .menu {
    max-height: 21.3714285714em;
  }
  .kb-labfront.container .ui.selection.dropdown.long .menu {
    max-height: 42.7428571429em;
  }
  .kb-labfront.container .ui.selection.dropdown[class*="very long"] .menu {
    max-height: 64.1142857143em;
  }
}
.kb-labfront.container .ui.selection.dropdown .menu > .item {
  border-top: 1px solid #fafafa;
  padding: 0.7857142857rem 1.1428571429rem !important;
  white-space: normal;
  word-wrap: normal;
}
.kb-labfront.container .ui.selection.dropdown .menu > .hidden.addition.item {
  display: none;
}
.kb-labfront.container .ui.selection.dropdown:hover {
  border-color: rgba(34, 36, 38, 0.35);
  box-shadow: none;
}
.kb-labfront.container .ui.selection.active.dropdown {
  border-color: #96c8da;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.selection.active.dropdown .menu {
  border-color: #96c8da;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.selection.dropdown:focus {
  border-color: #96c8da;
  box-shadow: none;
}
.kb-labfront.container .ui.selection.dropdown:focus .menu {
  border-color: #96c8da;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.selection.visible.dropdown > .text:not(.default) {
  font-weight: normal;
  color: rgba(0, 0, 0, 0.8);
}
.kb-labfront.container .ui.selection.active.dropdown:hover {
  border-color: #96c8da;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.selection.active.dropdown:hover .menu {
  border-color: #96c8da;
  box-shadow: 0 2px 3px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.active.selection.dropdown > .dropdown.icon,
.kb-labfront.container .ui.visible.selection.dropdown > .dropdown.icon {
  opacity: "";
  z-index: 3;
}
.kb-labfront.container .ui.active.selection.dropdown {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.kb-labfront.container .ui.active.empty.selection.dropdown {
  border-radius: 0.2857142857rem !important;
  box-shadow: none !important;
}
.kb-labfront.container .ui.active.empty.selection.dropdown .menu {
  border: none !important;
  box-shadow: none !important;
}
.kb-labfront.container .ui.search.dropdown {
  min-width: "";
}
.kb-labfront.container .ui.search.dropdown > input.search {
  background: none transparent !important;
  border: none !important;
  box-shadow: none !important;
  cursor: text;
  top: 0;
  left: 1px;
  width: 100%;
  outline: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  padding: inherit;
}
.kb-labfront.container .ui.search.dropdown > input.search {
  position: absolute;
  z-index: 2;
}
.kb-labfront.container .ui.search.dropdown > .text {
  cursor: text;
  position: relative;
  left: 1px;
  z-index: 3;
}
.kb-labfront.container .ui.search.selection.dropdown > input.search {
  line-height: 1.2142857143em;
  padding: 0.6785714286em 3.2em 0.6785714286em 1em;
}
.kb-labfront.container .ui.search.selection.dropdown > span.sizer {
  line-height: 1.2142857143em;
  padding: 0.6785714286em 3.2em 0.6785714286em 1em;
  display: none;
  white-space: pre;
}
.kb-labfront.container .ui.search.dropdown.active > input.search,
.kb-labfront.container .ui.search.dropdown.visible > input.search {
  cursor: auto;
}
.kb-labfront.container .ui.search.dropdown.active > .text,
.kb-labfront.container .ui.search.dropdown.visible > .text {
  pointer-events: none;
}
.kb-labfront.container .ui.active.search.dropdown input.search:focus + .text .icon,
.kb-labfront.container .ui.active.search.dropdown input.search:focus + .text .flag {
  opacity: 0.45;
}
.kb-labfront.container .ui.active.search.dropdown input.search:focus + .text {
  color: rgba(114.75, 114.75, 114.75, 0.87) !important;
}
.kb-labfront.container .ui.search.dropdown .menu {
  overflow-x: hidden;
  overflow-y: auto;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.search.dropdown .menu {
    max-height: 8.0142857143em;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.search.dropdown .menu {
    max-height: 10.6857142857em;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.search.dropdown .menu {
    max-height: 16.0285714286em;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.search.dropdown .menu {
    max-height: 21.3714285714em;
  }
}
.kb-labfront.container .ui.dropdown > .remove.icon {
  cursor: pointer;
  font-size: 0.8571428571em;
  margin: -0.7857142857em;
  padding: 0.9166666667em;
  right: 3em;
  top: 0.7857142857em;
  position: absolute;
  opacity: 0.6;
  z-index: 3;
}
.kb-labfront.container .ui.clearable.dropdown .text,
.kb-labfront.container .ui.clearable.dropdown a:last-of-type {
  margin-right: 1.5em;
}
.kb-labfront.container .ui.dropdown select.noselection ~ .remove.icon,
.kb-labfront.container .ui.dropdown input[value=""] ~ .remove.icon,
.kb-labfront.container .ui.dropdown input:not([value]) ~ .remove.icon,
.kb-labfront.container .ui.dropdown.loading > .remove.icon {
  display: none;
}
.kb-labfront.container .ui.multiple.dropdown {
  padding: 0.2261904762em 3.2em 0.2261904762em 0.3571428571em;
}
.kb-labfront.container .ui.multiple.dropdown .menu {
  cursor: auto;
}
.kb-labfront.container .ui.multiple.search.dropdown,
.kb-labfront.container .ui.multiple.search.dropdown > input.search {
  cursor: text;
}
.kb-labfront.container .ui.multiple.dropdown > .label {
  display: inline-block;
  white-space: normal;
  font-size: 1em;
  padding: 0.3571428571em 0.7857142857em;
  margin: 0.1428571429rem 0.2857142857rem 0.1428571429rem 0;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
}
.kb-labfront.container .ui.multiple.dropdown .dropdown.icon {
  margin: "";
  padding: "";
}
.kb-labfront.container .ui.multiple.dropdown > .text {
  position: static;
  padding: 0;
  max-width: 100%;
  margin: 0.4523809524em 0 0.4523809524em 0.6428571429em;
  line-height: 1.2142857143em;
}
.kb-labfront.container .ui.multiple.dropdown > .label ~ input.search {
  margin-left: 0.1428571429em !important;
}
.kb-labfront.container .ui.multiple.dropdown > .label ~ .text {
  display: none;
}
.kb-labfront.container .ui.multiple.dropdown > .label:not(.image) > img:not(.centered) {
  margin-right: 0.7857142857rem;
}
.kb-labfront.container .ui.multiple.dropdown > .label:not(.image) > img.ui:not(.avatar) {
  margin-bottom: 0.3928571429rem;
}
.kb-labfront.container .ui.multiple.dropdown > .image.label img {
  margin: -0.3571428571em 0.7857142857em -0.3571428571em -0.7857142857em;
  height: 1.7142857143em;
}
.kb-labfront.container .ui.multiple.search.dropdown > .text {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  padding: inherit;
  margin: 0.4523809524em 0 0.4523809524em 0.6428571429em;
  line-height: 1.2142857143em;
}
.kb-labfront.container .ui.multiple.search.dropdown > .label ~ .text {
  display: none;
}
.kb-labfront.container .ui.multiple.search.dropdown > input.search {
  position: static;
  padding: 0;
  max-width: 100%;
  margin: 0.4523809524em 0 0.4523809524em 0.6428571429em;
  width: 2.2em;
  line-height: 1.2142857143em;
}
.kb-labfront.container .ui.inline.dropdown {
  cursor: pointer;
  display: inline-block;
  color: inherit;
}
.kb-labfront.container .ui.inline.dropdown .dropdown.icon {
  margin: 0 0.2142857143em 0 0.2142857143em;
  vertical-align: baseline;
}
.kb-labfront.container .ui.inline.dropdown > .text {
  font-weight: bold;
}
.kb-labfront.container .ui.inline.dropdown .menu {
  cursor: auto;
  margin-top: 0.2142857143em;
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.dropdown .menu .active.item {
  background: transparent;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.95);
  box-shadow: none;
  z-index: 12;
}
.kb-labfront.container .ui.dropdown .menu > .item:hover {
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.95);
  z-index: 13;
}
.kb-labfront.container .ui.loading.dropdown > i.icon {
  height: 1em !important;
}
.kb-labfront.container .ui.loading.selection.dropdown > i.icon {
  padding: 1.5em 1.2857142857em !important;
}
.kb-labfront.container .ui.loading.dropdown > i.icon:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 1.2857142857em;
  height: 1.2857142857em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.loading.dropdown > i.icon:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  box-shadow: 0 0 0 1px transparent;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 1.2857142857em;
  height: 1.2857142857em;
  animation: loader 0.6s infinite linear;
  border: 0.2em solid #767676;
  border-radius: 500rem;
}
.kb-labfront.container .ui.loading.dropdown.button > i.icon:before,
.kb-labfront.container .ui.loading.dropdown.button > i.icon:after {
  display: none;
}
.kb-labfront.container .ui.dropdown:not(.button) > .default.text,
.kb-labfront.container .ui.default.dropdown:not(.button) > .text {
  color: rgba(191.25, 191.25, 191.25, 0.87);
}
.kb-labfront.container .ui.dropdown:not(.button) > input:focus ~ .default.text,
.kb-labfront.container .ui.default.dropdown:not(.button) > input:focus ~ .text {
  color: rgba(114.75, 114.75, 114.75, 0.87);
}
.kb-labfront.container .ui.loading.dropdown > .text {
  transition: none;
}
.kb-labfront.container .ui.dropdown .loading.menu {
  display: block;
  visibility: hidden;
  z-index: -1;
}
.kb-labfront.container .ui.dropdown > .loading.menu {
  left: 0 !important;
  right: auto !important;
}
.kb-labfront.container .ui.dropdown > .menu .loading.menu {
  left: 100% !important;
  right: auto !important;
}
.kb-labfront.container .ui.dropdown.selected,
.kb-labfront.container .ui.dropdown .menu .selected.item {
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.dropdown > .filtered.text {
  visibility: hidden;
}
.kb-labfront.container .ui.dropdown .filtered.item {
  display: none !important;
}
.kb-labfront.container .ui.dropdown.error,
.kb-labfront.container .ui.dropdown.error > .text,
.kb-labfront.container .ui.dropdown.error > .default.text {
  color: #9f3a38;
}
.kb-labfront.container .ui.selection.dropdown.error {
  background: #fff6f6;
  border-color: #e0b4b4;
}
.kb-labfront.container .ui.selection.dropdown.error:hover {
  border-color: #e0b4b4;
}
.kb-labfront.container .ui.dropdown.error > .menu,
.kb-labfront.container .ui.dropdown.error > .menu .menu {
  border-color: #e0b4b4;
}
.kb-labfront.container .ui.dropdown.error > .menu > .item {
  color: #9f3a38;
}
.kb-labfront.container .ui.multiple.selection.error.dropdown > .label {
  border-color: #e0b4b4;
}
.kb-labfront.container .ui.dropdown.error > .menu > .item:hover {
  background-color: #fff2f2;
}
.kb-labfront.container .ui.dropdown.error > .menu .active.item {
  background-color: #fdcfcf;
}
.kb-labfront.container .ui.dropdown > .clear.dropdown.icon {
  opacity: 0.8;
  transition: opacity 0.1s ease;
}
.kb-labfront.container .ui.dropdown > .clear.dropdown.icon:hover {
  opacity: 1;
}
.kb-labfront.container .ui.disabled.dropdown,
.kb-labfront.container .ui.dropdown .menu > .disabled.item {
  cursor: default;
  pointer-events: none;
  opacity: 0.45;
}
.kb-labfront.container .ui.dropdown .menu {
  left: 0;
}
.kb-labfront.container .ui.dropdown .right.menu > .menu,
.kb-labfront.container .ui.dropdown .menu .right.menu {
  left: 100% !important;
  right: auto !important;
  border-radius: 0.2857142857rem !important;
}
.kb-labfront.container .ui.dropdown > .left.menu {
  left: auto !important;
  right: 0 !important;
}
.kb-labfront.container .ui.dropdown > .left.menu .menu,
.kb-labfront.container .ui.dropdown .menu .left.menu {
  left: auto;
  right: 100%;
  margin: 0 -0.5em 0 0 !important;
  border-radius: 0.2857142857rem !important;
}
.kb-labfront.container .ui.dropdown .item .left.dropdown.icon,
.kb-labfront.container .ui.dropdown .left.menu .item .dropdown.icon {
  width: auto;
  float: left;
  margin: 0em 0 0 0;
}
.kb-labfront.container .ui.dropdown .item .left.dropdown.icon,
.kb-labfront.container .ui.dropdown .left.menu .item .dropdown.icon {
  width: auto;
  float: left;
  margin: 0em 0 0 0;
}
.kb-labfront.container .ui.dropdown .item .left.dropdown.icon + .text,
.kb-labfront.container .ui.dropdown .left.menu .item .dropdown.icon + .text {
  margin-left: 1em;
  margin-right: 0;
}
.kb-labfront.container .ui.upward.dropdown > .menu {
  top: auto;
  bottom: 100%;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08);
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.dropdown .upward.menu {
  top: auto !important;
  bottom: 0 !important;
}
.kb-labfront.container .ui.simple.upward.active.dropdown,
.kb-labfront.container .ui.simple.upward.dropdown:hover {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0 !important;
}
.kb-labfront.container .ui.upward.dropdown.button:not(.pointing):not(.floating).active {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.upward.selection.dropdown .menu {
  border-top-width: 1px !important;
  border-bottom-width: 0 !important;
  box-shadow: 0 -2px 3px 0 rgba(0, 0, 0, 0.08);
}
.kb-labfront.container .ui.upward.selection.dropdown:hover {
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.05);
}
.kb-labfront.container .ui.active.upward.selection.dropdown {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem !important;
}
.kb-labfront.container .ui.upward.selection.dropdown.visible {
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08);
  border-radius: 0 0 0.2857142857rem 0.2857142857rem !important;
}
.kb-labfront.container .ui.upward.active.selection.dropdown:hover {
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.05);
}
.kb-labfront.container .ui.upward.active.selection.dropdown:hover .menu {
  box-shadow: 0 -2px 3px 0 rgba(0, 0, 0, 0.08);
}
.kb-labfront.container .ui.scrolling.dropdown .menu,
.kb-labfront.container .ui.dropdown .scrolling.menu {
  overflow-x: hidden;
  overflow-y: auto;
}
.kb-labfront.container .ui.scrolling.dropdown .menu {
  overflow-x: hidden;
  overflow-y: auto;
  backface-visibility: hidden;
  -webkit-overflow-scrolling: touch;
  min-width: 100% !important;
  width: auto !important;
}
.kb-labfront.container .ui.dropdown .scrolling.menu {
  position: static;
  overflow-y: auto;
  border: none;
  box-shadow: none !important;
  border-radius: 0 !important;
  margin: 0 !important;
  min-width: 100% !important;
  width: auto !important;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.scrolling.dropdown .menu .item.item.item,
.kb-labfront.container .ui.dropdown .scrolling.menu > .item.item.item {
  border-top: none;
}
.kb-labfront.container .ui.scrolling.dropdown .menu .item:first-child,
.kb-labfront.container .ui.dropdown .scrolling.menu .item:first-child {
  border-top: none;
}
.kb-labfront.container .ui.dropdown > .animating.menu .scrolling.menu,
.kb-labfront.container .ui.dropdown > .visible.menu .scrolling.menu {
  display: block;
}
@media all and (-ms-high-contrast: none) {
  .kb-labfront.container .ui.scrolling.dropdown .menu,
  .kb-labfront.container .ui.dropdown .scrolling.menu {
    min-width: calc(100% - 17px);
  }
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.scrolling.dropdown .menu,
  .kb-labfront.container .ui.dropdown .scrolling.menu {
    max-height: 10.2857142857em;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.scrolling.dropdown .menu,
  .kb-labfront.container .ui.dropdown .scrolling.menu {
    max-height: 15.4285714286em;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.scrolling.dropdown .menu,
  .kb-labfront.container .ui.dropdown .scrolling.menu {
    max-height: 20.5714285714em;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.scrolling.dropdown .menu,
  .kb-labfront.container .ui.dropdown .scrolling.menu {
    max-height: 20.5714285714em;
  }
}
.kb-labfront.container .ui.dropdown[class*="two column"] > .menu > .item {
  display: inline-block;
  width: 50%;
}
.kb-labfront.container .ui.dropdown[class*="three column"] > .menu > .item {
  display: inline-block;
  width: 33%;
}
.kb-labfront.container .ui.dropdown[class*="four column"] > .menu > .item {
  display: inline-block;
  width: 25%;
}
.kb-labfront.container .ui.dropdown[class*="five column"] > .menu > .item {
  display: inline-block;
  width: 20%;
}
.kb-labfront.container .ui.simple.dropdown .menu:before,
.kb-labfront.container .ui.simple.dropdown .menu:after {
  display: none;
}
.kb-labfront.container .ui.simple.dropdown .menu {
  position: absolute;
  /* IE hack to make dropdown icons appear inline */
  display: -ms-inline-flexbox !important;
  display: block;
  overflow: hidden;
  top: -9999px;
  opacity: 0;
  width: 0;
  height: 0;
  transition: opacity 0.1s ease;
  margin-top: 0 !important;
}
.kb-labfront.container .ui.simple.active.dropdown,
.kb-labfront.container .ui.simple.dropdown:hover {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.kb-labfront.container .ui.simple.active.dropdown > .menu,
.kb-labfront.container .ui.simple.dropdown:hover > .menu {
  overflow: visible;
  width: auto;
  height: auto;
  top: 100%;
  opacity: 1;
}
.kb-labfront.container .ui.simple.dropdown > .menu > .item:active > .menu,
.kb-labfront.container .ui.simple.dropdown:hover > .menu > .item:hover > .menu {
  overflow: visible;
  width: auto;
  height: auto;
  top: 0 !important;
  left: 100% !important;
  opacity: 1;
}
.kb-labfront.container .ui.simple.disabled.dropdown:hover .menu {
  display: none;
  height: 0;
  width: 0;
  overflow: hidden;
}
.kb-labfront.container .ui.simple.visible.dropdown > .menu {
  display: block;
}
.kb-labfront.container .ui.simple.scrolling.active.dropdown > .menu,
.kb-labfront.container .ui.simple.scrolling.dropdown:hover > .menu {
  overflow-x: hidden;
  overflow-y: auto;
}
.kb-labfront.container .ui.fluid.dropdown {
  display: block;
  width: 100% !important;
  min-width: 0;
}
.kb-labfront.container .ui.fluid.dropdown > .dropdown.icon {
  float: right;
}
.kb-labfront.container .ui.floating.dropdown .menu {
  left: 0;
  right: auto;
  box-shadow: 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15) !important;
  border-radius: 0.2857142857rem !important;
}
.kb-labfront.container .ui.floating.dropdown > .menu {
  border-radius: 0.2857142857rem !important;
}
.kb-labfront.container .ui:not(.upward).floating.dropdown > .menu {
  margin-top: 0.5em;
}
.kb-labfront.container .ui.upward.floating.dropdown > .menu {
  margin-bottom: 0.5em;
}
.kb-labfront.container .ui.pointing.dropdown > .menu {
  top: 100%;
  margin-top: 0.7857142857rem;
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.pointing.dropdown > .menu:not(.hidden):after {
  top: -0.25em;
  left: 50%;
  margin: 0 0 0 -0.25em;
  display: block;
  position: absolute;
  pointer-events: none;
  content: "";
  visibility: visible;
  transform: rotate(45deg);
  width: 0.5em;
  height: 0.5em;
  box-shadow: -1px -1px 0 0 rgba(34, 36, 38, 0.15);
  background: #ffffff;
  z-index: 2;
}
.kb-labfront.container .ui.top.left.pointing.dropdown > .menu {
  top: 100%;
  bottom: auto;
  left: 0;
  right: auto;
  margin: 1em 0 0;
}
.kb-labfront.container .ui.top.left.pointing.dropdown > .menu {
  top: 100%;
  bottom: auto;
  left: 0;
  right: auto;
  margin: 1em 0 0;
}
.kb-labfront.container .ui.top.left.pointing.dropdown > .menu:after {
  top: -0.25em;
  left: 1em;
  right: auto;
  margin: 0;
  transform: rotate(45deg);
}
.kb-labfront.container .ui.top.right.pointing.dropdown > .menu {
  top: 100%;
  bottom: auto;
  right: 0;
  left: auto;
  margin: 1em 0 0;
}
.kb-labfront.container .ui.top.pointing.dropdown > .left.menu:after,
.kb-labfront.container .ui.top.right.pointing.dropdown > .menu:after {
  top: -0.25em;
  left: auto !important;
  right: 1em !important;
  margin: 0;
  transform: rotate(45deg);
}
.kb-labfront.container .ui.left.pointing.dropdown > .menu {
  top: 0;
  left: 100%;
  right: auto;
  margin: 0 0 0 1em;
}
.kb-labfront.container .ui.left.pointing.dropdown > .menu:after {
  top: 1em;
  left: -0.25em;
  margin: 0 0 0 0;
  transform: rotate(-45deg);
}
.kb-labfront.container .ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu {
  left: auto !important;
  right: 100% !important;
  margin: 0 1em 0 0;
}
.kb-labfront.container .ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu:after {
  top: 1em;
  left: auto;
  right: -0.25em;
  margin: 0 0 0 0;
  transform: rotate(135deg);
}
.kb-labfront.container .ui.right.pointing.dropdown > .menu {
  top: 0;
  left: auto;
  right: 100%;
  margin: 0 1em 0 0;
}
.kb-labfront.container .ui.right.pointing.dropdown > .menu:after {
  top: 1em;
  left: auto;
  right: -0.25em;
  margin: 0 0 0 0;
  transform: rotate(135deg);
}
.kb-labfront.container .ui.bottom.pointing.dropdown > .menu {
  top: auto;
  bottom: 100%;
  left: 0;
  right: auto;
  margin: 0 0 1em;
}
.kb-labfront.container .ui.bottom.pointing.dropdown > .menu:after {
  top: auto;
  bottom: -0.25em;
  right: auto;
  margin: 0;
  transform: rotate(-135deg);
}
.kb-labfront.container .ui.bottom.pointing.dropdown > .menu .menu {
  top: auto !important;
  bottom: 0 !important;
}
.kb-labfront.container .ui.bottom.left.pointing.dropdown > .menu {
  left: 0;
  right: auto;
}
.kb-labfront.container .ui.bottom.left.pointing.dropdown > .menu:after {
  left: 1em;
  right: auto;
}
.kb-labfront.container .ui.bottom.right.pointing.dropdown > .menu {
  right: 0;
  left: auto;
}
.kb-labfront.container .ui.bottom.right.pointing.dropdown > .menu:after {
  left: auto;
  right: 1em;
}
.kb-labfront.container .ui.pointing.upward.dropdown .menu,
.kb-labfront.container .ui.top.pointing.upward.dropdown .menu {
  top: auto !important;
  bottom: 100% !important;
  margin: 0 0 0.7857142857rem;
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.pointing.upward.dropdown .menu:after,
.kb-labfront.container .ui.top.pointing.upward.dropdown .menu:after {
  top: 100% !important;
  bottom: auto !important;
  box-shadow: 1px 1px 0 0 rgba(34, 36, 38, 0.15);
  margin: -0.25em 0 0;
}
.kb-labfront.container .ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu {
  top: auto !important;
  bottom: 0 !important;
  margin: 0 1em 0 0;
}
.kb-labfront.container .ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {
  top: auto !important;
  bottom: 0 !important;
  margin: 0 0 1em 0;
  box-shadow: -1px -1px 0 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu {
  top: auto !important;
  bottom: 0 !important;
  margin: 0 0 0 1em;
}
.kb-labfront.container .ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {
  top: auto !important;
  bottom: 0 !important;
  margin: 0 0 1em 0;
  box-shadow: -1px -1px 0 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.mini.dropdown {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.dropdown {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.dropdown {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.dropdown {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.dropdown {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.dropdown {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.dropdown {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.dropdown {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.mini.dropdown .menu > .item {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.dropdown .menu > .item {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.dropdown .menu > .item {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.dropdown .menu > .item {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.dropdown .menu > .item {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.big.dropdown .menu > .item {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.huge.dropdown .menu > .item {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.dropdown .menu > .item {
  font-size: 1.7142857143rem;
}
.kb-labfront.container .ui.inverted.dropdown .menu {
  background: #1b1c1d;
  box-shadow: none;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.kb-labfront.container .ui.inverted.dropdown .menu > .item {
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.dropdown .menu .active.item {
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  box-shadow: none;
}
.kb-labfront.container .ui.inverted.dropdown .menu > .item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.dropdown.selected,
.kb-labfront.container .ui.inverted.dropdown .menu .selected.item {
  background: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.dropdown .menu > .header {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.dropdown > .text > .description,
.kb-labfront.container .ui.inverted.dropdown .menu > .item > .description {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.inverted.dropdown .menu > .divider {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.kb-labfront.container .ui.inverted.dropdown .scrolling.menu {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.kb-labfront.container .ui.inverted.dropdown:not(.button) > .default.text,
.kb-labfront.container .ui.inverted.default.dropdown:not(.button) > .text {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.inverted.dropdown:not(.button) > input:focus ~ .default.text,
.kb-labfront.container .ui.inverted.default.dropdown:not(.button) > input:focus ~ .text {
  color: rgba(255, 255, 255, 0.7);
}
.kb-labfront.container .ui.inverted.active.search.dropdown input.search:focus + .text .icon,
.kb-labfront.container .ui.inverted.active.search.dropdown input.search:focus + .text .flag {
  opacity: 0.45;
}
.kb-labfront.container .ui.inverted.active.search.dropdown input.search:focus + .text {
  color: rgba(255, 255, 255, 0.7) !important;
}
.kb-labfront.container .ui.inverted.selection.dropdown {
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: #1b1c1d;
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.selection.dropdown input {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.selection.dropdown:hover {
  border-color: rgba(255, 255, 255, 0.25);
  box-shadow: none;
}
.kb-labfront.container .ui.inverted.selection.active.dropdown .menu,
.kb-labfront.container .ui.inverted.selection.active.dropdown:hover {
  border-color: rgba(255, 255, 255, 0.15);
}
.kb-labfront.container .ui.inverted.selection.dropdown .menu > .item {
  border-top: 1px solid #242526;
}
.kb-labfront.container .ui.inverted.selection.visible.dropdown > .text:not(.default) {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.dropdown .menu > .message:not(.ui) {
  color: rgba(255, 255, 255, 0.5);
}
.kb-labfront.container .ui.inverted.dropdown .menu > .item:first-child {
  border-top-width: 0;
}
.kb-labfront.container .ui.inverted.multiple.dropdown > .label {
  background-color: rgba(255, 255, 255, 0.7);
  background-image: none;
  color: rgb(0, 0, 0);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0) inset;
}
.kb-labfront.container .ui.inverted.multiple.dropdown > .label:hover {
  background-color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.9);
  background-image: none;
  color: rgb(0, 0, 0);
}
.kb-labfront.container .ui.inverted.multiple.dropdown > .label > .close.icon,
.kb-labfront.container .ui.inverted.multiple.dropdown > .label > .delete.icon {
  opacity: 0.6;
}
.kb-labfront.container .ui.inverted.multiple.dropdown > .label > .close.icon:hover,
.kb-labfront.container .ui.inverted.multiple.dropdown > .label > .delete.icon:hover {
  opacity: 0.8;
}
.kb-labfront.container .ui.inverted.dropdown textarea::-webkit-selection,
.kb-labfront.container .ui.inverted.dropdown input::-webkit-selection {
  background-color: rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.dropdown textarea::-moz-selection,
.kb-labfront.container .ui.inverted.dropdown input::-moz-selection {
  background-color: rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.dropdown textarea::selection,
.kb-labfront.container .ui.inverted.dropdown input::selection {
  background-color: rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.8);
}
.kb-labfront.container .ui.inverted.dropdown .menu::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}
.kb-labfront.container .ui.inverted.dropdown .menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}
.kb-labfront.container .ui.inverted.dropdown .menu::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 255, 255, 0.15);
}
.kb-labfront.container .ui.inverted.dropdown .menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}
.kb-labfront.container .ui.inverted.pointing.dropdown > .menu:after {
  background: #1b1c1d;
  box-shadow: -1px -1px 0 0 rgba(255, 255, 255, 0.15);
}
@font-face {
  font-family: "Dropdown";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
.kb-labfront.container .ui.dropdown > .dropdown.icon {
  font-family: "Dropdown";
  line-height: 1;
  height: 1em;
  width: 1.23em;
  backface-visibility: hidden;
  font-weight: normal;
  font-style: normal;
  text-align: center;
}
.kb-labfront.container .ui.dropdown > .dropdown.icon {
  width: auto;
}
.kb-labfront.container .ui.dropdown > .dropdown.icon:before {
  content: "\\f0d7";
}
.kb-labfront.container .ui.dropdown .menu .item .dropdown.icon:before {
  content: "\\f0da";
}
.kb-labfront.container .ui.dropdown .item .left.dropdown.icon:before,
.kb-labfront.container .ui.dropdown .left.menu .item .dropdown.icon:before {
  content: "\\f0d9";
}
.kb-labfront.container .ui.vertical.menu .dropdown.item > .dropdown.icon:before {
  content: "\\f0da";
}
.kb-labfront.container .ui.embed {
  position: relative;
  max-width: 100%;
  height: 0;
  overflow: hidden;
  background: #dcddde;
  padding-bottom: 56.25%;
}
.kb-labfront.container .ui.embed iframe,
.kb-labfront.container .ui.embed embed,
.kb-labfront.container .ui.embed object {
  position: absolute;
  border: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.kb-labfront.container .ui.embed > .embed {
  display: none;
}
.kb-labfront.container .ui.embed > .placeholder {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));
}
.kb-labfront.container .ui.embed > .icon {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.kb-labfront.container .ui.embed > .icon:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  content: "";
  background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));
  opacity: 0.5;
  transition: opacity 0.5s ease;
}
.kb-labfront.container .ui.embed > .icon:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  color: #ffffff;
  font-size: 6rem;
  text-shadow: 0 2px 10px rgba(34, 36, 38, 0.2);
  transition: opacity 0.5s ease, color 0.5s ease;
  z-index: 10;
}
.kb-labfront.container .ui.embed .icon:hover:after {
  background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3));
  opacity: 1;
}
.kb-labfront.container .ui.embed .icon:hover:before {
  color: #ffffff;
}
.kb-labfront.container .ui.active.embed > .icon,
.kb-labfront.container .ui.active.embed > .placeholder {
  display: none;
}
.kb-labfront.container .ui.active.embed > .embed {
  display: block;
}
.kb-labfront.container .ui.square.embed {
  padding-bottom: 100%;
}
.kb-labfront.container .ui[class*="4:3"].embed {
  padding-bottom: 75%;
}
.kb-labfront.container .ui[class*="16:9"].embed {
  padding-bottom: 56.25%;
}
.kb-labfront.container .ui[class*="21:9"].embed {
  padding-bottom: 42.8571428571%;
}
.kb-labfront.container .ui.modal {
  position: absolute;
  display: none;
  z-index: 1001;
  text-align: left;
  background: #ffffff;
  border: none;
  box-shadow: 1px 3px 3px 0 rgba(0, 0, 0, 0.2), 1px 3px 15px 2px rgba(0, 0, 0, 0.2);
  transform-origin: 50% 25%;
  flex: 0 0 auto;
  border-radius: 0.2857142857rem;
  user-select: text;
  will-change: top, left, margin, transform, opacity;
}
.kb-labfront.container .ui.modal > :first-child:not(.icon):not(.dimmer),
.kb-labfront.container .ui.modal > .icon:first-child + *,
.kb-labfront.container .ui.modal > .dimmer:first-child + *:not(.icon),
.kb-labfront.container .ui.modal > .dimmer:first-child + .icon + * {
  border-top-left-radius: 0.2857142857rem;
  border-top-right-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.modal > :last-child {
  border-bottom-left-radius: 0.2857142857rem;
  border-bottom-right-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.modal > .close {
  cursor: pointer;
  position: absolute;
  top: -2.5rem;
  right: -2.5rem;
  z-index: 1;
  opacity: 0.8;
  font-size: 1.25em;
  color: #ffffff;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0.625rem 0 0 0;
}
.kb-labfront.container .ui.modal > .close:hover {
  opacity: 1;
}
.kb-labfront.container .ui.modal > .header {
  display: block;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  background: #ffffff;
  margin: 0;
  padding: 1.25rem 1.5rem;
  box-shadow: none;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.modal > .header:not(.ui) {
  font-size: 1.4285714286rem;
  line-height: 1.2857142857em;
  font-weight: bold;
}
.kb-labfront.container .ui.modal > .content {
  display: block;
  width: 100%;
  font-size: 1em;
  line-height: 1.4;
  padding: 1.5rem;
  background: #FFFFFF;
}
.kb-labfront.container .ui.modal > .image.content {
  display: flex;
  flex-direction: row;
}
.kb-labfront.container .ui.modal > .content > .image {
  display: block;
  flex: 0 1 auto;
  width: "";
  align-self: start;
  max-width: 100%;
}
.kb-labfront.container .ui.modal > [class*="top aligned"] {
  align-self: start;
}
.kb-labfront.container .ui.modal > [class*="middle aligned"] {
  align-self: center;
}
.kb-labfront.container .ui.modal > [class*=stretched] {
  align-self: stretch;
}
.kb-labfront.container .ui.modal > .content > .description {
  display: block;
  flex: 1 0 auto;
  min-width: 0;
  align-self: start;
}
.kb-labfront.container .ui.modal > .content > .icon + .description,
.kb-labfront.container .ui.modal > .content > .image + .description {
  flex: 0 1 auto;
  min-width: "";
  width: auto;
  padding-left: 2em;
}
.kb-labfront.container .ui.modal > .content > .image > i.icon {
  margin: 0;
  opacity: 1;
  width: auto;
  line-height: 1;
  font-size: 8rem;
}
.kb-labfront.container .ui.modal > .actions {
  background: #f9fafb;
  padding: 1rem 1rem;
  border-top: 1px solid rgba(34, 36, 38, 0.15);
  text-align: right;
}
.kb-labfront.container .ui.modal .actions > .button {
  margin-left: 0.75em;
}
.kb-labfront.container .ui.basic.modal > .actions {
  border-top: none;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.modal:not(.fullscreen) {
    width: calc(95% - 1px);
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.modal:not(.fullscreen) {
    width: calc(88% - 1px);
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.modal:not(.fullscreen) {
    width: 850px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1200px) {
  .kb-labfront.container .ui.modal:not(.fullscreen) {
    width: 900px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.modal:not(.fullscreen) {
    width: 950px;
    margin: 0 0 0 0;
  }
}
@media only screen and (max-width: 991.98px) {
  .kb-labfront.container .ui.modal > .header {
    padding-right: 2.25rem;
  }
  .kb-labfront.container .ui.modal > .close {
    top: 1.0535em;
    right: 1rem;
    color: rgba(0, 0, 0, 0.87);
  }
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container {
    /*rtl:ignore*/
    /*rtl:ignore*/
    /* Let Buttons Stack */
  }
  .kb-labfront.container .ui.modal > .header {
    padding: 0.75rem 1rem !important;
    padding-right: 2.25rem !important;
  }
  .kb-labfront.container .ui.overlay.fullscreen.modal > .content.content.content {
    min-height: calc(100vh - 8.1rem);
  }
  .kb-labfront.container .ui.overlay.fullscreen.modal > .scrolling.content.content.content {
    max-height: calc(100vh - 8.1rem);
  }
  .kb-labfront.container .ui.modal > .content {
    display: block;
    padding: 1rem !important;
  }
  .kb-labfront.container .ui.modal > .close {
    top: 0.5rem !important;
    right: 0.5rem !important;
  }
  .kb-labfront.container .ui.modal .image.content {
    flex-direction: column;
  }
  .kb-labfront.container .ui.modal .content > .image {
    display: block;
    max-width: 100%;
    margin: 0 auto !important;
    text-align: center;
    padding: 0 0 1rem !important;
  }
  .kb-labfront.container .ui.modal > .content > .image > i.icon {
    font-size: 5rem;
    text-align: center;
  }
  .kb-labfront.container .ui.modal .content > .description {
    display: block;
    width: 100% !important;
    margin: 0 !important;
    padding: 1rem 0 !important;
    box-shadow: none;
  }
  .kb-labfront.container .ui.modal > .actions {
    padding: 1rem 1rem 0rem !important;
  }
  .kb-labfront.container .ui.modal .actions > .buttons,
  .kb-labfront.container .ui.modal .actions > .button {
    margin-bottom: 1rem;
  }
}
.kb-labfront.container .ui.inverted.dimmer > .ui.modal {
  box-shadow: 1px 3px 10px 2px rgba(0, 0, 0, 0.2);
}
.kb-labfront.container .ui.basic.modal {
  background-color: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none !important;
  color: #ffffff;
}
.kb-labfront.container .ui.basic.modal > .header,
.kb-labfront.container .ui.basic.modal > .content,
.kb-labfront.container .ui.basic.modal > .actions {
  background-color: transparent;
}
.kb-labfront.container .ui.basic.modal > .header {
  color: #ffffff;
}
.kb-labfront.container .ui.basic.modal > .close {
  top: 1rem;
  right: 1.5rem;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.dimmer > .basic.modal {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.inverted.dimmer > .ui.basic.modal > .header {
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.legacy.legacy.modal,
.kb-labfront.container .ui.legacy.legacy.page.dimmer > .ui.modal {
  left: 50% !important;
}
.kb-labfront.container .ui.legacy.legacy.modal:not(.aligned),
.kb-labfront.container .ui.legacy.legacy.page.dimmer > .ui.modal:not(.aligned) {
  top: 50%;
}
.kb-labfront.container .ui.legacy.legacy.page.dimmer > .ui.scrolling.modal:not(.aligned),
.kb-labfront.container .ui.page.dimmer > .ui.scrolling.legacy.legacy.modal:not(.aligned),
.kb-labfront.container .ui.top.aligned.legacy.legacy.page.dimmer > .ui.modal:not(.aligned),
.kb-labfront.container .ui.top.aligned.dimmer > .ui.legacy.legacy.modal:not(.aligned) {
  top: auto;
}
.kb-labfront.container .ui.legacy.overlay.fullscreen.modal {
  margin-top: -1rem !important;
}
.kb-labfront.container .ui.loading.modal {
  display: block;
  visibility: hidden;
  z-index: -1;
}
.kb-labfront.container .ui.active.modal {
  display: block;
}
.kb-labfront.container .ui.top.aligned.modal {
  top: 5vh;
}
.kb-labfront.container .ui.bottom.aligned.modal {
  bottom: 5vh;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.top.aligned.modal {
    top: 1rem;
  }
  .kb-labfront.container .ui.bottom.aligned.modal {
    bottom: 1rem;
  }
}
.kb-labfront.container .scrolling.dimmable.dimmed {
  overflow: hidden;
}
.kb-labfront.container .scrolling.dimmable > .dimmer {
  justify-content: flex-start;
  position: fixed;
}
.kb-labfront.container .scrolling.dimmable.dimmed > .dimmer {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.kb-labfront.container .modals.dimmer .ui.scrolling.modal:not(.fullscreen) {
  margin: 1rem auto;
}
.kb-labfront.container .scrolling.undetached.dimmable.dimmed {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.kb-labfront.container .scrolling.undetached.dimmable.dimmed > .dimmer {
  overflow: hidden;
}
.kb-labfront.container .scrolling.undetached.dimmable .ui.scrolling.modal:not(.fullscreen) {
  position: absolute;
  left: 50%;
  margin-top: 1rem !important;
}
.kb-labfront.container .ui.modal > .scrolling.content {
  max-height: calc(80vh - 10rem);
  overflow: auto;
}
.kb-labfront.container .ui.overlay.fullscreen.modal > .content {
  min-height: calc(100vh - 9.1rem);
}
.kb-labfront.container .ui.overlay.fullscreen.modal > .scrolling.content {
  max-height: calc(100vh - 9.1rem);
}
.kb-labfront.container .ui.fullscreen.modal {
  width: 95%;
  left: 2.5%;
  margin: 1em auto;
}
.kb-labfront.container .ui.overlay.fullscreen.modal {
  width: 100%;
  left: 0;
  margin: 0 auto;
  top: 0;
  border-radius: 0;
}
.kb-labfront.container .ui.fullscreen.modal > .header {
  padding-right: 2.25rem;
}
.kb-labfront.container .ui.fullscreen.modal > .close {
  top: 1.0535em;
  right: 1rem;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.basic.fullscreen.modal > .close {
  color: #ffffff;
}
.kb-labfront.container .ui.modal {
  font-size: 1rem;
}
.kb-labfront.container .ui.mini.modal > .header:not(.ui) {
  font-size: 1.3em;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.mini.modal {
    width: 95%;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.mini.modal {
    width: 35.2%;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.mini.modal {
    width: 340px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1200px) {
  .kb-labfront.container .ui.mini.modal {
    width: 360px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.mini.modal {
    width: 380px;
    margin: 0 0 0 0;
  }
}
.kb-labfront.container .ui.tiny.modal > .header:not(.ui) {
  font-size: 1.3em;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.tiny.modal {
    width: 95%;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.tiny.modal {
    width: 52.8%;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.tiny.modal {
    width: 510px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1200px) {
  .kb-labfront.container .ui.tiny.modal {
    width: 540px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.tiny.modal {
    width: 570px;
    margin: 0 0 0 0;
  }
}
.kb-labfront.container .ui.small.modal > .header:not(.ui) {
  font-size: 1.3em;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.small.modal {
    width: 95%;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.small.modal {
    width: 70.4%;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.small.modal {
    width: 680px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1200px) {
  .kb-labfront.container .ui.small.modal {
    width: 720px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.small.modal {
    width: 760px;
    margin: 0 0 0 0;
  }
}
.kb-labfront.container .ui.large.modal > .header {
  font-size: 1.6em;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.large.modal {
    width: 95%;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 768px) {
  .kb-labfront.container .ui.large.modal {
    width: 88%;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 992px) {
  .kb-labfront.container .ui.large.modal {
    width: 1020px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1200px) {
  .kb-labfront.container .ui.large.modal {
    width: 1080px;
    margin: 0 0 0 0;
  }
}
@media only screen and (min-width: 1920px) {
  .kb-labfront.container .ui.large.modal {
    width: 1140px;
    margin: 0 0 0 0;
  }
}
.kb-labfront.container .ui.inverted.modal {
  background: rgba(0, 0, 0, 0.9);
}
.kb-labfront.container .ui.inverted.modal > .header,
.kb-labfront.container .ui.inverted.modal > .content {
  background: rgba(0, 0, 0, 0.9);
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.modal > .actions {
  background: #191A1B;
  border-top: 1px solid rgba(34, 36, 38, 0.85);
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.dimmer > .modal > .close {
  color: rgba(0, 0, 0, 0.85);
}
@media only screen and (max-width: 991.98px) {
  .kb-labfront.container .ui.dimmer .inverted.modal > .close {
    color: #ffffff;
  }
}
.kb-labfront.container .ui.inverted.fullscreen.modal > .close {
  color: #ffffff;
}
.kb-labfront.container .ui.nag {
  display: none;
  opacity: 0.95;
  position: relative;
  top: 0;
  left: 0;
  z-index: 999;
  min-height: 0;
  width: 100%;
  margin: 0;
  padding: 0.75em 1em;
  background: #555555;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  font-size: 1rem;
  text-align: center;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
  transition: 0.2s background ease;
}
.kb-labfront.container a.ui.nag {
  cursor: pointer;
}
.kb-labfront.container .ui.nag > .title {
  display: inline-block;
  margin: 0 0.5em;
  color: #ffffff;
}
.kb-labfront.container .ui.nag > .close.icon {
  cursor: pointer;
  opacity: 0.4;
  position: absolute;
  top: 50%;
  right: 1em;
  font-size: 1em;
  margin: -0.5em 0 0;
  color: #ffffff;
  transition: opacity 0.2s ease;
}
.kb-labfront.container .ui.nag:hover {
  background: #555555;
  opacity: 1;
}
.kb-labfront.container .ui.nag .close:hover {
  opacity: 1;
}
.kb-labfront.container .ui.overlay.nag {
  position: absolute;
  display: block;
}
.kb-labfront.container .ui.fixed.nag {
  position: fixed;
}
.kb-labfront.container .ui.bottom.nags,
.kb-labfront.container .ui.bottom.nag {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
  top: auto;
  bottom: 0;
}
.kb-labfront.container .ui.inverted.nags .nag,
.kb-labfront.container .ui.inverted.nag {
  background-color: #f3f4f5;
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.inverted.nags .nag .close,
.kb-labfront.container .ui.inverted.nags .nag .title,
.kb-labfront.container .ui.inverted.nag .close,
.kb-labfront.container .ui.inverted.nag .title {
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.nags .nag {
  border-radius: 0 !important;
}
.kb-labfront.container .ui.nags .nag:last-child {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.bottom.nags .nag:last-child {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.popup {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  /* Fixes content being squished when inline (moz only) */
  min-width: min-content;
  z-index: 1900;
  border: 1px solid #d4d4d5;
  line-height: 1.4285em;
  max-width: 250px;
  background: #ffffff;
  padding: 0.833em 1em;
  font-weight: normal;
  font-style: normal;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.2857142857rem;
  box-shadow: 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.popup > .header {
  padding: 0;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 1.1428571429em;
  line-height: 1.2;
  font-weight: bold;
}
.kb-labfront.container .ui.popup > .header + .content {
  padding-top: 0.5em;
}
.kb-labfront.container .ui.popup:before {
  position: absolute;
  content: "";
  width: 0.7142857143em;
  height: 0.7142857143em;
  background: #ffffff;
  transform: rotate(45deg);
  z-index: 1901;
  box-shadow: 1px 1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container [data-tooltip] {
  position: relative;
}
.kb-labfront.container [data-tooltip]:before {
  pointer-events: none;
  position: absolute;
  content: "";
  font-size: 1rem;
  width: 0.7142857143em;
  height: 0.7142857143em;
  background: #ffffff;
  transform: rotate(45deg);
  z-index: 1901;
  box-shadow: 1px 1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container [data-tooltip]:after {
  pointer-events: none;
  content: attr(data-tooltip);
  position: absolute;
  text-transform: none;
  text-align: left;
  white-space: nowrap;
  font-size: 1rem;
  border: 1px solid #d4d4d5;
  line-height: 1.4285em;
  max-width: none;
  background: #ffffff;
  padding: 0.833em 1em;
  font-weight: normal;
  font-style: normal;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 0.2857142857rem;
  box-shadow: 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
  z-index: 1900;
}
.kb-labfront.container [data-tooltip]:not([data-position]):before {
  top: auto;
  right: auto;
  bottom: 100%;
  left: 50%;
  background: #ffffff;
  margin-left: -0.0714285714rem;
  margin-bottom: 0.1428571429rem;
}
.kb-labfront.container [data-tooltip]:not([data-position]):after {
  left: 50%;
  transform: translateX(-50%);
  bottom: 100%;
  margin-bottom: 0.5em;
}
.kb-labfront.container [data-tooltip]:before,
.kb-labfront.container [data-tooltip]:after {
  pointer-events: none;
  visibility: hidden;
}
.kb-labfront.container [data-tooltip]:before {
  opacity: 0;
  transform: rotate(45deg) scale(0) !important;
  transform-origin: center top;
  transition: all 0.1s ease;
}
.kb-labfront.container [data-tooltip]:after {
  opacity: 1;
  transform-origin: center bottom;
  transition: all 0.1s ease;
}
.kb-labfront.container [data-tooltip]:hover:before,
.kb-labfront.container [data-tooltip]:hover:after {
  visibility: visible;
  pointer-events: auto;
}
.kb-labfront.container [data-tooltip]:hover:before {
  transform: rotate(45deg) scale(1) !important;
  opacity: 1;
}
.kb-labfront.container [data-tooltip]:after,
.kb-labfront.container [data-tooltip][data-position="top center"]:after,
.kb-labfront.container [data-tooltip][data-position="bottom center"]:after {
  transform: translateX(-50%) scale(0) !important;
}
.kb-labfront.container [data-tooltip]:hover:after,
.kb-labfront.container [data-tooltip][data-position="bottom center"]:hover:after {
  transform: translateX(-50%) scale(1) !important;
}
.kb-labfront.container [data-tooltip][data-position="left center"]:after,
.kb-labfront.container [data-tooltip][data-position="right center"]:after {
  transform: translateY(-50%) scale(0) !important;
}
.kb-labfront.container [data-tooltip][data-position="left center"]:hover:after,
.kb-labfront.container [data-tooltip][data-position="right center"]:hover:after {
  transform: translateY(-50%) scale(1) !important;
}
.kb-labfront.container [data-tooltip][data-position="top left"]:after,
.kb-labfront.container [data-tooltip][data-position="top right"]:after,
.kb-labfront.container [data-tooltip][data-position="bottom left"]:after,
.kb-labfront.container [data-tooltip][data-position="bottom right"]:after {
  transform: scale(0) !important;
}
.kb-labfront.container [data-tooltip][data-position="top left"]:hover:after,
.kb-labfront.container [data-tooltip][data-position="top right"]:hover:after,
.kb-labfront.container [data-tooltip][data-position="bottom left"]:hover:after,
.kb-labfront.container [data-tooltip][data-position="bottom right"]:hover:after {
  transform: scale(1) !important;
}
.kb-labfront.container [data-tooltip][data-inverted]:before {
  box-shadow: none !important;
}
.kb-labfront.container [data-tooltip][data-inverted]:before {
  background: #1b1c1d;
}
.kb-labfront.container [data-tooltip][data-inverted]:after {
  background: #1b1c1d;
  color: #ffffff;
  border: none;
  box-shadow: none;
}
.kb-labfront.container [data-tooltip][data-inverted]:after .header {
  background: none;
  color: #ffffff;
}
.kb-labfront.container [data-position="top center"][data-tooltip]:after {
  top: auto;
  right: auto;
  left: 50%;
  bottom: 100%;
  transform: translateX(-50%);
  margin-bottom: 0.5em;
}
.kb-labfront.container [data-position="top center"][data-tooltip]:before {
  top: auto;
  right: auto;
  bottom: 100%;
  left: 50%;
  background: #ffffff;
  margin-left: -0.0714285714rem;
  margin-bottom: 0.1428571429rem;
}
.kb-labfront.container [data-position="top left"][data-tooltip]:after {
  top: auto;
  right: auto;
  left: 0;
  bottom: 100%;
  margin-bottom: 0.5em;
}
.kb-labfront.container [data-position="top left"][data-tooltip]:before {
  top: auto;
  right: auto;
  bottom: 100%;
  left: 1em;
  margin-left: -0.0714285714rem;
  margin-bottom: 0.1428571429rem;
}
.kb-labfront.container [data-position="top right"][data-tooltip]:after {
  top: auto;
  left: auto;
  right: 0;
  bottom: 100%;
  margin-bottom: 0.5em;
}
.kb-labfront.container [data-position="top right"][data-tooltip]:before {
  top: auto;
  left: auto;
  bottom: 100%;
  right: 1em;
  margin-left: -0.0714285714rem;
  margin-bottom: 0.1428571429rem;
}
.kb-labfront.container [data-position="bottom center"][data-tooltip]:after {
  bottom: auto;
  right: auto;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  margin-top: 0.5em;
}
.kb-labfront.container [data-position="bottom center"][data-tooltip]:before {
  bottom: auto;
  right: auto;
  top: 100%;
  left: 50%;
  margin-left: -0.0714285714rem;
  margin-top: 0.1428571429rem;
}
.kb-labfront.container [data-position="bottom left"][data-tooltip]:after {
  left: 0;
  top: 100%;
  margin-top: 0.5em;
}
.kb-labfront.container [data-position="bottom left"][data-tooltip]:before {
  bottom: auto;
  right: auto;
  top: 100%;
  left: 1em;
  margin-left: -0.0714285714rem;
  margin-top: 0.1428571429rem;
}
.kb-labfront.container [data-position="bottom right"][data-tooltip]:after {
  right: 0;
  top: 100%;
  margin-top: 0.5em;
}
.kb-labfront.container [data-position="bottom right"][data-tooltip]:before {
  bottom: auto;
  left: auto;
  top: 100%;
  right: 1em;
  margin-left: -0.1428571429rem;
  margin-top: 0.0714285714rem;
}
.kb-labfront.container [data-position="left center"][data-tooltip]:after {
  right: 100%;
  top: 50%;
  margin-right: 0.5em;
  transform: translateY(-50%);
}
.kb-labfront.container [data-position="left center"][data-tooltip]:before {
  right: 100%;
  top: 50%;
  margin-top: -0.1428571429rem;
  margin-right: -0.0714285714rem;
}
.kb-labfront.container [data-position="right center"][data-tooltip]:after {
  left: 100%;
  top: 50%;
  margin-left: 0.5em;
  transform: translateY(-50%);
}
.kb-labfront.container [data-position="right center"][data-tooltip]:before {
  left: 100%;
  top: 50%;
  margin-top: -0.0714285714rem;
  margin-left: 0.1428571429rem;
}
.kb-labfront.container [data-position~=bottom][data-tooltip]:before {
  background: #ffffff;
  box-shadow: -1px -1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container [data-position="left center"][data-tooltip]:before {
  background: #ffffff;
  box-shadow: 1px -1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container [data-position="right center"][data-tooltip]:before {
  background: #ffffff;
  box-shadow: -1px 1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container [data-position~=top][data-tooltip]:before {
  background: #ffffff;
}
.kb-labfront.container [data-inverted][data-position~=bottom][data-tooltip]:before {
  background: #1b1c1d;
  box-shadow: -1px -1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container [data-inverted][data-position="left center"][data-tooltip]:before {
  background: #1b1c1d;
  box-shadow: 1px -1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container [data-inverted][data-position="right center"][data-tooltip]:before {
  background: #1b1c1d;
  box-shadow: -1px 1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container [data-inverted][data-position~=top][data-tooltip]:before {
  background: #1b1c1d;
}
.kb-labfront.container [data-position~=bottom][data-tooltip]:before {
  transform-origin: center bottom;
}
.kb-labfront.container [data-position~=bottom][data-tooltip]:after {
  transform-origin: center top;
}
.kb-labfront.container [data-position="left center"][data-tooltip]:before {
  transform-origin: top center;
}
.kb-labfront.container [data-position="left center"][data-tooltip]:after {
  transform-origin: right center;
}
.kb-labfront.container [data-position="right center"][data-tooltip]:before {
  transform-origin: right center;
}
.kb-labfront.container [data-position="right center"][data-tooltip]:after {
  transform-origin: left center;
}
.kb-labfront.container [data-tooltip][data-variation~=mini]:before,
.kb-labfront.container [data-tooltip][data-variation~=mini]:after {
  font-size: 0.7857142857rem;
}
.kb-labfront.container [data-tooltip][data-variation~=tiny]:before,
.kb-labfront.container [data-tooltip][data-variation~=tiny]:after {
  font-size: 0.8571428571rem;
}
.kb-labfront.container [data-tooltip][data-variation~=small]:before,
.kb-labfront.container [data-tooltip][data-variation~=small]:after {
  font-size: 0.9285714286rem;
}
.kb-labfront.container [data-tooltip][data-variation~=medium]:before,
.kb-labfront.container [data-tooltip][data-variation~=medium]:after {
  font-size: 1rem;
}
.kb-labfront.container [data-tooltip][data-variation~=large]:before,
.kb-labfront.container [data-tooltip][data-variation~=large]:after {
  font-size: 1.1428571429rem;
}
.kb-labfront.container [data-tooltip][data-variation~=huge]:before,
.kb-labfront.container [data-tooltip][data-variation~=huge]:after {
  font-size: 1.4285714286rem;
}
.kb-labfront.container [data-tooltip][data-variation~=basic]:before {
  display: none;
}
.kb-labfront.container .ui.popup {
  margin: 0;
}
.kb-labfront.container .ui.top.popup {
  margin: 0 0 0.7142857143em;
}
.kb-labfront.container .ui.top.left.popup {
  transform-origin: left bottom;
}
.kb-labfront.container .ui.top.center.popup {
  transform-origin: center bottom;
}
.kb-labfront.container .ui.top.right.popup {
  transform-origin: right bottom;
}
.kb-labfront.container .ui.left.center.popup {
  margin: 0 0.7142857143em 0 0;
  transform-origin: right 50%;
}
.kb-labfront.container .ui.right.center.popup {
  margin: 0 0 0 0.7142857143em;
  transform-origin: left 50%;
}
.kb-labfront.container .ui.bottom.popup {
  margin: 0.7142857143em 0 0;
}
.kb-labfront.container .ui.bottom.left.popup {
  transform-origin: left top;
}
.kb-labfront.container .ui.bottom.center.popup {
  transform-origin: center top;
}
.kb-labfront.container .ui.bottom.right.popup {
  transform-origin: right top;
}
.kb-labfront.container .ui.bottom.center.popup:before {
  margin-left: -0.3071428571em;
  top: -0.3071428571em;
  left: 50%;
  right: auto;
  bottom: auto;
  box-shadow: -1px -1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container .ui.bottom.left.popup {
  margin-left: 0;
}
.kb-labfront.container .ui.bottom.left.popup:before {
  top: -0.3071428571em;
  left: 1em;
  right: auto;
  bottom: auto;
  margin-left: 0;
  box-shadow: -1px -1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container .ui.bottom.right.popup {
  margin-right: 0;
}
.kb-labfront.container .ui.bottom.right.popup:before {
  top: -0.3071428571em;
  right: 1em;
  bottom: auto;
  left: auto;
  margin-left: 0;
  box-shadow: -1px -1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container .ui.top.center.popup:before {
  top: auto;
  right: auto;
  bottom: -0.3071428571em;
  left: 50%;
  margin-left: -0.3071428571em;
}
.kb-labfront.container .ui.top.left.popup {
  margin-left: 0;
}
.kb-labfront.container .ui.top.left.popup:before {
  bottom: -0.3071428571em;
  left: 1em;
  top: auto;
  right: auto;
  margin-left: 0;
}
.kb-labfront.container .ui.top.right.popup {
  margin-right: 0;
}
.kb-labfront.container .ui.top.right.popup:before {
  bottom: -0.3071428571em;
  right: 1em;
  top: auto;
  left: auto;
  margin-left: 0;
}
.kb-labfront.container .ui.left.center.popup:before {
  top: 50%;
  right: -0.3071428571em;
  bottom: auto;
  left: auto;
  margin-top: -0.3071428571em;
  box-shadow: 1px -1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container .ui.right.center.popup:before {
  top: 50%;
  left: -0.3071428571em;
  bottom: auto;
  right: auto;
  margin-top: -0.3071428571em;
  box-shadow: -1px 1px 0 0 rgb(186.2, 186.2, 187.8);
}
.kb-labfront.container .ui.bottom.popup:before {
  background: #ffffff;
}
.kb-labfront.container .ui.right.center.popup:before,
.kb-labfront.container .ui.left.center.popup:before {
  background: #ffffff;
}
.kb-labfront.container .ui.top.popup:before {
  background: #ffffff;
}
.kb-labfront.container .ui.inverted.bottom.popup:before {
  background: #1b1c1d;
}
.kb-labfront.container .ui.inverted.right.center.popup:before,
.kb-labfront.container .ui.inverted.left.center.popup:before {
  background: #1b1c1d;
}
.kb-labfront.container .ui.inverted.top.popup:before {
  background: #1b1c1d;
}
.kb-labfront.container .ui.popup > .ui.grid:not(.padded) {
  width: calc(100% + 1.75rem);
  margin: -0.7rem -0.875rem;
}
.kb-labfront.container .ui.loading.popup {
  display: block;
  visibility: hidden;
  z-index: -1;
}
.kb-labfront.container .ui.animating.popup,
.kb-labfront.container .ui.visible.popup {
  display: block;
}
.kb-labfront.container .ui.visible.popup {
  transform: translateZ(0);
  backface-visibility: hidden;
}
.kb-labfront.container .ui.basic.popup:before {
  display: none;
}
.kb-labfront.container .ui.wide.popup {
  max-width: 350px;
}
.kb-labfront.container .ui[class*="very wide"].popup {
  max-width: 550px;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.wide.popup,
  .kb-labfront.container .ui[class*="very wide"].popup {
    max-width: 250px;
  }
}
.kb-labfront.container .ui.fluid.popup {
  width: 100%;
  max-width: none;
}
.kb-labfront.container .ui.inverted.popup {
  background: #1b1c1d;
  color: #ffffff;
  border: none;
  box-shadow: none;
}
.kb-labfront.container .ui.inverted.popup .header {
  background-color: none;
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.popup:before {
  background-color: #1b1c1d;
  box-shadow: none !important;
}
.kb-labfront.container .ui.flowing.popup {
  max-width: none;
}
.kb-labfront.container .ui.mini.popup {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.popup {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.popup {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.popup {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.popup {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.huge.popup {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.progress {
  position: relative;
  display: block;
  max-width: 100%;
  border: none;
  margin: 1em 0 2.5em;
  box-shadow: none;
  background: rgba(0, 0, 0, 0.1);
  padding: 0;
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.progress:first-child {
  margin: 0 0 2.5em;
}
.kb-labfront.container .ui.progress:last-child {
  margin: 0 0 1.5em;
}
.kb-labfront.container .ui.progress .bar {
  display: block;
  line-height: 1;
  position: relative;
  width: 0;
  min-width: 2em;
  background: #888888;
  border-radius: 0.2857142857rem;
  transition: width 0.1s ease, background-color 0.1s ease;
  overflow: hidden;
}
.kb-labfront.container .ui.ui.ui.progress:not([data-percent]):not(.indeterminate) .bar,
.kb-labfront.container .ui.ui.ui.progress[data-percent="0"]:not(.indeterminate) .bar {
  background: transparent;
}
.kb-labfront.container .ui.progress[data-percent="0"] .bar .progress {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.inverted.progress[data-percent="0"] .bar .progress {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.progress .bar > .progress {
  white-space: nowrap;
  position: absolute;
  width: auto;
  font-size: 0.9285714286em;
  top: 50%;
  right: 0.5em;
  left: auto;
  bottom: auto;
  color: rgba(255, 255, 255, 0.7);
  text-shadow: none;
  margin-top: -0.5em;
  font-weight: bold;
  text-align: left;
}
.kb-labfront.container .ui.progress > .label {
  position: absolute;
  width: 100%;
  font-size: 1em;
  top: 100%;
  right: auto;
  left: 0;
  bottom: auto;
  color: rgba(0, 0, 0, 0.87);
  font-weight: bold;
  text-shadow: none;
  margin-top: 0.2em;
  text-align: center;
  transition: color 0.4s ease;
}
.kb-labfront.container .ui.indicating.progress[data-percent^="1"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent^="2"] .bar {
  background-color: #D95C5C;
}
.kb-labfront.container .ui.indicating.progress[data-percent^="3"] .bar {
  background-color: #EFBC72;
}
.kb-labfront.container .ui.indicating.progress[data-percent^="4"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent^="5"] .bar {
  background-color: #E6BB48;
}
.kb-labfront.container .ui.indicating.progress[data-percent^="6"] .bar {
  background-color: #DDC928;
}
.kb-labfront.container .ui.indicating.progress[data-percent^="7"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent^="8"] .bar {
  background-color: #B4D95C;
}
.kb-labfront.container .ui.indicating.progress[data-percent^="9"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent^="100"] .bar {
  background-color: #66DA81;
}
.kb-labfront.container .ui.indicating.progress[data-percent^="1"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent^="2"] .label {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.indicating.progress[data-percent^="3"] .label {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.indicating.progress[data-percent^="4"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent^="5"] .label {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.indicating.progress[data-percent^="6"] .label {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.indicating.progress[data-percent^="7"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent^="8"] .label {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.indicating.progress[data-percent^="9"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent^="100"] .label {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="1"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="2"] .label {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="3"] .label {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="4"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="5"] .label {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="6"] .label {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="7"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="8"] .label {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="9"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent^="100"] .label {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.indicating.progress[data-percent="1"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent="2"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent="3"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent="4"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent="5"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent="6"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent="7"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent="8"] .bar,
.kb-labfront.container .ui.indicating.progress[data-percent="9"] .bar {
  background-color: #D95C5C;
}
.kb-labfront.container .ui.indicating.progress[data-percent="0"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="1"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="2"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="3"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="4"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="5"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="6"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="7"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="8"] .label,
.kb-labfront.container .ui.indicating.progress[data-percent="9"] .label {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="0"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="1"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="2"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="3"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="4"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="5"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="6"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="7"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="8"] .label,
.kb-labfront.container .ui.inverted.indicating.progress[data-percent="9"] .label {
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .ui.ui.indicating.progress.success .label {
  color: #1a531b;
}
.kb-labfront.container .ui.multiple.progress {
  display: flex;
}
.kb-labfront.container .ui.ui.progress.success .bar {
  background-color: #21ba45;
}
.kb-labfront.container .ui.ui.progress.success .bar,
.kb-labfront.container .ui.ui.progress.success .bar::after {
  animation: none;
}
.kb-labfront.container .ui.progress.success > .label {
  color: #1a531b;
}
.kb-labfront.container .ui.ui.progress.warning .bar {
  background-color: #f2c037;
}
.kb-labfront.container .ui.ui.progress.warning .bar,
.kb-labfront.container .ui.ui.progress.warning .bar::after {
  animation: none;
}
.kb-labfront.container .ui.progress.warning > .label {
  color: #794b02;
}
.kb-labfront.container .ui.ui.progress.error .bar {
  background-color: #db2828;
}
.kb-labfront.container .ui.ui.progress.error .bar,
.kb-labfront.container .ui.ui.progress.error .bar::after {
  animation: none;
}
.kb-labfront.container .ui.progress.error > .label {
  color: #912d2b;
}
.kb-labfront.container .ui.active.progress .bar {
  position: relative;
  min-width: 2em;
}
.kb-labfront.container .ui.active.progress .bar::after {
  content: "";
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  border-radius: 0.2857142857rem;
  animation: progress-active 2s ease infinite;
  transform-origin: left;
}
@keyframes progress-active {
  0% {
    opacity: 0.3;
    transform: scale(0, 1);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
.kb-labfront.container .ui.disabled.progress {
  opacity: 0.35;
}
.kb-labfront.container .ui.ui.disabled.progress .bar,
.kb-labfront.container .ui.ui.disabled.progress .bar::after {
  animation: none;
}
.kb-labfront.container .ui.inverted.progress {
  background: rgba(255, 255, 255, 0.08);
  border: none;
}
.kb-labfront.container .ui.inverted.progress .bar {
  background: #888888;
}
.kb-labfront.container .ui.inverted.progress .bar > .progress {
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.progress > .label {
  color: #ffffff;
}
.kb-labfront.container .ui.inverted.progress.success > .label {
  color: #21ba45;
}
.kb-labfront.container .ui.inverted.progress.warning > .label {
  color: #f2c037;
}
.kb-labfront.container .ui.inverted.progress.error > .label {
  color: #db2828;
}
.kb-labfront.container .ui.progress.attached {
  background: transparent;
  position: relative;
  border: none;
  margin: 0;
}
.kb-labfront.container .ui.progress.attached,
.kb-labfront.container .ui.progress.attached .bar {
  display: block;
  height: 0.2rem;
  padding: 0;
  overflow: hidden;
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.progress.attached .bar {
  border-radius: 0;
}
.kb-labfront.container .ui.progress.top.attached,
.kb-labfront.container .ui.progress.top.attached .bar {
  top: 0;
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.progress.top.attached .bar {
  border-radius: 0;
}
.kb-labfront.container .ui.segment > .ui.attached.progress,
.kb-labfront.container .ui.card > .ui.attached.progress {
  position: absolute;
  top: auto;
  left: 0;
  bottom: 100%;
  width: 100%;
}
.kb-labfront.container .ui.segment > .ui.bottom.attached.progress,
.kb-labfront.container .ui.card > .ui.bottom.attached.progress {
  top: 100%;
  bottom: auto;
}
.kb-labfront.container .ui.indeterminate.primary.progress .bar::before,
.kb-labfront.container .ui.primary.progress .bar,
.kb-labfront.container .ui.progress .primary.bar {
  background-color: #2185d0;
}
.kb-labfront.container .ui.inverted.indeterminate.primary.progress .bar::before,
.kb-labfront.container .ui.primary.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .primary.bar {
  background-color: #54c8ff;
}
.kb-labfront.container .ui.indeterminate.secondary.progress .bar::before,
.kb-labfront.container .ui.secondary.progress .bar,
.kb-labfront.container .ui.progress .secondary.bar {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.indeterminate.secondary.progress .bar::before,
.kb-labfront.container .ui.secondary.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .secondary.bar {
  background-color: #545454;
}
.kb-labfront.container .ui.indeterminate.red.progress .bar::before,
.kb-labfront.container .ui.red.progress .bar,
.kb-labfront.container .ui.progress .red.bar {
  background-color: #db2828;
}
.kb-labfront.container .ui.inverted.indeterminate.red.progress .bar::before,
.kb-labfront.container .ui.red.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .red.bar {
  background-color: #ff695e;
}
.kb-labfront.container .ui.indeterminate.orange.progress .bar::before,
.kb-labfront.container .ui.orange.progress .bar,
.kb-labfront.container .ui.progress .orange.bar {
  background-color: #f2711c;
}
.kb-labfront.container .ui.inverted.indeterminate.orange.progress .bar::before,
.kb-labfront.container .ui.orange.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .orange.bar {
  background-color: #ff851b;
}
.kb-labfront.container .ui.indeterminate.yellow.progress .bar::before,
.kb-labfront.container .ui.yellow.progress .bar,
.kb-labfront.container .ui.progress .yellow.bar {
  background-color: #fbbd08;
}
.kb-labfront.container .ui.inverted.indeterminate.yellow.progress .bar::before,
.kb-labfront.container .ui.yellow.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .yellow.bar {
  background-color: #ffe21f;
}
.kb-labfront.container .ui.indeterminate.olive.progress .bar::before,
.kb-labfront.container .ui.olive.progress .bar,
.kb-labfront.container .ui.progress .olive.bar {
  background-color: #b5cc18;
}
.kb-labfront.container .ui.inverted.indeterminate.olive.progress .bar::before,
.kb-labfront.container .ui.olive.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .olive.bar {
  background-color: #d9e778;
}
.kb-labfront.container .ui.indeterminate.green.progress .bar::before,
.kb-labfront.container .ui.green.progress .bar,
.kb-labfront.container .ui.progress .green.bar {
  background-color: #21ba45;
}
.kb-labfront.container .ui.inverted.indeterminate.green.progress .bar::before,
.kb-labfront.container .ui.green.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .green.bar {
  background-color: #2ecc40;
}
.kb-labfront.container .ui.indeterminate.teal.progress .bar::before,
.kb-labfront.container .ui.teal.progress .bar,
.kb-labfront.container .ui.progress .teal.bar {
  background-color: #00b5ad;
}
.kb-labfront.container .ui.inverted.indeterminate.teal.progress .bar::before,
.kb-labfront.container .ui.teal.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .teal.bar {
  background-color: #6dffff;
}
.kb-labfront.container .ui.indeterminate.blue.progress .bar::before,
.kb-labfront.container .ui.blue.progress .bar,
.kb-labfront.container .ui.progress .blue.bar {
  background-color: #2185d0;
}
.kb-labfront.container .ui.inverted.indeterminate.blue.progress .bar::before,
.kb-labfront.container .ui.blue.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .blue.bar {
  background-color: #54c8ff;
}
.kb-labfront.container .ui.indeterminate.violet.progress .bar::before,
.kb-labfront.container .ui.violet.progress .bar,
.kb-labfront.container .ui.progress .violet.bar {
  background-color: #6435c9;
}
.kb-labfront.container .ui.inverted.indeterminate.violet.progress .bar::before,
.kb-labfront.container .ui.violet.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .violet.bar {
  background-color: #a291fb;
}
.kb-labfront.container .ui.indeterminate.purple.progress .bar::before,
.kb-labfront.container .ui.purple.progress .bar,
.kb-labfront.container .ui.progress .purple.bar {
  background-color: #a333c8;
}
.kb-labfront.container .ui.inverted.indeterminate.purple.progress .bar::before,
.kb-labfront.container .ui.purple.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .purple.bar {
  background-color: #dc73ff;
}
.kb-labfront.container .ui.indeterminate.pink.progress .bar::before,
.kb-labfront.container .ui.pink.progress .bar,
.kb-labfront.container .ui.progress .pink.bar {
  background-color: #e03997;
}
.kb-labfront.container .ui.inverted.indeterminate.pink.progress .bar::before,
.kb-labfront.container .ui.pink.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .pink.bar {
  background-color: #ff8edf;
}
.kb-labfront.container .ui.indeterminate.brown.progress .bar::before,
.kb-labfront.container .ui.brown.progress .bar,
.kb-labfront.container .ui.progress .brown.bar {
  background-color: #a5673f;
}
.kb-labfront.container .ui.inverted.indeterminate.brown.progress .bar::before,
.kb-labfront.container .ui.brown.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .brown.bar {
  background-color: #d67c1c;
}
.kb-labfront.container .ui.indeterminate.grey.progress .bar::before,
.kb-labfront.container .ui.grey.progress .bar,
.kb-labfront.container .ui.progress .grey.bar {
  background-color: #767676;
}
.kb-labfront.container .ui.inverted.indeterminate.grey.progress .bar::before,
.kb-labfront.container .ui.grey.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .grey.bar {
  background-color: #dcddde;
}
.kb-labfront.container .ui.indeterminate.black.progress .bar::before,
.kb-labfront.container .ui.black.progress .bar,
.kb-labfront.container .ui.progress .black.bar {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.indeterminate.black.progress .bar::before,
.kb-labfront.container .ui.black.inverted.progress .bar,
.kb-labfront.container .ui.inverted.progress .black.bar {
  background-color: #545454;
}
.kb-labfront.container .ui.tiny.progress {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.tiny.progress .bar {
  height: 0.5em;
}
.kb-labfront.container .ui.small.progress {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.small.progress .bar {
  height: 1em;
}
.kb-labfront.container .ui.progress {
  font-size: 1rem;
}
.kb-labfront.container .ui.progress .bar {
  height: 1.75em;
}
.kb-labfront.container .ui.large.progress {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.large.progress .bar {
  height: 2.5em;
}
.kb-labfront.container .ui.big.progress {
  font-size: 1.2857142857rem;
}
.kb-labfront.container .ui.big.progress .bar {
  height: 3.5em;
}
.kb-labfront.container .ui.indeterminate.progress .bar {
  width: 100%;
}
.kb-labfront.container .ui.indeterminate.progress .bar .progress,
.kb-labfront.container .ui.progress .bar .centered.progress {
  text-align: center;
  position: relative;
}
.kb-labfront.container .ui.indeterminate.progress .bar::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  border-radius: 0.2857142857rem;
  animation: progress-pulsating 2s ease infinite;
  transform-origin: center;
  width: 100%;
}
.kb-labfront.container .ui.slow.indeterminate.progress .bar::before {
  animation-duration: 4s;
}
.kb-labfront.container .ui.fast.indeterminate.progress .bar::before {
  animation-duration: 1s;
}
.kb-labfront.container .ui.swinging.indeterminate.progress .bar::before {
  transform-origin: left;
  animation-name: progress-swinging;
}
.kb-labfront.container .ui.sliding.indeterminate.progress .bar::before {
  transform-origin: left;
  animation-name: progress-sliding;
}
.kb-labfront.container .ui.filling.indeterminate.progress .bar::before {
  animation-name: progress-filling;
}
.kb-labfront.container .ui.indeterminate.progress:not(.sliding):not(.filling):not(.swinging) .bar::before {
  background: #ffffff;
}
.kb-labfront.container .ui.sliding.indeterminate.progress .bar,
.kb-labfront.container .ui.swinging.indeterminate.progress .bar,
.kb-labfront.container .ui.filling.indeterminate.progress .bar {
  background: rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.inverted.sliding.indeterminate.progress .bar,
.kb-labfront.container .ui.inverted.swinging.indeterminate.progress .bar,
.kb-labfront.container .ui.inverted.filling.indeterminate.progress .bar {
  background: rgba(255, 255, 255, 0.08);
}
.kb-labfront.container .ui.sliding.indeterminate.progress .bar .progress,
.kb-labfront.container .ui.swinging.indeterminate.progress .bar .progress {
  color: #1b1c1d;
}
.kb-labfront.container .ui.inverted.sliding.indeterminate.progress .bar .progress,
.kb-labfront.container .ui.inverted.swinging.indeterminate.progress .bar .progress {
  color: rgba(255, 255, 255, 0.7);
}
@keyframes progress-swinging {
  0%, 100% {
    width: 10%;
    left: -25%;
  }
  25%, 65% {
    width: 70%;
  }
  50% {
    width: 10%;
    left: 100%;
  }
}
@keyframes progress-sliding {
  0% {
    width: 10%;
    left: -25%;
  }
  50% {
    width: 70%;
  }
  100% {
    width: 10%;
    left: 100%;
  }
}
@keyframes progress-filling {
  0% {
    transform: scale(0, 1);
  }
  80% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes progress-pulsating {
  0% {
    transform: scale(0, 1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
.kb-labfront.container .ui.rating {
  display: inline-flex;
  white-space: nowrap;
  vertical-align: baseline;
}
.kb-labfront.container .ui.rating:last-child {
  margin-right: 0;
}
.kb-labfront.container .ui.rating .icon {
  padding: 0;
  margin: 0;
  text-align: center;
  font-weight: normal;
  font-style: normal;
  flex: 1 0 auto;
  cursor: pointer;
  width: 1.25em;
  height: auto;
  transition: opacity 0.1s ease, background 0.1s ease, text-shadow 0.1s ease, color 0.1s ease;
  line-height: 1;
  backface-visibility: hidden;
}
.kb-labfront.container .ui.rating .icon {
  background: transparent;
  color: rgba(0, 0, 0, 0.15);
}
.kb-labfront.container .ui.rating .active.icon {
  background: transparent;
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.rating .icon.selected,
.kb-labfront.container .ui.rating .icon.selected.active {
  background: transparent;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.primary.rating .active.icon {
  color: #54c8ff;
  text-shadow: 0px -1px 0px #2185d0, -1px 0px 0px #2185d0, 0px 1px 0px #2185d0, 1px 0px 0px #2185d0;
}
.kb-labfront.container .ui.primary.rating .icon.selected,
.kb-labfront.container .ui.primary.rating .icon.selected.active {
  color: rgb(33, 183.5964912281, 255);
  text-shadow: 0px -1px 0px rgb(18.7332987552, 120.4666716064, 196.7667012448), -1px 0px 0px rgb(18.7332987552, 120.4666716064, 196.7667012448), 0px 1px 0px rgb(18.7332987552, 120.4666716064, 196.7667012448), 1px 0px 0px rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.secondary.rating .active.icon {
  color: #545454;
  text-shadow: 0px -1px 0px #1b1c1d, -1px 0px 0px #1b1c1d, 0px 1px 0px #1b1c1d, 1px 0px 0px #1b1c1d;
}
.kb-labfront.container .ui.secondary.rating .icon.selected,
.kb-labfront.container .ui.secondary.rating .icon.selected.active {
  color: rgb(120.45, 98.55, 98.55);
  text-shadow: 0px -1px 0px rgb(35.2196428571, 40.75, 46.2803571429), -1px 0px 0px rgb(35.2196428571, 40.75, 46.2803571429), 0px 1px 0px rgb(35.2196428571, 40.75, 46.2803571429), 1px 0px 0px rgb(35.2196428571, 40.75, 46.2803571429);
}
.kb-labfront.container .ui.red.rating .active.icon {
  color: #ff695e;
  text-shadow: 0px -1px 0px #db2828, -1px 0px 0px #db2828, 0px 1px 0px #db2828, 1px 0px 0px #db2828;
}
.kb-labfront.container .ui.red.rating .icon.selected,
.kb-labfront.container .ui.red.rating .icon.selected.active {
  color: rgb(255, 57.4844720497, 43);
  text-shadow: 0px -1px 0px rgb(211.6849601594, 21.8150398406, 21.8150398406), -1px 0px 0px rgb(211.6849601594, 21.8150398406, 21.8150398406), 0px 1px 0px rgb(211.6849601594, 21.8150398406, 21.8150398406), 1px 0px 0px rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.orange.rating .active.icon {
  color: #ff851b;
  text-shadow: 0px -1px 0px #f2711c, -1px 0px 0px #f2711c, 0px 1px 0px #f2711c, 1px 0px 0px #f2711c;
}
.kb-labfront.container .ui.orange.rating .icon.selected,
.kb-labfront.container .ui.orange.rating .icon.selected.active {
  color: rgb(231, 107.3947368421, 0);
  text-shadow: 0px -1px 0px rgb(243.48125, 97.3239485981, 1.01875), -1px 0px 0px rgb(243.48125, 97.3239485981, 1.01875), 0px 1px 0px rgb(243.48125, 97.3239485981, 1.01875), 1px 0px 0px rgb(243.48125, 97.3239485981, 1.01875);
}
.kb-labfront.container .ui.yellow.rating .active.icon {
  color: #ffe21f;
  text-shadow: 0px -1px 0px #fbbd08, -1px 0px 0px #fbbd08, 0px 1px 0px #fbbd08, 1px 0px 0px #fbbd08;
}
.kb-labfront.container .ui.yellow.rating .icon.selected,
.kb-labfront.container .ui.yellow.rating .icon.selected.active {
  color: rgb(235, 204.5758928571, 0);
  text-shadow: 0px -1px 0px rgb(233.5, 173.9238683128, 0), -1px 0px 0px rgb(233.5, 173.9238683128, 0), 0px 1px 0px rgb(233.5, 173.9238683128, 0), 1px 0px 0px rgb(233.5, 173.9238683128, 0);
}
.kb-labfront.container .ui.olive.rating .active.icon {
  color: #d9e778;
  text-shadow: 0px -1px 0px #b5cc18, -1px 0px 0px #b5cc18, 0px 1px 0px #b5cc18, 1px 0px 0px #b5cc18;
}
.kb-labfront.container .ui.olive.rating .icon.selected,
.kb-labfront.container .ui.olive.rating .icon.selected.active {
  color: rgb(212.6626721061, 233.8018867925, 66.1981132075);
  text-shadow: 0px -1px 0px rgb(168.2940789474, 191.3092105263, 11.1907894737), -1px 0px 0px rgb(168.2940789474, 191.3092105263, 11.1907894737), 0px 1px 0px rgb(168.2940789474, 191.3092105263, 11.1907894737), 1px 0px 0px rgb(168.2940789474, 191.3092105263, 11.1907894737);
}
.kb-labfront.container .ui.green.rating .active.icon {
  color: #2ecc40;
  text-shadow: 0px -1px 0px #21ba45, -1px 0px 0px #21ba45, 0px 1px 0px #21ba45, 1px 0px 0px #21ba45;
}
.kb-labfront.container .ui.green.rating .icon.selected,
.kb-labfront.container .ui.green.rating .icon.selected.active {
  color: rgb(26.666, 172.334, 43.2610886076);
  text-shadow: 0px -1px 0px rgb(19.4825342466, 174.0174657534, 55.8436946011), -1px 0px 0px rgb(19.4825342466, 174.0174657534, 55.8436946011), 0px 1px 0px rgb(19.4825342466, 174.0174657534, 55.8436946011), 1px 0px 0px rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.teal.rating .active.icon {
  color: #6dffff;
  text-shadow: 0px -1px 0px #00b5ad, -1px 0px 0px #00b5ad, 0px 1px 0px #00b5ad, 1px 0px 0px #00b5ad;
}
.kb-labfront.container .ui.teal.rating .icon.selected,
.kb-labfront.container .ui.teal.rating .icon.selected.active {
  color: #3affff;
  text-shadow: 0px -1px 0px rgb(0, 155.5, 148.6270718232), -1px 0px 0px rgb(0, 155.5, 148.6270718232), 0px 1px 0px rgb(0, 155.5, 148.6270718232), 1px 0px 0px rgb(0, 155.5, 148.6270718232);
}
.kb-labfront.container .ui.blue.rating .active.icon {
  color: #54c8ff;
  text-shadow: 0px -1px 0px #2185d0, -1px 0px 0px #2185d0, 0px 1px 0px #2185d0, 1px 0px 0px #2185d0;
}
.kb-labfront.container .ui.blue.rating .icon.selected,
.kb-labfront.container .ui.blue.rating .icon.selected.active {
  color: rgb(33, 183.5964912281, 255);
  text-shadow: 0px -1px 0px rgb(18.7332987552, 120.4666716064, 196.7667012448), -1px 0px 0px rgb(18.7332987552, 120.4666716064, 196.7667012448), 0px 1px 0px rgb(18.7332987552, 120.4666716064, 196.7667012448), 1px 0px 0px rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.violet.rating .active.icon {
  color: #a291fb;
  text-shadow: 0px -1px 0px #6435c9, -1px 0px 0px #6435c9, 0px 1px 0px #6435c9, 1px 0px 0px #6435c9;
}
.kb-labfront.container .ui.violet.rating .icon.selected,
.kb-labfront.container .ui.violet.rating .icon.selected.active {
  color: rgb(116.4622641509, 90, 255);
  text-shadow: 0px -1px 0px rgb(85.7920488402, 36.2541338583, 192.2458661417), -1px 0px 0px rgb(85.7920488402, 36.2541338583, 192.2458661417), 0px 1px 0px rgb(85.7920488402, 36.2541338583, 192.2458661417), 1px 0px 0px rgb(85.7920488402, 36.2541338583, 192.2458661417);
}
.kb-labfront.container .ui.purple.rating .active.icon {
  color: #dc73ff;
  text-shadow: 0px -1px 0px #a333c8, -1px 0px 0px #a333c8, 0px 1px 0px #a333c8, 1px 0px 0px #a333c8;
}
.kb-labfront.container .ui.purple.rating .icon.selected,
.kb-labfront.container .ui.purple.rating .icon.selected.active {
  color: rgb(207.25, 64, 255);
  text-shadow: 0px -1px 0px rgb(152.1155746143, 34.5437250996, 190.9562749004), -1px 0px 0px rgb(152.1155746143, 34.5437250996, 190.9562749004), 0px 1px 0px rgb(152.1155746143, 34.5437250996, 190.9562749004), 1px 0px 0px rgb(152.1155746143, 34.5437250996, 190.9562749004);
}
.kb-labfront.container .ui.pink.rating .active.icon {
  color: #ff8edf;
  text-shadow: 0px -1px 0px #e03997, -1px 0px 0px #e03997, 0px 1px 0px #e03997, 1px 0px 0px #e03997;
}
.kb-labfront.container .ui.pink.rating .icon.selected,
.kb-labfront.container .ui.pink.rating .icon.selected.active {
  color: rgb(255, 91, 208.5575221239);
  text-shadow: 0px -1px 0px rgb(233.2730349345, 22.2269650655, 141.0193636744), -1px 0px 0px rgb(233.2730349345, 22.2269650655, 141.0193636744), 0px 1px 0px rgb(233.2730349345, 22.2269650655, 141.0193636744), 1px 0px 0px rgb(233.2730349345, 22.2269650655, 141.0193636744);
}
.kb-labfront.container .ui.brown.rating .active.icon {
  color: #d67c1c;
  text-shadow: 0px -1px 0px #a5673f, -1px 0px 0px #a5673f, 0px 1px 0px #a5673f, 1px 0px 0px #a5673f;
}
.kb-labfront.container .ui.brown.rating .icon.selected,
.kb-labfront.container .ui.brown.rating .icon.selected.active {
  color: rgb(178.4508264463, 98.1758331112, 12.5491735537);
  text-shadow: 0px -1px 0px rgb(156.6710526316, 89.2964396285, 45.8289473684), -1px 0px 0px rgb(156.6710526316, 89.2964396285, 45.8289473684), 0px 1px 0px rgb(156.6710526316, 89.2964396285, 45.8289473684), 1px 0px 0px rgb(156.6710526316, 89.2964396285, 45.8289473684);
}
.kb-labfront.container .ui.grey.rating .active.icon {
  color: #dcddde;
  text-shadow: 0px -1px 0px #767676, -1px 0px 0px #767676, 0px 1px 0px #767676, 1px 0px 0px #767676;
}
.kb-labfront.container .ui.grey.rating .icon.selected,
.kb-labfront.container .ui.grey.rating .icon.selected.active {
  color: rgb(187.8, 195.5, 203.2);
  text-shadow: 0px -1px 0px rgb(115.775, 94.725, 94.725), -1px 0px 0px rgb(115.775, 94.725, 94.725), 0px 1px 0px rgb(115.775, 94.725, 94.725), 1px 0px 0px rgb(115.775, 94.725, 94.725);
}
.kb-labfront.container .ui.black.rating .active.icon {
  color: #545454;
  text-shadow: 0px -1px 0px #1b1c1d, -1px 0px 0px #1b1c1d, 0px 1px 0px #1b1c1d, 1px 0px 0px #1b1c1d;
}
.kb-labfront.container .ui.black.rating .icon.selected,
.kb-labfront.container .ui.black.rating .icon.selected.active {
  color: black;
  text-shadow: 0px -1px 0px rgb(13.1803571429, 15.25, 17.3196428571), -1px 0px 0px rgb(13.1803571429, 15.25, 17.3196428571), 0px 1px 0px rgb(13.1803571429, 15.25, 17.3196428571), 1px 0px 0px rgb(13.1803571429, 15.25, 17.3196428571);
}
.kb-labfront.container .ui.disabled.rating .icon {
  cursor: default;
}
.kb-labfront.container .ui.rating.selected .active.icon {
  opacity: 1;
}
.kb-labfront.container .ui.rating.selected .icon.selected,
.kb-labfront.container .ui.rating .icon.selected {
  opacity: 1;
}
.kb-labfront.container .ui.mini.rating {
  font-size: 0.7857142857rem;
}
.kb-labfront.container .ui.tiny.rating {
  font-size: 0.8571428571rem;
}
.kb-labfront.container .ui.small.rating {
  font-size: 0.9285714286rem;
}
.kb-labfront.container .ui.rating {
  font-size: 1rem;
}
.kb-labfront.container .ui.large.rating {
  font-size: 1.1428571429rem;
}
.kb-labfront.container .ui.huge.rating {
  font-size: 1.4285714286rem;
}
.kb-labfront.container .ui.massive.rating {
  font-size: 2rem;
}
.kb-labfront.container .ui.search {
  position: relative;
}
.kb-labfront.container .ui.search > .prompt {
  margin: 0;
  outline: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  text-shadow: none;
  font-style: normal;
  font-weight: normal;
  line-height: 1.2142857143em;
  padding: 0.6785714286em 1em;
  font-size: 1em;
  background: #ffffff;
  border: 1px solid rgba(34, 36, 38, 0.15);
  color: rgba(0, 0, 0, 0.87);
  box-shadow: 0 0 0 0 transparent inset;
  transition: background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease, border-color 0.1s ease;
}
.kb-labfront.container .ui.search .prompt {
  border-radius: 500rem;
}
.kb-labfront.container .ui.search .prompt ~ .search.icon {
  cursor: pointer;
}
.kb-labfront.container .ui.search > .results {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  transform-origin: center top;
  white-space: normal;
  text-align: left;
  text-transform: none;
  background: #FFFFFF;
  margin-top: 0.5em;
  width: 18em;
  border-radius: 0.2857142857rem;
  box-shadow: 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
  border: 1px solid #d4d4d5;
  z-index: 998;
}
.kb-labfront.container .ui.search > .results > :first-child {
  border-radius: 0.2857142857rem 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.search > .results > :last-child {
  border-radius: 0 0 0.2857142857rem 0.2857142857rem;
}
.kb-labfront.container .ui.search > .results .result {
  cursor: pointer;
  display: block;
  overflow: hidden;
  font-size: 1em;
  padding: 0.8571428571em 1.1428571429em;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.33;
  border-bottom: 1px solid rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.search > .results .result:last-child {
  border-bottom: none !important;
}
.kb-labfront.container .ui.search > .results .result .image {
  float: right;
  overflow: hidden;
  background: none;
  width: 5em;
  height: 3em;
  border-radius: 0.25em;
}
.kb-labfront.container .ui.search > .results .result .image img {
  display: block;
  width: auto;
  height: 100%;
}
.kb-labfront.container .ui.search > .results .result .image + .content {
  margin: 0 6em 0 0;
}
.kb-labfront.container .ui.search > .results .result .title {
  margin: -0.1428571429em 0 0;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.search > .results .result .description {
  margin-top: 0;
  font-size: 0.9285714286em;
  color: rgba(0, 0, 0, 0.4);
}
.kb-labfront.container .ui.search > .results .result .price {
  float: right;
  color: #21ba45;
}
.kb-labfront.container .ui.search > .results > .message {
  padding: 1em 1em;
}
.kb-labfront.container .ui.search > .results > .message .header {
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 1rem;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.search > .results > .message .description {
  margin-top: 0.25rem;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.search > .results > .action {
  display: block;
  border-top: none;
  background: #f3f4f5;
  padding: 0.9285714286em 1em;
  color: rgba(0, 0, 0, 0.87);
  font-weight: bold;
  text-align: center;
}
.kb-labfront.container .ui.search > .prompt:focus {
  border-color: rgba(34, 36, 38, 0.35);
  background: #ffffff;
  color: rgba(0, 0, 0, 0.95);
}
.kb-labfront.container .ui.loading.search .input > i.icon:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 1.2857142857em;
  height: 1.2857142857em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.loading.search .input > i.icon:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 1.2857142857em;
  height: 1.2857142857em;
  animation: loader 0.6s infinite linear;
  border: 0.2em solid #767676;
  border-radius: 500rem;
  box-shadow: 0 0 0 1px transparent;
}
.kb-labfront.container .ui.search > .results .result:hover,
.kb-labfront.container .ui.category.search > .results .category .result:hover {
  background: #f9fafb;
}
.kb-labfront.container .ui.search .action:hover:not(div) {
  background: #E0E0E0;
}
.kb-labfront.container .ui.category.search > .results .category.active {
  background: #f3f4f5;
}
.kb-labfront.container .ui.category.search > .results .category.active > .name {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .ui.search > .results .result.active,
.kb-labfront.container .ui.category.search > .results .category .result.active {
  position: relative;
  border-left-color: rgba(34, 36, 38, 0.1);
  background: #f3f4f5;
  box-shadow: none;
}
.kb-labfront.container .ui.search > .results .result.active .title {
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.search > .results .result.active .description {
  color: rgba(0, 0, 0, 0.85);
}
.kb-labfront.container .ui.disabled.search {
  cursor: default;
  pointer-events: none;
  opacity: 0.45;
}
.kb-labfront.container .ui.search.selection .prompt {
  border-radius: 0.2857142857rem;
}
.kb-labfront.container .ui.search.selection > .icon.input > .remove.icon {
  pointer-events: none;
  position: absolute;
  left: auto;
  opacity: 0;
  color: "";
  top: 0;
  right: 0;
  transition: color 0.1s ease, opacity 0.1s ease;
}
.kb-labfront.container .ui.search.selection > .icon.input > .active.remove.icon {
  cursor: pointer;
  opacity: 0.8;
  pointer-events: auto;
}
.kb-labfront.container .ui.search.selection > .icon.input:not([class*="left icon"]) > .icon ~ .remove.icon {
  right: 1.85714em;
}
.kb-labfront.container .ui.search.selection > .icon.input > .remove.icon:hover {
  opacity: 1;
  color: #db2828;
}
.kb-labfront.container .ui.category.search .results {
  width: 28em;
}
.kb-labfront.container .ui.category.search .results.animating,
.kb-labfront.container .ui.category.search .results.visible {
  display: table;
}
.kb-labfront.container .ui.category.search > .results .category {
  display: table-row;
  background: #f3f4f5;
  box-shadow: none;
  transition: background 0.1s ease, border-color 0.1s ease;
}
.kb-labfront.container .ui.category.search > .results .category:last-child {
  border-bottom: none;
}
.kb-labfront.container .ui.category.search > .results .category:first-child .name + .result {
  border-radius: 0 0.2857142857rem 0 0;
}
.kb-labfront.container .ui.category.search > .results .category:last-child .result:last-child {
  border-radius: 0 0 0.2857142857rem 0;
}
.kb-labfront.container .ui.category.search > .results .category > .name {
  display: table-cell;
  text-overflow: ellipsis;
  width: 100px;
  white-space: nowrap;
  background: transparent;
  font-family: "Amplitude Wide", "Helvetica Neue", Arial, Helvetica, sans-serif;
  font-size: 1em;
  padding: 0.4em 1em;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.category.search > .results .category .results {
  display: table-cell;
  background: #ffffff;
  border-left: 1px solid rgba(34, 36, 38, 0.15);
  border-bottom: 1px solid rgba(34, 36, 38, 0.1);
}
.kb-labfront.container .ui.category.search > .results .category .result {
  border-bottom: 1px solid rgba(34, 36, 38, 0.1);
  transition: background 0.1s ease, border-color 0.1s ease;
  padding: 0.8571428571em 1.1428571429em;
}
.kb-labfront.container .ui[class*="left aligned"].search > .results {
  right: auto;
  left: 0;
}
.kb-labfront.container .ui[class*="right aligned"].search > .results {
  right: 0;
  left: auto;
}
.kb-labfront.container .ui.fluid.search .results {
  width: 100%;
}
.kb-labfront.container .ui.mini.search {
  font-size: 0.7857142857em;
}
.kb-labfront.container .ui.small.search {
  font-size: 0.9285714286em;
}
.kb-labfront.container .ui.search {
  font-size: 1em;
}
.kb-labfront.container .ui.large.search {
  font-size: 1.1428571429em;
}
.kb-labfront.container .ui.big.search {
  font-size: 1.2857142857em;
}
.kb-labfront.container .ui.huge.search {
  font-size: 1.4285714286em;
}
.kb-labfront.container .ui.massive.search {
  font-size: 1.7142857143em;
}
@media only screen and (max-width: 767.98px) {
  .kb-labfront.container .ui.search .results {
    max-width: calc(100vw - 2rem);
  }
}
.kb-labfront.container .ui.shape {
  position: relative;
  vertical-align: top;
  display: inline-block;
  perspective: 2000px;
  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out;
}
.kb-labfront.container .ui.shape .sides {
  transform-style: preserve-3d;
}
.kb-labfront.container .ui.shape .side {
  display: none;
  opacity: 1;
  width: 100%;
  margin: 0 !important;
  backface-visibility: hidden;
}
.kb-labfront.container .ui.shape .side * {
  backface-visibility: visible !important;
}
.kb-labfront.container .ui.cube.shape .side {
  min-width: 15em;
  height: 15em;
  padding: 2em;
  background-color: #E6E6E6;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}
.kb-labfront.container .ui.cube.shape .side > .content {
  width: 100%;
  height: 100%;
  display: table;
  text-align: center;
  user-select: text;
}
.kb-labfront.container .ui.cube.shape .side > .content > div {
  display: table-cell;
  vertical-align: middle;
  font-size: 2em;
}
.kb-labfront.container .ui.text.shape.animating .sides {
  position: static;
}
.kb-labfront.container .ui.text.shape .side {
  white-space: nowrap;
}
.kb-labfront.container .ui.text.shape .side > * {
  white-space: normal;
}
.kb-labfront.container .ui.loading.shape {
  position: absolute;
  top: -9999px;
  left: -9999px;
}
.kb-labfront.container .ui.shape .animating.side {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  z-index: 100;
}
.kb-labfront.container .ui.shape .hidden.side {
  opacity: 0.6;
}
.kb-labfront.container .ui.shape.animating .sides {
  position: absolute;
  transition: transform 0.6s ease-in-out, left 0.6s ease-in-out, width 0.6s ease-in-out, height 0.6s ease-in-out;
}
.kb-labfront.container .ui.shape.animating .side {
  transition: opacity 0.6s ease-in-out;
}
.kb-labfront.container .ui.shape .animating.side *,
.kb-labfront.container .ui.shape.animating .side * {
  transition: none;
}
.kb-labfront.container .ui.shape .active.side {
  display: block;
}
.kb-labfront.container .ui.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  backface-visibility: hidden;
  transition: none;
  will-change: transform;
  transform: translate3d(0, 0, 0);
  visibility: hidden;
  -webkit-overflow-scrolling: touch;
  height: 100% !important;
  max-height: 100%;
  border-radius: 0 !important;
  margin: 0 !important;
  overflow-y: auto !important;
  z-index: 102;
}
.kb-labfront.container .ui.sidebar > * {
  backface-visibility: hidden;
}
.kb-labfront.container .ui.left.sidebar {
  right: auto;
  left: 0;
  transform: translate3d(-100%, 0, 0);
}
.kb-labfront.container .ui.right.sidebar {
  right: 0 !important;
  left: auto !important;
  transform: translate3d(100%, 0, 0);
}
.kb-labfront.container .ui.top.sidebar,
.kb-labfront.container .ui.bottom.sidebar {
  width: 100% !important;
  height: auto !important;
}
.kb-labfront.container .ui.top.sidebar {
  top: 0 !important;
  bottom: auto !important;
  transform: translate3d(0, -100%, 0);
}
.kb-labfront.container .ui.bottom.sidebar {
  top: auto !important;
  bottom: 0 !important;
  transform: translate3d(0, 100%, 0);
}
.kb-labfront.container .pushable {
  height: 100%;
  overflow-x: hidden;
  padding: 0 !important;
}
.kb-labfront.container body.pushable {
  background: #545454;
}
.kb-labfront.container body.pushable.dimmed {
  background: inherit;
}
.kb-labfront.container .pushable:not(body) {
  transform: translate3d(0, 0, 0);
}
.kb-labfront.container .pushable:not(body) > .ui.sidebar,
.kb-labfront.container .pushable:not(body) > .fixed,
.kb-labfront.container .pushable:not(body) > .pusher:after {
  position: absolute;
}
.kb-labfront.container .pushable > .fixed {
  position: fixed;
  backface-visibility: hidden;
  transition: transform 500ms ease;
  will-change: transform;
  z-index: 101;
}
.kb-labfront.container .pushable > .pusher {
  position: relative;
  backface-visibility: hidden;
  overflow: hidden;
  min-height: 100%;
  transition: transform 500ms ease;
  z-index: 2;
  /* Pusher should inherit background from context */
  background: inherit;
}
.kb-labfront.container body.pushable > .pusher {
  background: #ffffff;
}
.kb-labfront.container .pushable > .pusher:after {
  position: fixed;
  top: 0;
  right: 0;
  content: "";
  background-color: rgba(0, 0, 0, 0.4);
  overflow: hidden;
  opacity: 0;
  transition: opacity 500ms;
  will-change: opacity;
  z-index: 1000;
}
.kb-labfront.container .ui.sidebar.menu .item {
  border-radius: 0 !important;
}
.kb-labfront.container .pushable > .pusher.dimmed:after {
  width: 100% !important;
  height: 100% !important;
  opacity: 1 !important;
}
.kb-labfront.container .ui.animating.sidebar {
  visibility: visible;
}
.kb-labfront.container .ui.visible.sidebar {
  visibility: visible;
  transform: translate3d(0, 0, 0);
}
.kb-labfront.container .ui.left.visible.sidebar,
.kb-labfront.container .ui.right.visible.sidebar {
  box-shadow: 0 0 20px rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.top.visible.sidebar,
.kb-labfront.container .ui.bottom.visible.sidebar {
  box-shadow: 0 0 20px rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .ui.visible.left.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.left.sidebar ~ .pusher {
  transform: translate3d(260px, 0, 0);
}
.kb-labfront.container .ui.visible.right.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.right.sidebar ~ .pusher {
  transform: translate3d(-260px, 0, 0);
}
.kb-labfront.container .ui.visible.top.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.top.sidebar ~ .pusher {
  transform: translate3d(0, 36px, 0);
}
.kb-labfront.container .ui.visible.bottom.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.bottom.sidebar ~ .pusher {
  transform: translate3d(0, -36px, 0);
}
.kb-labfront.container .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher,
.kb-labfront.container .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher {
  transform: translate3d(0, 0, 0);
}
.kb-labfront.container .ui.thin.left.sidebar,
.kb-labfront.container .ui.thin.right.sidebar {
  width: 150px;
}
.kb-labfront.container .ui[class*="very thin"].left.sidebar,
.kb-labfront.container .ui[class*="very thin"].right.sidebar {
  width: 60px;
}
.kb-labfront.container .ui.left.sidebar,
.kb-labfront.container .ui.right.sidebar {
  width: 260px;
}
.kb-labfront.container .ui.wide.left.sidebar,
.kb-labfront.container .ui.wide.right.sidebar {
  width: 350px;
}
.kb-labfront.container .ui[class*="very wide"].left.sidebar,
.kb-labfront.container .ui[class*="very wide"].right.sidebar {
  width: 475px;
}
.kb-labfront.container .ui.visible.thin.left.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.thin.left.sidebar ~ .pusher {
  transform: translate3d(150px, 0, 0);
}
.kb-labfront.container .ui.visible[class*="very thin"].left.sidebar ~ .fixed,
.kb-labfront.container .ui.visible[class*="very thin"].left.sidebar ~ .pusher {
  transform: translate3d(60px, 0, 0);
}
.kb-labfront.container .ui.visible.wide.left.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.wide.left.sidebar ~ .pusher {
  transform: translate3d(350px, 0, 0);
}
.kb-labfront.container .ui.visible[class*="very wide"].left.sidebar ~ .fixed,
.kb-labfront.container .ui.visible[class*="very wide"].left.sidebar ~ .pusher {
  transform: translate3d(475px, 0, 0);
}
.kb-labfront.container .ui.visible.thin.right.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.thin.right.sidebar ~ .pusher {
  transform: translate3d(-150px, 0, 0);
}
.kb-labfront.container .ui.visible[class*="very thin"].right.sidebar ~ .fixed,
.kb-labfront.container .ui.visible[class*="very thin"].right.sidebar ~ .pusher {
  transform: translate3d(-60px, 0, 0);
}
.kb-labfront.container .ui.visible.wide.right.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.wide.right.sidebar ~ .pusher {
  transform: translate3d(-350px, 0, 0);
}
.kb-labfront.container .ui.visible[class*="very wide"].right.sidebar ~ .fixed,
.kb-labfront.container .ui.visible[class*="very wide"].right.sidebar ~ .pusher {
  transform: translate3d(-475px, 0, 0);
}
.kb-labfront.container .ui.overlay.sidebar {
  z-index: 102;
}
.kb-labfront.container .ui.left.overlay.sidebar {
  transform: translate3d(-100%, 0, 0);
}
.kb-labfront.container .ui.right.overlay.sidebar {
  transform: translate3d(100%, 0, 0);
}
.kb-labfront.container .ui.top.overlay.sidebar {
  transform: translate3d(0%, -100%, 0);
}
.kb-labfront.container .ui.bottom.overlay.sidebar {
  transform: translate3d(0%, 100%, 0);
}
.kb-labfront.container .animating.ui.overlay.sidebar,
.kb-labfront.container .ui.visible.overlay.sidebar {
  transition: transform 500ms ease;
}
.kb-labfront.container .ui.visible.left.overlay.sidebar {
  transform: translate3d(0%, 0, 0);
}
.kb-labfront.container .ui.visible.right.overlay.sidebar {
  transform: translate3d(0%, 0, 0);
}
.kb-labfront.container .ui.visible.top.overlay.sidebar {
  transform: translate3d(0%, 0, 0);
}
.kb-labfront.container .ui.visible.bottom.overlay.sidebar {
  transform: translate3d(0%, 0, 0);
}
.kb-labfront.container .ui.visible.overlay.sidebar ~ .fixed,
.kb-labfront.container .ui.visible.overlay.sidebar ~ .pusher {
  transform: none !important;
}
.kb-labfront.container .ui.push.sidebar {
  transition: transform 500ms ease;
  z-index: 102;
}
.kb-labfront.container .ui.left.push.sidebar {
  transform: translate3d(-100%, 0, 0);
}
.kb-labfront.container .ui.right.push.sidebar {
  transform: translate3d(100%, 0, 0);
}
.kb-labfront.container .ui.top.push.sidebar {
  transform: translate3d(0%, -100%, 0);
}
.kb-labfront.container .ui.bottom.push.sidebar {
  transform: translate3d(0%, 100%, 0);
}
.kb-labfront.container .ui.visible.push.sidebar {
  transform: translate3d(0%, 0, 0);
}
.kb-labfront.container .ui.uncover.sidebar {
  transform: translate3d(0, 0, 0);
  z-index: 1;
}
.kb-labfront.container .ui.visible.uncover.sidebar {
  transform: translate3d(0, 0, 0);
  transition: transform 500ms ease;
}
.kb-labfront.container .ui.slide.along.sidebar {
  z-index: 1;
}
.kb-labfront.container .ui.left.slide.along.sidebar {
  transform: translate3d(-50%, 0, 0);
}
.kb-labfront.container .ui.right.slide.along.sidebar {
  transform: translate3d(50%, 0, 0);
}
.kb-labfront.container .ui.top.slide.along.sidebar {
  transform: translate3d(0, -50%, 0);
}
.kb-labfront.container .ui.bottom.slide.along.sidebar {
  transform: translate3d(0%, 50%, 0);
}
.kb-labfront.container .ui.animating.slide.along.sidebar {
  transition: transform 500ms ease;
}
.kb-labfront.container .ui.visible.slide.along.sidebar {
  transform: translate3d(0%, 0, 0);
}
.kb-labfront.container .ui.slide.out.sidebar {
  z-index: 1;
}
.kb-labfront.container .ui.left.slide.out.sidebar {
  transform: translate3d(50%, 0, 0);
}
.kb-labfront.container .ui.right.slide.out.sidebar {
  transform: translate3d(-50%, 0, 0);
}
.kb-labfront.container .ui.top.slide.out.sidebar {
  transform: translate3d(0%, 50%, 0);
}
.kb-labfront.container .ui.bottom.slide.out.sidebar {
  transform: translate3d(0%, -50%, 0);
}
.kb-labfront.container .ui.animating.slide.out.sidebar {
  transition: transform 500ms ease;
}
.kb-labfront.container .ui.visible.slide.out.sidebar {
  transform: translate3d(0%, 0, 0);
}
.kb-labfront.container .ui.scale.down.sidebar {
  transition: transform 500ms ease;
  z-index: 102;
}
.kb-labfront.container .ui.left.scale.down.sidebar {
  transform: translate3d(-100%, 0, 0);
}
.kb-labfront.container .ui.right.scale.down.sidebar {
  transform: translate3d(100%, 0, 0);
}
.kb-labfront.container .ui.top.scale.down.sidebar {
  transform: translate3d(0%, -100%, 0);
}
.kb-labfront.container .ui.bottom.scale.down.sidebar {
  transform: translate3d(0%, 100%, 0);
}
.kb-labfront.container .ui.scale.down.left.sidebar ~ .pusher {
  transform-origin: 75% 50%;
}
.kb-labfront.container .ui.scale.down.right.sidebar ~ .pusher {
  transform-origin: 25% 50%;
}
.kb-labfront.container .ui.scale.down.top.sidebar ~ .pusher {
  transform-origin: 50% 75%;
}
.kb-labfront.container .ui.scale.down.bottom.sidebar ~ .pusher {
  transform-origin: 50% 25%;
}
.kb-labfront.container .ui.animating.scale.down > .visible.ui.sidebar {
  transition: transform 500ms ease;
}
.kb-labfront.container .ui.visible.scale.down.sidebar ~ .pusher,
.kb-labfront.container .ui.animating.scale.down.sidebar ~ .pusher {
  display: block !important;
  width: 100%;
  height: 100%;
  overflow: hidden !important;
}
.kb-labfront.container .ui.visible.scale.down.sidebar {
  transform: translate3d(0, 0, 0);
}
.kb-labfront.container .ui.visible.scale.down.sidebar ~ .pusher {
  transform: scale(0.75);
}
.kb-labfront.container .ui.slider:not(.vertical):not(.checkbox) {
  width: 100%;
  padding: 1em 0.5em;
}
.kb-labfront.container .ui.slider:not(.checkbox) {
  position: relative;
}
.kb-labfront.container .ui.slider:not(.checkbox):focus {
  outline: 0;
}
.kb-labfront.container .ui.slider .inner {
  position: relative;
  z-index: 2;
}
.kb-labfront.container .ui.slider:not(.vertical) .inner {
  height: 1.5em;
}
.kb-labfront.container .ui.slider .inner:hover {
  cursor: auto;
}
.kb-labfront.container .ui.slider .inner .track {
  position: absolute;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.05);
}
.kb-labfront.container .ui.slider:not(.vertical) .inner .track {
  width: 100%;
  height: 0.4em;
  top: 0.55em;
  left: 0;
}
.kb-labfront.container .ui.slider .inner .track-fill {
  position: absolute;
  border-radius: 4px;
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.slider:not(.vertical) .inner .track-fill {
  height: 0.4em;
  top: 0.55em;
  left: 0;
}
.kb-labfront.container .ui.slider .inner .thumb {
  position: absolute;
  left: 0;
  top: 0;
  height: 1.5em;
  width: 1.5em;
  background: #ffffff linear-gradient(transparent, rgba(0, 0, 0, 0.05));
  border-radius: 100%;
  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15), 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
  transition: background 0.3s ease;
}
.kb-labfront.container .ui.slider:not(.disabled) .inner .thumb:hover {
  cursor: pointer;
  background: rgb(242.25, 242.25, 242.25) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
}
.kb-labfront.container .ui.slider:not(.disabled):focus .inner .thumb {
  background: rgb(242.25, 242.25, 242.25) linear-gradient(transparent, rgba(0, 0, 0, 0.05));
}
.kb-labfront.container .ui.disabled.slider:not(.checkbox) {
  opacity: 0.5;
}
.kb-labfront.container .ui.disabled.slider .inner:hover {
  cursor: auto;
}
.kb-labfront.container .ui.disabled.slider .inner .track-fill {
  background: #ccc;
}
.kb-labfront.container .ui.reversed.slider .inner .track-fill {
  left: auto;
  right: 0;
}
.kb-labfront.container .ui.reversed.slider .inner .thumb {
  left: auto;
  right: 0;
}
.kb-labfront.container .ui.labeled.reversed.slider > .labels .label {
  transform: translate(-100%, -100%);
}
.kb-labfront.container .ui.vertical.slider {
  height: 100%;
  width: 1.5em;
  padding: 0.5em 1em;
}
.kb-labfront.container .ui.vertical.slider .inner {
  height: 100%;
}
.kb-labfront.container .ui.vertical.slider .inner .track {
  height: 100%;
  width: 0.4em;
  left: 0.55em;
  top: 0;
}
.kb-labfront.container .ui.vertical.slider .inner .track-fill {
  width: 0.4em;
  left: 0.55em;
  top: 0;
}
.kb-labfront.container .ui.vertical.reversed.slider .inner .thumb {
  top: auto;
  bottom: 0;
}
.kb-labfront.container .ui.vertical.reversed.slider .inner .track-fill {
  top: auto;
  bottom: 0;
}
.kb-labfront.container .ui.labeled.vertical.reversed.slider > .labels .label {
  transform: translate(-100%, 50%);
}
.kb-labfront.container .ui.labeled.vertical.slider > .labels {
  width: 1.5em;
  height: auto;
  left: 50%;
  top: 0;
  bottom: 0;
  transform: translateX(-50%);
}
.kb-labfront.container .ui.labeled.vertical.slider > .labels .label {
  transform: translate(-100%, -50%);
}
.kb-labfront.container .ui.labeled.vertical.slider > .labels .label:after {
  width: 1.5em;
  height: 1px;
  left: 100%;
  top: 50%;
}
.kb-labfront.container .ui.labeled.vertical.slider > .labels .halftick.label:after {
  width: 0.75em;
  height: 1px;
}
.kb-labfront.container .ui.slider.small.vertical .inner {
  width: 1em;
}
.kb-labfront.container .ui.slider.small.vertical .inner .track,
.kb-labfront.container .ui.slider.small.vertical .inner .track-fill {
  width: 0.3em;
  left: 0.35em;
}
.kb-labfront.container .ui.small.labeled.vertical.slider > .labels,
.kb-labfront.container .ui.small.labeled.vertical.slider > .labels .label:after {
  width: 1em;
}
.kb-labfront.container .ui.small.labeled.vertical.slider > .labels .halftick.label:after {
  width: 0.5em;
}
.kb-labfront.container .ui.slider.large.vertical .inner {
  width: 2em;
}
.kb-labfront.container .ui.slider.large.vertical .inner .track,
.kb-labfront.container .ui.slider.large.vertical .inner .track-fill {
  width: 0.5em;
  left: 0.75em;
}
.kb-labfront.container .ui.large.labeled.vertical.slider > .labels,
.kb-labfront.container .ui.large.labeled.vertical.slider > .labels .label:after {
  width: 2em;
}
.kb-labfront.container .ui.large.labeled.vertical.slider > .labels .halftick.label:after {
  width: 1em;
}
.kb-labfront.container .ui.slider.big.vertical .inner {
  width: 2.5em;
}
.kb-labfront.container .ui.slider.big.vertical .inner .track,
.kb-labfront.container .ui.slider.big.vertical .inner .track-fill {
  width: 0.6em;
  left: 0.95em;
}
.kb-labfront.container .ui.big.labeled.vertical.slider > .labels,
.kb-labfront.container .ui.big.labeled.vertical.slider > .labels .label:after {
  width: 2.5em;
}
.kb-labfront.container .ui.big.labeled.vertical.slider > .labels .halftick.label:after {
  width: 1.25em;
}
.kb-labfront.container .ui.labeled.slider > .labels {
  height: 1.5em;
  width: auto;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
}
.kb-labfront.container .ui.labeled.slider:not(.vertical) > .labels {
  transform: translateY(-50%);
}
.kb-labfront.container .ui.labeled.slider > .labels .label {
  display: inline-flex;
  position: absolute;
  transform: translate(-50%, -100%);
}
.kb-labfront.container .ui.labeled.ticked.slider > .labels .label:after {
  content: " ";
  height: 1.5em;
  width: 1px;
  background: #ccc;
  position: absolute;
  top: 100%;
  left: 50%;
}
.kb-labfront.container .ui.labeled.ticked.slider > .labels .halftick.label:after {
  height: 0.75em;
}
.kb-labfront.container .ui.hover.slider .inner .thumb {
  opacity: 0;
  transition: opacity 0.2s linear;
}
.kb-labfront.container .ui.hover.slider:not(.disabled):hover .inner .thumb, .kb-labfront.container .ui.hover.slider:not(.disabled):focus .inner .thumb {
  opacity: 1;
}
.kb-labfront.container .ui.inverted.slider .inner .track-fill {
  background-color: #545454;
}
.kb-labfront.container .ui.inverted.slider .inner .track {
  background-color: rgba(255, 255, 255, 0.08);
}
.kb-labfront.container .ui.primary.slider .inner .track-fill {
  background-color: #2185d0;
}
.kb-labfront.container .ui.primary.slider.basic .inner .thumb {
  background-color: #2185d0;
}
.kb-labfront.container .ui.primary.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.primary.slider.basic:focus .inner .thumb {
  background-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.primary.inverted.slider.basic .inner .thumb {
  background-color: #54c8ff;
}
.kb-labfront.container .ui.primary.inverted.slider .inner .track-fill {
  background-color: #54c8ff;
}
.kb-labfront.container .ui.primary.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.primary.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.secondary.slider .inner .track-fill {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.secondary.slider.basic .inner .thumb {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.secondary.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.secondary.slider.basic:focus .inner .thumb {
  background-color: rgb(35.2196428571, 40.75, 46.2803571429);
}
.kb-labfront.container .ui.secondary.inverted.slider.basic .inner .thumb {
  background-color: #545454;
}
.kb-labfront.container .ui.secondary.inverted.slider .inner .track-fill {
  background-color: #545454;
}
.kb-labfront.container .ui.secondary.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.secondary.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(120.45, 98.55, 98.55);
}
.kb-labfront.container .ui.red.slider .inner .track-fill {
  background-color: #db2828;
}
.kb-labfront.container .ui.red.slider.basic .inner .thumb {
  background-color: #db2828;
}
.kb-labfront.container .ui.red.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.red.slider.basic:focus .inner .thumb {
  background-color: rgb(211.6849601594, 21.8150398406, 21.8150398406);
}
.kb-labfront.container .ui.red.inverted.slider.basic .inner .thumb {
  background-color: #ff695e;
}
.kb-labfront.container .ui.red.inverted.slider .inner .track-fill {
  background-color: #ff695e;
}
.kb-labfront.container .ui.red.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.red.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(255, 57.4844720497, 43);
}
.kb-labfront.container .ui.orange.slider .inner .track-fill {
  background-color: #f2711c;
}
.kb-labfront.container .ui.orange.slider.basic .inner .thumb {
  background-color: #f2711c;
}
.kb-labfront.container .ui.orange.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.orange.slider.basic:focus .inner .thumb {
  background-color: rgb(243.48125, 97.3239485981, 1.01875);
}
.kb-labfront.container .ui.orange.inverted.slider.basic .inner .thumb {
  background-color: #ff851b;
}
.kb-labfront.container .ui.orange.inverted.slider .inner .track-fill {
  background-color: #ff851b;
}
.kb-labfront.container .ui.orange.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.orange.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(231, 107.3947368421, 0);
}
.kb-labfront.container .ui.yellow.slider .inner .track-fill {
  background-color: #fbbd08;
}
.kb-labfront.container .ui.yellow.slider.basic .inner .thumb {
  background-color: #fbbd08;
}
.kb-labfront.container .ui.yellow.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.yellow.slider.basic:focus .inner .thumb {
  background-color: rgb(233.5, 173.9238683128, 0);
}
.kb-labfront.container .ui.yellow.inverted.slider.basic .inner .thumb {
  background-color: #ffe21f;
}
.kb-labfront.container .ui.yellow.inverted.slider .inner .track-fill {
  background-color: #ffe21f;
}
.kb-labfront.container .ui.yellow.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.yellow.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(235, 204.5758928571, 0);
}
.kb-labfront.container .ui.olive.slider .inner .track-fill {
  background-color: #b5cc18;
}
.kb-labfront.container .ui.olive.slider.basic .inner .thumb {
  background-color: #b5cc18;
}
.kb-labfront.container .ui.olive.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.olive.slider.basic:focus .inner .thumb {
  background-color: rgb(168.2940789474, 191.3092105263, 11.1907894737);
}
.kb-labfront.container .ui.olive.inverted.slider.basic .inner .thumb {
  background-color: #d9e778;
}
.kb-labfront.container .ui.olive.inverted.slider .inner .track-fill {
  background-color: #d9e778;
}
.kb-labfront.container .ui.olive.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.olive.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(212.6626721061, 233.8018867925, 66.1981132075);
}
.kb-labfront.container .ui.green.slider .inner .track-fill {
  background-color: #21ba45;
}
.kb-labfront.container .ui.green.slider.basic .inner .thumb {
  background-color: #21ba45;
}
.kb-labfront.container .ui.green.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.green.slider.basic:focus .inner .thumb {
  background-color: rgb(19.4825342466, 174.0174657534, 55.8436946011);
}
.kb-labfront.container .ui.green.inverted.slider.basic .inner .thumb {
  background-color: #2ecc40;
}
.kb-labfront.container .ui.green.inverted.slider .inner .track-fill {
  background-color: #2ecc40;
}
.kb-labfront.container .ui.green.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.green.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(26.666, 172.334, 43.2610886076);
}
.kb-labfront.container .ui.teal.slider .inner .track-fill {
  background-color: #00b5ad;
}
.kb-labfront.container .ui.teal.slider.basic .inner .thumb {
  background-color: #00b5ad;
}
.kb-labfront.container .ui.teal.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.teal.slider.basic:focus .inner .thumb {
  background-color: rgb(0, 155.5, 148.6270718232);
}
.kb-labfront.container .ui.teal.inverted.slider.basic .inner .thumb {
  background-color: #6dffff;
}
.kb-labfront.container .ui.teal.inverted.slider .inner .track-fill {
  background-color: #6dffff;
}
.kb-labfront.container .ui.teal.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.teal.inverted.slider.basic:focus .inner .thumb {
  background-color: #3affff;
}
.kb-labfront.container .ui.blue.slider .inner .track-fill {
  background-color: #2185d0;
}
.kb-labfront.container .ui.blue.slider.basic .inner .thumb {
  background-color: #2185d0;
}
.kb-labfront.container .ui.blue.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.blue.slider.basic:focus .inner .thumb {
  background-color: rgb(18.7332987552, 120.4666716064, 196.7667012448);
}
.kb-labfront.container .ui.blue.inverted.slider.basic .inner .thumb {
  background-color: #54c8ff;
}
.kb-labfront.container .ui.blue.inverted.slider .inner .track-fill {
  background-color: #54c8ff;
}
.kb-labfront.container .ui.blue.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.blue.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(33, 183.5964912281, 255);
}
.kb-labfront.container .ui.violet.slider .inner .track-fill {
  background-color: #6435c9;
}
.kb-labfront.container .ui.violet.slider.basic .inner .thumb {
  background-color: #6435c9;
}
.kb-labfront.container .ui.violet.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.violet.slider.basic:focus .inner .thumb {
  background-color: rgb(85.7920488402, 36.2541338583, 192.2458661417);
}
.kb-labfront.container .ui.violet.inverted.slider.basic .inner .thumb {
  background-color: #a291fb;
}
.kb-labfront.container .ui.violet.inverted.slider .inner .track-fill {
  background-color: #a291fb;
}
.kb-labfront.container .ui.violet.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.violet.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(116.4622641509, 90, 255);
}
.kb-labfront.container .ui.purple.slider .inner .track-fill {
  background-color: #a333c8;
}
.kb-labfront.container .ui.purple.slider.basic .inner .thumb {
  background-color: #a333c8;
}
.kb-labfront.container .ui.purple.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.purple.slider.basic:focus .inner .thumb {
  background-color: rgb(152.1155746143, 34.5437250996, 190.9562749004);
}
.kb-labfront.container .ui.purple.inverted.slider.basic .inner .thumb {
  background-color: #dc73ff;
}
.kb-labfront.container .ui.purple.inverted.slider .inner .track-fill {
  background-color: #dc73ff;
}
.kb-labfront.container .ui.purple.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.purple.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(207.25, 64, 255);
}
.kb-labfront.container .ui.pink.slider .inner .track-fill {
  background-color: #e03997;
}
.kb-labfront.container .ui.pink.slider.basic .inner .thumb {
  background-color: #e03997;
}
.kb-labfront.container .ui.pink.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.pink.slider.basic:focus .inner .thumb {
  background-color: rgb(233.2730349345, 22.2269650655, 141.0193636744);
}
.kb-labfront.container .ui.pink.inverted.slider.basic .inner .thumb {
  background-color: #ff8edf;
}
.kb-labfront.container .ui.pink.inverted.slider .inner .track-fill {
  background-color: #ff8edf;
}
.kb-labfront.container .ui.pink.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.pink.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(255, 91, 208.5575221239);
}
.kb-labfront.container .ui.brown.slider .inner .track-fill {
  background-color: #a5673f;
}
.kb-labfront.container .ui.brown.slider.basic .inner .thumb {
  background-color: #a5673f;
}
.kb-labfront.container .ui.brown.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.brown.slider.basic:focus .inner .thumb {
  background-color: rgb(156.6710526316, 89.2964396285, 45.8289473684);
}
.kb-labfront.container .ui.brown.inverted.slider.basic .inner .thumb {
  background-color: #d67c1c;
}
.kb-labfront.container .ui.brown.inverted.slider .inner .track-fill {
  background-color: #d67c1c;
}
.kb-labfront.container .ui.brown.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.brown.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(178.4508264463, 98.1758331112, 12.5491735537);
}
.kb-labfront.container .ui.grey.slider .inner .track-fill {
  background-color: #767676;
}
.kb-labfront.container .ui.grey.slider.basic .inner .thumb {
  background-color: #767676;
}
.kb-labfront.container .ui.grey.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.grey.slider.basic:focus .inner .thumb {
  background-color: rgb(115.775, 94.725, 94.725);
}
.kb-labfront.container .ui.grey.inverted.slider.basic .inner .thumb {
  background-color: #dcddde;
}
.kb-labfront.container .ui.grey.inverted.slider .inner .track-fill {
  background-color: #dcddde;
}
.kb-labfront.container .ui.grey.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.grey.inverted.slider.basic:focus .inner .thumb {
  background-color: rgb(187.8, 195.5, 203.2);
}
.kb-labfront.container .ui.black.slider .inner .track-fill {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.black.slider.basic .inner .thumb {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.black.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.black.slider.basic:focus .inner .thumb {
  background-color: rgb(13.1803571429, 15.25, 17.3196428571);
}
.kb-labfront.container .ui.black.inverted.slider.basic .inner .thumb {
  background-color: #545454;
}
.kb-labfront.container .ui.black.inverted.slider .inner .track-fill {
  background-color: #545454;
}
.kb-labfront.container .ui.black.inverted.slider.basic .inner .thumb:hover,
.kb-labfront.container .ui.black.inverted.slider.basic:focus .inner .thumb {
  background-color: black;
}
.kb-labfront.container .ui.slider.basic .inner .thumb {
  background-color: #1b1c1d;
}
.kb-labfront.container .ui.slider.basic .inner .thumb:hover, .kb-labfront.container .ui.slider.basic:focus .inner .thumb {
  background-color: rgb(13.1803571429, 15.25, 17.3196428571);
}
.kb-labfront.container .ui.inverted.slider.basic .inner .thumb {
  background-color: #545454;
}
.kb-labfront.container .ui.inverted.slider.basic .inner .thumb:hover, .kb-labfront.container .ui.inverted.slider.basic:focus .inner .thumb {
  background-color: black;
}
.kb-labfront.container .ui.slider.small .inner .thumb {
  height: 1em;
  width: 1em;
}
.kb-labfront.container .ui.slider.small:not(.vertical) .inner {
  height: 1em;
}
.kb-labfront.container .ui.slider.small:not(.vertical) .inner .track,
.kb-labfront.container .ui.slider.small:not(.vertical) .inner .track-fill {
  height: 0.3em;
  top: 0.35em;
}
.kb-labfront.container .ui.small.labeled.slider:not(.vertical) > .labels,
.kb-labfront.container .ui.small.labeled.slider:not(.vertical) > .labels .label:after {
  height: 1em;
}
.kb-labfront.container .ui.small.labeled.slider:not(.vertical) > .labels .halftick.label:after {
  height: 0.5em;
}
.kb-labfront.container .ui.slider.large .inner .thumb {
  height: 2em;
  width: 2em;
}
.kb-labfront.container .ui.slider.large:not(.vertical) .inner {
  height: 2em;
}
.kb-labfront.container .ui.slider.large:not(.vertical) .inner .track,
.kb-labfront.container .ui.slider.large:not(.vertical) .inner .track-fill {
  height: 0.5em;
  top: 0.75em;
}
.kb-labfront.container .ui.large.labeled.slider:not(.vertical) > .labels,
.kb-labfront.container .ui.large.labeled.slider:not(.vertical) > .labels .label:after {
  height: 2em;
}
.kb-labfront.container .ui.large.labeled.slider:not(.vertical) > .labels .halftick.label:after {
  height: 1em;
}
.kb-labfront.container .ui.slider.big .inner .thumb {
  height: 2.5em;
  width: 2.5em;
}
.kb-labfront.container .ui.slider.big:not(.vertical) .inner {
  height: 2.5em;
}
.kb-labfront.container .ui.slider.big:not(.vertical) .inner .track,
.kb-labfront.container .ui.slider.big:not(.vertical) .inner .track-fill {
  height: 0.6em;
  top: 0.95em;
}
.kb-labfront.container .ui.big.labeled.slider:not(.vertical) > .labels,
.kb-labfront.container .ui.big.labeled.slider:not(.vertical) > .labels .label:after {
  height: 2.5em;
}
.kb-labfront.container .ui.big.labeled.slider:not(.vertical) > .labels .halftick.label:after {
  height: 1.25em;
}
.kb-labfront.container .ui.sticky {
  position: static;
  transition: none;
  z-index: 800;
}
.kb-labfront.container .ui.sticky.bound {
  position: absolute;
  left: auto;
  right: auto;
}
.kb-labfront.container .ui.sticky.fixed {
  position: fixed;
  left: auto;
  right: auto;
}
.kb-labfront.container .ui.sticky.bound.top,
.kb-labfront.container .ui.sticky.fixed.top {
  top: 0;
  bottom: auto;
}
.kb-labfront.container .ui.sticky.bound.bottom,
.kb-labfront.container .ui.sticky.fixed.bottom {
  top: auto;
  bottom: 0;
}
.kb-labfront.container .ui.native.sticky {
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  position: sticky;
}
.kb-labfront.container .ui.tab {
  display: none;
}
.kb-labfront.container .ui.tab.active,
.kb-labfront.container .ui.tab.open {
  display: block;
}
.kb-labfront.container .ui.tab.loading {
  position: relative;
  overflow: hidden;
  display: block;
  min-height: 250px;
}
.kb-labfront.container .ui.tab.loading * {
  position: relative !important;
  left: -10000px !important;
}
.kb-labfront.container .ui.tab.loading:before,
.kb-labfront.container .ui.tab.loading.segment:before {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 2.5em;
  height: 2.5em;
  border-radius: 500rem;
  border: 0.2em solid rgba(0, 0, 0, 0.1);
}
.kb-labfront.container .ui.tab.loading:after,
.kb-labfront.container .ui.tab.loading.segment:after {
  position: absolute;
  content: "";
  top: 50%;
  left: 50%;
  margin: -0.6428571429em 0 0 -0.6428571429em;
  width: 2.5em;
  height: 2.5em;
  animation: loader 0.6s infinite linear;
  border: 0.2em solid #767676;
  border-radius: 500rem;
  box-shadow: 0 0 0 1px transparent;
}
.kb-labfront.container .ui.toast-container {
  position: fixed;
  z-index: 9999;
}
.kb-labfront.container .ui.top.right.toast-container {
  top: 0.8571428571em;
  right: 0.8571428571em;
  margin-left: 0.8571428571em;
}
.kb-labfront.container .ui.top.left.toast-container {
  top: 0.8571428571em;
  left: 0.8571428571em;
  margin-right: 0.8571428571em;
}
.kb-labfront.container .ui.top.center.toast-container {
  left: 50%;
  transform: translate(-50%, 0);
  top: 0.8571428571em;
}
.kb-labfront.container .ui.bottom.right.toast-container {
  bottom: 0.8571428571em;
  right: 0.8571428571em;
  margin-left: 0.8571428571em;
}
.kb-labfront.container .ui.bottom.left.toast-container {
  bottom: 0.8571428571em;
  left: 0.8571428571em;
  margin-right: 0.8571428571em;
}
.kb-labfront.container .ui.bottom.center.toast-container {
  left: 50%;
  transform: translate(-50%, 0);
  bottom: 0.8571428571em;
}
.kb-labfront.container .toast {
  display: block;
  border-radius: 0.2857142857rem;
  padding: 0.7857142857em 1em;
  margin: 0 0 6px;
  color: rgba(255, 255, 255, 0.9);
}
.kb-labfront.container .floating.toast,
.kb-labfront.container .hoverfloating.toast:hover {
  box-shadow: 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .hoverfloating.message:hover {
  box-shadow: 0 0 0 1px inset, 0 0px 0px 0 rgba(34, 36, 38, 0.12), 0 0px 4px 0 rgba(34, 36, 38, 0.15);
}
.kb-labfront.container .center.toast-container .toast-box,
.kb-labfront.container .right.toast-container .toast-box {
  margin-left: auto;
}
.kb-labfront.container .center.toast-container .toast-box {
  margin-right: auto;
}
.kb-labfront.container .visible.toast-box,
.kb-labfront.container .animating.toast-box,
.kb-labfront.container .toast-box {
  display: table !important;
}
.kb-labfront.container .toast-container .compact {
  display: block;
  width: 300px;
}
.kb-labfront.container .toast-container .message,
.kb-labfront.container .toast:hover {
  opacity: 1;
  cursor: pointer;
}
.kb-labfront.container .icon.toast .content {
  padding-left: 3em;
}
.kb-labfront.container .toast > .content > .header {
  font-weight: bold;
}
.kb-labfront.container .info.toast {
  background-color: #31ccec;
}
.kb-labfront.container .warning.toast {
  background-color: #f2c037;
}
.kb-labfront.container .success.toast {
  background-color: #21ba45;
}
.kb-labfront.container .error.toast {
  background-color: #db2828;
}
.kb-labfront.container .toast-box .info.attached.progress .bar {
  background: rgb(17.6066666667, 161.24, 190.8933333333) !important;
}
.kb-labfront.container .toast-box .warning.attached.progress .bar {
  background: rgb(207.0422535211, 155.2816901408, 13.4577464789) !important;
}
.kb-labfront.container .toast-box .success.attached.progress .bar {
  background: rgb(21.4726027397, 121.0273972603, 44.897260274) !important;
}
.kb-labfront.container .toast-box .error.attached.progress .bar {
  background: rgb(156.3247011952, 26.1752988048, 26.1752988048) !important;
}
.kb-labfront.container .primary.toast {
  background-color: #2185d0;
}
.kb-labfront.container .inverted.primary.toast,
.kb-labfront.container .toast-box .inverted.primary.attached.progress .bar {
  background-color: #54c8ff;
}
.kb-labfront.container .secondary.toast {
  background-color: #1b1c1d;
}
.kb-labfront.container .inverted.secondary.toast,
.kb-labfront.container .toast-box .inverted.secondary.attached.progress .bar {
  background-color: #545454;
}
.kb-labfront.container .red.toast {
  background-color: #db2828;
}
.kb-labfront.container .inverted.red.toast,
.kb-labfront.container .toast-box .inverted.red.attached.progress .bar {
  background-color: #ff695e;
}
.kb-labfront.container .orange.toast {
  background-color: #f2711c;
}
.kb-labfront.container .inverted.orange.toast,
.kb-labfront.container .toast-box .inverted.orange.attached.progress .bar {
  background-color: #ff851b;
}
.kb-labfront.container .yellow.toast {
  background-color: #fbbd08;
}
.kb-labfront.container .inverted.yellow.toast,
.kb-labfront.container .toast-box .inverted.yellow.attached.progress .bar {
  background-color: #ffe21f;
}
.kb-labfront.container .olive.toast {
  background-color: #b5cc18;
}
.kb-labfront.container .inverted.olive.toast,
.kb-labfront.container .toast-box .inverted.olive.attached.progress .bar {
  background-color: #d9e778;
}
.kb-labfront.container .green.toast {
  background-color: #21ba45;
}
.kb-labfront.container .inverted.green.toast,
.kb-labfront.container .toast-box .inverted.green.attached.progress .bar {
  background-color: #2ecc40;
}
.kb-labfront.container .teal.toast {
  background-color: #00b5ad;
}
.kb-labfront.container .inverted.teal.toast,
.kb-labfront.container .toast-box .inverted.teal.attached.progress .bar {
  background-color: #6dffff;
}
.kb-labfront.container .blue.toast {
  background-color: #2185d0;
}
.kb-labfront.container .inverted.blue.toast,
.kb-labfront.container .toast-box .inverted.blue.attached.progress .bar {
  background-color: #54c8ff;
}
.kb-labfront.container .violet.toast {
  background-color: #6435c9;
}
.kb-labfront.container .inverted.violet.toast,
.kb-labfront.container .toast-box .inverted.violet.attached.progress .bar {
  background-color: #a291fb;
}
.kb-labfront.container .purple.toast {
  background-color: #a333c8;
}
.kb-labfront.container .inverted.purple.toast,
.kb-labfront.container .toast-box .inverted.purple.attached.progress .bar {
  background-color: #dc73ff;
}
.kb-labfront.container .pink.toast {
  background-color: #e03997;
}
.kb-labfront.container .inverted.pink.toast,
.kb-labfront.container .toast-box .inverted.pink.attached.progress .bar {
  background-color: #ff8edf;
}
.kb-labfront.container .brown.toast {
  background-color: #a5673f;
}
.kb-labfront.container .inverted.brown.toast,
.kb-labfront.container .toast-box .inverted.brown.attached.progress .bar {
  background-color: #d67c1c;
}
.kb-labfront.container .grey.toast {
  background-color: #767676;
}
.kb-labfront.container .inverted.grey.toast,
.kb-labfront.container .toast-box .inverted.grey.attached.progress .bar {
  background-color: #dcddde;
}
.kb-labfront.container .black.toast {
  background-color: #1b1c1d;
}
.kb-labfront.container .inverted.black.toast,
.kb-labfront.container .toast-box .inverted.black.attached.progress .bar {
  background-color: #545454;
}
.kb-labfront.container .inverted.toast {
  color: rgba(0, 0, 0, 0.87);
}
.kb-labfront.container .icon.toast > .icon:not(.close) {
  display: inline-block;
  vertical-align: middle;
  font-size: 1.5em;
  position: absolute;
}
.kb-labfront.container .icon.toast > .content {
  display: inline-block;
  vertical-align: middle;
}
.kb-labfront.container .toast-box .attached.progress .bar {
  min-width: 0;
}
.kb-labfront.container .toast-box .active.progress .bar:after {
  animation: progress-active 2s ease infinite !important;
}
.kb-labfront.container .toast-box {
  margin-bottom: 6px;
}
.kb-labfront.container .toast-box .toast,
.kb-labfront.container .toast-box .message {
  margin-top: 0;
  margin-bottom: 0;
  position: relative;
}
.kb-labfront.container .toast-box .attached.progress {
  z-index: 1;
}
.kb-labfront.container .toast-box .bottom.attached.progress {
  margin: -3px 0 6px;
}
.kb-labfront.container .toast-box .top.attached.progress {
  margin: 6px 0 -3px;
}
.kb-labfront.container .toast-box .message > .close.icon {
  top: 0.3em;
  right: 0.3em;
}
.kb-labfront.container .toast-box .toast > .close.icon {
  cursor: pointer;
  position: absolute;
  margin: 0;
  top: 0.3em;
  right: 0.3em;
  opacity: 0.7;
  transition: opacity 0.1s ease;
}
.kb-labfront.container .toast-box .toast > .close.icon:hover {
  opacity: 1;
}
.kb-labfront.container .transition {
  animation-iteration-count: 1;
  animation-duration: 300ms;
  animation-timing-function: ease;
  animation-fill-mode: both;
}
.kb-labfront.container .animating.transition {
  backface-visibility: hidden;
  visibility: visible !important;
}
.kb-labfront.container .loading.transition {
  position: absolute;
  top: -99999px;
  left: -99999px;
}
.kb-labfront.container .hidden.transition {
  display: none;
  visibility: hidden;
}
.kb-labfront.container .visible.transition {
  display: block !important;
  visibility: visible !important;
  /*  backface-visibility: \$transition-backface-visibility;
    transform: \$transition-use3-d-acceleration;*/
}
.kb-labfront.container .disabled.transition {
  animation-play-state: paused;
}
.kb-labfront.container .looping.transition {
  animation-iteration-count: infinite;
}
.kb-labfront.container .transition.browse {
  animation-duration: 500ms;
}
.kb-labfront.container .transition.browse.in {
  animation-name: browseIn;
}
.kb-labfront.container .transition.browse.out,
.kb-labfront.container .transition.browse.left.out {
  animation-name: browseOutLeft;
}
.kb-labfront.container .transition.browse.right.out {
  animation-name: browseOutRight;
}
@keyframes browseIn {
  0% {
    transform: scale(0.8) translateZ(0px);
    z-index: -1;
  }
  10% {
    transform: scale(0.8) translateZ(0px);
    z-index: -1;
    opacity: 0.7;
  }
  80% {
    transform: scale(1.05) translateZ(0px);
    opacity: 1;
    z-index: 999;
  }
  100% {
    transform: scale(1) translateZ(0px);
    z-index: 999;
  }
}
@keyframes browseOutLeft {
  0% {
    z-index: 999;
    transform: translateX(0%) rotateY(0deg) rotateX(0deg);
  }
  50% {
    z-index: -1;
    transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);
  }
  80% {
    opacity: 1;
  }
  100% {
    z-index: -1;
    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);
    opacity: 0;
  }
}
@keyframes browseOutRight {
  0% {
    z-index: 999;
    transform: translateX(0%) rotateY(0deg) rotateX(0deg);
  }
  50% {
    z-index: 1;
    transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);
  }
  80% {
    opacity: 1;
  }
  100% {
    z-index: 1;
    transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);
    opacity: 0;
  }
}
.kb-labfront.container .drop.transition {
  transform-origin: top center;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1);
}
.kb-labfront.container .drop.transition.in {
  animation-name: dropIn;
}
.kb-labfront.container .drop.transition.out {
  animation-name: dropOut;
}
@keyframes dropIn {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes dropOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0);
  }
}
.kb-labfront.container .transition.fade.in {
  animation-name: fadeIn;
}
.kb-labfront.container .transition[class*="fade up"].in {
  animation-name: fadeInUp;
}
.kb-labfront.container .transition[class*="fade down"].in {
  animation-name: fadeInDown;
}
.kb-labfront.container .transition[class*="fade left"].in {
  animation-name: fadeInLeft;
}
.kb-labfront.container .transition[class*="fade right"].in {
  animation-name: fadeInRight;
}
.kb-labfront.container .transition.fade.out {
  animation-name: fadeOut;
}
.kb-labfront.container .transition[class*="fade up"].out {
  animation-name: fadeOutUp;
}
.kb-labfront.container .transition[class*="fade down"].out {
  animation-name: fadeOutDown;
}
.kb-labfront.container .transition[class*="fade left"].out {
  animation-name: fadeOutLeft;
}
.kb-labfront.container .transition[class*="fade right"].out {
  animation-name: fadeOutRight;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(10%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-10%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translateX(10%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(-10%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeOutUp {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(5%);
  }
}
@keyframes fadeOutDown {
  0% {
    opacity: 1;
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(-5%);
  }
}
@keyframes fadeOutLeft {
  0% {
    opacity: 1;
    transform: translateX(0%);
  }
  100% {
    opacity: 0;
    transform: translateX(5%);
  }
}
@keyframes fadeOutRight {
  0% {
    opacity: 1;
    transform: translateX(0%);
  }
  100% {
    opacity: 0;
    transform: translateX(-5%);
  }
}
.kb-labfront.container .flip.transition.in,
.kb-labfront.container .flip.transition.out {
  animation-duration: 600ms;
}
.kb-labfront.container .horizontal.flip.transition.in {
  animation-name: horizontalFlipIn;
}
.kb-labfront.container .horizontal.flip.transition.out {
  animation-name: horizontalFlipOut;
}
.kb-labfront.container .vertical.flip.transition.in {
  animation-name: verticalFlipIn;
}
.kb-labfront.container .vertical.flip.transition.out {
  animation-name: verticalFlipOut;
}
@keyframes horizontalFlipIn {
  0% {
    transform: perspective(2000px) rotateY(-90deg);
    opacity: 0;
  }
  100% {
    transform: perspective(2000px) rotateY(0deg);
    opacity: 1;
  }
}
@keyframes verticalFlipIn {
  0% {
    transform: perspective(2000px) rotateX(-90deg);
    opacity: 0;
  }
  100% {
    transform: perspective(2000px) rotateX(0deg);
    opacity: 1;
  }
}
@keyframes horizontalFlipOut {
  0% {
    transform: perspective(2000px) rotateY(0deg);
    opacity: 1;
  }
  100% {
    transform: perspective(2000px) rotateY(90deg);
    opacity: 0;
  }
}
@keyframes verticalFlipOut {
  0% {
    transform: perspective(2000px) rotateX(0deg);
    opacity: 1;
  }
  100% {
    transform: perspective(2000px) rotateX(-90deg);
    opacity: 0;
  }
}
.kb-labfront.container .scale.transition.in {
  animation-name: scaleIn;
}
.kb-labfront.container .scale.transition.out {
  animation-name: scaleOut;
}
@keyframes scaleIn {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes scaleOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}
.kb-labfront.container .transition.fly {
  animation-duration: 0.6s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
.kb-labfront.container .transition.fly.in {
  animation-name: flyIn;
}
.kb-labfront.container .transition[class*="fly up"].in {
  animation-name: flyInUp;
}
.kb-labfront.container .transition[class*="fly down"].in {
  animation-name: flyInDown;
}
.kb-labfront.container .transition[class*="fly left"].in {
  animation-name: flyInLeft;
}
.kb-labfront.container .transition[class*="fly right"].in {
  animation-name: flyInRight;
}
.kb-labfront.container .transition.fly.out {
  animation-name: flyOut;
}
.kb-labfront.container .transition[class*="fly up"].out {
  animation-name: flyOutUp;
}
.kb-labfront.container .transition[class*="fly down"].out {
  animation-name: flyOutDown;
}
.kb-labfront.container .transition[class*="fly left"].out {
  animation-name: flyOutLeft;
}
.kb-labfront.container .transition[class*="fly right"].out {
  animation-name: flyOutRight;
}
@keyframes flyIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }
  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
@keyframes flyInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 1500px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes flyInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -1500px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  100% {
    transform: none;
  }
}
@keyframes flyInLeft {
  0% {
    opacity: 0;
    transform: translate3d(1500px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  100% {
    transform: none;
  }
}
@keyframes flyInRight {
  0% {
    opacity: 0;
    transform: translate3d(-1500px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  100% {
    transform: none;
  }
}
@keyframes flyOut {
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  50%, 55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }
  100% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
@keyframes flyOutUp {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
@keyframes flyOutDown {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes flyOutRight {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes flyOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
.kb-labfront.container .transition.slide.in,
.kb-labfront.container .transition[class*="slide down"].in {
  animation-name: slideInY;
  transform-origin: top center;
}
.kb-labfront.container .transition[class*="slide up"].in {
  animation-name: slideInY;
  transform-origin: bottom center;
}
.kb-labfront.container .transition[class*="slide left"].in {
  animation-name: slideInX;
  transform-origin: center right;
}
.kb-labfront.container .transition[class*="slide right"].in {
  animation-name: slideInX;
  transform-origin: center left;
}
.kb-labfront.container .transition.slide.out,
.kb-labfront.container .transition[class*="slide down"].out {
  animation-name: slideOutY;
  transform-origin: top center;
}
.kb-labfront.container .transition[class*="slide up"].out {
  animation-name: slideOutY;
  transform-origin: bottom center;
}
.kb-labfront.container .transition[class*="slide left"].out {
  animation-name: slideOutX;
  transform-origin: center right;
}
.kb-labfront.container .transition[class*="slide right"].out {
  animation-name: slideOutX;
  transform-origin: center left;
}
@keyframes slideInY {
  0% {
    opacity: 0;
    transform: scaleY(0);
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes slideInX {
  0% {
    opacity: 0;
    transform: scaleX(0);
  }
  100% {
    opacity: 1;
    transform: scaleX(1);
  }
}
@keyframes slideOutY {
  0% {
    opacity: 1;
    transform: scaleY(1);
  }
  100% {
    opacity: 0;
    transform: scaleY(0);
  }
}
@keyframes slideOutX {
  0% {
    opacity: 1;
    transform: scaleX(1);
  }
  100% {
    opacity: 0;
    transform: scaleX(0);
  }
}
.kb-labfront.container .transition.swing {
  animation-duration: 800ms;
}
.kb-labfront.container .transition[class*="swing down"].in {
  animation-name: swingInX;
  transform-origin: top center;
}
.kb-labfront.container .transition[class*="swing up"].in {
  animation-name: swingInX;
  transform-origin: bottom center;
}
.kb-labfront.container .transition[class*="swing left"].in {
  animation-name: swingInY;
  transform-origin: center right;
}
.kb-labfront.container .transition[class*="swing right"].in {
  animation-name: swingInY;
  transform-origin: center left;
}
.kb-labfront.container .transition.swing.out,
.kb-labfront.container .transition[class*="swing down"].out {
  animation-name: swingOutX;
  transform-origin: top center;
}
.kb-labfront.container .transition[class*="swing up"].out {
  animation-name: swingOutX;
  transform-origin: bottom center;
}
.kb-labfront.container .transition[class*="swing left"].out {
  animation-name: swingOutY;
  transform-origin: center right;
}
.kb-labfront.container .transition[class*="swing right"].out {
  animation-name: swingOutY;
  transform-origin: center left;
}
@keyframes swingInX {
  0% {
    transform: perspective(1000px) rotateX(90deg);
    opacity: 0;
  }
  40% {
    transform: perspective(1000px) rotateX(-30deg);
    opacity: 1;
  }
  60% {
    transform: perspective(1000px) rotateX(15deg);
  }
  80% {
    transform: perspective(1000px) rotateX(-7.5deg);
  }
  100% {
    transform: perspective(1000px) rotateX(0deg);
  }
}
@keyframes swingInY {
  0% {
    transform: perspective(1000px) rotateY(-90deg);
    opacity: 0;
  }
  40% {
    transform: perspective(1000px) rotateY(30deg);
    opacity: 1;
  }
  60% {
    transform: perspective(1000px) rotateY(-17.5deg);
  }
  80% {
    transform: perspective(1000px) rotateY(7.5deg);
  }
  100% {
    transform: perspective(1000px) rotateY(0deg);
  }
}
@keyframes swingOutX {
  0% {
    transform: perspective(1000px) rotateX(0deg);
  }
  40% {
    transform: perspective(1000px) rotateX(-7.5deg);
  }
  60% {
    transform: perspective(1000px) rotateX(17.5deg);
  }
  80% {
    transform: perspective(1000px) rotateX(-30deg);
    opacity: 1;
  }
  100% {
    transform: perspective(1000px) rotateX(90deg);
    opacity: 0;
  }
}
@keyframes swingOutY {
  0% {
    transform: perspective(1000px) rotateY(0deg);
  }
  40% {
    transform: perspective(1000px) rotateY(7.5deg);
  }
  60% {
    transform: perspective(1000px) rotateY(-10deg);
  }
  80% {
    transform: perspective(1000px) rotateY(30deg);
    opacity: 1;
  }
  100% {
    transform: perspective(1000px) rotateY(-90deg);
    opacity: 0;
  }
}
.kb-labfront.container .transition.zoom.in {
  animation-name: zoomIn;
}
.kb-labfront.container .transition.zoom.out {
  animation-name: zoomOut;
}
@keyframes zoomIn {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes zoomOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(0);
  }
}
.kb-labfront.container .flash.transition {
  animation-duration: 750ms;
  animation-name: flash;
}
.kb-labfront.container .shake.transition {
  animation-duration: 750ms;
  animation-name: shake;
}
.kb-labfront.container .bounce.transition {
  animation-duration: 750ms;
  animation-name: bounce;
}
.kb-labfront.container .tada.transition {
  animation-duration: 750ms;
  animation-name: tada;
}
.kb-labfront.container .pulse.transition {
  animation-duration: 500ms;
  animation-name: pulse;
}
.kb-labfront.container .jiggle.transition {
  animation-duration: 750ms;
  animation-name: jiggle;
}
.kb-labfront.container .transition.glow {
  animation-duration: 2000ms;
  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
}
.kb-labfront.container .transition.glow {
  animation-name: glow;
}
@keyframes flash {
  0%, 50%, 100% {
    opacity: 1;
  }
  25%, 75% {
    opacity: 0;
  }
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-10px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(10px);
  }
}
@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
@keyframes tada {
  0% {
    transform: scale(1);
  }
  10%, 20% {
    transform: scale(0.9) rotate(-3deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale(1.1) rotate(3deg);
  }
  40%, 60%, 80% {
    transform: scale(1.1) rotate(-3deg);
  }
  100% {
    transform: scale(1) rotate(0);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.9);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes jiggle {
  0% {
    transform: scale3d(1, 1, 1);
  }
  30% {
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
@keyframes glow {
  0% {
    background-color: #FCFCFD;
  }
  30% {
    background-color: #FFF6CD;
  }
  100% {
    background-color: #FCFCFD;
  }
}
.kb-labfront.container {
  position: relative;
  width: 100%;
  min-height: 500px;
  box-sizing: border-box;
  padding: 0;
  font-family: "Amplitude Wide", "Lato", sans-serif;
  letter-spacing: -0.3px;
  font-weight: 300;
  line-height: 142%;
  letter-spacing: -0.48px;
  font-size: 16px;
}
.kb-labfront.container .page-dim {
  position: relative;
  max-width: 1156px;
  margin: 0 auto;
}
@media (max-width: 1200px) {
  .kb-labfront.container .page-dim {
    padding-left: 22px;
    padding-right: 22px;
  }
  .kb-labfront.container .page-dim.no-gutter {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (max-width: 1200px) and (min-width: 748px) and (max-width: 1200px) {
  .kb-labfront.container .page-dim.no-gutter {
    padding-left: 22px;
    padding-right: 22px;
  }
}
.kb-labfront.container a.no-hover:hover {
  all: revert;
  color: inherit;
  text-decoration: inherit;
}
.kb-labfront.container .light-blue-theme a.ext-link::after,
.kb-labfront.container .blue-theme a.ext-link::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.kb-labfront.container p.login-prompt {
  font-family: "Amplitude Wide", "Lato", sans-serif;
  letter-spacing: -0.3px;
  font-weight: 300;
  line-height: 142%;
  letter-spacing: -0.48px;
  font-size: 16px;
}
.kb-labfront.container header h1, .kb-labfront.container header h2 {
  font-family: "Publico Banner Web", "Merriweather", serif;
  font-weight: 700;
}
.kb-labfront.container header h1 {
  font-weight: 900;
}
.kb-labfront.container header h2 {
  font-weight: 700;
}
.kb-labfront.container .content {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 1156px;
  overflow: hidden;
}
.kb-labfront.container .row {
  display: block;
  padding: 7px 0;
}
.kb-labfront.container .segment.page-element {
  margin-bottom: 2em;
}
.kb-labfront.container .flex-container {
  display: flex;
  flex-direction: column;
}
.kb-labfront.container .flex-container .flex-item {
  flex: 1;
}
.kb-labfront.container a {
  color: var(--bodytext-link-color);
  text-decoration: none;
}
.kb-labfront.container a:hover {
  text-decoration: underline;
}
.kb-labfront.container p {
  margin-bottom: 1.5em;
}
.kb-labfront.container p.tiny {
  font-size: 0.8em;
  line-height: 1em;
  font-weight: 300;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/components/KbLabFront.scss","webpack://./src/styling/_kr.scss","webpack://./src/styling/_table.scss","webpack://./src/styling/_semantic_ui_overrides.scss","webpack://./src/styling/_fonts.scss","webpack://./src/styling/_labrador_overrides.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/globals/reset.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/globals/site.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/button.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/container.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/divider.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/flag.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/flag.style.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/header.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/icon.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/icon.style.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/image.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/input.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/label.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/list.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/loader.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/placeholder.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/rail.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/reveal.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/segment.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/step.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/elements/text.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/collections/breadcrumb.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/collections/form.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/collections/grid.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/collections/menu.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/collections/message.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/collections/table.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/views/ad.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/views/card.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/views/comment.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/views/feed.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/views/item.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/views/statistic.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/accordion.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/accordion.style.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/calendar.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/checkbox.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/checkbox.style.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/dimmer.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/dropdown.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/dropdown.style.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/embed.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/modal.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/nag.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/popup.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/progress.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/rating.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/search.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/shape.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/sidebar.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/slider.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/sticky.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/tab.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/toast.scss","webpack://./node_modules/fomantic-ui-sass/src/definitions/modules/transition.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/transition.style.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/fonts/_main.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/page/_main.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/texts/_main.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/texts/_colored.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/headers/_font-size.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/headers/_main.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/links/_colored.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/links/_main.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/links/_states.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/scrollbars/_main.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/scrollbars/_background.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/scrollbars/_inverted.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/texts/_highlighted.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/button.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/fonts/_exact-pixels.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/texts/_neutral.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/loader/_main.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/fonts/_em-sizes.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/border/_radius.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/colors/_neutrals.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/loader/_colors.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/colors/_main.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/border/_state-colors.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/border/_colored.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/colors/_brand.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/event-colors/_hovered.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/event-colors/_onmousedown.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/colors/_transparent.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/container.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/divider.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/divider.style.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/flag.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/header.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/event-colors/_disabled.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/icon.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/icons/_all.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/image.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/input.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/input/_all.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/colors/_states.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/texts/_states.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/label.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/list.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/loader.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/loader/_speed.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/placeholder.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/rail.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/reveal.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/shadows/_accents.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/segment.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/step.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/colors/_light.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/step.style.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/elements/text.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/collections/breadcrumb.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/collections/form.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/columns/_all.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/collections/grid.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/collections/menu.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/collections/message.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/collections/table.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/views/ad.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/views/card.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/views/comment.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/views/feed.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/views/item.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/views/statistic.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/accordion.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/calendar.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/checkbox.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/dimmer.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/dropdown.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/embed.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/modal.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/nag.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/popup.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/progress.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/headers/_states.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/rating.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/search.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/shape.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/sidebar.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/slider.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/sticky.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/tab.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/toast.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/modules/transition.variables.scss","webpack://./node_modules/fomantic-ui-sass/src/themes/default/globals/transitions/_all.scss","webpack://./src/styling/_kr_colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACiBhB;EACE,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;ADfF;;AENA,2CAAA;ACGE;EACE,0BAAA;AHOJ;;AGJI;EACE,eAAA;AHON;;AGJE,wCAAA;AACA;EACE,2BAAA;EACA,+BAAA;AHOJ;;AGJI;ECVF,iDAAA;EACA,sBAAA;EAeA,gBAAA;EAWA,iBAAA;EACA,uBAAA;EACA,eAAA;AJNF;AGVI;EACE,2BAAA;AHYN;;AGTE;ECjBA,iDAAA;EACA,sBAAA;EAeA,gBAAA;EAWA,iBAAA;EACA,uBAAA;EACA,eAAA;AJMF;;AGfE;EACE,2BAAA;AHkBJ;;AGhBE;EACE,WAAA;AHmBJ;;AKjDE;EACE,aAAA;ALoDJ;;AKlDE;EACE,sBAAA;EACA,0BAAA;ALqDJ;;AKnDE;EACE,0BAAA;ALsDJ;;AAtDA;EACE;IACE,0BAAA;IACA,2BAAA;EAyDF;AACF;AAtDA;EMhBA;;iCAAA;EAIA,eAAA;EAUA,uBAAA;ECdA;;iCAAA;EAKY,8GAAA;EAwBZ;;iCAAA;EAiDA;;iCAAA;EAeA;;uBAAA;EAaA;;iCAAA;EAKE,4BAAA;EAuBA,gBAAA;EAeF;;iCAAA;EAIA,SAAA;EAcA,SAAA;EC5EE;;iCAAA;EAwCA;;iCAAA;EAIA;;kBAAA;EAeA;;kBAAA;EAeA;;kBAAA;EAYA;;kBAAA;EAqBA;;kBAAA;EAIA,qBAAA;EAwDA;;uBAAA;EAiBE,8BAAA;EAKF;;iCAAA;EAKE;;uBAAA;EAuBA,eAAA;EA0BA,aAAA;EAyBA,SAAA;EAkCA;;uBAAA;EAWA,UAAA;EAcA,WAAA;EAEA,UAAA;EAOA,mBAAA;EAQA,iBAAA;EAUA;;uBAAA;EAyBA,QAAA;EAMA,UAAA;EAUA,cAAA;EAYA;;uBAAA;EAIE,aAAA;EAqBA,YAAA;EAqBA,gBAAA;EAqBA,cAAA;EAmBA,YAAA;EAqBA,cAAA;EAqBA,cAAA;EAqBA,OAAA;EAkBA,aAAA;EAkBA,aAAA;EAkBJ;;kBAAA;EAqBA;;iCAAA;EAKA;;uBAAA;EAiBA;;uBAAA;EAqBA;;uBAAA;EA6CA,mCAAA;EA4CA;;kBAAA;EAiBE;;uBAAA;EAmDA,aAAA;EAWA,4BAAA;EAqCA,gBAAA;EAgBA;;uBAAA;EAoFA;;kBAAA;EAUA,iBAAA;EAsBA,kBAAA;EA8CA,mCAAA;EAKF;;kBAAA;EAIA,uDAAA;EAeA;;kBAAA;EAaA;;uBAAA;EAuCA,aAAA;EASA;;uBAAA;EAKA,aAAA;EASA,iBAAA;EAQA,iBAAA;EAgBA,WAAA;EAoBA,iBAAA;EAuBA,iBAAA;EA+BA;;uBAAA;EAyFA,2BAAA;EA2CA;;uBAAA;EAmEM,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAtIA,UAAA;EAoCA,aAAA;EA2CA,mBAAA;EAuDA,aAAA;EAoFJ;;mBAAA;EAvtDF,aAAA;EAuCE,UAAA;EAurDA;;mBAAA;EA9tDF,aAAA;EAuCE,UAAA;EA4rDF;;iCAAA;EAeA,aAAA;EASA,mBAAA;EAqBA,oBAAA;ECxxDA;;iCAAA;EAIA,cAAA;EAMA,WAAA;EAkBA,WAAA;EAkBA,kBAAA;EAkBA,kBAAA;EAkBA;;iCAAA;EAKA,mBAAA;EAQA,UAAA;EAMA;;iCAAA;ECrGA;;iCAAA;EAmBA;;kBAAA;EASA;;kBAAA;EAIA,0CAAA;EAMA;;kBAAA;EA+BA;;kBAAA;EA0CA,gBAAA;EA2CA;;kBAAA;EAWA;;kBAAA;EAoBA;;iCAAA;EAIA;;kBAAA;EAYA;;kBAAA;EAkBA;;kBAAA;EAQA;;kBAAA;EAQA;;kBAAA;EASA;;kBAAA;ECpPA;;iCAAA;EAqBA,WAAA;ECvBA,mEAAA;EAGA,mBAAA;EA49BA,iBAAA;EC79BA;;iCAAA;EAIA,aAAA;EAmBA;;kBAAA;EAcA;;kBAAA;EAYA,mBAAA;EAOA;;uBAAA;EAiBA;;kBAAA;EASA,gBAAA;EAOA,eAAA;EAQA;;kBAAA;EAUA,gBAAA;EAOA;;iCAAA;EAKA;;kBAAA;EAqBA,eAAA;EAkBA;;kBAAA;EAqBA,eAAA;EAiBA;;kBAAA;EAyBA;;uBAAA;EAqDA;;iCAAA;EASA;;iCAAA;EAIA;;uBAAA;EAsBA;;uBAAA;EAkCA;;uBAAA;EAuBA;;uBAAA;EAgBA;;uBAAA;EASA;;uBAAA;EAoBA;;uBAAA;EA4BA;;uBAAA;EAyBA,mBAAA;EAiBA;;uBAAA;ECjeA;;iCAAA;EAwCA;;iCAAA;EAIA;;kBAAA;EAUA;;iCAAA;EAiBA;;iCAAA;EAKA;;uBAAA;EASA;;uBAAA;EAaA;;uBAAA;EAmBA;;uBAAA;EAYA;;uBAAA;EAmBA;;8BAAA;EAiCA;;uBAAA;EAkBA;;uBAAA;EAIA,oBAAA;EAYA;;uBAAA;EAuBA;;uBAAA;EAgDA;;iCAAA;EA0BA,gBAAA;EC1TA;;;GAAA;EAKA;;;;;;;;;;;;;;;;;;;;;;iCAAA;EAyBA;;iCAAA;EAIA,wCAAA;EAUA;;iCAAA;EAIA,UAAA;EA87BA,YAAA;EAmSA;;iCAAA;EAIA,iBAAA;EAEE,4BAAA;EAgBA,UAAA;EA4JF;;iCAAA;EAKE,6BAAA;EAYA,UAAA;EA8aA,YAAA;ECh4DF;;iCAAA;EAwBA;;iCAAA;EA0BA;;iCAAA;EAKA;;kBAAA;EAUA;;sBAAA;EA0BA;;kBAAA;EAWA;;kBAAA;EAaA;;kBAAA;EAkBA;;kBAAA;EAgBA;;kBAAA;EAqBA;;uBAAA;EAoBA;;uBAAA;EA8BA;;kBAAA;EAsEA;;iCAAA;EClSA;;iCAAA;EAKA;;wBAAA;EAiCA;;wBAAA;EAIA,0CAAA;EAaA;;iCAAA;EAIA;;wBAAA;EAcA;;wBAAA;EAYA;;wBAAA;EAoCA;;wBAAA;EA0BA;;wBAAA;EAWA,sBAAA;EAWA,8BAAA;EAWA;;iCAAA;EAIE;;wBAAA;EAiBA,qBAAA;EAaA,yBAAA;EAsBA;;wBAAA;EA4CA,oBAAA;EAgBA,UAAA;EAQA;;wBAAA;EAIA,mBAAA;EAWA,0BAAA;EAcA,2BAAA;EAeA,iBAAA;EAQA,8BAAA;EAaA,iBAAA;EAmBA,2BAAA;EAUA,mCAAA;EA2BA;;wBAAA;EAiBA,oBAAA;EAiBA,gBAAA;EAKA,mBAAA;EAgBA,gBAAA;EAMF;;wBAAA;EAIA,aAAA;EAKA;;wBAAA;EAWA;;wBAAA;EC1fA;;iCAAA;EA+BA,SAAA;EAKA,gBAAA;EAWA,UAAA;EAOA,SAAA;EAOA,WAAA;EAYA,oBAAA;EAaA,oCAAA;EAUA,2BAAA;EAKA,oBAAA;EAKA;;uBAAA;EASA;;uBAAA;EASA,6CAAA;EAgBA,0CAAA;EAWA;;iCAAA;EAoCE;;uBAAA;EAgEA;;uBAAA;EAoBA,eAAA;EAkCA,gBAAA;EAmBA,YAAA;EAYA;;uBAAA;EA4BA,gBAAA;EAkCA,iBAAA;EAgBA,iBAAA;EAgBA,iBAAA;EAYA;;uBAAA;EAkDF;;iCAAA;EAIA;;uBAAA;EAQA;;uBAAA;EAiBA;;uBAAA;EAiBA;;uBAAA;EAoBA;;uBAAA;EASA;;uBAAA;EAUA;;iCAAA;EAME;;uBAAA;EAYA,SAAA;EAWF;;uBAAA;EAWE;;uBAAA;EA2BF;;uBAAA;EAsBI,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAnEA,SAAA;EAOA,WAAA;EAIA,UAAA;EAaA,aAAA;EAOA,kBAAA;EAYA,oBAAA;EAIA,mBAAA;EAoBA,wBAAA;EAiBF;;uBAAA;EAeA;;uBAAA;EA2BA;;uBAAA;EAmBA,UAAA;EAaA,gBAAA;EAYA,gBAAA;EAeA,eAAA;EAaA,gBAAA;EAiBA,mBAAA;EAEA,aAAA;EAKA,gBAAA;EAKA,gBAAA;EAOA,eAAA;EAKA,gBAAA;EASA;;sBAAA;EA6BF;;uBAAA;ECh7BA;;iCAAA;EA0BA;;iCAAA;EAIA,cAAA;EAsCA,eAAA;EASA,eAAA;EASA,SAAA;EAqBA,UAAA;EAwBA,YAAA;EA8BA,WAAA;EAUA,gBAAA;EAOA,eAAA;EAMA,iBAAA;EAWA,sBAAA;EAMA,gBAAA;EAWA,oBAAA;EAmBA;;iCAAA;EA+BA;;iCAAA;EAKE;;uBAAA;EA+BA,4BAAA;EAOA,oBAAA;EAgBF;;iCAAA;EAIA;;uBAAA;EAcA;;uBAAA;EAUA;;iCAAA;EAKE;;uBAAA;EAoBA,cAAA;EAYA,oBAAA;EASF;;uBAAA;EAoBA;;uBAAA;EAwBE,aAAA;EAsBA;;uBAAA;EAmCE,aAAA;EAoBJ,oCAAA;EAQA;;uBAAA;EAWA;;uBAAA;EAgBE;;uBAAA;EAwCA,wBAAA;EAwBA;;uBAAA;EAyCA,UAAA;EASA,gBAAA;EAWE,uBAAA;EAaF,qBAAA;EAUA;;uBAAA;EAkBA,aAAA;EAKA,qBAAA;EAUA,oBAAA;EAiBA,sBAAA;EAQE,uBAAA;EAsBA,aAAA;EAWF;;uBAAA;EAcA,4BAAA;EAOA,aAAA;EASE,oBAAA;EAgBA,mBAAA;EAmBA,sBAAA;EAsBA,aAAA;EAcF;;uBAAA;EAmBA,iBAAA;EAgBF;;uBAAA;EC75BA;;iCAAA;EAKA,kBAAA;EAYA,iBAAA;EAaA,iBAAA;EAgBA,WAAA;EAgBA,qBAAA;EAOA,UAAA;EAkDA;;uBAAA;EAIA,8BAAA;EAKA,iBAAA;EAQA,4BAAA;EAQA;;iCAAA;EAIA;;uBAAA;EAYA;;iCAAA;EAkBA;;iCAAA;EAKA;;uBAAA;EAKA,WAAA;EA0CA,gBAAA;EAmCA;;uBAAA;EA0DA;;uBAAA;EAkBA,oBAAA;EA+BA;;uBAAA;ECpXA;;uBAAA;EAoDA,UAAA;EAkBA,UAAA;EAmBA,cAAA;EAYA,2BAAA;EAMA,iBAAA;EAiBA,qBAAA;EAkBA,iBAAA;EAcA,YAAA;EAcA,4BAAA;EAYA;;iCAAA;EAKA;;uBAAA;EAwBA;;uBAAA;ECnNA;;iCAAA;EAyBA;;iCAAA;EAIA;;kBAAA;EAmBA;;kBAAA;EAkBA;;kBAAA;EA4BA;;kBAAA;EAUA;;kBAAA;ECxGA;;iCAAA;EAsBA,wDAAA;EAOA;;iCAAA;EAKE;;kBAAA;EA+EA;;kBAAA;EAeA;;kBAAA;EA+CA;;kBAAA;EA6BF;;iCAAA;EAmBA;;iCAAA;EAQA;;iCAAA;EAIA;;kBAAA;EAQA;;kBAAA;EASA;;kBAAA;EC5PA;;iCAAA;EAsBA,aAAA;EAiBA;;uBAAA;EAIA,WAAA;EAMA,UAAA;EAkBA,SAAA;EAYA,UAAA;EAUA,QAAA;EAKA;;iCAAA;EAKE;;uBAAA;EAsDA;;uBAAA;EA4CA,mBAAA;EAmBA;;uBAAA;EA4BA,wBAAA;EAQE,aAAA;EAWJ;;uBAAA;EAYA,oBAAA;EAOA;;uBAAA;EAQA,kBAAA;EAUA;;uBAAA;EAYA;;uBAAA;EAUA;;iCAAA;EAIA,UAAA;EAiBA,mBAAA;EAqBA,WAAA;EAUA,SAAA;EAMA,iBAAA;EAYA,qBAAA;EAeA,4BAAA;EAUA,uBAAA;EAcA,iBAAA;EASA;;iCAAA;EAIA;;kBAAA;EASA;;kBAAA;EA2CA;;iCAAA;EAKA;;uBAAA;EAaA;;uBAAA;EAUA;;uBAAA;EAoBA;;uBAAA;EAcA;;uBAAA;EAgBE;;uBAAA;EAcA,WAAA;EAQA,aAAA;EAKA,YAAA;EAmBF;;uBAAA;EAIA,cAAA;EAMA,aAAA;EAQE;;uBAAA;EAIA,WAAA;EAeA,QAAA;EAYA,WAAA;EAeF;;kBAAA;EAaA;;uBAAA;ECzrBA;;iCAAA;EAmBA,gBAAA;EAKA,eAAA;EAMA;;iCAAA;EAyBA,UAAA;EAqBA,eAAA;EAMA,cAAA;EAOA,cAAA;EAMA;;iCAAA;EAIA,UAAA;EAUA,gBAAA;EAaA,SAAA;EAaA,oBAAA;EAKA,SAAA;EAMA;;iCAAA;EAKE;;kBAAA;EA2BA;;kBAAA;EA6BA,UAAA;EAmBF;;mBAAA;EAIA,qBAAA;EAgDA;;iCAAA;EAIA,eAAA;EASA,cAAA;EASA,WAAA;EAgBA,iBAAA;EAcA,iBAAA;EAUA,cAAA;EAMA,aAAA;EAgBA;;iCAAA;EAKA;;kBAAA;EAIA,oBAAA;EA+CA;;kBAAA;EAIA,UAAA;EAQE;;kBAAA;EAIA,QAAA;EAcA,WAAA;EAaF;;uBAAA;EAiDA;;uBAAA;EAwCE;;kBAAA;EAuBA,WAAA;EAUA,aAAA;EAWA,eAAA;EASA,cAAA;EC3lBF;;iCAAA;EAqBA,UAAA;ECrBA;;iCAAA;EAiBA;;iCAAA;EAIA,YAAA;EAWA,SAAA;EASA,iBAAA;EAMA,YAAA;EAUA,mBAAA;EAOE,aAAA;EAYF;;iCAAA;EASA;;iCAAA;ECrFA;;wBAAA;EASA;;wBAAA;EAQA;;wBAAA;EAoBA;;wBAAA;EAaA;;wBAAA;EAsBA,oCAAA;EAoCA,cAAA;EA+BA;;wBAAA;EA0BA;;wBAAA;EAyBA;;8BAAA;EASA;;wBAAA;EAiBA;;wBAAA;EAIA,UAAA;EASA,WAAA;EAUA;;wBAAA;EAIA,UAAA;EAOA,YAAA;EAOA,eAAA;EAMA,qBAAA;EAgBA;;wBAAA;EAWA,gBAAA;EAKA;;wBAAA;EAyBA;;iCAAA;EAIA;;wBAAA;EASA,UAAA;EAMA,UAAA;EAQA;;wBAAA;EAIA,0CAAA;EAqBA,sBAAA;EAsBA;;wBAAA;EAgCA;;wBAAA;EAIA,YAAA;EAWA;;wBAAA;EAIA,YAAA;EAWA;;wBAAA;EAIA,YAAA;EAWA,gBAAA;EAqEA,oCAAA;EAKA;;uBAAA;EA8BA,UAAA;EAMA,aAAA;EAOA,WAAA;EAMA;;wBAAA;EAwBA;;wBAAA;EAmBA;;kBAAA;EA2CA;;iCAAA;EAIA;;wBAAA;EA+BA;;iCAAA;EAKA;;wBAAA;EAuBA,mBAAA;EAmBA;;wBAAA;EAIA,uBAAA;EAwBA;;wBAAA;EAIA,iBAAA;EAgBA,uBAAA;EAsCA,iCAAA;EAgCA,wBAAA;EAwDA,iCAAA;EAgCA;;wBAAA;EAUA;;wBAAA;EAaA,iBAAA;EAiBA,yBAAA;EAKA,iBAAA;EAeA,UAAA;EAUA,SAAA;EAWA;;wBAAA;EA6BA,aAAA;EA0BA,mBAAA;EChlCA;;iCAAA;EAYA;;0BAAA;EAoBA,+CAAA;EAKA;;uBAAA;EAIA,uBAAA;EAiBA;;uBAAA;EAiBA;;uBAAA;EAIA,kCAAA;EAUA;;uBAAA;EASA;;uBAAA;EAIA,wCAAA;EAQA,gCAAA;EAMA,+BAAA;EASA,6CAAA;EAMA;;iCAAA;EAKA;;4BAAA;EAmDA;;uBAAA;EAIA,sCAAA;EAMA,eAAA;EAkEA,wBAAA;EAkDA,gBAAA;EAKA;;uBAAA;EAIA,wBAAA;EAkGA;;0BAAA;EAIA,+BAAA;EAoGA,+BAAA;EAoGA,yCAAA;EAoGA,sCAAA;EAoGA,mCAAA;EAoGA;;0BAAA;EAuBA;;0BAAA;EAkBA,6BAAA;EAaA;;0BAAA;EAgBA;;0BAAA;EAYA;;0BAAA;EASA,kEAAA;EAeA,sCAAA;EAMA,iCAAA;EAMA,gBAAA;EAQA,uBAAA;EAiBA,gCAAA;EAMA,iCAAA;EAKA,qBAAA;EAaA,YAAA;EAYA;;0BAAA;EAuCA,sBAAA;EAYA;;0BAAA;EAIA,gBAAA;EAWA,mBAAA;EAWA,mBAAA;EAWA,cAAA;EAmBA;;0BAAA;EAIA,iBAAA;EAUA,mBAAA;EAaA,kBAAA;EAUA,cAAA;EAUA;;0BAAA;EAiBA;;0BAAA;EAiBA;;0BAAA;EAKA,WAAA;EAqCA,WAAA;EAoCA,aAAA;EAqCA;;uBAAA;EAIA,gBAAA;EA+FA,gBAAA;EA2FA;;uBAAA;EA4EA;;0BAAA;EAKA,qEAAA;EAEA,qBAAA;EA2BA,qBAAA;EA4BA,uBAAA;EA4BA,2BAAA;EAsBA,yBAAA;EAgBA;;oBAAA;EAeA,QAAA;EAMA,YAAA;EAMA,qBAAA;EAUA;;oBAAA;EAeA,QAAA;EAMA,YAAA;EAMA,qBAAA;ECx0DA;;kBAAA;EAgCA;;kBAAA;EAYA;;kBAAA;EA8BA,WAAA;EAYA;;kBAAA;EAiBA;;kBAAA;EAUA;;kBAAA;EAaA;;oBAAA;EAWA;;kBAAA;EAmBA;;kBAAA;EAkBA;;kBAAA;EAKA,kBAAA;EAOA,SAAA;EAWA,eAAA;EAsCA,cAAA;EAOA,aAAA;EAME,aAAA;EAQA,aAAA;EA8BF,mBAAA;EAKA;;kBAAA;EAwBA;;kBAAA;EAgBA;;iCAAA;EAIA;;kBAAA;EAIA,gCAAA;EAME;;kBAAA;EAIA,sCAAA;EAWF;;kBAAA;EAsBA;;iCAAA;EAIA;;kBAAA;EAeA;;kBAAA;EAYA;;kBAAA;EAcA;;kBAAA;EAWA;;kBAAA;EAYA;;iCAAA;EAIA;;sBAAA;EAIA,iBAAA;EAMA,kBAAA;EAYA,WAAA;EAQA,oBAAA;EAOA,yBAAA;EAOE;;kBAAA;EAWA,eAAA;EAcA,gBAAA;EAMA,eAAA;EAaA,iBAAA;EAgBA,mBAAA;EAkBA,oBAAA;EA2BA;;kBAAA;EA4BA,UAAA;EAMA,WAAA;EAaE,yCAAA;EAuCA,4BAAA;EAuBA,2BAAA;EAyBF,aAAA;EAYA;;kBAAA;EA2BA,WAAA;EAYA;;kBAAA;EAaA,SAAA;EAYA,eAAA;EAKA,WAAA;EAOA,UAAA;EAKA,UAAA;EAQA,WAAA;EAQA,iBAAA;EAQE,aAAA;EAiBF,qBAAA;EAcE;;0BAAA;EAIA,aAAA;EAkBA,aAAA;EAKA,aAAA;EAOA;;0BAAA;EAkCA,eAAA;EAWA,UAAA;EAQA,YAAA;EAQA,WAAA;EASA,iBAAA;EAMA,oBAAA;EAME,sBAAA;EAeA,oBAAA;EAQA,aAAA;EAYA,UAAA;EAMA,WAAA;EAYJ;;kBAAA;EAuBA,WAAA;EAMA,WAAA;EAUA,UAAA;EAKA,qBAAA;EAME,wBAAA;EAuBA,sBAAA;EAUF,gBAAA;EAMA,iBAAA;EASA,uBAAA;EAKA,uBAAA;EAWE,aAAA;EAYF,UAAA;EAOF;;kBAAA;EAIA,kBAAA;EAMA,SAAA;EAOA,SAAA;EAMA,eAAA;EAKA,kBAAA;EAMA,kBAAA;EAQA;;kBAAA;EAIA,SAAA;EAKA,SAAA;EAMA,SAAA;EAQA,UAAA;EAMA;;iCAAA;EAIA;;kBAAA;EA2CA;;kBAAA;EAqBE;;kBAAA;EAUA,cAAA;EAUA,iBAAA;EAQA,aAAA;EAMA,WAAA;EAOA,aAAA;EAKA,gBAAA;EAcA,kBAAA;EAOA,iBAAA;EAgBA,uBAAA;EAeF;;kBAAA;EAkBE;;kBAAA;EA0BF;;kBAAA;EAsBA;;kBAAA;EAUA;;uBAAA;EA2BA;;uBAAA;EAUA;;uBAAA;EAwDA;;kBAAA;EA4DA,uBAAA;EAOE;;uBAAA;EA2CA,WAAA;EAQA,6BAAA;EAMA,WAAA;EAsCA;;kBAAA;EAIA,WAAA;EAcA,QAAA;EAYA,WAAA;EAaA,uBAAA;EAQA,qBAAA;EAgBF;;kBAAA;EAIA,SAAA;EAcA,SAAA;EAcA,UAAA;EAcA,WAAA;EAQA,UAAA;EAcA,SAAA;EAcA,QAAA;EAcA,YAAA;EAeE;;uBAAA;EA2BA,aAAA;ECx6DF;;iCAAA;EAyBA;;kBAAA;EAIA,WAAA;EAQA,sBAAA;EAKA,cAAA;EAeA,SAAA;EAgCA,SAAA;EAKA,eAAA;EAcA,yBAAA;EAQA;;iCAAA;EAQA;;iCAAA;EAIA;;kBAAA;EAYA;;kBAAA;EASA;;iCAAA;EAIA;;kBAAA;EAaA;;kBAAA;EA4BA;;kBAAA;EAgCA;;kBAAA;EASA;;kBAAA;EAoFA;;kBAAA;EC/TA;;iCAAA;EAIA,cAAA;EA2BA;;iCAAA;EAIA,kBAAA;EAMA,YAAA;EAgCA,WAAA;EA6BA,cAAA;EAUA,mBAAA;EAKA,gBAAA;EAOA,UAAA;EAQA,kBAAA;EAYA,eAAA;EAiEA;;iCAAA;EAIA,aAAA;EAOA;;iCAAA;EAKE;;kBAAA;EAwCA;;kBAAA;EAsBA,8BAAA;EAgBA,mBAAA;EAaF;;iCAAA;EAIA;;kBAAA;EAWA;;kBAAA;EAWA;;kBAAA;EAWA;;kBAAA;EAWA;;kBAAA;EAaA;;kBAAA;EAYA;;iCAAA;EAIA;;kBAAA;EA2DA;;kBAAA;EAiBA;;qBAAA;EAiBA;;kBAAA;EAUA;;kBAAA;EAeA;;kBAAA;EAiBA,yBAAA;EAgBA,iBAAA;EAkCA;;uBAAA;EAIA,WAAA;EAeA,QAAA;EAYA,WAAA;EAaA;;kBAAA;EAIA,mBAAA;EAOE,YAAA;EAOF,+BAAA;EAMA;;kBAAA;EASA;;uBAAA;EA8DA;;kBAAA;EAIA,eAAA;EAkDA,iBAAA;EAmEE;;kBAAA;EAqCA,UAAA;EAUA,WAAA;EASA,iBAAA;EAOE,aAAA;EAkBF;;kBAAA;EAIA,eAAA;EAgCA,eAAA;EAYF;;kBAAA;EASE;;kBAAA;EAoBA;;KAAA;EAWA,eAAA;EAkCA;;kBAAA;EA6BA;;kBAAA;EAoBA,SAAA;EAeA;;kBAAA;EAgBA,SAAA;EAcF;;kBAAA;EAIA,UAAA;EAKA,aAAA;EAKA,UAAA;EC7nCA;;iCAAA;EAyBA;;kBAAA;EAIA,gBAAA;EAMA,qBAAA;EAMA,oBAAA;EAKA,cAAA;EAMA;;kBAAA;EAIA,WAAA;EAMA,iBAAA;EAMA;;kBAAA;EAIA,oBAAA;EAMA,uBAAA;EAMA;;kBAAA;EAiBA;;kBAAA;EAIA,eAAA;EAMA,oBAAA;EAKA;;kBAAA;EAIA,WAAA;EAMA,oBAAA;EAMA,eAAA;EAMA,gBAAA;EAMA;;kBAAA;EAIA,gBAAA;EAMA,cAAA;EAMA;;kBAAA;EAIA,aAAA;EAMA;;kBAAA;EAIA,aAAA;EAQA;;kBAAA;EAIA,wBAAA;EAMA,uBAAA;EAMA;;iCAAA;EAIA,iBAAA;EAYA;;iCAAA;ECtNA;;iCAAA;EAIA;;kBAAA;EAuCA;;kBAAA;EAgBA,aAAA;EAYA,iDAAA;EAMA;;kBAAA;EAoBA;;kBAAA;EAwBA;;kBAAA;EAmCA,wBAAA;EAgBA;;oBAAA;EAaA;;kBAAA;EAkBA;;kBAAA;EAoBA;;kBAAA;EAUA;;kBAAA;EAaA;;kBAAA;EAwBA;;kBAAA;EAIA,YAAA;EAWA,WAAA;EAUA,SAAA;EAUA;;kBAAA;EAeA;;kBAAA;EAUA;;kBAAA;EAIA,kBAAA;EAEA,SAAA;EAiBA,kBAAA;EAEA,SAAA;EAiBA;;oBAAA;EA+BA;;iCAAA;EAIA;;uBAAA;EA0CA;;uBAAA;EAeA;;uBAAA;EAYA;;uBAAA;EASA;;uBAAA;EAwBA;;uBAAA;EA+CA;;kBAAA;EAyGA;;uBAAA;EAIA,gBAAA;EAqFA,gBAAA;EAqFA;;uBAAA;EAoBA;;kBAAA;EASE;;qBAAA;EAUA,YAAA;EAMA,WAAA;EAMA,gBAAA;EAMA,SAAA;EAcA,UAAA;EAeA,iBAAA;ECz5BF;;iCAAA;EAKA;;kBAAA;EAgBA;;kBAAA;EAmBA;;wBAAA;EAmBA;;kBAAA;EAoBA;;kBAAA;EAOA,4CAAA;EAKA;;kBAAA;EAgBA;;kBAAA;EAkBA;;wBAAA;EAaA;;wBAAA;EAqBA;;wBAAA;EAgBA;;iCAAA;EAWA;;iCAAA;EAIA;;wBAAA;EAUA;;wBAAA;EAkBA;;uBAAA;EA8BE;;uBAAA;ECxPF;;iCAAA;EAeA;;iCAAA;EAIA,UAAA;EAkBA,gBAAA;EA4BA;;kBAAA;EAIA,YAAA;EAYA,SAAA;EAKA;;kBAAA;EAaA;;kBAAA;EAWA,kBAAA;EASA;;kBAAA;EAgBA;;kBAAA;EAIA,wBAAA;EAYA;;kBAAA;EAWA,WAAA;EAOA,SAAA;EASA;;kBAAA;EAyCA,kBAAA;EAQA,WAAA;EAgBA;;iCAAA;EAeE;;sBAAA;EClQF;;iCAAA;EAIA;;kBAAA;EAsBA;;kBAAA;EAeA;;kBAAA;EAqBA;;kBAAA;EA2BA;;kBAAA;EAyCA,wBAAA;EAKA;;kBAAA;EAYA;;kBAAA;EAgBA;;kBAAA;EAYA;;kBAAA;EAWA;;kBAAA;EAsBA;;kBAAA;EAIA,YAAA;EASA,WAAA;EAQA,SAAA;EAUA;;kBAAA;EAIA,kBAAA;EAEA,SAAA;EAcA,kBAAA;EAEA,SAAA;EAcA;;oBAAA;EAmCA;;iCAAA;EAIA,wBAAA;EAMA,gBAAA;EAeA,gBAAA;EAwBA;;iCAAA;EAKA;;uBAAA;EAeA;;kBAAA;EAYA;;uBAAA;EAmBA,oBAAA;EAWA;;uBAAA;EAeA;;kBAAA;EAQA;;mBAAA;EAaE;;kBAAA;ECzcF;;iCAAA;EAIA,eAAA;EAqBA;;iCAAA;EAIA,YAAA;EAkBA,aAAA;EAeA;;iCAAA;EAKA;;kBAAA;EAeA;;kBAAA;EAcA,cAAA;EAMA,iBAAA;EAQA;;iCAAA;EAIA;;kBAAA;EAWA;;kBAAA;EAgBA;;kBAAA;EAYA;;iCAAA;EAKA;;kBAAA;EAwFA;;kBAAA;EA0CE;;kBAAA;EAeF;;kBAAA;EAyBA;;kBAAA;EAgBA;;kBAAA;EAkBA;;kBAAA;EAKA,SAAA;EAeA,SAAA;EAcA,UAAA;EAcA,WAAA;EAcA,UAAA;EAcA,SAAA;ECtbA;;iCAAA;EAaA,UAAA;EAMA,oBAAA;EAQA,oBAAA;EAUA,UAAA;EAgBA;;kBAAA;EAIA,SAAA;EAWA,WAAA;EAMA;;iCAAA;EAaA;;iCAAA;EAIA;;kBAAA;EA6BA,YAAA;EAYA,UAAA;EAeA,WAAA;EAWA;;iCAAA;EAIA;;kBAAA;EASA;;iCAAA;EAIA;;kBAAA;EAUE;;kBAAA;ECjLF,kBAAA;ECRA;;iCAAA;EAWA;;iCAAA;EAQA;;iCAAA;EAaA;;iCAAA;EAmFA;;kBAAA;EA+BA;;iCAAA;EAIA;;wBAAA;ECtJA;;iCAAA;EAKA;;kBAAA;EAkBA,kBAAA;EAeA;;kBAAA;EAgCA;;kBAAA;EAmBA;;kBAAA;EAIA,WAAA;EAOA,YAAA;EAMA;;iCAAA;EAKA;;kBAAA;EAcA;;kBAAA;EAiBA;;kBAAA;EAiBA;;kBAAA;EAeA;;kBAAA;EAuBA;;kBAAA;EAmBA;;kBAAA;EAUA;;kBAAA;EAaA;;kBAAA;EAIA;kCAAA;EAMA,qBAAA;EAOA;;iCAAA;EAKA;;kBAAA;EAaA,QAAA;EAaA,WAAA;EAUA,mBAAA;EAYA,UAAA;EAUA,kBAAA;EAMA,WAAA;EAUA,iBAAA;EAWE;;kBAAA;EAQA,UAAA;EAMA,UAAA;EAQA,SAAA;EAsBA,WAAA;EAqBA,UAAA;EAOA,UAAA;EAUA,WAAA;EAcA,iBAAA;EAaA;;kBAAA;EAQA,UAAA;EAMA,UAAA;EAWA,WAAA;EAmBA,WAAA;EA0BA,UAAA;EAOA,UAAA;EAOA,WAAA;EAgBA,iBAAA;EAYF;;iCAAA;EAKE;;kBAAA;EAuBA;;kBAAA;EAQA,UAAA;EAWE,gBAAA;EAMA,gBAAA;EAMA,iBAAA;EAMA,kBAAA;EAUA,wBAAA;EAYA,kBAAA;EAMA,iBAAA;EAMA,kBAAA;EAUA,wBAAA;EAYJ;;wBAAA;EC3qBA,cAAA;EAMA,YAAA;EAMA,kBAAA;EAQA;;;;GAAA;ECzBA;;iCAAA;EAsCA,mBAAA;EAOA,mBAAA;EAKA,eAAA;EAgBA;;iCAAA;EAIA,cAAA;EAMA,iCAAA;EAQA,aAAA;EAOA;;iCAAA;EAKA;;kBAAA;EAIA,iCAAA;EAOA;;kBAAA;EAWA;;kBAAA;EAqBE;;kBAAA;EAYA,iBAAA;EASF;;kBAAA;EAaE;;kBAAA;EAgBA;;kBAAA;EAYA;;kBAAA;EAeF;;kBAAA;EAIA,gCAAA;EA4BE;;mBAAA;ECxPF;;iCAAA;EAgBA;;iCAAA;EAIA;;kBAAA;EAiCA;;kBAAA;EASA;;kBAAA;EAoBA;;kBAAA;EASA;;kBAAA;EA2BA;;kBAAA;EAyBA;;kBAAA;EA0CA;;sBAAA;EAWA;;sBAAA;EAYA;;kBAAA;EAaA,eAAA;EAKA;;kBAAA;EAIA,mCAAA;EA+BA;;kBAAA;EAiBA;;iCAAA;EAKA;;kBAAA;EAIA,6BAAA;EAMA,6BAAA;EAKA,8DAAA;EAQA;;kBAAA;EAIA,kBAAA;EAKA;;kBAAA;EAIA,6BAAA;EAUA;;iCAAA;EAIE;;kBAAA;EAIA,+BAAA;EAiDA,YAAA;EAKA,oBAAA;EAsBA;;kBAAA;EA6EA,cAAA;EAQA,cAAA;EAKA,UAAA;EAMA,WAAA;EAUA,UAAA;EAUA,YAAA;EAMA,kBAAA;EAUA,kBAAA;EAOA,sBAAA;EAMA,4BAAA;EAYA;;kBAAA;EAIA,qBAAA;EAKA,oBAAA;EAcA,kBAAA;EAYA,qBAAA;EAMA,uDAAA;EAQA,0BAAA;EAUA,kBAAA;EASA,gBAAA;EA+BA,wBAAA;EA2BA;;kBAAA;EAIA,uBAAA;EAQA,8BAAA;EAMA,oBAAA;EAUA,kBAAA;EAMA,SAAA;EA0BE;;oBAAA;EAIA,gBAAA;EAeA,WAAA;EAaF;;kBAAA;EAuBF;;iCAAA;EAKA;;yBAAA;EAIA,qBAAA;EAUA;;yBAAA;EAIA,oBAAA;EAOA;;wBAAA;EAwCA,aAAA;EAMA;;yBAAA;EAYA;;yBAAA;EAQA,2BAAA;EAeA;;yBAAA;EAIA,kBAAA;EAQA;;yBAAA;EAIA,kBAAA;EASA;;yBAAA;EA6BA,eAAA;EAKA,gBAAA;EAMA;;yBAAA;EAaA;;yBAAA;EAIA,aAAA;EASA;;iCAAA;EAIA;;kBAAA;EAIA,qBAAA;EAMA,yBAAA;EAQA,0BAAA;EAiCA;;kBAAA;EAIA,qBAAA;EAQA,oBAAA;EAMA,kBAAA;EASA,cAAA;EAUA,kBAAA;EAKA,mBAAA;EAMA,yBAAA;EAQA;;kBAAA;EAIA,oBAAA;EAwCA,oBAAA;EAiCE;;kBAAA;EAsBA;;kBAAA;EAIA,gCAAA;EAkDA,YAAA;EAKA,cAAA;EAQF;;kBAAA;EAcA;;kBAAA;EAqBE;;kBAAA;EA6BA,sBAAA;EAsBA,uBAAA;EAiBA,kBAAA;EA2BA,mBAAA;EAeA,oBAAA;EAeA,+BAAA;EAMA,gBAAA;EAUA,iBAAA;EAUA,oBAAA;EAgBA,0BAAA;EAcA,yBAAA;EAeF;;wBAAA;EAIA,kBAAA;EA0BA,uBAAA;EA2BE;;kBAAA;EAIA,sCAAA;EAkEE,cAAA;EAiCF,sBAAA;EAME,WAAA;EA0BF,gCAAA;EAiBA,eAAA;ECpsDF,oBAAA;EA6BA,aAAA;EAUA,2BAAA;EAKA;;;;;;;;;;;;;GAAA;EC1CA;;iCAAA;EAaA;;qBAAA;EAkBA;;qBAAA;EAQA;;kBAAA;EAeA;;kBAAA;EAsCA;;iCAAA;EAIA;;kBAAA;EAYA;;kBAAA;EAaA;;iCAAA;ECzHA;;iCAAA;EAmCA;;iCAAA;EAIA;;kBAAA;EAuBA;;kBAAA;EAqBA;;kBAAA;EAiBA,UAAA;EAkBA,gBAAA;EAgBA,aAAA;EASA;;kBAAA;EAiBA;;uBAAA;EAIA,gBAAA;EAgCA,sBAAA;EAYA,WAAA;EAyDA;;kBAAA;EAQA;;iCAAA;EAkCA,2CAAA;EAoBA;;iCAAA;EAcA;;iCAAA;EAIA;;kBAAA;EAqBA;;kBAAA;EAIA,qBAAA;EAgBA,yBAAA;EAcA,sBAAA;EAaE;;kBAAA;EA6BF;;kBAAA;EAQA,SAAA;EAKA,qBAAA;EAgCA,SAAA;EAKA,qBAAA;EAgCA,UAAA;EAKA,sBAAA;EAgCA,sBAAA;EAqCE;;iCAAA;ECtlBF;;iCAAA;EA0DA;;iCAAA;EAIA,UAAA;EAWA;;iCAAA;EAKA;;kBAAA;EASA;;kBAAA;EAQA;;kBAAA;EAWA;;kBAAA;EAiBA;;iCAAA;EC3HA;;iCAAA;EAoDA;;iCAAA;EAIA;;kBAAA;EAIA,YAAA;EAKA,UAAA;EAgBA,UAAA;EA0BA,kCAAA;EAiBA,cAAA;EA+BA,uBAAA;EAgCA;;kBAAA;EAIA,UAAA;EAKA,mBAAA;EAKA,WAAA;EAYA;;kBAAA;EAIA,eAAA;EAmBA,aAAA;EAiBA,cAAA;EAkBA,kBAAA;EAkBA,gBAAA;EAeA,iBAAA;EAeA,gBAAA;EAcA,iBAAA;EAcA,UAAA;EAiBA,yBAAA;EAoCA;;kBAAA;EA6BA;;kBAAA;EAOA;;kBAAA;EAQA,uBAAA;EAcA,mCAAA;EAUA,0BAAA;EAcA;;kBAAA;EAIA,gBAAA;EAaA,aAAA;EAaA,aAAA;EAUA,gBAAA;EAWA,aAAA;EAWA,aAAA;EASA,sBAAA;EACA,aAAA;EAUA,wBAAA;EACA,aAAA;EAUA,4BAAA;EAYA,yBAAA;EAaA;;iCAAA;EAIA,0BAAA;EAMA;;iCAAA;EAqBA;;iCAAA;EAIA;;kBAAA;EASA;;kBAAA;EAmBA;;kBAAA;EAWE;;kBAAA;EAIA,qBAAA;EAiBF;;kBAAA;EASA;;kBAAA;EChsBA;;iCAAA;EAuBA;;iCAAA;EAIA,iBAAA;EAyBA,qBAAA;EAiBA,UAAA;EAkBA;;iCAAA;EAKA,eAAA;EAwBA,qBAAA;EAyBE,8BAAA;EAyBF,kBAAA;EAwCA,uBAAA;EAKA,aAAA;EAKA;;iCAAA;EAKA;;kBAAA;EAeA;;kBAAA;EAeA;;kBAAA;EAeA;;kBAAA;EAmCA;;kBAAA;EAaA;;iCAAA;EAKE;;kBAAA;EA6BA;;kBAAA;EAIA,oBAAA;EAmBA,iBAAA;EAUA,aAAA;EAgBF;;kBAAA;EAyBA;;kBAAA;EAuCA;;mBAAA;EC7cA;;iCAAA;EAaA,SAAA;EAiBA;;iCAAA;EAKA;;uBAAA;EAIA,kBAAA;EAMA,gBAAA;EAMA,kBAAA;EAQA;;kBAAA;EAgCA;;iCAAA;EAIA;;uBAAA;EAIA,oBAAA;EAMA;;uBAAA;EAIA,oBAAA;EAWA;;iCAAA;ECxHA;;iCAAA;EAkCA;;kBAAA;EAQA;;kBAAA;EAgCA;;kBAAA;EAkBA,UAAA;EAeA;;kBAAA;EAyBA;;kBAAA;EAmBA,qBAAA;EAYA;;iCAAA;EAIA;;wBAAA;EAUA;;wBAAA;EAmCA;;kBAAA;EAYA;;kBAAA;EAyBA;;yBAAA;EAIA,aAAA;EAQA;;iCAAA;EAIA;;kBAAA;EAQA,iBAAA;EAyBA;;kBAAA;EAaA,aAAA;EAQA,kBAAA;EAKA,iBAAA;EAQA,yBAAA;EAeA,oBAAA;EAaA;;iCAAA;EAIA;;uBAAA;EAaA;;kBAAA;EASA;;kBAAA;EA0BA;;kBAAA;EC5ZA;;iCAAA;EA6BA;;iCAAA;EA4BA;;iCAAA;EAeA;;iCAAA;EAIA;;kBAAA;EAWA;;kBAAA;EAgBA;;kBAAA;EAgBA;;kBAAA;ECvHA;;iCAAA;EAIA,iBAAA;EAqBA,kCAAA;EAMA;;kBAAA;EAgCA;;kBAAA;EAUA,eAAA;EAQA,iBAAA;EAWA;;kBAAA;EAaA;;kBAAA;EAoBA;;kBAAA;EAiBA;;kBAAA;EAQA;;iCAAA;EAIA;;kBAAA;EAUA;;kBAAA;EAQA;;kBAAA;EASA,qBAAA;EAUA,oBAAA;EAkBA,kDAAA;EAQA;;kBAAA;EAKA;;iCAAA;EAIA;;kBAAA;EAIA,iBAAA;EAsBA,iBAAA;EAkBA,kBAAA;EAoBA;;iCAAA;EAIA;;kBAAA;EAIA,WAAA;EAKA,YAAA;EAcA,cAAA;EAMA,kBAAA;EAcA,iBAAA;EAQA;;kBAAA;EAIA,YAAA;EAMA,sBAAA;EAcA,QAAA;EAMA;;kBAAA;EAIA,YAAA;EAMA,QAAA;EAOA;;kBAAA;EAIA,YAAA;EAKA,sBAAA;EAcA,cAAA;EAKA,QAAA;EAMA;;kBAAA;EAIA,YAAA;EAKA,sBAAA;EAcA,cAAA;EAKA,QAAA;EAKA;;kBAAA;EAIA,YAAA;EAMA,uBAAA;EAcA,qBAAA;EAcA,cAAA;EAYA,QAAA;EClbA;;iCAAA;EAKA;;kBAAA;EAiBE;;kBAAA;EAmBF;;iCAAA;EAKE;;kBAAA;EA4BE,sBAAA;EAWA,6BAAA;EAMF,oBAAA;EA0BA,mBAAA;EAgBA,mBAAA;EAiBA,iBAAA;EAkBF;;kBAAA;EAsCA;;kBAAA;EAeE;;kBAAA;EAaF;;kBAAA;EAYI,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAdF,aAAA;EAKA,UAAA;EASE,mBAAA;EAeN;;kBAAA;EAIA,aAAA;EASE;;kBAAA;EAIA,aAAA;EASF;;kBAAA;EAIA,UAAA;EAsBA,UAAA;EAsBA,QAAA;ECxaA;;iCAAA;EAUA;;iCAAA;EAIA,UAAA;EAOA,UAAA;EAOA,yBAAA;EAaA;;iCAAA;ECzCA;;iCAAA;EAQA;;iCAAA;EAIA;;wBAAA;EASA;;wBAAA;ECrBA;;iCAAA;EA6CA;;iCAAA;EAyFA;;kBAAA;EA2BA;;kBAAA;EAkBA;;mBAAA;EAkCA;;cAAA;ECrNA;;iCAAA;EAWA;;iCAAA;EAKA,cAAA;EAMA,YAAA;EAOA,WAAA;EAMA,YAAA;EAQA,aAAA;EAKA;;iCAAA;EClDA;;iCAAA;EAIA;;;;;;GAAA;EAQA;;kBAAA;EAkBA,OAAA;EAsBA,QAAA;EAuCA;;kBAAA;EAgBA,SAAA;EAsBA;;kBAAA;EAoCA,OAAA;EAkDA,QAAA;EAkDA;;kBAAA;EAqBA,OAAA;EAsBA,QAAA;EAsBA;;kBAAA;EAsBA,QAAA;EAaA;;kBAAA;EAIA,WAAA;EAqBA,YAAA;EAiBA,OAAA;EAqGA,QAAA;EA6DA;;kBAAA;EAwCA,OAAA;EAsBA,QAAA;EAuBA;;kBAAA;EA2CA,OAAA;EAwCA,QAAA;EAyCA;;kBAAA;EAgCA;;iCAAA;EAIA;;kBAAA;EAsCA,UAAA;EAUA,UAAA;EAaA,WAAA;EAaA,SAAA;EAmBA,UAAA;EAiBA,WAAA;EAyBA,SAAA;E7Dn6BA,mBAAA;AAs9GF;AEt+GI;;;;EAIE,kBAAA;AFw+GN;AEt+GI;;;EAGE,yBAAA;AFw+GN;AM/+GA;;;EAGE,mBAAA;ANi/GF;AM/+GA;EACE,sBAAA;ANi/GF;AM7+GA;;;;EAIE,wBAAA;EACA,qBAAA,EAAA,wBAAA;AN++GF;AO3/GA;;EAEE,YAAA;AP6/GF;AO1/GA;EACE,euDGQ;A9Dy/GV;AOz/GA;EACE,SAAA;EACA,UAAA;EACA,kBwDnBgB;ExDoBhB,gBwDlBe;ExDmBf,mBwDtBgB;ExDuBhB,6EuDpBU;EvDqBV,euDJU;EvDKV,qByDzBY;EzD0BZ,0B0DvBW;AjEkhHb;AOp/GA;;;;;EAKE,6EuDpCY;EvDqCZ,2B2DnCmB;E3DoCnB,0C4DjCc;E5DkCd,iBuD5BK;EvD6BL,UAAA;APs/GF;AOn/GA;EACE,gBAAA;EACA,e2DzCG;AlE8hHL;AOn/GA;EACE,0B2D3CG;AlEgiHL;AOn/GA;EACE,0B2D7CG;AlEkiHL;AOn/GA;EACE,0B2D/CG;AlEoiHL;AOn/GA;EACE,e2DjDG;AlEsiHL;AOl/GA;;;;;EAKE,aAAA;APo/GF;AOj/GA;;;;;EAKE,gBAAA;APm/GF;AO5+GA;EACE,eyDjFiB;EzDkFjB,qByDpFY;AhEkkHd;AO5+GA;EACE,aAAA;AP8+GF;AO5+GA;EACE,gBAAA;AP8+GF;AOv+GA;EACE,c6DlGW;E7DmGX,qB8DnGe;ArE4kHjB;AOv+GA;EACE,wD+DnGiB;E/DoGjB,qB8DvGe;ArEglHjB;AOh+GE;EACE,wBAAA;EACA,UgE7GqB;EhE8GrB,WgE7GsB;AvE+kH1B;AOh+GE;EACE,uBiEtHe;EjEuHf,gBgE/GkB;AvEilHtB;AOh+GE;EACE,eAAA;EACA,kBgEjHkB;EhEkHlB,8BiE3He;EjE4Hf,2BgElHe;AvEolHnB;AOh+GE;EACE,+BiE9HwB;AxEgmH5B;AOh+GE;EACE,oCiEhIqB;AxEkmHzB;AO99GE;EACE,oCkExIwB;AzEwmH5B;AO99GE;EACE,qCkE1IwB;AzE0mH5B;AO99GE;EACE,qCkE5IiC;AzE4mHrC;AO99GE;EACE,qCkE9I8B;AzE8mHlC;AOv9GA;EACE,yBmEzJqB;EnE0JrB,0B0DzJW;AjEknHb;AOv9GA;EACE,yBmE7JqB;EnE8JrB,0B0D7JW;AjEsnHb;AOv9GA;EACE,yBmEjKqB;EnEkKrB,0B0DjKW;AjE0nHb;AOr9GA;;EAEE,0CmErK2B;EnEsK3B,0B0DxKW;AjE+nHb;AOr9GA;;EAEE,0CmE1K2B;EnE2K3B,0B0D7KW;AjEooHb;AOr9GA;;EAEE,0CmE/K2B;EnEgL3B,0B0DlLW;AjEyoHb;AQ7iHE;EACE,eAAA;EACA,qBAAA;EAEA,eAAA;EAEA,aAAA;EACA,YAAA;EACA,wBmE7EoB;EnE8EpB,wBmE9FgB;EnE+FhB,yBmEnFgB;EnEqFhB,6EsDxGQ;EtD0GR,oBAAA;EACA,4CAAA;EAEA,oBmE9FoB;EnE+FpB,iBmE1FiB;EnE2FjB,iBsDrGG;EtDsGH,gBmExGiB;EnEyGjB,kBAAA;EACA,kBAAA;EACA,qBAAA;EAEA,8BoElHG;EpEmHH,6EmEnFF;EnEqFE,iBAAA;EACA,sHmEnEF;EnEoEE,iBmE7DiB;EnE+DjB,wCmE5Ge;A3EmpHnB;AQ3hHE;EACE,yBmE/D4B;EnEgE5B,sBmEpIsB;EnEqItB,6EmExGF;EnEyGE,yBqE1IiB;A7EuqHrB;AQ1hHE;EACE,amElEwB;A3E8lH5B;AQrhHE;EACE,yBmE9E4B;EnE+E5B,yBqEvJiB;ErEwJjB,sBmExE4B;EnEyE5B,cmExEsB;A3E+lH1B;AQphHE;EACE,amE1EwB;A3EgmH5B;AQ/gHE;;EAEE,yBmE5E2B;EnE6E3B,oBmE5E2B;EnE6E3B,yBqEvKiB;ErEwKjB,6CmE3EF;A3E4lHF;AQ1gHE;EACE,yBmE7E6B;EnE8E7B,sBmE7E6B;EnE8E7B,uCmEpJuB;EnEqJvB,0BqElLkB;A7E8rHtB;AQ1gHE;EACE,yBmEnF6B;EnEoF7B,sBmE7EmC;EnE8EnC,0BqEvLkB;A7EmsHtB;AQ1gHE;EACE,yBmExF6B;EnEyF7B,sBmExF6B;A3EomHjC;AQngHE;EACE,kBAAA;EACA,eAAA;EACA,4BAAA;EACA,kBAAA;EACA,UmE3FqB;EnE4FrB,oBmE3F4B;EnE4F5B,4CmE1FF;A3E+lHF;AQngHE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CsEtNY;EtEuNZ,qBuE7LW;EvE8LX,sBuE9LW;EvEgMX,qBwE5Nc;ExE6Nd,uCAAA;ARmgHJ;AQjgHE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CsEnOY;EtEoOZ,qBuE1MW;EvE2MX,sBuE3MW;EvE6MX,qBwEzOc;ExE2Od,sCAAA;EACA,gCAAA;EACA,cyE3OI;EzE6OJ,iCAAA;AR+/GJ;AQ5/GI;EACE,6BAAA;EACA,gBAAA;AR8/GN;AQz/GI;EACE,gC0E1Pc;AlFqvHpB;AQz/GI;EACE,qB2EpPC;AnF+uHP;AQp/GE;;;;;EAKE,eAAA;EACA,wBAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;ARs/GJ;AQj/GI;EACE,mC4E5QkB;ApF+vHxB;AQx+GI;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,sBmE+E2B;EnE9E3B,UmE+EoB;A3E25G1B;AQv+GI;EACE,+BAAA;ARy+GN;AQv+GI;EACE,kBAAA;EACA,mBmE9RsB;A3EuwH5B;AQv+GI;EACE,kBAAA;EACA,WAAA;ARy+GN;AQr+GI;;EAEE,8BAAA;ARu+GN;AQr+GI;EACE,UAAA;EACA,QAAA;ARu+GN;AQr+GI;EACE,QAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;ARu+GN;AQr+GI;;EAEE,UAAA;EACA,WAAA;ARu+GN;AQr+GI;;EAEE,UAAA;EACA,QAAA;ARu+GN;AQn+GI;;EAEE,8CAAA;ARq+GN;AQn+GI;EACE,yBAAA;EACA,WAAA;ARq+GN;AQn+GI;EACE,SAAA;EACA,OAAA;EACA,WAAA;ARq+GN;AQn+GI;;EAEE,2BAAA;EACA,WAAA;ARq+GN;AQn+GI;;EAEE,QAAA;EACA,WAAA;ARq+GN;AQj+GI;;EAEE,kDAAA;ARm+GN;AQj+GI;EACE,UAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;ARm+GN;AQj+GI;EACE,UAAA;EACA,OAAA;EACA,WAAA;EACA,qBAAA;ARm+GN;AQj+GI;;EAEE,UAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;ARm+GN;AQj+GI;;EAEE,OAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;ARm+GN;AQ19GI;EACE,mCAAA;EACA,4BAAA;EACA,cyE5YE;EzE6YF,4BAAA;AR49GN;AQx9GI;EACE,kBmEnOyB;A3E6rH/B;AQx9GI;EACE,cAAA;AR09GN;AQx9GI;EACE,kBmExOkC;A3EksHxC;AQx9GI;EACE,aAAA;AR09GN;AQp9GI;EACE,mByElaE;EzEmaF,mCAAA;EACA,yBqEnae;A7Ey3HrB;AQl9GI;;EAEE,mByE1aE;EzE2aF,mCAAA;EACA,yBqE3ae;A7E+3HrB;AQh9GI;EACE,mByElbM;EzEmbN,mCAAA;EACA,yBqElbe;A7Eo4HrB;AQx8GI;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AR08GN;AQv8GI;EACE,SAAA;ARy8GN;AQv8GI;EACE,aAAA;EACA,mBmEnTuB;EnEoTvB,6BAAA;EACA,euE/bG;EvEgcH,WmErTyB;EnEsTzB,oC6EhdS;ArFy5Hf;AQr8GI;EACE,amEvT0B;EnEwT1B,cmExT0B;A3E+vHhC;AQn8GI;EACE,0BAAA;EACA,6BAAA;ARq8GN;AQn8GI;EACE,yBAAA;EACA,4BAAA;ARq8GN;AQj8GI;EACE,yBAAA;EACA,4BAAA;ARm8GN;AQj8GI;EACE,0BAAA;EACA,6BAAA;ARm8GN;AQz7GM;EACE,yB8ErfS;E9EsfT,cyErfA;EzEsfA,iBmEnea;EnEoeb,sBmEzO0B;EnE0O1B,gDmE7dmB;A3Ew5H3B;AQz7GM;EACE,mE+Ejde;E/Ekdf,cyE5fA;EzE6fA,iBmE1ea;A3Eq6HrB;AQz7GM;EACE,mEgF9dc;EhF+dd,cyEjgBA;EzEkgBA,iBmE/ea;A3E06HrB;AQr7GM;EACE,yB8EzgBQ;E9E0gBR,cyE1gBA;EzE2gBA,iBmExfa;EnEyfb,sBmE9P0B;EnE+P1B,gDmElfmB;A3Ey6H3B;AQr7GM;EACE,mE+Erec;E/Esed,cyEjhBA;EzEkhBA,iBmE/fa;A3Es7HrB;AQr7GM;EACE,oEgFlfa;EhFmfb,cyEthBA;EzEuhBA,iBmEpgBa;A3E27HrB;AQj7GM;EACE,yB8E7hBY;E9E8hBZ,cyE/hBA;EzEgiBA,iBmE7gBa;EnE8gBb,sBmEnR0B;EnEoR1B,gDmEvgBmB;A3E07H3B;AQj7GM;EACE,mE+EzfkB;E/E0flB,cyEtiBA;EzEuiBA,iBmEphBa;A3Eu8HrB;AQj7GM;EACE,mEgFtgBiB;EhFugBjB,cyE3iBA;EzE4iBA,iBmEzhBa;A3E48HrB;AQ76GM;EACE,yB8EjjBU;E9EkjBV,cyEpjBA;EzEqjBA,iBmEliBa;A3Ei9HrB;AQ76GM;EACE,+C+E3gBgB;E/E4gBhB,cyEzjBA;EzE0jBA,iBmEviBa;A3Es9HrB;AQ76GM;EACE,4CgFxhBe;EhFyhBf,cyE9jBA;EzE+jBA,iBmE5iBa;A3E29HrB;AQz6GM;EACE,yB8EnkBQ;E9EokBR,cyEvkBA;EzEwkBA,iBmErjBa;EnEsjBb,sBmE3T0B;EnE4T1B,gDmE/iBmB;A3E09H3B;AQz6GM;EACE,kC+E/hBc;E/EgiBd,cyE9kBA;EzE+kBA,iBmE5jBa;A3Eu+HrB;AQz6GM;EACE,yBgF5iBa;EhF6iBb,cyEnlBA;EzEolBA,iBmEjkBa;A3E4+HrB;AQr6GM;EACE,yB8ErlBU;E9EslBV,cyE5lBA;EzE6lBA,iBmE1kBa;EnE2kBb,sBmEhV0B;EnEiV1B,gDmEpkBmB;A3E2+H3B;AQr6GM;EACE,oE+EnjBgB;E/EojBhB,cyEnmBA;EzEomBA,iBmEjlBa;A3Ew/HrB;AQr6GM;EACE,mEgFhkBe;EhFikBf,cyExmBA;EzEymBA,iBmEtlBa;A3E6/HrB;AQj6GM;EACE,yB8E5mBU;E9E6mBV,cyEjnBA;EzEknBA,iBmE/lBa;EnEgmBb,sBmErW0B;EnEsW1B,gDmEzlBmB;A3E4/H3B;AQj6GM;EACE,8C+EvkBgB;E/EwkBhB,cyExnBA;EzEynBA,iBmEtmBa;A3EygIrB;AQj6GM;EACE,kEgFplBe;EhFqlBf,cyE7nBA;EzE8nBA,iBmE3mBa;A3E8gIrB;AQ75GM;EACE,yB8EhoBG;E9EioBH,cyEtoBA;EzEuoBA,sBmEzX0B;EnE0X1B,gDmE7mBmB;A3E4gI3B;AQ75GM;EACE,mE+E1lBS;E/E2lBT,cyE5oBA;AjF2iIR;AQ75GM;EACE,kEgFtmBQ;EhFumBR,cyEhpBA;AjF+iIR;AQz5GM;EACE,yB8E/oBU;E9EgpBV,cyExpBA;EzEypBA,sBmE3Y0B;EnE4Y1B,gDmE/nBmB;A3E0hI3B;AQz5GM;EACE,mE+E1mBgB;E/E2mBhB,cyE9pBA;AjFyjIR;AQz5GM;EACE,mEgFtnBe;EhFunBf,cyElqBA;AjF6jIR;AQr5GM;EACE,yB8ElqBS;E9EmqBT,cyE1qBA;EzE2qBA,sBmE7Z0B;EnE8Z1B,gDmEjpBmB;A3EwiI3B;AQr5GM;EACE,oC+E7nBe;E/E8nBf,cyEhrBA;AjFukIR;AQr5GM;EACE,yBgFzoBc;EhF0oBd,cyEprBA;AjF2kIR;AQ94GE;EACE,YmEvpBiB;EnEwpBjB,YmEvpBkB;EnEwpBlB,0CmElpBiB;EnEmpBjB,6BmEtpBqB;EnEupBrB,kBmEtpByB;EnEupBzB,SmEzpBgB;A3EyiIpB;AQ74GE;;EAEE,0CmE1pBiB;A3EyiIrB;AQ74GE;EACE,0CmE5pBuB;A3E2iI3B;AQn4GE;;EAEE,WAAA;EACA,cAAA;EACA,oBmE/WoB;A3EovHxB;AQn4GE;;EAEE,YAAA;EACA,eAAA;EACA,mBmErXoB;A3E0vHxB;AQ93GE;;EAEE,8CAAA;ARg4GJ;AQ93GE;;EAEE,qDAAA;ARg4GJ;AQ93GE;;EAEE,qDAAA;ARg4GJ;AQ93GE;;EAEE,0CAAA;ARg4GJ;AQz3GE;;;EAGE,0BuErvBG;A/EgnIP;AQz3GE;;;EAGE,0BuEzvBG;A/EonIP;AQz3GE;;;EAGE,0BuE7vBI;A/EwnIR;AQz3GE;;;EAGE,euEjwBK;A/E4nIT;AQz3GE;;;EAGE,0BuErwBI;A/EgoIR;AQz3GE;;;EAGE,0BuEzwBE;A/EooIN;AQz3GE;;;EAGE,0BuE7wBG;A/EwoIP;AQz3GE;;;EAGE,0BuEjxBM;A/E4oIV;AQv3GE;EACE,0BuE7xBG;A/EspIP;AQv3GE;EACE,0BuEhyBG;A/EypIP;AQv3GE;EACE,0BuElyBG;A/E2pIP;AQv3GE;EACE,0BuEryBG;A/E8pIP;AQv3GE;EACE,0BuEvyBI;A/EgqIR;AQv3GE;EACE,0BuE1yBI;A/EmqIR;AQv3GE;EACE,0BuE3yBI;A/EoqIR;AQv3GE;EACE,0BuE9yBI;A/EuqIR;AQv3GE;EACE,0BuEhzBE;A/EyqIN;AQv3GE;EACE,0BuEnzBE;A/E4qIN;AQv3GE;EACE,0BuErzBG;A/E8qIP;AQv3GE;EACE,0BuExzBG;A/EirIP;AQv3GE;EACE,0BuE1zBM;A/EmrIV;AQv3GE;EACE,0BuE7zBM;A/EsrIV;AQl3GE;;EAEE,qDAAA;ARo3GJ;AQl3GE;;EAEE,YmExsBuB;EnEysBvB,oBAAA;EACA,mBAAA;ARo3GJ;AQ52GI;;EAEE,4BmEhrBoB;EnEirBpB,yBmEv1Bc;EnEw1Bd,mBsDh2BG;EtDi2BH,8BoEz2BC;EpE02BD,oBmE/qBwB;EnEgrBxB,4BAAA;EACA,kDmEnrBoB;A3EiiI1B;AQ52GI;EACE,gBmEtoB0B;EnEuoB1B,wCmExoBsB;EnEyoBtB,8BoEj3BC;A5E+tIP;AQ52GI;EACE,gBAAA;AR82GN;AQ32GI;;EAEE,mBmE3rB0B;EnE4rB1B,yBqE33Be;ErE43Bf,wFmE1rBJ;A3EuiIF;AQ32GI;;EAEE,mBmEjsB0B;EnEksB1B,yBqEj4Be;ErEk4Bf,wFmEhsBJ;A3E6iIF;AQ32GI;;EAEE,mBmE3rByB;EnE4rBzB,yBqEt4Be;ErEu4Bf,yFmE1rBJ;A3EuiIF;AQ32GI;;EAEE,+BiF/4Bc;EjFg5Bd,cmE1rB2B;EnE2rB3B,0BqE54BgB;A7EyvItB;AQ32GI;;EAEE,qCiFr5Bc;AzFkwIpB;AQz2GI;EACE,8FAAA;AR22GN;AQz2GI;EACE,+FAAA;AR22GN;AQz2GI;EACE,cmE1sB2B;A3EqjIjC;AQv2GI;;EAEE,6BAAA;EACA,cyEx6BM;EzEy6BN,oDmEzsB6B;A3EkjInC;AQv2GI;;EAEE,cyE16BE;EzE26BF,8CmE7sBmC;A3EsjIzC;AQv2GI;;EAEE,cyE/6BE;EzEg7BF,8CmEjtBmC;A3E0jIzC;AQv2GI;;EAEE,2CiFj7Bc;EjFk7Bd,cyEr7BE;EzEs7BF,oDmEttBkC;A3E+jIxC;AQv2GI;;EAEE,2CiFv7Bc;EjFw7Bd,cyE37BE;EzE47BF,iBmEz6Be;EnE06Bf,oDmE5tBoC;A3EqkI1C;AQv2GI;;EAEE,2CiF77BqB;EjF87BrB,8CmEpuBmC;A3E6kIzC;AQp2GI;EACE,6CmE9tBsB;EnE+tBtB,gBAAA;ARs2GN;AQp2GI;EACE,iBAAA;EACA,oBAAA;EACA,4CmEpuBsB;A3E0kI5B;AQp2GI;EACE,mBAAA;ARs2GN;AQ71GI;EACE,sCAAA;EACA,gBAAA;EACA,yDACE;EAKF,yBAAA;EAWE,gBAAA;EAEF,yBmE99Bc;EnE+9Bd,gBmE7vB6B;A3E4kInC;AQ50GI;EAGI,oCAAA;EAUF,cmE1wBwB;EnE2wBxB,gBmEvwBmC;A3E0kIzC;AQh0GI;EAEI,oCAAA;EAUF,cmEnxBwB;EnEoxBxB,gBmEhxBmC;A3EwkIzC;AQrzGI;EAEI,oCAAA;EACA,kDAAA;EAYF,cmE/xByB;EnEgyBzB,gBmE5xBoC;A3EukI1C;AQnyGI;;EAEE,kBAAA;EACA,uCAAA;EACA,+BAAA;ARqyGN;AQjyGI;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,+BAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;EAEA,SmEr6BuB;EnEs6BvB,qBmEn6BsB;EnEo6BtB,qCmEn6BiC;EnEo6BjC,SmEj6BsB;EnEk6BtB,wCmEh6B4B;A3EksIlC;AQ9xGI;EACE,wCAAA;EACA,8BAAA;ARgyGN;AQ9xGI;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,gCAAA;EACA,mCAAA;EACA,uCmE76B6B;A3E6sInC;AQ5xGI;;;;EAIE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,kBAAA;AR8xGN;AQ3xGI;EACE,gBAAA;AR6xGN;AQ3xGI;EACE,uCoEtmCC;EpEumCD,0CoEvmCC;A5Eo4IP;AQ3xGI;EACE,wCoE1mCC;EpE2mCD,2CoE3mCC;A5Ew4IP;AQ3xGI;EACE,gBAAA;EACA,uCoE/mCC;A5E44IP;AQ3xGI;EACE,gBAAA;EACA,0CoEnnCC;A5Eg5IP;AQzxGI;EACE,oCAAA;AR2xGN;AQnxGE;;;EAGE,yB2EroCI;E3EsoCJ,gBAAA;EACA,iBmEpnCiB;EnEqnCjB,cyExoCI;AjF65IR;AQnxGE;EACE,mE+ErmCmB;E/EsmCnB,iBmEznCiB;EnE0nCjB,cyE7oCI;AjFk6IR;AQ9wGE;EACE,mBAAA;ARgxGJ;AQ9wGE;EACE,UAAA;EACA,wBAAA;ARgxGJ;AQxwGE;EACE,kBAAA;EACA,YmEtiCY;EnEuiCZ,sBmEtiCe;EnEuiCf,UmEtiCgB;A3EgzIpB;AQxwGE;EACE,kBAAA;EACA,kBAAA;EACA,qBwE5qCc;ExE8qCd,amEjjCa;EnEkjCb,QAAA;EACA,SAAA;EACA,yByE/qCI;EzEgrCJ,iBmE7pCiB;EnE+pCjB,2BmE5iCwB;EnE6iCxB,4BmE5iC0B;EnE8iC1B,qBmEnjCoB;EnEojCpB,sBmEpjCoB;EnEsjCpB,2BmErjCoB;EnEsjCpB,yBqE3rCe;ErE6rCf,kBsDjrCK;EtDkrCL,iBsDnrCG;EtDqrCH,uCmE9pCuB;A3Ek6I3B;AQlwGE;EACE,wBAAA;ARowGJ;AQhwGE;EACE,mBAAA;ARkwGJ;AQhwGE;EACE,aAAA;ARkwGJ;AQxvGE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,4CmEj3ByB;A3E2mI7B;AQtvGE;EACE,kDAAA;ARwvGJ;AQtvGE;EACE,kDAAA;ARwvGJ;AQpvGE;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;EAEA,qBmEj4BiC;EnEk4BjC,kDAAA;ARqvGJ;AQnvGE;EACE,qBAAA;EACA,gBAAA;EACA,oBmEv4BiC;EnEw4BjC,kDAAA;ARqvGJ;AQjvGE;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,amEh5BsB;EnEi5BtB,iBmEp5BqB;EnEq5BrB,kBmEr5BqB;A3EwoIzB;AQjvGE;EACE,SAAA;ARmvGJ;AQjvGE;EACE,gBAAA;ARmvGJ;AQjvGE;EACE,gBAAA;ARmvGJ;AQ/uGE;EACE,mBmEn6BqB;EnEo6BrB,kDAAA;ARivGJ;AQ/uGE;EACE,oCAAA;ARivGJ;AQ/uGE;EACE,oCAAA;ARivGJ;AQ9uGE;EACE,gBmE96BqB;EnE+6BrB,kDAAA;ARgvGJ;AQ9uGE;EACE,oCAAA;ARgvGJ;AQ9uGE;EACE,oCAAA;ARgvGJ;AQ5uGE;EACE,oBAAA;EACA,eAAA;EACA,iBmE57BqB;EnE67BrB,kDAAA;AR8uGJ;AQ5uGE;EACE,iBmEh8BqB;EnEi8BrB,oCAAA;AR8uGJ;AQ5uGE;EACE,iBmEp8BqB;EnEq8BrB,oCAAA;AR8uGJ;AQ3uGE;EACE,oBAAA;EACA,cAAA;EACA,kBmE38BqB;EnE48BrB,kDAAA;AR6uGJ;AQ3uGE;EACE,iBmE/8BqB;EnEg9BrB,oCAAA;AR6uGJ;AQ3uGE;EACE,iBmEn9BqB;EnEo9BrB,oCAAA;AR6uGJ;AQtuGE;;EAEE,WAAA;ARwuGJ;AQtuGE;EACE,cAAA;ARwuGJ;AQruGE;EACE,WAAA;ARuuGJ;AQruGE;EACE,UAAA;ARuuGJ;AQpuGE;EACE,WAAA;ARsuGJ;AQpuGE;EACE,cAAA;ARsuGJ;AQnuGE;EACE,WAAA;ARquGJ;AQnuGE;EACE,UAAA;ARquGJ;AQluGE;EACE,WAAA;ARouGJ;AQluGE;EACE,UAAA;ARouGJ;AQjuGE;EACE,WAAA;ARmuGJ;AQjuGE;EACE,cAAA;ARmuGJ;AQhuGE;EACE,WAAA;ARkuGJ;AQhuGE;EACE,cAAA;ARkuGJ;AQ/tGE;EACE,WAAA;ARiuGJ;AQ/tGE;EACE,YAAA;ARiuGJ;AQ9tGE;EACE,WAAA;ARguGJ;AQ9tGE;EACE,aAAA;ARguGJ;AQ7tGE;EACE,WAAA;AR+tGJ;AQ7tGE;EACE,UAAA;AR+tGJ;AQ5tGE;EACE,WAAA;AR8tGJ;AQ5tGE;EACE,YAAA;AR8tGJ;AQ3tGE;EACE,WAAA;AR6tGJ;AQ3tGE;EACE,cAAA;AR6tGJ;AQztGE;;EAEE,aAAA;EACA,WAAA;EACA,uBAAA;AR2tGJ;AQxtGE;EACE,WAAA;AR0tGJ;AQxtGE;EACE,eAAA;AR0tGJ;AQxtGE;EACE,WAAA;AR0tGJ;AQxtGE;EACE,WAAA;AR0tGJ;AQxtGE;EACE,eAAA;AR0tGJ;AQxtGE;EACE,eAAA;AR0tGJ;AQxtGE;EACE,aAAA;AR0tGJ;AQxtGE;EACE,cAAA;AR0tGJ;AQxtGE;EACE,WAAA;AR0tGJ;AQxtGE;EACE,aAAA;AR0tGJ;AQxtGE;EACE,eAAA;AR0tGJ;AQzrGM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3Eg5IlC;AQzrGM;EACE,gDmE38CmB;A3EsoJ3B;AQzrGM;;EAEE,oEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARytGV;AQzrGM;;EAEE,mEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+tGV;AQzrGM;;EAEE,oEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARquGV;AQzrGM;;;;EAIE,oEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6uGV;AQtrGQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARyvGV;AQtrGQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDAtEA;AR8vGV;AQtrGQ;;EAEE,uBAAA;EACA,6EAAA;EACA,yDA5EA;ARowGV;AQtrGQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDAhFA;ARwwGV;AQtrGQ;;EAEE,8EAAA;EACA,yDArFA;AR6wGV;AQtrGQ;EACE,iBAAA;ARwrGV;AQlrGQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARkxGV;AQ1qGQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARwxGX;AQ1qGQ;;EAEE,8CApHC;ARgyGX;AQ1qGQ;;EAEE,gDAvHC;ARmyGX;AQ1qGQ;;EAEE,+CAzHC;ARqyGX;AQ1qGQ;;EAEE,8CA9HC;AR0yGX;AQxqGQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmwJR;AQxqGQ;;;EAGE,wDAAA;EAOE,cAtJF;AR0zGV;AQjqGQ;;;EAGE,0DAAA;EACA,cA7JA;ARg0GV;AQjqGQ;;;EAGE,yDAAA;EAOE,cAzKF;ARs0GV;AQ1pGQ;;;EAGE,wDAAA;EAOE,cAtLF;AR40GV;AQhpGQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR01GV;AQpoGQ;;;EAKI,4DAAA;EAWF,sCArNE;AR+0GZ;AQvnGQ;;;EAKI,+EAAA;EAWF,yDAvOE;ARo1GZ;AQ1mGQ;;;;;;EAQI,0DAAA;EAWF,yDA3QA;AR22GV;AQz1GM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EgjJlC;AQz1GM;EACE,gDmE38CmB;A3EsyJ3B;AQz1GM;;EAEE,0DAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARy3GV;AQz1GM;;EAEE,yDAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+3GV;AQz1GM;;EAEE,yDA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARq4GV;AQz1GM;;;;EAIE,0DAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR64GV;AQt1GQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARy5GV;AQt1GQ;;EAEE,uBAAA;EACA,oEAAA;EACA,+CAtEA;AR85GV;AQt1GQ;;EAEE,uBAAA;EACA,mEAAA;EACA,+CA5EA;ARo6GV;AQt1GQ;;EAEE,uBAAA;EACA,oEAAA;EACA,8CAhFA;ARw6GV;AQt1GQ;;EAEE,mEAAA;EACA,8CArFA;AR66GV;AQt1GQ;EACE,iBAAA;ARw1GV;AQl1GQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARk7GV;AQ10GQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARw7GX;AQ10GQ;;EAEE,2CApHC;ARg8GX;AQ10GQ;;EAEE,2CAvHC;ARm8GX;AQ10GQ;;EAEE,iDAzHC;ARq8GX;AQ10GQ;;EAEE,0CA9HC;AR08GX;AQx0GQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFm6JR;AQx0GQ;;;EAGE,qDAAA;EAOE,cAtJF;AR09GV;AQj0GQ;;;EAGE,qDAAA;EACA,cA7JA;ARg+GV;AQj0GQ;;;EAGE,2DAAA;EAOE,cAzKF;ARs+GV;AQ1zGQ;;;EAGE,oDAAA;EAOE,cAtLF;AR4+GV;AQhzGQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0/GV;AQpyGQ;;;EAKI,gDAAA;EAWF,0BArNE;AR++GZ;AQvxGQ;;;EAKI,oEAAA;EAWF,8CAvOE;ARo/GZ;AQ1wGQ;;;;;;EAQI,qEAAA;EAWF,+CA3QA;AR2gHV;AQz/GM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EgtJlC;AQz/GM;EACE,gDmE38CmB;A3Es8J3B;AQz/GM;;EAEE,mEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARyhHV;AQz/GM;;EAEE,iEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+hHV;AQz/GM;;EAEE,mEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARqiHV;AQz/GM;;;;EAIE,mEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6iHV;AQt/GQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARyjHV;AQt/GQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDAtEA;AR8jHV;AQt/GQ;;EAEE,uBAAA;EACA,2EAAA;EACA,wDA5EA;ARokHV;AQt/GQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDAhFA;ARwkHV;AQt/GQ;;EAEE,6EAAA;EACA,wDArFA;AR6kHV;AQt/GQ;EACE,iBAAA;ARw/GV;AQl/GQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARklHV;AQ1+GQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARwlHX;AQ1+GQ;;EAEE,6CApHC;ARgmHX;AQ1+GQ;;EAEE,+CAvHC;ARmmHX;AQ1+GQ;;EAEE,+CAzHC;ARqmHX;AQ1+GQ;;EAEE,6CA9HC;AR0mHX;AQx+GQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmkKR;AQx+GQ;;;EAGE,uDAAA;EAOE,cAtJF;AR0nHV;AQj+GQ;;;EAGE,yDAAA;EACA,cA7JA;ARgoHV;AQj+GQ;;;EAGE,yDAAA;EAOE,cAzKF;ARsoHV;AQ19GQ;;;EAGE,uDAAA;EAOE,cAtLF;AR4oHV;AQh9GQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0pHV;AQp8GQ;;;EAKI,mDAAA;EAWF,6BArNE;AR+oHZ;AQv7GQ;;;EAKI,8EAAA;EAWF,wDAvOE;ARopHZ;AQ16GQ;;;;;;EAQI,6CAAA;EAWF,wDA3QA;AR2qHV;AQzpHM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3Eg3JlC;AQzpHM;EACE,gDmE38CmB;A3EsmK3B;AQzpHM;;EAEE,wDAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARyrHV;AQzpHM;;EAEE,8CAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+rHV;AQzpHM;;EAEE,gDA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARqsHV;AQzpHM;;;;EAIE,8CAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6sHV;AQtpHQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARytHV;AQtpHQ;;EAEE,uBAAA;EACA,kEAAA;EACA,6CAtEA;AR8tHV;AQtpHQ;;EAEE,uBAAA;EACA,wDAAA;EACA,6CA5EA;ARouHV;AQtpHQ;;EAEE,uBAAA;EACA,wDAAA;EACA,qCAhFA;ARwuHV;AQtpHQ;;EAEE,0DAAA;EACA,qCArFA;AR6uHV;AQtpHQ;EACE,iBAAA;ARwpHV;AQlpHQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARkvHV;AQ1oHQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARwvHX;AQ1oHQ;;EAEE,6CApHC;ARgwHX;AQ1oHQ;;EAEE,+CAvHC;ARmwHX;AQ1oHQ;;EAEE,+CAzHC;ARqwHX;AQ1oHQ;;EAEE,6CA9HC;AR0wHX;AQxoHQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmuKR;AQxoHQ;;;EAGE,uDAAA;EAOE,cAtJF;AR0xHV;AQjoHQ;;;EAGE,yDAAA;EACA,cA7JA;ARgyHV;AQjoHQ;;;EAGE,yDAAA;EAOE,cAzKF;ARsyHV;AQ1nHQ;;;EAGE,uDAAA;EAOE,cAtLF;AR4yHV;AQhnHQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0zHV;AQpmHQ;;;EAKI,yDAAA;EAWF,mCArNE;AR+yHZ;AQvlHQ;;;EAKI,8DAAA;EAWF,wCAvOE;ARozHZ;AQ1kHQ;;;;;;EAQI,yDAAA;EAWF,mCA3QA;AR20HV;AQzzHM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EghKlC;AQzzHM;EACE,gDmE38CmB;A3EswK3B;AQzzHM;;EAEE,+CAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARy1HV;AQzzHM;;EAEE,+CAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+1HV;AQzzHM;;EAEE,mEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARq2HV;AQzzHM;;;;EAIE,+CAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR62HV;AQtzHQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARy3HV;AQtzHQ;;EAEE,uBAAA;EACA,yDAAA;EACA,oCAtEA;AR83HV;AQtzHQ;;EAEE,uBAAA;EACA,yDAAA;EACA,oCA5EA;ARo4HV;AQtzHQ;;EAEE,uBAAA;EACA,yDAAA;EACA,wDAhFA;ARw4HV;AQtzHQ;;EAEE,6EAAA;EACA,wDArFA;AR64HV;AQtzHQ;EACE,iBAAA;ARwzHV;AQlzHQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARk5HV;AQ1yHQ;;;;;;;;EAQE,gBAAA;EACA,yBA5GC;ARw5HX;AQ1yHQ;;EAEE,6CApHC;ARg6HX;AQ1yHQ;;EAEE,+CAvHC;ARm6HX;AQ1yHQ;;EAEE,+CAzHC;ARq6HX;AQ1yHQ;;EAEE,6CA9HC;AR06HX;AQxyHQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFm4KR;AQxyHQ;;;EAGE,uDAAA;EAOE,cAtJF;AR07HV;AQjyHQ;;;EAGE,yDAAA;EACA,cA7JA;ARg8HV;AQjyHQ;;;EAGE,yDAAA;EAOE,cAzKF;ARs8HV;AQ1xHQ;;;EAGE,uDAAA;EAOE,cAtLF;AR48HV;AQhxHQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR09HV;AQpwHQ;;;EAKI,wDAAA;EAWF,kCArNE;AR+8HZ;AQvvHQ;;;EAKI,+DAAA;EAWF,yCAvOE;ARo9HZ;AQ1uHQ;;;;;;EAQI,0DAAA;EAWF,oCA3QA;AR2+HV;AQz9HM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EgrKlC;AQz9HM;EACE,gDmE38CmB;A3Es6K3B;AQz9HM;;EAEE,oEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARy/HV;AQz9HM;;EAEE,mEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+/HV;AQz9HM;;EAEE,oEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARqgIV;AQz9HM;;;;EAIE,mEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6gIV;AQt9HQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARyhIV;AQt9HQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDAtEA;AR8hIV;AQt9HQ;;EAEE,uBAAA;EACA,6EAAA;EACA,yDA5EA;ARoiIV;AQt9HQ;;EAEE,uBAAA;EACA,6EAAA;EACA,yDAhFA;ARwiIV;AQt9HQ;;EAEE,8EAAA;EACA,yDArFA;AR6iIV;AQt9HQ;EACE,iBAAA;ARw9HV;AQl9HQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARkjIV;AQ18HQ;;;;;;;;EAQE,gBAAA;EACA,yBA5GC;ARwjIX;AQ18HQ;;EAEE,oEApHC;ARgkIX;AQ18HQ;;EAEE,kEAvHC;ARmkIX;AQ18HQ;;EAEE,oEAzHC;ARqkIX;AQ18HQ;;EAEE,oEA9HC;AR0kIX;AQx8HQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmiLR;AQx8HQ;;;EAGE,8EAAA;EAOE,cAtJF;AR0lIV;AQj8HQ;;;EAGE,4EAAA;EACA,cA7JA;ARgmIV;AQj8HQ;;;EAGE,8EAAA;EAOE,cAzKF;ARsmIV;AQ17HQ;;;EAGE,8EAAA;EAOE,cAtLF;AR4mIV;AQh7HQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0nIV;AQp6HQ;;;EAKI,4DAAA;EAWF,sCArNE;AR+mIZ;AQv5HQ;;;EAKI,+EAAA;EAWF,yDAvOE;ARonIZ;AQ14HQ;;;;;;EAQI,mDAAA;EAWF,wDA3QA;AR2oIV;AQznIM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3Eg1KlC;AQznIM;EACE,gDmE38CmB;A3EskL3B;AQznIM;;EAEE,mEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARypIV;AQznIM;;EAEE,kEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+pIV;AQznIM;;EAEE,mEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARqqIV;AQznIM;;;;EAIE,mEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6qIV;AQtnIQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARyrIV;AQtnIQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDAtEA;AR8rIV;AQtnIQ;;EAEE,uBAAA;EACA,4EAAA;EACA,wDA5EA;ARosIV;AQtnIQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDAhFA;ARwsIV;AQtnIQ;;EAEE,6EAAA;EACA,wDArFA;AR6sIV;AQtnIQ;EACE,iBAAA;ARwnIV;AQlnIQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARktIV;AQ1mIQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARwtIX;AQ1mIQ;;EAEE,qDApHC;ARguIX;AQ1mIQ;;EAEE,uDAvHC;ARmuIX;AQ1mIQ;;EAEE,uDAzHC;ARquIX;AQ1mIQ;;EAEE,8CA9HC;AR0uIX;AQxmIQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmsLR;AQxmIQ;;;EAGE,+DAAA;EAOE,cAtJF;AR0vIV;AQjmIQ;;;EAGE,iEAAA;EACA,cA7JA;ARgwIV;AQjmIQ;;;EAGE,iEAAA;EAOE,cAzKF;ARswIV;AQ1lIQ;;;EAGE,wDAAA;EAOE,cAtLF;AR4wIV;AQhlIQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0xIV;AQpkIQ;;;EAKI,4DAAA;EAWF,sCArNE;AR+wIZ;AQvjIQ;;;EAKI,8EAAA;EAWF,wDAvOE;ARoxIZ;AQ1iIQ;;;;;;EAQI,yDAAA;EAWF,wDA3QA;AR2yIV;AQzxIM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3Eg/KlC;AQzxIM;EACE,gDmE38CmB;A3EsuL3B;AQzxIM;;EAEE,+CAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARyzIV;AQzxIM;;EAEE,+CAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+zIV;AQzxIM;;EAEE,6CA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARq0IV;AQzxIM;;;;EAIE,+CAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR60IV;AQtxIQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARy1IV;AQtxIQ;;EAEE,uBAAA;EACA,yDAAA;EACA,oCAtEA;AR81IV;AQtxIQ;;EAEE,uBAAA;EACA,yDAAA;EACA,oCA5EA;ARo2IV;AQtxIQ;;EAEE,uBAAA;EACA,yDAAA;EACA,kCAhFA;ARw2IV;AQtxIQ;;EAEE,uDAAA;EACA,kCArFA;AR62IV;AQtxIQ;EACE,iBAAA;ARwxIV;AQlxIQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARk3IV;AQ1wIQ;;;;;;;;EAQE,gBAAA;EACA,yBA5GC;ARw3IX;AQ1wIQ;;EAEE,yBApHC;ARg4IX;AQ1wIQ;;EAEE,qCAvHC;ARm4IX;AQ1wIQ;;EAEE,qCAzHC;ARq4IX;AQ1wIQ;;EAEE,yBA9HC;AR04IX;AQxwIQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFm2LR;AQxwIQ;;;EAGE,mCAAA;EAOE,cAtJF;AR05IV;AQjwIQ;;;EAGE,+CAAA;EACA,cA7JA;ARg6IV;AQjwIQ;;;EAGE,+CAAA;EAOE,cAzKF;ARs6IV;AQ1vIQ;;;EAGE,mCAAA;EAOE,cAtLF;AR46IV;AQhvIQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR07IV;AQpuIQ;;;EAKI,oCAAA;EAWF,cArNE;AR+6IZ;AQvtIQ;;;EAKI,+DAAA;EAWF,yCAvOE;ARo7IZ;AQ1sIQ;;;;;;EAQI,0DAAA;EAWF,oCA3QA;AR28IV;AQz7IM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EgpLlC;AQz7IM;EACE,gDmE38CmB;A3Es4L3B;AQz7IM;;EAEE,oEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARy9IV;AQz7IM;;EAEE,mEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+9IV;AQz7IM;;EAEE,oEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARq+IV;AQz7IM;;;;EAIE,oEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6+IV;AQt7IQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARy/IV;AQt7IQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDAtEA;AR8/IV;AQt7IQ;;EAEE,uBAAA;EACA,6EAAA;EACA,yDA5EA;ARogJV;AQt7IQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDAhFA;ARwgJV;AQt7IQ;;EAEE,8EAAA;EACA,yDArFA;AR6gJV;AQt7IQ;EACE,iBAAA;ARw7IV;AQl7IQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARkhJV;AQ16IQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARwhJX;AQ16IQ;;EAEE,8CApHC;ARgiJX;AQ16IQ;;EAEE,gDAvHC;ARmiJX;AQ16IQ;;EAEE,+CAzHC;ARqiJX;AQ16IQ;;EAEE,8CA9HC;AR0iJX;AQx6IQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmgMR;AQx6IQ;;;EAGE,wDAAA;EAOE,cAtJF;AR0jJV;AQj6IQ;;;EAGE,0DAAA;EACA,cA7JA;ARgkJV;AQj6IQ;;;EAGE,yDAAA;EAOE,cAzKF;ARskJV;AQ15IQ;;;EAGE,wDAAA;EAOE,cAtLF;AR4kJV;AQh5IQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0lJV;AQp4IQ;;;EAKI,4DAAA;EAWF,sCArNE;AR+kJZ;AQv3IQ;;;EAKI,+EAAA;EAWF,yDAvOE;ARolJZ;AQ12IQ;;;;;;EAQI,0DAAA;EAWF,yDA3QA;AR2mJV;AQzlJM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EgzLlC;AQzlJM;EACE,gDmE38CmB;A3EsiM3B;AQzlJM;;EAEE,mEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARynJV;AQzlJM;;EAEE,mEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+nJV;AQzlJM;;EAEE,mEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARqoJV;AQzlJM;;;;EAIE,mEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6oJV;AQtlJQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARypJV;AQtlJQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDAtEA;AR8pJV;AQtlJQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDA5EA;ARoqJV;AQtlJQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDAhFA;ARwqJV;AQtlJQ;;EAEE,6EAAA;EACA,wDArFA;AR6qJV;AQtlJQ;EACE,iBAAA;ARwlJV;AQllJQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARkrJV;AQ1kJQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARwrJX;AQ1kJQ;;EAEE,8CApHC;ARgsJX;AQ1kJQ;;EAEE,iDAvHC;ARmsJX;AQ1kJQ;;EAEE,iDAzHC;ARqsJX;AQ1kJQ;;EAEE,oEA9HC;AR0sJX;AQxkJQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmqMR;AQxkJQ;;;EAGE,wDAAA;EAOE,cAtJF;AR0tJV;AQjkJQ;;;EAGE,2DAAA;EACA,cA7JA;ARguJV;AQjkJQ;;;EAGE,2DAAA;EAOE,cAzKF;ARsuJV;AQ1jJQ;;;EAGE,8EAAA;EAOE,cAtLF;AR4uJV;AQhjJQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0vJV;AQpiJQ;;;EAKI,4DAAA;EAWF,sCArNE;AR+uJZ;AQvhJQ;;;EAKI,6EAAA;EAWF,uDAvOE;ARovJZ;AQ1gJQ;;;;;;EAQI,6EAAA;EAWF,wDA3QA;AR2wJV;AQzvJM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3Eg9LlC;AQzvJM;EACE,gDmE38CmB;A3EssM3B;AQzvJM;;EAEE,oEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARyxJV;AQzvJM;;EAEE,oEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+xJV;AQzvJM;;EAEE,oEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARqyJV;AQzvJM;;;;EAIE,oEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6yJV;AQtvJQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARyzJV;AQtvJQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDAtEA;AR8zJV;AQtvJQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDA5EA;ARo0JV;AQtvJQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDAhFA;ARw0JV;AQtvJQ;;EAEE,8EAAA;EACA,yDArFA;AR60JV;AQtvJQ;EACE,iBAAA;ARwvJV;AQlvJQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARk1JV;AQ1uJQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARw1JX;AQ1uJQ;;EAEE,sCApHC;ARg2JX;AQ1uJQ;;EAEE,uCAvHC;ARm2JX;AQ1uJQ;;EAEE,yCAzHC;ARq2JX;AQ1uJQ;;EAEE,sCA9HC;AR02JX;AQxuJQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFm0MR;AQxuJQ;;;EAGE,gDAAA;EAOE,cAtJF;AR03JV;AQjuJQ;;;EAGE,iDAAA;EACA,cA7JA;ARg4JV;AQjuJQ;;;EAGE,mDAAA;EAOE,cAzKF;ARs4JV;AQ1tJQ;;;EAGE,gDAAA;EAOE,cAtLF;AR44JV;AQhtJQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR05JV;AQpsJQ;;;EAKI,6DAAA;EAWF,uCArNE;AR+4JZ;AQvrJQ;;;EAKI,+EAAA;EAWF,yDAvOE;ARo5JZ;AQ1qJQ;;;;;;EAQI,8EAAA;EAWF,yDA3QA;AR26JV;AQz5JM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EgnMlC;AQz5JM;EACE,gDmE38CmB;A3Es2M3B;AQz5JM;;EAEE,oEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARy7JV;AQz5JM;;EAEE,mEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+7JV;AQz5JM;;EAEE,kEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARq8JV;AQz5JM;;;;EAIE,oEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR68JV;AQt5JQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARy9JV;AQt5JQ;;EAEE,uBAAA;EACA,8EAAA;EACA,yDAtEA;AR89JV;AQt5JQ;;EAEE,uBAAA;EACA,6EAAA;EACA,yDA5EA;ARo+JV;AQt5JQ;;EAEE,uBAAA;EACA,8EAAA;EACA,uDAhFA;ARw+JV;AQt5JQ;;EAEE,4EAAA;EACA,uDArFA;AR6+JV;AQt5JQ;EACE,iBAAA;ARw5JV;AQl5JQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARk/JV;AQ14JQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARw/JX;AQ14JQ;;EAEE,8CApHC;ARggKX;AQ14JQ;;EAEE,iDAvHC;ARmgKX;AQ14JQ;;EAEE,iDAzHC;ARqgKX;AQ14JQ;;EAEE,8CA9HC;AR0gKX;AQx4JQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFm+MR;AQx4JQ;;;EAGE,wDAAA;EAOE,cAtJF;AR0hKV;AQj4JQ;;;EAGE,2DAAA;EACA,cA7JA;ARgiKV;AQj4JQ;;;EAGE,2DAAA;EAOE,cAzKF;ARsiKV;AQ13JQ;;;EAGE,wDAAA;EAOE,cAtLF;AR4iKV;AQh3JQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0jKV;AQp2JQ;;;EAKI,6DAAA;EAWF,uCArNE;AR+iKZ;AQv1JQ;;;EAKI,+EAAA;EAWF,yDAvOE;ARojKZ;AQ10JQ;;;;;;EAQI,yDAAA;EAWF,yDA3QA;AR2kKV;AQzjKM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EgxMlC;AQzjKM;EACE,gDmE38CmB;A3EsgN3B;AQzjKM;;EAEE,mEAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARylKV;AQzjKM;;EAEE,mEAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+lKV;AQzjKM;;EAEE,mEA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARqmKV;AQzjKM;;;;EAIE,mEAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6mKV;AQtjKQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARynKV;AQtjKQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDAtEA;AR8nKV;AQtjKQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDA5EA;ARooKV;AQtjKQ;;EAEE,uBAAA;EACA,6EAAA;EACA,wDAhFA;ARwoKV;AQtjKQ;;EAEE,6EAAA;EACA,wDArFA;AR6oKV;AQtjKQ;EACE,iBAAA;ARwjKV;AQljKQ;;EAEE,6BAAA;EAQE,mCAAA;EACA,cArGF;ARkpKV;AQ1iKQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARwpKX;AQ1iKQ;;EAEE,mEApHC;ARgqKX;AQ1iKQ;;EAEE,iEAvHC;ARmqKX;AQ1iKQ;;EAEE,mEAzHC;ARqqKX;AQ1iKQ;;EAEE,kEA9HC;AR0qKX;AQxiKQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmoNR;AQxiKQ;;;EAGE,6EAAA;EAOE,cAtJF;AR0rKV;AQjiKQ;;;EAGE,2EAAA;EACA,cA7JA;ARgsKV;AQjiKQ;;;EAGE,6EAAA;EAOE,cAzKF;ARssKV;AQ1hKQ;;;EAGE,4EAAA;EAOE,cAtLF;AR4sKV;AQhhKQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0tKV;AQpgKQ;;;EAKI,4DAAA;EAWF,sCArNE;AR+sKZ;AQv/JQ;;;EAKI,8EAAA;EAWF,wDAvOE;ARotKZ;AQ1+JQ;;;;;;EAQI,6EAAA;EAWF,wDA3QA;AR2uKV;AQztKM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3Eg7MlC;AQztKM;EACE,gDmE38CmB;A3EsqN3B;AQztKM;;EAEE,8CAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARyvKV;AQztKM;;EAEE,0CAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+vKV;AQztKM;;EAEE,0CA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARqwKV;AQztKM;;;;EAIE,6CAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR6wKV;AQttKQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARyxKV;AQttKQ;;EAEE,uBAAA;EACA,wDAAA;EACA,mCAtEA;AR8xKV;AQttKQ;;EAEE,uBAAA;EACA,oDAAA;EACA,mCA5EA;ARoyKV;AQttKQ;;EAEE,uBAAA;EACA,uDAAA;EACA,+BAhFA;ARwyKV;AQttKQ;;EAEE,oDAAA;EACA,+BArFA;AR6yKV;AQttKQ;EACE,iBAAA;ARwtKV;AQltKQ;;EAEE,6BAAA;EAGE,mCAAA;EACA,cyE/iDJ;AjFiwNR;AQ1sKQ;;;;;;;;EAQE,gBAAA;EACA,yBA5GC;ARwzKX;AQ1sKQ;;EAEE,0CApHC;ARg0KX;AQ1sKQ;;EAEE,4CAvHC;ARm0KX;AQ1sKQ;;EAEE,iDAzHC;ARq0KX;AQ1sKQ;;EAEE,4CA9HC;AR00KX;AQxsKQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFmyNR;AQxsKQ;;;EAGE,oDAAA;EAGE,cyEjmDJ;AjFyyNR;AQjsKQ;;;EAGE,sDAAA;EACA,cA7JA;ARg2KV;AQjsKQ;;;EAGE,2DAAA;EAGE,cyEpnDJ;AjFqzNR;AQ1rKQ;;;EAGE,sDAAA;EAGE,cyEjoDJ;AjF2zNR;AQhrKQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR03KV;AQpqKQ;;;EAKI,mDAAA;EAWF,6BArNE;AR+2KZ;AQvpKQ;;;EAKI,qDAAA;EAWF,+BAvOE;ARo3KZ;AQ1oKQ;;;;;;EAQI,mDAAA;EAWF,kCA3QA;AR24KV;AQz3KM;;EAEE,yBAxBE;EAyBF,cApBE;EAqBF,iBApBE;EAqBF,sBmErtC0B;A3EglNlC;AQz3KM;EACE,gDmE38CmB;A3Es0N3B;AQz3KM;;EAEE,0DAjCE;EAkCF,cA9BE;EA+BF,iBA9BE;ARy5KV;AQz3KM;;EAEE,yDAtCE;EAuCF,cApCE;EAqCF,iBApCE;AR+5KV;AQz3KM;;EAEE,yDA3CE;EA4CF,cA1CE;EA2CF,iBA1CE;ARq6KV;AQz3KM;;;;EAIE,0DAlDE;EAmDF,cAlDE;EAmDF,iBAlDE;AR66KV;AQt3KQ;;EAEE,uBAAA;EACA,mCAAA;EACA,cAjEA;ARy7KV;AQt3KQ;;EAEE,uBAAA;EACA,oEAAA;EACA,+CAtEA;AR87KV;AQt3KQ;;EAEE,uBAAA;EACA,mEAAA;EACA,+CA5EA;ARo8KV;AQt3KQ;;EAEE,uBAAA;EACA,oEAAA;EACA,8CAhFA;ARw8KV;AQt3KQ;;EAEE,mEAAA;EACA,8CArFA;AR68KV;AQt3KQ;EACE,iBAAA;ARw3KV;AQl3KQ;;EAEE,6BAAA;EAGE,mCAAA;EACA,cyE/iDJ;AjFi6NR;AQ12KQ;;;;;;;;EAQE,gBAAA;EACA,cA5GC;ARw9KX;AQ12KQ;;EAEE,uBApHC;ARg+KX;AQ12KQ;;EAEE,uBAvHC;ARm+KX;AQ12KQ;;EAEE,uBAzHC;ARq+KX;AQ12KQ;;EAEE,uBA9HC;AR0+KX;AQx2KQ;;;EAGE,6BAAA;EACA,oDmE33CyB;EnE43CzB,cyEzlDF;AjFm8NR;AQx2KQ;;;EAGE,iCAAA;EAGE,cyEjmDJ;AjFy8NR;AQj2KQ;;;EAGE,iCAAA;EACA,cA7JA;ARggLV;AQj2KQ;;;EAGE,iCAAA;EAGE,cyEpnDJ;AjFq9NR;AQ11KQ;;;EAGE,iCAAA;EAGE,cyEjoDJ;AjF29NR;AQh1KQ;;;EAGE,uBAAA;EAWE,gBAAA;EAEF,cAnNA;AR0hLV;AQp0KQ;;;EAKI,kEAAA;EAWF,4CArNE;AR+gLZ;AQvzKQ;;;EAKI,uEAAA;EAWF,iDAvOE;ARohLZ;AQ1yKQ;;;;;;EAQI,qEAAA;EAWF,+CA3QA;AR2iLV;AQ/+NE;;EAEE,yBAXiB;EAYjB,cyEXI;EzEYJ,iBmEOiB;EnENjB,sBmEiQ8B;A3EgvNlC;AQ/+NE;EACE,gDmEWuB;A3Es+N3B;AQ/+NE;;EAEE,mEApBsB;EAqBtB,cyErBI;EzEsBJ,iBmEHiB;A3Eo/NrB;AQ/+NE;;EAEE,kEAzBsB;EA0BtB,cyE3BI;EzE4BJ,iBmETiB;A3E0/NrB;AQ/+NE;;EAEE,mEA9BqB;EA+BrB,cyEjCI;EzEkCJ,iBmEfiB;A3EggOrB;AQ/+NE;;;;EAIE,mEArCuB;EAsCvB,cyEzCI;EzE0CJ,iBmEvBiB;A3EwgOrB;AQ5+NI;;EAEE,uBAAA;EACA,mCAAA;EACA,cApDe;ARkiOrB;AQ5+NI;;EAEE,uBAAA;EACA,6EAAA;EAEA,wDA1DoB;ARuiO1B;AQ3+NI;;EAEE,uBAAA;EACA,4EAAA;EAEA,wDAjEoB;AR6iO1B;AQ1+NI;;EAEE,uBAAA;EACA,6EAAA;EAEA,wDAtEmB;ARijOzB;AQz+NI;;EAEE,6EAAA;EAEA,wDA5EmB;ARsjOzB;AQx+NI;EACE,iBAAA;AR0+NN;AQnjOE;;EAEE,yBAXiB;EAYjB,cyEXI;EzEYJ,iBmEOiB;EnENjB,sBmEiQ8B;A3EozNlC;AQnjOE;EACE,gDmEWuB;A3E0iO3B;AQnjOE;;EAEE,mEApBsB;EAqBtB,cyErBI;EzEsBJ,iBmEHiB;A3EwjOrB;AQnjOE;;EAEE,iEAzBsB;EA0BtB,cyE3BI;EzE4BJ,iBmETiB;A3E8jOrB;AQnjOE;;EAEE,mEA9BqB;EA+BrB,cyEjCI;EzEkCJ,iBmEfiB;A3EokOrB;AQnjOE;;;;EAIE,mEArCuB;EAsCvB,cyEzCI;EzE0CJ,iBmEvBiB;A3E4kOrB;AQhjOI;;EAEE,uBAAA;EACA,mCAAA;EACA,cApDe;ARsmOrB;AQhjOI;;EAEE,uBAAA;EACA,6EAAA;EAEA,wDA1DoB;AR2mO1B;AQ/iOI;;EAEE,uBAAA;EACA,2EAAA;EAEA,wDAjEoB;ARinO1B;AQ9iOI;;EAEE,uBAAA;EACA,6EAAA;EAEA,wDAtEmB;ARqnOzB;AQ7iOI;;EAEE,6EAAA;EAEA,wDA5EmB;AR0nOzB;AQ5iOI;EACE,iBAAA;AR8iON;AQj5KE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,oBAAA;ARm5KJ;AQj5KE;EACE,gBmEtrDsB;A3EykO1B;AQ/4KE;EACE,YAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;ARi5KJ;AQ74KE;EACE,cAAA;EACA,gBAAA;EACA,emEnsDkB;A3EklOtB;AQ74KE;EACE,6EmEvuDF;A3EsnOF;AQ54KE;EACE,iBAAA;EACA,cAAA;EACA,uCoE7wDG;EpE8wDH,0CoE9wDG;A5E4pOP;AQ54KE;EACE,wCoEjxDG;EpEkxDH,2CoElxDG;A5EgqOP;AQ14KE;EACE,oBAAA;EACA,sBAAA;AR44KJ;AQ14KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,emE5tD2B;EnE6tD3B,gBmE/tDyB;EnEguDzB,gBAAA;AR44KJ;AQ14KE;EACE,uCoEnyDG;EpEoyDH,wCoEpyDG;A5EgrOP;AQ14KE;EACE,gBAAA;EACA,0CoExyDG;EpEyyDH,2CoEzyDG;A5EqrOP;AQ14KE;EACE,8BoE5yDG;A5EwrOP;AStrOE;EACE,cAAA;EACA,eiFHkB;A1F2rOtB;ASprOE;EACE;IACE,WiFLmB;IjFMnB,gBiFLoB;IjFMpB,iBiFNoB;E1F4rOxB;ESprOE;IACE,WiFVmB;E1FgsOvB;ESprOE;IACE,WiFbmB;E1FmsOvB;ESprOE;IACE,WiFhBmB;E1FssOvB;AACF;ASlrOE;EACE;IACE,YiFnBmB;IjFoBnB,iBiFnBoB;IjFoBpB,kBiFpBoB;E1FwsOxB;ESlrOE;IACE,yBiFPyB;E1F2rO7B;ESlrOE;IACE,yBiFLiC;E1FyrOrC;ESlrOE;IACE,yBiFHsC;E1FurO1C;AACF;AShrOE;EACE;IACE,YiFjCqB;IjFkCrB,iBiFjCsB;IjFkCtB,kBiFlCsB;E1FotO1B;EShrOE;IACE,yBiFxB2B;E1F0sO/B;EShrOE;IACE,yBiFtBmC;E1FwsOvC;EShrOE;IACE,yBiFpBwC;E1FssO5C;AACF;AS9qOE;EACE;IACE,aiF/C0B;IjFgD1B,iBiF/C2B;IjFgD3B,kBiFhD2B;E1FguO/B;ES9qOE;IACE,0BiFzCgC;E1FytOpC;ES9qOE;IACE,0BiFvCwC;E1FutO5C;ES9qOE;IACE,0BiFrC6C;E1FqtOjD;AACF;ASvqOE;EACE,6EqDzFQ;ErD0FR,gBiF5CmB;EjF6CnB,gBiF3CyB;EjF4CzB,0BsE5EI;A/EqvOR;ASrqOE;EACE,WAAA;ATuqOJ;AS/pOE;EACE,gBAAA;ATiqOJ;AS/pOE;EACE,kBAAA;ATiqOJ;AS/pOE;EACE,iBAAA;ATiqOJ;AS/pOE;EACE,mBAAA;EACA,aAAA;ATiqOJ;AUjxOE;EACE,ciFHa;EjFKb,cAAA;EACA,SAAA;EAEA,iBAAA;EACA,yBiFGqB;EjFFrB,sBiFDqB;EjFErB,0BmEhBc;EnEkBd,iBAAA;EACA,6CAAA;AVgxOJ;AUzwOE;EACE,4CAAA;EACA,iDAAA;AV2wOJ;AUnwOE;;EAEE,UAAA;AVqwOJ;AU9vOE;EACE,cAAA;EACA,mBAAA;EAEA,YAAA;EACA,UiFrBwB;EjFsBxB,cAAA;EACA,kBAAA;AV+vOJ;AU5vOE;;EAEE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,4BAAA;AV8vOJ;AU3vOE;EACE,sCAAA;AV6vOJ;AU3vOE;EACE,qCAAA;AV6vOJ;AUtvOE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAEA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EAEA,cAAA;EACA,kBAAA;EACA,2BAAA;AVsvOJ;AUnvOE;;EAEE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EAEA,6CAAA;EACA,gDAAA;EAEA,QAAA;EACA,yBiFrEsB;A3FwzO1B;AUhvOE;EACE,UAAA;AVkvOJ;AUhvOE;EACE,SAAA;EACA,SAAA;AVkvOJ;AU9uOE;EAEE;;IAEE,cAAA;IACA,mBAAA;IACA,YAAA;IACA,UiF7FsB;IjF8FtB,gBAAA;IACA,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,MAAA;IACA,OAAA;IACA,eAAA;EV+uOJ;EU5uOE;;;;IAIE,OAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;IACA,4BAAA;EV8uOJ;EU3uOE;;IAEE,sCAAA;EV6uOJ;EU3uOE;;IAEE,qCAAA;EV6uOJ;AACF;AUtuOE;EACE,SiF3IkB;EjF4IlB,eiF7IgB;EjF8IhB,WAAA;EACA,sBAAA;AVwuOJ;AUjuOI;EACE,aAAA;AVmuON;AUjuOI;EACE,WAAA;AVmuON;AU/tOI;EACE,WAAA;AViuON;AU/tOI;EACE,aAAA;AViuON;AUrtOE;EACE,oCAAA;AVutOJ;AUrtOE;;EAEE,aAAA;AVutOJ;AUhtOE;;;EAGE,cuE/MI;AjFi6OR;AUhtOE;;;EAGE,mDAAA;EACA,oDAAA;EACA,yDAAA;EACA,wDAAA;AVktOJ;AU3sOE;EACE,SAAA;AV6sOJ;AUtsOE;EACE,WAAA;AVwsOJ;AUjsOE;EACE,gBiFzMqB;EjF0MrB,mBiF1MqB;A3F64OzB;AU5rOE;EACE,eiF/Ma;A3F64OjB;A4Fz7OE;;EAEE,yDAAA;A5F27OJ;A4Fx7OE;EACE;;;;IAIE,yDAAA;E5F07OJ;AACF;AW/7OE;EACE,qBAAA;EAEA,WkFJS;ElFKT,YkFJU;ElFMV,iBkFNU;ElFOV,wBkFNkB;ElFOlB,mBAAA;EAEA,wBAAA;EAEA,WAAA;EACA,mCAAA;EACA,2BAAA;AX67OJ;AWz7OE;EACE,qBAAA;EACA,WAAA;EACA,4EAAA;EACA,WkFvBS;ElFwBT,YkFvBU;A7Fk9Od;AYn9OE;;EAEE,wBAAA;AZq9OJ;AYn9OE;;;EAGE,4BAAA;AZq9OJ;AYn9OE;;EAEE,4BAAA;AZq9OJ;AYn9OE;;EAEE,4BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,8BAAA;AZq9OJ;AYn9OE;;EAEE,4BAAA;AZq9OJ;AYn9OE;;;EAGE,gCAAA;AZq9OJ;AYn9OE;;EAEE,gCAAA;AZq9OJ;AYn9OE;;EAEE,gCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;;EAGE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,4BAAA;AZq9OJ;AYn9OE;;EAEE,gCAAA;AZq9OJ;AYn9OE;;EAEE,gCAAA;AZq9OJ;AYn9OE;;EAEE,gCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;;EAGE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;;EAGE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,6BAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,iCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;AYn9OE;;EAEE,kCAAA;AZq9OJ;Aa16QE;EACE,YAAA;EACA,0CsDHY;EtDIZ,YAAA;EACA,6EiDVU;EjDWV,iBAAA;EACA,2BqDViB;ErDWjB,oBiFVoB;EjFWpB,0BoDbS;AjEy7Qb;Aaz6QE;EACE,2BiFLkB;A9Fg7QtB;Aaz6QE;EACE,gBiFPiB;A9Fk7QrB;Aap6QE;EACE,cAAA;EACA,mBiDlBK;EjDmBL,UAAA;EACA,SiFFgB;EjFGhB,ekEjBK;ElEkBL,kBiFHqB;EjFIrB,yBgEpCe;A7E08QnB;Aa/5QE;EACE,mBAAA;EACA,UiFTkB;EjFUlB,gBiFTe;EjFUf,ciFTiB;EjFUjB,sBiFRoB;A9Fy6QxB;Aa75QE;EACE,qBAAA;EACA,UAAA;EACA,qBiFhBiB;A9F+6QrB;Aax5QE;;EAEE,qBAAA;EACA,0BsDhEwB;EtDiExB,YiFvBiB;EjFwBjB,YiFvBkB;EjFwBlB,sBiFrBqB;A9F+6QzB;Aax5QE;;EAEE,qBiFjCiB;A9F27QrB;Aan5QE;EACE,qBAAA;EACA,mBiF1BuB;A9F+6Q3B;Aaj5QE;;EAEE,qBiFhDiB;EjFiDjB,sBiF/B6B;A9Fk7QjC;Aa/4QE;EACE,qBiFtDiB;EjFuDjB,mBAAA;EACA,sBiFvC4B;A9Fw7QhC;Aaz4QE;EACE,aiFtDgB;EjFuDhB,mBiFtDoB;EjFuDpB,sBiFtD0B;A9Fi8Q9B;Aav4QE;EACE,aiFnD6B;A9F47QjC;Aa33QE;EACE,eqDzHC;AlEs/QL;Aa33QE;EACE,0BqD3HC;AlEw/QL;Aa33QE;EACE,0BqD7HC;AlE0/QL;Aa33QE;EACE,0BqD/HC;AlE4/QL;Aa33QE;EACE,eqDjIC;AlE8/QL;Aax3QE;EACE,0BkE9HI;A/Ew/QR;Aax3QE;EACE,0BkEjII;A/E2/QR;Aax3QE;EACE,ekErIK;A/E+/QT;Aax3QE;EACE,ekExIK;A/EkgRT;Aax3QE;EACE,0BkE5II;A/EsgRR;Aal3QE;EACE,eAAA;EACA,ciFrGuB;A9Fy9Q3B;Aal3QE;EACE,yBiFvGuB;A9F29Q3B;Aal3QE;EACE,yBiFzGuB;A9F69Q3B;Aal3QE;EACE,yBiF3GuB;A9F+9Q3B;Aal3QE;EACE,ciF7GuB;A9Fi+Q3B;Aah3QE;EACE,0BkErKI;A/EuhRR;Aah3QE;EACE,0BkExKI;A/E0hRR;Aah3QE;EACE,ekE5KK;A/E8hRT;Aah3QE;EACE,ekE/KK;A/EiiRT;Aah3QE;EACE,0BkEnLI;A/EqiRR;Aa32QE;EACE,UAAA;EACA,8B+DzMG;E/D0MH,iBiDjMG;EjDkMH,yBkErLY;ElEsLZ,yBiFxLgC;EjFyLhC,SiFxLuB;A9FqiR3B;Aa12QE;EACE,yBkE5LY;A/EwiRhB;Aa12QE;EACE,yBkE7La;A/EyiRjB;Aa12QE;EACE,ckE/Lc;A/E2iRlB;Aan2QE;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;Abq2QJ;Aan2QE;EACE,WAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;Abq2QJ;Aal2QE;EACE,aiFlJuB;A9Fs/Q3B;Aal2QE;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,ciFrKsB;EjFsKtB,qBAAA;EACA,UiFtKyB;A9F0gR7B;Aal2QE;EACE,2BiFrKsB;A9FygR1B;Aal2QE;EACE,cAAA;EACA,UAAA;Abo2QJ;Aal2QE;EACE,ciF9KwB;A9FkhR5B;Aal2QE;EACE,ciFhLsB;A9FohR1B;Aal2QE;EACE,gBAAA;Abo2QJ;Aal2QE;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;Abo2QJ;Aa71QE;EACE,akF1Re;A/FynRnB;Aan1QE;EACE,coEnSI;AjFwnRR;Aan1QE;EACE,+BgE/RwB;A7EonR5B;Aan1QE;EACE,mBsEjSI;EtEkSJ,gBAAA;EACA,yBAAA;Abq1QJ;Aan1QE;EACE,qEiFpK+B;EjFqK/B,gBAAA;EACA,mBAAA;Abq1QJ;Aar0QM;EACE,cANE;Ab60QV;Aar0QM;EACE,yDAPE;Ab80QV;Aar0QM;EACE,gCAAA;Abu0QR;Aar0QM;EACE,cAdE;Abq1QV;Aar0QM;EACE,mCAfG;Abs1QX;Aar0QM;EACE,gCAAA;Abu0QR;Aav1QM;EACE,cANE;Ab+1QV;Aav1QM;EACE,+CAPE;Abg2QV;Aav1QM;EACE,gCAAA;Aby1QR;Aav1QM;EACE,cAdE;Abu2QV;Aav1QM;EACE,gCAfG;Abw2QX;Aav1QM;EACE,gCAAA;Aby1QR;Aaz2QM;EACE,cANE;Abi3QV;Aaz2QM;EACE,wDAPE;Abk3QV;Aaz2QM;EACE,gCAAA;Ab22QR;Aaz2QM;EACE,cAdE;Aby3QV;Aaz2QM;EACE,kCAfG;Ab03QX;Aaz2QM;EACE,gCAAA;Ab22QR;Aa33QM;EACE,cANE;Abm4QV;Aa33QM;EACE,6CAPE;Abo4QV;Aa33QM;EACE,gCAAA;Ab63QR;Aa33QM;EACE,cAdE;Ab24QV;Aa33QM;EACE,kCAfG;Ab44QX;Aa33QM;EACE,gCAAA;Ab63QR;Aa74QM;EACE,cANE;Abq5QV;Aa74QM;EACE,oCAPE;Abs5QV;Aa74QM;EACE,gCAAA;Ab+4QR;Aa74QM;EACE,cAdE;Ab65QV;Aa74QM;EACE,kCAfG;Ab85QX;Aa74QM;EACE,gCAAA;Ab+4QR;Aa/5QM;EACE,cANE;Abu6QV;Aa/5QM;EACE,yDAPE;Abw6QV;Aa/5QM;EACE,gCAAA;Abi6QR;Aa/5QM;EACE,cAdE;Ab+6QV;Aa/5QM;EACE,yDAfG;Abg7QX;Aa/5QM;EACE,gCAAA;Abi6QR;Aaj7QM;EACE,cANE;Aby7QV;Aaj7QM;EACE,wDAPE;Ab07QV;Aaj7QM;EACE,gCAAA;Abm7QR;Aaj7QM;EACE,cAdE;Abi8QV;Aaj7QM;EACE,0CAfG;Abk8QX;Aaj7QM;EACE,gCAAA;Abm7QR;Aan8QM;EACE,cANE;Ab28QV;Aan8QM;EACE,oCAPE;Ab48QV;Aan8QM;EACE,gCAAA;Abq8QR;Aan8QM;EACE,cAdE;Abm9QV;Aan8QM;EACE,cAfG;Abo9QX;Aan8QM;EACE,gCAAA;Abq8QR;Aar9QM;EACE,cANE;Ab69QV;Aar9QM;EACE,yDAPE;Ab89QV;Aar9QM;EACE,gCAAA;Abu9QR;Aar9QM;EACE,cAdE;Abq+QV;Aar9QM;EACE,mCAfG;Abs+QX;Aar9QM;EACE,gCAAA;Abu9QR;Aav+QM;EACE,cANE;Ab++QV;Aav+QM;EACE,wDAPE;Abg/QV;Aav+QM;EACE,gCAAA;Aby+QR;Aav+QM;EACE,cAdE;Abu/QV;Aav+QM;EACE,mCAfG;Abw/QX;Aav+QM;EACE,gCAAA;Aby+QR;Aaz/QM;EACE,cANE;AbigRV;Aaz/QM;EACE,yDAPE;AbkgRV;Aaz/QM;EACE,gCAAA;Ab2/QR;Aaz/QM;EACE,cAdE;AbygRV;Aaz/QM;EACE,2BAfG;Ab0gRX;Aaz/QM;EACE,gCAAA;Ab2/QR;Aa3gRM;EACE,cANE;AbmhRV;Aa3gRM;EACE,yDAPE;AbohRV;Aa3gRM;EACE,gCAAA;Ab6gRR;Aa3gRM;EACE,cAdE;Ab2hRV;Aa3gRM;EACE,mCAfG;Ab4hRX;Aa3gRM;EACE,gCAAA;Ab6gRR;Aa7hRM;EACE,cANE;AbqiRV;Aa7hRM;EACE,wDAPE;AbsiRV;Aa7hRM;EACE,gCAAA;Ab+hRR;Aa7hRM;EACE,cAdE;Ab6iRV;Aa7hRM;EACE,wDAfG;Ab8iRX;Aa7hRM;EACE,gCAAA;Ab+hRR;Aa/iRM;EACE,cANE;AbujRV;Aa/iRM;EACE,mCAPE;AbwjRV;Aa/iRM;EACE,gCAAA;AbijRR;Aa/iRM;EACE,cAdE;Ab+jRV;Aa/iRM;EACE,+BAfG;AbgkRX;Aa/iRM;EACE,gCAAA;AbijRR;AajkRM;EACE,cANE;AbykRV;AajkRM;EACE,+CAPE;Ab0kRV;AajkRM;EACE,gCAAA;AbmkRR;AajkRM;EACE,cAdE;AbilRV;AajkRM;EACE,YAfG;AbklRX;AajkRM;EACE,gCAAA;AbmkRR;AazjRE;EACE,gBAAA;Ab2jRJ;AazjRE;EACE,iBAAA;Ab2jRJ;AazjRE;;EAEE,kBAAA;Ab2jRJ;AazjRE;EACE,mBAAA;Ab2jRJ;AazjRE;EACE,qBAAA;EACA,WAAA;EACA,WAAA;Ab2jRJ;AapjRE;;EAEE,WAAA;EACA,aAAA;EACA,mBiFvOoB;A9F6xRxB;AapjRE;EACE,YAAA;EACA,aAAA;EACA,kBiF5OoB;A9FkyRxB;Aa/iRE;EACE,UAAA;AbijRJ;AaziRE;EACE,+B+D1YG;E/D2YH,+CiF5SoB;A9Fu1RxB;AaziRE;EACE,+B+D9YG;A5Ey7RP;AaziRE;EACE,gBiF7S0B;A9Fw1R9B;AaxiRE;EACE,6CwEtYiB;ArFg7RrB;AaliRE;EACE,mBoEjaS;EpEkaT,6BAAA;EACA,gBiFxTsB;EjFyTtB,yBiFvTkB;EjFwTlB,8B+DjaG;A5Eq8RP;AajiRE;EACE,0BkE3ZG;A/E87RP;AajiRE;EACE,0BkE7ZI;A/Eg8RR;AajiRE;EACE,ekE/ZK;A/Ek8RT;AajiRE;EACE,0BkEjaI;A/Eo8RR;AajiRE;EACE,0BkElaG;A/Eq8RP;Aa5hRE;EACE,mBoE3bI;EpE4bJ,6BAAA;EACA,qBAAA;EACA,gBiFtUyB;EjFuUzB,yBiFtUqB;EjFuUrB,gBAAA;Ab8hRJ;Aa5hRE;EACE,mBoErcS;AjFm+Rb;Aa5hRE;EACE,gBAAA;Ab8hRJ;Aa5hRE;EACE,kDAAA;Ab8hRJ;Aa5hRE;EACE,kDAAA;Ab8hRJ;Aa1hRE;EACE,yBkE3bY;A/Eu9RhB;Aa1hRE;EACE,yBkE7ba;A/Ey9RjB;Aa1hRE;EACE,ckE/bc;A/E29RlB;Aa1hRE;EACE,yBkEjca;A/E69RjB;Aa1hRE;EACE,yBkElcY;A/E89RhB;AarhRE;EACE,yBiFrauB;A9F47R3B;Acz/RE;EACE,oBAAA;EACA,4CkFKgB;ElFJhB,4SkFFF;ElFGE,kBAAA;EACA,mBgDEK;EhDDL,oBAAA;EACA,wBAAA;EACA,oBAAA;Ad2/RJ;Acx/RE;EACE,qBAAA;EACA,UkF0BW;ElFxBX,qBAAA;EAEA,amFvBS;EnFwBT,WkFuBU;ElFrBV,oBAAA;EACA,kBAAA;EACA,mBgDfK;EhDgBL,wBAAA;EACA,kBAAA;EAEA,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,2BAAA;Ads/RJ;Acn/RE;EACE,2BAAA;Adq/RJ;Ac1+RE;EACE,WAAA;EACA,cAAA;EACA,oCAAA;Ad4+RJ;Acr+RE;;;EAGE,UAAA;Adu+RJ;Acp+RE;EACE,aiFpEe;EjFqEf,eAAA;EACA,oBAAA;Ads+RJ;Acz9RE;EACE,WAAA;EACA,oBAAA;Ad29RJ;Acp9RE;EACE,eAAA;EACA,YkFzCgB;ElF0ChB,6BAAA;Ads9RJ;Acp9RE;EACE,UAAA;Ads9RJ;Ac/8RE;EACE,+BAAA;EACA,yBAAA;EAEA,2BAAA;EACA,gDkFnDmB;ElFqDnB,qBAAA;EACA,sBAAA;Ad+8RJ;Ac78RE;EACE,YAAA;EACA,gBAAA;Ad+8RJ;Acx8RE;;EAEE,uBAAA;Ad08RJ;Acx8RE;EACE,uBAAA;Ad08RJ;Acn8RE;;;EAGE,wBAAA;Adq8RJ;Acl8RE;;EAEE,yBAAA;Ado8RJ;Acj8RE;EACE,yBAAA;Adm8RJ;Ac77RE;;;EAGE,qCAAA;Ad+7RJ;Ac57RE;;EAEE,sCAAA;Ad87RJ;Ac37RE;EACE,sCAAA;Ad67RJ;Ac17RE;;;EAGE,qCAAA;Ad47RJ;Acz7RE;;EAEE,sCAAA;Ad27RJ;Acx7RE;EACE,sCAAA;Ad07RJ;Acn7RE;EACE,cAAA;EACA,wBAAA;EAEA,UkFnIiB;ElFoIjB,WkFpIiB;ElFqIjB,2BAAA;EACA,gDkFnImB;AhGujSvB;Acl7RE;EACE,YAAA;EACA,gBAAA;Ado7RJ;Ac56RE;;EAEE,yBqErMI;ErEsMJ,cmE9MI;AjF4nSR;Ac36RE;EACE,cmElNI;AjF+nSR;Ach6RI;EACE,cAJE;Ads6RR;Ach6RI;EACE,cANE;Adw6RR;Ach6RI;;EAEE,yBAXE;EAYF,cmExOE;AjF0oSR;Ac36RI;EACE,cAJE;Adi7RR;Ac36RI;EACE,cANE;Adm7RR;Ac36RI;;EAEE,yBAXE;EAYF,cmExOE;AjFqpSR;Act7RI;EACE,cAJE;Ad47RR;Act7RI;EACE,cANE;Ad87RR;Act7RI;;EAEE,yBAXE;EAYF,cmExOE;AjFgqSR;Acj8RI;EACE,cAJE;Adu8RR;Acj8RI;EACE,cANE;Ady8RR;Acj8RI;;EAEE,yBAXE;EAYF,cmExOE;AjF2qSR;Ac58RI;EACE,cAJE;Adk9RR;Ac58RI;EACE,cANE;Ado9RR;Ac58RI;;EAEE,yBAXE;EAYF,cmExOE;AjFsrSR;Acv9RI;EACE,cAJE;Ad69RR;Acv9RI;EACE,cANE;Ad+9RR;Acv9RI;;EAEE,yBAXE;EAYF,cmExOE;AjFisSR;Acl+RI;EACE,cAJE;Adw+RR;Acl+RI;EACE,cANE;Ad0+RR;Acl+RI;;EAEE,yBAXE;EAYF,cmExOE;AjF4sSR;Ac7+RI;EACE,cAJE;Adm/RR;Ac7+RI;EACE,cANE;Adq/RR;Ac7+RI;;EAEE,yBAXE;EAYF,cmExOE;AjFutSR;Acx/RI;EACE,cAJE;Ad8/RR;Acx/RI;EACE,cANE;AdggSR;Acx/RI;;EAEE,yBAXE;EAYF,cmExOE;AjFkuSR;AcngSI;EACE,cAJE;AdygSR;AcngSI;EACE,cANE;Ad2gSR;AcngSI;;EAEE,yBAXE;EAYF,cmExOE;AjF6uSR;Ac9gSI;EACE,cAJE;AdohSR;Ac9gSI;EACE,cANE;AdshSR;Ac9gSI;;EAEE,yBAXE;EAYF,cmExOE;AjFwvSR;AczhSI;EACE,cAJE;Ad+hSR;AczhSI;EACE,cANE;AdiiSR;AczhSI;;EAEE,yBAXE;EAYF,cmExOE;AjFmwSR;AcpiSI;EACE,cAJE;Ad0iSR;AcpiSI;EACE,cANE;Ad4iSR;AcpiSI;;EAEE,yBAXE;EAYF,cmExOE;AjF8wSR;Ac/iSI;EACE,cAJE;AdqjSR;Ac/iSI;EACE,cANE;AdujSR;Ac/iSI;;EAEE,yBAXE;EAYF,cmExOE;AjFyxSR;Ac1jSI;EACE,cAJE;AdgkSR;Ac1jSI;EACE,cANE;AdkkSR;Ac1jSI;;EAEE,yBAXE;EAYF,cmExOE;AjFoySR;AcnjSE;;EAEE,cAAA;EACA,gBkFvKQ;AhG4tSZ;AcnjSE;;EAEE,cAAA;EACA,gBkF3KQ;AhGguSZ;AcnjSE;;EAEE,cAAA;EACA,iBkF/KS;AhGouSb;AcnjSE;;EAEE,ckFlLU;AhGuuSd;AcnjSE;;EAEE,cAAA;EACA,sBAAA;EACA,gBkFvLS;AhG4uSb;AcnjSE;;EAEE,cAAA;EACA,sBAAA;EACA,ckF5LO;AhGivSX;AcnjSE;;EAEE,cAAA;EACA,sBAAA;EACA,ckFjMQ;AhGsvSZ;AcnjSE;;EAEE,cAAA;EACA,sBAAA;EACA,ckFtMW;AhG2vSf;Ac9iSE;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;AdgjSJ;Ac7iSE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,SAAA;Ad+iSJ;Ac5iSE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;Ad8iSJ;Ac1iSE;EACE,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,iBkFhQe;ElFiQf,2FkF9PF;AhG0ySF;Ac1iSE;EACE,MAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;Ad4iSJ;Ac1iSE;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;Ad4iSJ;Ac1iSE;EACE,SAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;Ad4iSJ;Ac1iSE;EACE,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;Ad4iSJ;AcziSE;EACE,2FkFpRF;AhG+zSF;Aet2SE;EAA4B,gBAAA;Afy2S9B;Aex2SE;EAAwB,gBAAA;Af22S1B;Ae12SE;EAAyB,gBAAA;Af62S3B;Ae52SE;EAAwB,gBAAA;Af+2S1B;Ae92SE;EAAwB,gBAAA;Afi3S1B;Aeh3SE;EAAwB,gBAAA;Afm3S1B;Ael3SE;EAAyB,gBAAA;Afq3S3B;Ae72SE;EAAmB,gBAAA;Afg3SrB;Ae/2SE;EAA6B,gBAAA;Afk3S/B;Aej3SE;EAA6B,gBAAA;Afo3S/B;Aen3SE;EAAuB,gBAAA;Afs3SzB;Aer3SE;EAA8B,gBAAA;Afw3ShC;Aev3SE;EAA6B,gBAAA;Af03S/B;Aez3SE;EAA8B,gBAAA;Af43ShC;Ae33SE;EAA2B,gBAAA;Af83S7B;Ae73SE;EAA4B,gBAAA;Afg4S9B;Ae/3SE;EAA0B,gBAAA;Afk4S5B;Aej4SE;EAA0B,gBAAA;Afo4S5B;Aen4SE;EAAoD,gBAAA;Afs4StD;Aer4SE;EAAuB,gBAAA;Afw4SzB;Aev4SE;EAAkC,gBAAA;Af04SpC;Aez4SE;EAAkC,gBAAA;Af44SpC;Ae34SE;EAAmC,gBAAA;Af84SrC;Ae74SE;EAAgC,gBAAA;Afg5SlC;Ae/4SE;EAA2B,gBAAA;Afk5S7B;Aej5SE;EAA4B,gBAAA;Afo5S9B;Aen5SE;EAAyB,gBAAA;Afs5S3B;Aer5SE;EAA2B,gBAAA;Afw5S7B;Aev5SE;EAAsB,gBAAA;Af05SxB;Aez5SE;EAAqB,gBAAA;Af45SvB;Ae35SE;EAAwB,gBAAA;Af85S1B;Ae75SE;EAAwB,gBAAA;Afg6S1B;Ae/5SE;EAA4C,gBAAA;Afk6S9C;Aej6SE;EAA4C,gBAAA;Afo6S9C;Aen6SE;EAA6C,gBAAA;Afs6S/C;Aer6SE;EAA0C,gBAAA;Afw6S5C;Aev6SE;EAAkC,gBAAA;Af06SpC;Aez6SE;EAAkC,gBAAA;Af46SpC;Ae36SE;EAAmC,gBAAA;Af86SrC;Ae76SE;EAAgC,gBAAA;Afg7SlC;Ae/6SE;EAA2B,gBAAA;Afk7S7B;Aej7SE;EAA2B,gBAAA;Afo7S7B;Aen7SE;EAA4B,gBAAA;Afs7S9B;Aer7SE;EAAyB,gBAAA;Afw7S3B;Aev7SE;EAAiC,gBAAA;Af07SnC;Aez7SE;EAA4C,gBAAA;Af47S9C;Ae37SE;EAA0C,gBAAA;Af87S5C;Ae77SE;EAA4C,gBAAA;Afg8S9C;Ae/7SE;EAAyB,gBAAA;Afk8S3B;Aej8SE;EAAmB,gBAAA;Afo8SrB;Aen8SE;EAAsB,gBAAA;Afs8SxB;Aer8SE;EAAqB,gBAAA;Afw8SvB;Aev8SE;EAAkC,gBAAA;Af08SpC;Aez8SE;EAAsB,gBAAA;Af48SxB;Ae38SE;EAAqB,gBAAA;Af88SvB;Ae78SE;EAA8B,gBAAA;Afg9ShC;Ae/8SE;EAA0B,gBAAA;Afk9S5B;Aej9SE;EAAyB,gBAAA;Afo9S3B;Aen9SE;EAAsB,gBAAA;Afs9SxB;Aer9SE;EAA8B,gBAAA;Afw9ShC;Aev9SE;EAAmC,gBAAA;Af09SrC;Aez9SE;EAAoC,gBAAA;Af49StC;Ae39SE;EAAoB,gBAAA;Af89StB;Ae79SE;EAAyB,gBAAA;Afg+S3B;Ae/9SE;EAAwB,gBAAA;Afk+S1B;Aej+SE;EAAqB,gBAAA;Afo+SvB;Aen+SE;EAA8B,gBAAA;Afs+ShC;Aer+SE;EAAgC,gBAAA;Afw+SlC;Aev+SE;EAAqB,gBAAA;Af0+SvB;Aez+SE;EAA8B,gBAAA;Af4+ShC;Ae3+SE;EAA6B,gBAAA;Af8+S/B;Ae7+SE;EAA6B,gBAAA;Afg/S/B;Ae/+SE;EAAgC,gBAAA;Afk/SlC;Aej/SE;EAAuC,gBAAA;Afo/SzC;Aen/SE;EAAoB,gBAAA;Afs/StB;Aer/SE;EAAqB,gBAAA;Afw/SvB;Aev/SE;EAAqB,gBAAA;Af0/SvB;Aez/SE;EAA2B,gBAAA;Af4/S7B;Ae3/SE;EAA6B,gBAAA;Af8/S/B;Ae7/SE;EAAsB,gBAAA;AfggTxB;Ae//SE;EAAwB,gBAAA;AfkgT1B;AejgTE;EAAuB,gBAAA;AfogTzB;AengTE;EAA2B,gBAAA;AfsgT7B;AergTE;EAA0B,gBAAA;AfwgT5B;AevgTE;EAA8B,gBAAA;Af0gThC;AezgTE;EAAwB,gBAAA;Af4gT1B;Ae3gTE;EAA8B,gBAAA;Af8gThC;Ae7gTE;EAAsB,gBAAA;AfghTxB;Ae/gTE;EAAqB,gBAAA;AfkhTvB;AejhTE;EAAqB,gBAAA;AfohTvB;AenhTE;EAAqB,gBAAA;AfshTvB;AerhTE;EAAqB,gBAAA;AfwhTvB;AevhTE;EAAqB,gBAAA;Af0hTvB;AezhTE;EAAqB,gBAAA;Af4hTvB;Ae3hTE;EAAqB,gBAAA;Af8hTvB;Ae7hTE;EAA0B,gBAAA;AfgiT5B;Ae/hTE;EAA6B,gBAAA;AfkiT/B;AejiTE;EAA0B,gBAAA;AfoiT5B;AeniTE;EAA4B,gBAAA;AfsiT9B;AeriTE;EAAyB,gBAAA;AfwiT3B;AeviTE;EAA2B,gBAAA;Af0iT7B;AeziTE;EAA4B,gBAAA;Af4iT9B;Ae3iTE;EAA6B,gBAAA;Af8iT/B;Ae7iTE;EAA6B,gBAAA;AfgjT/B;Ae/iTE;EAAoB,gBAAA;AfkjTtB;AejjTE;EAAyB,gBAAA;AfojT3B;AenjTE;EAAsB,gBAAA;AfsjTxB;AerjTE;EAAwB,gBAAA;AfwjT1B;AevjTE;EAAsB,gBAAA;Af0jTxB;AezjTE;EAA4B,gBAAA;Af4jT9B;Ae3jTE;EAA0B,gBAAA;Af8jT5B;Ae7jTE;EAAkC,gBAAA;AfgkTpC;Ae/jTE;EAAgC,gBAAA;AfkkTlC;AejkTE;EAAsB,gBAAA;AfokTxB;AenkTE;EAAsB,gBAAA;AfskTxB;AerkTE;EAAoB,gBAAA;AfwkTtB;AevkTE;EAAyB,gBAAA;Af0kT3B;AezkTE;EAAyB,gBAAA;Af4kT3B;Ae3kTE;EAAyB,gBAAA;Af8kT3B;Ae7kTE;EAAqB,gBAAA;AfglTvB;Ae/kTE;EAAoB,gBAAA;AfklTtB;AejlTE;EAA8B,gBAAA;AfolThC;AenlTE;EAA8B,gBAAA;AfslThC;AerlTE;EAA2B,gBAAA;AfwlT7B;AevlTE;EAAyB,gBAAA;Af0lT3B;AezlTE;EAAmC,gBAAA;Af4lTrC;Ae3lTE;EAA+B,gBAAA;Af8lTjC;Ae7lTE;EAA6B,gBAAA;AfgmT/B;Ae/lTE;EAA+B,gBAAA;AfkmTjC;AejmTE;EAA8B,gBAAA;AfomThC;AenmTE;EAA+B,gBAAA;AfsmTjC;AermTE;EAA8B,gBAAA;AfwmThC;AevmTE;EAAuB,gBAAA;Af0mTzB;AezmTE;EAA6B,gBAAA;Af4mT/B;Ae3mTE;EAA2B,gBAAA;Af8mT7B;Ae7mTE;EAA2B,gBAAA;AfgnT7B;Ae/mTE;EAAyB,gBAAA;AfknT3B;AejnTE;EAAyB,gBAAA;AfonT3B;AennTE;EAAoB,gBAAA;AfsnTtB;AernTE;EAA8B,gBAAA;AfwnThC;AevnTE;EAA4B,gBAAA;Af0nT9B;AeznTE;EAA0B,gBAAA;Af4nT5B;Ae3nTE;EAAyB,gBAAA;Af8nT3B;Ae7nTE;EAA2B,gBAAA;AfgoT7B;Ae/nTE;EAA2B,gBAAA;AfkoT7B;AejoTE;EAA4B,gBAAA;AfooT9B;AenoTE;EAAkC,gBAAA;AfsoTpC;AeroTE;EAAkC,gBAAA;AfwoTpC;AevoTE;EAAmC,gBAAA;Af0oTrC;AezoTE;EAAgC,gBAAA;Af4oTlC;Ae3oTE;EAAyB,gBAAA;Af8oT3B;Ae7oTE;EAAuB,gBAAA;AfgpTzB;Ae/oTE;EAAgC,gBAAA;AfkpTlC;AejpTE;EAA0B,gBAAA;AfopT5B;AenpTE;EAA8B,gBAAA;AfspThC;AerpTE;EAAoB,gBAAA;AfwpTtB;AevpTE;EAA4B,gBAAA;Af0pT9B;AezpTE;EAAsB,gBAAA;Af4pTxB;Ae3pTE;EAA2B,gBAAA;Af8pT7B;Ae7pTE;EAAmC,gBAAA;AfgqTrC;Ae/pTE;EAAiC,gBAAA;AfkqTnC;AejqTE;EAA2B,gBAAA;AfoqT7B;AenqTE;EAA0B,gBAAA;AfsqT5B;AerqTE;EAA2B,gBAAA;AfwqT7B;AevqTE;EAA0B,gBAAA;Af0qT5B;AezqTE;EAAsB,gBAAA;Af4qTxB;Ae3qTE;EAA6B,gBAAA;Af8qT/B;Ae7qTE;EAA6B,gBAAA;AfgrT/B;Ae/qTE;EAA6B,gBAAA;AfkrT/B;AejrTE;EAAuB,gBAAA;AforTzB;AenrTE;EAAsB,gBAAA;AfsrTxB;AerrTE;EAA6B,gBAAA;AfwrT/B;AevrTE;EAA4B,gBAAA;Af0rT9B;AezrTE;EAA2B,gBAAA;Af4rT7B;Ae3rTE;EAA6B,gBAAA;Af8rT/B;Ae7rTE;EAA2B,gBAAA;AfgsT7B;Ae/rTE;EAA4B,gBAAA;AfksT9B;AejsTE;EAA2B,gBAAA;AfosT7B;AensTE;EAAoC,gBAAA;AfssTtC;AersTE;EAAoC,gBAAA;AfwsTtC;AevsTE;EAAqC,gBAAA;Af0sTvC;AezsTE;EAAkC,gBAAA;Af4sTpC;Ae3sTE;EAA6B,gBAAA;Af8sT/B;Ae7sTE;EAA6B,gBAAA;AfgtT/B;Ae/sTE;EAA8B,gBAAA;AfktThC;AejtTE;EAA2B,gBAAA;AfotT7B;AentTE;EAAsB,gBAAA;AfstTxB;AertTE;EAAuB,gBAAA;AfwtTzB;AevtTE;EAAuB,gBAAA;Af0tTzB;AeztTE;EAA6B,gBAAA;Af4tT/B;Ae3tTE;EAAqB,gBAAA;Af8tTvB;Ae7tTE;EAA+B,gBAAA;AfguTjC;Ae/tTE;EAA0B,gBAAA;AfkuT5B;AejuTE;EAAgC,gBAAA;AfouTlC;AenuTE;EAA+B,gBAAA;AfsuTjC;AeruTE;EAAsB,gBAAA;AfwuTxB;AevuTE;EAAsB,gBAAA;Af0uTxB;AezuTE;EAAkC,gBAAA;Af4uTpC;Ae3uTE;EAAsB,gBAAA;Af8uTxB;Ae7uTE;EAAyC,gBAAA;AfgvT3C;Ae/uTE;EAA+B,gBAAA;AfkvTjC;AejvTE;EAA2B,gBAAA;AfovT7B;AenvTE;EAAgC,gBAAA;AfsvTlC;AervTE;EAA2B,gBAAA;AfwvT7B;AevvTE;EAAoC,gBAAA;Af0vTtC;AezvTE;EAA0B,gBAAA;Af4vT5B;Ae3vTE;EAA+B,gBAAA;Af8vTjC;Ae7vTE;EAAuC,gBAAA;AfgwTzC;Ae/vTE;EAAyB,gBAAA;AfkwT3B;AejwTE;EAAqB,gBAAA;AfowTvB;AenwTE;EAA4B,gBAAA;AfswT9B;AerwTE;EAAuB,gBAAA;AfwwTzB;AevwTE;EAAoB,gBAAA;Af0wTtB;AezwTE;EAAqB,gBAAA;Af4wTvB;Ae3wTE;EAAsB,gBAAA;Af8wTxB;Ae7wTE;EAAwB,gBAAA;AfgxT1B;Ae/wTE;EAAwB,gBAAA;AfkxT1B;AejxTE;EAAkC,gBAAA;AfoxTpC;AenxTE;EAA+B,gBAAA;AfsxTjC;AerxTE;EAA6B,gBAAA;AfwxT/B;AevxTE;EAAgC,gBAAA;Af0xTlC;AezxTE;EAA8B,gBAAA;Af4xThC;Ae3xTE;EAAyB,gBAAA;Af8xT3B;Ae7xTE;EAAgC,gBAAA;AfgyTlC;Ae/xTE;EAA6B,gBAAA;AfkyT/B;AejyTE;EAAwB,gBAAA;AfoyT1B;AenyTE;EAAyB,gBAAA;AfsyT3B;AeryTE;EAA0C,gBAAA;AfwyT5C;AevyTE;EAA+B,gBAAA;Af0yTjC;AezyTE;EAAuB,gBAAA;Af4yTzB;Ae3yTE;EAA4B,gBAAA;Af8yT9B;Ae7yTE;EAAqB,gBAAA;AfgzTvB;Ae/yTE;EAA0B,gBAAA;AfkzT5B;AejzTE;EAAsB,gBAAA;AfozTxB;AenzTE;EAA4B,gBAAA;AfszT9B;AerzTE;EAAqB,gBAAA;AfwzTvB;AevzTE;EAA+B,gBAAA;Af0zTjC;AezzTE;EAAsB,gBAAA;Af4zTxB;Ae3zTE;EAA2B,gBAAA;Af8zT7B;Ae7zTE;EAAqB,gBAAA;Afg0TvB;Ae/zTE;EAAsB,gBAAA;Afk0TxB;Aej0TE;EAAuB,gBAAA;Afo0TzB;Aen0TE;EAAqB,gBAAA;Afs0TvB;Aer0TE;EAAsB,gBAAA;Afw0TxB;Aev0TE;EAAoB,gBAAA;Af00TtB;Aez0TE;EAAyB,gBAAA;Af40T3B;Ae30TE;EAAqB,gBAAA;Af80TvB;Ae70TE;EAAyB,gBAAA;Afg1T3B;Ae/0TE;EAAwB,gBAAA;Afk1T1B;Aej1TE;EAA6B,gBAAA;Afo1T/B;Aen1TE;EAA0B,gBAAA;Afs1T5B;Aer1TE;EAAqB,gBAAA;Afw1TvB;Aev1TE;EAAyB,gBAAA;Af01T3B;Aez1TE;EAAwB,gBAAA;Af41T1B;Ae31TE;EAA0B,gBAAA;Af81T5B;Ae71TE;EAA0B,gBAAA;Afg2T5B;Ae/1TE;EAAyB,gBAAA;Afk2T3B;Aej2TE;EAAyB,gBAAA;Afo2T3B;Aen2TE;EAA2B,gBAAA;Afs2T7B;Aer2TE;EAAyB,gBAAA;Afw2T3B;Aev2TE;EAAmC,gBAAA;Af02TrC;Aez2TE;EAA2B,gBAAA;Af42T7B;Ae32TE;EAAuB,gBAAA;Af82TzB;Ae72TE;EAAsB,gBAAA;Afg3TxB;Ae/2TE;EAAoB,gBAAA;Afk3TtB;Aej3TE;EAAoB,gBAAA;Afo3TtB;Aen3TE;EAA4B,gBAAA;Afs3T9B;Aer3TE;EAAsB,gBAAA;Afw3TxB;Aev3TE;EAA8B,gBAAA;Af03ThC;Aez3TE;EAAuB,gBAAA;Af43TzB;Ae33TE;EAA4B,gBAAA;Af83T9B;Ae73TE;EAA0B,gBAAA;Afg4T5B;Ae/3TE;EAA2B,gBAAA;Afk4T7B;Aej4TE;EAAqB,gBAAA;Afo4TvB;Aen4TE;EAAyB,gBAAA;Afs4T3B;Aer4TE;EAAiC,gBAAA;Afw4TnC;Aev4TE;EAAuB,gBAAA;Af04TzB;Aez4TE;EAA6B,gBAAA;Af44T/B;Ae34TE;EAAqB,gBAAA;Af84TvB;Ae74TE;EAA8B,gBAAA;Afg5ThC;Ae/4TE;EAA+B,gBAAA;Afk5TjC;Aej5TE;EAAyB,gBAAA;Afo5T3B;Aen5TE;EAAyB,gBAAA;Afs5T3B;Aer5TE;EAA8B,gBAAA;Afw5ThC;Aev5TE;EAAwB,gBAAA;Af05T1B;Aez5TE;EAAqB,gBAAA;Af45TvB;Ae35TE;EAAoB,gBAAA;Af85TtB;Ae75TE;EAAsB,gBAAA;Afg6TxB;Ae/5TE;EAAoC,gBAAA;Afk6TtC;Aej6TE;EAAkC,gBAAA;Afo6TpC;Aen6TE;EAAyB,gBAAA;Afs6T3B;Aer6TE;EAA8B,gBAAA;Afw6ThC;Aev6TE;EAAmC,gBAAA;Af06TrC;Aez6TE;EAAgC,gBAAA;Af46TlC;Ae36TE;EAAuB,gBAAA;Af86TzB;Ae76TE;EAAuB,gBAAA;Afg7TzB;Ae/6TE;EAAyB,gBAAA;Afk7T3B;Aej7TE;EAA0B,gBAAA;Afo7T5B;Aen7TE;EAAmC,gBAAA;Afs7TrC;Aer7TE;EAA4B,gBAAA;Afw7T9B;Aev7TE;EAAmC,gBAAA;Af07TrC;Aez7TE;EAAqC,gBAAA;Af47TvC;Ae37TE;EAAuB,gBAAA;Af87TzB;Ae77TE;EAAwC,gBAAA;Afg8T1C;Ae/7TE;EAAmC,gBAAA;Afk8TrC;Aej8TE;EAA+C,gBAAA;Afo8TjD;Aen8TE;EAAoB,gBAAA;Afs8TtB;Aer8TE;EAA4B,gBAAA;Afw8T9B;Aev8TE;EAA0B,gBAAA;Af08T5B;Aez8TE;EAAoB,gBAAA;Af48TtB;Ae38TE;EAA8B,gBAAA;Af88ThC;Ae78TE;EAA6B,gBAAA;Afg9T/B;Ae/8TE;EAAoB,gBAAA;Afk9TtB;Aej9TE;EAAwB,gBAAA;Afo9T1B;Aen9TE;EAAkC,gBAAA;Afs9TpC;Aer9TE;EAAuB,gBAAA;Afw9TzB;Aev9TE;EAA4B,gBAAA;Af09T9B;Aez9TE;EAAqB,gBAAA;Af49TvB;Ae39TE;EAA+B,gBAAA;Af89TjC;Ae79TE;EAA6B,gBAAA;Afg+T/B;Ae/9TE;EAA2B,gBAAA;Afk+T7B;Aej+TE;EAA0B,gBAAA;Afo+T5B;Aen+TE;EAA8B,gBAAA;Afs+ThC;Aer+TE;EAAyB,gBAAA;Afw+T3B;Aev+TE;EAA8B,gBAAA;Af0+ThC;Aez+TE;EAA2B,gBAAA;Af4+T7B;Ae3+TE;EAA4B,gBAAA;Af8+T9B;Ae7+TE;EAA2B,gBAAA;Afg/T7B;Ae/+TE;EAA4B,gBAAA;Afk/T9B;Aej/TE;EAA6B,gBAAA;Afo/T/B;Aen/TE;EAAoC,gBAAA;Afs/TtC;Aer/TE;EAA6B,gBAAA;Afw/T/B;Aev/TE;EAAuC,gBAAA;Af0/TzC;Aez/TE;EAAyB,gBAAA;Af4/T3B;Ae3/TE;EAAgC,gBAAA;Af8/TlC;Ae7/TE;EAAkC,gBAAA;AfggUpC;Ae//TE;EAA+B,gBAAA;AfkgUjC;AejgUE;EAA4B,gBAAA;AfogU9B;AengUE;EAA2B,gBAAA;AfsgU7B;AergUE;EAA0B,gBAAA;AfwgU5B;AevgUE;EAAqB,gBAAA;Af0gUvB;AezgUE;EAA0B,gBAAA;Af4gU5B;Ae3gUE;EAAqB,gBAAA;Af8gUvB;Ae7gUE;EAAuB,gBAAA;AfghUzB;Ae/gUE;EAA4B,gBAAA;AfkhU9B;AejhUE;EAAqB,gBAAA;AfohUvB;AenhUE;EAA+B,gBAAA;AfshUjC;AerhUE;EAAkC,gBAAA;AfwhUpC;AevhUE;EAA0B,gBAAA;Af0hU5B;AezhUE;EAAqB,gBAAA;Af4hUvB;Ae3hUE;EAA4B,gBAAA;Af8hU9B;Ae7hUE;EAAqB,gBAAA;AfgiUvB;Ae/hUE;EAA+B,gBAAA;AfkiUjC;AejiUE;EAAyB,gBAAA;AfoiU3B;AeniUE;EAAsB,gBAAA;AfsiUxB;AeriUE;EAAwB,gBAAA;AfwiU1B;AeviUE;EAAuB,gBAAA;Af0iUzB;AeziUE;EAA6B,gBAAA;Af4iU/B;Ae3iUE;EAA4B,gBAAA;Af8iU9B;Ae7iUE;EAA4B,gBAAA;AfgjU9B;Ae/iUE;EAAqB,gBAAA;AfkjUvB;AejjUE;EAA8B,gBAAA;AfojUhC;AenjUE;EAAwB,gBAAA;AfsjU1B;AerjUE;EAAqB,gBAAA;AfwjUvB;AevjUE;EAAsB,gBAAA;Af0jUxB;AezjUE;EAA2B,gBAAA;Af4jU7B;Ae3jUE;EAA4B,gBAAA;Af8jU9B;Ae7jUE;EAA8B,gBAAA;AfgkUhC;Ae/jUE;EAAuB,gBAAA;AfkkUzB;AejkUE;EAAwB,gBAAA;AfokU1B;AenkUE;EAAyB,gBAAA;AfskU3B;AerkUE;EAAsB,gBAAA;AfwkUxB;AevkUE;EAAoB,gBAAA;Af0kUtB;AezkUE;EAA2B,gBAAA;Af4kU7B;Ae3kUE;EAAsB,gBAAA;Af8kUxB;Ae7kUE;EAAqB,gBAAA;AfglUvB;Ae/kUE;EAAsB,gBAAA;AfklUxB;AejlUE;EAA6B,gBAAA;AfolU/B;AenlUE;EAA8B,gBAAA;AfslUhC;AerlUE;EAAwC,gBAAA;AfwlU1C;AevlUE;EAA8B,gBAAA;Af0lUhC;AezlUE;EAAwB,gBAAA;Af4lU1B;Ae3lUE;EAAsB,gBAAA;Af8lUxB;Ae7lUE;EAA6B,gBAAA;AfgmU/B;Ae/lUE;EAA+B,gBAAA;AfkmUjC;AejmUE;EAA2B,gBAAA;AfomU7B;AenmUE;EAA6B,gBAAA;AfsmU/B;AermUE;EAA0B,gBAAA;AfwmU5B;AevmUE;EAAwB,gBAAA;Af0mU1B;AezmUE;EAA+B,gBAAA;Af4mUjC;Ae3mUE;EAA6B,gBAAA;Af8mU/B;Ae7mUE;EAAmC,gBAAA;AfgnUrC;Ae/mUE;EAAwB,gBAAA;AfknU1B;AejnUE;EAAqB,gBAAA;AfonUvB;AennUE;EAA+B,gBAAA;AfsnUjC;AernUE;EAA0B,gBAAA;AfwnU5B;AevnUE;EAAgC,gBAAA;Af0nUlC;AeznUE;EAA4B,gBAAA;Af4nU9B;Ae3nUE;EAA4B,gBAAA;Af8nU9B;Ae7nUE;EAAkC,gBAAA;AfgoUpC;Ae/nUE;EAA2B,gBAAA;AfkoU7B;AejoUE;EAA2B,gBAAA;AfooU7B;AenoUE;EAA4B,gBAAA;AfsoU9B;AeroUE;EAAmC,gBAAA;AfwoUrC;AevoUE;EAAiC,gBAAA;Af0oUnC;AezoUE;EAA0B,gBAAA;Af4oU5B;Ae3oUE;EAAgC,gBAAA;Af8oUlC;Ae7oUE;EAA2B,gBAAA;AfgpU7B;Ae/oUE;EAAoC,gBAAA;AfkpUtC;AejpUE;EAA8B,gBAAA;AfopUhC;AenpUE;EAAuB,gBAAA;AfspUzB;AerpUE;EAAyB,gBAAA;AfwpU3B;AevpUE;EAA0B,gBAAA;Af0pU5B;AezpUE;EAAuB,gBAAA;Af4pUzB;Ae3pUE;EAAsB,gBAAA;Af8pUxB;Ae7pUE;EAA6B,gBAAA;AfgqU/B;Ae/pUE;EAAmC,gBAAA;AfkqUrC;AejqUE;EAAiC,gBAAA;AfoqUnC;AenqUE;EAA4B,gBAAA;AfsqU9B;AerqUE;EAAmC,gBAAA;AfwqUrC;AevqUE;EAA2B,gBAAA;Af0qU7B;AezqUE;EAA2B,gBAAA;Af4qU7B;Ae3qUE;EAAgC,gBAAA;Af8qUlC;Ae7qUE;EAAgC,gBAAA;AfgrUlC;Ae/qUE;EAAiC,gBAAA;AfkrUnC;AejrUE;EAA8B,gBAAA;AforUhC;AenrUE;EAA6B,gBAAA;AfsrU/B;AerrUE;EAA0B,gBAAA;AfwrU5B;AevrUE;EAA8B,gBAAA;Af0rUhC;AezrUE;EAA2B,gBAAA;Af4rU7B;Ae3rUE;EAAsB,gBAAA;Af8rUxB;Ae7rUE;EAA8B,gBAAA;AfgsUhC;Ae/rUE;EAA0B,gBAAA;AfksU5B;AejsUE;EAAyB,gBAAA;AfosU3B;AensUE;EAAyB,gBAAA;AfssU3B;AersUE;EAAwB,gBAAA;AfwsU1B;AevsUE;EAA2B,gBAAA;Af0sU7B;AezsUE;EAAuB,gBAAA;Af4sUzB;Ae3sUE;EAAoB,gBAAA;Af8sUtB;Ae7sUE;EAAwB,gBAAA;AfgtU1B;Ae/sUE;EAA2B,gBAAA;AfktU7B;AejtUE;EAAqC,gBAAA;AfotUvC;AentUE;EAAwB,gBAAA;AfstU1B;AertUE;EAAsB,gBAAA;AfwtUxB;AevtUE;EAA6B,gBAAA;Af0tU/B;AeztUE;EAA0B,gBAAA;Af4tU5B;Ae3tUE;EAA2B,gBAAA;Af8tU7B;Ae7tUE;EAA4B,gBAAA;AfguU9B;Ae/tUE;EAAuB,gBAAA;AfkuUzB;AejuUE;EAAsB,gBAAA;AfouUxB;AenuUE;EAAwB,gBAAA;AfsuU1B;AeruUE;EAA4B,gBAAA;AfwuU9B;AevuUE;EAA4B,gBAAA;Af0uU9B;AezuUE;EAAqB,gBAAA;Af4uUvB;Ae3uUE;EAAsB,gBAAA;Af8uUxB;Ae7uUE;EAA2B,gBAAA;AfgvU7B;Ae/uUE;EAAyB,gBAAA;AfkvU3B;AejvUE;EAAmC,gBAAA;AfovUrC;AenvUE;EAAgC,gBAAA;AfsvUlC;AervUE;EAAwB,gBAAA;AfwvU1B;AevvUE;EAAuB,gBAAA;Af0vUzB;AezvUE;EAAsB,gBAAA;Af4vUxB;Ae3vUE;EAA0B,gBAAA;Af8vU5B;Ae7vUE;EAA8B,gBAAA;AfgwUhC;Ae/vUE;EAA+B,gBAAA;AfkwUjC;AejwUE;EAAgC,gBAAA;AfowUlC;AenwUE;EAA6B,gBAAA;AfswU/B;AerwUE;EAAwB,gBAAA;AfwwU1B;AevwUE;EAAyB,gBAAA;Af0wU3B;AezwUE;EAA0B,gBAAA;Af4wU5B;Ae3wUE;EAAwB,gBAAA;Af8wU1B;Ae7wUE;EAAsB,gBAAA;AfgxUxB;Ae/wUE;EAAyB,gBAAA;AfkxU3B;AejxUE;EAAwB,gBAAA;AfoxU1B;AenxUE;EAAkC,gBAAA;AfsxUpC;AerxUE;EAAsB,gBAAA;AfwxUxB;AevxUE;EAAsB,gBAAA;Af0xUxB;AezxUE;EAAuB,gBAAA;Af4xUzB;Ae3xUE;EAAsB,gBAAA;Af8xUxB;Ae7xUE;EAAuB,gBAAA;AfgyUzB;Ae/xUE;EAAyB,gBAAA;AfkyU3B;AejyUE;EAAyB,gBAAA;AfoyU3B;AenyUE;EAAqB,gBAAA;AfsyUvB;AeryUE;EAA4B,gBAAA;AfwyU9B;AevyUE;EAAuB,gBAAA;Af0yUzB;AezyUE;EAAqB,gBAAA;Af4yUvB;Ae3yUE;EAAsB,gBAAA;Af8yUxB;Ae7yUE;EAA+B,gBAAA;AfgzUjC;Ae/yUE;EAAsB,gBAAA;AfkzUxB;AejzUE;EAAoB,gBAAA;AfozUtB;AenzUE;EAAyB,gBAAA;AfszU3B;AerzUE;EAAuB,gBAAA;AfwzUzB;AevzUE;EAAqB,gBAAA;Af0zUvB;AezzUE;EAA0B,gBAAA;Af4zU5B;Ae3zUE;EAAgC,gBAAA;Af8zUlC;Ae7zUE;EAA0B,gBAAA;Afg0U5B;Ae/zUE;EAAyB,gBAAA;Afk0U3B;Aej0UE;EAAyB,gBAAA;Afo0U3B;Aen0UE;EAAuB,gBAAA;Afs0UzB;Aer0UE;EAA4B,gBAAA;Afw0U9B;Aev0UE;EAA+B,gBAAA;Af00UjC;Aez0UE;EAAsB,gBAAA;Af40UxB;Ae30UE;EAA2B,gBAAA;Af80U7B;Ae70UE;EAA6B,gBAAA;Afg1U/B;Ae/0UE;EAA2B,gBAAA;Afk1U7B;Aej1UE;EAA4B,gBAAA;Afo1U9B;Aen1UE;EAAqB,gBAAA;Afs1UvB;Aer1UE;EAAsB,gBAAA;Afw1UxB;Aev1UE;EAA0B,gBAAA;Af01U5B;Aez1UE;EAAgC,gBAAA;Af41UlC;Ae31UE;EAAqC,gBAAA;Af81UvC;Ae71UE;EAAmC,gBAAA;Afg2UrC;Ae/1UE;EAA0B,gBAAA;Afk2U5B;Aej2UE;EAA0B,gBAAA;Afo2U5B;Aen2UE;EAAwB,gBAAA;Afs2U1B;Aer2UE;EAA0B,gBAAA;Afw2U5B;Aev2UE;EAAqB,gBAAA;Af02UvB;Aez2UE;EAA+B,gBAAA;Af42UjC;Ae32UE;EAAwB,gBAAA;Af82U1B;Ae72UE;EAAwB,gBAAA;Afg3U1B;Ae/2UE;EAA+B,gBAAA;Afk3UjC;Aej3UE;EAAqB,gBAAA;Afo3UvB;Aen3UE;EAA0B,gBAAA;Afs3U5B;Aer3UE;EAA0C,gBAAA;Afw3U5C;Aev3UE;EAA0C,gBAAA;Af03U5C;Aez3UE;EAA2C,gBAAA;Af43U7C;Ae33UE;EAAwC,gBAAA;Af83U1C;Ae73UE;EAA2B,gBAAA;Afg4U7B;Ae/3UE;EAA6B,gBAAA;Afk4U/B;Aej4UE;EAAsB,gBAAA;Afo4UxB;Aen4UE;EAAuB,gBAAA;Afs4UzB;Aer4UE;EAA0B,gBAAA;Afw4U5B;Aev4UE;EAAqB,gBAAA;Af04UvB;Aez4UE;EAAoB,gBAAA;Af44UtB;Ae34UE;EAA2B,gBAAA;Af84U7B;Ae74UE;EAAqC,gBAAA;Afg5UvC;Ae/4UE;EAA2B,gBAAA;Afk5U7B;Aej5UE;EAAqC,gBAAA;Afo5UvC;Aen5UE;EAAwB,gBAAA;Afs5U1B;Aer5UE;EAA0B,gBAAA;Afw5U5B;Aev5UE;EAAuB,gBAAA;Af05UzB;Aez5UE;EAAqB,gBAAA;Af45UvB;Ae35UE;EAA4B,gBAAA;Af85U9B;Ae75UE;EAA4B,gBAAA;Afg6U9B;Ae/5UE;EAAuC,gBAAA;Afk6UzC;Aej6UE;EAAqC,gBAAA;Afo6UvC;Aen6UE;EAAqB,gBAAA;Afs6UvB;Aer6UE;EAAsB,gBAAA;Afw6UxB;Aev6UE;EAAuB,gBAAA;Af06UzB;Aez6UE;EAAoB,gBAAA;Af46UtB;Ae36UE;EAA0B,gBAAA;Af86U5B;Ae76UE;EAAiC,gBAAA;Afg7UnC;Ae/6UE;EAAuB,gBAAA;Afk7UzB;Aej7UE;EAAwB,gBAAA;Afo7U1B;Aen7UE;EAAwB,gBAAA;Afs7U1B;Aer7UE;EAAuB,gBAAA;Afw7UzB;Aev7UE;EAA0B,gBAAA;Af07U5B;Aez7UE;EAA2B,gBAAA;Af47U7B;Ae37UE;EAAqC,gBAAA;Af87UvC;Ae77UE;EAA2C,gBAAA;Afg8U7C;Ae/7UE;EAAiC,gBAAA;Afk8UnC;Aej8UE;EAA2B,gBAAA;Afo8U7B;Aen8UE;EAAsB,gBAAA;Afs8UxB;Aer8UE;EAA6B,gBAAA;Afw8U/B;Aev8UE;EAA6B,gBAAA;Af08U/B;Aez8UE;EAAuB,gBAAA;Af48UzB;Ae38UE;EAAuB,gBAAA;Af88UzB;Ae78UE;EAAiC,gBAAA;Afg9UnC;Ae/8UE;EAA2B,gBAAA;Afk9U7B;Aej9UE;EAAqC,gBAAA;Afo9UvC;Aen9UE;EAAgC,gBAAA;Afs9UlC;Aer9UE;EAA0C,gBAAA;Afw9U5C;Aev9UE;EAA4B,gBAAA;Af09U9B;Aez9UE;EAAsC,gBAAA;Af49UxC;Ae39UE;EAAyB,gBAAA;Af89U3B;Ae79UE;EAAqB,gBAAA;Afg+UvB;Ae/9UE;EAA8B,gBAAA;Afk+UhC;Aej+UE;EAAuB,gBAAA;Afo+UzB;Aen+UE;EAA2B,gBAAA;Afs+U7B;Aer+UE;EAAyB,gBAAA;Afw+U3B;Aev+UE;EAA8B,gBAAA;Af0+UhC;Aez+UE;EAAwB,gBAAA;Af4+U1B;Ae3+UE;EAAsB,gBAAA;Af8+UxB;Ae7+UE;EAA8B,gBAAA;Afg/UhC;Ae/+UE;EAAuB,gBAAA;Afk/UzB;Aej/UE;EAA0B,gBAAA;Afo/U5B;Aen/UE;EAA0B,gBAAA;Afs/U5B;Aer/UE;EAA8B,gBAAA;Afw/UhC;Aev/UE;EAA6B,gBAAA;Af0/U/B;Aez/UE;EAA+B,gBAAA;Af4/UjC;Ae3/UE;EAAwB,gBAAA;Af8/U1B;Ae7/UE;EAAmB,gBAAA;AfggVrB;Ae//UE;EAAsB,gBAAA;AfkgVxB;AejgVE;EAAwB,gBAAA;AfogV1B;AengVE;EAAsB,gBAAA;AfsgVxB;AergVE;EAA4B,gBAAA;AfwgV9B;AevgVE;EAA6B,gBAAA;Af0gV/B;AezgVE;EAAwB,gBAAA;Af4gV1B;Ae3gVE;EAAuB,gBAAA;Af8gVzB;Ae7gVE;EAA4B,gBAAA;AfghV9B;Ae/gVE;EAA0B,gBAAA;AfkhV5B;AejhVE;EAA8B,gBAAA;AfohVhC;AenhVE;EAA0B,gBAAA;AfshV5B;AerhVE;EAAwB,gBAAA;AfwhV1B;AevhVE;EAAyB,gBAAA;Af0hV3B;AezhVE;EAA+B,gBAAA;Af4hVjC;Ae3hVE;EAAsB,gBAAA;Af8hVxB;Ae7hVE;EAAsB,gBAAA;AfgiVxB;Ae/hVE;EAA6B,gBAAA;AfkiV/B;AejiVE;EAAoB,gBAAA;AfoiVtB;AeniVE;EAAsB,gBAAA;AfsiVxB;AeriVE;EAAoB,gBAAA;AfwiVtB;AeviVE;EAA8B,gBAAA;Af0iVhC;AeziVE;EAA0B,gBAAA;Af4iV5B;Ae3iVE;EAAwB,gBAAA;Af8iV1B;Ae7iVE;EAA2B,gBAAA;AfgjV7B;Ae/iVE;EAAiC,gBAAA;AfkjVnC;AejjVE;EAA6B,gBAAA;AfojV/B;AenjVE;EAA6B,gBAAA;AfsjV/B;AerjVE;EAA2B,gBAAA;AfwjV7B;AevjVE;EAAwB,gBAAA;Af0jV1B;AezjVE;EAA2B,gBAAA;Af4jV7B;Ae3jVE;EAA6B,gBAAA;Af8jV/B;Ae7jVE;EAAsB,gBAAA;AfgkVxB;Ae/jVE;EAAgC,gBAAA;AfkkVlC;AejkVE;EAA4B,gBAAA;AfokV9B;AenkVE;EAA6B,gBAAA;AfskV/B;AerkVE;EAAuC,gBAAA;AfwkVzC;AevkVE;EAA6B,gBAAA;Af0kV/B;AezkVE;EAA4B,gBAAA;Af4kV9B;Ae3kVE;EAA2B,gBAAA;Af8kV7B;Ae7kVE;EAAsB,gBAAA;AfglVxB;Ae/kVE;EAA4B,gBAAA;AfklV9B;AejlVE;EAAiC,gBAAA;AfolVnC;AenlVE;EAAsB,gBAAA;AfslVxB;AerlVE;EAA8B,gBAAA;AfwlVhC;AevlVE;EAAgC,gBAAA;Af0lVlC;AezlVE;EAAqB,gBAAA;Af4lVvB;Ae3lVE;EAA4B,gBAAA;Af8lV9B;Ae7lVE;EAAqB,gBAAA;AfgmVvB;Ae/lVE;EAAqB,gBAAA;AfkmVvB;AejmVE;EAA4B,gBAAA;AfomV9B;AenmVE;EAA4B,gBAAA;AfsmV9B;AermVE;EAAwB,gBAAA;AfwmV1B;AevmVE;EAAqB,gBAAA;Af0mVvB;AezmVE;EAAgC,gBAAA;Af4mVlC;Ae3mVE;EAAoB,gBAAA;Af8mVtB;Ae7mVE;EAA0B,gBAAA;AfgnV5B;Ae/mVE;EAAqB,gBAAA;AfknVvB;AejnVE;EAAyB,gBAAA;AfonV3B;AennVE;EAA2B,gBAAA;AfsnV7B;AernVE;EAA0B,gBAAA;AfwnV5B;AevnVE;EAAqB,gBAAA;Af0nVvB;AeznVE;EAA8B,gBAAA;Af4nVhC;Ae3nVE;EAA6B,gBAAA;Af8nV/B;Ae7nVE;EAAoC,gBAAA;AfgoVtC;Ae/nVE;EAA8C,gBAAA;AfkoVhD;AejoVE;EAAsB,gBAAA;AfooVxB;AenoVE;EAA2B,gBAAA;AfsoV7B;AeroVE;EAAgC,gBAAA;AfwoVlC;AevoVE;EAA6B,gBAAA;Af0oV/B;AezoVE;EAAuB,gBAAA;Af4oVzB;Ae3oVE;EAAyB,gBAAA;Af8oV3B;Ae7oVE;EAAgC,gBAAA;AfgpVlC;Ae/oVE;EAA0B,gBAAA;AfkpV5B;AejpVE;EAA2B,gBAAA;AfopV7B;AenpVE;EAA4B,gBAAA;AfspV9B;AerpVE;EAAsB,gBAAA;AfwpVxB;AevpVE;EAA0B,gBAAA;Af0pV5B;AezpVE;EAAoC,gBAAA;Af4pVtC;Ae3pVE;EAAwB,gBAAA;Af8pV1B;Ae7pVE;EAAuB,gBAAA;AfgqVzB;Ae/pVE;EAAwB,gBAAA;AfkqV1B;AejqVE;EAAwB,gBAAA;AfoqV1B;AenqVE;EAAqB,gBAAA;AfsqVvB;AerqVE;EAA+B,gBAAA;AfwqVjC;AevqVE;EAA2B,gBAAA;Af0qV7B;AezqVE;EAA8B,gBAAA;Af4qVhC;Ae3qVE;EAAsB,gBAAA;Af8qVxB;Ae7qVE;EAA0B,gBAAA;AfgrV5B;Ae/qVE;EAA2B,gBAAA;AfkrV7B;AejrVE;EAAyB,gBAAA;AforV3B;AenrVE;EAAwB,gBAAA;AfsrV1B;AerrVE;EAAuB,gBAAA;AfwrVzB;AevrVE;EAAqB,gBAAA;Af0rVvB;AezrVE;EAAqB,gBAAA;Af4rVvB;Ae3rVE;EAAsB,gBAAA;Af8rVxB;Ae7rVE;EAAuB,gBAAA;AfgsVzB;Ae/rVE;EAAsB,gBAAA;AfksVxB;AejsVE;EAAoB,gBAAA;AfosVtB;AensVE;EAA2B,gBAAA;AfssV7B;AersVE;EAA2B,gBAAA;AfwsV7B;AevsVE;EAAsB,gBAAA;Af0sVxB;AezsVE;EAA+B,gBAAA;Af4sVjC;Ae3sVE;EAAiC,gBAAA;Af8sVnC;Ae7sVE;EAA+B,gBAAA;AfgtVjC;Ae/sVE;EAAwB,gBAAA;AfktV1B;AejtVE;EAA2B,gBAAA;AfotV7B;AentVE;EAAwB,gBAAA;AfstV1B;AertVE;EAAyB,gBAAA;AfwtV3B;AevtVE;EAA0B,gBAAA;Af0tV5B;AeztVE;EAA+B,gBAAA;Af4tVjC;Ae3tVE;EAAqB,gBAAA;Af8tVvB;Ae7tVE;EAAuB,gBAAA;AfguVzB;Ae/tVE;EAA4B,gBAAA;AfkuV9B;AejuVE;EAAuB,gBAAA;AfouVzB;AenuVE;EAAwB,gBAAA;AfsuV1B;AeruVE;EAAuB,gBAAA;AfwuVzB;AevuVE;EAA8B,gBAAA;Af0uVhC;AezuVE;EAAgC,gBAAA;Af4uVlC;Ae3uVE;EAA6B,gBAAA;Af8uV/B;Ae7uVE;EAA4B,gBAAA;AfgvV9B;Ae/uVE;EAAyB,gBAAA;AfkvV3B;AejvVE;EAAuB,gBAAA;AfovVzB;AenvVE;EAAuB,gBAAA;AfsvVzB;AervVE;EAAsB,gBAAA;AfwvVxB;AevvVE;EAAgC,gBAAA;Af0vVlC;AezvVE;EAAuC,gBAAA;Af4vVzC;Ae3vVE;EAA6B,gBAAA;Af8vV/B;Ae7vVE;EAA4B,gBAAA;AfgwV9B;Ae/vVE;EAAiC,gBAAA;AfkwVnC;AejwVE;EAAqB,gBAAA;AfowVvB;AenwVE;EAA8B,gBAAA;AfswVhC;AerwVE;EAA4B,gBAAA;AfwwV9B;AevwVE;EAA6B,gBAAA;Af0wV/B;AezwVE;EAAgC,gBAAA;Af4wVlC;Ae3wVE;EAA8B,gBAAA;Af8wVhC;Ae7wVE;EAAuB,gBAAA;AfgxVzB;Ae/wVE;EAA4B,gBAAA;AfkxV9B;AejxVE;EAAqB,gBAAA;AfoxVvB;AenxVE;EAAkC,gBAAA;AfsxVpC;AerxVE;EAA8B,gBAAA;AfwxVhC;AevxVE;EAAmC,gBAAA;Af0xVrC;AezxVE;EAAuB,gBAAA;Af4xVzB;Ae3xVE;EAA0B,gBAAA;Af8xV5B;Ae7xVE;EAAyB,gBAAA;AfgyV3B;Ae/xVE;EAAwB,gBAAA;AfkyV1B;AejyVE;EAAwB,gBAAA;AfoyV1B;AenyVE;EAAuB,gBAAA;AfsyVzB;AeryVE;EAA8B,gBAAA;AfwyVhC;AevyVE;EAAsB,gBAAA;Af0yVxB;AezyVE;EAAiC,gBAAA;Af4yVnC;Ae3yVE;EAAsB,gBAAA;Af8yVxB;Ae7yVE;EAAuB,gBAAA;AfgzVzB;Ae/yVE;EAAmC,gBAAA;AfkzVrC;AejzVE;EAAsB,gBAAA;AfozVxB;AenzVE;EAA2B,gBAAA;AfszV7B;AerzVE;EAA2B,gBAAA;AfwzV7B;AevzVE;EAAqB,gBAAA;Af0zVvB;AezzVE;EAAwB,gBAAA;Af4zV1B;Ae3zVE;EAA4B,gBAAA;Af8zV9B;Ae7zVE;EAAoB,gBAAA;Afg0VtB;Ae/zVE;EAA6B,gBAAA;Afk0V/B;Aej0VE;EAA0B,gBAAA;Afo0V5B;Aen0VE;EAAwB,gBAAA;Afs0V1B;Aer0VE;EAAyB,gBAAA;Afw0V3B;Aev0VE;EAAsB,gBAAA;Af00VxB;Aez0VE;EAA4B,gBAAA;Af40V9B;Ae30VE;EAAqB,gBAAA;Af80VvB;Ae70VE;EAAmC,gBAAA;Afg1VrC;Ae/0VE;EAA6C,gBAAA;Afk1V/C;Aej1VE;EAAiC,gBAAA;Afo1VnC;Aen1VE;EAA2C,gBAAA;Afs1V7C;Aer1VE;EAAiC,gBAAA;Afw1VnC;Aev1VE;EAA2C,gBAAA;Af01V7C;Aez1VE;EAA+B,gBAAA;Af41VjC;Ae31VE;EAAyC,gBAAA;Af81V3C;Ae71VE;EAA0B,gBAAA;Afg2V5B;Ae/1VE;EAAkC,gBAAA;Afk2VpC;Aej2VE;EAA4C,gBAAA;Afo2V9C;Aen2VE;EAAgC,gBAAA;Afs2VlC;Aer2VE;EAA0C,gBAAA;Afw2V5C;Aev2VE;EAAwB,gBAAA;Af02V1B;Aez2VE;EAAoB,gBAAA;Af42VtB;Ae32VE;EAA8B,gBAAA;Af82VhC;Ae72VE;EAA4B,gBAAA;Afg3V9B;Ae/2VE;EAAuB,gBAAA;Afk3VzB;Aej3VE;EAAwB,gBAAA;Afo3V1B;Aen3VE;EAAwB,gBAAA;Afs3V1B;Aer3VE;EAA0B,gBAAA;Afw3V5B;Aev3VE;EAAuB,gBAAA;Af03VzB;Aez3VE;EAA4B,gBAAA;Af43V9B;Ae33VE;EAAsC,gBAAA;Af83VxC;Ae73VE;EAAsB,gBAAA;Afg4VxB;Ae/3VE;EAAqB,gBAAA;Afk4VvB;Aej4VE;EAAkC,gBAAA;Afo4VpC;Aen4VE;EAA0B,gBAAA;Afs4V5B;Aer4VE;EAAoC,gBAAA;Afw4VtC;Aev4VE;EAA8B,gBAAA;Af04VhC;Aez4VE;EAA6B,gBAAA;Af44V/B;Ae34VE;EAA8B,gBAAA;Af84VhC;Ae74VE;EAA6B,gBAAA;Afg5V/B;Ae/4VE;EAA4B,gBAAA;Afk5V9B;Aej5VE;EAA4B,gBAAA;Afo5V9B;Aen5VE;EAAqB,gBAAA;Afs5VvB;Aer5VE;EAA4B,gBAAA;Afw5V9B;Aev5VE;EAA0B,gBAAA;Af05V5B;Aez5VE;EAAsB,gBAAA;Af45VxB;Ae35VE;EAAgC,gBAAA;Af85VlC;Ae75VE;EAAuB,gBAAA;Afg6VzB;Ae/5VE;EAA4B,gBAAA;Afk6V9B;Aej6VE;EAA8B,gBAAA;Afo6VhC;Aen6VE;EAA4B,gBAAA;Afs6V9B;Aer6VE;EAA0B,gBAAA;Afw6V5B;Aev6VE;EAAuB,gBAAA;Af06VzB;Aez6VE;EAAyB,gBAAA;Af46V3B;Ae36VE;EAAiC,gBAAA;Af86VnC;Ae76VE;EAAoB,gBAAA;Afg7VtB;Ae/6VE;EAA4B,gBAAA;Afk7V9B;Aej7VE;EAAyB,gBAAA;Afo7V3B;Aen7VE;EAA2B,gBAAA;Afs7V7B;Aer7VE;EAAwB,gBAAA;Afw7V1B;Aev7VE;EAA8B,gBAAA;Af07VhC;Aez7VE;EAA0B,gBAAA;Af47V5B;Ae37VE;EAAqB,gBAAA;Af87VvB;Ae77VE;EAA+B,gBAAA;Afg8VjC;Ae/7VE;EAAwB,gBAAA;Afk8V1B;Aej8VE;EAAsB,gBAAA;Afo8VxB;Aen8VE;EAA6B,gBAAA;Afs8V/B;Aer8VE;EAAuB,gBAAA;Afw8VzB;Aev8VE;EAAiC,gBAAA;Af08VnC;Aez8VE;EAAwB,gBAAA;Af48V1B;Ae38VE;EAAqC,gBAAA;Af88VvC;Ae78VE;EAAoB,gBAAA;Afg9VtB;Ae/8VE;EAAqB,gBAAA;Afk9VvB;Aej9VE;EAAqB,gBAAA;Afo9VvB;Aen9VE;EAAsB,gBAAA;Afs9VxB;Aer9VE;EAAqB,gBAAA;Afw9VvB;Aev9VE;EAAsB,gBAAA;Af09VxB;Aez9VE;EAA2B,gBAAA;Af49V7B;Ae39VE;EAAiC,gBAAA;Af89VnC;Ae79VE;EAAgC,gBAAA;Afg+VlC;Ae/9VE;EAAsB,gBAAA;Afk+VxB;Aej+VE;EAAyB,gBAAA;Afo+V3B;Aen+VE;EAA4B,gBAAA;Afs+V9B;Aer+VE;EAA2B,gBAAA;Afw+V7B;Aev+VE;EAAmB,gBAAA;Af0+VrB;Aez+VE;EAAyB,gBAAA;Af4+V3B;Ae3+VE;EAAwB,gBAAA;Af8+V1B;Ae7+VE;EAA8B,gBAAA;Afg/VhC;Ae/+VE;EAA4B,gBAAA;Afk/V9B;Aej/VE;EAAkC,gBAAA;Afo/VpC;Aen/VE;EAAiC,gBAAA;Afs/VnC;Aer/VE;EAAiC,gBAAA;Afw/VnC;Aev/VE;EAAoC,gBAAA;Af0/VtC;Aez/VE;EAA2C,gBAAA;Af4/V7C;Ae3/VE;EAA4B,gBAAA;Af8/V9B;Ae7/VE;EAA0B,gBAAA;AfggW5B;Ae//VE;EAA0B,gBAAA;AfkgW5B;AejgWE;EAAiC,gBAAA;AfogWnC;AengWE;EAAsB,gBAAA;AfsgWxB;AergWE;EAA6B,gBAAA;AfwgW/B;AevgWE;EAAqB,gBAAA;Af0gWvB;AezgWE;EAA2B,gBAAA;Af4gW7B;Ae3gWE;EAAsB,gBAAA;Af8gWxB;Ae7gWE;EAA2B,gBAAA;AfghW7B;Ae/gWE;EAA0B,gBAAA;AfkhW5B;AejhWE;EAAuB,gBAAA;AfohWzB;AenhWE;EAA6B,gBAAA;AfshW/B;AerhWE;EAAwB,gBAAA;AfwhW1B;AevhWE;EAAsB,gBAAA;Af0hWxB;AezhWE;EAAsB,gBAAA;Af4hWxB;Ae3hWE;EAAsB,gBAAA;Af8hWxB;Ae7hWE;EAA2B,gBAAA;AfgiW7B;Ae/hWE;EAAwB,gBAAA;AfkiW1B;AejiWE;EAA0B,gBAAA;AfoiW5B;AeniWE;EAA8B,gBAAA;AfsiWhC;AeriWE;EAAsB,gBAAA;AfwiWxB;AeviWE;EAAqB,gBAAA;Af0iWvB;AeziWE;EAA4B,gBAAA;Af4iW9B;Ae3iWE;EAAsC,gBAAA;Af8iWxC;Ae7iWE;EAAsB,gBAAA;AfgjWxB;Ae/iWE;EAAgC,gBAAA;AfkjWlC;AejjWE;EAA8B,gBAAA;AfojWhC;AenjWE;EAAwC,gBAAA;AfsjW1C;AerjWE;EAAqB,gBAAA;AfwjWvB;AevjWE;EAAuB,gBAAA;Af0jWzB;AezjWE;EAAsB,gBAAA;Af4jWxB;Ae3jWE;EAA8B,gBAAA;Af8jWhC;Ae7jWE;EAA6B,gBAAA;AfgkW/B;Ae/jWE;EAA8B,gBAAA;AfkkWhC;AejkWE;EAA6B,gBAAA;AfokW/B;AenkWE;EAAuB,gBAAA;AfskWzB;AerkWE;EAAoB,gBAAA;AfwkWtB;AevkWE;EAAmB,gBAAA;Af0kWrB;AezkWE;EAAyB,gBAAA;Af4kW3B;Ae3kWE;EAA+B,gBAAA;Af8kWjC;Ae7kWE;EAA0B,gBAAA;AfglW5B;Ae/kWE;EAAqB,gBAAA;AfklWvB;AejlWE;EAA+B,gBAAA;AfolWjC;AenlWE;EAAiC,gBAAA;AfslWnC;AerlWE;EAA2B,gBAAA;AfwlW7B;AevlWE;EAAuB,gBAAA;Af0lWzB;AezlWE;EAAuB,gBAAA;Af4lWzB;Ae3lWE;EAAiC,gBAAA;Af8lWnC;Ae7lWE;EAAuB,gBAAA;AfgmWzB;Ae/lWE;EAAqB,gBAAA;AfkmWvB;AejmWE;EAA+B,gBAAA;AfomWjC;AenmWE;EAAqC,gBAAA;AfsmWvC;AermWE;EAA+B,gBAAA;AfwmWjC;AevmWE;EAA2B,gBAAA;Af0mW7B;AezmWE;EAA4B,gBAAA;Af4mW9B;Ae3mWE;EAA2B,gBAAA;Af8mW7B;Ae7mWE;EAAyB,gBAAA;AfgnW3B;Ae/mWE;EAA0B,gBAAA;AfknW5B;AejnWE;EAA6B,gBAAA;AfonW/B;AennWE;EAA8B,gBAAA;AfsnWhC;AernWE;EAA6B,gBAAA;AfwnW/B;AevnWE;EAA0B,gBAAA;Af0nW5B;AeznWE;EAAwB,gBAAA;Af4nW1B;Ae3nWE;EAA2B,gBAAA;Af8nW7B;Ae7nWE;EAA2B,gBAAA;AfgoW7B;Ae/nWE;EAA2B,gBAAA;AfkoW7B;AejoWE;EAA0B,gBAAA;AfooW5B;AenoWE;EAA4B,gBAAA;AfsoW9B;AeroWE;EAA4B,gBAAA;AfwoW9B;AevoWE;EAA2B,gBAAA;Af0oW7B;AezoWE;EAAyB,gBAAA;Af4oW3B;Ae3oWE;EAAyB,gBAAA;Af8oW3B;Ae7oWE;EAA2B,gBAAA;AfgpW7B;Ae/oWE;EAAsB,gBAAA;AfkpWxB;AejpWE;EAA0B,gBAAA;AfopW5B;AenpWE;EAA8B,gBAAA;AfspWhC;AerpWE;EAAyB,gBAAA;AfwpW3B;AevpWE;EAA8B,gBAAA;Af0pWhC;AezpWE;EAAsB,gBAAA;Af4pWxB;Ae3pWE;EAA6B,gBAAA;Af8pW/B;Ae7pWE;EAA2B,gBAAA;AfgqW7B;Ae/pWE;EAAqB,gBAAA;AfkqWvB;AejqWE;EAAsB,gBAAA;AfoqWxB;AenqWE;EAAsB,gBAAA;AfsqWxB;AerqWE;EAA4B,gBAAA;AfwqW9B;AevqWE;EAAuB,gBAAA;Af0qWzB;AezqWE;EAA0B,gBAAA;Af4qW5B;Ae3qWE;EAAgC,gBAAA;Af8qWlC;Ae7qWE;EAA4B,gBAAA;AfgrW9B;Ae/qWE;EAA4B,gBAAA;AfkrW9B;AejrWE;EAA2B,gBAAA;AforW7B;AenrWE;EAA0B,gBAAA;AfsrW5B;AerrWE;EAAyB,gBAAA;AfwrW3B;AevrWE;EAA6B,gBAAA;Af0rW/B;AezrWE;EAAwB,gBAAA;Af4rW1B;Ae3rWE;EAAuB,gBAAA;Af8rWzB;Ae7rWE;EAA0B,gBAAA;AfgsW5B;Ae/rWE;EAAsB,gBAAA;AfksWxB;AejsWE;EAA4B,gBAAA;AfosW9B;AensWE;EAAuB,gBAAA;AfssWzB;AersWE;EAA+B,gBAAA;AfwsWjC;AevsWE;EAA2B,gBAAA;Af0sW7B;AezsWE;EAAqB,gBAAA;Af4sWvB;Ae3sWE;EAAqB,gBAAA;Af8sWvB;Ae7sWE;EAA6B,gBAAA;AfgtW/B;Ae/sWE;EAAgC,gBAAA;AfktWlC;AejtWE;EAAgC,gBAAA;AfotWlC;AentWE;EAA+B,gBAAA;AfstWjC;AertWE;EAA4B,gBAAA;AfwtW9B;AevtWE;EAA2B,gBAAA;Af0tW7B;AeztWE;EAAqC,gBAAA;Af4tWvC;Ae3tWE;EAAyB,gBAAA;Af8tW3B;Ae7tWE;EAAuB,gBAAA;AfguWzB;Ae/tWE;EAAsB,gBAAA;AfkuWxB;AejuWE;EAAyB,gBAAA;AfouW3B;AenuWE;EAAyB,gBAAA;AfsuW3B;AenuWE;EAAoB,gBAAA;AfsuWtB;AeruWE;EAA2B,gBAAA;AfwuW7B;AevuWE;EAA2B,gBAAA;Af0uW7B;AezuWE;EAAgC,gBAAA;Af4uWlC;Ae3uWE;EAA4B,gBAAA;Af8uW9B;Ae7uWE;EAAyB,gBAAA;AfgvW3B;Ae/uWE;EAAsB,gBAAA;AfkvWxB;AejvWE;EAA2B,gBAAA;AfovW7B;AenvWE;EAAoB,gBAAA;AfsvWtB;AervWE;EAAoB,gBAAA;AfwvWtB;AevvWE;EAA6B,gBAAA;Af0vW/B;AezvWE;EAA2B,gBAAA;Af4vW7B;Ae3vWE;EAA2B,gBAAA;Af8vW7B;Ae7vWE;EAAgC,gBAAA;AfgwWlC;Ae/vWE;EAAwB,gBAAA;AfkwW1B;AejwWE;EAAoB,gBAAA;AfowWtB;AenwWE;EAAiC,gBAAA;AfswWnC;AerwWE;EAA4C,gBAAA;AfwwW9C;AevwWE;EAAuB,gBAAA;Af0wWzB;AezwWE;EAA0B,gBAAA;Af4wW5B;Ae3wWE;EAAwB,gBAAA;Af8wW1B;Ae7wWE;EAAoB,gBAAA;AfgxWtB;Ae/wWE;EAAwB,gBAAA;AfkxW1B;AejxWE;EAA6B,gBAAA;AfoxW/B;AenxWE;EAA6B,gBAAA;AfsxW/B;AerxWE;EAA4B,gBAAA;AfwxW9B;AevxWE;EAA+B,gBAAA;Af0xWjC;AezxWE;EAA4B,gBAAA;Af4xW9B;Ae3xWE;EAA8B,gBAAA;Af8xWhC;Ae7xWE;EAA4B,gBAAA;AfgyW9B;Ae/xWE;EAA6B,gBAAA;AfkyW/B;AejyWE;EAAyB,gBAAA;AfoyW3B;AenyWE;EAA6B,gBAAA;AfsyW/B;AeryWE;EAA6B,gBAAA;AfwyW/B;AevyWE;EAAwB,gBAAA;Af0yW1B;AezyWE;EAAqB,gBAAA;Af4yWvB;Ae3yWE;EAA4B,gBAAA;Af8yW9B;Ae7yWE;EAAuB,gBAAA;AfgzWzB;Ae/yWE;EAAqB,gBAAA;AfkzWvB;AejzWE;EAAmB,gBAAA;AfozWrB;AenzWE;EAAsB,gBAAA;AfszWxB;AerzWE;EAAqB,gBAAA;AfwzWvB;AevzWE;EAAiC,gBAAA;Af0zWnC;AezzWE;EAA0B,gBAAA;Af4zW5B;Ae3zWE;EAA8B,gBAAA;Af8zWhC;Ae7zWE;EAA2B,gBAAA;Afg0W7B;Ae/zWE;EAA+B,gBAAA;Afk0WjC;Aej0WE;EAA4B,gBAAA;Afo0W9B;Aen0WE;EAAsB,gBAAA;Afs0WxB;Aer0WE;EAA+B,gBAAA;Afw0WjC;Aev0WE;EAA6B,gBAAA;Af00W/B;Aez0WE;EAAoB,gBAAA;Af40WtB;Ae30WE;EAAyB,gBAAA;Af80W3B;Ae70WE;EAA2B,gBAAA;Afg1W7B;Ae/0WE;EAAwB,gBAAA;Afk1W1B;Aej1WE;EAAyB,gBAAA;Afo1W3B;Aen1WE;EAA0B,gBAAA;Afs1W5B;Aer1WE;EAAwB,gBAAA;Afw1W1B;Aev1WE;EAA6B,gBAAA;Af01W/B;Aez1WE;EAAwC,gBAAA;Af41W1C;Ae31WE;EAAyB,gBAAA;Af81W3B;Ae71WE;EAA0B,gBAAA;Afg2W5B;Ae/1WE;EAAyB,gBAAA;Afk2W3B;Aej2WE;EAAuB,gBAAA;Afo2WzB;Aen2WE;EAAgC,gBAAA;Afs2WlC;Aer2WE;EAA0B,gBAAA;Afw2W5B;Aev2WE;EAAwB,gBAAA;Af02W1B;Aez2WE;EAA4B,gBAAA;Af42W9B;Ae32WE;EAAqB,gBAAA;Af82WvB;Ae72WE;EAAuB,gBAAA;Afg3WzB;Ae/2WE;EAAuB,gBAAA;Afk3WzB;Aej3WE;EAAqB,gBAAA;Afo3WvB;Aen3WE;EAAgC,gBAAA;Afs3WlC;Aer3WE;EAAyB,gBAAA;Afw3W3B;Aev3WE;EAA0B,gBAAA;Af03W5B;Aez3WE;EAAsB,gBAAA;Af43WxB;Ae33WE;EAAoB,gBAAA;Af83WtB;Ae73WE;EAAqB,gBAAA;Afg4WvB;Ae/3WE;EAAyB,gBAAA;Afk4W3B;Aej4WE;EAAyB,gBAAA;Afo4W3B;Aen4WE;EAA+B,gBAAA;Afs4WjC;Aer4WE;EAAgC,gBAAA;Afw4WlC;Aev4WE;EAA2B,gBAAA;Af04W7B;Aez4WE;EAAwB,gBAAA;Af44W1B;Ae34WE;EAAyB,gBAAA;Af84W3B;Ae74WE;EAAqB,gBAAA;Afg5WvB;Ae/4WE;EAAkC,gBAAA;Afk5WpC;Aej5WE;EAA0B,gBAAA;Afo5W5B;Aen5WE;EAAqB,gBAAA;Afs5WvB;Aer5WE;EAA0B,gBAAA;Afw5W5B;Aev5WE;EAAqB,gBAAA;Af05WvB;Aez5WE;EAAqB,gBAAA;Af45WvB;Ae35WE;EAAqB,gBAAA;Af85WvB;Ae75WE;EAAoB,gBAAA;Afg6WtB;Ae/5WE;EAAoB,gBAAA;Afk6WtB;Aej6WE;EAAqB,gBAAA;Afo6WvB;Aen6WE;EAA2B,gBAAA;Afs6W7B;Aer6WE;EAA4B,gBAAA;Afw6W9B;Aev6WE;EAAsB,gBAAA;Af06WxB;Aez6WE;EAAkB,gBAAA;Af46WpB;Ae36WE;EAA0B,gBAAA;Af86W5B;Ae76WE;EAA6B,gBAAA;Afg7W/B;Ae/6WE;EAAyB,gBAAA;Afk7W3B;Aej7WE;EAAgC,gBAAA;Afo7WlC;Aen7WE;EAAuB,gBAAA;Afs7WzB;Aer7WE;EAA4B,gBAAA;Afw7W9B;Aev7WE;EAAqB,gBAAA;Af07WvB;Aez7WE;EAA4B,gBAAA;Af47W9B;Ae37WE;EAA6B,gBAAA;Af87W/B;Ae77WE;EAAqB,gBAAA;Afg8WvB;Ae/7WE;EAAsB,gBAAA;Afk8WxB;Aej8WE;EAA+B,gBAAA;Afo8WjC;Aen8WE;EAA+B,gBAAA;Afs8WjC;Aer8WE;EAA8B,gBAAA;Afw8WhC;Aev8WE;EAAgC,gBAAA;Af08WlC;Aez8WE;EAA8B,gBAAA;Af48WhC;Ae38WE;EAA+B,gBAAA;Af88WjC;Ae78WE;EAAqB,gBAAA;Afg9WvB;Ae/8WE;EAAoB,gBAAA;Afk9WtB;Aej9WE;EAAwB,gBAAA;Afo9W1B;Aen9WE;EAAoB,gBAAA;Afs9WtB;Aer9WE;EAA4B,gBAAA;Afw9W9B;Aev9WE;EAAyB,gBAAA;Af09W3B;Aez9WE;EAAoB,gBAAA;Af49WtB;Ae39WE;EAAoB,gBAAA;Af89WtB;Ae79WE;EAAoB,gBAAA;Afg+WtB;Ae/9WE;EAAoB,gBAAA;Afk+WtB;Aej+WE;EAAsB,gBAAA;Afo+WxB;Aen+WE;EAAwB,gBAAA;Afs+W1B;Aer+WE;EAA2B,gBAAA;Afw+W7B;Aev+WE;EAAyB,gBAAA;Af0+W3B;Aez+WE;EAA0B,gBAAA;Af4+W5B;Ae3+WE;EAAqB,gBAAA;Af8+WvB;Ae7+WE;EAA2B,gBAAA;Afg/W7B;Ae/+WE;EAAwB,gBAAA;Afk/W1B;Aej/WE;EAAqB,gBAAA;Afo/WvB;Aen/WE;EAA4B,gBAAA;Afs/W9B;Aer/WE;EAAwB,gBAAA;Afw/W1B;Aev/WE;EAAwB,gBAAA;Af0/W1B;Aez/WE;EAAqB,gBAAA;Af4/WvB;Ae3/WE;EAA6B,gBAAA;Af8/W/B;Ae7/WE;EAA4B,gBAAA;AfggX9B;Ae//WE;EAAgC,gBAAA;AfkgXlC;AejgXE;EAAoB,gBAAA;AfogXtB;AengXE;EAAuB,gBAAA;AfsgXzB;AergXE;EAA+B,gBAAA;AfwgXjC;AevgXE;EAAgC,gBAAA;Af0gXlC;AezgXE;EAA8B,gBAAA;Af4gXhC;Ae3gXE;EAAyB,gBAAA;Af8gX3B;Ae7gXE;EAAyB,gBAAA;AfghX3B;Ae/gXE;EAAsB,gBAAA;AfkhXxB;AejhXE;EAAqB,gBAAA;AfohXvB;AenhXE;EAAqB,gBAAA;AfshXvB;AerhXE;EAAuC,gBAAA;AfwhXzC;AevhXE;EAA8B,gBAAA;Af0hXhC;AezhXE;EAAwB,gBAAA;Af4hX1B;Ae3hXE;EAA6B,gBAAA;Af8hX/B;Ae7hXE;EAA6B,gBAAA;AfgiX/B;Ae/hXE;EAAwC,gBAAA;AfkiX1C;AejiXE;EAAsC,gBAAA;AfoiXxC;AeniXE;EAAwB,gBAAA;AfsiX1B;AeriXE;EAAuB,gBAAA;AfwiXzB;AeviXE;EAA8B,gBAAA;Af0iXhC;AeziXE;EAAsB,gBAAA;Af4iXxB;Ae3iXE;EAAwB,gBAAA;Af8iX1B;Ae7iXE;EAA0B,gBAAA;AfgjX5B;Ae/iXE;EAA0B,gBAAA;AfkjX5B;AejjXE;EAAoB,gBAAA;AfojXtB;AenjXE;EAA0B,gBAAA;AfsjX5B;AerjXE;EAAsB,gBAAA;AfwjXxB;AevjXE;EAA8B,gBAAA;Af0jXhC;AezjXE;EAA8B,gBAAA;Af4jXhC;Ae3jXE;EAA+B,gBAAA;Af8jXjC;Ae7jXE;EAA4B,gBAAA;AfgkX9B;Ae/jXE;EAAsB,gBAAA;AfkkXxB;AejkXE;EAAsB,gBAAA;AfokXxB;AenkXE;EAA2B,gBAAA;AfskX7B;AerkXE;EAAwB,gBAAA;AfwkX1B;AevkXE;EAAwB,gBAAA;Af0kX1B;AezkXE;EAAuB,gBAAA;Af4kXzB;Ae3kXE;EAAyB,gBAAA;Af8kX3B;Ae7kXE;EAAsB,gBAAA;AfglXxB;Ae/kXE;EAAqB,gBAAA;AfklXvB;AejlXE;EAAuB,gBAAA;AfolXzB;AenlXE;EAAwB,gBAAA;AfslX1B;AerlXE;EAAuB,gBAAA;AfwlXzB;AevlXE;EAAgC,gBAAA;Af0lXlC;AezlXE;EAA8B,gBAAA;Af4lXhC;Ae3lXE;EAAqC,gBAAA;Af8lXvC;Ae7lXE;EAA4B,gBAAA;AfgmX9B;Ae/lXE;EAAuB,gBAAA;AfkmXzB;AejmXE;EAAkC,gBAAA;AfomXpC;AenmXE;EAAgC,gBAAA;AfsmXlC;AermXE;EAAoB,gBAAA;AfwmXtB;AevmXE;EAAuB,gBAAA;Af0mXzB;AezmXE;EAAoB,gBAAA;Af4mXtB;Ae3mXE;EAAsB,gBAAA;Af8mXxB;Ae7mXE;EAAsB,gBAAA;AfgnXxB;Ae/mXE;EAAoB,gBAAA;AfknXtB;AejnXE;EAA+B,gBAAA;AfonXjC;AennXE;EAAqB,gBAAA;AfsnXvB;AernXE;EAAwB,gBAAA;AfwnX1B;AevnXE;EAAyB,gBAAA;Af0nX3B;AeznXE;EAAuB,gBAAA;Af4nXzB;Ae3nXE;EAAuB,gBAAA;Af8nXzB;Ae7nXE;EAAuB,gBAAA;AfgoXzB;Ae/nXE;EAAyB,gBAAA;AfkoX3B;AejoXE;EAAqB,gBAAA;AfooXvB;AenoXE;EAAwB,gBAAA;AfsoX1B;AeroXE;EAAyB,gBAAA;AfwoX3B;AevoXE;EAAwB,gBAAA;Af0oX1B;AezoXE;EAAwB,gBAAA;Af4oX1B;Ae3oXE;EAAyB,gBAAA;Af8oX3B;Ae7oXE;EAAwB,gBAAA;AfgpX1B;Ae/oXE;EAAuB,gBAAA;AfkpXzB;AejpXE;EAAwB,gBAAA;AfopX1B;AenpXE;EAAuB,gBAAA;AfspXzB;AerpXE;EAAwC,gBAAA;AfwpX1C;AevpXE;EAAyC,gBAAA;Af0pX3C;AezpXE;EAA+B,gBAAA;Af4pXjC;Ae3pXE;EAAuC,gBAAA;Af8pXzC;Ae7pXE;EAAwC,gBAAA;AfgqX1C;Ae/pXE;EAAgC,gBAAA;AfkqXlC;AejqXE;EAAuC,gBAAA;AfoqXzC;AenqXE;EAAwC,gBAAA;AfsqX1C;AerqXE;EAAsB,gBAAA;AfwqXxB;AevqXE;EAAsB,gBAAA;Af0qXxB;AezqXE;EAAoB,gBAAA;Af4qXtB;Ae3qXE;EAA2B,gBAAA;Af8qX7B;Ae7qXE;EAAgC,gBAAA;AfgrXlC;Ae/qXE;EAA+B,gBAAA;AfkrXjC;AejrXE;EAAwB,gBAAA;AforX1B;AenrXE;EAAqB,gBAAA;AfsrXvB;AerrXE;EAAuB,gBAAA;AfwrXzB;AevrXE;EAAyB,gBAAA;Af0rX3B;AezrXE;EAA2B,gBAAA;Af4rX7B;Ae3rXE;EAA4B,gBAAA;Af8rX9B;Ae7rXE;EAA+B,gBAAA;AfgsXjC;Ae/rXE;EAAsB,gBAAA;AfksXxB;AejsXE;EAA4B,gBAAA;AfosX9B;AensXE;EAA2B,gBAAA;AfssX7B;AersXE;EAAuB,gBAAA;AfwsXzB;AevsXE;EAAqB,gBAAA;Af0sXvB;AezsXE;EAAgC,gBAAA;Af4sXlC;Ae3sXE;EAAmB,gBAAA;Af8sXrB;Ae7sXE;EAA4B,gBAAA;AfgtX9B;Ae/sXE;EAA4B,gBAAA;AfktX9B;AejtXE;EAA6B,gBAAA;AfotX/B;AentXE;EAA0B,gBAAA;AfstX5B;AertXE;EAA0B,gBAAA;AfwtX5B;AevtXE;EAAuB,gBAAA;Af0tXzB;AeztXE;EAA0B,gBAAA;Af4tX5B;Ae3tXE;EAA8B,gBAAA;Af8tXhC;Ae7tXE;EAA8B,gBAAA;AfguXhC;Ae/tXE;EAA+B,gBAAA;AfkuXjC;AejuXE;EAA4B,gBAAA;AfouX9B;AenuXE;EAAoB,gBAAA;AfsuXtB;AeruXE;EAAuB,gBAAA;AfwuXzB;AevuXE;EAA0B,gBAAA;Af0uX5B;AezuXE;EAAuB,gBAAA;Af4uXzB;Ae3uXE;EAA+B,gBAAA;Af8uXjC;Ae7uXE;EAAoB,gBAAA;AfgvXtB;Ae/uXE;EAA4B,gBAAA;AfkvX9B;AejvXE;EAA2B,gBAAA;AfovX7B;AenvXE;EAA4B,gBAAA;AfsvX9B;AervXE;EAA4B,gBAAA;AfwvX9B;AevvXE;EAAuB,gBAAA;Af0vXzB;AezvXE;EAAsB,gBAAA;Af4vXxB;Ae3vXE;EAA6B,gBAAA;Af8vX/B;Ae7vXE;EAA2B,gBAAA;AfgwX7B;Ae/vXE;EAAqC,gBAAA;AfkwXvC;AejwXE;EAAqB,gBAAA;AfowXvB;AenwXE;EAAwB,gBAAA;AfswX1B;AerwXE;EAA+B,gBAAA;AfwwXjC;AevwXE;EAA6B,gBAAA;Af0wX/B;AezwXE;EAAsB,gBAAA;Af4wXxB;Ae3wXE;EAAuB,gBAAA;Af8wXzB;Ae7wXE;EAAuB,gBAAA;AfgxXzB;Ae/wXE;EAAsB,gBAAA;AfkxXxB;AejxXE;EAAoB,gBAAA;AfoxXtB;AenxXE;EAAsB,gBAAA;AfsxXxB;AerxXE;EAAsB,gBAAA;AfwxXxB;AevxXE;EAA6B,gBAAA;Af0xX/B;AezxXE;EAAkB,gBAAA;Af4xXpB;Ae3xXE;EAAoB,gBAAA;Af8xXtB;Ae7xXE;EAAoB,gBAAA;AfgyXtB;Ae/xXE;EAAqB,gBAAA;AfkyXvB;AejyXE;EAAwB,gBAAA;AfoyX1B;AenyXE;EAAyB,gBAAA;AfsyX3B;Ae7xXI;EACE,4BiFxwCmB;EjFywCnB,4CiFjwCsB;EjFkwCtB,gTiFxwCJ;EjFywCI,kBAAA;EACA,mB+ChxCG;E/CixCH,oBAAA;EACA,wBAAA;EACA,oBAAA;Af+xXN;Ae5xXI;EACE,4BiFnxCmB;AhGijazB;Ae1xXI;EAAqC,gBAAA;Af6xXzC;Ae5xXI;EAAqC,gBAAA;Af+xXzC;Ae9xXI;EAA8B,gBAAA;AfiyXlC;AehyXI;EAAoD,gBAAA;AfmyXxD;AelyXI;EAAoD,gBAAA;AfqyXxD;AepyXI;EAAqD,gBAAA;AfuyXzD;AetyXI;EAAkD,gBAAA;AfyyXtD;AexyXI;EAA6B,gBAAA;Af2yXjC;Ae1yXI;EAAmC,gBAAA;Af6yXvC;Ae5yXI;EAAiC,gBAAA;Af+yXrC;Ae9yXI;EAAiC,gBAAA;AfizXrC;AehzXI;EAA2C,gBAAA;AfmzX/C;AelzXI;EAAuC,gBAAA;AfqzX3C;AepzXI;EAAuC,gBAAA;AfuzX3C;AetzXI;EAAiC,gBAAA;AfyzXrC;AexzXI;EAAsC,gBAAA;Af2zX1C;Ae1zXI;EAAuC,gBAAA;Af6zX3C;Ae5zXI;EAA0C,gBAAA;Af+zX9C;Ae9zXI;EAA0C,gBAAA;Afi0X9C;Aeh0XI;EAA2C,gBAAA;Afm0X/C;Ael0XI;EAAwC,gBAAA;Afq0X5C;Aep0XI;EAAkC,gBAAA;Afu0XtC;Aet0XI;EAAqC,gBAAA;Afy0XzC;Aex0XI;EAAqC,gBAAA;Af20XzC;Ae10XI;EAA+B,gBAAA;Af60XnC;Ae50XI;EAAkC,gBAAA;Af+0XtC;Ae90XI;EAA8B,gBAAA;Afi1XlC;Aeh1XI;EAA8B,gBAAA;Afm1XlC;Ael1XI;EAA0C,gBAAA;Afq1X9C;Aep1XI;EAA0C,gBAAA;Afu1X9C;Aet1XI;EAAqC,gBAAA;Afy1XzC;Aex1XI;EAAgC,gBAAA;Af21XpC;Ae11XI;EAAiC,gBAAA;Af61XrC;Ae51XI;EAAgC,gBAAA;Af+1XpC;Ae91XI;EAA6B,gBAAA;Afi2XjC;Aeh2XI;EAAkC,gBAAA;Afm2XtC;Ael2XI;EAAoC,gBAAA;Afq2XxC;Aep2XI;EAA8B,gBAAA;Afu2XlC;Aet2XI;EAAmC,gBAAA;Afy2XvC;Aex2XI;EAA6B,gBAAA;Af22XjC;Ae12XI;EAAsC,gBAAA;Af62X1C;Ae52XI;EAAiC,gBAAA;Af+2XrC;Ae92XI;EAA4B,gBAAA;Afi3XhC;Aeh3XI;EAAkC,gBAAA;Afm3XtC;Ael3XI;EAAuC,gBAAA;Afq3X3C;Aep3XI;EAAqC,gBAAA;Afu3XzC;Aet3XI;EAAmC,gBAAA;Afy3XvC;Aex3XI;EAAkC,gBAAA;Af23XtC;Ae13XI;EAAmC,gBAAA;Af63XvC;Ae53XI;EAAmC,gBAAA;Af+3XvC;Ae93XI;EAA6B,gBAAA;Afi4XjC;Aeh4XI;EAAiC,gBAAA;Afm4XrC;Ael4XI;EAAwC,gBAAA;Afq4X5C;Aep4XI;EAAmC,gBAAA;Afu4XvC;Aet4XI;EAAkC,gBAAA;Afy4XtC;Aex4XI;EAA6B,gBAAA;Af24XjC;Ae14XI;EAAgC,gBAAA;Af64XpC;Ae54XI;EAAoC,gBAAA;Af+4XxC;Ae94XI;EAA+B,gBAAA;Afi5XnC;Aeh5XI;EAAmC,gBAAA;Afm5XvC;Ael5XI;EAA8B,gBAAA;Afq5XlC;Aep5XI;EAA+B,gBAAA;Afu5XnC;Aet5XI;EAA4B,gBAAA;Afy5XhC;Aex5XI;EAAgC,gBAAA;Af25XpC;Ae15XI;EAAuC,gBAAA;Af65X3C;Ae55XI;EAAkC,gBAAA;Af+5XtC;Ae95XI;EAAwC,gBAAA;Afi6X5C;Aeh6XI;EAAoC,gBAAA;Afm6XxC;Ael6XI;EAA6B,gBAAA;Afq6XjC;Aep6XI;EAAoC,gBAAA;Afu6XxC;Aet6XI;EAA0C,gBAAA;Afy6X9C;Aex6XI;EAAmC,gBAAA;Af26XvC;Ae16XI;EAAmC,gBAAA;Af66XvC;Ae56XI;EAAoC,gBAAA;Af+6XxC;Ae96XI;EAA2C,gBAAA;Afi7X/C;Aeh7XI;EAAyC,gBAAA;Afm7X7C;Ael7XI;EAAkC,gBAAA;Afq7XtC;Aep7XI;EAAoC,gBAAA;Afu7XxC;Aet7XI;EAAmC,gBAAA;Afy7XvC;Aex7XI;EAAmC,gBAAA;Af27XvC;Ae17XI;EAAwC,gBAAA;Af67X5C;Ae57XI;EAAwC,gBAAA;Af+7X5C;Ae97XI;EAAyC,gBAAA;Afi8X7C;Aeh8XI;EAAsC,gBAAA;Afm8X1C;Ael8XI;EAAqC,gBAAA;Afq8XzC;Aep8XI;EAAkC,gBAAA;Afu8XtC;Aet8XI;EAAsC,gBAAA;Afy8X1C;Aex8XI;EAAmC,gBAAA;Af28XvC;Ae18XI;EAAkC,gBAAA;Af68XtC;Ae58XI;EAA4B,gBAAA;Af+8XhC;Ae98XI;EAA8B,gBAAA;Afi9XlC;Aeh9XI;EAAiC,gBAAA;Afm9XrC;Ael9XI;EAAkC,gBAAA;Afq9XtC;Aep9XI;EAAiC,gBAAA;Afu9XrC;Aet9XI;EAAgC,gBAAA;Afy9XpC;Aex9XI;EAA8B,gBAAA;Af29XlC;Ae19XI;EAA+B,gBAAA;Af69XnC;Ae59XI;EAAiC,gBAAA;Af+9XrC;Ae99XI;EAAkC,gBAAA;Afi+XtC;Aeh+XI;EAA6B,gBAAA;Afm+XjC;Ael+XI;EAAwC,gBAAA;Afq+X5C;Aep+XI;EAAmC,gBAAA;Afu+XvC;Aet+XI;EAA8B,gBAAA;Afy+XlC;Aex+XI;EAAqC,gBAAA;Af2+XzC;Ae1+XI;EAAmC,gBAAA;Af6+XvC;Ae5+XI;EAA8B,gBAAA;Af++XlC;Ae9+XI;EAAkC,gBAAA;Afi/XtC;Aeh/XI;EAAkC,gBAAA;Afm/XtC;Ael/XI;EAAuC,gBAAA;Afq/X3C;Aep/XI;EAA4B,gBAAA;Afu/XhC;Aet/XI;EAAkC,gBAAA;Afy/XtC;Aex/XI;EAA4B,gBAAA;Af2/XhC;Ae1/XI;EAAyC,gBAAA;Af6/X7C;Ae5/XI;EAAqC,gBAAA;Af+/XzC;Ae9/XI;EAA6C,gBAAA;AfigYjD;AehgYI;EAA6B,gBAAA;AfmgYjC;AelgYI;EAAkC,gBAAA;AfqgYtC;AepgYI;EAAqC,gBAAA;AfugYzC;AetgYI;EAAuC,gBAAA;AfygY3C;AexgYI;EAAoC,gBAAA;Af2gYxC;Ae1gYI;EAAqC,gBAAA;Af6gYzC;Ae5gYI;EAAoC,gBAAA;Af+gYxC;Ae9gYI;EAAoC,gBAAA;AfihYxC;AehhYI;EAAwC,gBAAA;AfmhY5C;AelhYI;EAAmC,gBAAA;AfqhYvC;AephYI;EAAgC,gBAAA;AfuhYpC;AethYI;EAAiC,gBAAA;AfyhYrC;AexhYI;EAA6B,gBAAA;Af2hYjC;Ae1hYI;EAAqC,gBAAA;Af6hYzC;Ae5hYI;EAAmC,gBAAA;Af+hYvC;Ae9hYI;EAA8B,gBAAA;AfiiYlC;AehiYI;EAAmC,gBAAA;AfmiYvC;AeliYI;EAAkC,gBAAA;AfqiYtC;AepiYI;EAA+B,gBAAA;AfuiYnC;AetiYI;EAAkC,gBAAA;AfyiYtC;AexiYI;EAA6B,gBAAA;Af2iYjC;Ae1iYI;EAAoC,gBAAA;Af6iYxC;Ae5iYI;EAAoC,gBAAA;Af+iYxC;Ae9iYI;EAA4B,gBAAA;AfijYhC;AehjYI;EAAiC,gBAAA;AfmjYrC;AeljYI;EAAoC,gBAAA;AfqjYxC;AepjYI;EAAkC,gBAAA;AfujYtC;AetjYI;EAAqC,gBAAA;AfyjYzC;AexjYI;EAA8B,gBAAA;Af2jYlC;Ae1jYI;EAAwC,gBAAA;Af6jY5C;Ae5jYI;EAAoC,gBAAA;Af+jYxC;Ae9jYI;EAA6B,gBAAA;AfikYjC;AehkYI;EAAqC,gBAAA;AfmkYzC;AelkYI;EAAwC,gBAAA;AfqkY5C;AepkYI;EAAwC,gBAAA;AfukY5C;AetkYI;EAAuC,gBAAA;AfykY3C;Ae9jYI;EACE,0BiF36CiB;EjF46CjB,6CiFp6CoB;EjFq6CpB,iTiF36CJ;EjF46CI,kBAAA;EACA,mB+Cj8CG;E/Ck8CH,oBAAA;EACA,wBAAA;EACA,oBAAA;AfgkYN;Ae5jYI;EAAyB,gBAAA;EAAkB,0BiFt7CxB;AhGs/avB;Ae/jYI;EAA2B,gBAAA;EAAkB,0BiFv7C1B;AhG0/avB;AelkYI;EAAyB,gBAAA;EAAkB,0BiFx7CxB;AhG8/avB;AerkYI;EAA0C,gBAAA;EAAkB,0BiFz7CzC;AhGkgbvB;AexkYI;EAAoB,gBAAA;EAAkB,0BiF17CnB;AhGsgbvB;Ae3kYI;EAAsB,gBAAA;EAAkB,0BiF37CrB;AhG0gbvB;Ae9kYI;EAAyB,gBAAA;EAAkB,0BiF57CxB;AhG8gbvB;AejlYI;EAA+B,gBAAA;EAAkB,0BiF77C9B;AhGkhbvB;AeplYI;EAAuB,gBAAA;EAAkB,0BiF97CtB;AhGshbvB;AevlYI;EAAwB,gBAAA;EAAkB,0BiF/7CvB;AhG0hbvB;Ae1lYI;EAAuB,gBAAA;EAAkB,0BiFh8CtB;AhG8hbvB;Ae7lYI;EAAuB,gBAAA;EAAkB,0BiFj8CtB;AhGkibvB;AehmYI;EAA2B,gBAAA;EAAkB,0BiFl8C1B;AhGsibvB;AenmYI;EAAuB,gBAAA;EAAkB,0BiFn8CtB;AhG0ibvB;AetmYI;EAAwB,gBAAA;EAAkB,0BiFp8CvB;AhG8ibvB;AezmYI;EAA0B,gBAAA;EAAkB,0BiFr8CzB;AhGkjbvB;Ae5mYI;EAA8B,gBAAA;EAAkB,0BiFt8C7B;AhGsjbvB;Ae/mYI;EAAwB,gBAAA;EAAkB,0BiFv8CvB;AhG0jbvB;AelnYI;EAA0B,gBAAA;EAAkB,0BiFx8CzB;AhG8jbvB;AernYI;EAA8B,gBAAA;EAAkB,0BiFz8C7B;AhGkkbvB;AexnYI;EAAsB,gBAAA;EAAkB,0BiF18CrB;AhGskbvB;Ae3nYI;EAAsB,gBAAA;EAAkB,0BiF38CrB;AhG0kbvB;Ae9nYI;EAA0B,gBAAA;EAAkB,0BiF58CzB;AhG8kbvB;AejoYI;EAA2B,gBAAA;EAAkB,0BiF78C1B;AhGklbvB;AepoYI;EAA2B,gBAAA;EAAkB,0BiF98C1B;AhGslbvB;AevoYI;EAA0B,gBAAA;EAAkB,0BiF/8CzB;AhG0lbvB;Ae1oYI;EAAwB,gBAAA;EAAkB,0BiFh9CvB;AhG8lbvB;Ae7oYI;EAA6B,gBAAA;EAAkB,0BiFj9C5B;AhGkmbvB;AehpYI;EAAwB,gBAAA;EAAkB,0BiFl9CvB;AhGsmbvB;AenpYI;EAAuB,gBAAA;EAAkB,0BiFn9CtB;AhG0mbvB;AetpYI;EAAoB,gBAAA;EAAkB,0BiFp9CnB;AhG8mbvB;AezpYI;EAAyB,gBAAA;EAAkB,0BiFr9CxB;AhGknbvB;Ae5pYI;EAA2B,gBAAA;EAAkB,0BiFt9C1B;AhGsnbvB;Ae/pYI;EAAwB,gBAAA;EAAkB,0BiFv9CvB;AhG0nbvB;AelqYI;EAA+B,gBAAA;EAAkB,0BiFx9C9B;AhG8nbvB;AerqYI;EAA0B,gBAAA;EAAkB,0BiFz9CzB;AhGkobvB;AexqYI;EAA0B,gBAAA;EAAkB,0BiF19CzB;AhGsobvB;Ae3qYI;EAAwB,gBAAA;EAAkB,0BiF39CvB;AhG0obvB;Ae9qYI;EAAqB,gBAAA;EAAkB,0BiF59CpB;AhG8obvB;AejrYI;EAA0B,gBAAA;EAAkB,0BiF79CzB;AhGkpbvB;AeprYI;EAA2B,gBAAA;EAAkB,0BiF99C1B;AhGspbvB;AevrYI;EAAwB,gBAAA;EAAkB,0BiF/9CvB;AhG0pbvB;Ae1rYI;EAA0B,gBAAA;EAAkB,0BiFh+CzB;AhG8pbvB;Ae7rYI;EAA0B,gBAAA;EAAkB,0BiFj+CzB;AhGkqbvB;AehsYI;EAA4B,gBAAA;EAAkB,0BiFl+C3B;AhGsqbvB;AensYI;EAA0B,gBAAA;EAAkB,0BiFn+CzB;AhG0qbvB;AetsYI;EAAoB,gBAAA;EAAkB,0BiFp+CnB;AhG8qbvB;AezsYI;EAAuB,gBAAA;EAAkB,0BiFr+CtB;AhGkrbvB;Ae5sYI;EAAiC,gBAAA;EAAkB,0BiFt+ChC;AhGsrbvB;Ae/sYI;EAA2B,gBAAA;EAAkB,0BiFv+C1B;AhG0rbvB;AeltYI;EAAoC,gBAAA;EAAkB,0BiFx+CnC;AhG8rbvB;AertYI;EAA8B,gBAAA;EAAkB,0BiFz+C7B;AhGksbvB;AextYI;EAAwB,gBAAA;EAAkB,0BiF1+CvB;AhGssbvB;Ae3tYI;EAA6B,gBAAA;EAAkB,0BiF3+C5B;AhG0sbvB;Ae9tYI;EAA+B,gBAAA;EAAkB,0BiF5+C9B;AhG8sbvB;AejuYI;EAA4B,gBAAA;EAAkB,0BiF7+C3B;AhGktbvB;AepuYI;EAAuB,gBAAA;EAAkB,0BiF9+CtB;AhGstbvB;AevuYI;EAA8B,gBAAA;EAAkB,0BiF/+C7B;AhG0tbvB;Ae1uYI;EAA0B,gBAAA;EAAkB,0BiFh/CzB;AhG8tbvB;Ae7uYI;EAA0B,gBAAA;EAAkB,0BiFj/CzB;AhGkubvB;AehvYI;EAAwB,gBAAA;EAAkB,0BiFl/CvB;AhGsubvB;AenvYI;EAA2B,gBAAA;EAAkB,0BiFn/C1B;AhG0ubvB;AetvYI;EAAuB,gBAAA;EAAkB,0BiFp/CtB;AhG8ubvB;AezvYI;EAAuB,gBAAA;EAAkB,0BiFr/CtB;AhGkvbvB;Ae5vYI;EAA2B,gBAAA;EAAkB,0BiFt/C1B;AhGsvbvB;Ae/vYI;EAA2B,gBAAA;EAAkB,0BiFv/C1B;AhG0vbvB;AelwYI;EAA2B,gBAAA;EAAkB,0BiFx/C1B;AhG8vbvB;AerwYI;EAA6B,gBAAA;EAAkB,0BiFz/C5B;AhGkwbvB;AexwYI;EAAwB,gBAAA;EAAkB,0BiF1/CvB;AhGswbvB;Ae3wYI;EAAyB,gBAAA;EAAkB,0BiF3/CxB;AhG0wbvB;Ae9wYI;EAA2B,gBAAA;EAAkB,0BiF5/C1B;AhG8wbvB;AejxYI;EAA+B,gBAAA;EAAkB,0BiF7/C9B;AhGkxbvB;AepxYI;EAAuB,gBAAA;EAAkB,0BiF9/CtB;AhGsxbvB;AevxYI;EAAuB,gBAAA;EAAkB,0BiF//CtB;AhG0xbvB;Ae1xYI;EAAiC,gBAAA;EAAkB,0BiFhgDhC;AhG8xbvB;Ae7xYI;EAAoC,gBAAA;EAAkB,0BiFjgDnC;AhGkybvB;AehyYI;EAAoC,gBAAA;EAAkB,0BiFlgDnC;AhGsybvB;AenyYI;EAAuC,gBAAA;EAAkB,0BiFngDtC;AhG0ybvB;AetyYI;EAAuC,gBAAA;EAAkB,0BiFpgDtC;AhG8ybvB;AezyYI;EAAoC,gBAAA;EAAkB,0BiFrgDnC;AhGkzbvB;Ae5yYI;EAAoC,gBAAA;EAAkB,0BiFtgDnC;AhGszbvB;Ae/yYI;EAA8C,gBAAA;EAAkB,0BiFvgD7C;AhG0zbvB;AelzYI;EAAuC,gBAAA;EAAkB,0BiFxgDtC;AhG8zbvB;AerzYI;EAAoC,gBAAA;EAAkB,0BiFzgDnC;AhGk0bvB;AexzYI;EAA0C,gBAAA;EAAkB,0BiF1gDzC;AhGs0bvB;Ae3zYI;EAA+C,gBAAA;EAAkB,0BiF3gD9C;AhG00bvB;Ae9zYI;EAAuC,gBAAA;EAAkB,0BiF5gDtC;AhG80bvB;Aej0YI;EAAsC,gBAAA;EAAkB,0BiF7gDrC;AhGk1bvB;Aep0YI;EAA8B,gBAAA;EAAkB,0BiF9gD7B;AhGs1bvB;Aev0YI;EAAqB,gBAAA;EAAkB,0BiF/gDpB;AhG01bvB;Ae10YI;EAA+B,gBAAA;EAAkB,0BiFhhD9B;AhG81bvB;Ae70YI;EAA2B,gBAAA;EAAkB,0BiFjhD1B;AhGk2bvB;Aeh1YI;EAAwB,gBAAA;EAAkB,0BiFlhDvB;AhGs2bvB;Aen1YI;EAA+B,gBAAA;EAAkB,0BiFnhD9B;AhG02bvB;Aet1YI;EAAyB,gBAAA;EAAkB,0BiFphDxB;AhG82bvB;Aez1YI;EAA0B,gBAAA;EAAkB,0BiFrhDzB;AhGk3bvB;Ae51YI;EAA0B,gBAAA;EAAkB,0BiFthDzB;AhGs3bvB;Ae/1YI;EAAwB,gBAAA;EAAkB,0BiFvhDvB;AhG03bvB;Ael2YI;EAAoB,gBAAA;EAAkB,0BiFxhDnB;AhG83bvB;Aer2YI;EAA2B,gBAAA;EAAkB,0BiFzhD1B;AhGk4bvB;Aex2YI;EAAoB,gBAAA;EAAkB,0BiF1hDnB;AhGs4bvB;Ae32YI;EAAyB,gBAAA;EAAkB,0BiF3hDxB;AhG04bvB;Ae92YI;EAAqB,gBAAA;EAAkB,0BiF5hDpB;AhG84bvB;Aej3YI;EAA8B,gBAAA;EAAkB,0BiF7hD7B;AhGk5bvB;Aep3YI;EAAwB,gBAAA;EAAkB,0BiF9hDvB;AhGs5bvB;Aev3YI;EAA0B,gBAAA;EAAkB,0BiF/hDzB;AhG05bvB;Ae13YI;EAAuB,gBAAA;EAAkB,0BiFhiDtB;AhG85bvB;Ae73YI;EAAuB,gBAAA;EAAkB,0BiFjiDtB;AhGk6bvB;Aeh4YI;EAA8B,gBAAA;EAAkB,0BiFliD7B;AhGs6bvB;Aen4YI;EAAyB,gBAAA;EAAkB,0BiFniDxB;AhG06bvB;Aet4YI;EAAgC,gBAAA;EAAkB,0BiFpiD/B;AhG86bvB;Aez4YI;EAAwB,gBAAA;EAAkB,0BiFriDvB;AhGk7bvB;Ae54YI;EAAuB,gBAAA;EAAkB,0BiFtiDtB;AhGs7bvB;Ae/4YI;EAAuB,gBAAA;EAAkB,0BiFviDtB;AhG07bvB;Ael5YI;EAA2B,gBAAA;EAAkB,0BiFxiD1B;AhG87bvB;Aer5YI;EAAqB,gBAAA;EAAkB,0BiFziDpB;AhGk8bvB;Aex5YI;EAAqB,gBAAA;EAAkB,0BiF1iDpB;AhGs8bvB;Ae35YI;EAA0B,gBAAA;EAAkB,0BiF3iDzB;AhG08bvB;Ae95YI;EAAqB,gBAAA;EAAkB,0BiF5iDpB;AhG88bvB;Aej6YI;EAAsB,gBAAA;EAAkB,0BiF7iDrB;AhGk9bvB;Aep6YI;EAAuB,gBAAA;EAAkB,0BiF9iDtB;AhGs9bvB;Aev6YI;EAAuB,gBAAA;EAAkB,0BiF/iDtB;AhG09bvB;Ae16YI;EAAuB,gBAAA;EAAkB,0BiFhjDtB;AhG89bvB;Ae76YI;EAAyB,gBAAA;EAAkB,0BiFjjDxB;AhGk+bvB;Aeh7YI;EAAqB,gBAAA;EAAkB,0BiFljDpB;AhGs+bvB;Aen7YI;EAAyB,gBAAA;EAAkB,0BiFnjDxB;AhG0+bvB;Aet7YI;EAA6B,gBAAA;EAAkB,0BiFpjD5B;AhG8+bvB;Aez7YI;EAAyB,gBAAA;EAAkB,0BiFrjDxB;AhGk/bvB;Ae57YI;EAA2B,gBAAA;EAAkB,0BiFtjD1B;AhGs/bvB;Ae/7YI;EAAmC,gBAAA;EAAkB,0BiFvjDlC;AhG0/bvB;Ael8YI;EAAgC,gBAAA;EAAkB,0BiFxjD/B;AhG8/bvB;Aer8YI;EAAqC,gBAAA;EAAkB,0BiFzjDpC;AhGkgcvB;Aex8YI;EAAsB,gBAAA;EAAkB,0BiF1jDrB;AhGsgcvB;Ae38YI;EAAuB,gBAAA;EAAkB,0BiF3jDtB;AhG0gcvB;Ae98YI;EAAsB,gBAAA;EAAkB,0BiF5jDrB;AhG8gcvB;Aej9YI;EAAwB,gBAAA;EAAkB,0BiF7jDvB;AhGkhcvB;Aep9YI;EAA4B,gBAAA;EAAkB,0BiF9jD3B;AhGshcvB;Aev9YI;EAAsC,gBAAA;EAAkB,0BiF/jDrC;AhG0hcvB;Ae19YI;EAA2B,gBAAA;EAAkB,0BiFhkD1B;AhG8hcvB;Ae79YI;EAAuB,gBAAA;EAAkB,0BiFjkDtB;AhGkicvB;Aeh+YI;EAA0B,gBAAA;EAAkB,0BiFlkDzB;AhGsicvB;Aen+YI;EAAoB,gBAAA;EAAkB,0BiFnkDnB;AhG0icvB;Aet+YI;EAA6B,gBAAA;EAAkB,0BiFpkD5B;AhG8icvB;Aez+YI;EAAuC,gBAAA;EAAkB,0BiFrkDtC;AhGkjcvB;Ae5+YI;EAAkC,gBAAA;EAAkB,0BiFtkDjC;AhGsjcvB;Ae/+YI;EAA0B,gBAAA;EAAkB,0BiFvkDzB;AhG0jcvB;Ael/YI;EAA6B,gBAAA;EAAkB,0BiFxkD5B;AhG8jcvB;Aer/YI;EAA6B,gBAAA;EAAkB,0BiFzkD5B;AhGkkcvB;Aex/YI;EAAuC,gBAAA;EAAkB,0BiF1kDtC;AhGskcvB;Ae3/YI;EAAyB,gBAAA;EAAkB,0BiF3kDxB;AhG0kcvB;Ae9/YI;EAA2B,gBAAA;EAAkB,0BiF5kD1B;AhG8kcvB;AejgZI;EAA+B,gBAAA;EAAkB,0BiF7kD9B;AhGklcvB;AepgZI;EAAwB,gBAAA;EAAkB,0BiF9kDvB;AhGslcvB;AevgZI;EAAwB,gBAAA;EAAkB,0BiF/kDvB;AhG0lcvB;Ae1gZI;EAAkC,gBAAA;EAAkB,0BiFhlDjC;AhG8lcvB;Ae7gZI;EAAgC,gBAAA;EAAkB,0BiFjlD/B;AhGkmcvB;AehhZI;EAA2B,gBAAA;EAAkB,0BiFllD1B;AhGsmcvB;AenhZI;EAAmB,gBAAA;EAAkB,0BiFnlDlB;AhG0mcvB;AethZI;EAA0B,gBAAA;EAAkB,0BiFplDzB;AhG8mcvB;AezhZI;EAAoB,gBAAA;EAAkB,0BiFrlDnB;AhGkncvB;Ae5hZI;EAA8B,gBAAA;EAAkB,0BiFtlD7B;AhGsncvB;Ae/hZI;EAA2B,gBAAA;EAAkB,0BiFvlD1B;AhG0ncvB;AeliZI;EAAuB,gBAAA;EAAkB,0BiFxlDtB;AhG8ncvB;AeriZI;EAAiC,gBAAA;EAAkB,0BiFzlDhC;AhGkocvB;AexiZI;EAA8B,gBAAA;EAAkB,0BiF1lD7B;AhGsocvB;Ae3iZI;EAA0B,gBAAA;EAAkB,0BiF3lDzB;AhG0ocvB;Ae9iZI;EAAuB,gBAAA;EAAkB,0BiF5lDtB;AhG8ocvB;AejjZI;EAAuB,gBAAA;EAAkB,0BiF7lDtB;AhGkpcvB;AepjZI;EAAsB,gBAAA;EAAkB,0BiF9lDrB;AhGspcvB;AevjZI;EAAwB,gBAAA;EAAkB,0BiF/lDvB;AhG0pcvB;Ae1jZI;EAAuB,gBAAA;EAAkB,0BiFhmDtB;AhG8pcvB;Ae7jZI;EAA0B,gBAAA;EAAkB,0BiFjmDzB;AhGkqcvB;AehkZI;EAA4B,gBAAA;EAAkB,0BiFlmD3B;AhGsqcvB;AenkZI;EAAuB,gBAAA;EAAkB,0BiFnmDtB;AhG0qcvB;AetkZI;EAA6B,gBAAA;EAAkB,0BiFpmD5B;AhG8qcvB;AezkZI;EAA4B,gBAAA;EAAkB,0BiFrmD3B;AhGkrcvB;Ae5kZI;EAA4B,gBAAA;EAAkB,0BiFtmD3B;AhGsrcvB;Ae/kZI;EAA8B,gBAAA;EAAkB,0BiFvmD7B;AhG0rcvB;AellZI;EAAmC,gBAAA;EAAkB,0BiFxmDlC;AhG8rcvB;AerlZI;EAA8B,gBAAA;EAAkB,0BiFzmD7B;AhGkscvB;AexlZI;EAAyB,gBAAA;EAAkB,0BiF1mDxB;AhGsscvB;Ae3lZI;EAAqB,gBAAA;EAAkB,0BiF3mDpB;AhG0scvB;Ae9lZI;EAAyB,gBAAA;EAAkB,0BiF5mDxB;AhG8scvB;AejmZI;EAAsB,gBAAA;EAAkB,0BiF7mDrB;AhGktcvB;AepmZI;EAAqB,gBAAA;EAAkB,0BiF9mDpB;AhGstcvB;AevmZI;EAA4B,gBAAA;EAAkB,0BiF/mD3B;AhG0tcvB;Ae1mZI;EAAmC,gBAAA;EAAkB,0BiFhnDlC;AhG8tcvB;Ae7mZI;EAA2B,gBAAA;EAAkB,0BiFjnD1B;AhGkucvB;AehnZI;EAAqB,gBAAA;EAAkB,0BiFlnDpB;AhGsucvB;AennZI;EAA8B,gBAAA;EAAkB,0BiFnnD7B;AhG0ucvB;AetnZI;EAAsB,gBAAA;EAAkB,0BiFpnDrB;AhG8ucvB;AeznZI;EAAyB,gBAAA;EAAkB,0BiFrnDxB;AhGkvcvB;Ae5nZI;EAAuB,gBAAA;EAAkB,0BiFtnDtB;AhGsvcvB;Ae/nZI;EAAsB,gBAAA;EAAkB,0BiFvnDrB;AhG0vcvB;AeloZI;EAAsB,gBAAA;EAAkB,0BiFxnDrB;AhG8vcvB;AeroZI;EAAwB,gBAAA;EAAkB,0BiFznDvB;AhGkwcvB;AexoZI;EAAqB,gBAAA;EAAkB,0BiF1nDpB;AhGswcvB;Ae3oZI;EAA0B,gBAAA;EAAkB,0BiF3nDzB;AhG0wcvB;Ae9oZI;EAAyB,gBAAA;EAAkB,0BiF5nDxB;AhG8wcvB;AejpZI;EAAkC,gBAAA;EAAkB,0BiF7nDjC;AhGkxcvB;AeppZI;EAAyB,gBAAA;EAAkB,0BiF9nDxB;AhGsxcvB;AevpZI;EAAwB,gBAAA;EAAkB,0BiF/nDvB;AhG0xcvB;Ae1pZI;EAAwB,gBAAA;EAAkB,0BiFhoDvB;AhG8xcvB;Ae7pZI;EAAuB,gBAAA;EAAkB,0BiFjoDtB;AhGkycvB;AehqZI;EAA4B,gBAAA;EAAkB,0BiFloD3B;AhGsycvB;AenqZI;EAAqB,gBAAA;EAAkB,0BiFnoDpB;AhG0ycvB;AetqZI;EAA2B,gBAAA;EAAkB,0BiFpoD1B;AhG8ycvB;AezqZI;EAAwB,gBAAA;EAAkB,0BiFroDvB;AhGkzcvB;Ae5qZI;EAAqB,gBAAA;EAAkB,0BiFtoDpB;AhGszcvB;Ae/qZI;EAAsB,gBAAA;EAAkB,0BiFvoDrB;AhG0zcvB;AelrZI;EAAuB,gBAAA;EAAkB,0BiFxoDtB;AhG8zcvB;AerrZI;EAAmB,gBAAA;EAAkB,0BiFzoDlB;AhGk0cvB;AexrZI;EAA0B,gBAAA;EAAkB,0BiF1oDzB;AhGs0cvB;Ae3rZI;EAAyB,gBAAA;EAAkB,0BiF3oDxB;AhG00cvB;Ae9rZI;EAAuB,gBAAA;EAAkB,0BiF5oDtB;AhG80cvB;AejsZI;EAAwB,gBAAA;EAAkB,0BiF7oDvB;AhGk1cvB;AepsZI;EAAuB,gBAAA;EAAkB,0BiF9oDtB;AhGs1cvB;AevsZI;EAA4B,gBAAA;EAAkB,0BiF/oD3B;AhG01cvB;Ae1sZI;EAA8B,gBAAA;EAAkB,0BiFhpD7B;AhG81cvB;Ae7sZI;EAAuB,gBAAA;EAAkB,0BiFjpDtB;AhGk2cvB;AehtZI;EAAwB,gBAAA;EAAkB,0BiFlpDvB;AhGs2cvB;AentZI;EAAuB,gBAAA;EAAkB,0BiFnpDtB;AhG02cvB;AettZI;EAA8B,gBAAA;EAAkB,0BiFppD7B;AhG82cvB;AeztZI;EAAwB,gBAAA;EAAkB,0BiFrpDvB;AhGk3cvB;Ae5tZI;EAAwB,gBAAA;EAAkB,0BiFtpDvB;AhGs3cvB;Ae/tZI;EAAyB,gBAAA;EAAkB,0BiFvpDxB;AhG03cvB;AeluZI;EAAyB,gBAAA;EAAkB,0BiFxpDxB;AhG83cvB;AeruZI;EAA4B,gBAAA;EAAkB,0BiFzpD3B;AhGk4cvB;AexuZI;EAAuB,gBAAA;EAAkB,0BiF1pDtB;AhGs4cvB;Ae3uZI;EAAsB,gBAAA;EAAkB,0BiF3pDrB;AhG04cvB;Ae9uZI;EAAqB,gBAAA;EAAkB,0BiF5pDpB;AhG84cvB;AejvZI;EAAwB,gBAAA;EAAkB,0BiF7pDvB;AhGk5cvB;AepvZI;EAA0B,gBAAA;EAAkB,0BiF9pDzB;AhGs5cvB;AevvZI;EAA4B,gBAAA;EAAkB,0BiF/pD3B;AhG05cvB;Ae1vZI;EAAyB,gBAAA;EAAkB,0BiFhqDxB;AhG85cvB;Ae7vZI;EAAyB,gBAAA;EAAkB,0BiFjqDxB;AhGk6cvB;AehwZI;EAAuB,gBAAA;EAAkB,0BiFlqDtB;AhGs6cvB;AenwZI;EAAwB,gBAAA;EAAkB,0BiFnqDvB;AhG06cvB;AetwZI;EAAuB,gBAAA;EAAkB,0BiFpqDtB;AhG86cvB;AezwZI;EAAyB,gBAAA;EAAkB,0BiFrqDxB;AhGk7cvB;Ae5wZI;EAAsB,gBAAA;EAAkB,0BiFtqDrB;AhGs7cvB;Ae/wZI;EAAuB,gBAAA;EAAkB,0BiFvqDtB;AhG07cvB;AelxZI;EAAyB,gBAAA;EAAkB,0BiFxqDxB;AhG87cvB;AerxZI;EAAyB,gBAAA;EAAkB,0BiFzqDxB;AhGk8cvB;AexxZI;EAA0B,gBAAA;EAAkB,0BiF1qDzB;AhGs8cvB;Ae3xZI;EAAoB,gBAAA;EAAkB,0BiF3qDnB;AhG08cvB;Ae9xZI;EAAyB,gBAAA;EAAkB,0BiF5qDxB;AhG88cvB;AejyZI;EAAuB,gBAAA;EAAkB,0BiF7qDtB;AhGk9cvB;AepyZI;EAAqB,gBAAA;EAAkB,0BiF9qDpB;AhGs9cvB;AevyZI;EAAuB,gBAAA;EAAkB,0BiF/qDtB;AhG09cvB;Ae1yZI;EAAwB,gBAAA;EAAkB,0BiFhrDvB;AhG89cvB;Ae7yZI;EAAqB,gBAAA;EAAkB,0BiFjrDpB;AhGk+cvB;AehzZI;EAAuB,gBAAA;EAAkB,0BiFlrDtB;AhGs+cvB;AenzZI;EAAqB,gBAAA;EAAkB,0BiFnrDpB;AhG0+cvB;AetzZI;EAAwB,gBAAA;EAAkB,0BiFprDvB;AhG8+cvB;AezzZI;EAAoB,gBAAA;EAAkB,0BiFrrDnB;AhGk/cvB;Ae5zZI;EAAoB,gBAAA;EAAkB,0BiFtrDnB;AhGs/cvB;Ae/zZI;EAA4B,gBAAA;EAAkB,0BiFvrD3B;AhG0/cvB;Ael0ZI;EAA8B,gBAAA;EAAkB,0BiFxrD7B;AhG8/cvB;Aer0ZI;EAAqC,gBAAA;EAAkB,0BiFzrDpC;AhGkgdvB;Aex0ZI;EAA6B,gBAAA;EAAkB,0BiF1rD5B;AhGsgdvB;Ae30ZI;EAAyB,gBAAA;EAAkB,0BiF3rDxB;AhG0gdvB;Ae90ZI;EAAuB,gBAAA;EAAkB,0BiF5rDtB;AhG8gdvB;Aej1ZI;EAAsB,gBAAA;EAAkB,0BiF7rDrB;AhGkhdvB;Aep1ZI;EAA8B,gBAAA;EAAkB,0BiF9rD7B;AhGshdvB;Aev1ZI;EAAoB,gBAAA;EAAkB,0BiF/rDnB;AhG0hdvB;Ae11ZI;EAAsB,gBAAA;EAAkB,0BiFhsDrB;AhG8hdvB;Ae71ZI;EAA0B,gBAAA;EAAkB,0BiFjsDzB;AhGkidvB;Aeh2ZI;EAAuB,gBAAA;EAAkB,0BiFlsDtB;AhGsidvB;Aen2ZI;EAAwB,gBAAA;EAAkB,0BiFnsDvB;AhG0idvB;Aet2ZI;EAAuB,gBAAA;EAAkB,0BiFpsDtB;AhG8idvB;Aez2ZI;EAA6B,gBAAA;EAAkB,0BiFrsD5B;AhGkjdvB;Ae52ZI;EAA0B,gBAAA;EAAkB,0BiFtsDzB;AhGsjdvB;Ae/2ZI;EAA4B,gBAAA;EAAkB,0BiFvsD3B;AhG0jdvB;Ael3ZI;EAAkC,gBAAA;EAAkB,0BiFxsDjC;AhG8jdvB;Aer3ZI;EAAiC,gBAAA;EAAkB,0BiFzsDhC;AhGkkdvB;Aex3ZI;EAAoB,gBAAA;EAAkB,0BiF1sDnB;AhGskdvB;Ae33ZI;EAA2B,gBAAA;EAAkB,0BiF3sD1B;AhG0kdvB;Ae93ZI;EAAqC,gBAAA;EAAkB,0BiF5sDpC;AhG8kdvB;Aej4ZI;EAA+B,gBAAA;EAAkB,0BiF7sD9B;AhGkldvB;Aep4ZI;EAA8B,gBAAA;EAAkB,0BiF9sD7B;AhGsldvB;Aev4ZI;EAA0B,gBAAA;EAAkB,0BiF/sDzB;AhG0ldvB;Ae14ZI;EAA4B,gBAAA;EAAkB,0BiFhtD3B;AhG8ldvB;Ae74ZI;EAAiC,gBAAA;EAAkB,0BiFjtDhC;AhGkmdvB;Aeh5ZI;EAA4B,gBAAA;EAAkB,0BiFltD3B;AhGsmdvB;Aen5ZI;EAA6B,gBAAA;EAAkB,0BiFntD5B;AhG0mdvB;Aet5ZI;EAAuB,gBAAA;EAAkB,0BiFptDtB;AhG8mdvB;Aez5ZI;EAAuB,gBAAA;EAAkB,0BiFrtDtB;AhGkndvB;Ae55ZI;EAAmB,gBAAA;EAAkB,0BiFttDlB;AhGsndvB;Ae/5ZI;EAA0B,gBAAA;EAAkB,0BiFvtDzB;AhG0ndvB;Ael6ZI;EAAsB,gBAAA;EAAkB,0BiFxtDrB;AhG8ndvB;Aer6ZI;EAA0B,gBAAA;EAAkB,0BiFztDzB;AhGkodvB;Aex6ZI;EAA6B,gBAAA;EAAkB,0BiF1tD5B;AhGsodvB;Ae36ZI;EAAwB,gBAAA;EAAkB,0BiF3tDvB;AhG0odvB;Ae96ZI;EAAsB,gBAAA;EAAkB,0BiF5tDrB;AhG8odvB;Aej7ZI;EAA4B,gBAAA;EAAkB,0BiF7tD3B;AhGkpdvB;Aep7ZI;EAAuB,gBAAA;EAAkB,0BiF9tDtB;AhGspdvB;Aev7ZI;EAAsB,gBAAA;EAAkB,0BiF/tDrB;AhG0pdvB;Ae17ZI;EAAuB,gBAAA;EAAkB,0BiFhuDtB;AhG8pdvB;Ae77ZI;EAA6B,gBAAA;EAAkB,0BiFjuD5B;AhGkqdvB;Aeh8ZI;EAA8B,gBAAA;EAAkB,0BiFluD7B;AhGsqdvB;Aen8ZI;EAAuB,gBAAA;EAAkB,0BiFnuDtB;AhG0qdvB;Aet8ZI;EAAyB,gBAAA;EAAkB,0BiFpuDxB;AhG8qdvB;Aez8ZI;EAAwB,gBAAA;EAAkB,0BiFruDvB;AhGkrdvB;Ae58ZI;EAAuB,gBAAA;EAAkB,0BiFtuDtB;AhGsrdvB;Ae/8ZI;EAAuB,gBAAA;EAAkB,0BiFvuDtB;AhG0rdvB;Ael9ZI;EAA6B,gBAAA;EAAkB,0BiFxuD5B;AhG8rdvB;Aer9ZI;EAA0B,gBAAA;EAAkB,0BiFzuDzB;AhGksdvB;Aex9ZI;EAAoB,gBAAA;EAAkB,0BiF1uDnB;AhGssdvB;Ae39ZI;EAA2B,gBAAA;EAAkB,0BiF3uD1B;AhG0sdvB;Ae99ZI;EAAwB,gBAAA;EAAkB,0BiF5uDvB;AhG8sdvB;Aej+ZI;EAAuB,gBAAA;EAAkB,0BiF7uDtB;AhGktdvB;Aep+ZI;EAA2B,gBAAA;EAAkB,0BiF9uD1B;AhGstdvB;Aev+ZI;EAAqB,gBAAA;EAAkB,0BiF/uDpB;AhG0tdvB;Ae1+ZI;EAAuB,gBAAA;EAAkB,0BiFhvDtB;AhG8tdvB;Ae7+ZI;EAAuB,gBAAA;EAAkB,0BiFjvDtB;AhGkudvB;Aeh/ZI;EAA4B,gBAAA;EAAkB,0BiFlvD3B;AhGsudvB;Aen/ZI;EAAyB,gBAAA;EAAkB,0BiFnvDxB;AhG0udvB;Aet/ZI;EAAuB,gBAAA;EAAkB,0BiFpvDtB;AhG8udvB;Aez/ZI;EAA6B,gBAAA;EAAkB,0BiFrvD5B;AhGkvdvB;Ae5/ZI;EAA6B,gBAAA;EAAkB,0BiFtvD5B;AhGsvdvB;Ae//ZI;EAAyB,gBAAA;EAAkB,0BiFvvDxB;AhG0vdvB;AelgaI;EAA4B,gBAAA;EAAkB,0BiFxvD3B;AhG8vdvB;AergaI;EAAwB,gBAAA;EAAkB,0BiFzvDvB;AhGkwdvB;AexgaI;EAAqB,gBAAA;EAAkB,0BiF1vDpB;AhGswdvB;Ae3gaI;EAAuB,gBAAA;EAAkB,0BiF3vDtB;AhG0wdvB;Ae9gaI;EAAyB,gBAAA;EAAkB,0BiF5vDxB;AhG8wdvB;AejhaI;EAAsB,gBAAA;EAAkB,0BiF7vDrB;AhGkxdvB;AephaI;EAAsB,gBAAA;EAAkB,0BiF9vDrB;AhGsxdvB;AevhaI;EAA2B,gBAAA;EAAkB,0BiF/vD1B;AhG0xdvB;Ae1haI;EAA2B,gBAAA;EAAkB,0BiFhwD1B;AhG8xdvB;Ae7haI;EAAyB,gBAAA;EAAkB,0BiFjwDxB;AhGkydvB;AehiaI;EAA+B,gBAAA;EAAkB,0BiFlwD9B;AhGsydvB;AeniaI;EAAgC,gBAAA;EAAkB,0BiFnwD/B;AhG0ydvB;AetiaI;EAA2B,gBAAA;EAAkB,0BiFpwD1B;AhG8ydvB;AeziaI;EAA2B,gBAAA;EAAkB,0BiFrwD1B;AhGkzdvB;Ae5iaI;EAAwB,gBAAA;EAAkB,0BiFtwDvB;AhGszdvB;Ae/iaI;EAA6B,gBAAA;EAAkB,0BiFvwD5B;AhG0zdvB;AeljaI;EAAwB,gBAAA;EAAkB,0BiFxwDvB;AhG8zdvB;AerjaI;EAA4B,gBAAA;EAAkB,0BiFzwD3B;AhGk0dvB;AexjaI;EAA+B,gBAAA;EAAkB,0BiF1wD9B;AhGs0dvB;Ae3jaI;EAA+B,gBAAA;EAAkB,0BiF3wD9B;AhG00dvB;Ae9jaI;EAA0B,gBAAA;EAAkB,0BiF5wDzB;AhG80dvB;AejkaI;EAA2B,gBAAA;EAAkB,0BiF7wD1B;AhGk1dvB;AepkaI;EAAsB,gBAAA;EAAkB,0BiF9wDrB;AhGs1dvB;AevkaI;EAA6B,gBAAA;EAAkB,0BiF/wD5B;AhG01dvB;Ae1kaI;EAA6B,gBAAA;EAAkB,0BiFhxD5B;AhG81dvB;Ae7kaI;EAA6B,gBAAA;EAAkB,0BiFjxD5B;AhGk2dvB;AehlaI;EAAuB,gBAAA;EAAkB,0BiFlxDtB;AhGs2dvB;AenlaI;EAAuB,gBAAA;EAAkB,0BiFnxDtB;AhG02dvB;AetlaI;EAAyB,gBAAA;EAAkB,0BiFpxDxB;AhG82dvB;AezlaI;EAA6B,gBAAA;EAAkB,0BiFrxD5B;AhGk3dvB;Ae5laI;EAA4B,gBAAA;EAAkB,0BiFtxD3B;AhGs3dvB;Ae/laI;EAAmC,gBAAA;EAAkB,0BiFvxDlC;AhG03dvB;AelmaI;EAA4B,gBAAA;EAAkB,0BiFxxD3B;AhG83dvB;AermaI;EAAuB,gBAAA;EAAkB,0BiFzxDtB;AhGk4dvB;AexmaI;EAAqB,gBAAA;EAAkB,0BiF1xDpB;AhGs4dvB;Ae3maI;EAAwB,gBAAA;EAAkB,0BiF3xDvB;AhG04dvB;Ae9maI;EAA0B,gBAAA;EAAkB,0BiF5xDzB;AhG84dvB;AejnaI;EAAyB,gBAAA;EAAkB,0BiF7xDxB;AhGk5dvB;AepnaI;EAA+B,gBAAA;EAAkB,0BiF9xD9B;AhGs5dvB;AevnaI;EAA8B,gBAAA;EAAkB,0BiF/xD7B;AhG05dvB;Ae1naI;EAAwB,gBAAA;EAAkB,0BiFhyDvB;AhG85dvB;Ae7naI;EAA0B,gBAAA;EAAkB,0BiFjyDzB;AhGk6dvB;AehoaI;EAA4B,gBAAA;EAAkB,0BiFlyD3B;AhGs6dvB;AenoaI;EAAiC,gBAAA;EAAkB,0BiFnyDhC;AhG06dvB;AetoaI;EAAuB,gBAAA;EAAkB,0BiFpyDtB;AhG86dvB;AezoaI;EAA4B,gBAAA;EAAkB,0BiFryD3B;AhGk7dvB;Ae5oaI;EAAuB,gBAAA;EAAkB,0BiFtyDtB;AhGs7dvB;Ae/oaI;EAA8B,gBAAA;EAAkB,0BiFvyD7B;AhG07dvB;AelpaI;EAAuB,gBAAA;EAAkB,0BiFxyDtB;AhG87dvB;AerpaI;EAAwB,gBAAA;EAAkB,0BiFzyDvB;AhGk8dvB;AexpaI;EAA+B,gBAAA;EAAkB,0BiF1yD9B;AhGs8dvB;Ae3paI;EAAsB,gBAAA;EAAkB,0BiF3yDrB;AhG08dvB;Ae9paI;EAAqB,gBAAA;EAAkB,0BiF5yDpB;AhG88dvB;AejqaI;EAAuB,gBAAA;EAAkB,0BiF7yDtB;AhGk9dvB;AepqaI;EAAsB,gBAAA;EAAkB,0BiF9yDrB;AhGs9dvB;AevqaI;EAA4B,gBAAA;EAAkB,0BiF/yD3B;AhG09dvB;Ae1qaI;EAAwB,gBAAA;EAAkB,0BiFhzDvB;AhG89dvB;Ae7qaI;EAAoB,gBAAA;EAAkB,0BiFjzDnB;AhGk+dvB;AehraI;EAAoB,gBAAA;EAAkB,0BiFlzDnB;AhGs+dvB;AenraI;EAAqB,gBAAA;EAAkB,0BiFnzDpB;AhG0+dvB;AetraI;EAAyB,gBAAA;EAAkB,0BiFpzDxB;AhG8+dvB;AezraI;EAAuB,gBAAA;EAAkB,0BiFrzDtB;AhGk/dvB;Ae5raI;EAAwB,gBAAA;EAAkB,0BiFtzDvB;AhGs/dvB;Ae/raI;EAAuB,gBAAA;EAAkB,0BiFvzDtB;AhG0/dvB;AelsaI;EAA8B,gBAAA;EAAkB,0BiFxzD7B;AhG8/dvB;AersaI;EAAsB,gBAAA;EAAkB,0BiFzzDrB;AhGkgevB;AexsaI;EAAsB,gBAAA;EAAkB,0BiF1zDrB;AhGsgevB;Ae3saI;EAA6B,gBAAA;EAAkB,0BiF3zD5B;AhG0gevB;Ae9saI;EAAwB,gBAAA;EAAkB,0BiF5zDvB;AhG8gevB;AejtaI;EAAqB,gBAAA;EAAkB,0BiF7zDpB;AhGkhevB;AeptaI;EAAmB,gBAAA;EAAkB,0BiF9zDlB;AhGshevB;AevtaI;EAAoB,gBAAA;EAAkB,0BiF/zDnB;AhG0hevB;Ae1taI;EAAsB,gBAAA;EAAkB,0BiFh0DrB;AhG8hevB;Ae7taI;EAAqB,gBAAA;EAAkB,0BiFj0DpB;AhGkievB;AehuaI;EAAuB,gBAAA;EAAkB,0BiFl0DtB;AhGsievB;AenuaI;EAAsB,gBAAA;EAAkB,0BiFn0DrB;AhG0ievB;AetuaI;EAAuB,gBAAA;EAAkB,0BiFp0DtB;AhG8ievB;AezuaI;EAAyB,gBAAA;EAAkB,0BiFr0DxB;AhGkjevB;Ae5uaI;EAAgC,gBAAA;EAAkB,0BiFt0D/B;AhGsjevB;Ae/uaI;EAAsB,gBAAA;EAAkB,0BiFv0DrB;AhG0jevB;AelvaI;EAA4B,gBAAA;EAAkB,0BiFx0D3B;AhG8jevB;AervaI;EAAwB,gBAAA;EAAkB,0BiFz0DvB;AhGkkevB;AexvaI;EAAoB,gBAAA;EAAkB,0BiF10DnB;AhGskevB;Ae3vaI;EAAqC,gBAAA;EAAkB,0BiF30DpC;AhG0kevB;Ae9vaI;EAAoC,gBAAA;EAAkB,0BiF50DnC;AhG8kevB;AejwaI;EAA0B,gBAAA;EAAkB,0BiF70DzB;AhGklevB;AepwaI;EAAiC,gBAAA;EAAkB,0BiF90DhC;AhGslevB;AevwaI;EAA2B,gBAAA;EAAkB,0BiF/0D1B;AhG0levB;Ae1waI;EAA2B,gBAAA;EAAkB,0BiFh1D1B;AhG8levB;Ae7waI;EAAwB,gBAAA;EAAkB,0BiFj1DvB;AhGkmevB;AehxaI;EAAwB,gBAAA;EAAkB,0BiFl1DvB;AhGsmevB;AenxaI;EAAqB,gBAAA;EAAkB,0BiFn1DpB;AhG0mevB;AetxaI;EAAqB,gBAAA;EAAkB,0BiFp1DpB;AhG8mevB;AezxaI;EAA4B,gBAAA;EAAkB,0BiFr1D3B;AhGknevB;Ae5xaI;EAA6B,gBAAA;EAAkB,0BiFt1D5B;AhGsnevB;Ae/xaI;EAAsB,gBAAA;EAAkB,0BiFv1DrB;AhG0nevB;AelyaI;EAAuB,gBAAA;EAAkB,0BiFx1DtB;AhG8nevB;AeryaI;EAAuB,gBAAA;EAAkB,0BiFz1DtB;AhGkoevB;AexyaI;EAAqC,gBAAA;EAAkB,0BiF11DpC;AhGsoevB;Ae3yaI;EAAqB,gBAAA;EAAkB,0BiF31DpB;AhG0oevB;Ae9yaI;EAAqB,gBAAA;EAAkB,0BiF51DpB;AhG8oevB;AejzaI;EAAsB,gBAAA;EAAkB,0BiF71DrB;AhGkpevB;AepzaI;EAAwB,gBAAA;EAAkB,0BiF91DvB;AhGspevB;AevzaI;EAA+B,gBAAA;EAAkB,0BiF/1D9B;AhG0pevB;Ae1zaI;EAAsB,gBAAA;EAAkB,0BiFh2DrB;AhG8pevB;Ae1zaI;EAAiC,gBAAA;EAAkB,0BiFp2DhC;AhGkqevB;Ae7zaI;EAAsC,gBAAA;EAAkB,0BiFr2DrC;AhGsqevB;Aeh0aI;EAAqB,gBAAA;EAAkB,0BiFt2DpB;AhG0qevB;Aen0aI;EAAiC,gBAAA;EAAkB,0BiFv2DhC;AhG8qevB;Aet0aI;EAAsC,gBAAA;EAAkB,0BiFx2DrC;AhGkrevB;Aez0aI;EAAuC,gBAAA;EAAkB,0BiFz2DtC;AhGsrevB;Ae50aI;EAA6C,gBAAA;EAAkB,0BiF12D5C;AhG0revB;Ae/0aI;EAAwC,gBAAA;EAAkB,0BiF32DvC;AhG8revB;Ael1aI;EAAqC,gBAAA;EAAkB,0BiF52DpC;AhGksevB;Aer1aI;EAAgC,gBAAA;EAAkB,0BiF72D/B;AhGssevB;Aex1aI;EAAuC,gBAAA;EAAkB,0BiF92DtC;AhG0sevB;Ae31aI;EAAmC,gBAAA;EAAkB,0BiF/2DlC;AhG8sevB;Ae91aI;EAAmC,gBAAA;EAAkB,0BiFh3DlC;AhGktevB;Aej2aI;EAAiC,gBAAA;EAAkB,0BiFj3DhC;AhGstevB;Aep2aI;EAA4B,gBAAA;EAAkB,0BiFl3D3B;AhG0tevB;Aev2aI;EAAiC,gBAAA;EAAkB,0BiFn3DhC;AhG8tevB;Ae12aI;EAAyB,gBAAA;EAAkB,0BiFp3DxB;AhGkuevB;Ae72aI;EAA8B,gBAAA;EAAkB,0BiFr3D7B;AhGsuevB;Aeh3aI;EAA6B,gBAAA;EAAkB,0BiFt3D5B;AhG0uevB;Aen3aI;EAAwB,gBAAA;EAAkB,0BiFv3DvB;AhG8uevB;Aet3aI;EAAwB,gBAAA;EAAkB,0BiFx3DvB;AhGkvevB;Aez3aI;EAA+B,gBAAA;EAAkB,0BiFz3D9B;AhGsvevB;Ae53aI;EAAmB,gBAAA;EAAkB,0BiF13DlB;AhG0vevB;Ae/3aI;EAAkC,gBAAA;EAAkB,0BiF33DjC;AhG8vevB;Ael4aI;EAAoC,gBAAA;EAAkB,0BiF53DnC;AhGkwevB;Aer4aI;EAAuB,gBAAA;EAAkB,0BiF73DtB;AhGswevB;Aex4aI;EAAmC,gBAAA;EAAkB,0BiF93DlC;AhG0wevB;Ae34aI;EAAqC,gBAAA;EAAkB,0BiF/3DpC;AhG8wevB;Ae94aI;EAAoC,gBAAA;EAAkB,0BiFh4DnC;AhGkxevB;Aej5aI;EAAyC,gBAAA;EAAkB,0BiFj4DxC;AhGsxevB;Aep5aI;EAAoB,gBAAA;EAAkB,0BiFl4DnB;AhG0xevB;Aev5aI;EAAgC,gBAAA;EAAkB,0BiFn4D/B;AhG8xevB;Ae15aI;EAA2B,gBAAA;EAAkB,0BiFp4D1B;AhGkyevB;Ae75aI;EAAgC,gBAAA;EAAkB,0BiFr4D/B;AhGsyevB;Aeh6aI;EAA+B,gBAAA;EAAkB,0BiFt4D9B;AhG0yevB;Aen6aI;EAAwB,gBAAA;EAAkB,0BiFv4DvB;AhG8yevB;Aet6aI;EAA+B,gBAAA;EAAkB,0BiFx4D9B;AhGkzevB;Aez6aI;EAA6B,gBAAA;EAAkB,0BiFz4D5B;AhGszevB;Ae56aI;EAA4B,gBAAA;EAAkB,0BiF14D3B;AhG0zevB;Ae/6aI;EAA+B,gBAAA;EAAkB,0BiF34D9B;AhG8zevB;Ael7aI;EAAuB,gBAAA;EAAkB,0BiF54DtB;AhGk0evB;Aer7aI;EAA4B,gBAAA;EAAkB,0BiF74D3B;AhGs0evB;Aex7aI;EAA2B,gBAAA;EAAkB,0BiF94D1B;AhG00evB;Ae37aI;EAAqB,gBAAA;EAAkB,0BiF/4DpB;AhG80evB;Ae97aI;EAA0B,gBAAA;EAAkB,0BiFh5DzB;AhGk1evB;Aej8aI;EAAuB,gBAAA;EAAkB,0BiFj5DtB;AhGs1evB;Aep8aI;EAA0B,gBAAA;EAAkB,0BiFl5DzB;AhG01evB;Aev8aI;EAAmC,gBAAA;EAAkB,0BiFn5DlC;AhG81evB;Ae18aI;EAAgC,gBAAA;EAAkB,0BiFp5D/B;AhGk2evB;Ae78aI;EAAmB,gBAAA;EAAkB,0BiFr5DlB;AhGs2evB;Aeh9aI;EAA4B,gBAAA;EAAkB,0BiFt5D3B;AhG02evB;Aen9aI;EAA6B,gBAAA;EAAkB,0BiFv5D5B;AhG82evB;AgBv4eE;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,6BkFPsB;AlGg5e1B;AgBt4eE;EACE,cAAA;AhBw4eJ;AgBr4eE;;EAEE,cAAA;EACA,eAAA;EACA,YAAA;AhBu4eJ;AgB/3eE;;EAEE,aAAA;AhBi4eJ;AgB/3eE;;EAEE,cAAA;EACA,kBAAA;AhBi4eJ;AgB/3eE;EACE,qBAAA;EACA,kBAAA;AhBi4eJ;AgB73eE;;EAEE,eAAA;EACA,a+EjDe;A/Fg7enB;AgBl3eE;;;EAGE,qBAAA;AhBo3eJ;AgB72eE;;;;EAIE,qBAAA;EACA,mBAAA;AhB+2eJ;AgB72eE;;;;EAIE,qBAAA;EACA,sBAAA;AhB+2eJ;AgB72eE;;;;EAIE,qBAAA;EACA,sBAAA;AhB+2eJ;AgBx2eE;;;;EAIE,uBkFhG0B;AlG08e9B;AgBn2eE;;;;;;EAME,oCkFzGW;AlG88ef;AgB91eE;;EAEE,gBAAA;AhBg2eJ;AgB71eE;;;;EAIE,6BgEjIc;EhEkId,0BgElIc;EhEmId,qBgEnIc;AhFk+elB;AgBx1eE;;;;;;EAME,cAAA;EACA,WAAA;EACA,YAAA;AhB01eJ;AgBl1eE;;;;;;EAME,oBkFlJkB;ElFoJlB,qBAAA;EACA,UkFtJgB;ElFuJhB,WkFvJgB;ElFyJhB,6BgEtKc;EhEuKd,0BgEvKc;EhEwKd,qBgExKc;AhF0/elB;AgB30eE;EACE,gCAAA;EACA,kBkF7JoB;ElF8JpB,mBkF9JoB;AlG2+exB;AgB10eE;EACE,kBkFlKoB;ElFmKpB,eAAA;AhB40eJ;AgBz0eE;EACE,cAAA;EACA,mBkFxKoB;AlGm/exB;AgBp0eE;;EAEE,WAAA;EACA,iBkF/K8B;ElFgL9B,kBkF/K4B;AlGq/ehC;AgBp0eE;;EAEE,YAAA;EACA,eAAA;EACA,kBkFrL4B;ElFsL5B,gBkFvL8B;AlG6/elC;AgBn0eE;;EAEE,gBAAA;AhBq0eJ;AgBj0eE;;EAEE,iBAAA;EACA,kBAAA;AhBm0eJ;AgB5zeE;;;;EAIE,WkF1Me;ElF2Mf,YAAA;EACA,0B+D1NG;A/EwhfP;AgB5zeE;;;;EAIE,WkFjNe;ElFkNf,YAAA;EACA,0B+DjOG;A/E+hfP;AgB5zeE;;;;EAIE,YkFxNgB;ElFyNhB,YAAA;EACA,0B+DxOI;A/EsifR;AgB5zeE;;;;EAIE,YkF/NiB;ElFgOjB,YAAA;EACA,e+D/OK;A/E6ifT;AgB5zeE;;;;EAIE,YkFtOgB;ElFuOhB,YAAA;EACA,0B+DtPI;A/EojfR;AgB5zeE;;;;EAIE,YkF7Oc;ElF8Od,YAAA;EACA,0B+D7PE;A/E2jfN;AgB5zeE;;;;EAIE,YkFpPe;ElFqPf,YAAA;EACA,0B+DpQG;A/EkkfP;AgB5zeE;;;;EAIE,YkF3PkB;ElF4PlB,YAAA;EACA,0B+D3QM;A/EykfV;AgBtzeE;EACE,YAAA;EACA,oBAAA;AhBwzeJ;AgBrzeE;;;EAGE,qBAAA;EACA,wBAAA;AhBuzeJ;AiB7lfE;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BgDdS;AjE6mfb;AiB7lfE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mDAAA;EACA,gBkFXe;ElFYf,2BmFVgB;EnFYhB,6E6CzBQ;E7C0BR,2BmFrBY;EnFuBZ,mBgE3BI;EhE4BJ,wCkFfW;ElFgBX,0BgD9BS;EhD+BT,8B2D5BG;E3D6BH,wDkFbF;ElFeE,gBkFnBe;AnG+mfnB;AiBllfE;EACE,yCmFpCsB;ApGwnf1B;AiBllfE;EACE,yCmFvCsB;ApG2nf1B;AiBllfE;EACE,yCmF1CsB;ApG8nf1B;AiBxkfE;;EAEE,a8EpEe;A/F8ofnB;AiBvkfE;;EAEE,oBAAA;AjBykfJ;AiBlkfE;;EAEE,gCkFhBsB;ElFiBtB,mBkFhBoB;ElFiBpB,0BgDjFS;EhDkFT,gBkFhBoB;AnGolfxB;AiB7jfE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2C6D9FY;E7D+FZ,qB8DrEW;E9DsEX,sB8DtEW;E9DwEX,qB+DpGc;E/DqGd,sCAAA;AjB6jfJ;AiB3jfE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2C6D3GY;E7D4GZ,qB8DlFW;E9DmFX,sB8DnFW;E9DqFX,sCAAA;EAEA,2BAAA;EACA,qB+DpHc;E/DsHd,iCAAA;AjByjfJ;AiBjjfE;;EAEE,qBmF3GwB;EnF4GxB,mBgE/HI;EhEgIJ,yB4D/HiB;E5DgIjB,gBkF1DqB;AnG6mfzB;AiBjjfE;;EAEE,yCmF5H4B;ApG+qfhC;AiBjjfE;;EAEE,yCmFhI4B;ApGmrfhC;AiBjjfE;;EAEE,yCmFpI4B;ApGurfhC;AiB1ifE;EACE,yBoFjJwB;EpFkJxB,qBmEzJoB;EnE0JpB,cqF1JkB;ErF2JlB,gBkF7EqB;AnGynfzB;AiBxifE;EACE,0DkFhF4B;AnG0nfhC;AiBxifE;EACE,0DkFnF4B;AnG6nfhC;AiBxifE;EACE,qEAAA;AjB0ifJ;AiBtifE;EACE,0DkF1FkC;AnGkoftC;AiBtifE;EACE,0DkF7FkC;AnGqoftC;AiBtifE;EACE,qEAAA;AjBwifJ;AiB5hfI;;EAEE,oCAAA;EACA,wCAAA;EACA,UAAA;EACA,2BAAA;EACA,2BAAA;AjB8hfN;AiB5hfI;EACE,2BmFjMU;ApG+tfhB;AiB1hfI;EACE,Y6CxLQ;A9Dotfd;AiB1hfI;EACE,eAAA;EACA,kBkF3K0B;AnGusfhC;AiB1hfI;EACE,iBkF9K0B;ElF+K1B,gBAAA;AjB4hfN;AiBxhfI;EACE,cgEvNE;AjFivfR;AiBxhfI;;EAEE,cAAA;AjB0hfN;AiBvhfI;EACE,+B4DtN2B;A7E+ufjC;AiBvhfI;EACE,+B4DzN2B;A7EkvfjC;AiBvhfI;EACE,+B4D5N2B;A7EqvfjC;AiB/gfI;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EAEA,qBkFhOa;ElFiOb,YkFhOe;ElFiOf,kDAAA;EACA,6BkF5NkB;AnG4ufxB;AiB9gfI;EACE,oBAAA;AjBghfN;AiB9gfI;;EAEE,6BkFpOc;AnGovfpB;AiB7gfI;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kBkFjPc;AnGgwfpB;AiB7gfI;EACE,eAAA;AjB+gfN;AiB7gfI;EACE,WkF1OgC;ElF2OhC,YkF1OkC;AnGyvfxC;AiB3gfI;EACE,WAAA;EACA,SkF9Qe;ElF+Qf,kDAAA;AjB6gfN;AiB3gfI;EACE,WAAA;EACA,WkFrPkC;AnGkwfxC;AiB3gfI;;EAEE,4BkFpQc;ElFqQd,kB2DvNS;A5Eouff;AiBzgfI;;EAEE,UAAA;AjB2gfN;AiBjgfI;EACE,cAAA;EACA,SAAA;EACA,c8D/RY;A/EkyflB;AiBjgfI;EACE,2B2DhPS;E3DiPT,8B2DjPS;A5Eovff;AiB//eI;EACE,0BAAA;EACA,6BAAA;AjBigfN;AiB//eI;EACE,yBAAA;EACA,4BAAA;EACA,8BAAA;AjBigfN;AiB//eI;EACE,0BmFtTsB;ApGuzf5B;AiB7/eI;EACE,qCAAA;EACA,wCAAA;EACA,0CAAA;AjB+/eN;AiB7/eI;EACE,yBAAA;EACA,4BAAA;AjB+/eN;AiB5/eI;EACE,sCAAA;AjB8/eN;AiB1/eI;EACE,QkFjVe;ElFkVf,UkFlVe;ElFmVf,yB2DvRQ;E3DwRR,oCAAA;AjB4/eN;AiBx/eI;;EAEE,+BAAA;AjB0/eN;AiBx/eI;;EAEE,gCAAA;AjB0/eN;AiBx/eI;EACE,oBkFxTsB;AnGkzf5B;AiBt/eI;;EAEE,8BAAA;AjBw/eN;AiBt/eI;;EAEE,+BAAA;AjBw/eN;AiBt/eI;EACE,mBkFrUsB;AnG6zf5B;AiBt/eI;EACE,WkFxVuB;AnGg1f7B;AiBt/eI;EACE,akF1VmC;AnGk1fzC;AiBp/eI;EACE,QkFzXe;ElF0Xf,UkF1Xe;AnGg3frB;AiBp/eI;EACE,WAAA;EACA,SkF9Xe;AnGo3frB;AiBl/eI;;;;EAIE,6BAAA;EACA,gCAAA;AjBo/eN;AiBl/eI;;;;EAIE,8BAAA;AjBo/eN;AiBl/eI;;;;EAIE,+BAAA;AjBo/eN;AiBl/eI;;EAEE,8BAAA;AjBo/eN;AiB3+eI;;EAEE,aAAA;EACA,mBAAA;EACA,cAAA;AjB6+eN;AiB3+eI;;EAEE,2B2D1WS;E3D2WT,8B2D3WS;E3D4WT,SAAA;AjB6+eN;AiBz+eI;EACE,qCAAA;EACA,wCAAA;EACA,0CAAA;AjB2+eN;AiBz+eI;;;EAGE,gBAAA;AjB2+eN;AiBz+eI;;;EAGE,kDAAA;AjB2+eN;AiBv+eI;EACE,sCAAA;AjBy+eN;AiBr+eI;EACE,oCAAA;EACA,uCAAA;EACA,yCAAA;AjBu+eN;AiBr+eI;;;EAGE,gBAAA;AjBu+eN;AiBr+eI;;;EAGE,kDAAA;AjBu+eN;AiBp+eI;EACE,qCAAA;AjBs+eN;AiB79eE;EACE,YAAA;AjB+9eJ;AiBx9eE;EACE,aAAA;AjB09eJ;AiBx9eE;EACE,mBAAA;AjB09eJ;AiBn9eE;EACE,yB8DzeY;A/E87fhB;AiBn9eE;EACE,yB8D3eY;A/Eg8fhB;AiBn9eE;EACE,yB8D7ea;A/Ek8fjB;AiBn9eE;EACE,c8D/ec;A/Eo8flB;AiBn9eE;EACE,yB8Djfa;A/Es8fjB;AiBn9eE;EACE,yB8DnfW;A/Ew8ff;AiBn9eE;EACE,yB8DrfY;A/E08fhB;AiBn9eE;EACE,yB8Dvfe;A/E48fnB;AkBr+fE;EACE,qBAAA;EACA,cAAA;EACA,wBqFLmB;ErFOnB,wBAAA;EAEA,yBqFNqB;ErFOrB,sBqFLqB;ErFMrB,yBAAA;EACA,yB2DhBe;E3DkBf,oBqFLmB;ErFMnB,iB4CPG;E5CSH,2BqFLW;ErFMX,8B0DjBG;E1DkBH,gCqFDe;AvGo+fnB;AkBh+fE;EACE,cAAA;AlBk+fJ;AkBh+fE;EACE,eAAA;AlBk+fJ;AkB99fE;EACE,eAAA;AlBg+fJ;AkB59fE;EACE,eAAA;EACA,cAAA;EACA,YqFXiB;ErFYjB,6BqFXoB;AvGy+fxB;AkB59fE;EACE,UAAA;AlB89fJ;AkB19fE;EACE,sBAAA;EACA,sBAAA;EACA,gBqFfiB;AvG2+frB;AkBx9fE;;EAEE,WAAA;EACA,oBAAA;AlB09fJ;AkBt9fE;EACE,qBAAA;EACA,mBAAA;EACA,iB4CvDG;E5CwDH,gBqFxBkB;ErFyBlB,YqF3BmB;AvGm/fvB;AkBt9fE;EACE,oBAAA;AlBw9fJ;AkBp9fE;;EAEE,eAAA;EACA,yB6DrDa;E7DsDb,YqFjDiB;ErFkDjB,gCqF/BsB;AvGq/f1B;AkBp9fE;;EAEE,UAAA;AlBs9fJ;AkBl9fE;;EAEE,mBAAA;AlBo9fJ;AkBl9fE;;EAEE,mBAAA;AlBo9fJ;AkBh9fE;EACE,cAAA;AlBk9fJ;AkB98fE;EACE,oBAAA;AlBg9fJ;AkBz8fE;EACE,uBAAA;AlB28fJ;AkBn8fE;EACE,sBqFxGuB;AvG6igB3B;AkBh8fE;;EAEE,yBAAA;AlBk8fJ;AkBh8fE;;EAEE,0BAAA;AlBk8fJ;AkBh8fE;EACE,4BAAA;AlBk8fJ;AkBh8fE;EACE,6BAAA;AlBk8fJ;AkB97fE;;EAEE,2BAAA;AlBg8fJ;AkB97fE;EACE,aAAA;EACA,8BAAA;AlBg8fJ;AkBx7fI;EACE,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,oBAAA;EAEA,mBqF9JmB;ErF+JnB,wCqFxGgB;ErFyGhB,8B0DlKC;E1DmKD,gBqF3GmB;AvGoigBzB;AkBt7fI;EACE,qBAAA;EACA,mBAAA;EAEA,gBqFzIe;ErF0If,wCqFhHqB;ErFiHrB,kDqFhH4B;AvGuigBlC;AkBp7fI;EACE,8BuEnLqB;EvEoLrB,0CqFhHsB;ErFiHtB,yBqFlHuB;ErFmHvB,kDAAA;AlBs7fN;AkB76fI;;EAEE,gBAAA;EACA,kBAAA;EACA,mBqFxFyB;ErFyFzB,oBqFzFyB;ErF2FzB,kDAAA;EACA,gBqFrFiB;AvGmggBvB;AkB56fI;;EAEI,kBAAA;EACA,0DAAA;EAEA,QqF/FwB;ErFgGxB,WqFjG0B;ErFkG1B,WAAA;EAEA,yBAAA;EACA,sBqFlG8B;ErFoG9B,aqFrGkB;ErFsGlB,cqFtGkB;ErFuGlB,gBqFrGe;AvGghgBvB;AkBv6fI;;EAEE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EAEA,mBAAA;EACA,yB+DlOE;E/DmOF,YqF1HkB;ErF2HlB,aqF3HkB;ErF6HlB,2CqF3HwB;ErF4HxB,qB8DzOY;AhFgpgBlB;AkBn6fM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,uBqFnJ+B;AvGwjgBvC;AkBn6fM;;EAEE,2CqFxI4B;AvG6igBpC;AkB35fI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EAEA,qBqFlQmB;ErFoQnB,UqF1EuB;ErF2EvB,WqF3EuB;ErF4EvB,UqF1E0B;ErF2E1B,kCqF5E6B;AvGu+fnC;AkBv5fI;EACE,wCAAA;AlBy5fN;AkBv5fI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EAEA,QAAA;EACA,SAAA;EACA,6BAAA;EAEA,+BAAA;EACA,mCAAA;EACA,oCAAA;EACA,gCAAA;EAEA,2BAAA;EACA,kCqFpG6B;AvG0/fnC;AkBn5fI;EACE,eAAA;EACA,kBAAA;EACA,mB0DjOQ;E1DkOR,UAAA;EACA,qB0DpOQ;E1DqOR,yB6DnRW;E7DoRX,SAAA;AlBq5fN;AkBj5fI;;EAEE,WAAA;EACA,OAAA;AlBm5fN;AkBj5fI;EACE,iCAAA;EACA,mCAAA;EACA,kCAAA;EACA,gCAAA;EAEA,yBAAA;AlBk5fN;AkBh5fI;EACE,oB0DxPQ;E1DyPR,WAAA;AlBk5fN;AkB94fI;EACE,SAAA;EACA,WAAA;AlBg5fN;AkB94fI;EACE,WAAA;EACA,UAAA;AlBg5fN;AkBv4fI;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,kDAAA;EACA,iCqFjOsB;AvG0mgB5B;AkBt4fI;EACE,kBAAA;EACA,WAAA;EAEA,SAAA;EACA,OAAA;EACA,6BAAA;EAEA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,2BAAA;EAEA,QAAA;EACA,SAAA;AlBq4fN;AkBl4fI;EACE,yBqFnPiB;ErFoPjB,oBAAA;EACA,gCqFnPmB;ErFoPnB,oBqF5PuB;AvGgogB7B;AkBl4fI;EACE,+BqFtPuB;ErFuPvB,mBqFhQuB;ErFiQvB,iCqFzPmB;AvG6ngBzB;AkBl4fI;EACE,iCqF7PuB;ErF8PvB,oCqF9PuB;AvGkogB7B;AkBl4fI;EACE,sCqFtQqC;ErFuQrC,gCqFxQ8B;AvG4ogBpC;AkBl4fI;EACE,+BqF3Q8B;ErF4Q9B,uCqF3QqC;AvG+ogB3C;AkBl4fI;EACE,qBqFvSiC;AvG2qgBvC;AkBl4fI;EACE,UqF3S4B;AvG+qgBlC;AkBl4fI;EACE,WqF9S4B;AvGkrgBlC;AkBh4fI;EACE,gBAAA;EACA,4BAAA;EACA,kDAAA;AlBk4fN;AkBh4fI;EACE,UAAA;EACA,QAAA;EAEA,mBAAA;EACA,6BAAA;EACA,yBAAA;EACA,yBAAA;AlBi4fN;AkB73fI;;EAEE,kBAAA;EACA,SqFlS4B;AvGiqgBlC;AkB73fI;;EAEE,2BqFpSuB;AvGmqgB7B;AkB73fI;;EAEE,mCqFvS6B;ErFwS7B,qBqFlaqB;AvGiygB3B;AkB33fI;EACE,wBqF1SuB;AvGuqgB7B;AkB33fI;EACE,8BqF5S6B;ErF6S7B,qBqF3aqB;AvGwygB3B;AkBn3fI;;EAEE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,OAAA;EAEA,mBAAA;EAEA,kDAAA;AlBm3fN;AkBj3fI;EACE,SAAA;EACA,SAAA;EACA,kDAAA;AlBm3fN;AkBh3fI;EACE,WAAA;EACA,wBAAA;EACA,kDAAA;AlBk3fN;AkB/2fI;EACE,WAAA;EACA,UAAA;EACA,QAAA;EACA,kDAAA;AlBi3fN;AkB/2fI;EACE,WAAA;EACA,SAAA;EACA,SAAA;EACA,kDAAA;AlBi3fN;AkB/2fI;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,kDAAA;AlBi3fN;AkBr2fE;EACE,YAAA;AlBu2fJ;AkBh2fE;;EAEE,yBqFrb2B;ErFsb3B,qBqFtb2B;ErFwb3B,sBqFvb2B;ErFwb3B,yB2DhgBiB;A7Ei2gBrB;AkB/1fE;;EAEE,yB2DpgBiB;A7Eq2gBrB;AkB11fE;EACE,yBqFhc4B;ErFic5B,qBqFjc4B;ErFmc5B,sBqFlc4B;ErFmc5B,0B2D9gBkB;A7Ey2gBtB;AkBz1fE;EACE,yBqFvc4B;ErFwc5B,sBqFvc4B;ErFwc5B,0B2DnhBkB;A7E82gBtB;AkBp1fE;;EAEE,yBqF7ckC;ErF8clC,qBqF9ckC;ErFgdlC,sBqF/ckC;ErFgdlC,0B2DhiBkB;A7Eq3gBtB;AkBn1fE;;EAEE,yBqFrdkC;ErFsdlC,sBqFrdkC;ErFsdlC,0B2DtiBkB;A7E23gBtB;AkB70fE;;EAEE,gCAAA;AlB+0fJ;AkBx0fE;;EAEE,wBAAA;AlB00fJ;AkB5zfI;;EAEE,wBqFlfmB;ErFmfnB,wCqF/ee;ErFgff,0B+C/kBO;E/CglBP,gBqF/emB;AvG6ygBzB;AkB1zfI;;EAEE,qBAAA;EACA,wBqF5fmB;ErF6fnB,wDoDxlBa;EpDylBb,gBqFxfmB;AvGozgBzB;AkBnzfE;;EAEE,WAAA;EACA,sBAAA;AlBqzfJ;AkB7yfI;;EAEE,+B2DxmBgB;E3DymBhB,yBqFte4B;AvGqxgBlC;AkB7yfI;EACI,qBqFze0B;AvGwxgBlC;AkB7yfI;EACI,qBqFjnBiB;ErFknBjB,gBAAA;AlB+yfR;AkB7yfI;;;EAGE,sCqF7e8B;ErF8e9B,mBiEpnBE;AnFm6gBR;AkB7yfI;EACE,ckDnoBO;ApEk7gBb;AkB3xfM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,+BAXgB;AlBwyfxB;AkB1xfM;;EAEE,oEAfY;EAgBZ,gEAhBY;EAiBZ,cAfqB;AlB2yf7B;AkBzxfM;EACE,gEAlBmB;AlB6yf3B;AkBxxfM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlByzfpB;AkBxxfM;;EAEE,wBqFnlBiB;ErFolBjB,gEAjCY;EAkCZ,yDAlCY;AlB4zfpB;AkBvxfM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFu8gBR;AkBtxfM;;EAEE,8CA7CoB;EA8CpB,0CA9CoB;EAgDlB,ciEtrBF;AnF68gBR;AkBhxfM;EACE,0CArD2B;AlBu0fnC;AkB/wfM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlBm1f5B;AkB1wfM;;EAEE,0CAxEoB;EAyEpB,yBiE/sBA;EjEitBE,mCA3EkB;AlBs1f5B;AkBvwfM;;EAEE,yBAAA;AlBywfR;AkBvwfM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlBywfR;AkB71fM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,+BAXgB;AlB02fxB;AkB51fM;;EAEE,0DAfY;EAgBZ,sDAhBY;EAiBZ,cAfqB;AlB62f7B;AkB31fM;EACE,kDAlBmB;AlB+2f3B;AkB11fM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlB23fpB;AkB11fM;;EAEE,wBqFnlBiB;ErFolBjB,sDAjCY;EAkCZ,+CAlCY;AlB83fpB;AkBz1fM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFyghBR;AkBx1fM;;EAEE,2CA7CoB;EA8CpB,uCA9CoB;EAgDlB,ciEtrBF;AnF+ghBR;AkBl1fM;EACE,mCArD2B;AlBy4fnC;AkBj1fM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlBq5f5B;AkB50fM;;EAEE,uCAxEoB;EAyEpB,yBiE/sBA;EjEitBE,gCA3EkB;AlBw5f5B;AkBz0fM;;EAEE,yBAAA;AlB20fR;AkBz0fM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlB20fR;AkB/5fM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlB46fxB;AkB95fM;;EAEE,mEAfY;EAgBZ,+DAhBY;EAiBZ,cAfqB;AlB+6f7B;AkB75fM;EACE,+DAlBmB;AlBi7f3B;AkB55fM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlB67fpB;AkB55fM;;EAEE,wBqFnlBiB;ErFolBjB,+DAjCY;EAkCZ,wDAlCY;AlBg8fpB;AkB35fM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnF2khBR;AkB15fM;;EAEE,6CA7CoB;EA8CpB,yCA9CoB;EAgDlB,ciEtrBF;AnFilhBR;AkBp5fM;EACE,yCArD2B;AlB28fnC;AkBn5fM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlBu9f5B;AkB94fM;;EAEE,yCAxEoB;EAyEpB,yBiE/sBA;EjEitBE,kCA3EkB;AlB09f5B;AkB34fM;;EAEE,yBAAA;AlB64fR;AkB34fM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlB64fR;AkBj+fM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlB8+fxB;AkBh+fM;;EAEE,wDAfY;EAgBZ,oDAhBY;EAiBZ,cAfqB;AlBi/f7B;AkB/9fM;EACE,4CAlBmB;AlBm/f3B;AkB99fM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlB+/fpB;AkB99fM;;EAEE,wBqFnlBiB;ErFolBjB,oDAjCY;EAkCZ,6CAlCY;AlBkggBpB;AkB79fM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnF6ohBR;AkB59fM;;EAEE,6CA7CoB;EA8CpB,yCA9CoB;EAgDlB,ciEtrBF;AnFmphBR;AkBt9fM;EACE,yCArD2B;AlB6ggBnC;AkBr9fM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlByhgB5B;AkBh9fM;;EAEE,yCAxEoB;EAyEpB,yBiE/sBA;EjEitBE,kCA3EkB;AlB4hgB5B;AkB78fM;;EAEE,yBAAA;AlB+8fR;AkB78fM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlB+8fR;AkBnigBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlBgjgBxB;AkBligBM;;EAEE,+CAfY;EAgBZ,2CAhBY;EAiBZ,cAfqB;AlBmjgB7B;AkBjigBM;EACE,+DAlBmB;AlBqjgB3B;AkBhigBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlBikgBpB;AkBhigBM;;EAEE,wBqFnlBiB;ErFolBjB,2CAjCY;EAkCZ,oCAlCY;AlBokgBpB;AkB/hgBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnF+shBR;AkB9hgBM;;EAEE,6CA7CoB;EA8CpB,yCA9CoB;EAgDlB,ciEtrBF;AnFqthBR;AkBxhgBM;EACE,yCArD2B;AlB+kgBnC;AkBvhgBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlB2lgB5B;AkBlhgBM;;EAEE,yCAxEoB;EAyEpB,yBiE/sBA;EjEitBE,kCA3EkB;AlB8lgB5B;AkB/ggBM;;EAEE,yBAAA;AlBihgBR;AkB/ggBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlBihgBR;AkBrmgBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlBkngBxB;AkBpmgBM;;EAEE,oEAfY;EAgBZ,gEAhBY;EAiBZ,cAfqB;AlBqngB7B;AkBnmgBM;EACE,gEAlBmB;AlBungB3B;AkBlmgBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlBmogBpB;AkBlmgBM;;EAEE,wBqFnlBiB;ErFolBjB,gEAjCY;EAkCZ,yDAlCY;AlBsogBpB;AkBjmgBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFixhBR;AkBhmgBM;;EAEE,oEA7CoB;EA8CpB,gEA9CoB;EAgDlB,ciEtrBF;AnFuxhBR;AkB1lgBM;EACE,gEArD2B;AlBipgBnC;AkBzlgBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlB6pgB5B;AkBplgBM;;EAEE,gEAxEoB;EAyEpB,yBiE/sBA;EjEitBE,yDA3EkB;AlBgqgB5B;AkBjlgBM;;EAEE,yBAAA;AlBmlgBR;AkBjlgBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlBmlgBR;AkBvqgBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlBorgBxB;AkBtqgBM;;EAEE,mEAfY;EAgBZ,+DAhBY;EAiBZ,cAfqB;AlBurgB7B;AkBrqgBM;EACE,+DAlBmB;AlByrgB3B;AkBpqgBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlBqsgBpB;AkBpqgBM;;EAEE,wBqFnlBiB;ErFolBjB,+DAjCY;EAkCZ,wDAlCY;AlBwsgBpB;AkBnqgBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFm1hBR;AkBlqgBM;;EAEE,qDA7CoB;EA8CpB,iDA9CoB;EAgDlB,ciEtrBF;AnFy1hBR;AkB5pgBM;EACE,0CArD2B;AlBmtgBnC;AkB3pgBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlB+tgB5B;AkBtpgBM;;EAEE,iDAxEoB;EAyEpB,yBiE/sBA;EjEitBE,0CA3EkB;AlBkugB5B;AkBnpgBM;;EAEE,yBAAA;AlBqpgBR;AkBnpgBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlBqpgBR;AkBzugBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlBsvgBxB;AkBxugBM;;EAEE,+CAfY;EAgBZ,2CAhBY;EAiBZ,cAfqB;AlByvgB7B;AkBvugBM;EACE,yCAlBmB;AlB2vgB3B;AkBtugBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlBuwgBpB;AkBtugBM;;EAEE,wBqFnlBiB;ErFolBjB,2CAjCY;EAkCZ,oCAlCY;AlB0wgBpB;AkBrugBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFq5hBR;AkBpugBM;;EAEE,yBA7CoB;EA8CpB,qBA9CoB;EAgDlB,ciEtrBF;AnF25hBR;AkB9tgBM;EACE,qBArD2B;AlBqxgBnC;AkB7tgBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlBiygB5B;AkBxtgBM;;EAEE,qBAxEoB;EAyEpB,yBiE/sBA;EjEitBE,cA3EkB;AlBoygB5B;AkBrtgBM;;EAEE,yBAAA;AlButgBR;AkBrtgBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlButgBR;AkB3ygBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlBwzgBxB;AkB1ygBM;;EAEE,oEAfY;EAgBZ,gEAhBY;EAiBZ,cAfqB;AlB2zgB7B;AkBzygBM;EACE,gEAlBmB;AlB6zgB3B;AkBxygBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlBy0gBpB;AkBxygBM;;EAEE,wBqFnlBiB;ErFolBjB,gEAjCY;EAkCZ,yDAlCY;AlB40gBpB;AkBvygBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFu9hBR;AkBtygBM;;EAEE,8CA7CoB;EA8CpB,0CA9CoB;EAgDlB,ciEtrBF;AnF69hBR;AkBhygBM;EACE,0CArD2B;AlBu1gBnC;AkB/xgBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlBm2gB5B;AkB1xgBM;;EAEE,0CAxEoB;EAyEpB,yBiE/sBA;EjEitBE,mCA3EkB;AlBs2gB5B;AkBvxgBM;;EAEE,yBAAA;AlByxgBR;AkBvxgBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlByxgBR;AkB72gBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlB03gBxB;AkB52gBM;;EAEE,mEAfY;EAgBZ,+DAhBY;EAiBZ,cAfqB;AlB63gB7B;AkB32gBM;EACE,+DAlBmB;AlB+3gB3B;AkB12gBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlB24gBpB;AkB12gBM;;EAEE,wBqFnlBiB;ErFolBjB,+DAjCY;EAkCZ,wDAlCY;AlB84gBpB;AkBz2gBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFyhiBR;AkBx2gBM;;EAEE,8CA7CoB;EA8CpB,0CA9CoB;EAgDlB,ciEtrBF;AnF+hiBR;AkBl2gBM;EACE,gEArD2B;AlBy5gBnC;AkBj2gBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlBq6gB5B;AkB51gBM;;EAEE,0CAxEoB;EAyEpB,yBiE/sBA;EjEitBE,mCA3EkB;AlBw6gB5B;AkBz1gBM;;EAEE,yBAAA;AlB21gBR;AkBz1gBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlB21gBR;AkB/6gBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlB47gBxB;AkB96gBM;;EAEE,oEAfY;EAgBZ,gEAhBY;EAiBZ,cAfqB;AlB+7gB7B;AkB76gBM;EACE,gEAlBmB;AlBi8gB3B;AkB56gBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlB68gBpB;AkB56gBM;;EAEE,wBqFnlBiB;ErFolBjB,gEAjCY;EAkCZ,yDAlCY;AlBg9gBpB;AkB36gBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnF2liBR;AkB16gBM;;EAEE,sCA7CoB;EA8CpB,kCA9CoB;EAgDlB,ciEtrBF;AnFimiBR;AkBp6gBM;EACE,kCArD2B;AlB29gBnC;AkBn6gBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlBu+gB5B;AkB95gBM;;EAEE,kCAxEoB;EAyEpB,yBiE/sBA;EjEitBE,2BA3EkB;AlB0+gB5B;AkB35gBM;;EAEE,yBAAA;AlB65gBR;AkB35gBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlB65gBR;AkBj/gBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlB8/gBxB;AkBh/gBM;;EAEE,oEAfY;EAgBZ,gEAhBY;EAiBZ,cAfqB;AlBighB7B;AkB/+gBM;EACE,8DAlBmB;AlBmghB3B;AkB9+gBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlB+ghBpB;AkB9+gBM;;EAEE,wBqFnlBiB;ErFolBjB,gEAjCY;EAkCZ,yDAlCY;AlBkhhBpB;AkB7+gBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnF6piBR;AkB5+gBM;;EAEE,8CA7CoB;EA8CpB,0CA9CoB;EAgDlB,ciEtrBF;AnFmqiBR;AkBt+gBM;EACE,0CArD2B;AlB6hhBnC;AkBr+gBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlByihB5B;AkBh+gBM;;EAEE,0CAxEoB;EAyEpB,yBiE/sBA;EjEitBE,mCA3EkB;AlB4ihB5B;AkB79gBM;;EAEE,yBAAA;AlB+9gBR;AkB79gBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlB+9gBR;AkBnjhBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlBgkhBxB;AkBljhBM;;EAEE,mEAfY;EAgBZ,+DAhBY;EAiBZ,cAfqB;AlBmkhB7B;AkBjjhBM;EACE,+DAlBmB;AlBqkhB3B;AkBhjhBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlBilhBpB;AkBhjhBM;;EAEE,wBqFnlBiB;ErFolBjB,+DAjCY;EAkCZ,wDAlCY;AlBolhBpB;AkB/ihBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnF+tiBR;AkB9ihBM;;EAEE,mEA7CoB;EA8CpB,+DA9CoB;EAgDlB,ciEtrBF;AnFquiBR;AkBxihBM;EACE,8DArD2B;AlB+lhBnC;AkBvihBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAmElB,cAnEkB;AlB2mhB5B;AkBlihBM;;EAEE,+DAxEoB;EAyEpB,yBiE/sBA;EjEitBE,wDA3EkB;AlB8mhB5B;AkB/hhBM;;EAEE,yBAAA;AlBiihBR;AkB/hhBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlBiihBR;AkBrnhBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlBkohBxB;AkBpnhBM;;EAEE,8CAfY;EAgBZ,0CAhBY;EAiBZ,cAfqB;AlBqohB7B;AkBnnhBM;EACE,mCAlBmB;AlBuohB3B;AkBlnhBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlBmphBpB;AkBlnhBM;;EAEE,wBqFnlBiB;ErFolBjB,0CAjCY;EAkCZ,mCAlCY;AlBsphBpB;AkBjnhBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFiyiBR;AkBhnhBM;;EAEE,0CA7CoB;EA8CpB,sCA9CoB;EAmDlB,cArDc;AlBmqhBxB;AkB1mhBM;EACE,2CArD2B;AlBiqhBnC;AkBzmhBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAsElB,+B2D3sBY;A7EkziBtB;AkBpmhBM;;EAEE,sCAxEoB;EAyEpB,yBiE/sBA;AnFqziBR;AkBhmhBM;;EAEE,yBAAA;AlBkmhBR;AkBhmhBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlBkmhBR;AkBtrhBM;;EAEE,yBAXY;EAYZ,qBAZY;EAaZ,cAXgB;AlBmshBxB;AkBrrhBM;;EAEE,0DAfY;EAgBZ,sDAhBY;EAiBZ,cAfqB;AlBsshB7B;AkBprhBM;EACE,kDAlBmB;AlBwshB3B;AkBnrhBM;;EAEE,wBqF7kBiB;ErF8kBjB,qBA9BY;EA+BZ,cA/BY;AlBothBpB;AkBnrhBM;;EAEE,wBqFnlBiB;ErFolBjB,sDAjCY;EAkCZ,+CAlCY;AlButhBpB;AkBlrhBM;;EAEE,yBAzCoB;EA0CpB,qBA1CoB;EA2CpB,ciE9qBA;AnFk2iBR;AkBjrhBM;;EAEE,uBA7CoB;EA8CpB,mBA9CoB;EAmDlB,cArDc;AlBouhBxB;AkB3qhBM;EACE,sCArD2B;AlBkuhBnC;AkB1qhBM;;EAEE,yBiEnsBA;EjEosBA,qBAjEoB;EAsElB,+B2D3sBY;A7Em3iBtB;AkBrqhBM;;EAEE,mBAxEoB;EAyEpB,yBiE/sBA;AnFs3iBR;AkBjqhBM;;EAEE,yBAAA;AlBmqhBR;AkBjqhBM;;EAEE,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBiE9tBA;EjE+tBA,uBAAA;AlBmqhBR;AkBzphBI;;EAEE,mBAAA;EAEA,sBAAA;EACA,cqFziBuB;ErF0iBvB,kBAAA;AlB0phBN;AkBjphBI;;EAEE,cqF/iBoB;ErFgjBpB,eqFhjBoB;ErFkjBpB,yBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,qB8D3wBY;AhF45iBlB;AkB/ohBI;;EAEE,YAAA;EACA,aAAA;EACA,gBAAA;EACA,YqF5jBoB;ErF6jBpB,aqF7jBoB;ErF8jBpB,wBAAA;AlBiphBN;AkBxohBI;EACE,kBAAA;AlB0ohBN;AkBvohBI;EACE,kBAAA;AlByohBN;AkBtohBI;EACE,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBqFjlBwB;AvGytiB9B;AkBrohBI;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EAEA,UqFnlB4B;ErFolB5B,eqFxlByB;ErFylBzB,gBqFzlByB;ErF0lBzB,gBqFvlB+B;AvG6tiBrC;AkBlohBI;;EAEE,eqFjmB6B;AvGquiBnC;AkBlohBI;;EAEE,yBAAA;EACA,0DAAA;EACA,MAAA;EACA,SAAA;AlBoohBN;AkBjohBI;;EAEE,aAAA;EACA,kBqF9mB6B;AvGiviBnC;AkBjohBI;;EAEE,yBAAA;EACA,SAAA;EACA,WAAA;EACA,0DAAA;EACA,SAAA;EACA,SAAA;AlBmohBN;AkBhohBI;EACE,aAAA;EACA,qBqF3nByB;AvG6viB/B;AkBhohBI;EACE,yBAAA;EACA,0DAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;AlBkohBN;AkB/nhBI;EACE,aAAA;EACA,sBqFxoByB;AvGywiB/B;AkB/nhBI;EACE,yBAAA;EACA,yDAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AlBiohBN;AkBxnhBI;EACE,qBAAA;AlB0nhBN;AkBtnhBI;;EAEE,gBqFzpBiC;AvGixiBvC;AkBrnhBI;;EAEE,YAAA;EACA,SAAA;EACA,eAAA;AlBunhBN;AkBpnhBI;EACE,QAAA;EACA,UqFrqBiC;AvG2xiBvC;AkBnnhBI;EACE,QAAA;EACA,WqF1qBiC;AvG+xiBvC;AkB3mhBI;EACE,kBAAA;EACA,YqFhrBmB;ErFirBnB,SqFprBsB;ErFqrBtB,QAAA;EACA,mBAAA;EACA,0BAAA;AlB6mhBN;AkB3mhBI;EACE,4BAAA;AlB6mhBN;AkB3mhBI;EACE,OAAA;EACA,WAAA;EACA,2BAAA;AlB6mhBN;AkB3mhBI;EACE,6BAAA;AlB6mhBN;AkB3mhBI;EACE,SAAA;EACA,YqFtsBsB;AvGmziB5B;AkBrmhBE;;EAEE,0B0D76BG;A5EohjBP;AkBrmhBE;;EAEE,0B0Dh7BI;A5EuhjBR;AkBrmhBE;;EAEE,0B0Dn7BI;A5E0hjBR;AkBrmhBE;;EAEE,0B0Dt7BI;A5E6hjBR;AkBrmhBE;;EAEE,e6Dl6Bc;A/EygjBlB;AkBrmhBE;;EAEE,0B6Dp6BW;A/E2gjBf;AkBrmhBE;;EAEE,0B6Dv6BY;A/E8gjBhB;AkBrmhBE;;EAEE,0B6D16Be;A/EihjBnB;AmBrjjBE;;;EAGE,qBqFHc;ErFId,aqFFU;ErFGV,YAAA;AnBujjBJ;AmBpjjBE;;;EAGE,aAAA;EACA,cAAA;AnBsjjBJ;AmBnjjBE;;;EAGE,gBAAA;EACA,iBAAA;AnBqjjBJ;AmB7ijBE;;;;EAIE,kBAAA;EACA,mBAAA;EACA,qBqFjCc;ErFkCd,4BqFjCkB;ErFmClB,yBqF3BgB;ErF4BhB,2B4Dda;A/E4jjBjB;AmB3ijBE;;;;EAIE,WAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;AnB6ijBJ;AmB1ijBE;;;;EAIE,cAAA;AnB4ijBJ;AmB1ijBE;;;;EAIE,iBAAA;AnB4ijBJ;AmBxijBE;;;EAGE,WAAA;EACA,SAAA;EACA,8BqFzDiB;AxGmmjBrB;AmBtijBE;;;EAGE,yBqF1DsB;ErF2DtB,oBqF1D0B;AxGkmjB9B;AmBnijBE;;EAEE,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,cqF9De;ErF+Df,2BqF9DmB;AxGmmjBvB;AmBpijBI;;EACE,6ByD1BQ;EzD2BR,mBqF/D6B;AxGsmjBnC;AmBpijBE;;EAEE,qBAAA;EACA,eAAA;EACA,mBqFvEuB;AxG6mjB3B;AmBjijBE;;EAEE,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,mBqF5Ee;AxG+mjBnB;AmBjijBE;;EAEE,oBqFjFkB;AxGonjBtB;AmBjijBE;;EAEE,mBqFpFe;AxGunjBnB;AmBhijBE;;;;EAIE,qBAAA;AnBkijBJ;AmB9hjBE;;EAEE,2B4D3Ga;E5D4Gb,0B8CtIS;AjEsqjBb;AmB9hjBE;;;;EAIE,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBqFrG0B;AxGqojB9B;AmB9hjBE;;EAEE,0CAAA;AnBgijBJ;AmB9hjBE;;EAEE,qBAAA;EACA,WAAA;AnBgijBJ;AmB9hjBE;;EAEE,cAAA;EACA,eAAA;AnBgijBJ;AmB5hjBE;;EAEE,cAAA;EACA,SAAA;EACA,6E2CtKU;E3CuKV,iB2C5JG;E3C6JH,0B8CvKS;AjEqsjBb;AmB1hjBE;;EAEE,cAAA;EACA,yBqF3H0B;AxGupjB9B;AmBxhjBE;;EAEE,eAAA;AnB0hjBJ;AmBthjBE;;EAEE,eAAA;EACA,ciD9LS;ApEstjBb;AmBthjBE;;EAEE,wDmD/Le;AtEutjBnB;AmBphjBE;;EAEE,yB0DtMe;A7E4tjBnB;AmBlhjBE;;EAEE,eAAA;EACA,yBAAA;AnBohjBJ;AmBlhjBE;;EAEE,mEAAA;AnBohjBJ;AmBhhjBE;EACE,WAAA;AnBkhjBJ;AmBhhjBE;EACE,YAAA;AnBkhjBJ;AmB/gjBE;;EAEE,WAAA;EACA,iBqFnJqB;AxGoqjBzB;AmB/gjBE;;EAEE,YAAA;EACA,iBqFvJsB;AxGwqjB1B;AmB1gjBE;;EAEE,kBAAA;EACA,mBAAA;EACA,6BAAA;EAEA,qBqF7Oc;ErF8Od,4BqF7OkB;ErF+OlB,yBAAA;EACA,2B4D1Na;A/EoujBjB;AmBxgjBE;;EAEE,YAAA;EACA,gBAAA;AnB0gjBJ;AmBxgjBE;;EAEE,cAAA;AnB0gjBJ;AmBxgjBE;;EAEE,iBAAA;AnB0gjBJ;AmB7/iBI;EACE,qBAAA;EACA,YAAA;AnB+/iBN;AmB7/iBI;EACE,qBAAA;EACA,iBqFrMoB;ErFsMpB,eAAA;AnB+/iBN;AmB7/iBI;EACE,eAAA;EACA,gBAAA;AnB+/iBN;AmB7/iBI;EACE,eAAA;EACA,iBAAA;AnB+/iBN;AmB5/iBI;;;;;;EAME,sBqFrN2B;AxGmtjBjC;AmB1/iBI;;EAEE,2ByDzOQ;EzD0OR,8ByD1OQ;A5EsujBd;AmBx/iBI;EACE,SAAA;EACA,qBAAA;AnB0/iBN;AmBx/iBI;;;EAGE,WAAA;EACA,qBAAA;EACA,WAAA;AnB0/iBN;AmBx/iBI;EACE,qBAAA;AnB0/iBN;AmB/+iBE;;EAEE,oBAAA;EACA,oCAAA;AnBi/iBJ;AmB/+iBE;;EAEE,0CAAA;AnBi/iBJ;AmB1+iBE;;EAEE,0B8CxVS;AjEo0jBb;AmB/9iBI;;EAEE,+B0D9VsB;A7E+zjB5B;AmB/9iBI;;EAEE,+B0DpWgB;A7Eq0jBtB;AmB/9iBI;;EAEE,+B0DtWsB;A7Eu0jB5B;AmB/9iBI;;EAEE,+B0D1WsB;A7E20jB5B;AmB99iBI;;EAEE,eAAA;EACA,+B0DlXgB;A7Ek1jBtB;AmB99iBI;;EAEE,wDmD7Xa;AtE61jBnB;AmB39iBI;EACE,0CAAA;AnB69iBN;AmB39iBI;EACE,mEAAA;AnB69iBN;AmBr9iBE;;;EAGE,8BAAA;AnBu9iBJ;AmBr9iBE;;;EAGE,iCAAA;AnBu9iBJ;AmBr9iBE;;;EAGE,iCAAA;AnBu9iBJ;AmBh9iBE;;;EAGE,yB0DpaoB;E1DqapB,2BqFrUF;AxGuxjBF;AmBh9iBE;;EAEE,yB0DxaiB;A7E03jBrB;AmBh9iBE;;EAEE,yB0D3aiB;A7E63jBrB;AmBh9iBE;;EAEE,0B0D9akB;A7Eg4jBtB;AmB78iBI;;;EAGE,+B0Dhb2B;A7E+3jBjC;AmB78iBI;;EAEE,yB0DnbwB;A7Ek4jB9B;AmB78iBI;;EAEE,yB0DtbwB;A7Eq4jB9B;AmB78iBI;;EAEE,yB0DzbyB;A7Ew4jB/B;AmBr8iBI;;EAEE,eAAA;EACA,uBqF7VsB;ErF8VtB,oBAAA;EACA,SqF1WuB;ErF2WvB,yB0DrdkB;E1DsdlB,oBqF3W8B;ErF4W9B,+EqFxWJ;AxG+yjBF;AmBr8iBI;;EAEE,gBAAA;AnBu8iBN;AmBr8iBI;;EAEE,+BsEneqB;EtEoerB,yB0D/de;A7Es6jBrB;AmBr8iBI;;EAEE,+BsEtec;EtEued,yB0Dnee;A7E06jBrB;AmBr8iBI;;EAEE,+BsE3ec;EtE4ed,0B0DvegB;A7E86jBtB;AmBl8iBM;EACE,uBqFjX6B;ErFkX7B,+B0DxeyB;A7E46jBjC;AmBl8iBM;EACE,qCsElfmB;EtEmfnB,yB0D3esB;A7E+6jB9B;AmBl8iBM;EACE,qCsErfY;EtEsfZ,yB0D9esB;A7Ek7jB9B;AmBl8iBM;EACE,qCsEzfY;EtE0fZ,yB0DjfuB;A7Eq7jB/B;AmB97iBE;;;;EAIE,gBAAA;AnBg8iBJ;AmBz7iBE;EACE,iGqFnYF;AxG8zjBF;AmBz7iBE;EACE,iBqFlYmB;AxG6zjBvB;AmBr7iBE;;EAEE,eAAA;EACA,gBAAA;AnBu7iBJ;AmBr7iBE;;EAEE,mBAAA;EACA,oBAAA;AnBu7iBJ;AmB96iBI;;EAEE,oBqFxZiB;AxGw0jBvB;AmB96iBI;;;EAGE,kBAAA;AnBg7iBN;AmB96iBI;;;EAGE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mB2ChjBG;E3CijBH,qBqFvae;ErFwaf,YqFrakB;ErFsalB,UqFvagB;ErFwahB,cqFtac;ErFuad,mBqFrauB;AxGq1jB7B;AmB76iBI;;;EAGE,0B8CtkBO;AjEq/jBb;AmB56iBI;;EAEE,qBqFvbiB;AxGq2jBvB;AmB16iBI;;EAEE,cAAA;AnB46iBN;AmB16iBI;;EAEE,mBqFrb2B;AxGi2jBjC;AmB16iBI;;EAEE,cAAA;AnB46iBN;AmB16iBI;;EAEE,0B8C7lBO;AjEygkBb;AmB16iBI;;EAEE,aAAA;AnB46iBN;AmBn6iBI;;;;EAIE,sBAAA;EACA,oBqFtcwB;ErFucxB,qBAAA;AnBq6iBN;AmBn6iBI;;;EAGE,qBAAA;EACA,kBAAA;AnBq6iBN;AmBn6iBI;;;EAGE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,0BqF9doB;ErF+dpB,mCqF5duB;ErF6dvB,iBqFxd0B;ErFyd1B,0B8CpoBO;E9CqoBP,sBqFzd8B;ErF0d9B,YqF5duB;AxGi4jB7B;AmBl6iBI;;;EAGE,+B0DnoBsB;A7EuikB5B;AmBh6iBI;;EAEE,yBAAA;AnBk6iBN;AmBh6iBI;EACE,oBAAA;AnBk6iBN;AmB95iBI;;EAEE,gBqF7e8B;AxG64jBpC;AmB95iBI;;EAEE,iBqFhf4B;AxGg5jBlC;AmB35iBM;;EAEE,cAAA;AnB65iBR;AmB35iBM;;;EAGE,gBAAA;EACA,mBAAA;AnB65iBR;AmBx5iBI;;;EAGE,mCqF7gBgC;AxGu6jBtC;AmBh5iBI;EACE,4CqFvgBgB;AxGy5jBtB;AmBh5iBI;EACE,gBqFxgBsB;AxG05jB5B;AmBh5iBI;EACE,gBqF1gB2B;AxG45jBjC;AmBh5iBI;;EAEE,gBAAA;AnBk5iBN;AmB94iBI;EACE,qBqFvhBsB;AxGu6jB5B;AmB54iBI;;EAEE,cAAA;EACA,eAAA;AnB84iBN;AmB54iBI;EACE,qBqFpkBiB;AxGk9jBvB;AmB14iBI;EACE,cAAA;AnB44iBN;AmB14iBI;;EAEE,qBqFxjBwB;AxGo8jB9B;AmB14iBI;EACE,cAAA;EACA,eAAA;EACA,8ByDnqBQ;A5E+ikBd;AmB14iBI;EACE,iBqF3jB8B;AxGu8jBpC;AmBx4iBI;;EAEE,SAAA;EACA,gBAAA;AnB04iBN;AmBr4iBM;EACE,cAAA;AnBu4iBR;AmBr4iBM;EACE,mBqF3jB0B;AxGk8jBlC;AmBr4iBM;EACE,oBqF9jB0B;AxGq8jBlC;AmBr4iBM;EACE,gBAAA;EACA,8CqFxkBc;ErFykBd,SAAA;EACA,gBqFnkB8B;AxG08jBtC;AmBr4iBM;EACE,kBAAA;AnBu4iBR;AmBj4iBM;;;EAGE,sCkE7vBa;ArFgokBrB;AmBx3iBI;;EAEE,4CqFxlBe;ErFylBf,mBqFvlB2B;ErFwlB3B,oBqFxlB2B;AxGk9jBjC;AmBx3iBI;EACE,+CqF7lBe;AxGu9jBrB;AmBt3iBI;;EAEE,2ByDnuBQ;EzDouBR,8ByDpuBQ;A5E4lkBd;AmBp3iBI;EACE,eAAA;AnBs3iBN;AmBp3iBI;EACE,mBAAA;AnBs3iBN;AmBj3iBM;EACE,cAAA;AnBm3iBR;AmBj3iBM;;EAEE,qBAAA;AnBm3iBR;AmBj3iBM;EACE,qBAAA;EACA,sBAAA;EACA,8ByD3vBM;A5E8mkBd;AmB72iBM;EACE,cAAA;AnB+2iBR;AmB72iBM;;EAEE,qBqFhqBsB;AxG+gkB9B;AmB72iBM;EACE,cAAA;EACA,eAAA;EACA,8ByD3wBM;A5E0nkBd;AmB72iBM;EACE,iBqFnqB4B;AxGkhkBpC;AmBz2iBM;EACE,cAAA;AnB22iBR;AmBz2iBM;;EAEE,gBAAA;EACA,6CqF1pBa;ErF2pBb,SAAA;EACA,mBqFrpByB;ErFspBzB,oBqFtpByB;ErFwpBzB,gBqFvpB6B;AxGigkBrC;AmBx2iBM;;EAEE,mBAAA;EACA,8CqFpqBa;AxG8gkBrB;AmBp2iBM;;EAEE,sCkE91Ba;ArFoskBrB;AmBp2iBM;;EAEE,sCkEl2Ba;ArFwskBrB;AmB31iBI;EACE,2ByDzzBQ;A5EspkBd;AmB31iBI;EACE,8ByD5zBQ;A5EypkBd;AmB31iBI;;EAEE,kBqFrrB4B;AxGkhkBlC;AmB31iBI;;EAEE,mBqFzrB4B;AxGshkBlC;AmBz1iBI;EACE,2ByDn0BS;A5E8pkBf;AmBz1iBI;EACE,8ByDt0BS;A5EiqkBf;AmBz1iBI;;EAEE,oBqF/rBiC;AxG0hkBvC;AmBz1iBI;;EAEE,qBqFnsBiC;AxG8hkBvC;AmBp1iBE;EACE,yB4D54BY;A/EkukBhB;AmBp1iBE;EACE,yB4D94BY;A/EoukBhB;AmBp1iBE;EACE,yB4Dh5Ba;A/EsukBjB;AmBp1iBE;EACE,c4Dl5Bc;A/EwukBlB;AmBp1iBE;EACE,yB4Dp5Ba;A/E0ukBjB;AmBp1iBE;EACE,yB4Dt5BW;A/E4ukBf;AmBp1iBE;EACE,yB4Dx5BY;A/E8ukBhB;AmBp1iBE;EACE,yB4D15Be;A/EgvkBnB;AmBn1iBE;;EAEE,0B4Dh7BG;A/EqwkBP;AmBn1iBE;;EAEE,0B4Dn7BG;A/EwwkBP;AmBn1iBE;;EAEE,0B4Dt7BI;A/E2wkBR;AmBn1iBE;;EAEE,e4Dz7BK;A/E8wkBT;AmBn1iBE;;EAEE,0B4D57BI;A/EixkBR;AmBn1iBE;;EAEE,0B4D/7BE;A/EoxkBN;AmBn1iBE;;EAEE,0B4Dl8BG;A/EuxkBP;AmBn1iBE;;EAEE,0B4Dr8BM;A/E0xkBV;AoBvykBE;EACE,aAAA;EACA,kBAAA;EACA,QqFCgB;ErFAhB,SqFCiB;ErFAjB,SAAA;EACA,kBAAA;EACA,aAAA;EACA,4CAAA;ApByykBJ;AoBrykBE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAEA,qB4D3Bc;E5D4Bd,sCAAA;ApBsykBJ;AoBlykBE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAEA,sCAAA;EACA,2BAAA;EACA,qB4D1Cc;E5D4Cd,iCAAA;ApBkykBJ;AoB7xkBE;;;;EAIE,wBsFvDgB;A1Gs1kBpB;AoB5xkBE;;;;EAIE,wBsF5DgB;A1G01kBpB;AoB1xkBE;EACE;IACE,yBAAA;EpB4xkBJ;AACF;AoBxxkBE;;EAEE,WwD3DI;ExD4DJ,YwD5DI;ExD6DJ,qBqF9BiB;AzGwzkBrB;AoBxxkBE;;EAEE,sBwD/DI;ExDgEJ,uBwDhEI;ExDiEJ,8BqFnCiB;AzG6zkBrB;AoBxxkBE;;EAEE,sBwD7DI;ExD8DJ,uBwD9DI;ExD+DJ,8BqFxCkB;AzGk0kBtB;AoBxxkBE;;EAEE,sBwD3DI;ExD4DJ,uBwD5DI;ExD6DJ,8BqF7CmB;AzGu0kBvB;AoBxxkBE;;EAEE,sBwDjDI;ExDkDJ,uBwDlDI;ExDmDJ,8BqFlDkB;AzG40kBtB;AoBxxkBE;;EAEE,sBwDnDI;ExDoDJ,uBwDpDI;ExDqDJ,8BqFvDgB;AzGi1kBpB;AoBxxkBE;;EAEE,sBwDnDI;ExDoDJ,uBwDpDI;ExDqDJ,8BqF5DiB;AzGs1kBrB;AoBxxkBE;;EAEE,sBwDnDI;ExDoDJ,uBwDpDI;ExDqDJ,8BqFjEoB;AzG21kBxB;AoBlxkBE;EACE,cAAA;ApBoxkBJ;AoBhxkBE;EACE,+ByD3HkB;A7E64kBtB;AoBhxkBE;EACE,uC8DpIyB;AlFs5kB7B;AoB9wkBE;EACE,0B6C1IS;AjE05kBb;AoB9wkBE;EACE,gC8D9IgB;AlF85kBpB;AoBrwkBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;ApBuwkBJ;AoB/vkBE;EACE,4BqF3I6B;ErF4I7B,wBqF3IyB;AzG44kB7B;AoB9vkBE;;EAEE,cAAA;ApBgwkBJ;AoB9vkBE;;EAEE,aAAA;ApBgwkBJ;AoBlvkBE;EACE,WwDjLI;ExDkLJ,YwDlLI;ExDmLJ,yB2D1KY;A/E85kBhB;AoBlvkBE;EACE,sBwDpLI;ExDqLJ,uBwDrLI;ExDsLJ,yB2D9KY;A/Ek6kBhB;AoBlvkBE;EACE,sBwDjLI;ExDkLJ,uBwDlLI;ExDmLJ,yB2DlLa;A/Es6kBjB;AoBlvkBE;EACE,sBwD9KI;ExD+KJ,uBwD/KI;ExDgLJ,c2DtLc;A/E06kBlB;AoBlvkBE;EACE,sBwDnKI;ExDoKJ,uBwDpKI;ExDqKJ,yB2D1La;A/E86kBjB;AoBlvkBE;EACE,sBwDpKI;ExDqKJ,uBwDrKI;ExDsKJ,yB2D9LW;A/Ek7kBf;AoBlvkBE;EACE,sBwDnKI;ExDoKJ,uBwDpKI;ExDqKJ,yB2DlMY;A/Es7kBhB;AoBlvkBE;EACE,sBwDlKI;ExDmKJ,uBwDnKI;ExDoKJ,yB2DtMe;A/E07kBnB;AoBhvkBE;EACE,ewD3NI;ExD4NJ,2BAAA;ApBkvkBJ;AoBhvkBE;EACE,0BwD7NI;ExD8NJ,2BAAA;ApBkvkBJ;AoBhvkBE;EACE,0BwDzNI;ExD0NJ,kBAAA;ApBkvkBJ;AoBhvkBE;EACE,0BwDrNI;ExDsNJ,2BAAA;ApBkvkBJ;AoBhvkBE;EACE,0BwDzMI;ExD0MJ,2BAAA;ApBkvkBJ;AoBhvkBE;EACE,0BwDzMI;ExD0MJ,kBAAA;ApBkvkBJ;AoBhvkBE;EACE,0BwDvMI;ExDwMJ,2BAAA;ApBkvkBJ;AoBhvkBE;EACE,0BwDrMI;ExDsMJ,2BAAA;ApBkvkBJ;AoBpukBM;;;;;;;;;;EAUE,cAbE;ApBmvkBV;AoBlukBQ;;;;;;;;EAQE,cAxBA;ApB4vkBV;AoB1vkBM;;;;;;;;;;EAUE,cAbE;ApBywkBV;AoBxvkBQ;;;;;;;;EAQE,cAxBA;ApBkxkBV;AoBhxkBM;;;;;;;;;;EAUE,cAbE;ApB+xkBV;AoB9wkBQ;;;;;;;;EAQE,cAxBA;ApBwykBV;AoBtykBM;;;;;;;;;;EAUE,cAbE;ApBqzkBV;AoBpykBQ;;;;;;;;EAQE,cAxBA;ApB8zkBV;AoB5zkBM;;;;;;;;;;EAUE,cAbE;ApB20kBV;AoB1zkBQ;;;;;;;;EAQE,cAxBA;ApBo1kBV;AoBl1kBM;;;;;;;;;;EAUE,cAbE;ApBi2kBV;AoBh1kBQ;;;;;;;;EAQE,cAxBA;ApB02kBV;AoBx2kBM;;;;;;;;;;EAUE,cAbE;ApBu3kBV;AoBt2kBQ;;;;;;;;EAQE,cAxBA;ApBg4kBV;AoB93kBM;;;;;;;;;;EAUE,cAbE;ApB64kBV;AoB53kBQ;;;;;;;;EAQE,cAxBA;ApBs5kBV;AoBp5kBM;;;;;;;;;;EAUE,cAbE;ApBm6kBV;AoBl5kBQ;;;;;;;;EAQE,cAxBA;ApB46kBV;AoB16kBM;;;;;;;;;;EAUE,cAbE;ApBy7kBV;AoBx6kBQ;;;;;;;;EAQE,cAxBA;ApBk8kBV;AoBh8kBM;;;;;;;;;;EAUE,cAbE;ApB+8kBV;AoB97kBQ;;;;;;;;EAQE,cAxBA;ApBw9kBV;AoBt9kBM;;;;;;;;;;EAUE,cAbE;ApBq+kBV;AoBp9kBQ;;;;;;;;EAQE,cAxBA;ApB8+kBV;AoB5+kBM;;;;;;;;;;EAUE,cAbE;ApB2/kBV;AoB1+kBQ;;;;;;;;EAQE,cAxBA;ApBoglBV;AoBlglBM;;;;;;;;;;EAUE,cAbE;ApBihlBV;AoBhglBQ;;;;;;;;EAQE,cAxBA;ApB0hlBV;AoBxhlBM;;;;;;;;;;EAUE,cAbE;ApBuilBV;AoBthlBQ;;;;;;;;EAQE,cAxBA;ApBgjlBV;AoBlhlBE;;;;;;;;EAQE,0BAAA;ApBohlBJ;AoBlhlBE;EACE,c6DzTI;AjF60lBR;AoBlhlBE;;EAEE,c+DtTG;AnF00lBP;AoBlhlBE;EACE,iCAAA;ApBohlBJ;AoB9glBE;EACE,kBAAA;EACA,sBqF1S2B;ErF2S3B,SqF1SmB;ErF2SnB,OAAA;EACA,MAAA;EACA,eAAA;ApBghlBJ;AoB7glBE;;EAEE,qBAAA;ApB+glBJ;AoB3glBE;;EAEE,cAAA;EACA,iBAAA;EACA,kBAAA;ApB6glBJ;AoB1glBE;;;;EAIE,8BAAA;EACA,+BAAA;ApB4glBJ;AoB1glBE;;;;EAIE,gCAAA;ApB4glBJ;AoB1glBE;;EAEE,qC8D7WgB;E9D8WhB,sC8D9WgB;AlF03lBpB;AoB1glBE;;EAEE,uC8DlXgB;AlF83lBpB;AoBrglBE;EACE,c6DxXI;AjF+3lBR;AoBrglBE;EACE,c+DpXG;AnF23lBP;AoBrglBE;;;;EAIE,kEAAA;EACA,qBAAA;ApBuglBJ;AoBrglBE;;;;EAIE,0EAAA;EACA,4FAAA;EACA,+BAAA;ApBuglBJ;AoBrglBE;EACE,oCAAA;ApBuglBJ;AoBrglBE;;;;EAIE,wBAAA;EACA,sBAAA;ApBuglBJ;AoBrglBE;;;;EAIE,wBAAA;ApBuglBJ;AoBrglBE;;;;EAIE,yBAAA;EACA,qBAAA;ApBuglBJ;AoBrglBE;;;;EAIE,yBAAA;ApBuglBJ;AoBrglBE;EACE;IACE,8BAAA;IACA,gCAAA;EpBuglBJ;EoBrglBE;IACE,0BAAA;EpBuglBJ;EoBrglBE;IACE,gCAAA;EpBuglBJ;EoBrglBE;IACE,4BAAA;EpBuglBJ;EoBrglBE;IACE,8BAAA;EpBuglBJ;EoBrglBE;IACE,8BAAA;IACA,gCAAA;IACA,yBAAA;EpBuglBJ;AACF;AoBpglBE;EACE;IACE,8BAAA;IACA,gCAAA;EpBsglBJ;EoBpglBE;IACE,+BAAA;EpBsglBJ;EoBpglBE;IACE,gCAAA;EpBsglBJ;EoBpglBE;IACE,iCAAA;EpBsglBJ;EoBpglBE;IACE,8BAAA;EpBsglBJ;EoBpglBE;IACE,8BAAA;IACA,gCAAA;IACA,yBAAA;EpBsglBJ;AACF;AqBz9lBE;EACE,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yB4DRI;E5DSJ,oHsFiC2B;EtFhC3B,4BAAA;EACA,gBsFdoB;A3Gy+lBxB;AqBx9lBE;EACE;IACE,8BAAA;ErB09lBJ;EqBx9lBE;IACE,6BAAA;ErB09lBJ;AACF;AqBv9lBE;EACE,gBsFL8B;A3G89lBlC;AqBv9lBE;EACE,sBsFX6B;A3Go+lBjC;AqBv9lBE;EACE,qBAAA;ArBy9lBJ;AqBv9lBE;EACE,sBAAA;ArBy9lBJ;AqBv9lBE;EACE,qBAAA;ArBy9lBJ;AqBt9lBE;;;;;EAKE,yB4D5CI;AjFogmBR;AqBr9lBE;EACE,aAAA;ArBu9lBJ;AqBn9lBE;EACE,asF/BuB;A3Go/lB3B;AqBn9lBE;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;ArBq9lBJ;AqBn9lBE;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;ArBq9lBJ;AqBh9lBE;EACE,kBAAA;EACA,sBuDGW;A5E+8lBf;AqBh9lBE;;EAEE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;ArBk9lBJ;AqBh9lBE;EACE,OAAA;ArBk9lBJ;AqBh9lBE;EACE,QAAA;ArBk9lBJ;AqB98lBE;EACE,oBuDpBU;A5Eo+lBd;AqB98lBE;;EAEE,auDxBU;A5Ew+lBd;AqB98lBE;EACE,iBuD3BU;A5E2+lBd;AqB58lBE;EACE,kBAAA;EACA,gBAAA;ArB88lBJ;AqB18lBE;EACE,QsF5G4B;A3GwjmBhC;AqB18lBE;EACE,UsF5G8B;A3GwjmBlC;AqB18lBE;EACE,UsFjHiC;A3G6jmBrC;AqB18lBE;EACE,UsFnH4B;A3G+jmBhC;AqB18lBE;EACE,UsFpH6B;A3GgkmBjC;AqBx8lBE;EACE,6BuDrDU;A5E+/lBd;AqBx8lBE;;EAEE,sBuDzDU;A5EmgmBd;AqBx8lBE;EACE,0BuD5DU;A5EsgmBd;AqBx8lBE;EACE,UsF1GkC;A3GojmBtC;AqBx8lBE;EACE,UsF5GkC;A3GsjmBtC;AqBt8lBE;EACE,gBsFtHsB;A3G8jmB1B;AqBt8lBE;EACE,sBuD1II;A5EklmBR;AqBt8lBE;EACE,cAAA;EACA,sBuD3EW;EvD4EX,WAAA;EACA,gBsF/HsB;A3GukmB1B;AqBp8lBE;;;EAGE,cAAA;ArBs8lBJ;AqBp8lBE;;;EAGE,sBuDjFW;EvDkFX,WAAA;EACA,cAAA;ArBs8lBJ;AqBl8lBE;EACE,sIsF5HoC;A3GgkmBxC;AqBl8lBE;;;;;EAKE,yB8D1KI;AnF8mmBR;AqBx7lBE;EACE,QsF/L4B;A3GynmBhC;AqBx7lBE;EACE,UsFjMiC;A3G2nmBrC;AqBx7lBE;EACE,UsFnM4B;A3G6nmBhC;AqBx7lBE;EACE,UsFrM8B;A3G+nmBlC;AqBx7lBE;EACE,UsFvM6B;A3GiomBjC;AqBx7lBE;EACE,UsFzMkC;A3GmomBtC;AqBl7lBE;EACE,eAAA;ArBo7lBJ;AsBxomBE;EACE,kBAAA;EACA,MAAA;EACA,YsFLS;EtFMT,YsFLU;A5G+omBd;AsBvomBE;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AtByomBJ;AsBtomBE;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AtBwomBJ;AsB7nmBE;EACE,OAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AtB+nmBJ;AsB5nmBE;EACE,UAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;AtB8nmBJ;AsBtnmBE;EACE,csF7BkB;A5GqpmBtB;AsBtnmBE;EACE,qBAAA;EACA,oBAAA;EACA,8CsFrCmB;A5G6pmBvB;AsBtnmBE;EACE,6CsFxCmB;EtFyCnB,qBAAA;EACA,oBAAA;AtBwnmBJ;AsBjnmBE;EACE,wBsFtDgB;A5GyqmBpB;AsBjnmBE;EACE,kBAAA;EACA,iBAAA;AtBmnmBJ;AsBjnmBE;EACE,kBAAA;EACA,iBAAA;AtBmnmBJ;AsBhnmBE;EACE,0BsFjEqB;A5GmrmBzB;AsBhnmBE;EACE,oBAAA;EACA,mBAAA;AtBknmBJ;AsBhnmBE;EACE,oBAAA;EACA,mBAAA;AtBknmBJ;AsB3mmBE;;EAEE,UAAA;EACA,SAAA;AtB6mmBJ;AsBtmmBE;EACE,0ByDjGG;A/EysmBP;AsBtmmBE;EACE,0ByDnGG;A/E2smBP;AsBtmmBE;EACE,0ByDrGI;A/E6smBR;AsBtmmBE;EACE,eyDvGK;A/E+smBT;AsBtmmBE;EACE,0ByDzGI;A/EitmBR;AsBtmmBE;EACE,0ByD3GE;A/EmtmBN;AsBtmmBE;EACE,0ByD7GG;A/EqtmBP;AsBtmmBE;EACE,0ByD/GM;A/EutmBV;AuBtumBE;EACE,gBAAA;EACA,6BAAA;EACA,uBAAA;AvBwumBJ;AuBrumBE;EACE,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,8BsFZgB;A7GmvmBpB;AuBrumBE;EACE,6BAAA;EACA,qBAAA;AvBuumBJ;AuBnumBE;;EAEE,qBAAA;AvBqumBJ;AuBxtmBI;EACE,6BAAA;EACA,2BAAA;EACA,mBAAA;AvB0tmBN;AuBvtmBI;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EAEA,SAAA;EACA,oCsFtCoB;A7G8vmB1B;AuBrtmBI;EACE,6BAAA;AvButmBN;AuBrtmBI;EACE,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,sCAAA;AvButmBN;AuBrtmBI;;EAEE,uCAAA;AvButmBN;AuBrtmBI;;EAEE,oCAAA;AvButmBN;AuBptmBI;EACE,oCAAA;AvBstmBN;AuBptmBI;EACE,uCAAA;AvBstmBN;AuBptmBI;;EAEE,sCAAA;AvBstmBN;AuBptmBI;;EAEE,oCAAA;AvBstmBN;AuBntmBI;EACE,sCAAA;AvBqtmBN;AuBntmBI;;EAEE,uCAAA;AvBqtmBN;AuBntmBI;;EAEE,oCAAA;AvBqtmBN;AuBltmBI;EACE,uCAAA;AvBotmBN;AuBltmBI;;EAEE,sCAAA;AvBotmBN;AuBltmBI;;EAEE,oCAAA;AvBotmBN;AuB3smBI;EACE,UAAA;AvB6smBN;AuB3smBI;;EAEE,UAAA;AvB6smBN;AuBnsmBI;EACE,6BAAA;EACA,2BAAA;EACA,mBAAA;AvBqsmBN;AuBlsmBI;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EAEA,SAAA;EACA,mEsFpImB;A7Gu0mBzB;AuBhsmBI;EACE,6BAAA;AvBksmBN;AuBhsmBI;EACE,6BAAA;EACA,kBAAA;EACA,sBAAA;AvBksmBN;AuBhsmBI;;EAEE,uCAAA;AvBksmBN;AuBhsmBI;;EAEE,sCAAA;AvBksmBN;AuBhsmBI;;EAEE,uCAAA;AvBksmBN;AuBhsmBI;;EAEE,sCAAA;AvBksmBN;AuBxrmBI;EACE,yBsFnLuB;EtFoLvB,uBAAA;AvB0rmBN;AuBvrmBI;;EAEE,8BAAA;AvByrmBN;AuBvrmBI;;;;EAIE,yBAAA;AvByrmBN;AuBtrmBI;EACE,6BAAA;AvBwrmBN;AuBtrmBI;;EAEE,0BAAA;AvBwrmBN;AuBhrmBE;EACE,2BAAA;EACA,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;AvBkrmBJ;AuBhrmBE;EACE,wBAAA;AvBkrmBJ;AuB1qmBE;EACE,UsF5NqB;A7Gw4mBzB;AuBjqmBE;EACE,iBAAA;AvBmqmBJ;AuB5pmBE;EACE,+BAAA;AvB8pmBJ;AuBtpmBE;EACE,0BAAA;AvBwpmBJ;AwBr5mBE;EACE,kBAAA;EACA,mByDLI;EzDMJ,8CsFHY;EtFIZ,cuFKa;EvFJb,gBAAA;EACA,8BoDPG;EpDQH,wCuFPa;A/G85mBjB;AwBp5mBE;EACE,aAAA;AxBs5mBJ;AwBp5mBE;EACE,gBAAA;AxBs5mBJ;AwBj5mBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EAEA,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,+CAAA;AxBk5mBJ;AwBh5mBE;EACE,mBAAA;AxBk5mBJ;AwBz4mBE;;EAEE,cyD7CI;AjFw7mBR;AwBv4mBE;EACE,yBAAA;EACA,0BAAA;AxBy4mBJ;AwBv4mBE;EACE,4BAAA;EACA,6BAAA;AxBy4mBJ;AwBv4mBE;EACE,yBAAA;EACA,0BAAA;AxBy4mBJ;AwBv4mBE;EACE,4BAAA;EACA,6BAAA;AxBy4mBJ;AwBr4mBE;;;EAGE,gBuFrCuB;EvFsCvB,mBuFtCuB;A/G66mB3B;AwBr4mBE;EACE,cuF9Da;EvF+Db,8BoDzEG;A5Eg9mBP;AwBn4mBE;EACE,mByDhFI;EzDiFJ,wCuF9Ea;EvF+Eb,8CsF/EY;A9Go9mBhB;AwBn4mBE;EACE,gBuF7Ec;A/Gk9mBlB;AwBj4mBE;EACE,mBuFhFsB;A/Gm9mB1B;AwBv3mBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBuFtGY;EvFuGZ,iBuFrE2B;EvFsE3B,mByDnHM;EzDoHN,oC6DlHS;E7DmHT,qDuFzE2B;A/Gk8mBjC;AwBt3mBI;;EAEE,cAAA;AxBw3mBN;AwBt3mBI;;;;EAIE,gBuFlFkC;EvFmFlC,iBAAA;EACA,kBAAA;AxBw3mBN;AwBt3mBI;;;;EAIE,gBuF1FkC;EvF2FlC,iBAAA;EACA,kBAAA;AxBw3mBN;AwBr3mBI;EACE,kBAAA;AxBu3mBN;AwBr3mBI;EACE,qBAAA;EACA,WAAA;EACA,6BuFpG6C;A/G29mBnD;AwBr3mBI;EACE,eAAA;AxBu3mBN;AwB92mBI;;EAEE,aAAA;EACA,cuF7GqB;EvF8GrB,auFhHkB;A/Gg+mBxB;AwB92mBI;EACE,aAAA;AxBg3mBN;AwB92mBI;EACE,gBAAA;AxBg3mBN;AwB92mBI;;;;EAIE,yByD5KE;EzD6KF,mBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,wCuFjLW;EvFkLX,cuFnIqB;A/Gm/mB3B;AwB92mBI;;EAEE,0BAAA;EACA,MAAA;EACA,WAAA;AxBg3mBN;AwB92mBI;;EAEE,yBAAA;EACA,MAAA;EACA,WAAA;AxBg3mBN;AwB52mBI;EACE,euFrJiB;EvFsJjB,gBAAA;AxB82mBN;AwB52mBI;EACE,aAAA;AxB82mBN;AwB52mBI;EACE,aAAA;EACA,kBuF7JiB;A/G2gnBvB;AwB52mBI;EACE,gBAAA;AxB82mBN;AwBp2mBI;EACE,qBuFhKoB;A/GsgnB1B;AwBp2mBI;;;;EAIE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EAEA,4CAAA;EACA,+BiE5OqB;EjE8OrB,WAAA;EACA,WuFjLmB;EvFkLnB,mBAAA;AxBo2mBN;AwBl2mBI;;EAEE,aAAA;AxBo2mBN;AwBh2mBI;;EAEE,cAAA;EACA,SAAA;AxBk2mBN;AwB71mBM;;;;EAIE,qCiEpQmB;EjEqQnB,4CAAA;AxB+1mBR;AwBt1mBE;EACE,cuFzLqB;A/GihnBzB;AwBr1mBE;EACE,YuF5L0B;A/GmhnB9B;AwBn1mBE;;EAEE,eAAA;EACA,gBAAA;AxBq1mBJ;AwB90mBE;EACE,cAAA;AxBg1mBJ;AwB50mBE;EACE,oBAAA;AxB80mBJ;AwB50mBE;;EAEE,cAAA;EACA,cAAA;AxB80mBJ;AwBv0mBE;EACE,mBAAA;EACA,YuF1PuB;EvF2PvB,kBAAA;EACA,sBAAA;EACA,oBAAA;AxBy0mBJ;AwBl0mBE;;EAEE,kFsFxTc;A9G4nnBlB;AwB3zmBE;EACE,sBAAA;EACA,kBAAA;EACA,cuF7Ta;EvF8Tb,wCuFvUa;EvFwUb,8CsFxUY;EtFyUZ,8BoD1UG;A5EuonBP;AwB3zmBE;EACE,aAAA;AxB6zmBJ;AwB3zmBE;EACE,gBAAA;AxB6zmBJ;AwBxzmBE;EACE,MAAA;EACA,SAAA;EACA,gBAAA;EACA,SuFjUqB;EvFkUrB,WuFjUoB;EvFkUpB,gBuFjUyB;EvFkUzB,YuFtUqB;EvFuUrB,4CuF5Va;A/GspnBjB;AwBvzmBE;EACE,MuF7Q0B;EvF8Q1B,SAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,kDAAA;AxByzmBJ;AwBrzmBE;EACE,MuFtR6B;EvFuR7B,SAAA;EACA,aAAA;EACA,gBAAA;EACA,oDuFpRF;EvFqRE,kDAAA;AxBuzmBJ;AwBnzmBE;EACE,8BoDrXG;A5E0qnBP;AwBhzmBE;EACE,4CuF1Xa;EvF2Xb,iBuFxW0B;A/G0pnB9B;AwBhzmBE;EACE,gBAAA;AxBkzmBJ;AwBhzmBE;EACE,aAAA;AxBkzmBJ;AwB9ymBE;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,8CsF1YY;EtF2YZ,cuFlYa;EvFmYb,8BoD7YG;EpD8YH,wCuF7Ya;A/G6rnBjB;AwB9ymBE;EACE,eAAA;AxBgzmBJ;AwB5ymBE;EACE,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,4CuF1Za;A/GwsnBjB;AwB1ymBE;EACE,cAAA;EACA,eAAA,EAAA,yBAAA;AxB4ymBJ;AwB1ymBE;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,6CAAA;AxB4ymBJ;AwBxymBE;EACE,gBAAA;AxB0ymBJ;AwBxymBE;EACE,iBAAA;AxB0ymBJ;AwB9xmBE;EACE,auEpce;EvEqcf,yBqD7bkB;A7E6tnBtB;AwBzxmBE;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;AxB2xmBJ;AwBzxmBE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,oCuFlZ0B;EvFmZ1B,WAAA;EACA,YAAA;EACA,8BoDrdG;EpDsdH,YuFpZ4B;A/G+qnBhC;AwBzxmBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CsDheY;EtDieZ,UuF1ZkB;EvF2ZlB,WuF3ZkB;EvF6ZlB,sCAAA;EACA,2BAAA;EACA,qBwDxec;ExD0ed,iCAAA;EACA,mBAAA;EACA,YuFla0B;A/G0rnB9B;AwB1wmBE;;;EAGE,4BuFnZuB;EvFoZvB,gBuFlZuB;EvFmZvB,YuFpZmB;EvFqZnB,gBuFnZ0B;A/G+pnB9B;AwBrwmBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AxBuwmBJ;AwB3vmBQ;EACE,6BAAA;AxB6vmBV;AwB3vmBQ;EACE,yBANA;EAOA,cyDzhBF;AjFsxnBR;AwBlwmBQ;EACE,6BAAA;AxBowmBV;AwBlwmBQ;EACE,yBANA;EAOA,cyDzhBF;AjF6xnBR;AwBzwmBQ;EACE,6BAAA;AxB2wmBV;AwBzwmBQ;EACE,yBANA;EAOA,cyDzhBF;AjFoynBR;AwBhxmBQ;EACE,6BAAA;AxBkxmBV;AwBhxmBQ;EACE,yBANA;EAOA,cyDzhBF;AjF2ynBR;AwBvxmBQ;EACE,6BAAA;AxByxmBV;AwBvxmBQ;EACE,yBANA;EAOA,cyDzhBF;AjFkznBR;AwB9xmBQ;EACE,6BAAA;AxBgymBV;AwB9xmBQ;EACE,yBANA;EAOA,cyDzhBF;AjFyznBR;AwBrymBQ;EACE,6BAAA;AxBuymBV;AwBrymBQ;EACE,yBANA;EAOA,cyDzhBF;AjFg0nBR;AwB5ymBQ;EACE,6BAAA;AxB8ymBV;AwB5ymBQ;EACE,yBANA;EAOA,cyDzhBF;AjFu0nBR;AwBnzmBQ;EACE,6BAAA;AxBqzmBV;AwBnzmBQ;EACE,yBANA;EAOA,cyDzhBF;AjF80nBR;AwB1zmBQ;EACE,6BAAA;AxB4zmBV;AwB1zmBQ;EACE,yBANA;EAOA,cyDzhBF;AjFq1nBR;AwBj0mBQ;EACE,6BAAA;AxBm0mBV;AwBj0mBQ;EACE,yBANA;EAOA,cyDzhBF;AjF41nBR;AwBx0mBQ;EACE,6BAAA;AxB00mBV;AwBx0mBQ;EACE,yBANA;EAOA,cyDzhBF;AjFm2nBR;AwB/0mBQ;EACE,6BAAA;AxBi1mBV;AwB/0mBQ;EACE,yBANA;EAOA,cyDzhBF;AjF02nBR;AwBv0mBE;EACE,gBAAA;AxBy0mBJ;AwBv0mBE;EACE,iBAAA;AxBy0mBJ;AwBv0mBE;EACE,kBAAA;AxBy0mBJ;AwBl0mBE;;EAEE,WAAA;EACA,iBuF/cuB;A/GmxnB3B;AwBl0mBE;EACE,YAAA;EACA,gBuFnduB;A/GuxnB3B;AwB3zmBI;EACE,YAAA;EACA,gBAAA;AxB6zmBN;AwB3zmBI;;EAEE,mB2D/jBE;E3DgkBF,+BqDlkBgB;A7E+3nBtB;AwBzzmBI;EACE,0ByC9kBO;AjEy4nBb;AwBzzmBI;EACE,+BqD1kBgB;A7Eq4nBtB;AwBvzmBI;EACE,qB6D5jBqB;ArFq3nB3B;AwBrzmBI;EACE,cyD1lBE;AjFi5nBR;AwBrzmBI;EACE,+BuF1hBiC;A/Gi1nBvC;AwBpzmBI;EACE,4HuFxeJ;EvFyeI,+BqD3lBsB;A7Ei5nB5B;AwBnzmBI;EACE,wHuFneJ;EvFoeI,+BqDhmBsB;A7Eq5nB5B;AwB5ymBE;EACE,mByDnnBS;EzDonBT,yBqDrnBe;A7Em6nBnB;AwB1ymBE;EACE,mByDxnBQ;EzDynBR,yBqD3nBe;A7Eu6nBnB;AwBlymBI;EACE,MAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,uBuF9iBmB;EvF+iBnB,2BuF/iBmB;EvFgjBnB,gBuF/iBwB;EvFgjBxB,yBuF/iBoB;A/Gm1nB1B;AwBlymBI;EACE,gBAAA;AxBoymBN;AwBhymBI;EACE,SAAA;EACA,gBAAA;EACA,MuF9jBwB;EvF+jBxB,gBuF3oBoB;EvF4oBpB,kDAAA;AxBkymBN;AwBhymBI;EACE,aAAA;AxBkymBN;AwB9xmBI;EACE,SAAA;EACA,aAAA;EACA,MuFzkB2B;EvF0kB3B,mBuFvpBoB;EvFwpBpB,oDuFrkBJ;EvFskBI,kDAAA;AxBgymBN;AwB9xmBI;EACE,mBuF5pBoB;A/G47nB1B;AwBvxmBE;EACE,cAAA;EACA,iBAAA;AxByxmBJ;AwBvxmBE;EACE,eAAA;EACA,gBAAA;AxByxmBJ;AwBlxmBE;;EAEE,0BuDnrBG;A/Eu8nBP;AwBlxmBE;;EAEE,0BuDtrBG;A/E08nBP;AwBlxmBE;;EAEE,0BuDzrBI;A/E68nBR;AwBlxmBE;;EAEE,euD5rBK;A/Eg9nBT;AwBlxmBE;;EAEE,0BuD/rBI;A/Em9nBR;AwBlxmBE;;EAEE,0BuDlsBE;A/Es9nBN;AwBlxmBE;;EAEE,0BuDrsBG;A/Ey9nBP;AwBlxmBE;;EAEE,0BuDxsBM;A/E49nBV;AyB3+nBE;EACE,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,auFNU;EvFOV,cuFLoB;EvFMpB,gBuFLoB;EvFMpB,2BsDea;EtDdb,8BmDTG;EnDUH,wCuFPgB;AhHo/nBpB;AyB3+nBE;EACE,eAAA;AzB6+nBJ;AyBz+nBE;EACE,aAAA;AzB2+nBJ;AyBv+nBE;EACE,gBAAA;AzBy+nBJ;AyBj+nBE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBuFjBmB;EvFmBnB,WAAA;EACA,2BAAA;EACA,mBwD7CI;ExD8CJ,0BwC/CS;ExCgDT,gBuFlBc;EvFmBd,gBuFrBiB;EvFsBjB,YuFnBU;EvFoBV,8CuFnBW;EvFoBX,gGuFlCF;AhHogoBF;AyB99nBE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,QuFPoB;EvFQpB,QuFPsB;EvFQtB,mBAAA;EACA,yBwD/DI;ExDgEJ,qBsDvCa;EtDwCb,sBsDxCa;EtD0Cb,mBAAA;EACA,oC4DrEW;E5DsEX,yBuFdsB;EvFgBtB,gGuFtDF;EvFuDE,0DAAA;AzB89nBJ;AyB19nBE;EACE,iBuF/DsB;EvFgEtB,kDAAA;AzB49nBJ;AyBx9nBE;EACE,kDAAA;EACA,kBAAA;EACA,eAAA;AzB09nBJ;AyBt9nBE;EACE,8BmDxFG;A5EgjoBP;AyB/8nBE;EACE,6EqCtGU;ErCuGV,yBsD5Ea;EtD6Eb,iBqC7FG;A9D8ioBP;AyB/8nBE;EACE,WAAA;AzBi9nBJ;AyB78nBE;EACE,mBqCpGK;ErCqGL,yBsDxFa;EtDyFb,0BwCjHS;AjEgkoBb;AyB78nBE;EACE,WAAA;AzB+8nBJ;AyB78nBE;EACE,kBuFzEwB;AhHwhoB5B;AyB38nBE;EACE,cAAA;EACA,gBuFzFa;EvF0Fb,kBAAA;AzB68nBJ;AyB38nBE;;EAEE,cAAA;EACA,cAAA;EACA,kBuF/Fc;AhH4ioBlB;AyBz8nBE;EACE,WAAA;AzB28nBJ;AyBv8nBE;;EAEE,eAAA;AzBy8nBJ;AyB77nBI;EACE,sBAAA;AzB+7nBN;AyB77nBI;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBuF9HY;EvF+HZ,kBuFjIe;EvFkIf,gBuFjIW;EvFkIX,0BAAA;EACA,oBuFhFqB;EvFiFrB,iBqC9JC;A9D6loBP;AyB57nBI;EACE,cAAA;EACA,kBuFxIY;AhHskoBlB;AyBr7nBI;EACE,oBAAA;EACA,sBAAA;EACA,iBAAA;AzBu7nBN;AyBr7nBI;EACE,2BAAA;EACA,gBuFjKe;EvFkKf,2BAAA;EACA,kBAAA;EACA,+CuFhKS;AhHuloBf;AyBr7nBI;EACE,2BAAA;EACA,kDAAA;AzBu7nBN;AyBr7nBI;EACE,mBAAA;EACA,kDAAA;AzBu7nBN;AyBr7nBI;EACE,8BmDxMC;A5E+noBP;AyBl7nBI;EACE,QuF1I2B;EvF2I3B,QuF1I6B;EvF2I7B,yBuF1I6B;EvF2I7B,auFzIwB;AhH6joB9B;AyBj7nBI;EACE,cuF1I+B;AhH6joBrC;AyBj7nBI;EACE,auFhJwB;AhHmkoB9B;AyBj7nBI;EACE,cuF/IoC;AhHkkoB1C;AyB16nBE;EzB1NF;IyBkPI,UAAA;IAUA,YAAA;IAKA,SAAA;EzBy4nBF;EyB96nBE;IACE,oBAAA;IACA,iBAAA;IACA,sBAAA;EzBg7nBJ;EyB96nBE;IACE,sBAAA;IACA,sBAAA;IACA,gBuFrNe;IvFsNf,2BAAA;IACA,kBAAA;IACA,+CuF9Oc;EhH8poBlB;EyB96nBE;IACE,2BAAA;IACA,kDAAA;EzBg7nBJ;EyB96nBE;IACE,kDAAA;IACA,mBAAA;EzBg7nBJ;EyB56nBE;IACE,UAAA;IACA,uBAAA;IACA,UAAA;IACA,yDAAA;EzB86nBJ;EyB56nBE;IACE,aAAA;EzB86nBJ;EyB36nBE;IACE,kBAAA;EzB66nBJ;EyBz6nBE;;IAEE,kBAAA;EzB26nBJ;AACF;AyBl6nBE;;;;EAIE,mBwDjSQ;ExDkSR,yBoD9RiB;A7EksoBrB;AyBh6nBE;;;;EAIE,mBwDzSS;ExD0ST,yBoDtSiB;A7EwsoBrB;AyB95nBE;EACE,YAAA;EACA,mBwDhTS;AjFgtoBb;AyB95nBE;EACE,mBwDnTS;AjFmtoBb;AyB95nBE;EACE,c2CxTS;ApEwtoBb;AyB95nBE;;EAEE,0BoD5Tc;A7E4toBlB;AyB55nBE;EACE,cuFpQiB;AhHkqoBrB;AyB55nBE;EACE,cuFpQwB;AhHkqoB5B;AyB55nBE;EACE,auFzQsB;AhHuqoB1B;AyB55nBE;EACE,auFzQ6B;AhHuqoBjC;AyB15nBE;;;;EAIE,eAAA;EACA,mBwFxUS;ExFyUT,0BwCjVS;AjE6uoBb;AyBx5nBE;;EAEE,c0DtVI;AnFgvoBR;AyBt5nBE;EACE,YAAA;EACA,mBwD5VI;ExD6VJ,oBAAA;AzBw5nBJ;AyBt5nBE;;;EAGE,yBoD9VkB;A7EsvoBtB;AyBt5nBE;EACE,mBwDrWI;AjF6voBR;AyB14nBE;EzBvWF;IyB+WE,UAAA;IAiBA,UAAA;IAQA,YAAA;IAKA,SAAA;EzB22nBA;EyB/4nBA;IACE,oBAAA;IACA,iBAAA;IACA,sBAAA;EzBi5nBF;EyB74nBA;IACE,sBAAA;IACA,gBuFnWiB;IvFoWjB,2BAAA;IACA,kBAAA;IACA,+CuF5XgB;EhH2woBlB;EyB74nBA;IACE,2BAAA;IACA,kDAAA;EzB+4nBF;EyB74nBA;IACE,kDAAA;IACA,mBAAA;EzB+4nBF;EyB34nBA;IACE,UAAA;IACA,uBAAA;IACA,UAAA;IACA,yDAAA;EzB64nBF;EyBz4nBA;IACE,kBAAA;EzB24nBF;EyBv4nBA;;IAEE,kBAAA;EzBy4nBF;AACF;AyBh4nBE;EACE,aAAA;EACA,WAAA;AzBk4nBJ;AyBx3nBI;EACE,kCAAA;EACA,gBAAA;EACA,2BuFjWgB;EvFkWhB,kDAAA;AzB03nBN;AyBx3nBI;EACE,oCAAA;AzB03nBN;AyBx3nBI;EACE,oCAAA;AzB03nBN;AyBt3nBI;EACE,gBAAA;EACA,kDAAA;AzBw3nBN;AyBt3nBI;EACE,oCAAA;AzBw3nBN;AyBt3nBI;EACE,oCAAA;AzBw3nBN;AyBh3nBE;;;;;;;;EAQE,WAAA;AzBk3nBJ;AyBh3nBE;;;;;;;;EAQE,iBAAA;AzBk3nBJ;AyBh3nBE;EACE,WAAA;AzBk3nBJ;AyBh3nBE;EACE,UAAA;AzBk3nBJ;AyBh3nBE;EACE,cAAA;AzBk3nBJ;AyBh3nBE;EACE,UAAA;AzBk3nBJ;AyBh3nBE;EACE,UAAA;AzBk3nBJ;AyBh3nBE;EACE,cAAA;AzBk3nBJ;AyBh3nBE;EACE,cAAA;AzBk3nBJ;AyBh3nBE;EACE,YAAA;AzBk3nBJ;AyB12nBE;;EAEE,0BsDzfG;A/Eq2oBP;AyB12nBE;;EAEE,0BsD5fG;A/Ew2oBP;AyB12nBE;;EAEE,0BsD/fI;A/E22oBR;AyB12nBE;;EAEE,esDlgBK;A/E82oBT;AyB12nBE;;EAEE,0BsDrgBI;A/Ei3oBR;AyB12nBE;;EAEE,0BsDxgBE;A/Eo3oBN;AyB12nBE;;EAEE,0BsD3gBG;A/Eu3oBP;AyB12nBE;;EAEE,0BsD9gBM;A/E03oBV;AyBn2nBI;EACE,yBAAA;AzBq2nBN;AyBl2nBI;EACE,+BoDxiBgB;EpDyiBhB,mB0DviBE;E1DwiBF,qB4DvhBqB;ArF23oB3B;AyBj2nBI;EACE,yB0D5iBE;E1D6iBF,qB4D5hBqB;ArF+3oB3B;AyBh2nBI;EACE,+BoDnjBgB;A7Eq5oBtB;AyB91nBI;;EAEE,mBuF1c4B;AhH0yoBlC;AyB91nBI;;EAEE,yBoDvjByB;A7Eu5oB/B;AyB51nBI;;EAEE,mBuFjd8B;AhH+yoBpC;AyB51nBI;;;EAGE,+BoDjkByB;A7E+5oB/B;AyB11nBI;;;;EAIE,mBuF/d2B;EvFge3B,yBoD7kBwB;A7Ey6oB9B;AyBx1nBI;;;;EAIE,mBuFzekC;EvF0elC,yBoDrlBwB;A7E+6oB9B;AkH77oBE;EACE,mBAAA;EACA,yHACE;AlH87oBN;AkH17oBE;;EAEE,mBAAA;EACA,gBAAA,EAAA,QAAA;AlH47oBJ;A0B37oBI;EACE,cAJE;A1Bi8oBR;A0B37oBI;EACE,cANE;A1Bm8oBR;A0Bj8oBI;EACE,cAJE;A1Bu8oBR;A0Bj8oBI;EACE,cANE;A1By8oBR;A0Bv8oBI;EACE,cAJE;A1B68oBR;A0Bv8oBI;EACE,cANE;A1B+8oBR;A0B78oBI;EACE,cAJE;A1Bm9oBR;A0B78oBI;EACE,cANE;A1Bq9oBR;A0Bn9oBI;EACE,cAJE;A1By9oBR;A0Bn9oBI;EACE,cANE;A1B29oBR;A0Bz9oBI;EACE,cAJE;A1B+9oBR;A0Bz9oBI;EACE,cANE;A1Bi+oBR;A0B/9oBI;EACE,cAJE;A1Bq+oBR;A0B/9oBI;EACE,cANE;A1Bu+oBR;A0Br+oBI;EACE,cAJE;A1B2+oBR;A0Br+oBI;EACE,cANE;A1B6+oBR;A0B3+oBI;EACE,cAJE;A1Bi/oBR;A0B3+oBI;EACE,cANE;A1Bm/oBR;A0Bj/oBI;EACE,cAJE;A1Bu/oBR;A0Bj/oBI;EACE,cANE;A1By/oBR;A0Bv/oBI;EACE,cAJE;A1B6/oBR;A0Bv/oBI;EACE,cANE;A1B+/oBR;A0B7/oBI;EACE,cAJE;A1BmgpBR;A0B7/oBI;EACE,cANE;A1BqgpBR;A0BngpBI;EACE,cAJE;A1BygpBR;A0BngpBI;EACE,cANE;A1B2gpBR;A0BzgpBI;EACE,cAJE;A1B+gpBR;A0BzgpBI;EACE,cANE;A1BihpBR;A0B/gpBI;EACE,cAJE;A1BqhpBR;A0B/gpBI;EACE,cANE;A1BuhpBR;A0B7gpBE;EACE,aqErBe;A/FoipBnB;A0B3gpBE;EACE,gByFtBQ;AnHmipBZ;A0B3gpBE;EACE,gByFxBQ;AnHqipBZ;A0B3gpBE;EACE,iByF1BS;AnHuipBb;A0B3gpBE;EACE,cyF5BU;AnHyipBd;A0B3gpBE;EACE,gByF9BS;AnH2ipBb;A0B3gpBE;EACE,cyFhCO;AnH6ipBX;A0B3gpBE;EACE,cyFlCQ;AnH+ipBZ;A0B3gpBE;EACE,cyFpCW;AnHijpBf;A2BrjpBE;EACE,qBqCRU;ErCSV,qByFHiB;EzFIjB,WAAA;EACA,sByFJwB;ApH2jpB5B;A2BrjpBE;EACE,aAAA;A3BujpBJ;A2BrjpBE;EACE,gBAAA;A3BujpBJ;A2B/ipBE;EACE,qBAAA;EACA,YyFjByB;EzFkBzB,2BAAA;EAEA,yBoDHa;EpDIb,yBkD7Be;ElD8Bf,wByFlBgC;ApHkkpBpC;A2B5ipBE;EACE,cyCrCS;ApEmlpBb;A2B5ipBE;EACE,wD2CrCe;AtEmlpBnB;A2BzipBE;EACE,yBoDpBY;EpDqBZ,wByF9BqC;ApHykpBzC;A2BvipBE;EACE,eAAA;A3ByipBJ;A2BvipBE;EACE,qBAAA;EACA,SyFrCwB;EzFsCxB,UyFrCyB;ApH8kpB7B;A2BripBE;EACE,qBAAA;EACA,2ByFxCyB;ApH+kpB7B;A2BlipBI;EACE,csDlEM;AjFsmpBZ;A2BlipBI;EACE,csDpEE;AjFwmpBR;A2BlipBI;EACE,+BkD/DsB;A7EmmpB5B;A2B5hpBE;EACE,iBmCvEG;A9DqmpBP;A2BthpBE;EACE,0BoD9EG;A/EsmpBP;A2BthpBE;EACE,0BoDhFG;A/EwmpBP;A2BthpBE;EACE,0BoDlFI;A/E0mpBR;A2BthpBE;EACE,eoDpFK;A/E4mpBT;A2BthpBE;EACE,0BoDtFI;A/E8mpBR;A2BthpBE;EACE,0BoDxFE;A/EgnpBN;A2BthpBE;EACE,0BoD1FG;A/EknpBP;A2BthpBE;EACE,0BoD5FM;A/EonpBV;A4BnopBE;EACE,kBAAA;EACA,eAAA;A5BqopBJ;A4B9npBE;EACE,ayFPoB;ArHuopBxB;A4BznpBE;EACE,WAAA;EACA,eyFbgB;ArHwopBpB;A4BxnpBE;;EAEE,gBAAA;A5B0npBJ;A4BvnpBE;EACE,WAAA;EACA,SAAA;A5BynpBJ;A4BjnpBE;EACE,cAAA;EACA,6ByF1BgB;EzF2BhB,0BqC5CS;ErC6CT,yBmDrBa;EnDsBb,iBkCpCG;ElCqCH,oByF3BwB;ArH8opB5B;A4B3mpBE;;;;;;;;;;;;;EAaE,WyF3Ce;EzF4Cf,mBAAA;A5B6mpBJ;A4BzmpBE;;EAEE,sBwE9DgB;ApGyqpBpB;A4BxmpBE;;;;;;;;;;;;EAYE,6EkC1FQ;ElC2FR,SAAA;EACA,aAAA;EACA,wBAAA;EACA,mDAAA;EAEA,2BwEnFgB;ExEoFhB,2ByFtEiB;EzFuEjB,cyFxEmB;EzF0EnB,mBqDnGI;ErDoGJ,wCyFzEgB;EzF0EhB,0BqCtGS;ErCuGT,8BgDpGG;EhDqGH,qCyFrEoB;EzFsEpB,mDyFzEF;ArHirpBF;A4BpmpBE;;EAEE,SAAA;EACA,wBAAA;EACA,mDAAA;EAEA,2ByFpEqB;EzFqErB,mBqDnHI;ErDoHJ,wCyFzFgB;EzF0FhB,aAAA;EACA,0BqCvHS;ErCwHT,8BgDrHG;EhDsHH,qCyFtFoB;EzFuFpB,mDyF1FF;EzF2FE,cyFjGmB;EzFkGnB,6EkC5HQ;ElC6HR,mByF3EyB;EzF4EzB,gByF7EoB;ArHkrpBxB;A4BnmpBE;EACE,YyFjFoB;EzFkFpB,eyF/EwB;EzFgFxB,gByF/EwB;ArHorpB5B;A4BlmpBE;;EAEE,mByF7E2B;ArHirpB/B;A4B7lpBE;EACE,iByFlFmC;ArHirpBvC;A4B7lpBE;EACE,0BAAA;A5B+lpBJ;A4B7lpBE;EACE,0BAAA;A5B+lpBJ;A4B7lpBE;EACE,0BAAA;A5B+lpBJ;A4B7lpBE;EACE,iBAAA;A5B+lpBJ;A4B7lpBE;EACE,iBAAA;A5B+lpBJ;A4B7lpBE;EACE,iBAAA;A5B+lpBJ;A4BxlpBE;;;EAGE,2ByFjJiB;ArH2upBrB;A4BvlpBE;;EAEE,oCAAA;EACA,wCAAA;EACA,2BAAA;A5BylpBJ;A4BtlpBE;;;;EAIE,oCAAA;EACA,yBAAA;A5BwlpBJ;A4BjlpBE;EACE,WAAA;A5BmlpBJ;A4B3kpBE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBqD9MI;ErD+MJ,wCyFpLgB;EzFqLhB,8BgD9MG;EhD+MH,qCyF/KoB;EzFgLpB,mByF1KkB;EzF2KlB,0BqCpNS;ErCqNT,mDyFrLF;ArHkwpBF;A4BrkpBE;EACE,eAAA;EACA,WAAA;A5BukpBJ;A4BrkpBE;EACE,YAAA;A5BukpBJ;A4BnkpBE;;EAEE,WAAA;A5BqkpBJ;A4BnkpBE;;EAEE,WAAA;A5BqkpBJ;A4B7jpBE;;;EAGE,WAAA;A5B+jpBJ;A4B3jpBE;;EAEE,WAAA;EACA,sBAAA;A5B6jpBJ;A4BzjpBE;;EAEE,WAAA;A5B2jpBJ;A4BvjpBE;;;;;;;;;;EAUE,cAAA;EACA,QAAA;A5ByjpBJ;A4BjjpBE;;;;EAIE,aAAA;A5BmjpBJ;A4B/ipBE;EACE,aAAA;A5BijpBJ;A4B1ipBE;EACE,mBAAA;EACA,8BAAA;EACA,oCAAA;EACA,yBAAA;A5B4ipBJ;A4B1ipBE;;EAEE,mBAAA;EACA,8ByFvOwB;ArHmxpB5B;A4B1ipBE;;EAEE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;A5B4ipBJ;A4BhipBE;EACE,gDAAA;EACA,gCAAA;A5BkipBJ;A4B9hpBE;EACE,gDAAA;EACA,gCAAA;A5BgipBJ;A4B5hpBE;EACE,gDAAA;EACA,gCAAA;A5B8hpBJ;A4BphpBE;EACE,yCwExVsB;ApG82pB1B;A4BphpBE;EACE,oDAAA;A5BshpBJ;A4BphpBE;EACE,yCwE9VsB;ApGo3pB1B;A4BnhpBE;EACE,yCwEjW4B;ApGs3pBhC;A4BnhpBE;EACE,oDAAA;A5BqhpBJ;A4BnhpBE;EACE,yCwEvW4B;ApG43pBhC;A4BjhpBE;EACE,0DyFhPiC;ArHmwpBrC;A4BjhpBE;EACE,qEAAA;A5BmhpBJ;A4BjhpBE;EACE,0DyFtPiC;ArHywpBrC;A4BhhpBE;EACE,0DyFzPuC;ArH2wpB3C;A4BhhpBE;EACE,qEAAA;A5BkhpBJ;A4BhhpBE;EACE,0DyF/PuC;ArHixpB3C;A4B1gpBE;;;;;;;;;;;;EAYE,0BiDtZkB;EjDuZlB,qBwEvYwB;ExEwYxB,8BgDzZG;EhD0ZH,mBqD5ZI;ErD6ZJ,gDyFrU0B;ArHi1pB9B;A4B1gpBE;EACE,0BiD7ZkB;EjD8ZlB,qBwE9YwB;ExE+YxB,8BgDhaG;EhDiaH,mBqDnaI;ErDoaJ,gDyF5U0B;EzF6U1B,wBAAA;A5B4gpBJ;A4BngpBE;EACE,cAAA;A5BqgpBJ;A4BngpBE;EACE,qBAAA;A5BqgpBJ;A4BngpBE;EACE,aAAA;A5BqgpBJ;A4B7/oBE;EACE,cAAA;A5B+/oBJ;A4B7/oBE;EACE,qBAAA;A5B+/oBJ;A4B7/oBE;EACE,aAAA;A5B+/oBJ;A4Bv/oBE;EACE,cAAA;A5By/oBJ;A4Bv/oBE;EACE,qBAAA;A5By/oBJ;A4Bv/oBE;EACE,aAAA;A5By/oBJ;A4Br/oBE;;;;EAIE,c0E5dkB;AtGm9pBtB;A4Bp/oBE;;EAEE,qB0EjekB;E1EkelB,cqDjeI;AjFu9pBR;A4Bn/oBE;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4BE,mByE1fwB;EzE2fxB,qBwDlgBoB;ExDmgBpB,c0EngBkB;E1EogBlB,iByF/Y6B;EzFgZ7B,gByF/Y0B;ArHo4pB9B;A4Bn/oBE;;;;;;;;;;;;;;EAcE,mByE9gBwB;EzE+gBxB,qBwDthBoB;ExDuhBpB,c0EvhBkB;E1EyhBlB,gByFtZgC;ArH04pBpC;A4Bh/oBE;EACE,mCAAA;A5Bk/oBJ;A4B3+oBE;;;;;EAKE,mByEniBwB;EzEoiBxB,c0E3iBkB;AtGwhqBtB;A4B3+oBE;;EAEE,gCAAA;A5B6+oBJ;A4B3+oBE;;EAEE,gCAAA;A5B6+oBJ;A4B3+oBE;;EAEE,qBwDvjBoB;ApFoiqBxB;A4B3+oBE;;EAEE,yByF/bmC;EzFgcnC,c0E5jBkB;AtGyiqBtB;A4Bz+oBE;;EAEE,yByFzcmC;ArHo7pBvC;A4Bv+oBE;;EAEE,yByF/cmC;ArHw7pBvC;A4Bp+oBE;;EAEE,oCAAA;A5Bs+oBJ;A4B/9oBE;;;;EAIE,c0E1lBkB;AtG2jqBtB;A4B/9oBE;;;;EAIE,mByEzlBwB;EzE0lBxB,qBwDjmBoB;ApFkkqBxB;A4B/9oBE;;;;EAIE,c0EvmBkB;AtGwkqBtB;A4B19oBE;;;EAGE,oBAAA;EACA,amErnBe;A/FilqBnB;A4B19oBE;;EAEE,amEznBe;A/FqlqBnB;A4B19oBE;EACE,UAAA;A5B49oBJ;A4Bp9oBE;EACE,kBAAA;EACA,eAAA;EACA,oBAAA;A5Bs9oBJ;A4Bp9oBE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,oCyFjgBuB;EzFkgBvB,WAAA;EACA,YAAA;EACA,YyFlgByB;ArHw9pB7B;A4Bn9oBE;EACE,8BgD/oBG;A5EomqBP;A4Bl9oBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CkD1pBY;ElD2pBZ,UyF7gBe;EzF8gBf,WyF9gBe;EzFghBf,sCAAA;EACA,2BAAA;EACA,qBoDlqBc;EpDoqBd,iCAAA;EACA,mBAAA;EACA,YyFrhBuB;ArHs+pB3B;A4Bt8oBE;;;;;;EAME,wByF7hBmB;EzF8hBnB,YyFliBoB;EzFmiBpB,cuD3rBE;AnFmoqBN;A4Br8oBE;;;;EAIE,qBAAA;EACA,mBAAA;A5Bu8oBJ;A4Bp8oBE;;EAEE,kBAAA;EACA,MAAA;EACA,UAAA;A5Bs8oBJ;A4Bz7oBE;;;;;;;;;;;EAWE,+BiDxtBkB;A7EmpqBtB;A4Bz7oBE;EACE,cqDjuBI;AjF4pqBR;A4Bz7oBE;EACE,+ByF1lBgC;ArHqhqBpC;A4Bx7oBE;;;;;;;;;;;;EAYE,mBqDnvBI;ErDovBJ,sCyDpuBiB;EzDquBjB,0BqCtvBS;ErCuvBT,qCyFptBoB;ArH8oqBxB;A4Bl7oBE;EACE,cAAA;EACA,eyFvvBgB;ArH2qqBpB;A4Bl7oBE;EACE,gBAAA;A5Bo7oBJ;A4Bj7oBE;EACE,6ByFvvBgB;EzFwvBhB,0BqCzwBS;ErC0wBT,yBmDlvBa;EnDmvBb,iBkCjwBG;ElCkwBH,oByFxvBwB;ArH2qqB5B;A4Bh7oBE;;EAEE,cAAA;EACA,eyF3mBwB;EzF4mBxB,UAAA;A5Bk7oBJ;A4B16oBE;EACE,aAAA;EACA,mBAAA;EACA,oByFjxBiB;ArH6rqBrB;A4B16oBE;EACE,cAAA;EACA,mBAAA;EACA,oBAAA;A5B46oBJ;A4B16oBE;EACE,iBAAA;EACA,gBAAA;A5B46oBJ;A4Bx6oBE;;EAEE,U0F5xBS;AtHssqBb;A4Bx6oBE;;EAEE,qB0F/xBW;AtHysqBf;A4Bx6oBE;;EAEE,U0FlyBU;AtH4sqBd;A4Bx6oBE;;EAEE,U0FryBU;AtH+sqBd;A4Bx6oBE;;EAEE,qB0FxyBS;AtHktqBb;A4Bx6oBE;;EAEE,qB0F3yBW;AtHqtqBf;A4Bx6oBE;;EAEE,Y0F9yBW;AtHwtqBf;A4Bx6oBE;;EAEE,qB0FjzBU;AtH2tqBd;A4Bx6oBE;;EAEE,U0FpzBS;AtH8tqBb;A4Bt6oBE;EACE;IACE,eAAA;E5Bw6oBJ;E4Br6oBE;;;;;;;;;;;;;;;;;;;;IAoBE,sBAAA;IACA,eAAA;E5Bu6oBJ;AACF;A4Bl6oBE;EACE,Y0Fn3BO;E1Fo3BP,mBAAA;EACA,oBAAA;A5Bo6oBJ;A4Bj6oBE;EACE,uBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,uBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,wBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,qBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,wBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,uBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,wBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,qBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,wBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,uBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,wBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,qBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,wBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,uBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,wBAAA;A5Bm6oBJ;A4Bj6oBE;EACE,sBAAA;A5Bm6oBJ;A4B/5oBE;EACE;;;;;;;;;;;;;;;;;;;;;;;IAuBE,sBAAA;E5Bi6oBJ;E4B/5oBE;IACE,gBAAA;E5Bi6oBJ;AACF;A4B15oBE;;EAEE,WAAA;EACA,cAAA;A5B45oBJ;A4Br5oBE;EACE,eyF78BgB;EzF88BhB,mBAAA;A5Bu5oBJ;A4Br5oBE;EACE,SAAA;EACA,kByF9xBwB;ArHqrqB5B;A4Bn5oBE;;;;;EAKE,qBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBmDl9Ba;EnDm9Bb,iBkCj+BG;ElCk+BH,0BqC5+BS;ErC6+BT,oByFz9BwB;ArH82qB5B;A4Bj5oBE;EACE,0ByFxzB+B;ArH2sqBnC;A4B/4oBE;;;;EAIE,qBAAA;EACA,WAAA;EAEA,aAAA;EACA,gBAAA;EAEA,sBAAA;EACA,cmDx+Bc;A/Eu3qBlB;A4B34oBE;;EAEE,4BAAA;A5B64oBJ;A4B34oBE;;EAEE,SAAA;A5B64oBJ;A4Bz4oBE;EACE,aAAA;EACA,mBAAA;A5B24oBJ;A4Bz4oBE;;EAEE,WAAA;A5B24oBJ;A4Bn4oBE;EACE,0BmDlhCG;A/Eu5qBP;A4Bn4oBE;EACE,0BmDphCG;A/Ey5qBP;A4Bn4oBE;EACE,0BmDthCI;A/E25qBR;A4Bn4oBE;EACE,emDxhCK;A/E65qBT;A4Bn4oBE;EACE,0BmD1hCI;A/E+5qBR;A4Bn4oBE;EACE,0BmD5hCE;A/Ei6qBN;A4Bn4oBE;EACE,0BmD9hCG;A/Em6qBP;A4Bn4oBE;EACE,0BmDhiCM;A/Eq6qBV;A4Bj4oBE;EACE,0BmD5iCG;A/E+6qBP;A4Bj4oBE;EACE,0BmD9iCG;A/Ei7qBP;A4Bj4oBE;EACE,0BmDhjCI;A/Em7qBR;A4Bj4oBE;EACE,emDljCK;A/Eq7qBT;A4Bj4oBE;EACE,0BmDpjCI;A/Eu7qBR;A4Bj4oBE;EACE,0BmDtjCE;A/Ey7qBN;A4Bj4oBE;EACE,0BmDxjCG;A/E27qBP;A4Bj4oBE;EACE,0BmD1jCM;A/E67qBV;A4B/3oBE;EACE,0BmDtkCG;A/Eu8qBP;A4B/3oBE;EACE,0BmDxkCG;A/Ey8qBP;A4B/3oBE;EACE,0BmD1kCI;A/E28qBR;A4B/3oBE;EACE,emD5kCK;A/E68qBT;A4B/3oBE;EACE,0BmD9kCI;A/E+8qBR;A4B/3oBE;EACE,0BmDhlCE;A/Ei9qBN;A4B/3oBE;EACE,0BmDllCG;A/Em9qBP;A4B/3oBE;EACE,0BmDplCM;A/Eq9qBV;A6Bp+qBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;A7Bs+qBJ;A6B/9qBE;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;A7Bi+qBJ;A6B/9qBE;EACE,oBAAA;EACA,qBAAA;A7Bi+qBJ;A6B/9qBE;EACE,oBAAA;EACA,qBAAA;A7Bi+qBJ;A6B59qBE;EACE,gB0FhBwB;AvH8+qB5B;A6Bt9qBE;;EAEE,kBAAA;EACA,qBAAA;EAEA,YyFhDO;EzFiDP,kBAAA;EACA,mBAAA;EACA,mBAAA;A7Bu9qBJ;A6Bp9qBE;EACE,kBAAA;EACA,mBAAA;A7Bs9qBJ;A6B/8qBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;A7Bi9qBJ;A6Bz8qBE;EACE,iBAAA;EACA,oBAAA;A7B28qBJ;A6Bz8qBE;EACE,aAAA;EACA,gBAAA;A7B28qBJ;A6Bp8qBE;;EAEE,e0F/E0B;AvHqhrB9B;A6B97qBE;EACE,aAAA;A7Bg8qBJ;A6B97qBE;EACE,gBAAA;A7Bg8qBJ;A6B57qBE;;EAEE,WAAA;A7B87qBJ;A6B17qBE;EACE,YAAA;EACA,iBAAA;A7B47qBJ;A6B17qBE;EACE,wBAAA;A7B47qBJ;A6Bx7qBE;;EAEE,gBAAA;A7B07qBJ;A6B96qBE;EACE;IACE,W0FnEc;I1FoEd,e0FlEe;I1FmEf,gB0FnEe;I1FoEf,cAAA;IACA,eAAA;E7Bg7qBJ;AACF;A6B96qBE;EACE;IACE,W0FxEc;I1FyEd,c0FxEe;I1FyEf,e0FzEe;I1F0Ef,iB0FzEe;I1F0Ef,kB0F1Ee;EvH0/qBnB;AACF;A6B96qBE;EACE;IACE,W0F7EgB;I1F8EhB,c0F7EiB;I1F8EjB,e0F9EiB;I1F+EjB,gB0F9EiB;I1F+EjB,iB0F/EiB;EvH+/qBrB;AACF;A6B96qBE;EACE;IACE,W0FlFqB;I1FmFrB,c0FlFsB;I1FmFtB,e0FnFsB;I1FoFtB,iB0FnFsB;I1FoFtB,kB0FpFsB;EvHogrB1B;AACF;A6B96qBE;EACE;IACE,W0FvF0B;I1FwF1B,c0FvFmB;I1FwFnB,e0FxFmB;I1FyFnB,iB0FxF2B;I1FyF3B,kB0FzF2B;EvHygrB/B;AACF;A6Bv6qBE;;EAEE,WyFlLS;AtH2lrBb;A6Br6qBE;;EAEE,WyFxLS;AtH+lrBb;A6Br6qBE;;EAEE,UyF3LS;AtHkmrBb;A6Br6qBE;;EAEE,qByF9LW;AtHqmrBf;A6Br6qBE;;EAEE,UyFjMU;AtHwmrBd;A6Br6qBE;;EAEE,UyFpMU;AtH2mrBd;A6Br6qBE;;EAEE,qByFvMS;AtH8mrBb;A6Br6qBE;;EAEE,qByF1MW;AtHinrBf;A6Br6qBE;;EAEE,YyF7MW;AtHonrBf;A6Br6qBE;;EAEE,qByFhNU;AtHunrBd;A6Br6qBE;;EAEE,UyFnNS;AtH0nrBb;A6Br6qBE;;EAEE,oByFtNY;AtH6nrBhB;A6Br6qBE;;EAEE,oByFzNY;AtHgorBhB;A6Br6qBE;;EAEE,oByF5Nc;AtHmorBlB;A6Br6qBE;;EAEE,oByF/Nc;AtHsorBlB;A6Br6qBE;;EAEE,oByFlOa;AtHyorBjB;A6Br6qBE;;EAEE,YyFrOa;AtH4orBjB;A6Bn6qBE;EACE,sBAAA;A7Bq6qBJ;A6Bn6qBE;EACE,qBAAA;A7Bq6qBJ;A6Bn6qBE;EACE,gCAAA;A7Bq6qBJ;A6Bn6qBE;EACE,qBAAA;A7Bq6qBJ;A6Bn6qBE;EACE,qBAAA;A7Bq6qBJ;A6Bn6qBE;EACE,gCAAA;A7Bq6qBJ;A6Bn6qBE;EACE,gCAAA;A7Bq6qBJ;A6Bn6qBE;EACE,uBAAA;A7Bq6qBJ;A6Bn6qBE;EACE,gCAAA;A7Bq6qBJ;A6Bn6qBE;EACE,qBAAA;A7Bq6qBJ;A6Bn6qBE;EACE,+BAAA;A7Bq6qBJ;A6Bn6qBE;EACE,+BAAA;A7Bq6qBJ;A6Bn6qBE;EACE,+BAAA;A7Bq6qBJ;A6Bn6qBE;EACE,+BAAA;A7Bq6qBJ;A6Bn6qBE;EACE,+BAAA;A7Bq6qBJ;A6Bn6qBE;EACE,uBAAA;A7Bq6qBJ;A6Bj6qBE;EACE,gBAAA;A7Bm6qBJ;A6B35qBE;;;;EAIE,uBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,uBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,wBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,qBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,wBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,uBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,wBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,qBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,wBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,uBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,wBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,qBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,wBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,uBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,wBAAA;A7B65qBJ;A6B35qBE;;;;EAIE,sBAAA;A7B65qBJ;A6Br5qBE;EACE;;;;IAIE,uBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,uBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,wBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,qBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,wBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,uBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,wBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,qBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,wBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,uBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,wBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,qBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,wBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,uBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,wBAAA;E7Bu5qBJ;E6Br5qBE;;;;IAIE,sBAAA;E7Bu5qBJ;AACF;A6Bn5qBE;EACE;;;;IAIE,uBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,uBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,wBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,qBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,wBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,uBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,wBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,qBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,wBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,uBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,wBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,qBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,wBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,uBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,wBAAA;E7Bq5qBJ;E6Bn5qBE;;;;IAIE,sBAAA;E7Bq5qBJ;AACF;A6Bj5qBE;EACI;;;;IAIA,uBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,uBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,wBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,qBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,wBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,uBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,wBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,qBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,wBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,uBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,wBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,qBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,wBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,uBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,wBAAA;E7Bm5qBJ;E6Bj5qBE;;;;IAIE,sBAAA;E7Bm5qBJ;AACF;A6B/4qBE;EACE;;;;IAIE,uBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,uBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,wBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,qBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,wBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,uBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,wBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,qBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,wBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,uBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,wBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,qBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,wBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,uBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,wBAAA;E7Bi5qBJ;E6B/4qBE;;;;IAIE,sBAAA;E7Bi5qBJ;AACF;A6B74qBE;EACE;;;;IAIE,uBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,uBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,wBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,qBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,wBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,uBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,wBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,qBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,wBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,uBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,wBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,qBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,wBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,uBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,wBAAA;E7B+4qBJ;E6B74qBE;;;;IAIE,sBAAA;E7B+4qBJ;AACF;A6Bx4qBE;;;EAGE,kBAAA;EACA,uBAAA;A7B04qBJ;A6Bx4qBE;;;EAGE,gBAAA;A7B04qBJ;A6Bv4qBE;;EAEE,cAAA;EACA,iBAAA;EACA,kBAAA;A7By4qBJ;A6Bl4qBE;;;EAGE,oBAAA;EACA,qBAAA;A7Bo4qBJ;A6Bj4qBE;;;EAGE,oBAAA;EACA,qBAAA;A7Bm4qBJ;A6B/3qBE;;EAEE,mBAAA;EACA,oBAAA;A7Bi4qBJ;A6B/3qBE;;EAEE,mBAAA;EACA,oBAAA;A7Bi4qBJ;A6Bz3qBE;EACE,oBAAA;A7B23qBJ;A6Bz3qBE;EACE,yBAAA;EACA,0BAAA;A7B23qBJ;A6Bz3qBE;EACE,wBAAA;EACA,2BAAA;A7B23qBJ;A6Bp3qBE;EACE,kBAAA;A7Bs3qBJ;A6Bp3qBE;EACE,iBAAA;A7Bs3qBJ;A6B92qBE;;EAEE,6C0Fv9BkB;AvHu0sBtB;A6B52qBE;;EAEE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;A7B82qBJ;A6B52qBE;EACE,aAAA;EACA,gBAAA;A7B82qBJ;A6Bx2qBE;;EAEE,gBAAA;A7B02qBJ;A6Bt2qBE;EACE,aAAA;A7Bw2qBJ;A6Bn2qBE;EACE,6C0Fv/BkB;AvH41sBtB;A6Bn2qBE;EACE,gBAAA;A7Bq2qBJ;A6Bj2qBE;EACE,kBAAA;A7Bm2qBJ;A6Bj2qBE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EAEA,wBAAA;EACA,WAAA;EAEA,cAAA;EACA,6C0F1gC6B;AvH22sBjC;A6B71qBE;;EAEE,WAAA;A7B+1qBJ;A6B31qBE;EACE,gBAAA;A7B61qBJ;A6Bz1qBE;;EAEE,+C0FzhC2B;AvHo3sB/B;A6Bz1qBE;;EAEE,gBAAA;A7B21qBJ;A6Bz1qBE;EACE,+C0F/hCsC;AvH03sB1C;A6Bv1qBE;EACE,mBAAA;EACA,oBAAA;EACA,wBAAA;A7By1qBJ;A6Bv1qBE;EACE,mBAAA;EACA,oBAAA;EACA,wBAAA;A7By1qBJ;A6Bl1qBE;EACE,WAAA;EACA,a0FhjCiB;E1FijCjB,6B0FziCkB;AvH63sBtB;A6Bj1qBE;EACE,sBAAA;EACA,SAAA;EACA,UAAA;EACA,8B0F/iCsB;AvHk4sB1B;A6Bj1qBE;;EAEE,8B0FljCyB;AvHq4sB7B;A6Bh1qBE;;EAEE,gBAAA;A7Bk1qBJ;A6B/0qBE;;EAEE,Y0FlkCkB;AvHm5sBtB;A6B/0qBE;;EAEE,c0FrkC0B;AvHs5sB9B;A6B/0qBE;;EAEE,Y0FxkC+B;AvHy5sBnC;A6B70qBE;EACE,gBAAA;EACA,SAAA;A7B+0qBJ;A6B70qBE;EACE,gBAAA;A7B+0qBJ;A6B70qBE;EACE,gBAAA;A7B+0qBJ;A6Bv0qBE;;;;;EAKE,sBAAA;EACA,mBAAA;EACA,iCAAA;A7By0qBJ;A6Br0qBE;;;;;EAKE,sBAAA;EACA,sBAAA;EACA,6BAAA;A7Bu0qBJ;A6Bn0qBE;;;;;EAKE,sBAAA;EACA,sBAAA;EACA,+BAAA;A7Bq0qBJ;A6Bj0qBE;;;;;EAKE,+BAAA;EACA,mBAAA;EACA,sBAAA;A7Bm0qBJ;A6Bh0qBE;;;;;EAKE,YAAA;A7Bk0qBJ;A6B1zqBE;;;;;EAKE,gBAAA;EACA,mBAAA;A7B4zqBJ;A6BxzqBE;;;;;EAKE,kBAAA;EACA,mBAAA;A7B0zqBJ;A6BxzqBE;EACE,uBAAA;A7B0zqBJ;A6BtzqBE;;;;;EAKE,iBAAA;EACA,mBAAA;A7BwzqBJ;A6BpzqBE;;;;;EAKE,mBAAA;EACA,aAAA;A7BszqBJ;A6B3yqBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFiitBR;A6BjzqBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFuitBR;A6BvzqBI;;;EAGE,yBALE;EAMF,coDpvCE;AjF6itBR;A6B7zqBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFmjtBR;A6Bn0qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFyjtBR;A6Bz0qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjF+jtBR;A6B/0qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFqktBR;A6Br1qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjF2ktBR;A6B31qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFiltBR;A6Bj2qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFultBR;A6Bv2qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjF6ltBR;A6B72qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFmmtBR;A6Bn3qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFymtBR;A6Bz3qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjF+mtBR;A6B/3qBI;;;EAGE,yBALE;EAMF,coDpvCE;AjFqntBR;A6Bx3qBE;;;EAGE,qBAAA;EACA,YAAA;A7B03qBJ;A6Bx3qBE;;;EAGE,YAAA;A7B03qBJ;A6Bh3qBE;E7BpwCF;I6B+wCI,qBAAA;IASA,gCAAA;IAOA,oBAAA;E7B21qBF;E6Br3qBE;;;IAGE,2BAAA;E7Bu3qBJ;E6Br3qBE;;IAEE,8BAAA;E7Bu3qBJ;E6Bn3qBE;;IAEE,6C0FlwCgB;EvHuntBpB;E6Bn3qBE;;IAEE,gBAAA;E7Bq3qBJ;E6Bl3qBE;IACE,6C0FzwC2B;EvH6ntB/B;E6Bl3qBE;IACE,gBAAA;E7Bo3qBJ;E6Bj3qBE;IACE,8B0F/vCuB;EvHkntB3B;E6Bj3qBE;IACE,gBAAA;E7Bm3qBJ;AACF;A6B/2qBE;E7BzyCF;I6BmzCI,qBAAA;IASA,gCAAA;IAOA,oBAAA;E7B21qBF;E6Bp3qBE;;;IAGE,2BAAA;E7Bs3qBJ;E6Bp3qBE;IACE,8BAAA;E7Bs3qBJ;E6Bl3qBE;;IAEE,6C0FtyCgB;EvH0ptBpB;E6Bl3qBE;;IAEE,gBAAA;E7Bo3qBJ;E6Bj3qBE;IACE,6C0F7yC2B;EvHgqtB/B;E6Bj3qBE;IACE,gBAAA;E7Bm3qBJ;E6Bh3qBE;IACE,8B0FnyCuB;EvHqptB3B;E6Bh3qBE;IACE,gBAAA;E7Bk3qBJ;AACF;A6B92qBE;E7B70CF;I6Bu1CI,qBAAA;IASA,gCAAA;IAOA,oBAAA;E7B01qBF;E6Bn3qBE;;;IAGE,2BAAA;E7Bq3qBJ;E6Bn3qBE;IACE,8BAAA;E7Bq3qBJ;E6Bj3qBE;;IAEE,6C0F10CgB;EvH6rtBpB;E6Bj3qBE;;IAEE,gBAAA;E7Bm3qBJ;E6Bh3qBE;IACE,6C0Fj1C2B;EvHmstB/B;E6Bh3qBE;IACE,gBAAA;E7Bk3qBJ;E6B/2qBE;IACE,8B0Fv0CuB;EvHwrtB3B;E6B/2qBE;IACE,gBAAA;E7Bi3qBJ;AACF;A6Bx2qBE;EACE;IACE,WAAA;E7B02qBJ;E6Bx2qBE;;IAEE,oBAAA;IACA,qBAAA;E7B02qBJ;E6Bx2qBE;;IAEE,gCAAA;IACA,4BAAA;IACA,+BAAA;IACA,2BAAA;IACA,SAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,sBAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,qBAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,qBAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,gCAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,gCAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,gCAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,qBAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,qBAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,qBAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,qBAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,gCAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,gCAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,gCAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,gCAAA;E7B02qBJ;E6Bx2qBE;;;IAGE,uBAAA;E7B02qBJ;AACF;A6Bt2qBE;EACE;;IAEE,oBAAA;IACA,qBAAA;E7Bw2qBJ;E6Bt2qBE;;IAEE,4BAAA;IACA,+BAAA;IACA,oBAAA;IACA,2BAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,sBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,gCAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,gCAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,gCAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,gCAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,gCAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;E6Bt2qBE;;;IAGE,qBAAA;E7Bw2qBJ;AACF;A6Bj2qBE;E7BnjDF;I6B0kDI,aAAA;IAOA,4CAAA;IAOA,sBAAA;E7Bk0qBF;E6Bt2qBE;IACE,WAAA;IACA,yBAAA;IACA,0BAAA;E7Bw2qBJ;E6Bt2qBE;;;;;;;IAOE,sBAAA;IACA,sBAAA;IACA,2BAAA;IACA,6BAAA;E7Bw2qBJ;E6Bt2qBE;IACE,SAAA;IACA,UAAA;E7Bw2qBJ;E6Bp2qBE;;IAEE,0BAAA;IACA,2BAAA;E7Bs2qBJ;E6Bl2qBE;;IAEE,6BAAA;IACA,8BAAA;E7Bo2qBJ;E6Bh2qBE;;;;IAIE,2BAAA;E7Bk2qBJ;E6Bh2qBE;;;;IAIE,8C0FzjDkC;EvH25tBtC;E6B/1qBE;;;;IAIE,4C0FjkDyB;I1FkkDzB,2BAAA;IACA,4BAAA;IACA,+BAAA;E7Bi2qBJ;E6B91qBE;IACE,2BAAA;E7Bg2qBJ;E6B91qBE;;IAEE,0BAAA;IACA,2BAAA;E7Bg2qBJ;AACF;A6Bp1qBE;EACE;;;;IAIE,wBAAA;E7Bs1qBJ;E6Bp1qBE;;;;IAIE,wBAAA;E7Bs1qBJ;E6Bp1qBE;;;;IAIE,wBAAA;E7Bs1qBJ;E6Bp1qBE;;;;IAIE,wBAAA;E7Bs1qBJ;AACF;A6Bn1qBE;EACE;;;;IAIE,wBAAA;E7Bq1qBJ;E6Bn1qBE;;;;IAIE,wBAAA;E7Bq1qBJ;E6Bn1qBE;;;;IAIE,wBAAA;E7Bq1qBJ;E6Bn1qBE;;;;IAIE,wBAAA;E7Bq1qBJ;AACF;A6Bj1qBE;EACE;;;;IAIE,wBAAA;E7Bm1qBJ;E6Bj1qBE;;;;IAIE,wBAAA;E7Bm1qBJ;E6Bj1qBE;;;;IAIE,wBAAA;E7Bm1qBJ;E6Bj1qBE;;;;IAIE,wBAAA;E7Bm1qBJ;AACF;A6B/0qBE;EACE;;;;IAIE,wBAAA;E7Bi1qBJ;E6B/0qBE;;;;IAIE,wBAAA;E7Bi1qBJ;E6B/0qBE;;;;IAIE,wBAAA;E7Bi1qBJ;AACF;A6B70qBE;EACE;;;;IAIE,wBAAA;E7B+0qBJ;E6B70qBE;;;;IAIE,wBAAA;E7B+0qBJ;AACF;A6Bx0qBE;;EAEE,oBAAA;EACA,qBAAA;A7B00qBJ;A6Bv0qBE;EACE,oBAAA;EACA,qBAAA;A7By0qBJ;A6Br0qBE;EACE,mBAAA;EACA,sBAAA;A7Bu0qBJ;A6Bn0qBE;EACE,mBAAA;EACA,sBAAA;A7Bq0qBJ;A6Bj0qBE;;EAEE,e0F1uDkC;AvH6iuBtC;A6Bj0qBE;;EAEE,Y0F7uDuC;AvHgjuB3C;A6B5zqBE;;EAEE,qBAAA;EACA,qBAAA;A7B8zqBJ;A6B3zqBE;EACE,qBAAA;EACA,sBAAA;A7B6zqBJ;A6BzzqBE;EACE,oBAAA;EACA,uBAAA;A7B2zqBJ;A6BvzqBE;EACE,oBAAA;EACA,uBAAA;A7ByzqBJ;A6BrzqBE;;EAEE,gB0FzwDuC;AvHgkuB3C;A6BrzqBE;;EAEE,c0F5wD4C;AvHmkuBhD;A8BlouBE;EACE,aAAA;EACA,c0FWU;E1FVV,6EgCPQ;EhCQR,mB0FUc;E1FTd,mBgCEK;EhCDL,wC0FaU;E1FZV,8CgFPY;EhFQZ,8B8CTG;E9CUH,0B0Fac;AxHunuBlB;A8BjouBE;EACE,WAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;A9BmouBJ;A8BhouBE;EACE,aAAA;A9BkouBJ;A8BhouBE;EACE,gBAAA;A9BkouBJ;A8B1nuBE;EACE,SAAA;A9B4nuBJ;A8BznuBE;EACE,aAAA;A9B2nuBJ;A8BpnuBE;EACE,aAAA;EACA,mBAAA;A9BsnuBJ;A8BnnuBE;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,wCAAA;EACA,cAAA;EACA,iBAAA;EAEA,gB0F1CmB;E1F2CnB,sCAAA;EACA,oB0F3DuB;E1F4DvB,0BmCjES;EnCkET,mBgCvDK;EhCwDL,uE0F5DF;AxHgruBF;A8BjnuBE;EACE,kDAAA;A9BmnuBJ;A8B/muBE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EAEA,U0FrDgB;E1FsDhB,iCuD9DoB;ArF8quBxB;A8BzmuBE;;;EAGE,iBAAA;EACA,gB0FnDoB;AxH8puBxB;A8BzmuBE;EACE,aAAA;A9B2muBJ;A8BzmuBE;EACE,gBAAA;A9B2muBJ;A8BpmuBE;EACE,Y0F1DgB;E1F2DhB,W0F7Dc;E1F8Dd,4B0F7De;AxHmquBnB;A8B/luBE;EACE,kBAAA;EACA,M0F9BiB;E1F+BjB,gB0F9BiB;E1F+BjB,8BiDnGY;EjDoGZ,2BiDpGY;EjDqGZ,ciDlGc;A/EmsuBlB;A8B1luBE;;EAEE,aAAA;EACA,oBAAA;EACA,uBAAA;A9B4luBJ;A8BrluBE;EACE,WAAA;A9BuluBJ;A8BrluBE;EACE,kBAAA;EACA,M0FlDgB;E1FmDhB,gBAAA;A9BuluBJ;A8BrluBE;EACE,ciD7Hc;EjD8Hd,2B8C/EU;E9CgFV,8B8ChFU;A5EuquBd;A8B/kuBE;;EAEE,SAAA;EACA,c0F1GqB;E1F2GrB,sBgCzJK;EhC0JL,iBgC3JG;A9D4uuBP;A8B9kuBE;EACE,iB0FvG0B;E1FwG1B,ciDjJc;EjDkJd,iBgCjKG;A9DivuBP;A8BvkuBE;EACE,UAAA;EACA,Y0FjIuB;E1FkIvB,iBAAA;A9BykuBJ;A8BrkuBE;EACE,2BAAA;EACA,kDAAA;EACA,mB0FhEuB;E1FiEvB,aAAA;EACA,2C0FpEuB;E1FqEvB,iCAAA;A9BukuBJ;A8BlkuBE;EACE,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,iDAAA;EACA,kCAAA;EACA,qCAAA;EACA,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;A9BokuBJ;A8BlkuBE;EACE,0CAAA;EACA,qCAAA;A9BokuBJ;A8BlkuBE;EACE,0CAAA;EACA,qCAAA;A9BokuBJ;A8BlkuBE;EACE,0CAAA;EACA,4BAAA;EACA,qCAAA;A9BokuBJ;A8BjkuBE;EACE,cAAA;A9BmkuBJ;A8BjkuBE;EACE,qBAAA;EACA,yBAAA;EACA,W0F3F4B;E1F4F5B,+BAAA;A9BmkuBJ;A8B9juBE;;EAEE,8B8C3OG;E9C4OH,0B8C1KU;A5E0uuBd;A8B5juBE;EACE,kB0F/F8B;AxH6puBlC;A8BzjuBI;;EAEE,+B+CpPgB;A7E+yuBtB;A8BrjuBI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;A9BujuBN;A8BrjuBI;EACE,UAAA;EACA,oGAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,2C0FzH8B;E1F0H9B,gEAAA;A9BujuBN;A8BrjuBI;EACE,SAAA;A9BujuBN;A8BrjuBI;EACE,MAAA;A9BujuBN;A8BrjuBI;EACE,0BAAA;EACA,6BAAA;A9BujuBN;A8BrjuBI;EACE,gBAAA;A9BujuBN;A8BljuBE;EACE,WAAA;A9BojuBJ;A8B7iuBE;EACE,gB0F3LqB;E1F4LrB,6BAAA;A9B+iuBJ;A8B7iuBE;EACE,mB0FnMgB;E1FoMhB,sB0FpMgB;E1FqMhB,6BAAA;A9B+iuBJ;A8B7iuBE;EACE,6BAAA;A9B+iuBJ;A8B7iuBE;EACE,mB0F1MoB;E1F2MpB,cmDpTI;AjFm2uBR;A8B7iuBE;EACE,wC0F/L4B;E1FgM5B,gB0FjMsB;AxHgvuB1B;A8BziuBE;EACE,qBAAA;EACA,sBAAA;EACA,gB0F9NgB;E1F+NhB,Y0F9Ne;AxHywuBnB;A8BziuBE;EACE,cAAA;EACA,eAAA;EACA,W0FlOwB;AxH6wuB5B;A8B/huBE;EACE,2BAAA;A9BiiuBJ;A8BvhuBI;EACE,yBAAA;A9ByhuBN;A8BvhuBI;EACE,SAAA;EACA,SAAA;A9ByhuBN;A8BjhuBE;EACE;IACE,sBAAA;IACA,yBAAA;IACA,0BAAA;E9BmhuBJ;AACF;A8BjhuBE;EACE;IACE,4CAAA;E9BmhuBJ;E8BjhuBE;;IAEE,6CAAA;E9BmhuBJ;AACF;A8BtguBE;;;;EAIE,eAAA;EACA,+B2D/YuB;E3DgZvB,0B+CzYkB;A7Ei5uBtB;A8BhguBE;;;EAGE,+B2D3ZuB;E3D4ZvB,0B+CrZkB;A7Eu5uBtB;A8B1/tBE;EACE,+B2DnagB;E3DoahB,0B+C/ZkB;E/CgalB,mBgCzZK;EhC0ZL,gB0F7P0B;AxHyvuB9B;A8B1/tBE;EACE,U0FjQuB;AxH6vuB3B;A8Br/tBE;;EAEE,qC2DlbgB;E3DmbhB,0B+C9akB;A7Eq6uBtB;A8B/+tBE;EACE,eAAA;EACA,6BAAA;EACA,yB+CxbkB;E/CyblB,oBAAA;A9Bi/tBJ;A8Bp+tBE;;EAEE,aAAA;EACA,6BAAA;A9Bs+tBJ;A8Bn+tBE;;EAEE,aAAA;EACA,4BAAA;A9Bq+tBJ;A8Bl+tBE;;EAEE,gBAAA;A9Bo+tBJ;A8Bh+tBE;;EAEE,aAAA;EACA,4BAAA;EACA,6BAAA;A9Bk+tBJ;A8B99tBE;;EAEE,WAAA;EACA,OAAA;A9Bg+tBJ;A8B59tBE;;EAEE,aAAA;A9B89tBJ;A8Bt9tBI;EACE,cAAA;EACA,sBAAA;EACA,mB0FvTqB;E1FwTrB,8CgFtfU;A9G88uBhB;A8Bp9tBI;EACE,cAAA;EACA,gB0F7T0B;E1F8T1B,gBAAA;EACA,kBAAA;A9Bs9tBN;A8Bp9tBI;EACE,kDAAA;A9Bs9tBN;A8Bp9tBI;EACE,kDAAA;A9Bs9tBN;A8Bl9tBI;EACE,YAAA;EACA,kBAAA;A9Bo9tBN;A8Bh9tBI;;EAEE,amEthBO;EnEuhBP,Y0FvdqB;E1FwdrB,mB0FvdsB;AxHy6uB5B;A8Bh9tBI;EACE,W0FvasB;E1FwatB,mB0FvauB;AxHy3uB7B;A8B78tBI;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,W0FxgBc;E1FygBd,iCuDjhBkB;ArFg+uBxB;A8B58tBI;EACE,wBAAA;A9B88tBN;A8Bz8tBI;EACE,+B0F9gBY;AxHy9uBlB;A8Bz8tBI;EACE,gBAAA;EACA,6BAAA;EACA,yBiD9hBU;EjD+hBV,yB0FlhBgB;AxH69uBtB;A8Bz8tBI;;EAEE,0B+C7jBY;A7EwgvBlB;A8Bz8tBI;EACE,aAAA;A9B28tBN;A8Bv8tBI;EACE,+B2DnkBc;E3DokBd,gBAAA;EACA,gB0F9X4B;AxHu0uBlC;A8Bv8tBI;EACE,kDAAA;A9By8tBN;A8Bv8tBI;EACE,kDAAA;A9By8tBN;A8Bv8tBI;EACE,8B8C1kBC;A5EmhvBP;A8Bv8tBI;EACE,iBAAA;A9By8tBN;A8Bv8tBI;EACE,6B0F3ZuB;E1F4ZvB,iBgC1kBC;EhC2kBD,0B+CjlBgB;A7E0hvBtB;A8B/7tBI;EACE,gBAAA;EACA,2BAAA;EACA,YAAA;EACA,4B0FrToB;E1FsTpB,gCAAA;A9Bi8tBN;A8B/7tBI;EACE,kCAAA;A9Bi8tBN;A8B/7tBI;EACE,uBAAA;EACA,mBAAA;EAEA,kCAAA;EACA,mCAAA;EACA,iCAAA;EACA,sCAAA;EACA,0BmCjnBO;AjEijvBb;A8B97tBI;EACE,aAAA;A9Bg8tBN;A8B57tBI;EACE,6BAAA;EACA,yB+CxnBe;A7EsjvBrB;A8B17tBI;EACE,wB0FlU2B;E1FmU3B,0B+C5nBgB;E/C6nBhB,qB0FlVsB;E1FmVtB,qBuD1mBe;EvD2mBf,iBgCznBC;EhC0nBD,mBAAA;EACA,gB0FtU2B;E1FuU3B,6DAAA;A9B47tBN;A8Bv7tBM;;EAEE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;A9By7tBR;A8Bv7tBM;EACE,kBAAA;EACA,uB0F1VmB;E1F2VnB,UAAA;A9By7tBR;A8Br7tBI;EACE,4B0F7WoB;E1F8WpB,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,6BAAA;A9Bu7tBN;A8Br7tBI;EACE,gBAAA;EACA,kCAAA;EACA,mCAAA;EACA,oCAAA;EACA,gBAAA;A9Bu7tBN;A8Br7tBI;EACE,wB0F5W2B;E1F6W3B,0B+CtqBgB;E/CuqBhB,qBuDnpBe;EvDopBf,kBAAA;EACA,6DAAA;A9Bu7tBN;A8Bl7tBM;EACE,4B0F3X2B;E1F4X3B,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,+BAAA;A9Bo7tBR;A8Bl7tBM;EACE,gBAAA;EACA,kCAAA;EACA,oCAAA;EACA,iCAAA;EACA,kBAAA;A9Bo7tBR;A8Bl7tBM;EACE,wB0FpYyB;E1FqYzB,0B+C9rBc;E/C+rBd,qBuD3qBa;EvD4qBb,kBAAA;EACA,6DAAA;A9Bo7tBR;A8Bh7tBM;EACE,4B0FlZ2B;E1FmZ3B,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;A9Bk7tBR;A8Bh7tBM;EACE,gBAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;EACA,iBAAA;A9Bk7tBR;A8Bh7tBM;EACE,wB0F5ZyB;E1F6ZzB,0B+CttBc;E/CutBd,qBuDnsBa;EvDosBb,kBAAA;EACA,6DAAA;A9Bk7tBR;A8B76tBI;EACE,gBAAA;EACA,kCAAA;EACA,mCAAA;EACA,iCAAA;EACA,mBAAA;A9B+6tBN;A8Br6tBI;EACE,SAAA;EACA,oBAAA;EACA,sBAAA;A9Bu6tBN;A8Br6tBI;EACE,kDAAA;A9Bu6tBN;A8Br6tBI;EACE,kDAAA;A9Bu6tBN;A8Br6tBI;EACE,aAAA;A9Bu6tBN;A8Bp6tBI;EACE,c0F5bsB;E1F6btB,kBAAA;A9Bs6tBN;A8Bp6tBI;EACE,mBAAA;A9Bs6tBN;A8Bl6tBI;EACE,gBAAA;EACA,2BiDnvBW;EjDovBX,qC2D7wBc;E3D8wBd,0B+CzwBgB;E/C0wBhB,gBAAA;A9Bo6tBN;A8B15tBI;EACE,gB0F/kBsB;E1FglBtB,4BAAA;EACA,6BAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;A9B45tBN;A8Bx5tBI;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sC0FrlBwB;E1FslBxB,wB0FzlBuB;E1F0lBvB,gB0F3lB2B;E1F4lB3B,2B0FtlB2B;E1FulB3B,8B8CvyBC;A5EisvBP;A8Bt5tBI;EACE,wBAAA;A9Bw5tBN;A8Bp5tBI;EACE,gBAAA;EACA,kB0FnlByB;E1FolBzB,4B0FrlB6B;AxH2+uBnC;A8Bl5tBI;EACE,SAAA;A9Bo5tBN;A8Bh5tBI;;;EAGE,+B2Dn0Bc;E3Do0Bd,0B+C/zBgB;A7EitvBtB;A8B94tBI;EACE,gBAAA;EACA,+B2D10Bc;E3D20Bd,0B+Ct0BgB;E/Cu0BhB,8B8Cx0BC;A5EwtvBP;A8B54tBI;EACE,gBAAA;EACA,+B2Dl1Bc;E3Dm1Bd,0B+C90BgB;A7E4tvBtB;A8Bz4tBM;;EAEE,+B+Ch1BoB;A7E2tvB5B;A8Bz4tBM;;;EAGE,qC2D11BY;E3D21BZ,yB+Cl1BuB;A7E6tvB/B;A8Bz4tBM;EACE,qC2D71BmB;E3D81BnB,yB+Ct1BuB;A7EiuvB/B;A8Bt4tBI;EACE,cAAA;EACA,eAAA;A9Bw4tBN;A8Bt4tBI;EACE,eAAA;A9Bw4tBN;A8Bt4tBI;EACE,gBAAA;A9Bw4tBN;A8B93tBM;EACE,yB0FnpByB;AxHmhvBjC;A8B93tBM;EACE,S0FrpB8B;E1FspB9B,6B0FppB+B;AxHohvBvC;A8B73tBM;EACE,YAAA;EACA,0B0F/pB8B;E1FgqB9B,yCAAA;A9B+3tBR;A8B73tBM;EACE,gBAAA;A9B+3tBR;A8B33tBM;EACE,6BAAA;A9B63tBR;A8Bz3tBM;EACE,6BAAA;A9B23tBR;A8Bl3tBM;EACE,cAAA;EACA,eAAA;EACA,+CAAA;A9Bo3tBR;A8Bj3tBM;EACE,gCAAA;EACA,0BAAA;EACA,gBAAA;EACA,oBAAA;EAEA,gBAAA;EACA,sCAAA;EACA,wB0F3rB+B;E1F4rB/B,2B0FvtByB;AxHykvBjC;A8Bh3tBM;EACE,sBAAA;A9Bk3tBR;A8B/2tBM;EACE,kBAAA;EACA,qBAAA;A9Bi3tBR;A8B/2tBM;EACE,kBAAA;EACA,qBAAA;A9Bi3tBR;A8B72tBM;EACE,qCAAA;A9B+2tBR;A8B72tBM;EACE,2BAAA;A9B+2tBR;A8B72tBM;EACE,aAAA;A9B+2tBR;A8B32tBM;;;EAGE,6BAAA;EACA,0BmCz8BK;AjEszvBb;A8Bz2tBM;;;EAGE,6BAAA;EACA,oCuDj9BO;ArF4zvBf;A8Bv2tBM;EACE,6BAAA;EACA,gBAAA;EACA,0B0FnuBsC;E1FouBtC,iBgC/8BD;EhCg9BC,0B+Ct9Bc;A7E+zvBtB;A8Br2tBM;EACE,0B0F1uBsC;E1F2uBtC,0B+C59Bc;A7Em0vBtB;A8Bn2tBM;EACE,yB0F5uB+C;AxHilvBvD;A8Bh2tBQ;EACE,sBAAA;EACA,uB0F9vB6B;E1F+vB7B,yBAAA;EACA,0CuD9+BK;ArFg1vBf;A8Bh2tBQ;EACE,mBAAA;EACA,yBAAA;EACA,+BAAA;EACA,2BAAA;EACA,kB0FtvBqC;E1FuvBrC,uB0FxwB6B;AxH0mvBvC;A8B/1tBQ;EACE,0B0FrwBoC;AxHsmvB9C;A8B11tBQ;EACE,sCuDj/BW;ArF60vBrB;A8Bz1tBQ;EACE,+B+C//BY;A7E01vBtB;A8Bz1tBQ;EACE,yBAAA;A9B21tBV;A8Bv1tBQ;;EAEE,yB+ClgCqB;A7E21vB/B;A8Br1tBQ;EACE,qBmDnhCF;EnDohCE,yB+CxgCqB;E/CygCrB,6BAAA;A9Bu1tBV;A8B30tBI;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EAEA,a0FttBa;AxHkivBnB;A8B10tBI;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,W0FztBkB;E1F0tBlB,6B0FztBmB;E1F0tBnB,mBgCriCG;EhCsiCH,yB+CnjCa;E/CojCb,6B0F3tBsB;AxHuivB5B;A8Bx0tBI;;EAEE,wBAAA;A9B00tBN;A8Bt0tBI;EACE,6BAAA;EACA,UAAA;EACA,0B+ClkCY;E/CmkCZ,yBiDxiCW;EjDyiCX,yB0F9tB4B;E1F+tB5B,iBgCxjCC;A9Dg4vBP;A8Bp0tBI;EACE,SAAA;A9Bs0tBN;A8Bl0tBI;EACE,SAAA;A9Bo0tBN;A8B/ztBM;EACE,a0F7uBoB;AxH8ivB5B;A8B/ztBM;EACE,aAAA;A9Bi0tBR;A8B/ztBM;EACE,gBAAA;A9Bi0tBR;A8B/ztBM;EACE,wB0FpvByB;E1FqvBzB,eAAA;EACA,gBAAA;A9Bi0tBR;A8B/ztBM;EACE,W0FvvBwB;E1FwvBxB,4B0FhjCW;AxHi3vBnB;A8B/ztBM;EACE,uC0F9vB2B;AxH+jvBnC;A8B7ztBM;EACE,S0FhxBoB;AxH+kvB5B;A8B7ztBM;EACE,S0FlxByB;E1FmxBzB,gB0FlxB0B;AxHilvBlC;A8B1ztBI;EACE,UAAA;EACA,6BAAA;A9B4ztBN;A8BxztBI;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,mBgCjnCG;EhCknCH,0B+CznCgB;A7Em7vBtB;A8BtztBI;EACE,6BAAA;A9BwztBN;A8BpztBI;EACE,gBAAA;A9BsztBN;A8BnztBM;EACE,gBAAA;A9BqztBR;A8B/ytBM;;;;EAIE,6BAAA;A9BiztBR;A8B/ytBM;EACE,cmDvpCA;AjFw8vBR;A8B5ytBI;EACE,cAAA;EACA,eAAA;A9B8ytBN;A8BrytBE;EACE,qBAAA;EACA,WAAA;A9BuytBJ;A8BnytBE;EACE,YAAA;EACA,kB0F14BmB;E1F24BnB,cqDxqCI;AnF68vBR;A8BjytBE;EACE,SAAA;EACA,UAAA;A9BmytBJ;A8B/xtBE;EACE,UAAA;A9BiytBJ;A8B7xtBE;EACE,WAAA;EACA,cAAA;A9B+xtBJ;A8B3xtBE;EACE,cAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;A9B6xtBJ;A8BrxtBE;EACE,kBAAA;A9BuxtBJ;A8BnxtBE;EACE,c0F54B0B;E1F64B1B,sBAAA;A9BqxtBJ;A8BjxtBE;EACE,WAAA;EACA,cAAA;EACA,oCAAA;EACA,gCAAA;A9BmxtBJ;A8B/wtBE;EACE,YAAA;A9BixtBJ;A8BrwtBE;EACE;IACE,sBAAA;E9BuwtBJ;E8BrwtBE;IACE,sBAAA;E9BuwtBJ;E8BrwtBE;IACE,kBAAA;IACA,WAAA;IACA,SAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,W0FnuCc;I1FouCd,iCuD5uCkB;ErFm/vBtB;E8BpwtBE;;IAEE,0BAAA;E9BswtBJ;E8BpwtBE;;IAEE,yBAAA;E9BswtBJ;E8BpwtBE;;IAEE,yBAAA;IACA,0BAAA;E9BswtBJ;E8BnwtBE;;;IAGE,sBAAA;E9BqwtBJ;AACF;A8BzvtBM;;;EAME,cATA;A9BiwtBR;A8B9vtBM;;;EAME,cATA;A9BswtBR;A8BnwtBM;;;EAME,cATA;A9B2wtBR;A8BxwtBM;;;EAME,cATA;A9BgxtBR;A8B7wtBM;;;EAME,cATA;A9BqxtBR;A8BlxtBM;;;EAME,cATA;A9B0xtBR;A8BvxtBM;;;EAME,cATA;A9B+xtBR;A8B5xtBM;;;EAME,cATA;A9BoytBR;A8BjytBM;;;EAME,cATA;A9ByytBR;A8BtytBM;;;EAME,cATA;A9B8ytBR;A8B3ytBM;;;EAME,cATA;A9BmztBR;A8BhztBM;;;EAME,cATA;A9BwztBR;A8BrztBM;;;EAME,cATA;A9B6ztBR;A8B1ztBM;;;EAME,cATA;A9Bk0tBR;A8B/ytBI;EACE,2B0Fj8BiB;E1Fk8BjB,mBqD3yCE;ErD4yCF,gB0Fp8BqB;AxHqvvB3B;A8B7ytBI;;EAEE,uB0Ft8B0B;E1Fu8B1B,+B+CrzCgB;A7EomwBtB;A8B7ytBI;EACE,uB0Ft8ByB;AxHqvvB/B;A8B3ytBI;EACE,qC0F/6B6B;AxH4tvBnC;A8B3ytBI;EACE,qC0Fl7B6B;AxH+tvBnC;A8BzytBI;;EAEE,+B+Cn0C2B;A7E8mwBjC;A8BvytBI;EACE,SAAA;EACA,uB0Fh+B4B;E1Fi+B5B,gBAAA;A9ByytBN;A8BrytBI;EACE,+B+C30CyB;A7EknwB/B;A8BnytBI;;;;EAIE,qC2D71Cc;E3D81Cd,yB+Cr1CyB;A7E0nwB/B;A8BnytBI;;EAEE,uB0F7+ByB;E1F8+BzB,yB+C11CyB;A7E+nwB/B;A8BjytBI;;EAEE,qC2Dz2Cc;E3D02Cd,yB+Cj2CyB;A7EoowB/B;A8B/xtBI;EACE,mB0F3+B6B;E1F4+B7B,oCAAA;A9BiytBN;A8B/xtBI;EACE,uB0Ft+BgC;E1Fu+BhC,cmDv3CE;AjFwpwBR;A8B/xtBI;EACE,mB0Fn/B6B;E1Fo/B7B,oBAAA;EACA,2BAAA;EACA,uBAAA;A9BiytBN;A8B7xtBI;EACE,mB0F3/B6B;E1F4/B7B,yBAAA;A9B+xtBN;A8B7xtBI;EACE,mB0F//B6B;AxH8xvBnC;A8B5xtBI;EACE,yBAAA;A9B8xtBN;A8BrxtBE;EACE,WAAA;EACA,oBAAA;A9BuxtBJ;A8BrxtBE;EACE,aAAA;A9BuxtBJ;A8BpxtBE;EACE,YAAA;EACA,oBAAA;A9BsxtBJ;A8BzwtBQ;;EAEE,yBANA;A9BixtBV;A8BzwtBQ;EACE,uCuD35Cc;ArFsqwBxB;A8BzwtBQ;EACE,oC2Dn7CiB;AzF8rwB3B;A8BzwtBQ;EACE,oEAdA;A9ByxtBV;A8BtxtBQ;;EAEE,yBANA;A9B8xtBV;A8BtxtBQ;EACE,uCuD35Cc;ArFmrwBxB;A8BtxtBQ;EACE,oC2Dn7CiB;AzF2swB3B;A8BtxtBQ;EACE,mEAdA;A9BsytBV;A8BnytBQ;;EAEE,yBANA;A9B2ytBV;A8BnytBQ;EACE,uCuD35Cc;ArFgswBxB;A8BnytBQ;EACE,oC2Dn7CiB;AzFwtwB3B;A8BnytBQ;EACE,wDAdA;A9BmztBV;A8BhztBQ;;EAEE,yBANA;A9BwztBV;A8BhztBQ;EACE,uCuD35Cc;ArF6swBxB;A8BhztBQ;EACE,oC2Dn7CiB;AzFquwB3B;A8BhztBQ;EACE,+CAdA;A9Bg0tBV;A8B7ztBQ;;EAEE,yBANA;A9Bq0tBV;A8B7ztBQ;EACE,uCuD35Cc;ArF0twBxB;A8B7ztBQ;EACE,oC2Dn7CiB;AzFkvwB3B;A8B7ztBQ;EACE,oEAdA;A9B60tBV;A8B10tBQ;;EAEE,yBANA;A9Bk1tBV;A8B10tBQ;EACE,uCuD35Cc;ArFuuwBxB;A8B10tBQ;EACE,oC2Dn7CiB;AzF+vwB3B;A8B10tBQ;EACE,mEAdA;A9B01tBV;A8Bv1tBQ;;EAEE,yBANA;A9B+1tBV;A8Bv1tBQ;EACE,uCuD35Cc;ArFovwBxB;A8Bv1tBQ;EACE,oC2Dn7CiB;AzF4wwB3B;A8Bv1tBQ;EACE,+CAdA;A9Bu2tBV;A8Bp2tBQ;;EAEE,yBANA;A9B42tBV;A8Bp2tBQ;EACE,uCuD35Cc;ArFiwwBxB;A8Bp2tBQ;EACE,oC2Dn7CiB;AzFyxwB3B;A8Bp2tBQ;EACE,oEAdA;A9Bo3tBV;A8Bj3tBQ;;EAEE,yBANA;A9By3tBV;A8Bj3tBQ;EACE,uCuD35Cc;ArF8wwBxB;A8Bj3tBQ;EACE,oC2Dn7CiB;AzFsywB3B;A8Bj3tBQ;EACE,mEAdA;A9Bi4tBV;A8B93tBQ;;EAEE,yBANA;A9Bs4tBV;A8B93tBQ;EACE,uCuD35Cc;ArF2xwBxB;A8B93tBQ;EACE,oC2Dn7CiB;AzFmzwB3B;A8B93tBQ;EACE,oEAdA;A9B84tBV;A8B34tBQ;;EAEE,yBANA;A9Bm5tBV;A8B34tBQ;EACE,uCuD35Cc;ArFwywBxB;A8B34tBQ;EACE,oC2Dn7CiB;AzFg0wB3B;A8B34tBQ;EACE,oEAdA;A9B25tBV;A8Bx5tBQ;;EAEE,yBANA;A9Bg6tBV;A8Bx5tBQ;EACE,uCuD35Cc;ArFqzwBxB;A8Bx5tBQ;EACE,oC2Dn7CiB;AzF60wB3B;A8Bx5tBQ;EACE,mEAdA;A9Bw6tBV;A8Br6tBQ;;EAEE,yBANA;A9B66tBV;A8Br6tBQ;EACE,uCuD35Cc;ArFk0wBxB;A8Br6tBQ;EACE,oC2Dn7CiB;AzF01wB3B;A8Br6tBQ;EACE,8CAdA;A9Bq7tBV;A8Bl7tBQ;;EAEE,yBANA;A9B07tBV;A8Bl7tBQ;EACE,uCuD35Cc;ArF+0wBxB;A8Bl7tBQ;EACE,oC2Dn7CiB;AzFu2wB3B;A8Bl7tBQ;EACE,0DAdA;A9Bk8tBV;A8B16tBE;;;EAGE,UAAA;A9B46tBJ;A8B16tBE;;;EAGE,2BiDh7Ca;EjDi7Cb,8BiDj7Ca;A/E61wBjB;A8B16tBE;;;EAGE,4BiDp7Ca;EjDq7Cb,6BiDr7Ca;A/Ei2wBjB;A8Br6tBE;;;EAGE,2BAAA;A9Bu6tBJ;A8Bh6tBE;EACE,oBAAA;EACA,SAAA;EACA,sBAAA;A9Bk6tBJ;A8Bh6tBE;EACA,iDAAA;EACE,sCAAA;EACA,qBAAA;A9Bk6tBJ;A8Bh6tBE;EACE,kDAAA;A9Bk6tBJ;A8Bh6tBE;EACE,aAAA;A9Bk6tBJ;A8Bh6tBE;EACE,sBAAA;A9Bk6tBJ;A8Bh6tBE;EACE,cAAA;A9Bk6tBJ;A8B35tBE;;EAEE,sBAAA;A9B65tBJ;A8Br5tBE;;EAEE,WAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;A9Bu5tBJ;A8Br5tBE;EACE,yBAAA;A9Bu5tBJ;A8Bp5tBE;EACE,aAAA;A9Bs5tBJ;A8Bn5tBE;EACE,UAAA;A9Bq5tBJ;A8Bn5tBE;EACE,cAAA;A9Bq5tBJ;A8Bn5tBE;EACE,UAAA;A9Bq5tBJ;A8Bn5tBE;EACE,UAAA;A9Bq5tBJ;A8Bn5tBE;EACE,cAAA;A9Bq5tBJ;A8Bn5tBE;EACE,cAAA;A9Bq5tBJ;A8Bn5tBE;EACE,YAAA;A9Bq5tBJ;A8Bn5tBE;EACE,aAAA;A9Bq5tBJ;A8Bn5tBE;EACE,UAAA;A9Bq5tBJ;A8Bn5tBE;EACE,YAAA;A9Bq5tBJ;A8Bn5tBE;EACE,aAAA;A9Bq5tBJ;A8B94tBE;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;A9Bg5tBJ;A8B94tBE;;;EAGE,2BAAA;A9Bg5tBJ;A8B74tBE;;EAEE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A9B+4tBJ;A8B74tBE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;A9B+4tBJ;A8B74tBE;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;A9B+4tBJ;A8B74tBE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;A9B+4tBJ;A8B74tBE;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;A9B+4tBJ;A8B34tBE;EACE,oB0F1tC+B;AxHumwBnC;A8Bp4tBI;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,0DAAA;EACA,gBAAA;EAEA,iBAAA;EACA,qB8ClkDQ;E9CmkDR,sB8CnkDQ;E9CqkDR,YAAA;EACA,gC0FrkDc;E1FskDd,+B0FtkDc;E1FwkDd,U0FtkDe;E1FukDf,gC0FxkDkB;AxH28wBxB;A8Bj4tBI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EAEA,yDAAA;EACA,oBAAA;EAEA,YAAA;EACA,6B0FtlDc;E1FulDd,+B0FvlDc;AxHw9wBpB;A8B/3tBI;;EAEE,aAAA;A9Bi4tBN;A8B73tBI;EACE,mBAAA;A9B+3tBN;A8B73tBI;EACE,kBAAA;A9B+3tBN;A8B33tBI;;EAEE,aAAA;A9B63tBN;A8Bz3tBI;EACE,yB0F1mDmB;AxHq+wBzB;A8Bz3tBI;EACE,yB0F7mDmB;AxHw+wBzB;A8Bz3tBI;EACE,yB0FhnDmB;AxH2+wBzB;A8Bx3tBI;EACE,yB0FpnDmB;AxH8+wBzB;A8Bx3tBI;EACE,yB0FvnDmB;AxHi/wBzB;A8Bx3tBI;EACE,yBmDtsDE;AjFgkxBR;A8Bj3tBU;EACE,yBAHE;A9Bs3tBd;A8Bp3tBU;EACE,yBAHE;A9By3tBd;A8Bv3tBU;EACE,yBAHE;A9B43tBd;A8B13tBU;EACE,yBAHE;A9B+3tBd;A8B73tBU;EACE,yBAHE;A9Bk4tBd;A8Bh4tBU;EACE,yBAHE;A9Bq4tBd;A8Bn4tBU;EACE,yBAHE;A9Bw4tBd;A8Bt4tBU;EACE,yBAHE;A9B24tBd;A8Bz4tBU;EACE,yBAHE;A9B84tBd;A8B54tBU;EACE,yBAHE;A9Bi5tBd;A8B/4tBU;EACE,yBAHE;A9Bo5tBd;A8Bl5tBU;EACE,yBAHE;A9Bu5tBd;A8Br5tBU;EACE,yBAHE;A9B05tBd;A8Bx5tBU;EACE,yBAHE;A9B65tBd;A8B35tBU;EACE,yBAHE;A9Bg6tBd;A8B94tBI;EACE,MAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,uB0F/zCgB;E1Fg0ChB,2B0Fh0CgB;E1Fi0ChB,gB0Fh0CqB;AxHgtwB3B;A8B94tBI;EACE,gBAAA;A9Bg5tBN;A8B54tBI;EACE,SAAA;EACA,gBAAA;EACA,M0F90CqB;E1F+0CrB,gBiDnuDG;EjDouDH,kDAAA;A9B84tBN;A8B54tBI;EACE,aAAA;A9B84tBN;A8B14tBI;EACE,SAAA;EACA,aAAA;EACA,M0Fz1CwB;E1F01CxB,mBiD/uDG;EjDgvDH,oD0Fr1CJ;E1Fs1CI,kDAAA;A9B44tBN;A8B14tBI;EACE,gBAAA;A9B44tBN;A8Bx4tBI;EACE,oCAAA;A9B04tBN;A8Bx4tBI;EACE,oCAAA;A9B04tBN;A8Bt4tBI;EACE,yB0Fx2CiB;AxHgvwBvB;A8Br4tBM;EACE,YAAA;A9Bu4tBR;A8Bp4tBI;EACE,cAAA;EACA,eAAA;EACA,WAAA;A9Bs4tBN;A8B73tBE;EACE,0B8C1xDI;A5EypxBR;A8B73tBE;EACE,W0F/2Cc;AxH8uwBlB;A8B73tBE;EACE,0B8ChyDI;A5E+pxBR;A8B73tBE;EACE,0B8CnyDI;A5EkqxBR;A8B33tBE;EACE,0B8CvyDI;A5EoqxBR;A8B33tBE;EACE,Y0F53Cc;AxHyvwBlB;A8B33tBE;EACE,0B8C7yDI;A5E0qxBR;A8B33tBE;EACE,0B8ChzDI;A5E6qxBR;A8Bz3tBE;EACE,0B8CpzDI;A5E+qxBR;A8Bz3tBE;EACE,Y0Fz4Ce;AxHowwBnB;A8Bz3tBE;EACE,0B8C1zDI;A5EqrxBR;A8Bz3tBE;EACE,0B8C7zDI;A5EwrxBR;A8Bv3tBE;EACE,eiD/zDK;A/EwrxBT;A8Bv3tBE;EACE,Y0Ft5CgB;AxH+wwBpB;A8Br3tBE;EACE,0B8Cx0DI;A5E+rxBR;A8Br3tBE;EACE,Y0F75Ce;AxHoxwBnB;A8Br3tBE;EACE,0B8C90DI;A5EqsxBR;A8Br3tBE;EACE,0B8Cj1DI;A5EwsxBR;A8Bn3tBE;EACE,0B8Cp1DI;A5EysxBR;A8Bn3tBE;EACE,Y0Fz6Cc;AxH8xwBlB;A8Bn3tBE;EACE,0B8C11DI;A5E+sxBR;A8Bn3tBE;EACE,0B8C71DI;A5EktxBR;A8Bj3tBE;EACE,0B8Cn2DI;A5EstxBR;A8Bj3tBE;EACE,Y0Fx7Ca;AxH2ywBjB;A8Bj3tBE;EACE,0B8Cz2DI;A5E4txBR;A8Bj3tBE;EACE,0B8C52DI;A5E+txBR;A8B/2tBE;EACE,0B8C/2DI;A5EguxBR;A8B/2tBE;EACE,Y0Fp8CiB;AxHqzwBrB;A8B/2tBE;EACE,0B8Cr3DI;A5EsuxBR;A8B/2tBE;EACE,0B8Cx3DI;A5EyuxBR;A8B12tBI;EACE,mBqDx4DE;ErDy4DF,gB0F98C8B;AxH0zwBpC;A8Bz2tBI;EACE,0CAAA;A9B22tBN;A8Bx2tBI;EACE,kCAAA;EACA,0CAAA;A9B02tBN;A8Bv2tBI;EACE,gDAAA;EACA,0CAAA;A9By2tBN;A8Bt2tBI;EACE,gDAAA;EACA,0CAAA;A9Bw2tBN;A8Bp2tBI;EACE,gB0Ft+C8B;AxH40wBpC;A+B5wxBE;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kB0FFc;E1FGd,qBiCbU;EjCcV,0BkCXS;ElCYT,0F0FSF;E1FRE,8B6CVG;E7CWH,4E0FEF;AzH4wxBF;A+B3wxBE;EACE,aAAA;A/B6wxBJ;A+B3wxBE;EACE,gBAAA;A/B6wxBJ;A+BpwxBE;EACE,c0FDqB;E1FErB,6E+BjCU;E/BkCV,iB+BvBG;E/BwBH,6B0FFoB;AzHwwxBxB;A+BlwxBE;EACE,yBgDba;A/EixxBjB;A+BhwxBE;EACE,a0FRmB;E1FSnB,gBAAA;A/BkwxBJ;A+BhwxBE;EACE,aAAA;A/BkwxBJ;A+BhwxBE;EACE,gBAAA;A/BkwxBJ;A+BhwxBE;EACE,kB0FrBgC;AzHuxxBpC;A+B9vxBE;EACE,gBAAA;EACA,UAAA;EACA,a0FrBmB;E1FsBnB,2B0FrB0B;E1FsB1B,iBAAA;A/BgwxBJ;A+B9vxBE;EACE,aAAA;A/BgwxBJ;A+B9vxBE;EACE,gBAAA;A/BgwxBJ;A+B9vxBE;EACE,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,UAAA;A/BgwxBJ;A+B9vxBE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;A/BgwxBJ;A+B9vxBE;EACE,gBAAA;A/BgwxBJ;A+B3vxBE;EACE,mB0F5CoB;AzHyyxBxB;A+BzvxBE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,c0FjDyB;E1FkDzB,Y0FjD2B;E1FkD3B,Y0FjDoB;E1FkDpB,6B0FjDuB;AzH4yxB3B;A+BzvxBE;EACE,UAAA;A/B2vxBJ;A+BvvxBE;EACE,aAAA;A/ByvxBJ;A+BvvxBE;EACE,gBAAA;A/ByvxBJ;A+BlvxBE;EACE,cAAA;A/BovxBJ;A+BzuxBE;EACE,cAAA;A/B2uxBJ;A+BxuxBE;EACE,aAAA;A/B0uxBJ;A+BnuxBE;EACE,aAAA;A/BquxBJ;A+BztxBE;EACE,qBAAA;A/B2txBJ;A+BztxBE;EACE,oBAAA;EACA,WAAA;A/B2txBJ;A+BntxBE;EACE,mB0FzGwB;E1F0GxB,kDAAA;EACA,kD0F1G0B;E1F2G1B,iB0F7GwB;E1F8GxB,kB0F9GwB;AzHm0xB5B;A+BntxBE;EACE,gB0FhHwB;E1FiHxB,gBAAA;A/BqtxBJ;A+BntxBE;EACE,gB0FpHwB;E1FqHxB,kDAAA;EACA,sF0FnHF;AzHw0xBF;A+BntxBE;EACE,kB0FvLsB;AzH44xB1B;A+BntxBE;EACE,WAAA;A/BqtxBJ;A+B7sxBE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;A/B+sxBJ;A+B7sxBE;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,sB0FlJ0B;E1FmJ1B,c0FtJgB;E1FuJhB,Y0FtJmB;AzHq2xBvB;A+B7sxBE;EACE,cAAA;EACA,cAAA;EACA,sB0FzJ0B;AzHw2xB9B;A+B3sxBE;EACE,e0F/J4B;AzH42xBhC;A+B3sxBE;EACE,UAAA;A/B6sxBJ;A+BtsxBE;EACE,0H0F5JF;AzHo2xBF;A+BvrxBM;EACE,yBAPG;EAQH,cAJE;A/B6rxBV;A+BtrxBM;;EAEE,6DAXG;A/BmsxBX;A+BrrxBM;EACI,2GAdE;A/BqsxBZ;A+BprxBM;EACE,cApBG;A/B0sxBX;A+BrsxBM;EACE,yBAPG;EAQH,cAJE;A/B2sxBV;A+BpsxBM;;EAEE,6DAXG;A/BitxBX;A+BnsxBM;EACI,2GAdE;A/BmtxBZ;A+BlsxBM;EACE,cApBG;A/BwtxBX;A+BrrxBM;EAEI,yBATC;EAUD,+BANA;A/B4rxBV;A+B9qxBM;;EAGI,6DAnBC;A/BksxBX;A+B3qxBM;EAEI,2GAxBE;A/BosxBZ;A+BxqxBM;EAEI,wCAhCC;A/BysxBX;A+BnsxBM;EAEI,yBATC;EAUD,+BANA;A/B0sxBV;A+B5rxBM;;EAGI,6DAnBC;A/BgtxBX;A+BzrxBM;EAEI,2GAxBE;A/BktxBZ;A+BtrxBM;EAEI,wCAhCC;A/ButxBX;A+BjtxBM;EAEI,yBATC;EAUD,cANA;A/BwtxBV;A+B1sxBM;;EAGI,6DAnBC;A/B8txBX;A+BvsxBM;EAEI,2GAxBE;A/BguxBZ;A+BpsxBM;EAEI,wDAhCC;A/BquxBX;A+B/txBM;EAEI,yBATC;EAUD,cANA;A/BsuxBV;A+BxtxBM;;EAGI,6DAnBC;A/B4uxBX;A+BrtxBM;EAEI,2GAxBE;A/B8uxBZ;A+BltxBM;EAEI,wCAhCC;A/BmvxBX;A+B7uxBM;EAEI,yBATC;EAUD,cANA;A/BovxBV;A+BtuxBM;;EAGI,6DAnBC;A/B0vxBX;A+BnuxBM;EAEI,2GAxBE;A/B4vxBZ;A+BhuxBM;EAEI,qDAhCC;A/BiwxBX;A+B3vxBM;EAEI,yBATC;EAUD,cANA;A/BkwxBV;A+BpvxBM;;EAGI,6DAnBC;A/BwwxBX;A+BjvxBM;EAEI,2GAxBE;A/B0wxBZ;A+B9uxBM;EAEI,yDAhCC;A/B+wxBX;A+BzwxBM;EAEI,yBATC;EAUD,cANA;A/BgxxBV;A+BlwxBM;;EAGI,6DAnBC;A/BsxxBX;A+B/vxBM;EAEI,2GAxBE;A/BwxxBZ;A+B5vxBM;EAEI,wDAhCC;A/B6xxBX;A+BvxxBM;EAEI,yBATC;EAUD,cANA;A/B8xxBV;A+BhxxBM;;EAGI,6DAnBC;A/BoyxBX;A+B7wxBM;EAEI,2GAxBE;A/BsyxBZ;A+B1wxBM;EAEI,yDAhCC;A/B2yxBX;A+BryxBM;EAEI,yBATC;EAUD,cANA;A/B4yxBV;A+B9xxBM;;EAGI,6DAnBC;A/BkzxBX;A+B3xxBM;EAEI,2GAxBE;A/BozxBZ;A+BxxxBM;EAEI,yDAhCC;A/ByzxBX;A+BnzxBM;EAEI,yBATC;EAUD,cANA;A/B0zxBV;A+B5yxBM;;EAGI,6DAnBC;A/Bg0xBX;A+BzyxBM;EAEI,2GAxBE;A/Bk0xBZ;A+BtyxBM;EAEI,wDAhCC;A/Bu0xBX;A+Bj0xBM;EAEI,yBATC;EAUD,cANA;A/Bw0xBV;A+B1zxBM;;EAGI,6DAnBC;A/B80xBX;A+BvzxBM;EAEI,2GAxBE;A/Bg1xBZ;A+BpzxBM;EAEI,yDAhCC;A/Bq1xBX;A+B/0xBM;EAEI,yBATC;EAUD,cANA;A/Bs1xBV;A+Bx0xBM;;EAGI,6DAnBC;A/B41xBX;A+Br0xBM;EAEI,2GAxBE;A/B81xBZ;A+Bl0xBM;EAEI,yDAhCC;A/Bm2xBX;A+B71xBM;EAEI,yBATC;EAUD,cANA;A/Bo2xBV;A+Bt1xBM;;EAGI,6DAnBC;A/B02xBX;A+Bn1xBM;EAEI,2GAxBE;A/B42xBZ;A+Bh1xBM;EAEI,wDAhCC;A/Bi3xBX;A+B32xBM;EAEI,yBATC;EAUD,cANA;A/Bk3xBV;A+Bp2xBM;;EAGI,6DAnBC;A/Bw3xBX;A+Bj2xBM;EAEI,2GAxBE;A/B03xBZ;A+B91xBM;EAEI,kCAhCC;A/B+3xBX;A+Bz3xBM;EAMI,yBoDnRF;EpDoRE,+B8CtRY;A7E4oyBtB;A+Br2xBM;EAKI,+B8C5SY;A7E+oyBtB;A+B51xBE;EACE,yBoDlTI;EpDmTJ,+B8CrTkB;A7EmpyBtB;A+Bv1xBE;EACE,yBgD9SY;A/EuoyBhB;A+Bv1xBE;EACE,yBgDhTY;A/EyoyBhB;A+Bv1xBE;EACE,yBgDlTa;A/E2oyBjB;A+Bv1xBE;EACE,cgDpTc;A/E6oyBlB;A+Bv1xBE;EACE,yBgDtTa;A/E+oyBjB;A+Bv1xBE;EACE,yBgDxTW;A/EipyBf;A+Bv1xBE;EACE,yBgD1TY;A/EmpyBhB;A+Bv1xBE;EACE,yBgD5Te;A/EqpyBnB;AgC7qyBE;EACE,WAAA;EACA,mBiDNI;EjDOJ,a0FJW;E1FKX,wC0FMW;E1FLX,gB0FMe;E1FLf,8B4CRG;E5CSH,gB0FKe;E1FJf,sB0FKmB;E1FJnB,0BiCdS;EjCeT,yB0FVoB;E1FWpB,iB0FVmB;A1HyryBvB;AgC5qyBE;EACE,aAAA;AhC8qyBJ;AgC5qyBE;EACE,gBAAA;AhC8qyBJ;AgC5qyBE;;EAEE,mBAAA;EACA,uBAAA;AhC8qyBJ;AgCtqyBE;;EAEE,iD0F7BF;A1HqsyBF;AgCpqyBE;EACE,gB0FCsB;A1HqqyB1B;AgCpqyBE;EACE,YAAA;EACA,mBiDjDQ;EjDkDR,mB0FZiB;E1FajB,0BiCjDS;EjCkDT,sCAAA;EACA,uB0Fd0B;E1Fe1B,gB0FXsB;E1FYtB,iB8B3CG;E9B4CH,oB0FX0B;E1FY1B,8C0FtBkB;E1FuBlB,iB0FtBmB;A1H4ryBvB;AgCnqyBE;EACE,iBAAA;AhCqqyBJ;AgClqyBE;EACE,oCAAA;AhCoqyBJ;AgClqyBE;EACE,oCAAA;AhCoqyBJ;AgClqyBE;EACE,kDAAA;AhCoqyBJ;AgChqyBE;EACE,gB0F5BsB;A1H8ryB1B;AgChqyBE;EACE,YAAA;EACA,4C0F/BkB;E1FgClB,mBiDlFQ;EjDmFR,mB0F9BiB;E1F+BjB,0BiClFS;EjCmFT,sCAAA;EACA,sB0FhC0B;E1FiC1B,kB8B1EK;E9B2EL,mB8B3EK;E9B4EL,oB0F7B0B;A1H+ryB9B;AgChqyBE;EACE,iBAAA;AhCkqyBJ;AgChqyBE;EACE,oCAAA;AhCkqyBJ;AgChqyBE;EACE,oCAAA;AhCkqyBJ;AgChqyBE;EACE,kDAAA;AhCkqyBJ;AgC9pyBE;;EAEE,2C0FlFe;A1HkvyBnB;AgC9pyBE;;EAEE,gBAAA;AhCgqyBJ;AgC5pyBE;EACE,2C0F3Fe;A1HyvyBnB;AgC1pyBE;;EAEE,sCAAA;EACA,mB0F5FoB;A1HwvyBxB;AgCxpyBE;EACE,wB0F/BwB;A1HyryB5B;AgCxpyBE;EACE,SAAA;AhC0pyBJ;AgCtpyBE;EACE,UAAA;AhCwpyBJ;AgCtpyBE;EACE,aAAA;AhCwpyBJ;AgCtpyBE;EACE,cAAA;AhCwpyBJ;AgCnpyBE;EhCpIF;IgC6LI,qBAAA;EhC8lyBF;EgCtpyBE;IACE,WAAA;IACA,UAAA;EhCwpyBJ;EgCtpyBE;;;;;;;;;;;;;IAaE,yBAAA;IACA,sBAAA;EhCwpyBJ;EgCrpyBE;IACE,c0F3G4B;E1HkwyBhC;EgCrpyBE;IACE,c0F7G4B;E1HowyBhC;EgCrpyBE;;;;IAIE,gB0FlHkC;I1FmHlC,mB0FnHkC;I1FoHlC,0D0FnH4B;E1H0wyBhC;EgCppyBE;;;;;;IAME,gBAAA;IACA,YAAA;IACA,sBAAA;IACA,2B0F5H6B;E1HkxyBjC;EgCppyBE;;;;;;IAME,iB8B7LC;E9Dm1yBL;EgClpyBE;IACE,2BAAA;EhCopyBJ;AACF;AgC3oyBE;;EAEE,eAAA;AhC6oyBJ;AgChoyBI;EACE,yBAAA;AhCkoyBN;AgChoyBI;EACE,iB0FvMiB;E1FwMjB,kB0FxMiB;A1H00yBvB;AgC/nyBM;EACE,6C0F7EgB;E1F8EhB,8C0F9EgB;A1H+syBxB;AgC7nyBM;;;;EAIE,iB0FnCqB;E1FoCrB,kB0FpCqB;A1HmqyB7B;AgC3nyBM;;;;;;EAME,4C0FpOY;E1FqOZ,6C0FrOY;A1Hk2yBpB;AgCnnyBI;EACE,oBAAA;EACA,mBiD9QE;EjD+QF,mB8BrQG;E9BsQH,yB6ChRkB;E7CiRlB,yCAAA;EACA,wBAAA;AhCqnyBN;AgClnyBI;EACE,oBAAA;EACA,mBiDvRE;EjDwRF,mB8B9QG;E9B+QH,yB6CzRkB;E7C0RlB,wCAAA;EACA,wBAAA;AhConyBN;AgChnyBI;;;EAGE,+ByDtSqB;EzDuSrB,iB8B1RC;E9B2RD,0B6CjSgB;E7CkShB,kB0F/MmC;E1FgNnC,c0F/M+B;E1FgN/B,c0F/M+B;E1FgN/B,c+ChRY;E/CiRZ,gB0FhNuC;E1FiNvC,iB0FjNuC;A1Hm0yB7C;AgC7myBI;EACE,6CAAA;AhC+myBN;AgC7myBI;EACE,6CAAA;AhC+myBN;AgC7myBI;;EAEE,6CAAA;AhC+myBN;AgCnmyBE;;EAEE,+B0F/NwB;E1FgOxB,mBqEtUwB;ErEuUxB,csE3UkB;AtGg7yBtB;AgC9lyBE;;EAEE,+B0FpOwB;E1FqOxB,mBqE3UwB;ErE4UxB,csEnVkB;AtGm7yBtB;AgCzlyBE;;EAEE,+B0FzOqB;E1F0OrB,mBqEtVwB;ErEuVxB,csE9VkB;AtGy7yBtB;AgCplyBE;;EAEE,+B0F9OuB;E1F+OvB,mBqEvVuB;ErEwVvB,csErWiB;AtG27yBrB;AgC/kyBE;;EAEE,2C0FlPsB;E1FmPtB,mB0FpP4B;E1FqP5B,0BiCpXS;AjEq8yBb;AgCxkyBE;;;;EAIE,oBAAA;EACA,yB6C7XkB;A7Eu8yBtB;AgC/jyBE;EhChYF;IgCibI,qBAAA;EhCkhyBF;EgCjkyBE;;;;;;;;;;;;;;IAcE,yBAAA;IACA,sBAAA;EhCmkyBJ;EgChkyBE;IACE,UAAA;EhCkkyBJ;EgChkyBE;IACE,c0FxW4B;E1H06yBhC;EgChkyBE;IACE,c0F1W4B;E1H46yBhC;EgChkyBE;;;;IAIE,gB0F/WkC;I1FgXlC,mB0FhXkC;I1FiXlC,0D0FhX4B;E1Hk7yBhC;EgChkyBE;;;;;;IAME,gBAAA;IACA,uBAAA;IACA,sBAAA;IACA,2B0FxX6B;E1H07yBjC;EgC9jyBE;IACE,2BAAA;EhCgkyBJ;AACF;AgCzjyBE;;EAEE,gBAAA;AhC2jyBJ;AgCzjyBE;;EAEE,kBAAA;AhC2jyBJ;AgCzjyBE;;EAEE,iBAAA;AhC2jyBJ;AgCpjyBE;;EAEE,mBAAA;AhCsjyBJ;AgCpjyBE;;EAEE,sBAAA;AhCsjyBJ;AgCpjyBE;;EAEE,sBAAA;AhCsjyBJ;AgC/iyBE;;EAEE,UAAA;EACA,mBAAA;AhCijyBJ;AgC1iyBE;EACE,mBAAA;AhC4iyBJ;AgCziyBE;;EAEE,gBAAA;EACA,uBAAA;AhC2iyBJ;AgCniyBE;;EAEE,+ByDtgBgB;EzDugBhB,0B6ClgBkB;A7EuizBtB;AgCliyBI;;EAEE,qCyDvgBc;EzDwgBd,yB6C/fyB;A7EmizB/B;AgC/hyBE;EACE,UAAA;AhCiiyBJ;AgC/hyBE;EACE,cAAA;EACA,cAAA;EACA,sCAAA;AhCiiyBJ;AgC/hyBE;;;;EAIE,eAAA;AhCiiyBJ;AgC7hyBE;;;EAGE,kC0Fhb2B;E1Fib3B,wD0FhbsB;A1H+8yB1B;AgC7hyBE;;;EAGE,oC0Fhb6B;E1Fib7B,sD0FhbwB;A1H+8yB5B;AgC7hyBE;;;EAGE,mB0Fjb4B;E1Fkb5B,0BiCjjBS;AjEglzBb;AgC7hyBE;;;EAGE,mC0F9c8B;E1F+c9B,uD0F9cyB;A1H6+yB7B;AgC7hyBE;;;EAGE,kC0F9c8B;E1F+c9B,wD0F9cyB;A1H6+yB7B;AgCrhyBE;EACE,MAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,uB0FjcmB;E1FkcnB,2B0FlcmB;E1FmcnB,gB0FlcwB;E1FmcxB,yB0FlcoB;A1Hy9yBxB;AgCrhyBE;EACE,gBAAA;AhCuhyBJ;AgCnhyBE;EACE,SAAA;EACA,gBAAA;EACA,M0FjdwB;E1FkdxB,e0FxlBoB;E1FylBpB,kDAAA;AhCqhyBJ;AgCnhyBE;EACE,aAAA;AhCqhyBJ;AgCjhyBE;EACE,SAAA;EACA,aAAA;EACA,M0F5d2B;E1F6d3B,kB0FpmBoB;E1FqmBpB,sB0FxdF;E1FydE,kDAAA;AhCmhyBJ;AgCjhyBE;EACE,gBAAA;AhCmhyBJ;AgC3gyBE;;EAEE,sC0FjeuB;A1H8+yB3B;AgCxgyBI;;EAEE,2C0Fve8B;A1Hi/yBpC;AgCrgyBE;EACE,mB0FhgB4B;E1FigB5B,0B6C/nBkB;A7EsozBtB;AgChgyBE;;EAEE,mBAAA;AhCkgyBJ;AgC7+xBM;EACE,+BAAA;AhC++xBR;AgC5+xBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFopzBR;AgC3+xBM;;EAEE,0EAAA;EAKE,mBAzBA;EA+BA,+BAjCA;AhCqgyBV;AgCj+xBM;;;EAOI,oCArCC;EA2CD,+BA9CC;AhCwgyBX;AgChgyBM;EACE,+BAAA;AhCkgyBR;AgC//xBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFuqzBR;AgC9/xBM;;EAEE,4DAAA;EAKE,mBAzBA;EA+BA,+BAjCA;AhCwhyBV;AgCp/xBM;;;EAOI,oCArCC;EA2CD,+BA9CC;AhC2hyBX;AgCnhyBM;EACE,+BAAA;AhCqhyBR;AgClhyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjF0rzBR;AgCjhyBM;;EAEE,yEAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhC2iyBV;AgCvgyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhC8iyBX;AgCtiyBM;EACE,+BAAA;AhCwiyBR;AgCriyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjF6szBR;AgCpiyBM;;EAEE,sDAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhC8jyBV;AgC1hyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhCikyBX;AgCzjyBM;EACE,+BAAA;AhC2jyBR;AgCxjyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFguzBR;AgCvjyBM;;EAEE,yEAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhCilyBV;AgC7iyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhColyBX;AgC5kyBM;EACE,+BAAA;AhC8kyBR;AgC3kyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFmvzBR;AgC1kyBM;;EAEE,0EAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhComyBV;AgChkyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhCumyBX;AgC/lyBM;EACE,+BAAA;AhCimyBR;AgC9lyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFswzBR;AgC7lyBM;;EAEE,yEAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhCunyBV;AgCnlyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhC0nyBX;AgClnyBM;EACE,+BAAA;AhConyBR;AgCjnyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFyxzBR;AgChnyBM;;EAEE,mDAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhC0oyBV;AgCtmyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhC6oyBX;AgCroyBM;EACE,+BAAA;AhCuoyBR;AgCpoyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjF4yzBR;AgCnoyBM;;EAEE,0EAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhC6pyBV;AgCznyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhCgqyBX;AgCxpyBM;EACE,+BAAA;AhC0pyBR;AgCvpyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjF+zzBR;AgCtpyBM;;EAEE,yEAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhCgryBV;AgC5oyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhCmryBX;AgC3qyBM;EACE,+BAAA;AhC6qyBR;AgC1qyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFk1zBR;AgCzqyBM;;EAEE,0EAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhCmsyBV;AgC/pyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhCssyBX;AgC9ryBM;EACE,+BAAA;AhCgsyBR;AgC7ryBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFq2zBR;AgC5ryBM;;EAEE,wEAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhCstyBV;AgClryBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhCytyBX;AgCjtyBM;EACE,+BAAA;AhCmtyBR;AgChtyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjFw3zBR;AgC/syBM;;EAEE,yEAAA;EAKE,mBAzBA;EA+BA,cAjCA;AhCyuyBV;AgCrsyBM;;;EAOI,oCArCC;EA2CD,cA9CC;AhC4uyBX;AgCpuyBM;EACE,+BAAA;AhCsuyBR;AgCnuyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjF24zBR;AgCluyBM;;EAEE,6CAAA;EAEE,mBApBA;EA6BA,cAjCA;AhC4vyBV;AgCxtyBM;;;EAII,oCAnCC;EA4CD,cA9CC;AhC+vyBX;AgCvvyBM;EACE,+BAAA;AhCyvyBR;AgCtvyBQ;EACE,yBAjBA;EAkBA,ciDtqBF;AjF85zBR;AgCrvyBM;;EAEE,4DAAA;EAEE,mBApBA;EA0BA,ciDnrBF;AjFo6zBR;AgC3uyBM;;;EAII,iBAnCC;EAyCD,ciDnsBF;AjF06zBR;AgCztyBE;EACE,WsFnsBS;AtH85zBb;AgCztyBE;EACE,UsFrsBS;AtHg6zBb;AgCztyBE;EACE,qBsFvsBW;AtHk6zBf;AgCztyBE;EACE,UsFzsBU;AtHo6zBd;AgCztyBE;EACE,UsF3sBU;AtHs6zBd;AgCztyBE;EACE,qBsF7sBS;AtHw6zBb;AgCztyBE;EACE,qBsF/sBW;AtH06zBf;AgCztyBE;EACE,YsFjtBW;AtH46zBf;AgCztyBE;EACE,qBsFntBU;AtH86zBd;AgCztyBE;EACE,UsFrtBS;AtHg7zBb;AgCztyBE;EACE,oBsFvtBY;AtHk7zBhB;AgCztyBE;EACE,oBsFztBY;AtHo7zBhB;AgCztyBE;EACE,oBsF3tBc;AtHs7zBlB;AgCztyBE;EACE,oBsF7tBc;AtHw7zBlB;AgCztyBE;EACE,oBsF/tBa;AtH07zBjB;AgCztyBE;EACE,YsFjuBa;AtH47zBjB;AgCvtyBE;;EAEE,YsFvwBO;AtHg+zBX;AgCvtyBE;;EAEE,YsF1wBO;AtHm+zBX;AgCvtyBE;;EAEE,asF7wBS;AtHs+zBb;AgCvtyBE;;EAEE,UsFhxBQ;AtHy+zBZ;AgCvtyBE;;EAEE,asFnxBQ;AtH4+zBZ;AgCvtyBE;;EAEE,YsFtxBO;AtH++zBX;AgCvtyBE;;EAEE,asFzxBS;AtHk/zBb;AgCvtyBE;;EAEE,UsF5xBS;AtHq/zBb;AgCvtyBE;;EAEE,asF/xBQ;AtHw/zBZ;AgCvtyBE;;EAEE,YsFlyBO;AtH2/zBX;AgCvtyBE;;EAEE,asFryBU;AtH8/zBd;AgCvtyBE;;EAEE,UsFxyBU;AtHig0Bd;AgCvtyBE;;EAEE,asF3yBY;AtHog0BhB;AgCvtyBE;;EAEE,YsF9yBY;AtHug0BhB;AgCvtyBE;;EAEE,asFjzBW;AtH0g0Bf;AgCvtyBE;;EAEE,WsFpzBW;AtH6g0Bf;AgCjtyBI;EACE,eAAA;EACA,mBAAA;EACA,6C0F5qBkB;E1F6qBlB,0BiC90BO;AjEii0Bb;AgCjtyBI;EACE,iBAAA;AhCmtyBN;AgCjtyBI;;EAEE,iBAAA;AhCmtyBN;AgChtyBI;EACE,aAAA;EACA,kBAAA;EACA,mB8Bh1BG;E9Bi1BH,wBAAA;EACA,WAAA;EACA,WAAA;EACA,W0F7rBsB;E1F8rBtB,Y0F5rBwB;E1F6rBxB,mBAAA;EACA,oB0F7rBqB;A1H+4zB3B;AgChtyBI;EACE,gB0F/rB0B;A1Hi5zBhC;AgChtyBI;EACE,gB0FjsB2B;A1Hm5zBjC;AgC9syBI;EACE,YAAA;EACA,yB6Cz2BgB;A7Eyj0BtB;AgC9syBI;EACE,+ByDl3Bc;EzDm3Bd,yB6Ch3Be;A7Egk0BrB;AgC5syBI;EACE,+ByDx3Bc;EzDy3Bd,0B6Cp3BgB;A7Ekk0BtB;AgC5syBI;EACE,qBAAA;AhC8syBN;AgC1syBI;EACE,+ByDj4Bc;EzDk4Bd,0B6C73BgB;A7Eyk0BtB;AgCvsyBM;EACE,uF0FjtBoC;E1FktBpC,yB6C33BuB;A7Eok0B/B;AgCvsyBM;EACE,uF0FvtBmC;E1FwtBnC,yB6Cj4BsB;A7E0k0B9B;AgCvsyBM;EACE,8B0F5tB+B;E1F6tB/B,+B0F7tB+B;A1Hs6zBvC;AgC7ryBI;EACE,mB0F9tBsB;E1F+tBtB,+B6Cv5BgB;E7Cw5BhB,Y0F/tBkB;A1H85zBxB;AgC7ryBI;;;;EAIE,qCyDp6B0B;EzDq6B1B,sCqDr5Be;ErDs5Bf,+B6Ch6BgB;A7E+l0BtB;AgC7ryBI;;EAEE,sCqD15Be;ArFyl0BrB;AgC5ryBI;;;;EAIE,oBAAA;EACA,+B6Cr6ByB;A7Emm0B/B;AgC5ryBI;;;;EAIE,yB6Cp7BgB;A7Ekn0BtB;AgC3ryBI;;EAEE,mBiD77BE;AjF0n0BR;AgC3ryBI;;EAEE,qCyD/7BqB;EzDg8BrB,yB6Ct7ByB;A7Emn0B/B;AgCrryBE;EACE,WAAA;AhCuryBJ;AgC/qyBI;EACE,uB0FvwBmB;E1FwwBnB,8BqDt9BS;ErDu9BT,gB0FvwBmB;A1Hw7zBzB;AgC/qyBI;;EAEE,gBAAA;AhCiryBN;AgC/qyBI;;;;EAIE,uB0F/wB0B;E1FgxB1B,iB0F9wBuB;A1H+7zB7B;AgC5qyBI;;EAEE,uB0FtxBwB;A1Ho8zB9B;AgC5qyBI;EACE,qCyD7+Bc;AzF2p0BpB;AgC1qyBI;EACE,YAAA;AhC4qyBN;AgC1qyBI;;;;;;EAME,W0FnyBqB;A1H+8zB3B;AgC1qyBI;;;;;;EAME,eAAA;AhC4qyBN;AgC1qyBI;;;;;;EAME,gBAAA;AhC4qyBN;AgC1qyBI;EACE,cAAA;AhC4qyBN;AgCnqyBI;;;;;;EAME,4C0F7/Bc;A1Hkq0BpB;AgClqyBM;;EAEE,+C0F/1BqB;A1Hmg0B7B;AgCjqyBI;;;;;;EAME,iBAAA;AhCmqyBN;AgC1pyBI;;;;EAIE,iB0F31B4B;E1F41B5B,kB0F51B4B;A1Hw/zBlC;AgC1pyBI;;;;;;EAME,gBAAA;AhC4pyBN;AgCxpyBI;;;;EAIE,mB0F12BiC;E1F22BjC,oB0F32BiC;A1Hqg0BvC;AgCxpyBI;;EAEE,oBAAA;AhC0pyBN;AgCjpyBI;;;;EAIE,mB0Fx3B6B;E1Fy3B7B,oB0Fz3B6B;A1H4g0BnC;AgCjpyBI;;EAEE,oBAAA;AhCmpyBN;AgC/oyBI;;;;EAIE,mB0Fn4BkC;E1Fo4BlC,oB0Fp4BkC;A1Hqh0BxC;AgC/oyBI;;EAEE,oBAAA;AhCipyBN;AgCxoyBE;EACE,gB0F94BU;A1Hwh0Bd;AgCtoyBE;EACE,c0Fl5BW;A1H0h0Bf;AgCpoyBE;EACE,gB0Ft5BU;A1H4h0Bd;AiCjw0BE;EACE,cAAA;EACA,gB0FLU;E1FMV,a0FPQ;A3H0w0BZ;AiChw0BE;EACE,SAAA;AjCkw0BJ;AiC/v0BE;EACE,SAAA;AjCiw0BJ;AiC9v0BE;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AjCgw0BJ;AiCxv0BE;EACE,YAAA;EACA,YAAA;AjC0v0BJ;AiCtv0BE;EACE,YAAA;EACA,aAAA;AjCwv0BJ;AiCpv0BE;EACE,YAAA;EACA,aAAA;AjCsv0BJ;AiCnv0BE;EACE,YAAA;EACA,aAAA;AjCqv0BJ;AiC7u0BE;EACE,YAAA;EACA,aAAA;AjC+u0BJ;AiC3u0BE;EACE,YAAA;EACA,aAAA;AjC6u0BJ;AiCru0BE;EACE,YAAA;EACA,aAAA;AjCuu0BJ;AiCnu0BE;EACE,YAAA;EACA,aAAA;AjCqu0BJ;AiC9t0BE;EACE,YAAA;EACA,YAAA;AjCgu0BJ;AiC9t0BE;EACE,YAAA;EACA,aAAA;AjCgu0BJ;AiC9t0BE;EACE,YAAA;EACA,YAAA;AjCgu0BJ;AiCxt0BE;EACE,YAAA;EACA,aAAA;AjC0t0BJ;AiCtt0BE;EACE,YAAA;AjCwt0BJ;AiCht0BE;EACE,YAAA;EACA,YAAA;AjCkt0BJ;AiC9s0BE;EACE,YAAA;EACA,aAAA;AjCgt0BJ;AiC5s0BE;EACE,YAAA;EACA,aAAA;AjC8s0BJ;AiC1s0BE;EACE,YAAA;EACA,YAAA;AjC4s0BJ;AiCps0BE;EACE,YAAA;EACA,YAAA;AjCss0BJ;AiCls0BE;EACE,YAAA;EACA,aAAA;AjCos0BJ;AiC5r0BE;EACE,YAAA;EACA,aAAA;AjC8r0BJ;AiCtr0BE;EACE,YAAA;EACA,aAAA;AjCwr0BJ;AiC9q0BE;EACE,YAAA;EACA,aAAA;AjCgr0BJ;AiC5q0BE;EACE,YAAA;EACA,YAAA;AjC8q0BJ;AiCtq0BE;EACE,aAAA;AjCwq0BJ;AiCrq0BE;EACE;IACE,cAAA;EjCuq0BJ;AACF;AiC/p0BE;EACE,iBAAA;EACA,kBAAA;AjCiq0BJ;AiC9p0BE;EACE,kBAAA;EACA,mBgFxNU;AjHw30Bd;AiC9p0BE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,4CAAA;EAEA,a0FrOW;E1FsOX,cgD3OI;EhD4OJ,c8CpNc;E9CqNd,iB6BpOG;A9Dm40BP;AiC7p0BE;EACE,yB8C1NY;A/Ey30BhB;AiC7p0BE;EACE,wBAAA;AjC+p0BJ;AkC340BE;;EAEE,eAAA;EACA,kBAAA;EACA,a0FJW;E1FKX,sBAAA;EAEA,Y0FDS;E1FET,a0FJc;E1FKd,mB+ChBI;E/CiBJ,U0FLW;E1FOX,Y0FCU;E1FAV,8B0ClBG;E1CmBH,kD0FJF;E1FKE,qD0FCF;E1FAE,W0FFW;E1FGX,qBAAA;AlC240BJ;AkCz40BE;EACE,a0FjBU;A5H450Bd;AkCx40BE;;EAEE,eAAA;AlC040BJ;AkCv40BE;EACE,aAAA;AlCy40BJ;AkCv40BE;EACE,gBAAA;AlCy40BJ;AkCl40BE;EACE,a0FfuB;E1FgBvB,uB0FjBqB;E1FkBrB,eAAA;AlCo40BJ;AkCj40BE;EACE,a0FlBiB;E1FmBjB,qB0FlBgB;E1FmBhB,W0FrBe;A5Hw50BnB;AkC/30BE;;EAEE,cAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AlCi40BJ;AkC530BE;EACE,mB0FjC8B;A5H+50BlC;AkCt30BE;;EAEE,6DAAA;EACA,2BAAA;AlCw30BJ;AkCr30BE;;EAEE,6DAAA;AlCu30BJ;AkCp30BE;;EAEE,yCAAA;AlCs30BJ;AkC/20BE;;EAEE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,U0F3DiB;E1F4DjB,+BuD5GgB;AzF690BpB;AkC/20BE;;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AlCi30BJ;AkC/20BE;;EAEE,Y0FtEgB;A5Hu70BpB;AkC120BE;;EAEE,YAAA;EACA,Y0FpEkB;E1FqElB,2C0F5EmB;E1F6EnB,gB0F3EsB;E1F4EtB,S0F7EkB;E1F8ElB,gB0F5EmB;E1F6EnB,gB0F1EsB;E1F2EtB,c0F7EqB;E1F8ErB,gB0F7EyB;A5Hy70B7B;AkCz20BE;;EAEE,cAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AlC220BJ;AkCx20BE;;EAEE,cAAA;EACA,U0FvFiB;E1FwFjB,6E4BzJU;E5B0JV,0B2C5Jc;A7Esg1BlB;AkCt20BE;;EAEE,iB4BrJG;E5BsJH,yB6CrIW;E7CsIX,sB0F9F6B;E1F+F7B,2BgCjKiB;AlEyg1BrB;AkCr20BE;;;;EAIE,iB0FvEwB;A5H860B5B;AkCh20BE;;EAEE,WAAA;AlCk20BJ;AkCh20BE;;EAEE,YAAA;AlCk20BJ;AkC310BE;;EAEE,gBAAA;AlC610BJ;AkC310BE;;EAEE,kBAAA;AlC610BJ;AkC310BE;;EAEE,iBAAA;AlC610BJ;AkCr10BE;;EAEE,qBAAA;EACA,sB0F3GgC;E1F4GhC,S0F7GuB;A5Ho80B3B;AkCr10BE;;;;EAIE,U0F/Ge;E1FgHf,W0FhHe;E1FiHf,qB8C5Nc;AhFmj1BlB;AkC/00BE;;EAEE,WAAA;EACA,0B0FnIqB;A5Ho90BzB;AkC100BE;;EAEE,iBAAA;AlC400BJ;AkC100BE;;EAEE,gBAAA;AlC400BJ;AkCr00BE;;EAEE,c6CnOc;E7CoOd,yB2C9Pe;A7Eqk1BnB;AkCr00BE;;EAEE,mB0FzLgB;A5Hgg1BpB;AkCr00BE;;EAEE,eAAA;AlCu00BJ;AkCp00BE;;EAEE,eAAA;EACA,kB0FnMgB;A5Hyg1BpB;AkC9z0BE;;EAEE,S0F9LsB;E1F+LtB,2B0F7L2B;A5H6/0B/B;AkC9z0BE;;EAEE,S0FlM4B;A5Hkg1BhC;AkC5z0BE;;EAEE,0B2CnSc;A7Eim1BlB;AkC5z0BE;;EAEE,wDoCpSe;AtEkm1BnB;AkC1z0BE;;EAEE,yB2C3Se;A7Eum1BnB;AkC1z0BE;;EAEE,0B+B9SS;AjE0m1Bb;AkCrz0BE;;;;EAIE,c0FnLiB;E1FoLjB,uB0FnLgB;A5H0+0BpB;AkCtz0BI;;;;EACE,mBAAA;AlC2z0BN;AkCnz0BE;;EAEE,oB0FpNgB;E1FqNhB,W0FtNkB;A5H2g1BtB;AkC3y0BE;;EAEE,eAAA;EACA,a0FxQkB;E1FyQlB,2B0FvQqB;A5Hoj1BzB;AkC3y0BE;;EAEE,U0F5QwB;E1F6QxB,c0F1Qc;A5Huj1BlB;AkC3y0BE;;EAEE,c0F7QqB;A5H0j1BzB;AkCvy0BE;;EAEE,eAAA;EACA,a0F3RkB;E1F4RlB,2B0F1RqB;A5Hmk1BzB;AkCvy0BE;;EAEE,U0F/RwB;E1FgSxB,c0F1Rc;A5Hmk1BlB;AkCvy0BE;;EAEE,c0F7RqB;A5Hsk1BzB;AkCly0BE;;EAEE,eAAA;EACA,wBAAA;EACA,YAAA;EACA,oDAAA;EACA,gB0FvQkB;E1FwQlB,gB0FzQoB;E1F0QpB,W0FxQe;E1FyQf,W0FtQgB;E1FuQhB,mB0FtQiB;E1FuQjB,M0F1Qa;E1F2Qb,O0F1Qc;E1F2Qd,yB2CtYe;E3CuYf,gB0FzQoB;E1F0QpB,2B0FxQoB;A5H4i1BxB;AkCly0BE;;EAEE,yB2C1YoB;A7E8q1BxB;AkCly0BE;;EAEE,wDoC/Ye;AtEmr1BnB;AkCxx0BE;;EAEE,mBAAA;EACA,eAAA;EACA,gB0FtQwB;E1FuQxB,Y0FtQoB;E1FuQpB,eAAA;AlC0x0BJ;AkCvx0BE;;EAEE,kDAAA;EACA,Y0F5Q0B;A5Hqi1B9B;AkCtx0BE;;EAEE,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kDAAA;AlCwx0BJ;AkCtx0BE;EACE,eAAA;AlCwx0BJ;AkCtx0BE;EACE,gBAAA;AlCwx0BJ;AkCjx0BE;;EAEE,qG0FxSF;A5H2j1BF;AkCjx0BE;;;;EAIE,sG0F1SF;A5H6j1BF;AkC5w0BE;EACE,uBAAA;AlC8w0BJ;AkC5w0BE;EACE,iBAAA;EACA,kBAAA;AlC8w0BJ;AkCvw0BE;EACE,WAAA;EACA,iBAAA;AlCyw0BJ;AkClw0BE;;;;EAIE,eAAA;AlCow0BJ;AkChw0BE;;;;EAIE,eAAA;EACA,U0FxWsB;E1FyWtB,mB+CtfI;E/CufJ,Y0FneU;E1FoeV,kD0FrWF;E1FsWE,2B0F1WwB;A5H4m1B5B;AkCnv0BM;;;EAGE,qEACQ;AlCov0BhB;AkChv0BQ;;;EACA,gHACQ;AlCmv0BhB;AkC5u0BQ;;;EAGE,qEACQ;AlC6u0BlB;AkC1u0BU;;;EACA,0FACQ;AlC6u0BlB;AkCvw0BM;;;EAGE,qEACQ;AlCww0BhB;AkCpw0BQ;;;EACA,sGACQ;AlCuw0BhB;AkChw0BQ;;;EAGE,qEACQ;AlCiw0BlB;AkC9v0BU;;;EACA,uFACQ;AlCiw0BlB;AkC3x0BM;;;EAGE,qEACQ;AlC4x0BhB;AkCxx0BQ;;;EACA,+GACQ;AlC2x0BhB;AkCpx0BQ;;;EAGE,qEACQ;AlCqx0BlB;AkClx0BU;;;EACA,yFACQ;AlCqx0BlB;AkC/y0BM;;;EAGE,qEACQ;AlCgz0BhB;AkC5y0BQ;;;EACA,oGACQ;AlC+y0BhB;AkCxy0BQ;;;EAGE,qEACQ;AlCyy0BlB;AkCty0BU;;;EACA,yFACQ;AlCyy0BlB;AkCn00BM;;;EAGE,qEACQ;AlCo00BhB;AkCh00BQ;;;EACA,2FACQ;AlCm00BhB;AkC5z0BQ;;;EAGE,qEACQ;AlC6z0BlB;AkC1z0BU;;;EACA,yFACQ;AlC6z0BlB;AkCv10BM;;;EAGE,qEACQ;AlCw10BhB;AkCp10BQ;;;EACA,gHACQ;AlCu10BhB;AkCh10BQ;;;EAGE,qEACQ;AlCi10BlB;AkC900BU;;;EACA,gHACQ;AlCi10BlB;AkC320BM;;;EAGE,qEACQ;AlC420BhB;AkCx20BQ;;;EACA,+GACQ;AlC220BhB;AkCp20BQ;;;EAGE,qEACQ;AlCq20BlB;AkCl20BU;;;EACA,iGACQ;AlCq20BlB;AkC/30BM;;;EAGE,qEACQ;AlCg40BhB;AkC530BQ;;;EACA,2FACQ;AlC+30BhB;AkCx30BQ;;;EAGE,qEACQ;AlCy30BlB;AkCt30BU;;;EACA,qEACQ;AlCy30BlB;AkCn50BM;;;EAGE,qEACQ;AlCo50BhB;AkCh50BQ;;;EACA,gHACQ;AlCm50BhB;AkC540BQ;;;EAGE,qEACQ;AlC640BlB;AkC140BU;;;EACA,0FACQ;AlC640BlB;AkCv60BM;;;EAGE,qEACQ;AlCw60BhB;AkCp60BQ;;;EACA,+GACQ;AlCu60BhB;AkCh60BQ;;;EAGE,qEACQ;AlCi60BlB;AkC950BU;;;EACA,0FACQ;AlCi60BlB;AkC370BM;;;EAGE,qEACQ;AlC470BhB;AkCx70BQ;;;EACA,gHACQ;AlC270BhB;AkCp70BQ;;;EAGE,qEACQ;AlCq70BlB;AkCl70BU;;;EACA,kFACQ;AlCq70BlB;AkC/80BM;;;EAGE,qEACQ;AlCg90BhB;AkC580BQ;;;EACA,gHACQ;AlC+80BhB;AkCx80BQ;;;EAGE,qEACQ;AlCy80BlB;AkCt80BU;;;EACA,0FACQ;AlCy80BlB;AkCn+0BM;;;EAGE,qEACQ;AlCo+0BhB;AkCh+0BQ;;;EACA,+GACQ;AlCm+0BhB;AkC590BQ;;;EAGE,qEACQ;AlC690BlB;AkC190BU;;;EACA,+GACQ;AlC690BlB;AkCv/0BM;;;EAGE,qEACQ;AlCw/0BhB;AkCp/0BQ;;;EACA,0FACQ;AlCu/0BhB;AkCh/0BQ;;;EAGE,qEACQ;AlCi/0BlB;AkC9+0BU;;;EACA,sFACQ;AlCi/0BlB;AkC3g1BM;;;EAGE,qEACQ;AlC4g1BhB;AkCxg1BQ;;;EACA,sGACQ;AlC2g1BhB;AkCpg1BQ;;;EAGE,qEACQ;AlCqg1BlB;AkClg1BU;;;EACA,mEACQ;AlCqg1BlB;AkCx/0BE;EACE,c0FzXc;E1F0Xd,e0F1Xc;A5Ho31BlB;AkCx/0BE;EACE,WoFriBS;AtH+h2Bb;AkCv/0BE;EACE,iB0F/Xc;E1FgYd,kB0FhYc;A5Hy31BlB;AkCv/0BE;EACE,sB0FpYQ;E1FqYR,gB0FtZgB;E1FuZhB,iB0FvZgB;A5Hg51BpB;AkCt/0BE;EACE,iB0FvYgB;E1FwYhB,kB0FxYgB;A5Hg41BpB;AkCt/0BE;EACE,iC0F5YU;E1F6YV,gB0FhagB;E1FiahB,iB0FjagB;A5Hy51BpB;AkCr/0BE;EACE,oB0F/Ye;E1FgZf,qB0FhZe;A5Hu41BnB;AkCr/0BE;EACE,wB0FpZS;E1FqZT,mB0FzaW;E1F0aX,oB0F1aW;A5Hi61Bf;AkCp/0BE;EACE,oB0FvZe;E1FwZf,qB0FxZe;A5H841BnB;AkCp/0BE;EACE,wB0F5ZS;E1F6ZT,mB0FnbW;E1FobX,oB0FpbW;A5H061Bf;AkCn/0BE;EACE,oB0F/Zc;E1Fgad,qB0Fhac;A5Hq51BlB;AkCn/0BE;EACE,mC0FpaQ;E1FqaR,mB0F7bW;E1F8bX,oB0F9bW;A5Hm71Bf;AkCl/0BE;EACE,mB0FvagB;E1FwahB,oB0FxagB;A5H451BpB;AkCl/0BE;EACE,iC0F5aU;E1F6aV,kB0FtciB;E1FucjB,mB0FvciB;A5H271BrB;AkCj/0BE;EACE,mB0F/agB;E1FgbhB,oB0FhbgB;A5Hm61BpB;AkCj/0BE;EACE,wB0FpbU;E1FqbV,kB0FhdiB;E1FidjB,mB0FjdiB;E1FkdjB,eAAA;AlCm/0BJ;AkCh/0BE;EACE,mB0Fxbe;E1Fybf,oB0Fzbe;A5H261BnB;AkCh/0BE;EACE,iC0F7bS;E1F8bT,kB0F3diB;E1F4djB,mB0F5diB;E1F6djB,eAAA;AlCk/0BJ;AkC/+0BE;EACE,mB0Fjcc;E1Fkcd,oB0Flcc;A5Hm71BlB;AkC/+0BE;EACE,sB0FtcQ;E1FucR,kB0FteiB;E1FuejB,mB0FveiB;A5Hw91BrB;AkCx+0BE;EACE;IACE,c0FpeY;I1FqeZ,e0FreY;E5H+81BhB;EkCx+0BE;IACE,WoFhpBO;IpFipBP,c0Frfa;I1Fsfb,e0Ftfa;E5Hg+1BjB;EkCx+0BE;IACE,iB0F3eY;I1F4eZ,kB0F5eY;E5Hs91BhB;EkCx+0BE;IACE,sB0FhfM;I1FifN,gB0FlgBc;I1FmgBd,iB0FngBc;E5H6+1BlB;EkCx+0BE;IACE,iB0FpfY;I1FqfZ,kB0FrfY;E5H+91BhB;EkCx+0BE;IACE,sB0FzfM;I1F0fN,gB0F3gBc;I1F4gBd,iB0F5gBc;E5Hs/1BlB;EkCx+0BE;IACE,iB0F7fY;I1F8fZ,kB0F9fY;E5Hw+1BhB;EkCx+0BE;IACE,sB0FlgBM;I1FmgBN,gB0FphBc;I1FqhBd,iB0FrhBc;E5H+/1BlB;EkCx+0BE;IACE,iB0FtgBY;I1FugBZ,kB0FvgBY;E5Hi/1BhB;EkCx+0BE;IACE,sB0F3gBM;I1F4gBN,gB0F7hBc;I1F8hBd,iB0F9hBc;E5Hwg2BlB;EkCx+0BE;IACE,iB0F7gBc;I1F8gBd,kB0F9gBc;E5Hw/1BlB;EkCx+0BE;IACE,iC0FlhBQ;I1FmhBR,gB0FtiBc;I1FuiBd,iB0FviBc;E5Hih2BlB;EkCx+0BE;IACE,iB0FthBc;I1FuhBd,kB0FvhBc;E5Hig2BlB;EkCx+0BE;IACE,iC0F3hBQ;I1F4hBR,gB0F/iBc;I1FgjBd,iB0FhjBc;E5H0h2BlB;EkCx+0BE;IACE,iB0F/hBc;I1FgiBd,kB0FhiBc;E5H0g2BlB;EkCx+0BE;IACE,iC0FpiBQ;I1FqiBR,gB0FxjBc;I1FyjBd,iB0FzjBc;E5Hmi2BlB;EkCx+0BE;IACE,iB0FxiBc;I1FyiBd,kB0FziBc;E5Hmh2BlB;EkCx+0BE;IACE,iC0F7iBQ;I1F8iBR,gB0FjkBc;I1FkkBd,iB0FlkBc;E5H4i2BlB;AACF;AkCt+0BE;EACE;IACE,c0FzjBY;I1F0jBZ,e0F1jBY;E5Hki2BhB;EkCt+0BE;IACE,WoFruBO;IpFsuBP,c0F1kBa;I1F2kBb,e0F3kBa;E5Hmj2BjB;EkCt+0BE;IACE,iB0FhkBY;I1FikBZ,kB0FjkBY;E5Hyi2BhB;EkCt+0BE;IACE,sB0FrkBM;I1FskBN,gB0FvlBc;I1FwlBd,iB0FxlBc;E5Hgk2BlB;EkCt+0BE;IACE,iB0FzkBY;I1F0kBZ,kB0F1kBY;E5Hkj2BhB;EkCt+0BE;IACE,sB0F9kBM;I1F+kBN,gB0FhmBc;I1FimBd,iB0FjmBc;E5Hyk2BlB;EkCt+0BE;IACE,iB0FhlBc;I1FilBd,kB0FjlBc;E5Hyj2BlB;EkCt+0BE;IACE,iC0FrlBQ;I1FslBR,gB0FzmBc;I1F0mBd,iB0F1mBc;E5Hkl2BlB;EkCt+0BE;IACE,iB0FzlBc;I1F0lBd,kB0F1lBc;E5Hkk2BlB;EkCt+0BE;IACE,iC0F9lBQ;I1F+lBR,gB0FlnBc;I1FmnBd,iB0FnnBc;E5H2l2BlB;EkCt+0BE;IACE,iB0FlmBc;I1FmmBd,kB0FnmBc;E5H2k2BlB;EkCt+0BE;IACE,iC0FvmBQ;I1FwmBR,gB0F3nBc;I1F4nBd,iB0F5nBc;E5Hom2BlB;EkCt+0BE;IACE,oB0FzmBa;I1F0mBb,qB0F1mBa;E5Hkl2BjB;EkCt+0BE;IACE,wB0F9mBO;I1F+mBP,mB0FnoBS;I1FooBT,oB0FpoBS;E5H4m2Bb;EkCt+0BE;IACE,oB0FlnBa;I1FmnBb,qB0FnnBa;E5H2l2BjB;EkCt+0BE;IACE,wB0FvnBO;I1FwnBP,mB0F5oBS;I1F6oBT,oB0F7oBS;E5Hqn2Bb;EkCt+0BE;IACE,oB0FznBa;I1F0nBb,qB0F1nBa;E5Hkm2BjB;EkCt+0BE;IACE,wB0F9nBO;I1F+nBP,mB0FrpBS;I1FspBT,oB0FtpBS;E5H8n2Bb;AACF;AkCj+0BE;EACE;IACE,yBAAA;ElCm+0BJ;EkCj+0BE;IACE,wBAAA;ElCm+0BJ;EkCj+0BE;IACE,yBAAA;IACA,uBAAA;IACA,eAAA;IACA,qBAAA;IACA,kCAAA;ElCm+0BJ;AACF;AkC590BE;EACE,c0F1oBU;A5Hwm2Bd;AkCt90BI;;EAEE,mBiD71BE;EjD81BF,kD0FnoBJ;A5H2l2BF;AkCp90BI;;EAEE,+C0FppB0B;A5H0m2BhC;AkCl90BI;;EAEE,+B2C52BgB;A7Eg02BtB;AkCh90BI;;EAEE,+B2Cj3BsB;A7Em02B5B;AkC980BI;;EAEE,+B2Ct3BsB;A7Es02B5B;AkC980BI;;EAEE,+B2C13BsB;A7E002B5B;AkC980BI;;EAEE,yB2C53BwB;A7E402B9B;AkC580BI;;EAEE,0DAAA;EACA,+B2Cr4BsB;A7Em12B5B;AkC580BI;;EAEE,+B2Cx4B2B;A7Es12BjC;AkC580BI;;EAEE,wDoCt5Ba;AtEo22BnB;AkC180BI;;;;EAIE,mBiDr5BE;AnFi22BR;AmCj22BE;EACE,e0FNmB;E1FOnB,gB0FRgB;A7H222BpB;AmCh22BE;EACE,aAAA;AnCk22BJ;AmCh22BE;EACE,gBAAA;AnCk22BJ;AmC312BE;EACE,kBAAA;EACA,gB0FlBiB;E1FmBjB,iB0FlBa;E1FmBb,kB0FlBc;E1FmBd,Y0FjBa;E1FkBb,gB0FnBc;E1FoBd,gB0FlBkB;A7H+22BtB;AmC312BE;EACE,a0FpBmB;E1FqBnB,c0FpBoB;A7Hi32BxB;AmCr12BE;EACE,uB0F1B6B;E1F2B7B,sB0F1B8B;A7Hi32BlC;AmCr12BE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AnCu12BJ;AmCr12BE;EACE,Y0F/BoB;E1FgCpB,gB0FjCqB;E1FkCrB,gB0FhCwB;A7Hu32B5B;AmCh12BE;EACE,c0FrCqB;E1FsCrB,Y0FpCmB;E1FqCnB,Y0FpCoB;E1FqCpB,W0FvCmB;E1FwCnB,iB0FpCoB;A7Hs32BxB;AmCh12BE;;EAEE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sB0F3C2B;A7H632B/B;AmC302BE;EACE,cAAA;AnC602BJ;AmC102BE;EACE,kB0FpDqB;A7Hg42BzB;AmCr02BE;EACE,c0FzDuB;E1F0DvB,0B8BjGS;E9BkGT,iB2BxFG;A9D+52BP;AmCr02BE;EACE,eAAA;AnCu02BJ;AmCr02BE;EACE,wDmCxGe;AtE+62BnB;AmCh02BE;EACE,qB0FnEuB;E1FoEvB,kB0FlEuB;E1FmEvB,yB0CnHe;E1CoHf,kB0FrEyB;A7Hu42B7B;AmCh02BE;EACE,qBAAA;EACA,mBAAA;AnCk02BJ;AmCh02BE;EACE,eAAA;AnCk02BJ;AmC3z2BE;EACE,sB0F7EkB;E1F8ElB,c0F/EqB;E1FgFrB,qB0F9EqB;E1F+ErB,0B8BrIS;E9BsIT,gB0F/EuB;A7H442B3B;AmCrz2BE;EACE,kB0FrFuB;A7H442B3B;AmCrz2BE;EACE,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,yB0CpJoB;A7E282BxB;AmCrz2BE;EACE,eAAA;AnCuz2BJ;AmCrz2BE;;EAEE,yB0C1JiB;A7Ei92BrB;AmChz2BE;EACE,e0FpG2B;A7Hs52B/B;AmChz2BE;EACE,WAAA;EACA,e0FxG2B;A7H052B/B;AmChz2BE;EACE,c0FzGsB;E1F0GtB,Y0F3GmB;A7H652BvB;AmC3y2BE;;;EAGE,aAAA;AnC6y2BJ;AmCjy2BE;EACE,4B0F1HsB;E1F2HtB,yB0F1HuB;E1F2HvB,2C0F1H0B;A7H652B9B;AmC5x2BE;EACE,UAAA;EACA,kB0F/H8B;E1FgI9B,M0F/HyB;E1FgIzB,Q0F/H2B;E1FgI3B,U0F/H0B;E1FgI1B,6B0F3HyB;E1F4HzB,sB0F/H+B;A7H652BnC;AmC5x2BE;EACE,UAAA;AnC8x2BJ;AmCtx2BE;EACE,0B4CnNG;A/E2+2BP;AmCtx2BE;EACE,0B4CrNG;A/E6+2BP;AmCtx2BE;EACE,0B4CvNI;A/E++2BR;AmCtx2BE;EACE,e4CzNK;A/Ei/2BT;AmCtx2BE;EACE,0B4C3NI;A/Em/2BR;AmCtx2BE;EACE,0B4C7NE;A/Eq/2BN;AmCtx2BE;EACE,0B4C/NG;A/Eu/2BP;AmCtx2BE;EACE,0B4CjOM;A/Ey/2BV;AmCjx2BI;EACE,yBgDnPE;AnFsg3BR;AmChx2BI;;EAEE,+B0C1PgB;A7E4g3BtB;AmC/w2BI;;EAEE,+B0C7PsB;A7E8g3B5B;AmC9w2BI;;;EAGE,yB0CjQwB;A7Eih3B9B;AmC7w2BI;EACE,4BAAA;AnC+w2BN;AoC3h3BE;EACE,a0FHU;A9Hgi3Bd;AoC3h3BE;EACE,aAAA;ApC6h3BJ;AoC3h3BE;EACE,gBAAA;ApC6h3BJ;AoCph3BE;EACE,aAAA;EACA,mBAAA;EACA,W0FhBe;E1FiBf,0B0FhBiB;E1FiBjB,S0FhBgB;E1FiBhB,gB0FhBoB;E1FiBpB,gB0FhBiB;A9Hsi3BrB;AoCph3BE;EACE,aAAA;EACA,cAAA;ApCsh3BJ;AoCph3BE;EACE,iBAAA;ApCsh3BJ;AoClh3BE;EACE,cAAA;EACA,cAAA;EACA,Y0F3Be;E1F4Bf,Y0F3BgB;E1F4BhB,mB0F3BoB;E1F4BpB,gB0F3BoB;A9H+i3BxB;AoClh3BE;EACE,U0F3BsB;E1F4BtB,gB0F1BmB;E1F2BnB,W0F5BoB;E1F6BpB,e0F3BsB;E1F4BtB,gB0F3ByB;E1F4BzB,Y0F1BqB;E1F2BrB,mB0F5B4B;E1F6B5B,yB0F3BoB;A9H+i3BxB;AoClh3BE;EACE,W0F3BqB;E1F4BrB,Y0F3BsB;E1F4BtB,qB4C5Dc;AhFgl3BlB;AoClh3BE;EACE,6C0F3B0B;A9H+i3B9B;AoC5g3BE;EACE,cAAA;EACA,cAAA;EACA,mB0FlCsB;E1FmCtB,gB0FlCsB;E1FmCtB,qB0FlCqB;A9Hgj3BzB;AoC5g3BE;EACE,iB0F1CgC;A9Hwj3BpC;AoC1g3BE;EACE,eAAA;ApC4g3BJ;AoCrg3BE;EACE,mB0F/Ce;E1FgDf,U0F/CgB;E1FgDhB,yByC9Fe;EzC+Ff,mB0BnFK;E1BoFL,c2CtEc;E3CuEd,kB0BrFK;A9D4l3BT;AoChg3BE;EACE,S0FpDkB;E1FqDlB,c2ChFc;E3CiFd,iB0BhGG;E1BiGH,0B6B3GS;AjE6m3Bb;AoC9/2BE;EACE,qBAAA;EACA,W0FvDuB;E1FwDvB,Y0FvDwB;E1FwDxB,0B0FvDwB;E1FwDxB,qB0FtD+B;E1FuD/B,sB0FxDgC;A9Hwj3BpC;AoC1/2BE;EACE,qBAAA;EACA,iB0BnHG;E1BoHH,e0FlDiB;E1FmDjB,wBAAA;ApC4/2BJ;AoC1/2BE;EACE,0B0FtEwB;E1FuExB,W0FzEuB;E1F0EvB,Y0FzEwB;E1F0ExB,sB0FxEgC;A9Hok3BpC;AoCr/2BE;EACE,qB0F5EwB;E1F6ExB,W0F5EsB;E1F6EtB,mB0BpIK;E1BqIL,yB2CzHY;E3C0HZ,kB0BtIK;E1BuIL,mB0F/EuB;E1FgFvB,U0F/EwB;E1FgFxB,yByCrJe;A7E4o3BnB;AoCh/2BE;EACE,iB0FzEgB;E1F0EhB,gB0FzEoB;E1F0EpB,U0FzEiB;E1F0EjB,0B6B/JS;AjEip3Bb;AoC9+2BE;EACE,qBAAA;EACA,oB0F5EsB;E1F6EtB,U0F5EqB;A9H4j3BzB;AoC5+2BE;EACE,U0F9EsB;E1F+EtB,iB0F9EsB;E1F+EtB,c2CpJc;E3CqJd,gB0F7EwB;E1F8ExB,qB4BlLU;AhEgq3Bd;AoCv+2BE;EACE,qB0FnFoB;E1FoFpB,yB2CjKY;E3CkKZ,iB0FnFmB;E1FoFnB,gB0FnFuB;E1FoFvB,Y0FnFmB;E1FoFnB,gB0FnF0B;E1FoF1B,gB0FnFuB;E1FoFvB,U0FnFoB;E1FoFpB,yB0FnFkB;A9H4j3BtB;AoCt+2BE;EACE,kBAAA;EACA,mB0FtF4B;A9H8j3BhC;AoCt+2BE;EACE,W0FhFoB;E1FiFpB,yB0FhF0B;E1FiF1B,MAAA;EACA,U0FjF2B;E1FkF3B,UAAA;EACA,kBAAA;EACA,mBAAA;ApCw+2BJ;AoCr+2BE;EACE,S0FhGc;E1FiGd,2B0F9FmB;A9Hqk3BvB;AoCr+2BE;EACE,c0FnGoB;A9H0k3BxB;AoCr+2BE;EACE,c0FrGqB;A9H4k3BzB;AoCn+2BE;EACE,cAAA;ApCq+2BJ;AoCn+2BE;EACE,aAAA;ApCq+2BJ;AoCj+2BE;;EAEE,e0F3G0B;E1F4G1B,U0F3G2B;E1F4G3B,yB0F3GyB;E1F4GzB,2B0F3G8B;A9H8k3BlC;AoCj+2BE;;;EAGE,0ByC1OkB;A7E6s3BtB;AoC192BE;EACE,0B2C1OI;A/Ess3BR;AoC192BE;EACE,e2C5OK;A/Ews3BT;AoC192BE;EACE,0B2C9OI;A/E0s3BR;AoCp92BI;EACE,mB+C9PE;AnFot3BR;AoCn92BI;;EAEE,+ByCnQsB;A7Ewt3B5B;AoCl92BI;;EAEE,+ByC1QgB;A7E8t3BtB;AoCj92BI;EACE,yByCxQyB;A7E2t3B/B;AqChu3BE;EACE,a0FHW;E1FIX,aAAA;EACA,WAAA;EACA,a0FHc;E1FId,uB0FNc;E1FOd,U0FJW;E1FMX,Y0FHU;E1FIV,gB0FTiB;E1FUjB,gB0FNc;E1FOd,gC0FJc;E1FKd,W0FNW;A/Huu3Bf;AqC/t3BE;EACE,eAAA;ArCiu3BJ;AqC1t3BE;EACE,e0F5BgB;A/Hwv3BpB;AqCzt3BE;EACE,wBAAA;ArC2t3BJ;AqCzt3BE;EACE,2BAAA;ArC2t3BJ;AqCpt3BE;EACE,cAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;ArCst3BJ;AqCpt3BE;EACE,aAAA;ArCst3BJ;AqCpt3BE;EACE,gBAAA;ArCst3BJ;AqC7s3BE;EACE,kBAAA;EACA,cAAA;EACA,c0FlCiB;E1FmCjB,W0FlCe;E1FmCf,S0FhCgB;E1FiChB,U0FhCiB;E1FiCjB,c0FpCoB;E1FqCpB,iB0FpCwB;A/Hmv3B5B;AqC7s3BE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,uB0FtCuB;E1FuCvB,Y0FxCgB;A/Huv3BpB;AqC5s3BE;EACE,gB0F7EiB;A/H2x3BrB;AqCts3BE;EACE,cAAA;EACA,cAAA;EACA,gB0F5CsB;E1F6CtB,0B4BjGS;E5BkGT,S0F7CkB;E1F8ClB,U0F7CmB;E1F8CnB,gB0F1CsB;E1F2CtB,c0F9CqB;E1F+CrB,Y0F9CkB;E1F+ClB,gB0F9CyB;A/Hsv3B7B;AqCts3BE;EACE,cAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;ArCws3BJ;AqCrs3BE;EACE,YAAA;EACA,W0FlEiB;E1FmEjB,c0FtEmB;E1FuEnB,c0FnEkB;E1FoElB,iB0FvE0B;E1FwE1B,mB0FpG0B;A/H2y3B9B;AqCps3BE;EACE,qBAAA;EACA,sB0F/DiB;E1FgEjB,6EyB/HU;EzBgIV,iByBrHG;EzBsHH,0BwCnIc;A7Ey03BlB;AqCns3BE;EACE,yB0CzGW;A/E8y3Bf;AqC9r3BE;EACE,WAAA;ArCgs3BJ;AqC9r3BE;EACE,YAAA;ArCgs3BJ;AqCxr3BE;EACE,kB0FhDgC;E1FiDhC,S0FlDuB;A/H4u3B3B;AqCxr3BE;;EAEE,S0FtDuB;E1FuDvB,U0FvDuB;E1FwDvB,qB2ChKc;AhF013BlB;AqClr3BE;EACE,iB0FxEwB;E1FyExB,e0FxEyB;E1FyEzB,c0FxEyB;E1FyEzB,qB2B9KU;E3B+KV,0B4B5KS;AjEg23Bb;AqC7q3BE;EACE,iBAAA;ArC+q3BJ;AqC7q3BE;EACE,gBAAA;ArC+q3BJ;AqCxq3BE;EACE,qB0F3He;E1F4Hf,c0F3HkB;E1F4HlB,gB0F3HoB;E1F4HpB,yB0F1Hc;A/Hoy3BlB;AqCxq3BE;EACE,mB0F9HgB;A/Hwy3BpB;AqCxq3BE;EACE,eAAA;ArC0q3BJ;AqCvq3BE;EACE,eAAA;EACA,kB0FtIgB;A/H+y3BpB;AqCjq3BE;EACE,S0F5HsB;E1F6HtB,2B0F3H2B;A/H8x3B/B;AqCjq3BE;EACE,S0F/H4B;A/Hky3BhC;AqC/p3BE;EACE,0BwClOc;A7Em43BlB;AqC/p3BE;EACE,wDiClOe;AtEm43BnB;AqC7p3BE;EACE,yBwCxOe;A7Eu43BnB;AqC7p3BE;EACE,0B4B1OS;AjEy43Bb;AqCnp3BE;EACE,eAAA;EACA,a0F7KkB;E1F8KlB,2B0F5KqB;A/Hi03BzB;AqCnp3BE;EACE,U0FhLwB;E1FiLxB,c0F7KkB;A/Hk03BtB;AqCnp3BE;EACE,c0F/KyB;A/Ho03B7B;AqC/o3BE;EACE,eAAA;EACA,a0F7LkB;E1F8LlB,2B0F5LqB;A/H603BzB;AqC/o3BE;EACE,U0FhMwB;E1FiMxB,c0F3Lc;A/H403BlB;AqC/o3BE;EACE,c0F7LqB;A/H803BzB;AqC1o3BE;EACE,c0FjKiB;E1FkKjB,kB0FjKkB;E1FkKlB,gB0FpKoB;E1FqKpB,kB0FlKgB;E1FmKhB,W0FhKe;E1FiKf,c0FhKiB;E1FiKjB,M0FpKa;E1FqKb,O0FpKc;E1FqKd,yBwCjSe;ExCkSf,gB0FnKoB;E1FoKpB,2B0FlKoB;E1FmKpB,gB0FjLiB;A/H6z3BrB;AqC1o3BE;EACE,gCAAA;ArC4o3BJ;AqC1o3BE;EACE,gCAAA;ArC4o3BJ;AqCzo3BE;EACE,cAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;ArC2o3BJ;AqClo3BE;EACE,Y0FzSe;A/H663BnB;AqC/n3BE;EACE;IACE,aAAA;ErCio3BJ;EqC/n3BE;IACE,Y0F/SoB;E/Hg73BxB;EqC/n3BE;IACE,cAAA;IACA,kBAAA;ErCio3BJ;AACF;AqC5n3BE;EACE;IACE,sBAAA;IACA,aAAA;ErC8n3BJ;EqC5n3BE;IACE,cAAA;IACA,iBAAA;IACA,kBAAA;ErC8n3BJ;EqC5n3BE;;IAEE,0BAAA;IACA,sBAAA;IACA,4BAAA;ErC8n3BJ;EqC5n3BE;IACE,cAAA;IACA,kBAAA;ErC8n3BJ;AACF;AqCjn3BE;EACE,sBAAA;ArCmn3BJ;AqCjn3BE;EACE,kBAAA;ArCmn3BJ;AqCjn3BE;EACE,oBAAA;ArCmn3BJ;AqC3m3BE;EACE,eAAA;ArC6m3BJ;AqC3m3BE;EACE,aAAA;ArC6m3BJ;AqCrm3BE;EACE,4C0FnQkB;E1FoQlB,S0FnQkB;E1FoQlB,c0FnQmB;A/H023BvB;AqCrm3BE;EACE,gBAAA;EACA,wBAAA;EACA,yBAAA;ArCum3BJ;AqCrm3BE;EACE,2BAAA;EACA,4BAAA;ArCum3BJ;AqCnm3BE;EACE,SAAA;EACA,gBAAA;ArCqm3BJ;AqCnm3BE;EACE,SAAA;EACA,cAAA;ArCqm3BJ;AqC7l3BE;;EAEE,eAAA;ArC+l3BJ;AqC5l3BE;;EAEE,wDiChbe;AtE8g4BnB;AqCtl3BE;EACE,c0Chac;A/Ew/3BlB;AqCjl3BE;EACE;;IAEE,uBAAA;ErCml3BJ;AACF;AqC1k3BI;EACE,uB0FvcY;A/Hmh4BlB;AqC1k3BI;EACE,gB0F7ZoB;E1F8ZpB,+BwC3cgB;A7Euh4BtB;AqC1k3BI;EACE,gB0F/VkB;A/H263BxB;AqC1k3BI;EACE,+BwCjdgB;A7E6h4BtB;AqC1k3BI;EACE,+BwCpdgB;A7Egi4BtB;AqC1k3BI;EACE,+B0F5TqB;A/Hw43B3B;AqC1k3BI;EACE,yD0FnU6B;A/H+43BnC;AqC1k3BI;EACE,c+BveO;ApEmj4Bb;AqC1k3BI;EACE,+BwChegB;A7E4i4BtB;AqC1k3BI;EACE,yBwC/dwB;A7E2i4B9B;AqC1k3BI;EACE,+BwCpesB;A7Egj4B5B;AqC1k3BI;EACE,+BwCzegB;A7Eqj4BtB;AqC1k3BI;EACE,kC0F9UyB;A/H053B/B;AqC1k3BI;EACE,mC0FhVgC;A/H453BtC;AqC1k3BI;EACE,kC0FtVqB;A/Hk63B3B;AqC1k3BI;EACE,kC0FxV4B;A/Ho63BlC;AqC1k3BI;EACE,+BwCtfsB;A7Ekk4B5B;AqC1k3BI;;EAEE,yBwCxfwB;A7Eok4B9B;AqC1k3BI;EACE,8C0F/VyB;A/H263B/B;AqC1k3BI;EACE,gBAAA;ArC4k3BN;AsChl4BE;EACE,oBAAA;EACA,sBAAA;EACA,a0FLe;E1FMf,e0FJkB;AhIsl4BtB;AsC/k4BE;EACE,mBAAA;AtCil4BJ;AsC9k4BE;EACE,aAAA;AtCgl4BJ;AsC9k4BE;EACE,gBAAA;AtCgl4BJ;AsCtk4BE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AtCwk4BJ;AsCtk4BE;EACE,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,mB0F1BuB;E1F2BvB,e0FnCkB;AhI2m4BtB;AsCtk4BE;EACE,aAAA;EACA,uB0FlCqB;AhI0m4BzB;AsCpk4BE;EACE,cAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AtCsk4BJ;AsCnk4BE;EACE,aAAA;AtCqk4BJ;AsCxj4BE;;EAEE,6EwBzEQ;ExB0ER,e0FOmB;E1FNnB,mBwBhEK;ExBiEL,gB0FvD0B;E1FwD1B,c6CpEI;E7CqEJ,yB0FvD6B;E1FwD7B,kB0F3EmB;AhIqo4BvB;AsCnj4BE;;EAEE,6EwBzFU;ExB0FV,cyChEc;EzCiEd,iBwBhFG;ExBiFH,0B2B3FS;E3B4FT,yB0F3D6B;E1F4D7B,kB0FzFmB;AhI8o4BvB;AsCjj4BE;;EAEE,a0FxE2B;AhI2n4B/B;AsC/i4BE;;EAEE,a0F7E8B;AhI8n4BlC;AsCpi4BE;;EAEE,UAAA;EACA,WAAA;EACA,SAAA;AtCsi4BJ;AsC/h4BE;;EAEE,gB0F/F+B;E1FgG/B,e0F/F8B;E1FgG9B,iBwB3HG;ExB4HH,kBAAA;AtCii4BJ;AsC/h4BE;;EAEE,kBAAA;AtCii4BJ;AsC1h4BE;;EAEE,gB0F1GqB;E1F2GrB,wB0F1G6B;AhIso4BjC;AsC7g4BE;EACE,gB0FxG0B;AhIun4B9B;AsC7g4BE;EACE,cgF9IS;EhF+IT,e0F3GoB;AhI0n4BxB;AsC5g4BE;EACE,gB0FhH0B;AhI8n4B9B;AsC5g4BE;EACE,yBgFvJU;EhFwJV,e0FnHoB;AhIio4BxB;AsC3g4BE;EACE,gB0FxH0B;AhIqo4B9B;AsC3g4BE;EACE,gBgFhKW;EhFiKX,e0F3HoB;AhIwo4BxB;AsC1g4BE;EACE,gB0FhI0B;AhI4o4B9B;AsC1g4BE;EACE,yBgFzKW;EhF0KX,e0FnIoB;AhI+o4BxB;AsCzg4BE;EACE,gB0FxI0B;AhImp4B9B;AsCzg4BE;EACE,yBgFlLS;EhFmLT,e0F3IoB;AhIsp4BxB;AsCxg4BE;EACE,gB0FhJ0B;AhI0p4B9B;AsCxg4BE;EACE,cgF3LU;EhF4LV,e0FnJoB;AhI6p4BxB;AsCvg4BE;EACE,gB0FxJ0B;AhIiq4B9B;AsCvg4BE;EACE,cgFpMU;EhFqMV,e0F3JoB;AhIoq4BxB;AsCtg4BE;EACE,gB0FhK0B;AhIwq4B9B;AsCtg4BE;EACE,yBgF7MW;EhF8MX,e0FnKoB;AhI2q4BxB;AsCrg4BE;EACE,gB0FxK0B;AhI+q4B9B;AsCrg4BE;EACE,cgFtNS;EhFuNT,e0F3KoB;AhIkr4BxB;AsCpg4BE;EACE,gB0FhL0B;AhIsr4B9B;AsCpg4BE;EACE,egF/NS;EhFgOT,e0FnLoB;AhIyr4BxB;AsC5/3BE;EACE,mBAAA;EACA,mBAAA;AtC8/3BJ;AsC5/3BE;EACE,sBAAA;EACA,SAAA;EACA,eAAA;AtC8/3BJ;AsC5/3BE;EACE,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,a0FzNwC;AhIut4B5C;AsC3/3BE;;EAEE,wBAAA;AtC6/3BJ;AsC3/3BE;;EAEE,a2DlRS;AjG+w4Bb;AsC1/3BE;;EAEE,qBAAA;EACA,sBAAA;AtC4/3BJ;AsC1/3BE;;EAEE,qBAAA;EACA,sBAAA;EACA,oBAAA;AtC4/3BJ;AsCp/3BI;;EAEE,c2CrSE;AjF2x4BR;AsCp/3BI;;EAEE,+BuCnSgB;A7Eyx4BtB;AsCv+3BM;;;EAGE,cANE;AtC++3BV;AsCt+3BQ;;;EAGE,cAXA;AtCm/3BV;AsCj/3BM;;;EAGE,cANE;AtCy/3BV;AsCh/3BQ;;;EAGE,cAXA;AtC6/3BV;AsC3/3BM;;;EAGE,cANE;AtCmg4BV;AsC1/3BQ;;;EAGE,cAXA;AtCug4BV;AsCrg4BM;;;EAGE,cANE;AtC6g4BV;AsCpg4BQ;;;EAGE,cAXA;AtCih4BV;AsC/g4BM;;;EAGE,cANE;AtCuh4BV;AsC9g4BQ;;;EAGE,cAXA;AtC2h4BV;AsCzh4BM;;;EAGE,cANE;AtCii4BV;AsCxh4BQ;;;EAGE,cAXA;AtCqi4BV;AsCni4BM;;;EAGE,cANE;AtC2i4BV;AsCli4BQ;;;EAGE,cAXA;AtC+i4BV;AsC7i4BM;;;EAGE,cANE;AtCqj4BV;AsC5i4BQ;;;EAGE,cAXA;AtCyj4BV;AsCvj4BM;;;EAGE,cANE;AtC+j4BV;AsCtj4BQ;;;EAGE,cAXA;AtCmk4BV;AsCjk4BM;;;EAGE,cANE;AtCyk4BV;AsChk4BQ;;;EAGE,cAXA;AtC6k4BV;AsC3k4BM;;;EAGE,cANE;AtCml4BV;AsC1k4BQ;;;EAGE,cAXA;AtCul4BV;AsCrl4BM;;;EAGE,cANE;AtC6l4BV;AsCpl4BQ;;;EAGE,cAXA;AtCim4BV;AsC/l4BM;;;EAGE,cANE;AtCum4BV;AsC9l4BQ;;;EAGE,cAXA;AtC2m4BV;AsCzm4BM;;;EAGE,cANE;AtCin4BV;AsCxm4BQ;;;EAGE,cAXA;AtCqn4BV;AsCnn4BM;;;EAGE,cANE;AtC2n4BV;AsCln4BQ;;;EAGE,cAXA;AtC+n4BV;AsC1m4BE;EACE,WAAA;EACA,mB0F1R4B;AhIs44BhC;AsC1m4BE;EACE,YAAA;EACA,mB0F7R6B;AhIy44BjC;AsC1m4BE;EACE,gBAAA;AtC4m4BJ;AsCrm4BE;EACE;IACE,WAAA;IACA,yBAAA;IACA,0BAAA;EtCum4BJ;EsCrm4BE;IACE,sBAAA;IACA,sBAAA;IACA,6BAAA;EtCum4BJ;AACF;AsC7l4BE;;EAEE,4BAAA;AtC+l4BJ;AsC7l4BE;;EAEE,4BAAA;AtC+l4BJ;AsC7l4BE;;EAEE,0BAAA;AtC+l4BJ;AsC1l4BE;;EAEE,0BAAA;AtC4l4BJ;AsC1l4BE;;EAEE,0BAAA;AtC4l4BJ;AsC1l4BE;;EAEE,0BAAA;AtC4l4BJ;AsCxl4BE;;EAEE,0BAAA;AtC0l4BJ;AsCxl4BE;;EAEE,0BAAA;AtC0l4BJ;AsCxl4BE;;EAEE,0BAAA;AtC0l4BJ;AsCtl4BE;;EAEE,0BAAA;AtCwl4BJ;AsCtl4BE;;EAEE,0BAAA;AtCwl4BJ;AsCtl4BE;;EAEE,0BAAA;AtCwl4BJ;AsCpl4BE;;EAEE,0BAAA;AtCsl4BJ;AsCpl4BE;;EAEE,0BAAA;AtCsl4BJ;AsCpl4BE;;EAEE,4BAAA;AtCsl4BJ;AsCll4BE;;EAEE,0BAAA;AtCol4BJ;AsCll4BE;;EAEE,0BAAA;AtCol4BJ;AsCll4BE;;EAEE,4BAAA;AtCol4BJ;AuCjh5BE;;EAEE,eAAA;AvCmh5BJ;AuCjh5BE;EACE,e0FgBqB;E1FfrB,U0FgBsB;AjImg5B1B;AuC/g5BE;;EAEE,eAAA;AvCih5BJ;AuC7g5BE;EACE,gB0FjBsB;E1FkBtB,6EuBvBU;EvBwBV,c0FlBwB;E1FmBxB,0B0BxBS;AjEui5Bb;AuC3g5BE;;EAEE,U0FDuB;E1FEvB,oB0FDwB;AjI8g5B5B;AuC3g5BE;EACE,iBAAA;AvC6g5BJ;AuCzg5BE;;EAEE,qB0F1BqB;E1F2BrB,W0F9BmB;E1F+BnB,U0FjCqB;E1FkCrB,a0F/BmB;E1FgCnB,W0F/BoB;E1FgCpB,qB0F9BoB;E1F+BpB,U0F9BqB;E1F+BrB,c0FrCuB;E1FsCvB,kD0F9BF;E1F+BE,wB0F5B4B;E1F6B5B,e0F5BuB;AjIui5B3B;AuCng5BE;EACE,cAAA;EACA,U0F1B2B;AjI+h5B/B;AuCng5BE;EACE,Y0F5BwB;E1F6BxB,yB0F5ByB;E1F6BzB,yB0F5B4B;AjIii5BhC;AuCjg5BE;EACE,c0F5DuB;E1F6DvB,qB0FxDoB;AjI2j5BxB;AuC5/4BE;;EAEE,wB0FtC8B;AjIoi5BlC;AuC3/4BE;EACE,wB0F1C8B;AjIui5BlC;AuCl/4BE;EACE,Y0FjDqB;AjIqi5BzB;AuCj/4BE;;EAEE,8BqClGG;ErCmGH,mB0CrGI;E1CsGJ,gF0FpDF;AjIui5BF;AuCj/4BE;;EAEE,S0F3C4B;E1F4C5B,mB0F3C6B;E1F4C7B,yBsC5GoB;EtC6GpB,iBuBpGG;EvBqGH,4C0F1C4B;E1F2C5B,sC0F5CgC;AjI+h5BpC;AuCj/4BE;;EAEE,gBAAA;AvCm/4BJ;AuC9+4BE;;EAEE,S0FnE8B;E1FoE9B,wB0FnE+B;AjImj5BnC;AuC9+4BE;EACE,S0FnEoC;E1FoEpC,wB0FvE+B;AjIuj5BnC;AuC3+4BE;;;;EAIE,uB0F7DsC;E1F8DtC,0B0B1IS;AjEun5Bb;AuC3+4BE;;EAEE,uB0FlEsC;E1FmEtC,0B0B/IS;AjE4n5Bb;AuCx+4BE;EACE,uB0FvEuC;E1FwEvC,0BsClJkB;A7E4n5BtB;AuCx+4BE;EACE,uB0F3EuC;E1F4EvC,0BsCtJkB;A7Ego5BtB;AuC994BE;;EAEE,aAAA;AvCg+4BJ;AuCr94BE;;EAEE,WAAA;AvCu94BJ;AuC/84BI;EACE,+BsCvLgB;A7Ewo5BtB;AwCjp5BE;EACE,wBAAA;EACA,yHACE;EAGF,mBAAA;EACA,kBAAA;AxCgp5BJ;AwC5o5BE;;EAEE,sBAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AxC8o5BJ;AwC3o5BE;;EAEE,gBAAA;AxC6o5BJ;AyC9p5BE;EACE,eAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AzCgq5BJ;AyCzp5BE;EACE,UAAA;AzC2p5BJ;AyCpp5BE;EACE,cAAA;EACA,mBAAA;AzCsp5BJ;AyCnp5BE;EACE,WAAA;AzCqp5BJ;AyC9o5BE;;;EAGE,eAAA;AzCgp5BJ;AyC7o5BE;EACE,eAAA;AzC+o5BJ;AyC5o5BE;EACE,eAAA;AzC8o5BJ;AyC3o5BE;EACE,eAAA;AzC6o5BJ;AyC1o5BE;;EAEE,cAAA;EACA,mBAAA;AzC4o5BJ;AyCzo5BE;EACE,iBAAA;AzC2o5BJ;AyCxo5BE;EACE,SAAA;AzC0o5BJ;AyCvo5BE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AzCyo5BJ;AyCto5BE;EACE,YAAA;AzCwo5BJ;AyCro5BE;EACE,kBAAA;EACA,qBAAA;AzCuo5BJ;AyCpo5BE;EACE,mBAAA;EACA,oBAAA;AzCso5BJ;AyCno5BE;EACE,eAAA;AzCqo5BJ;AyClo5BE;EACE,mBAAA;EACA,kBAAA;EACA,OAAA;AzCoo5BJ;AyCjo5BE;EACE,mBAAA;EACA,kBAAA;EACA,QAAA;AzCmo5BJ;AyCho5BE;EACE,oBAAA;EACA,eAAA;EACA,yBoCtGkB;A7Ewu5BtB;AyC/n5BE;EACE,yBoCjHe;EpCkHf,+BgDnHuB;AzFov5B3B;AyC1n5BE;EACE,iByFrHyB;AlIiv5B7B;AyCzn5BE;EACE,+BgD7HgB;EhD8HhB,0BoCzHkB;EpC0HlB,gByFvHwB;AlIkv5B5B;AyCxn5BE;EACE,qCgD9HgB;EhD+HhB,yBoCtH2B;EpCuH3B,gByF1HiC;AlIov5BrC;AyCvn5BE;;EAEE,mCyFzIwB;AlIkw5B5B;AyCtn5BE;;EAEE,mCyF7IiC;AlIqw5BrC;AyC5m5BE;EACE,asD9Je;A/F4w5BnB;AyC3m5BE;;EAEE,oBAAA;AzC6m5BJ;A0Cpw5BE;EACE,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,aAAA;EACA,wBAAA;EACA,kBAAA;EAEA,gByFjBY;EzFkBZ,cqCOc;ErCNd,iByFnBY;EzFoBZ,eyFpBY;AnIyx5BhB;A0Cjw5BE;;EAEE,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,qBAAA;EACA,aAAA;EACA,UAAA;EACA,WyFjCY;EzFkCZ,YyFlCY;AnIqy5BhB;A0C1v5BE;;EAEE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,uByF1CsB;EzF2CtB,aAAA;EACA,cqCzBc;A/Eqx5BlB;A0Czv5BE;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,WyF3DY;EzF4DZ,YyF5DY;EzF6DZ,WAAA;EAEA,mBuC9DI;EvC+DJ,8BkC9DG;ElCgEH,0FyFrDF;EzFsDE,yByFzDc;AnIiz5BlB;A0Cjv5BE;;EAEE,kBAAA;EACA,eyFzDuB;EzF0DvB,MyFzDiB;EzF0DjB,OyFzDkB;EzF0DlB,WyFhFY;EzFiFZ,YyFjFY;EzFkFZ,kBAAA;EAEA,UAAA;EACA,0BuBrFS;EvBsFT,0FyFzEF;AnI2z5BF;A0C1u5BE;;EAEE,0BuBhGS;EvBiGT,2ByFrEwB;AnIiz5B5B;A0Cxu5BE;EACE,sBAAA;A1C0u5BJ;A0C7t5BE;;EAEE,mBuCpHI;EvCqHJ,oC0C9GoB;ApF605BxB;A0C7t5BE;;EAEE,yBmCxHiB;A7Eu15BrB;A0Cxt5BE;;EAEE,mBuCrIQ;EvCsIR,oC0C5HoB;ApFs15BxB;A0Cxt5BE;;EAEE,0BmCpIkB;A7E815BtB;A0Cxt5BE;EACE,0BmCvIkB;A7Ei25BtB;A0Cnt5BE;;EAEE,mBuCnJI;EvCoJJ,qB0D9H8B;ApGm15BlC;A0Cnt5BE;;EAEE,0BmCrJkB;A7E025BtB;A0Cnt5BE;EACE,0BmCxJkB;A7E625BtB;A0C9s5BE;;EAEE,mBuCpKI;EvCqKJ,oC0C9JoB;ApF825BxB;A0C9s5BE;;EAEE,UyFpH4B;EzFqH5B,0BmCvKkB;A7Eu35BtB;A0Czs5BE;;EAEE,mBuCnLI;EvCoLJ,oC0C7KoB;ApFw35BxB;A0Czs5BE;;EAEE,UyFzHmC;EzF0HnC,0BmCtLkB;A7Ei45BtB;A0Cxs5BI;EACE,+B+C7L0B;AzFu45BhC;A0Cxs5BI;EACE,cyFjC0B;AnI2u5BhC;A0Cls5BE;;;;EAIE,mBuC5MI;EvC6MJ,qB0DvL8B;ApG235BlC;A0Cls5BE;;;;EAIE,0BmChNkB;A7Eo55BtB;A0C5r5BE;;EAEE,eAAA;A1C8r5BJ;A0Ctr5BE;;;;EAIE,0BAAA;EACA,YyFvKwB;EzFwKxB,mByFvK4B;AnI+15BhC;A0C/q5BE;EACE,WAAA;A1Cir5BJ;A0C7q5BE;EACE,eAAA;EACA,iBAAA;A1C+q5BJ;A0Clq5BE;EACE,gByF9LkB;AnIk25BtB;A0Cjq5BE;;EAEE,uByFzQsB;AnI465B1B;A0C/p5BE;;EAEE,WAAA;EACA,eAAA;EAEA,WyF5MkB;EzF6MlB,YyF7MkB;EzF8MlB,qBsC3Rc;EtC4Rd,QyF9MiB;EzF+MjB,OyF9MkB;AnI825BtB;A0C5p5BE;;EAEE,YAAA;EACA,sBAAA;EACA,WyFxNkB;EzFyNlB,YyFzNkB;EzF0NlB,iByF1NkB;AnIw35BtB;A0C1p5BE;;EAEE,QyF3NkB;EzF4NlB,OyF3NmB;EzF4NnB,WyFlOkB;EzFmOlB,YyFnOkB;EzFoOlB,qBsCjTc;EtCkTd,8BAAA;EACA,qCuBlTS;AjE885Bb;A0Cxp5BE;;EAEE,yBuCvTI;AjFi95BR;A0Cxp5BE;;EAEE,qCmCxTkB;A7Ek95BtB;A0Ctp5BE;;EAEE,UAAA;A1Cwp5BJ;A0Cpp5BE;;EAEE,yBuCvUI;AjF695BR;A0Cpp5BE;;EAEE,qCmCxUkB;A7E895BtB;A0Clp5BE;;EAEE,yBuCjVI;AjFq+5BR;A0Clp5BE;;EAEE,qCmClVkB;A7Es+5BtB;A0C5o5BI;EACE,mByF/OmB;AnI635BzB;A0C1o5BI;EACE,ayF3PuB;EzF4PvB,eyFrPmB;AnIi45BzB;A0Cxo5BI;;EAEE,oByFjP2B;EzFkP3B,iByF/O8B;EzFgP9B,yBmC5WkB;A7Es/5BxB;A0Cto5BI;;EAEE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,OAAA;EACA,UAAA;EAEA,WyFxQiC;EzF0QjC,qC+C9Xc;E/C+Xd,ayFrRuB;EzFsRvB,uBkC7XC;ElC+XD,qBsClYY;EtCmYZ,gCyF5Q4B;AnIi55BlC;A0Cho5BI;;EAEE,qEyFxSuB;EzFySvB,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,UAAA;EAEA,YAAA;EACA,sFyF7SJ;EzF8SI,ayFzSwB;EzF0SxB,cyF1SwB;EzF2SxB,ayFvS0B;EzFwS1B,OAAA;EACA,eAAA;EAEA,qBsCxZY;EtCyZZ,0ByF3S8B;AnI265BpC;A0C5n5BI;;EAEE,qC+C7Z0B;E/C8Z1B,YAAA;A1C8n5BN;A0C1n5BI;;EAEE,yBmCnae;A7E+h6BrB;A0C1n5BI;;EAEE,+B+Cxa0B;AzFoi6BhC;A0Cxn5BI;;EAEE,qCAAA;A1C0n5BN;A0Cxn5BI;;EAEE,oCAAA;A1C0n5BN;A0Cxn5BI;;EAEE,UyF/T4B;AnIy75BlC;A0Ctn5BI;;EAEE,qCAAA;A1Cwn5BN;A0Ctn5BI;;EAEE,kCAAA;A1Cwn5BN;A0C9m5BI;EACE,kByF/TwB;AnI+65B9B;A0C5m5BI;EACE,ayFrUuB;EzFsUvB,cyFrUwB;AnIm75B9B;A0C1m5BI;;EAEE,kByF3UwB;EzF4UxB,oByFtT2B;EzFuT3B,0BuB1dO;AjEsk6Bb;A0C1m5BI;EACE,mByFxTyB;AnIo65B/B;A0Cxm5BI;;EAEE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EAEA,MyF7UiC;EzF+UjC,+B+C7ec;E/C8ed,gByFjV4B;EzFkV5B,ayFlWuB;EzFmWvB,cyFlWwB;EzFmWxB,qBsCjfY;AhFyl6BlB;A0Cpm5BI;;EAEE,qEyFrZuB;EzFsZvB,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,UAAA;EAEA,YAAA;EACA,sFyF1ZJ;EzF2ZI,ayFjXwB;EzFkXxB,cyFlXwB;EzFmXxB,MyF5W0B;EzF6W1B,OAAA;EAEA,qBsCpgBY;EtCqgBZ,gDyF9WJ;AnIk95BF;A0Cjm5BI;;EAEE,cyF3WuB;EzF4WvB,sFyFvaJ;AnI0g6BF;A0C/l5BI;;EAEE,qC+C/gB0B;E/CghB1B,YAAA;A1Cim5BN;A0C7l5BI;;EAEE,qC+CthB0B;E/CuhB1B,YAAA;A1C+l5BN;A0C3l5BI;;EAEE,qCAAA;A1C6l5BN;A0C3l5BI;;EAEE,oCAAA;A1C6l5BN;A0C3l5BI;;EAEE,ayFvYsB;EzFwYtB,sFyFpcJ;AnIii6BF;A0Cxl5BI;;EAEE,qCAAA;A1C0l5BN;A0Cxl5BI;;EAEE,8EAAA;A1C0l5BN;A0C5k5BI;;EAEE,0BAAA;A1C8k5BN;A0C1k5BM;EACE,ayF3bqB;AnIug6B7B;A0Cvk5BM;EACE,ayFpeqB;AnI6i6B7B;A0Chk5BI;;EAEE,0CAAA;A1Ckk5BN;A0C9j5BI;;EAEE,oCAAA;A1Cgk5BN;A0C9j5BI;;EAEE,mC2C9kByB;ArF8o6B/B;A0C3j5BM;;EAEE,+BmC/lByB;A7E4p6BjC;A0Czj5BM;;EAEE,qDAAA;A1C2j5BR;A0Cvj5BM;;EAEE,+CAAA;A1Cyj5BR;A0Crj5BM;;EAEE,oCAAA;A1Cuj5BR;A0Crj5BM;;EAEE,qDAAA;A1Cuj5BR;A0Cnj5BM;;EAEE,oCAAA;A1Cqj5BR;A0Cnj5BM;;EAEE,qDAAA;A1Cqj5BR;A0C/i5BM;;EAEE,qDAAA;A1Cij5BR;A0C7i5BM;;EAEE,yCAAA;A1C+i5BR;A0C3i5BM;;EAEE,oCAAA;A1C6i5BR;A0C3i5BM;;EAEE,oCAAA;A1C6i5BR;A0Czi5BM;;EAEE,oCAAA;A1C2i5BR;A0Czi5BM;;EAEE,8EAAA;A1C2i5BR;A0C3h5BM;EACE,yBALK;A1Cki5Bb;A0C9h5BM;EACE,yBALK;A1Cqi5Bb;A0Cji5BM;EACE,yBALK;A1Cwi5Bb;A0Cpi5BM;EACE,yBALK;A1C2i5Bb;A0C/h5BY;;;;;;;;EAKE,8BAAA;EACA,sBAAA;A1Coi5Bd;A0Chi5BY;;;;EAGE,8BAAA;EACA,sBAAA;A1Cmi5Bd;A0Cji5BY;;;;EAGE,8BAAA;EACA,sBAAA;EACA,oBA/BK;A1Cmk5BnB;A0Cjk5BM;EACE,yBALK;A1Cwk5Bb;A0C5j5BY;;;;;;;;EAKE,8BAAA;EACA,sBAAA;A1Cik5Bd;A0C7j5BY;;;;EAGE,8BAAA;EACA,sBAAA;A1Cgk5Bd;A0C9j5BY;;;;EAGE,8BAAA;EACA,sBAAA;EACA,oBA/BK;A1Cgm5BnB;A0C9l5BM;EACE,yBALK;A1Cqm5Bb;A0Czl5BY;;;;;;;;EAKE,8BAAA;EACA,sBAAA;A1C8l5Bd;A0C1l5BY;;;;EAGE,8BAAA;EACA,sBAAA;A1C6l5Bd;A0C3l5BY;;;;EAGE,8BAAA;EACA,sBAAA;EACA,oBA/BK;A1C6n5BnB;A0C3n5BM;EACE,yBALK;A1Cko5Bb;A0Ctn5BY;;;;;;;;EAKE,8BAAA;EACA,sBAAA;A1C2n5Bd;A0Cvn5BY;;;;EAGE,8BAAA;EACA,sBAAA;A1C0n5Bd;A0Cxn5BY;;;;EAGE,8BAAA;EACA,sBAAA;EACA,oBA/BK;A1C0p5BnB;A2Cr16BE;EACE,uBAAA;EACA,gEACE;A3Cs16BN;A2Cj16BE;;EAEE,uBAAA;A3Cm16BJ;A2C/06BE;;EAEE,gBAAA;A3Ci16BJ;A2C706BE;;EAEE,eAAA;EACA,gBAAA;A3C+06BJ;A4Ch26BE;EACE,kBwFLuB;ApIu26B3B;A4C/16BE;EACE,aAAA;EACA,kBwFTc;ExFUd,iBAAA;EACA,kBAAA;EAEA,WAAA;EACA,YAAA;EAEA,kBwFJgB;ExFKhB,sBwFJoB;ExFKpB,YwFba;ExFeb,qCwFlBsB;ExFmBtB,UwFIoB;ExFHpB,cwFnBiB;ExFqBjB,yBAAA;EACA,wBwFlBc;ExFmBd,wCwFjBF;ExFmBE,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA;EACA,oBAAA;EACA,awFvBa;ApIk36BjB;A4Cv16BE;EACE,iBAAA;EACA,cqCxCI;AjFi46BR;A4Cp16BE;EACE,iCAAA;A5Cs16BJ;A4Cj16BI;EACE,oC6BxDsB;AzE246B5B;A4Cj16BI;EACE,qC6B1DsB;AzE646B5B;A4Cj16BI;EACE,qC6B5D+B;AzE+46BrC;A4Cj16BI;EACE,qC6B9D4B;AzEi56BlC;A4C106BE;;EAEE,gBwFzDc;ApIq46BlB;A4Cx06BE;;;EAGE,aAAA;EACA,UwFpDqB;ApI836BzB;A4Ct06BE;EACE,mBAAA;EACA,oBAAA;A5Cw06BJ;A4C1z6BE;;;EAGE,cAAA;A5C4z6BJ;A4Crz6BE;EACE,2BAAA;A5Cuz6BJ;A4Crz6BE;EACE,yBAAA;A5Cuz6BJ;A4Chz6BE;EACE,ewFxFmB;ExFyFnB,mBwF1FqB;ExF2FrB,mBwFxHiB;ExFyHjB,+BAAA;A5Ckz6BJ;A4C/y6BE;;EAEE,gBAAA;A5Ciz6BJ;A4C9y6BE;EACE,eAAA;A5Cgz6BJ;A4Cxy6BI;EACE,ewF9HwB;ExF+HxB,6BwF7HsB;ApIu66B5B;A4Cxy6BI;EACE,gCwFjIsB;ApI266B5B;A4Cty6BI;EACE,oCwFnI4B;ApI266BlC;A4Cty6BI;EACE,0CwFrIqC;ApI666B3C;A4Chy6BE;EACE,mBAAA;A5Cky6BJ;A4Chy6BE;EACE,sBAAA;A5Cky6BJ;A4Czx6BI;EACE,qCwF5H2B;ApIu56BjC;A4Czx6BI;EACE,qCwFhI0B;ApI256BhC;A4Czx6BI;EACE,qCwFpI+B;ApI+56BrC;A4Clx6BI;EACE,2CwFzJ6B;ApI666BnC;A4Clx6BI;;EAEE,cqCzMO;AjF696Bb;A4C7w6BI;EACE,2CwFrJoC;ApIo66B1C;A4C7w6BI;EACE,2CwFzJmC;ApIw66BzC;A4C7w6BI;EACE,2CwF7JwC;ApI466B9C;A4Ctw6BE;EACE,cAAA;EACA,gBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,kCwFtLmC;ApI876BvC;A4Ctw6BE;EACE,iBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qCwFxOsB;ExFyOtB,UwF/LoB;ApIu86BxB;A4Crw6BE;EACE,wCwFhM4C;ApIu86BhD;A4Crw6BE;EACE,2CwF1M+B;ApIi96BnC;A4C9v6BI;;;EAGE,YAAA;A5Cgw6BN;A4C9v6BI;EACE,oBAAA;EACA,SAAA;A5Cgw6BN;A4C9v6BI;EACE,mBAAA;EACA,2BAAA;EACA,iDAAA;A5Cgw6BN;A4C7v6BI;EACI,uCAAA;EACA,wCAAA;A5C+v6BR;A4C7v6BI;EACI,2BAAA;A5C+v6BR;A4C7v6BI;EACI,oCAAA;EACA,qCAAA;A5C+v6BR;A4C5v6BI;EACE,8BAAA;A5C8v6BN;A4C5v6BI;EACE,gCAAA;A5C8v6BN;A4C5v6BI;EACE,+BAAA;A5C8v6BN;A4C5v6BI;EACE,iCAAA;A5C8v6BN;A4C5v6BI;EACE,4BAAA;A5C8v6BN;A4C5v6BI;EACE;IACE,UAAA;IACA,2BAAA;IACA,iDAAA;E5C8v6BN;E4C5v6BI;IACE,UAAA;IACA,2BAAA;IACA,iDAAA;E5C8v6BN;AACF;A4C5v6BI;EACE;IACE,UAAA;IACA,2BAAA;IACA,iDAAA;E5C8v6BN;E4C5v6BI;IACE,UAAA;IACA,2BAAA;IACA,iDAAA;E5C8v6BN;AACF;A4C5v6BI;EACE;IACE,UAAA;IACA,2BAAA;IACA,iDAAA;E5C8v6BN;E4C5v6BI;IACE,UAAA;IACA,2BAAA;IACA,iDAAA;E5C8v6BN;AACF;A4C5v6BI;EACE;IACE,UAAA;IACA,2BAAA;IACA,iDAAA;E5C8v6BN;E4C5v6BI;IACE,UAAA;IACA,2BAAA;IACA,iDAAA;E5C8v6BN;AACF;A4C5v6BI;EACE;IACE,2BAAA;IACA,iDAAA;E5C8v6BN;E4C5v6BI;IACE,wCAAA;E5C8v6BN;E4C5v6BI;IACE,wCAAA;E5C8v6BN;AACF;A6C1l7BE;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,gBAAA;EACA,iDwFRkB;ExFSlB,iBAAA;EAEA,6CAAA;A7C2l7BJ;A6Chl7BE;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EAEA,SwFdmB;ExFenB,YwFdoB;ExFepB,mBwFjBuB;ExFmBvB,ckCXc;ElCYd,iBAAA;EACA,gBwFjBuB;ExFmBvB,8CwFnCqB;ExFoCrB,wCwFhBmB;ExFiBnB,8B+BvCG;E/BwCH,6BwFfuB;ExFgBvB,WwFdoB;ExFepB,+BAAA;A7C+k7BJ;A6C5k7BE;EACE,mBAAA;A7C8k7BJ;A6Ctk7BE;;EAEE,wBAAA;A7Cwk7BJ;A6Cjk7BE;EACE,kBAAA;EACA,WAAA;EACA,yB+BOW;E/BNX,iBwF3DmB;ArI8n7BvB;A6Cjk7BE;EACE,WAAA;EACA,YwFoBuB;ExFnBvB,mBwFoBwB;ArI+i7B5B;A6Cjk7BE;EACE,iBwFe0B;ArIoj7B9B;A6C3j7BE;EACE,qBAAA;EACA,gBwF1EuB;ArIuo7B3B;A6Ctj7BE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,YwF3DmB;ExF4DnB,YwF3DmB;ExF4DnB,gBwF9DuB;ExFgEvB,gBwF7DoB;ExF8DpB,gBwFxDwB;ExFyDxB,ekC1FK;ElC2FL,0BoB1GS;EpB4GT,mDAAA;EACA,oBwF3D2B;ExF4D3B,mBiBnGK;EjBoGL,gBwF5DuB;ExF6DvB,2BAAA;A7Csj7BJ;A6Cpj7BE;EACE,mBAAA;A7Csj7BJ;A6C/i7BE;;EAEE,uBAAA;EACA,0BAAA;EACA,2BAAA;A7Cij7BJ;A6C/i7BE;;EAEE,sBAAA;EACA,yBAAA;EACA,4BAAA;A7Cij7BJ;A6C9i7BE;;;;EAIE,ewF1F+B;ArI0o7BnC;A6Cxi7BE;EACE,sBwFjF0B;ExFkF1B,0BwFjF2B;ExFkF3B,iBiB5IG;EjB6IH,yBwFrFkC;ArI+n7BtC;A6Cxi7BE;EACE,0BgC7Jc;EhC8Jd,yB+BhFW;A5E0n7Bf;A6Cxi7BE;EACE,2CwFpF2B;ExFqF3B,SAAA;EACA,ewFzF2B;ArImo7B/B;A6Cxi7BE;EACE,gBAAA;A7C0i7BJ;A6Cvi7BE;EACE,WAAA;EACA,aAAA;EACA,uCwF5FyB;ExF6FzB,gBwF5F4B;ArIqo7BhC;A6Cvi7BE;EACE,aAAA;A7Cyi7BJ;A6Cvi7BE;EACE,kBwF/F0B;ArIwo7B9B;A6Cvi7BE;;;EAGE,kBwFtGmC;ExFuGnC,qBwFvGmC;ArIgp7BvC;A6Cli7BE;;EAEE,YwF7F8B;ExF8F9B,iBwF7F+B;ExF8F/B,yBgClMe;A7Esu7BnB;A6C7h7BE;EACE,wCwFlF8B;ExFmF9B,mBiB/LK;A9D8t7BT;A6C7h7BE;EACE,yBgC5MoB;A7E2u7BxB;A6Cxh7BE;EACE,MwF/JoB;ExFgKpB,UwF/JqB;ExFgKrB,WwF/JsB;ExFgKtB,+BAAA;EACA,yCAAA;EACA,sBAAA;A7C0h7BJ;A6Cth7BE;EACE,aAAA;A7Cwh7BJ;A6Chh7BE;;;;;EAKE,ewF1M+B;ArI4t7BnC;A6Chh7BE;;;;;EAKE,ewFlM+B;ArIot7BnC;A6C/g7BE;;;;;;;;;;EAUE,cAAA;EACA,WwFzK0B;ExF0K1B,6BkCtPG;A/Euw7BP;A6C1g7BE;;;;EAIE,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBwF3LkC;ExF4LlC,qBwF5LkC;ExF6LlC,ewF9L6B;ArI0s7BjC;A6C9/6BE;;EAEE,aAAA;A7Cgg7BJ;A6C5/6BE;EACE,iBAAA;A7C8/6BJ;A6C1/6BE;;;EAGE,UAAA;EACA,QAAA;A7C4/6BJ;A6Cp/6BE;EACE,eAAA;A7Cs/6BJ;A6C9+6BE;EACE,SAAA;A7Cg/6BJ;A6C9+6BE;EACE,eAAA;A7Cg/6BJ;A6Cl+6BI;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,wBAAA;EAEA,ewFlPyB;ExFmPzB,0BwF/O0B;ExFiP1B,mBoC5VE;EpC6VF,qBwF/OuB;ExFgPvB,gDwF9OuB;ExF+OvB,0BoBhWO;EpBiWP,gBwF3N0B;ExF4N1B,wCwF1NsB;ExF2NtB,8B+BhWC;E/BiWD,iDwFlWgB;ArIo07BtB;A6Ch+6BI;;EAEE,WwFrPuB;ArIut7B7B;A6C/96BI;EACE,YwF7OmB;ExF8OnB,cwFhPoB;ExFiPpB,wCwFlPmB;ExFmPnB,mBwFjPuB;ArIkt7B7B;A6C/96BI;;;EAGE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,2BuD3Wc;EvD4Wd,mB+B9SS;E/B+ST,U+B5SS;E/B6ST,UwF/O4B;ExFgP5B,uBwF9O2B;ExF+O3B,uBwF9O4B;ExF+O5B,YwFnP4B;ExFoP5B,6BwF/O+B;ArIgt7BrC;A6C796BI;EACE,YAAA;A7C+96BN;A6C396BI;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,2BwFpXoB;ExFqXpB,uBwFrXoB;ExFuXpB,kDwFlQkC;ExFmQlC,8CwFhZmB;ExFiZnB,6BwF1XqB;ArIs17B3B;A6C196BI;;EAEE,aAAA;A7C496BN;A6Cr96BI;EACE,wCwF3S4B;ArIkw7BlC;A6Cp96BI;EACE;IACE,0BAAA;E7Cs96BN;E6Cp96BI;IACE,0BAAA;E7Cs96BN;E6Cp96BI;IACE,0BwFhQoC;ErIst7B1C;E6Cp96BI;IACE,2BAAA;E7Cs96BN;E6Cp96BI;IACE,2BAAA;E7Cs96BN;AACF;A6Cp96BI;EACE;IACE,0BAAA;E7Cs96BN;E6Cp96BI;IACE,0BAAA;E7Cs96BN;E6Cp96BI;IACE,2BwFhRoC;ErIsu7B1C;E6Cp96BI;IACE,2BAAA;E7Cs96BN;E6Cp96BI;IACE,2BAAA;E7Cs96BN;AACF;A6Cp96BI;EACE;IACE,0BAAA;E7Cs96BN;E6Cp96BI;IACE,2BAAA;E7Cs96BN;E6Cp96BI;IACE,2BwFhSsC;ErIsv7B5C;E6Cp96BI;IACE,2BAAA;E7Cs96BN;E6Cp96BI;IACE,2BAAA;E7Cs96BN;AACF;A6Cp96BI;EACE;IACE,2BAAA;E7Cs96BN;E6Cp96BI;IACE,2BAAA;E7Cs96BN;E6Cp96BI;IACE,2BwF9SwC;ErIow7B9C;E6Cp96BI;IACE,2BAAA;E7Cs96BN;E6Cp96BI;IACE,2BAAA;E7Cs96BN;AACF;A6Cl96BI;EACE,6BwFpX4B;ExFqX5B,mDAAA;EACA,mBAAA;EACA,iBAAA;A7Co96BN;A6Ch96BI;EACE,aAAA;A7Ck96BN;A6C986BI;EACE,oCuCjfkB;EvCkflB,gBwFlUgC;ArIkx7BtC;A6C586BI;EACE,qBuDxe4B;EvDye5B,8CwF3fmB;ArIy87BzB;A6C586BI;EACE,qBuD5e4B;EvD6e5B,8CwF/fmB;ArI687BzB;A6C186BI;EACE,qBuDlf4B;EvDmf5B,gBwF9UgC;ArI0x7BtC;A6C186BI;EACE,qBuDtf4B;EvDuf5B,8CwFzgBmB;ArIq97BzB;A6Cx86BI;EACE,mBiBxgBG;EjBygBH,yBgClhBe;A7E497BrB;A6Ct86BI;EACE,qBuDlgB4B;EvDmgB5B,8CwFrhBmB;ArI697BzB;A6Ct86BI;EACE,qBuDtgB4B;EvDugB5B,8CwFzhBmB;ArIi+7BzB;A6Cp86BI;;EAEE,WwFvVoC;ExFwVpC,UAAA;A7Cs86BN;A6Cl86BI;EACE,uCAAA;EACA,wCAAA;A7Co86BN;A6Ch86BI;EACE,yCAAA;EACA,2BAAA;A7Ck86BN;A6Ch86BI;EACE,uBAAA;EACA,2BAAA;A7Ck86BN;A6Cx76BI;EACE,awF/WsB;ArIyy7B5B;A6Ct76BI;EACE,uCAAA;EACA,uBAAA;EACA,2BAAA;EACA,YAAA;EACA,MAAA;EACA,SwFviByB;ExFwiBzB,WAAA;EACA,aAAA;EACA,mDAAA;EACA,gBAAA;A7Cw76BN;A6Cp76BI;EACE,kBAAA;EACA,UAAA;A7Cs76BN;A6Cp76BI;EACE,YAAA;EACA,kBAAA;EACA,SwFtjByB;ExFujBzB,UAAA;A7Cs76BN;A6Cl76BI;EACE,2BuDllBc;EvDmlBd,gDwFtYoC;ArI0z7B1C;A6Ch76BI;EACE,2BuDxlBc;EvDylBd,gDwF5YoC;ExF6YpC,aAAA;EACA,gBAAA;A7Ck76BN;A6C966BI;;EAEE,YAAA;A7Cg76BN;A6C966BI;;EAEE,oBAAA;A7Cg76BN;A6C566BI;;EAEE,akD3nBa;A/Fyi8BnB;A6C566BI;EACE,oDAAA;A7C866BN;A6C166BI;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iCAAA;A7C466BN;A6C166BI;EACE;IACE,0BwF1doC;ErIs47B1C;AACF;A6C166BI;EACE;IACE,2BwF9doC;ErI047B1C;AACF;A6C166BI;EACE;IACE,2BwFlesC;ErI847B5C;AACF;A6C166BI;EACE;IACE,2BwFpewC;ErIg57B9C;AACF;A6Cr66BI;EACE,eAAA;EACA,yB+BplBS;E/BqlBT,uBwFnhB2B;ExFohB3B,uBwFnhB4B;ExFohB5B,UAAA;EACA,mB+BzlBS;E/B0lBT,kBAAA;EACA,YAAA;EACA,UwF3hB4B;ArIk87BlC;A6Cp66BI;;EAEE,mBAAA;A7Cs66BN;A6Cn66BI;;;;EAIE,aAAA;A7Cq66BN;A6C356BI;EACE,2DwF/cgC;ArI427BtC;A6C356BI;EACE,YAAA;A7C656BN;A6Cz56BI;;EAEE,YAAA;A7C256BN;A6Cv56BI;EACE,qBAAA;EACA,mBAAA;EACA,ckCrrBY;ElCsrBZ,sCwFncmB;ExFocnB,yDwF3ckB;ExF4clB,kDwFzcsB;ArIk27B5B;A6Cr56BI;EACE,UwF1doC;ExF2dpC,WwF1dqC;ArIi37B3C;A6Cn56BI;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,sDwFzeqC;ExF0erC,2B+B/oBS;A5Eoi8Bf;A6Cn56BI;EACE,sCAAA;A7Cq56BN;A6Cn56BI;EACE,aAAA;A7Cq56BN;A6Cn56BI;EACE,6BkC7tBC;A/Ekn8BP;A6Cn56BI;EACE,8BwFlpBkC;ArIui8BxC;A6Cn56BI;EACE,sEwFhe8B;ExFie9B,sBwFlewB;ArIu37B9B;A6C546BM;EACE,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;EACA,sDwFzgBmC;ExF0gBnC,2B+B/qBO;A5E6j8Bf;A6C346BM;EACE,aAAA;A7C646BR;A6Cz46BM;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,sDwFthBmC;ExFuhBnC,YwFphByC;ExFqhBzC,2B+B7rBO;A5Ewk8Bf;A6Cj46BI;EACE,eAAA;EACA,qBAAA;EACA,cwFvjBuB;ArI077B7B;A6Cj46BI;EACE,yCwF3jBwB;ExF4jBxB,wBAAA;A7Cm46BN;A6Cj46BI;EACE,iBiBxxBC;A9D2p8BP;A6Cj46BI;EACE,YAAA;EACA,0B+BnuBQ;E/BouBR,8B+BpyBC;A5Euq8BP;A6Cr36BE;EACE,uBwFrhB8B;ExFshB9B,iBiB7yBG;EjB8yBH,0BgCpzBkB;EhCqzBlB,gBwFvhB8B;ExFwhB9B,WwF1hB2B;ArIi57B/B;A6C926BE;EACE,+B4Cr0BgB;E5Cs0BhB,0BgCj0BkB;EhCk0BlB,WwFhjBuB;ArIg67B3B;A6Cz26BE;EACE,sBAAA;A7C226BJ;A6Cz26BE;EACE,wCAAA;A7C226BJ;A6Cz26BE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CiCx1BY;EjCy1BZ,qBkC/zBW;ElCg0BX,sBkCh0BW;ElCk0BX,qBmC91Bc;EnC+1Bd,sCAAA;A7Cy26BJ;A6Cv26BE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EAEA,2CiCt2BY;EjCu2BZ,qBkC70BW;ElC80BX,sBkC90BW;ElCg1BX,sCAAA;EACA,2BAAA;EACA,qBmC92Bc;AhFqt8BlB;A6Cl26BE;;EAEE,aAAA;A7Co26BJ;A6C716BE;;EAEE,yCuDp3BsB;ApGmt8B1B;A6C716BE;;EAEE,yCuDv3B4B;ApGst8BhC;A6Cz16BE;EACE,gBAAA;A7C216BJ;A6Cv16BE;EACE,cAAA;EACA,kBAAA;EACA,WwFlnBuB;ArI287B3B;A6Cv16BE;EACE,kBAAA;EACA,sBAAA;A7Cy16BJ;A6Cv16BE;EACE,qBAAA;EACA,sBAAA;A7Cy16BJ;A6Cj16BE;;EAEE,+B4Cp6BuB;E5Cq6BvB,0BgC95BkB;A7Eiv8BtB;A6C106BE;EACE,kBAAA;A7C406BJ;A6C106BE;EACE,wBAAA;A7C406BJ;A6Cp06BE;;;EAGE,cyD17BkB;AtGgw8BtB;A6Cn06BE;EACE,mBwDv7BwB;ExDw7BxB,qBuC/7BoB;ApFow8BxB;A6Cn06BE;EACE,qBuCl8BoB;ApFuw8BxB;A6Cl06BE;;EAEE,qBuCv8BoB;ApF2w8BxB;A6Cl06BE;EACE,cyD18BkB;AtG8w8BtB;A6Cl06BE;EACE,qBuC78BoB;ApFix8BxB;A6Ch06BE;EACE,yBwFnqBmC;ArIq+7BvC;A6C9z6BE;EACE,yBwFvqBoC;ArIu+7BxC;A6Cxz6BE;EACE,YwF7qB8B;ExF8qB9B,6BAAA;A7C0z6BJ;A6Cxz6BE;EACE,UwFhrBqC;ArI0+7BzC;A6Cjz6BE;;EAEE,eAAA;EACA,oBAAA;EACA,akDp/Be;A/Fuy8BnB;A6Cty6BE;EACE,OAAA;A7Cwy6BJ;A6Cny6BE;;EAEE,qBAAA;EACA,sBAAA;EACA,yCAAA;A7Cqy6BJ;A6Cjy6BE;EACE,qBAAA;EACA,mBAAA;A7Cmy6BJ;A6Chy6BE;;EAEE,UAAA;EACA,WAAA;EACA,+BAAA;EACA,yCAAA;A7Cky6BJ;A6C/x6BE;;EAEE,WAAA;EACA,WwFlsB4B;ExFmsB5B,iBwFlsB6B;ArIm+7BjC;A6C/x6BE;;EAEE,WAAA;EACA,WwFxsB4B;ExFysB5B,iBwFxsB6B;ArIy+7BjC;A6C/x6BE;;EAEE,gBwF18B0B;ExF28B1B,eAAA;A7Ciy6BJ;A6Cxx6BE;EACE,SAAA;EACA,YAAA;EACA,yCwFnuB8B;ExFouB9B,kDwFluBiC;ArI4/7BrC;A6Ctx6BE;EACE,oBAAA;EACA,oBAAA;A7Cwx6BJ;A6Cpx6BE;;EAEE,6DAAA;A7Csx6BJ;A6Cpx6BE;EACE,kDAAA;A7Csx6BJ;A6Clx6BE;EACE,gCAAA;EACA,iCAAA;EACA,4CwFzvBwC;ArI6g8B5C;A6Clx6BE;EACE,yCwF1vByC;ArI8g8B7C;A6Chx6BE;EACE,6DAAA;A7Ckx6BJ;A6C9w6BE;EACE,yCwFnwB2C;ExFowB3C,6DAAA;A7Cgx6BJ;A6C5w6BE;EACE,yCwFxwBgD;ArIsh8BpD;A6C5w6BE;EACE,4CwF1wBqD;ArIwh8BzD;A6Ctw6BE;;EAEE,kBAAA;EACA,gBAAA;A7Cww6BJ;A6Crw6BE;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iCAAA;EACA,0BAAA;EACA,sBAAA;A7Cuw6BJ;A6Cpw6BE;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,2BAAA;EACA,oBAAA;EACA,0BAAA;EACA,sBAAA;EACA,4CwFxmCmB;ArI828BvB;A6Cpw6BE;;EAEE,gBwF30BkC;ArIil8BtC;A6Cpw6BE;;EAEE,gBAAA;A7Csw6BJ;A6Cpw6BE;;EAEE,cAAA;A7Csw6BJ;A6Clw6BE;EACE;;IAEE,4BAAA;E7Cow6BJ;AACF;A6Clw6BE;EACE;;IAEE,2BwFr1BsC;ErIyl8B1C;AACF;A6Clw6BE;EACE;;IAEE,2BwF11BsC;ErI8l8B1C;AACF;A6Clw6BE;EACE;;IAEE,2BwF/1BwC;ErImm8B5C;AACF;A6Clw6BE;EACE;;IAEE,2BwFl2B0C;ErIsm8B9C;AACF;A6C7v6BI;EACE,qBAAA;EACA,UAAA;A7C+v6BN;A6C7v6BI;EACE,qBAAA;EACA,UAAA;A7C+v6BN;A6C7v6BI;EACE,qBAAA;EACA,UAAA;A7C+v6BN;A6C7v6BI;EACE,qBAAA;EACA,UAAA;A7C+v6BN;A6Cpv6BI;;EAEE,aAAA;A7Csv6BN;A6Cpv6BI;EACE,kBAAA;EACA,iDAAA;EACA,sCAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,6BwFx3BuB;ExFy3BvB,wBAAA;A7Csv6BN;A6Cnv6BI;;EAEE,uCAAA;EACA,wCAAA;A7Cqv6BN;A6Clv6BI;;EAEE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;A7Cov6BN;A6Clv6BI;;EAEE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,UAAA;A7Cov6BN;A6Clv6BI;EACE,aAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;A7Cov6BN;A6Chv6BI;EACE,cAAA;A7Ckv6BN;A6C9u6BI;;EAEE,kBAAA;EACA,gBAAA;A7Cgv6BN;A6Cxu6BE;EACE,cAAA;EACA,sBAAA;EACA,YAAA;A7C0u6BJ;A6Cxu6BE;EACE,YAAA;A7C0u6BJ;A6Clu6BE;EACE,OAAA;EACA,WAAA;EACA,6FAAA;EACA,yCAAA;A7Cou6BJ;A6Clu6BE;EACE,yCAAA;A7Cou6BJ;A6Clu6BE;EACE,iBwFh8B8B;ArIoq8BlC;A6Clu6BE;EACE,oBwFn8B8B;ArIuq8BlC;A6C5t6BI;EACE,SAAA;EACA,2BkCvyCC;ElCwyCD,8B+BjzCC;A5E+g9BP;A6C3t6BI;EACE,YwF58B2B;ExF68B3B,SAAA;EACA,qBAAA;EAEA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EAEA,Y+B5vCQ;E/B6vCR,a+B7vCQ;E/B8vCR,gDwFp9B+B;ExFq9B/B,mBoCr0CE;EpCs0CF,UwFv9B4B;ArIkr8BlC;A6Cvt6BI;EACE,SAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;A7Cyt6BN;A6Cvt6BI;EACE,SAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;A7Cyt6BN;A6Cvt6BI;EACE,YwF9+B2B;ExF++B3B,SwF9+BuC;ExF++BvC,WAAA;EACA,SAAA;EACA,wBAAA;A7Cyt6BN;A6Ctt6BI;EACE,SAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;A7Cwt6BN;A6Ctt6BI;;EAEE,YwF9/B2B;ExF+/B3B,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,wBAAA;A7Cwt6BN;A6Cpt6BI;EACE,MAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;A7Cst6BN;A6Cpt6BI;EACE,QAAA;EACA,awF9gC2B;ExF+gC3B,eAAA;EACA,yBAAA;A7Cst6BN;A6Cpt6BI;EACE,qBAAA;EACA,sBAAA;EACA,iBAAA;A7Cst6BN;A6Cpt6BI;EACE,QAAA;EACA,UAAA;EACA,cwF1hC2B;ExF2hC3B,eAAA;EACA,yBAAA;A7Cst6BN;A6Cjt6BI;EACE,MAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;A7Cmt6BN;A6Cjt6BI;EACE,QAAA;EACA,UAAA;EACA,cwF1iC2B;ExF2iC3B,eAAA;EACA,yBAAA;A7Cmt6BN;A6C/s6BI;EACE,SAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;A7Cit6BN;A6C/s6BI;EACE,SAAA;EACA,ewFzjC2B;ExF0jC3B,WAAA;EACA,SAAA;EACA,0BAAA;A7Cit6BN;A6C9s6BI;EACE,oBAAA;EACA,oBAAA;A7Cgt6BN;A6C5s6BI;EACE,OAAA;EACA,WAAA;A7C8s6BN;A6C5s6BI;EACE,SwFzkCuC;ExF0kCvC,WAAA;A7C8s6BN;A6C1s6BI;EACE,QAAA;EACA,UAAA;A7C4s6BN;A6C1s6BI;EACE,UAAA;EACA,UwFplCuC;ArIgy8B7C;A6Cxs6BI;;EAEE,oBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8B+Bv8CC;A5Eip9BP;A6Cxs6BI;;EAEE,oBAAA;EACA,uBAAA;EACA,8CwFxlCsC;ExFylCtC,mBAAA;A7C0s6BN;A6Cts6BI;EACE,oBAAA;EACA,oBAAA;EACA,iBAAA;A7Cws6BN;A6Cts6BI;EACE,oBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gDwF7mC+B;ArIqz8BrC;A6Cns6BI;EACE,oBAAA;EACA,oBAAA;EACA,iBAAA;A7Cqs6BN;A6Cns6BI;EACE,oBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gDwF3nC+B;ArIg08BrC;A6C3r6BE;EACE,0BkC3+CG;A/Ewq9BP;A6C3r6BE;EACE,0BkC7+CG;A/E0q9BP;A6C3r6BE;EACE,0BkC/+CI;A/E4q9BR;A6C3r6BE;EACE,ekCj/CK;A/E8q9BT;A6C3r6BE;EACE,0BkCn/CI;A/Egr9BR;A6C3r6BE;EACE,0BkCr/CE;A/Ekr9BN;A6C3r6BE;EACE,0BkCv/CG;A/Eor9BP;A6C3r6BE;EACE,0BkCz/CM;A/Esr9BV;A6Czr6BE;EACE,0BkCrgDG;A/Egs9BP;A6Czr6BE;EACE,0BkCvgDG;A/Eks9BP;A6Czr6BE;EACE,0BkCzgDI;A/Eos9BR;A6Czr6BE;EACE,ekC3gDK;A/Ess9BT;A6Czr6BE;EACE,0BkC7gDI;A/Ews9BR;A6Czr6BE;EACE,0BkC/gDE;A/E0s9BN;A6Czr6BE;EACE,0BkCjhDG;A/E4s9BP;A6Czr6BE;EACE,0BkCnhDM;A/E8s9BV;A6Clr6BI;EACE,mBsCviDE;EtCwiDF,gBwF/qC8B;ExFgrC9B,2CwFjrC0B;ArIq28BhC;A6Cjr6BI;EACE,+BgC9iDsB;A7Eiu9B5B;A6Chr6BI;EACE,uBwFhrCqC;ExFirCrC,+BgCnjDsB;EhCojDtB,gBwFhrCqC;ArIk28B3C;A6C/q6BI;EACE,qC4C5jDc;E5C6jDd,+BgCzjDsB;A7E0u9B5B;A6C9q6BI;;EAEE,qC4CjkDqB;E5CkkDrB,+BgC/jDsB;A7E+u9B5B;A6C7q6BI;EACE,coC1kDE;AjFyv9BR;A6C5q6BI;;EAEE,+BgCtkD2B;A7Eov9BjC;A6C3q6BI;EACE,+CwFhsCkC;ArI628BxC;A6C1q6BI;EACE,YAAA;EACA,+CwFxtC0B;ArIo48BhC;A6Czq6BI;;EAEE,+BgCplD2B;A7E+v9BjC;A6Czq6BI;;EAEE,+BgCzlDsB;A7Eow9B5B;A6Cvq6BM;;EAEE,awFnsCiD;ArI428BzD;A6Cvq6BM;EACE,0CAAA;A7Cyq6BR;A6Cnq6BM;EACE,2CwF1tC6B;ExF2tC7B,mBsC1mDA;EtC2mDA,+BgC5mDoB;A7Eix9B5B;A6Clq6BM;EACE,coCvnDA;AjF2x9BR;A6Cjq6BM;EACE,uCwF/tCyC;ExFguCzC,gBwF/tCuC;ArIk48B/C;A6Cjq6BM;;EAEE,uC4C5nDmB;AzF+x9B3B;A6Chq6BM;EACE,6BwF7tCmC;ArI+38B3C;A6C/p6BM;EACE,+BgCloDc;A7Emy9BtB;A6C7p6BI;EACE,+BgCpoD2B;A7Emy9BjC;A6C3p6BI;EACE,mBAAA;A7C6p6BN;A6Cxp6BM;EACE,0CwFtuCmC;ExFuuCnC,sBwFtuCmC;ExFuuCnC,mBwFtuCwB;ExFuuCxB,kDwFtuC6B;ArIg48BrC;A6Cvp6BM;EACE,0CwFxuCyC;ExFyuCzC,sCwFzuCyC;ExF2uCzC,sBwF1uCyC;ExF2uCzC,mBwF/uCwB;ArIu48BhC;A6Crp6BM;;EAEE,YwF7uC+B;ArIo48BvC;A6Cpp6BM;;EAEE,YwFjvCqC;ArIu48B7C;A6Clp6BI;;EAEE,2CwFvwCyC;ExFwwCzC,+BgC7qDsB;A7Ei09B5B;A6Clp6BI;;EAEE,2CwF5wCyC;ExF6wCzC,+BgClrDsB;A7Es09B5B;A6Clp6BI;;EAEE,2CwFjxCyC;ExFkxCzC,+BgCvrDsB;A7E209B5B;A6Chp6BI;EACE,oC4BvsDsB;AzEy19B5B;A6Chp6BI;EACE,qC4BzsDsB;AzE219B5B;A6Chp6BI;EACE,qC4B3sD+B;AzE619BrC;A6Chp6BI;EACE,qC4B7sD4B;AzE+19BlC;A6C9o6BM;EACE,mBsCzsDA;EtC0sDA,mDwF90CsC;ArI898B9C;A8Cp29BE;EACE,uBAAA;EACA,yHACE;EAGF,mBAAA;EACA,kBAAA;A9Cm29BJ;A8Ch29BE;EACE,uBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9Ck29BJ;A8C/19BE;EACE,WAAA;A9Ci29BJ;A8C/19BE;EACE,gBAAA;A9Ci29BJ;A8C719BE;EACE,gBAAA;A9C+19BJ;A8C519BE;;EAEE,gBAAA;A9C819BJ;A8C119BE;EACE,gBAAA;A9C419BJ;A+C/39BE;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,mBkEDS;ElEET,sBuF8BqB;AtIm29BzB;A+C139BE;;;EAGE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;A/C439BJ;A+Cr39BE;EACE,aAAA;A/Cu39BJ;A+Ch39BE;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sEuFxC2B;AtI059B/B;A+C329BE;EACE,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;A/C629BJ;A+C329BE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,gEuFhE2B;EvFiE3B,YuFhEmC;EvFiEnC,6BuFhEsC;AtI669B1C;A+C329BE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EAEA,ckCpFI;ElCqFJ,euFrEc;EvFsEd,6CuF/DF;EvFgEE,8CuFrEF;EvFsEE,WuF/DiB;AtI269BrB;A+Cj29BE;EACE,gEuF1F2B;EvF2F3B,UuFtEyC;AtIy69B7C;A+Cj29BE;EACE,ckCxGI;AjF289BR;A+C519BE;;EAEE,aAAA;A/C819BJ;A+C519BE;EACE,cAAA;A/C819BJ;A+Ct19BE;EACE,oBuFvFiB;AtI+69BrB;A+Ct19BE;EACE,mBuFvFmB;AtI+69BvB;A+Ct19BE;EACE,sBuF5FqB;AtIo79BzB;A+Ct19BE;EACE,8BuF9F2B;AtIs79B/B;AgD399BE;EACE,kBAAA;EACA,aAAA;EACA,auFYY;EvFXZ,gBAAA;EAEA,mBiCTI;EjCUJ,YuFOW;EvFNX,iFuFWF;EvFVE,yBuFQqB;EvFNrB,cAAA;EAEA,8B4BdG;E5BeH,iBAAA;EACA,kDAAA;AhD099BJ;AgDv99BE;;;;EAIE,uC4BvBG;E5BwBH,wC4BxBG;A5Ei/9BP;AgDt99BE;EACE,0C4B5BG;E5B6BH,2C4B7BG;A5Eq/9BP;AgD789BE;EACE,eAAA;EACA,kBAAA;EACA,YuFVc;EvFWd,cuFVgB;EvFWhB,UAAA;EAEA,YuFtBkB;EvFuBlB,iBuFtBe;EvFuBf,ciCnDI;EjCqDJ,cuFtBiB;EvFuBjB,euFvBiB;EvFwBjB,uBuFrBkB;AvIk+9BtB;AgD389BE;EACE,UAAA;AhD689BJ;AgDt89BE;EACE,cAAA;EACA,6EcrEU;EdsEV,mBiCpEI;EjCqEJ,SuF9BkB;EvF+BlB,uBuF5BmB;EvF6BnB,gBuFzBsB;EvF2BtB,0B6B7Ec;E7B8Ed,+CuFzBkB;AvIg+9BtB;AgDr89BE;EACE,0B+B5DG;E/B6DH,2BkB9EiB;ElB+EjB,iBctEG;A9D6g+BP;AgDh89BE;EACE,cAAA;EACA,WAAA;EACA,cuFrCsB;EvFsCtB,gBuFpCwB;EvFqCxB,euFtCoB;EvFuCpB,mBuFrCuB;AvIu+9B3B;AgDh89BE;EACE,aAAA;EACA,mBAAA;AhDk89BJ;AgD979BE;EACE,cAAA;EACA,cAAA;EACA,SuFxGgB;EvFyGhB,iBuFvGyB;EvFwGzB,eAAA;AhDg89BJ;AgD979BE;EACE,iBAAA;AhDg89BJ;AgD979BE;EACE,kBAAA;AhDg89BJ;AgD979BE;EACE,mBAAA;AhDg89BJ;AgD579BE;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,iBuFpH+B;AvIkj+BnC;AgD379BE;;EAEE,cAAA;EACA,auF5H0B;EvF6H1B,WuF5HsB;EvF6HtB,iBuF/HyB;AvI4j+B7B;AgDz79BE;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,euF3IoB;AvIsk+BxB;AgDp79BE;EACE,mBiCtJQ;EjCuJR,kBuFzImB;EvF0InB,4CuF5IkB;EvF6IlB,iBuF1IiB;AvIgk+BrB;AgDp79BE;EACE,mBuF3IoB;AvIik+BxB;AgDp79BE;EACE,gBAAA;AhDs79BJ;AgD969BE;EACE;IACE,sBAAA;IACA,euFtFgB;EvIsg+BpB;AACF;AgD969BE;EACE;IACE,sBAAA;IACA,euF3FgB;EvI2g+BpB;AACF;AgD969BE;EACE;IACE,YuFrGiB;IvFsGjB,euFhGkB;EvIgh+BtB;AACF;AgD969BE;EACE;IACE,YuF1GsB;IvF2GtB,euFrGuB;EvIqh+B3B;AACF;AgD969BE;EACE;IACE,YuF/G2B;IvFgH3B,euF1G4B;EvI0h+BhC;AACF;AgD569BE;EACE;IACE,sBuFvKe;EvIql+BnB;EgD569BE;IACE,auF9IkB;IvF+IlB,WuF9IoB;IvF+IpB,0BiB5MO;EjE0n+BX;AACF;AgD169BE;EhDpMF;IgDyNI,aAAA;IAgBA,aAAA;IASA,sBAAA;EhDk49BF;EgD969BE;IACE,gCAAA;IACA,iCAAA;EhDg79BJ;EgD969BE;IACE,gCuF5FyD;EvI4g+B7D;EgD969BE;IACE,gCuF/FyD;EvI+g+B7D;EgD969BE;IACE,cAAA;IACA,wBAAA;EhDg79BJ;EgD969BE;IACE,sBAAA;IACA,wBAAA;EhDg79BJ;EgD569BE;IACE,sBAAA;EhD869BJ;EgD569BE;IACE,cAAA;IACA,eAAA;IACA,yBAAA;IACA,kBAAA;IACA,4BAAA;EhD869BJ;EgD569BE;IACE,euF3KyB;IvF4KzB,kBAAA;EhD869BJ;EgD169BE;IACE,cAAA;IACA,sBAAA;IACA,oBAAA;IACA,0BAAA;IACA,gBAAA;EhD469BJ;EgDx69BE;IACE,kCAAA;EhD069BJ;EgDx69BE;;IAEE,mBuFhMyB;EvI0m+B7B;AACF;AgDn69BE;EACE,+CuFjLwB;AvIsl+B5B;AgD759BI;EACE,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,ciC1RE;AjFyr+BR;AgD759BI;;;EAGE,6BAAA;AhD+59BN;AgD759BI;EACE,ciClSE;AjFis+BR;AgD759BI;EACE,SuF9LkB;EvF+LlB,auF9LoB;EvF+LpB,ciCvSE;AjFss+BR;AgD559BI;EACE,0BiB5SO;AjE0s+Bb;AgD559BI;EACE,0B6BlTY;A7Egt+BlB;AgDz59BE;;EAEE,oBAAA;AhD259BJ;AgDz59BE;;EAEE,QAAA;AhD259BJ;AgDz59BE;;;;EAIE,SAAA;AhD259BJ;AgDx59BE;EACE,4BAAA;AhD059BJ;AgDn59BE;EACE,cAAA;EACA,kBAAA;EACA,WuF7OoB;AvIko+BxB;AgDl59BE;EACE,cAAA;AhDo59BJ;AgDz49BE;EACE,QuF9OuB;AvIyn+B3B;AgDz49BE;EACE,WuFjPuB;AvI4n+B3B;AgDx49BE;EACE;IACE,SuFrP4B;EvI+n+BhC;EgDx49BE;IACE,YuFxP4B;EvIko+BhC;AACF;AgDj49BE;EACE,gBAAA;AhDm49BJ;AgDj49BE;EACE,2BAAA;EACA,eAAA;AhDm49BJ;AgDj49BE;EACE,cAAA;EACA,iCAAA;AhDm49BJ;AgDj49BE;EACE,iBAAA;AhDm49BJ;AgD/39BE;EACE,cAAA;EACA,iCAAA;AhDi49BJ;AgD/39BE;EACE,gBAAA;AhDi49BJ;AgD/39BE;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;AhDi49BJ;AgD739BE;EACE,8BuFxRiC;EvFyRjC,cAAA;AhD+39BJ;AgD739BE;EACE,gCuF3RoD;AvI0p+BxD;AgD739BE;EACE,gCuF9RoD;AvI6p+BxD;AgDv39BI;EACE,UuF1UoB;EvF2UpB,UuF1UqB;EvF2UrB,gBuF1UqB;AvIms+B3B;AgDv39BI;EACE,WAAA;EACA,OAAA;EACA,cAAA;EACA,MAAA;EACA,gBAAA;AhDy39BN;AgDv39BI;EACE,sBuF9Ye;AvIuw+BrB;AgDv39BI;EACE,auFrXkB;EvFsXlB,WuFrXoB;EvFsXpB,0BiBnbO;AjE4y+Bb;AgDv39BI;EACE,ciCrbE;AjF8y+BR;AgDj39BE;EACE,e+BhbK;A/Emy+BT;AgD/29BE;EACE,gBuF7TqB;AvI8q+BzB;AgD729BE;EACE;IACE,UuF9Xe;IvF+Xf,euF7TqB;EvI4q+BzB;AACF;AgD729BE;EACE;IACE,YuFvUoB;IvFwUpB,euFlUqB;EvIir+BzB;AACF;AgD729BE;EACE;IACE,YuF5UsB;IvF6UtB,euFvUuB;EvIsr+B3B;AACF;AgD729BE;EACE;IACE,YuFjV2B;IvFkV3B,euF5U4B;EvI2r+BhC;AACF;AgD729BE;EACE;IACE,YuFtVgC;IvFuVhC,euFjViC;EvIgs+BrC;AACF;AgD329BE;EACE,gBuFrVqB;AvIks+BzB;AgDz29BE;EACE;IACE,UuFnae;IvFoaf,euFrVqB;EvIgs+BzB;AACF;AgDz29BE;EACE;IACE,YuF/VoB;IvFgWpB,euF1VqB;EvIqs+BzB;AACF;AgDz29BE;EACE;IACE,YuFpWsB;IvFqWtB,euF/VuB;EvI0s+B3B;AACF;AgDz29BE;EACE;IACE,YuFzW2B;IvF0W3B,euFpW4B;EvI+s+BhC;AACF;AgDz29BE;EACE;IACE,YuF9WgC;IvF+WhC,euFzWiC;EvIot+BrC;AACF;AgDv29BE;EACE,gBuF7WsB;AvIst+B1B;AgDr29BE;EACE;IACE,UuFxce;IvFycf,euF7WsB;EvIot+B1B;AACF;AgDr29BE;EACE;IACE,YuFvXqB;IvFwXrB,euFlXsB;EvIyt+B1B;AACF;AgDr29BE;EACE;IACE,YuF5XuB;IvF6XvB,euFvXwB;EvI8t+B5B;AACF;AgDr29BE;EACE;IACE,YuFjY4B;IvFkY5B,euF5X6B;EvImu+BjC;AACF;AgDr29BE;EACE;IACE,YuFtYiC;IvFuYjC,euFjYkC;EvIwu+BtC;AACF;AgDn29BE;EACE,gBuFrYsB;AvI0u+B1B;AgDn29BE;EACE;IACE,UuF3ee;IvF4ef,euFnYsB;EvIwu+B1B;AACF;AgDn29BE;EACE;IACE,UuFhfe;IvFiff,euFxYsB;EvI6u+B1B;AACF;AgDn29BE;EACE;IACE,auFlZuB;IvFmZvB,euF7YwB;EvIkv+B5B;AACF;AgDn29BE;EACE;IACE,auFvZ4B;IvFwZ5B,euFlZ6B;EvIuv+BjC;AACF;AgDn29BE;EACE;IACE,auF5ZiC;IvF6ZjC,euFvZkC;EvI4v+BtC;AACF;AgD519BI;EACE,8BuF/ZsB;AvI6v+B5B;AgD319BI;;EAEE,8BuFpasB;EvFqatB,ciChmBE;AjF67+BR;AgD119BI;EACE,mBuFra6B;EvFsa7B,4CuFrayB;EvFsazB,ciCtmBE;AjFk8+BR;AgDz19BI;EACE,0BuFxa8B;AvImw+BpC;AgDv19BI;EACE;IACE,ciChnBA;EjFy8+BN;AACF;AgDt19BI;EACE,ciCrnBE;AjF68+BR;AiD18+BE;EACE,aAAA;EACA,auFEU;EvFDV,kBuFLW;EvFOX,MuFsCM;EvFrCN,OAAA;EACA,YuFPU;EvFSV,auFJa;EvFKb,WuFXQ;EvFaR,SuFXS;EvFYT,mBuFPU;EvFSV,mBuFZa;EvFab,0CuFRa;EvFUb,euFRY;EvFSZ,kBuFRa;EvFSb,0BgBxBS;EhB0BT,kDuFwBoB;EvFvBpB,gCuFTa;AxI+8+BjB;AiDn8+BE;EACE,eAAA;AjDq8+BJ;AiDl8+BE;EACE,qBAAA;EACA,euFXe;EvFYf,cgCpCI;AjFw++BR;AiDh8+BE;EACE,eAAA;EACA,YuFVgB;EvFYhB,kBAAA;EACA,QuFjBY;EvFkBZ,UuFjBc;EvFmBd,cuFtBa;EvFwBb,kBuFvBe;EvFwBf,cgCnDI;EhCoDJ,6BuFrBmB;AxIo9+BvB;AiDr7+BE;EACE,mBuFzDa;EvF0Db,UuFzBgB;AxIg9+BpB;AiDp7+BE;EACE,UuF3BsB;AxIi9+B1B;AiDz6+BE;EACE,kBAAA;EACA,cAAA;AjD26+BJ;AiDp6+BE;EACE,eAAA;AjDs6+BJ;AiD/5+BE;;EAEE,kDuFlDuB;EvFmDvB,SAAA;EACA,SuFvDS;AxIw9+Bb;AiD15+BE;;EAEE,yBgCjHS;EhCkHT,0B4BpHc;A7Egh/BlB;AiD15+BE;;;;EAIE,yB4BxHe;A7Eoh/BnB;AiDp5+BE;EACE,2BAAA;AjDs5+BJ;AiDp5+BE;EACE,kDuFjFoB;AxIu++BxB;AiDp5+BE;EACE,kDuFnFuB;AxIy++B3B;AkDxh/BE;EACE,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EAEA,wDAAA;EACA,sBAAA;EACA,auFVY;EvFYZ,yBuFqBW;EvFpBX,qBclBU;EdmBV,gBuFXc;EvFYd,mB+BhBI;E/BkBJ,oBAAA;EACA,mBYTK;EZUL,kBYVK;EZWL,0BetBS;EfwBT,8B0BrBG;E1BsBH,kF4DnBc;A9Gyi/BlB;AkDph/BE;EACE,UAAA;EAEA,6EY/BU;EZgCV,yB6BLa;E7BMb,gBAAA;EACA,iBYvBG;A9D4i/BP;AkDnh/BE;EACE,kB0BmCU;A5Ek/+Bd;AkDlh/BE;EACE,kBAAA;EACA,WAAA;EACA,qB0BgCW;E1B/BX,sB0B+BW;E1B7BX,mB+B5CI;E/B6CJ,wBAAA;EAEA,auFTkB;EvFUlB,gDuFEqB;AzIgh/BzB;AkDtg/BE;EACE,kBAAA;AlDwg/BJ;AkDpg/BE;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,e6BvDK;E7BwDL,qB0BGW;E1BFX,sB0BEW;E1BAX,mB+BzEI;E/B0EJ,wBAAA;EAEA,auFtCkB;EvFuClB,gDuF3BqB;AzI+h/BzB;AkDhg/BE;EACE,oBAAA;EACA,2BAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,e6B3EK;E7B6EL,yBuFzDW;EvF0DX,qBchGU;EdiGV,euF3BsB;EvF4BtB,mB+B9FI;E/BgGJ,oBuFpCoB;EvFqCpB,mBYvFK;EZwFL,kBYxFK;EZyFL,0BepGS;EfsGT,8B0BnGG;E1BoGH,kF4DjGc;E5DkGd,auFjCoB;AzI+h/BxB;AkD1/+BE;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mB+BhHI;E/BiHJ,6BuFRoC;EvFSpC,8BAAA;AlD4/+BJ;AkD1/+BE;EACE,SAAA;EACA,2BAAA;EACA,YAAA;EACA,oB0BlDU;A5E8i/Bd;AkDx/+BE;;EAEE,oBAAA;EACA,kBAAA;AlD0/+BJ;AkDx/+BE;EACE,UAAA;EACA,4CAAA;EACA,4BAAA;EACA,yBACE;AlDy/+BN;AkDt/+BE;EACE,UAAA;EACA,+BAAA;EACA,yBACE;AlDu/+BN;AkDp/+BE;;EAEE,mBAAA;EACA,oBAAA;AlDs/+BJ;AkDp/+BE;EACE,4CAAA;EACA,UAAA;AlDs/+BJ;AkDl/+BE;;;EAGE,+CAAA;AlDo/+BJ;AkDl/+BE;;EAEE,+CAAA;AlDo/+BJ;AkDl/+BE;;EAEE,+CAAA;AlDo/+BJ;AkDl/+BE;;EAEE,+CAAA;AlDo/+BJ;AkDl/+BE;;;;EAIE,8BAAA;AlDo/+BJ;AkDl/+BE;;;;EAIE,8BAAA;AlDo/+BJ;AkD3++BE;EACE,2BAAA;AlD6++BJ;AkDz++BE;EACE,mBiC7LI;AnFwq/BR;AkDv++BE;EACE,mBiClMI;EjCmMJ,c+B3MI;E/B4MJ,YuFzHoB;EvF0HpB,gBuFzHwB;AzIkm/B5B;AkDv++BE;EACE,gBuF1H+B;EvF2H/B,c+BjNI;AjF0r/BR;AkDj++BE;EACE,SAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,oB0BzJU;A5E4n/Bd;AkDj++BE;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mB+BtOI;E/BuOJ,6BuF9HoC;EvF+HpC,8BAAA;AlDm++BJ;AkD/9+BE;EACE,SAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,oB0B3KU;A5E4o/Bd;AkD/9+BE;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,SuFlO6B;EvFmO7B,6BuF/IoC;EvFgJpC,8BAAA;AlDi++BJ;AkD79+BE;EACE,SAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,oB0B5LU;A5E2p/Bd;AkD79+BE;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,UuFnP6B;EvFoP7B,6BuFhKoC;EvFiKpC,8BAAA;AlD+9+BJ;AkD19+BE;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,iB0B/MU;A5E2q/Bd;AkD19+BE;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,6BuFnLoC;EvFoLpC,2BAAA;AlD49+BJ;AkDx9+BE;EACE,OAAA;EACA,SAAA;EACA,iB0B9NU;A5Ewr/Bd;AkDx9+BE;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,SuFrR6B;EvFsR7B,6BuFlMoC;EvFmMpC,2BAAA;AlD09+BJ;AkDt9+BE;EACE,QAAA;EACA,SAAA;EACA,iB0B7OU;A5Eqs/Bd;AkDt9+BE;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,UuFpS6B;EvFqS7B,6BuFlNkC;EvFmNlC,2BAAA;AlDw9+BJ;AkDp9+BE;EACE,WAAA;EACA,QAAA;EACA,mB0B5PU;E1B6PV,2BAAA;AlDs9+BJ;AkDp9+BE;EACE,WAAA;EACA,QAAA;EACA,4BuFhOkC;EvFiOlC,8BuFhOoC;AzIsr/BxC;AkDl9+BE;EACE,UAAA;EACA,QAAA;EACA,kB0B1QU;E1B2QV,2BAAA;AlDo9+BJ;AkDl9+BE;EACE,UAAA;EACA,QAAA;EACA,4BuF7OoC;EvF8OpC,4BAAA;AlDo9+BJ;AkDh9+BE;EACE,mB+B5VI;E/B6VJ,kDuFxS4B;AzI0v/BhC;AkDh9+BE;EACE,mB+BhWI;E/BiWJ,iDuF9S0B;AzIgw/B9B;AkDh9+BE;EACE,mB+BpWI;E/BqWJ,iDuFjT2B;AzImw/B/B;AkDh9+BE;EACE,mB+BxWI;AjF0z/BR;AkD98+BE;EACE,mBiCrWI;EjCsWJ,kDuFzT4B;AzIyw/BhC;AkD98+BE;EACE,mBiCzWI;EjC0WJ,iDuF/T0B;AzI+w/B9B;AkD98+BE;EACE,mBiC7WI;EjC8WJ,iDuFlU2B;AzIkx/B/B;AkD98+BE;EACE,mBiCjXI;AnFi0/BR;AkD78+BE;EACE,+BAAA;AlD+8+BJ;AkD78+BE;EACE,4BAAA;AlD+8+BJ;AkD78+BE;EACE,4BAAA;AlD+8+BJ;AkD78+BE;EACE,8BAAA;AlD+8+BJ;AkD78+BE;EACE,8BAAA;AlD+8+BJ;AkD78+BE;EACE,6BAAA;AlD+8+BJ;AkDx8+BE;;EAEE,0B6B1YG;A/Eo1/BP;AkDx8+BE;;EAEE,0B6B7YG;A/Eu1/BP;AkDx8+BE;;EAEE,0B6BhZI;A/E01/BR;AkDx8+BE;;EAEE,e6BnZK;A/E61/BT;AkDx8+BE;;EAEE,0B6BtZI;A/Eg2/BR;AkDx8+BE;;EAEE,0B6BxZG;A/Ek2/BP;AkDp8+BE;EACE,aAAA;AlDs8+BJ;AkD/7+BE;EACE,SAAA;AlDi8+BJ;AkD77+BE;EACE,0BAAA;AlD+7+BJ;AkD77+BE;EACE,6BAAA;AlD+7+BJ;AkD77+BE;EACE,+BAAA;AlD+7+BJ;AkD77+BE;EACE,8BAAA;AlD+7+BJ;AkD37+BE;EACE,4BAAA;EACA,2BAAA;AlD67+BJ;AkD37+BE;EACE,4BAAA;EACA,0BAAA;AlD67+BJ;AkDz7+BE;EACE,0BAAA;AlD27+BJ;AkDz7+BE;EACE,0BAAA;AlD27+BJ;AkDz7+BE;EACE,4BAAA;AlD27+BJ;AkDz7+BE;EACE,2BAAA;AlD27+BJ;AkDn7+BE;EACE,4BuF/biB;EvFgcjB,oBuFhciB;EvFicjB,SAAA;EACA,WAAA;EACA,YAAA;EACA,kDuFvb4B;AzI42/BhC;AkDl7+BE;EACE,cuF1dqB;AzI84/BzB;AkDj7+BE;EACE,oBuF5ciB;EvF6cjB,SuFhe6B;EvFie7B,WAAA;EACA,YAAA;EACA,cAAA;EACA,kDuFpc4B;AzIu3/BhC;AkDh7+BE;EACE,euFveqB;AzIy5/BzB;AkD/6+BE;EACE,oBuFzdiB;EvF0djB,UuF7e6B;EvF8e7B,YAAA;EACA,UAAA;EACA,cAAA;EACA,kDuFjd4B;AzIk4/BhC;AkD76+BE;EACE,SAAA;EACA,WAAA;EACA,uBuFreiB;EvFsejB,SAAA;EACA,4BuFveiB;AzIs5/BrB;AkD76+BE;EACE,cuF5fqB;AzI26/BzB;AkD56+BE;EACE,uBuF9eiB;EvF+ejB,SuFlgB6B;EvFmgB7B,SAAA;EACA,WAAA;EACA,cAAA;AlD86+BJ;AkD56+BE;EACE,euFvgBqB;AzIq7/BzB;AkD36+BE;EACE,uBuFzfiB;EvF0fjB,UuF7gB6B;EvF8gB7B,SAAA;EACA,UAAA;EACA,cAAA;AlD66+BJ;AkDx6+BE;EACE,QAAA;EACA,sBuFpgBiB;EvFqgBjB,YAAA;EACA,UAAA;EACA,2BuFvgBiB;EvFwgBjB,iDuF7f0B;AzIu6/B9B;AkDr6+BE;EACE,QAAA;EACA,qBuF/gBiB;EvFghBjB,YAAA;EACA,WAAA;EACA,2BuFlhBiB;EvFmhBjB,iDuFvgB2B;AzI86/B/B;AkDn6+BE;EACE,mB+BhkBI;AjFq+/BR;AkDn6+BE;;EAEE,mB+BpkBI;AjFy+/BR;AkDn6+BE;EACE,mB+BvkBI;AjF4+/BR;AkDj6+BE;EACE,mBiCpkBI;AnFu+/BR;AkDj6+BE;;EAEE,mBiCxkBI;AnF2+/BR;AkDj6+BE;EACE,mBiC3kBI;AnF8+/BR;AkD15+BE;EACE,2BuFzesB;EvF0etB,yBuF3euB;AzIu4/B3B;AkDr5+BE;EACE,cAAA;EACA,kBAAA;EACA,WuFhfoB;AzIu4/BxB;AkDp5+BE;;EAEE,cAAA;AlDs5+BJ;AkDn5+BE;EACE,wBAAA;EACA,2BAAA;AlDq5+BJ;AkDz4+BE;EACE,aAAA;AlD24+BJ;AkDn4+BE;EACE,gBuF3jBe;AzIg8/BnB;AkDn4+BE;EACE,gBuF7jBoB;AzIk8/BxB;AkDl4+BE;EACE;;IAEE,gBuF7oBY;EzIihgChB;AACF;AkD53+BE;EACE,WAAA;EACA,eAAA;AlD83+BJ;AkDp3+BI;EACE,mBiC/pBE;EjCgqBF,c+BxqBE;E/ByqBF,YuFtlBkB;EvFulBlB,gBuFtlBsB;AzI48/B5B;AkDp3+BI;EACE,sBuFvlB6B;EvFwlB7B,c+B9qBE;AjFoigCR;AkDp3+BI;EACE,yBiCzqBE;EjC0qBF,2BAAA;AlDs3+BN;AkD92+BE;EACE,eAAA;AlDg3+BJ;AkDx2+BE;EACE,0B6BzrBG;A/EmigCP;AkDx2+BE;EACE,0B6B3rBG;A/EqigCP;AkDx2+BE;EACE,0B6B7rBI;A/EuigCR;AkDx2+BE;EACE,e6B/rBK;A/EyigCT;AkDx2+BE;EACE,0B6BjsBI;A/E2igCR;AkDx2+BE;EACE,0B6BlsBG;A/E4igCP;AmD1jgCE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YuFgBc;EvFfd,mBuFUc;EvFTd,gBuFekB;EvFdlB,8BsCXuB;EtCYvB,UuFce;EvFbf,8ByBVG;A5EskgCP;AmDzjgCE;EACE,iBuFGoB;A1IwjgCxB;AmDzjgCE;EACE,iBuFCmB;A1I0jgCvB;AmDnjgCE;EACE,cAAA;EACA,cAAA;EACA,kBuFDoB;EvFEpB,QuFQyB;EvFPzB,cuFQqB;EvFPrB,mBuFFsB;EvFGtB,8ByBhCG;EzBiCH,uDuFCF;EvFAE,gBAAA;AnDqjgCJ;AmDnjgCE;;EAEE,uBAAA;AnDqjgCJ;AmDnjgCE;EACE,0Bc5CS;AjEimgCb;AmDljgCI;EACE,+B0BzCgB;A7E6lgCtB;AmD/igCE;EACE,mBAAA;EACA,kBuFTgB;EvFUhB,WuFZa;EvFab,yB4BjCa;E5BkCb,QuFXW;EvFYX,YuFXa;EvFYb,UuFXY;EvFYZ,YuFXc;EvFYd,+B0BrDwB;E1BsDxB,iBuFVmB;EvFWnB,kBuFbc;EvFcd,iBWvDG;EXwDH,gBuFXkB;A1I4jgCtB;AmD7igCE;EACE,kBAAA;EACA,WuFrEmB;EvFsEnB,cuFpEkB;EvFqElB,SuFnEiB;EvFoEjB,WuFlEmB;EvFmEnB,OuFpEkB;EvFqElB,YuFnEoB;EvFoEpB,0Bc9ES;Ed+ET,iBWrEG;EXsEH,iBuFnEyB;EvFoEzB,iBuFtEoB;EvFuEpB,kBuFnEwB;EvFoExB,2BuFnEwB;A1IkngC5B;AmDrigCE;;EAEE,yBuFpC8B;A1I2kgClC;AmDrigCE;EACE,yBuFtC+B;A1I6kgCnC;AmDrigCE;;EAEE,yBuFzC8B;A1IglgClC;AmDrigCE;EACE,yBuF3C+B;A1IklgCnC;AmDrigCE;;EAEE,yBuF9C8B;A1IqlgClC;AmDrigCE;;EAEE,yBuFjD8B;A1IwlgClC;AmDnigCE;;EAEE,0BcvHS;AjE4pgCb;AmDnigCE;EACE,0Bc1HS;AjE+pgCb;AmDnigCE;;EAEE,0Bc9HS;AjEmqgCb;AmDnigCE;EACE,0BcjIS;AjEsqgCb;AmDnigCE;;EAEE,0BcrIS;AjE0qgCb;AmDnigCE;;EAEE,0BczIS;AjE8qgCb;AmDhigCI;;EAEE,+B0BzIgB;A7E2qgCtB;AmDhigCI;EACE,+B0B5IgB;A7E8qgCtB;AmDhigCI;;EAEE,+B0BhJgB;A7EkrgCtB;AmDhigCI;EACE,+B0BnJgB;A7EqrgCtB;AmDhigCI;;EAEE,+B0BvJgB;A7EyrgCtB;AmDhigCI;;EAEE,+B0B3JgB;A7E6rgCtB;AmD7hgCE;;;;;;;;;EASE,yBuFrH8B;A1IopgClC;AmD7hgCE;;;;;;;;;;EAUE,0Bc5LS;AjE2tgCb;AmD3hgCI;;;;;;;;;;EAUE,+B0BnMgB;A7EgugCtB;AmDxhgCE;EACE,cwFnNoB;A3I6ugCxB;AmDthgCE;EACE,aAAA;AnDwhgCJ;AmD5ggCE;EACE,yBgCjOI;AnF+ugCR;AmD5ggCE;;EAEE,eAAA;AnD8ggCJ;AmD5ggCE;EACE,cwF5OoB;A3I0vgCxB;AmDvggCE;EACE,yBkDjOY;ArG0ugChB;AmDvggCE;;EAEE,eAAA;AnDyggCJ;AmDvggCE;EACE,cwFnPmB;A3I4vgCvB;AmDlggCE;EACE,yBgCnQE;AnFuwgCN;AmDlggCE;;EAEE,eAAA;AnDoggCJ;AmDlggCE;EACE,cwFvQoB;A3I2wgCxB;AmD7//BE;EACE,kBAAA;EACA,cuFvOqB;A1IsugCzB;AmD7//BE;EACE,WAAA;EACA,UAAA;EAEA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mB8B1RI;E9B4RJ,8ByB1RG;EzB4RH,2CAAA;EACA,sBAAA;AnD4//BJ;AmD1//BE;EACE;IACE,YuFhN8B;IvFiN9B,sBAAA;EnD4//BJ;EmD1//BE;IACE,UAAA;IACA,mBAAA;EnD4//BJ;AACF;AmDr//BE;EACE,aAAA;AnDu//BJ;AmDr//BE;;EAEE,eAAA;AnDu//BJ;AmD1+/BI;EACE,qCsChUc;EtCiUd,YuFnOqB;A1I+sgC3B;AmD1+/BI;EACE,mBuFxSoB;A1IoxgC1B;AmD1+/BI;EACE,cgClUE;AnF8ygCR;AmD1+/BI;EACE,c8B7UE;AjFyzgCR;AmD1+/BI;EACE,cgChVE;AnF4zgCR;AmD1+/BI;EACE,ckDpUU;ArGgzgChB;AmD1+/BI;EACE,cgC1VA;AnFs0gCN;AmDl+/BI;EACE,uBuFtQyB;EvFuQzB,kBAAA;EACA,YAAA;EACA,SAAA;AnDo+/BN;AmDl+/BI;;EAEE,cAAA;EACA,cuF7QqB;EvF8QrB,UAAA;EACA,gBAAA;EACA,kDAAA;AnDo+/BN;AmDl+/BI;EACE,gBAAA;AnDo+/BN;AmDh+/BI;;EAEE,MAAA;EACA,kDAAA;AnDk+/BN;AmDh+/BI;EACE,gBAAA;AnDk+/BN;AmD99/BI;;EAEE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AnDg+/BN;AmD99/BI;;EAEE,SAAA;EACA,YAAA;AnDg+/BN;AmDl9/BM;;;EAGE,yBANE;AnD09/BV;AmDj9/BQ;;;EAGE,yBAXA;AnD89/BV;AmD59/BM;;;EAGE,yBANE;AnDo+/BV;AmD39/BQ;;;EAGE,yBAXA;AnDw+/BV;AmDt+/BM;;;EAGE,yBANE;AnD8+/BV;AmDr+/BQ;;;EAGE,yBAXA;AnDk//BV;AmDh//BM;;;EAGE,yBANE;AnDw//BV;AmD/+/BQ;;;EAGE,yBAXA;AnD4//BV;AmD1//BM;;;EAGE,yBANE;AnDkggCV;AmDz//BQ;;;EAGE,yBAXA;AnDsggCV;AmDpggCM;;;EAGE,yBANE;AnD4ggCV;AmDnggCQ;;;EAGE,yBAXA;AnDghgCV;AmD9ggCM;;;EAGE,yBANE;AnDshgCV;AmD7ggCQ;;;EAGE,yBAXA;AnD0hgCV;AmDxhgCM;;;EAGE,yBANE;AnDgigCV;AmDvhgCQ;;;EAGE,yBAXA;AnDoigCV;AmDligCM;;;EAGE,yBANE;AnD0igCV;AmDjigCQ;;;EAGE,yBAXA;AnD8igCV;AmD5igCM;;;EAGE,yBANE;AnDojgCV;AmD3igCQ;;;EAGE,yBAXA;AnDwjgCV;AmDtjgCM;;;EAGE,yBANE;AnD8jgCV;AmDrjgCQ;;;EAGE,yBAXA;AnDkkgCV;AmDhkgCM;;;EAGE,yBANE;AnDwkgCV;AmD/jgCQ;;;EAGE,yBAXA;AnD4kgCV;AmD1kgCM;;;EAGE,yBANE;AnDklgCV;AmDzkgCQ;;;EAGE,yBAXA;AnDslgCV;AmDplgCM;;;EAGE,yBANE;AnD4lgCV;AmDnlgCQ;;;EAGE,yBAXA;AnDgmgCV;AmD9lgCM;;;EAGE,yBANE;AnDsmgCV;AmD7lgCQ;;;EAGE,yBAXA;AnD0mgCV;AmDrlgCE;EACE,0B4B9ZG;A/Eq/gCP;AmDrlgCE;EACE,auFtUuB;A1I65gC3B;AmDplgCE;EACE,0B4BpaI;A/E0/gCR;AmDplgCE;EACE,WuF5UwB;A1Ik6gC5B;AmDnlgCE;EACE,e4B1aK;A/E+/gCT;AmDnlgCE;EACE,cuF7ZkB;A1Ik/gCtB;AmDllgCE;EACE,0B4BhbI;A/EoghCR;AmDllgCE;EACE,auFzVwB;A1I66gC5B;AmDjlgCE;EACE,0B4BtbE;A/EyghCN;AmDjlgCE;EACE,auF/VsB;A1Ik7gC1B;AmD5kgCE;EACE,WAAA;AnD8kgCJ;AmD5kgCE;;EAEE,kBAAA;EACA,kBAAA;AnD8kgCJ;AmD5kgCE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,8ByB3dG;EzB4dH,8CAAA;EACA,wBAAA;EACA,WAAA;AnD8kgCJ;AmD5kgCE;EACE,sBuFpXyC;A1Ik8gC7C;AmD5kgCE;EACE,sBuFtXyC;A1Io8gC7C;AmD5kgCE;EACE,sBAAA;EACA,iCAAA;AnD8kgCJ;AmD5kgCE;EACE,sBAAA;EACA,gCAAA;AnD8kgCJ;AmD5kgCE;EACE,gCAAA;AnD8kgCJ;AmD5kgCE;EACE,mB8BpfI;AjFkkhCR;AmD5kgCE;;;EAGE,8BsC1fuB;AzFwkhC3B;AmD3kgCI;;;EAGE,qCsC5fc;AzFykhCpB;AmD3kgCI;;EAEE,cgC3fE;AnFwkhCR;AmD3kgCI;;EAEE,+B0B/fsB;A7E4khC5B;AmDzkgCE;EACE;IACE,UAAA;IACA,UAAA;EnD2kgCJ;EmDzkgCE;IACE,UAAA;EnD2kgCJ;EmDzkgCE;IACE,UAAA;IACA,UAAA;EnD2kgCJ;AACF;AmDxkgCE;EACE;IACE,UAAA;IACA,UAAA;EnD0kgCJ;EmDxkgCE;IACE,UAAA;EnD0kgCJ;EmDxkgCE;IACE,UAAA;IACA,UAAA;EnD0kgCJ;AACF;AmDvkgCE;EACE;IACE,sBAAA;EnDykgCJ;EmDvkgCE;IACE,mBAAA;IACA,UAAA;EnDykgCJ;EmDvkgCE;IACE,UAAA;EnDykgCJ;AACF;AmDtkgCE;EACE;IACE,sBAAA;IACA,YAAA;EnDwkgCJ;EmDtkgCE;IACE,mBAAA;IACA,UAAA;EnDwkgCJ;AACF;AoDjohCE;EACE,oBAAA;EACA,mBwFLiB;ExFMjB,wBwFLoB;A5IwohCxB;AoDjohCE;EACE,eAAA;ApDmohCJ;AoD/nhCE;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,mBUPK;EVQL,kBAAA;EACA,cAAA;EACA,ewFjBiB;ExFkBjB,awFjBgB;ExFkBhB,YwFjBiB;ExFkBjB,2FwFhBF;ExFiBE,cAAA;EACA,2BAAA;ApDiohCJ;AoDnnhCE;EACE,uBwFvByB;ExFwBzB,0BwFvBoB;A5I4ohCxB;AoDjnhCE;EACE,uBwF7ByB;ExF8BzB,0ByBnDc;A7EsqhClB;AoD/mhCE;;EAEE,uBwFpCyB;ExFqCzB,0BavDS;AjEwqhCb;AoDjmhCM;EACE,cALE;EAMF,iGAAA;ApDmmhCR;AoD9lhCM;;EAEE,mCAXG;EAYH,6QAAA;ApDgmhCR;AoD1mhCM;EACE,cALE;EAMF,iGAAA;ApD4mhCR;AoDvmhCM;;EAEE,gCAXG;EAYH,qOAAA;ApDymhCR;AoDnnhCM;EACE,cALE;EAMF,iGAAA;ApDqnhCR;AoDhnhCM;;EAEE,kCAXG;EAYH,yQAAA;ApDknhCR;AoD5nhCM;EACE,cALE;EAMF,iGAAA;ApD8nhCR;AoDznhCM;;EAEE,kCAXG;EAYH,6NAAA;ApD2nhCR;AoDrohCM;EACE,cALE;EAMF,iGAAA;ApDuohCR;AoDlohCM;;EAEE,kCAXG;EAYH,yLAAA;ApDoohCR;AoD9ohCM;EACE,cALE;EAMF,iGAAA;ApDgphCR;AoD3ohCM;;EAEE,yDAXG;EAYH,6QAAA;ApD6ohCR;AoDvphCM;EACE,cALE;EAMF,iGAAA;ApDyphCR;AoDpphCM;;EAEE,0CAXG;EAYH,yQAAA;ApDsphCR;AoDhqhCM;EACE,cALE;EAMF,iGAAA;ApDkqhCR;AoD7phCM;;EAEE,cAXG;EAYH,yLAAA;ApD+phCR;AoDzqhCM;EACE,cALE;EAMF,iGAAA;ApD2qhCR;AoDtqhCM;;EAEE,mCAXG;EAYH,6QAAA;ApDwqhCR;AoDlrhCM;EACE,cALE;EAMF,iGAAA;ApDorhCR;AoD/qhCM;;EAEE,mCAXG;EAYH,yQAAA;ApDirhCR;AoD3rhCM;EACE,cALE;EAMF,iGAAA;ApD6rhCR;AoDxrhCM;;EAEE,2BAXG;EAYH,6QAAA;ApD0rhCR;AoDpshCM;EACE,cALE;EAMF,iGAAA;ApDsshCR;AoDjshCM;;EAEE,mCAXG;EAYH,6QAAA;ApDmshCR;AoD7shCM;EACE,cALE;EAMF,iGAAA;ApD+shCR;AoD1shCM;;EAEE,wDAXG;EAYH,yQAAA;ApD4shCR;AoDtthCM;EACE,cALE;EAMF,iGAAA;ApDwthCR;AoDnthCM;;EAEE,+BAXG;EAYH,qLAAA;ApDqthCR;AoD/thCM;EACE,cALE;EAMF,iGAAA;ApDiuhCR;AoD5thCM;;EAEE,YAXG;EAYH,qOAAA;ApD8thCR;AoD3shCE;EACE,eAAA;ApD6shCJ;AoDpshCE;EACE,UwFhFqC;A5IsxhCzC;AoDpshCE;;EAEE,UwFnFuC;A5IyxhC3C;AoD7rhCE;EACE,0B2BjHG;A/EgzhCP;AoD7rhCE;EACE,0B2BnHG;A/EkzhCP;AoD7rhCE;EACE,0B2BrHI;A/EozhCR;AoD7rhCE;EACE,e2BvHK;A/EszhCT;AoD7rhCE;EACE,0B2BzHI;A/EwzhCR;AoD7rhCE;EACE,0B2B1HG;A/EyzhCP;AoD7rhCE;EACE,ewF3Ga;A5I0yhCjB;AqD10hCE;EACE,kBAAA;ArD40hCJ;AqDz0hCE;EACE,SAAA;EACA,aAAA;EACA,wBAAA;EACA,mDAAA;EAEA,iBAAA;EACA,kBAAA;EACA,mBSLK;ETOL,2B+CLgB;E/CMhB,2BwFboB;ExFcpB,c0BKc;E1BHd,mB4BrBI;E5BsBJ,wCwFhBmB;ExFiBnB,0BYxBS;EZyBT,qCwFTuB;ExFUvB,qGwFfF;A7Iu1hCF;AqDr0hCE;EACE,qB2B/Bc;AhFs2hClB;AqD/zhCE;EACE,eAAA;ArDi0hCJ;AqD1zhCE;EACE,aAAA;EAEA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EAEA,mBwFlCwB;ExFoCxB,iBwFnCsB;ExFoCtB,WwFtCmB;ExFwCnB,8BuB3DG;EvB4DH,kFyDzDc;EzD0Dd,yBwFtCoB;ExFuCpB,YwFyCqB;A7I+whCzB;AqDtzhCE;EACE,kDAAA;ArDwzhCJ;AqDtzhCE;EACE,kDAAA;ArDwzhCJ;AqDjzhCE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,cwFpDsB;ExFqDtB,sCwFlDoB;ExFmDpB,0BYpFS;EZqFT,iBwFlDwB;ExFmDxB,8CwFlDoB;A7Iq2hCxB;AqDjzhCE;EACE,8BAAA;ArDmzhCJ;AqD/yhCE;EACE,YwFtDwB;ExFuDxB,gBAAA;EACA,gBwFvD6B;ExFwD7B,UwFvDwB;ExFwDxB,WwFvDyB;ExFwDzB,qBwFvDgC;A7Iw2hCpC;AqD/yhCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;ArDizhCJ;AqD1yhCE;EACE,iBwFnEyB;A7I+2hC7B;AqDzyhCE;EACE,2BwFnEyB;ExFoEzB,6EStHU;ETuHV,iBS5GG;ET6GH,c0B9Fc;E1B+Fd,0BwB3Hc;A7Es6hClB;AqDzyhCE;EACE,awFnEiC;ExFoEjC,yB0BpGa;E1BqGb,yBwB9He;A7Ey6hCnB;AqDzyhCE;EACE,YwFpEwB;ExFqExB,c8BhII;AnF26hCR;AqDpyhCE;EACE,gBAAA;ArDsyhCJ;AqDpyhCE;EACE,6ES7IU;ET8IV,e0B9HK;E1B+HL,iBSpIG;ETqIH,0BY/IS;AjEq7hCb;AqDpyhCE;EACE,mBwF7EkC;ExF8ElC,cwF7EmC;ExF8EnC,0BYpJS;AjE07hCb;AqDlyhCE;EACE,cAAA;EACA,gBwFhFmB;ExFiFnB,mB4B5JS;E5B6JT,2BwFhFoB;ExFiFpB,0BY7JS;EZ8JT,iBSpJG;ETqJH,kBwFhFkB;A7Io3hCtB;AqDxxhCE;EACE,oC+BpKoB;E/BqKpB,mB4B5KI;E5B6KJ,0BwB1KkB;A7Eo8hCtB;AqDnxhCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CyB1LY;EzB2LZ,qB0BjKW;E1BkKX,sB0BlKW;E1BoKX,qB2BhMc;E3BiMd,sCAAA;ArDmxhCJ;AqDjxhCE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EAEA,2CyBvMY;EzBwMZ,qB0B9KW;E1B+KX,sB0B/KW;E1BiLX,sCAAA;EACA,2BAAA;EACA,qB2B/Mc;E3BiNd,iCAAA;ArDgxhCJ;AqDxwhCE;;EAEE,mB4B5NQ;AjFs+hCZ;AqDxwhCE;EACE,mBwFlI6B;A7I44hCjC;AqDnwhCE;EACE,mB4BtOS;AjF2+hCb;AqDnwhCE;EACE,0BYxOS;AjE6+hCb;AqDlwhCE;;EAEE,kBAAA;EACA,wCgCzNoB;EhC0NpB,mB4BhPS;E5BiPT,gBwFzI8B;A7I64hClC;AqDlwhCE;EACE,0BwBtPc;A7E0/hClB;AqDlwhCE;EACE,0BwBzPc;A7E6/hClB;AqD5vhCE;EACE,eAAA;EACA,oBAAA;EACA,a0CpQe;A/FkgiCnB;AqDlvhCE;EACE,8BuB3QG;A5E+/hCP;AqDhvhCE;EACE,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SwF9JgC;ExF+JhC,MwFtKyB;ExFuKzB,QwFlK2B;ExFmK3B,8CwFtKF;A7Iw5hCF;AqDhvhCE;EACE,eAAA;EACA,YwFtKkC;ExFuKlC,oBAAA;ArDkvhCJ;AqDhvhCE;EACE,gBwFrKsC;A7Iu5hC1C;AqDhvhCE;EACE,UwF3KwC;ExF4KxC,c8BzSE;AnF2hiCN;AqD1uhCE;EACE,WwFvK4B;A7Im5hChC;AqDzuhCE;;EAEE,cAAA;ArD2uhCJ;AqDvuhCE;EACE,kBAAA;EACA,mB4B3TS;E5B4TT,gBwF1LyB;ExF2LzB,wDwFxLF;A7Ii6hCF;AqDruhCE;EACE,mBAAA;ArDuuhCJ;AqDnuhCE;EACE,oCAAA;ArDquhCJ;AqDnuhCE;EACE,oCAAA;ArDquhCJ;AqDjuhCE;EACE,mBAAA;EACA,uBAAA;EACA,YwF/LyB;ExFgMzB,mBwF5L8B;ExF6L9B,uBwFhM8B;ExFiM9B,6ESnVQ;EToVR,cwFhM6B;ExFiM7B,kBwF/L2B;ExFgM3B,iBS5UG;ET6UH,yBwBxVe;ExByVf,8CwFtNsB;A7Iy7hC1B;AqD/thCE;EACE,mBAAA;EACA,mB4B7VI;E5B8VJ,6CwFpNiC;ExFqNjC,8CwF9NsB;A7I+7hC1B;AqD/thCE;EACE,8CwF/ToB;ExFgUpB,wDwFhOF;ExFiOE,sCwFpUoB;A7IqiiCxB;AqDtthCE;EACE,WAAA;EACA,OAAA;ArDwthCJ;AqDtthCE;EACE,QAAA;EACA,UAAA;ArDwthCJ;AqDjthCE;EACE,WAAA;ArDmthCJ;AqD3shCE;EACE,yB0BjXY;A/E8jiChB;AqD3shCE;EACE,yB0BlXa;A/E+jiCjB;AqD3shCE;EACE,c0BpXc;A/EikiClB;AqD3shCE;EACE,yB0BtXa;A/EmkiCjB;AqD3shCE;EACE,yB0BxXW;A/EqkiCf;AqD3shCE;EACE,yB0B1XY;A/EukiChB;AqD3shCE;EACE,yB0B5Xe;A/EykiCnB;AqDtshCE;EACE;IACE,6BwF/YoB;E7IuliCxB;AACF;AsDvmiCE;EACE,kBAAA;EACA,mBAAA;EACA,qBwFPY;ExFQZ,mBwFLgB;ExFMhB,8GwFGF;A9IsmiCF;AsDtmiCE;EACE,4BAAA;AtDwmiCJ;AsDrmiCE;EACE,aAAA;EACA,UAAA;EACA,WAAA;EAEA,oBAAA;EACA,2BwFJwB;A9I0miC5B;AsDnmiCE;EACE,uCAAA;AtDqmiCJ;AsD9liCE;EACE,ewFRc;ExFSd,YwFTc;ExFWd,YwFTiB;ExFWjB,yBwFZoB;ExFapB,0BWxCS;EXyCT,sCwFXoB;A9IymiCxB;AsD5liCE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EAEA,kBwFhBoB;ExFiBpB,iBAAA;AtD6liCJ;AsD3liCE;EACE,mBAAA;EACA,sBAAA;EACA,cwFrBmB;A9IkniCvB;AsDtliCE;EACE,gBAAA;AtDwliCJ;AsDtliCE;EACE,mBAAA;AtDwliCJ;AsDtliCE;EACE,mBAAA;AtDwliCJ;AsD5kiCE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AtD8kiCJ;AsDtkiCE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,YwFvFsB;A9I+piC1B;AsDtkiCE;EACE,YwF3FwB;A9ImqiC5B;AsDhkiCE;EACE,kBAAA;EACA,8GwFjGF;A9ImqiCF;AsDhkiCE;EACE,oCwF/FoB;A9IiqiCxB;AsDhkiCE;;EAEE,gBAAA;AtDkkiCJ;AsD3jiCE;EACE,cAAA;AtD6jiCJ;AuDpriCE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EAEA,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,+BAAA;EACA,kBAAA;EACA,iCAAA;EAEA,uBAAA;EACA,gBAAA;EACA,2BAAA;EACA,oBAAA;EACA,2BAAA;EACA,YwFCgB;A/ImriCpB;AuDhriCE;EACE,2BAAA;AvDkriCJ;AuD1qiCE;EACE,WAAA;EACA,OAAA;EACA,mCAAA;AvD4qiCJ;AuD1qiCE;EACE,mBAAA;EACA,qBAAA;EACA,kCAAA;AvD4qiCJ;AuDzqiCE;;EAEE,sBAAA;EACA,uBAAA;AvD2qiCJ;AuDzqiCE;EACE,iBAAA;EACA,uBAAA;EACA,mCAAA;AvD2qiCJ;AuDzqiCE;EACE,oBAAA;EACA,oBAAA;EACA,kCAAA;AvD2qiCJ;AuDnqiCE;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;AvDqqiCJ;AuDjqiCE;EACE,mB0DlEU;AjHquiCd;AuDlqiCI;EACE,mBAAA;AvDoqiCN;AuD/piCE;EACE,+BAAA;AvDiqiCJ;AuD/piCE;;;EAGE,kBAAA;AvDiqiCJ;AuDzpiCE;EACE,eAAA;EACA,2BAAA;EAEA,gCAAA;EACA,sBAAA;EACA,YwFhFkB;A/I0uiCtB;AuDnpiCE;EACE,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,UwF9FmB;ExFgGnB,kDAAA;EACA,mBAAA;AvDopiCJ;AuDjpiCE;EACE,mBQ7Hc;A/DgxiClB;AuD5oiCE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,oCwF9HmB;ExF+HnB,gBAAA;EACA,UAAA;EACA,yBwFhIwB;ExFiIxB,oBAAA;EACA,awFnHmB;A/IiwiCvB;AuDvoiCE;EACE,2BAAA;AvDyoiCJ;AuD9niCE;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;AvDgoiCJ;AuDzniCE;EACE,mBAAA;AvD2niCJ;AuDpniCE;EACE,mBAAA;EACA,+BAAA;AvDsniCJ;AuDlniCE;;EAEE,2CwFzKiB;A/I6xiCrB;AuDlniCE;;EAEE,2CwF7KiB;A/IiyiCrB;AuDhniCE;;EAEE,mCAAA;AvDkniCJ;AuDhniCE;;EAEE,oCAAA;AvDkniCJ;AuDhniCE;;EAEE,kCAAA;AvDkniCJ;AuDhniCE;;EAEE,mCAAA;AvDkniCJ;AuD9miCE;;;;EAIE,+BAAA;AvDgniCJ;AuD/liCE;;EAEE,YwF3MiB;A/I4yiCrB;AuD/liCE;;EAEE,WwFhNsB;A/IiziC1B;AuD/liCE;;EAEE,YwFlNY;A/ImziChB;AuD/liCE;;EAEE,YwFrNiB;A/IsziCrB;AuD/liCE;;EAEE,YwFxNsB;A/IyziC1B;AuD7liCE;;EAEE,mCAAA;AvD+liCJ;AuD7liCE;;EAEE,kCAAA;AvD+liCJ;AuD7liCE;;EAEE,mCAAA;AvD+liCJ;AuD7liCE;;EAEE,mCAAA;AvD+liCJ;AuD3liCE;;EAEE,oCAAA;AvD6liCJ;AuD3liCE;;EAEE,mCAAA;AvD6liCJ;AuD3liCE;;EAEE,oCAAA;AvD6liCJ;AuD3liCE;;EAEE,oCAAA;AvD6liCJ;AuD/kiCE;EACE,YwFrRgB;A/Is2iCpB;AuD7kiCE;EACE,mCAAA;AvD+kiCJ;AuD7kiCE;EACE,kCAAA;AvD+kiCJ;AuD7kiCE;EACE,oCAAA;AvD+kiCJ;AuD7kiCE;EACE,mCAAA;AvD+kiCJ;AuD3kiCE;;EAEE,gCAAA;AvD6kiCJ;AuDzkiCE;EACE,gCAAA;AvD2kiCJ;AuDzkiCE;EACE,gCAAA;AvD2kiCJ;AuDzkiCE;EACE,gCAAA;AvD2kiCJ;AuDzkiCE;EACE,gCAAA;AvD2kiCJ;AuDvkiCE;;EAEE,0BAAA;AvDykiCJ;AuD/jiCE;EACE,gCAAA;EACA,YwFzUgB;A/I04iCpB;AuD7jiCE;EACE,mCAAA;AvD+jiCJ;AuD7jiCE;EACE,kCAAA;AvD+jiCJ;AuD7jiCE;EACE,oCAAA;AvD+jiCJ;AuD7jiCE;EACE,mCAAA;AvD+jiCJ;AuD3jiCE;EACE,gCAAA;AvD6jiCJ;AuDpjiCE;EACE,+BAAA;EACA,UwF1WmB;A/Ig6iCvB;AuDljiCE;EACE,+BAAA;EACA,gCAAA;AvDojiCJ;AuD3iiCE;EACE,UwF1XmB;A/Iu6iCvB;AuDziiCE;EACE,kCAAA;AvD2iiCJ;AuDziiCE;EACE,iCAAA;AvD2iiCJ;AuDziiCE;EACE,kCAAA;AvD2iiCJ;AuDziiCE;EACE,kCAAA;AvD2iiCJ;AuDviiCE;EACE,gCAAA;AvDyiiCJ;AuDriiCE;EACE,gCAAA;AvDuiiCJ;AuD9hiCE;EACE,UwF5ZmB;A/I47iCvB;AuD5hiCE;EACE,iCAAA;AvD8hiCJ;AuD5hiCE;EACE,kCAAA;AvD8hiCJ;AuD5hiCE;EACE,kCAAA;AvD8hiCJ;AuD5hiCE;EACE,mCAAA;AvD8hiCJ;AuD1hiCE;EACE,gCAAA;AvD4hiCJ;AuDxhiCE;EACE,gCAAA;AvD0hiCJ;AuDlhiCE;EACE,gCAAA;EACA,YwF3bgB;A/I+8iCpB;AuDhhiCE;EACE,mCAAA;AvDkhiCJ;AuDhhiCE;EACE,kCAAA;AvDkhiCJ;AuDhhiCE;EACE,oCAAA;AvDkhiCJ;AuDhhiCE;EACE,mCAAA;AvDkhiCJ;AuD9giCE;EACE,yBAAA;AvDghiCJ;AuD9giCE;EACE,yBAAA;AvDghiCJ;AuD9giCE;EACE,yBAAA;AvDghiCJ;AuD9giCE;EACE,yBAAA;AvDghiCJ;AuD5giCE;EACE,gCAAA;AvD8giCJ;AuD5giCE;;EAEE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AvD8giCJ;AuD1giCE;EACE,+BAAA;AvD4giCJ;AuD1giCE;EACE,sBAAA;AvD4giCJ;AwD5gjCE;EACE,WAAA;EACA,kBAAA;AxD8gjCJ;AwD3gjCE;EACE,kBAAA;AxD6gjCJ;AwD1gjCE;EACE,UAAA;AxD4gjCJ;AwDzgjCE;EACE,kBAAA;EACA,UAAA;AxD2gjCJ;AwDxgjCE;EACE,awFnBoB;AhJ6hjCxB;AwDvgjCE;EACE,YwFtBqB;AhJ+hjCzB;AwDtgjCE;EACE,kBAAA;EACA,kBwFpB2B;ExFqB3B,qCiChCgB;AzFwijCpB;AwDrgjCE;EACE,WAAA;EACA,awF7B0B;ExF8B1B,WwF7B2B;ExF8B3B,OAAA;AxDugjCJ;AwDpgjCE;EACE,kBAAA;EACA,kBwFjC2B;ExFkC3B,yB2BnCI;AnFyijCR;AwDngjCE;EACE,awFzC0B;ExF0C1B,WwFzC2B;ExF0C3B,OAAA;AxDqgjCJ;AwDlgjCE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,awFvDoB;ExFwDpB,YwFxDoB;ExFyDpB,qEwFnCgC;ExFoChC,mBwFrCiC;ExFsCjC,sFwFpCgC;ExFqChC,gCwFnCgC;AhJuijCpC;AwDjgjCE;EACE,ewFpC6B;ExFqC7B,yFwFpC6B;AhJuijCjC;AwDhgjCE;EACE,yFwFxC6B;AhJ0ijCjC;AwDr/iCE;EACE,YwFjD8B;AhJwijClC;AwDp/iCE;EACE,YAAA;AxDs/iCJ;AwDn/iCE;EACE,gBwFpFyB;AhJykjC7B;AwD7+iCI;EACE,UAAA;EACA,QAAA;AxD++iCN;AwD5+iCI;EACE,UAAA;EACA,QAAA;AxD8+iCN;AwD3+iCI;EACE,kCAAA;AxD6+iCN;AwDh+iCI;EACE,YAAA;EACA,YwF7HkB;ExF8HlB,kBwFtFqB;AhJwjjC3B;AwD/9iCI;EACE,YAAA;AxDi+iCN;AwD99iCI;EACE,YAAA;EACA,YwFlIwB;ExFmIxB,YwFlIyB;ExFmIzB,MAAA;AxDg+iCN;AwD79iCI;EACE,YwFxIwB;ExFyIxB,YwFxIyB;ExFyIzB,MAAA;AxD+9iCN;AwD19iCM;EACE,SAAA;EACA,SAAA;AxD49iCR;AwDz9iCM;EACE,SAAA;EACA,SAAA;AxD29iCR;AwDv9iCM;EACE,gCAAA;AxDy9iCR;AwDn9iCI;EACE,YwFvKkB;ExFwKlB,YAAA;EACA,SAAA;EACA,MAAA;EACA,SAAA;EACA,2BAAA;AxDq9iCN;AwDl9iCI;EACE,iCAAA;AxDo9iCN;AwDj9iCI;EACE,YwFpLkB;ExFqLlB,WwFzIkB;ExF0IlB,UAAA;EACA,QAAA;AxDm9iCN;AwDj9iCI;EACE,aAAA;EACA,WwF/IkB;AhJkmjCxB;AwD/8iCI;EACE,UwF1I4B;AhJ2ljClC;AwD/8iCI;;EAEE,YwF5I6B;ExF6I7B,YwF5I8B;AhJ6ljCpC;AwD/8iCI;;EAEE,UwFnJ4B;AhJomjClC;AwD/8iCI;EACE,YAAA;AxDi9iCN;AwD98iCI;EACE,UwFrJ4B;AhJqmjClC;AwD98iCI;;EAEE,YwFvJ6B;ExFwJ7B,YwFvJ8B;AhJumjCpC;AwD98iCI;;EAEE,UwF9J4B;AhJ8mjClC;AwD98iCI;EACE,UAAA;AxDg9iCN;AwD58iCI;EACE,YwFjK4B;AhJ+mjClC;AwD58iCI;;EAEE,YwFnK6B;ExFoK7B,YwFnK8B;AhJinjCpC;AwD58iCI;;EAEE,YwF1K4B;AhJwnjClC;AwD58iCI;EACE,aAAA;AxD88iCN;AwDt8iCE;EACE,awFtPoB;ExFuPpB,WAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;AxDw8iCJ;AwDr8iCE;EACE,2BAAA;AxDu8iCJ;AwDp8iCE;EACE,oBAAA;EACA,kBAAA;EACA,iCAAA;AxDs8iCJ;AwDn8iCE;EACE,YAAA;EACA,awF5QoB;ExF6QpB,UwFjOoB;ExFkOpB,gBwFvQyB;ExFwQzB,kBAAA;EACA,SAAA;EACA,SAAA;AxDq8iCJ;AwDn8iCE;EACE,cAAA;AxDq8iCJ;AwD97iCE;EACE,UwF5OwC;ExF6OxC,+BwF1OwC;AhJ0qjC5C;AwD77iCE;EACE,UwFhPyC;AhJ+qjC7C;AwDv7iCI;EACE,yByDnSQ;AjH4tjCd;AwDt7iCI;EACE,2CiC5Sc;AzFoujCpB;AwDt6iCM;EACE,yBAPE;AxD+6iCV;AwDp6iCM;EACE,yBAZE;AxDk7iCV;AwDp6iCM;;EAEE,oEAdE;AxDo7iCV;AwDl6iCQ;EACE,yBApBA;AxDw7iCV;AwDl6iCQ;EACE,yBAvBA;AxD27iCV;AwDl6iCQ;;EAEE,8CAzBC;AxD67iCX;AwD17iCM;EACE,yBAPE;AxDm8iCV;AwDx7iCM;EACE,yBAZE;AxDs8iCV;AwDx7iCM;;EAEE,0DAdE;AxDw8iCV;AwDt7iCQ;EACE,yBApBA;AxD48iCV;AwDt7iCQ;EACE,yBAvBA;AxD+8iCV;AwDt7iCQ;;EAEE,2CAzBC;AxDi9iCX;AwD98iCM;EACE,yBAPE;AxDu9iCV;AwD58iCM;EACE,yBAZE;AxD09iCV;AwD58iCM;;EAEE,mEAdE;AxD49iCV;AwD18iCQ;EACE,yBApBA;AxDg+iCV;AwD18iCQ;EACE,yBAvBA;AxDm+iCV;AwD18iCQ;;EAEE,6CAzBC;AxDq+iCX;AwDl+iCM;EACE,yBAPE;AxD2+iCV;AwDh+iCM;EACE,yBAZE;AxD8+iCV;AwDh+iCM;;EAEE,wDAdE;AxDg/iCV;AwD99iCQ;EACE,yBApBA;AxDo/iCV;AwD99iCQ;EACE,yBAvBA;AxDu/iCV;AwD99iCQ;;EAEE,6CAzBC;AxDy/iCX;AwDt/iCM;EACE,yBAPE;AxD+/iCV;AwDp/iCM;EACE,yBAZE;AxDkgjCV;AwDp/iCM;;EAEE,+CAdE;AxDogjCV;AwDl/iCQ;EACE,yBApBA;AxDwgjCV;AwDl/iCQ;EACE,yBAvBA;AxD2gjCV;AwDl/iCQ;;EAEE,6CAzBC;AxD6gjCX;AwD1gjCM;EACE,yBAPE;AxDmhjCV;AwDxgjCM;EACE,yBAZE;AxDshjCV;AwDxgjCM;;EAEE,oEAdE;AxDwhjCV;AwDtgjCQ;EACE,yBApBA;AxD4hjCV;AwDtgjCQ;EACE,yBAvBA;AxD+hjCV;AwDtgjCQ;;EAEE,oEAzBC;AxDiijCX;AwD9hjCM;EACE,yBAPE;AxDuijCV;AwD5hjCM;EACE,yBAZE;AxD0ijCV;AwD5hjCM;;EAEE,mEAdE;AxD4ijCV;AwD1hjCQ;EACE,yBApBA;AxDgjjCV;AwD1hjCQ;EACE,yBAvBA;AxDmjjCV;AwD1hjCQ;;EAEE,qDAzBC;AxDqjjCX;AwDljjCM;EACE,yBAPE;AxD2jjCV;AwDhjjCM;EACE,yBAZE;AxD8jjCV;AwDhjjCM;;EAEE,+CAdE;AxDgkjCV;AwD9ijCQ;EACE,yBApBA;AxDokjCV;AwD9ijCQ;EACE,yBAvBA;AxDukjCV;AwD9ijCQ;;EAEE,yBAzBC;AxDykjCX;AwDtkjCM;EACE,yBAPE;AxD+kjCV;AwDpkjCM;EACE,yBAZE;AxDkljCV;AwDpkjCM;;EAEE,oEAdE;AxDoljCV;AwDlkjCQ;EACE,yBApBA;AxDwljCV;AwDlkjCQ;EACE,yBAvBA;AxD2ljCV;AwDlkjCQ;;EAEE,8CAzBC;AxD6ljCX;AwD1ljCM;EACE,yBAPE;AxDmmjCV;AwDxljCM;EACE,yBAZE;AxDsmjCV;AwDxljCM;;EAEE,mEAdE;AxDwmjCV;AwDtljCQ;EACE,yBApBA;AxD4mjCV;AwDtljCQ;EACE,yBAvBA;AxD+mjCV;AwDtljCQ;;EAEE,8CAzBC;AxDinjCX;AwD9mjCM;EACE,yBAPE;AxDunjCV;AwD5mjCM;EACE,yBAZE;AxD0njCV;AwD5mjCM;;EAEE,oEAdE;AxD4njCV;AwD1mjCQ;EACE,yBApBA;AxDgojCV;AwD1mjCQ;EACE,yBAvBA;AxDmojCV;AwD1mjCQ;;EAEE,sCAzBC;AxDqojCX;AwDlojCM;EACE,yBAPE;AxD2ojCV;AwDhojCM;EACE,yBAZE;AxD8ojCV;AwDhojCM;;EAEE,oEAdE;AxDgpjCV;AwD9njCQ;EACE,yBApBA;AxDopjCV;AwD9njCQ;EACE,yBAvBA;AxDupjCV;AwD9njCQ;;EAEE,8CAzBC;AxDypjCX;AwDtpjCM;EACE,yBAPE;AxD+pjCV;AwDppjCM;EACE,yBAZE;AxDkqjCV;AwDppjCM;;EAEE,mEAdE;AxDoqjCV;AwDlpjCQ;EACE,yBApBA;AxDwqjCV;AwDlpjCQ;EACE,yBAvBA;AxD2qjCV;AwDlpjCQ;;EAEE,mEAzBC;AxD6qjCX;AwD1qjCM;EACE,yBAPE;AxDmrjCV;AwDxqjCM;EACE,yBAZE;AxDsrjCV;AwDxqjCM;;EAEE,8CAdE;AxDwrjCV;AwDtqjCQ;EACE,yBApBA;AxD4rjCV;AwDtqjCQ;EACE,yBAvBA;AxD+rjCV;AwDtqjCQ;;EAEE,0CAzBC;AxDisjCX;AwD9rjCM;EACE,yBAPE;AxDusjCV;AwD5rjCM;EACE,yBAZE;AxD0sjCV;AwD5rjCM;;EAEE,0DAdE;AxD4sjCV;AwD1rjCQ;EACE,yBApBA;AxDgtjCV;AwD1rjCQ;EACE,yBAvBA;AxDmtjCV;AwD1rjCQ;;EAEE,uBAzBC;AxDqtjCX;AwDjrjCE;EACE,yB2B3VI;AnF8gkCR;AwDjrjCE;EACE,0D+BjVU;AvFogkCd;AwD1qjCI;EACE,yByDxWQ;AjHohkCd;AwD1qjCI;EACE,uB+BhVc;AvF4/jCpB;AwDnqjCE;EACE,WwFtU8B;ExFuU9B,UwFvU8B;AhJ4+jClC;AwDnqjCE;EACE,WwF1U8B;AhJ++jClC;AwDnqjCE;;EAEE,awF5U+B;ExF6U/B,WwF5UgC;AhJi/jCpC;AwDnqjCE;;EAEE,WwFnV8B;AhJw/jClC;AwDnqjCE;EACE,aAAA;AxDqqjCJ;AwDhqjCE;EACE,WwFvV8B;ExFwV9B,UwFxV8B;AhJ0/jClC;AwDhqjCE;EACE,WwF3V8B;AhJ6/jClC;AwDhqjCE;;EAEE,awF7V+B;ExF8V/B,WwF7VgC;AhJ+/jCpC;AwDhqjCE;;EAEE,WwFpW8B;AhJsgkClC;AwDhqjCE;EACE,WAAA;AxDkqjCJ;AwD7pjCE;EACE,awFxW8B;ExFyW9B,YwFzW8B;AhJwgkClC;AwD7pjCE;EACE,awF5W8B;AhJ2gkClC;AwD7pjCE;;EAEE,awF9W+B;ExF+W/B,WwF9WgC;AhJ6gkCpC;AwD7pjCE;;EAEE,awFrX8B;AhJohkClC;AwD7pjCE;EACE,cAAA;AxD+pjCJ;AyDrlkCE;EACE,gBAAA;EACA,gBwFLgB;ExFMhB,YwFLa;AjJ4lkCjB;AyD/kkCE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AzDilkCJ;AyD7kkCE;EACE,eAAA;EACA,UAAA;EACA,WAAA;AzD+kkCJ;AyD3kkCE;;EAEE,MAAA;EACA,YAAA;AzD6kkCJ;AyD3kkCE;;EAEE,SAAA;EACA,SAAA;AzD6kkCJ;AyDrkkCE;EACE,wBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AzDukkCJ;A0DrnkCE;EACE,aAAA;A1DunkCJ;A0D5mkCE;;EAEE,cAAA;A1D8mkCJ;A0DvmkCE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBwF5BqB;AlJqokCzB;A0DvmkCE;EACE,6BAAA;EACA,yBAAA;A1DymkCJ;A0DtmkCE;;EAEE,kBAAA;EACA,WAAA;EACA,QwFnC2B;ExFoC3B,SAAA;EAEA,2CoB1CY;EpB2CZ,YwFtCc;ExFuCd,awFvCc;ExFyCd,qBsBhDc;EtBiDd,sCAAA;A1DsmkCJ;A0DpmkCE;;EAEE,kBAAA;EACA,WAAA;EACA,QwFjD2B;ExFkD3B,SAAA;EAEA,2CoBxDY;EpByDZ,YwFpDc;ExFqDd,awFrDc;ExFuDd,sCAAA;EACA,2BAAA;EACA,qBsBhEc;EtBkEd,iCAAA;A1DmmkCJ;A2DhqkCE;EACI,eAAA;EACA,aAAA;A3DkqkCN;A2D/pkCE;EACI,mBiBkES;EjBjET,qBiBiES;EjBhET,2BiBgES;A5EimkCf;A2D9pkCE;EACI,mBiB4DS;EjB3DT,oBiB2DS;EjB1DT,4BiB0DS;A5EsmkCf;A2D7pkCE;EACI,SAAA;EACA,6BAAA;EACA,mBiBoDS;A5E2mkCf;A2D5pkCE;EACI,sBiBgDS;EjB/CT,qBiB+CS;EjB9CT,2BiB8CS;A5EgnkCf;A2D3pkCE;EACI,sBiB0CS;EjBzCT,oBiByCS;EjBxCT,4BiBwCS;A5EqnkCf;A2D1pkCE;EACI,SAAA;EACA,6BAAA;EACA,sBiBkCS;A5E0nkCf;A2DrpkCE;EACI,cAAA;EACA,8BiBhDC;EjBiDD,2ByC/CU;EzCgDV,ewF7CS;ExF8CT,+BkB/CgB;A7EsskCtB;A2DppkCE;;EAEE,kFmDrDc;A9G2skClB;A2DnpkCE;EACE,mGAAA;A3DqpkCJ;A2DlpkCE;;EAEI,iBAAA;A3DopkCN;A2DjpkCE;EACI,kBAAA;A3DmpkCN;A2DhpkCE;;;EAGI,yBAAA;A3DkpkCN;A2D9okCE;EACE,cAAA;EACA,YwFhFU;AnJgukCd;A2D7okCE;;EAEI,UwF5EmB;ExF6EnB,ewF5EkB;AnJ2tkCxB;A2D3okCE;EACE,iBwFxEyB;AnJqtkC7B;A2D1okCE;EACI,iBAAA;A3D4okCN;A2DzokCE;EACI,yB0C3FO;ArGsukCb;A2DxokCE;EACI,yB0C3FU;ArGqukChB;A2DvokCE;EACI,yBwB9GE;AnFuvkCR;A2DtokCE;EACI,yBwBtHA;AnF8vkCN;A2DrokCE;EACI,iEAAA;A3DuokCN;A2DpokCE;EACI,yEAAA;A3DsokCN;A2DnokCE;EACI,uEAAA;A3DqokCN;A2DlokCE;EACI,wEAAA;A3DookCN;A2DvnkCM;EACE,yBAJE;A3D6nkCV;A2DtnkCQ;;EAEE,yBARA;A3DgokCV;A2D9nkCM;EACE,yBAJE;A3DookCV;A2D7nkCQ;;EAEE,yBARA;A3DuokCV;A2DrokCM;EACE,yBAJE;A3D2okCV;A2DpokCQ;;EAEE,yBARA;A3D8okCV;A2D5okCM;EACE,yBAJE;A3DkpkCV;A2D3okCQ;;EAEE,yBARA;A3DqpkCV;A2DnpkCM;EACE,yBAJE;A3DypkCV;A2DlpkCQ;;EAEE,yBARA;A3D4pkCV;A2D1pkCM;EACE,yBAJE;A3DgqkCV;A2DzpkCQ;;EAEE,yBARA;A3DmqkCV;A2DjqkCM;EACE,yBAJE;A3DuqkCV;A2DhqkCQ;;EAEE,yBARA;A3D0qkCV;A2DxqkCM;EACE,yBAJE;A3D8qkCV;A2DvqkCQ;;EAEE,yBARA;A3DirkCV;A2D/qkCM;EACE,yBAJE;A3DqrkCV;A2D9qkCQ;;EAEE,yBARA;A3DwrkCV;A2DtrkCM;EACE,yBAJE;A3D4rkCV;A2DrrkCQ;;EAEE,yBARA;A3D+rkCV;A2D7rkCM;EACE,yBAJE;A3DmskCV;A2D5rkCQ;;EAEE,yBARA;A3DsskCV;A2DpskCM;EACE,yBAJE;A3D0skCV;A2DnskCQ;;EAEE,yBARA;A3D6skCV;A2D3skCM;EACE,yBAJE;A3DitkCV;A2D1skCQ;;EAEE,yBARA;A3DotkCV;A2DltkCM;EACE,yBAJE;A3DwtkCV;A2DjtkCQ;;EAEE,yBARA;A3D2tkCV;A2DztkCM;EACE,yBAJE;A3D+tkCV;A2DxtkCQ;;EAEE,yBARA;A3DkukCV;A2DntkCI;EACE,0BM9JO;AjEm3kCb;A2D9skCE;EACI,qBAAA;EACA,sBwF/IsB;ExFgJtB,gBwF/IiB;ExFgJjB,kBAAA;A3DgtkCN;A2D3skCE;EACI,qBAAA;EACA,sBwFpJyB;AnJi2kC/B;A2DtskCE;EACI,YAAA;A3DwskCN;A2DrskCE;EACE,sDAAA;A3DuskCJ;A2DpskCE;EACI,kBwFzLgB;AnJ+3kCtB;A2DnskCE;;EAEI,aAAA;EACA,gBAAA;EACA,kBAAA;A3DqskCN;A2DnskCE;EACI,UAAA;A3DqskCN;A2DlskCE;EACE,kBAAA;A3DoskCJ;A2DjskCE;EACE,kBAAA;A3DmskCJ;A2D5rkCE;EACE,UwFrLuB;ExFsLvB,YwFrLyB;AnJm3kC7B;A2D1rkCE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UwF9LuB;ExF+LvB,YwF9LyB;ExF+LzB,YwF9LkB;ExF+LlB,6BwF9LqB;AnJ03kCzB;A2DzrkCE;EACE,UAAA;A3D2rkCJ;A4Dj6kCE;EACE,4BAAA;EACA,yBwFJ0B;ExFK1B,+ByFTa;EzFUb,yBwFPsB;ApJ06kC1B;A4D15kCE;EACE,2BwFb6B;ExFc7B,8BAAA;A5D45kCJ;A4Dx5kCE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;A5D05kCJ;A4Dt5kCE;EACE,aAAA;EACA,kBAAA;A5Dw5kCJ;A4Dp5kCE;EACE,yBAAA;EACA,8BAAA;EACF;gDAAA;A5Du5kCF;A4Dl5kCE;EACE,4BAAA;A5Do5kCJ;A4D74kCE;EACE,mCAAA;A5D+4kCJ;A6Dt7kCE;EACE,yBAAA;A7Dw7kCJ;A6Dt7kCE;EACE,wBAAA;A7Dw7kCJ;A6Dt7kCE;;EAEE,6BAAA;A7Dw7kCJ;A6Dt7kCE;EACE,8BAAA;A7Dw7kCJ;A6Dp7kCE;EACE;IACE,qCAAA;IACA,WAAA;E7Ds7kCJ;E6Dp7kCE;IACE,qCAAA;IACA,WAAA;IACA,YAAA;E7Ds7kCJ;E6Dp7kCE;IACE,sCAAA;IACA,UAAA;IACA,YAAA;E7Ds7kCJ;E6Dp7kCE;IACE,mCAAA;IACA,YAAA;E7Ds7kCJ;AACF;A6Dl7kCE;EACE;IACE,YAAA;IACA,qDAAA;E7Do7kCJ;E6Dl7kCE;IACE,WAAA;IACA,4EAAA;E7Do7kCJ;E6Dl7kCE;IACE,UAAA;E7Do7kCJ;E6Dl7kCE;IACE,WAAA;IACA,uEAAA;IACA,UAAA;E7Do7kCJ;AACF;A6Dl7kCE;EACE;IACE,YAAA;IACA,qDAAA;E7Do7kCJ;E6Dl7kCE;IACE,UAAA;IACA,2EAAA;E7Do7kCJ;E6Dl7kCE;IACE,UAAA;E7Do7kCJ;E6Dl7kCE;IACE,UAAA;IACA,uEAAA;IACA,UAAA;E7Do7kCJ;AACF;A6D56kCE;EACE,4BAAA;EACA,yBAAA;EACA,2DAAA;A7D86kCJ;A6D56kCE;EACE,sBAAA;A7D86kCJ;A6D56kCE;EACE,uBAAA;A7D86kCJ;A6D16kCE;EACE;IACE,UAAA;IACA,mBAAA;E7D46kCJ;E6D16kCE;IACE,UAAA;IACA,mBAAA;E7D46kCJ;AACF;A6D16kCE;EACE;IACE,UAAA;IACA,mBAAA;E7D46kCJ;E6D16kCE;IACE,UAAA;IACA,mBAAA;E7D46kCJ;AACF;A6Dr6kCE;EACE,sBAAA;A7Du6kCJ;A6Dr6kCE;EACE,wBAAA;A7Du6kCJ;A6Dr6kCE;EACE,0BAAA;A7Du6kCJ;A6Dr6kCE;EACE,0BAAA;A7Du6kCJ;A6Dr6kCE;EACE,2BAAA;A7Du6kCJ;A6Dp6kCE;EACE,uBAAA;A7Ds6kCJ;A6Dp6kCE;EACE,yBAAA;A7Ds6kCJ;A6Dp6kCE;EACE,2BAAA;A7Ds6kCJ;A6Dp6kCE;EACE,2BAAA;A7Ds6kCJ;A6Dp6kCE;EACE,4BAAA;A7Ds6kCJ;A6Dl6kCE;EACE;IACE,UAAA;E7Do6kCJ;E6Dl6kCE;IACE,UAAA;E7Do6kCJ;AACF;A6Dl6kCE;EACE;IACE,UAAA;IACA,0BAAA;E7Do6kCJ;E6Dl6kCE;IACE,UAAA;IACA,yBAAA;E7Do6kCJ;AACF;A6Dl6kCE;EACE;IACE,UAAA;IACA,2BAAA;E7Do6kCJ;E6Dl6kCE;IACE,UAAA;IACA,yBAAA;E7Do6kCJ;AACF;A6Dl6kCE;EACE;IACE,UAAA;IACA,0BAAA;E7Do6kCJ;E6Dl6kCE;IACE,UAAA;IACA,yBAAA;E7Do6kCJ;AACF;A6Dl6kCE;EACE;IACE,UAAA;IACA,2BAAA;E7Do6kCJ;E6Dl6kCE;IACE,UAAA;IACA,yBAAA;E7Do6kCJ;AACF;A6Dh6kCE;EACE;IACE,UAAA;E7Dk6kCJ;E6Dh6kCE;IACE,UAAA;E7Dk6kCJ;AACF;A6Dh6kCE;EACE;IACE,UAAA;IACA,yBAAA;E7Dk6kCJ;E6Dh6kCE;IACE,UAAA;IACA,yBAAA;E7Dk6kCJ;AACF;A6Dh6kCE;EACE;IACE,UAAA;IACA,yBAAA;E7Dk6kCJ;E6Dh6kCE;IACE,UAAA;IACA,0BAAA;E7Dk6kCJ;AACF;A6Dh6kCE;EACE;IACE,UAAA;IACA,yBAAA;E7Dk6kCJ;E6Dh6kCE;IACE,UAAA;IACA,yBAAA;E7Dk6kCJ;AACF;A6Dh6kCE;EACE;IACE,UAAA;IACA,yBAAA;E7Dk6kCJ;E6Dh6kCE;IACE,UAAA;IACA,0BAAA;E7Dk6kCJ;AACF;A6D35kCE;;EAEE,yBAAA;A7D65kCJ;A6D35kCE;EACE,gCAAA;A7D65kCJ;A6D35kCE;EACE,iCAAA;A7D65kCJ;A6D35kCE;EACE,8BAAA;A7D65kCJ;A6D35kCE;EACE,+BAAA;A7D65kCJ;A6Dz5kCE;EACE;IACE,8CAAA;IACA,UAAA;E7D25kCJ;E6Dz5kCE;IACE,4CAAA;IACA,UAAA;E7D25kCJ;AACF;A6Dz5kCE;EACE;IACE,8CAAA;IACA,UAAA;E7D25kCJ;E6Dz5kCE;IACE,4CAAA;IACA,UAAA;E7D25kCJ;AACF;A6Dv5kCE;EACE;IACE,4CAAA;IACA,UAAA;E7Dy5kCJ;E6Dv5kCE;IACE,6CAAA;IACA,UAAA;E7Dy5kCJ;AACF;A6Dv5kCE;EACE;IACE,4CAAA;IACA,UAAA;E7Dy5kCJ;E6Dv5kCE;IACE,8CAAA;IACA,UAAA;E7Dy5kCJ;AACF;A6Dl5kCE;EACE,uBAAA;A7Do5kCJ;A6Dl5kCE;EACE,wBAAA;A7Do5kCJ;A6Dj5kCE;EACE;IACE,UAAA;IACA,qBAAA;E7Dm5kCJ;E6Dj5kCE;IACE,UAAA;IACA,mBAAA;E7Dm5kCJ;AACF;A6D/4kCE;EACE;IACE,UAAA;IACA,mBAAA;E7Di5kCJ;E6D/4kCE;IACE,UAAA;IACA,qBAAA;E7Di5kCJ;AACF;A6Dx4kCE;EACE,wBAAA;EACA,+DAAA;A7D04kCJ;A6Dx4kCE;EACE,qBAAA;A7D04kCJ;A6Dx4kCE;EACE,uBAAA;A7D04kCJ;A6Dx4kCE;EACE,yBAAA;A7D04kCJ;A6Dx4kCE;EACE,yBAAA;A7D04kCJ;A6Dx4kCE;EACE,0BAAA;A7D04kCJ;A6Dt4kCE;EACE,sBAAA;A7Dw4kCJ;A6Dt4kCE;EACE,wBAAA;A7Dw4kCJ;A6Dt4kCE;EACE,0BAAA;A7Dw4kCJ;A6Dt4kCE;EACE,0BAAA;A7Dw4kCJ;A6Dt4kCE;EACE,2BAAA;A7Dw4kCJ;A6Dp4kCE;EACE;IACE,UAAA;IACA,iCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,iCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,iCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,UAAA;IACA,oCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,oCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,UAAA;IACA,2BAAA;E7Ds4kCJ;AACF;A6Dp4kCE;EACE;IACE,UAAA;IACA,oCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,UAAA;IACA,mCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,kCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,kCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,+BAAA;E7Ds4kCJ;AACF;A6Dp4kCE;EACE;IACE,UAAA;IACA,qCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,UAAA;IACA,kCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,mCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,iCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,eAAA;E7Ds4kCJ;AACF;A6Dp4kCE;EACE;IACE,UAAA;IACA,oCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,UAAA;IACA,mCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,kCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,kCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,eAAA;E7Ds4kCJ;AACF;A6Dp4kCE;EACE;IACE,UAAA;IACA,qCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,UAAA;IACA,kCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,mCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,iCAAA;E7Ds4kCJ;E6Dp4kCE;IACE,eAAA;E7Ds4kCJ;AACF;A6Dl4kCE;EACE;IACE,iCAAA;E7Do4kCJ;E6Dl4kCE;IACE,UAAA;IACA,iCAAA;E7Do4kCJ;E6Dl4kCE;IACE,UAAA;IACA,iCAAA;E7Do4kCJ;AACF;A6Dl4kCE;EACE;IACE,kCAAA;E7Do4kCJ;E6Dl4kCE;IACE,UAAA;IACA,mCAAA;E7Do4kCJ;E6Dl4kCE;IACE,UAAA;IACA,oCAAA;E7Do4kCJ;AACF;A6Dl4kCE;EACE;IACE,mCAAA;E7Do4kCJ;E6Dl4kCE;IACE,UAAA;IACA,kCAAA;E7Do4kCJ;E6Dl4kCE;IACE,UAAA;IACA,qCAAA;E7Do4kCJ;AACF;A6Dl4kCE;EACE;IACE,UAAA;IACA,kCAAA;E7Do4kCJ;E6Dl4kCE;IACE,UAAA;IACA,qCAAA;E7Do4kCJ;AACF;A6Dl4kCE;EACE;IACE,UAAA;IACA,mCAAA;E7Do4kCJ;E6Dl4kCE;IACE,UAAA;IACA,oCAAA;E7Do4kCJ;AACF;A6D73kCE;;EAEE,wBAAA;EACA,4BAAA;A7D+3kCJ;A6D73kCE;EACE,wBAAA;EACA,+BAAA;A7D+3kCJ;A6D73kCE;EACE,wBAAA;EACA,8BAAA;A7D+3kCJ;A6D73kCE;EACE,wBAAA;EACA,6BAAA;A7D+3kCJ;A6D53kCE;;EAEE,yBAAA;EACA,4BAAA;A7D83kCJ;A6D53kCE;EACE,yBAAA;EACA,+BAAA;A7D83kCJ;A6D53kCE;EACE,yBAAA;EACA,8BAAA;A7D83kCJ;A6D53kCE;EACE,yBAAA;EACA,6BAAA;A7D83kCJ;A6D13kCE;EACE;IACE,UAAA;IACA,oBAAA;E7D43kCJ;E6D13kCE;IACE,UAAA;IACA,oBAAA;E7D43kCJ;AACF;A6D13kCE;EACE;IACE,UAAA;IACA,oBAAA;E7D43kCJ;E6D13kCE;IACE,UAAA;IACA,oBAAA;E7D43kCJ;AACF;A6Dx3kCE;EACE;IACE,UAAA;IACA,oBAAA;E7D03kCJ;E6Dx3kCE;IACE,UAAA;IACA,oBAAA;E7D03kCJ;AACF;A6Dx3kCE;EACE;IACE,UAAA;IACA,oBAAA;E7D03kCJ;E6Dx3kCE;IACE,UAAA;IACA,oBAAA;E7D03kCJ;AACF;A6Dl3kCE;EACE,yBAAA;A7Do3kCJ;A6Dj3kCE;EACE,wBAAA;EACA,4BAAA;A7Dm3kCJ;A6Dj3kCE;EACE,wBAAA;EACA,+BAAA;A7Dm3kCJ;A6Dj3kCE;EACE,wBAAA;EACA,8BAAA;A7Dm3kCJ;A6Dj3kCE;EACE,wBAAA;EACA,6BAAA;A7Dm3kCJ;A6Dh3kCE;;EAEE,yBAAA;EACA,4BAAA;A7Dk3kCJ;A6Dh3kCE;EACE,yBAAA;EACA,+BAAA;A7Dk3kCJ;A6Dh3kCE;EACE,yBAAA;EACA,8BAAA;A7Dk3kCJ;A6Dh3kCE;EACE,yBAAA;EACA,6BAAA;A7Dk3kCJ;A6D92kCE;EACE;IACE,6CAAA;IACA,UAAA;E7Dg3kCJ;E6D92kCE;IACE,8CAAA;IACA,UAAA;E7Dg3kCJ;E6D92kCE;IACE,6CAAA;E7Dg3kCJ;E6D92kCE;IACE,+CAAA;E7Dg3kCJ;E6D92kCE;IACE,4CAAA;E7Dg3kCJ;AACF;A6D92kCE;EACE;IACE,8CAAA;IACA,UAAA;E7Dg3kCJ;E6D92kCE;IACE,6CAAA;IACA,UAAA;E7Dg3kCJ;E6D92kCE;IACE,gDAAA;E7Dg3kCJ;E6D92kCE;IACE,8CAAA;E7Dg3kCJ;E6D92kCE;IACE,4CAAA;E7Dg3kCJ;AACF;A6D52kCE;EACE;IACE,4CAAA;E7D82kCJ;E6D52kCE;IACE,+CAAA;E7D82kCJ;E6D52kCE;IACE,+CAAA;E7D82kCJ;E6D52kCE;IACE,8CAAA;IACA,UAAA;E7D82kCJ;E6D52kCE;IACE,6CAAA;IACA,UAAA;E7D82kCJ;AACF;A6D52kCE;EACE;IACE,4CAAA;E7D82kCJ;E6D52kCE;IACE,8CAAA;E7D82kCJ;E6D52kCE;IACE,8CAAA;E7D82kCJ;E6D52kCE;IACE,6CAAA;IACA,UAAA;E7D82kCJ;E6D52kCE;IACE,8CAAA;IACA,UAAA;E7D82kCJ;AACF;A6Dt2kCE;EACE,sBAAA;A7Dw2kCJ;A6Dt2kCE;EACE,uBAAA;A7Dw2kCJ;A6Dt2kCE;EACE;IACE,UAAA;IACA,mBAAA;E7Dw2kCJ;E6Dt2kCE;IACE,UAAA;IACA,mBAAA;E7Dw2kCJ;AACF;A6Dt2kCE;EACE;IACE,UAAA;IACA,mBAAA;E7Dw2kCJ;E6Dt2kCE;IACE,UAAA;IACA,mBAAA;E7Dw2kCJ;AACF;A6D31kCE;EACE,yBAAA;EACA,qBAAA;A7D61kCJ;A6D31kCE;EACE,yBAAA;EACA,qBAAA;A7D61kCJ;A6D31kCE;EACE,yBAAA;EACA,sBAAA;A7D61kCJ;A6D31kCE;EACE,yBAAA;EACA,oBAAA;A7D61kCJ;A6D31kCE;EACE,yBAAA;EACA,qBAAA;A7D61kCJ;A6D31kCE;EACE,yBAAA;EACA,sBAAA;A7D61kCJ;A6D31kCE;EACE,0BAAA;EACA,yDAAA;A7D61kCJ;A6D31kCE;EACE,oBAAA;A7D61kCJ;A6Dx1kCE;EACE;IACE,UAAA;E7D01kCJ;E6Dx1kCE;IACE,UAAA;E7D01kCJ;AACF;A6Dt1kCE;EACE;IACE,wBAAA;E7Dw1kCJ;E6Dt1kCE;IACE,4BAAA;E7Dw1kCJ;E6Dt1kCE;IACE,2BAAA;E7Dw1kCJ;AACF;A6Dp1kCE;EACE;IACE,wBAAA;E7Ds1kCJ;E6Dp1kCE;IACE,4BAAA;E7Ds1kCJ;E6Dp1kCE;IACE,4BAAA;E7Ds1kCJ;AACF;A6Dl1kCE;EACE;IACE,mBAAA;E7Do1kCJ;E6Dl1kCE;IACE,mCAAA;E7Do1kCJ;E6Dl1kCE;IACE,kCAAA;E7Do1kCJ;E6Dl1kCE;IACE,mCAAA;E7Do1kCJ;E6Dl1kCE;IACE,6BAAA;E7Do1kCJ;AACF;A6Dh1kCE;EACE;IACE,mBAAA;IACA,UAAA;E7Dk1kCJ;E6Dh1kCE;IACE,qBAAA;IACA,YAAA;E7Dk1kCJ;E6Dh1kCE;IACE,mBAAA;IACA,UAAA;E7Dk1kCJ;AACF;A6D70kCE;EACE;IACE,2BAAA;E7D+0kCJ;E6D70kCE;IACE,iCAAA;E7D+0kCJ;E6D70kCE;IACE,iCAAA;E7D+0kCJ;E6D70kCE;IACE,iCAAA;E7D+0kCJ;E6D70kCE;IACE,iCAAA;E7D+0kCJ;E6D70kCE;IACE,iCAAA;E7D+0kCJ;E6D70kCE;IACE,2BAAA;E7D+0kCJ;AACF;A6D30kCE;EACE;IACE,yBAAA;E7D60kCJ;E6D30kCE;IACE,yBAAA;E7D60kCJ;E6D30kCE;IACE,yBAAA;E7D60kCJ;AACF;AAzvmCE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;EIlBF,iDAAA;EACA,sBAAA;EAeA,gBAAA;EAWA,iBAAA;EACA,uBAAA;EACA,eAAA;AJsvmCF;AA9vmCE;ECHA,kBAAA;EACA,iBArBkB;EAsBlB,cAAA;ADowmCF;ACnwmCE;EDAA;ICCE,kBArBiB;IAsBjB,mBAtBiB;ED4xmCnB;ECrwmCE;IACE,eAAA;IACA,gBAAA;EDuwmCJ;AACF;ACvwmCM;EAHF;IAII,kBA3Ba;IA4Bb,mBA5Ba;EDsymCnB;AACF;AA/wmCI;EACE,WAAA;EACA,cAAA;EACA,wBAAA;AAixmCN;AA5wmCI;;EACE,iDAAA;AA+wmCN;AA3wmCI;EItCF,iDAAA;EACA,sBAAA;EAeA,gBAAA;EAWA,iBAAA;EACA,uBAAA;EACA,eAAA;AJ4xmCF;AA9wmCI;EI+EF,wDAAA;EACA,gBAAA;AJksmCF;AA/wmCI;EAAK,gBAAA;AAkxmCT;AAjxmCI;EAAK,gBAAA;AAoxmCT;AAlxmCE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAoxmCJ;AAlxmCE;EACE,cAAA;EACA,cAAA;AAoxmCJ;AAlxmCE;EACE,kBAAA;AAoxmCJ;AAlxmCE;EACE,aAAA;EACA,sBAAA;AAoxmCJ;AAnxmCI;EACE,OAAA;AAqxmCN;AAlxmCE;EACE,iCsJpDS;EtJqDT,qBAAA;AAoxmCJ;AAnxmCI;EACE,0BAAA;AAqxmCN;AAlxmCE;EACE,oBAAA;AAoxmCJ;AAlxmCE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAoxmCJ","sourcesContent":["@use '/src/styling/kr';\n@use '/src/styling/fonts';\n@use '/src/styling/table';\n\n@include kr.semantic_ui_overrides;\n@include kr.globnav_overrides;\n\n$font-name: \"Amplitude Wide\";\n\n@media ( max-width: kr.$mobile-width ) {\n  .front>.page-content>.row {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n\n.kb-labfront.container {\n  @include table.reset;\n  @import '/src/styling/fomantic';\n  margin-bottom: 50px;\n  & {\n    position: relative;\n    width: 100%;\n    min-height: 500px;\n    box-sizing: border-box;\n    padding: 0;\n    @include fonts.font-amplitude-regular-16px;\n  }\n  .page-dim {\n    @include kr.max-page-dim;\n  }\n  a {\n    &.no-hover:hover {\n      all: revert;\n      color: inherit;\n      text-decoration: inherit;\n    }\n  }\n  .light-blue-theme,\n  .blue-theme {\n    a.ext-link::after {\n      content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiBmaWxsPSJub25lIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTU5Nl8yKSI+PHBhdGggZD0iTTkuNDExNzYgOS43MjY3NUM5LjQxMTc2IDEwLjIwMzIgOS4wMjM1MyAxMC41OTE1IDguNTQ3MDYgMTAuNTkxNUgyLjI3NjQ3QzEuOCAxMC41OTE1IDEuNDExNzYgMTAuMjAzMiAxLjQxMTc2IDkuNzI2NzVWMy40NTYxNkMxLjQxMTc2IDIuOTc5NjkgMS44IDIuNTkxNDUgMi4yNzY0NyAyLjU5MTQ1SDQuMDU4ODJWMS4xNzk2OUgyLjI3NjQ3QzEuMDIzNTMgMS4xNzk2OSAwIDIuMTk3MzMgMCAzLjQ1NjE2VjkuNzMyNjNDMCAxMC45ODU2IDEuMDIzNTMgMTIuMDA5MSAyLjI3NjQ3IDEyLjAwOTFIOC41NTI5NEM5LjgwNTg4IDEyLjAwOTEgMTAuODI5NCAxMC45OTE1IDEwLjgyOTQgOS43MzI2M1Y3Ljk1MDI4SDkuNDE3NjVWOS43MzI2M0w5LjQxMTc2IDkuNzI2NzVaIiBmaWxsPSIjZmZmZmZmIi8+PHBhdGggZD0iTTYuMTc3NjIgMFYxLjQxMTc2SDkuNTg5MzhMMy43MDcwMyA3LjI5NDEyTDQuNzA3MDMgOC4yOTQxMkwxMC41ODk0IDIuNDExNzZWNS44MjM1M0gxMi4wMDExVjBINi4xNzc2MloiIGZpbGw9IiNmZmZmZmYiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJjbGlwMF8xNTk2XzIiPjxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgZmlsbD0id2hpdGUiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4K');\n    }\n  }\n  p {\n    &.login-prompt {\n      @include fonts.font-amplitude-regular-16px;\n    }\n  }\n  header {\n    h1, h2 {\n      @include fonts.font-publico-banner;\n    }\n    h1 { font-weight: 900; }\n    h2 { font-weight: 700; }\n  }\n  .content {\n    position: relative;\n    margin: 0 auto;\n    width: 100%;\n    max-width: 1156px;\n    overflow: hidden;\n  }\n  .row {\n    display: block;\n    padding: 7px 0;\n  }\n  .segment.page-element {\n    margin-bottom: 2em;\n  }\n  .flex-container {\n    display: flex;\n    flex-direction: column;\n    .flex-item {\n      flex: 1;\n    }\n  }\n  a {\n    color: kr.$link-color;\n    text-decoration: none;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n  p {\n    margin-bottom: 1.5em;\n  }\n  p.tiny {\n    font-size: 0.8em;\n    line-height: 1.0em;\n    font-weight: 300;\n    color: #333;\n  }\n};","@forward 'kr_colors';\n@forward 'semantic_ui_overrides';\n@forward 'labrador_overrides';\n\n// Maximum page size\n$max_content_width: 1156px;\n\n// Minimum left/right padding\n$min_content_gutter: 22px;\n\n// Minimum left/right padding\n$ui-grid-breakpoint: 768px;\n\n// Breakpoints\n$mobile_width: 960px;\n$tablet_width: $max_content_width + ( 2 * $min_content_gutter ); // 1200 px\n\n:root {\n  --kr-mobile-width: #{$mobile-width};\n  --kr-tablet-width: #{$tablet-width};\n  --ui-grid-breakpoint: #{$ui-grid-breakpoint};\n  --kr-max-content-width: #{$max_content_width};\n}\n\n@mixin max-page-dim {\n  position: relative;\n  max-width: $max_content_width;\n  margin: 0 auto;\n  @media ( max-width: $tablet-width ) {\n    padding-left: $min_content_gutter;\n    padding-right: $min_content_gutter;\n    &.no-gutter {\n      padding-left: 0;\n      padding-right: 0;\n      @media ( min-width: 748px ) and ( max-width: ( $max_content_width + ( $min_content_gutter * 2 ) ) ) {\n        padding-left: $min_content_gutter;\n        padding-right: $min_content_gutter;\n      }\n    }\n  }\n}","/* Reset Labrador's default table styling */\n@mixin reset {\n  table {\n    .even,\n    .alt,\n    :nth-of-type(even),\n    :last-child {\n      border-right: none;\n    }\n    .even,\n    .alt,\n    :nth-of-type(even) {\n      background-color: inherit;\n    }\n  }\n}","@use '/src/styling/fonts';\n\n@mixin semantic_ui_overrides {\n  html {\n    font-size: 16px !important; // Semantic UI sets this to 14px, that mangles subsequent use of rems\n  }\n  .main.front { // reset intrusive margin setting\n    figure, h1, h2, h3, h4, h5 {\n      margin: initial;\n    }\n  }\n  /* Bugfix for clearable dropdown lists */\n  .kb-labfront.container .ui.dropdown > .dropdown.icon.clear:before {\n    content: \"\\f00d\" !important;\n    font-family: \"Icons\" !important;\n  }  \n  .kb-labfront.container .ui.dropdown .menu > .item {\n    & > .text {\n      @include fonts.font-amplitude-regular-16px;\n    }\n    &.selected {\n      font-weight: 400 !important;\n    }\n  }\n  .kb-labfront.container .ui.selection.dropdown > .text {\n    @include fonts.font-amplitude-regular-16px;\n  }\n  .kb-labfront.container .ui.selection.visible.dropdown > .text:not(.default) {\n    font-weight: 200 !important;\n  }\n  .kb-labfront.container .ui.dropdown.selection .divider.default.text {\n    color: #000;\n  }\n}\n","@mixin font-merriweather-regular-17px {\n  font-family: \"Merriweather\", serif;\n  font-weight: 400;\n  font-size: 17px;\n}\n\n@mixin font-amplitude {\n  font-family: \"Amplitude Wide\", \"Lato\", sans-serif;\n  letter-spacing: -0.3px;\n}\n\n@mixin font-amplitude-bold {\n  @include font-amplitude;\n  font-weight: 700;\n}\n\n@mixin font-amplitude-light {\n  @include font-amplitude;\n  font-weight: 200;\n}\n\n@mixin font-amplitude-regular {\n  @include font-amplitude;\n  font-weight: 300;\n}\n\n@mixin font-amplitude-light-16px {\n  @include font-amplitude-light;\n  line-height: 16px;\n  font-size: 16px;  \n}\n\n@mixin font-amplitude-regular-16px {\n  @include font-amplitude-regular;\n  line-height: 142%;\n  letter-spacing: -0.48px;\n  font-size: 16px;  \n}\n\n@mixin font-amplitude-regular-16px-uppercase {\n  @include font-amplitude-regular-16px;\n  text-transform: uppercase;\n}\n\n@mixin font-amplitude-regular-18px {\n  @include font-amplitude-regular;\n  line-height: 25.6px;\n  letter-spacing: -0.54px;\n  font-size: 18px;\n}\n\n@mixin font-amplitude-bold-18px {\n  @include font-amplitude-regular-18px;\n  font-weight: 500;\n}\n\n@mixin font-amplitude-regular-18px-uppercase {\n  @include font-amplitude-regular-18px;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n@mixin font-amplitude-20px {\n  @include font-amplitude;\n  font-size: 20px;\n  line-height: 28.4px;\n  letter-spacing: -0.6px;\n}\n\n@mixin font-amplitude-22px {\n  @include font-amplitude;\n  font-size: 22px;\n  line-height: 31.24px;\n  letter-spacing: -0.66px;\n}\n\n@mixin font-amplitude-regular-20px {\n  @include font-amplitude-regular;\n  font-size: 20px;\n}\n\n@mixin font-amplitude-regular-22px {\n  @include font-amplitude-regular;\n  font-size: 22px;\n}\n\n@mixin font-amplitude-medium {\n  @include font-amplitude;\n  font-weight: 500;\n}\n\n@mixin font-amplitude-book {\n  @include font-amplitude;\n  font-weight: 300;\n}\n\n@mixin font-amplitude-book-12px {\n  @include font-amplitude-book;\n  font-size: 12px;\n}\n\n@mixin font-amplitude-book-15px {\n  @include font-amplitude-book;\n  font-size: 15px;\n}\n\n@mixin font-amplitude-medium-12px {\n  @include font-amplitude-medium;\n  font-size: 12px;\n}\n\n@mixin font-amplitude-medium-13px {\n  @include font-amplitude-medium;\n  font-size: 13px;\n}\n\n@mixin font-amplitude-medium-15px {\n  @include font-amplitude-medium;\n  font-size: 15px;\n}\n\n@mixin font-amplitude-medium-20px {\n  @include font-amplitude-medium;\n  font-size: 20px;\n  line-height: 28.4px;\n  letter-spacing: -0.6px;\n}\n\n@mixin font-publico-banner {\n  font-family: \"Publico Banner Web\", \"Merriweather\", serif;\n  font-weight: 700;\n}\n\n@mixin font-publico-banner-regular {\n  font-family: \"Publico Banner Web\", \"Merriweather\", serif;\n  font-weight: 400;\n}\n\n@mixin font-publico-banner-18px {\n  @include font-publico-banner;\n  font-size: 18px;\n  line-height: 18px;\n}\n\n@mixin font-publico-banner-20px {\n  @include font-publico-banner;\n  font-size: 20px;\n  line-height: 20px;\n}\n\n@mixin font-publico-banner-22px {\n  @include font-publico-banner;\n  letter-spacing: 0;\n  font-size: 22px;\n  line-height: 22px;\n  font-weight: 400;\n}\n\n@mixin font-publico-banner-24px {\n  @include font-publico-banner;\n  font-size: 24px;\n  line-height: 29.8px;\n}\n\n@mixin font-publico-banner-25px {\n  @include font-publico-banner;\n  font-size: 25px;\n  line-height: 31px;\n}\n\n@mixin font-publico-banner-26px {\n  @include font-publico-banner;\n  font-size: 26px;\n  line-height: 35.1px;\n  letter-spacing: initial;\n}\n\n@mixin font-publico-banner-30px {\n  @include font-publico-banner;\n  font-size: 30px;\n  line-height: 37.2px;\n}\n\n@mixin font-publico-banner-32px {\n  @include font-publico-banner;\n  font-size: 32px;\n  line-height: 40.9px;\n}\n\n@mixin font-publico-banner-33px {\n  @include font-publico-banner;\n  font-size: 33px;\n  line-height: 40.9px;\n}\n\n@mixin font-publico-banner-35px {\n  @include font-publico-banner;\n  font-size: 35px;\n  line-height: 35px;\n}\n\n@mixin font-publico-banner-36px {\n  @include font-publico-banner;\n  font-size: 36px;\n  line-height: 44.6px;\n}\n\n@mixin font-publico-banner-40px {\n  @include font-publico-banner;\n  font-size: 40px;\n  line-height: 49.6px;\n}\n\n@mixin font-publico-banner-44px {\n  @include font-publico-banner;\n  font-size: 44px;\n  line-height: 54.56px;\n}\n\n@mixin font-publico-banner-60px {\n  @include font-publico-banner;\n  font-size: 60px;\n  line-height: 74.4px;\n}\n\n@mixin font-publico-banner-70px {\n  @include font-publico-banner;\n  font-size: 70px;\n  line-height: 89.3px;\n}\n\n@mixin font-publico-banner-85px {\n  @include font-publico-banner;\n  font-size: 85px;\n  line-height: 105.4px;\n}\n\n@mixin font-publico-banner-regular-20px {\n  @include font-publico-banner-20px;\n  font-weight: 300;\n  line-height: 24.8px;\n}\n\n@mixin font-publico-banner-regular-22px {\n  @include font-publico-banner-22px;\n  font-weight: 300;\n  line-height: 29.7px;\n}\n\n@mixin font-publico-banner-regular-24px {\n  @include font-publico-banner-24px;\n  font-weight: 300;\n}\n\n@mixin font-publico-banner-regular-26px {\n  @include font-publico-banner-26px;\n  font-weight: 300;\n}\n\n@mixin font-publico-banner-extrabold-22px {\n  @include font-publico-banner-22px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-24px {\n  @include font-publico-banner-24px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-25px {\n  @include font-publico-banner-25px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-26px {\n  @include font-publico-banner-26px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-30px {\n  @include font-publico-banner-30px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-bold-32px {\n  @include font-publico-banner-32px;\n  font-weight: 800;\n}\n\n@mixin font-publico-banner-extrabold-32px {\n  @include font-publico-banner-32px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-regular-32px {\n  @include font-publico-banner-32px;\n  font-weight: 400;\n}\n\n@mixin font-publico-banner-extrabold-33px {\n  @include font-publico-banner-33px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-35px {\n  @include font-publico-banner-35px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-36px {\n  @include font-publico-banner-36px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-40px {\n  @include font-publico-banner-40px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-44px {\n  @include font-publico-banner-44px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-regular-36px {\n  @include font-publico-banner-36px;\n  font-weight: 100;\n}\n\n@mixin font-publico-banner-extrabold-60px {\n  @include font-publico-banner-60px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-70px {\n  @include font-publico-banner-70px;\n  font-weight: 900;\n}\n\n@mixin font-publico-banner-extrabold-85px {\n  @include font-publico-banner-85px;\n  font-weight: 900;\n}\n\n@mixin ingress {\n  @include font-publico-banner-22px;\n  line-height: 27.3px;\n}\n\n@mixin widget {\n  h3.ui.header {\n    @include font-amplitude-regular-16px-uppercase;\n  }\n}\n\n@mixin table {\n  tbody {\n    td {\n      @include font-amplitude;\n      .ui.header {\n        font-size: 18px;\n        font-weight: 500;\n        .sub.header {\n          font-size: 16px;\n          font-weight: 300;\n        }\n      }\n    }\n  }\n  thead th {\n    @include font-amplitude-regular-18px-uppercase;\n  }\n  tfoot th {\n    @include font-amplitude-light-16px;\n  }\n}\n\n@mixin list {\n  @include font-amplitude;\n  h3.ui.header {\n    @include font-amplitude;\n  }\n  .header {\n    font-weight: 700 !important;\n  }\n  .description {\n    font-weight: 300 !important;\n  }\n  .label {\n    font-weight: 500 !important;\n    font-size: 16px !important;\n  }\n}\n\n@mixin _promotion {\n  .ui.button {\n    @include font-amplitude-regular-18px-uppercase;\n  }\n}\n\n@mixin kb-promotion {\n  @include _promotion;\n}\n\n@mixin kb-login-prompt {\n  @include font-amplitude;\n}\n\n@mixin product {\n  p.description {\n    @include font-amplitude-regular-18px-uppercase;\n    line-height: 22px;\n  }\n  .ui.statistic.price-tag > .value {\n    @include font-publico-banner-20px;\n  }\n}\n\n@mixin municipality-info {\n  .ui.header {\n    @include font-publico-banner-35px;\n  }\n}\n\n@mixin page {\n  h1 {\n    @include font-publico-banner-extrabold-35px;\n  }\n  h3 {\n    @include font-publico-banner-extrabold-25px;\n  }\n  p {\n    @include font-merriweather-regular-17px;\n  }\n}\n\n@mixin ai-text {\n  @include font-merriweather-regular-17px;\n}\n\n@mixin chart {\n  @include font-amplitude;\n  h3.ui.header {\n    @include font-amplitude-regular-18px-uppercase;\n  }\n  svg {\n    @include font-amplitude;\n  }\n}","@mixin globnav_overrides {\n  header.pageHeader {\n    display: none;\n  }\n  .page-content > .row:first-child {\n    margin: 0px !important;\n    max-width: none !important;\n  }\n  section.main.front .page-content > .row:first-child {\n    margin-top: 0px !important;\n  }\n}\n","/*******************************\n             Reset\n*******************************/\n\n/* Border-Box */\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\nhtml {\n  box-sizing: border-box;\n}\n\n/* iPad Input Shadows */\ninput[type=\"text\"],\ninput[type=\"email\"],\ninput[type=\"search\"],\ninput[type=\"password\"] {\n  -webkit-appearance: none;\n  -moz-appearance: none; /* mobile firefox too! */\n}\n","/*******************************\r\n             Page\r\n*******************************/\r\n\r\n@if $import-google-fonts != false {\r\n    @import url(\"#{$google-protocol}fonts.googleapis.com/css?family=#{$google-font-request}\");\r\n}\r\n\r\nhtml,\r\nbody {\r\n  height: 100%;\r\n}\r\n\r\nhtml {\r\n  font-size: $em-size;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow-x: $page-overflow-x;\r\n  min-width: $page-min-width;\r\n  background: $page-background;\r\n  font-family: $page-font;\r\n  font-size: $font-size;\r\n  line-height: $line-height;\r\n  color: $text-color;\r\n}\r\n\r\n/*******************************\r\n             Headers\r\n*******************************/\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5 {\r\n  font-family: $header-font;\r\n  line-height: $header-line-height;\r\n  margin: $header-margin;\r\n  font-weight: $header-font-weight;\r\n  padding: 0;\r\n}\r\n\r\nh1 {\r\n  min-height: 1rem;\r\n  font-size: $h1;\r\n}\r\nh2 {\r\n  font-size: $h2;\r\n}\r\nh3 {\r\n  font-size: $h3;\r\n}\r\nh4 {\r\n  font-size: $h4;\r\n}\r\nh5 {\r\n  font-size: $h5;\r\n}\r\n\r\nh1:first-child,\r\nh2:first-child,\r\nh3:first-child,\r\nh4:first-child,\r\nh5:first-child {\r\n  margin-top: 0;\r\n}\r\n\r\nh1:last-child,\r\nh2:last-child,\r\nh3:last-child,\r\nh4:last-child,\r\nh5:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/*******************************\r\n             Text\r\n*******************************/\r\n\r\np {\r\n  margin: $paragraph-margin;\r\n  line-height: $paragraph-line-height;\r\n}\r\np:first-child {\r\n  margin-top: 0;\r\n}\r\np:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/*-------------------\r\n        Links\r\n--------------------*/\r\n\r\na {\r\n  color: $link-color;\r\n  text-decoration: $link-underline;\r\n}\r\na:hover {\r\n  color: $link-hover-color;\r\n  text-decoration: $link-hover-underline;\r\n}\r\n\r\n/*******************************\r\n         Scrollbars\r\n*******************************/\r\n\r\n@if ($use-custom-scrollbars) {\r\n  /* Force Simple Scrollbars */\r\n  body ::-webkit-scrollbar {\r\n    -webkit-appearance: none;\r\n    width: $custom-scrollbar-width;\r\n    height: $custom-scrollbar-height;\r\n  }\r\n  body ::-webkit-scrollbar-track {\r\n    background: $track-background;\r\n    border-radius: $track-border-radius;\r\n  }\r\n  body ::-webkit-scrollbar-thumb {\r\n    cursor: pointer;\r\n    border-radius: $thumb-border-radius;\r\n    background: $thumb-background;\r\n    transition: $thumb-transition;\r\n  }\r\n  body ::-webkit-scrollbar-thumb:window-inactive {\r\n    background: $thumb-inactive-background;\r\n  }\r\n  body ::-webkit-scrollbar-thumb:hover {\r\n    background: $thumb-hover-background;\r\n  }\r\n\r\n  /* Inverted UI */\r\n  body .ui.inverted:not(.dimmer)::-webkit-scrollbar-track {\r\n    background: $track-inverted-background;\r\n  }\r\n  body .ui.inverted:not(.dimmer)::-webkit-scrollbar-thumb {\r\n    background: $thumb-inverted-background;\r\n  }\r\n  body .ui.inverted:not(.dimmer)::-webkit-scrollbar-thumb:window-inactive {\r\n    background: $thumb-inverted-inactive-background;\r\n  }\r\n  body .ui.inverted:not(.dimmer)::-webkit-scrollbar-thumb:hover {\r\n    background: $thumb-inverted-hover-background;\r\n  }\r\n}\r\n\r\n/*******************************\r\n          Highlighting\r\n*******************************/\r\n\r\n/* Site */\r\n::-webkit-selection {\r\n  background-color: $highlight-background;\r\n  color: $highlight-color;\r\n}\r\n::-moz-selection {\r\n  background-color: $highlight-background;\r\n  color: $highlight-color;\r\n}\r\n::selection {\r\n  background-color: $highlight-background;\r\n  color: $highlight-color;\r\n}\r\n\r\n/* Form */\r\ntextarea::-webkit-selection,\r\ninput::-webkit-selection {\r\n  background-color: $input-highlight-background;\r\n  color: $input-highlight-color;\r\n}\r\ntextarea::-moz-selection,\r\ninput::-moz-selection {\r\n  background-color: $input-highlight-background;\r\n  color: $input-highlight-color;\r\n}\r\ntextarea::selection,\r\ninput::selection {\r\n  background-color: $input-highlight-background;\r\n  color: $input-highlight-color;\r\n}\r\n","@import '../../themes/default/elements/button.variables';\n\n@mixin addConsequence($consequence) {\n  $_backgroundColor: get('#{$consequence}.color', $consequence-colors-map);\n  $_backgroundColorHover: get('#{$consequence}.hover', $consequence-colors-map);\n  $_backgroundColorFocus: get('#{$consequence}.focus', $consequence-colors-map);\n  $_backgroundColorDown: get('#{$consequence}.down', $consequence-colors-map);\n  $_backgroundColorActive: get('#{$consequence}.active', $consequence-colors-map);\n  $_textColor: $button-positive-text-color;\n  $_textShadow: $button-positive-text-shadow;\n\n  /* Standard */\n  .ui.#{$consequence}.buttons .button,\n  .ui.#{$consequence}.button {\n    background-color: $_backgroundColor;\n    color: $_textColor;\n    text-shadow: $_textShadow;\n    background-image: $button-colored-background-image;\n  }\n  .ui.#{$consequence}.button {\n    box-shadow: $button-colored-box-shadow;\n  }\n  .ui.#{$consequence}.buttons .button:hover,\n  .ui.#{$consequence}.button:hover {\n    background-color: $_backgroundColorHover;\n    color: $_textColor;\n    text-shadow: $_textShadow;\n  }\n  .ui.#{$consequence}.buttons .button:focus,\n  .ui.#{$consequence}.button:focus {\n    background-color: $_backgroundColorFocus;\n    color: $_textColor;\n    text-shadow: $_textShadow;\n  }\n  .ui.#{$consequence}.buttons .button:active,\n  .ui.#{$consequence}.button:active {\n    background-color: $_backgroundColorDown;\n    color: $_textColor;\n    text-shadow: $_textShadow;\n  }\n  .ui.#{$consequence}.buttons .active.button,\n  .ui.#{$consequence}.buttons .active.button:active,\n  .ui.#{$consequence}.active.button,\n  .ui.#{$consequence}.button .active.button:active {\n    background-color: $_backgroundColorActive;\n    color: $_textColor;\n    text-shadow: $_textShadow;\n  }\n\n  @if($use-button-type-basic) {\n    /* Basic */\n    .ui.basic.#{$consequence}.buttons .button,\n    .ui.basic.#{$consequence}.button {\n      background: transparent;\n      box-shadow: 0 0 0 $button-basic-border-size $_backgroundColor inset;\n      color: $_backgroundColor;\n    }\n    .ui.basic.#{$consequence}.buttons .button:hover,\n    .ui.basic.#{$consequence}.button:hover {\n      background: transparent;\n      box-shadow: 0 0 0 $button-basic-colored-border-size $_backgroundColorHover\n        inset;\n      color: $_backgroundColorHover;\n    }\n    .ui.basic.#{$consequence}.buttons .button:focus,\n    .ui.basic.#{$consequence}.button:focus {\n      background: transparent;\n      box-shadow: 0 0 0 $button-basic-colored-border-size $_backgroundColorFocus\n        inset;\n      color: $_backgroundColorHover;\n    }\n    .ui.basic.#{$consequence}.buttons .active.button,\n    .ui.basic.#{$consequence}.active.button {\n      background: transparent;\n      box-shadow: 0 0 0 $button-basic-colored-border-size $_backgroundColorActive\n        inset;\n      color: $_backgroundColorDown;\n    }\n    .ui.basic.#{$consequence}.buttons .button:active,\n    .ui.basic.#{$consequence}.button:active {\n      box-shadow: 0 0 0 $button-basic-colored-border-size $_backgroundColorDown\n        inset;\n      color: $_backgroundColorDown;\n    }\n    .ui.buttons:not(.vertical) > .basic.#{$consequence}.button:not(:first-child) {\n      margin-left: -$button-basic-colored-border-size;\n    }\n  }\n}\n\n@if $use-button {\n  /*******************************\n  //@-        Button\n  *******************************/\n  \n  .ui.button {\n    cursor: pointer;\n    display: inline-block;\n  \n    min-height: 1em;\n  \n    outline: none;\n    border: none;\n    vertical-align: $button-vertical-align;\n    background: $button-background;\n    color: $button-text-color;\n  \n    font-family: $button-font-family;\n  \n    margin: 0 $button-horizontal-margin $button-vertical-margin 0;\n    padding: $button-vertical-padding $button-horizontal-padding ($button-vertical-padding + $button-shadow-offset);\n  \n    text-transform: $button-text-transform;\n    text-shadow: $button-text-shadow;\n    font-weight: $button-font-weight;\n    line-height: $button-line-height;\n    font-style: normal;\n    text-align: center;\n    text-decoration: none;\n  \n    border-radius: $button-border-radius;\n    box-shadow: $button-box-shadow;\n  \n    user-select: none;\n    transition: $button-transition;\n    will-change: $button-will-change;\n  \n    -webkit-tap-highlight-color: $button-tap-color;\n  }\n  \n  \n  /*******************************\n              States\n  *******************************/\n  \n  /*--------------\n        Hover\n  ---------------*/\n  \n  .ui.button:hover {\n    background-color: $button-hover-background-color;\n    background-image: $button-hover-background-image;\n    box-shadow: $button-hover-box-shadow;\n    color: $button-hover-color;\n  }\n  \n  .ui.button:hover .icon {\n    opacity: $button-icon-hover-opacity;\n  }\n  \n  /*--------------\n        Focus\n  ---------------*/\n  \n  .ui.button:focus {\n    background-color: $button-focus-background-color;\n    color: $button-focus-color;\n    background-image: $button-focus-background-image;\n    box-shadow: $button-focus-box-shadow;\n  }\n  \n  .ui.button:focus .icon {\n    opacity: $button-icon-focus-opacity;\n  }\n  \n  /*--------------\n        Down\n  ---------------*/\n  \n  .ui.button:active,\n  .ui.active.button:active {\n    background-color: $button-down-background-color;\n    background-image: $button-down-background-image;\n    color: $button-down-color;\n    box-shadow: $button-down-box-shadow;\n  }\n  \n  /*--------------\n       Active\n  ---------------*/\n  \n  .ui.active.button {\n    background-color: $button-active-background-color;\n    background-image: $button-active-background-image;\n    box-shadow: $button-active-box-shadow;\n    color: $button-active-color;\n  }\n  .ui.active.button:hover {\n    background-color: $button-active-hover-background-color;\n    background-image: $button-active-hover-background-image;\n    color: $button-active-hover-color;\n  }\n  .ui.active.button:active {\n    background-color: $button-active-background-color;\n    background-image: $button-active-background-image;\n  }\n  \n  \n  /*--------------\n      Loading\n  ---------------*/\n  \n  /* Specificity hack */\n  .ui.loading.loading.loading.loading.loading.loading.button {\n    position: relative;\n    cursor: default;\n    text-shadow: none !important;\n    color: transparent;\n    opacity: $button-loading-opacity;\n    pointer-events: $button-loading-pointer-events;\n    transition: $button-loading-transition;\n  }\n  .ui.loading.button:before {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n  \n    margin: $loader-margin;\n    width: $loader-size;\n    height: $loader-size;\n  \n    border-radius: $circular-radius;\n    border: $loader-line-width solid $button-inverted-loader-fill-color;\n  }\n  .ui.loading.button:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n  \n    margin: $loader-margin;\n    width: $loader-size;\n    height: $loader-size;\n  \n    border-radius: $circular-radius;\n  \n    animation: loader $loader-speed infinite linear;\n    border: $loader-line-width solid currentColor;\n    color: $inverted-loader-line-color;\n  \n    box-shadow: 0 0 0 1px transparent;\n  }\n  @if($use-button-type-labeled) {\n    .ui.labeled.icon.loading.button .icon {\n      background-color: transparent;\n      box-shadow: none;\n    }\n  }\n  \n  @if($use-button-type-basic) {\n    .ui.basic.loading.button:not(.inverted):before {\n      border-color: $loader-fill-color;\n    }\n    .ui.basic.loading.button:not(.inverted):after {\n      border-color: $loader-line-color;\n    }\n  }\n  /*-------------------\n        Disabled\n  --------------------*/\n  \n  .ui.buttons .disabled.button:not(.basic),\n  .ui.disabled.button,\n  .ui.button:disabled,\n  .ui.disabled.button:hover,\n  .ui.disabled.active.button {\n    cursor: default;\n    opacity: $disabled-opacity !important;\n    background-image: none;\n    box-shadow: none;\n    pointer-events: none !important;\n  }\n  \n  @if($use-button-type-basic) {\n    /* Basic Group With Disabled */\n    .ui.basic.buttons .ui.disabled.button {\n      border-color: $disabled-border-color;\n    }\n  }\n  /*******************************\n               Types\n  *******************************/\n  \n  @if($use-button-type-animated) {\n    /*-------------------\n           Animated\n    --------------------*/\n    .ui.animated.button {\n      position: relative;\n      overflow: hidden;\n      padding-right: 0 !important;\n      vertical-align: $button-animated-vertical-align;\n      z-index: $button-animated-z-index;\n    }\n    \n    .ui.animated.button .content {\n      will-change: transform, opacity;\n    }\n    .ui.animated.button .visible.content {\n      position: relative;\n      margin-right: $button-horizontal-padding;\n    }\n    .ui.animated.button .hidden.content {\n      position: absolute;\n      width: 100%;\n    }\n    \n    /* Horizontal */\n    .ui.animated.button .visible.content,\n    .ui.animated.button .hidden.content {\n      transition: right $button-animation-duration $button-animation-easing 0s;\n    }\n    .ui.animated.button .visible.content {\n      left: auto;\n      right: 0;\n    }\n    .ui.animated.button .hidden.content {\n      top: 50%;\n      left: auto;\n      right: -100%;\n      margin-top: -($button-line-height / 2);\n    }\n    .ui.animated.button:focus .visible.content,\n    .ui.animated.button:hover .visible.content {\n      left: auto;\n      right: 200%;\n    }\n    .ui.animated.button:focus .hidden.content,\n    .ui.animated.button:hover .hidden.content {\n      left: auto;\n      right: 0;\n    }\n    \n    /* Vertical */\n    .ui.vertical.animated.button .visible.content,\n    .ui.vertical.animated.button .hidden.content {\n      transition: top $button-animation-duration $button-animation-easing, transform $button-animation-duration $button-animation-easing;\n    }\n    .ui.vertical.animated.button .visible.content {\n      transform: translateY(0%);\n      right: auto;\n    }\n    .ui.vertical.animated.button .hidden.content {\n      top: -50%;\n      left: 0;\n      right: auto;\n    }\n    .ui.vertical.animated.button:focus .visible.content,\n    .ui.vertical.animated.button:hover .visible.content {\n      transform: translateY(200%);\n      right: auto;\n    }\n    .ui.vertical.animated.button:focus .hidden.content,\n    .ui.vertical.animated.button:hover .hidden.content {\n      top: 50%;\n      right: auto;\n    }\n    \n    /* Fade */\n    .ui.fade.animated.button .visible.content,\n    .ui.fade.animated.button .hidden.content {\n      transition: opacity $button-animation-duration $button-animation-easing, transform $button-animation-duration $button-animation-easing;\n    }\n    .ui.fade.animated.button .visible.content {\n      left: auto;\n      right: auto;\n      opacity: 1;\n      transform: scale(1);\n    }\n    .ui.fade.animated.button .hidden.content {\n      opacity: 0;\n      left: 0;\n      right: auto;\n      transform: scale($button-fade-scale-high);\n    }\n    .ui.fade.animated.button:focus .visible.content,\n    .ui.fade.animated.button:hover .visible.content {\n      left: auto;\n      right: auto;\n      opacity: 0;\n      transform: scale($button-fade-scale-low);\n    }\n    .ui.fade.animated.button:focus .hidden.content,\n    .ui.fade.animated.button:hover .hidden.content {\n      left: 0;\n      right: auto;\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n  \n  @if($use-button-type-inverted) {\n    /*-------------------\n           Inverted\n    --------------------*/\n    \n    .ui.inverted.button {\n      box-shadow: 0 0 0 $button-inverted-border-size $white inset;\n      background: transparent none;\n      color: $white;\n      text-shadow: none !important;\n    }\n    \n    /* Group */\n    .ui.inverted.buttons .button {\n      margin: $button-inverted-group-offset;\n    }\n    .ui.inverted.buttons .button:first-child {\n      margin-left: 0;\n    }\n    .ui.inverted.vertical.buttons .button {\n      margin: $button-inverted-vertical-group-offset;\n    }\n    .ui.inverted.vertical.buttons .button:first-child {\n      margin-top: 0;\n    }\n    \n    /* States */\n    \n    /* Hover */\n    .ui.inverted.button:hover {\n      background: $white;\n      box-shadow: 0 0 0 $button-inverted-border-size $white inset;\n      color: $button-hover-color;\n    }\n    \n    /* Active / Focus */\n    .ui.inverted.button:focus,\n    .ui.inverted.button.active {\n      background: $white;\n      box-shadow: 0 0 0 $button-inverted-border-size $white inset;\n      color: $button-focus-color;\n    }\n    \n    /* Active Focus */\n    .ui.inverted.button.active:focus {\n      background: $mid-white;\n      box-shadow: 0 0 0 $button-inverted-border-size $mid-white inset;\n      color: $button-focus-color;\n    }\n  }\n  \n  \n  @if($use-button-type-labeled) {\n    /*-------------------\n        Labeled Button\n    --------------------*/\n  \n    .ui.labeled.button:not(.icon) {\n      display: inline-flex;\n      flex-direction: row;\n      background: none;\n      padding: 0 !important;\n      border: none;\n      box-shadow: none;\n    }\n  \n    .ui.labeled.button > .button {\n      margin: 0;\n    }\n    .ui.labeled.button > .label {\n      display: flex;\n      align-items: $button-labeled-label-align;\n      margin: 0 0 0 $button-labeled-label-border-offset !important;\n      font-size: $button-labeled-label-font-size;\n      padding: $button-labeled-label-padding;\n      border-color: $button-labeled-label-border-color;\n    }\n  \n    /* Tag */\n    .ui.labeled.button > .tag.label:before {\n      width: $button-labeled-tag-label-size;\n      height: $button-labeled-tag-label-size;\n    }\n  \n    /* Right */\n    .ui.labeled.button:not([class*=\"left labeled\"]) > .button {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n    .ui.labeled.button:not([class*=\"left labeled\"]) > .label {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  \n    /* Left Side */\n    .ui[class*=\"left labeled\"].button > .button {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n    .ui[class*=\"left labeled\"].button > .label {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n  \n  @if($use-button-variation-social) {\n    /*-------------------\n           Social\n    --------------------*/\n    @if(index($use-button-variation-social, facebook)) {\n      /* Facebook */\n      .ui.facebook.button {\n        background-color: $facebook-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.facebook.button:hover {\n        background-color: $facebook-hover-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n      .ui.facebook.button:active {\n        background-color: $facebook-down-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n    }\n    \n    @if(index($use-button-variation-social, twitter)) {\n      /* Twitter */\n      .ui.twitter.button {\n        background-color: $twitter-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.twitter.button:hover {\n        background-color: $twitter-hover-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n      .ui.twitter.button:active {\n        background-color: $twitter-down-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n    }\n    \n      @if(index($use-button-variation-social, \"google plus\")) {\n      /* Google Plus */\n      .ui.google.plus.button {\n        background-color: $google-plus-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.google.plus.button:hover {\n        background-color: $google-plus-hover-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n      .ui.google.plus.button:active {\n        background-color: $google-plus-down-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n    }\n    \n    @if(index($use-button-variation-social, linkedin)) {\n      /* Linked In */\n      .ui.linkedin.button {\n        background-color: $linked-in-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n      .ui.linkedin.button:hover {\n        background-color: $linked-in-hover-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n      .ui.linkedin.button:active {\n        background-color: $linked-in-down-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n    }\n    \n    @if(index($use-button-variation-social, youtube)) {\n      /* YouTube */\n      .ui.youtube.button {\n        background-color: $youtube-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.youtube.button:hover {\n        background-color: $youtube-hover-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n      .ui.youtube.button:active {\n        background-color: $youtube-down-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n    }\n    \n    @if(index($use-button-variation-social, instagram)) {\n      /* Instagram */\n      .ui.instagram.button {\n        background-color: $instagram-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.instagram.button:hover {\n        background-color: $instagram-hover-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n      .ui.instagram.button:active {\n        background-color: $instagram-down-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n    }\n    \n    @if(index($use-button-variation-social, pinterest)) {\n      /* Pinterest */\n      .ui.pinterest.button {\n        background-color: $pinterest-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.pinterest.button:hover {\n        background-color: $pinterest-hover-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n      .ui.pinterest.button:active {\n        background-color: $pinterest-down-color;\n        color: $button-inverted-text-color;\n        text-shadow: $button-inverted-text-shadow;\n      }\n    }\n    \n    @if(index($use-button-variation-social, vk)) {\n      /* VK */\n      .ui.vk.button {\n        background-color: $vk-color;\n        color: $white;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.vk.button:hover {\n        background-color: $vk-hover-color;\n        color: $white;\n      }\n      .ui.vk.button:active {\n        background-color: $vk-down-color;\n        color: $white;\n      }\n    }\n    \n    @if(index($use-button-variation-social, whatsapp)) {\n      /* WhatsApp */\n      .ui.whatsapp.button {\n        background-color: $whats-app-color;\n        color: $white;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.whatsapp.button:hover {\n        background-color: $whats-app-hover-color;\n        color: $white;\n      }\n      .ui.whatsapp.button:active {\n        background-color: $whats-app-down-color;\n        color: $white;\n      }\n    }\n    \n    @if(index($use-button-variation-social, twitter)) {\n      /* Telegram */\n      .ui.telegram.button {\n        background-color: $telegram-color;\n        color: $white;\n        background-image: $button-colored-background-image;\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.telegram.button:hover {\n        background-color: $telegram-hover-color;\n        color: $white;\n      }\n      .ui.telegram.button:active {\n        background-color: $telegram-down-color;\n        color: $white;\n      }\n    }\n  }\n  \n  /*--------------\n       Icon\n  ---------------*/\n  \n  .ui.button > .icon:not(.button) {\n    height: $button-icon-height;\n    opacity: $button-icon-opacity;\n    margin: $button-icon-margin;\n    transition: $button-icon-transition;\n    vertical-align: $button-icon-vertical-align;\n    color: $button-icon-color;\n  }\n  \n  .ui.button:not(.icon) > .icon:not(.button):not(.dropdown),\n  .ui.button:not(.icon) > .icons:not(.button):not(.dropdown) {\n    margin: $button-icon-margin;\n  }\n  .ui.button:not(.icon) > .right.icon:not(.button):not(.dropdown) {\n    margin: $button-right-icon-margin;\n  }\n  \n  /*******************************\n             Variations\n  *******************************/\n  \n  \n  /*-------------------\n         Floated\n  --------------------*/\n  \n  .ui[class*=\"left floated\"].buttons,\n  .ui[class*=\"left floated\"].button {\n    float: left;\n    margin-left: 0;\n    margin-right: $button-floated-margin;\n  }\n  .ui[class*=\"right floated\"].buttons,\n  .ui[class*=\"right floated\"].button {\n    float: right;\n    margin-right: 0;\n    margin-left: $button-floated-margin;\n  }\n  \n  /*-------------------\n         Compact\n  --------------------*/\n  \n  .ui.compact.buttons .button,\n  .ui.compact.button {\n    padding: $button-compact-vertical-padding $button-compact-horizontal-padding ( $button-compact-vertical-padding + $button-shadow-offset );\n  }\n  .ui.compact.icon.buttons .button,\n  .ui.compact.icon.button {\n    padding: $button-compact-vertical-padding $button-compact-vertical-padding ( $button-compact-vertical-padding + $button-shadow-offset );\n  }\n  .ui.compact.labeled.icon.buttons .button,\n  .ui.compact.labeled.icon.button {\n    padding: $button-compact-vertical-padding ($button-compact-horizontal-padding + $button-labeled-icon-width) ( $button-compact-vertical-padding + $button-shadow-offset );\n  }\n  .ui.compact.labeled.icon.buttons .button > .icon,\n  .ui.compact.labeled.icon.button > .icon {\n    padding: $button-compact-vertical-padding 0 $button-compact-vertical-padding 0;\n  }\n  \n  /*-------------------\n          Sizes\n  --------------------*/\n  \n  .ui.mini.buttons .button,\n  .ui.mini.buttons .or,\n  .ui.ui.ui.ui.mini.button {\n    font-size: $mini;\n  }\n  .ui.tiny.buttons .button,\n  .ui.tiny.buttons .or,\n  .ui.ui.ui.ui.tiny.button {\n    font-size: $tiny;\n  }\n  .ui.small.buttons .button,\n  .ui.small.buttons .or,\n  .ui.ui.ui.ui.small.button {\n    font-size: $small;\n  }\n  .ui.buttons .button,\n  .ui.buttons .or,\n  .ui.button {\n    font-size: $medium;\n  }\n  .ui.large.buttons .button,\n  .ui.large.buttons .or,\n  .ui.ui.ui.ui.large.button {\n    font-size: $large;\n  }\n  .ui.big.buttons .button,\n  .ui.big.buttons .or,\n  .ui.ui.ui.ui.big.button {\n    font-size: $big;\n  }\n  .ui.huge.buttons .button,\n  .ui.huge.buttons .or,\n  .ui.ui.ui.ui.huge.button {\n    font-size: $huge;\n  }\n  .ui.massive.buttons .button,\n  .ui.massive.buttons .or,\n  .ui.ui.ui.ui.massive.button {\n    font-size: $massive;\n  }\n  \n  /* Dropdown coupled buttons sizes */\n  .ui.mini.buttons .dropdown {\n    font-size: $mini;\n  }\n  .ui.mini.buttons .dropdown .menu > .item {\n    font-size: $mini;\n  }\n  .ui.tiny.buttons .dropdown {\n    font-size: $tiny;\n  }\n  .ui.tiny.buttons .dropdown .menu > .item {\n    font-size: $tiny;\n  }\n  .ui.small.buttons .dropdown {\n    font-size: $small;\n  }\n  .ui.small.buttons .dropdown .menu > .item {\n    font-size: $small;\n  }\n  .ui.large.buttons .dropdown {\n    font-size: $large;\n  }\n  .ui.large.buttons .dropdown .menu > .item {\n    font-size: $large;\n  }\n  .ui.big.buttons .dropdown {\n    font-size: $big;\n  }\n  .ui.big.buttons .dropdown .menu > .item {\n    font-size: $big;\n  }\n  .ui.huge.buttons .dropdown {\n    font-size: $huge;\n  }\n  .ui.huge.buttons .dropdown .menu > .item {\n    font-size: $huge;\n  }\n  .ui.massive.buttons .dropdown {\n    font-size: $massive;\n  }\n  .ui.massive.buttons .dropdown .menu > .item {\n    font-size: $massive;\n  }\n  \n  /*--------------\n      Icon Only\n  ---------------*/\n  \n  .ui.icon.buttons .button,\n  .ui.icon.button {\n    padding: $button-vertical-padding $button-vertical-padding ( $button-vertical-padding + $button-shadow-offset );\n  }\n  .ui.icon.buttons .button > .icon,\n  .ui.icon.button > .icon {\n    opacity: $button-with-icon-opacity;\n    margin: 0 !important;\n    vertical-align: top;\n  }\n  \n  \n  @if($use-button-type-basic) {\n    /*-------------------\n            Basic\n    --------------------*/\n    .ui.basic.buttons .button,\n    .ui.basic.button {\n      background: $button-basic-background;\n      color: $button-basic-text-color;\n      font-weight: $button-basic-font-weight;\n      border-radius: $button-basic-border-radius;\n      text-transform: $button-basic-text-transform;\n      text-shadow: none !important;\n      box-shadow: $button-basic-box-shadow;\n    }\n    .ui.basic.buttons {\n      box-shadow: $button-basic-group-box-shadow;\n      border: $button-basic-group-border;\n      border-radius: $button-border-radius;\n    }\n    .ui.basic.buttons .button {\n      border-radius: 0;\n    }\n  \n    .ui.basic.buttons .button:hover,\n    .ui.basic.button:hover {\n      background: $button-basic-hover-background;\n      color: $button-basic-hover-text-color;\n      box-shadow: $button-basic-hover-box-shadow;\n    }\n    .ui.basic.buttons .button:focus,\n    .ui.basic.button:focus {\n      background: $button-basic-focus-background;\n      color: $button-basic-focus-text-color;\n      box-shadow: $button-basic-focus-box-shadow;\n    }\n    .ui.basic.buttons .button:active,\n    .ui.basic.button:active {\n      background: $button-basic-down-background;\n      color: $button-basic-down-text-color;\n      box-shadow: $button-basic-down-box-shadow;\n    }\n    .ui.basic.buttons .active.button,\n    .ui.basic.active.button {\n      background: $button-basic-active-background;\n      box-shadow: $button-basic-active-box-shadow;\n      color: $button-basic-active-text-color;\n    }\n    .ui.basic.buttons .active.button:hover,\n    .ui.basic.active.button:hover {\n      background-color: $transparent-black;\n    }\n  \n    /* Vertical */\n    .ui.basic.buttons .button:hover {\n      box-shadow: $button-basic-hover-box-shadow inset;\n    }\n    .ui.basic.buttons .button:active {\n      box-shadow: $button-basic-down-box-shadow inset;\n    }\n    .ui.basic.buttons .active.button {\n      box-shadow: $button-basic-active-box-shadow;\n    }\n  \n    /* Standard Basic Inverted */\n    .ui.basic.inverted.buttons .button,\n    .ui.basic.inverted.button {\n      background-color: transparent;\n      color: $off-white;\n      box-shadow: $button-basic-inverted-box-shadow;\n    }\n    .ui.basic.inverted.buttons .button:hover,\n    .ui.basic.inverted.button:hover {\n      color: $white;\n      box-shadow: $button-basic-inverted-hover-box-shadow;\n    }\n    .ui.basic.inverted.buttons .button:focus,\n    .ui.basic.inverted.button:focus {\n      color: $white;\n      box-shadow: $button-basic-inverted-focus-box-shadow;\n    }\n    .ui.basic.inverted.buttons .button:active,\n    .ui.basic.inverted.button:active {\n      background-color: $transparent-white;\n      color: $white;\n      box-shadow: $button-basic-inverted-down-box-shadow;\n    }\n    .ui.basic.inverted.buttons .active.button,\n    .ui.basic.inverted.active.button {\n      background-color: $transparent-white;\n      color: $button-inverted-text-color;\n      text-shadow: $button-inverted-text-shadow;\n      box-shadow: $button-basic-inverted-active-box-shadow;\n    }\n    .ui.basic.inverted.buttons .active.button:hover,\n    .ui.basic.inverted.active.button:hover {\n      background-color: $strong-transparent-white;\n      box-shadow: $button-basic-inverted-hover-box-shadow;\n    }\n  \n  \n    /* Basic Group */\n    .ui.basic.buttons .button {\n      border-left: $button-basic-group-border;\n      box-shadow: none;\n    }\n    .ui.basic.vertical.buttons .button {\n      border-left: none;\n      border-left-width: 0;\n      border-top: $button-basic-group-border;\n    }\n    .ui.basic.vertical.buttons .button:first-child {\n      border-top-width: 0;\n    }\n  }\n  \n  @if($use-button-type-tertiary) {\n    /*-------------------\n           Tertiary\n    --------------------*/\n    \n    .ui.tertiary.button {\n      transition: color $default-duration $default-easing !important;\n      border-radius: 0;\n      margin:\n        ($button-vertical-padding  - $button-tertiary-line-padding)\n        ($button-horizontal-margin)\n        ($button-vertical-padding + $button-shadow-offset + $button-vertical-margin - $button-tertiary-line-padding)\n        0\n        !important;\n      padding: $button-tertiary-line-padding !important;\n  \n      @if ($button-tertiary-with-underline == true) {\n        box-shadow: inset 0 (-$button-tertiary-line-height) 0 $button-tertiary-line-color;\n      }\n  \n      @if ($button-tertiary-with-overline == true) {\n        box-shadow: inset 0 $button-tertiary-line-height 0 $button-tertiary-line-color;\n      }\n  \n      @if ($button-tertiary-with-underline == false) and ($button-tertiary-with-overline == false){\n        box-shadow: none;\n      }\n      color: $button-tertiary-text-color;\n      background: $button-tertiary-background-color;\n    }\n  \n    .ui.tertiary.button:hover {\n  \n      @if ($button-tertiary-hover-with-underline == true) {\n        box-shadow: inset 0 (-$button-tertiary-line-height) 0 $button-tertiary-hover-line-color;\n      }\n  \n      @if ($button-tertiary-hover-with-overline == true) {\n        box-shadow: inset 0 $button-tertiary-line-height 0 $button-tertiary-hover-line-color;\n      }\n  \n      @if ($button-tertiary-hover-with-underline == false) and ($button-tertiary-hover-with-overline == false) {\n        box-shadow: none;\n      }\n      color: $button-tertiary-hover-color;\n      background: $button-tertiary-hover-background-color;\n    }\n  \n    .ui.tertiary.button:focus {\n      @if ($button-tertiary-focus-with-underline == true) {\n        box-shadow: inset 0 (-$button-tertiary-line-height) 0 $button-tertiary-focus-line-color;\n      }\n  \n      @if ($button-tertiary-focus-with-overline == true) {\n        box-shadow: inset 0 $button-tertiary-line-height 0 $button-tertiary-focus-line-color;\n      }\n  \n      @if ($button-tertiary-focus-with-underline == false) and ($button-tertiary-focus-with-overline == false){\n        box-shadow: none;\n      }\n      color: $button-tertiary-focus-color;\n      background: $button-tertiary-focus-background-color;\n    }\n  \n    .ui.tertiary.button:active {\n      @if ($button-tertiary-active-with-underline == true) {\n        box-shadow: inset 0 (-$button-tertiary-line-height) 0 $button-tertiary-active-line-color;\n        border-radius: $button-border-radius $button-border-radius 0 0;\n      }\n  \n      @if ($button-tertiary-active-with-overline == true) {\n        box-shadow: inset 0 $button-tertiary-line-height 0 $button-tertiary-active-line-color;\n        border-radius: 0 0 $button-border-radius $button-border-radius;\n      }\n  \n      @if ($button-tertiary-active-with-underline == false) and ($button-tertiary-active-with-overline == false){\n        box-shadow: none;\n        border-radius: 0;\n      }\n      color: $button-tertiary-active-color;\n      background: $button-tertiary-active-background-color;\n    }\n  }\n  \n  @if($use-button-type-labeled) {\n    /*--------------\n      Labeled Icon\n    ---------------*/\n    .ui.labeled.icon.buttons .button,\n    .ui.labeled.icon.button {\n      position: relative;\n      padding-left: $button-labeled-icon-padding !important;\n      padding-right: $button-horizontal-padding !important;\n    }\n  \n    /* Left Labeled */\n    .ui.labeled.icon.buttons > .button > .icon,\n    .ui.labeled.icon.button > .icon {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      line-height: 1;\n      border-radius: 0;\n      border-top-left-radius: inherit;\n      border-bottom-left-radius: inherit;\n      text-align: center;\n      animation:none;\n      padding: $button-vertical-padding 0 $button-vertical-padding 0;\n  \n      margin: $button-labeled-icon-margin;\n      width: $button-labeled-icon-width;\n      background-color: $button-labeled-icon-background-color;\n      color: $button-labeled-icon-color;\n      box-shadow: $button-labeled-icon-left-shadow;\n    }\n  \n    /* Right Labeled */\n    .ui[class*=\"right labeled\"].icon.button {\n      padding-right: $button-labeled-icon-padding !important;\n      padding-left: $button-horizontal-padding !important;\n    }\n    .ui[class*=\"right labeled\"].icon.button > .icon {\n      left: auto;\n      right: 0;\n      border-radius: 0;\n      border-top-right-radius: inherit;\n      border-bottom-right-radius: inherit;\n      box-shadow: $button-labeled-icon-right-shadow;\n    }\n  \n  \n    .ui.labeled.icon.buttons > .button > .icon:before,\n    .ui.labeled.icon.button > .icon:before,\n    .ui.labeled.icon.buttons > .button > .icon:after,\n    .ui.labeled.icon.button > .icon:after {\n      display: block;\n      position: relative;\n      width: 100%;\n      top: 0;\n      text-align: center;\n    }\n  \n    .ui.labeled.icon.buttons .button > .icon {\n      border-radius: 0;\n    }\n    .ui.labeled.icon.buttons .button:first-child > .icon {\n      border-top-left-radius: $button-border-radius;\n      border-bottom-left-radius: $button-border-radius;\n    }\n    .ui.labeled.icon.buttons .button:last-child > .icon {\n      border-top-right-radius: $button-border-radius;\n      border-bottom-right-radius: $button-border-radius;\n    }\n    .ui.vertical.labeled.icon.buttons .button:first-child > .icon {\n      border-radius: 0;\n      border-top-left-radius: $button-border-radius;\n    }\n    .ui.vertical.labeled.icon.buttons .button:last-child > .icon {\n      border-radius: 0;\n      border-bottom-left-radius: $button-border-radius;\n    }\n  \n    /* Loading Icon in Labeled Button */\n    .ui.labeled.icon.button > .loading.icon:before {\n      animation: loader 2s linear infinite;\n    }\n  }\n  /*--------------\n       Toggle\n  ---------------*/\n  \n  /* Toggle (Modifies active state to give affordances) */\n  .ui.toggle.buttons .active.button,\n  .ui.buttons .button.toggle.active,\n  .ui.button.toggle.active {\n    background-color: $positive-color;\n    box-shadow: none;\n    text-shadow: $button-inverted-text-shadow;\n    color: $button-inverted-text-color;\n  }\n  .ui.button.toggle.active:hover {\n    background-color: $positive-color-hover;\n    text-shadow: $button-inverted-text-shadow;\n    color: $button-inverted-text-color;\n  }\n  \n  /*--------------\n      Circular\n  ---------------*/\n  \n  .ui.circular.button {\n    border-radius: 10em;\n  }\n  .ui.circular.button > .icon {\n    width: 1em;\n    vertical-align: baseline;\n  }\n  \n  \n  /*-------------------\n        Or Buttons\n  --------------------*/\n  \n  .ui.buttons .or {\n    position: relative;\n    width: $button-or-gap;\n    height: $button-or-height;\n    z-index: $button-or-z-index;\n  }\n  .ui.buttons .or:before {\n    position: absolute;\n    text-align: center;\n    border-radius: $circular-radius;\n  \n    content: $button-or-text;\n    top: 50%;\n    left: 50%;\n    background-color: $button-or-background-color;\n    text-shadow: $button-or-text-shadow;\n  \n    margin-top: $button-or-vertical-offset;\n    margin-left: $button-or-horizontal-offset;\n  \n    width: $button-or-circle-size;\n    height: $button-or-circle-size;\n  \n    line-height: $button-or-line-height;\n    color: $button-or-text-color;\n  \n    font-style: $button-or-text-style;\n    font-weight: $button-or-text-weight;\n  \n    box-shadow: $button-or-box-shadow;\n  }\n  .ui.buttons .or[data-text]:before {\n    content: attr(data-text);\n  }\n  \n  /* Fluid Or */\n  .ui.fluid.buttons .or {\n    width: 0 !important;\n  }\n  .ui.fluid.buttons .or:after {\n    display: none;\n  }\n  \n  \n  /*-------------------\n         Attached\n  --------------------*/\n  \n  \n  /* Singular */\n  .ui.attached.button {\n    position: relative;\n    display: block;\n    margin: 0;\n    border-radius: 0;\n    box-shadow: $button-attached-box-shadow;\n  }\n  \n  /* Top / Bottom */\n  .ui.attached.top.button {\n    border-radius: $button-border-radius $button-border-radius 0 0;\n  }\n  .ui.attached.bottom.button {\n    border-radius: 0 0 $button-border-radius $button-border-radius;\n  }\n  \n  /* Left / Right */\n  .ui.left.attached.button {\n    display: inline-block;\n    border-left: none;\n    text-align: right;\n  \n    padding-right: $button-attached-horizontal-padding;\n    border-radius: $button-border-radius 0 0 $button-border-radius;\n  }\n  .ui.right.attached.button {\n    display: inline-block;\n    text-align: left;\n    padding-left: $button-attached-horizontal-padding;\n    border-radius: 0 $button-border-radius $button-border-radius 0;\n  }\n  \n  /* Plural */\n  .ui.attached.buttons {\n    position: relative;\n    display: flex;\n    border-radius: 0;\n    width: auto !important;\n    z-index: $button-attached-z-index;\n    margin-left: $button-attached-offset;\n    margin-right: $button-attached-offset;\n  }\n  .ui.attached.buttons .button {\n    margin: 0;\n  }\n  .ui.attached.buttons .button:first-child {\n    border-radius: 0;\n  }\n  .ui.attached.buttons .button:last-child {\n    border-radius: 0;\n  }\n  \n  /* Top / Bottom */\n  .ui[class*=\"top attached\"].buttons {\n    margin-bottom: $button-attached-offset;\n    border-radius: $button-border-radius $button-border-radius 0 0;\n  }\n  .ui[class*=\"top attached\"].buttons .button:first-child {\n    border-radius: $button-border-radius 0 0 0;\n  }\n  .ui[class*=\"top attached\"].buttons .button:last-child {\n    border-radius: 0 $button-border-radius 0 0;\n  }\n  \n  .ui[class*=\"bottom attached\"].buttons {\n    margin-top: $button-attached-offset;\n    border-radius: 0 0 $button-border-radius $button-border-radius;\n  }\n  .ui[class*=\"bottom attached\"].buttons .button:first-child {\n    border-radius: 0 0 0 $button-border-radius;\n  }\n  .ui[class*=\"bottom attached\"].buttons .button:last-child {\n    border-radius: 0 0 $button-border-radius 0;\n  }\n  \n  /* Left / Right */\n  .ui[class*=\"left attached\"].buttons {\n    display: inline-flex;\n    margin-right: 0;\n    margin-left: $button-attached-offset;\n    border-radius: 0 $button-border-radius $button-border-radius 0;\n  }\n  .ui[class*=\"left attached\"].buttons .button:first-child {\n    margin-left: $button-attached-offset;\n    border-radius: 0 $button-border-radius 0 0;\n  }\n  .ui[class*=\"left attached\"].buttons .button:last-child {\n    margin-left: $button-attached-offset;\n    border-radius: 0 0 $button-border-radius 0;\n  }\n  \n  .ui[class*=\"right attached\"].buttons {\n    display: inline-flex;\n    margin-left: 0;\n    margin-right: $button-attached-offset;\n    border-radius: $button-border-radius 0 0 $button-border-radius;\n  }\n  .ui[class*=\"right attached\"].buttons .button:first-child {\n    margin-left: $button-attached-offset;\n    border-radius: $button-border-radius 0 0 0;\n  }\n  .ui[class*=\"right attached\"].buttons .button:last-child {\n    margin-left: $button-attached-offset;\n    border-radius: 0 0 0 $button-border-radius;\n  }\n  \n  /*-------------------\n          Fluid\n  --------------------*/\n  \n  .ui.fluid.buttons,\n  .ui.fluid.button {\n    width: 100%;\n  }\n  .ui.fluid.button {\n    display: block;\n  }\n  \n  .ui.two.buttons {\n    width: 100%;\n  }\n  .ui.two.buttons > .button {\n    width: 50%;\n  }\n  \n  .ui.three.buttons {\n    width: 100%;\n  }\n  .ui.three.buttons > .button {\n    width: 33.333%;\n  }\n  \n  .ui.four.buttons {\n    width: 100%;\n  }\n  .ui.four.buttons > .button {\n    width: 25%;\n  }\n  \n  .ui.five.buttons {\n    width: 100%;\n  }\n  .ui.five.buttons > .button {\n    width: 20%;\n  }\n  \n  .ui.six.buttons {\n    width: 100%;\n  }\n  .ui.six.buttons > .button {\n    width: 16.666%;\n  }\n  \n  .ui.seven.buttons {\n    width: 100%;\n  }\n  .ui.seven.buttons > .button {\n    width: 14.285%;\n  }\n  \n  .ui.eight.buttons {\n    width: 100%;\n  }\n  .ui.eight.buttons > .button {\n    width: 12.500%;\n  }\n  \n  .ui.nine.buttons {\n    width: 100%;\n  }\n  .ui.nine.buttons > .button {\n    width: 11.11%;\n  }\n  \n  .ui.ten.buttons {\n    width: 100%;\n  }\n  .ui.ten.buttons > .button {\n    width: 10%;\n  }\n  \n  .ui.eleven.buttons {\n    width: 100%;\n  }\n  .ui.eleven.buttons > .button {\n    width: 9.09%;\n  }\n  \n  .ui.twelve.buttons {\n    width: 100%;\n  }\n  .ui.twelve.buttons > .button {\n    width: 8.3333%;\n  }\n  \n  /* Fluid Vertical Buttons */\n  .ui.fluid.vertical.buttons,\n  .ui.fluid.vertical.buttons > .button {\n    display: flex;\n    width: auto;\n    justify-content: center;\n  }\n  \n  .ui.two.vertical.buttons > .button {\n    height: 50%;\n  }\n  .ui.three.vertical.buttons > .button {\n    height: 33.333%;\n  }\n  .ui.four.vertical.buttons > .button {\n    height: 25%;\n  }\n  .ui.five.vertical.buttons > .button {\n    height: 20%;\n  }\n  .ui.six.vertical.buttons > .button {\n    height: 16.666%;\n  }\n  .ui.seven.vertical.buttons > .button {\n    height: 14.285%;\n  }\n  .ui.eight.vertical.buttons > .button {\n    height: 12.500%;\n  }\n  .ui.nine.vertical.buttons > .button {\n    height: 11.11%;\n  }\n  .ui.ten.vertical.buttons > .button {\n    height: 10%;\n  }\n  .ui.eleven.vertical.buttons > .button {\n    height: 9.09%;\n  }\n  .ui.twelve.vertical.buttons > .button {\n    height: 8.3333%;\n  }\n  \n  \n  /*-------------------\n         Colors\n  --------------------*/\n  \n  @each $key, $value in $button-colors-map {\n    @if(index(join($main-colors-names, $use-button-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $h: map-get($value, hover);\n      $f: map-get($value, focus);\n      $d: map-get($value, down);\n      $a: map-get($value, active);\n      $t: map-get($value, text);\n      $s: map-get($value, shadow);\n      $l: map-get($value, light);\n      $lh: map-get($value, lightHover);\n      $lf: map-get($value, lightFocus);\n      $ld: map-get($value, lightDown);\n      $la: map-get($value, lightActive);\n      $lt: map-get($value, lightText);\n      $ls: map-get($value, lightShadow);\n      $isDark: map-get($value, isDark);\n      $isVeryDark: map-get($value, isVeryDark);\n      $ty: getTertiaryButtonColor($isVeryDark, $c);\n      $tyh: getTertiaryButtonColor($isVeryDark, $c);\n      $tyf: getTertiaryButtonColorFocus($isVeryDark, $f);\n      $tya: getTertiaryButtonColorActive($isVeryDark, $a);\n    \n    \n      .ui.#{$key + \"\"}.buttons .button,\n      .ui.#{$key + \"\"}.button {\n        background-color: $c;\n        color: $t;\n        text-shadow: $s;\n        background-image: $button-colored-background-image;\n      }\n      .ui.#{$key + \"\"}.button {\n        box-shadow: $button-colored-box-shadow;\n      }\n      .ui.#{$key + \"\"}.buttons .button:hover,\n      .ui.#{$key + \"\"}.button:hover {\n        background-color: $h;\n        color: $t;\n        text-shadow: $s;\n      }\n      .ui.#{$key + \"\"}.buttons .button:focus,\n      .ui.#{$key + \"\"}.button:focus {\n        background-color: $f;\n        color: $t;\n        text-shadow: $s;\n      }\n      .ui.#{$key + \"\"}.buttons .button:active,\n      .ui.#{$key + \"\"}.button:active {\n        background-color: $d;\n        color: $t;\n        text-shadow: $s;\n      }\n      .ui.#{$key + \"\"}.buttons .active.button,\n      .ui.#{$key + \"\"}.buttons .active.button:active,\n      .ui.#{$key + \"\"}.active.button,\n      .ui.#{$key + \"\"}.button .active.button:active {\n        background-color: $a;\n        color: $t;\n        text-shadow: $s;\n      }\n    \n      @if($use-button-type-basic) {\n        /* Basic */\n        .ui.basic.#{$key + \"\"}.buttons .button,\n        .ui.basic.#{$key + \"\"}.button {\n          background: transparent;\n          box-shadow: 0 0 0 $button-basic-border-size $c inset ;\n          color: $c ;\n        }\n        .ui.basic.#{$key + \"\"}.buttons .button:hover,\n        .ui.basic.#{$key + \"\"}.button:hover {\n          background: transparent ;\n          box-shadow: 0 0 0 $button-basic-colored-border-size $h inset ;\n          color: $h ;\n        }\n        .ui.basic.#{$key + \"\"}.buttons .button:focus,\n        .ui.basic.#{$key + \"\"}.button:focus {\n          background: transparent ;\n          box-shadow: 0 0 0 $button-basic-colored-border-size $f inset ;\n          color: $h ;\n        }\n        .ui.basic.#{$key + \"\"}.buttons .active.button,\n        .ui.basic.#{$key + \"\"}.active.button {\n          background: transparent ;\n          box-shadow: 0 0 0 $button-basic-colored-border-size $a inset ;\n          color: $d ;\n        }\n        .ui.basic.#{$key + \"\"}.buttons .button:active,\n        .ui.basic.#{$key + \"\"}.button:active {\n          box-shadow: 0 0 0 $button-basic-colored-border-size $d inset ;\n          color: $d ;\n        }\n        .ui.buttons:not(.vertical) > .basic.#{$key + \"\"}.button:not(:first-child) {\n          margin-left: -$button-basic-colored-border-size;\n        }\n      }\n    \n      @if($use-button-type-inverted) {\n        /* Inverted */\n        .ui.inverted.#{$key + \"\"}.buttons .button,\n        .ui.inverted.#{$key + \"\"}.button {\n          background-color: transparent;\n    \n          @if ($isDark) {\n            box-shadow: 0 0 0 $button-inverted-border-size $solid-border-color inset ;\n            color: $button-inverted-text-color;\n          }\n    \n          @if not ($isDark) {\n            box-shadow: 0 0 0 $button-inverted-border-size $l inset ;\n            color: $l;\n          }\n        }\n        .ui.inverted.#{$key + \"\"}.buttons .button:hover,\n        .ui.inverted.#{$key + \"\"}.button:hover,\n        .ui.inverted.#{$key + \"\"}.buttons .button:focus,\n        .ui.inverted.#{$key + \"\"}.button:focus,\n        .ui.inverted.#{$key + \"\"}.buttons .button.active,\n        .ui.inverted.#{$key + \"\"}.button.active,\n        .ui.inverted.#{$key + \"\"}.buttons .button:active,\n        .ui.inverted.#{$key + \"\"}.button:active {\n          box-shadow: none ;\n          color: $lt;\n        }\n        .ui.inverted.#{$key + \"\"}.buttons .button:hover,\n        .ui.inverted.#{$key + \"\"}.button:hover {\n          background-color: $lh;\n        }\n        .ui.inverted.#{$key + \"\"}.buttons .button:focus,\n        .ui.inverted.#{$key + \"\"}.button:focus {\n          background-color: $lf;\n        }\n        .ui.inverted.#{$key + \"\"}.buttons .active.button,\n        .ui.inverted.#{$key + \"\"}.active.button {\n          background-color: $la;\n        }\n        .ui.inverted.#{$key + \"\"}.buttons .button:active,\n        .ui.inverted.#{$key + \"\"}.button:active {\n          background-color: $ld;\n        }\n    \n        /* Inverted Basic */\n        .ui.inverted.#{$key + \"\"}.basic.buttons .button,\n        .ui.inverted.#{$key + \"\"}.buttons .basic.button,\n        .ui.inverted.#{$key + \"\"}.basic.button {\n          background-color: transparent;\n          box-shadow: $button-basic-inverted-box-shadow ;\n          color: $white ;\n        }\n        .ui.inverted.#{$key + \"\"}.basic.buttons .button:hover,\n        .ui.inverted.#{$key + \"\"}.buttons .basic.button:hover,\n        .ui.inverted.#{$key + \"\"}.basic.button:hover {\n          box-shadow: 0 0 0 $button-inverted-border-size $lh inset ;\n    \n          @if ($isDark) {\n            color: $white ;\n          }\n    \n          @if not ($isDark) {\n            color: $l ;\n          }\n        }\n        .ui.inverted.#{$key + \"\"}.basic.buttons .button:focus,\n        .ui.inverted.#{$key + \"\"}.basic.buttons .button:focus,\n        .ui.inverted.#{$key + \"\"}.basic.button:focus {\n          box-shadow: 0 0 0 $button-inverted-border-size $lf inset ;\n          color: $l ;\n        }\n        .ui.inverted.#{$key + \"\"}.basic.buttons .active.button,\n        .ui.inverted.#{$key + \"\"}.buttons .basic.active.button,\n        .ui.inverted.#{$key + \"\"}.basic.active.button {\n          box-shadow: 0 0 0 $button-inverted-border-size $la inset ;\n    \n          @if ($isDark) {\n            color: $white ;\n          }\n    \n          @if not ($isDark) {\n            color: $l ;\n          }\n        }\n        .ui.inverted.#{$key + \"\"}.basic.buttons .button:active,\n        .ui.inverted.#{$key + \"\"}.buttons .basic.button:active,\n        .ui.inverted.#{$key + \"\"}.basic.button:active {\n          box-shadow: 0 0 0 $button-inverted-border-size $ld inset ;\n    \n          @if ($isDark) {\n            color: $white ;\n          }\n    \n          @if not ($isDark) {\n            color: $l ;\n          }\n        }\n      }\n      @if($use-button-type-tertiary) {\n        /* Tertiary */\n        .ui.tertiary.#{$key + \"\"}.buttons .button,\n        .ui.tertiary.#{$key + \"\"}.buttons .tertiary.button,\n        .ui.tertiary.#{$key + \"\"}.button {\n          background: transparent;\n    \n          @if ($button-tertiary-with-underline == true) {\n            box-shadow: inset 0 (-$button-tertiary-line-height) 0 $ty;\n          }\n    \n          @if ($button-tertiary-with-overline == true) {\n            box-shadow: inset 0 $button-tertiary-line-height 0 $ty;\n          }\n    \n          @if ($button-tertiary-with-underline == false) and ($button-tertiary-with-overline == false){\n            box-shadow: none;\n          }\n          color: $c ;\n        }\n    \n        .ui.tertiary.#{$key + \"\"}.buttons .button:hover,\n        .ui.tertiary.#{$key + \"\"}.buttons button:hover,\n        .ui.tertiary.#{$key + \"\"}.button:hover {\n    \n          @if ($button-tertiary-hover-with-underline == true) {\n            box-shadow: inset 0 (-$button-tertiary-line-height) 0 $tyh;\n          }\n    \n          @if ($button-tertiary-hover-with-overline == true) {\n            box-shadow: inset 0 $button-tertiary-line-height 0 $tyh;\n          }\n    \n          @if ($button-tertiary-hover-with-underline == false) and ($button-tertiary-hover-with-overline == false) {\n            box-shadow: none ;\n          }\n    \n          color: $tyh;\n        }\n    \n        .ui.tertiary.#{$key + \"\"}.buttons .button:focus,\n        .ui.tertiary.#{$key + \"\"}.buttons .tertiary.button:focus,\n        .ui.tertiary.#{$key + \"\"}.button:focus {\n    \n          @if ($button-tertiary-focus-with-underline == true) {\n            box-shadow: inset 0 (-$button-tertiary-line-height) 0 $tyf;\n          }\n    \n          @if ($button-tertiary-focus-with-overline == true) {\n            box-shadow: inset 0 $button-tertiary-line-height 0 $tyf;\n          }\n    \n          @if ($button-tertiary-focus-with-underline == false) and ($button-tertiary-focus-with-overline == false) {\n            box-shadow: none;\n          }\n    \n          color: $tyf;\n        }\n    \n        .ui.tertiary.#{$key + \"\"}.buttons .active.button,\n        .ui.tertiary.#{$key + \"\"}.buttons .tertiary.active.button,\n        .ui.tertiary.#{$key + \"\"}.active.button,\n        .ui.tertiary.#{$key + \"\"}.buttons .button:active,\n        .ui.tertiary.#{$key + \"\"}.buttons .tertiary.button:active,\n        .ui.tertiary.#{$key + \"\"}.button:active {\n    \n          @if ($button-tertiary-active-with-underline == true) {\n            box-shadow: inset 0 (-$button-tertiary-line-height) 0 $tya;\n          }\n    \n          @if ($button-tertiary-active-with-overline == true) {\n            box-shadow: inset 0 $button-tertiary-line-height 0 $tya;\n          }\n    \n          @if ($button-tertiary-active-with-underline == false) and ($button-tertiary-active-with-overline == false) {\n            box-shadow: none;\n          }\n    \n          color: $a ;\n        }\n      }\n    }\n  }\n  \n  @if(index($use-button-variation-consequences, positive)){\n    /*---------------\n        Positive\n    ----------------*/\n    @include addConsequence(positive);\n  }\n  \n  @if(index($use-button-variation-consequences, negative)){\n    /*---------------\n        Negative\n    ----------------*/\n    @include addConsequence(negative);\n  }\n  /*******************************\n              Groups\n  *******************************/\n  \n  .ui.buttons {\n    display: inline-flex;\n    flex-direction: row;\n    font-size: 0;\n    vertical-align: baseline;\n    margin: $button-vertical-margin $button-horizontal-margin 0 0;\n  }\n  .ui.buttons:not(.basic):not(.inverted) {\n    box-shadow: $button-group-box-shadow;\n  }\n  \n  /* Clearfix */\n  .ui.buttons:after {\n    content: \".\";\n    display: block;\n    height: 0;\n    clear: both;\n    visibility: hidden;\n  }\n  \n  /* Standard Group */\n  .ui.buttons .button {\n    flex: 1 0 auto;\n    border-radius: 0;\n    margin: $button-group-offset;\n  }\n  .ui.buttons:not(.basic):not(.inverted) > .button:not(.basic):not(.inverted) {\n    box-shadow: $button-group-super-box-shadow;\n  }\n  \n  .ui.buttons .button:first-child {\n    border-left: none;\n    margin-left: 0;\n    border-top-left-radius: $button-border-radius;\n    border-bottom-left-radius: $button-border-radius;\n  }\n  .ui.buttons .button:last-child {\n    border-top-right-radius: $button-border-radius;\n    border-bottom-right-radius: $button-border-radius;\n  }\n  \n  /* Vertical  Style */\n  .ui.vertical.buttons {\n    display: inline-flex;\n    flex-direction: column;\n  }\n  .ui.vertical.buttons .button {\n    display: block;\n    float: none;\n    width: 100%;\n    margin: $button-vertical-group-offset;\n    box-shadow: $button-vertical-box-shadow;\n    border-radius: 0;\n  }\n  .ui.vertical.buttons .button:first-child {\n    border-top-left-radius: $button-border-radius;\n    border-top-right-radius: $button-border-radius;\n  }\n  .ui.vertical.buttons .button:last-child {\n    margin-bottom: 0;\n    border-bottom-left-radius: $button-border-radius;\n    border-bottom-right-radius: $button-border-radius;\n  }\n  .ui.vertical.buttons .button:only-child {\n    border-radius: $button-border-radius;\n  }\n}\n\n\n@import '../../themes/default/elements/button.style';","@import '../../themes/default/elements/container.variables';\n\n@if $use-container {\n  /*******************************\n  //@-        Container\n  *******************************/\n  \n  /* All Sizes */\n  .ui.container {\n    display: block;\n    max-width: $container-max-width;\n  }\n  \n  /* Mobile */\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.ui.ui.container:not(.fluid) {\n      width: $container-mobile-width;\n      margin-left: $container-mobile-gutter;\n      margin-right: $container-mobile-gutter;\n    }\n    .ui.ui.grid.container {\n      width: $container-mobile-grid-width;\n    }\n    .ui.ui.relaxed.grid.container {\n      width: $container-mobile-relaxed-grid-width;\n    }\n    .ui.ui.very.relaxed.grid.container {\n      width: $container-mobile-very-relaxed-grid-width;\n    }\n  }\n  \n  /* Tablet */\n  @media only screen and (min-width: $tablet-breakpoint) and (max-width: $largest-tablet-screen) {\n    .ui.ui.ui.container:not(.fluid) {\n      width: $container-tablet-width;\n      margin-left: $container-tablet-gutter;\n      margin-right: $container-tablet-gutter;\n    }\n    .ui.ui.grid.container {\n      width: $container-tablet-grid-width;\n    }\n    .ui.ui.relaxed.grid.container {\n      width: $container-tablet-relaxed-grid-width;\n    }\n    .ui.ui.very.relaxed.grid.container {\n      width: $container-tablet-very-relaxed-grid-width;\n    }\n  }\n  \n  /* Small Monitor */\n  @media only screen and (min-width: $computer-breakpoint) and (max-width: $largest-small-monitor) {\n    .ui.ui.ui.container:not(.fluid) {\n      width: $container-computer-width;\n      margin-left: $container-computer-gutter;\n      margin-right: $container-computer-gutter;\n    }\n    .ui.ui.grid.container {\n      width: $container-computer-grid-width;\n    }\n    .ui.ui.relaxed.grid.container {\n      width: $container-computer-relaxed-grid-width;\n    }\n    .ui.ui.very.relaxed.grid.container {\n      width: $container-computer-very-relaxed-grid-width;\n    }\n  }\n  \n  /* Large Monitor */\n  @media only screen and (min-width: $large-monitor-breakpoint) {\n    .ui.ui.ui.container:not(.fluid) {\n      width: $container-large-monitor-width;\n      margin-left: $container-large-monitor-gutter;\n      margin-right: $container-large-monitor-gutter;\n    }\n    .ui.ui.grid.container {\n      width: $container-large-monitor-grid-width;\n    }\n    .ui.ui.relaxed.grid.container {\n      width: $container-large-monitor-relaxed-grid-width;\n    }\n    .ui.ui.very.relaxed.grid.container {\n      width: $container-large-monitor-very-relaxed-grid-width;\n    }\n  }\n  \n  /*******************************\n               Types\n  *******************************/\n  \n  \n  /* Text Container */\n  .ui.text.container {\n    font-family: $container-text-font-family;\n    max-width: $container-text-width;\n    line-height: $container-text-line-height;\n    font-size: $container-text-size;\n  }\n  \n  /* Fluid */\n  .ui.fluid.container {\n    width: 100%;\n  }\n  \n  \n  /*******************************\n             Variations\n  *******************************/\n  \n  .ui[class*=\"left aligned\"].container {\n    text-align: left;\n  }\n  .ui[class*=\"center aligned\"].container {\n    text-align: center;\n  }\n  .ui[class*=\"right aligned\"].container {\n    text-align: right;\n  }\n  .ui.justified.container {\n    text-align: justify;\n    hyphens: auto;\n  }\n}\n\n@import '../../themes/default/elements/container.style';","@import '../../themes/default/elements/divider.variables';\n\n@if $use-divider {\n  /*******************************\n  //@-        Divider\n  *******************************/\n  \n  .ui.divider {\n    margin: $divider-margin;\n  \n    line-height: 1;\n    height: 0;\n  \n    font-weight: $divider-font-weight;\n    text-transform: $divider-text-transform;\n    letter-spacing: $divider-letter-spacing;\n    color: $divider-color;\n  \n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  \n  /*--------------\n        Basic\n  ---------------*/\n  \n  .ui.divider:not(.vertical):not(.horizontal) {\n    border-top: $divider-shadow-width solid $divider-shadow-color;\n    border-bottom: $divider-highlight-width solid $divider-highlight-color;\n  }\n  \n  /*--------------\n      Coupling\n  ---------------*/\n  \n  /* Allow divider between each column row */\n  .ui.grid > .column + .divider,\n  .ui.grid > .row > .column + .divider {\n    left: auto;\n  }\n  \n  /*--------------\n     Horizontal\n  ---------------*/\n  \n  .ui.horizontal.divider {\n    display: table;\n    white-space: nowrap;\n  \n    height: auto;\n    margin: $divider-horizontal-margin;\n    line-height: 1;\n    text-align: center;\n  }\n  \n  .ui.horizontal.divider:before,\n  .ui.horizontal.divider:after {\n    content: '';\n    display: table-cell;\n    position: relative;\n    top: 50%;\n    width: 50%;\n    background-repeat: no-repeat;\n  }\n  \n  .ui.horizontal.divider:before {\n    background-position: right $divider-in-horizontal-position-margin top 50%;\n  }\n  .ui.horizontal.divider:after {\n    background-position: left $divider-in-horizontal-position-margin top 50%;\n  }\n  \n  /*--------------\n      Vertical\n  ---------------*/\n  \n  .ui.vertical.divider {\n    position: absolute;\n    z-index: 2;\n    top: 50%;\n    left: 50%;\n  \n    margin: 0;\n    padding: 0;\n    width: auto;\n    height: 50%;\n  \n    line-height: 0;\n    text-align: center;\n    transform: translateX(-50%);\n  }\n  \n  .ui.vertical.divider:before,\n  .ui.vertical.divider:after {\n    position: absolute;\n    left: 50%;\n    content: '';\n    z-index: 3;\n  \n    border-left: $divider-shadow-width solid $divider-shadow-color;\n    border-right: $divider-highlight-width solid $divider-highlight-color;\n  \n    width: 0;\n    height: $divider-vertical-height;\n  }\n  \n  .ui.vertical.divider:before {\n    top: -100%;\n  }\n  .ui.vertical.divider:after {\n    top: auto;\n    bottom: 0;\n  }\n  \n  /* Inside grid */\n  @media only screen and (max-width : $largest-mobile-screen) {\n  \n    .ui.stackable.grid .ui.vertical.divider,\n    .ui.grid .stackable.row .ui.vertical.divider {\n      display: table;\n      white-space: nowrap;\n      height: auto;\n      margin: $divider-horizontal-margin;\n      overflow: hidden;\n      line-height: 1;\n      text-align: center;\n      position: static;\n      top: 0;\n      left: 0;\n      transform: none;\n    }\n  \n    .ui.stackable.grid .ui.vertical.divider:before,\n    .ui.grid .stackable.row .ui.vertical.divider:before,\n    .ui.stackable.grid .ui.vertical.divider:after,\n    .ui.grid .stackable.row .ui.vertical.divider:after {\n      left: 0;\n      border-left: none;\n      border-right: none;\n      content: '';\n      display: table-cell;\n      position: relative;\n      top: 50%;\n      width: 50%;\n      background-repeat: no-repeat;\n    }\n  \n    .ui.stackable.grid .ui.vertical.divider:before,\n    .ui.grid .stackable.row .ui.vertical.divider:before {\n      background-position: right $divider-in-horizontal-position-margin top 50%;\n    }\n    .ui.stackable.grid .ui.vertical.divider:after,\n    .ui.grid .stackable.row .ui.vertical.divider:after {\n      background-position: left $divider-in-horizontal-position-margin top 50%;\n    }\n  }\n  \n  /*--------------\n        Icon\n  ---------------*/\n  \n  .ui.divider > .icon {\n    margin: $divider-icon-margin;\n    font-size: $divider-icon-size;\n    height: 1em;\n    vertical-align: middle;\n  }\n  \n  /*--------------\n       Header\n  ---------------*/\n  .ui.horizontal.divider[class*=\"left aligned\"] {\n    &:before {\n      display: none;\n    }\n    &:after {\n      width: 100%;\n    }\n  }\n  .ui.horizontal.divider[class*=\"right aligned\"] {\n    &:before {\n      width: 100%;\n    }\n    &:after {\n      display: none;\n    }\n  }\n  \n  /*******************************\n            Variations\n  *******************************/\n  \n  /*--------------\n      Hidden\n  ---------------*/\n  \n  .ui.hidden.divider {\n    border-color: transparent !important;\n  }\n  .ui.hidden.divider:before,\n  .ui.hidden.divider:after {\n    display: none;\n  }\n  \n  /*--------------\n      Inverted\n  ---------------*/\n  \n  .ui.divider.inverted,\n  .ui.vertical.inverted.divider,\n  .ui.horizontal.inverted.divider {\n    color: $divider-inverted-text-color;\n  }\n  .ui.divider.inverted,\n  .ui.divider.inverted:after,\n  .ui.divider.inverted:before {\n    border-top-color: $divider-inverted-shadow-color !important;\n    border-left-color: $divider-inverted-shadow-color !important;\n    border-bottom-color: $divider-inverted-highlight-color !important;\n    border-right-color: $divider-inverted-highlight-color !important;\n  }\n  \n  /*--------------\n      Fitted\n  ---------------*/\n  \n  .ui.fitted.divider {\n    margin: 0;\n  }\n  \n  /*--------------\n      Clearing\n  ---------------*/\n  \n  .ui.clearing.divider {\n    clear: both;\n  }\n  \n  /*--------------\n      Section\n  ---------------*/\n  \n  .ui.section.divider {\n    margin-top: $divider-section-margin;\n    margin-bottom: $divider-section-margin;\n  }\n  \n  /*--------------\n       Sizes\n  ---------------*/\n  \n  .ui.divider {\n    font-size: $divider-medium;\n  }\n}\n\n@import '../../themes/default/elements/divider.style';","@import '../../themes/default/elements/flag.variables';\n\n@if $use-flag {\n  /*******************************\n  //@-         Flag\n  *******************************/\n  \n  i.flag:not(.icon) {\n    display: inline-block;\n  \n    width: $flag-width;\n    height: $flag-height;\n  \n    line-height: $flag-height;\n    vertical-align: $flag-vertical-align;\n    margin: 0 $flag-margin 0 0;\n  \n    text-decoration: inherit;\n  \n    speak: none;\n    -webkit-font-smoothing: antialiased;\n    backface-visibility: hidden;\n  }\n  \n  /* Sprite */\n  i.flag:not(.icon):before {\n    display: inline-block;\n    content: '';\n    background: url($flag-sprite-path) no-repeat -108px -1976px;\n    width: $flag-width;\n    height: $flag-height;\n  }\n}\n\n@import '../../themes/default/elements/flag.style';","@if $use-flag {\n  /* Flag Sprite Based On http://www.famfamfam.com/lab/icons/flags/ */\n\n\n  /*rtl:begin:ignore*/\n\n  i.flag.ad:before,\n  i.flag.andorra:before {\n    background-position: 0 0;\n  }\n  i.flag.ae:before,\n  i.flag.united.arab.emirates:before,\n  i.flag.uae:before {\n    background-position: 0 -26px;\n  }\n  i.flag.af:before,\n  i.flag.afghanistan:before {\n    background-position: 0 -52px;\n  }\n  i.flag.ag:before,\n  i.flag.antigua:before {\n    background-position: 0 -78px;\n  }\n  i.flag.ai:before,\n  i.flag.anguilla:before {\n    background-position: 0 -104px;\n  }\n  i.flag.al:before,\n  i.flag.albania:before {\n    background-position: 0 -130px;\n  }\n  i.flag.am:before,\n  i.flag.armenia:before {\n    background-position: 0 -156px;\n  }\n  i.flag.an:before,\n  i.flag.netherlands.antilles:before {\n    background-position: 0 -182px;\n  }\n  i.flag.ao:before,\n  i.flag.angola:before {\n    background-position: 0 -208px;\n  }\n  i.flag.ar:before,\n  i.flag.argentina:before {\n    background-position: 0 -234px;\n  }\n  i.flag.as:before,\n  i.flag.american.samoa:before {\n    background-position: 0 -260px;\n  }\n  i.flag.at:before,\n  i.flag.austria:before {\n    background-position: 0 -286px;\n  }\n  i.flag.au:before,\n  i.flag.australia:before {\n    background-position: 0 -312px;\n  }\n  i.flag.aw:before,\n  i.flag.aruba:before {\n    background-position: 0 -338px;\n  }\n  i.flag.ax:before,\n  i.flag.aland.islands:before {\n    background-position: 0 -364px;\n  }\n  i.flag.az:before,\n  i.flag.azerbaijan:before {\n    background-position: 0 -390px;\n  }\n  i.flag.ba:before,\n  i.flag.bosnia:before {\n    background-position: 0 -416px;\n  }\n  i.flag.bb:before,\n  i.flag.barbados:before {\n    background-position: 0 -442px;\n  }\n  i.flag.bd:before,\n  i.flag.bangladesh:before {\n    background-position: 0 -468px;\n  }\n  i.flag.be:before,\n  i.flag.belgium:before {\n    background-position: 0 -494px;\n  }\n  i.flag.bf:before,\n  i.flag.burkina.faso:before {\n    background-position: 0 -520px;\n  }\n  i.flag.bg:before,\n  i.flag.bulgaria:before {\n    background-position: 0 -546px;\n  }\n  i.flag.bh:before,\n  i.flag.bahrain:before {\n    background-position: 0 -572px;\n  }\n  i.flag.bi:before,\n  i.flag.burundi:before {\n    background-position: 0 -598px;\n  }\n  i.flag.bj:before,\n  i.flag.benin:before {\n    background-position: 0 -624px;\n  }\n  i.flag.bm:before,\n  i.flag.bermuda:before {\n    background-position: 0 -650px;\n  }\n  i.flag.bn:before,\n  i.flag.brunei:before {\n    background-position: 0 -676px;\n  }\n  i.flag.bo:before,\n  i.flag.bolivia:before {\n    background-position: 0 -702px;\n  }\n  i.flag.br:before,\n  i.flag.brazil:before {\n    background-position: 0 -728px;\n  }\n  i.flag.bs:before,\n  i.flag.bahamas:before {\n    background-position: 0 -754px;\n  }\n  i.flag.bt:before,\n  i.flag.bhutan:before {\n    background-position: 0 -780px;\n  }\n  i.flag.bv:before,\n  i.flag.bouvet.island:before {\n    background-position: 0 -806px;\n  }\n  i.flag.bw:before,\n  i.flag.botswana:before {\n    background-position: 0 -832px;\n  }\n  i.flag.by:before,\n  i.flag.belarus:before {\n    background-position: 0 -858px;\n  }\n  i.flag.bz:before,\n  i.flag.belize:before {\n    background-position: 0 -884px;\n  }\n  i.flag.ca:before,\n  i.flag.canada:before {\n    background-position: 0 -910px;\n  }\n  i.flag.cc:before,\n  i.flag.cocos.islands:before {\n    background-position: 0 -962px;\n  }\n  i.flag.cd:before,\n  i.flag.congo:before {\n    background-position: 0 -988px;\n  }\n  i.flag.cf:before,\n  i.flag.central.african.republic:before {\n    background-position: 0 -1014px;\n  }\n  i.flag.cg:before,\n  i.flag.congo.brazzaville:before {\n    background-position: 0 -1040px;\n  }\n  i.flag.ch:before,\n  i.flag.switzerland:before {\n    background-position: 0 -1066px;\n  }\n  i.flag.ci:before,\n  i.flag.cote.divoire:before {\n    background-position: 0 -1092px;\n  }\n  i.flag.ck:before,\n  i.flag.cook.islands:before {\n    background-position: 0 -1118px;\n  }\n  i.flag.cl:before,\n  i.flag.chile:before {\n    background-position: 0 -1144px;\n  }\n  i.flag.cm:before,\n  i.flag.cameroon:before {\n    background-position: 0 -1170px;\n  }\n  i.flag.cn:before,\n  i.flag.china:before {\n    background-position: 0 -1196px;\n  }\n  i.flag.co:before,\n  i.flag.colombia:before {\n    background-position: 0 -1222px;\n  }\n  i.flag.cr:before,\n  i.flag.costa.rica:before {\n    background-position: 0 -1248px;\n  }\n  i.flag.cs:before,\n  i.flag.serbia:before {\n    background-position: 0 -1274px;\n  }\n  i.flag.cu:before,\n  i.flag.cuba:before {\n    background-position: 0 -1300px;\n  }\n  i.flag.cv:before,\n  i.flag.cape.verde:before {\n    background-position: 0 -1326px;\n  }\n  i.flag.cx:before,\n  i.flag.christmas.island:before {\n    background-position: 0 -1352px;\n  }\n  i.flag.cy:before,\n  i.flag.cyprus:before {\n    background-position: 0 -1378px;\n  }\n  i.flag.cz:before,\n  i.flag.czech.republic:before {\n    background-position: 0 -1404px;\n  }\n  i.flag.de:before,\n  i.flag.germany:before {\n    background-position: 0 -1430px;\n  }\n  i.flag.dj:before,\n  i.flag.djibouti:before {\n    background-position: 0 -1456px;\n  }\n  i.flag.dk:before,\n  i.flag.denmark:before {\n    background-position: 0 -1482px;\n  }\n  i.flag.dm:before,\n  i.flag.dominica:before {\n    background-position: 0 -1508px;\n  }\n  i.flag.do:before,\n  i.flag.dominican.republic:before {\n    background-position: 0 -1534px;\n  }\n  i.flag.dz:before,\n  i.flag.algeria:before {\n    background-position: 0 -1560px;\n  }\n  i.flag.ec:before,\n  i.flag.ecuador:before {\n    background-position: 0 -1586px;\n  }\n  i.flag.ee:before,\n  i.flag.estonia:before {\n    background-position: 0 -1612px;\n  }\n  i.flag.eg:before,\n  i.flag.egypt:before {\n    background-position: 0 -1638px;\n  }\n  i.flag.eh:before,\n  i.flag.western.sahara:before {\n    background-position: 0 -1664px;\n  }\n  i.flag.gb.eng:before,\n  i.flag.england:before {\n    background-position: 0 -1690px;\n  }\n  i.flag.er:before,\n  i.flag.eritrea:before {\n    background-position: 0 -1716px;\n  }\n  i.flag.es:before,\n  i.flag.spain:before {\n    background-position: 0 -1742px;\n  }\n  i.flag.et:before,\n  i.flag.ethiopia:before {\n    background-position: 0 -1768px;\n  }\n  i.flag.eu:before,\n  i.flag.european.union:before {\n    background-position: 0 -1794px;\n  }\n  i.flag.fi:before,\n  i.flag.finland:before {\n    background-position: 0 -1846px;\n  }\n  i.flag.fj:before,\n  i.flag.fiji:before {\n    background-position: 0 -1872px;\n  }\n  i.flag.fk:before,\n  i.flag.falkland.islands:before {\n    background-position: 0 -1898px;\n  }\n  i.flag.fm:before,\n  i.flag.micronesia:before {\n    background-position: 0 -1924px;\n  }\n  i.flag.fo:before,\n  i.flag.faroe.islands:before {\n    background-position: 0 -1950px;\n  }\n  i.flag.fr:before,\n  i.flag.france:before {\n    background-position: 0 -1976px;\n  }\n  i.flag.ga:before,\n  i.flag.gabon:before {\n    background-position: -36px 0;\n  }\n  i.flag.gb:before,\n  i.flag.uk:before,\n  i.flag.united.kingdom:before {\n    background-position: -36px -26px;\n  }\n  i.flag.gd:before,\n  i.flag.grenada:before {\n    background-position: -36px -52px;\n  }\n  i.flag.ge:before,\n  i.flag.georgia:before {\n    background-position: -36px -78px;\n  }\n  i.flag.gf:before,\n  i.flag.french.guiana:before {\n    background-position: -36px -104px;\n  }\n  i.flag.gh:before,\n  i.flag.ghana:before {\n    background-position: -36px -130px;\n  }\n  i.flag.gi:before,\n  i.flag.gibraltar:before {\n    background-position: -36px -156px;\n  }\n  i.flag.gl:before,\n  i.flag.greenland:before {\n    background-position: -36px -182px;\n  }\n  i.flag.gm:before,\n  i.flag.gambia:before {\n    background-position: -36px -208px;\n  }\n  i.flag.gn:before,\n  i.flag.guinea:before {\n    background-position: -36px -234px;\n  }\n  i.flag.gp:before,\n  i.flag.guadeloupe:before {\n    background-position: -36px -260px;\n  }\n  i.flag.gq:before,\n  i.flag.equatorial.guinea:before {\n    background-position: -36px -286px;\n  }\n  i.flag.gr:before,\n  i.flag.greece:before {\n    background-position: -36px -312px;\n  }\n  i.flag.gs:before,\n  i.flag.sandwich.islands:before {\n    background-position: -36px -338px;\n  }\n  i.flag.gt:before,\n  i.flag.guatemala:before {\n    background-position: -36px -364px;\n  }\n  i.flag.gu:before,\n  i.flag.guam:before {\n    background-position: -36px -390px;\n  }\n  i.flag.gw:before,\n  i.flag.guinea-bissau:before {\n    background-position: -36px -416px;\n  }\n  i.flag.gy:before,\n  i.flag.guyana:before {\n    background-position: -36px -442px;\n  }\n  i.flag.hk:before,\n  i.flag.hong.kong:before {\n    background-position: -36px -468px;\n  }\n  i.flag.hm:before,\n  i.flag.heard.island:before {\n    background-position: -36px -494px;\n  }\n  i.flag.hn:before,\n  i.flag.honduras:before {\n    background-position: -36px -520px;\n  }\n  i.flag.hr:before,\n  i.flag.croatia:before {\n    background-position: -36px -546px;\n  }\n  i.flag.ht:before,\n  i.flag.haiti:before {\n    background-position: -36px -572px;\n  }\n  i.flag.hu:before,\n  i.flag.hungary:before {\n    background-position: -36px -598px;\n  }\n  i.flag.id:before,\n  i.flag.indonesia:before {\n    background-position: -36px -624px;\n  }\n  i.flag.ie:before,\n  i.flag.ireland:before {\n    background-position: -36px -650px;\n  }\n  i.flag.il:before,\n  i.flag.israel:before {\n    background-position: -36px -676px;\n  }\n  i.flag.in:before,\n  i.flag.india:before {\n    background-position: -36px -702px;\n  }\n  i.flag.io:before,\n  i.flag.indian.ocean.territory:before {\n    background-position: -36px -728px;\n  }\n  i.flag.iq:before,\n  i.flag.iraq:before {\n    background-position: -36px -754px;\n  }\n  i.flag.ir:before,\n  i.flag.iran:before {\n    background-position: -36px -780px;\n  }\n  i.flag.is:before,\n  i.flag.iceland:before {\n    background-position: -36px -806px;\n  }\n  i.flag.it:before,\n  i.flag.italy:before {\n    background-position: -36px -832px;\n  }\n  i.flag.jm:before,\n  i.flag.jamaica:before {\n    background-position: -36px -858px;\n  }\n  i.flag.jo:before,\n  i.flag.jordan:before {\n    background-position: -36px -884px;\n  }\n  i.flag.jp:before,\n  i.flag.japan:before {\n    background-position: -36px -910px;\n  }\n  i.flag.ke:before,\n  i.flag.kenya:before {\n    background-position: -36px -936px;\n  }\n  i.flag.kg:before,\n  i.flag.kyrgyzstan:before {\n    background-position: -36px -962px;\n  }\n  i.flag.kh:before,\n  i.flag.cambodia:before {\n    background-position: -36px -988px;\n  }\n  i.flag.ki:before,\n  i.flag.kiribati:before {\n    background-position: -36px -1014px;\n  }\n  i.flag.km:before,\n  i.flag.comoros:before {\n    background-position: -36px -1040px;\n  }\n  i.flag.kn:before,\n  i.flag.saint.kitts.and.nevis:before {\n    background-position: -36px -1066px;\n  }\n  i.flag.kp:before,\n  i.flag.north.korea:before {\n    background-position: -36px -1092px;\n  }\n  i.flag.kr:before,\n  i.flag.south.korea:before {\n    background-position: -36px -1118px;\n  }\n  i.flag.kw:before,\n  i.flag.kuwait:before {\n    background-position: -36px -1144px;\n  }\n  i.flag.ky:before,\n  i.flag.cayman.islands:before {\n    background-position: -36px -1170px;\n  }\n  i.flag.kz:before,\n  i.flag.kazakhstan:before {\n    background-position: -36px -1196px;\n  }\n  i.flag.la:before,\n  i.flag.laos:before {\n    background-position: -36px -1222px;\n  }\n  i.flag.lb:before,\n  i.flag.lebanon:before {\n    background-position: -36px -1248px;\n  }\n  i.flag.lc:before,\n  i.flag.saint.lucia:before {\n    background-position: -36px -1274px;\n  }\n  i.flag.li:before,\n  i.flag.liechtenstein:before {\n    background-position: -36px -1300px;\n  }\n  i.flag.lk:before,\n  i.flag.sri.lanka:before {\n    background-position: -36px -1326px;\n  }\n  i.flag.lr:before,\n  i.flag.liberia:before {\n    background-position: -36px -1352px;\n  }\n  i.flag.ls:before,\n  i.flag.lesotho:before {\n    background-position: -36px -1378px;\n  }\n  i.flag.lt:before,\n  i.flag.lithuania:before {\n    background-position: -36px -1404px;\n  }\n  i.flag.lu:before,\n  i.flag.luxembourg:before {\n    background-position: -36px -1430px;\n  }\n  i.flag.lv:before,\n  i.flag.latvia:before {\n    background-position: -36px -1456px;\n  }\n  i.flag.ly:before,\n  i.flag.libya:before {\n    background-position: -36px -1482px;\n  }\n  i.flag.ma:before,\n  i.flag.morocco:before {\n    background-position: -36px -1508px;\n  }\n  i.flag.mc:before,\n  i.flag.monaco:before {\n    background-position: -36px -1534px;\n  }\n  i.flag.md:before,\n  i.flag.moldova:before {\n    background-position: -36px -1560px;\n  }\n  i.flag.me:before,\n  i.flag.montenegro:before {\n    background-position: -36px -1586px;\n  }\n  i.flag.mg:before,\n  i.flag.madagascar:before {\n    background-position: -36px -1613px;\n  }\n  i.flag.mh:before,\n  i.flag.marshall.islands:before {\n    background-position: -36px -1639px;\n  }\n  i.flag.mk:before,\n  i.flag.macedonia:before {\n    background-position: -36px -1665px;\n  }\n  i.flag.ml:before,\n  i.flag.mali:before {\n    background-position: -36px -1691px;\n  }\n  i.flag.mm:before,\n  i.flag.myanmar:before,\n  i.flag.burma:before {\n    background-position: -36px -1717px;\n  }\n  i.flag.mn:before,\n  i.flag.mongolia:before {\n    background-position: -36px -1743px;\n  }\n  i.flag.mo:before,\n  i.flag.macau:before {\n    background-position: -36px -1769px;\n  }\n  i.flag.mp:before,\n  i.flag.northern.mariana.islands:before {\n    background-position: -36px -1795px;\n  }\n  i.flag.mq:before,\n  i.flag.martinique:before {\n    background-position: -36px -1821px;\n  }\n  i.flag.mr:before,\n  i.flag.mauritania:before {\n    background-position: -36px -1847px;\n  }\n  i.flag.ms:before,\n  i.flag.montserrat:before {\n    background-position: -36px -1873px;\n  }\n  i.flag.mt:before,\n  i.flag.malta:before {\n    background-position: -36px -1899px;\n  }\n  i.flag.mu:before,\n  i.flag.mauritius:before {\n    background-position: -36px -1925px;\n  }\n  i.flag.mv:before,\n  i.flag.maldives:before {\n    background-position: -36px -1951px;\n  }\n  i.flag.mw:before,\n  i.flag.malawi:before {\n    background-position: -36px -1977px;\n  }\n  i.flag.mx:before,\n  i.flag.mexico:before {\n    background-position: -72px 0;\n  }\n  i.flag.my:before,\n  i.flag.malaysia:before {\n    background-position: -72px -26px;\n  }\n  i.flag.mz:before,\n  i.flag.mozambique:before {\n    background-position: -72px -52px;\n  }\n  i.flag.na:before,\n  i.flag.namibia:before {\n    background-position: -72px -78px;\n  }\n  i.flag.nc:before,\n  i.flag.new.caledonia:before {\n    background-position: -72px -104px;\n  }\n  i.flag.ne:before,\n  i.flag.niger:before {\n    background-position: -72px -130px;\n  }\n  i.flag.nf:before,\n  i.flag.norfolk.island:before {\n    background-position: -72px -156px;\n  }\n  i.flag.ng:before,\n  i.flag.nigeria:before {\n    background-position: -72px -182px;\n  }\n  i.flag.ni:before,\n  i.flag.nicaragua:before {\n    background-position: -72px -208px;\n  }\n  i.flag.nl:before,\n  i.flag.netherlands:before {\n    background-position: -72px -234px;\n  }\n  i.flag.no:before,\n  i.flag.norway:before {\n    background-position: -72px -260px;\n  }\n  i.flag.np:before,\n  i.flag.nepal:before {\n    background-position: -72px -286px;\n  }\n  i.flag.nr:before,\n  i.flag.nauru:before {\n    background-position: -72px -312px;\n  }\n  i.flag.nu:before,\n  i.flag.niue:before {\n    background-position: -72px -338px;\n  }\n  i.flag.nz:before,\n  i.flag.new.zealand:before {\n    background-position: -72px -364px;\n  }\n  i.flag.om:before,\n  i.flag.oman:before {\n    background-position: -72px -390px;\n  }\n  i.flag.pa:before,\n  i.flag.panama:before {\n    background-position: -72px -416px;\n  }\n  i.flag.pe:before,\n  i.flag.peru:before {\n    background-position: -72px -442px;\n  }\n  i.flag.pf:before,\n  i.flag.french.polynesia:before {\n    background-position: -72px -468px;\n  }\n  i.flag.pg:before,\n  i.flag.new.guinea:before {\n    background-position: -72px -494px;\n  }\n  i.flag.ph:before,\n  i.flag.philippines:before {\n    background-position: -72px -520px;\n  }\n  i.flag.pk:before,\n  i.flag.pakistan:before {\n    background-position: -72px -546px;\n  }\n  i.flag.pl:before,\n  i.flag.poland:before {\n    background-position: -72px -572px;\n  }\n  i.flag.pm:before,\n  i.flag.saint.pierre:before {\n    background-position: -72px -598px;\n  }\n  i.flag.pn:before,\n  i.flag.pitcairn.islands:before {\n    background-position: -72px -624px;\n  }\n  i.flag.pr:before,\n  i.flag.puerto.rico:before {\n    background-position: -72px -650px;\n  }\n  i.flag.ps:before,\n  i.flag.palestine:before {\n    background-position: -72px -676px;\n  }\n  i.flag.pt:before,\n  i.flag.portugal:before {\n    background-position: -72px -702px;\n  }\n  i.flag.pw:before,\n  i.flag.palau:before {\n    background-position: -72px -728px;\n  }\n  i.flag.py:before,\n  i.flag.paraguay:before {\n    background-position: -72px -754px;\n  }\n  i.flag.qa:before,\n  i.flag.qatar:before {\n    background-position: -72px -780px;\n  }\n  i.flag.re:before,\n  i.flag.reunion:before {\n    background-position: -72px -806px;\n  }\n  i.flag.ro:before,\n  i.flag.romania:before {\n    background-position: -72px -832px;\n  }\n  i.flag.rs:before,\n  i.flag.serbia:before {\n    background-position: -72px -858px;\n  }\n  i.flag.ru:before,\n  i.flag.russia:before {\n    background-position: -72px -884px;\n  }\n  i.flag.rw:before,\n  i.flag.rwanda:before {\n    background-position: -72px -910px;\n  }\n  i.flag.sa:before,\n  i.flag.saudi.arabia:before {\n    background-position: -72px -936px;\n  }\n  i.flag.sb:before,\n  i.flag.solomon.islands:before {\n    background-position: -72px -962px;\n  }\n  i.flag.sc:before,\n  i.flag.seychelles:before {\n    background-position: -72px -988px;\n  }\n  i.flag.gb.sct:before,\n  i.flag.scotland:before {\n    background-position: -72px -1014px;\n  }\n  i.flag.sd:before,\n  i.flag.sudan:before {\n    background-position: -72px -1040px;\n  }\n  i.flag.se:before,\n  i.flag.sweden:before {\n    background-position: -72px -1066px;\n  }\n  i.flag.sg:before,\n  i.flag.singapore:before {\n    background-position: -72px -1092px;\n  }\n  i.flag.sh:before,\n  i.flag.saint.helena:before {\n    background-position: -72px -1118px;\n  }\n  i.flag.si:before,\n  i.flag.slovenia:before {\n    background-position: -72px -1144px;\n  }\n  i.flag.sj:before,\n  i.flag.svalbard:before,\n  i.flag.jan.mayen:before {\n    background-position: -72px -1170px;\n  }\n  i.flag.sk:before,\n  i.flag.slovakia:before {\n    background-position: -72px -1196px;\n  }\n  i.flag.sl:before,\n  i.flag.sierra.leone:before {\n    background-position: -72px -1222px;\n  }\n  i.flag.sm:before,\n  i.flag.san.marino:before {\n    background-position: -72px -1248px;\n  }\n  i.flag.sn:before,\n  i.flag.senegal:before {\n    background-position: -72px -1274px;\n  }\n  i.flag.so:before,\n  i.flag.somalia:before {\n    background-position: -72px -1300px;\n  }\n  i.flag.sr:before,\n  i.flag.suriname:before {\n    background-position: -72px -1326px;\n  }\n  i.flag.st:before,\n  i.flag.sao.tome:before {\n    background-position: -72px -1352px;\n  }\n  i.flag.sv:before,\n  i.flag.el.salvador:before {\n    background-position: -72px -1378px;\n  }\n  i.flag.sy:before,\n  i.flag.syria:before {\n    background-position: -72px -1404px;\n  }\n  i.flag.sz:before,\n  i.flag.swaziland:before {\n    background-position: -72px -1430px;\n  }\n  i.flag.tc:before,\n  i.flag.caicos.islands:before {\n    background-position: -72px -1456px;\n  }\n  i.flag.td:before,\n  i.flag.chad:before {\n    background-position: -72px -1482px;\n  }\n  i.flag.tf:before,\n  i.flag.french.territories:before {\n    background-position: -72px -1508px;\n  }\n  i.flag.tg:before,\n  i.flag.togo:before {\n    background-position: -72px -1534px;\n  }\n  i.flag.th:before,\n  i.flag.thailand:before {\n    background-position: -72px -1560px;\n  }\n  i.flag.tj:before,\n  i.flag.tajikistan:before {\n    background-position: -72px -1586px;\n  }\n  i.flag.tk:before,\n  i.flag.tokelau:before {\n    background-position: -72px -1612px;\n  }\n  i.flag.tl:before,\n  i.flag.timorleste:before {\n    background-position: -72px -1638px;\n  }\n  i.flag.tm:before,\n  i.flag.turkmenistan:before {\n    background-position: -72px -1664px;\n  }\n  i.flag.tn:before,\n  i.flag.tunisia:before {\n    background-position: -72px -1690px;\n  }\n  i.flag.to:before,\n  i.flag.tonga:before {\n    background-position: -72px -1716px;\n  }\n  i.flag.tr:before,\n  i.flag.turkey:before {\n    background-position: -72px -1742px;\n  }\n  i.flag.tt:before,\n  i.flag.trinidad:before {\n    background-position: -72px -1768px;\n  }\n  i.flag.tv:before,\n  i.flag.tuvalu:before {\n    background-position: -72px -1794px;\n  }\n  i.flag.tw:before,\n  i.flag.taiwan:before {\n    background-position: -72px -1820px;\n  }\n  i.flag.tz:before,\n  i.flag.tanzania:before {\n    background-position: -72px -1846px;\n  }\n  i.flag.ua:before,\n  i.flag.ukraine:before {\n    background-position: -72px -1872px;\n  }\n  i.flag.ug:before,\n  i.flag.uganda:before {\n    background-position: -72px -1898px;\n  }\n  i.flag.um:before,\n  i.flag.us.minor.islands:before {\n    background-position: -72px -1924px;\n  }\n  i.flag.us:before,\n  i.flag.america:before,\n  i.flag.united.states:before {\n    background-position: -72px -1950px;\n  }\n  i.flag.uy:before,\n  i.flag.uruguay:before {\n    background-position: -72px -1976px;\n  }\n  i.flag.uz:before,\n  i.flag.uzbekistan:before {\n    background-position: -108px 0;\n  }\n  i.flag.va:before,\n  i.flag.vatican.city:before {\n    background-position: -108px -26px;\n  }\n  i.flag.vc:before,\n  i.flag.saint.vincent:before {\n    background-position: -108px -52px;\n  }\n  i.flag.ve:before,\n  i.flag.venezuela:before {\n    background-position: -108px -78px;\n  }\n  i.flag.vg:before,\n  i.flag.british.virgin.islands:before {\n    background-position: -108px -104px;\n  }\n  i.flag.vi:before,\n  i.flag.us.virgin.islands:before {\n    background-position: -108px -130px;\n  }\n  i.flag.vn:before,\n  i.flag.vietnam:before {\n    background-position: -108px -156px;\n  }\n  i.flag.vu:before,\n  i.flag.vanuatu:before {\n    background-position: -108px -182px;\n  }\n  i.flag.gb.wls:before,\n  i.flag.wales:before {\n    background-position: -108px -208px;\n  }\n  i.flag.wf:before,\n  i.flag.wallis.and.futuna:before {\n    background-position: -108px -234px;\n  }\n  i.flag.ws:before,\n  i.flag.samoa:before {\n    background-position: -108px -260px;\n  }\n  i.flag.ye:before,\n  i.flag.yemen:before {\n    background-position: -108px -286px;\n  }\n  i.flag.yt:before,\n  i.flag.mayotte:before {\n    background-position: -108px -312px;\n  }\n  i.flag.za:before,\n  i.flag.south.africa:before {\n    background-position: -108px -338px;\n  }\n  i.flag.zm:before,\n  i.flag.zambia:before {\n    background-position: -108px -364px;\n  }\n  i.flag.zw:before,\n  i.flag.zimbabwe:before {\n    background-position: -108px -390px;\n  }\n\n  /*rtl:end:ignore*/\n}","@import '../../themes/default/elements/header.variables';\n\n@if $use-header {\n  /*******************************\n  //@-        Header\n  *******************************/\n  \n  /* Standard */\n  .ui.header {\n    border: none;\n    margin: $header-margin;\n    padding: $header-vertical-padding $header-horizontal-padding;\n    font-family: $header-font-family;\n    font-weight: $header-font-weight;\n    line-height: $header-line-height;\n    text-transform: $header-text-transform;\n    color: $text-color;\n  }\n  \n  .ui.header:first-child {\n    margin-top: $header-first-margin;\n  }\n  .ui.header:last-child {\n    margin-bottom: $header-last-margin;\n  }\n  \n  /*--------------\n     Sub Header\n  ---------------*/\n  \n  .ui.header .sub.header {\n    display: block;\n    font-weight: $normal;\n    padding: 0;\n    margin: $header-sub-margin;\n    font-size: $header-sub-font-size;\n    line-height: $header-sub-line-height;\n    color: $header-sub-color;\n  }\n  \n  /*--------------\n        Icon\n  ---------------*/\n  \n  .ui.header > .icon {\n    display: table-cell;\n    opacity: $header-icon-opacity;\n    font-size: $header-icon-size;\n    padding-top: $header-icon-offset;\n    vertical-align: $header-icon-alignment;\n  }\n  \n  /* With Text Node */\n  .ui.header .icon:only-child {\n    display: inline-block;\n    padding: 0;\n    margin-right: $header-icon-margin;\n  }\n  \n  /*-------------------\n          Image\n  --------------------*/\n  \n  .ui.header > .image:not(.icon),\n  .ui.header > img {\n    display: inline-block;\n    margin-top: $header-image-offset;\n    width: $header-image-width;\n    height: $header-image-height;\n    vertical-align: $header-image-alignment;\n  }\n  .ui.header > .image:not(.icon):only-child,\n  .ui.header > img:only-child {\n    margin-right: $header-image-margin;\n  }\n  \n  /*--------------\n       Content\n  ---------------*/\n  \n  .ui.header .content {\n    display: inline-block;\n    vertical-align: $header-content-alignment;\n  }\n  \n  /* After Image */\n  .ui.header > img + .content,\n  .ui.header > .image + .content {\n    padding-left: $header-image-margin;\n    vertical-align: $header-content-image-alignment;\n  }\n  \n  /* After Icon */\n  .ui.header > .icon + .content {\n    padding-left: $header-icon-margin;\n    display: table-cell;\n    vertical-align: $header-content-icon-alignment;\n  }\n  \n  \n  /*--------------\n   Loose Coupling\n  ---------------*/\n  \n  .ui.header .ui.label {\n    font-size: $header-label-size;\n    margin-left: $header-label-distance;\n    vertical-align: $header-label-vertical-align;\n  }\n  \n  /* Positioning */\n  .ui.header + p {\n    margin-top: $header-next-paragraph-distance;\n  }\n  \n  \n  \n  /*******************************\n              Types\n  *******************************/\n  \n  \n  /*--------------\n       Page\n  ---------------*/\n  \n  h1.ui.header {\n    font-size: $h1;\n  }\n  h2.ui.header {\n    font-size: $h2;\n  }\n  h3.ui.header {\n    font-size: $h3;\n  }\n  h4.ui.header {\n    font-size: $h4;\n  }\n  h5.ui.header {\n    font-size: $h5;\n  }\n  \n  \n  /* Sub Header */\n  h1.ui.header .sub.header {\n    font-size: $header-h1-sub-font-size;\n  }\n  h2.ui.header .sub.header {\n    font-size: $header-h2-sub-font-size;\n  }\n  h3.ui.header .sub.header {\n    font-size: $header-h3-sub-font-size;\n  }\n  h4.ui.header .sub.header {\n    font-size: $header-h4-sub-font-size;\n  }\n  h5.ui.header .sub.header {\n    font-size: $header-h5-sub-font-size;\n  }\n  \n  \n  /*--------------\n   Content Heading\n  ---------------*/\n  \n  .ui.huge.header {\n    min-height: 1em;\n    font-size: $header-huge-font-size;\n  }\n  .ui.large.header {\n    font-size: $header-large-font-size;\n  }\n  .ui.medium.header {\n    font-size: $header-medium-font-size;\n  }\n  .ui.small.header {\n    font-size: $header-small-font-size;\n  }\n  .ui.tiny.header {\n    font-size: $header-tiny-font-size;\n  }\n  \n  /* Sub Header */\n  .ui.huge.header .sub.header {\n    font-size: $header-huge-sub-font-size;\n  }\n  .ui.large.header .sub.header {\n    font-size: $header-huge-sub-font-size;\n  }\n  .ui.header .sub.header {\n    font-size: $header-sub-font-size;\n  }\n  .ui.small.header .sub.header {\n    font-size: $header-small-sub-font-size;\n  }\n  .ui.tiny.header .sub.header {\n    font-size: $header-tiny-sub-font-size;\n  }\n  \n  /*--------------\n     Sub Heading\n  ---------------*/\n  \n  .ui.sub.header {\n    padding: 0;\n    margin-bottom: $header-sub-heading-distance;\n    font-weight: $header-sub-heading-font-weight;\n    font-size: $header-sub-heading-font-size;\n    text-transform: $header-sub-heading-text-transform;\n    color: $header-sub-heading-color;\n  }\n  \n  .ui.small.sub.header {\n    font-size: $header-small-sub-heading-size;\n  }\n  .ui.large.sub.header {\n    font-size: $header-large-sub-heading-size;\n  }\n  .ui.huge.sub.header {\n    font-size: $header-huge-sub-heading-size;\n  }\n  \n  \n  \n  /*-------------------\n          Icon\n  --------------------*/\n  \n  .ui.icon.header {\n    display: inline-block;\n    text-align: center;\n    margin: $header-icon-top-margin 0 $header-icon-bottom-margin;\n  }\n  .ui.icon.header:after {\n    content: '';\n    display: block;\n    height: 0;\n    clear: both;\n    visibility: hidden;\n  }\n  \n  .ui.icon.header:first-child {\n    margin-top: $header-icon-first-margin;\n  }\n  .ui.icon.header .icon {\n    float: none;\n    display: block;\n    width: auto;\n    height: auto;\n    line-height: 1;\n    padding: 0;\n    font-size: $header-iconed-icon-size;\n    margin: 0 auto $header-iconed-icon-margin;\n    opacity: $header-iconed-icon-opacity;\n  }\n  .ui.icon.header .corner.icon {\n    font-size: $header-corner-icon-size;\n  }\n  .ui.icon.header .content {\n    display: block;\n    padding: 0;\n  }\n  .ui.icon.header .circular.icon {\n    font-size: $header-circular-icon-size;\n  }\n  .ui.icon.header .square.icon {\n    font-size: $header-square-icon-size;\n  }\n  .ui.block.icon.header .icon {\n    margin-bottom: 0;\n  }\n  .ui.icon.header.aligned {\n    margin-left: auto;\n    margin-right: auto;\n    display: block;\n  }\n  \n  /*******************************\n              States\n  *******************************/\n  \n  .ui.disabled.header {\n    opacity: $disabled-opacity;\n  }\n  \n  \n  /*******************************\n             Variations\n  *******************************/\n  \n  /*-------------------\n        Inverted\n  --------------------*/\n  \n  .ui.inverted.header {\n    color: $header-inverted-color;\n  }\n  .ui.inverted.header .sub.header {\n    color: $header-inverted-sub-color;\n  }\n  .ui.inverted.attached.header {\n    background: $header-inverted-attached-background;\n    box-shadow: none;\n    border-color: transparent;\n  }\n  .ui.inverted.block.header {\n    background: $header-inverted-block-background;\n    box-shadow: none;\n    border-bottom: none;\n  }\n  \n  \n  /*-------------------\n         Colors\n  --------------------*/\n  \n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-header-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $l: map-get($value, light);\n      $h: map-get($value, hover);\n      $lh: map-get($value, lightHover);\n    \n      .ui.#{$key + \"\"}.header {\n        color: $c;\n      }\n      a.ui.#{$key + \"\"}.header:hover {\n        color: $h;\n      }\n      .ui.#{$key + \"\"}.dividing.header {\n        border-bottom: $header-divided-colored-border-width solid $c;\n      }\n      .ui.inverted.#{$key + \"\"}.header.header.header {\n        color: $l;\n      }\n      a.ui.inverted.#{$key + \"\"}.header.header.header:hover {\n        color: $lh;\n      }\n      .ui.inverted.#{$key + \"\"}.dividing.header {\n        border-bottom: $header-divided-colored-border-width solid $l;\n      }\n    }\n  }\n  \n  \n  /*-------------------\n         Aligned\n  --------------------*/\n  \n  .ui.left.aligned.header {\n    text-align: left;\n  }\n  .ui.right.aligned.header {\n    text-align: right;\n  }\n  .ui.centered.header,\n  .ui.center.aligned.header {\n    text-align: center;\n  }\n  .ui.justified.header {\n    text-align: justify;\n  }\n  .ui.justified.header:after {\n    display: inline-block;\n    content: '';\n    width: 100%;\n  }\n  \n  /*-------------------\n         Floated\n  --------------------*/\n  \n  .ui.floated.header,\n  .ui[class*=\"left floated\"].header {\n    float: left;\n    margin-top: 0;\n    margin-right: $header-floated-margin;\n  }\n  .ui[class*=\"right floated\"].header {\n    float: right;\n    margin-top: 0;\n    margin-left: $header-floated-margin;\n  }\n  \n  /*-------------------\n         Fitted\n  --------------------*/\n  \n  .ui.fitted.header {\n    padding: 0;\n  }\n  \n  \n  /*-------------------\n        Dividing\n  --------------------*/\n  \n  .ui.dividing.header {\n    padding-bottom: $header-divided-border-padding;\n    border-bottom: $header-divided-border;\n  }\n  .ui.dividing.header .sub.header {\n    padding-bottom: $header-divided-sub-padding;\n  }\n  .ui.dividing.header .icon {\n    margin-bottom: $header-divided-icon-padding;\n  }\n  \n  .ui.inverted.dividing.header {\n    border-bottom-color: $header-inverted-divided-border-color;\n  }\n  \n  \n  /*-------------------\n          Block\n  --------------------*/\n  \n  .ui.block.header {\n    background: $header-block-background;\n    padding: $header-block-vertical-padding $header-block-horizontal-padding;\n    box-shadow: $header-block-box-shadow;\n    border: $header-block-border;\n    border-radius: $header-block-border-radius;\n  }\n  \n  .ui.tiny.block.header {\n    font-size: $header-tiny-block;\n  }\n  .ui.small.block.header {\n    font-size: $header-small-block;\n  }\n  .ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n    font-size: $header-medium-block;\n  }\n  .ui.large.block.header {\n    font-size: $header-large-block;\n  }\n  .ui.huge.block.header {\n    font-size: $header-huge-block;\n  }\n  \n  /*-------------------\n         Attached\n  --------------------*/\n  \n  .ui.attached.header {\n    background: $header-attached-background;\n    padding: $header-attached-vertical-padding $header-attached-horizontal-padding;\n    margin: 0 $header-attached-offset 0 $header-attached-offset;\n    box-shadow: $header-attached-box-shadow;\n    border: $header-attached-border;\n    border-radius: 0;\n  }\n  .ui.attached.block.header {\n    background: $header-block-background;\n  }\n  .ui.attached:not(.top).header {\n    border-top: none;\n  }\n  .ui.top.attached.header {\n    border-radius: $header-attached-border-radius $header-attached-border-radius 0 0;\n  }\n  .ui.bottom.attached.header {\n    border-radius: 0 0 $header-attached-border-radius $header-attached-border-radius;\n  }\n  \n  /* Attached Sizes */\n  .ui.tiny.attached.header {\n    font-size: $header-tiny-attached-size;\n  }\n  .ui.small.attached.header {\n    font-size: $header-small-attached-size;\n  }\n  .ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n    font-size: $header-medium-attached-size;\n  }\n  .ui.large.attached.header {\n    font-size: $header-large-attached-size;\n  }\n  .ui.huge.attached.header {\n    font-size: $header-huge-attached-size;\n  }\n  \n  /*-------------------\n          Sizing\n  --------------------*/\n  \n  .ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6) {\n    font-size: $header-medium-font-size;\n  }\n}\n\n@import '../../themes/default/elements/header.style';","@import '../../themes/default/elements/icon.variables';\n\n@if $use-icon {\n  /*******************************\n  //@-         Icon\n  *******************************/\n  \n  @font-face {\n    font-family: 'Icons';\n    src: $icon-fallback-src;\n    src: $icon-src;\n    font-style: normal;\n    font-weight: $normal;\n    font-variant: normal;\n    text-decoration: inherit;\n    text-transform: none;\n  }\n  \n  i.icon {\n    display: inline-block;\n    opacity: $icon-opacity;\n  \n    margin: 0 $icon-distance-from-text 0 0;\n  \n    width: $icon-width;\n    height: $icon-height;\n  \n    font-family: 'Icons';\n    font-style: normal;\n    font-weight: $normal;\n    text-decoration: inherit;\n    text-align: center;\n  \n    speak: none;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    backface-visibility: hidden;\n  }\n  \n  i.icon:before {\n    background: none !important;\n  }\n  \n  /*******************************\n               Types\n  *******************************/\n  \n  /*--------------\n      Loading\n  ---------------*/\n  \n  i.icon.loading {\n    height: 1em;\n    line-height: 1;\n    animation: loader $icon-loading-duration linear infinite;\n  }\n  \n  /*******************************\n               States\n  *******************************/\n  \n  i.icon:hover, i.icons:hover,\n  i.icon:active, i.icons:active,\n  i.emphasized.icon:not(.disabled), i.emphasized.icons:not(.disabled) {\n    opacity: 1;\n  }\n  \n  i.disabled.icon, i.disabled.icons {\n    opacity: $disabled-opacity;\n    cursor: default;\n    pointer-events: none;\n  }\n  \n  \n  /*******************************\n             Variations\n  *******************************/\n  \n  \n  /*-------------------\n          Fitted\n  --------------------*/\n  \n  i.fitted.icon {\n    width: auto;\n    margin: 0 !important;\n  }\n  \n  /*-------------------\n           Link\n  --------------------*/\n  \n  i.link.icon:not(.disabled), i.link.icons:not(.disabled) {\n    cursor: pointer;\n    opacity: $icon-link-opacity;\n    transition: opacity $default-duration $default-easing;\n  }\n  i.link.icon:hover, i.link.icons:hover {\n    opacity: 1;\n  }\n  \n  /*-------------------\n        Circular\n  --------------------*/\n  \n  i.circular.icon {\n    border-radius: 500em !important;\n    line-height: 1 !important;\n  \n    padding: $icon-circular-padding !important;\n    box-shadow: $icon-circular-shadow;\n  \n    width: $icon-circular-size !important;\n    height: $icon-circular-size !important;\n  }\n  i.circular.inverted.icon {\n    border: none;\n    box-shadow: none;\n  }\n  \n  /*-------------------\n        Flipped\n  --------------------*/\n  \n  i.flipped.icon,\n  i.horizontally.flipped.icon {\n    transform: scale(-1, 1);\n  }\n  i.vertically.flipped.icon {\n    transform: scale(1, -1);\n  }\n  \n  /*-------------------\n        Rotated\n  --------------------*/\n  \n  i.rotated.icon,\n  i.right.rotated.icon,\n  i.clockwise.rotated.icon {\n    transform: rotate(90deg);\n  }\n  \n  i.left.rotated.icon,\n  i.counterclockwise.rotated.icon {\n    transform: rotate(-90deg);\n  }\n  \n  i.halfway.rotated.icon {\n    transform: rotate(180deg);\n  }\n  \n  /*--------------------------\n        Flipped & Rotated\n  ---------------------------*/\n  i.rotated.flipped.icon,\n  i.right.rotated.flipped.icon,\n  i.clockwise.rotated.flipped.icon {\n    transform: scale(-1, 1) rotate(90deg);\n  }\n  \n  i.left.rotated.flipped.icon,\n  i.counterclockwise.rotated.flipped.icon {\n    transform: scale(-1, 1) rotate(-90deg);\n  }\n  \n  i.halfway.rotated.flipped.icon {\n    transform: scale(-1, 1) rotate(180deg);\n  }\n  \n  i.rotated.vertically.flipped.icon,\n  i.right.rotated.vertically.flipped.icon,\n  i.clockwise.rotated.vertically.flipped.icon {\n    transform: scale(1, -1) rotate(90deg);\n  }\n  \n  i.left.rotated.vertically.flipped.icon,\n  i.counterclockwise.rotated.vertically.flipped.icon {\n    transform: scale(1, -1) rotate(-90deg);\n  }\n  \n  i.halfway.rotated.vertically.flipped.icon {\n    transform: scale(1, -1) rotate(180deg);\n  }\n  \n  /*-------------------\n        Bordered\n  --------------------*/\n  \n  i.bordered.icon {\n    line-height: 1;\n    vertical-align: baseline;\n  \n    width: $icon-bordered-size;\n    height: $icon-bordered-size;\n    padding: $icon-bordered-vertical-padding $icon-bordered-horizontal-padding !important;\n    box-shadow: $icon-bordered-shadow;\n  }\n  i.bordered.inverted.icon {\n    border: none;\n    box-shadow: none;\n  }\n  \n  /*-------------------\n        Inverted\n  --------------------*/\n  \n  /* Inverted Shapes */\n  i.inverted.bordered.icon,\n  i.inverted.circular.icon {\n    background-color: $black;\n    color: $white;\n  }\n  \n  i.inverted.icon {\n    color: $white;\n  }\n  \n  \n  /*-------------------\n         Colors\n  --------------------*/\n  \n  @each $key, $value in $colors {\n    $color: $key;\n    $c: map-get($value, color);\n    $l: map-get($value, light);\n  \n    i.#{$key + \"\"}.icon.icon.icon.icon {\n      color: $c;\n    }\n    i.inverted.#{$key + \"\"}.icon.icon.icon.icon {\n      color: $l;\n    }\n    i.inverted.bordered.#{$key + \"\"}.icon.icon.icon.icon,\n    i.inverted.circular.#{$key + \"\"}.icon.icon.icon.icon {\n      background-color: $c;\n      color: $white;\n    }\n  }\n  \n  \n  /*-------------------\n          Sizes\n  --------------------*/\n  \n  i.mini.mini.mini.icon,\n  i.mini.mini.mini.icons {\n    line-height: 1;\n    font-size: $icon-mini;\n  }\n  i.tiny.tiny.tiny.icon,\n  i.tiny.tiny.tiny.icons {\n    line-height: 1;\n    font-size: $icon-tiny;\n  }\n  i.small.small.small.icon,\n  i.small.small.small.icons {\n    line-height: 1;\n    font-size: $icon-small;\n  }\n  i.icon,\n  i.icons {\n    font-size: $icon-medium;\n  }\n  i.large.large.large.icon,\n  i.large.large.large.icons {\n    line-height: 1;\n    vertical-align: middle;\n    font-size: $icon-large;\n  }\n  i.big.big.big.icon,\n  i.big.big.big.icons {\n    line-height: 1;\n    vertical-align: middle;\n    font-size: $icon-big;\n  }\n  i.huge.huge.huge.icon,\n  i.huge.huge.huge.icons {\n    line-height: 1;\n    vertical-align: middle;\n    font-size: $icon-huge;\n  }\n  i.massive.massive.massive.icon,\n  i.massive.massive.massive.icons {\n    line-height: 1;\n    vertical-align: middle;\n    font-size: $icon-massive;\n  }\n  \n  /*******************************\n              Groups\n  *******************************/\n  \n  i.icons {\n    display: inline-block;\n    position: relative;\n    line-height: 1;\n  }\n  \n  i.icons .icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n    margin: 0;\n  }\n  \n  i.icons .icon:first-child {\n    position: static;\n    width: auto;\n    height: auto;\n    vertical-align: top;\n    transform: none;\n  }\n  \n  /* Corner Icon */\n  i.icons .corner.icon {\n    top: auto;\n    left: auto;\n    right: 0;\n    bottom: 0;\n    transform: none;\n    font-size: $icon-corner-size;\n    text-shadow: $icon-corner-shadow;\n  }\n  i.icons .icon.corner[class*=\"top right\"] {\n    top: 0;\n    left: auto;\n    right: 0;\n    bottom: auto;\n  }\n  i.icons .icon.corner[class*=\"top left\"] {\n    top: 0;\n    left: 0;\n    right: auto;\n    bottom: auto;\n  }\n  i.icons .icon.corner[class*=\"bottom left\"] {\n    top: auto;\n    left: 0;\n    right: auto;\n    bottom: 0;\n  }\n  i.icons .icon.corner[class*=\"bottom right\"] {\n    top: auto;\n    left: auto;\n    right: 0;\n    bottom: 0;\n  }\n  \n  i.icons .inverted.corner.icon {\n    text-shadow: $icon-corner-inverted-shadow;\n  }\n}\n\n@import '../../themes/default/elements/icon.style';","@if $use-icon {\n  /*\n  * Font Awesome 5.9.0 by @fontawesome [https://fontawesome.com]\n  * License - https://fontawesome.com/license (Icons: CC BY 4.0 License, Fonts: SIL OFL 1.1 License, CSS: MIT License)\n  */\n\n  /*******************************\n\n  Fomantic-UI integration of FontAwesome :\n\n  // class names are separated\n  i.icon.angle-left  =>  i.icon.angle.left\n\n  // variations are extracted\n  i.icon.circle      =>  i.icon.circle\n  i.icon.circle-o    =>  i.icon.circle.outline\n\n  // abbreviation are replaced by full words\n  i.icon.*-h         =>  i.icon.*.horizontal\n  i.icon.*-v         =>  i.icon.*.vertical\n  i.icon.alpha       =>  i.icon.alphabet\n  i.icon.asc         =>  i.icon.ascending\n  i.icon.desc        =>  i.icon.descending\n  i.icon.alt         =>  i.icon.alternate\n\n\n  Icons are order A-Z in their group, Solid, Outline, Thin (Pro only) and Brand\n\n  *******************************/\n\n\n  /*******************************\n              Icons\n  *******************************/\n\n  /* Deprecated *In/Out Naming Conflict) */\n  i.icon.linkedin.in:before { content: \"\\f0e1\"; }\n  i.icon.zoom.in:before { content: \"\\f00e\"; }\n  i.icon.zoom.out:before { content: \"\\f010\"; }\n  i.icon.sign.in:before { content: \"\\f2f6\"; }\n  i.icon.in.cart:before { content: \"\\f218\"; }\n  i.icon.log.out:before { content: \"\\f2f5\"; }\n  i.icon.sign.out:before { content: \"\\f2f5\"; }\n\n\n  /*******************************\n            Solid Icons\n  *******************************/\n\n  /* Icons */\n  i.icon.ad:before { content: \"\\f641\"; }\n  i.icon.address.book:before { content: \"\\f2b9\"; }\n  i.icon.address.card:before { content: \"\\f2bb\"; }\n  i.icon.adjust:before { content: \"\\f042\"; }\n  i.icon.air.freshener:before { content: \"\\f5d0\"; }\n  i.icon.align.center:before { content: \"\\f037\"; }\n  i.icon.align.justify:before { content: \"\\f039\"; }\n  i.icon.align.left:before { content: \"\\f036\"; }\n  i.icon.align.right:before { content: \"\\f038\"; }\n  i.icon.allergies:before { content: \"\\f461\"; }\n  i.icon.ambulance:before { content: \"\\f0f9\"; }\n  i.icon.american.sign.language.interpreting:before { content: \"\\f2a3\"; }\n  i.icon.anchor:before { content: \"\\f13d\"; }\n  i.icon.angle.double.down:before { content: \"\\f103\"; }\n  i.icon.angle.double.left:before { content: \"\\f100\"; }\n  i.icon.angle.double.right:before { content: \"\\f101\"; }\n  i.icon.angle.double.up:before { content: \"\\f102\"; }\n  i.icon.angle.left:before { content: \"\\f104\"; }\n  i.icon.angle.right:before { content: \"\\f105\"; }\n  i.icon.angle.up:before { content: \"\\f106\"; }\n  i.icon.angle.down:before { content: \"\\f107\"; }\n  i.icon.angry:before { content: \"\\f556\"; }\n  i.icon.ankh:before { content: \"\\f644\"; }\n  i.icon.archive:before { content: \"\\f187\"; }\n  i.icon.archway:before { content: \"\\f557\"; }\n  i.icon.arrow.alternate.circle.down:before { content: \"\\f358\"; }\n  i.icon.arrow.alternate.circle.left:before { content: \"\\f359\"; }\n  i.icon.arrow.alternate.circle.right:before { content: \"\\f35a\"; }\n  i.icon.arrow.alternate.circle.up:before { content: \"\\f35b\"; }\n  i.icon.arrow.circle.down:before { content: \"\\f0ab\"; }\n  i.icon.arrow.circle.left:before { content: \"\\f0a8\"; }\n  i.icon.arrow.circle.right:before { content: \"\\f0a9\"; }\n  i.icon.arrow.circle.up:before { content: \"\\f0aa\"; }\n  i.icon.arrow.down:before { content: \"\\f063\"; }\n  i.icon.arrow.left:before { content: \"\\f060\"; }\n  i.icon.arrow.right:before { content: \"\\f061\"; }\n  i.icon.arrow.up:before { content: \"\\f062\"; }\n  i.icon.arrows.alternate:before { content: \"\\f0b2\"; }\n  i.icon.arrows.alternate.horizontal:before { content: \"\\f337\"; }\n  i.icon.arrows.alternate.vertical:before { content: \"\\f338\"; }\n  i.icon.assistive.listening.systems:before { content: \"\\f2a2\"; }\n  i.icon.asterisk:before { content: \"\\f069\"; }\n  i.icon.at:before { content: \"\\f1fa\"; }\n  i.icon.atlas:before { content: \"\\f558\"; }\n  i.icon.atom:before { content: \"\\f5d2\"; }\n  i.icon.audio.description:before { content: \"\\f29e\"; }\n  i.icon.award:before { content: \"\\f559\"; }\n  i.icon.baby:before { content: \"\\f77c\"; }\n  i.icon.baby.carriage:before { content: \"\\f77d\"; }\n  i.icon.backspace:before { content: \"\\f55a\"; }\n  i.icon.backward:before { content: \"\\f04a\"; }\n  i.icon.bacon:before { content: \"\\f7e5\"; }\n  i.icon.balance.scale:before { content: \"\\f24e\"; }\n  i.icon.balance.scale.left:before { content: \"\\f515\"; }\n  i.icon.balance.scale.right:before { content: \"\\f516\"; }\n  i.icon.ban:before { content: \"\\f05e\"; }\n  i.icon.band.aid:before { content: \"\\f462\"; }\n  i.icon.barcode:before { content: \"\\f02a\"; }\n  i.icon.bars:before { content: \"\\f0c9\"; }\n  i.icon.baseball.ball:before { content: \"\\f433\"; }\n  i.icon.basketball.ball:before { content: \"\\f434\"; }\n  i.icon.bath:before { content: \"\\f2cd\"; }\n  i.icon.battery.empty:before { content: \"\\f244\"; }\n  i.icon.battery.full:before { content: \"\\f240\"; }\n  i.icon.battery.half:before { content: \"\\f242\"; }\n  i.icon.battery.quarter:before { content: \"\\f243\"; }\n  i.icon.battery.three.quarters:before { content: \"\\f241\"; }\n  i.icon.bed:before { content: \"\\f236\"; }\n  i.icon.beer:before { content: \"\\f0fc\"; }\n  i.icon.bell:before { content: \"\\f0f3\"; }\n  i.icon.bell.slash:before { content: \"\\f1f6\"; }\n  i.icon.bezier.curve:before { content: \"\\f55b\"; }\n  i.icon.bible:before { content: \"\\f647\"; }\n  i.icon.bicycle:before { content: \"\\f206\"; }\n  i.icon.biking:before { content: \"\\f84a\"; }\n  i.icon.binoculars:before { content: \"\\f1e5\"; }\n  i.icon.biohazard:before { content: \"\\f780\"; }\n  i.icon.birthday.cake:before { content: \"\\f1fd\"; }\n  i.icon.blender:before { content: \"\\f517\"; }\n  i.icon.blender.phone:before { content: \"\\f6b6\"; }\n  i.icon.blind:before { content: \"\\f29d\"; }\n  i.icon.blog:before { content: \"\\f781\"; }\n  i.icon.bold:before { content: \"\\f032\"; }\n  i.icon.bolt:before { content: \"\\f0e7\"; }\n  i.icon.bomb:before { content: \"\\f1e2\"; }\n  i.icon.bone:before { content: \"\\f5d7\"; }\n  i.icon.bong:before { content: \"\\f55c\"; }\n  i.icon.book:before { content: \"\\f02d\"; }\n  i.icon.book.dead:before { content: \"\\f6b7\"; }\n  i.icon.book.medical:before { content: \"\\f7e6\"; }\n  i.icon.book.open:before { content: \"\\f518\"; }\n  i.icon.book.reader:before { content: \"\\f5da\"; }\n  i.icon.bookmark:before { content: \"\\f02e\"; }\n  i.icon.border.all:before { content: \"\\f84c\"; }\n  i.icon.border.none:before { content: \"\\f850\"; }\n  i.icon.border.style:before { content: \"\\f853\"; }\n  i.icon.bowling.ball:before { content: \"\\f436\"; }\n  i.icon.box:before { content: \"\\f466\"; }\n  i.icon.box.open:before { content: \"\\f49e\"; }\n  i.icon.boxes:before { content: \"\\f468\"; }\n  i.icon.braille:before { content: \"\\f2a1\"; }\n  i.icon.brain:before { content: \"\\f5dc\"; }\n  i.icon.bread.slice:before { content: \"\\f7ec\"; }\n  i.icon.briefcase:before { content: \"\\f0b1\"; }\n  i.icon.briefcase.medical:before { content: \"\\f469\"; }\n  i.icon.broadcast.tower:before { content: \"\\f519\"; }\n  i.icon.broom:before { content: \"\\f51a\"; }\n  i.icon.brush:before { content: \"\\f55d\"; }\n  i.icon.bug:before { content: \"\\f188\"; }\n  i.icon.building:before { content: \"\\f1ad\"; }\n  i.icon.bullhorn:before { content: \"\\f0a1\"; }\n  i.icon.bullseye:before { content: \"\\f140\"; }\n  i.icon.burn:before { content: \"\\f46a\"; }\n  i.icon.bus:before { content: \"\\f207\"; }\n  i.icon.bus.alternate:before { content: \"\\f55e\"; }\n  i.icon.business.time:before { content: \"\\f64a\"; }\n  i.icon.calculator:before { content: \"\\f1ec\"; }\n  i.icon.calendar:before { content: \"\\f133\"; }\n  i.icon.calendar.alternate:before { content: \"\\f073\"; }\n  i.icon.calendar.check:before { content: \"\\f274\"; }\n  i.icon.calendar.day:before { content: \"\\f783\"; }\n  i.icon.calendar.minus:before { content: \"\\f272\"; }\n  i.icon.calendar.plus:before { content: \"\\f271\"; }\n  i.icon.calendar.times:before { content: \"\\f273\"; }\n  i.icon.calendar.week:before { content: \"\\f784\"; }\n  i.icon.camera:before { content: \"\\f030\"; }\n  i.icon.camera.retro:before { content: \"\\f083\"; }\n  i.icon.campground:before { content: \"\\f6bb\"; }\n  i.icon.candy.cane:before { content: \"\\f786\"; }\n  i.icon.cannabis:before { content: \"\\f55f\"; }\n  i.icon.capsules:before { content: \"\\f46b\"; }\n  i.icon.car:before { content: \"\\f1b9\"; }\n  i.icon.car.alternate:before { content: \"\\f5de\"; }\n  i.icon.car.battery:before { content: \"\\f5df\"; }\n  i.icon.car.crash:before { content: \"\\f5e1\"; }\n  i.icon.car.side:before { content: \"\\f5e4\"; }\n  i.icon.caret.down:before { content: \"\\f0d7\"; }\n  i.icon.caret.left:before { content: \"\\f0d9\"; }\n  i.icon.caret.right:before { content: \"\\f0da\"; }\n  i.icon.caret.square.down:before { content: \"\\f150\"; }\n  i.icon.caret.square.left:before { content: \"\\f191\"; }\n  i.icon.caret.square.right:before { content: \"\\f152\"; }\n  i.icon.caret.square.up:before { content: \"\\f151\"; }\n  i.icon.caret.up:before { content: \"\\f0d8\"; }\n  i.icon.carrot:before { content: \"\\f787\"; }\n  i.icon.cart.arrow.down:before { content: \"\\f218\"; }\n  i.icon.cart.plus:before { content: \"\\f217\"; }\n  i.icon.cash.register:before { content: \"\\f788\"; }\n  i.icon.cat:before { content: \"\\f6be\"; }\n  i.icon.certificate:before { content: \"\\f0a3\"; }\n  i.icon.chair:before { content: \"\\f6c0\"; }\n  i.icon.chalkboard:before { content: \"\\f51b\"; }\n  i.icon.chalkboard.teacher:before { content: \"\\f51c\"; }\n  i.icon.charging.station:before { content: \"\\f5e7\"; }\n  i.icon.chart.area:before { content: \"\\f1fe\"; }\n  i.icon.chart.bar:before { content: \"\\f080\"; }\n  i.icon.chart.line:before { content: \"\\f201\"; }\n  i.icon.chart.pie:before { content: \"\\f200\"; }\n  i.icon.check:before { content: \"\\f00c\"; }\n  i.icon.check.circle:before { content: \"\\f058\"; }\n  i.icon.check.double:before { content: \"\\f560\"; }\n  i.icon.check.square:before { content: \"\\f14a\"; }\n  i.icon.cheese:before { content: \"\\f7ef\"; }\n  i.icon.chess:before { content: \"\\f439\"; }\n  i.icon.chess.bishop:before { content: \"\\f43a\"; }\n  i.icon.chess.board:before { content: \"\\f43c\"; }\n  i.icon.chess.king:before { content: \"\\f43f\"; }\n  i.icon.chess.knight:before { content: \"\\f441\"; }\n  i.icon.chess.pawn:before { content: \"\\f443\"; }\n  i.icon.chess.queen:before { content: \"\\f445\"; }\n  i.icon.chess.rook:before { content: \"\\f447\"; }\n  i.icon.chevron.circle.down:before { content: \"\\f13a\"; }\n  i.icon.chevron.circle.left:before { content: \"\\f137\"; }\n  i.icon.chevron.circle.right:before { content: \"\\f138\"; }\n  i.icon.chevron.circle.up:before { content: \"\\f139\"; }\n  i.icon.chevron.down:before { content: \"\\f078\"; }\n  i.icon.chevron.left:before { content: \"\\f053\"; }\n  i.icon.chevron.right:before { content: \"\\f054\"; }\n  i.icon.chevron.up:before { content: \"\\f077\"; }\n  i.icon.child:before { content: \"\\f1ae\"; }\n  i.icon.church:before { content: \"\\f51d\"; }\n  i.icon.circle:before { content: \"\\f111\"; }\n  i.icon.circle.notch:before { content: \"\\f1ce\"; }\n  i.icon.city:before { content: \"\\f64f\"; }\n  i.icon.clinic.medical:before { content: \"\\f7f2\"; }\n  i.icon.clipboard:before { content: \"\\f328\"; }\n  i.icon.clipboard.check:before { content: \"\\f46c\"; }\n  i.icon.clipboard.list:before { content: \"\\f46d\"; }\n  i.icon.clock:before { content: \"\\f017\"; }\n  i.icon.clone:before { content: \"\\f24d\"; }\n  i.icon.closed.captioning:before { content: \"\\f20a\"; }\n  i.icon.cloud:before { content: \"\\f0c2\"; }\n  i.icon.cloud.download.alternate:before { content: \"\\f381\"; }\n  i.icon.cloud.meatball:before { content: \"\\f73b\"; }\n  i.icon.cloud.moon:before { content: \"\\f6c3\"; }\n  i.icon.cloud.moon.rain:before { content: \"\\f73c\"; }\n  i.icon.cloud.rain:before { content: \"\\f73d\"; }\n  i.icon.cloud.showers.heavy:before { content: \"\\f740\"; }\n  i.icon.cloud.sun:before { content: \"\\f6c4\"; }\n  i.icon.cloud.sun.rain:before { content: \"\\f743\"; }\n  i.icon.cloud.upload.alternate:before { content: \"\\f382\"; }\n  i.icon.cocktail:before { content: \"\\f561\"; }\n  i.icon.code:before { content: \"\\f121\"; }\n  i.icon.code.branch:before { content: \"\\f126\"; }\n  i.icon.coffee:before { content: \"\\f0f4\"; }\n  i.icon.cog:before { content: \"\\f013\"; }\n  i.icon.cogs:before { content: \"\\f085\"; }\n  i.icon.coins:before { content: \"\\f51e\"; }\n  i.icon.columns:before { content: \"\\f0db\"; }\n  i.icon.comment:before { content: \"\\f075\"; }\n  i.icon.comment.alternate:before { content: \"\\f27a\"; }\n  i.icon.comment.dollar:before { content: \"\\f651\"; }\n  i.icon.comment.dots:before { content: \"\\f4ad\"; }\n  i.icon.comment.medical:before { content: \"\\f7f5\"; }\n  i.icon.comment.slash:before { content: \"\\f4b3\"; }\n  i.icon.comments:before { content: \"\\f086\"; }\n  i.icon.comments.dollar:before { content: \"\\f653\"; }\n  i.icon.compact.disc:before { content: \"\\f51f\"; }\n  i.icon.compass:before { content: \"\\f14e\"; }\n  i.icon.compress:before { content: \"\\f066\"; }\n  i.icon.compress.arrows.alternate:before { content: \"\\f78c\"; }\n  i.icon.concierge.bell:before { content: \"\\f562\"; }\n  i.icon.cookie:before { content: \"\\f563\"; }\n  i.icon.cookie.bite:before { content: \"\\f564\"; }\n  i.icon.copy:before { content: \"\\f0c5\"; }\n  i.icon.copyright:before { content: \"\\f1f9\"; }\n  i.icon.couch:before { content: \"\\f4b8\"; }\n  i.icon.credit.card:before { content: \"\\f09d\"; }\n  i.icon.crop:before { content: \"\\f125\"; }\n  i.icon.crop.alternate:before { content: \"\\f565\"; }\n  i.icon.cross:before { content: \"\\f654\"; }\n  i.icon.crosshairs:before { content: \"\\f05b\"; }\n  i.icon.crow:before { content: \"\\f520\"; }\n  i.icon.crown:before { content: \"\\f521\"; }\n  i.icon.crutch:before { content: \"\\f7f7\"; }\n  i.icon.cube:before { content: \"\\f1b2\"; }\n  i.icon.cubes:before { content: \"\\f1b3\"; }\n  i.icon.cut:before { content: \"\\f0c4\"; }\n  i.icon.database:before { content: \"\\f1c0\"; }\n  i.icon.deaf:before { content: \"\\f2a4\"; }\n  i.icon.democrat:before { content: \"\\f747\"; }\n  i.icon.desktop:before { content: \"\\f108\"; }\n  i.icon.dharmachakra:before { content: \"\\f655\"; }\n  i.icon.diagnoses:before { content: \"\\f470\"; }\n  i.icon.dice:before { content: \"\\f522\"; }\n  i.icon.dice.d20:before { content: \"\\f6cf\"; }\n  i.icon.dice.d6:before { content: \"\\f6d1\"; }\n  i.icon.dice.five:before { content: \"\\f523\"; }\n  i.icon.dice.four:before { content: \"\\f524\"; }\n  i.icon.dice.one:before { content: \"\\f525\"; }\n  i.icon.dice.six:before { content: \"\\f526\"; }\n  i.icon.dice.three:before { content: \"\\f527\"; }\n  i.icon.dice.two:before { content: \"\\f528\"; }\n  i.icon.digital.tachograph:before { content: \"\\f566\"; }\n  i.icon.directions:before { content: \"\\f5eb\"; }\n  i.icon.divide:before { content: \"\\f529\"; }\n  i.icon.dizzy:before { content: \"\\f567\"; }\n  i.icon.dna:before { content: \"\\f471\"; }\n  i.icon.dog:before { content: \"\\f6d3\"; }\n  i.icon.dollar.sign:before { content: \"\\f155\"; }\n  i.icon.dolly:before { content: \"\\f472\"; }\n  i.icon.dolly.flatbed:before { content: \"\\f474\"; }\n  i.icon.donate:before { content: \"\\f4b9\"; }\n  i.icon.door.closed:before { content: \"\\f52a\"; }\n  i.icon.door.open:before { content: \"\\f52b\"; }\n  i.icon.dot.circle:before { content: \"\\f192\"; }\n  i.icon.dove:before { content: \"\\f4ba\"; }\n  i.icon.download:before { content: \"\\f019\"; }\n  i.icon.drafting.compass:before { content: \"\\f568\"; }\n  i.icon.dragon:before { content: \"\\f6d5\"; }\n  i.icon.draw.polygon:before { content: \"\\f5ee\"; }\n  i.icon.drum:before { content: \"\\f569\"; }\n  i.icon.drum.steelpan:before { content: \"\\f56a\"; }\n  i.icon.drumstick.bite:before { content: \"\\f6d7\"; }\n  i.icon.dumbbell:before { content: \"\\f44b\"; }\n  i.icon.dumpster:before { content: \"\\f793\"; }\n  i.icon.dumpster.fire:before { content: \"\\f794\"; }\n  i.icon.dungeon:before { content: \"\\f6d9\"; }\n  i.icon.edit:before { content: \"\\f044\"; }\n  i.icon.egg:before { content: \"\\f7fb\"; }\n  i.icon.eject:before { content: \"\\f052\"; }\n  i.icon.ellipsis.horizontal:before { content: \"\\f141\"; }\n  i.icon.ellipsis.vertical:before { content: \"\\f142\"; }\n  i.icon.envelope:before { content: \"\\f0e0\"; }\n  i.icon.envelope.open:before { content: \"\\f2b6\"; }\n  i.icon.envelope.open.text:before { content: \"\\f658\"; }\n  i.icon.envelope.square:before { content: \"\\f199\"; }\n  i.icon.equals:before { content: \"\\f52c\"; }\n  i.icon.eraser:before { content: \"\\f12d\"; }\n  i.icon.ethernet:before { content: \"\\f796\"; }\n  i.icon.euro.sign:before { content: \"\\f153\"; }\n  i.icon.exchange.alternate:before { content: \"\\f362\"; }\n  i.icon.exclamation:before { content: \"\\f12a\"; }\n  i.icon.exclamation.circle:before { content: \"\\f06a\"; }\n  i.icon.exclamation.triangle:before { content: \"\\f071\"; }\n  i.icon.expand:before { content: \"\\f065\"; }\n  i.icon.expand.arrows.alternate:before { content: \"\\f31e\"; }\n  i.icon.external.alternate:before { content: \"\\f35d\"; }\n  i.icon.external.link.square.alternate:before { content: \"\\f360\"; }\n  i.icon.eye:before { content: \"\\f06e\"; }\n  i.icon.eye.dropper:before { content: \"\\f1fb\"; }\n  i.icon.eye.slash:before { content: \"\\f070\"; }\n  i.icon.fan:before { content: \"\\f863\"; }\n  i.icon.fast.backward:before { content: \"\\f049\"; }\n  i.icon.fast.forward:before { content: \"\\f050\"; }\n  i.icon.fax:before { content: \"\\f1ac\"; }\n  i.icon.feather:before { content: \"\\f52d\"; }\n  i.icon.feather.alternate:before { content: \"\\f56b\"; }\n  i.icon.female:before { content: \"\\f182\"; }\n  i.icon.fighter.jet:before { content: \"\\f0fb\"; }\n  i.icon.file:before { content: \"\\f15b\"; }\n  i.icon.file.alternate:before { content: \"\\f15c\"; }\n  i.icon.file.archive:before { content: \"\\f1c6\"; }\n  i.icon.file.audio:before { content: \"\\f1c7\"; }\n  i.icon.file.code:before { content: \"\\f1c9\"; }\n  i.icon.file.contract:before { content: \"\\f56c\"; }\n  i.icon.file.csv:before { content: \"\\f6dd\"; }\n  i.icon.file.download:before { content: \"\\f56d\"; }\n  i.icon.file.excel:before { content: \"\\f1c3\"; }\n  i.icon.file.export:before { content: \"\\f56e\"; }\n  i.icon.file.image:before { content: \"\\f1c5\"; }\n  i.icon.file.import:before { content: \"\\f56f\"; }\n  i.icon.file.invoice:before { content: \"\\f570\"; }\n  i.icon.file.invoice.dollar:before { content: \"\\f571\"; }\n  i.icon.file.medical:before { content: \"\\f477\"; }\n  i.icon.file.medical.alternate:before { content: \"\\f478\"; }\n  i.icon.file.pdf:before { content: \"\\f1c1\"; }\n  i.icon.file.powerpoint:before { content: \"\\f1c4\"; }\n  i.icon.file.prescription:before { content: \"\\f572\"; }\n  i.icon.file.signature:before { content: \"\\f573\"; }\n  i.icon.file.upload:before { content: \"\\f574\"; }\n  i.icon.file.video:before { content: \"\\f1c8\"; }\n  i.icon.file.word:before { content: \"\\f1c2\"; }\n  i.icon.fill:before { content: \"\\f575\"; }\n  i.icon.fill.drip:before { content: \"\\f576\"; }\n  i.icon.film:before { content: \"\\f008\"; }\n  i.icon.filter:before { content: \"\\f0b0\"; }\n  i.icon.fingerprint:before { content: \"\\f577\"; }\n  i.icon.fire:before { content: \"\\f06d\"; }\n  i.icon.fire.alternate:before { content: \"\\f7e4\"; }\n  i.icon.fire.extinguisher:before { content: \"\\f134\"; }\n  i.icon.first.aid:before { content: \"\\f479\"; }\n  i.icon.fish:before { content: \"\\f578\"; }\n  i.icon.fist.raised:before { content: \"\\f6de\"; }\n  i.icon.flag:before { content: \"\\f024\"; }\n  i.icon.flag.checkered:before { content: \"\\f11e\"; }\n  i.icon.flag.usa:before { content: \"\\f74d\"; }\n  i.icon.flask:before { content: \"\\f0c3\"; }\n  i.icon.flushed:before { content: \"\\f579\"; }\n  i.icon.folder:before { content: \"\\f07b\"; }\n  i.icon.folder.minus:before { content: \"\\f65d\"; }\n  i.icon.folder.open:before { content: \"\\f07c\"; }\n  i.icon.folder.plus:before { content: \"\\f65e\"; }\n  i.icon.font:before { content: \"\\f031\"; }\n  i.icon.football.ball:before { content: \"\\f44e\"; }\n  i.icon.forward:before { content: \"\\f04e\"; }\n  i.icon.frog:before { content: \"\\f52e\"; }\n  i.icon.frown:before { content: \"\\f119\"; }\n  i.icon.frown.open:before { content: \"\\f57a\"; }\n  i.icon.fruit-apple:before { content: \"\\f5d1\"; }\n  i.icon.funnel.dollar:before { content: \"\\f662\"; }\n  i.icon.futbol:before { content: \"\\f1e3\"; }\n  i.icon.gamepad:before { content: \"\\f11b\"; }\n  i.icon.gas.pump:before { content: \"\\f52f\"; }\n  i.icon.gavel:before { content: \"\\f0e3\"; }\n  i.icon.gem:before { content: \"\\f3a5\"; }\n  i.icon.genderless:before { content: \"\\f22d\"; }\n  i.icon.ghost:before { content: \"\\f6e2\"; }\n  i.icon.gift:before { content: \"\\f06b\"; }\n  i.icon.gifts:before { content: \"\\f79c\"; }\n  i.icon.glass.cheers:before { content: \"\\f79f\"; }\n  i.icon.glass.martini:before { content: \"\\f000\"; }\n  i.icon.glass.martini.alternate:before { content: \"\\f57b\"; }\n  i.icon.glass.whiskey:before { content: \"\\f7a0\"; }\n  i.icon.glasses:before { content: \"\\f530\"; }\n  i.icon.globe:before { content: \"\\f0ac\"; }\n  i.icon.globe.africa:before { content: \"\\f57c\"; }\n  i.icon.globe.americas:before { content: \"\\f57d\"; }\n  i.icon.globe.asia:before { content: \"\\f57e\"; }\n  i.icon.globe.europe:before { content: \"\\f7a2\"; }\n  i.icon.golf.ball:before { content: \"\\f450\"; }\n  i.icon.gopuram:before { content: \"\\f664\"; }\n  i.icon.graduation.cap:before { content: \"\\f19d\"; }\n  i.icon.greater.than:before { content: \"\\f531\"; }\n  i.icon.greater.than.equal:before { content: \"\\f532\"; }\n  i.icon.grimace:before { content: \"\\f57f\"; }\n  i.icon.grin:before { content: \"\\f580\"; }\n  i.icon.grin.alternate:before { content: \"\\f581\"; }\n  i.icon.grin.beam:before { content: \"\\f582\"; }\n  i.icon.grin.beam.sweat:before { content: \"\\f583\"; }\n  i.icon.grin.hearts:before { content: \"\\f584\"; }\n  i.icon.grin.squint:before { content: \"\\f585\"; }\n  i.icon.grin.squint.tears:before { content: \"\\f586\"; }\n  i.icon.grin.stars:before { content: \"\\f587\"; }\n  i.icon.grin.tears:before { content: \"\\f588\"; }\n  i.icon.grin.tongue:before { content: \"\\f589\"; }\n  i.icon.grin.tongue.squint:before { content: \"\\f58a\"; }\n  i.icon.grin.tongue.wink:before { content: \"\\f58b\"; }\n  i.icon.grin.wink:before { content: \"\\f58c\"; }\n  i.icon.grip.horizontal:before { content: \"\\f58d\"; }\n  i.icon.grip.lines:before { content: \"\\f7a4\"; }\n  i.icon.grip.lines.vertical:before { content: \"\\f7a5\"; }\n  i.icon.grip.vertical:before { content: \"\\f58e\"; }\n  i.icon.guitar:before { content: \"\\f7a6\"; }\n  i.icon.h.square:before { content: \"\\f0fd\"; }\n  i.icon.hamburger:before { content: \"\\f805\"; }\n  i.icon.hammer:before { content: \"\\f6e3\"; }\n  i.icon.hamsa:before { content: \"\\f665\"; }\n  i.icon.hand.holding:before { content: \"\\f4bd\"; }\n  i.icon.hand.holding.heart:before { content: \"\\f4be\"; }\n  i.icon.hand.holding.usd:before { content: \"\\f4c0\"; }\n  i.icon.hand.lizard:before { content: \"\\f258\"; }\n  i.icon.hand.middle.finger:before { content: \"\\f806\"; }\n  i.icon.hand.paper:before { content: \"\\f256\"; }\n  i.icon.hand.peace:before { content: \"\\f25b\"; }\n  i.icon.hand.point.down:before { content: \"\\f0a7\"; }\n  i.icon.hand.point.left:before { content: \"\\f0a5\"; }\n  i.icon.hand.point.right:before { content: \"\\f0a4\"; }\n  i.icon.hand.point.up:before { content: \"\\f0a6\"; }\n  i.icon.hand.pointer:before { content: \"\\f25a\"; }\n  i.icon.hand.rock:before { content: \"\\f255\"; }\n  i.icon.hand.scissors:before { content: \"\\f257\"; }\n  i.icon.hand.spock:before { content: \"\\f259\"; }\n  i.icon.hands:before { content: \"\\f4c2\"; }\n  i.icon.hands.helping:before { content: \"\\f4c4\"; }\n  i.icon.handshake:before { content: \"\\f2b5\"; }\n  i.icon.hanukiah:before { content: \"\\f6e6\"; }\n  i.icon.hard.hat:before { content: \"\\f807\"; }\n  i.icon.hashtag:before { content: \"\\f292\"; }\n  i.icon.hat.wizard:before { content: \"\\f6e8\"; }\n  i.icon.haykal:before { content: \"\\f666\"; }\n  i.icon.hdd:before { content: \"\\f0a0\"; }\n  i.icon.heading:before { content: \"\\f1dc\"; }\n  i.icon.headphones:before { content: \"\\f025\"; }\n  i.icon.headphones.alternate:before { content: \"\\f58f\"; }\n  i.icon.headset:before { content: \"\\f590\"; }\n  i.icon.heart:before { content: \"\\f004\"; }\n  i.icon.heart.broken:before { content: \"\\f7a9\"; }\n  i.icon.heartbeat:before { content: \"\\f21e\"; }\n  i.icon.helicopter:before { content: \"\\f533\"; }\n  i.icon.highlighter:before { content: \"\\f591\"; }\n  i.icon.hiking:before { content: \"\\f6ec\"; }\n  i.icon.hippo:before { content: \"\\f6ed\"; }\n  i.icon.history:before { content: \"\\f1da\"; }\n  i.icon.hockey.puck:before { content: \"\\f453\"; }\n  i.icon.holly.berry:before { content: \"\\f7aa\"; }\n  i.icon.home:before { content: \"\\f015\"; }\n  i.icon.horse:before { content: \"\\f6f0\"; }\n  i.icon.horse.head:before { content: \"\\f7ab\"; }\n  i.icon.hospital:before { content: \"\\f0f8\"; }\n  i.icon.hospital.alternate:before { content: \"\\f47d\"; }\n  i.icon.hospital.symbol:before { content: \"\\f47e\"; }\n  i.icon.hot.tub:before { content: \"\\f593\"; }\n  i.icon.hotdog:before { content: \"\\f80f\"; }\n  i.icon.hotel:before { content: \"\\f594\"; }\n  i.icon.hourglass:before { content: \"\\f254\"; }\n  i.icon.hourglass.end:before { content: \"\\f253\"; }\n  i.icon.hourglass.half:before { content: \"\\f252\"; }\n  i.icon.hourglass.start:before { content: \"\\f251\"; }\n  i.icon.house.damage:before { content: \"\\f6f1\"; }\n  i.icon.hryvnia:before { content: \"\\f6f2\"; }\n  i.icon.i.cursor:before { content: \"\\f246\"; }\n  i.icon.ice.cream:before { content: \"\\f810\"; }\n  i.icon.icicles:before { content: \"\\f7ad\"; }\n  i.icon.icons:before { content: \"\\f86d\"; }\n  i.icon.id.badge:before { content: \"\\f2c1\"; }\n  i.icon.id.card:before { content: \"\\f2c2\"; }\n  i.icon.id.card.alternate:before { content: \"\\f47f\"; }\n  i.icon.igloo:before { content: \"\\f7ae\"; }\n  i.icon.image:before { content: \"\\f03e\"; }\n  i.icon.images:before { content: \"\\f302\"; }\n  i.icon.inbox:before { content: \"\\f01c\"; }\n  i.icon.indent:before { content: \"\\f03c\"; }\n  i.icon.industry:before { content: \"\\f275\"; }\n  i.icon.infinity:before { content: \"\\f534\"; }\n  i.icon.info:before { content: \"\\f129\"; }\n  i.icon.info.circle:before { content: \"\\f05a\"; }\n  i.icon.italic:before { content: \"\\f033\"; }\n  i.icon.jedi:before { content: \"\\f669\"; }\n  i.icon.joint:before { content: \"\\f595\"; }\n  i.icon.journal.whills:before { content: \"\\f66a\"; }\n  i.icon.kaaba:before { content: \"\\f66b\"; }\n  i.icon.key:before { content: \"\\f084\"; }\n  i.icon.keyboard:before { content: \"\\f11c\"; }\n  i.icon.khanda:before { content: \"\\f66d\"; }\n  i.icon.kiss:before { content: \"\\f596\"; }\n  i.icon.kiss.beam:before { content: \"\\f597\"; }\n  i.icon.kiss.wink.heart:before { content: \"\\f598\"; }\n  i.icon.kiwi.bird:before { content: \"\\f535\"; }\n  i.icon.landmark:before { content: \"\\f66f\"; }\n  i.icon.language:before { content: \"\\f1ab\"; }\n  i.icon.laptop:before { content: \"\\f109\"; }\n  i.icon.laptop.code:before { content: \"\\f5fc\"; }\n  i.icon.laptop.medical:before { content: \"\\f812\"; }\n  i.icon.laugh:before { content: \"\\f599\"; }\n  i.icon.laugh.beam:before { content: \"\\f59a\"; }\n  i.icon.laugh.squint:before { content: \"\\f59b\"; }\n  i.icon.laugh.wink:before { content: \"\\f59c\"; }\n  i.icon.layer.group:before { content: \"\\f5fd\"; }\n  i.icon.leaf:before { content: \"\\f06c\"; }\n  i.icon.lemon:before { content: \"\\f094\"; }\n  i.icon.less.than:before { content: \"\\f536\"; }\n  i.icon.less.than.equal:before { content: \"\\f537\"; }\n  i.icon.level.down.alternate:before { content: \"\\f3be\"; }\n  i.icon.level.up.alternate:before { content: \"\\f3bf\"; }\n  i.icon.life.ring:before { content: \"\\f1cd\"; }\n  i.icon.lightbulb:before { content: \"\\f0eb\"; }\n  i.icon.linkify:before { content: \"\\f0c1\"; }\n  i.icon.lira.sign:before { content: \"\\f195\"; }\n  i.icon.list:before { content: \"\\f03a\"; }\n  i.icon.list.alternate:before { content: \"\\f022\"; }\n  i.icon.list.ol:before { content: \"\\f0cb\"; }\n  i.icon.list.ul:before { content: \"\\f0ca\"; }\n  i.icon.location.arrow:before { content: \"\\f124\"; }\n  i.icon.lock:before { content: \"\\f023\"; }\n  i.icon.lock.open:before { content: \"\\f3c1\"; }\n  i.icon.long.arrow.alternate.down:before { content: \"\\f309\"; }\n  i.icon.long.arrow.alternate.left:before { content: \"\\f30a\"; }\n  i.icon.long.arrow.alternate.right:before { content: \"\\f30b\"; }\n  i.icon.long.arrow.alternate.up:before { content: \"\\f30c\"; }\n  i.icon.low.vision:before { content: \"\\f2a8\"; }\n  i.icon.luggage.cart:before { content: \"\\f59d\"; }\n  i.icon.magic:before { content: \"\\f0d0\"; }\n  i.icon.magnet:before { content: \"\\f076\"; }\n  i.icon.mail.bulk:before { content: \"\\f674\"; }\n  i.icon.male:before { content: \"\\f183\"; }\n  i.icon.map:before { content: \"\\f279\"; }\n  i.icon.map.marked:before { content: \"\\f59f\"; }\n  i.icon.map.marked.alternate:before { content: \"\\f5a0\"; }\n  i.icon.map.marker:before { content: \"\\f041\"; }\n  i.icon.map.marker.alternate:before { content: \"\\f3c5\"; }\n  i.icon.map.pin:before { content: \"\\f276\"; }\n  i.icon.map.signs:before { content: \"\\f277\"; }\n  i.icon.marker:before { content: \"\\f5a1\"; }\n  i.icon.mars:before { content: \"\\f222\"; }\n  i.icon.mars.double:before { content: \"\\f227\"; }\n  i.icon.mars.stroke:before { content: \"\\f229\"; }\n  i.icon.mars.stroke.horizontal:before { content: \"\\f22b\"; }\n  i.icon.mars.stroke.vertical:before { content: \"\\f22a\"; }\n  i.icon.mask:before { content: \"\\f6fa\"; }\n  i.icon.medal:before { content: \"\\f5a2\"; }\n  i.icon.medkit:before { content: \"\\f0fa\"; }\n  i.icon.meh:before { content: \"\\f11a\"; }\n  i.icon.meh.blank:before { content: \"\\f5a4\"; }\n  i.icon.meh.rolling.eyes:before { content: \"\\f5a5\"; }\n  i.icon.memory:before { content: \"\\f538\"; }\n  i.icon.menorah:before { content: \"\\f676\"; }\n  i.icon.mercury:before { content: \"\\f223\"; }\n  i.icon.meteor:before { content: \"\\f753\"; }\n  i.icon.microchip:before { content: \"\\f2db\"; }\n  i.icon.microphone:before { content: \"\\f130\"; }\n  i.icon.microphone.alternate:before { content: \"\\f3c9\"; }\n  i.icon.microphone.alternate.slash:before { content: \"\\f539\"; }\n  i.icon.microphone.slash:before { content: \"\\f131\"; }\n  i.icon.microscope:before { content: \"\\f610\"; }\n  i.icon.minus:before { content: \"\\f068\"; }\n  i.icon.minus.circle:before { content: \"\\f056\"; }\n  i.icon.minus.square:before { content: \"\\f146\"; }\n  i.icon.mitten:before { content: \"\\f7b5\"; }\n  i.icon.mobile:before { content: \"\\f10b\"; }\n  i.icon.mobile.alternate:before { content: \"\\f3cd\"; }\n  i.icon.money.bill:before { content: \"\\f0d6\"; }\n  i.icon.money.bill.alternate:before { content: \"\\f3d1\"; }\n  i.icon.money.bill.wave:before { content: \"\\f53a\"; }\n  i.icon.money.bill.wave.alternate:before { content: \"\\f53b\"; }\n  i.icon.money.check:before { content: \"\\f53c\"; }\n  i.icon.money.check.alternate:before { content: \"\\f53d\"; }\n  i.icon.monument:before { content: \"\\f5a6\"; }\n  i.icon.moon:before { content: \"\\f186\"; }\n  i.icon.mortar.pestle:before { content: \"\\f5a7\"; }\n  i.icon.mosque:before { content: \"\\f678\"; }\n  i.icon.motorcycle:before { content: \"\\f21c\"; }\n  i.icon.mountain:before { content: \"\\f6fc\"; }\n  i.icon.mouse.pointer:before { content: \"\\f245\"; }\n  i.icon.mug.hot:before { content: \"\\f7b6\"; }\n  i.icon.music:before { content: \"\\f001\"; }\n  i.icon.network.wired:before { content: \"\\f6ff\"; }\n  i.icon.neuter:before { content: \"\\f22c\"; }\n  i.icon.newspaper:before { content: \"\\f1ea\"; }\n  i.icon.not.equal:before { content: \"\\f53e\"; }\n  i.icon.notes.medical:before { content: \"\\f481\"; }\n  i.icon.object.group:before { content: \"\\f247\"; }\n  i.icon.object.ungroup:before { content: \"\\f248\"; }\n  i.icon.oil.can:before { content: \"\\f613\"; }\n  i.icon.om:before { content: \"\\f679\"; }\n  i.icon.otter:before { content: \"\\f700\"; }\n  i.icon.outdent:before { content: \"\\f03b\"; }\n  i.icon.pager:before { content: \"\\f815\"; }\n  i.icon.paint.brush:before { content: \"\\f1fc\"; }\n  i.icon.paint.roller:before { content: \"\\f5aa\"; }\n  i.icon.palette:before { content: \"\\f53f\"; }\n  i.icon.pallet:before { content: \"\\f482\"; }\n  i.icon.paper.plane:before { content: \"\\f1d8\"; }\n  i.icon.paperclip:before { content: \"\\f0c6\"; }\n  i.icon.parachute.box:before { content: \"\\f4cd\"; }\n  i.icon.paragraph:before { content: \"\\f1dd\"; }\n  i.icon.parking:before { content: \"\\f540\"; }\n  i.icon.passport:before { content: \"\\f5ab\"; }\n  i.icon.pastafarianism:before { content: \"\\f67b\"; }\n  i.icon.paste:before { content: \"\\f0ea\"; }\n  i.icon.pause:before { content: \"\\f04c\"; }\n  i.icon.pause.circle:before { content: \"\\f28b\"; }\n  i.icon.paw:before { content: \"\\f1b0\"; }\n  i.icon.peace:before { content: \"\\f67c\"; }\n  i.icon.pen:before { content: \"\\f304\"; }\n  i.icon.pen.alternate:before { content: \"\\f305\"; }\n  i.icon.pen.fancy:before { content: \"\\f5ac\"; }\n  i.icon.pen.nib:before { content: \"\\f5ad\"; }\n  i.icon.pen.square:before { content: \"\\f14b\"; }\n  i.icon.pencil.alternate:before { content: \"\\f303\"; }\n  i.icon.pencil.ruler:before { content: \"\\f5ae\"; }\n  i.icon.people.carry:before { content: \"\\f4ce\"; }\n  i.icon.pepper.hot:before { content: \"\\f816\"; }\n  i.icon.percent:before { content: \"\\f295\"; }\n  i.icon.percentage:before { content: \"\\f541\"; }\n  i.icon.person.booth:before { content: \"\\f756\"; }\n  i.icon.phone:before { content: \"\\f095\"; }\n  i.icon.phone.alternate:before { content: \"\\f879\"; }\n  i.icon.phone.slash:before { content: \"\\f3dd\"; }\n  i.icon.phone.square:before { content: \"\\f098\"; }\n  i.icon.phone.square.alternate:before { content: \"\\f87b\"; }\n  i.icon.phone.volume:before { content: \"\\f2a0\"; }\n  i.icon.photo.video:before { content: \"\\f87c\"; }\n  i.icon.piggy.bank:before { content: \"\\f4d3\"; }\n  i.icon.pills:before { content: \"\\f484\"; }\n  i.icon.pizza.slice:before { content: \"\\f818\"; }\n  i.icon.place.of.worship:before { content: \"\\f67f\"; }\n  i.icon.plane:before { content: \"\\f072\"; }\n  i.icon.plane.arrival:before { content: \"\\f5af\"; }\n  i.icon.plane.departure:before { content: \"\\f5b0\"; }\n  i.icon.play:before { content: \"\\f04b\"; }\n  i.icon.play.circle:before { content: \"\\f144\"; }\n  i.icon.plug:before { content: \"\\f1e6\"; }\n  i.icon.plus:before { content: \"\\f067\"; }\n  i.icon.plus.circle:before { content: \"\\f055\"; }\n  i.icon.plus.square:before { content: \"\\f0fe\"; }\n  i.icon.podcast:before { content: \"\\f2ce\"; }\n  i.icon.poll:before { content: \"\\f681\"; }\n  i.icon.poll.horizontal:before { content: \"\\f682\"; }\n  i.icon.poo:before { content: \"\\f2fe\"; }\n  i.icon.poo.storm:before { content: \"\\f75a\"; }\n  i.icon.poop:before { content: \"\\f619\"; }\n  i.icon.portrait:before { content: \"\\f3e0\"; }\n  i.icon.pound.sign:before { content: \"\\f154\"; }\n  i.icon.power.off:before { content: \"\\f011\"; }\n  i.icon.pray:before { content: \"\\f683\"; }\n  i.icon.praying.hands:before { content: \"\\f684\"; }\n  i.icon.prescription:before { content: \"\\f5b1\"; }\n  i.icon.prescription.bottle:before { content: \"\\f485\"; }\n  i.icon.prescription.bottle.alternate:before { content: \"\\f486\"; }\n  i.icon.print:before { content: \"\\f02f\"; }\n  i.icon.procedures:before { content: \"\\f487\"; }\n  i.icon.project.diagram:before { content: \"\\f542\"; }\n  i.icon.puzzle.piece:before { content: \"\\f12e\"; }\n  i.icon.qrcode:before { content: \"\\f029\"; }\n  i.icon.question:before { content: \"\\f128\"; }\n  i.icon.question.circle:before { content: \"\\f059\"; }\n  i.icon.quidditch:before { content: \"\\f458\"; }\n  i.icon.quote.left:before { content: \"\\f10d\"; }\n  i.icon.quote.right:before { content: \"\\f10e\"; }\n  i.icon.quran:before { content: \"\\f687\"; }\n  i.icon.radiation:before { content: \"\\f7b9\"; }\n  i.icon.radiation.alternate:before { content: \"\\f7ba\"; }\n  i.icon.rainbow:before { content: \"\\f75b\"; }\n  i.icon.random:before { content: \"\\f074\"; }\n  i.icon.receipt:before { content: \"\\f543\"; }\n  i.icon.recycle:before { content: \"\\f1b8\"; }\n  i.icon.redo:before { content: \"\\f01e\"; }\n  i.icon.redo.alternate:before { content: \"\\f2f9\"; }\n  i.icon.registered:before { content: \"\\f25d\"; }\n  i.icon.remove.format:before { content: \"\\f87d\"; }\n  i.icon.reply:before { content: \"\\f3e5\"; }\n  i.icon.reply.all:before { content: \"\\f122\"; }\n  i.icon.republican:before { content: \"\\f75e\"; }\n  i.icon.restroom:before { content: \"\\f7bd\"; }\n  i.icon.retweet:before { content: \"\\f079\"; }\n  i.icon.ribbon:before { content: \"\\f4d6\"; }\n  i.icon.ring:before { content: \"\\f70b\"; }\n  i.icon.road:before { content: \"\\f018\"; }\n  i.icon.robot:before { content: \"\\f544\"; }\n  i.icon.rocket:before { content: \"\\f135\"; }\n  i.icon.route:before { content: \"\\f4d7\"; }\n  i.icon.rss:before { content: \"\\f09e\"; }\n  i.icon.rss.square:before { content: \"\\f143\"; }\n  i.icon.ruble.sign:before { content: \"\\f158\"; }\n  i.icon.ruler:before { content: \"\\f545\"; }\n  i.icon.ruler.combined:before { content: \"\\f546\"; }\n  i.icon.ruler.horizontal:before { content: \"\\f547\"; }\n  i.icon.ruler.vertical:before { content: \"\\f548\"; }\n  i.icon.running:before { content: \"\\f70c\"; }\n  i.icon.rupee.sign:before { content: \"\\f156\"; }\n  i.icon.sad.cry:before { content: \"\\f5b3\"; }\n  i.icon.sad.tear:before { content: \"\\f5b4\"; }\n  i.icon.satellite:before { content: \"\\f7bf\"; }\n  i.icon.satellite.dish:before { content: \"\\f7c0\"; }\n  i.icon.save:before { content: \"\\f0c7\"; }\n  i.icon.school:before { content: \"\\f549\"; }\n  i.icon.screwdriver:before { content: \"\\f54a\"; }\n  i.icon.scroll:before { content: \"\\f70e\"; }\n  i.icon.sd.card:before { content: \"\\f7c2\"; }\n  i.icon.search:before { content: \"\\f002\"; }\n  i.icon.search.dollar:before { content: \"\\f688\"; }\n  i.icon.search.location:before { content: \"\\f689\"; }\n  i.icon.search.minus:before { content: \"\\f010\"; }\n  i.icon.search.plus:before { content: \"\\f00e\"; }\n  i.icon.seedling:before { content: \"\\f4d8\"; }\n  i.icon.server:before { content: \"\\f233\"; }\n  i.icon.shapes:before { content: \"\\f61f\"; }\n  i.icon.share:before { content: \"\\f064\"; }\n  i.icon.share.alternate:before { content: \"\\f1e0\"; }\n  i.icon.share.alternate.square:before { content: \"\\f1e1\"; }\n  i.icon.share.square:before { content: \"\\f14d\"; }\n  i.icon.shekel.sign:before { content: \"\\f20b\"; }\n  i.icon.shield.alternate:before { content: \"\\f3ed\"; }\n  i.icon.ship:before { content: \"\\f21a\"; }\n  i.icon.shipping.fast:before { content: \"\\f48b\"; }\n  i.icon.shoe.prints:before { content: \"\\f54b\"; }\n  i.icon.shopping.bag:before { content: \"\\f290\"; }\n  i.icon.shopping.basket:before { content: \"\\f291\"; }\n  i.icon.shopping.cart:before { content: \"\\f07a\"; }\n  i.icon.shower:before { content: \"\\f2cc\"; }\n  i.icon.shuttle.van:before { content: \"\\f5b6\"; }\n  i.icon.sign:before { content: \"\\f4d9\"; }\n  i.icon.sign.in.alternate:before { content: \"\\f2f6\"; }\n  i.icon.sign.language:before { content: \"\\f2a7\"; }\n  i.icon.sign.out.alternate:before { content: \"\\f2f5\"; }\n  i.icon.signal:before { content: \"\\f012\"; }\n  i.icon.signature:before { content: \"\\f5b7\"; }\n  i.icon.sim.card:before { content: \"\\f7c4\"; }\n  i.icon.sitemap:before { content: \"\\f0e8\"; }\n  i.icon.skating:before { content: \"\\f7c5\"; }\n  i.icon.skiing:before { content: \"\\f7c9\"; }\n  i.icon.skiing.nordic:before { content: \"\\f7ca\"; }\n  i.icon.skull:before { content: \"\\f54c\"; }\n  i.icon.skull.crossbones:before { content: \"\\f714\"; }\n  i.icon.slash:before { content: \"\\f715\"; }\n  i.icon.sleigh:before { content: \"\\f7cc\"; }\n  i.icon.sliders.horizontal:before { content: \"\\f1de\"; }\n  i.icon.smile:before { content: \"\\f118\"; }\n  i.icon.smile.beam:before { content: \"\\f5b8\"; }\n  i.icon.smile.wink:before { content: \"\\f4da\"; }\n  i.icon.smog:before { content: \"\\f75f\"; }\n  i.icon.smoking:before { content: \"\\f48d\"; }\n  i.icon.smoking.ban:before { content: \"\\f54d\"; }\n  i.icon.sms:before { content: \"\\f7cd\"; }\n  i.icon.snowboarding:before { content: \"\\f7ce\"; }\n  i.icon.snowflake:before { content: \"\\f2dc\"; }\n  i.icon.snowman:before { content: \"\\f7d0\"; }\n  i.icon.snowplow:before { content: \"\\f7d2\"; }\n  i.icon.socks:before { content: \"\\f696\"; }\n  i.icon.solar.panel:before { content: \"\\f5ba\"; }\n  i.icon.sort:before { content: \"\\f0dc\"; }\n  i.icon.sort.alphabet.down:before { content: \"\\f15d\"; }\n  i.icon.sort.alphabet.down.alternate:before { content: \"\\f881\"; }\n  i.icon.sort.alphabet.up:before { content: \"\\f15e\"; }\n  i.icon.sort.alphabet.up.alternate:before { content: \"\\f882\"; }\n  i.icon.sort.amount.down:before { content: \"\\f160\"; }\n  i.icon.sort.amount.down.alternate:before { content: \"\\f884\"; }\n  i.icon.sort.amount.up:before { content: \"\\f161\"; }\n  i.icon.sort.amount.up.alternate:before { content: \"\\f885\"; }\n  i.icon.sort.down:before { content: \"\\f0dd\"; }\n  i.icon.sort.numeric.down:before { content: \"\\f162\"; }\n  i.icon.sort.numeric.down.alternate:before { content: \"\\f886\"; }\n  i.icon.sort.numeric.up:before { content: \"\\f163\"; }\n  i.icon.sort.numeric.up.alternate:before { content: \"\\f887\"; }\n  i.icon.sort.up:before { content: \"\\f0de\"; }\n  i.icon.spa:before { content: \"\\f5bb\"; }\n  i.icon.space.shuttle:before { content: \"\\f197\"; }\n  i.icon.spell.check:before { content: \"\\f891\"; }\n  i.icon.spider:before { content: \"\\f717\"; }\n  i.icon.spinner:before { content: \"\\f110\"; }\n  i.icon.splotch:before { content: \"\\f5bc\"; }\n  i.icon.spray.can:before { content: \"\\f5bd\"; }\n  i.icon.square:before { content: \"\\f0c8\"; }\n  i.icon.square.full:before { content: \"\\f45c\"; }\n  i.icon.square.root.alternate:before { content: \"\\f698\"; }\n  i.icon.stamp:before { content: \"\\f5bf\"; }\n  i.icon.star:before { content: \"\\f005\"; }\n  i.icon.star.and.crescent:before { content: \"\\f699\"; }\n  i.icon.star.half:before { content: \"\\f089\"; }\n  i.icon.star.half.alternate:before { content: \"\\f5c0\"; }\n  i.icon.star.of.david:before { content: \"\\f69a\"; }\n  i.icon.star.of.life:before { content: \"\\f621\"; }\n  i.icon.step.backward:before { content: \"\\f048\"; }\n  i.icon.step.forward:before { content: \"\\f051\"; }\n  i.icon.stethoscope:before { content: \"\\f0f1\"; }\n  i.icon.sticky.note:before { content: \"\\f249\"; }\n  i.icon.stop:before { content: \"\\f04d\"; }\n  i.icon.stop.circle:before { content: \"\\f28d\"; }\n  i.icon.stopwatch:before { content: \"\\f2f2\"; }\n  i.icon.store:before { content: \"\\f54e\"; }\n  i.icon.store.alternate:before { content: \"\\f54f\"; }\n  i.icon.stream:before { content: \"\\f550\"; }\n  i.icon.street.view:before { content: \"\\f21d\"; }\n  i.icon.strikethrough:before { content: \"\\f0cc\"; }\n  i.icon.stroopwafel:before { content: \"\\f551\"; }\n  i.icon.subscript:before { content: \"\\f12c\"; }\n  i.icon.subway:before { content: \"\\f239\"; }\n  i.icon.suitcase:before { content: \"\\f0f2\"; }\n  i.icon.suitcase.rolling:before { content: \"\\f5c1\"; }\n  i.icon.sun:before { content: \"\\f185\"; }\n  i.icon.superscript:before { content: \"\\f12b\"; }\n  i.icon.surprise:before { content: \"\\f5c2\"; }\n  i.icon.swatchbook:before { content: \"\\f5c3\"; }\n  i.icon.swimmer:before { content: \"\\f5c4\"; }\n  i.icon.swimming.pool:before { content: \"\\f5c5\"; }\n  i.icon.synagogue:before { content: \"\\f69b\"; }\n  i.icon.sync:before { content: \"\\f021\"; }\n  i.icon.sync.alternate:before { content: \"\\f2f1\"; }\n  i.icon.syringe:before { content: \"\\f48e\"; }\n  i.icon.table:before { content: \"\\f0ce\"; }\n  i.icon.table.tennis:before { content: \"\\f45d\"; }\n  i.icon.tablet:before { content: \"\\f10a\"; }\n  i.icon.tablet.alternate:before { content: \"\\f3fa\"; }\n  i.icon.tablets:before { content: \"\\f490\"; }\n  i.icon.tachometer.alternate:before { content: \"\\f3fd\"; }\n  i.icon.tag:before { content: \"\\f02b\"; }\n  i.icon.tags:before { content: \"\\f02c\"; }\n  i.icon.tape:before { content: \"\\f4db\"; }\n  i.icon.tasks:before { content: \"\\f0ae\"; }\n  i.icon.taxi:before { content: \"\\f1ba\"; }\n  i.icon.teeth:before { content: \"\\f62e\"; }\n  i.icon.teeth.open:before { content: \"\\f62f\"; }\n  i.icon.temperature.high:before { content: \"\\f769\"; }\n  i.icon.temperature.low:before { content: \"\\f76b\"; }\n  i.icon.tenge:before { content: \"\\f7d7\"; }\n  i.icon.terminal:before { content: \"\\f120\"; }\n  i.icon.text.height:before { content: \"\\f034\"; }\n  i.icon.text.width:before { content: \"\\f035\"; }\n  i.icon.th:before { content: \"\\f00a\"; }\n  i.icon.th.large:before { content: \"\\f009\"; }\n  i.icon.th.list:before { content: \"\\f00b\"; }\n  i.icon.theater.masks:before { content: \"\\f630\"; }\n  i.icon.thermometer:before { content: \"\\f491\"; }\n  i.icon.thermometer.empty:before { content: \"\\f2cb\"; }\n  i.icon.thermometer.full:before { content: \"\\f2c7\"; }\n  i.icon.thermometer.half:before { content: \"\\f2c9\"; }\n  i.icon.thermometer.quarter:before { content: \"\\f2ca\"; }\n  i.icon.thermometer.three.quarters:before { content: \"\\f2c8\"; }\n  i.icon.thumbs.down:before { content: \"\\f165\"; }\n  i.icon.thumbs.up:before { content: \"\\f164\"; }\n  i.icon.thumbtack:before { content: \"\\f08d\"; }\n  i.icon.ticket.alternate:before { content: \"\\f3ff\"; }\n  i.icon.times:before { content: \"\\f00d\"; }\n  i.icon.times.circle:before { content: \"\\f057\"; }\n  i.icon.tint:before { content: \"\\f043\"; }\n  i.icon.tint.slash:before { content: \"\\f5c7\"; }\n  i.icon.tired:before { content: \"\\f5c8\"; }\n  i.icon.toggle.off:before { content: \"\\f204\"; }\n  i.icon.toggle.on:before { content: \"\\f205\"; }\n  i.icon.toilet:before { content: \"\\f7d8\"; }\n  i.icon.toilet.paper:before { content: \"\\f71e\"; }\n  i.icon.toolbox:before { content: \"\\f552\"; }\n  i.icon.tools:before { content: \"\\f7d9\"; }\n  i.icon.tooth:before { content: \"\\f5c9\"; }\n  i.icon.torah:before { content: \"\\f6a0\"; }\n  i.icon.torii.gate:before { content: \"\\f6a1\"; }\n  i.icon.tractor:before { content: \"\\f722\"; }\n  i.icon.trademark:before { content: \"\\f25c\"; }\n  i.icon.traffic.light:before { content: \"\\f637\"; }\n  i.icon.train:before { content: \"\\f238\"; }\n  i.icon.tram:before { content: \"\\f7da\"; }\n  i.icon.transgender:before { content: \"\\f224\"; }\n  i.icon.transgender.alternate:before { content: \"\\f225\"; }\n  i.icon.trash:before { content: \"\\f1f8\"; }\n  i.icon.trash.alternate:before { content: \"\\f2ed\"; }\n  i.icon.trash.restore:before { content: \"\\f829\"; }\n  i.icon.trash.restore.alternate:before { content: \"\\f82a\"; }\n  i.icon.tree:before { content: \"\\f1bb\"; }\n  i.icon.trophy:before { content: \"\\f091\"; }\n  i.icon.truck:before { content: \"\\f0d1\"; }\n  i.icon.truck.monster:before { content: \"\\f63b\"; }\n  i.icon.truck.moving:before { content: \"\\f4df\"; }\n  i.icon.truck.packing:before { content: \"\\f4de\"; }\n  i.icon.truck.pickup:before { content: \"\\f63c\"; }\n  i.icon.tshirt:before { content: \"\\f553\"; }\n  i.icon.tty:before { content: \"\\f1e4\"; }\n  i.icon.tv:before { content: \"\\f26c\"; }\n  i.icon.umbrella:before { content: \"\\f0e9\"; }\n  i.icon.umbrella.beach:before { content: \"\\f5ca\"; }\n  i.icon.underline:before { content: \"\\f0cd\"; }\n  i.icon.undo:before { content: \"\\f0e2\"; }\n  i.icon.undo.alternate:before { content: \"\\f2ea\"; }\n  i.icon.universal.access:before { content: \"\\f29a\"; }\n  i.icon.university:before { content: \"\\f19c\"; }\n  i.icon.unlink:before { content: \"\\f127\"; }\n  i.icon.unlock:before { content: \"\\f09c\"; }\n  i.icon.unlock.alternate:before { content: \"\\f13e\"; }\n  i.icon.upload:before { content: \"\\f093\"; }\n  i.icon.user:before { content: \"\\f007\"; }\n  i.icon.user.alternate:before { content: \"\\f406\"; }\n  i.icon.user.alternate.slash:before { content: \"\\f4fa\"; }\n  i.icon.user.astronaut:before { content: \"\\f4fb\"; }\n  i.icon.user.check:before { content: \"\\f4fc\"; }\n  i.icon.user.circle:before { content: \"\\f2bd\"; }\n  i.icon.user.clock:before { content: \"\\f4fd\"; }\n  i.icon.user.cog:before { content: \"\\f4fe\"; }\n  i.icon.user.edit:before { content: \"\\f4ff\"; }\n  i.icon.user.friends:before { content: \"\\f500\"; }\n  i.icon.user.graduate:before { content: \"\\f501\"; }\n  i.icon.user.injured:before { content: \"\\f728\"; }\n  i.icon.user.lock:before { content: \"\\f502\"; }\n  i.icon.user.md:before { content: \"\\f0f0\"; }\n  i.icon.user.minus:before { content: \"\\f503\"; }\n  i.icon.user.ninja:before { content: \"\\f504\"; }\n  i.icon.user.nurse:before { content: \"\\f82f\"; }\n  i.icon.user.plus:before { content: \"\\f234\"; }\n  i.icon.user.secret:before { content: \"\\f21b\"; }\n  i.icon.user.shield:before { content: \"\\f505\"; }\n  i.icon.user.slash:before { content: \"\\f506\"; }\n  i.icon.user.tag:before { content: \"\\f507\"; }\n  i.icon.user.tie:before { content: \"\\f508\"; }\n  i.icon.user.times:before { content: \"\\f235\"; }\n  i.icon.users:before { content: \"\\f0c0\"; }\n  i.icon.users.cog:before { content: \"\\f509\"; }\n  i.icon.utensil.spoon:before { content: \"\\f2e5\"; }\n  i.icon.utensils:before { content: \"\\f2e7\"; }\n  i.icon.vector.square:before { content: \"\\f5cb\"; }\n  i.icon.venus:before { content: \"\\f221\"; }\n  i.icon.venus.double:before { content: \"\\f226\"; }\n  i.icon.venus.mars:before { content: \"\\f228\"; }\n  i.icon.vial:before { content: \"\\f492\"; }\n  i.icon.vials:before { content: \"\\f493\"; }\n  i.icon.video:before { content: \"\\f03d\"; }\n  i.icon.video.slash:before { content: \"\\f4e2\"; }\n  i.icon.vihara:before { content: \"\\f6a7\"; }\n  i.icon.voicemail:before { content: \"\\f897\"; }\n  i.icon.volleyball.ball:before { content: \"\\f45f\"; }\n  i.icon.volume.down:before { content: \"\\f027\"; }\n  i.icon.volume.mute:before { content: \"\\f6a9\"; }\n  i.icon.volume.off:before { content: \"\\f026\"; }\n  i.icon.volume.up:before { content: \"\\f028\"; }\n  i.icon.vote.yea:before { content: \"\\f772\"; }\n  i.icon.vr.cardboard:before { content: \"\\f729\"; }\n  i.icon.walking:before { content: \"\\f554\"; }\n  i.icon.wallet:before { content: \"\\f555\"; }\n  i.icon.warehouse:before { content: \"\\f494\"; }\n  i.icon.water:before { content: \"\\f773\"; }\n  i.icon.wave.square:before { content: \"\\f83e\"; }\n  i.icon.weight:before { content: \"\\f496\"; }\n  i.icon.weight.hanging:before { content: \"\\f5cd\"; }\n  i.icon.wheelchair:before { content: \"\\f193\"; }\n  i.icon.wifi:before { content: \"\\f1eb\"; }\n  i.icon.wind:before { content: \"\\f72e\"; }\n  i.icon.window.close:before { content: \"\\f410\"; }\n  i.icon.window.maximize:before { content: \"\\f2d0\"; }\n  i.icon.window.minimize:before { content: \"\\f2d1\"; }\n  i.icon.window.restore:before { content: \"\\f2d2\"; }\n  i.icon.wine.bottle:before { content: \"\\f72f\"; }\n  i.icon.wine.glass:before { content: \"\\f4e3\"; }\n  i.icon.wine.glass.alternate:before { content: \"\\f5ce\"; }\n  i.icon.won.sign:before { content: \"\\f159\"; }\n  i.icon.wrench:before { content: \"\\f0ad\"; }\n  i.icon.x.ray:before { content: \"\\f497\"; }\n  i.icon.yen.sign:before { content: \"\\f157\"; }\n  i.icon.yin.yang:before { content: \"\\f6ad\"; }\n\n  /* Aliases */\n  i.icon.add:before { content: \"\\f067\"; }\n  i.icon.add.circle:before { content: \"\\f055\"; }\n  i.icon.add.square:before { content: \"\\f0fe\"; }\n  i.icon.add.to.calendar:before { content: \"\\f271\"; }\n  i.icon.add.to.cart:before { content: \"\\f217\"; }\n  i.icon.add.user:before { content: \"\\f234\"; }\n  i.icon.alarm:before { content: \"\\f0f3\"; }\n  i.icon.alarm.mute:before { content: \"\\f1f6\"; }\n  i.icon.ald:before { content: \"\\f2a2\"; }\n  i.icon.als:before { content: \"\\f2a2\"; }\n  i.icon.announcement:before { content: \"\\f0a1\"; }\n  i.icon.area.chart:before { content: \"\\f1fe\"; }\n  i.icon.area.graph:before { content: \"\\f1fe\"; }\n  i.icon.arrow.down.cart:before { content: \"\\f218\"; }\n  i.icon.asexual:before { content: \"\\f22d\"; }\n  i.icon.asl:before { content: \"\\f2a3\"; }\n  i.icon.asl.interpreting:before { content: \"\\f2a3\"; }\n  i.icon.assistive.listening.devices:before { content: \"\\f2a2\"; }\n  i.icon.attach:before { content: \"\\f0c6\"; }\n  i.icon.attention:before { content: \"\\f06a\"; }\n  i.icon.balance:before { content: \"\\f24e\"; }\n  i.icon.bar:before { content: \"\\f0fc\"; }\n  i.icon.bathtub:before { content: \"\\f2cd\"; }\n  i.icon.battery.four:before { content: \"\\f240\"; }\n  i.icon.battery.high:before { content: \"\\f241\"; }\n  i.icon.battery.low:before { content: \"\\f243\"; }\n  i.icon.battery.medium:before { content: \"\\f242\"; }\n  i.icon.battery.one:before { content: \"\\f243\"; }\n  i.icon.battery.three:before { content: \"\\f241\"; }\n  i.icon.battery.two:before { content: \"\\f242\"; }\n  i.icon.battery.zero:before { content: \"\\f244\"; }\n  i.icon.birthday:before { content: \"\\f1fd\"; }\n  i.icon.block.layout:before { content: \"\\f009\"; }\n  i.icon.broken.chain:before { content: \"\\f127\"; }\n  i.icon.browser:before { content: \"\\f022\"; }\n  i.icon.call:before { content: \"\\f095\"; }\n  i.icon.call.square:before { content: \"\\f098\"; }\n  i.icon.cancel:before { content: \"\\f00d\"; }\n  i.icon.cart:before { content: \"\\f07a\"; }\n  i.icon.cc:before { content: \"\\f20a\"; }\n  i.icon.chain:before { content: \"\\f0c1\"; }\n  i.icon.chat:before { content: \"\\f075\"; }\n  i.icon.checked.calendar:before { content: \"\\f274\"; }\n  i.icon.checkmark:before { content: \"\\f00c\"; }\n  i.icon.checkmark.box:before { content: \"\\f14a\"; }\n  i.icon.chess.rock:before { content: \"\\f447\"; }\n  i.icon.circle.notched:before { content: \"\\f1ce\"; }\n  i.icon.circle.thin:before { content: \"\\f111\"; }\n  i.icon.close:before { content: \"\\f00d\"; }\n  i.icon.cloud.download:before { content: \"\\f381\"; }\n  i.icon.cloud.upload:before { content: \"\\f382\"; }\n  i.icon.cny:before { content: \"\\f157\"; }\n  i.icon.cocktail:before { content: \"\\f000\"; }\n  i.icon.commenting:before { content: \"\\f27a\"; }\n  i.icon.compose:before { content: \"\\f303\"; }\n  i.icon.computer:before { content: \"\\f108\"; }\n  i.icon.configure:before { content: \"\\f0ad\"; }\n  i.icon.content:before { content: \"\\f0c9\"; }\n  i.icon.conversation:before { content: \"\\f086\"; }\n  i.icon.credit.card.alternative:before { content: \"\\f09d\"; }\n  i.icon.currency:before { content: \"\\f3d1\"; }\n  i.icon.dashboard:before { content: \"\\f3fd\"; }\n  i.icon.deafness:before { content: \"\\f2a4\"; }\n  i.icon.delete:before { content: \"\\f00d\"; }\n  i.icon.delete.calendar:before { content: \"\\f273\"; }\n  i.icon.detective:before { content: \"\\f21b\"; }\n  i.icon.diamond:before { content: \"\\f3a5\"; }\n  i.icon.discussions:before { content: \"\\f086\"; }\n  i.icon.disk:before { content: \"\\f0a0\"; }\n  i.icon.doctor:before { content: \"\\f0f0\"; }\n  i.icon.dollar:before { content: \"\\f155\"; }\n  i.icon.dont:before { content: \"\\f05e\"; }\n  i.icon.drivers.license:before { content: \"\\f2c2\"; }\n  i.icon.dropdown:before { content: \"\\f0d7\"; }\n  i.icon.emergency:before { content: \"\\f0f9\"; }\n  i.icon.erase:before { content: \"\\f12d\"; }\n  i.icon.eur:before { content: \"\\f153\"; }\n  i.icon.euro:before { content: \"\\f153\"; }\n  i.icon.exchange:before { content: \"\\f362\"; }\n  i.icon.external:before { content: \"\\f35d\"; }\n  i.icon.external.share:before { content: \"\\f14d\"; }\n  i.icon.external.square:before { content: \"\\f360\"; }\n  i.icon.eyedropper:before { content: \"\\f1fb\"; }\n  i.icon.factory:before { content: \"\\f275\"; }\n  i.icon.favorite:before { content: \"\\f005\"; }\n  i.icon.feed:before { content: \"\\f09e\"; }\n  i.icon.female.homosexual:before { content: \"\\f226\"; }\n  i.icon.file.text:before { content: \"\\f15c\"; }\n  i.icon.find:before { content: \"\\f1e5\"; }\n  i.icon.first.aid:before { content: \"\\f0fa\"; }\n  i.icon.food:before { content: \"\\f2e7\"; }\n  i.icon.fork:before { content: \"\\f126\"; }\n  i.icon.game:before { content: \"\\f11b\"; }\n  i.icon.gay:before { content: \"\\f227\"; }\n  i.icon.gbp:before { content: \"\\f154\"; }\n  i.icon.grab:before { content: \"\\f255\"; }\n  i.icon.graduation:before { content: \"\\f19d\"; }\n  i.icon.grid.layout:before { content: \"\\f00a\"; }\n  i.icon.group:before { content: \"\\f0c0\"; }\n  i.icon.h:before { content: \"\\f0fd\"; }\n  i.icon.hamburger:before { content: \"\\f0c9\"; }\n  i.icon.hand.victory:before { content: \"\\f25b\"; }\n  i.icon.handicap:before { content: \"\\f193\"; }\n  i.icon.hard.of.hearing:before { content: \"\\f2a4\"; }\n  i.icon.header:before { content: \"\\f1dc\"; }\n  i.icon.heart.empty:before { content: \"\\f004\"; }\n  i.icon.help:before { content: \"\\f128\"; }\n  i.icon.help.circle:before { content: \"\\f059\"; }\n  i.icon.heterosexual:before { content: \"\\f228\"; }\n  i.icon.hide:before { content: \"\\f070\"; }\n  i.icon.hotel:before { content: \"\\f236\"; }\n  i.icon.hourglass.four:before { content: \"\\f254\"; }\n  i.icon.hourglass.full:before { content: \"\\f254\"; }\n  i.icon.hourglass.one:before { content: \"\\f251\"; }\n  i.icon.hourglass.three:before { content: \"\\f253\"; }\n  i.icon.hourglass.two:before { content: \"\\f252\"; }\n  i.icon.hourglass.zero:before { content: \"\\f253\"; }\n  i.icon.idea:before { content: \"\\f0eb\"; }\n  i.icon.ils:before { content: \"\\f20b\"; }\n  i.icon.in.cart:before { content: \"\\f218\"; }\n  i.icon.inr:before { content: \"\\f156\"; }\n  i.icon.intergender:before { content: \"\\f224\"; }\n  i.icon.intersex:before { content: \"\\f224\"; }\n  i.icon.jpy:before { content: \"\\f157\"; }\n  i.icon.krw:before { content: \"\\f159\"; }\n  i.icon.lab:before { content: \"\\f0c3\"; }\n  i.icon.law:before { content: \"\\f24e\"; }\n  i.icon.legal:before { content: \"\\f0e3\"; }\n  i.icon.lesbian:before { content: \"\\f226\"; }\n  i.icon.level.down:before { content: \"\\f3be\"; }\n  i.icon.level.up:before { content: \"\\f3bf\"; }\n  i.icon.lightning:before { content: \"\\f0e7\"; }\n  i.icon.like:before { content: \"\\f004\"; }\n  i.icon.line.graph:before { content: \"\\f201\"; }\n  i.icon.linkify:before { content: \"\\f0c1\"; }\n  i.icon.lira:before { content: \"\\f195\"; }\n  i.icon.list.layout:before { content: \"\\f00b\"; }\n  i.icon.log.out:before { content: \"\\f2f5\"; }\n  i.icon.magnify:before { content: \"\\f00e\"; }\n  i.icon.mail:before { content: \"\\f0e0\"; }\n  i.icon.mail.forward:before { content: \"\\f064\"; }\n  i.icon.mail.square:before { content: \"\\f199\"; }\n  i.icon.male.homosexual:before { content: \"\\f227\"; }\n  i.icon.man:before { content: \"\\f222\"; }\n  i.icon.marker:before { content: \"\\f041\"; }\n  i.icon.mars.alternate:before { content: \"\\f229\"; }\n  i.icon.mars.horizontal:before { content: \"\\f22b\"; }\n  i.icon.mars.vertical:before { content: \"\\f22a\"; }\n  i.icon.meanpath:before { content: \"\\f0c8\"; }\n  i.icon.military:before { content: \"\\f0fb\"; }\n  i.icon.money:before { content: \"\\f3d1\"; }\n  i.icon.move:before { content: \"\\f0b2\"; }\n  i.icon.mute:before { content: \"\\f131\"; }\n  i.icon.non.binary.transgender:before { content: \"\\f223\"; }\n  i.icon.numbered.list:before { content: \"\\f0cb\"; }\n  i.icon.options:before { content: \"\\f1de\"; }\n  i.icon.ordered.list:before { content: \"\\f0cb\"; }\n  i.icon.other.gender:before { content: \"\\f229\"; }\n  i.icon.other.gender.horizontal:before { content: \"\\f22b\"; }\n  i.icon.other.gender.vertical:before { content: \"\\f22a\"; }\n  i.icon.payment:before { content: \"\\f09d\"; }\n  i.icon.pencil:before { content: \"\\f303\"; }\n  i.icon.pencil.square:before { content: \"\\f14b\"; }\n  i.icon.photo:before { content: \"\\f030\"; }\n  i.icon.picture:before { content: \"\\f03e\"; }\n  i.icon.pie.chart:before { content: \"\\f200\"; }\n  i.icon.pie.graph:before { content: \"\\f200\"; }\n  i.icon.pin:before { content: \"\\f08d\"; }\n  i.icon.plus.cart:before { content: \"\\f217\"; }\n  i.icon.point:before { content: \"\\f041\"; }\n  i.icon.pointing.down:before { content: \"\\f0a7\"; }\n  i.icon.pointing.left:before { content: \"\\f0a5\"; }\n  i.icon.pointing.right:before { content: \"\\f0a4\"; }\n  i.icon.pointing.up:before { content: \"\\f0a6\"; }\n  i.icon.pound:before { content: \"\\f154\"; }\n  i.icon.power:before { content: \"\\f011\"; }\n  i.icon.power.cord:before { content: \"\\f1e6\"; }\n  i.icon.privacy:before { content: \"\\f084\"; }\n  i.icon.protect:before { content: \"\\f023\"; }\n  i.icon.puzzle:before { content: \"\\f12e\"; }\n  i.icon.r.circle:before { content: \"\\f25d\"; }\n  i.icon.radio:before { content: \"\\f192\"; }\n  i.icon.rain:before { content: \"\\f0e9\"; }\n  i.icon.record:before { content: \"\\f03d\"; }\n  i.icon.refresh:before { content: \"\\f021\"; }\n  i.icon.remove:before { content: \"\\f00d\"; }\n  i.icon.remove.bookmark:before { content: \"\\f02e\"; }\n  i.icon.remove.circle:before { content: \"\\f057\"; }\n  i.icon.remove.from.calendar:before { content: \"\\f272\"; }\n  i.icon.remove.user:before { content: \"\\f235\"; }\n  i.icon.repeat:before { content: \"\\f01e\"; }\n  i.icon.resize.horizontal:before { content: \"\\f337\"; }\n  i.icon.resize.vertical:before { content: \"\\f338\"; }\n  i.icon.rmb:before { content: \"\\f157\"; }\n  i.icon.rouble:before { content: \"\\f158\"; }\n  i.icon.rub:before { content: \"\\f158\"; }\n  i.icon.ruble:before { content: \"\\f158\"; }\n  i.icon.rupee:before { content: \"\\f156\"; }\n  i.icon.s15:before { content: \"\\f2cd\"; }\n  i.icon.selected.radio:before { content: \"\\f192\"; }\n  i.icon.send:before { content: \"\\f1d8\"; }\n  i.icon.setting:before { content: \"\\f013\"; }\n  i.icon.settings:before { content: \"\\f085\"; }\n  i.icon.shekel:before { content: \"\\f20b\"; }\n  i.icon.sheqel:before { content: \"\\f20b\"; }\n  i.icon.shield:before { content: \"\\f3ed\"; }\n  i.icon.shipping:before { content: \"\\f0d1\"; }\n  i.icon.shop:before { content: \"\\f07a\"; }\n  i.icon.shuffle:before { content: \"\\f074\"; }\n  i.icon.shutdown:before { content: \"\\f011\"; }\n  i.icon.sidebar:before { content: \"\\f0c9\"; }\n  i.icon.sign.in:before { content: \"\\f2f6\"; }\n  i.icon.sign.out:before { content: \"\\f2f5\"; }\n  i.icon.signing:before { content: \"\\f2a7\"; }\n  i.icon.signup:before { content: \"\\f044\"; }\n  i.icon.sliders:before { content: \"\\f1de\"; }\n  i.icon.soccer:before { content: \"\\f1e3\"; }\n  i.icon.sort.alphabet.ascending:before { content: \"\\f15d\"; }\n  i.icon.sort.alphabet.descending:before { content: \"\\f15e\"; }\n  i.icon.sort.ascending:before { content: \"\\f0de\"; }\n  i.icon.sort.content.ascending:before { content: \"\\f160\"; }\n  i.icon.sort.content.descending:before { content: \"\\f161\"; }\n  i.icon.sort.descending:before { content: \"\\f0dd\"; }\n  i.icon.sort.numeric.ascending:before { content: \"\\f162\"; }\n  i.icon.sort.numeric.descending:before { content: \"\\f163\"; }\n  i.icon.sound:before { content: \"\\f025\"; }\n  i.icon.spoon:before { content: \"\\f2e5\"; }\n  i.icon.spy:before { content: \"\\f21b\"; }\n  i.icon.star.empty:before { content: \"\\f005\"; }\n  i.icon.star.half.empty:before { content: \"\\f089\"; }\n  i.icon.star.half.full:before { content: \"\\f089\"; }\n  i.icon.student:before { content: \"\\f19d\"; }\n  i.icon.talk:before { content: \"\\f27a\"; }\n  i.icon.target:before { content: \"\\f140\"; }\n  i.icon.teletype:before { content: \"\\f1e4\"; }\n  i.icon.television:before { content: \"\\f26c\"; }\n  i.icon.text.cursor:before { content: \"\\f246\"; }\n  i.icon.text.telephone:before { content: \"\\f1e4\"; }\n  i.icon.theme:before { content: \"\\f043\"; }\n  i.icon.thermometer:before { content: \"\\f2c7\"; }\n  i.icon.thumb.tack:before { content: \"\\f08d\"; }\n  i.icon.ticket:before { content: \"\\f3ff\"; }\n  i.icon.time:before { content: \"\\f017\"; }\n  i.icon.times.rectangle:before { content: \"\\f410\"; }\n  i.icon.tm:before { content: \"\\f25c\"; }\n  i.icon.toggle.down:before { content: \"\\f150\"; }\n  i.icon.toggle.left:before { content: \"\\f191\"; }\n  i.icon.toggle.right:before { content: \"\\f152\"; }\n  i.icon.toggle.up:before { content: \"\\f151\"; }\n  i.icon.translate:before { content: \"\\f1ab\"; }\n  i.icon.travel:before { content: \"\\f0b1\"; }\n  i.icon.treatment:before { content: \"\\f0f1\"; }\n  i.icon.triangle.down:before { content: \"\\f0d7\"; }\n  i.icon.triangle.left:before { content: \"\\f0d9\"; }\n  i.icon.triangle.right:before { content: \"\\f0da\"; }\n  i.icon.triangle.up:before { content: \"\\f0d8\"; }\n  i.icon.try:before { content: \"\\f195\"; }\n  i.icon.unhide:before { content: \"\\f06e\"; }\n  i.icon.unlinkify:before { content: \"\\f127\"; }\n  i.icon.unmute:before { content: \"\\f130\"; }\n  i.icon.unordered.list:before { content: \"\\f0ca\"; }\n  i.icon.usd:before { content: \"\\f155\"; }\n  i.icon.user.cancel:before { content: \"\\f235\"; }\n  i.icon.user.close:before { content: \"\\f235\"; }\n  i.icon.user.delete:before { content: \"\\f235\"; }\n  i.icon.user.doctor:before { content: \"\\f0f0\"; }\n  i.icon.user.x:before { content: \"\\f235\"; }\n  i.icon.vcard:before { content: \"\\f2bb\"; }\n  i.icon.video.camera:before { content: \"\\f03d\"; }\n  i.icon.video.play:before { content: \"\\f144\"; }\n  i.icon.volume.control.phone:before { content: \"\\f2a0\"; }\n  i.icon.wait:before { content: \"\\f017\"; }\n  i.icon.warning:before { content: \"\\f12a\"; }\n  i.icon.warning.circle:before { content: \"\\f06a\"; }\n  i.icon.warning.sign:before { content: \"\\f071\"; }\n  i.icon.wi.fi:before { content: \"\\f1eb\"; }\n  i.icon.winner:before { content: \"\\f091\"; }\n  i.icon.wizard:before { content: \"\\f0d0\"; }\n  i.icon.woman:before { content: \"\\f221\"; }\n  i.icon.won:before { content: \"\\f159\"; }\n  i.icon.world:before { content: \"\\f0ac\"; }\n  i.icon.write:before { content: \"\\f303\"; }\n  i.icon.write.square:before { content: \"\\f14b\"; }\n  i.icon.x:before { content: \"\\f00d\"; }\n  i.icon.yen:before { content: \"\\f157\"; }\n  i.icon.zip:before { content: \"\\f187\"; }\n  i.icon.zoom:before { content: \"\\f00e\"; }\n  i.icon.zoom.in:before { content: \"\\f00e\"; }\n  i.icon.zoom.out:before { content: \"\\f010\"; }\n\n  /*******************************\n          Outline Icons\n  *******************************/\n\n  /* Outline Icon */\n  @if ($icon-import-outline-icons) {\n    /* Load & Define Icon Font */\n    @font-face {\n      font-family: $icon-outline-font-name;\n      src: $icon-outline-fallback-src;\n      src: $icon-outline-src;\n      font-style: normal;\n      font-weight: $normal;\n      font-variant: normal;\n      text-decoration: inherit;\n      text-transform: none;\n    }\n\n    i.icon.outline {\n      font-family: $icon-outline-font-name;\n    }\n\n    /* Icons */\n    i.icon.address.book.outline:before { content: \"\\f2b9\"; }\n    i.icon.address.card.outline:before { content: \"\\f2bb\"; }\n    i.icon.angry.outline:before { content: \"\\f556\"; }\n    i.icon.arrow.alternate.circle.down.outline:before { content: \"\\f358\"; }\n    i.icon.arrow.alternate.circle.left.outline:before { content: \"\\f359\"; }\n    i.icon.arrow.alternate.circle.right.outline:before { content: \"\\f35a\"; }\n    i.icon.arrow.alternate.circle.up.outline:before { content: \"\\f35b\"; }\n    i.icon.bell.outline:before { content: \"\\f0f3\"; }\n    i.icon.bell.slash.outline:before { content: \"\\f1f6\"; }\n    i.icon.bookmark.outline:before { content: \"\\f02e\"; }\n    i.icon.building.outline:before { content: \"\\f1ad\"; }\n    i.icon.calendar.alternate.outline:before { content: \"\\f073\"; }\n    i.icon.calendar.check.outline:before { content: \"\\f274\"; }\n    i.icon.calendar.minus.outline:before { content: \"\\f272\"; }\n    i.icon.calendar.outline:before { content: \"\\f133\"; }\n    i.icon.calendar.plus.outline:before { content: \"\\f271\"; }\n    i.icon.calendar.times.outline:before { content: \"\\f273\"; }\n    i.icon.caret.square.down.outline:before { content: \"\\f150\"; }\n    i.icon.caret.square.left.outline:before { content: \"\\f191\"; }\n    i.icon.caret.square.right.outline:before { content: \"\\f152\"; }\n    i.icon.caret.square.up.outline:before { content: \"\\f151\"; }\n    i.icon.chart.bar.outline:before { content: \"\\f080\"; }\n    i.icon.check.circle.outline:before { content: \"\\f058\"; }\n    i.icon.check.square.outline:before { content: \"\\f14a\"; }\n    i.icon.circle.outline:before { content: \"\\f111\"; }\n    i.icon.clipboard.outline:before { content: \"\\f328\"; }\n    i.icon.clock.outline:before { content: \"\\f017\"; }\n    i.icon.clone.outline:before { content: \"\\f24d\"; }\n    i.icon.closed.captioning.outline:before { content: \"\\f20a\"; }\n    i.icon.comment.alternate.outline:before { content: \"\\f27a\"; }\n    i.icon.comment.dots.outline:before { content: \"\\f4ad\"; }\n    i.icon.comment.outline:before { content: \"\\f075\"; }\n    i.icon.comments.outline:before { content: \"\\f086\"; }\n    i.icon.compass.outline:before { content: \"\\f14e\"; }\n    i.icon.copy.outline:before { content: \"\\f0c5\"; }\n    i.icon.copyright.outline:before { content: \"\\f1f9\"; }\n    i.icon.credit.card.outline:before { content: \"\\f09d\"; }\n    i.icon.dizzy.outline:before { content: \"\\f567\"; }\n    i.icon.dot.circle.outline:before { content: \"\\f192\"; }\n    i.icon.edit.outline:before { content: \"\\f044\"; }\n    i.icon.envelope.open.outline:before { content: \"\\f2b6\"; }\n    i.icon.envelope.outline:before { content: \"\\f0e0\"; }\n    i.icon.eye.outline:before { content: \"\\f06e\"; }\n    i.icon.eye.slash.outline:before { content: \"\\f070\"; }\n    i.icon.file.alternate.outline:before { content: \"\\f15c\"; }\n    i.icon.file.archive.outline:before { content: \"\\f1c6\"; }\n    i.icon.file.audio.outline:before { content: \"\\f1c7\"; }\n    i.icon.file.code.outline:before { content: \"\\f1c9\"; }\n    i.icon.file.excel.outline:before { content: \"\\f1c3\"; }\n    i.icon.file.image.outline:before { content: \"\\f1c5\"; }\n    i.icon.file.outline:before { content: \"\\f15b\"; }\n    i.icon.file.pdf.outline:before { content: \"\\f1c1\"; }\n    i.icon.file.powerpoint.outline:before { content: \"\\f1c4\"; }\n    i.icon.file.video.outline:before { content: \"\\f1c8\"; }\n    i.icon.file.word.outline:before { content: \"\\f1c2\"; }\n    i.icon.flag.outline:before { content: \"\\f024\"; }\n    i.icon.flushed.outline:before { content: \"\\f579\"; }\n    i.icon.folder.open.outline:before { content: \"\\f07c\"; }\n    i.icon.folder.outline:before { content: \"\\f07b\"; }\n    i.icon.frown.open.outline:before { content: \"\\f57a\"; }\n    i.icon.frown.outline:before { content: \"\\f119\"; }\n    i.icon.futbol.outline:before { content: \"\\f1e3\"; }\n    i.icon.gem.outline:before { content: \"\\f3a5\"; }\n    i.icon.grimace.outline:before { content: \"\\f57f\"; }\n    i.icon.grin.alternate.outline:before { content: \"\\f581\"; }\n    i.icon.grin.beam.outline:before { content: \"\\f582\"; }\n    i.icon.grin.beam.sweat.outline:before { content: \"\\f583\"; }\n    i.icon.grin.hearts.outline:before { content: \"\\f584\"; }\n    i.icon.grin.outline:before { content: \"\\f580\"; }\n    i.icon.grin.squint.outline:before { content: \"\\f585\"; }\n    i.icon.grin.squint.tears.outline:before { content: \"\\f586\"; }\n    i.icon.grin.stars.outline:before { content: \"\\f587\"; }\n    i.icon.grin.tears.outline:before { content: \"\\f588\"; }\n    i.icon.grin.tongue.outline:before { content: \"\\f589\"; }\n    i.icon.grin.tongue.squint.outline:before { content: \"\\f58a\"; }\n    i.icon.grin.tongue.wink.outline:before { content: \"\\f58b\"; }\n    i.icon.grin.wink.outline:before { content: \"\\f58c\"; }\n    i.icon.hand.lizard.outline:before { content: \"\\f258\"; }\n    i.icon.hand.paper.outline:before { content: \"\\f256\"; }\n    i.icon.hand.peace.outline:before { content: \"\\f25b\"; }\n    i.icon.hand.point.down.outline:before { content: \"\\f0a7\"; }\n    i.icon.hand.point.left.outline:before { content: \"\\f0a5\"; }\n    i.icon.hand.point.right.outline:before { content: \"\\f0a4\"; }\n    i.icon.hand.point.up.outline:before { content: \"\\f0a6\"; }\n    i.icon.hand.pointer.outline:before { content: \"\\f25a\"; }\n    i.icon.hand.rock.outline:before { content: \"\\f255\"; }\n    i.icon.hand.scissors.outline:before { content: \"\\f257\"; }\n    i.icon.hand.spock.outline:before { content: \"\\f259\"; }\n    i.icon.handshake.outline:before { content: \"\\f2b5\"; }\n    i.icon.hdd.outline:before { content: \"\\f0a0\"; }\n    i.icon.heart.outline:before { content: \"\\f004\"; }\n    i.icon.hospital.outline:before { content: \"\\f0f8\"; }\n    i.icon.hourglass.outline:before { content: \"\\f254\"; }\n    i.icon.id.badge.outline:before { content: \"\\f2c1\"; }\n    i.icon.id.card.outline:before { content: \"\\f2c2\"; }\n    i.icon.image.outline:before { content: \"\\f03e\"; }\n    i.icon.images.outline:before { content: \"\\f302\"; }\n    i.icon.keyboard.outline:before { content: \"\\f11c\"; }\n    i.icon.kiss.beam.outline:before { content: \"\\f597\"; }\n    i.icon.kiss.outline:before { content: \"\\f596\"; }\n    i.icon.kiss.wink.heart.outline:before { content: \"\\f598\"; }\n    i.icon.laugh.beam.outline:before { content: \"\\f59a\"; }\n    i.icon.laugh.outline:before { content: \"\\f599\"; }\n    i.icon.laugh.squint.outline:before { content: \"\\f59b\"; }\n    i.icon.laugh.wink.outline:before { content: \"\\f59c\"; }\n    i.icon.lemon.outline:before { content: \"\\f094\"; }\n    i.icon.life.ring.outline:before { content: \"\\f1cd\"; }\n    i.icon.lightbulb.outline:before { content: \"\\f0eb\"; }\n    i.icon.list.alternate.outline:before { content: \"\\f022\"; }\n    i.icon.map.outline:before { content: \"\\f279\"; }\n    i.icon.meh.blank.outline:before { content: \"\\f5a4\"; }\n    i.icon.meh.outline:before { content: \"\\f11a\"; }\n    i.icon.meh.rolling.eyes.outline:before { content: \"\\f5a5\"; }\n    i.icon.minus.square.outline:before { content: \"\\f146\"; }\n    i.icon.money.bill.alternate.outline:before { content: \"\\f3d1\"; }\n    i.icon.moon.outline:before { content: \"\\f186\"; }\n    i.icon.newspaper.outline:before { content: \"\\f1ea\"; }\n    i.icon.object.group.outline:before { content: \"\\f247\"; }\n    i.icon.object.ungroup.outline:before { content: \"\\f248\"; }\n    i.icon.paper.plane.outline:before { content: \"\\f1d8\"; }\n    i.icon.pause.circle.outline:before { content: \"\\f28b\"; }\n    i.icon.play.circle.outline:before { content: \"\\f144\"; }\n    i.icon.plus.square.outline:before { content: \"\\f0fe\"; }\n    i.icon.question.circle.outline:before { content: \"\\f059\"; }\n    i.icon.registered.outline:before { content: \"\\f25d\"; }\n    i.icon.sad.cry.outline:before { content: \"\\f5b3\"; }\n    i.icon.sad.tear.outline:before { content: \"\\f5b4\"; }\n    i.icon.save.outline:before { content: \"\\f0c7\"; }\n    i.icon.share.square.outline:before { content: \"\\f14d\"; }\n    i.icon.smile.beam.outline:before { content: \"\\f5b8\"; }\n    i.icon.smile.outline:before { content: \"\\f118\"; }\n    i.icon.smile.wink.outline:before { content: \"\\f4da\"; }\n    i.icon.snowflake.outline:before { content: \"\\f2dc\"; }\n    i.icon.square.outline:before { content: \"\\f0c8\"; }\n    i.icon.star.half.outline:before { content: \"\\f089\"; }\n    i.icon.star.outline:before { content: \"\\f005\"; }\n    i.icon.sticky.note.outline:before { content: \"\\f249\"; }\n    i.icon.stop.circle.outline:before { content: \"\\f28d\"; }\n    i.icon.sun.outline:before { content: \"\\f185\"; }\n    i.icon.surprise.outline:before { content: \"\\f5c2\"; }\n    i.icon.thumbs.down.outline:before { content: \"\\f165\"; }\n    i.icon.thumbs.up.outline:before { content: \"\\f164\"; }\n    i.icon.times.circle.outline:before { content: \"\\f057\"; }\n    i.icon.tired.outline:before { content: \"\\f5c8\"; }\n    i.icon.trash.alternate.outline:before { content: \"\\f2ed\"; }\n    i.icon.user.circle.outline:before { content: \"\\f2bd\"; }\n    i.icon.user.outline:before { content: \"\\f007\"; }\n    i.icon.window.close.outline:before { content: \"\\f410\"; }\n    i.icon.window.maximize.outline:before { content: \"\\f2d0\"; }\n    i.icon.window.minimize.outline:before { content: \"\\f2d1\"; }\n    i.icon.window.restore.outline:before { content: \"\\f2d2\"; }\n    \n  }\n\n\n  /*******************************\n            Brand Icons\n  *******************************/\n\n  @if ($icon-import-brand-icons) {\n    /* Load & Define Brand Font */\n    @font-face {\n      font-family: $icon-brand-font-name;\n      src: $icon-brand-fallback-src;\n      src: $icon-brand-src;\n      font-style: normal;\n      font-weight: $normal;\n      font-variant: normal;\n      text-decoration: inherit;\n      text-transform: none;\n    }\n\n    /* Icons */\n    i.icon.\\35 00px:before { content: \"\\f26e\"; font-family: $icon-brand-font-name; }\n    i.icon.accessible:before { content: \"\\f368\"; font-family: $icon-brand-font-name; }\n    i.icon.accusoft:before { content: \"\\f369\"; font-family: $icon-brand-font-name; }\n    i.icon.acquisitions.incorporated:before { content: \"\\f6af\"; font-family: $icon-brand-font-name; }\n    i.icon.adn:before { content: \"\\f170\"; font-family: $icon-brand-font-name; }\n    i.icon.adobe:before { content: \"\\f778\"; font-family: $icon-brand-font-name; }\n    i.icon.adversal:before { content: \"\\f36a\"; font-family: $icon-brand-font-name; }\n    i.icon.affiliatetheme:before { content: \"\\f36b\"; font-family: $icon-brand-font-name; }\n    i.icon.airbnb:before { content: \"\\f834\"; font-family: $icon-brand-font-name; }\n    i.icon.algolia:before { content: \"\\f36c\"; font-family: $icon-brand-font-name; }\n    i.icon.alipay:before { content: \"\\f642\"; font-family: $icon-brand-font-name; }\n    i.icon.amazon:before { content: \"\\f270\"; font-family: $icon-brand-font-name; }\n    i.icon.amazon.pay:before { content: \"\\f42c\"; font-family: $icon-brand-font-name; }\n    i.icon.amilia:before { content: \"\\f36d\"; font-family: $icon-brand-font-name; }\n    i.icon.android:before { content: \"\\f17b\"; font-family: $icon-brand-font-name; }\n    i.icon.angellist:before { content: \"\\f209\"; font-family: $icon-brand-font-name; }\n    i.icon.angrycreative:before { content: \"\\f36e\"; font-family: $icon-brand-font-name; }\n    i.icon.angular:before { content: \"\\f420\"; font-family: $icon-brand-font-name; }\n    i.icon.app.store:before { content: \"\\f36f\"; font-family: $icon-brand-font-name; }\n    i.icon.app.store.ios:before { content: \"\\f370\"; font-family: $icon-brand-font-name; }\n    i.icon.apper:before { content: \"\\f371\"; font-family: $icon-brand-font-name; }\n    i.icon.apple:before { content: \"\\f179\"; font-family: $icon-brand-font-name; }\n    i.icon.apple.pay:before { content: \"\\f415\"; font-family: $icon-brand-font-name; }\n    i.icon.artstation:before { content: \"\\f77a\"; font-family: $icon-brand-font-name; }\n    i.icon.asymmetrik:before { content: \"\\f372\"; font-family: $icon-brand-font-name; }\n    i.icon.atlassian:before { content: \"\\f77b\"; font-family: $icon-brand-font-name; }\n    i.icon.audible:before { content: \"\\f373\"; font-family: $icon-brand-font-name; }\n    i.icon.autoprefixer:before { content: \"\\f41c\"; font-family: $icon-brand-font-name; }\n    i.icon.avianex:before { content: \"\\f374\"; font-family: $icon-brand-font-name; }\n    i.icon.aviato:before { content: \"\\f421\"; font-family: $icon-brand-font-name; }\n    i.icon.aws:before { content: \"\\f375\"; font-family: $icon-brand-font-name; }\n    i.icon.bandcamp:before { content: \"\\f2d5\"; font-family: $icon-brand-font-name; }\n    i.icon.battle.net:before { content: \"\\f835\"; font-family: $icon-brand-font-name; }\n    i.icon.behance:before { content: \"\\f1b4\"; font-family: $icon-brand-font-name; }\n    i.icon.behance.square:before { content: \"\\f1b5\"; font-family: $icon-brand-font-name; }\n    i.icon.bimobject:before { content: \"\\f378\"; font-family: $icon-brand-font-name; }\n    i.icon.bitbucket:before { content: \"\\f171\"; font-family: $icon-brand-font-name; }\n    i.icon.bitcoin:before { content: \"\\f379\"; font-family: $icon-brand-font-name; }\n    i.icon.bity:before { content: \"\\f37a\"; font-family: $icon-brand-font-name; }\n    i.icon.black.tie:before { content: \"\\f27e\"; font-family: $icon-brand-font-name; }\n    i.icon.blackberry:before { content: \"\\f37b\"; font-family: $icon-brand-font-name; }\n    i.icon.blogger:before { content: \"\\f37c\"; font-family: $icon-brand-font-name; }\n    i.icon.blogger.b:before { content: \"\\f37d\"; font-family: $icon-brand-font-name; }\n    i.icon.bluetooth:before { content: \"\\f293\"; font-family: $icon-brand-font-name; }\n    i.icon.bluetooth.b:before { content: \"\\f294\"; font-family: $icon-brand-font-name; }\n    i.icon.bootstrap:before { content: \"\\f836\"; font-family: $icon-brand-font-name; }\n    i.icon.btc:before { content: \"\\f15a\"; font-family: $icon-brand-font-name; }\n    i.icon.buffer:before { content: \"\\f837\"; font-family: $icon-brand-font-name; }\n    i.icon.buromobelexperte:before { content: \"\\f37f\"; font-family: $icon-brand-font-name; }\n    i.icon.buysellads:before { content: \"\\f20d\"; font-family: $icon-brand-font-name; }\n    i.icon.canadian.maple.leaf:before { content: \"\\f785\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.amazon.pay:before { content: \"\\f42d\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.amex:before { content: \"\\f1f3\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.apple.pay:before { content: \"\\f416\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.diners.club:before { content: \"\\f24c\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.discover:before { content: \"\\f1f2\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.jcb:before { content: \"\\f24b\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.mastercard:before { content: \"\\f1f1\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.paypal:before { content: \"\\f1f4\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.stripe:before { content: \"\\f1f5\"; font-family: $icon-brand-font-name; }\n    i.icon.cc.visa:before { content: \"\\f1f0\"; font-family: $icon-brand-font-name; }\n    i.icon.centercode:before { content: \"\\f380\"; font-family: $icon-brand-font-name; }\n    i.icon.centos:before { content: \"\\f789\"; font-family: $icon-brand-font-name; }\n    i.icon.chrome:before { content: \"\\f268\"; font-family: $icon-brand-font-name; }\n    i.icon.chromecast:before { content: \"\\f838\"; font-family: $icon-brand-font-name; }\n    i.icon.cloudscale:before { content: \"\\f383\"; font-family: $icon-brand-font-name; }\n    i.icon.cloudsmith:before { content: \"\\f384\"; font-family: $icon-brand-font-name; }\n    i.icon.cloudversify:before { content: \"\\f385\"; font-family: $icon-brand-font-name; }\n    i.icon.codepen:before { content: \"\\f1cb\"; font-family: $icon-brand-font-name; }\n    i.icon.codiepie:before { content: \"\\f284\"; font-family: $icon-brand-font-name; }\n    i.icon.confluence:before { content: \"\\f78d\"; font-family: $icon-brand-font-name; }\n    i.icon.connectdevelop:before { content: \"\\f20e\"; font-family: $icon-brand-font-name; }\n    i.icon.contao:before { content: \"\\f26d\"; font-family: $icon-brand-font-name; }\n    i.icon.cpanel:before { content: \"\\f388\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons:before { content: \"\\f25e\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.by:before { content: \"\\f4e7\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.nc:before { content: \"\\f4e8\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.nc.eu:before { content: \"\\f4e9\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.nc.jp:before { content: \"\\f4ea\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.nd:before { content: \"\\f4eb\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.pd:before { content: \"\\f4ec\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.pd.alternate:before { content: \"\\f4ed\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.remix:before { content: \"\\f4ee\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.sa:before { content: \"\\f4ef\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.sampling:before { content: \"\\f4f0\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.sampling.plus:before { content: \"\\f4f1\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.share:before { content: \"\\f4f2\"; font-family: $icon-brand-font-name; }\n    i.icon.creative.commons.zero:before { content: \"\\f4f3\"; font-family: $icon-brand-font-name; }\n    i.icon.critical.role:before { content: \"\\f6c9\"; font-family: $icon-brand-font-name; }\n    i.icon.css3:before { content: \"\\f13c\"; font-family: $icon-brand-font-name; }\n    i.icon.css3.alternate:before { content: \"\\f38b\"; font-family: $icon-brand-font-name; }\n    i.icon.cuttlefish:before { content: \"\\f38c\"; font-family: $icon-brand-font-name; }\n    i.icon.d.and.d:before { content: \"\\f38d\"; font-family: $icon-brand-font-name; }\n    i.icon.d.and.d.beyond:before { content: \"\\f6ca\"; font-family: $icon-brand-font-name; }\n    i.icon.dashcube:before { content: \"\\f210\"; font-family: $icon-brand-font-name; }\n    i.icon.delicious:before { content: \"\\f1a5\"; font-family: $icon-brand-font-name; }\n    i.icon.deploydog:before { content: \"\\f38e\"; font-family: $icon-brand-font-name; }\n    i.icon.deskpro:before { content: \"\\f38f\"; font-family: $icon-brand-font-name; }\n    i.icon.dev:before { content: \"\\f6cc\"; font-family: $icon-brand-font-name; }\n    i.icon.deviantart:before { content: \"\\f1bd\"; font-family: $icon-brand-font-name; }\n    i.icon.dhl:before { content: \"\\f790\"; font-family: $icon-brand-font-name; }\n    i.icon.diaspora:before { content: \"\\f791\"; font-family: $icon-brand-font-name; }\n    i.icon.digg:before { content: \"\\f1a6\"; font-family: $icon-brand-font-name; }\n    i.icon.digital.ocean:before { content: \"\\f391\"; font-family: $icon-brand-font-name; }\n    i.icon.discord:before { content: \"\\f392\"; font-family: $icon-brand-font-name; }\n    i.icon.discourse:before { content: \"\\f393\"; font-family: $icon-brand-font-name; }\n    i.icon.dochub:before { content: \"\\f394\"; font-family: $icon-brand-font-name; }\n    i.icon.docker:before { content: \"\\f395\"; font-family: $icon-brand-font-name; }\n    i.icon.draft2digital:before { content: \"\\f396\"; font-family: $icon-brand-font-name; }\n    i.icon.dribbble:before { content: \"\\f17d\"; font-family: $icon-brand-font-name; }\n    i.icon.dribbble.square:before { content: \"\\f397\"; font-family: $icon-brand-font-name; }\n    i.icon.dropbox:before { content: \"\\f16b\"; font-family: $icon-brand-font-name; }\n    i.icon.drupal:before { content: \"\\f1a9\"; font-family: $icon-brand-font-name; }\n    i.icon.dyalog:before { content: \"\\f399\"; font-family: $icon-brand-font-name; }\n    i.icon.earlybirds:before { content: \"\\f39a\"; font-family: $icon-brand-font-name; }\n    i.icon.ebay:before { content: \"\\f4f4\"; font-family: $icon-brand-font-name; }\n    i.icon.edge:before { content: \"\\f282\"; font-family: $icon-brand-font-name; }\n    i.icon.elementor:before { content: \"\\f430\"; font-family: $icon-brand-font-name; }\n    i.icon.ello:before { content: \"\\f5f1\"; font-family: $icon-brand-font-name; }\n    i.icon.ember:before { content: \"\\f423\"; font-family: $icon-brand-font-name; }\n    i.icon.empire:before { content: \"\\f1d1\"; font-family: $icon-brand-font-name; }\n    i.icon.envira:before { content: \"\\f299\"; font-family: $icon-brand-font-name; }\n    i.icon.erlang:before { content: \"\\f39d\"; font-family: $icon-brand-font-name; }\n    i.icon.ethereum:before { content: \"\\f42e\"; font-family: $icon-brand-font-name; }\n    i.icon.etsy:before { content: \"\\f2d7\"; font-family: $icon-brand-font-name; }\n    i.icon.evernote:before { content: \"\\f839\"; font-family: $icon-brand-font-name; }\n    i.icon.expeditedssl:before { content: \"\\f23e\"; font-family: $icon-brand-font-name; }\n    i.icon.facebook:before { content: \"\\f09a\"; font-family: $icon-brand-font-name; }\n    i.icon.facebook.f:before { content: \"\\f39e\"; font-family: $icon-brand-font-name; }\n    i.icon.facebook.messenger:before { content: \"\\f39f\"; font-family: $icon-brand-font-name; }\n    i.icon.facebook.square:before { content: \"\\f082\"; font-family: $icon-brand-font-name; }\n    i.icon.fantasy.flight.games:before { content: \"\\f6dc\"; font-family: $icon-brand-font-name; }\n    i.icon.fedex:before { content: \"\\f797\"; font-family: $icon-brand-font-name; }\n    i.icon.fedora:before { content: \"\\f798\"; font-family: $icon-brand-font-name; }\n    i.icon.figma:before { content: \"\\f799\"; font-family: $icon-brand-font-name; }\n    i.icon.firefox:before { content: \"\\f269\"; font-family: $icon-brand-font-name; }\n    i.icon.first.order:before { content: \"\\f2b0\"; font-family: $icon-brand-font-name; }\n    i.icon.first.order.alternate:before { content: \"\\f50a\"; font-family: $icon-brand-font-name; }\n    i.icon.firstdraft:before { content: \"\\f3a1\"; font-family: $icon-brand-font-name; }\n    i.icon.flickr:before { content: \"\\f16e\"; font-family: $icon-brand-font-name; }\n    i.icon.flipboard:before { content: \"\\f44d\"; font-family: $icon-brand-font-name; }\n    i.icon.fly:before { content: \"\\f417\"; font-family: $icon-brand-font-name; }\n    i.icon.font.awesome:before { content: \"\\f2b4\"; font-family: $icon-brand-font-name; }\n    i.icon.font.awesome.alternate:before { content: \"\\f35c\"; font-family: $icon-brand-font-name; }\n    i.icon.font.awesome.flag:before { content: \"\\f425\"; font-family: $icon-brand-font-name; }\n    i.icon.fonticons:before { content: \"\\f280\"; font-family: $icon-brand-font-name; }\n    i.icon.fonticons.fi:before { content: \"\\f3a2\"; font-family: $icon-brand-font-name; }\n    i.icon.fort.awesome:before { content: \"\\f286\"; font-family: $icon-brand-font-name; }\n    i.icon.fort.awesome.alternate:before { content: \"\\f3a3\"; font-family: $icon-brand-font-name; }\n    i.icon.forumbee:before { content: \"\\f211\"; font-family: $icon-brand-font-name; }\n    i.icon.foursquare:before { content: \"\\f180\"; font-family: $icon-brand-font-name; }\n    i.icon.free.code.camp:before { content: \"\\f2c5\"; font-family: $icon-brand-font-name; }\n    i.icon.freebsd:before { content: \"\\f3a4\"; font-family: $icon-brand-font-name; }\n    i.icon.fulcrum:before { content: \"\\f50b\"; font-family: $icon-brand-font-name; }\n    i.icon.galactic.republic:before { content: \"\\f50c\"; font-family: $icon-brand-font-name; }\n    i.icon.galactic.senate:before { content: \"\\f50d\"; font-family: $icon-brand-font-name; }\n    i.icon.get.pocket:before { content: \"\\f265\"; font-family: $icon-brand-font-name; }\n    i.icon.gg:before { content: \"\\f260\"; font-family: $icon-brand-font-name; }\n    i.icon.gg.circle:before { content: \"\\f261\"; font-family: $icon-brand-font-name; }\n    i.icon.git:before { content: \"\\f1d3\"; font-family: $icon-brand-font-name; }\n    i.icon.git.alternate:before { content: \"\\f841\"; font-family: $icon-brand-font-name; }\n    i.icon.git.square:before { content: \"\\f1d2\"; font-family: $icon-brand-font-name; }\n    i.icon.github:before { content: \"\\f09b\"; font-family: $icon-brand-font-name; }\n    i.icon.github.alternate:before { content: \"\\f113\"; font-family: $icon-brand-font-name; }\n    i.icon.github.square:before { content: \"\\f092\"; font-family: $icon-brand-font-name; }\n    i.icon.gitkraken:before { content: \"\\f3a6\"; font-family: $icon-brand-font-name; }\n    i.icon.gitlab:before { content: \"\\f296\"; font-family: $icon-brand-font-name; }\n    i.icon.gitter:before { content: \"\\f426\"; font-family: $icon-brand-font-name; }\n    i.icon.glide:before { content: \"\\f2a5\"; font-family: $icon-brand-font-name; }\n    i.icon.glide.g:before { content: \"\\f2a6\"; font-family: $icon-brand-font-name; }\n    i.icon.gofore:before { content: \"\\f3a7\"; font-family: $icon-brand-font-name; }\n    i.icon.goodreads:before { content: \"\\f3a8\"; font-family: $icon-brand-font-name; }\n    i.icon.goodreads.g:before { content: \"\\f3a9\"; font-family: $icon-brand-font-name; }\n    i.icon.google:before { content: \"\\f1a0\"; font-family: $icon-brand-font-name; }\n    i.icon.google.drive:before { content: \"\\f3aa\"; font-family: $icon-brand-font-name; }\n    i.icon.google.play:before { content: \"\\f3ab\"; font-family: $icon-brand-font-name; }\n    i.icon.google.plus:before { content: \"\\f2b3\"; font-family: $icon-brand-font-name; }\n    i.icon.google.plus.g:before { content: \"\\f0d5\"; font-family: $icon-brand-font-name; }\n    i.icon.google.plus.square:before { content: \"\\f0d4\"; font-family: $icon-brand-font-name; }\n    i.icon.google.wallet:before { content: \"\\f1ee\"; font-family: $icon-brand-font-name; }\n    i.icon.gratipay:before { content: \"\\f184\"; font-family: $icon-brand-font-name; }\n    i.icon.grav:before { content: \"\\f2d6\"; font-family: $icon-brand-font-name; }\n    i.icon.gripfire:before { content: \"\\f3ac\"; font-family: $icon-brand-font-name; }\n    i.icon.grunt:before { content: \"\\f3ad\"; font-family: $icon-brand-font-name; }\n    i.icon.gulp:before { content: \"\\f3ae\"; font-family: $icon-brand-font-name; }\n    i.icon.hacker.news:before { content: \"\\f1d4\"; font-family: $icon-brand-font-name; }\n    i.icon.hacker.news.square:before { content: \"\\f3af\"; font-family: $icon-brand-font-name; }\n    i.icon.hackerrank:before { content: \"\\f5f7\"; font-family: $icon-brand-font-name; }\n    i.icon.hips:before { content: \"\\f452\"; font-family: $icon-brand-font-name; }\n    i.icon.hire.a.helper:before { content: \"\\f3b0\"; font-family: $icon-brand-font-name; }\n    i.icon.hooli:before { content: \"\\f427\"; font-family: $icon-brand-font-name; }\n    i.icon.hornbill:before { content: \"\\f592\"; font-family: $icon-brand-font-name; }\n    i.icon.hotjar:before { content: \"\\f3b1\"; font-family: $icon-brand-font-name; }\n    i.icon.houzz:before { content: \"\\f27c\"; font-family: $icon-brand-font-name; }\n    i.icon.html5:before { content: \"\\f13b\"; font-family: $icon-brand-font-name; }\n    i.icon.hubspot:before { content: \"\\f3b2\"; font-family: $icon-brand-font-name; }\n    i.icon.imdb:before { content: \"\\f2d8\"; font-family: $icon-brand-font-name; }\n    i.icon.instagram:before { content: \"\\f16d\"; font-family: $icon-brand-font-name; }\n    i.icon.intercom:before { content: \"\\f7af\"; font-family: $icon-brand-font-name; }\n    i.icon.internet.explorer:before { content: \"\\f26b\"; font-family: $icon-brand-font-name; }\n    i.icon.invision:before { content: \"\\f7b0\"; font-family: $icon-brand-font-name; }\n    i.icon.ioxhost:before { content: \"\\f208\"; font-family: $icon-brand-font-name; }\n    i.icon.itch.io:before { content: \"\\f83a\"; font-family: $icon-brand-font-name; }\n    i.icon.itunes:before { content: \"\\f3b4\"; font-family: $icon-brand-font-name; }\n    i.icon.itunes.note:before { content: \"\\f3b5\"; font-family: $icon-brand-font-name; }\n    i.icon.java:before { content: \"\\f4e4\"; font-family: $icon-brand-font-name; }\n    i.icon.jedi.order:before { content: \"\\f50e\"; font-family: $icon-brand-font-name; }\n    i.icon.jenkins:before { content: \"\\f3b6\"; font-family: $icon-brand-font-name; }\n    i.icon.jira:before { content: \"\\f7b1\"; font-family: $icon-brand-font-name; }\n    i.icon.joget:before { content: \"\\f3b7\"; font-family: $icon-brand-font-name; }\n    i.icon.joomla:before { content: \"\\f1aa\"; font-family: $icon-brand-font-name; }\n    i.icon.js:before { content: \"\\f3b8\"; font-family: $icon-brand-font-name; }\n    i.icon.js.square:before { content: \"\\f3b9\"; font-family: $icon-brand-font-name; }\n    i.icon.jsfiddle:before { content: \"\\f1cc\"; font-family: $icon-brand-font-name; }\n    i.icon.kaggle:before { content: \"\\f5fa\"; font-family: $icon-brand-font-name; }\n    i.icon.keybase:before { content: \"\\f4f5\"; font-family: $icon-brand-font-name; }\n    i.icon.keycdn:before { content: \"\\f3ba\"; font-family: $icon-brand-font-name; }\n    i.icon.kickstarter:before { content: \"\\f3bb\"; font-family: $icon-brand-font-name; }\n    i.icon.kickstarter.k:before { content: \"\\f3bc\"; font-family: $icon-brand-font-name; }\n    i.icon.korvue:before { content: \"\\f42f\"; font-family: $icon-brand-font-name; }\n    i.icon.laravel:before { content: \"\\f3bd\"; font-family: $icon-brand-font-name; }\n    i.icon.lastfm:before { content: \"\\f202\"; font-family: $icon-brand-font-name; }\n    i.icon.lastfm.square:before { content: \"\\f203\"; font-family: $icon-brand-font-name; }\n    i.icon.leanpub:before { content: \"\\f212\"; font-family: $icon-brand-font-name; }\n    i.icon.lesscss:before { content: \"\\f41d\"; font-family: $icon-brand-font-name; }\n    i.icon.linechat:before { content: \"\\f3c0\"; font-family: $icon-brand-font-name; }\n    i.icon.linkedin:before { content: \"\\f08c\"; font-family: $icon-brand-font-name; }\n    i.icon.linkedin.in:before { content: \"\\f0e1\"; font-family: $icon-brand-font-name; }\n    i.icon.linode:before { content: \"\\f2b8\"; font-family: $icon-brand-font-name; }\n    i.icon.linux:before { content: \"\\f17c\"; font-family: $icon-brand-font-name; }\n    i.icon.lyft:before { content: \"\\f3c3\"; font-family: $icon-brand-font-name; }\n    i.icon.magento:before { content: \"\\f3c4\"; font-family: $icon-brand-font-name; }\n    i.icon.mailchimp:before { content: \"\\f59e\"; font-family: $icon-brand-font-name; }\n    i.icon.mandalorian:before { content: \"\\f50f\"; font-family: $icon-brand-font-name; }\n    i.icon.markdown:before { content: \"\\f60f\"; font-family: $icon-brand-font-name; }\n    i.icon.mastodon:before { content: \"\\f4f6\"; font-family: $icon-brand-font-name; }\n    i.icon.maxcdn:before { content: \"\\f136\"; font-family: $icon-brand-font-name; }\n    i.icon.medapps:before { content: \"\\f3c6\"; font-family: $icon-brand-font-name; }\n    i.icon.medium:before { content: \"\\f23a\"; font-family: $icon-brand-font-name; }\n    i.icon.medium.m:before { content: \"\\f3c7\"; font-family: $icon-brand-font-name; }\n    i.icon.medrt:before { content: \"\\f3c8\"; font-family: $icon-brand-font-name; }\n    i.icon.meetup:before { content: \"\\f2e0\"; font-family: $icon-brand-font-name; }\n    i.icon.megaport:before { content: \"\\f5a3\"; font-family: $icon-brand-font-name; }\n    i.icon.mendeley:before { content: \"\\f7b3\"; font-family: $icon-brand-font-name; }\n    i.icon.microsoft:before { content: \"\\f3ca\"; font-family: $icon-brand-font-name; }\n    i.icon.mix:before { content: \"\\f3cb\"; font-family: $icon-brand-font-name; }\n    i.icon.mixcloud:before { content: \"\\f289\"; font-family: $icon-brand-font-name; }\n    i.icon.mizuni:before { content: \"\\f3cc\"; font-family: $icon-brand-font-name; }\n    i.icon.modx:before { content: \"\\f285\"; font-family: $icon-brand-font-name; }\n    i.icon.monero:before { content: \"\\f3d0\"; font-family: $icon-brand-font-name; }\n    i.icon.napster:before { content: \"\\f3d2\"; font-family: $icon-brand-font-name; }\n    i.icon.neos:before { content: \"\\f612\"; font-family: $icon-brand-font-name; }\n    i.icon.nimblr:before { content: \"\\f5a8\"; font-family: $icon-brand-font-name; }\n    i.icon.node:before { content: \"\\f419\"; font-family: $icon-brand-font-name; }\n    i.icon.node.js:before { content: \"\\f3d3\"; font-family: $icon-brand-font-name; }\n    i.icon.npm:before { content: \"\\f3d4\"; font-family: $icon-brand-font-name; }\n    i.icon.ns8:before { content: \"\\f3d5\"; font-family: $icon-brand-font-name; }\n    i.icon.nutritionix:before { content: \"\\f3d6\"; font-family: $icon-brand-font-name; }\n    i.icon.odnoklassniki:before { content: \"\\f263\"; font-family: $icon-brand-font-name; }\n    i.icon.odnoklassniki.square:before { content: \"\\f264\"; font-family: $icon-brand-font-name; }\n    i.icon.old.republic:before { content: \"\\f510\"; font-family: $icon-brand-font-name; }\n    i.icon.opencart:before { content: \"\\f23d\"; font-family: $icon-brand-font-name; }\n    i.icon.openid:before { content: \"\\f19b\"; font-family: $icon-brand-font-name; }\n    i.icon.opera:before { content: \"\\f26a\"; font-family: $icon-brand-font-name; }\n    i.icon.optin.monster:before { content: \"\\f23c\"; font-family: $icon-brand-font-name; }\n    i.icon.osi:before { content: \"\\f41a\"; font-family: $icon-brand-font-name; }\n    i.icon.page4:before { content: \"\\f3d7\"; font-family: $icon-brand-font-name; }\n    i.icon.pagelines:before { content: \"\\f18c\"; font-family: $icon-brand-font-name; }\n    i.icon.palfed:before { content: \"\\f3d8\"; font-family: $icon-brand-font-name; }\n    i.icon.patreon:before { content: \"\\f3d9\"; font-family: $icon-brand-font-name; }\n    i.icon.paypal:before { content: \"\\f1ed\"; font-family: $icon-brand-font-name; }\n    i.icon.penny.arcade:before { content: \"\\f704\"; font-family: $icon-brand-font-name; }\n    i.icon.periscope:before { content: \"\\f3da\"; font-family: $icon-brand-font-name; }\n    i.icon.phabricator:before { content: \"\\f3db\"; font-family: $icon-brand-font-name; }\n    i.icon.phoenix.framework:before { content: \"\\f3dc\"; font-family: $icon-brand-font-name; }\n    i.icon.phoenix.squadron:before { content: \"\\f511\"; font-family: $icon-brand-font-name; }\n    i.icon.php:before { content: \"\\f457\"; font-family: $icon-brand-font-name; }\n    i.icon.pied.piper:before { content: \"\\f2ae\"; font-family: $icon-brand-font-name; }\n    i.icon.pied.piper.alternate:before { content: \"\\f1a8\"; font-family: $icon-brand-font-name; }\n    i.icon.pied.piper.hat:before { content: \"\\f4e5\"; font-family: $icon-brand-font-name; }\n    i.icon.pied.piper.pp:before { content: \"\\f1a7\"; font-family: $icon-brand-font-name; }\n    i.icon.pinterest:before { content: \"\\f0d2\"; font-family: $icon-brand-font-name; }\n    i.icon.pinterest.p:before { content: \"\\f231\"; font-family: $icon-brand-font-name; }\n    i.icon.pinterest.square:before { content: \"\\f0d3\"; font-family: $icon-brand-font-name; }\n    i.icon.playstation:before { content: \"\\f3df\"; font-family: $icon-brand-font-name; }\n    i.icon.product.hunt:before { content: \"\\f288\"; font-family: $icon-brand-font-name; }\n    i.icon.pushed:before { content: \"\\f3e1\"; font-family: $icon-brand-font-name; }\n    i.icon.python:before { content: \"\\f3e2\"; font-family: $icon-brand-font-name; }\n    i.icon.qq:before { content: \"\\f1d6\"; font-family: $icon-brand-font-name; }\n    i.icon.quinscape:before { content: \"\\f459\"; font-family: $icon-brand-font-name; }\n    i.icon.quora:before { content: \"\\f2c4\"; font-family: $icon-brand-font-name; }\n    i.icon.r.project:before { content: \"\\f4f7\"; font-family: $icon-brand-font-name; }\n    i.icon.raspberry.pi:before { content: \"\\f7bb\"; font-family: $icon-brand-font-name; }\n    i.icon.ravelry:before { content: \"\\f2d9\"; font-family: $icon-brand-font-name; }\n    i.icon.react:before { content: \"\\f41b\"; font-family: $icon-brand-font-name; }\n    i.icon.reacteurope:before { content: \"\\f75d\"; font-family: $icon-brand-font-name; }\n    i.icon.readme:before { content: \"\\f4d5\"; font-family: $icon-brand-font-name; }\n    i.icon.rebel:before { content: \"\\f1d0\"; font-family: $icon-brand-font-name; }\n    i.icon.reddit:before { content: \"\\f1a1\"; font-family: $icon-brand-font-name; }\n    i.icon.reddit.alien:before { content: \"\\f281\"; font-family: $icon-brand-font-name; }\n    i.icon.reddit.square:before { content: \"\\f1a2\"; font-family: $icon-brand-font-name; }\n    i.icon.redhat:before { content: \"\\f7bc\"; font-family: $icon-brand-font-name; }\n    i.icon.redriver:before { content: \"\\f3e3\"; font-family: $icon-brand-font-name; }\n    i.icon.redyeti:before { content: \"\\f69d\"; font-family: $icon-brand-font-name; }\n    i.icon.renren:before { content: \"\\f18b\"; font-family: $icon-brand-font-name; }\n    i.icon.replyd:before { content: \"\\f3e6\"; font-family: $icon-brand-font-name; }\n    i.icon.researchgate:before { content: \"\\f4f8\"; font-family: $icon-brand-font-name; }\n    i.icon.resolving:before { content: \"\\f3e7\"; font-family: $icon-brand-font-name; }\n    i.icon.rev:before { content: \"\\f5b2\"; font-family: $icon-brand-font-name; }\n    i.icon.rocketchat:before { content: \"\\f3e8\"; font-family: $icon-brand-font-name; }\n    i.icon.rockrms:before { content: \"\\f3e9\"; font-family: $icon-brand-font-name; }\n    i.icon.safari:before { content: \"\\f267\"; font-family: $icon-brand-font-name; }\n    i.icon.salesforce:before { content: \"\\f83b\"; font-family: $icon-brand-font-name; }\n    i.icon.sass:before { content: \"\\f41e\"; font-family: $icon-brand-font-name; }\n    i.icon.schlix:before { content: \"\\f3ea\"; font-family: $icon-brand-font-name; }\n    i.icon.scribd:before { content: \"\\f28a\"; font-family: $icon-brand-font-name; }\n    i.icon.searchengin:before { content: \"\\f3eb\"; font-family: $icon-brand-font-name; }\n    i.icon.sellcast:before { content: \"\\f2da\"; font-family: $icon-brand-font-name; }\n    i.icon.sellsy:before { content: \"\\f213\"; font-family: $icon-brand-font-name; }\n    i.icon.servicestack:before { content: \"\\f3ec\"; font-family: $icon-brand-font-name; }\n    i.icon.shirtsinbulk:before { content: \"\\f214\"; font-family: $icon-brand-font-name; }\n    i.icon.shopware:before { content: \"\\f5b5\"; font-family: $icon-brand-font-name; }\n    i.icon.simplybuilt:before { content: \"\\f215\"; font-family: $icon-brand-font-name; }\n    i.icon.sistrix:before { content: \"\\f3ee\"; font-family: $icon-brand-font-name; }\n    i.icon.sith:before { content: \"\\f512\"; font-family: $icon-brand-font-name; }\n    i.icon.sketch:before { content: \"\\f7c6\"; font-family: $icon-brand-font-name; }\n    i.icon.skyatlas:before { content: \"\\f216\"; font-family: $icon-brand-font-name; }\n    i.icon.skype:before { content: \"\\f17e\"; font-family: $icon-brand-font-name; }\n    i.icon.slack:before { content: \"\\f198\"; font-family: $icon-brand-font-name; }\n    i.icon.slack.hash:before { content: \"\\f3ef\"; font-family: $icon-brand-font-name; }\n    i.icon.slideshare:before { content: \"\\f1e7\"; font-family: $icon-brand-font-name; }\n    i.icon.snapchat:before { content: \"\\f2ab\"; font-family: $icon-brand-font-name; }\n    i.icon.snapchat.ghost:before { content: \"\\f2ac\"; font-family: $icon-brand-font-name; }\n    i.icon.snapchat.square:before { content: \"\\f2ad\"; font-family: $icon-brand-font-name; }\n    i.icon.soundcloud:before { content: \"\\f1be\"; font-family: $icon-brand-font-name; }\n    i.icon.sourcetree:before { content: \"\\f7d3\"; font-family: $icon-brand-font-name; }\n    i.icon.speakap:before { content: \"\\f3f3\"; font-family: $icon-brand-font-name; }\n    i.icon.speaker.deck:before { content: \"\\f83c\"; font-family: $icon-brand-font-name; }\n    i.icon.spotify:before { content: \"\\f1bc\"; font-family: $icon-brand-font-name; }\n    i.icon.squarespace:before { content: \"\\f5be\"; font-family: $icon-brand-font-name; }\n    i.icon.stack.exchange:before { content: \"\\f18d\"; font-family: $icon-brand-font-name; }\n    i.icon.stack.overflow:before { content: \"\\f16c\"; font-family: $icon-brand-font-name; }\n    i.icon.stackpath:before { content: \"\\f842\"; font-family: $icon-brand-font-name; }\n    i.icon.staylinked:before { content: \"\\f3f5\"; font-family: $icon-brand-font-name; }\n    i.icon.steam:before { content: \"\\f1b6\"; font-family: $icon-brand-font-name; }\n    i.icon.steam.square:before { content: \"\\f1b7\"; font-family: $icon-brand-font-name; }\n    i.icon.steam.symbol:before { content: \"\\f3f6\"; font-family: $icon-brand-font-name; }\n    i.icon.sticker.mule:before { content: \"\\f3f7\"; font-family: $icon-brand-font-name; }\n    i.icon.strava:before { content: \"\\f428\"; font-family: $icon-brand-font-name; }\n    i.icon.stripe:before { content: \"\\f429\"; font-family: $icon-brand-font-name; }\n    i.icon.stripe.s:before { content: \"\\f42a\"; font-family: $icon-brand-font-name; }\n    i.icon.studiovinari:before { content: \"\\f3f8\"; font-family: $icon-brand-font-name; }\n    i.icon.stumbleupon:before { content: \"\\f1a4\"; font-family: $icon-brand-font-name; }\n    i.icon.stumbleupon.circle:before { content: \"\\f1a3\"; font-family: $icon-brand-font-name; }\n    i.icon.superpowers:before { content: \"\\f2dd\"; font-family: $icon-brand-font-name; }\n    i.icon.supple:before { content: \"\\f3f9\"; font-family: $icon-brand-font-name; }\n    i.icon.suse:before { content: \"\\f7d6\"; font-family: $icon-brand-font-name; }\n    i.icon.symfony:before { content: \"\\f83d\"; font-family: $icon-brand-font-name; }\n    i.icon.teamspeak:before { content: \"\\f4f9\"; font-family: $icon-brand-font-name; }\n    i.icon.telegram:before { content: \"\\f2c6\"; font-family: $icon-brand-font-name; }\n    i.icon.telegram.plane:before { content: \"\\f3fe\"; font-family: $icon-brand-font-name; }\n    i.icon.tencent.weibo:before { content: \"\\f1d5\"; font-family: $icon-brand-font-name; }\n    i.icon.themeco:before { content: \"\\f5c6\"; font-family: $icon-brand-font-name; }\n    i.icon.themeisle:before { content: \"\\f2b2\"; font-family: $icon-brand-font-name; }\n    i.icon.think.peaks:before { content: \"\\f731\"; font-family: $icon-brand-font-name; }\n    i.icon.trade.federation:before { content: \"\\f513\"; font-family: $icon-brand-font-name; }\n    i.icon.trello:before { content: \"\\f181\"; font-family: $icon-brand-font-name; }\n    i.icon.tripadvisor:before { content: \"\\f262\"; font-family: $icon-brand-font-name; }\n    i.icon.tumblr:before { content: \"\\f173\"; font-family: $icon-brand-font-name; }\n    i.icon.tumblr.square:before { content: \"\\f174\"; font-family: $icon-brand-font-name; }\n    i.icon.twitch:before { content: \"\\f1e8\"; font-family: $icon-brand-font-name; }\n    i.icon.twitter:before { content: \"\\f099\"; font-family: $icon-brand-font-name; }\n    i.icon.twitter.square:before { content: \"\\f081\"; font-family: $icon-brand-font-name; }\n    i.icon.typo3:before { content: \"\\f42b\"; font-family: $icon-brand-font-name; }\n    i.icon.uber:before { content: \"\\f402\"; font-family: $icon-brand-font-name; }\n    i.icon.ubuntu:before { content: \"\\f7df\"; font-family: $icon-brand-font-name; }\n    i.icon.uikit:before { content: \"\\f403\"; font-family: $icon-brand-font-name; }\n    i.icon.uniregistry:before { content: \"\\f404\"; font-family: $icon-brand-font-name; }\n    i.icon.untappd:before { content: \"\\f405\"; font-family: $icon-brand-font-name; }\n    i.icon.ups:before { content: \"\\f7e0\"; font-family: $icon-brand-font-name; }\n    i.icon.usb:before { content: \"\\f287\"; font-family: $icon-brand-font-name; }\n    i.icon.usps:before { content: \"\\f7e1\"; font-family: $icon-brand-font-name; }\n    i.icon.ussunnah:before { content: \"\\f407\"; font-family: $icon-brand-font-name; }\n    i.icon.vaadin:before { content: \"\\f408\"; font-family: $icon-brand-font-name; }\n    i.icon.viacoin:before { content: \"\\f237\"; font-family: $icon-brand-font-name; }\n    i.icon.viadeo:before { content: \"\\f2a9\"; font-family: $icon-brand-font-name; }\n    i.icon.viadeo.square:before { content: \"\\f2aa\"; font-family: $icon-brand-font-name; }\n    i.icon.viber:before { content: \"\\f409\"; font-family: $icon-brand-font-name; }\n    i.icon.vimeo:before { content: \"\\f40a\"; font-family: $icon-brand-font-name; }\n    i.icon.vimeo.square:before { content: \"\\f194\"; font-family: $icon-brand-font-name; }\n    i.icon.vimeo.v:before { content: \"\\f27d\"; font-family: $icon-brand-font-name; }\n    i.icon.vine:before { content: \"\\f1ca\"; font-family: $icon-brand-font-name; }\n    i.icon.vk:before { content: \"\\f189\"; font-family: $icon-brand-font-name; }\n    i.icon.vnv:before { content: \"\\f40b\"; font-family: $icon-brand-font-name; }\n    i.icon.vuejs:before { content: \"\\f41f\"; font-family: $icon-brand-font-name; }\n    i.icon.waze:before { content: \"\\f83f\"; font-family: $icon-brand-font-name; }\n    i.icon.weebly:before { content: \"\\f5cc\"; font-family: $icon-brand-font-name; }\n    i.icon.weibo:before { content: \"\\f18a\"; font-family: $icon-brand-font-name; }\n    i.icon.weixin:before { content: \"\\f1d7\"; font-family: $icon-brand-font-name; }\n    i.icon.whatsapp:before { content: \"\\f232\"; font-family: $icon-brand-font-name; }\n    i.icon.whatsapp.square:before { content: \"\\f40c\"; font-family: $icon-brand-font-name; }\n    i.icon.whmcs:before { content: \"\\f40d\"; font-family: $icon-brand-font-name; }\n    i.icon.wikipedia.w:before { content: \"\\f266\"; font-family: $icon-brand-font-name; }\n    i.icon.windows:before { content: \"\\f17a\"; font-family: $icon-brand-font-name; }\n    i.icon.wix:before { content: \"\\f5cf\"; font-family: $icon-brand-font-name; }\n    i.icon.wizards.of.the.coast:before { content: \"\\f730\"; font-family: $icon-brand-font-name; }\n    i.icon.wolf.pack.battalion:before { content: \"\\f514\"; font-family: $icon-brand-font-name; }\n    i.icon.wordpress:before { content: \"\\f19a\"; font-family: $icon-brand-font-name; }\n    i.icon.wordpress.simple:before { content: \"\\f411\"; font-family: $icon-brand-font-name; }\n    i.icon.wpbeginner:before { content: \"\\f297\"; font-family: $icon-brand-font-name; }\n    i.icon.wpexplorer:before { content: \"\\f2de\"; font-family: $icon-brand-font-name; }\n    i.icon.wpforms:before { content: \"\\f298\"; font-family: $icon-brand-font-name; }\n    i.icon.wpressr:before { content: \"\\f3e4\"; font-family: $icon-brand-font-name; }\n    i.icon.xbox:before { content: \"\\f412\"; font-family: $icon-brand-font-name; }\n    i.icon.xing:before { content: \"\\f168\"; font-family: $icon-brand-font-name; }\n    i.icon.xing.square:before { content: \"\\f169\"; font-family: $icon-brand-font-name; }\n    i.icon.y.combinator:before { content: \"\\f23b\"; font-family: $icon-brand-font-name; }\n    i.icon.yahoo:before { content: \"\\f19e\"; font-family: $icon-brand-font-name; }\n    i.icon.yammer:before { content: \"\\f840\"; font-family: $icon-brand-font-name; }\n    i.icon.yandex:before { content: \"\\f413\"; font-family: $icon-brand-font-name; }\n    i.icon.yandex.international:before { content: \"\\f414\"; font-family: $icon-brand-font-name; }\n    i.icon.yarn:before { content: \"\\f7e3\"; font-family: $icon-brand-font-name; }\n    i.icon.yelp:before { content: \"\\f1e9\"; font-family: $icon-brand-font-name; }\n    i.icon.yoast:before { content: \"\\f2b1\"; font-family: $icon-brand-font-name; }\n    i.icon.youtube:before { content: \"\\f167\"; font-family: $icon-brand-font-name; }\n    i.icon.youtube.square:before { content: \"\\f431\"; font-family: $icon-brand-font-name; }\n    i.icon.zhihu:before { content: \"\\f63f\"; font-family: $icon-brand-font-name; }\n    \n\n    /* Aliases */\n    i.icon.american.express:before { content: \"\\f1f3\"; font-family: $icon-brand-font-name; }\n    i.icon.american.express.card:before { content: \"\\f1f3\"; font-family: $icon-brand-font-name; }\n    i.icon.amex:before { content: \"\\f1f3\"; font-family: $icon-brand-font-name; }\n    i.icon.bitbucket.square:before { content: \"\\f171\"; font-family: $icon-brand-font-name; }\n    i.icon.bluetooth.alternative:before { content: \"\\f294\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.amazon.pay:before { content: \"\\f42d\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.american.express:before { content: \"\\f1f3\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.diners.club:before { content: \"\\f24c\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.discover:before { content: \"\\f1f2\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.jcb:before { content: \"\\f24b\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.mastercard:before { content: \"\\f1f1\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.paypal:before { content: \"\\f1f4\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.stripe:before { content: \"\\f1f5\"; font-family: $icon-brand-font-name; }\n    i.icon.credit.card.visa:before { content: \"\\f1f0\"; font-family: $icon-brand-font-name; }\n    i.icon.diners.club:before { content: \"\\f24c\"; font-family: $icon-brand-font-name; }\n    i.icon.diners.club.card:before { content: \"\\f24c\"; font-family: $icon-brand-font-name; }\n    i.icon.discover:before { content: \"\\f1f2\"; font-family: $icon-brand-font-name; }\n    i.icon.discover.card:before { content: \"\\f1f2\"; font-family: $icon-brand-font-name; }\n    i.icon.disk.outline:before { content: \"\\f369\"; font-family: $icon-brand-font-name; }\n    i.icon.dribble:before { content: \"\\f17d\"; font-family: $icon-brand-font-name; }\n    i.icon.eercast:before { content: \"\\f2da\"; font-family: $icon-brand-font-name; }\n    i.icon.envira.gallery:before { content: \"\\f299\"; font-family: $icon-brand-font-name; }\n    i.icon.fa:before { content: \"\\f2b4\"; font-family: $icon-brand-font-name; }\n    i.icon.facebook.official:before { content: \"\\f082\"; font-family: $icon-brand-font-name; }\n    i.icon.five.hundred.pixels:before { content: \"\\f26e\"; font-family: $icon-brand-font-name; }\n    i.icon.gittip:before { content: \"\\f184\"; font-family: $icon-brand-font-name; }\n    i.icon.google.plus.circle:before { content: \"\\f2b3\"; font-family: $icon-brand-font-name; }\n    i.icon.google.plus.official:before { content: \"\\f2b3\"; font-family: $icon-brand-font-name; }\n    i.icon.japan.credit.bureau:before { content: \"\\f24b\"; font-family: $icon-brand-font-name; }\n    i.icon.japan.credit.bureau.card:before { content: \"\\f24b\"; font-family: $icon-brand-font-name; }\n    i.icon.jcb:before { content: \"\\f24b\"; font-family: $icon-brand-font-name; }\n    i.icon.linkedin.square:before { content: \"\\f08c\"; font-family: $icon-brand-font-name; }\n    i.icon.mastercard:before { content: \"\\f1f1\"; font-family: $icon-brand-font-name; }\n    i.icon.mastercard.card:before { content: \"\\f1f1\"; font-family: $icon-brand-font-name; }\n    i.icon.microsoft.edge:before { content: \"\\f282\"; font-family: $icon-brand-font-name; }\n    i.icon.ms.edge:before { content: \"\\f282\"; font-family: $icon-brand-font-name; }\n    i.icon.new.pied.piper:before { content: \"\\f2ae\"; font-family: $icon-brand-font-name; }\n    i.icon.optinmonster:before { content: \"\\f23c\"; font-family: $icon-brand-font-name; }\n    i.icon.paypal.card:before { content: \"\\f1f4\"; font-family: $icon-brand-font-name; }\n    i.icon.pied.piper.hat:before { content: \"\\f2ae\"; font-family: $icon-brand-font-name; }\n    i.icon.pocket:before { content: \"\\f265\"; font-family: $icon-brand-font-name; }\n    i.icon.stripe.card:before { content: \"\\f1f5\"; font-family: $icon-brand-font-name; }\n    i.icon.theme.isle:before { content: \"\\f2b2\"; font-family: $icon-brand-font-name; }\n    i.icon.visa:before { content: \"\\f1f0\"; font-family: $icon-brand-font-name; }\n    i.icon.visa.card:before { content: \"\\f1f0\"; font-family: $icon-brand-font-name; }\n    i.icon.wechat:before { content: \"\\f1d7\"; font-family: $icon-brand-font-name; }\n    i.icon.wikipedia:before { content: \"\\f266\"; font-family: $icon-brand-font-name; }\n    i.icon.wordpress.beginner:before { content: \"\\f297\"; font-family: $icon-brand-font-name; }\n    i.icon.wordpress.forms:before { content: \"\\f298\"; font-family: $icon-brand-font-name; }\n    i.icon.yc:before { content: \"\\f23b\"; font-family: $icon-brand-font-name; }\n    i.icon.ycombinator:before { content: \"\\f23b\"; font-family: $icon-brand-font-name; }\n    i.icon.youtube.play:before { content: \"\\f167\"; font-family: $icon-brand-font-name; }\n    \n  }\n\n}","@import '../../themes/default/elements/image.variables';\n\n@if $use-image {\n  /*******************************\n  //@-         Image\n  *******************************/\n  \n  .ui.image {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n    max-width: 100%;\n    background-color: $image-placeholder-color;\n  }\n  \n  img.ui.image {\n    display: block;\n  }\n  \n  .ui.image svg,\n  .ui.image img {\n    display: block;\n    max-width: 100%;\n    height: auto;\n  }\n  \n  \n  /*******************************\n              States\n  *******************************/\n  \n  .ui.hidden.images,\n  .ui.ui.hidden.image {\n    display: none;\n  }\n  .ui.hidden.transition.images,\n  .ui.hidden.transition.image {\n    display: block;\n    visibility: hidden;\n  }\n  .ui.images > .hidden.transition {\n    display: inline-block;\n    visibility: hidden;\n  }\n  \n  \n  .ui.disabled.images,\n  .ui.disabled.image {\n    cursor: default;\n    opacity: $disabled-opacity;\n  }\n  \n  \n  /*******************************\n            Variations\n  *******************************/\n  \n  \n  /*--------------\n       Inline\n  ---------------*/\n  \n  .ui.inline.image,\n  .ui.inline.image svg,\n  .ui.inline.image img {\n    display: inline-block;\n  }\n  \n  /*------------------\n    Vertical Aligned\n  -------------------*/\n  \n  .ui.top.aligned.images .image,\n  .ui.top.aligned.image,\n  .ui.top.aligned.image svg,\n  .ui.top.aligned.image img {\n    display: inline-block;\n    vertical-align: top;\n  }\n  .ui.middle.aligned.images .image,\n  .ui.middle.aligned.image,\n  .ui.middle.aligned.image svg,\n  .ui.middle.aligned.image img {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .ui.bottom.aligned.images .image,\n  .ui.bottom.aligned.image,\n  .ui.bottom.aligned.image svg,\n  .ui.bottom.aligned.image img {\n    display: inline-block;\n    vertical-align: bottom;\n  }\n  \n  /*--------------\n       Rounded\n  ---------------*/\n  \n  .ui.rounded.images .image,\n  .ui.rounded.image,\n  .ui.rounded.images .image > *,\n  .ui.rounded.image > * {\n    border-radius: $image-rounded-border-radius;\n  }\n  \n  /*--------------\n      Bordered\n  ---------------*/\n  \n  .ui.bordered.images .image,\n  .ui.bordered.images img,\n  .ui.bordered.images svg,\n  .ui.bordered.image img,\n  .ui.bordered.image svg,\n  img.ui.bordered.image {\n    border: $image-border;\n  }\n  \n  /*--------------\n      Circular\n  ---------------*/\n  \n  .ui.circular.images,\n  .ui.circular.image {\n    overflow: hidden;\n  }\n  \n  .ui.circular.images .image,\n  .ui.circular.image,\n  .ui.circular.images .image > *,\n  .ui.circular.image > * {\n    -webkit-border-radius: $circular-radius;\n    -moz-border-radius: $circular-radius;\n    border-radius: $circular-radius;\n  }\n  \n  /*--------------\n       Fluid\n  ---------------*/\n  \n  .ui.fluid.images,\n  .ui.fluid.image,\n  .ui.fluid.images img,\n  .ui.fluid.images svg,\n  .ui.fluid.image svg,\n  .ui.fluid.image img {\n    display: block;\n    width: 100%;\n    height: auto;\n  }\n  \n  \n  /*--------------\n       Avatar\n  ---------------*/\n  \n  .ui.avatar.images .image,\n  .ui.avatar.images img,\n  .ui.avatar.images svg,\n  .ui.avatar.image img,\n  .ui.avatar.image svg,\n  .ui.avatar.image {\n    margin-right: $image-avatar-margin;\n  \n    display: inline-block;\n    width: $image-avatar-size;\n    height: $image-avatar-size;\n  \n    -webkit-border-radius: $circular-radius;\n    -moz-border-radius: $circular-radius;\n    border-radius: $circular-radius;\n  }\n  \n  /*-------------------\n         Spaced\n  --------------------*/\n  \n  .ui.spaced.image {\n    display: inline-block !important;\n    margin-left: $image-spaced-distance;\n    margin-right: $image-spaced-distance;\n  }\n  \n  .ui[class*=\"left spaced\"].image {\n    margin-left: $image-spaced-distance;\n    margin-right: 0;\n  }\n  \n  .ui[class*=\"right spaced\"].image {\n    margin-left: 0;\n    margin-right: $image-spaced-distance;\n  }\n  \n  /*-------------------\n         Floated\n  --------------------*/\n  \n  .ui.floated.image,\n  .ui.floated.images {\n    float: left;\n    margin-right: $image-floated-horizontal-margin;\n    margin-bottom: $image-floated-vertical-margin;\n  }\n  .ui.right.floated.images,\n  .ui.right.floated.image {\n    float: right;\n    margin-right: 0;\n    margin-bottom: $image-floated-vertical-margin;\n    margin-left: $image-floated-horizontal-margin;\n  }\n  \n  .ui.floated.images:last-child,\n  .ui.floated.image:last-child {\n    margin-bottom: 0;\n  }\n  \n  \n  .ui.centered.images,\n  .ui.centered.image {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  /*--------------\n       Sizes\n  ---------------*/\n  \n  .ui.mini.images .image,\n  .ui.mini.images img,\n  .ui.mini.images svg,\n  .ui.mini.image {\n    width: $image-mini-width;\n    height: auto;\n    font-size: $mini;\n  }\n  .ui.tiny.images .image,\n  .ui.tiny.images img,\n  .ui.tiny.images svg,\n  .ui.tiny.image {\n    width: $image-tiny-width;\n    height: auto;\n    font-size: $tiny;\n  }\n  .ui.small.images .image,\n  .ui.small.images img,\n  .ui.small.images svg,\n  .ui.small.image {\n    width: $image-small-width;\n    height: auto;\n    font-size: $small;\n  }\n  .ui.medium.images .image,\n  .ui.medium.images img,\n  .ui.medium.images svg,\n  .ui.medium.image {\n    width: $image-medium-width;\n    height: auto;\n    font-size: $medium;\n  }\n  .ui.large.images .image,\n  .ui.large.images img,\n  .ui.large.images svg,\n  .ui.large.image {\n    width: $image-large-width;\n    height: auto;\n    font-size: $large;\n  }\n  .ui.big.images .image,\n  .ui.big.images img,\n  .ui.big.images svg,\n  .ui.big.image {\n    width: $image-big-width;\n    height: auto;\n    font-size: $big;\n  }\n  .ui.huge.images .image,\n  .ui.huge.images img,\n  .ui.huge.images svg,\n  .ui.huge.image {\n    width: $image-huge-width;\n    height: auto;\n    font-size: $huge;\n  }\n  .ui.massive.images .image,\n  .ui.massive.images img,\n  .ui.massive.images svg,\n  .ui.massive.image {\n    width: $image-massive-width;\n    height: auto;\n    font-size: $massive;\n  }\n  \n  \n  /*******************************\n                Groups\n  *******************************/\n  \n  .ui.images {\n    font-size: 0;\n    margin: 0 (-$image-horizontal-margin) 0;\n  }\n  \n  .ui.images .image,\n  .ui.images > img,\n  .ui.images > svg {\n    display: inline-block;\n    margin: 0 $image-horizontal-margin $image-vertical-margin;\n  }\n}\n\n@import '../../themes/default/elements/image.style';","@import '../../themes/default/elements/input.variables';\n\n@if $use-input {\n  /*******************************\n  //@-       Standard\n  *******************************/\n  \n  \n  /*--------------------\n          Inputs\n  ---------------------*/\n  \n  .ui.input {\n    position: relative;\n    font-weight: $normal;\n    font-style: normal;\n    display: inline-flex;\n    color: $input-color;\n  }\n  .ui.input > input {\n    margin: 0;\n    max-width: 100%;\n    flex: 1 0 auto;\n    outline: none;\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n    text-align: $input-text-align;\n    line-height: $input-line-height;\n  \n    font-family: $input-font;\n    padding: $input-padding;\n  \n    background: $input-background;\n    border: $input-border;\n    color: $input-color;\n    border-radius: $input-border-radius;\n    transition: $input-transition;\n  \n    box-shadow: $input-box-shadow;\n  }\n  \n  \n  /*--------------------\n        Placeholder\n  ---------------------*/\n  \n  /* browsers require these rules separate */\n  \n  .ui.input > input::-webkit-input-placeholder {\n    color: $input-placeholder-color;\n  }\n  .ui.input > input::-moz-placeholder {\n    color: $input-placeholder-color;\n  }\n  .ui.input > input:-ms-input-placeholder {\n    color: $input-placeholder-color;\n  }\n  \n  \n  /*******************************\n              States\n  *******************************/\n  \n  /*--------------------\n          Disabled\n  ---------------------*/\n  \n  .ui.disabled.input,\n  .ui.input:not(.disabled) input[disabled] {\n    opacity: $disabled-opacity;\n  }\n  \n  .ui.disabled.input > input,\n  .ui.input:not(.disabled) input[disabled] {\n    pointer-events: none;\n  }\n  \n  /*--------------------\n          Active\n  ---------------------*/\n  \n  .ui.input > input:active,\n  .ui.input.down input {\n    border-color: $input-down-border-color;\n    background: $input-down-background;\n    color: $input-down-color;\n    box-shadow: $input-down-box-shadow;\n  }\n  \n  /*--------------------\n         Loading\n  ---------------------*/\n  \n  .ui.loading.loading.input > i.icon:before {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n  \n    margin: $loader-margin;\n    width: $loader-size;\n    height: $loader-size;\n  \n    border-radius: $circular-radius;\n    border: $loader-line-width solid $loader-fill-color;\n  }\n  .ui.loading.loading.input > i.icon:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n  \n    margin: $loader-margin;\n    width: $loader-size;\n    height: $loader-size;\n  \n    animation: loader $loader-speed infinite linear;\n  \n    border: $loader-line-width solid $loader-line-color;\n    border-radius: $circular-radius;\n  \n    box-shadow: 0 0 0 1px transparent;\n  }\n  \n  \n  /*--------------------\n          Focus\n  ---------------------*/\n  \n  .ui.input.focus > input,\n  .ui.input > input:focus  {\n    border-color: $input-focus-border-color;\n    background: $input-focus-background;\n    color: $input-focus-color;\n    box-shadow: $input-focus-box-shadow;\n  }\n  .ui.input.focus > input::-webkit-input-placeholder,\n  .ui.input > input:focus::-webkit-input-placeholder {\n    color: $input-placeholder-focus-color;\n  }\n  .ui.input.focus > input::-moz-placeholder,\n  .ui.input > input:focus::-moz-placeholder {\n    color: $input-placeholder-focus-color;\n  }\n  .ui.input.focus > input:-ms-input-placeholder,\n  .ui.input > input:focus:-ms-input-placeholder {\n    color: $input-placeholder-focus-color;\n  }\n  \n  \n  \n  /*--------------------\n          Error\n  ---------------------*/\n  \n  .ui.input.error > input {\n    background-color: $input-error-background;\n    border-color: $input-error-border;\n    color: $input-error-color;\n    box-shadow: $input-error-box-shadow;\n  }\n  \n  /* Error Placeholder */\n  .ui.input.error > input::-webkit-input-placeholder {\n    color: $input-placeholder-error-color;\n  }\n  .ui.input.error > input::-moz-placeholder {\n    color: $input-placeholder-error-color;\n  }\n  .ui.input.error > input:-ms-input-placeholder {\n    color: $input-placeholder-error-color !important;\n  }\n  \n  /* Focused Error Placeholder */\n  .ui.input.error > input:focus::-webkit-input-placeholder {\n    color: $input-placeholder-error-focus-color;\n  }\n  .ui.input.error > input:focus::-moz-placeholder {\n    color: $input-placeholder-error-focus-color;\n  }\n  .ui.input.error > input:focus:-ms-input-placeholder {\n    color: $input-placeholder-error-focus-color !important;\n  }\n  \n  /*******************************\n             Variations\n  *******************************/\n  @if($use-input-variation-transparent) {\n    /*--------------------\n          Transparent\n    ---------------------*/\n  \n  \n    .ui.transparent.input > textarea,\n    .ui.transparent.input > input {\n      border-color: transparent !important;\n      background-color: transparent !important;\n      padding: 0;\n      box-shadow: none !important;\n      border-radius: 0 !important;\n    }\n    .field .ui.transparent.input > textarea {\n      padding: $input-padding;\n    }\n  \n    /* Transparent Icon */\n    :not(.field) > .ui.transparent.icon.input > i.icon {\n      width: $input-transparent-icon-width;\n    }\n    :not(.field) > .ui.transparent.icon.input > input {\n      padding-left: 0;\n      padding-right: $input-transparent-icon-margin;\n    }\n    :not(.field) > .ui.transparent[class*=\"left icon\"].input > input {\n      padding-left: $input-transparent-icon-margin;\n      padding-right: 0;\n    }\n  \n    /* Transparent Inverted */\n    .ui.transparent.inverted.input {\n      color: $input-transparent-inverted-color;\n    }\n    .ui.ui.transparent.inverted.input > textarea,\n    .ui.ui.transparent.inverted.input > input {\n      color: inherit;\n    }\n  \n    .ui.transparent.inverted.input > input::-webkit-input-placeholder {\n      color: $input-transparent-inverted-placeholder-color;\n    }\n    .ui.transparent.inverted.input > input::-moz-placeholder {\n      color: $input-transparent-inverted-placeholder-color;\n    }\n    .ui.transparent.inverted.input > input:-ms-input-placeholder {\n      color: $input-transparent-inverted-placeholder-color;\n    }\n  }\n  \n  \n  @if($use-input-variation-icon) {\n    /*--------------------\n            Icon\n    ---------------------*/\n  \n    .ui.icon.input > i.icon {\n      cursor: default;\n      position: absolute;\n      line-height: 1;\n      text-align: center;\n      top: 0;\n      right: 0;\n      margin: 0;\n      height: 100%;\n  \n      width: $input-icon-width;\n      opacity: $input-icon-opacity;\n      border-radius: 0 $input-border-radius $input-border-radius 0;\n      transition: $input-icon-transition;\n    }\n    .ui.icon.input > i.icon:not(.link) {\n      pointer-events: none;\n    }\n    .ui.ui.icon.input > textarea,\n    .ui.ui.icon.input > input {\n      padding-right: $input-icon-margin;\n    }\n  \n    .ui.icon.input > i.icon:before,\n    .ui.icon.input > i.icon:after {\n      left: 0;\n      position: absolute;\n      text-align: center;\n      top: 50%;\n      width: 100%;\n      margin-top: $input-icon-offset;\n    }\n    .ui.icon.input > i.link.icon {\n      cursor: pointer;\n    }\n    .ui.icon.input > i.circular.icon {\n      top: $input-circular-icon-vertical-offset;\n      right: $input-circular-icon-horizontal-offset;\n    }\n  \n    /* Left Icon Input */\n    .ui[class*=\"left icon\"].input > i.icon {\n      right: auto;\n      left: $input-border-width;\n      border-radius: $input-border-radius 0 0 $input-border-radius;\n    }\n    .ui[class*=\"left icon\"].input > i.circular.icon {\n      right: auto;\n      left: $input-circular-icon-horizontal-offset;\n    }\n    .ui.ui[class*=\"left icon\"].input > textarea,\n    .ui.ui[class*=\"left icon\"].input > input {\n      padding-left: $input-icon-margin;\n      padding-right: $input-horizontal-padding;\n    }\n  \n    /* Focus */\n    .ui.icon.input > textarea:focus ~ i.icon,\n    .ui.icon.input > input:focus ~ i.icon {\n      opacity: 1;\n    }\n  }\n  \n  @if($use-input-variation-labeled) {\n    /*--------------------\n            Labeled\n    ---------------------*/\n  \n    /* Adjacent Label */\n    .ui.labeled.input > .label {\n      flex: 0 0 auto;\n      margin: 0;\n      font-size: $relative-medium;\n    }\n    .ui.labeled.input > .label:not(.corner) {\n      padding-top: $input-vertical-padding;\n      padding-bottom: $input-vertical-padding;\n    }\n  \n    /* Regular Label on Left */\n    .ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child {\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n    .ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child + input {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n      border-left-color: transparent;\n    }\n    .ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child + input:focus {\n      border-left-color: $input-focus-border-color;\n    }\n  \n    /* Regular Label on Right */\n    .ui[class*=\"right labeled\"].input > input {\n      border-top-right-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n      border-right-color: transparent !important;\n    }\n    .ui[class*=\"right labeled\"].input > input + .label {\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  \n    .ui[class*=\"right labeled\"].input > input:focus {\n      border-right-color: $input-focus-border-color !important;\n    }\n  \n    /* Corner Label */\n    .ui.labeled.input .corner.label {\n      top: $input-label-corner-top;\n      right: $input-label-corner-right;\n      font-size: $input-label-corner-size;\n      border-radius: 0 $input-border-radius 0 0;\n    }\n  \n    /* Spacing with corner label */\n    .ui[class*=\"corner labeled\"]:not([class*=\"left corner labeled\"]).labeled.input > textarea,\n    .ui[class*=\"corner labeled\"]:not([class*=\"left corner labeled\"]).labeled.input > input {\n      padding-right: $input-labeled-margin !important;\n    }\n    .ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > textarea,\n    .ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > input {\n      padding-right: $input-labeled-icon-itself-margin !important;\n    }\n    .ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"]) > .icon {\n      margin-right: $input-labeled-icon-margin;\n    }\n  \n    /* Left Labeled */\n    .ui[class*=\"left corner labeled\"].labeled.input > textarea,\n    .ui[class*=\"left corner labeled\"].labeled.input > input {\n      padding-left: $input-labeled-margin !important;\n    }\n    .ui[class*=\"left corner labeled\"].icon.input > textarea,\n    .ui[class*=\"left corner labeled\"].icon.input > input {\n      padding-left: $input-labeled-icon-itself-margin !important;\n    }\n    .ui[class*=\"left corner labeled\"].icon.input > .icon {\n      margin-left: $input-labeled-icon-margin;\n    }\n    .ui.icon.input > textarea ~ .icon {\n      height: $input-textarea-icon-height;\n    }\n    :not(.field) > .ui.transparent.icon.input > textarea ~ .icon {\n      height: $input-transparent-textarea-icon-height;\n    }\n  \n    /* Corner Label Position  */\n    .ui.input > .ui.corner.label {\n      top: $input-border-width;\n      right: $input-border-width;\n    }\n    .ui.input > .ui.left.corner.label {\n      right: auto;\n      left: $input-border-width;\n    }\n  \n    /* Labeled and action input error */\n    .ui.form > .field.error > .ui.action.input > .ui.button,\n    .ui.form > .field.error > .ui.labeled.input:not([class*=\"corner labeled\"]) > .ui.label,\n    .ui.action.input.error > .ui.button,\n    .ui.labeled.input.error:not([class*=\"corner labeled\"]) > .ui.label {\n      border-top: $input-border-width solid $input-error-border;\n      border-bottom: $input-border-width solid $input-error-border;\n    }\n    .ui.form > .field.error > .ui.left.action.input > .ui.button,\n    .ui.form > .field.error > .ui.labeled.input:not(.right):not([class*=\"corner labeled\"]) > .ui.label,\n    .ui.left.action.input.error > .ui.button,\n    .ui.labeled.input.error:not(.right):not([class*=\"corner labeled\"]) > .ui.label {\n      border-left: $input-border-width solid $input-error-border;\n    }\n    .ui.form > .field.error > .ui.action.input:not(.left) > input + .ui.button,\n    .ui.form > .field.error > .ui.right.labeled.input:not([class*=\"corner labeled\"]) > input + .ui.label,\n    .ui.action.input.error:not(.left) > input + .ui.button,\n    .ui.right.labeled.input.error:not([class*=\"corner labeled\"]) > input + .ui.label {\n      border-right: $input-border-width solid $input-error-border;\n    }\n    .ui.form > .field.error > .ui.right.labeled.input:not([class*=\"corner labeled\"]) > .ui.label:first-child,\n    .ui.right.labeled.input.error:not([class*=\"corner labeled\"]) > .ui.label:first-child {\n      border-left: $input-border-width solid $input-error-border;\n    }\n  }\n  \n  @if($use-input-variation-action) {\n    /*--------------------\n            Action\n    ---------------------*/\n  \n    .ui.action.input > .button,\n    .ui.action.input > .buttons {\n      display: flex;\n      align-items: center;\n      flex: 0 0 auto;\n    }\n    .ui.action.input > .button,\n    .ui.action.input > .buttons > .button {\n      padding-top: $input-vertical-padding;\n      padding-bottom: $input-vertical-padding;\n      margin: 0;\n    }\n  \n    /* Button on Right */\n    .ui.action.input:not([class*=\"left action\"]) > input {\n      border-top-right-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n      border-right-color: transparent !important;\n    }\n    .ui.action.input:not([class*=\"left action\"]) > .dropdown:not(:first-child),\n    .ui.action.input:not([class*=\"left action\"]) > .button:not(:first-child),\n    .ui.action.input:not([class*=\"left action\"]) > .buttons:not(:first-child) > .button {\n      border-radius: 0;\n    }\n    .ui.action.input:not([class*=\"left action\"]) > .dropdown:last-child,\n    .ui.action.input:not([class*=\"left action\"]) > .button:last-child,\n    .ui.action.input:not([class*=\"left action\"]) > .buttons:last-child > .button {\n      border-radius: 0 $input-border-radius $input-border-radius 0;\n    }\n  \n    /* Input Focus */\n    .ui.action.input:not([class*=\"left action\"]) > input:focus {\n      border-right-color: $input-focus-border-color !important;\n    }\n  \n    /* Button on Left */\n    .ui[class*=\"left action\"].input > input {\n      border-top-left-radius: 0 !important;\n      border-bottom-left-radius: 0 !important;\n      border-left-color: transparent !important;\n    }\n    .ui[class*=\"left action\"].input > .dropdown,\n    .ui[class*=\"left action\"].input > .button,\n    .ui[class*=\"left action\"].input > .buttons > .button {\n      border-radius: 0;\n    }\n    .ui[class*=\"left action\"].input > .dropdown:first-child,\n    .ui[class*=\"left action\"].input > .button:first-child,\n    .ui[class*=\"left action\"].input > .buttons:first-child > .button {\n      border-radius: $input-border-radius 0 0 $input-border-radius;\n    }\n    /* Input Focus */\n    .ui[class*=\"left action\"].input > input:focus {\n      border-left-color: $input-focus-border-color !important;\n    }\n  }\n  \n  /*--------------------\n         Inverted\n  ---------------------*/\n  \n  /* Standard */\n  .ui.inverted.input > input {\n    border: none;\n  }\n  \n  /*--------------------\n          Fluid\n  ---------------------*/\n  \n  .ui.fluid.input {\n    display: flex;\n  }\n  .ui.fluid.input > input {\n    width: 0 !important;\n  }\n  \n  /*--------------------\n          Size\n  ---------------------*/\n  \n  .ui.mini.input {\n    font-size: $relative-mini;\n  }\n  .ui.tiny.input {\n    font-size: $relative-tiny;\n  }\n  .ui.small.input {\n    font-size: $relative-small;\n  }\n  .ui.input {\n    font-size: $relative-medium;\n  }\n  .ui.large.input {\n    font-size: $relative-large;\n  }\n  .ui.big.input {\n    font-size: $relative-big;\n  }\n  .ui.huge.input {\n    font-size: $relative-huge;\n  }\n  .ui.massive.input {\n    font-size: $relative-massive;\n  }\n}\n\n@import '../../themes/default/elements/input.style';","@import '../../themes/default/elements/label.variables';\n\n@if $use-label {\n  /*******************************\n  //@-        Label\n  *******************************/\n  \n  .ui.label {\n    display: inline-block;\n    line-height: 1;\n    vertical-align: $label-vertical-align;\n  \n    margin: $label-vertical-margin $label-horizontal-margin;\n  \n    background-color: $label-background-color;\n    background-image: $label-background-image;\n    padding: $label-vertical-padding $label-horizontal-padding;\n    color: $label-color;\n  \n    text-transform: $label-text-transform;\n    font-weight: $label-font-weight;\n  \n    border: $label-border;\n    border-radius: $label-border-radius;\n    transition: $label-transition;\n  }\n  \n  .ui.label:first-child {\n    margin-left: 0;\n  }\n  .ui.label:last-child {\n    margin-right: 0;\n  }\n  \n  /* Link */\n  a.ui.label {\n    cursor: pointer;\n  }\n  \n  /* Inside Link */\n  .ui.label > a {\n    cursor: pointer;\n    color: inherit;\n    opacity: $label-link-opacity;\n    transition: $label-link-transition;\n  }\n  .ui.label > a:hover {\n    opacity: 1;\n  }\n  \n  /* Image */\n  .ui.label > img {\n    width: auto !important;\n    vertical-align: middle;\n    height: $label-image-height;\n  }\n  \n  /* Icon */\n  .ui.left.icon.label > .icon,\n  .ui.label > .icon {\n    width: auto;\n    margin: 0 $label-icon-distance 0 0;\n  }\n  \n  /* Detail */\n  .ui.label > .detail {\n    display: inline-block;\n    vertical-align: top;\n    font-weight: $label-detail-font-weight;\n    margin-left: $label-detail-margin;\n    opacity: $label-detail-opacity;\n  }\n  .ui.label > .detail .icon {\n    margin: 0 $label-detail-icon-distance 0 0;\n  }\n  \n  /* Removable label */\n  .ui.label > .close.icon,\n  .ui.label > .delete.icon {\n    cursor: pointer;\n    font-size: $label-delete-size;\n    opacity: $label-delete-opacity;\n    transition: $label-delete-transition;\n  }\n  .ui.label > .close.icon:hover,\n  .ui.label > .delete.icon:hover {\n    opacity: 1;\n  }\n  \n  /* Backward compatible positioning */\n  .ui.label.left.icon > .close.icon,\n  .ui.label.left.icon > .delete.icon {\n    margin: 0 $label-delete-margin 0 0;\n  }\n  .ui.label:not(.icon) > .close.icon,\n  .ui.label:not(.icon) > .delete.icon {\n    margin: 0 0 0 $label-delete-margin;\n  }\n  \n  /* Label for only an icon */\n  .ui.icon.label > .icon {\n    margin: 0 auto;\n  }\n  \n  /* Right Side Icon */\n  .ui.right.icon.label > .icon {\n    margin: 0 0 0 $label-icon-distance;\n  }\n  \n  /*-------------------\n         Group\n  --------------------*/\n  \n  .ui.labels > .label {\n    margin: 0 $label-group-horizontal-margin $label-group-vertical-margin 0;\n  }\n  \n  \n  /*-------------------\n         Coupling\n  --------------------*/\n  \n  .ui.header > .ui.label {\n    margin-top: $label-line-height-offset;\n  }\n  \n  \n  /* Remove border radius on attached segment */\n  .ui.attached.segment > .ui.top.left.attached.label,\n  .ui.bottom.attached.segment > .ui.top.left.attached.label  {\n    border-top-left-radius: 0;\n  }\n  .ui.attached.segment > .ui.top.right.attached.label,\n  .ui.bottom.attached.segment > .ui.top.right.attached.label  {\n    border-top-right-radius: 0;\n  }\n  .ui.top.attached.segment > .ui.bottom.left.attached.label  {\n    border-bottom-left-radius: 0;\n  }\n  .ui.top.attached.segment > .ui.bottom.right.attached.label  {\n    border-bottom-right-radius: 0;\n  }\n  \n  /* Padding on next content after a label */\n  .ui.top.attached.label ~ .ui.bottom.attached.label + :not(.attached),\n  .ui.top.attached.label + :not(.attached) {\n    margin-top: $label-attached-segment-padding !important;\n  }\n  .ui.bottom.attached.label ~ :last-child:not(.attached) {\n    margin-top:0;\n    margin-bottom: $label-attached-segment-padding !important;\n  }\n  \n  \n  /*******************************\n               Types\n  *******************************/\n  @if($use-label-type-image) {\n    .ui.image.label {\n      width: auto !important;\n      margin-top: 0;\n      margin-bottom: 0;\n      max-width: 9999px;\n      vertical-align: baseline;\n      text-transform: none;\n  \n      background: $label-image-background;\n      padding: $label-image-padding;\n      border-radius: $label-image-border-radius;\n      box-shadow: $label-image-box-shadow;\n    }\n  \n    .ui.image.label img {\n      display: inline-block;\n      vertical-align: top;\n  \n      height: $label-image-image-height;\n      margin: $label-image-image-margin;\n      border-radius: $label-image-image-border-radius;\n    }\n  \n    .ui.image.label .detail {\n      background: $label-image-detail-background;\n      margin: $label-image-detail-margin;\n      padding: $label-image-detail-padding;\n      border-radius: 0 $label-image-border-radius $label-image-border-radius 0;\n    }\n  }\n  \n  @if($use-label-type-tag) {\n    /*-------------------\n            Tag\n    --------------------*/\n  \n    .ui.tag.labels .label,\n    .ui.tag.label {\n      margin-left: 1em;\n      position: relative;\n      padding-left: $label-tag-horizontal-padding;\n      padding-right: $label-tag-horizontal-padding;\n  \n      border-radius: 0 $label-border-radius $label-border-radius 0;\n      transition: $label-tag-transition;\n    }\n    .ui.tag.labels .label:before,\n    .ui.tag.label:before {\n        position: absolute;\n        transform: translateY(-50%) translateX(50%) rotate(-45deg);\n  \n        top: $label-tag-triangle-top-offset;\n        right: $label-tag-triangle-right-offset;\n        content: '';\n  \n        background-color: inherit;\n        background-image: $label-tag-triangle-background-image;\n  \n        width: $label-tag-triangle-size;\n        height: $label-tag-triangle-size;\n        transition: $label-tag-transition;\n    }\n  \n  \n    .ui.tag.labels .label:after,\n    .ui.tag.label:after {\n      position: absolute;\n      content: '';\n      top: 50%;\n      left: -($label-tag-circle-size / 2);\n  \n      margin-top: -($label-tag-circle-size / 2);\n      background-color: $label-tag-circle-color;\n      width: $label-tag-circle-size;\n      height: $label-tag-circle-size;\n  \n      box-shadow: $label-tag-circle-box-shadow;\n      border-radius: $circular-radius;\n    }\n  \n    @if($use-label-variation-basic-tag) {\n      .ui.basic.tag.labels .label:before,\n      .ui.basic.tag.label:before {\n        border-color: inherit;\n        border-width: $label-basic-border-width 0 0 $label-basic-border-width;\n        border-style: inherit;\n        right: $label-basic-border-full-width-offset;\n      }\n      .ui.basic.tag.labels .label:after,\n      .ui.basic.tag.label:after {\n        box-shadow: $label-basic-tag-circle-box-shadow;\n      }\n    }\n  }\n  \n  @if($use-label-type-corner) {\n    /*-------------------\n        Corner Label\n    --------------------*/\n  \n    .ui.corner.label {\n      position: absolute;\n      top: 0;\n      right: 0;\n      margin: 0;\n      padding: 0;\n      text-align: center;\n  \n      border-color: $label-background-color;\n  \n      width: $label-corner-triangle-size;\n      height: $label-corner-triangle-size;\n      z-index: $label-corner-triangle-z-index;\n      transition: $label-corner-triangle-transition;\n    }\n  \n    /* Icon Label */\n    .ui.corner.label{\n      background-color: transparent !important;\n    }\n    .ui.corner.label:after {\n      position: absolute;\n      content: \"\";\n      right: 0;\n      top: 0;\n      z-index: -1;\n  \n      width: 0;\n      height: 0;\n      background-color: transparent;\n  \n      border-top: 0 solid transparent;\n      border-right: $label-corner-triangle-size solid transparent;\n      border-bottom: $label-corner-triangle-size solid transparent;\n      border-left: 0 solid transparent;\n  \n      border-right-color: inherit;\n      transition: $label-corner-triangle-transition;\n    }\n  \n    .ui.corner.label .icon {\n      cursor: inherit;\n      position: absolute;\n      top: $label-corner-icon-top-offset;\n      left: auto;\n      right: $label-corner-icon-right-offset;\n      font-size: $label-corner-icon-size;\n      margin: 0;\n    }\n  \n    /* Left Corner */\n    .ui.left.corner.label,\n    .ui.left.corner.label:after {\n      right: auto;\n      left: 0;\n    }\n    .ui.left.corner.label:after {\n      border-top: $label-corner-triangle-size solid transparent;\n      border-right: $label-corner-triangle-size solid transparent;\n      border-bottom: 0 solid transparent;\n      border-left: 0 solid transparent;\n  \n      border-top-color: inherit;\n    }\n    .ui.left.corner.label .icon {\n      left: $label-corner-icon-left-offset;\n      right: auto;\n    }\n  \n    /* Segment */\n    .ui.segment > .ui.corner.label {\n      top: -1px;\n      right: -1px;\n    }\n    .ui.segment > .ui.left.corner.label {\n      right: auto;\n      left: -1px;\n    }\n  }\n  \n  @if($use-label-type-ribbon) {\n    /*-------------------\n          Ribbon\n    --------------------*/\n  \n    .ui.ribbon.label {\n      position: relative;\n      margin: 0;\n      min-width: max-content;\n      border-radius: 0 $label-border-radius $label-border-radius 0;\n      border-color: $label-ribbon-shadow-color;\n    }\n  \n    .ui.ribbon.label:after {\n      position: absolute;\n      content: '';\n  \n      top: 100%;\n      left: 0;\n      background-color: transparent;\n  \n      border-style: solid;\n      border-width: 0 $label-ribbon-triangle-size $label-ribbon-triangle-size 0;\n      border-color: transparent;\n      border-right-color: inherit;\n  \n      width: 0;\n      height: 0;\n    }\n    /* Positioning */\n    .ui.ribbon.label {\n      left: $label-ribbon-offset;\n      margin-right: -$label-ribbon-triangle-size;\n      padding-left: $label-ribbon-distance;\n      padding-right: $label-ribbon-triangle-size;\n    }\n    .ui[class*=\"right ribbon\"].label {\n      left: $label-right-ribbon-offset;\n      padding-left: $label-ribbon-triangle-size;\n      padding-right: $label-ribbon-distance;\n    }\n    .ui.basic.ribbon.label {\n      padding-top: $label-basic-ribbon-offset;\n      padding-bottom: $label-basic-ribbon-offset;\n    }\n    .ui.basic.ribbon.label:not([class*=\"right ribbon\"]) {\n      padding-left: $label-basic-ribbon-triangle-size-offset;\n      padding-right: $label-basic-ribbon-triangle-size;\n    }\n    .ui.basic[class*=\"right ribbon\"].label {\n      padding-left: $label-basic-ribbon-triangle-size;\n      padding-right: $label-basic-ribbon-triangle-size-offset;\n    }\n    .ui.basic.ribbon.label::after {\n      top: $label-basic-border-full-width-offset;\n    }\n    .ui.basic.ribbon.label:not([class*=\"right ribbon\"])::after {\n      left: $label-basic-border-width-offset;\n    }\n    .ui.basic[class*=\"right ribbon\"].label::after {\n      right: $label-basic-border-width-offset;\n    }\n  \n    /* Right Ribbon */\n    .ui[class*=\"right ribbon\"].label {\n      text-align: left;\n      transform: translateX(-100%);\n      border-radius: $label-border-radius 0 0 $label-border-radius;\n    }\n    .ui[class*=\"right ribbon\"].label:after {\n      left: auto;\n      right: 0;\n  \n      border-style: solid;\n      border-width: $label-ribbon-triangle-size $label-ribbon-triangle-size 0 0;\n      border-color: transparent;\n      border-top-color: inherit;\n    }\n  \n    /* Inside Table */\n    .ui.image > .ribbon.label,\n    .ui.card .image > .ribbon.label {\n      position: absolute;\n      top: $label-ribbon-image-top-distance;\n    }\n    .ui.card .image > .ui.ribbon.label,\n    .ui.image > .ui.ribbon.label {\n      left: $label-ribbon-image-offset;\n    }\n    .ui.card .image > .ui[class*=\"right ribbon\"].label,\n    .ui.image > .ui[class*=\"right ribbon\"].label {\n      left: $label-right-ribbon-image-offset;\n      padding-left: $label-horizontal-padding;\n    }\n  \n    /* Inside Table */\n    .ui.table td > .ui.ribbon.label {\n      left: $label-ribbon-table-offset;\n    }\n    .ui.table td > .ui[class*=\"right ribbon\"].label {\n      left: $label-right-ribbon-table-offset;\n      padding-left: $label-horizontal-padding;\n    }\n  }\n  \n  \n  @if($use-label-type-attached) {\n    /*-------------------\n          Attached\n    --------------------*/\n  \n    .ui[class*=\"top attached\"].label,\n    .ui.attached.label {\n      width: 100%;\n      position: absolute;\n      margin: 0;\n      top: 0;\n      left: 0;\n  \n      padding: $label-attached-vertical-padding $label-attached-horizontal-padding;\n  \n      border-radius: $label-attached-corner-border-radius $label-attached-corner-border-radius 0 0;\n    }\n    .ui[class*=\"bottom attached\"].label {\n      top: auto;\n      bottom: 0;\n      border-radius: 0 0 $label-attached-corner-border-radius $label-attached-corner-border-radius;\n    }\n  \n    .ui[class*=\"top left attached\"].label {\n      width: auto;\n      margin-top: 0 !important;\n      border-radius: $label-attached-corner-border-radius 0 $label-attached-border-radius 0;\n    }\n  \n    .ui[class*=\"top right attached\"].label {\n      width: auto;\n      left: auto;\n      right: 0;\n      border-radius: 0 $label-attached-corner-border-radius 0 $label-attached-border-radius;\n    }\n    .ui[class*=\"bottom left attached\"].label {\n      width: auto;\n      top: auto;\n      bottom: 0;\n      border-radius: 0 $label-attached-border-radius 0 $label-attached-corner-border-radius;\n    }\n    .ui[class*=\"bottom right attached\"].label {\n      top: auto;\n      bottom: 0;\n      left: auto;\n      right: 0;\n      width: auto;\n      border-radius: $label-attached-border-radius 0 $label-attached-corner-border-radius 0;\n    }\n  }\n  \n  /*******************************\n               States\n  *******************************/\n  \n  /*-------------------\n        Disabled\n  --------------------*/\n  \n  .ui.label.disabled {\n    opacity: 0.5;\n  }\n  \n  /*-------------------\n          Hover\n  --------------------*/\n  \n  .ui.labels a.label:hover,\n  a.ui.label:hover {\n    background-color: $label-hover-background-color;\n    border-color: $label-hover-background-color;\n  \n    background-image: $label-hover-background-image;\n    color: $label-hover-text-color;\n  }\n  .ui.labels a.label:hover:before,\n  a.ui.label:hover:before {\n    color: $label-hover-text-color;\n  }\n  \n  /*-------------------\n          Active\n  --------------------*/\n  \n  .ui.active.label {\n    background-color: $label-active-background-color;\n    border-color: $label-active-background-color;\n  \n    background-image: $label-active-background-image;\n    color: $label-active-text-color;\n  }\n  .ui.active.label:before {\n    background-color: $label-active-background-color;\n    background-image: $label-active-background-image;\n    color: $label-active-text-color;\n  }\n  \n  /*-------------------\n       Active Hover\n  --------------------*/\n  \n  .ui.labels a.active.label:hover,\n  a.ui.active.label:hover {\n    background-color: $label-active-hover-background-color;\n    border-color: $label-active-hover-background-color;\n  \n    background-image: $label-active-hover-background-image;\n    color: $label-active-hover-text-color;\n  }\n  .ui.labels a.active.label:hover:before,\n  a.ui.active.label:hover:before {\n    background-color: $label-active-hover-background-color;\n    background-image: $label-active-hover-background-image;\n    color: $label-active-hover-text-color;\n  }\n  \n  \n  /*-------------------\n        Visible\n  --------------------*/\n  \n  .ui.labels.visible .label,\n  .ui.label.visible:not(.dropdown) {\n    display: inline-block !important;\n  }\n  \n  /*-------------------\n        Hidden\n  --------------------*/\n  \n  .ui.labels.hidden .label,\n  .ui.label.hidden {\n    display: none !important;\n  }\n  \n  \n  /*******************************\n             Variations\n  *******************************/\n  \n  \n  @if($use-label-variation-basic) {\n    /*-------------------\n            Basic\n    --------------------*/\n  \n    .ui.basic.labels .label,\n    .ui.basic.label {\n      background: $label-basic-background;\n      border: $label-basic-border;\n      color: $label-basic-color;\n      box-shadow: $label-basic-box-shadow;\n    }\n  \n    /* Link */\n    .ui.basic.labels a.label:hover,\n    a.ui.basic.label:hover {\n      text-decoration: none;\n      background: $label-basic-hover-background;\n      color: $label-basic-hover-color;\n      box-shadow: $label-basic-hover-box-shadow;\n    }\n  }\n  \n  \n  /*-------------------\n         Fluid\n  --------------------*/\n  \n  .ui.label.fluid,\n  .ui.fluid.labels > .label {\n    width: 100%;\n    box-sizing: border-box;\n  }\n  \n  @if($use-label-variation-inverted) {\n    /*-------------------\n          Inverted\n    --------------------*/\n  \n    .ui.inverted.labels .label,\n    .ui.inverted.label {\n      color: $inverted-text-color;\n      background-color: $label-inverted-background-color;\n    }\n    .ui.inverted.corner.label {\n        border-color: $label-inverted-background-color;\n    }\n    .ui.inverted.corner.label:hover {\n        border-color: $label-background-color;\n        transition: none;\n    }\n    .ui.inverted.basic.labels .label,\n    .ui.inverted.basic.label,\n    .ui.inverted.basic.label:hover {\n      border-color: $label-basic-inverted-border-color;\n      background: $black;\n    }\n    .ui.inverted.basic.label:hover {\n      color: $link-color;\n    }\n  }\n  \n  /*-------------------\n         Colors\n  --------------------*/\n  \n  @each $key, $value in $label-colors-map {\n    @if(index(join($main-colors-names, $use-label-variation-colors), $key+'')) {\n      $isDark: map-get($value, isDark);\n      $_labelColor: map-get($value, color);\n      $_labelInvertedColor: map-get($value, light);\n      $_labelTextColor: map-get($value, text);\n      $_labelHover: map-get($value, hover);\n      $_labelInvertedHover: map-get($value, lightHover);\n      $_labelHoverTextColor: map-get($value, hoverText);\n      $_labelRibbonShadow: map-get($value, ribbon);\n      $_labelInvertedRibbonShadow: map-get($value, invertedRibbon);\n  \n      .ui.#{$key + \"\"}.labels .label,\n      .ui.ui.ui.#{$key + \"\"}.label {\n        background-color: $_labelColor;\n        border-color: $_labelColor;\n        color: $_labelTextColor;\n      }\n      /* Link */\n      .ui.#{$key + \"\"}.labels a.label:hover,\n      a.ui.ui.ui.#{$key + \"\"}.label:hover{\n        background-color: $_labelHover;\n        border-color: $_labelHover;\n        color: $_labelHoverTextColor;\n      }\n      /* Ribbon */\n      .ui.ui.ui.#{$key + \"\"}.ribbon.label {\n        border-color: $_labelRibbonShadow;\n      }\n      /* Basic */\n      .ui.basic.labels .#{$key + \"\"}.label,\n      .ui.ui.ui.basic.#{$key + \"\"}.label {\n        background: $label-basic-background;\n        border-color: $_labelColor;\n        color: $_labelColor;\n      }\n      .ui.basic.labels a.#{$key + \"\"}.label:hover,\n      a.ui.ui.ui.basic.#{$key + \"\"}.label:hover {\n        background: $label-basic-background;\n        border-color: $_labelHover;\n        color: $_labelHover;\n      }\n      /* Inverted */\n      .ui.inverted.labels .#{$key + \"\"}.label,\n      .ui.ui.ui.inverted.#{$key + \"\"}.label {\n        background-color: $_labelInvertedColor;\n        border-color: $_labelInvertedColor;\n        color: $black;\n      }\n      /* Inverted Link */\n      .ui.inverted.labels a.#{$key + \"\"}.label:hover,\n      a.ui.ui.ui.inverted.#{$key + \"\"}.label:hover{\n        background-color: $_labelInvertedHover;\n        border-color: $_labelInvertedHover;\n        @if not ($isDark) {\n          color: $black;\n        }\n        @if ($isDark) {\n          color: $_labelTextColor;\n        }\n      }\n      /* Inverted Ribbon */\n      .ui.ui.ui.inverted.#{$key + \"\"}.ribbon.label {\n        border-color: $_labelInvertedRibbonShadow;\n      }\n      /* Inverted Basic */\n      .ui.inverted.basic.labels .#{$key + \"\"}.label,\n      .ui.ui.ui.inverted.basic.#{$key + \"\"}.label {\n        background-color: $label-inverted-background;\n        border-color: $_labelInvertedColor;\n        @if not ($isDark) {\n          color: $_labelInvertedColor;\n        }\n        @if ($isDark) {\n          color: $inverted-text-color;\n        }\n      }\n      .ui.inverted.basic.labels a.#{$key + \"\"}.label:hover,\n      a.ui.ui.ui.inverted.basic.#{$key + \"\"}.label:hover {\n        border-color: $_labelInvertedHover;\n        background-color: $label-inverted-background;\n        @if not ($isDark) {\n          color: $_labelInvertedHover;\n        }\n      }\n      /* Inverted Basic Tags */\n      .ui.inverted.basic.tag.labels .#{$key + \"\"}.label,\n      .ui.ui.ui.inverted.#{$key + \"\"}.basic.tag.label {\n        border: $label-inverted-border-size solid $_labelInvertedColor;\n      }\n      .ui.inverted.basic.tag.labels .#{$key + \"\"}.label:before,\n      .ui.ui.ui.inverted.#{$key + \"\"}.basic.tag.label:before {\n        border-color: inherit;\n        border-width: $label-inverted-border-size 0 0 $label-inverted-border-size;\n        border-style: inherit;\n        background-color: $label-inverted-background;\n        right: calc(100% + #{$label-inverted-border-size});\n      }\n    }\n  }\n  \n  @if($use-label-type-horizontal){\n    /*-------------------\n        Horizontal\n    --------------------*/\n  \n    .ui.horizontal.labels .label,\n    .ui.horizontal.label {\n      margin: 0 $label-in-horizontal-position-margin 0 0;\n  \n      padding: $label-horizontal-vertical-padding $label-horizontal-padding;\n      min-width: $label-horizontal-min-width;\n      text-align: center;\n    }\n  }\n  \n  @if($use-label-variation-circular) {\n    /*-------------------\n          Circular\n    --------------------*/\n  \n    .ui.circular.labels .label,\n    .ui.circular.label {\n      min-width: $label-circular-min-size;\n      min-height: $label-circular-min-size;\n  \n      padding: $label-circular-padding !important;\n  \n      line-height: 1em;\n      text-align: center;\n      border-radius: $circular-radius;\n    }\n    .ui.empty.circular.labels .label,\n    .ui.empty.circular.label {\n      min-width: 0;\n      min-height: 0;\n      overflow: hidden;\n      width: $label-empty-circle-size;\n      height: $label-empty-circle-size;\n      vertical-align: baseline;\n    }\n  }\n  \n  @if($use-label-type-pointing) {\n    /*-------------------\n          Pointing\n    --------------------*/\n  \n    .ui.pointing.label {\n      position: relative;\n    }\n  \n    .ui.attached.pointing.label {\n      position: absolute;\n    }\n  \n    .ui.pointing.label:before {\n      background-color: inherit;\n      background-image: inherit;\n      border-width: 0;\n      border-style: solid;\n      border-color: $label-pointing-border-color;\n    }\n    /* Arrow */\n    .ui.pointing.label:before {\n      position: absolute;\n      content: '';\n      transform: rotate(45deg);\n      background-image: none;\n  \n      z-index: $label-pointing-triangle-z-index;\n      width: $label-pointing-triangle-size;\n      height: $label-pointing-triangle-size;\n      transition: $label-pointing-triangle-transition;\n    }\n  \n    /*--- Above ---*/\n    .ui.pointing.label,\n    .ui[class*=\"pointing above\"].label {\n      margin-top: $label-pointing-vertical-distance;\n    }\n    .ui.pointing.label:before,\n    .ui[class*=\"pointing above\"].label:before {\n      border-width: $label-border-width 0 0 $label-border-width;\n      transform: translateX(-50%) translateY(-50%) rotate(45deg);\n      top: 0;\n      left: 50%;\n    }\n    /*--- Below ---*/\n    .ui[class*=\"bottom pointing\"].label,\n    .ui[class*=\"pointing below\"].label {\n      margin-top: 0;\n      margin-bottom: $label-pointing-vertical-distance;\n    }\n    .ui[class*=\"bottom pointing\"].label:before,\n    .ui[class*=\"pointing below\"].label:before {\n      border-width: 0 $label-border-width $label-border-width 0;\n      top: auto;\n      right: auto;\n      transform: translateX(-50%) translateY(-50%) rotate(45deg);\n      top: 100%;\n      left: 50%;\n    }\n    /*--- Left ---*/\n    .ui[class*=\"left pointing\"].label {\n      margin-top: 0;\n      margin-left: $label-pointing-horizontal-distance;\n    }\n    .ui[class*=\"left pointing\"].label:before {\n      border-width: 0 0 $label-border-width $label-border-width;\n      transform: translateX(-50%) translateY(-50%) rotate(45deg);\n      bottom: auto;\n      right: auto;\n      top: 50%;\n      left: 0;\n    }\n    /*--- Right ---*/\n    .ui[class*=\"right pointing\"].label {\n      margin-top: 0;\n      margin-right: $label-pointing-horizontal-distance;\n    }\n    .ui[class*=\"right pointing\"].label:before {\n      border-width: $label-border-width $label-border-width 0 0;\n      transform: translateX(50%) translateY(-50%) rotate(45deg);\n      top: 50%;\n      right: 0;\n      bottom: auto;\n      left: auto;\n    }\n  }\n  \n  \n  @if($use-label-variation-basic-pointing) {\n    /* Basic Pointing */\n  \n    /* Pointing */\n    .ui.basic.pointing.label:before {\n      border-color: inherit;\n    }\n  \n    /*--- Above ---*/\n    .ui.basic.pointing.label:before,\n    .ui.basic[class*=\"pointing above\"].label:before {\n      margin-top: $label-basic-pointing-triangle-offset;\n    }\n    /*--- Below ---*/\n    .ui.basic[class*=\"bottom pointing\"].label:before,\n    .ui.basic[class*=\"pointing below\"].label:before {\n      bottom: auto;\n      top: 100%;\n      margin-top: -$label-basic-pointing-triangle-offset;\n    }\n    /*--- Left ---*/\n    .ui.basic[class*=\"left pointing\"].label:before {\n      top: 50%;\n      left: $label-basic-pointing-triangle-offset;\n    }\n    /*--- Right ---*/\n    .ui.basic[class*=\"right pointing\"].label:before {\n      top: 50%;\n      right: $label-basic-pointing-triangle-offset;\n    }\n  }\n  \n  \n  @if($use-label-type-floating) {\n    /*------------------\n      Floating Label\n    -------------------*/\n  \n    .ui.floating.label {\n      position: absolute;\n      z-index: $label-floating-z-index;\n      top: $label-floating-top-offset;\n      right: 0;\n      white-space: nowrap;\n      transform: translateX(50%);\n    }\n    .ui.right.aligned.floating.label {\n      transform: translateX($label-floating-align-offset);\n    }\n    .ui.left.floating.label {\n      left:0;\n      right:auto;\n      transform: translateX(-50%);\n    }\n    .ui.left.aligned.floating.label {\n      transform: translateX(-$label-floating-align-offset);\n    }\n    .ui.bottom.floating.label {\n      top: auto;\n      bottom: $label-floating-bottom-offset;\n    }\n  }\n  \n  /*-------------------\n          Sizes\n  --------------------*/\n  \n  .ui.mini.labels .label,\n  .ui.mini.label {\n    font-size: $label-mini;\n  }\n  .ui.tiny.labels .label,\n  .ui.tiny.label {\n    font-size: $label-tiny;\n  }\n  .ui.small.labels .label,\n  .ui.small.label {\n    font-size: $label-small;\n  }\n  .ui.labels .label,\n  .ui.label {\n    font-size: $label-medium;\n  }\n  .ui.large.labels .label,\n  .ui.large.label {\n    font-size: $label-large;\n  }\n  .ui.big.labels .label,\n  .ui.big.label {\n    font-size: $label-big;\n  }\n  .ui.huge.labels .label,\n  .ui.huge.label {\n    font-size: $label-huge;\n  }\n  .ui.massive.labels .label,\n  .ui.massive.label {\n    font-size: $label-massive;\n  }\n}\n\n@import '../../themes/default/elements/label.style';","@import '../../themes/default/elements/list.variables';\n@if $use-list {\n  /*******************************\n  //@-        List\n  *******************************/\n\n  ul.ui.list,\n  ol.ui.list,\n  .ui.list {\n    list-style-type: $list-style-type;\n    margin: $list-margin;\n    padding: $list-vertical-padding $list-horizontal-padding;\n  }\n\n  ul.ui.list:first-child,\n  ol.ui.list:first-child,\n  .ui.list:first-child {\n    margin-top: 0;\n    padding-top: 0;\n  }\n\n  ul.ui.list:last-child,\n  ol.ui.list:last-child,\n  .ui.list:last-child {\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n\n  /*******************************\n              Content\n  *******************************/\n\n  /* List Item */\n  ul.ui.list li,\n  ol.ui.list li,\n  .ui.list > .item,\n  .ui.list .list > .item {\n    display: list-item;\n    table-layout: fixed;\n    list-style-type: $list-style-type;\n    list-style-position: $list-style-position;\n\n    padding: $list-item-padding;\n    line-height: $list-item-line-height;\n  }\n\n  ul.ui.list > li:first-child:after,\n  ol.ui.list > li:first-child:after,\n  .ui.list > .list > .item:after,\n  .ui.list > .item:after {\n    content: '';\n    display: block;\n    height: 0;\n    clear: both;\n    visibility: hidden;\n  }\n\n  ul.ui.list li:first-child,\n  ol.ui.list li:first-child,\n  .ui.list .list > .item:first-child,\n  .ui.list > .item:first-child {\n    padding-top: 0;\n  }\n  ul.ui.list li:last-child,\n  ol.ui.list li:last-child,\n  .ui.list .list > .item:last-child,\n  .ui.list > .item:last-child {\n    padding-bottom: 0;\n  }\n\n  /* Child List */\n  ul.ui.list ul,\n  ol.ui.list ol,\n  .ui.list .list:not(.icon) {\n    clear: both;\n    margin: 0;\n    padding: $list-child-padding;\n  }\n\n  /* Child Item */\n  ul.ui.list ul li,\n  ol.ui.list ol li,\n  .ui.list .list > .item {\n    padding: $list-child-item-padding;\n    line-height: $list-child-item-line-height;\n  }\n\n\n  /* Icon */\n  .ui.list .list > .item > i.icon,\n  .ui.list > .item > i.icon {\n    display: table-cell;\n    min-width: 1.55em;\n    margin: 0;\n    padding-top: $list-icon-offset;\n    transition: $list-icon-transition;\n    &:not(.loading) {\n      padding-right: $list-icon-distance;\n      vertical-align: $list-icon-content-vertical-align;\n    }\n  }\n  .ui.list .list > .item > i.icon:only-child,\n  .ui.list > .item > i.icon:only-child {\n    display: inline-block;\n    min-width: auto;\n    vertical-align: $list-icon-vertical-align;\n  }\n\n\n  /* Image */\n  .ui.list .list > .item > .image,\n  .ui.list > .item > .image {\n    display: table-cell;\n    background-color: transparent;\n    margin: 0;\n    vertical-align: $list-image-align;\n  }\n  .ui.list .list > .item > .image:not(:only-child):not(img),\n  .ui.list > .item > .image:not(:only-child):not(img) {\n    padding-right: $list-image-distance;\n  }\n  .ui.list .list > .item > .image img,\n  .ui.list > .item > .image img {\n    vertical-align: $list-image-align;\n  }\n\n  .ui.list .list > .item > img.image,\n  .ui.list .list > .item > .image:only-child,\n  .ui.list > .item > img.image,\n  .ui.list > .item > .image:only-child {\n    display: inline-block;\n  }\n\n  /* Content */\n  .ui.list .list > .item > .content,\n  .ui.list > .item > .content {\n    line-height: $list-content-line-height;\n    color: $list-content-color;\n  }\n  .ui.list .list > .item > .image + .content,\n  .ui.list .list > .item > .icon + .content,\n  .ui.list > .item > .image + .content,\n  .ui.list > .item > .icon + .content {\n    display: table-cell;\n    width: 100%;\n    padding: 0 0 0 $list-content-distance;\n    vertical-align: $list-content-vertical-align;\n  }\n  .ui.list .list > .item > .loading.icon + .content,\n  .ui.list > .item > .loading.icon + .content {\n    padding-left:  calc(#{$list-icon-distance} + #{$list-content-distance});\n  }\n  .ui.list .list > .item > img.image + .content,\n  .ui.list > .item > img.image + .content {\n    display: inline-block;\n    width: auto;\n  }\n  .ui.list .list > .item > .content > .list,\n  .ui.list > .item > .content > .list {\n    margin-left: 0;\n    padding-left: 0;\n  }\n\n  /* Header */\n  .ui.list .list > .item .header,\n  .ui.list > .item .header {\n    display: block;\n    margin: 0;\n    font-family: $list-item-header-font-family;\n    font-weight: $list-item-header-font-weight;\n    color: $list-item-header-color;\n  }\n\n  /* Description */\n  .ui.list .list > .item .description,\n  .ui.list > .item .description {\n    display: block;\n    color: $list-item-description-color;\n  }\n\n  /* Child Link */\n  .ui.list > .item a,\n  .ui.list .list > .item a {\n    cursor: pointer;\n  }\n\n  /* Linking Item */\n  .ui.list .list > a.item,\n  .ui.list > a.item {\n    cursor: pointer;\n    color: $list-item-link-color;\n  }\n  .ui.list .list > a.item:hover,\n  .ui.list > a.item:hover {\n    color: $list-item-link-hover-color;\n  }\n\n  /* Linked Item Icons */\n  .ui.list .list > a.item > i.icon,\n  .ui.list > a.item > i.icon {\n    color: $list-item-link-icon-color;\n  }\n\n  /* Header Link */\n  .ui.list .list > .item a.header,\n  .ui.list > .item a.header {\n    cursor: pointer;\n    color: $list-item-header-link-color !important;\n  }\n  .ui.list .list > .item > a.header:hover,\n  .ui.list > .item > a.header:hover {\n    color: $list-item-header-link-hover-color !important;\n  }\n\n  /* Floated Content */\n  .ui[class*=\"left floated\"].list {\n    float: left;\n  }\n  .ui[class*=\"right floated\"].list {\n    float: right;\n  }\n\n  .ui.list .list > .item [class*=\"left floated\"],\n  .ui.list > .item [class*=\"left floated\"] {\n    float: left;\n    margin: $list-left-float-margin;\n  }\n  .ui.list .list > .item [class*=\"right floated\"],\n  .ui.list > .item [class*=\"right floated\"] {\n    float: right;\n    margin: $list-right-float-margin;\n  }\n\n  /*******************************\n              Coupling\n  *******************************/\n\n  .ui.menu .ui.list > .item,\n  .ui.menu .ui.list .list > .item {\n    display: list-item;\n    table-layout: fixed;\n    background-color: transparent;\n\n    list-style-type: $list-style-type;\n    list-style-position: $list-style-position;\n\n    padding: $list-item-vertical-padding $list-item-horizontal-padding;\n    line-height: $list-item-line-height;\n  }\n  .ui.menu .ui.list .list > .item:before,\n  .ui.menu .ui.list > .item:before {\n    border: none;\n    background: none;\n  }\n  .ui.menu .ui.list .list > .item:first-child,\n  .ui.menu .ui.list > .item:first-child {\n    padding-top: 0;\n  }\n  .ui.menu .ui.list .list > .item:last-child,\n  .ui.menu .ui.list > .item:last-child {\n    padding-bottom: 0;\n  }\n\n\n  /*******************************\n              Types\n  *******************************/\n\n  @if($use-list-variation-horizontal) {\n    /*-------------------\n          Horizontal\n    --------------------*/\n\n    .ui.horizontal.list {\n      display: inline-block;\n      font-size: 0;\n    }\n    .ui.horizontal.list > .item {\n      display: inline-block;\n      margin-right: $list-horizontal-spacing;\n      font-size: 1rem;\n    }\n    .ui.horizontal.list:not(.celled) > .item:last-child {\n      margin-right: 0;\n      padding-right: 0;\n    }\n    .ui.horizontal.list .list:not(.icon) {\n      padding-left: 0;\n      padding-bottom: 0;\n    }\n\n    .ui.horizontal.list > .item > .image,\n    .ui.horizontal.list .list > .item > .image,\n    .ui.horizontal.list > .item > .icon,\n    .ui.horizontal.list .list > .item > .icon,\n    .ui.horizontal.list > .item > .content,\n    .ui.horizontal.list .list > .item > .content {\n      vertical-align: $list-horizontal-vertical-align;\n    }\n\n    /* Padding on all elements */\n    .ui.horizontal.list > .item:first-child,\n    .ui.horizontal.list > .item:last-child {\n      padding-top: $list-item-vertical-padding;\n      padding-bottom: $list-item-vertical-padding;\n    }\n\n    /* Horizontal List */\n    .ui.horizontal.list > .item > i.icon {\n      margin: 0;\n      padding: 0 $list-horizontal-icon-distance 0 0;\n    }\n    .ui.horizontal.list > .item > .image + .content,\n    .ui.horizontal.list > .item > .icon,\n    .ui.horizontal.list > .item > .icon + .content {\n      float: none;\n      display: inline-block;\n      width: auto;\n    }\n    .ui.horizontal.list > .item > .image {\n      display:inline-block;\n    }\n  }\n  /*******************************\n              States\n  *******************************/\n\n  /*-------------------\n        Disabled\n  --------------------*/\n\n  .ui.list .list > .disabled.item,\n  .ui.list > .disabled.item {\n    pointer-events: none;\n    color: $list-disabled-color !important;\n  }\n  .ui.inverted.list .list > .disabled.item,\n  .ui.inverted.list > .disabled.item {\n    color: $list-inverted-disabled-color !important;\n  }\n\n  /*-------------------\n          Hover\n  --------------------*/\n\n  .ui.list .list > a.item:hover > .icon,\n  .ui.list > a.item:hover > .icon {\n    color: $list-item-link-icon-hover-color;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  @if($use-list-variation-inverted) {\n    /*-------------------\n          Inverted\n    --------------------*/\n\n    .ui.inverted.list .list > a.item > .icon,\n    .ui.inverted.list > a.item > .icon {\n      color: $list-inverted-icon-link-color;\n    }\n    .ui.inverted.list .list > .item .header,\n    .ui.inverted.list > .item .header {\n      color: $list-inverted-header-color;\n    }\n    .ui.inverted.list .list > .item .description,\n    .ui.inverted.list > .item .description {\n      color: $list-inverted-description-color;\n    }\n    .ui.inverted.list .list > .item > .content,\n    .ui.inverted.list > .item > .content {\n      color: $list-inverted-content-color;\n    }\n    /* Item Link */\n    .ui.inverted.list .list > a.item,\n    .ui.inverted.list > a.item {\n      cursor: pointer;\n      color: $list-inverted-item-link-color;\n    }\n    .ui.inverted.list .list > a.item:hover,\n    .ui.inverted.list > a.item:hover {\n      color: $list-inverted-item-link-hover-color;\n    }\n\n\n    /* Linking Content */\n    .ui.inverted.list .item a:not(.ui) {\n      color: $list-inverted-item-link-color !important;\n    }\n    .ui.inverted.list .item a:not(.ui):hover {\n      color: $list-inverted-item-link-hover-color !important;\n    }\n  }\n\n  /*-------------------\n        Aligned\n  --------------------*/\n\n  .ui.list[class*=\"top aligned\"] .image,\n  .ui.list[class*=\"top aligned\"] .content,\n  .ui.list [class*=\"top aligned\"] {\n    vertical-align: top !important;\n  }\n  .ui.list[class*=\"middle aligned\"] .image,\n  .ui.list[class*=\"middle aligned\"] .content,\n  .ui.list [class*=\"middle aligned\"] {\n    vertical-align: middle !important;\n  }\n  .ui.list[class*=\"bottom aligned\"] .image,\n  .ui.list[class*=\"bottom aligned\"] .content,\n  .ui.list [class*=\"bottom aligned\"] {\n    vertical-align: bottom !important;\n  }\n\n  /*-------------------\n        Link\n  --------------------*/\n\n  .ui.link.list .item,\n  .ui.link.list a.item,\n  .ui.link.list .item a:not(.ui) {\n    color: $list-link-item-color;\n    transition: $list-link-transition;\n  }\n  .ui.link.list.list a.item:hover,\n  .ui.link.list.list .item a:not(.ui):hover {\n    color: $list-link-item-hover-color;\n  }\n  .ui.link.list.list a.item:active,\n  .ui.link.list.list .item a:not(.ui):active {\n    color: $list-link-item-down-color;\n  }\n  .ui.link.list.list .active.item,\n  .ui.link.list.list .active.item a:not(.ui) {\n    color: $list-link-item-active-color;\n  }\n\n  @if($use-list-variation-inverted) {\n    /* Inverted */\n    .ui.inverted.link.list .item,\n    .ui.inverted.link.list a.item,\n    .ui.inverted.link.list .item a:not(.ui) {\n      color: $list-inverted-link-item-color;\n    }\n    .ui.inverted.link.list.list a.item:hover,\n    .ui.inverted.link.list.list .item a:not(.ui):hover {\n      color: $list-inverted-link-item-hover-color;\n    }\n    .ui.inverted.link.list.list a.item:active,\n    .ui.inverted.link.list.list .item a:not(.ui):active {\n      color: $list-inverted-link-item-down-color;\n    }\n    .ui.inverted.link.list.list a.active.item,\n    .ui.inverted.link.list.list .active.item a:not(.ui) {\n      color: $list-inverted-link-item-active-color;\n    }\n  }\n\n\n  @if($use-list-variation-selection) {\n    /*-------------------\n          Selection\n    --------------------*/\n\n    .ui.selection.list .list > .item,\n    .ui.selection.list > .item {\n      cursor: pointer;\n      background: $list-selection-background;\n      padding: $list-selection-item-vertical-padding $list-selection-item-horizontal-padding;\n      margin: $list-selection-item-margin;\n      color: $list-selection-color;\n      border-radius: $list-selection-item-border-radius;\n      transition: $list-selection-transition;\n    }\n    .ui.selection.list .list > .item:last-child,\n    .ui.selection.list > .item:last-child {\n      margin-bottom: 0;\n    }\n    .ui.selection.list .list > .item:hover,\n    .ui.selection.list > .item:hover {\n      background: $list-selection-hover-background;\n      color: $list-selection-hover-color;\n    }\n    .ui.selection.list .list > .item:active,\n    .ui.selection.list > .item:active {\n      background: $list-selection-down-background;\n      color: $list-selection-down-color;\n    }\n    .ui.selection.list .list > .item.active,\n    .ui.selection.list > .item.active {\n      background: $list-selection-active-background;\n      color: $list-selection-active-color;\n    }\n\n    @if($use-list-variation-inverted) {\n      /* Inverted */\n      .ui.inverted.selection.list > .item {\n        background: $list-inverted-selection-background;\n        color: $list-inverted-selection-color;\n      }\n      .ui.inverted.selection.list > .item:hover {\n        background: $list-inverted-selection-hover-background;\n        color: $list-inverted-selection-hover-color;\n      }\n      .ui.inverted.selection.list > .item:active {\n        background: $list-inverted-selection-down-background;\n        color: $list-inverted-selection-down-color;\n      }\n      .ui.inverted.selection.list > .item.active {\n        background: $list-inverted-selection-active-background;\n        color: $list-inverted-selection-active-color;\n      }\n    }\n  }\n\n  /* Celled / Divided Selection List */\n  .ui.celled.selection.list .list > .item,\n  .ui.divided.selection.list .list > .item,\n  .ui.celled.selection.list > .item,\n  .ui.divided.selection.list > .item {\n    border-radius: 0;\n  }\n\n  /*-------------------\n        Animated\n  --------------------*/\n\n  .ui.animated.list > .item {\n    transition: $list-animated-transition;\n  }\n  .ui.animated.list:not(.horizontal) > .item:hover {\n    padding-left: $list-animated-indent;\n  }\n\n  /*-------------------\n        Fitted\n  --------------------*/\n  .ui.fitted.list:not(.selection) .list > .item,\n  .ui.fitted.list:not(.selection) > .item {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .ui.fitted.selection.list .list > .item,\n  .ui.fitted.selection.list > .item {\n    margin-left: -$list-selection-item-horizontal-padding;\n    margin-right: -$list-selection-item-horizontal-padding;\n  }\n\n\n  @if($use-list-type-bulleted) {\n    /*-------------------\n          Bulleted\n    --------------------*/\n\n    ul.ui.list,\n    .ui.bulleted.list {\n      margin-left: $list-bullet-distance;\n    }\n    ul.ui.list li,\n    .ui.bulleted.list .list > .item,\n    .ui.bulleted.list > .item {\n      position: relative;\n    }\n    ul.ui.list li:before,\n    .ui.bulleted.list .list > .item:before,\n    .ui.bulleted.list > .item:before {\n      user-select: none;\n      pointer-events: none;\n      position: absolute;\n      top: auto;\n      left: auto;\n      font-weight: $normal;\n      margin-left: $list-bullet-offset;\n      content: $list-bullet-character;\n      opacity: $list-bullet-opacity;\n      color: $list-bullet-color;\n      vertical-align: $list-bullet-vertical-align;\n    }\n\n    ul.ui.list li:before,\n    .ui.bulleted.list .list > a.item:before,\n    .ui.bulleted.list > a.item:before {\n      color: $list-bullet-link-color;\n    }\n\n    ul.ui.list ul,\n    .ui.bulleted.list .list:not(.icon) {\n      padding-left: $list-bullet-child-distance;\n    }\n\n    /* Horizontal Bulleted */\n    ul.ui.horizontal.bulleted.list,\n    .ui.horizontal.bulleted.list {\n      margin-left: 0;\n    }\n    ul.ui.horizontal.bulleted.list li,\n    .ui.horizontal.bulleted.list > .item {\n      margin-left: $list-horizontal-bullet-spacing;\n    }\n    ul.ui.horizontal.bulleted.list li:first-child,\n    .ui.horizontal.bulleted.list > .item:first-child {\n      margin-left: 0;\n    }\n    ul.ui.horizontal.bulleted.list li::before,\n    .ui.horizontal.bulleted.list > .item::before {\n      color: $list-horizontal-bullet-color;\n    }\n    ul.ui.horizontal.bulleted.list li:first-child::before,\n    .ui.horizontal.bulleted.list > .item:first-child::before {\n      display: none;\n    }\n  }\n\n  @if($use-list-type-ordered) {\n    /*-------------------\n          Ordered\n    --------------------*/\n\n    ol.ui.list,\n    .ui.ordered.list,\n    .ui.ordered.list .list:not(.icon),\n    ol.ui.list ol {\n      counter-reset: ordered;\n      margin-left: $list-ordered-count-distance;\n      list-style-type: none;\n    }\n    ol.ui.list li,\n    .ui.ordered.list .list > .item,\n    .ui.ordered.list > .item {\n      list-style-type: none;\n      position: relative;\n    }\n    ol.ui.list li:before,\n    .ui.ordered.list .list > .item:before,\n    .ui.ordered.list > .item:before {\n      position: absolute;\n      top: auto;\n      left: auto;\n      user-select: none;\n      pointer-events: none;\n      margin-left: -($list-ordered-count-distance);\n      counter-increment: $list-ordered-count-name;\n      content: $list-ordered-count-content;\n      text-align: $list-ordered-count-text-align;\n      color: $list-ordered-count-color;\n      vertical-align: $list-ordered-count-vertical-align;\n      opacity: $list-ordered-count-opacity;\n    }\n\n    ol.ui.inverted.list li:before,\n    .ui.ordered.inverted.list .list > .item:before,\n    .ui.ordered.inverted.list > .item:before {\n      color: $list-ordered-inverted-count-color;\n    }\n\n    /* Value */\n    .ui.ordered.list .list > .item[data-value]:before,\n    .ui.ordered.list > .item[data-value]:before {\n      content: attr(data-value);\n    }\n    ol.ui.list li[value]:before {\n      content: attr(value);\n    }\n\n    /* Child Lists */\n    ol.ui.list ol,\n    .ui.ordered.list .list:not(.icon) {\n      margin-left: $list-ordered-child-count-distance;\n    }\n    ol.ui.list ol li:before,\n    .ui.ordered.list .list > .item:before {\n      margin-left: $list-ordered-child-count-offset;\n    }\n\n    @if($use-list-variation-horizontal) {\n      /* Horizontal Ordered */\n      ol.ui.horizontal.list,\n      .ui.ordered.horizontal.list {\n        margin-left: 0;\n      }\n      ol.ui.horizontal.list li:before,\n      .ui.ordered.horizontal.list .list > .item:before,\n      .ui.ordered.horizontal.list > .item:before {\n        position: static;\n        margin: 0 $list-horizontal-ordered-count-distance 0 0;\n      }\n    }\n\n    /* Suffixed Ordered */\n    ol.ui.suffixed.list li:before,\n    .ui.suffixed.ordered.list .list > .item:before,\n    .ui.suffixed.ordered.list > .item:before {\n      content: $list-ordered-count-content-suffixed;\n    }\n  }\n\n\n  @if($use-list-variation-divided) {\n    /*-------------------\n          Divided\n    --------------------*/\n\n    .ui.divided.list > .item {\n      border-top: $list-divided-border;\n    }\n    .ui.divided.list .list > .item {\n      border-top: $list-divided-child-border;\n    }\n    .ui.divided.list .item .list > .item {\n      border-top: $list-divided-child-item-border;\n    }\n    .ui.divided.list .list > .item:first-child,\n    .ui.divided.list > .item:first-child {\n      border-top: none;\n    }\n\n    /* Sub Menu */\n    .ui.divided.list:not(.horizontal) .list > .item:first-child {\n      border-top-width: $list-divided-border-width;\n    }\n\n    /* Divided bulleted */\n    .ui.divided.bulleted.list:not(.horizontal),\n    .ui.divided.bulleted.list .list:not(.icon) {\n      margin-left: 0;\n      padding-left: 0;\n    }\n    .ui.divided.bulleted.list > .item:not(.horizontal) {\n      padding-left: $list-bullet-distance;\n    }\n\n    /* Divided Ordered */\n    .ui.divided.ordered.list {\n      margin-left: 0;\n    }\n    .ui.divided.ordered.list .list > .item,\n    .ui.divided.ordered.list > .item {\n      padding-left: $list-ordered-count-distance;\n    }\n    .ui.divided.ordered.list .item .list:not(.icon) {\n      margin-left: 0;\n      margin-right: 0;\n      padding-bottom: $list-item-vertical-padding;\n    }\n    .ui.divided.ordered.list .item .list > .item {\n      padding-left: $list-ordered-child-count-distance;\n    }\n\n    /* Divided Selection */\n    .ui.divided.selection.list .list > .item,\n    .ui.divided.selection.list > .item {\n      margin: 0;\n      border-radius: 0;\n    }\n\n    @if($use-list-variation-horizontal) {\n      /* Divided horizontal */\n      .ui.divided.horizontal.list {\n        margin-left: 0;\n      }\n      .ui.divided.horizontal.list > .item {\n        padding-left: $list-horizontal-divided-spacing;\n      }\n      .ui.divided.horizontal.list > .item:not(:last-child) {\n        padding-right: $list-horizontal-divided-spacing;\n      }\n      .ui.divided.horizontal.list > .item {\n        border-top: none;\n        border-right: $list-divided-border;\n        margin: 0;\n        line-height: $list-horizontal-divided-line-height;\n      }\n      .ui.horizontal.divided.list > .item:last-child {\n        border-right: none;\n      }\n    }\n\n    @if($use-list-variation-inverted) {\n      /* Inverted */\n      .ui.divided.inverted.list > .item,\n      .ui.divided.inverted.list > .list,\n      .ui.divided.inverted.horizontal.list > .item {\n        border-color: $list-divided-inverted-border-color;\n      }\n    }\n  }\n\n\n  @if($use-list-variation-celled) {\n    /*-------------------\n            Celled\n    --------------------*/\n\n    .ui.celled.list > .item,\n    .ui.celled.list > .list {\n      border-top: $list-celled-border;\n      padding-left: $list-celled-horizontal-padding;\n      padding-right: $list-celled-horizontal-padding;\n    }\n    .ui.celled.list > .item:last-child {\n      border-bottom: $list-celled-border;\n    }\n\n    /* Padding on all elements */\n    .ui.celled.list > .item:first-child,\n    .ui.celled.list > .item:last-child {\n      padding-top: $list-item-vertical-padding;\n      padding-bottom: $list-item-vertical-padding;\n    }\n\n    /* Sub Menu */\n    .ui.celled.list .item .list > .item {\n      border-width: 0;\n    }\n    .ui.celled.list .list > .item:first-child {\n      border-top-width: 0;\n    }\n\n    @if($use-list-type-bulleted) {\n      /* Celled Bulleted */\n      .ui.celled.bulleted.list {\n        margin-left: 0;\n      }\n      .ui.celled.bulleted.list .list > .item,\n      .ui.celled.bulleted.list > .item {\n        padding-left: ($list-bullet-distance);\n      }\n      .ui.celled.bulleted.list .item .list:not(.icon) {\n        margin-left: -($list-bullet-distance);\n        margin-right: -($list-bullet-distance);\n        padding-bottom: $list-item-vertical-padding;\n      }\n    }\n\n    @if($use-list-type-ordered) {\n      /* Celled Ordered */\n      .ui.celled.ordered.list {\n        margin-left: 0;\n      }\n      .ui.celled.ordered.list .list > .item,\n      .ui.celled.ordered.list > .item {\n        padding-left: $list-ordered-count-distance;\n      }\n      .ui.celled.ordered.list .item .list:not(.icon) {\n        margin-left: 0;\n        margin-right: 0;\n        padding-bottom: $list-item-vertical-padding;\n      }\n      .ui.celled.ordered.list .list > .item {\n        padding-left: $list-ordered-child-count-distance;\n      }\n    }\n\n    @if($use-list-variation-horizontal) {\n      /* Celled Horizontal */\n      .ui.horizontal.celled.list {\n        margin-left: 0;\n      }\n      .ui.horizontal.celled.list .list > .item,\n      .ui.horizontal.celled.list > .item {\n        border-top: none;\n        border-left: $list-celled-border;\n        margin: 0;\n        padding-left: $list-horizontal-celled-spacing;\n        padding-right: $list-horizontal-celled-spacing;\n\n        line-height: $list-horizontal-celled-line-height;\n      }\n      .ui.horizontal.celled.list .list > .item:last-child,\n      .ui.horizontal.celled.list > .item:last-child {\n        border-bottom: none;\n        border-right: $list-celled-border;\n      }\n    }\n\n    @if($use-list-variation-inverted) {\n      /* Inverted */\n      .ui.celled.inverted.list > .item,\n      .ui.celled.inverted.list > .list {\n        border-color: $list-celled-inverted-border;\n      }\n      .ui.celled.inverted.horizontal.list .list > .item,\n      .ui.celled.inverted.horizontal.list > .item {\n        border-color: $list-celled-inverted-border;\n      }\n    }\n  }\n\n\n  @if($use-list-variation-relaxed) {\n    /*-------------------\n          Relaxed\n    --------------------*/\n\n    .ui.relaxed.list:not(.horizontal) > .item:not(:first-child) {\n      padding-top: $list-relaxed-item-vertical-padding;\n    }\n    .ui.relaxed.list:not(.horizontal) > .item:not(:last-child) {\n      padding-bottom: $list-relaxed-item-vertical-padding;\n    }\n    .ui.horizontal.relaxed.list .list > .item:not(:first-child),\n    .ui.horizontal.relaxed.list > .item:not(:first-child) {\n      padding-left: $list-relaxed-horizontal-padding;\n    }\n    .ui.horizontal.relaxed.list .list > .item:not(:last-child),\n    .ui.horizontal.relaxed.list > .item:not(:last-child) {\n      padding-right: $list-relaxed-horizontal-padding;\n    }\n\n    /* Very Relaxed */\n    .ui[class*=\"very relaxed\"].list:not(.horizontal) > .item:not(:first-child) {\n      padding-top: $list-very-relaxed-item-vertical-padding;\n    }\n    .ui[class*=\"very relaxed\"].list:not(.horizontal) > .item:not(:last-child) {\n      padding-bottom: $list-very-relaxed-item-vertical-padding;\n    }\n    .ui.horizontal[class*=\"very relaxed\"].list .list > .item:not(:first-child),\n    .ui.horizontal[class*=\"very relaxed\"].list > .item:not(:first-child) {\n      padding-left: $list-very-relaxed-horizontal-padding;\n    }\n    .ui.horizontal[class*=\"very relaxed\"].list .list > .item:not(:last-child),\n    .ui.horizontal[class*=\"very relaxed\"].list > .item:not(:last-child) {\n      padding-right: $list-very-relaxed-horizontal-padding;\n    }\n  }\n  /*-------------------\n        Sizes\n  --------------------*/\n\n  .ui.mini.list {\n    font-size: $relative-mini;\n  }\n  .ui.tiny.list {\n    font-size: $relative-tiny;\n  }\n  .ui.small.list {\n    font-size: $relative-small;\n  }\n  .ui.list {\n    font-size: $relative-medium;\n  }\n  .ui.large.list {\n    font-size: $relative-large;\n  }\n  .ui.big.list {\n    font-size: $relative-big;\n  }\n  .ui.huge.list {\n    font-size: $relative-huge;\n  }\n  .ui.massive.list {\n    font-size: $relative-massive;\n  }\n\n  .ui.mini.horizontal.list .list > .item,\n  .ui.mini.horizontal.list > .item {\n    font-size: $mini;\n  }\n  .ui.tiny.horizontal.list .list > .item,\n  .ui.tiny.horizontal.list > .item {\n    font-size: $tiny;\n  }\n  .ui.small.horizontal.list .list > .item,\n  .ui.small.horizontal.list > .item {\n    font-size: $small;\n  }\n  .ui.horizontal.list .list > .item,\n  .ui.horizontal.list > .item {\n    font-size: $medium;\n  }\n  .ui.large.horizontal.list .list > .item,\n  .ui.large.horizontal.list > .item {\n    font-size: $large;\n  }\n  .ui.big.horizontal.list .list > .item,\n  .ui.big.horizontal.list > .item {\n    font-size: $big;\n  }\n  .ui.huge.horizontal.list .list > .item,\n  .ui.huge.horizontal.list > .item {\n    font-size: $huge;\n  }\n  .ui.massive.horizontal.list .list > .item,\n  .ui.massive.horizontal.list > .item {\n    font-size: $massive;\n  }\n}\n\n@import '../../themes/default/elements/list.style';","@import '../../themes/default/elements/loader.variables';\n\n@if $use-loader {\n  /*******************************\n  //@-        Loader\n  *******************************/\n\n\n  /* Standard Size */\n  .ui.loader {\n    display: none;\n    position: absolute;\n    top: $loader-top-offset;\n    left: $loader-left-offset;\n    margin: 0;\n    text-align: center;\n    z-index: 1000;\n    transform: translateX(-50%) translateY(-50%);\n  }\n\n  /* Static Shape */\n  .ui.loader:before {\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 50%;\n    width: 100%;\n    height: 100%;\n\n    border-radius: $circular-radius;\n    border: $loader-line-width solid $loader-fill-color;\n  }\n\n  /* Active Shape */\n  .ui.loader:after {\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 50%;\n    width: 100%;\n    height: 100%;\n\n    animation: loader $loader-speed infinite linear;\n    border: $loader-line-width solid $loader-shape-border-color;\n    border-radius: $circular-radius;\n\n    box-shadow: 0 0 0 1px transparent;\n  }\n\n  /* Speeds */\n\n  .ui.fast.loading.loading:after,\n  .ui.fast.loading.loading .input > i.icon:after,\n  .ui.fast.loading.loading > i.icon:after,\n  .ui.fast.loader:after {\n    animation-duration: $loader-speed-fast;\n  }\n\n  .ui.slow.loading.loading:after,\n  .ui.slow.loading.loading .input > i.icon:after,\n  .ui.slow.loading.loading > i.icon:after,\n  .ui.slow.loader:after {\n    animation-duration: $loader-speed-slow;\n  }\n\n  /* Active Animation */\n  @keyframes loader {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  /* Sizes */\n  .ui.mini.loader:before,\n  .ui.mini.loader:after {\n    width: $loader-mini;\n    height: $loader-mini;\n    margin: $loader-mini-offset;\n  }\n  .ui.tiny.loader:before,\n  .ui.tiny.loader:after {\n    width: $loader-tiny;\n    height: $loader-tiny;\n    margin: $loader-tiny-offset;\n  }\n  .ui.small.loader:before,\n  .ui.small.loader:after {\n    width: $loader-small;\n    height: $loader-small;\n    margin: $loader-small-offset;\n  }\n  .ui.loader:before,\n  .ui.loader:after {\n    width: $loader-medium;\n    height: $loader-medium;\n    margin: $loader-medium-offset;\n  }\n  .ui.large.loader:before,\n  .ui.large.loader:after {\n    width: $loader-large;\n    height: $loader-large;\n    margin: $loader-large-offset;\n  }\n  .ui.big.loader:before,\n  .ui.big.loader:after {\n    width: $loader-big;\n    height: $loader-big;\n    margin: $loader-big-offset;\n  }\n  .ui.huge.loader:before,\n  .ui.huge.loader:after {\n    width: $loader-huge;\n    height: $loader-huge;\n    margin: $loader-huge-offset;\n  }\n  .ui.massive.loader:before,\n  .ui.massive.loader:after {\n    width: $loader-massive;\n    height: $loader-massive;\n    margin: $loader-massive-offset;\n  }\n\n  /*-------------------\n        Coupling\n  --------------------*/\n\n  /* Show inside active dimmer */\n  .ui.dimmer > .loader {\n    display: block;\n  }\n\n  /* Black Dimmer */\n  .ui.dimmer > .ui.loader {\n    color: $loader-inverted-text-color;\n  }\n  .ui.dimmer > .ui.loader:not(.elastic):before {\n    border-color: $inverted-loader-fill-color;\n  }\n\n  /* White Dimmer (Inverted) */\n  .ui.inverted.dimmer > .ui.loader {\n    color: $loader-text-color;\n  }\n  .ui.inverted.dimmer > .ui.loader:not(.elastic):before {\n    border-color: $loader-fill-color;\n  }\n\n  /*******************************\n              Types\n  *******************************/\n\n  /*-------------------\n          Text\n  --------------------*/\n\n  .ui.ui.ui.ui.text.loader {\n    width: auto;\n    height: auto;\n    text-align: center;\n    font-style: normal;\n  }\n\n\n  /*******************************\n              States\n  *******************************/\n\n  .ui.indeterminate.loader:after {\n    animation-direction: $loader-indeterminate-direction;\n    animation-duration: $loader-indeterminate-speed;\n  }\n\n  .ui.loader.active,\n  .ui.loader.visible {\n    display: block;\n  }\n  .ui.loader.disabled,\n  .ui.loader.hidden {\n    display: none;\n  }\n\n  /*******************************\n              Variations\n  *******************************/\n\n\n  /*-------------------\n          Sizes\n  --------------------*/\n\n\n  /* Loader */\n  .ui.mini.loader {\n    width: $loader-mini;\n    height: $loader-mini;\n    font-size: $loader-mini-font-size;\n  }\n  .ui.tiny.loader {\n    width: $loader-tiny;\n    height: $loader-tiny;\n    font-size: $loader-tiny-font-size;\n  }\n  .ui.small.loader {\n    width: $loader-small;\n    height: $loader-small;\n    font-size: $loader-small-font-size;\n  }\n  .ui.loader {\n    width: $loader-medium;\n    height: $loader-medium;\n    font-size: $loader-medium-font-size;\n  }\n  .ui.large.loader {\n    width: $loader-large;\n    height: $loader-large;\n    font-size: $loader-large-font-size;\n  }\n  .ui.big.loader {\n    width: $loader-big;\n    height: $loader-big;\n    font-size: $loader-big-font-size;\n  }\n  .ui.huge.loader {\n    width: $loader-huge;\n    height: $loader-huge;\n    font-size: $loader-huge-font-size;\n  }\n  .ui.massive.loader {\n    width: $loader-massive;\n    height: $loader-massive;\n    font-size: $loader-massive-font-size;\n  }\n\n  /* Text Loader */\n  .ui.mini.text.loader {\n    min-width: $loader-mini;\n    padding-top: (strip-unit($loader-mini) + $loader-text-distance);\n  }\n  .ui.tiny.text.loader {\n    min-width: $loader-tiny;\n    padding-top: (strip-unit($loader-tiny) + $loader-text-distance);\n  }\n  .ui.small.text.loader {\n    min-width: $loader-small;\n    padding-top: (strip-unit($loader-small) + $loader-text-distance);\n  }\n  .ui.text.loader {\n    min-width: $loader-medium;\n    padding-top: (strip-unit($loader-medium) + $loader-text-distance);\n  }\n  .ui.large.text.loader {\n    min-width: $loader-large;\n    padding-top: (strip-unit($loader-large) + $loader-text-distance);\n  }\n  .ui.big.text.loader {\n    min-width: $loader-big;\n    padding-top: (strip-unit($loader-big) + $loader-text-distance);\n  }\n  .ui.huge.text.loader {\n    min-width: $loader-huge;\n    padding-top: (strip-unit($loader-huge) + $loader-text-distance);\n  }\n  .ui.massive.text.loader {\n    min-width: $loader-massive;\n    padding-top: (strip-unit($loader-massive) + $loader-text-distance);\n  }\n\n\n  /*-------------------\n        Colors\n  --------------------*/\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-loader-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $l: map-get($value, light);\n\n      .ui.#{$key + \"\"}.elastic.loader.loader:before,\n      .ui.#{$key + \"\"}.basic.elastic.loading.button:before,\n      .ui.#{$key + \"\"}.basic.elastic.loading.button:after,\n      .ui.#{$key + \"\"}.elastic.loading.loading.loading:not(.segment):before,\n      .ui.#{$key + \"\"}.elastic.loading.loading.loading .input > i.icon:before,\n      .ui.#{$key + \"\"}.elastic.loading.loading.loading.loading > i.icon:before,\n      .ui.#{$key + \"\"}.loading.loading.loading.loading:not(.usual):not(.button):after,\n      .ui.#{$key + \"\"}.loading.loading.loading.loading .input > i.icon:after,\n      .ui.#{$key + \"\"}.loading.loading.loading.loading > i.icon:after,\n      .ui.#{$key + \"\"}.loader.loader.loader:after {\n        color: $c;\n      }\n\n      @if($use-list-variation-inverted) {\n        .ui.inverted.#{$key + \"\"}.elastic.loader:before,\n        .ui.inverted.#{$key + \"\"}.elastic.loading.loading.loading:not(.segment):before,\n        .ui.inverted.#{$key + \"\"}.elastic.loading.loading.loading .input > i.icon:before,\n        .ui.inverted.#{$key + \"\"}.elastic.loading.loading.loading > i.icon:before,\n        .ui.inverted.#{$key + \"\"}.loading.loading.loading.loading:not(.usual):after,\n        .ui.inverted.#{$key + \"\"}.loading.loading.loading.loading .input > i.icon:after,\n        .ui.inverted.#{$key + \"\"}.loading.loading.loading.loading > i.icon:after,\n        .ui.inverted.#{$key + \"\"}.loader.loader.loader:after {\n          color: $l;\n        }\n      }\n    }\n  }\n\n  .ui.elastic.loader.loader:before,\n  .ui.elastic.loading.loading.loading:before,\n  .ui.elastic.loading.loading.loading .input > i.icon:before,\n  .ui.elastic.loading.loading.loading > i.icon:before,\n  .ui.loading.loading.loading.loading:not(.usual):after,\n  .ui.loading.loading.loading.loading .input > i.icon:after,\n  .ui.loading.loading.loading.loading > i.icon:after,\n  .ui.loader.loader.loader:after {\n    border-color: currentColor;\n  }\n  .ui.elastic.loading.loading.loading.loading.button:not(.inverted):not(.basic):before {\n    color: $inverted-loader-line-color;\n  }\n  .ui.elastic.basic.loading.button:before,\n  .ui.elastic.basic.loading.button:after {\n    color: $loader-line-color;\n  }\n  .ui.double.loading.loading.loading.loading.button:after {\n    border-bottom-color: currentColor;\n  }\n  /*-------------------\n        Inline\n  --------------------*/\n\n  .ui.inline.loader {\n    position: relative;\n    vertical-align: $loader-inline-vertical-align;\n    margin: $loader-inline-margin;\n    left: 0;\n    top: 0;\n    transform: none;\n  }\n\n  .ui.inline.loader.active,\n  .ui.inline.loader.visible {\n    display: inline-block;\n  }\n\n  /* Centered Inline */\n  .ui.centered.inline.loader.active,\n  .ui.centered.inline.loader.visible {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .ui.loading.loading.loading.loading.loading.loading:after,\n  .ui.loading.loading.loading.loading.loading.loading .input > i.icon:after,\n  .ui.loading.loading.loading.loading.loading.loading > i.icon:after,\n  .ui.loader.loader.loader.loader.loader:after {\n    border-left-color:transparent;\n    border-right-color:transparent;\n  }\n  .ui.loading.loading.loading.loading.loading.loading.loading:not(.double):after,\n  .ui.loading.loading.loading.loading.loading.loading.loading:not(.double) .input > i.icon:after,\n  .ui.loading.loading.loading.loading.loading.loading.loading:not(.double) > i.icon:after,\n  .ui.loader.loader.loader.loader.loader.loader:not(.double):after {\n    border-bottom-color: transparent;\n  }\n  .ui.loading.loading.loading.loading.loading.loading.segment:after,\n  .ui.loading.loading.loading.loading.loading.loading.form:after {\n    border-left-color:$loader-fill-color;\n    border-right-color:$loader-fill-color;\n  }\n  .ui.loading.loading.loading.loading.loading.loading.segment:not(.double):after,\n  .ui.loading.loading.loading.loading.loading.loading.form:not(.double):after {\n    border-bottom-color: $loader-fill-color;\n  }\n\n  /*-------------------\n        Elastic\n  --------------------*/\n\n  .ui.dimmer > .ui.elastic.loader {\n    color: $inverted-loader-line-color;\n  }\n  .ui.inverted.dimmer > .ui.elastic.loader {\n    color: $loader-line-color;\n  }\n  .ui.elastic.loading.loading:not(.form):not(.segment):after,\n  .ui.elastic.loading.loading .input > i.icon:after,\n  .ui.elastic.loading.loading > i.icon:after,\n  .ui.elastic.loader.loader:after {\n    animation: loader 1s infinite cubic-bezier(.27, 1.05, .92, .61);\n    animation-delay: 0.3s;\n  }\n  .ui.elastic.loading.loading.loading:not(.form):not(.segment):before,\n  .ui.elastic.loading.loading.loading .input > i.icon:before,\n  .ui.elastic.loading.loading.loading > i.icon:before,\n  .ui.elastic.loader.loader:before {\n    animation: elastic-loader 1s infinite cubic-bezier(.27, 1.05, .92, .61);\n    -moz-animation: currentcolor-elastic-loader 1s infinite cubic-bezier(.27, 1.05, .92, .61);\n    border-right-color: transparent;\n  }\n  .ui.elastic.inline.loader:empty {\n    animation: loader 8s infinite linear;\n  }\n  .ui.slow.elastic.loading.loading:not(.form):not(.segment):after,\n  .ui.slow.elastic.loading.loading .input > i.icon:after,\n  .ui.slow.elastic.loading.loading > i.icon:after,\n  .ui.slow.elastic.loader.loader:after {\n    animation-duration: 1.5s;\n    animation-delay: 0.45s;\n  }\n  .ui.slow.elastic.loading.loading.loading:not(.form):not(.segment):before,\n  .ui.slow.elastic.loading.loading.loading .input > i.icon:before,\n  .ui.slow.elastic.loading.loading.loading > i.icon:before,\n  .ui.slow.elastic.loader.loader:before {\n    animation-duration: 1.5s;\n  }\n  .ui.fast.elastic.loading.loading:not(.form):not(.segment):after,\n  .ui.fast.elastic.loading.loading .input > i.icon:after,\n  .ui.fast.elastic.loading.loading > i.icon:after,\n  .ui.fast.elastic.loader.loader:after {\n    animation-duration: 0.66s;\n    animation-delay: 0.20s;\n  }\n  .ui.fast.elastic.loading.loading.loading:not(.form):not(.segment):before,\n  .ui.fast.elastic.loading.loading.loading .input > i.icon:before,\n  .ui.fast.elastic.loading.loading.loading > i.icon:before,\n  .ui.fast.elastic.loader.loader:before {\n    animation-duration: 0.66s;\n  }\n  @keyframes elastic-loader {\n    0%, 1% {\n      border-left-color: transparent;\n      border-bottom-color: transparent\n    }\n    1.1%, 50% {\n      border-left-color: inherit;\n    }\n    10%, 35.1%{\n      border-bottom-color: transparent;\n    }\n    10.1%, 35%{\n      border-bottom-color: inherit;\n    }\n    50.1%{\n      border-left-color: transparent;\n    }\n    100% {\n      border-left-color: transparent;\n      border-bottom-color: transparent;\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes currentcolor-elastic-loader {\n    0%, 1% {\n      border-left-color: transparent;\n      border-bottom-color: transparent\n    }\n    1.1%, 50% {\n      border-left-color: currentColor;\n    }\n    10%, 35.1%{\n      border-bottom-color: transparent;\n    }\n    10.1%, 35%{\n      border-bottom-color: currentColor;\n    }\n    50.1%{\n      border-left-color: transparent;\n    }\n    100% {\n      border-left-color: transparent;\n      border-bottom-color: transparent;\n      transform: rotate(360deg);\n    }\n  }\n}\n\n@import '../../themes/default/elements/loader.style';","@import '../../themes/default/elements/placeholder.variables';\n\n@if $use-placeholder {\n  /*-------------------\n  //@-    Content\n  --------------------*/\n\n  .ui.placeholder {\n    position: static;\n    overflow: hidden;\n    animation: placeholderShimmer $placeholder-loading-animation-duration linear;\n    animation-iteration-count: infinite;\n    background-color: $white;\n    background-image: $placeholder-loading-gradient;\n    background-size: $placeholder-loading-gradient-width 100%;\n    max-width: $placeholder-max-width;\n  }\n\n  @keyframes placeholderShimmer{\n    0% {\n      background-position: (-$placeholder-loading-gradient-width) 0\n    }\n    100% {\n      background-position: $placeholder-loading-gradient-width 0\n    }\n  }\n\n  .ui.placeholder + .ui.placeholder {\n    margin-top: $placeholder-consecutive-spacing;\n  }\n  .ui.placeholder + .ui.placeholder {\n    animation-delay: $placeholder-animation-interval;\n  }\n  .ui.placeholder + .ui.placeholder + .ui.placeholder {\n    animation-delay: ($placeholder-animation-interval * 2);\n  }\n  .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {\n    animation-delay: ($placeholder-animation-interval * 3);\n  }\n  .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {\n    animation-delay: ($placeholder-animation-interval * 4);\n  }\n\n  .ui.placeholder,\n  .ui.placeholder > :before,\n  .ui.placeholder .image.header:after,\n  .ui.placeholder .line,\n  .ui.placeholder .line:after {\n    background-color: $white;\n  }\n\n  .ui.placeholder.hidden {\n    display:none;\n  }\n\n  /* Image */\n  .ui.placeholder .image:not(.header):not(.ui):not(.icon) {\n    height: $placeholder-image-height;\n  }\n  .ui.placeholder .square.image:not(.header) {\n    height: 0;\n    overflow: hidden;\n    /* 1/1 aspect ratio */\n    padding-top: 100%;\n  }\n  .ui.placeholder .rectangular.image:not(.header) {\n    height: 0;\n    overflow: hidden;\n    /* 4/3 aspect ratio */\n    padding-top: 75%;\n  }\n\n\n  /* Lines */\n  .ui.placeholder .line {\n    position: relative;\n    height: $placeholder-line-margin;\n  }\n  .ui.placeholder .line:before,\n  .ui.placeholder .line:after {\n    top: 100%;\n    position: absolute;\n    content: '';\n    background-color: inherit;\n  }\n  .ui.placeholder .line:before {\n    left: 0;\n  }\n  .ui.placeholder .line:after {\n    right: 0;\n  }\n\n  /* Any Lines */\n  .ui.placeholder .line {\n    margin-bottom: $placeholder-line-height;\n  }\n  .ui.placeholder .line:before,\n  .ui.placeholder .line:after {\n    height: $placeholder-line-height;\n  }\n  .ui.placeholder .line:not(:first-child) {\n    margin-top: $placeholder-line-height;\n  }\n\n  /* Header Image + 2 Lines */\n  .ui.placeholder .header {\n    position: relative;\n    overflow: hidden;\n  }\n\n  /* Line Outdent */\n  .ui.placeholder .line:nth-child(1):after {\n    width: $placeholder-line-one-outdent;\n  }\n  .ui.placeholder .line:nth-child(2):after {\n    width: $placeholder-line-two-outdent;\n  }\n  .ui.placeholder .line:nth-child(3):after {\n    width: $placeholder-line-three-outdent;\n  }\n  .ui.placeholder .line:nth-child(4):after {\n    width: $placeholder-line-four-outdent;\n  }\n  .ui.placeholder .line:nth-child(5):after {\n    width: $placeholder-line-five-outdent;\n  }\n\n  /* Header Line 1 & 2*/\n  .ui.placeholder .header .line {\n    margin-bottom: $placeholder-header-line-height;\n  }\n  .ui.placeholder .header .line:before,\n  .ui.placeholder .header .line:after {\n    height: $placeholder-header-line-height;\n  }\n  .ui.placeholder .header .line:not(:first-child) {\n    margin-top: $placeholder-header-line-height;\n  }\n  .ui.placeholder .header .line:after {\n    width: $placeholder-header-line-one-outdent;\n  }\n  .ui.placeholder .header .line:nth-child(2):after {\n    width: $placeholder-header-line-two-outdent;\n  }\n\n  /* Image Header */\n  .ui.placeholder .image.header .line {\n    margin-left: $placeholder-image-width;\n  }\n  .ui.placeholder .image.header .line:before {\n    width: $placeholder-image-text-indent;\n  }\n  .ui.placeholder .image.header:after {\n    display: block;\n    height: $placeholder-line-margin;\n    content: '';\n    margin-left: $placeholder-image-width;\n  }\n\n  /* Spacing */\n  .ui.placeholder .image .line:first-child,\n  .ui.placeholder .paragraph .line:first-child,\n  .ui.placeholder .header .line:first-child {\n    height: 0.01px;\n  }\n  .ui.placeholder .image:not(:first-child):before,\n  .ui.placeholder .paragraph:not(:first-child):before,\n  .ui.placeholder .header:not(:first-child):before {\n    height: $placeholder-spacing;\n    content: '';\n    display: block;\n  }\n\n  /* Inverted Content Loader */\n  .ui.inverted.placeholder {\n    background-image: $placeholder-inverted-loading-gradient;\n  }\n  .ui.inverted.placeholder,\n  .ui.inverted.placeholder > :before,\n  .ui.inverted.placeholder .image.header:after,\n  .ui.inverted.placeholder .line,\n  .ui.inverted.placeholder .line:after {\n    background-color: $black;\n  }\n\n  /*******************************\n              Variations\n  *******************************/\n\n\n  /*-------------------\n          Sizes\n  --------------------*/\n\n  .ui.placeholder .full.line.line.line:after {\n    width: $placeholder-full-line-outdent;\n  }\n  .ui.placeholder .very.long.line.line.line:after {\n    width: $placeholder-very-long-line-outdent;\n  }\n  .ui.placeholder .long.line.line.line:after {\n    width: $placeholder-long-line-outdent;\n  }\n  .ui.placeholder .medium.line.line.line:after {\n    width: $placeholder-medium-line-outdent;\n  }\n  .ui.placeholder .short.line.line.line:after {\n    width: $placeholder-short-line-outdent;\n  }\n  .ui.placeholder .very.short.line.line.line:after {\n    width: $placeholder-very-short-line-outdent;\n  }\n\n\n  /*-------------------\n          Fluid\n  --------------------*/\n\n  .ui.fluid.placeholder {\n    max-width: none;\n  }\n}\n\n@import '../../themes/default/elements/placeholder.style';","@import '../../themes/default/elements/rail.variables';\n\n@if $use-rail {\n  /*******************************\n  //@-         Rails\n  *******************************/\n\n  .ui.rail {\n    position: absolute;\n    top: 0;\n    width: $rail-width;\n    height: $rail-height;\n  }\n\n  .ui.left.rail {\n    left: auto;\n    right: 100%;\n    padding: 0 $rail-split-distance 0 0;\n    margin: 0 $rail-split-distance 0 0;\n  }\n\n  .ui.right.rail {\n    left: 100%;\n    right: auto;\n    padding: 0 0 0 $rail-split-distance;\n    margin: 0 0 0 $rail-split-distance;\n  }\n\n  /*******************************\n            Variations\n  *******************************/\n\n  /*--------------\n      Internal\n  ---------------*/\n\n  .ui.left.internal.rail {\n    left: 0;\n    right: auto;\n    padding: 0 0 0 $rail-split-distance;\n    margin: 0 0 0 $rail-split-distance;\n  }\n\n  .ui.right.internal.rail {\n    left: auto;\n    right: 0;\n    padding: 0 $rail-split-distance 0 0;\n    margin: 0 $rail-split-distance 0 0;\n  }\n\n\n  /*--------------\n      Dividing\n  ---------------*/\n\n  .ui.dividing.rail {\n    width: $rail-dividing-width;\n  }\n  .ui.left.dividing.rail {\n    padding: 0 $rail-split-dividing-distance 0 0;\n    margin: 0 $rail-split-dividing-distance 0 0;\n    border-right: $rail-dividing-border;\n  }\n  .ui.right.dividing.rail {\n    border-left: $rail-dividing-border;\n    padding: 0 0 0 $rail-split-dividing-distance;\n    margin: 0 0 0 $rail-split-dividing-distance;\n  }\n\n  /*--------------\n      Distance\n  ---------------*/\n\n  .ui.close.rail {\n    width: $rail-close-width;\n  }\n  .ui.close.left.rail {\n    padding: 0 $rail-split-close-distance 0 0;\n    margin: 0 $rail-split-close-distance 0 0;\n  }\n  .ui.close.right.rail {\n    padding: 0 0 0 $rail-split-close-distance;\n    margin: 0 0 0 $rail-split-close-distance;\n  }\n\n  .ui.very.close.rail {\n    width: $rail-very-close-width;\n  }\n  .ui.very.close.left.rail {\n    padding: 0 $rail-split-very-close-distance 0 0;\n    margin: 0 $rail-split-very-close-distance 0 0;\n  }\n  .ui.very.close.right.rail {\n    padding: 0 0 0 $rail-split-very-close-distance;\n    margin: 0 0 0 $rail-split-very-close-distance;\n  }\n\n  /*--------------\n      Attached\n  ---------------*/\n\n  .ui.attached.left.rail,\n  .ui.attached.right.rail {\n    padding: 0;\n    margin: 0;\n  }\n\n  /*--------------\n      Sizing\n  ---------------*/\n\n  .ui.mini.rail {\n    font-size: $mini;\n  }\n  .ui.tiny.rail {\n    font-size: $tiny;\n  }\n  .ui.small.rail {\n    font-size: $small;\n  }\n  .ui.rail {\n    font-size: $medium;\n  }\n  .ui.large.rail {\n    font-size: $large;\n  }\n  .ui.big.rail {\n    font-size: $big;\n  }\n  .ui.huge.rail {\n    font-size: $huge;\n  }\n  .ui.massive.rail {\n    font-size: $massive;\n  }\n}\n\n@import '../../themes/default/elements/rail.style';","@import '../../themes/default/elements/reveal.variables';\n\n@if $use-reveal {\n  /*******************************\n  //@-        Reveal\n  *******************************/\n\n  .ui.reveal  {\n    display: inherit;\n    position: relative !important;\n    font-size: 0 !important;\n  }\n\n  .ui.reveal > .visible.content {\n    position: absolute !important;\n    top: 0 !important;\n    left: 0 !important;\n    z-index: $reveal-top-z-index !important;\n    transition: $reveal-transition;\n  }\n  .ui.reveal > .hidden.content {\n    position: relative !important;\n    z-index: $reveal-bottom-z-index !important;\n  }\n\n  /* Make sure hovered element is on top of other reveal */\n  .ui.active.reveal .visible.content,\n  .ui.reveal:hover .visible.content {\n    z-index: $reveal-active-z-index !important;\n  }\n\n\n  /*******************************\n                Types\n  *******************************/\n\n  @if($use-reveal-type-slide) {\n    /*--------------\n          Slide\n    ---------------*/\n    \n    .ui.slide.reveal {\n      position: relative !important;\n      overflow: hidden !important;\n      white-space: nowrap;\n    }\n    \n    .ui.slide.reveal > .content {\n      display: block;\n      width: 100%;\n      white-space: normal;\n      float: left;\n    \n      margin: 0;\n      transition: $reveal-slide-transition;\n    }\n    \n    .ui.slide.reveal > .visible.content {\n      position: relative !important;\n    }\n    .ui.slide.reveal > .hidden.content {\n      position: absolute !important;\n      left: 0 !important;\n      width: 100% !important;\n      transform: translateX(100%) !important;\n    }\n    .ui.slide.active.reveal > .visible.content,\n    .ui.slide.reveal:hover > .visible.content {\n      transform: translateX(-100%) !important;\n    }\n    .ui.slide.active.reveal > .hidden.content,\n    .ui.slide.reveal:hover > .hidden.content {\n      transform: translateX(0%) !important;\n    }\n    \n    .ui.slide.right.reveal > .visible.content {\n      transform: translateX(0%) !important;\n    }\n    .ui.slide.right.reveal > .hidden.content {\n      transform: translateX(-100%) !important;\n    }\n    .ui.slide.right.active.reveal > .visible.content,\n    .ui.slide.right.reveal:hover > .visible.content {\n      transform: translateX(100%) !important;\n    }\n    .ui.slide.right.active.reveal > .hidden.content,\n    .ui.slide.right.reveal:hover > .hidden.content {\n      transform: translateX(0%) !important;\n    }\n    \n    .ui.slide.up.reveal > .hidden.content {\n      transform: translateY(100%) !important;\n    }\n    .ui.slide.up.active.reveal > .visible.content,\n    .ui.slide.up.reveal:hover > .visible.content {\n      transform: translateY(-100%) !important;\n    }\n    .ui.slide.up.active.reveal > .hidden.content,\n    .ui.slide.up.reveal:hover > .hidden.content {\n      transform: translateY(0%) !important;\n    }\n    \n    .ui.slide.down.reveal > .hidden.content {\n      transform: translateY(-100%) !important;\n    }\n    .ui.slide.down.active.reveal > .visible.content,\n    .ui.slide.down.reveal:hover > .visible.content {\n      transform: translateY(100%) !important;\n    }\n    .ui.slide.down.active.reveal > .hidden.content,\n    .ui.slide.down.reveal:hover > .hidden.content {\n      transform: translateY(0%) !important;\n    }\n  }\n\n  @if($use-reveal-type-fade) {\n    /*--------------\n          Fade\n    ---------------*/\n    \n    .ui.fade.reveal > .visible.content {\n      opacity: 1;\n    }\n    .ui.fade.active.reveal > .visible.content,\n    .ui.fade.reveal:hover > .visible.content {\n      opacity: 0;\n    }\n  }\n\n\n  @if($use-reveal-type-move) {\n    /*--------------\n          Move\n    ---------------*/\n    \n    .ui.move.reveal {\n      position: relative !important;\n      overflow: hidden !important;\n      white-space: nowrap;\n    }\n    \n    .ui.move.reveal > .content {\n      display: block;\n      float: left;\n      white-space: normal;\n    \n      margin: 0;\n      transition: $reveal-move-transition;\n    }\n    \n    .ui.move.reveal > .visible.content {\n      position: relative !important;\n    }\n    .ui.move.reveal > .hidden.content {\n      position: absolute !important;\n      left: 0 !important;\n      width: 100% !important;\n    }\n    .ui.move.active.reveal > .visible.content,\n    .ui.move.reveal:hover > .visible.content {\n      transform: translateX(-100%) !important;\n    }\n    .ui.move.right.active.reveal > .visible.content,\n    .ui.move.right.reveal:hover > .visible.content {\n      transform: translateX(100%) !important;\n    }\n    .ui.move.up.active.reveal > .visible.content,\n    .ui.move.up.reveal:hover > .visible.content {\n      transform: translateY(-100%) !important;\n    }\n    .ui.move.down.active.reveal > .visible.content,\n    .ui.move.down.reveal:hover > .visible.content {\n      transform: translateY(100%) !important;\n    }\n  }\n\n\n  @if($use-reveal-type-rotate) {\n    /*--------------\n        Rotate\n    ---------------*/\n    \n    .ui.rotate.reveal > .visible.content {\n      transition-duration: $reveal-transition-duration;\n      transform: rotate(0deg);\n    }\n    \n    .ui.rotate.reveal > .visible.content,\n    .ui.rotate.right.reveal > .visible.content {\n      transform-origin: bottom right;\n    }\n    .ui.rotate.active.reveal > .visible.content,\n    .ui.rotate.reveal:hover > .visible.content,\n    .ui.rotate.right.active.reveal > .visible.content,\n    .ui.rotate.right.reveal:hover > .visible.content {\n      transform: rotate($reveal-rotate-degrees);\n    }\n    \n    .ui.rotate.left.reveal > .visible.content {\n      transform-origin: bottom left;\n    }\n    .ui.rotate.left.active.reveal > .visible.content,\n    .ui.rotate.left.reveal:hover > .visible.content {\n      transform: rotate(-$reveal-rotate-degrees);\n    }\n  }\n\n  /*******************************\n                States\n  *******************************/\n\n  .ui.disabled.reveal:hover > .visible.visible.content {\n    position: static !important;\n    display: block !important;\n    opacity: 1 !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: auto !important;\n    bottom: auto !important;\n    transform: none !important;\n  }\n  .ui.disabled.reveal:hover > .hidden.hidden.content {\n    display: none !important;\n  }\n\n\n  /*******************************\n            Coupling\n  *******************************/\n\n  .ui.reveal > .ui.ribbon.label {\n    z-index: $reveal-overlay-z-index;\n  }\n\n  /*******************************\n            Variations\n  *******************************/\n\n  /*--------------\n      Visible\n  ---------------*/\n\n  .ui.visible.reveal {\n    overflow: visible;\n  }\n\n  /*--------------\n      Instant\n  ---------------*/\n\n  .ui.instant.reveal > .content {\n    transition-delay: 0s !important;\n  }\n\n\n  /*--------------\n      Sizing\n  ---------------*/\n\n  .ui.reveal > .content {\n    font-size: $medium !important;\n  }\n}\n\n@import '../../themes/default/elements/reveal.style';","@import '../../themes/default/elements/segment.variables';\n\n@if $use-segment {\n  /*******************************\n  //@-        Segment\n  *******************************/\n\n  .ui.segment {\n    position: relative;\n    background: $segment-background;\n    box-shadow: $segment-box-shadow;\n    margin: $segment-margin;\n    padding: $segment-padding;\n    border-radius: $segment-border-radius;\n    border: $segment-border;\n  }\n\n  .ui.segment:first-child {\n    margin-top: 0;\n  }\n  .ui.segment:last-child {\n    margin-bottom: 0;\n  }\n\n\n  /* Vertical */\n  .ui.vertical.segment {\n    margin: 0;\n    padding-left: 0;\n    padding-right: 0;\n\n    background: none transparent;\n    border-radius: 0;\n    box-shadow: none;\n    border: none;\n    border-bottom: $segment-border-width solid $border-color;\n  }\n  .ui.vertical.segment:last-child {\n    border-bottom: none;\n  }\n\n\n  /*-------------------\n      Loose Coupling\n  --------------------*/\n\n  /* Header */\n  .ui.inverted.segment > .ui.header > .sub.header,\n  .ui.inverted.segment > .ui.header {\n    color: $white;\n  }\n\n  /* Label */\n  .ui[class*=\"bottom attached\"].segment > [class*=\"top attached\"].label {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .ui[class*=\"top attached\"].segment > [class*=\"bottom attached\"].label {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .ui.attached.segment:not(.top):not(.bottom) > [class*=\"top attached\"].label {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .ui.attached.segment:not(.top):not(.bottom) > [class*=\"bottom attached\"].label {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  /* Grid */\n  .ui.page.grid.segment,\n  .ui.grid > .row > .ui.segment.column,\n  .ui.grid > .ui.segment.column {\n    padding-top: $segment-page-grid-margin;\n    padding-bottom: $segment-page-grid-margin;\n  }\n  .ui.grid.segment {\n    margin: $segment-margin;\n    border-radius: $segment-border-radius;\n  }\n\n  /* Table */\n  .ui.basic.table.segment {\n    background: $segment-background;\n    border: $segment-border;\n    box-shadow: $segment-box-shadow;\n  }\n  .ui[class*=\"very basic\"].table.segment {\n    padding: $segment-padding;\n  }\n\n  /* Tab */\n  .ui.segment.tab:last-child {\n    margin-bottom: $segment-vertical-margin;\n  }\n\n  /*******************************\n              Types\n  *******************************/\n\n  @if($use-segment-type-placeholder) {\n    /*-------------------\n        Placeholder\n    --------------------*/\n\n    .ui.placeholder.segment {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: stretch;\n      max-width: initial;\n      animation: none;\n      overflow: visible;\n      padding: $segment-placeholder-padding;\n      min-height: $segment-placeholder-min-height;\n      background: $segment-placeholder-background;\n      border-color: $segment-placeholder-border-color;\n      box-shadow: $segment-placeholder-box-shadow;\n    }\n\n    .ui.placeholder.segment .button,\n    .ui.placeholder.segment textarea {\n      display: block;\n    }\n    .ui.placeholder.segment .field,\n    .ui.placeholder.segment textarea,\n    .ui.placeholder.segment > .ui.input,\n    .ui.placeholder.segment .button {\n      max-width: $segment-placeholder-content-max-width;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    .ui.placeholder.segment .column .button,\n    .ui.placeholder.segment .column .field,\n    .ui.placeholder.segment .column textarea,\n    .ui.placeholder.segment .column > .ui.input {\n      max-width: $segment-placeholder-content-max-width;\n      margin-left: auto;\n      margin-right: auto;\n    }\n\n    .ui.placeholder.segment > .inline  {\n      align-self: center;\n    }\n    .ui.placeholder.segment > .inline > .button {\n      display: inline-block;\n      width: auto;\n      margin: $segment-placeholder-content-inline-button-margin;\n    }\n    .ui.placeholder.segment > .inline > .button:last-child {\n      margin-right: 0;\n    }\n  }\n\n  @if($use-segment-type-piled) {\n    /*-------------------\n            Piled\n    --------------------*/\n\n    .ui.piled.segments,\n    .ui.piled.segment {\n      margin: $segment-piled-margin 0;\n      box-shadow: $segment-piled-box-shadow;\n      z-index: $segment-piled-z-index;\n    }\n    .ui.piled.segment:first-child {\n      margin-top: 0;\n    }\n    .ui.piled.segment:last-child {\n      margin-bottom: 0;\n    }\n    .ui.piled.segments:after,\n    .ui.piled.segments:before,\n    .ui.piled.segment:after,\n    .ui.piled.segment:before {\n      background-color: $white;\n      visibility: visible;\n      content: '';\n      display: block;\n      height: 100%;\n      left: 0;\n      position: absolute;\n      width: 100%;\n      border: $segment-piled-border;\n      box-shadow: $segment-piled-box-shadow;\n    }\n    .ui.piled.segments:before,\n    .ui.piled.segment:before {\n      transform: rotate(-$segment-piled-degrees);\n      top: 0;\n      z-index: -2;\n    }\n    .ui.piled.segments:after,\n    .ui.piled.segment:after {\n      transform: rotate($segment-piled-degrees);\n      top: 0;\n      z-index: -1;\n    }\n\n    /* Piled Attached */\n    .ui[class*=\"top attached\"].piled.segment {\n      margin-top: $segment-piled-margin;\n      margin-bottom: 0;\n    }\n    .ui.piled.segment[class*=\"top attached\"]:first-child {\n      margin-top: 0;\n    }\n    .ui.piled.segment[class*=\"bottom attached\"] {\n      margin-top: 0;\n      margin-bottom: $segment-piled-margin;\n    }\n    .ui.piled.segment[class*=\"bottom attached\"]:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n\n  @if($use-segment-type-stacked) {\n    /*-------------------\n          Stacked\n    --------------------*/\n\n    .ui.stacked.segment {\n      padding-bottom: $segment-stacked-padding;\n    }\n    .ui.stacked.segments:before,\n    .ui.stacked.segments:after,\n    .ui.stacked.segment:before,\n    .ui.stacked.segment:after {\n      content: '';\n      position: absolute;\n      bottom: -($segment-stacked-height / 2);\n      left: 0;\n\n      border-top: 1px solid $border-color;\n      background: $segment-stacked-page-background;\n\n      width: 100%;\n      height: $segment-stacked-height;\n      visibility: visible;\n    }\n    .ui.stacked.segments:before,\n    .ui.stacked.segment:before {\n      display: none;\n    }\n\n    /* Add additional page */\n    .ui.tall.stacked.segments:before,\n    .ui.tall.stacked.segment:before {\n      display: block;\n      bottom: 0;\n    }\n\n    @if($use-segment-variation-inverted) {\n      /* Inverted */\n      .ui.stacked.inverted.segments:before,\n      .ui.stacked.inverted.segments:after,\n      .ui.stacked.inverted.segment:before,\n      .ui.stacked.inverted.segment:after {\n        background-color: $subtle-transparent-black;\n        border-top: 1px solid $selected-border-color;\n      }\n    }\n  }\n\n  /*-------------------\n        Padded\n  --------------------*/\n\n  .ui.padded.segment {\n    padding: $segment-padded-padding;\n  }\n\n  .ui[class*=\"very padded\"].segment {\n    padding: $segment-very-padded-padding;\n  }\n\n  /* Padded vertical */\n  .ui.padded.segment.vertical.segment,\n  .ui[class*=\"very padded\"].vertical.segment {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  /*-------------------\n        Compact\n  --------------------*/\n\n  .ui.compact.segment {\n    display: table;\n  }\n\n  /* Compact Group */\n  .ui.compact.segments {\n    display: inline-flex;\n  }\n  .ui.compact.segments .segment,\n  .ui.segments .compact.segment {\n    display: block;\n    flex: 0 1 auto;\n  }\n\n  /*-------------------\n        Circular\n  --------------------*/\n\n  .ui.circular.segment {\n    display: table-cell;\n    padding: $segment-circular-padding;\n    text-align: center;\n    vertical-align: middle;\n    border-radius: 500em;\n  }\n\n  /*-------------------\n        Raised\n  --------------------*/\n\n  .ui.raised.raised.segments,\n  .ui.raised.raised.segment {\n    box-shadow: $segment-raised-box-shadow;\n  }\n\n\n  /*******************************\n              Groups\n  *******************************/\n\n  /* Group */\n  .ui.segments {\n    flex-direction: column;\n    position: relative;\n    margin: $segment-grouped-super-margin;\n    border: $segment-grouped-super-border;\n    box-shadow: $segment-grouped-super-box-shadow;\n    border-radius: $segment-grouped-border-radius;\n  }\n  .ui.segments:first-child {\n    margin-top: 0;\n  }\n  .ui.segments:last-child {\n    margin-bottom: 0;\n  }\n\n\n  /* Nested Segment */\n  .ui.segments > .segment {\n    top: 0;\n    bottom: 0;\n    border-radius: 0;\n    margin: $segment-grouped-margin;\n    width: $segment-grouped-width;\n    box-shadow: $segment-grouped-box-shadow;\n    border: $segment-grouped-border;\n    border-top: $segment-grouped-divider;\n  }\n\n  .ui.segments:not(.horizontal) > .segment:first-child {\n    top: $segment-attached-top-offset;\n    bottom: 0;\n    border-top: none;\n    margin-top: 0;\n    margin-bottom: 0;\n    border-radius: $segment-border-radius $segment-border-radius 0 0;\n  }\n\n  /* Bottom */\n  .ui.segments:not(.horizontal) > .segment:last-child {\n    top: $segment-attached-bottom-offset;\n    bottom: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n    box-shadow: $segment-attached-bottom-box-shadow;\n    border-radius: 0 0 $segment-border-radius $segment-border-radius;\n  }\n\n  /* Only */\n  .ui.segments:not(.horizontal) > .segment:only-child {\n    border-radius: $segment-border-radius;\n  }\n\n\n  /* Nested Group */\n  .ui.segments > .ui.segments {\n    border-top: $segment-grouped-divider;\n    margin: $segment-nested-group-margin;\n  }\n  .ui.segments > .segments:first-child {\n    border-top: none;\n  }\n  .ui.segments > .segment + .segments:not(.horizontal) {\n    margin-top: 0;\n  }\n\n  /* Horizontal Group */\n  .ui.horizontal.segments {\n    display: flex;\n    flex-direction: row;\n    background-color: transparent;\n    padding: 0;\n    box-shadow: $segment-box-shadow;\n    margin: $segment-margin;\n    border-radius: $segment-border-radius;\n    border: $segment-border;\n  }\n  .ui.stackable.horizontal.segments {\n    flex-wrap: wrap;\n  }\n\n  /* Nested Horizontal Group */\n  .ui.segments > .horizontal.segments {\n    margin: 0;\n    background-color: transparent;\n    border-radius: 0;\n    border: none;\n    box-shadow: none;\n    border-top: $segment-grouped-divider;\n  }\n\n  /* Horizontal Segment */\n  .ui.horizontal.segments:not(.compact) > .segment:not(.compact) {\n    flex: 1 1 auto;\n    -ms-flex: 1 1 0; /* Solves #2550 MS Flex */\n  }\n  .ui.horizontal.segments > .segment {\n    margin: 0;\n    min-width: 0;\n    border-radius: 0;\n    border: none;\n    box-shadow: none;\n    border-left: $segment-border-width solid $border-color;\n  }\n\n  /* Border Fixes */\n  .ui.segments > .horizontal.segments:first-child {\n    border-top: none;\n  }\n  .ui.horizontal.segments:not(.stackable) > .segment:first-child {\n    border-left: none;\n  }\n\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------\n      Disabled\n  ---------------*/\n\n  .ui.disabled.segment {\n    opacity: $disabled-opacity;\n    color: $disabled-text-color;\n  }\n\n  /*--------------\n      Loading\n  ---------------*/\n\n  .ui.loading.segment {\n    position: relative;\n    cursor: default;\n    pointer-events: none;\n    text-shadow: none !important;\n    transition: all 0s linear;\n  }\n  .ui.loading.segment:before {\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 0;\n    background: $segment-loader-dimmer-color;\n    width: 100%;\n    height: 100%;\n    border-radius: $segment-border-radius;\n    z-index: $segment-loader-dimmer-z-index;\n  }\n  .ui.loading.segment:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n\n    margin: $loader-margin;\n    width: $segment-loader-size;\n    height: $segment-loader-size;\n\n    animation: loader $loader-speed infinite linear;\n    border: $loader-line-width solid $loader-line-color;\n    border-radius: $circular-radius;\n\n    box-shadow: 0 0 0 1px transparent;\n    visibility: visible;\n    z-index: $segment-loader-line-z-index;\n  }\n\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n\n  /*-------------------\n        Basic\n  --------------------*/\n\n  .ui.basic.segment,\n  .ui.segments .ui.basic.segment,\n  .ui.basic.segments {\n    background: $segment-basic-background;\n    box-shadow: $segment-basic-box-shadow;\n    border: $segment-basic-border;\n    border-radius: $segment-basic-border-radius;\n  }\n\n  /*-------------------\n        Clearing\n  --------------------*/\n\n  .ui.clearing.segment:after {\n    content: \"\";\n    display: block;\n    clear: both;\n  }\n\n  /*-------------------\n        Colors\n  --------------------*/\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-segment-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      @if not ($color==primary) and not ($color==secondary) {\n        .ui.#{$key + \"\"}.segment.segment.segment.segment.segment:not(.inverted) {\n          border-top: $segment-colored-border-size solid $c;\n        }\n        .ui.inverted.#{$key + \"\"}.segment.segment.segment.segment.segment {\n          background-color: $c;\n          color: $white;\n        }\n      }\n    }\n  }\n\n  /*-------------------\n        Aligned\n  --------------------*/\n\n  .ui[class*=\"left aligned\"].segment {\n    text-align: left;\n  }\n  .ui[class*=\"right aligned\"].segment {\n    text-align: right;\n  }\n  .ui[class*=\"center aligned\"].segment {\n    text-align: center;\n  }\n\n  /*-------------------\n        Floated\n  --------------------*/\n\n  .ui.floated.segment,\n  .ui[class*=\"left floated\"].segment {\n    float: left;\n    margin-right: $segment-floated-distance;\n  }\n  .ui[class*=\"right floated\"].segment {\n    float: right;\n    margin-left: $segment-floated-distance;\n  }\n\n\n  @if($use-segment-variation-inverted) {\n    /*-------------------\n          Inverted\n    --------------------*/\n\n    .ui.inverted.segment {\n      border: none;\n      box-shadow: none;\n    }\n    .ui.inverted.segment,\n    .ui.primary.inverted.segment {\n      background: $segment-inverted-background;\n      color: $inverted-text-color;\n    }\n\n    /* Nested */\n    .ui.inverted.segment .segment {\n      color: $text-color;\n    }\n    .ui.inverted.segment .inverted.segment {\n      color: $inverted-text-color;\n    }\n\n    /* Attached */\n    .ui.inverted.attached.segment {\n      border-color: $solid-white-border-color;\n    }\n\n    /* Loading */\n    .ui.inverted.loading.segment {\n      color: $inverted-loader-line-color;\n    }\n    .ui.inverted.loading.segment:before {\n      background: $segment-loader-inverted-dimmer-color;\n    }\n\n    .ui.secondary.inverted.segment {\n      background: $segment-secondary-inverted-background;\n      color: $segment-secondary-inverted-color;\n    }\n    \n    .ui.tertiary.inverted.segment {\n      background: $segment-tertiary-inverted-background;\n      color: $segment-tertiary-inverted-color;\n    }\n  }\n\n  /*-------------------\n      Emphasis\n  --------------------*/\n\n  /* Secondary */\n  .ui.secondary.segment {\n    background: $segment-secondary-background;\n    color: $segment-secondary-color;\n  }\n\n  /* Tertiary */\n  .ui.tertiary.segment {\n    background: $segment-tertiary-background;\n    color: $segment-tertiary-color;\n  }\n\n\n  @if($use-segment-variation-attached) {\n    /*-------------------\n          Attached\n    --------------------*/\n\n    /* Middle */\n    .ui.attached.segment {\n      top: 0;\n      bottom: 0;\n      border-radius: 0;\n      margin: 0 $segment-attached-horizontal-offset;\n      width: $segment-attached-width;\n      max-width: $segment-attached-width;\n      box-shadow: $segment-attached-box-shadow;\n      border: $segment-attached-border;\n    }\n    .ui.attached:not(.message) + .ui.attached.segment:not(.top) {\n      border-top: none;\n    }\n\n    /* Top */\n    .ui[class*=\"top attached\"].segment {\n      bottom: 0;\n      margin-bottom: 0;\n      top: $segment-attached-top-offset;\n      margin-top: $segment-vertical-margin;\n      border-radius: $segment-border-radius $segment-border-radius 0 0;\n    }\n    .ui.segment[class*=\"top attached\"]:first-child {\n      margin-top: 0;\n    }\n\n    /* Bottom */\n    .ui.segment[class*=\"bottom attached\"] {\n      bottom: 0;\n      margin-top: 0;\n      top: $segment-attached-bottom-offset;\n      margin-bottom: $segment-vertical-margin;\n      box-shadow: $segment-attached-bottom-box-shadow;\n      border-radius: 0 0 $segment-border-radius $segment-border-radius;\n    }\n    .ui.segment[class*=\"bottom attached\"]:last-child {\n      margin-bottom: $segment-vertical-margin;\n    }\n  }\n\n\n  /*--------------\n      Fitted\n  ---------------*/\n\n  .ui.fitted.segment:not(.horizontally) {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .ui.fitted.segment:not(.vertically) {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  /*-------------------\n          Size\n  --------------------*/\n\n  .ui.mini.segments .segment,\n  .ui.mini.segment {\n    font-size: $mini;\n  }\n  .ui.tiny.segments .segment,\n  .ui.tiny.segment {\n    font-size: $tiny;\n  }\n  .ui.small.segments .segment,\n  .ui.small.segment {\n    font-size: $small;\n  }\n  .ui.segments .segment,\n  .ui.segment {\n    font-size: $medium;\n  }\n  .ui.large.segments .segment,\n  .ui.large.segment {\n    font-size: $large;\n  }\n  .ui.big.segments .segment,\n  .ui.big.segment {\n    font-size: $big;\n  }\n  .ui.huge.segments .segment,\n  .ui.huge.segment {\n    font-size: $huge;\n  }\n  .ui.massive.segments .segment,\n  .ui.massive.segment {\n    font-size: $massive;\n  }\n}\n\n@import '../../themes/default/elements/segment.style';","@import '../../themes/default/elements/step.variables';\n\n@if $use-step {\n  /*******************************\n  //@-        Step\n  *******************************/\n\n  .ui.steps {\n    display: inline-flex;\n    flex-direction: row;\n    align-items: stretch;\n    margin: $step-margin;\n    background: $step-steps-background;\n    box-shadow: $step-steps-box-shadow;\n    line-height: $step-line-height;\n    border-radius: $step-steps-border-radius;\n    border: $step-steps-border;\n  }\n  .ui.steps:not(.unstackable) {\n    flex-wrap: wrap;\n  }\n\n  /* First Steps */\n  .ui.steps:first-child {\n    margin-top: 0;\n  }\n\n  /* Last Steps */\n  .ui.steps:last-child {\n    margin-bottom: 0;\n  }\n\n\n  /*******************************\n            Singular\n  *******************************/\n\n  .ui.steps .step {\n    position: relative;\n    display: flex;\n    flex: 1 0 auto;\n    flex-wrap: wrap;\n    flex-direction: row;\n    vertical-align: middle;\n    align-items: center;\n    justify-content: $step-justify-content;\n\n    margin: $step-vertical-margin $step-horizontal-margin;\n    padding: $step-vertical-padding $step-horizontal-padding;\n    background: $step-background;\n    color: $text-color;\n    box-shadow: $step-box-shadow;\n    border-radius: $step-border-radius;\n    border: $step-border;\n    border-right: $step-divider;\n    transition: $step-transition;\n  }\n\n  /* Arrow */\n  .ui.steps .step:after {\n    display: none;\n    position: absolute;\n    z-index: 2;\n    content: '';\n    top: $step-arrow-top-offset;\n    right: $step-arrow-right-offset;\n    border: medium none;\n    background-color: $step-arrow-background-color;\n    width: $step-arrow-size;\n    height: $step-arrow-size;\n\n    border-style: solid;\n    border-color: $border-color;\n    border-width: $step-arrow-border-width;\n\n    transition: $step-transition;\n    transform: translateY(-50%) translateX(50%) rotate(-45deg);\n  }\n\n  /* First Step */\n  .ui.steps .step:first-child {\n    padding-left: $step-horizontal-padding;\n    border-radius: $step-steps-border-radius 0 0 $step-steps-border-radius;\n  }\n\n  /* Last Step */\n  .ui.steps .step:last-child {\n    border-radius: 0 $step-steps-border-radius $step-steps-border-radius 0;\n    border-right: none;\n    margin-right: 0;\n  }\n\n  /* Only Step */\n  .ui.steps .step:only-child {\n    border-radius: $step-steps-border-radius;\n  }\n\n\n  /*******************************\n              Content\n  *******************************/\n\n  /* Title */\n  .ui.steps .step .title {\n    font-family: $step-title-font-family;\n    font-size: $step-title-font-size;\n    font-weight: $step-title-font-weight;\n  }\n  .ui.steps .step > .title {\n    width: 100%;\n  }\n\n  /* Description */\n  .ui.steps .step .description {\n    font-weight: $step-description-font-weight;\n    font-size: $step-description-font-size;\n    color: $step-description-color;\n  }\n  .ui.steps .step > .description {\n    width: 100%;\n  }\n  .ui.steps .step .title ~ .description {\n    margin-top: $step-description-distance;\n  }\n\n  /* Icon */\n  .ui.steps .step > .icon {\n    line-height: 1;\n    font-size: $step-icon-size;\n    margin: 0 $step-icon-distance 0 0;\n  }\n  .ui.steps .step > .icon,\n  .ui.steps .step > .icon ~ .content {\n    display: block;\n    flex: 0 1 auto;\n    align-self: $step-icon-align;\n  }\n\n  /* Horizontal Icon */\n  .ui.steps:not(.vertical) .step > .icon {\n    width: auto;\n  }\n\n  /* Link */\n  .ui.steps .link.step,\n  .ui.steps a.step {\n    cursor: pointer;\n  }\n\n  /*******************************\n              Types\n  *******************************/\n\n  @if($use-step-type-ordered) {\n    /*--------------\n        Ordered\n    ---------------*/\n\n    .ui.ordered.steps {\n      counter-reset: ordered;\n    }\n    .ui.ordered.steps .step:before {\n      display: block;\n      position: static;\n      text-align: center;\n      content: counter(ordered);\n      align-self: $step-icon-align;\n      margin-right: $step-icon-distance;\n      font-size: $step-icon-size;\n      counter-increment: ordered;\n      font-family: $step-ordered-font-family;\n      font-weight: $step-ordered-font-weight;\n    }\n\n    .ui.ordered.steps .step > * {\n      display: block;\n      align-self: $step-icon-align;\n    }\n  }\n\n  @if($use-step-type-vertical) {\n    /*--------------\n        Vertical\n    ---------------*/\n\n    .ui.vertical.steps {\n      display: inline-flex;\n      flex-direction: column;\n      overflow: visible;\n    }\n    .ui.vertical.steps .step {\n      justify-content: flex-start;\n      border-radius: $step-border-radius;\n      padding: $step-vertical-padding $step-horizontal-padding;\n      border-right: none;\n      border-bottom: $step-vertical-divider;\n    }\n    .ui.vertical.steps .step:first-child {\n      padding: $step-vertical-padding $step-horizontal-padding;\n      border-radius: $step-steps-border-radius $step-steps-border-radius 0 0;\n    }\n    .ui.vertical.steps .step:last-child {\n      border-bottom: none;\n      border-radius: 0 0 $step-steps-border-radius $step-steps-border-radius;\n    }\n    .ui.vertical.steps .step:only-child {\n      border-radius: $step-steps-border-radius;\n    }\n\n\n    /* Arrow */\n    .ui.vertical.steps .step:after {\n      top: $step-vertical-arrow-top-offset;\n      right: $step-vertical-arrow-right-offset;\n      border-width: $step-vertical-arrow-border-width;\n      display: $step-vertical-arrow-display;\n    }\n\n    .ui.vertical.steps .active.step:after {\n      display: $step-vertical-active-arrow-display;\n    }\n    .ui.vertical.steps .step:last-child:after {\n      display: $step-vertical-last-arrow-display;\n    }\n    .ui.vertical.steps .active.step:last-child:after {\n      display: $step-vertical-active-last-arrow-display;\n    }\n  }\n\n  /*---------------\n      Responsive\n  ----------------*/\n\n  /* Mobile (Default) */\n  @media only screen and (max-width: ($largest-mobile-screen)) {\n\n    .ui.steps:not(.unstackable) {\n      display: inline-flex;\n      overflow: visible;\n      flex-direction: column;\n    }\n    .ui.steps:not(.unstackable) .step {\n      width: 100% !important;\n      flex-direction: column;\n      border-radius: $step-border-radius;\n      padding: $step-vertical-padding $step-horizontal-padding;\n      border-right: none;\n      border-bottom: $step-steps-border;\n    }\n    .ui.steps:not(.unstackable) .step:first-child {\n      padding: $step-vertical-padding $step-horizontal-padding;\n      border-radius: $step-steps-border-radius $step-steps-border-radius 0 0;\n    }\n    .ui.steps:not(.unstackable) .step:last-child {\n      border-radius: 0 0 $step-steps-border-radius $step-steps-border-radius;\n      border-bottom: none;\n    }\n\n    /* Arrow */\n    .ui.steps:not(.unstackable) .step:after {\n      top: unset;\n      bottom: -$step-arrow-size;\n      right: 50%;\n      transform: translateY(-50%) translateX(50%) rotate(45deg);\n    }\n    .ui.vertical.steps .active.step:last-child:after {\n      display: none;\n    }\n    /* Content */\n    .ui.steps:not(.unstackable) .step .content {\n      text-align: center;\n    }\n\n    /* Icon */\n    .ui.steps:not(.unstackable) .step > .icon,\n    .ui.ordered.steps:not(.unstackable) .step:before {\n      margin: 0 0 $step-mobile-icon-distance 0;\n    }\n\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  /* Link Hover */\n  .ui.steps .link.step:hover::after,\n  .ui.steps .link.step:hover,\n  .ui.steps a.step:hover::after,\n  .ui.steps a.step:hover {\n    background: $step-hover-background;\n    color: $step-hover-color;\n  }\n\n  /* Link Down */\n  .ui.steps .link.step:active::after,\n  .ui.steps .link.step:active,\n  .ui.steps a.step:active::after,\n  .ui.steps a.step:active {\n    background: $step-down-background;\n    color: $step-down-color;\n  }\n\n  /* Active */\n  .ui.steps .step.active {\n    cursor: auto;\n    background: $step-active-background;\n  }\n  .ui.steps .step.active:after {\n    background: $step-active-background;\n  }\n  .ui.steps .step.active .title {\n    color: $step-active-color;\n  }\n  .ui.ordered.steps .step.active:before,\n  .ui.steps .active.step .icon {\n    color: $step-active-icon-color;\n  }\n\n  /* Active Arrow */\n  .ui.steps .step:after {\n    display: $step-arrow-display;\n  }\n  .ui.steps .active.step:after {\n    display: $step-active-arrow-display;\n  }\n  .ui.steps .step:last-child:after {\n    display: $step-last-arrow-display;\n  }\n  .ui.steps .active.step:last-child:after {\n    display: $step-active-last-arrow-display;\n  }\n\n  /* Active Hover */\n  .ui.steps .link.active.step:hover::after,\n  .ui.steps .link.active.step:hover,\n  .ui.steps a.active.step:hover::after,\n  .ui.steps a.active.step:hover {\n    cursor: pointer;\n    background: $step-active-hover-background;\n    color: $step-active-hover-color;\n  }\n\n  /* Completed */\n  .ui.steps .step.completed > .icon:before,\n  .ui.ordered.steps .step.completed:before {\n    color: $step-completed-color;\n  }\n\n  /* Disabled */\n  .ui.steps .disabled.step {\n    cursor: auto;\n    background: $step-disabled-background;\n    pointer-events: none;\n  }\n  .ui.steps .disabled.step,\n  .ui.steps .disabled.step .title,\n  .ui.steps .disabled.step .description {\n    color: $step-disabled-color;\n  }\n  .ui.steps .disabled.step:after {\n    background: $step-disabled-background;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n\n  /*--------------\n    Stackable\n  ---------------*/\n\n  /* Tablet Or Below */\n  @media only screen and (max-width: $largest-tablet-screen) {\n\n  .ui[class*=\"tablet stackable\"].steps {\n    display: inline-flex;\n    overflow: visible;\n    flex-direction: column;\n  }\n\n  /* Steps */\n  .ui[class*=\"tablet stackable\"].steps .step {\n    flex-direction: column;\n    border-radius: $step-border-radius;\n    padding: $step-vertical-padding $step-horizontal-padding;\n    border-right: none;\n    border-bottom: $step-steps-border;\n  }\n  .ui[class*=\"tablet stackable\"].steps .step:first-child {\n    padding: $step-vertical-padding $step-horizontal-padding;\n    border-radius: $step-steps-border-radius $step-steps-border-radius 0 0;\n  }\n  .ui[class*=\"tablet stackable\"].steps .step:last-child {\n    border-radius: 0 0 $step-steps-border-radius $step-steps-border-radius;\n    border-bottom: none;\n  }\n\n  /* Arrow */\n  .ui[class*=\"tablet stackable\"].steps .step:after {\n    top: unset;\n    bottom: -$step-arrow-size;\n    right: 50%;\n    transform: translateY(-50%) translateX(50%) rotate(45deg);\n  }\n\n  /* Content */\n  .ui[class*=\"tablet stackable\"].steps .step .content {\n    text-align: center;\n  }\n\n  /* Icon */\n  .ui[class*=\"tablet stackable\"].steps .step > .icon,\n  .ui[class*=\"tablet stackable\"].ordered.steps .step:before {\n    margin: 0 0 $step-mobile-icon-distance 0;\n  }\n\n  }\n\n  /*--------------\n        Fluid\n  ---------------*/\n\n  /* Fluid */\n  .ui.fluid.steps {\n    display: flex;\n    width: 100%;\n  }\n\n\n  @if($use-step-variation-attached) {\n    /*--------------\n        Attached\n    ---------------*/\n\n    /* Top */\n    .ui.attached.steps {\n      width: $step-attached-width !important;\n      margin: 0 $step-attached-horizontal-offset $step-attached-vertical-offset;\n      max-width: $step-attached-width;\n      border-radius: $step-steps-border-radius $step-steps-border-radius 0 0;\n    }\n    .ui.attached.steps .step:first-child {\n      border-radius: $step-steps-border-radius 0 0 0;\n    }\n    .ui.attached.steps .step:last-child {\n      border-radius: 0 $step-steps-border-radius 0 0;\n    }\n\n    /* Bottom */\n    .ui.bottom.attached.steps {\n      margin: $step-attached-vertical-offset $step-attached-horizontal-offset 0;\n      border-radius: 0 0 $step-steps-border-radius $step-steps-border-radius;\n    }\n    .ui.bottom.attached.steps .step:first-child {\n      border-radius: 0 0 0 $step-steps-border-radius;\n    }\n    .ui.bottom.attached.steps .step:last-child {\n      border-radius: 0 0 $step-steps-border-radius 0;\n    }\n  }\n\n  /*-------------------\n      Evenly Divided\n  --------------------*/\n\n  .ui.one.steps,\n  .ui.two.steps,\n  .ui.three.steps,\n  .ui.four.steps,\n  .ui.five.steps,\n  .ui.six.steps,\n  .ui.seven.steps,\n  .ui.eight.steps {\n    width: 100%;\n  }\n  .ui.one.steps > .step,\n  .ui.two.steps > .step,\n  .ui.three.steps > .step,\n  .ui.four.steps > .step,\n  .ui.five.steps > .step,\n  .ui.six.steps > .step,\n  .ui.seven.steps > .step,\n  .ui.eight.steps > .step {\n    flex-wrap: nowrap;\n  }\n  .ui.one.steps > .step {\n    width: 100%;\n  }\n  .ui.two.steps > .step {\n    width: 50%;\n  }\n  .ui.three.steps > .step {\n    width: 33.333%;\n  }\n  .ui.four.steps > .step {\n    width: 25%;\n  }\n  .ui.five.steps > .step {\n    width: 20%;\n  }\n  .ui.six.steps > .step {\n    width: 16.666%;\n  }\n  .ui.seven.steps > .step {\n    width: 14.285%;\n  }\n  .ui.eight.steps > .step {\n    width: 12.500%;\n  }\n\n  /*-------------------\n        Sizes\n  --------------------*/\n\n\n  .ui.mini.steps .step,\n  .ui.mini.step {\n    font-size: $mini;\n  }\n  .ui.tiny.steps .step,\n  .ui.tiny.step {\n    font-size: $tiny;\n  }\n  .ui.small.steps .step,\n  .ui.small.step {\n    font-size: $small;\n  }\n  .ui.steps .step,\n  .ui.step {\n    font-size: $medium;\n  }\n  .ui.large.steps .step,\n  .ui.large.step {\n    font-size: $large;\n  }\n  .ui.big.steps .step,\n  .ui.big.step {\n    font-size: $big;\n  }\n  .ui.huge.steps .step,\n  .ui.huge.step {\n    font-size: $huge;\n  }\n  .ui.massive.steps .step,\n  .ui.massive.step {\n    font-size: $massive;\n  }\n\n\n  @if($use-step-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n\n    .ui.inverted.steps {\n      border: 1px solid $solid-white-border-color;\n    }\n\n    .ui.inverted.steps .step {\n      color: $inverted-text-color;\n      background: $black;\n      border-color: $solid-white-border-color;\n    }\n\n    .ui.inverted.steps .step:after {\n      background-color: $black;\n      border-color: $solid-white-border-color;\n    }\n\n    .ui.inverted.steps .step .description {\n      color: $inverted-text-color;\n    }\n\n    /* Active */\n    .ui.inverted.steps .step.active,\n    .ui.inverted.steps .step.active:after {\n      background: $step-inverted-active-background;\n    }\n    .ui.inverted.ordered.steps .step.active:before,\n    .ui.inverted.steps .active.step .icon {\n      color: $inverted-selected-text-color;\n    }\n\n    /* Disabled */\n    .ui.inverted.steps .disabled.step,\n    .ui.inverted.steps .disabled.step:after {\n      background: $step-inverted-disabled-background;\n    }\n    .ui.inverted.steps .disabled.step,\n    .ui.inverted.steps .disabled.step .title,\n    .ui.inverted.steps .disabled.step .description {\n      color: $inverted-disabled-text-color;\n    }\n\n    /* Link Hover */\n    .ui.inverted.steps .link.step:hover::after,\n    .ui.inverted.steps .link.step:hover,\n    .ui.inverted.steps a.step:hover::after,\n    .ui.inverted.steps a.step:hover {\n      background: $step-inverted-hover-background;\n      color: $inverted-hovered-text-color;\n    }\n\n    /* Link Down */\n    .ui.inverted.steps .link.step:active::after,\n    .ui.inverted.steps .link.step:active,\n    .ui.inverted.steps a.step:active::after,\n    .ui.inverted.steps a.step:active {\n      background: $step-inverted-active-hover-background;\n      color: $inverted-pressed-text-color;\n    }\n  }\n}\n\n@import '../../themes/default/elements/step.style';","@import '../../themes/default/elements/text.variables';\n\n@if $use-text {\n  /*******************************\n  //@-         Text\n  *******************************/\n\n  @each $key, $value in $colors {\n    $color: $key;\n    $c: map-get($value, color);\n    $l: map-get($value, light);\n\n    span.ui.#{$key + \"\"}.text {\n      color: $c;\n    }\n    span.ui.inverted.#{$key + \"\"}.text {\n      color: $l;\n    }\n  }\n\n  span.ui.disabled.text {\n    opacity: $disabled-opacity;\n  }\n\n  /* Sizes */\n  span.ui.mini.text {\n    font-size: $text-mini;\n  }\n  span.ui.tiny.text {\n    font-size: $text-tiny;\n  }\n  span.ui.small.text {\n    font-size: $text-small;\n  }\n  span.ui.medium.text {\n    font-size: $text-medium;\n  }\n  span.ui.large.text {\n    font-size: $text-large;\n  }\n  span.ui.big.text {\n    font-size: $text-big;\n  }\n  span.ui.huge.text {\n    font-size: $text-huge;\n  }\n  span.ui.massive.text {\n    font-size: $text-massive;\n  }\n}\n\n@import '../../themes/default/elements/text.style';","@import '../../themes/default/collections/breadcrumb.variables';\n\n@if $use-breadcrumb {\n  /*******************************\n  //@-       Breadcrumb\n  *******************************/\n\n  .ui.breadcrumb {\n    line-height: $line-height;\n    display: $breadcrumb-display;\n    margin: $breadcrumb-vertical-margin 0;\n    vertical-align: $breadcrumb-vertical-align;\n  }\n  .ui.breadcrumb:first-child {\n    margin-top: 0;\n  }\n  .ui.breadcrumb:last-child {\n    margin-bottom: 0;\n  }\n\n  /*******************************\n            Content\n  *******************************/\n\n  /* Divider */\n  .ui.breadcrumb .divider {\n    display: inline-block;\n    opacity: $breadcrumb-divider-opacity;\n    margin: 0 $breadcrumb-divider-spacing 0;\n\n    font-size: $breadcrumb-divider-size;\n    color: $breadcrumb-divider-color;\n    vertical-align: $breadcrumb-divider-vertical-align;\n  }\n\n  /* Link */\n  .ui.breadcrumb a {\n    color: $link-color;\n  }\n  .ui.breadcrumb a:hover {\n    color: $link-hover-color;\n  }\n\n\n  /* Icon Divider */\n  .ui.breadcrumb .icon.divider {\n    font-size: $breadcrumb-icon-divider-size;\n    vertical-align: $breadcrumb-icon-divider-vertical-align;\n  }\n\n  /* Section */\n  .ui.breadcrumb a.section {\n    cursor: pointer;\n  }\n  .ui.breadcrumb .section {\n    display: inline-block;\n    margin: $breadcrumb-section-margin;\n    padding: $breadcrumb-section-padding;\n  }\n\n  /* Loose Coupling */\n  .ui.breadcrumb.segment {\n    display: inline-block;\n    padding: $breadcrumb-segment-padding;\n  }\n\n  @if ($use-breadcrumb-variation-inverted) {\n    /* Inverted */\n    .ui.inverted.breadcrumb {\n      color: $breadcrumb-inverted-color;\n    }\n    .ui.inverted.breadcrumb > .active.section {\n      color: $breadcrumb-inverted-active-color;\n    }\n    .ui.inverted.breadcrumb > .divider {\n      color: $breadcrumb-inverted-divider-color;\n    }\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  .ui.breadcrumb .active.section {\n    font-weight: $breadcrumb-active-font-weight;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  .ui.mini.breadcrumb {\n    font-size: $mini;\n  }\n  .ui.tiny.breadcrumb {\n    font-size: $tiny;\n  }\n  .ui.small.breadcrumb {\n    font-size: $small;\n  }\n  .ui.breadcrumb {\n    font-size: $medium;\n  }\n  .ui.large.breadcrumb {\n    font-size: $large;\n  }\n  .ui.big.breadcrumb {\n    font-size: $big;\n  }\n  .ui.huge.breadcrumb {\n    font-size: $huge;\n  }\n  .ui.massive.breadcrumb {\n    font-size: $massive;\n  }\n}\n\n@import '../../themes/default/collections/breadcrumb.style';","@import '../../themes/default/collections/form.variables';\n\n@if $use-form {\n  /*--------------------\n  //@-     Form\n  ---------------------*/\n\n  .ui.form {\n    position: relative;\n    max-width: 100%;\n  }\n\n  /*--------------------\n          Content\n  ---------------------*/\n\n  .ui.form > p {\n    margin: $form-paragraph-margin;\n  }\n\n  /*--------------------\n          Field\n  ---------------------*/\n\n  .ui.form .field {\n    clear: both;\n    margin: $form-field-margin;\n  }\n\n  .ui.form .field:last-child,\n  .ui.form .fields:last-child .field {\n    margin-bottom: 0;\n  }\n\n  .ui.form .fields .field {\n    clear: both;\n    margin: 0;\n  }\n\n\n  /*--------------------\n          Labels\n  ---------------------*/\n\n  .ui.form .field > label {\n    display: block;\n    margin: $form-label-margin;\n    color: $form-label-color;\n    font-size: $form-label-font-size;\n    font-weight: $form-label-font-weight;\n    text-transform: $form-label-text-transform;\n  }\n\n  /*--------------------\n      Standard Inputs\n  ---------------------*/\n\n\n  .ui.form textarea,\n  .ui.form input:not([type]),\n  .ui.form input[type=\"date\"],\n  .ui.form input[type=\"datetime-local\"],\n  .ui.form input[type=\"email\"],\n  .ui.form input[type=\"number\"],\n  .ui.form input[type=\"password\"],\n  .ui.form input[type=\"search\"],\n  .ui.form input[type=\"tel\"],\n  .ui.form input[type=\"time\"],\n  .ui.form input[type=\"text\"],\n  .ui.form input[type=\"file\"],\n  .ui.form input[type=\"url\"] {\n    width: $form-input-width;\n    vertical-align: top;\n  }\n\n  /* Set max height on unusual input */\n  .ui.form ::-webkit-datetime-edit,\n  .ui.form ::-webkit-inner-spin-button {\n    height: $input-line-height;\n  }\n\n  .ui.form input:not([type]),\n  .ui.form input[type=\"date\"],\n  .ui.form input[type=\"datetime-local\"],\n  .ui.form input[type=\"email\"],\n  .ui.form input[type=\"number\"],\n  .ui.form input[type=\"password\"],\n  .ui.form input[type=\"search\"],\n  .ui.form input[type=\"tel\"],\n  .ui.form input[type=\"time\"],\n  .ui.form input[type=\"text\"],\n  .ui.form input[type=\"file\"],\n  .ui.form input[type=\"url\"] {\n    font-family: $form-input-font;\n    margin: 0;\n    outline: none;\n    -webkit-appearance: none;\n    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);\n\n    line-height: $input-line-height;\n    padding: $form-input-padding;\n    font-size: $form-input-font-size;\n\n    background: $input-background;\n    border: $form-input-border;\n    color: $form-input-color;\n    border-radius: $form-input-border-radius;\n    box-shadow: $form-input-box-shadow;\n    transition: $form-input-transition;\n  }\n\n  /* Text Area */\n  .ui.input textarea,\n  .ui.form textarea {\n    margin: 0;\n    -webkit-appearance: none;\n    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);\n\n    padding: $form-text-area-padding;\n    background: $form-text-area-background;\n    border: $form-text-area-border;\n    outline: none;\n    color: $form-input-color;\n    border-radius: $form-input-border-radius;\n    box-shadow: $form-input-box-shadow;\n    transition: $form-text-area-transition;\n    font-size: $form-text-area-font-size;\n    font-family: $form-input-font;\n    line-height: $form-text-area-line-height;\n    resize: $form-text-area-resize;\n  }\n  .ui.form textarea:not([rows]) {\n    height: $form-text-area-height;\n    min-height: $form-text-area-min-height;\n    max-height: $form-text-area-max-height;\n  }\n\n  .ui.form textarea,\n  .ui.form input[type=\"checkbox\"] {\n    vertical-align: $form-checkbox-vertical-align;\n  }\n\n  /*--------------------\n      Checkbox margin\n  ---------------------*/\n\n  .ui.form .fields:not(.grouped):not(.inline) .field:not(:only-child) label + .ui.ui.checkbox {\n    margin-top: $form-checkbox-label-field-top-margin;\n  }\n  .ui.form .fields:not(.grouped):not(.inline) .field:not(:only-child) .ui.checkbox {\n    margin-top: $input-line-height + $form-checkbox-field-top-margin;\n  }\n  .ui.form .fields:not(.grouped):not(.inline) .field:not(:only-child) .ui.toggle.checkbox {\n    margin-top: $input-line-height + $form-checkbox-toggle-field-top-margin;\n  }\n  .ui.form .fields:not(.grouped):not(.inline) .field:not(:only-child) .ui.slider.checkbox {\n    margin-top: $input-line-height + $form-checkbox-slider-field-top-margin;\n  }\n  .ui.ui.form .field .fields .field:not(:only-child) .ui.checkbox {\n    margin-top: $form-checkbox-field-top-margin / 2;\n  }\n  .ui.ui.form .field .fields .field:not(:only-child) .ui.toggle.checkbox {\n    margin-top: $form-checkbox-toggle-field-top-margin / 2;\n  }\n  .ui.ui.form .field .fields .field:not(:only-child) .ui.slider.checkbox {\n    margin-top: $form-checkbox-slider-field-top-margin / 2;\n  }\n\n  /*--------------------\n        Transparent\n  ---------------------*/\n\n  .ui.form .field .transparent.input:not(.icon) input,\n  .ui.form .field input.transparent,\n  .ui.form .field textarea.transparent {\n    padding: $form-transparent-padding;\n  }\n\n  .ui.form .field input.transparent,\n  .ui.form .field textarea.transparent {\n    border-color: transparent !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n  }\n\n  .ui.form .field.error .transparent.input input,\n  .ui.form .field.error .transparent.input textarea,\n  .ui.form .field.error input.transparent,\n  .ui.form .field.error textarea.transparent {\n    background-color: $form-transparent-error-background !important;\n    color: $form-transparent-error-color !important;\n  }\n\n  /*--------------------------\n    Input w/ attached Button\n  ---------------------------*/\n\n  .ui.form input.attached {\n    width: auto;\n  }\n\n\n  /*--------------------\n      Basic Select\n  ---------------------*/\n\n  .ui.form select {\n    display: block;\n    height: auto;\n    width: 100%;\n    background: $form-select-background;\n    border: $form-select-border;\n    border-radius: $form-select-border-radius;\n    box-shadow: $form-select-box-shadow;\n    padding: $form-select-padding;\n    color: $form-select-color;\n    transition: $form-select-transition;\n  }\n\n  /*--------------------\n        Dropdown\n  ---------------------*/\n\n  /* Block */\n  .ui.form .field > .selection.dropdown {\n    min-width: auto;\n    width: 100%;\n  }\n  .ui.form .field > .selection.dropdown > .dropdown.icon {\n    float: right;\n  }\n\n  /* Inline */\n  .ui.form .inline.fields .field > .selection.dropdown,\n  .ui.form .inline.field > .selection.dropdown {\n    width: auto;\n  }\n  .ui.form .inline.fields .field > .selection.dropdown > .dropdown.icon,\n  .ui.form .inline.field > .selection.dropdown > .dropdown.icon {\n    float: none;\n  }\n\n  /*--------------------\n        UI Input\n  ---------------------*/\n\n  /* Block */\n  .ui.form .field .ui.input,\n  .ui.form .fields .field .ui.input,\n  .ui.form .wide.field .ui.input {\n    width: 100%;\n  }\n\n  /* Inline  */\n  .ui.form .inline.fields .field:not(.wide) .ui.input,\n  .ui.form .inline.field:not(.wide) .ui.input {\n    width: auto;\n    vertical-align: middle;\n  }\n\n  /* Auto Input */\n  .ui.form .fields .field .ui.input input,\n  .ui.form .field .ui.input input {\n    width: auto;\n  }\n\n  /* Full Width Input */\n  .ui.form .ten.fields .ui.input input,\n  .ui.form .nine.fields .ui.input input,\n  .ui.form .eight.fields .ui.input input,\n  .ui.form .seven.fields .ui.input input,\n  .ui.form .six.fields .ui.input input,\n  .ui.form .five.fields .ui.input input,\n  .ui.form .four.fields .ui.input input,\n  .ui.form .three.fields .ui.input input,\n  .ui.form .two.fields .ui.input input,\n  .ui.form .wide.field .ui.input input {\n    flex: 1 0 auto;\n    width: 0;\n  }\n\n\n  /*--------------------\n    Types of Messages\n  ---------------------*/\n\n  .ui.form .success.message,\n  .ui.form .warning.message,\n  .ui.form .error.message,\n  .ui.form .error.message:empty {\n    display: none;\n  }\n\n  /* Assumptions */\n  .ui.form .message:first-child {\n    margin-top: 0;\n  }\n\n  /*--------------------\n    Validation Prompt\n  ---------------------*/\n\n  .ui.form .field .prompt.label {\n    white-space: normal;\n    background: $form-prompt-background !important;\n    border: $form-prompt-border !important;\n    color: $form-prompt-text-color !important;\n  }\n  .ui.form .inline.fields .field .prompt,\n  .ui.form .inline.field .prompt {\n    vertical-align: top;\n    margin: $form-inline-prompt-margin;\n  }\n  .ui.form .inline.fields .field .prompt:before,\n  .ui.form .inline.field .prompt:before {\n    border-width: 0 0 $form-inline-prompt-border-width $form-inline-prompt-border-width;\n    bottom: auto;\n    right: auto;\n    top: 50%;\n    left: 0;\n  }\n\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------------\n        Autofilled\n  ---------------------*/\n\n  .ui.form .field.field input:-webkit-autofill {\n    box-shadow: 0 0 0 100px $form-input-auto-fill-background inset !important;\n    border-color: $form-input-auto-fill-border !important;\n  }\n\n  /* Focus */\n  .ui.form .field.field input:-webkit-autofill:focus {\n    box-shadow: 0 0 0 100px $form-input-auto-fill-focus-background inset !important;\n    border-color: $form-input-auto-fill-focus-border !important;\n  }\n\n  /* Error */\n  .ui.form .error.error input:-webkit-autofill {\n    box-shadow: 0 0 0 100px $form-input-auto-fill-error-background inset !important;\n    border-color: $form-input-auto-fill-error-border !important;\n  }\n\n\n\n  /*--------------------\n        Placeholder\n  ---------------------*/\n\n  /* browsers require these rules separate */\n  .ui.form ::-webkit-input-placeholder {\n    color: $input-placeholder-color;\n  }\n  .ui.form :-ms-input-placeholder {\n    color: $input-placeholder-color !important;\n  }\n  .ui.form ::-moz-placeholder {\n    color: $input-placeholder-color;\n  }\n\n  .ui.form :focus::-webkit-input-placeholder {\n    color: $input-placeholder-focus-color;\n  }\n  .ui.form :focus:-ms-input-placeholder {\n    color: $input-placeholder-focus-color !important;\n  }\n  .ui.form :focus::-moz-placeholder {\n    color: $input-placeholder-focus-color;\n  }\n\n  /* Error Placeholder */\n  .ui.form .error ::-webkit-input-placeholder {\n    color: $form-input-error-placeholder-color;\n  }\n  .ui.form .error :-ms-input-placeholder {\n    color: $form-input-error-placeholder-color !important;\n  }\n  .ui.form .error ::-moz-placeholder {\n    color: $form-input-error-placeholder-color;\n  }\n\n  .ui.form .error :focus::-webkit-input-placeholder {\n    color: $form-input-error-placeholder-focus-color;\n  }\n  .ui.form .error :focus:-ms-input-placeholder {\n    color: $form-input-error-placeholder-focus-color !important;\n  }\n  .ui.form .error :focus::-moz-placeholder {\n    color: $form-input-error-placeholder-focus-color;\n  }\n\n\n  /*--------------------\n          Focus\n  ---------------------*/\n\n  .ui.form input:not([type]):focus,\n  .ui.form input[type=\"date\"]:focus,\n  .ui.form input[type=\"datetime-local\"]:focus,\n  .ui.form input[type=\"email\"]:focus,\n  .ui.form input[type=\"number\"]:focus,\n  .ui.form input[type=\"password\"]:focus,\n  .ui.form input[type=\"search\"]:focus,\n  .ui.form input[type=\"tel\"]:focus,\n  .ui.form input[type=\"time\"]:focus,\n  .ui.form input[type=\"text\"]:focus,\n  .ui.form input[type=\"file\"]:focus,\n  .ui.form input[type=\"url\"]:focus {\n    color: $form-input-focus-color;\n    border-color: $form-input-focus-border-color;\n    border-radius: $form-input-focus-border-radius;\n    background: $form-input-focus-background;\n    box-shadow: $form-input-focus-box-shadow;\n  }\n  .ui.form textarea:focus {\n    color: $form-text-area-focus-color;\n    border-color: $form-text-area-focus-border-color;\n    border-radius: $form-text-area-focus-border-radius;\n    background: $form-text-area-focus-background;\n    box-shadow: $form-text-area-focus-box-shadow;\n    -webkit-appearance: none;\n  }\n\n\n  /*--------------------\n          Success\n  ---------------------*/\n\n  /* On Form */\n  .ui.form.success .success.message:not(:empty) {\n    display: block;\n  }\n  .ui.form.success .compact.success.message:not(:empty) {\n    display: inline-block;\n  }\n  .ui.form.success .icon.success.message:not(:empty) {\n    display: flex;\n  }\n\n  /*--------------------\n          Warning\n  ---------------------*/\n\n  /* On Form */\n  .ui.form.warning .warning.message:not(:empty) {\n    display: block;\n  }\n  .ui.form.warning .compact.warning.message:not(:empty) {\n    display: inline-block;\n  }\n  .ui.form.warning .icon.warning.message:not(:empty) {\n    display: flex;\n  }\n\n  /*--------------------\n          Error\n  ---------------------*/\n\n  /* On Form */\n  .ui.form.error .error.message:not(:empty) {\n    display: block;\n  }\n  .ui.form.error .compact.error.message:not(:empty) {\n    display: inline-block;\n  }\n  .ui.form.error .icon.error.message:not(:empty) {\n    display: flex;\n  }\n\n  /* On Field(s) */\n  .ui.ui.form .fields.error .field label,\n  .ui.ui.form .field.error label,\n  .ui.ui.form .fields.error .field .input,\n  .ui.ui.form .field.error .input {\n    color: $form-error-color;\n  }\n\n  .ui.form .fields.error .field .corner.label,\n  .ui.form .field.error .corner.label {\n    border-color: $form-error-color;\n    color: $white;\n  }\n\n  .ui.form .fields.error .field textarea,\n  .ui.form .fields.error .field select,\n  .ui.form .fields.error .field input:not([type]),\n  .ui.form .fields.error .field input[type=\"date\"],\n  .ui.form .fields.error .field input[type=\"datetime-local\"],\n  .ui.form .fields.error .field input[type=\"email\"],\n  .ui.form .fields.error .field input[type=\"number\"],\n  .ui.form .fields.error .field input[type=\"password\"],\n  .ui.form .fields.error .field input[type=\"search\"],\n  .ui.form .fields.error .field input[type=\"tel\"],\n  .ui.form .fields.error .field input[type=\"time\"],\n  .ui.form .fields.error .field input[type=\"text\"],\n  .ui.form .fields.error .field input[type=\"file\"],\n  .ui.form .fields.error .field input[type=\"url\"],\n  .ui.form .field.error textarea,\n  .ui.form .field.error select,\n  .ui.form .field.error input:not([type]),\n  .ui.form .field.error input[type=\"date\"],\n  .ui.form .field.error input[type=\"datetime-local\"],\n  .ui.form .field.error input[type=\"email\"],\n  .ui.form .field.error input[type=\"number\"],\n  .ui.form .field.error input[type=\"password\"],\n  .ui.form .field.error input[type=\"search\"],\n  .ui.form .field.error input[type=\"tel\"],\n  .ui.form .field.error input[type=\"time\"],\n  .ui.form .field.error input[type=\"text\"],\n  .ui.form .field.error input[type=\"file\"],\n  .ui.form .field.error input[type=\"url\"] {\n    background: $form-error-background;\n    border-color: $form-error-border;\n    color: $form-error-color;\n    border-radius: $form-input-error-border-radius;\n    box-shadow: $form-input-error-box-shadow;\n  }\n  .ui.form .field.error textarea:focus,\n  .ui.form .field.error select:focus,\n  .ui.form .field.error input:not([type]):focus,\n  .ui.form .field.error input[type=\"date\"]:focus,\n  .ui.form .field.error input[type=\"datetime-local\"]:focus,\n  .ui.form .field.error input[type=\"email\"]:focus,\n  .ui.form .field.error input[type=\"number\"]:focus,\n  .ui.form .field.error input[type=\"password\"]:focus,\n  .ui.form .field.error input[type=\"search\"]:focus,\n  .ui.form .field.error input[type=\"tel\"]:focus,\n  .ui.form .field.error input[type=\"time\"]:focus,\n  .ui.form .field.error input[type=\"text\"]:focus,\n  .ui.form .field.error input[type=\"file\"]:focus,\n  .ui.form .field.error input[type=\"url\"]:focus {\n    background: $form-input-error-focus-background;\n    border-color: $form-input-error-focus-border;\n    color: $form-input-error-focus-color;\n\n    box-shadow: $form-input-error-focus-box-shadow;\n  }\n\n  /* Preserve Native Select Stylings */\n  .ui.form .field.error select {\n    -webkit-appearance: menulist-button;\n  }\n\n  /*------------------\n      Dropdown Error\n  --------------------*/\n\n  .ui.form .fields.error .field .ui.dropdown,\n  .ui.form .fields.error .field .ui.dropdown .item,\n  .ui.form .field.error .ui.dropdown,\n  .ui.form .field.error .ui.dropdown .text,\n  .ui.form .field.error .ui.dropdown .item {\n    background: $form-error-background;\n    color: $form-error-color;\n  }\n  .ui.form .fields.error .field .ui.dropdown,\n  .ui.form .field.error .ui.dropdown {\n    border-color: $form-error-border !important;\n  }\n  .ui.form .fields.error .field .ui.dropdown:hover,\n  .ui.form .field.error .ui.dropdown:hover {\n    border-color: $form-error-border !important;\n  }\n  .ui.form .fields.error .field .ui.dropdown:hover .menu,\n  .ui.form .field.error .ui.dropdown:hover .menu {\n    border-color: $form-error-border;\n  }\n  .ui.form .fields.error .field .ui.multiple.selection.dropdown > .label,\n  .ui.form .field.error .ui.multiple.selection.dropdown > .label {\n    background-color: $form-dropdown-error-label-background;\n    color: $form-dropdown-error-label-color;\n  }\n\n  /* Hover */\n  .ui.form .fields.error .field .ui.dropdown .menu .item:hover,\n  .ui.form .field.error .ui.dropdown .menu .item:hover {\n    background-color: $form-dropdown-error-hover-background;\n  }\n\n  /* Selected */\n  .ui.form .fields.error .field .ui.dropdown .menu .selected.item,\n  .ui.form .field.error .ui.dropdown .menu .selected.item {\n    background-color: $form-dropdown-error-selected-background;\n  }\n\n\n  /* Active */\n  .ui.form .fields.error .field .ui.dropdown .menu .active.item,\n  .ui.form .field.error .ui.dropdown .menu .active.item {\n    background-color: $form-dropdown-error-active-background !important;\n  }\n\n  /*--------------------\n      Checkbox Error\n  ---------------------*/\n\n  .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label,\n  .ui.form .field.error .checkbox:not(.toggle):not(.slider) label,\n  .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box,\n  .ui.form .field.error .checkbox:not(.toggle):not(.slider) .box {\n    color: $form-error-color;\n  }\n  .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) label:before,\n  .ui.form .field.error .checkbox:not(.toggle):not(.slider) label:before,\n  .ui.form .fields.error .field .checkbox:not(.toggle):not(.slider) .box:before,\n  .ui.form .field.error .checkbox:not(.toggle):not(.slider) .box:before {\n    background: $form-error-background;\n    border-color: $form-error-border;\n  }\n  .ui.form .fields.error .field .checkbox label:after,\n  .ui.form .field.error .checkbox label:after,\n  .ui.form .fields.error .field .checkbox .box:after,\n  .ui.form .field.error .checkbox .box:after {\n    color: $form-error-color;\n  }\n\n  /*--------------------\n        Disabled\n  ---------------------*/\n\n  .ui.form .disabled.fields .field,\n  .ui.form .disabled.field,\n  .ui.form .field :disabled {\n    pointer-events: none;\n    opacity: $disabled-opacity;\n  }\n  .ui.form .field.disabled > label,\n  .ui.form .fields.disabled > label {\n    opacity: $form-disabled-label-opacity;\n  }\n  .ui.form .field.disabled :disabled {\n    opacity: 1;\n  }\n\n\n  /*--------------\n      Loading\n  ---------------*/\n\n  .ui.loading.form {\n    position: relative;\n    cursor: default;\n    pointer-events: none;\n  }\n  .ui.loading.form:before {\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 0;\n    background: $form-loader-dimmer-color;\n    width: 100%;\n    height: 100%;\n    z-index: $form-loader-dimmer-z-index;\n  }\n\n  .ui.loading.form.segments:before {\n    border-radius: $default-border-radius;\n  }\n\n  .ui.loading.form:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n\n    margin: $loader-margin;\n    width: $form-loader-size;\n    height: $form-loader-size;\n\n    animation: loader $loader-speed infinite linear;\n    border: $loader-line-width solid $loader-line-color;\n    border-radius: $circular-radius;\n\n    box-shadow: 0 0 0 1px transparent;\n    visibility: visible;\n    z-index: $form-loader-line-z-index;\n  }\n\n  /*******************************\n          Element Types\n  *******************************/\n\n  /*--------------------\n      Required Field\n  ---------------------*/\n\n  .ui.form .required.fields:not(.grouped) > .field > label:after,\n  .ui.form .required.fields.grouped > label:after,\n  .ui.form .required.field > label:after,\n  .ui.form .required.fields:not(.grouped) > .field > .checkbox:after,\n  .ui.form .required.field > .checkbox:after,\n  .ui.form label.required:after {\n    margin: $form-required-margin;\n    content: $form-required-content;\n    color: $form-required-color;\n  }\n\n  .ui.form .required.fields:not(.grouped) > .field > label:after,\n  .ui.form .required.fields.grouped > label:after,\n  .ui.form .required.field > label:after,\n  .ui.form label.required:after {\n    display: inline-block;\n    vertical-align: top;\n  }\n\n  .ui.form .required.fields:not(.grouped) > .field > .checkbox:after,\n  .ui.form .required.field > .checkbox:after {\n    position: absolute;\n    top: 0;\n    left: 100%;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n\n  /*--------------------\n      Inverted Colors\n  ---------------------*/\n\n  .ui.inverted.form label,\n  .ui.form .inverted.segment label,\n  .ui.form .inverted.segment .ui.checkbox label,\n  .ui.form .inverted.segment .ui.checkbox .box,\n  .ui.inverted.form .ui.checkbox label,\n  .ui.inverted.form .ui.checkbox .box,\n  .ui.inverted.form .inline.fields > label,\n  .ui.inverted.form .inline.fields .field > label,\n  .ui.inverted.form .inline.fields .field > p,\n  .ui.inverted.form .inline.field > label,\n  .ui.inverted.form .inline.field > p {\n    color: $form-inverted-label-color;\n  }\n  .ui.inverted.loading.form {\n    color: $inverted-loader-line-color;\n  }\n  .ui.inverted.loading.form:before {\n    background: $form-loader-inverted-dimmer-color;\n  }\n  /* Inverted Field */\n  .ui.inverted.form input:not([type]),\n  .ui.inverted.form input[type=\"date\"],\n  .ui.inverted.form input[type=\"datetime-local\"],\n  .ui.inverted.form input[type=\"email\"],\n  .ui.inverted.form input[type=\"number\"],\n  .ui.inverted.form input[type=\"password\"],\n  .ui.inverted.form input[type=\"search\"],\n  .ui.inverted.form input[type=\"tel\"],\n  .ui.inverted.form input[type=\"time\"],\n  .ui.inverted.form input[type=\"text\"],\n  .ui.inverted.form input[type=\"file\"],\n  .ui.inverted.form input[type=\"url\"] {\n    background: $form-inverted-input-background;\n    border-color: $form-inverted-input-border-color;\n    color: $form-inverted-input-color;\n    box-shadow: $form-inverted-input-box-shadow;\n  }\n\n  /*--------------------\n      Field Groups\n  ---------------------*/\n\n  /* Grouped Vertically */\n  .ui.form .grouped.fields {\n    display: block;\n    margin: $form-grouped-margin;\n  }\n  .ui.form .grouped.fields:last-child {\n    margin-bottom: 0;\n  }\n\n  .ui.form .grouped.fields > label {\n    margin: $form-grouped-label-margin;\n    color: $form-grouped-label-color;\n    font-size: $form-grouped-label-font-size;\n    font-weight: $form-grouped-label-font-weight;\n    text-transform: $form-grouped-label-text-transform;\n  }\n\n  .ui.form .grouped.fields .field,\n  .ui.form .grouped.inline.fields .field {\n    display: block;\n    margin: $form-grouped-field-margin;\n    padding: 0;\n  }\n\n  /*--------------------\n          Fields\n  ---------------------*/\n\n  /* Split fields */\n  .ui.form .fields {\n    display: flex;\n    flex-direction: row;\n    margin: $form-fields-margin;\n  }\n  .ui.form .fields > .field {\n    flex: 0 1 auto;\n    padding-left: ($form-gutter-width / 2);\n    padding-right: ($form-gutter-width / 2);\n  }\n  .ui.form .fields > .field:first-child {\n    border-left: none;\n    box-shadow: none;\n  }\n\n  /* Other Combinations */\n  .ui.form .two.fields > .fields,\n  .ui.form .two.fields > .field {\n    width: $two-column;\n  }\n  .ui.form .three.fields > .fields,\n  .ui.form .three.fields > .field {\n    width: $three-column;\n  }\n  .ui.form .four.fields > .fields,\n  .ui.form .four.fields > .field {\n    width: $four-column;\n  }\n  .ui.form .five.fields > .fields,\n  .ui.form .five.fields > .field {\n    width: $five-column;\n  }\n  .ui.form .six.fields > .fields,\n  .ui.form .six.fields > .field {\n    width: $six-column;\n  }\n  .ui.form .seven.fields > .fields,\n  .ui.form .seven.fields > .field {\n    width: $seven-column;\n  }\n  .ui.form .eight.fields > .fields,\n  .ui.form .eight.fields > .field {\n    width: $eight-column;\n  }\n  .ui.form .nine.fields > .fields,\n  .ui.form .nine.fields > .field {\n    width: $nine-column;\n  }\n  .ui.form .ten.fields > .fields,\n  .ui.form .ten.fields > .field {\n    width: $ten-column;\n  }\n\n  /* Swap to full width on mobile */\n  @media only screen and (max-width : $largest-mobile-screen) {\n    .ui.form .fields {\n      flex-wrap: wrap;\n    }\n\n    .ui[class*=\"equal width\"].form:not(.unstackable) .fields > .field,\n    .ui.form:not(.unstackable) [class*=\"equal width\"].fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .six.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .seven.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .eight.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .nine.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .ten.fields:not(.unstackable) > .field {\n      width: $one-column !important;\n      margin: 0 0 $form-row-distance;\n    }\n  }\n\n\n  /* Sizing Combinations */\n  .ui.form .fields .wide.field {\n    width: $one-wide;\n    padding-left: ($form-gutter-width / 2);\n    padding-right: ($form-gutter-width / 2);\n  }\n\n  .ui.form .one.wide.field {\n    width: $one-wide !important;\n  }\n  .ui.form .two.wide.field {\n    width: $two-wide !important;\n  }\n  .ui.form .three.wide.field {\n    width: $three-wide !important;\n  }\n  .ui.form .four.wide.field {\n    width: $four-wide !important;\n  }\n  .ui.form .five.wide.field {\n    width: $five-wide !important;\n  }\n  .ui.form .six.wide.field {\n    width: $six-wide !important;\n  }\n  .ui.form .seven.wide.field {\n    width: $seven-wide !important;\n  }\n  .ui.form .eight.wide.field {\n    width: $eight-wide !important;\n  }\n  .ui.form .nine.wide.field {\n    width: $nine-wide !important;\n  }\n  .ui.form .ten.wide.field {\n    width: $ten-wide !important;\n  }\n  .ui.form .eleven.wide.field {\n    width: $eleven-wide !important;\n  }\n  .ui.form .twelve.wide.field {\n    width: $twelve-wide !important;\n  }\n  .ui.form .thirteen.wide.field {\n    width: $thirteen-wide !important;\n  }\n  .ui.form .fourteen.wide.field {\n    width: $fourteen-wide !important;\n  }\n  .ui.form .fifteen.wide.field {\n    width: $fifteen-wide !important;\n  }\n  .ui.form .sixteen.wide.field {\n    width: $sixteen-wide !important;\n  }\n\n  /* Swap to full width on mobile */\n  @media only screen and (max-width : $largest-mobile-screen) {\n    .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .two.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .three.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .four.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .fields,\n    .ui.form:not(.unstackable) .five.fields:not(.unstackable) > .field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .two.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .three.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .four.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .five.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .six.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .seven.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .eight.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .nine.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .ten.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .eleven.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .twelve.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .thirteen.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .fourteen.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .fifteen.wide.field,\n    .ui.form:not(.unstackable) .fields:not(.unstackable) > .sixteen.wide.field {\n      width: $one-column !important;\n    }\n    .ui.form .fields {\n      margin-bottom: 0;\n    }\n  }\n\n  /*--------------------\n      Equal Width\n  ---------------------*/\n\n  .ui[class*=\"equal width\"].form .fields > .field,\n  .ui.form [class*=\"equal width\"].fields > .field {\n    width: 100%;\n    flex: 1 1 auto;\n  }\n\n  /*--------------------\n      Inline Fields\n  ---------------------*/\n\n  .ui.form .inline.fields {\n    margin: $form-field-margin;\n    align-items: center;\n  }\n  .ui.form .inline.fields .field {\n    margin: 0;\n    padding: $form-inline-fields-margin;\n  }\n\n  /* Inline Label */\n  .ui.form .inline.fields > label,\n  .ui.form .inline.fields .field > label,\n  .ui.form .inline.fields .field > p,\n  .ui.form .inline.field > label,\n  .ui.form .inline.field > p {\n    display: inline-block;\n    width: auto;\n    margin-top: 0;\n    margin-bottom: 0;\n    vertical-align: baseline;\n    font-size: $form-inline-label-font-size;\n    font-weight: $form-inline-label-font-weight;\n    color: $form-inline-label-color;\n    text-transform: $form-inline-label-text-transform;\n  }\n\n  /* Grouped Inline Label */\n  .ui.form .inline.fields > label {\n    margin: $form-grouped-inline-label-margin;\n  }\n\n  /* Inline Input */\n  .ui.form .inline.fields .field > input,\n  .ui.form .inline.fields .field > select,\n  .ui.form .inline.field > input,\n  .ui.form .inline.field > select {\n    display: inline-block;\n    width: auto;\n\n    margin-top: 0;\n    margin-bottom: 0;\n\n    vertical-align: middle;\n    font-size: $form-inline-input-size;\n  }\n\n  /* Label */\n  .ui.form .inline.fields .field > :first-child,\n  .ui.form .inline.field > :first-child {\n    margin: 0 $form-inline-label-distance 0 0;\n  }\n  .ui.form .inline.fields .field > :only-child,\n  .ui.form .inline.field > :only-child {\n    margin: 0;\n  }\n\n  /* Wide */\n  .ui.form .inline.fields .wide.field {\n    display: flex;\n    align-items: center;\n  }\n  .ui.form .inline.fields .wide.field > input,\n  .ui.form .inline.fields .wide.field > select {\n    width: 100%;\n  }\n\n\n  /*--------------------\n          Sizes\n  ---------------------*/\n\n  .ui.mini.form {\n    font-size: $mini;\n  }\n  .ui.tiny.form {\n    font-size: $tiny;\n  }\n  .ui.small.form {\n    font-size: $small;\n  }\n  .ui.form {\n    font-size: $medium;\n  }\n  .ui.large.form {\n    font-size: $large;\n  }\n  .ui.big.form {\n    font-size: $big;\n  }\n  .ui.huge.form {\n    font-size: $huge;\n  }\n  .ui.massive.form {\n    font-size: $massive;\n  }\n\n  /* Dropdown */\n  .ui.mini.form .field .dropdown {\n    font-size: $mini;\n  }\n  .ui.tiny.form .field .dropdown {\n    font-size: $tiny;\n  }\n  .ui.small.form .field .dropdown {\n    font-size: $small;\n  }\n  .ui.form .field .dropdown {\n    font-size: $medium;\n  }\n  .ui.large.form .field .dropdown {\n    font-size: $large;\n  }\n  .ui.big.form .field .dropdown {\n    font-size: $big;\n  }\n  .ui.huge.form .field .dropdown {\n    font-size: $huge;\n  }\n  .ui.massive.form .field .dropdown {\n    font-size: $massive;\n  }\n\n  /* Dropdown Items */\n  .ui.mini.form .field .dropdown .menu > .item {\n    font-size: $mini;\n  }\n  .ui.tiny.form .field .dropdown .menu > .item {\n    font-size: $tiny;\n  }\n  .ui.small.form .field .dropdown .menu > .item {\n    font-size: $small;\n  }\n  .ui.form .field .dropdown .menu > .item {\n    font-size: $medium;\n  }\n  .ui.large.form .field .dropdown .menu > .item {\n    font-size: $large;\n  }\n  .ui.big.form .field .dropdown .menu > .item {\n    font-size: $big;\n  }\n  .ui.huge.form .field .dropdown .menu > .item {\n    font-size: $huge;\n  }\n  .ui.massive.form .field .dropdown .menu > .item {\n    font-size: $massive;\n  }\n}\n\n@import '../../themes/default/collections/form.style';","@import '../../themes/default/collections/grid.variables';\n\n@if $use-grid {\n  /*******************************\n  //@-        Standard\n  *******************************/\n\n  .ui.grid {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: stretch;\n    padding: 0;\n  }\n\n  /*----------------------\n        Remove Gutters\n  -----------------------*/\n\n  .ui.grid {\n    margin-top: -($grid-row-spacing / 2);\n    margin-bottom: -($grid-row-spacing / 2);\n    margin-left: -($grid-gutter-width / 2);\n    margin-right: -($grid-gutter-width / 2);\n  }\n  .ui.relaxed.grid  {\n    margin-left: -($grid-relaxed-gutter-width / 2);\n    margin-right: -($grid-relaxed-gutter-width / 2);\n  }\n  .ui[class*=\"very relaxed\"].grid  {\n    margin-left: -($grid-very-relaxed-gutter-width / 2);\n    margin-right: -($grid-very-relaxed-gutter-width / 2);\n  }\n\n\n  /* Preserve Rows Spacing on Consecutive Grids */\n  .ui.grid + .grid {\n    margin-top: $grid-consecutive-distance;\n  }\n\n  /*-------------------\n        Columns\n  --------------------*/\n\n  /* Standard 16 column */\n  .ui.grid > .column:not(.row),\n  .ui.grid > .row > .column {\n    position: relative;\n    display: inline-block;\n\n    width: $one-wide;\n    padding-left: ($grid-gutter-width / 2);\n    padding-right: ($grid-gutter-width / 2);\n    vertical-align: top;\n  }\n\n  .ui.grid > * {\n    padding-left: ($grid-gutter-width / 2);\n    padding-right: ($grid-gutter-width / 2);\n  }\n\n  /*-------------------\n          Rows\n  --------------------*/\n\n  .ui.grid > .row {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: inherit;\n    align-items: stretch;\n    width: 100% !important;\n    padding: 0;\n    padding-top: ($grid-row-spacing / 2);\n    padding-bottom: ($grid-row-spacing / 2);\n  }\n\n  /*-------------------\n        Columns\n  --------------------*/\n\n  /* Vertical padding when no rows */\n  .ui.grid > .column:not(.row) {\n    padding-top: ($grid-row-spacing / 2);\n    padding-bottom: ($grid-row-spacing / 2);\n  }\n  .ui.grid > .row > .column {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  /*-------------------\n        Content\n  --------------------*/\n\n  .ui.grid > .row > img,\n  .ui.grid > .row > .column > img {\n    max-width: $grid-column-max-image-width;\n  }\n\n  /*-------------------\n      Loose Coupling\n  --------------------*/\n\n  /* Collapse Margin on Consecutive Grid */\n  .ui.grid > .ui.grid:first-child {\n    margin-top: 0;\n  }\n  .ui.grid > .ui.grid:last-child {\n    margin-bottom: 0;\n  }\n\n  /* Segment inside Aligned Grid */\n  .ui.grid .aligned.row > .column > .segment:not(.compact):not(.attached),\n  .ui.aligned.grid .column > .segment:not(.compact):not(.attached) {\n    width: 100%;\n  }\n\n  /* Align Dividers with Gutter */\n  .ui.grid .row + .ui.divider {\n    flex-grow: 1;\n    margin: ($grid-row-spacing / 2) ($grid-gutter-width / 2);\n  }\n  .ui.grid .column + .ui.vertical.divider {\n    height: calc(50% - #{$grid-row-spacing / 2});\n  }\n\n  /* Remove Border on Last Horizontal Segment */\n  .ui.grid > .row > .column:last-child > .horizontal.segment,\n  .ui.grid > .column:last-child > .horizontal.segment {\n    box-shadow: none;\n  }\n\n  /*******************************\n            Variations\n  *******************************/\n\n\n  /*-----------------------\n        Page Grid\n  -------------------------*/\n\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.page.grid {\n      width: $grid-mobile-width;\n      padding-left: $grid-mobile-gutter;\n      padding-right: $grid-mobile-gutter;\n      margin-left: 0;\n      margin-right: 0;\n    }\n  }\n  @media only screen and (min-width: $tablet-breakpoint) and (max-width: $largest-tablet-screen) {\n    .ui.page.grid {\n      width: $grid-tablet-width;\n      margin-left: $grid-tablet-margin;\n      margin-right: $grid-tablet-margin;\n      padding-left: $grid-tablet-gutter;\n      padding-right: $grid-tablet-gutter;\n    }\n  }\n  @media only screen and (min-width: $computer-breakpoint) and (max-width: $largest-small-monitor) {\n    .ui.page.grid {\n      width: $grid-computer-width;\n      margin-left: $grid-computer-margin;\n      margin-right: $grid-computer-margin;\n      padding-left: $grid-computer-gutter;\n      padding-right: $grid-computer-gutter;\n    }\n  }\n  @media only screen and (min-width: $large-monitor-breakpoint) and (max-width: $largest-large-monitor) {\n    .ui.page.grid {\n      width: $grid-large-monitor-width;\n      margin-left: $grid-large-monitor-margin;\n      margin-right: $grid-large-monitor-margin;\n      padding-left: $grid-large-monitor-gutter;\n      padding-right: $grid-large-monitor-gutter;\n    }\n  }\n  @media only screen and (min-width: $widescreen-monitor-breakpoint) {\n    .ui.page.grid {\n      width: $grid-widescreen-monitor-width;\n      margin-left: $grid-widescreen-margin;\n      margin-right: $grid-widescreen-margin;\n      padding-left: $grid-widescreen-monitor-gutter;\n      padding-right: $grid-widescreen-monitor-gutter;\n    }\n  }\n\n\n  /*-------------------\n      Column Count\n  --------------------*/\n\n  /* Assume full width with one column */\n  .ui.grid > .column:only-child,\n  .ui.grid > .row > .column:only-child {\n    width: $one-column;\n  }\n\n  /* Grid Based */\n  .ui[class*=\"one column\"].grid > .row > .column,\n  .ui[class*=\"one column\"].grid > .column:not(.row) {\n    width: $one-column;\n  }\n  .ui[class*=\"two column\"].grid > .row > .column,\n  .ui[class*=\"two column\"].grid > .column:not(.row) {\n    width: $two-column;\n  }\n  .ui[class*=\"three column\"].grid > .row > .column,\n  .ui[class*=\"three column\"].grid > .column:not(.row) {\n    width: $three-column;\n  }\n  .ui[class*=\"four column\"].grid > .row > .column,\n  .ui[class*=\"four column\"].grid > .column:not(.row) {\n    width: $four-column;\n  }\n  .ui[class*=\"five column\"].grid > .row > .column,\n  .ui[class*=\"five column\"].grid > .column:not(.row) {\n    width: $five-column;\n  }\n  .ui[class*=\"six column\"].grid > .row > .column,\n  .ui[class*=\"six column\"].grid > .column:not(.row) {\n    width: $six-column;\n  }\n  .ui[class*=\"seven column\"].grid > .row > .column,\n  .ui[class*=\"seven column\"].grid > .column:not(.row) {\n    width: $seven-column;\n  }\n  .ui[class*=\"eight column\"].grid > .row > .column,\n  .ui[class*=\"eight column\"].grid > .column:not(.row) {\n    width: $eight-column;\n  }\n  .ui[class*=\"nine column\"].grid > .row > .column,\n  .ui[class*=\"nine column\"].grid > .column:not(.row) {\n    width: $nine-column;\n  }\n  .ui[class*=\"ten column\"].grid > .row > .column,\n  .ui[class*=\"ten column\"].grid > .column:not(.row) {\n    width: $ten-column;\n  }\n  .ui[class*=\"eleven column\"].grid > .row > .column,\n  .ui[class*=\"eleven column\"].grid > .column:not(.row) {\n    width: $eleven-column;\n  }\n  .ui[class*=\"twelve column\"].grid > .row > .column,\n  .ui[class*=\"twelve column\"].grid > .column:not(.row) {\n    width: $twelve-column;\n  }\n  .ui[class*=\"thirteen column\"].grid > .row > .column,\n  .ui[class*=\"thirteen column\"].grid > .column:not(.row) {\n    width: $thirteen-column;\n  }\n  .ui[class*=\"fourteen column\"].grid > .row > .column,\n  .ui[class*=\"fourteen column\"].grid > .column:not(.row) {\n    width: $fourteen-column;\n  }\n  .ui[class*=\"fifteen column\"].grid > .row > .column,\n  .ui[class*=\"fifteen column\"].grid > .column:not(.row) {\n    width: $fifteen-column;\n  }\n  .ui[class*=\"sixteen column\"].grid > .row > .column,\n  .ui[class*=\"sixteen column\"].grid > .column:not(.row) {\n    width: $sixteen-column;\n  }\n\n  /* Row Based Overrides */\n  .ui.grid > [class*=\"one column\"].row > .column {\n    width: $one-column !important;\n  }\n  .ui.grid > [class*=\"two column\"].row > .column {\n    width: $two-column !important;\n  }\n  .ui.grid > [class*=\"three column\"].row > .column {\n    width: $three-column !important;\n  }\n  .ui.grid > [class*=\"four column\"].row > .column {\n    width: $four-column !important;\n  }\n  .ui.grid > [class*=\"five column\"].row > .column {\n    width: $five-column !important;\n  }\n  .ui.grid > [class*=\"six column\"].row > .column {\n    width: $six-column !important;\n  }\n  .ui.grid > [class*=\"seven column\"].row > .column {\n    width: $seven-column !important;\n  }\n  .ui.grid > [class*=\"eight column\"].row > .column {\n    width: $eight-column !important;\n  }\n  .ui.grid > [class*=\"nine column\"].row > .column {\n    width: $nine-column !important;\n  }\n  .ui.grid > [class*=\"ten column\"].row > .column {\n    width: $ten-column !important;\n  }\n  .ui.grid > [class*=\"eleven column\"].row > .column {\n    width: $eleven-column !important;\n  }\n  .ui.grid > [class*=\"twelve column\"].row > .column {\n    width: $twelve-column !important;\n  }\n  .ui.grid > [class*=\"thirteen column\"].row > .column {\n    width: $thirteen-column !important;\n  }\n  .ui.grid > [class*=\"fourteen column\"].row > .column {\n    width: $fourteen-column !important;\n  }\n  .ui.grid > [class*=\"fifteen column\"].row > .column {\n    width: $fifteen-column !important;\n  }\n  .ui.grid > [class*=\"sixteen column\"].row > .column {\n    width: $sixteen-column !important;\n  }\n\n  /* Celled Page */\n  .ui.celled.page.grid {\n    box-shadow: none;\n  }\n\n  /*-------------------\n      Column Width\n  --------------------*/\n\n  /* Sizing Combinations */\n  .ui.grid > .row > [class*=\"one wide\"].column,\n  .ui.grid > .column.row > [class*=\"one wide\"].column,\n  .ui.grid > [class*=\"one wide\"].column,\n  .ui.column.grid > [class*=\"one wide\"].column {\n    width: $one-wide !important;\n  }\n  .ui.grid > .row > [class*=\"two wide\"].column,\n  .ui.grid > .column.row > [class*=\"two wide\"].column,\n  .ui.grid > [class*=\"two wide\"].column,\n  .ui.column.grid > [class*=\"two wide\"].column {\n    width: $two-wide !important;\n  }\n  .ui.grid > .row > [class*=\"three wide\"].column,\n  .ui.grid > .column.row > [class*=\"three wide\"].column,\n  .ui.grid > [class*=\"three wide\"].column,\n  .ui.column.grid > [class*=\"three wide\"].column {\n    width: $three-wide !important;\n  }\n  .ui.grid > .row > [class*=\"four wide\"].column,\n  .ui.grid > .column.row > [class*=\"four wide\"].column,\n  .ui.grid > [class*=\"four wide\"].column,\n  .ui.column.grid > [class*=\"four wide\"].column {\n    width: $four-wide !important;\n  }\n  .ui.grid > .row > [class*=\"five wide\"].column,\n  .ui.grid > .column.row > [class*=\"five wide\"].column,\n  .ui.grid > [class*=\"five wide\"].column,\n  .ui.column.grid > [class*=\"five wide\"].column {\n    width: $five-wide !important;\n  }\n  .ui.grid > .row > [class*=\"six wide\"].column,\n  .ui.grid > .column.row > [class*=\"six wide\"].column,\n  .ui.grid > [class*=\"six wide\"].column,\n  .ui.column.grid > [class*=\"six wide\"].column {\n    width: $six-wide !important;\n  }\n  .ui.grid > .row > [class*=\"seven wide\"].column,\n  .ui.grid > .column.row > [class*=\"seven wide\"].column,\n  .ui.grid > [class*=\"seven wide\"].column,\n  .ui.column.grid > [class*=\"seven wide\"].column {\n    width: $seven-wide !important;\n  }\n  .ui.grid > .row > [class*=\"eight wide\"].column,\n  .ui.grid > .column.row > [class*=\"eight wide\"].column,\n  .ui.grid > [class*=\"eight wide\"].column,\n  .ui.column.grid > [class*=\"eight wide\"].column {\n    width: $eight-wide !important;\n  }\n  .ui.grid > .row > [class*=\"nine wide\"].column,\n  .ui.grid > .column.row > [class*=\"nine wide\"].column,\n  .ui.grid > [class*=\"nine wide\"].column,\n  .ui.column.grid > [class*=\"nine wide\"].column {\n    width: $nine-wide !important;\n  }\n  .ui.grid > .row > [class*=\"ten wide\"].column,\n  .ui.grid > .column.row > [class*=\"ten wide\"].column,\n  .ui.grid > [class*=\"ten wide\"].column,\n  .ui.column.grid > [class*=\"ten wide\"].column {\n    width: $ten-wide !important;\n  }\n  .ui.grid > .row > [class*=\"eleven wide\"].column,\n  .ui.grid > .column.row > [class*=\"eleven wide\"].column,\n  .ui.grid > [class*=\"eleven wide\"].column,\n  .ui.column.grid > [class*=\"eleven wide\"].column {\n    width: $eleven-wide !important;\n  }\n  .ui.grid > .row > [class*=\"twelve wide\"].column,\n  .ui.grid > .column.row > [class*=\"twelve wide\"].column,\n  .ui.grid > [class*=\"twelve wide\"].column,\n  .ui.column.grid > [class*=\"twelve wide\"].column {\n    width: $twelve-wide !important;\n  }\n  .ui.grid > .row > [class*=\"thirteen wide\"].column,\n  .ui.grid > .column.row > [class*=\"thirteen wide\"].column,\n  .ui.grid > [class*=\"thirteen wide\"].column,\n  .ui.column.grid > [class*=\"thirteen wide\"].column {\n    width: $thirteen-wide !important;\n  }\n  .ui.grid > .row > [class*=\"fourteen wide\"].column,\n  .ui.grid > .column.row > [class*=\"fourteen wide\"].column,\n  .ui.grid > [class*=\"fourteen wide\"].column,\n  .ui.column.grid > [class*=\"fourteen wide\"].column {\n    width: $fourteen-wide !important;\n  }\n  .ui.grid > .row > [class*=\"fifteen wide\"].column,\n  .ui.grid > .column.row > [class*=\"fifteen wide\"].column,\n  .ui.grid > [class*=\"fifteen wide\"].column,\n  .ui.column.grid > [class*=\"fifteen wide\"].column {\n    width: $fifteen-wide !important;\n  }\n  .ui.grid > .row > [class*=\"sixteen wide\"].column,\n  .ui.grid > .column.row > [class*=\"sixteen wide\"].column,\n  .ui.grid > [class*=\"sixteen wide\"].column,\n  .ui.column.grid > [class*=\"sixteen wide\"].column {\n    width: $sixteen-wide !important;\n  }\n\n  /*----------------------\n      Width per Device\n  -----------------------*/\n\n  /* Mobile Sizing Combinations */\n  @media only screen and (min-width: $mobile-breakpoint) and (max-width: $largest-mobile-screen) {\n    .ui.grid > .row > [class*=\"one wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"one wide mobile\"].column,\n    .ui.grid > [class*=\"one wide mobile\"].column,\n    .ui.column.grid > [class*=\"one wide mobile\"].column {\n      width: $one-wide !important;\n    }\n    .ui.grid > .row > [class*=\"two wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"two wide mobile\"].column,\n    .ui.grid > [class*=\"two wide mobile\"].column,\n    .ui.column.grid > [class*=\"two wide mobile\"].column {\n      width: $two-wide !important;\n    }\n    .ui.grid > .row > [class*=\"three wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"three wide mobile\"].column,\n    .ui.grid > [class*=\"three wide mobile\"].column,\n    .ui.column.grid > [class*=\"three wide mobile\"].column {\n      width: $three-wide !important;\n    }\n    .ui.grid > .row > [class*=\"four wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"four wide mobile\"].column,\n    .ui.grid > [class*=\"four wide mobile\"].column,\n    .ui.column.grid > [class*=\"four wide mobile\"].column {\n      width: $four-wide !important;\n    }\n    .ui.grid > .row > [class*=\"five wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"five wide mobile\"].column,\n    .ui.grid > [class*=\"five wide mobile\"].column,\n    .ui.column.grid > [class*=\"five wide mobile\"].column {\n      width: $five-wide !important;\n    }\n    .ui.grid > .row > [class*=\"six wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"six wide mobile\"].column,\n    .ui.grid > [class*=\"six wide mobile\"].column,\n    .ui.column.grid > [class*=\"six wide mobile\"].column {\n      width: $six-wide !important;\n    }\n    .ui.grid > .row > [class*=\"seven wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"seven wide mobile\"].column,\n    .ui.grid > [class*=\"seven wide mobile\"].column,\n    .ui.column.grid > [class*=\"seven wide mobile\"].column {\n      width: $seven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eight wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"eight wide mobile\"].column,\n    .ui.grid > [class*=\"eight wide mobile\"].column,\n    .ui.column.grid > [class*=\"eight wide mobile\"].column {\n      width: $eight-wide !important;\n    }\n    .ui.grid > .row > [class*=\"nine wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"nine wide mobile\"].column,\n    .ui.grid > [class*=\"nine wide mobile\"].column,\n    .ui.column.grid > [class*=\"nine wide mobile\"].column {\n      width: $nine-wide !important;\n    }\n    .ui.grid > .row > [class*=\"ten wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"ten wide mobile\"].column,\n    .ui.grid > [class*=\"ten wide mobile\"].column,\n    .ui.column.grid > [class*=\"ten wide mobile\"].column {\n      width: $ten-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eleven wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"eleven wide mobile\"].column,\n    .ui.grid > [class*=\"eleven wide mobile\"].column,\n    .ui.column.grid > [class*=\"eleven wide mobile\"].column {\n      width: $eleven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"twelve wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"twelve wide mobile\"].column,\n    .ui.grid > [class*=\"twelve wide mobile\"].column,\n    .ui.column.grid > [class*=\"twelve wide mobile\"].column {\n      width: $twelve-wide !important;\n    }\n    .ui.grid > .row > [class*=\"thirteen wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"thirteen wide mobile\"].column,\n    .ui.grid > [class*=\"thirteen wide mobile\"].column,\n    .ui.column.grid > [class*=\"thirteen wide mobile\"].column {\n      width: $thirteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fourteen wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"fourteen wide mobile\"].column,\n    .ui.grid > [class*=\"fourteen wide mobile\"].column,\n    .ui.column.grid > [class*=\"fourteen wide mobile\"].column {\n      width: $fourteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fifteen wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"fifteen wide mobile\"].column,\n    .ui.grid > [class*=\"fifteen wide mobile\"].column,\n    .ui.column.grid > [class*=\"fifteen wide mobile\"].column {\n      width: $fifteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"sixteen wide mobile\"].column,\n    .ui.grid > .column.row > [class*=\"sixteen wide mobile\"].column,\n    .ui.grid > [class*=\"sixteen wide mobile\"].column,\n    .ui.column.grid > [class*=\"sixteen wide mobile\"].column {\n      width: $sixteen-wide !important;\n    }\n  }\n\n  /* Tablet Sizing Combinations */\n  @media only screen and (min-width: $tablet-breakpoint) and (max-width: $largest-tablet-screen) {\n    .ui.grid > .row > [class*=\"one wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"one wide tablet\"].column,\n    .ui.grid > [class*=\"one wide tablet\"].column,\n    .ui.column.grid > [class*=\"one wide tablet\"].column {\n      width: $one-wide !important;\n    }\n    .ui.grid > .row > [class*=\"two wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"two wide tablet\"].column,\n    .ui.grid > [class*=\"two wide tablet\"].column,\n    .ui.column.grid > [class*=\"two wide tablet\"].column {\n      width: $two-wide !important;\n    }\n    .ui.grid > .row > [class*=\"three wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"three wide tablet\"].column,\n    .ui.grid > [class*=\"three wide tablet\"].column,\n    .ui.column.grid > [class*=\"three wide tablet\"].column {\n      width: $three-wide !important;\n    }\n    .ui.grid > .row > [class*=\"four wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"four wide tablet\"].column,\n    .ui.grid > [class*=\"four wide tablet\"].column,\n    .ui.column.grid > [class*=\"four wide tablet\"].column {\n      width: $four-wide !important;\n    }\n    .ui.grid > .row > [class*=\"five wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"five wide tablet\"].column,\n    .ui.grid > [class*=\"five wide tablet\"].column,\n    .ui.column.grid > [class*=\"five wide tablet\"].column {\n      width: $five-wide !important;\n    }\n    .ui.grid > .row > [class*=\"six wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"six wide tablet\"].column,\n    .ui.grid > [class*=\"six wide tablet\"].column,\n    .ui.column.grid > [class*=\"six wide tablet\"].column {\n      width: $six-wide !important;\n    }\n    .ui.grid > .row > [class*=\"seven wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"seven wide tablet\"].column,\n    .ui.grid > [class*=\"seven wide tablet\"].column,\n    .ui.column.grid > [class*=\"seven wide tablet\"].column {\n      width: $seven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eight wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"eight wide tablet\"].column,\n    .ui.grid > [class*=\"eight wide tablet\"].column,\n    .ui.column.grid > [class*=\"eight wide tablet\"].column {\n      width: $eight-wide !important;\n    }\n    .ui.grid > .row > [class*=\"nine wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"nine wide tablet\"].column,\n    .ui.grid > [class*=\"nine wide tablet\"].column,\n    .ui.column.grid > [class*=\"nine wide tablet\"].column {\n      width: $nine-wide !important;\n    }\n    .ui.grid > .row > [class*=\"ten wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"ten wide tablet\"].column,\n    .ui.grid > [class*=\"ten wide tablet\"].column,\n    .ui.column.grid > [class*=\"ten wide tablet\"].column {\n      width: $ten-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eleven wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"eleven wide tablet\"].column,\n    .ui.grid > [class*=\"eleven wide tablet\"].column,\n    .ui.column.grid > [class*=\"eleven wide tablet\"].column {\n      width: $eleven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"twelve wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"twelve wide tablet\"].column,\n    .ui.grid > [class*=\"twelve wide tablet\"].column,\n    .ui.column.grid > [class*=\"twelve wide tablet\"].column {\n      width: $twelve-wide !important;\n    }\n    .ui.grid > .row > [class*=\"thirteen wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"thirteen wide tablet\"].column,\n    .ui.grid > [class*=\"thirteen wide tablet\"].column,\n    .ui.column.grid > [class*=\"thirteen wide tablet\"].column {\n      width: $thirteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fourteen wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"fourteen wide tablet\"].column,\n    .ui.grid > [class*=\"fourteen wide tablet\"].column,\n    .ui.column.grid > [class*=\"fourteen wide tablet\"].column {\n      width: $fourteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fifteen wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"fifteen wide tablet\"].column,\n    .ui.grid > [class*=\"fifteen wide tablet\"].column,\n    .ui.column.grid > [class*=\"fifteen wide tablet\"].column {\n      width: $fifteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"sixteen wide tablet\"].column,\n    .ui.grid > .column.row > [class*=\"sixteen wide tablet\"].column,\n    .ui.grid > [class*=\"sixteen wide tablet\"].column,\n    .ui.column.grid > [class*=\"sixteen wide tablet\"].column {\n      width: $sixteen-wide !important;\n    }\n  }\n\n  /* Computer/Desktop Sizing Combinations */\n  @media only screen and (min-width: $computer-breakpoint) {\n      .ui.grid > .row > [class*=\"one wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"one wide computer\"].column,\n    .ui.grid > [class*=\"one wide computer\"].column,\n    .ui.column.grid > [class*=\"one wide computer\"].column {\n      width: $one-wide !important;\n    }\n    .ui.grid > .row > [class*=\"two wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"two wide computer\"].column,\n    .ui.grid > [class*=\"two wide computer\"].column,\n    .ui.column.grid > [class*=\"two wide computer\"].column {\n      width: $two-wide !important;\n    }\n    .ui.grid > .row > [class*=\"three wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"three wide computer\"].column,\n    .ui.grid > [class*=\"three wide computer\"].column,\n    .ui.column.grid > [class*=\"three wide computer\"].column {\n      width: $three-wide !important;\n    }\n    .ui.grid > .row > [class*=\"four wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"four wide computer\"].column,\n    .ui.grid > [class*=\"four wide computer\"].column,\n    .ui.column.grid > [class*=\"four wide computer\"].column {\n      width: $four-wide !important;\n    }\n    .ui.grid > .row > [class*=\"five wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"five wide computer\"].column,\n    .ui.grid > [class*=\"five wide computer\"].column,\n    .ui.column.grid > [class*=\"five wide computer\"].column {\n      width: $five-wide !important;\n    }\n    .ui.grid > .row > [class*=\"six wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"six wide computer\"].column,\n    .ui.grid > [class*=\"six wide computer\"].column,\n    .ui.column.grid > [class*=\"six wide computer\"].column {\n      width: $six-wide !important;\n    }\n    .ui.grid > .row > [class*=\"seven wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"seven wide computer\"].column,\n    .ui.grid > [class*=\"seven wide computer\"].column,\n    .ui.column.grid > [class*=\"seven wide computer\"].column {\n      width: $seven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eight wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"eight wide computer\"].column,\n    .ui.grid > [class*=\"eight wide computer\"].column,\n    .ui.column.grid > [class*=\"eight wide computer\"].column {\n      width: $eight-wide !important;\n    }\n    .ui.grid > .row > [class*=\"nine wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"nine wide computer\"].column,\n    .ui.grid > [class*=\"nine wide computer\"].column,\n    .ui.column.grid > [class*=\"nine wide computer\"].column {\n      width: $nine-wide !important;\n    }\n    .ui.grid > .row > [class*=\"ten wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"ten wide computer\"].column,\n    .ui.grid > [class*=\"ten wide computer\"].column,\n    .ui.column.grid > [class*=\"ten wide computer\"].column {\n      width: $ten-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eleven wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"eleven wide computer\"].column,\n    .ui.grid > [class*=\"eleven wide computer\"].column,\n    .ui.column.grid > [class*=\"eleven wide computer\"].column {\n      width: $eleven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"twelve wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"twelve wide computer\"].column,\n    .ui.grid > [class*=\"twelve wide computer\"].column,\n    .ui.column.grid > [class*=\"twelve wide computer\"].column {\n      width: $twelve-wide !important;\n    }\n    .ui.grid > .row > [class*=\"thirteen wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"thirteen wide computer\"].column,\n    .ui.grid > [class*=\"thirteen wide computer\"].column,\n    .ui.column.grid > [class*=\"thirteen wide computer\"].column {\n      width: $thirteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fourteen wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"fourteen wide computer\"].column,\n    .ui.grid > [class*=\"fourteen wide computer\"].column,\n    .ui.column.grid > [class*=\"fourteen wide computer\"].column {\n      width: $fourteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fifteen wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"fifteen wide computer\"].column,\n    .ui.grid > [class*=\"fifteen wide computer\"].column,\n    .ui.column.grid > [class*=\"fifteen wide computer\"].column {\n      width: $fifteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"sixteen wide computer\"].column,\n    .ui.grid > .column.row > [class*=\"sixteen wide computer\"].column,\n    .ui.grid > [class*=\"sixteen wide computer\"].column,\n    .ui.column.grid > [class*=\"sixteen wide computer\"].column {\n      width: $sixteen-wide !important;\n    }\n  }\n\n  /* Large Monitor Sizing Combinations */\n  @media only screen and (min-width: $large-monitor-breakpoint) and (max-width: $largest-large-monitor){\n    .ui.grid > .row > [class*=\"one wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"one wide large screen\"].column,\n    .ui.grid > [class*=\"one wide large screen\"].column,\n    .ui.column.grid > [class*=\"one wide large screen\"].column {\n      width: $one-wide !important;\n    }\n    .ui.grid > .row > [class*=\"two wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"two wide large screen\"].column,\n    .ui.grid > [class*=\"two wide large screen\"].column,\n    .ui.column.grid > [class*=\"two wide large screen\"].column {\n      width: $two-wide !important;\n    }\n    .ui.grid > .row > [class*=\"three wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"three wide large screen\"].column,\n    .ui.grid > [class*=\"three wide large screen\"].column,\n    .ui.column.grid > [class*=\"three wide large screen\"].column {\n      width: $three-wide !important;\n    }\n    .ui.grid > .row > [class*=\"four wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"four wide large screen\"].column,\n    .ui.grid > [class*=\"four wide large screen\"].column,\n    .ui.column.grid > [class*=\"four wide large screen\"].column {\n      width: $four-wide !important;\n    }\n    .ui.grid > .row > [class*=\"five wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"five wide large screen\"].column,\n    .ui.grid > [class*=\"five wide large screen\"].column,\n    .ui.column.grid > [class*=\"five wide large screen\"].column {\n      width: $five-wide !important;\n    }\n    .ui.grid > .row > [class*=\"six wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"six wide large screen\"].column,\n    .ui.grid > [class*=\"six wide large screen\"].column,\n    .ui.column.grid > [class*=\"six wide large screen\"].column {\n      width: $six-wide !important;\n    }\n    .ui.grid > .row > [class*=\"seven wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"seven wide large screen\"].column,\n    .ui.grid > [class*=\"seven wide large screen\"].column,\n    .ui.column.grid > [class*=\"seven wide large screen\"].column {\n      width: $seven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eight wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"eight wide large screen\"].column,\n    .ui.grid > [class*=\"eight wide large screen\"].column,\n    .ui.column.grid > [class*=\"eight wide large screen\"].column {\n      width: $eight-wide !important;\n    }\n    .ui.grid > .row > [class*=\"nine wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"nine wide large screen\"].column,\n    .ui.grid > [class*=\"nine wide large screen\"].column,\n    .ui.column.grid > [class*=\"nine wide large screen\"].column {\n      width: $nine-wide !important;\n    }\n    .ui.grid > .row > [class*=\"ten wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"ten wide large screen\"].column,\n    .ui.grid > [class*=\"ten wide large screen\"].column,\n    .ui.column.grid > [class*=\"ten wide large screen\"].column {\n      width: $ten-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eleven wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"eleven wide large screen\"].column,\n    .ui.grid > [class*=\"eleven wide large screen\"].column,\n    .ui.column.grid > [class*=\"eleven wide large screen\"].column {\n      width: $eleven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"twelve wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"twelve wide large screen\"].column,\n    .ui.grid > [class*=\"twelve wide large screen\"].column,\n    .ui.column.grid > [class*=\"twelve wide large screen\"].column {\n      width: $twelve-wide !important;\n    }\n    .ui.grid > .row > [class*=\"thirteen wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"thirteen wide large screen\"].column,\n    .ui.grid > [class*=\"thirteen wide large screen\"].column,\n    .ui.column.grid > [class*=\"thirteen wide large screen\"].column {\n      width: $thirteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fourteen wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"fourteen wide large screen\"].column,\n    .ui.grid > [class*=\"fourteen wide large screen\"].column,\n    .ui.column.grid > [class*=\"fourteen wide large screen\"].column {\n      width: $fourteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fifteen wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"fifteen wide large screen\"].column,\n    .ui.grid > [class*=\"fifteen wide large screen\"].column,\n    .ui.column.grid > [class*=\"fifteen wide large screen\"].column {\n      width: $fifteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"sixteen wide large screen\"].column,\n    .ui.grid > .column.row > [class*=\"sixteen wide large screen\"].column,\n    .ui.grid > [class*=\"sixteen wide large screen\"].column,\n    .ui.column.grid > [class*=\"sixteen wide large screen\"].column {\n      width: $sixteen-wide !important;\n    }\n  }\n\n  /* Widescreen Sizing Combinations */\n  @media only screen and (min-width: $widescreen-monitor-breakpoint) {\n    .ui.grid > .row > [class*=\"one wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"one wide widescreen\"].column,\n    .ui.grid > [class*=\"one wide widescreen\"].column,\n    .ui.column.grid > [class*=\"one wide widescreen\"].column {\n      width: $one-wide !important;\n    }\n    .ui.grid > .row > [class*=\"two wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"two wide widescreen\"].column,\n    .ui.grid > [class*=\"two wide widescreen\"].column,\n    .ui.column.grid > [class*=\"two wide widescreen\"].column {\n      width: $two-wide !important;\n    }\n    .ui.grid > .row > [class*=\"three wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"three wide widescreen\"].column,\n    .ui.grid > [class*=\"three wide widescreen\"].column,\n    .ui.column.grid > [class*=\"three wide widescreen\"].column {\n      width: $three-wide !important;\n    }\n    .ui.grid > .row > [class*=\"four wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"four wide widescreen\"].column,\n    .ui.grid > [class*=\"four wide widescreen\"].column,\n    .ui.column.grid > [class*=\"four wide widescreen\"].column {\n      width: $four-wide !important;\n    }\n    .ui.grid > .row > [class*=\"five wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"five wide widescreen\"].column,\n    .ui.grid > [class*=\"five wide widescreen\"].column,\n    .ui.column.grid > [class*=\"five wide widescreen\"].column {\n      width: $five-wide !important;\n    }\n    .ui.grid > .row > [class*=\"six wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"six wide widescreen\"].column,\n    .ui.grid > [class*=\"six wide widescreen\"].column,\n    .ui.column.grid > [class*=\"six wide widescreen\"].column {\n      width: $six-wide !important;\n    }\n    .ui.grid > .row > [class*=\"seven wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"seven wide widescreen\"].column,\n    .ui.grid > [class*=\"seven wide widescreen\"].column,\n    .ui.column.grid > [class*=\"seven wide widescreen\"].column {\n      width: $seven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eight wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"eight wide widescreen\"].column,\n    .ui.grid > [class*=\"eight wide widescreen\"].column,\n    .ui.column.grid > [class*=\"eight wide widescreen\"].column {\n      width: $eight-wide !important;\n    }\n    .ui.grid > .row > [class*=\"nine wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"nine wide widescreen\"].column,\n    .ui.grid > [class*=\"nine wide widescreen\"].column,\n    .ui.column.grid > [class*=\"nine wide widescreen\"].column {\n      width: $nine-wide !important;\n    }\n    .ui.grid > .row > [class*=\"ten wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"ten wide widescreen\"].column,\n    .ui.grid > [class*=\"ten wide widescreen\"].column,\n    .ui.column.grid > [class*=\"ten wide widescreen\"].column {\n      width: $ten-wide !important;\n    }\n    .ui.grid > .row > [class*=\"eleven wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"eleven wide widescreen\"].column,\n    .ui.grid > [class*=\"eleven wide widescreen\"].column,\n    .ui.column.grid > [class*=\"eleven wide widescreen\"].column {\n      width: $eleven-wide !important;\n    }\n    .ui.grid > .row > [class*=\"twelve wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"twelve wide widescreen\"].column,\n    .ui.grid > [class*=\"twelve wide widescreen\"].column,\n    .ui.column.grid > [class*=\"twelve wide widescreen\"].column {\n      width: $twelve-wide !important;\n    }\n    .ui.grid > .row > [class*=\"thirteen wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"thirteen wide widescreen\"].column,\n    .ui.grid > [class*=\"thirteen wide widescreen\"].column,\n    .ui.column.grid > [class*=\"thirteen wide widescreen\"].column {\n      width: $thirteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fourteen wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"fourteen wide widescreen\"].column,\n    .ui.grid > [class*=\"fourteen wide widescreen\"].column,\n    .ui.column.grid > [class*=\"fourteen wide widescreen\"].column {\n      width: $fourteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"fifteen wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"fifteen wide widescreen\"].column,\n    .ui.grid > [class*=\"fifteen wide widescreen\"].column,\n    .ui.column.grid > [class*=\"fifteen wide widescreen\"].column {\n      width: $fifteen-wide !important;\n    }\n    .ui.grid > .row > [class*=\"sixteen wide widescreen\"].column,\n    .ui.grid > .column.row > [class*=\"sixteen wide widescreen\"].column,\n    .ui.grid > [class*=\"sixteen wide widescreen\"].column,\n    .ui.column.grid > [class*=\"sixteen wide widescreen\"].column {\n      width: $sixteen-wide !important;\n    }\n  }\n\n  /*----------------------\n          Centered\n  -----------------------*/\n\n  .ui.centered.grid,\n  .ui.centered.grid > .row,\n  .ui.grid > .centered.row {\n    text-align: center;\n    justify-content: center;\n  }\n  .ui.centered.grid > .column:not(.aligned):not(.justified):not(.row),\n  .ui.centered.grid > .row > .column:not(.aligned):not(.justified),\n  .ui.grid .centered.row > .column:not(.aligned):not(.justified) {\n    text-align: left;\n  }\n\n  .ui.grid > .centered.column,\n  .ui.grid > .row > .centered.column {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  /*----------------------\n          Relaxed\n  -----------------------*/\n\n  .ui.relaxed.grid > .column:not(.row),\n  .ui.relaxed.grid > .row > .column,\n  .ui.grid > .relaxed.row > .column {\n    padding-left: ($grid-relaxed-gutter-width / 2);\n    padding-right: ($grid-relaxed-gutter-width / 2);\n  }\n\n  .ui[class*=\"very relaxed\"].grid > .column:not(.row),\n  .ui[class*=\"very relaxed\"].grid > .row > .column,\n  .ui.grid > [class*=\"very relaxed\"].row > .column {\n    padding-left: ($grid-very-relaxed-gutter-width / 2);\n    padding-right: ($grid-very-relaxed-gutter-width / 2);\n  }\n\n  /* Coupling with UI Divider */\n  .ui.relaxed.grid .row + .ui.divider,\n  .ui.grid .relaxed.row + .ui.divider {\n    margin-left: ($grid-relaxed-gutter-width / 2);\n    margin-right: ($grid-relaxed-gutter-width / 2);\n  }\n  .ui[class*=\"very relaxed\"].grid .row + .ui.divider,\n  .ui.grid [class*=\"very relaxed\"].row + .ui.divider {\n    margin-left: ($grid-very-relaxed-gutter-width / 2);\n    margin-right: ($grid-very-relaxed-gutter-width / 2);\n  }\n\n\n  /*----------------------\n          Padded\n  -----------------------*/\n\n  .ui.padded.grid:not(.vertically):not(.horizontally) {\n    margin: 0 !important;\n  }\n  [class*=\"horizontally padded\"].ui.grid {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n  [class*=\"vertically padded\"].ui.grid {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  /*----------------------\n        \"Floated\"\n  -----------------------*/\n\n  .ui.grid [class*=\"left floated\"].column {\n    margin-right: auto;\n  }\n  .ui.grid [class*=\"right floated\"].column {\n    margin-left: auto;\n  }\n\n\n  /*----------------------\n          Divided\n  -----------------------*/\n\n  .ui.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row),\n  .ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column {\n    box-shadow: $grid-divided-border;\n  }\n\n  /* Swap from padding to margin on columns to have dividers align */\n  .ui[class*=\"vertically divided\"].grid > .column:not(.row),\n  .ui[class*=\"vertically divided\"].grid > .row > .column {\n    margin-top: ($grid-row-spacing / 2);\n    margin-bottom: ($grid-row-spacing / 2);\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n  .ui[class*=\"vertically divided\"].grid > .row {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n\n\n  /* No divider on first column on row */\n  .ui.divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n  .ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: none;\n  }\n\n  /* No space on top of first row */\n  .ui[class*=\"vertically divided\"].grid > .row:first-child > .column {\n    margin-top: 0;\n  }\n\n\n  /* Divided Row */\n  .ui.grid > .divided.row > .column {\n    box-shadow: $grid-divided-border;\n  }\n  .ui.grid > .divided.row > .column:first-child {\n    box-shadow: none;\n  }\n\n  /* Vertically Divided */\n  .ui[class*=\"vertically divided\"].grid > .row {\n    position: relative;\n  }\n  .ui[class*=\"vertically divided\"].grid > .row:before {\n    position: absolute;\n    content: \"\";\n    top: 0;\n    left: 0;\n\n    width: calc(100% - #{$grid-gutter-width});\n    height: 1px;\n\n    margin: 0 ($grid-gutter-width / 2);\n    box-shadow: $grid-vertically-divided-border;\n  }\n\n  /* Padded Horizontally Divided */\n  [class*=\"horizontally padded\"].ui.divided.grid,\n  .ui.padded.divided.grid:not(.vertically):not(.horizontally) {\n    width: 100%;\n  }\n\n  /* First Row Vertically Divided */\n  .ui[class*=\"vertically divided\"].grid > .row:first-child:before {\n    box-shadow: none;\n  }\n\n  /* Inverted Divided */\n  .ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row),\n  .ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .row > .column {\n    box-shadow: $grid-divided-inverted-border;\n  }\n  .ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .column:not(.row):first-child,\n  .ui.inverted.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n    box-shadow: none;\n  }\n  .ui.inverted[class*=\"vertically divided\"].grid > .row:before {\n    box-shadow: $grid-vertically-divided-inverted-border;\n  }\n\n  /* Relaxed */\n  .ui.relaxed[class*=\"vertically divided\"].grid > .row:before {\n    margin-left: ($grid-relaxed-gutter-width / 2);\n    margin-right: ($grid-relaxed-gutter-width / 2);\n    width: calc(100% - #{$grid-relaxed-gutter-width});\n  }\n  .ui[class*=\"very relaxed\"][class*=\"vertically divided\"].grid > .row:before {\n    margin-left: ($grid-very-relaxed-gutter-width / 2);\n    margin-right: ($grid-very-relaxed-gutter-width / 2);\n    width: calc(100% - #{$grid-very-relaxed-gutter-width});\n  }\n\n  /*----------------------\n          Celled\n  -----------------------*/\n\n  .ui.celled.grid {\n    width: 100%;\n    margin: $grid-celled-margin;\n    box-shadow: $grid-celled-divider;\n  }\n\n  .ui.celled.grid > .row {\n    width: 100% !important;\n    margin: 0;\n    padding: 0;\n    box-shadow: $grid-celled-row-divider;\n  }\n  .ui.celled.grid > .column:not(.row),\n  .ui.celled.grid > .row > .column {\n    box-shadow: $grid-celled-column-divider;\n  }\n\n  .ui.celled.grid > .column:first-child,\n  .ui.celled.grid > .row > .column:first-child {\n    box-shadow: none;\n  }\n\n  .ui.celled.grid > .column:not(.row),\n  .ui.celled.grid > .row > .column {\n    padding: $grid-celled-padding;\n  }\n  .ui.relaxed.celled.grid > .column:not(.row),\n  .ui.relaxed.celled.grid > .row > .column {\n    padding: $grid-celled-relaxed-padding;\n  }\n  .ui[class*=\"very relaxed\"].celled.grid > .column:not(.row),\n  .ui[class*=\"very relaxed\"].celled.grid > .row > .column {\n    padding: $grid-celled-very-relaxed-padding;\n  }\n\n  /* Internally Celled */\n  .ui[class*=\"internally celled\"].grid {\n    box-shadow: none;\n    margin: 0;\n  }\n  .ui[class*=\"internally celled\"].grid > .row:first-child {\n    box-shadow: none;\n  }\n  .ui[class*=\"internally celled\"].grid > .row > .column:first-child {\n    box-shadow: none;\n  }\n\n  /*----------------------\n    Vertically Aligned\n  -----------------------*/\n\n  /* Top Aligned */\n  .ui[class*=\"top aligned\"].grid > .column:not(.row),\n  .ui[class*=\"top aligned\"].grid > .row > .column,\n  .ui.grid > [class*=\"top aligned\"].row > .column,\n  .ui.grid > [class*=\"top aligned\"].column:not(.row),\n  .ui.grid > .row > [class*=\"top aligned\"].column {\n    flex-direction: column;\n    vertical-align: top;\n    align-self: flex-start !important;\n  }\n\n  /* Middle Aligned */\n  .ui[class*=\"middle aligned\"].grid > .column:not(.row),\n  .ui[class*=\"middle aligned\"].grid > .row > .column,\n  .ui.grid > [class*=\"middle aligned\"].row > .column,\n  .ui.grid > [class*=\"middle aligned\"].column:not(.row),\n  .ui.grid > .row > [class*=\"middle aligned\"].column {\n    flex-direction: column;\n    vertical-align: middle;\n    align-self: center !important;\n  }\n\n  /* Bottom Aligned */\n  .ui[class*=\"bottom aligned\"].grid > .column:not(.row),\n  .ui[class*=\"bottom aligned\"].grid > .row > .column,\n  .ui.grid > [class*=\"bottom aligned\"].row > .column,\n  .ui.grid > [class*=\"bottom aligned\"].column:not(.row),\n  .ui.grid > .row > [class*=\"bottom aligned\"].column {\n    flex-direction: column;\n    vertical-align: bottom;\n    align-self: flex-end !important;\n  }\n\n  /* Stretched */\n  .ui.stretched.grid > .row > .column,\n  .ui.stretched.grid > .column,\n  .ui.grid > .stretched.row > .column,\n  .ui.grid > .stretched.column:not(.row),\n  .ui.grid > .row > .stretched.column {\n    display: inline-flex !important;\n    align-self: stretch;\n    flex-direction: column;\n  }\n\n  .ui.stretched.grid > .row > .column > *,\n  .ui.stretched.grid > .column > *,\n  .ui.grid > .stretched.row > .column > *,\n  .ui.grid > .stretched.column:not(.row) > *,\n  .ui.grid > .row > .stretched.column > * {\n    flex-grow: 1;\n  }\n\n  /*----------------------\n    Horizontally Centered\n  -----------------------*/\n\n  /* Left Aligned */\n  .ui[class*=\"left aligned\"].grid > .column,\n  .ui[class*=\"left aligned\"].grid > .row > .column,\n  .ui.grid > [class*=\"left aligned\"].row > .column,\n  .ui.grid > [class*=\"left aligned\"].column.column,\n  .ui.grid > .row > [class*=\"left aligned\"].column.column {\n    text-align: left;\n    align-self: inherit;\n  }\n\n  /* Center Aligned */\n  .ui[class*=\"center aligned\"].grid > .column,\n  .ui[class*=\"center aligned\"].grid > .row > .column,\n  .ui.grid > [class*=\"center aligned\"].row > .column,\n  .ui.grid > [class*=\"center aligned\"].column.column,\n  .ui.grid > .row > [class*=\"center aligned\"].column.column {\n    text-align: center;\n    align-self: inherit;\n  }\n  .ui[class*=\"center aligned\"].grid {\n    justify-content: center;\n  }\n\n  /* Right Aligned */\n  .ui[class*=\"right aligned\"].grid > .column,\n  .ui[class*=\"right aligned\"].grid > .row > .column,\n  .ui.grid > [class*=\"right aligned\"].row > .column,\n  .ui.grid > [class*=\"right aligned\"].column.column,\n  .ui.grid > .row > [class*=\"right aligned\"].column.column {\n    text-align: right;\n    align-self: inherit;\n  }\n\n  /* Justified */\n  .ui.justified.grid > .column,\n  .ui.justified.grid > .row > .column,\n  .ui.grid > .justified.row > .column,\n  .ui.grid > .justified.column.column,\n  .ui.grid > .row > .justified.column.column {\n    text-align: justify;\n    hyphens: auto;\n  }\n\n  /*----------------------\n          Colored\n  -----------------------*/\n\n  @each $key, $value in $colors {\n    $color: $key;\n    $c: map-get($value, color);\n\n    .ui.grid > .#{$key + \"\"}.row,\n    .ui.grid > .#{$key + \"\"}.column,\n    .ui.grid > .row > .#{$key + \"\"}.column {\n      background-color: $c;\n      color: $white;\n    }\n  }\n\n\n  /*----------------------\n        Equal Width\n  -----------------------*/\n\n  .ui[class*=\"equal width\"].grid > .column:not(.row),\n  .ui[class*=\"equal width\"].grid > .row > .column,\n  .ui.grid > [class*=\"equal width\"].row > .column {\n    display: inline-block;\n    flex-grow: 1;\n  }\n  .ui[class*=\"equal width\"].grid > .wide.column,\n  .ui[class*=\"equal width\"].grid > .row > .wide.column,\n  .ui.grid > [class*=\"equal width\"].row > .wide.column {\n    flex-grow: 0;\n  }\n\n\n  /*----------------------\n          Reverse\n  -----------------------*/\n\n\n  /* Mobile */\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui[class*=\"mobile reversed\"].grid,\n    .ui[class*=\"mobile reversed\"].grid > .row,\n    .ui.grid > [class*=\"mobile reversed\"].row {\n      flex-direction: row-reverse;\n    }\n    .ui[class*=\"mobile vertically reversed\"].grid,\n    .ui.stackable[class*=\"mobile reversed\"] {\n      flex-direction: column-reverse;\n    }\n\n    /* Divided Reversed */\n    .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n    .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n      box-shadow: $grid-divided-border;\n    }\n    .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n    .ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n      box-shadow: none;\n    }\n    /* Vertically Divided Reversed */\n    .ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"] > .row:first-child:before {\n      box-shadow: $grid-vertically-divided-border;\n    }\n    .ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"] > .row:last-child:before {\n      box-shadow: none;\n    }\n    /* Celled Reversed */\n    .ui[class*=\"mobile reversed\"].celled.grid > .row > .column:first-child {\n      box-shadow: $grid-celled-column-divider;\n    }\n    .ui[class*=\"mobile reversed\"].celled.grid > .row > .column:last-child {\n      box-shadow: none;\n    }\n  }\n\n  /* Tablet */\n  @media only screen and (min-width: $tablet-breakpoint) and (max-width: $largest-tablet-screen) {\n    .ui[class*=\"tablet reversed\"].grid,\n    .ui[class*=\"tablet reversed\"].grid > .row,\n    .ui.grid > [class*=\"tablet reversed\"].row {\n      flex-direction: row-reverse;\n    }\n    .ui[class*=\"tablet vertically reversed\"].grid {\n      flex-direction: column-reverse;\n    }\n\n    /* Divided Reversed */\n    .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n    .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n      box-shadow: $grid-divided-border;\n    }\n    .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n    .ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n      box-shadow: none;\n    }\n    /* Vertically Divided Reversed */\n    .ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"] > .row:first-child:before {\n      box-shadow: $grid-vertically-divided-border;\n    }\n    .ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"] > .row:last-child:before {\n      box-shadow: none;\n    }\n    /* Celled Reversed */\n    .ui[class*=\"tablet reversed\"].celled.grid > .row > .column:first-child {\n      box-shadow: $grid-celled-column-divider;\n    }\n    .ui[class*=\"tablet reversed\"].celled.grid > .row > .column:last-child {\n      box-shadow: none;\n    }\n  }\n\n  /* Computer */\n  @media only screen and (min-width: $computer-breakpoint) {\n    .ui[class*=\"computer reversed\"].grid,\n    .ui[class*=\"computer reversed\"].grid > .row,\n    .ui.grid > [class*=\"computer reversed\"].row {\n      flex-direction: row-reverse;\n    }\n    .ui[class*=\"computer vertically reversed\"].grid {\n      flex-direction: column-reverse;\n    }\n\n    /* Divided Reversed */\n    .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:first-child,\n    .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:first-child {\n      box-shadow: $grid-divided-border;\n    }\n    .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .column:last-child,\n    .ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"]) > .row > .column:last-child {\n      box-shadow: none;\n    }\n    /* Vertically Divided Reversed */\n    .ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"] > .row:first-child:before {\n      box-shadow: $grid-vertically-divided-border;\n    }\n    .ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"] > .row:last-child:before {\n      box-shadow: none;\n    }\n    /* Celled Reversed */\n    .ui[class*=\"computer reversed\"].celled.grid > .row > .column:first-child {\n      box-shadow: $grid-celled-column-divider;\n    }\n    .ui[class*=\"computer reversed\"].celled.grid > .row > .column:last-child {\n      box-shadow: none;\n    }\n  }\n\n\n  /*-------------------\n        Doubling\n  --------------------*/\n\n  /* Tablet Only */\n  @media only screen and (min-width: $tablet-breakpoint) and (max-width: $largest-tablet-screen) {\n    .ui.doubling.grid {\n      width: auto;\n    }\n    .ui.grid > .doubling.row,\n    .ui.doubling.grid > .row {\n      margin: 0 !important;\n      padding: 0 !important;\n    }\n    .ui.grid > .doubling.row > .column,\n    .ui.doubling.grid > .row > .column {\n      display: inline-block !important;\n      padding-top: ($grid-row-spacing / 2) !important;\n      padding-bottom: ($grid-row-spacing / 2) !important;\n      box-shadow: none !important;\n      margin: 0;\n    }\n    .ui[class*=\"two column\"].doubling.grid > .row > .column,\n    .ui[class*=\"two column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"two column\"].doubling.row.row > .column {\n      width: $one-column !important;\n    }\n    .ui[class*=\"three column\"].doubling.grid > .row > .column,\n    .ui[class*=\"three column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"three column\"].doubling.row.row > .column {\n      width: $two-column !important;\n    }\n    .ui[class*=\"four column\"].doubling.grid > .row > .column,\n    .ui[class*=\"four column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"four column\"].doubling.row.row > .column {\n      width: $two-column !important;\n    }\n    .ui[class*=\"five column\"].doubling.grid > .row > .column,\n    .ui[class*=\"five column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"five column\"].doubling.row.row > .column {\n      width: $three-column !important;\n    }\n    .ui[class*=\"six column\"].doubling.grid > .row > .column,\n    .ui[class*=\"six column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"six column\"].doubling.row.row > .column {\n      width: $three-column !important;\n    }\n    .ui[class*=\"seven column\"].doubling.grid > .row > .column,\n    .ui[class*=\"seven column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"seven column\"].doubling.row.row > .column {\n      width: $three-column !important;\n    }\n    .ui[class*=\"eight column\"].doubling.grid > .row > .column,\n    .ui[class*=\"eight column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"eight column\"].doubling.row.row > .column {\n      width: $four-column !important;\n    }\n    .ui[class*=\"nine column\"].doubling.grid > .row > .column,\n    .ui[class*=\"nine column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"nine column\"].doubling.row.row > .column {\n      width: $four-column !important;\n    }\n    .ui[class*=\"ten column\"].doubling.grid > .row > .column,\n    .ui[class*=\"ten column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"ten column\"].doubling.row.row > .column {\n      width: $five-column !important;\n    }\n    .ui[class*=\"eleven column\"].doubling.grid > .row > .column,\n    .ui[class*=\"eleven column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"eleven column\"].doubling.row.row > .column {\n      width: $five-column !important;\n    }\n    .ui[class*=\"twelve column\"].doubling.grid > .row > .column,\n    .ui[class*=\"twelve column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"twelve column\"].doubling.row.row > .column {\n      width: $six-column !important;\n    }\n    .ui[class*=\"thirteen column\"].doubling.grid > .row > .column,\n    .ui[class*=\"thirteen column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"thirteen column\"].doubling.row.row > .column {\n      width: $six-column !important;\n    }\n    .ui[class*=\"fourteen column\"].doubling.grid > .row > .column,\n    .ui[class*=\"fourteen column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"fourteen column\"].doubling.row.row > .column {\n      width: $seven-column !important;\n    }\n    .ui[class*=\"fifteen column\"].doubling.grid > .row > .column,\n    .ui[class*=\"fifteen column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"fifteen column\"].doubling.row.row > .column {\n      width: $seven-column !important;\n    }\n    .ui[class*=\"sixteen column\"].doubling.grid > .row > .column,\n    .ui[class*=\"sixteen column\"].doubling.grid > .column:not(.row),\n    .ui.grid > [class*=\"sixteen column\"].doubling.row.row > .column {\n      width: $eight-column !important;\n    }\n  }\n\n  /* Mobile Only */\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.grid > .doubling.row,\n    .ui.doubling.grid > .row {\n      margin: 0 !important;\n      padding: 0 !important;\n    }\n    .ui.grid > .doubling.row > .column,\n    .ui.doubling.grid > .row > .column {\n      padding-top: ($grid-row-spacing / 2) !important;\n      padding-bottom: ($grid-row-spacing / 2) !important;\n      margin: 0 !important;\n      box-shadow: none !important;\n    }\n    .ui[class*=\"two column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"two column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"two column\"].doubling:not(.stackable).row.row > .column {\n      width: $one-column !important;\n    }\n    .ui[class*=\"three column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"three column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"three column\"].doubling:not(.stackable).row.row > .column {\n      width: $two-column !important;\n    }\n    .ui[class*=\"four column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"four column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"four column\"].doubling:not(.stackable).row.row > .column {\n      width: $two-column !important;\n    }\n    .ui[class*=\"five column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"five column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"five column\"].doubling:not(.stackable).row.row > .column {\n      width: $two-column !important;\n    }\n    .ui[class*=\"six column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"six column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"six column\"].doubling:not(.stackable).row.row > .column {\n      width: $two-column !important;\n    }\n    .ui[class*=\"seven column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"seven column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"seven column\"].doubling:not(.stackable).row.row > .column {\n      width: $two-column !important;\n    }\n    .ui[class*=\"eight column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"eight column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"eight column\"].doubling:not(.stackable).row.row > .column {\n      width: $two-column !important;\n    }\n    .ui[class*=\"nine column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"nine column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"nine column\"].doubling:not(.stackable).row.row > .column {\n      width: $three-column !important;\n    }\n    .ui[class*=\"ten column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"ten column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"ten column\"].doubling:not(.stackable).row.row > .column {\n      width: $three-column !important;\n    }\n    .ui[class*=\"eleven column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"eleven column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"eleven column\"].doubling:not(.stackable).row.row > .column {\n      width: $three-column !important;\n    }\n    .ui[class*=\"twelve column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"twelve column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"twelve column\"].doubling:not(.stackable).row.row > .column {\n      width: $three-column !important;\n    }\n    .ui[class*=\"thirteen column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"thirteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"thirteen column\"].doubling:not(.stackable).row.row > .column {\n      width: $three-column !important;\n    }\n    .ui[class*=\"fourteen column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"fourteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"fourteen column\"].doubling:not(.stackable).row.row > .column {\n      width: $four-column !important;\n    }\n    .ui[class*=\"fifteen column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"fifteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"fifteen column\"].doubling:not(.stackable).row.row > .column {\n      width: $four-column !important;\n    }\n    .ui[class*=\"sixteen column\"].doubling:not(.stackable).grid > .row > .column,\n    .ui[class*=\"sixteen column\"].doubling:not(.stackable).grid > .column:not(.row),\n    .ui.grid > [class*=\"sixteen column\"].doubling:not(.stackable).row.row > .column {\n      width: $four-column !important;\n    }\n  }\n\n  /*-------------------\n        Stackable\n  --------------------*/\n\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.stackable.grid {\n      width: auto;\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n    }\n    .ui.stackable.grid > .row > .wide.column,\n    .ui.stackable.grid > .wide.column,\n    .ui.stackable.grid > .column.grid > .column,\n    .ui.stackable.grid > .column.row > .column,\n    .ui.stackable.grid > .row > .column,\n    .ui.stackable.grid > .column:not(.row),\n    .ui.grid > .stackable.stackable.row > .column {\n      width: 100% !important;\n      margin: 0 0 !important;\n      box-shadow: none !important;\n      padding: ($grid-stackable-row-spacing / 2) ($grid-stackable-gutter / 2) !important;\n    }\n    .ui.stackable.grid:not(.vertically) > .row {\n      margin: 0;\n      padding: 0;\n    }\n\n    /* Coupling */\n    .ui.container > .ui.stackable.grid > .column,\n    .ui.container > .ui.stackable.grid > .row > .column {\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    }\n\n    /* Don't pad inside segment or nested grid */\n    .ui.grid .ui.stackable.grid,\n    .ui.segment:not(.vertical) .ui.stackable.page.grid {\n      margin-left: -($grid-stackable-gutter / 2) !important;\n      margin-right: -($grid-stackable-gutter / 2) !important;\n    }\n\n    /* Divided Stackable */\n    .ui.stackable.divided.grid > .row:first-child > .column:first-child,\n    .ui.stackable.celled.grid > .row:first-child > .column:first-child,\n    .ui.stackable.divided.grid > .column:not(.row):first-child,\n    .ui.stackable.celled.grid > .column:not(.row):first-child {\n      border-top: none !important;\n    }\n    .ui.inverted.stackable.celled.grid > .column:not(.row),\n    .ui.inverted.stackable.divided.grid > .column:not(.row),\n    .ui.inverted.stackable.celled.grid > .row > .column,\n    .ui.inverted.stackable.divided.grid > .row > .column {\n      border-top: $grid-stackable-inverted-mobile-border;\n    }\n\n    .ui.stackable.celled.grid > .column:not(.row),\n    .ui.stackable.divided:not(.vertically).grid > .column:not(.row),\n    .ui.stackable.celled.grid > .row > .column,\n    .ui.stackable.divided:not(.vertically).grid > .row > .column {\n      border-top: $grid-stackable-mobile-border;\n      box-shadow: none !important;\n      padding-top: $grid-stackable-row-spacing !important;\n      padding-bottom: $grid-stackable-row-spacing !important;\n    }\n\n    .ui.stackable.celled.grid > .row {\n      box-shadow: none !important;\n    }\n    .ui.stackable.divided:not(.vertically).grid > .column:not(.row),\n    .ui.stackable.divided:not(.vertically).grid > .row > .column {\n      padding-left: 0 !important;\n      padding-right: 0 !important;\n    }\n\n  }\n\n  /*----------------------\n      Only (Device)\n  -----------------------*/\n\n\n  /* These include arbitrary class repetitions for forced specificity */\n\n  /* Mobile Only Hide */\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui[class*=\"tablet only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.mobile) {\n      display: none !important;\n    }\n    .ui[class*=\"computer only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"computer only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"computer only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"computer only\"].column:not(.mobile) {\n      display: none !important;\n    }\n    .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n      display: none !important;\n    }\n    .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n      display: none !important;\n    }\n  }\n  /* Tablet Only Hide */\n  @media only screen and (min-width: $tablet-breakpoint) and (max-width: $largest-tablet-screen) {\n    .ui[class*=\"mobile only\"].grid.grid.grid:not(.tablet),\n    .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.tablet),\n    .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.tablet),\n    .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.tablet) {\n      display: none !important;\n    }\n    .ui[class*=\"computer only\"].grid.grid.grid:not(.tablet),\n    .ui.grid.grid.grid > [class*=\"computer only\"].row:not(.tablet),\n    .ui.grid.grid.grid > [class*=\"computer only\"].column:not(.tablet),\n    .ui.grid.grid.grid > .row > [class*=\"computer only\"].column:not(.tablet) {\n      display: none !important;\n    }\n    .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n      display: none !important;\n    }\n    .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n      display: none !important;\n    }\n  }\n\n  /* Computer Only Hide */\n  @media only screen and (min-width: $computer-breakpoint) and (max-width: $largest-small-monitor) {\n    .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n    .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n    .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n    .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n      display: none !important;\n    }\n    .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n    .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n    .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n    .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n      display: none !important;\n    }\n    .ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"large screen only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"large screen only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"large screen only\"].column:not(.mobile) {\n      display: none !important;\n    }\n    .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n      display: none !important;\n    }\n  }\n\n  /* Large Screen Only Hide */\n  @media only screen and (min-width: $large-monitor-breakpoint) and (max-width: $largest-large-monitor) {\n    .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n    .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n    .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n    .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n      display: none !important;\n    }\n    .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n    .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n    .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n    .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n      display: none !important;\n    }\n    .ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"widescreen only\"].row:not(.mobile),\n    .ui.grid.grid.grid > [class*=\"widescreen only\"].column:not(.mobile),\n    .ui.grid.grid.grid > .row > [class*=\"widescreen only\"].column:not(.mobile) {\n      display: none !important;\n    }\n  }\n\n  /* Widescreen Only Hide */\n  @media only screen and (min-width: $widescreen-monitor-breakpoint) {\n    .ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),\n    .ui.grid.grid.grid > [class*=\"mobile only\"].row:not(.computer),\n    .ui.grid.grid.grid > [class*=\"mobile only\"].column:not(.computer),\n    .ui.grid.grid.grid > .row > [class*=\"mobile only\"].column:not(.computer) {\n      display: none !important;\n    }\n    .ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),\n    .ui.grid.grid.grid > [class*=\"tablet only\"].row:not(.computer),\n    .ui.grid.grid.grid > [class*=\"tablet only\"].column:not(.computer),\n    .ui.grid.grid.grid > .row > [class*=\"tablet only\"].column:not(.computer) {\n      display: none !important;\n    }\n  }\n\n  /*-----------------\n        Compact\n  -----------------*/\n\n  .ui.compact.grid > .column:not(.row),\n  .ui.compact.grid > .row > .column {\n    padding-left: ($grid-compact-gutter-width / 2);\n    padding-right: ($grid-compact-gutter-width / 2);\n  }\n\n  .ui.compact.grid > * {\n    padding-left: ($grid-compact-gutter-width / 2);\n    padding-right: ($grid-compact-gutter-width / 2);\n  }\n\n  /* Row */\n  .ui.compact.grid > .row {\n    padding-top: ($grid-compact-row-spacing / 2);\n    padding-bottom: ($grid-compact-row-spacing / 2);\n  }\n\n  /* Columns */\n  .ui.compact.grid > .column:not(.row) {\n    padding-top: ($grid-compact-row-spacing / 2);\n    padding-bottom: ($grid-compact-row-spacing / 2);\n  }\n\n  /* Relaxed + Celled */\n  .ui.compact.relaxed.celled.grid > .column:not(.row),\n  .ui.compact.relaxed.celled.grid > .row > .column {\n    padding: $grid-compact-celled-relaxed-padding;\n  }\n  .ui.compact[class*=\"very relaxed\"].celled.grid > .column:not(.row),\n  .ui.compact[class*=\"very relaxed\"].celled.grid > .row > .column {\n    padding: $grid-compact-celled-very-relaxed-padding;\n  }\n\n  /*-----------------\n      Very compact\n  -----------------*/\n\n  .ui[class*=\"very compact\"].grid > .column:not(.row),\n  .ui[class*=\"very compact\"].grid > .row > .column {\n    padding-left: ($grid-very-compact-gutter-width / 2);\n    padding-right: ($grid-compact-gutter-width / 2);\n  }\n\n  .ui[class*=\"very compact\"].grid > * {\n    padding-left: ($grid-very-compact-gutter-width / 2);\n    padding-right: ($grid-very-compact-gutter-width / 2);\n  }\n\n  /* Row */\n  .ui[class*=\"very compact\"].grid > .row {\n    padding-top: ($grid-very-compact-row-spacing / 2);\n    padding-bottom: ($grid-very-compact-row-spacing / 2);\n  }\n\n  /* Columns */\n  .ui[class*=\"very compact\"].grid > .column:not(.row) {\n    padding-top: ($grid-very-compact-row-spacing / 2);\n    padding-bottom: ($grid-very-compact-row-spacing / 2);\n  }\n\n  /* Relaxed + Celled */\n  .ui[class*=\"very compact\"].relaxed.celled.grid > .column:not(.row),\n  .ui[class*=\"very compact\"].relaxed.celled.grid > .row > .column {\n    padding: $grid-very-compact-celled-relaxed-padding;\n  }\n  .ui[class*=\"very compact\"][class*=\"very relaxed\"].celled.grid > .column:not(.row),\n  .ui[class*=\"very compact\"][class*=\"very relaxed\"].celled.grid > .row > .column {\n    padding: $grid-very-compact-celled-very-relaxed-padding;\n  }\n}\n\n@import '../../themes/default/collections/grid.style';","@import '../../themes/default/collections/menu.variables';\r\n\r\n@if $use-menu {\r\n  /*--------------\r\n  //@-  Menu\r\n  ---------------*/\r\n\r\n  .ui.menu {\r\n    display: flex;\r\n    margin: $menu-margin;\r\n    font-family: $menu-font-family;\r\n    background: $menu-background;\r\n    font-weight: $menu-font-weight;\r\n    border: $menu-border;\r\n    box-shadow: $menu-box-shadow;\r\n    border-radius: $menu-border-radius;\r\n    min-height: $menu-min-height;\r\n  }\r\n\r\n  .ui.menu:after {\r\n    content: '';\r\n    display: block;\r\n    height: 0;\r\n    clear: both;\r\n    visibility: hidden;\r\n  }\r\n\r\n  .ui.menu:first-child {\r\n    margin-top: 0;\r\n  }\r\n  .ui.menu:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n\r\n  /*--------------\r\n      Sub-Menu\r\n  ---------------*/\r\n\r\n  .ui.menu .menu {\r\n    margin: 0;\r\n  }\r\n\r\n  .ui.menu:not(.vertical) > .menu {\r\n    display: flex;\r\n  }\r\n\r\n  /*--------------\r\n        Item\r\n  ---------------*/\r\n\r\n  .ui.menu:not(.vertical) .item {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .ui.menu .item {\r\n    position: relative;\r\n    vertical-align: middle;\r\n    line-height: 1;\r\n    text-decoration: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n    flex: 0 0 auto;\r\n    user-select: none;\r\n\r\n    background: $menu-item-background;\r\n    padding: $menu-item-vertical-padding $menu-item-horizontal-padding;\r\n    text-transform: $menu-item-text-transform;\r\n    color: $menu-item-text-color;\r\n    font-weight: $menu-item-font-weight;\r\n    transition: $menu-item-transition;\r\n  }\r\n\r\n  .ui.menu > .item:first-child {\r\n    border-radius: $menu-border-radius 0 0 $menu-border-radius;\r\n  }\r\n\r\n  /* Border */\r\n  .ui.menu .item:before {\r\n    position: absolute;\r\n    content: '';\r\n    top: 0;\r\n    right: 0;\r\n    height: 100%;\r\n\r\n    width: $menu-divider-size;\r\n    background: $menu-divider-background;\r\n  }\r\n\r\n  /*--------------\r\n    Text Content\r\n  ---------------*/\r\n\r\n  .ui.menu .text.item > *,\r\n  .ui.menu .item > a:not(.ui),\r\n  .ui.menu .item > p:only-child {\r\n    user-select: text;\r\n    line-height: $menu-text-line-height;\r\n  }\r\n  .ui.menu .item > p:first-child {\r\n    margin-top: 0;\r\n  }\r\n  .ui.menu .item > p:last-child {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  /*--------------\r\n        Icons\r\n  ---------------*/\r\n\r\n  .ui.menu .item > i.icon {\r\n    opacity: $menu-icon-opacity;\r\n    float: $menu-icon-float;\r\n    margin: $menu-icon-margin;\r\n  }\r\n\r\n  /*--------------\r\n      Button\r\n  ---------------*/\r\n\r\n  .ui.menu:not(.vertical) .item > .button {\r\n    position: relative;\r\n    top: $menu-button-offset;\r\n    margin: $menu-button-margin;\r\n    padding-bottom: $menu-button-vertical-padding;\r\n    padding-top: $menu-button-vertical-padding;\r\n    font-size: $menu-button-size;\r\n  }\r\n\r\n  /*----------------\r\n  Grid / Container\r\n  -----------------*/\r\n\r\n  .ui.menu >  .grid,\r\n  .ui.menu > .container {\r\n    display: flex;\r\n    align-items: inherit;\r\n    flex-direction: inherit;\r\n  }\r\n\r\n  /*--------------\r\n      Inputs\r\n  ---------------*/\r\n\r\n  .ui.menu .item > .input {\r\n    width: 100%;\r\n  }\r\n  .ui.menu:not(.vertical) .item > .input {\r\n    position: relative;\r\n    top: $menu-input-offset;\r\n    margin: $menu-input-vertical-margin 0;\r\n  }\r\n  .ui.menu .item > .input input {\r\n    font-size: $menu-input-size;\r\n    padding-top: $menu-input-vertical-padding;\r\n    padding-bottom: $menu-input-vertical-padding;\r\n  }\r\n\r\n\r\n  /*--------------\r\n      Header\r\n  ---------------*/\r\n\r\n  .ui.menu .header.item,\r\n  .ui.vertical.menu .header.item {\r\n    margin: 0;\r\n    background: $menu-header-background;\r\n    text-transform: $menu-header-text-transform;\r\n    font-weight: $menu-header-weight;\r\n  }\r\n\r\n  .ui.vertical.menu .item > .header:not(.ui) {\r\n    margin: $menu-vertical-header-margin;\r\n    font-size: $menu-vertical-header-font-size;\r\n    font-weight: $menu-vertical-header-font-weight;\r\n  }\r\n\r\n  /*--------------\r\n      Dropdowns\r\n  ---------------*/\r\n\r\n\r\n  /* Dropdown Icon */\r\n  .ui.menu .item > i.dropdown.icon {\r\n    padding: 0;\r\n    float: $menu-dropdown-icon-float;\r\n    margin: 0 0 0 $menu-dropdown-icon-distance;\r\n  }\r\n\r\n  /* Menu */\r\n  .ui.menu .dropdown.item .menu {\r\n    min-width: calc(100% - 1px);\r\n    border-radius: 0 0 $menu-dropdown-border-radius $menu-dropdown-border-radius;\r\n    background: $menu-dropdown-background;\r\n    margin: $menu-dropdown-distance 0 0;\r\n    box-shadow: $menu-dropdown-box-shadow;\r\n    flex-direction: column !important;\r\n  }\r\n\r\n\r\n  /* Menu Items */\r\n  .ui.menu .ui.dropdown .menu > .item {\r\n    margin: 0;\r\n    text-align: left;\r\n    font-size: $menu-dropdown-item-font-size !important;\r\n    padding: $menu-dropdown-item-padding !important;\r\n    background: $menu-dropdown-item-background !important;\r\n    color: $menu-dropdown-item-color !important;\r\n    text-transform: $menu-dropdown-item-text-transform !important;\r\n    font-weight: $menu-dropdown-item-font-weight !important;\r\n    box-shadow: $menu-dropdown-item-box-shadow !important;\r\n    transition: $menu-dropdown-item-transition !important;\r\n  }\r\n  .ui.menu .ui.dropdown .menu > .item:hover {\r\n    background: $menu-dropdown-hovered-item-background !important;\r\n    color: $menu-dropdown-hovered-item-color !important;\r\n  }\r\n  .ui.menu .ui.dropdown .menu > .selected.item {\r\n    background: $menu-dropdown-selected-item-background !important;\r\n    color: $menu-dropdown-selected-item-color !important;\r\n  }\r\n  .ui.menu .ui.dropdown .menu > .active.item {\r\n    background: $menu-dropdown-active-item-background !important;\r\n    font-weight: $menu-dropdown-active-item-font-weight !important;\r\n    color: $menu-dropdown-active-item-color !important;\r\n  }\r\n\r\n  .ui.menu .ui.dropdown.item .menu .item:not(.filtered) {\r\n    display: block;\r\n  }\r\n  .ui.menu .ui.dropdown .menu > .item .icon:not(.dropdown) {\r\n    display: inline-block;\r\n    font-size: $menu-dropdown-item-icon-font-size !important;\r\n    float: $menu-dropdown-item-icon-float;\r\n    margin: $menu-dropdown-item-icon-margin !important;\r\n  }\r\n\r\n\r\n  /* Secondary */\r\n  .ui.secondary.menu .dropdown.item > .menu,\r\n  .ui.text.menu .dropdown.item > .menu {\r\n    border-radius: $menu-dropdown-border-radius;\r\n    margin-top: $menu-secondary-dropdown-distance;\r\n  }\r\n\r\n  /* Pointing */\r\n  .ui.menu .pointing.dropdown.item .menu {\r\n    margin-top: $menu-pointing-dropdown-distance;\r\n  }\r\n\r\n  @if($use-menu-variation-inverted) {\r\n    /* Inverted */\r\n    .ui.inverted.menu .search.dropdown.item > .search,\r\n    .ui.inverted.menu .search.dropdown.item > .text {\r\n      color: $menu-inverted-selection-dropdown-color;\r\n    }\r\n  }\r\n\r\n  @if($use-menu-type-vertical) {\r\n    /* Vertical */\r\n    .ui.vertical.menu .dropdown.item > .icon {\r\n      float: right;\r\n      content: \"\\f0da\";\r\n      margin-left: 1em;\r\n    }\r\n    .ui.vertical.menu .dropdown.item .menu {\r\n      left: 100%;\r\n      /* IE needs 0, all others support max-content to show dropdown icon inline, so keep both settings! */\r\n      min-width: 0;\r\n      min-width: max-content;\r\n      margin: 0 0 0 $menu-dropdown-distance;\r\n      box-shadow: $menu-dropdown-vertical-box-shadow;\r\n      border-radius: 0 $menu-dropdown-border-radius $menu-dropdown-border-radius $menu-dropdown-border-radius;\r\n    }\r\n    .ui.vertical.menu .dropdown.item.upward .menu {\r\n      bottom: 0;\r\n    }\r\n    .ui.vertical.menu .dropdown.item:not(.upward) .menu {\r\n      top: 0;\r\n    }\r\n    .ui.vertical.menu .active.dropdown.item {\r\n      border-top-right-radius: 0;\r\n      border-bottom-right-radius: 0;\r\n    }\r\n    .ui.vertical.menu .dropdown.active.item {\r\n      box-shadow: none;\r\n    }\r\n  }\r\n\r\n  /* Evenly Divided */\r\n  .ui.item.menu .dropdown .menu .item {\r\n    width: 100%;\r\n  }\r\n\r\n  /*--------------\r\n      Labels\r\n  ---------------*/\r\n\r\n  .ui.menu .item > .label:not(.floating) {\r\n    margin-left: $menu-label-text-margin;\r\n    padding: $menu-label-vertical-padding $menu-label-horizontal-padding;\r\n  }\r\n  .ui.vertical.menu .item > .label {\r\n    margin-top: $menu-label-offset;\r\n    margin-bottom: $menu-label-offset;\r\n    padding: $menu-label-vertical-padding $menu-label-horizontal-padding;\r\n  }\r\n  .ui.menu .item > .floating.label {\r\n    padding: $menu-label-vertical-padding $menu-label-horizontal-padding;\r\n  }\r\n  .ui.menu .item > .label {\r\n    background: $menu-label-background;\r\n    color: $menu-label-text-color;\r\n  }\r\n  .ui.menu .item > .image.label img {\r\n    margin: $menu-image-label-image-margin;\r\n    height: $menu-image-label-height;\r\n  }\r\n  /*--------------\r\n      Images\r\n  ---------------*/\r\n\r\n  .ui.menu .item > img:not(.ui) {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    margin: $menu-image-margin;\r\n    width: $menu-image-width;\r\n  }\r\n  .ui.vertical.menu .item > img:not(.ui):only-child {\r\n    display: block;\r\n    max-width: 100%;\r\n    width: $menu-vertical-image-width;\r\n  }\r\n\r\n  /*******************************\r\n            Coupling\r\n  *******************************/\r\n\r\n  /*--------------\r\n      List\r\n  ---------------*/\r\n\r\n  /* Menu divider shouldnt apply */\r\n  .ui.menu .list .item:before {\r\n    background: none !important;\r\n  }\r\n\r\n  @if($use-menu-type-vertical) {\r\n    /*--------------\r\n        Sidebar\r\n    ---------------*/\r\n\r\n    /* Show vertical dividers below last */\r\n\r\n    .ui.vertical.sidebar.menu > .item:first-child:before {\r\n      display: block !important;\r\n    }\r\n    .ui.vertical.sidebar.menu > .item::before {\r\n      top: auto;\r\n      bottom: 0;\r\n    }\r\n  }\r\n\r\n  /*--------------\r\n      Container\r\n  ---------------*/\r\n\r\n  @media only screen and (max-width: $largest-mobile-screen) {\r\n    .ui.menu > .ui.container {\r\n      width: 100% !important;\r\n      margin-left: 0 !important;\r\n      margin-right: 0 !important;\r\n    }\r\n  }\r\n  @media only screen and (min-width: $tablet-breakpoint) {\r\n    .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .item:not(.right):not(.borderless):first-child {\r\n      border-left: $menu-divider-size solid $menu-divider-background;\r\n    }\r\n    .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .right.item:not(.borderless):last-child,\r\n    .ui.menu:not(.secondary):not(.text):not(.tabular):not(.borderless) > .container > .right.menu > .item:not(.borderless):last-child {\r\n      border-right: $menu-divider-size solid $menu-divider-background;\r\n    }\r\n  }\r\n\r\n\r\n  /*******************************\r\n              States\r\n  *******************************/\r\n\r\n  /*--------------\r\n        Hover\r\n  ---------------*/\r\n\r\n\r\n  .ui.link.menu .item:hover,\r\n  .ui.menu .dropdown.item:hover,\r\n  .ui.menu .link.item:hover,\r\n  .ui.menu a.item:hover {\r\n    cursor: pointer;\r\n    background: $menu-hover-item-background;\r\n    color: $menu-hover-item-text-color;\r\n  }\r\n\r\n\r\n  /*--------------\r\n      Pressed\r\n  ---------------*/\r\n\r\n  .ui.link.menu .item:active,\r\n  .ui.menu .link.item:active,\r\n  .ui.menu a.item:active {\r\n    background: $menu-pressed-item-background;\r\n    color: $menu-pressed-item-text-color;\r\n  }\r\n\r\n\r\n  /*--------------\r\n      Active\r\n  ---------------*/\r\n\r\n  .ui.menu .active.item  {\r\n    background: $menu-active-item-background;\r\n    color: $menu-active-item-text-color;\r\n    font-weight: $menu-active-item-font-weight;\r\n    box-shadow: $menu-active-item-box-shadow;\r\n  }\r\n  .ui.menu .active.item > i.icon {\r\n    opacity: $menu-active-icon-opacity;\r\n  }\r\n\r\n  /*--------------\r\n    Active Hover\r\n  ---------------*/\r\n\r\n  .ui.menu .active.item:hover,\r\n  .ui.vertical.menu .active.item:hover {\r\n    background-color: $menu-active-hover-item-background;\r\n    color: $menu-active-hover-item-color;\r\n  }\r\n\r\n\r\n  /*--------------\r\n      Disabled\r\n  ---------------*/\r\n\r\n  .ui.ui.menu .item.disabled {\r\n    cursor: default;\r\n    background-color: transparent;\r\n    color: $disabled-text-color;\r\n    pointer-events: none;\r\n  }\r\n\r\n\r\n  /*******************************\r\n              Types\r\n  *******************************/\r\n\r\n  /*------------------\r\n  Floated Menu / Item\r\n  -------------------*/\r\n\r\n  /* Left Floated */\r\n  .ui.menu:not(.vertical) .left.item,\r\n  .ui.menu:not(.vertical) .left.menu {\r\n    display: flex;\r\n    margin-right: auto !important;\r\n  }\r\n  /* Right Floated */\r\n  .ui.menu:not(.vertical) .right.item,\r\n  .ui.menu:not(.vertical) .right.menu {\r\n    display: flex;\r\n    margin-left: auto !important;\r\n  }\r\n\r\n  .ui.menu:not(.vertical) :not(.dropdown) > .left.menu,\r\n  .ui.menu:not(.vertical) :not(.dropdown) > .right.menu {\r\n    display: inherit;\r\n  }\r\n\r\n  /* Center */\r\n  .ui.menu:not(.vertical) .center.item,\r\n  .ui.menu:not(.vertical) .center.menu {\r\n    display: flex;\r\n    margin-left: auto !important;\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  /* Swapped Borders */\r\n  .ui.menu .right.item::before,\r\n  .ui.menu .right.menu > .item::before {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  /* Remove Outer Borders */\r\n  .ui.menu .center.item:last-child::before,\r\n  .ui.menu .center.menu > .item:last-child::before {\r\n    display: none;\r\n  }\r\n\r\n  @if($use-menu-type-vertical) {\r\n    /*--------------\r\n        Vertical\r\n    ---------------*/\r\n\r\n    .ui.vertical.menu {\r\n      display: block;\r\n      flex-direction: column;\r\n      background: $menu-vertical-background;\r\n      box-shadow: $menu-vertical-box-shadow;\r\n    }\r\n\r\n    /*--- Item ---*/\r\n    .ui.vertical.menu .item {\r\n      display: block;\r\n      background: $menu-vertical-item-background;\r\n      border-top: none;\r\n      border-right: none;\r\n    }\r\n    .ui.vertical.menu > .item:first-child {\r\n      border-radius: $menu-border-radius $menu-border-radius 0 0;\r\n    }\r\n    .ui.vertical.menu > .item:last-child {\r\n      border-radius: 0 0 $menu-border-radius $menu-border-radius;\r\n    }\r\n\r\n    /*--- Label ---*/\r\n    .ui.vertical.menu .item > .label {\r\n      float: right;\r\n      text-align: center;\r\n    }\r\n\r\n    /*--- Icon ---*/\r\n    .ui.vertical.menu .item > i.icon,\r\n    .ui.vertical.menu .item > i.icons {\r\n      width: $icon-width;\r\n      float: $menu-vertical-icon-float;\r\n      margin: $menu-vertical-icon-margin;\r\n    }\r\n    .ui.vertical.menu .item > .label + i.icon {\r\n      float: $menu-label-and-icon-float;\r\n      margin: $menu-label-and-icon-margin;\r\n    }\r\n\r\n\r\n    /*--- Border ---*/\r\n    .ui.vertical.menu .item:before {\r\n      position: absolute;\r\n      content: '';\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: $menu-divider-size;\r\n      background: $menu-vertical-divider-background;\r\n    }\r\n\r\n    .ui.vertical.menu .item:first-child:before {\r\n      display: none !important;\r\n    }\r\n\r\n\r\n    /*--- Sub Menu ---*/\r\n    .ui.vertical.menu .item > .menu {\r\n      margin: $menu-sub-margin;\r\n    }\r\n    .ui.vertical.menu .menu .item {\r\n      background: none;\r\n      padding: $menu-sub-vertical-padding $menu-sub-horizontal-padding;\r\n      font-size: $menu-sub-font-size;\r\n      color: $menu-sub-text-color;\r\n    }\r\n    .ui.vertical.menu .item .menu a.item:hover,\r\n    .ui.vertical.menu .item .menu .link.item:hover {\r\n      color: $dark-text-color;\r\n    }\r\n    .ui.vertical.menu .menu .item:before {\r\n      display: none;\r\n    }\r\n\r\n    /* Vertical Active */\r\n    .ui.vertical.menu .active.item {\r\n      background: $menu-active-item-background;\r\n      border-radius: 0;\r\n      box-shadow: $menu-vertical-active-box-shadow;\r\n    }\r\n    .ui.vertical.menu > .active.item:first-child {\r\n      border-radius: $menu-border-radius $menu-border-radius 0 0;\r\n    }\r\n    .ui.vertical.menu > .active.item:last-child {\r\n      border-radius: 0 0 $menu-border-radius $menu-border-radius;\r\n    }\r\n    .ui.vertical.menu > .active.item:only-child {\r\n      border-radius: $menu-border-radius;\r\n    }\r\n    .ui.vertical.menu .active.item .menu .active.item {\r\n      border-left: none;\r\n    }\r\n    .ui.vertical.menu .item .menu .active.item {\r\n      background-color: $menu-sub-active-background;\r\n      font-weight: $menu-sub-active-font-weight;\r\n      color: $menu-sub-active-text-color;\r\n    }\r\n  }\r\n\r\n\r\n  @if($use-menu-type-tabular) {\r\n    /*--------------\r\n        Tabular\r\n    ---------------*/\r\n\r\n    .ui.tabular.menu {\r\n      border-radius: 0;\r\n      box-shadow: none !important;\r\n      border: none;\r\n      background: $menu-tabular-background;\r\n      border-bottom: $menu-tabular-border-width solid $menu-tabular-border-color;\r\n    }\r\n    .ui.tabular.fluid.menu {\r\n      width: $menu-tabular-fluid-width !important;\r\n    }\r\n    .ui.tabular.menu .item {\r\n      background: transparent;\r\n      border-bottom: none;\r\n\r\n      border-left: $menu-tabular-border-width solid transparent;\r\n      border-right: $menu-tabular-border-width solid transparent;\r\n      border-top: $menu-tabular-opposite-border-width solid transparent;\r\n      padding: $menu-tabular-vertical-padding $menu-tabular-horizontal-padding;\r\n      color: $menu-tabular-text-color;\r\n    }\r\n    .ui.tabular.menu .item:before {\r\n      display: none;\r\n    }\r\n\r\n    /* Hover */\r\n    .ui.tabular.menu .item:hover {\r\n      background-color: transparent;\r\n      color: $menu-tabular-hovered-text-color;\r\n    }\r\n\r\n    /* Active */\r\n    .ui.tabular.menu .active.item {\r\n      background: $menu-tabular-active-background;\r\n      color: $menu-tabular-active-color;\r\n      border-top-width: $menu-tabular-border-width;\r\n      border-color: $menu-tabular-border-color;\r\n      font-weight: $menu-tabular-active-weight;\r\n      margin-bottom: -$menu-tabular-border-width;\r\n      box-shadow: $menu-tabular-active-box-shadow;\r\n      border-radius: $menu-tabular-border-radius $menu-tabular-border-radius 0 0 !important;\r\n    }\r\n\r\n    @if($use-menu-variation-attached) {\r\n      /* Coupling with segment for attachment */\r\n      .ui.tabular.menu + .attached:not(.top).segment,\r\n      .ui.tabular.menu + .attached:not(.top).segment + .attached:not(.top).segment {\r\n        border-top: none;\r\n        margin-left: 0;\r\n        margin-top: 0;\r\n        margin-right: 0;\r\n        width: 100%;\r\n      }\r\n      .top.attached.segment + .ui.bottom.tabular.menu {\r\n        position: relative;\r\n        width: $menu-tabular-fluid-width;\r\n        left: -$menu-tabular-fluid-offset;\r\n      }\r\n    }\r\n\r\n    .ui.bottom.tabular.menu {\r\n      background: $menu-tabular-background;\r\n      border-radius: 0;\r\n      box-shadow: none !important;\r\n      border-bottom: none;\r\n      border-top: $menu-tabular-border-width solid $menu-tabular-border-color;\r\n    }\r\n    .ui.bottom.tabular.menu .item {\r\n      background: none;\r\n      border-left: $menu-tabular-border-width solid transparent;\r\n      border-right: $menu-tabular-border-width solid transparent;\r\n      border-bottom: $menu-tabular-border-width solid transparent;\r\n      border-top: none;\r\n    }\r\n    .ui.bottom.tabular.menu .active.item {\r\n      background: $menu-tabular-active-background;\r\n      color: $menu-tabular-active-color;\r\n      border-color: $menu-tabular-border-color;\r\n      margin: (-$menu-tabular-border-width) 0 0 0;\r\n      border-radius: 0 0 $menu-tabular-border-radius $menu-tabular-border-radius !important;\r\n    }\r\n\r\n    @if($use-menu-type-vertical) {\r\n      /* Vertical Tabular (Left) */\r\n      .ui.vertical.tabular.menu {\r\n        background: $menu-tabular-vertical-background;\r\n        border-radius: 0;\r\n        box-shadow: none !important;\r\n        border-bottom: none;\r\n        border-right: $menu-tabular-border-width solid $menu-tabular-border-color;\r\n      }\r\n      .ui.vertical.tabular.menu .item {\r\n        background: none;\r\n        border-left: $menu-tabular-border-width solid transparent;\r\n        border-bottom: $menu-tabular-border-width solid transparent;\r\n        border-top: $menu-tabular-border-width solid transparent;\r\n        border-right: none;\r\n      }\r\n      .ui.vertical.tabular.menu .active.item {\r\n        background: $menu-tabular-active-background;\r\n        color: $menu-tabular-active-color;\r\n        border-color: $menu-tabular-border-color;\r\n        margin: 0 (-$menu-tabular-border-width) 0 0;\r\n        border-radius: $menu-tabular-border-radius 0 0 $menu-tabular-border-radius !important;\r\n      }\r\n\r\n      /* Vertical Right Tabular */\r\n      .ui.vertical.right.tabular.menu {\r\n        background: $menu-tabular-vertical-background;\r\n        border-radius: 0;\r\n        box-shadow: none !important;\r\n        border-bottom: none;\r\n        border-right: none;\r\n        border-left: $menu-tabular-border-width solid $menu-tabular-border-color;\r\n      }\r\n      .ui.vertical.right.tabular.menu .item {\r\n        background: none;\r\n        border-right: $menu-tabular-border-width solid transparent;\r\n        border-bottom: $menu-tabular-border-width solid transparent;\r\n        border-top: $menu-tabular-border-width solid transparent;\r\n        border-left: none;\r\n      }\r\n      .ui.vertical.right.tabular.menu .active.item {\r\n        background: $menu-tabular-active-background;\r\n        color: $menu-tabular-active-color;\r\n        border-color: $menu-tabular-border-color;\r\n        margin: 0 0 0 (-$menu-tabular-border-width);\r\n        border-radius: 0 $menu-tabular-border-radius $menu-tabular-border-radius 0 !important;\r\n      }\r\n    }\r\n\r\n    /* Dropdown */\r\n    .ui.tabular.menu .active.dropdown.item {\r\n      margin-bottom: 0;\r\n      border-left: $menu-tabular-border-width solid transparent;\r\n      border-right: $menu-tabular-border-width solid transparent;\r\n      border-top: $menu-tabular-opposite-border-width solid transparent;\r\n      border-bottom: none;\r\n    }\r\n  }\r\n\r\n\r\n  @if($use-menu-type-pagination) {\r\n    /*--------------\r\n      Pagination\r\n    ---------------*/\r\n\r\n    .ui.pagination.menu {\r\n      margin: 0;\r\n      display: inline-flex;\r\n      vertical-align: middle;\r\n    }\r\n    .ui.pagination.menu .item:last-child {\r\n      border-radius: 0 $menu-border-radius $menu-border-radius 0;\r\n    }\r\n    .ui.compact.menu .item:last-child {\r\n      border-radius: 0 $menu-border-radius $menu-border-radius 0;\r\n    }\r\n    .ui.pagination.menu .item:last-child:before {\r\n      display: none;\r\n    }\r\n\r\n    .ui.pagination.menu .item {\r\n      min-width: $menu-pagination-min-width;\r\n      text-align: center;\r\n    }\r\n    .ui.pagination.menu .icon.item i.icon {\r\n      vertical-align: top;\r\n    }\r\n\r\n    /* Active */\r\n    .ui.pagination.menu .active.item {\r\n      border-top: none;\r\n      padding-top: $menu-item-vertical-padding;\r\n      background-color: $menu-pagination-active-background;\r\n      color: $menu-pagination-active-text-color;\r\n      box-shadow: none;\r\n    }\r\n  }\r\n\r\n\r\n  @if($use-menu-type-secondary) {\r\n    /*--------------\r\n      Secondary\r\n    ---------------*/\r\n\r\n    .ui.secondary.menu {\r\n      background: $menu-secondary-background;\r\n      margin-left: -$menu-secondary-item-spacing;\r\n      margin-right: -$menu-secondary-item-spacing;\r\n      border-radius: 0;\r\n      border: none;\r\n      box-shadow: none;\r\n    }\r\n\r\n    /* Item */\r\n    .ui.secondary.menu .item {\r\n      align-self: center;\r\n      box-shadow: none;\r\n      border: none;\r\n      padding: $menu-secondary-item-padding;\r\n      margin: $menu-secondary-item-margin;\r\n      background: $menu-secondary-item-background;\r\n      transition: $menu-secondary-item-transition;\r\n      border-radius: $menu-secondary-item-border-radius;\r\n    }\r\n\r\n    /* No Divider */\r\n    .ui.secondary.menu .item:before {\r\n      display: none !important;\r\n    }\r\n\r\n    /* Header */\r\n    .ui.secondary.menu .header.item {\r\n      border-radius: 0;\r\n      border-right: $menu-secondary-header-border;\r\n      background: $menu-secondary-header-background;\r\n    }\r\n\r\n    /* Image */\r\n    .ui.secondary.menu .item > img:not(.ui) {\r\n      margin: 0;\r\n    }\r\n\r\n    /* Hover */\r\n    .ui.secondary.menu .dropdown.item:hover,\r\n    .ui.secondary.menu .link.item:hover,\r\n    .ui.secondary.menu a.item:hover {\r\n      background: $menu-secondary-hover-item-background;\r\n      color: $menu-secondary-hover-item-color;\r\n    }\r\n\r\n    /* Active */\r\n    .ui.secondary.menu .active.item {\r\n      box-shadow: none;\r\n      background: $menu-secondary-active-item-background;\r\n      color: $menu-secondary-active-item-color;\r\n      border-radius: $menu-secondary-item-border-radius;\r\n    }\r\n\r\n    /* Active Hover */\r\n    .ui.secondary.menu .active.item:hover {\r\n      box-shadow: none;\r\n      background: $menu-secondary-active-hover-item-background;\r\n      color: $menu-secondary-active-hover-item-color;\r\n    }\r\n\r\n    @if($use-menu-variation-inverted) {\r\n      /* Inverted */\r\n      .ui.secondary.inverted.menu .link.item:not(.disabled),\r\n      .ui.secondary.inverted.menu a.item:not(.disabled) {\r\n        color: $menu-secondary-inverted-color;\r\n      }\r\n      .ui.secondary.inverted.menu .dropdown.item:hover,\r\n      .ui.secondary.inverted.menu .link.item:hover,\r\n      .ui.secondary.inverted.menu a.item:hover {\r\n        background: $menu-secondary-inverted-hover-background;\r\n        color: $menu-secondary-inverted-hover-color;\r\n      }\r\n      .ui.secondary.inverted.menu .active.item {\r\n        background: $menu-secondary-inverted-active-background;\r\n        color: $menu-secondary-inverted-active-color;\r\n      }\r\n    }\r\n\r\n    /* Fix item margins */\r\n    .ui.secondary.item.menu {\r\n      margin-left: 0;\r\n      margin-right: 0;\r\n    }\r\n    .ui.secondary.item.menu .item:last-child {\r\n      margin-right: 0;\r\n    }\r\n    .ui.secondary.attached.menu {\r\n      box-shadow: none;\r\n    }\r\n\r\n    \r\n    @if($use-menu-type-vertical) {\r\n      /*---------------------\r\n      Secondary Vertical\r\n      -----------------------*/\r\n      \r\n      /* Sub Menu */\r\n      .ui.vertical.secondary.menu .item:not(.dropdown) > .menu {\r\n        margin: $menu-secondary-sub-menu-margin;\r\n      }\r\n      .ui.vertical.secondary.menu .item:not(.dropdown) > .menu > .item {\r\n        margin: $menu-secondary-sub-menu-item-margin;\r\n        padding: $menu-secondary-sub-menu-item-padding;\r\n      }\r\n\r\n      .ui.secondary.vertical.menu > .item {\r\n        border: none;\r\n        margin: $menu-secondary-vertical-item-margin;\r\n        border-radius: $menu-secondary-vertical-item-border-radius !important;\r\n      }\r\n      .ui.secondary.vertical.menu > .header.item {\r\n        border-radius: 0;\r\n      }\r\n\r\n      /* Sub Menu */\r\n      .ui.vertical.secondary.menu .item > .menu .item {\r\n        background-color: transparent;\r\n      }\r\n\r\n      /* Inverted */\r\n      .ui.secondary.inverted.menu {\r\n        background-color: transparent;\r\n      }\r\n    }\r\n\r\n    @if($use-menu-type-pointing) {\r\n      /*---------------------\r\n        Secondary Pointing\r\n      -----------------------*/\r\n\r\n      .ui.secondary.pointing.menu {\r\n        margin-left: 0;\r\n        margin-right: 0;\r\n        border-bottom: $menu-secondary-pointing-border-width solid $menu-secondary-pointing-border-color;\r\n      }\r\n\r\n      .ui.secondary.pointing.menu .item {\r\n        border-bottom-color: transparent;\r\n        border-bottom-style: solid;\r\n        border-radius: 0;\r\n        align-self: flex-end;\r\n\r\n        margin: 0 0 (-$menu-secondary-pointing-border-width);\r\n        padding: $menu-secondary-pointing-item-vertical-padding $menu-secondary-pointing-item-horizontal-padding;\r\n        border-bottom-width: $menu-secondary-pointing-border-width;\r\n        transition: $menu-secondary-item-transition;\r\n      }\r\n      .ui.secondary.pointing.menu .ui.dropdown .menu .item {\r\n        border-bottom-width: 0;\r\n      }\r\n\r\n      .ui.secondary.pointing.menu .item > .label:not(.floating) {\r\n        margin-top: -$menu-label-vertical-padding;\r\n        margin-bottom: -$menu-label-vertical-padding;\r\n      }\r\n      .ui.secondary.pointing.menu .item > .circular.label {\r\n        margin-top: -$menu-circular-label-vertical-padding;\r\n        margin-bottom: -$menu-circular-label-vertical-padding;\r\n      }\r\n\r\n      /* Item Types */\r\n      .ui.secondary.pointing.menu .header.item {\r\n        color: $menu-secondary-pointing-header-color !important;\r\n      }\r\n      .ui.secondary.pointing.menu .text.item {\r\n        box-shadow: none !important;\r\n      }\r\n      .ui.secondary.pointing.menu .item:after {\r\n        display: none;\r\n      }\r\n\r\n      /* Hover */\r\n      .ui.secondary.pointing.menu .dropdown.item:hover,\r\n      .ui.secondary.pointing.menu .link.item:hover,\r\n      .ui.secondary.pointing.menu a.item:hover {\r\n        background-color: transparent;\r\n        color: $menu-secondary-pointing-hover-text-color;\r\n      }\r\n\r\n      /* Pressed */\r\n      .ui.secondary.pointing.menu .dropdown.item:active,\r\n      .ui.secondary.pointing.menu .link.item:active,\r\n      .ui.secondary.pointing.menu a.item:active {\r\n        background-color: transparent;\r\n        border-color: $menu-secondary-pointing-border-color;\r\n      }\r\n\r\n      /* Active */\r\n      .ui.secondary.pointing.menu .active.item {\r\n        background-color: transparent;\r\n        box-shadow: none;\r\n        border-color: $menu-secondary-pointing-active-border-color;\r\n        font-weight: $menu-secondary-pointing-active-font-weight;\r\n        color: $menu-secondary-pointing-active-text-color;\r\n      }\r\n\r\n      /* Active Hover */\r\n      .ui.secondary.pointing.menu .active.item:hover {\r\n        border-color: $menu-secondary-pointing-active-hover-border-color;\r\n        color: $menu-secondary-pointing-active-hover-text-color;\r\n      }\r\n\r\n      /* Active Dropdown */\r\n      .ui.secondary.pointing.menu .active.dropdown.item {\r\n        border-color: $menu-secondary-pointing-active-dropdown-border-color;\r\n      }\r\n\r\n      @if($use-menu-type-vertical) {\r\n        /* Vertical Pointing */\r\n        .ui.secondary.vertical.pointing.menu {\r\n          border-bottom-width: 0;\r\n          border-right-width: $menu-secondary-pointing-border-width;\r\n          border-right-style: solid;\r\n          border-right-color: $menu-secondary-pointing-border-color;\r\n        }\r\n        .ui.secondary.vertical.pointing.menu .item {\r\n          border-bottom: none;\r\n          border-right-style: solid;\r\n          border-right-color: transparent;\r\n          border-radius: 0 !important;\r\n          margin: $menu-secondary-vertical-pointing-item-margin;\r\n          border-right-width: $menu-secondary-pointing-border-width;\r\n        }\r\n        /* Vertical Active */\r\n        .ui.secondary.vertical.pointing.menu .active.item {\r\n          border-color: $menu-secondary-pointing-active-border-color;\r\n        }\r\n      }\r\n\r\n\r\n      @if($use-menu-variation-inverted) {\r\n        /* Inverted */\r\n        .ui.secondary.inverted.pointing.menu {\r\n          border-color: $menu-secondary-pointing-inverted-border-color;\r\n        }\r\n\r\n        .ui.secondary.inverted.pointing.menu .item:not(.disabled) {\r\n          color: $menu-secondary-pointing-inverted-item-text-color;\r\n        }\r\n        .ui.secondary.inverted.pointing.menu .header.item {\r\n          color: $menu-secondary-pointing-inverted-item-header-color !important;\r\n        }\r\n\r\n        /* Hover */\r\n        .ui.secondary.inverted.pointing.menu .link.item:hover,\r\n        .ui.secondary.inverted.pointing.menu a.item:hover {\r\n          color: $menu-secondary-pointing-inverted-item-hover-text-color;\r\n        }\r\n\r\n        /* Active */\r\n        .ui.ui.secondary.inverted.pointing.menu .active.item {\r\n          border-color: $menu-secondary-pointing-inverted-active-border-color;\r\n          color: $menu-secondary-pointing-inverted-active-color;\r\n          background-color: transparent;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  @if($use-menu-type-text) {\r\n    /*--------------\r\n        Text Menu\r\n    ---------------*/\r\n\r\n    .ui.text.menu {\r\n      background: none transparent;\r\n      border-radius: 0;\r\n      box-shadow: none;\r\n      border: none;\r\n\r\n      margin: $menu-text-margin;\r\n    }\r\n    .ui.text.menu .item {\r\n      border-radius: 0;\r\n      box-shadow: none;\r\n      align-self: center;\r\n      margin: $menu-text-item-margin;\r\n      padding: $menu-text-item-padding;\r\n      font-weight: $menu-text-item-font-weight;\r\n      color: $menu-text-item-color;\r\n      transition: $menu-text-item-transition;\r\n    }\r\n\r\n    /* Border */\r\n    .ui.text.menu .item:before,\r\n    .ui.text.menu .menu .item:before {\r\n      display: none !important;\r\n    }\r\n\r\n    /* Header */\r\n    .ui.text.menu .header.item {\r\n      background-color: transparent;\r\n      opacity: 1;\r\n      color: $menu-text-header-color;\r\n      font-size: $menu-text-header-size;\r\n      text-transform: $menu-text-header-text-transform;\r\n      font-weight: $menu-text-header-font-weight;\r\n    }\r\n\r\n    /* Image */\r\n    .ui.text.menu .item > img:not(.ui) {\r\n      margin: 0;\r\n    }\r\n\r\n    /*--- fluid text ---*/\r\n    .ui.text.item.menu .item {\r\n      margin: 0;\r\n    }\r\n    \r\n    @if($use-menu-type-vertical) {\r\n      /*--- vertical text ---*/\r\n      .ui.vertical.text.menu {\r\n        margin: $menu-text-vertical-margin;\r\n      }\r\n      .ui.vertical.text.menu:first-child {\r\n        margin-top: 0;\r\n      }\r\n      .ui.vertical.text.menu:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n      .ui.vertical.text.menu .item {\r\n        margin: $menu-text-vertical-item-margin;\r\n        padding-left: 0;\r\n        padding-right: 0;\r\n      }\r\n      .ui.vertical.text.menu .item > i.icon {\r\n        float: $menu-text-vertical-icon-float;\r\n        margin: $menu-icon-margin;\r\n      }\r\n      .ui.vertical.text.menu .header.item {\r\n        margin: $menu-text-vertical-header-margin;\r\n      }\r\n\r\n      /* Vertical Sub Menu */\r\n      .ui.vertical.text.menu .item:not(.dropdown) > .menu {\r\n        margin: $menu-text-sub-menu-margin;\r\n      }\r\n      .ui.vertical.text.menu .item:not(.dropdown) > .menu > .item {\r\n        margin: $menu-text-sub-menu-item-margin;\r\n        padding: $menu-text-sub-menu-item-padding;\r\n      }\r\n    }\r\n\r\n    /*--- hover ---*/\r\n    .ui.text.menu .item:hover {\r\n      opacity: 1;\r\n      background-color: transparent;\r\n    }\r\n\r\n    /*--- active ---*/\r\n    .ui.text.menu .active.item {\r\n      background-color: transparent;\r\n      border: none;\r\n      box-shadow: none;\r\n      font-weight: $menu-text-active-item-font-weight;\r\n      color: $menu-text-active-item-color;\r\n    }\r\n\r\n    /*--- active hover ---*/\r\n    .ui.text.menu .active.item:hover {\r\n      background-color: transparent;\r\n    }\r\n\r\n    /* Disable Bariations */\r\n    .ui.text.pointing.menu .active.item:after {\r\n      box-shadow: none;\r\n    }\r\n    @if($use-menu-variation-attached) {\r\n      .ui.text.attached.menu {\r\n        box-shadow: none;\r\n      }\r\n    }\r\n\r\n    @if($use-menu-variation-inverted) {\r\n      /* Inverted */\r\n      .ui.inverted.text.menu,\r\n      .ui.inverted.text.menu .item,\r\n      .ui.inverted.text.menu .item:hover,\r\n      .ui.inverted.text.menu .active.item {\r\n        background-color: transparent;\r\n      }\r\n      .ui.inverted.icon.menu .item {\r\n        color: $menu-icon-inverted-item-color;\r\n      }\r\n    }\r\n\r\n    /* Fluid */\r\n    .ui.fluid.text.menu {\r\n      margin-left: 0;\r\n      margin-right: 0;\r\n    }\r\n  }\r\n\r\n  /*--------------\r\n      Icon Only\r\n  ---------------*/\r\n\r\n  /* Vertical Menu */\r\n  .ui.vertical.icon.menu {\r\n    display: inline-block;\r\n    width: auto;\r\n  }\r\n\r\n  /* Item */\r\n  .ui.icon.menu .item {\r\n    height: auto;\r\n    text-align: $menu-icon-text-align;\r\n    color: $menu-icon-item-color;\r\n  }\r\n\r\n  /* Icon */\r\n  .ui.icon.menu .item > .icon:not(.dropdown) {\r\n    margin: 0;\r\n    opacity: 1;\r\n  }\r\n\r\n  /* Icon Gylph */\r\n  .ui.icon.menu .icon:before {\r\n    opacity: 1;\r\n  }\r\n\r\n  /* (x) Item Icon */\r\n  .ui.menu .icon.item > .icon {\r\n    width: auto;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  /* Vertical Icon */\r\n  .ui.vertical.icon.menu .item > .icon:not(.dropdown) {\r\n    display: block;\r\n    opacity: 1;\r\n    margin: 0 auto;\r\n    float: none;\r\n  }\r\n\r\n  /*--------------\r\n    Labeled Icon\r\n  ---------------*/\r\n\r\n  /* Menu */\r\n  .ui.labeled.icon.menu {\r\n    text-align: center;\r\n  }\r\n\r\n  /* Item */\r\n  .ui.labeled.icon.menu .item {\r\n    min-width: $menu-labeled-icon-min-width;\r\n    flex-direction: column;\r\n  }\r\n\r\n  /* Icon */\r\n  .ui.labeled.icon.menu > .item > .icon:not(.dropdown) {\r\n    height: 1em;\r\n    display: block;\r\n    font-size: $menu-labeled-icon-size !important;\r\n    margin: 0 auto $menu-labeled-icon-text-margin !important;\r\n  }\r\n\r\n  /* Fluid */\r\n  .ui.fluid.labeled.icon.menu > .item {\r\n    min-width: 0;\r\n  }\r\n\r\n\r\n  /*******************************\r\n            Variations\r\n  *******************************/\r\n\r\n  /*--------------\r\n      Stackable\r\n  ---------------*/\r\n\r\n  @media only screen and (max-width: $largest-mobile-screen) {\r\n    .ui.stackable.menu {\r\n      flex-direction: column;\r\n    }\r\n    .ui.stackable.menu .item {\r\n      width: 100% !important;\r\n    }\r\n    .ui.stackable.menu .item:before {\r\n      position: absolute;\r\n      content: '';\r\n      top: auto;\r\n      bottom: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: $menu-divider-size;\r\n      background: $menu-vertical-divider-background;\r\n    }\r\n\r\n    .ui.stackable.menu .left.menu,\r\n    .ui.stackable.menu .left.item {\r\n      margin-right: 0 !important;\r\n    }\r\n    .ui.stackable.menu .right.menu,\r\n    .ui.stackable.menu .right.item {\r\n      margin-left: 0 !important;\r\n    }\r\n    .ui.stackable.menu .center.menu,\r\n    .ui.stackable.menu .center.item {\r\n      margin-left: 0 !important;\r\n      margin-right: 0 !important;\r\n    }\r\n\r\n    .ui.stackable.menu .right.menu,\r\n    .ui.stackable.menu .center.menu,\r\n    .ui.stackable.menu .left.menu {\r\n      flex-direction: column;\r\n    }\r\n  }\r\n\r\n  /*--------------\r\n      Colors\r\n  ---------------*/\r\n\r\n  @each $key, $value in $colors {\r\n    $color: $key;\r\n    $c: map-get($value, color);\r\n\r\n    @if not ($color==secondary) {\r\n      .ui.ui.menu .#{$key + \"\"}.active.active.active.item,\r\n      .ui.ui.#{$key + \"\"}.menu .active.active.active.item:hover,\r\n      .ui.ui.#{$key + \"\"}.menu .active.active.active.item {\r\n        @if not ($menu-secondary-pointing-active-border-color == currentColor) {\r\n          border-color: $c;\r\n        }\r\n        color: $c;\r\n      }\r\n    }\r\n  }\r\n\r\n  @if($use-menu-variation-inverted) {\r\n    /*--------------\r\n        Inverted\r\n    ---------------*/\r\n\r\n    .ui.inverted.menu {\r\n      border: $menu-inverted-border;\r\n      background: $menu-inverted-background;\r\n      box-shadow: $menu-inverted-box-shadow;\r\n    }\r\n\r\n    /* Menu Item */\r\n    .ui.inverted.menu .item,\r\n    .ui.inverted.menu .item > a:not(.ui) {\r\n      background: $menu-inverted-item-background;\r\n      color: $menu-inverted-item-text-color;\r\n    }\r\n    .ui.inverted.menu .item.menu {\r\n      background: $menu-inverted-sub-background;\r\n    }\r\n\r\n    /*--- Border ---*/\r\n    .ui.inverted.menu .item:before {\r\n      background: $menu-inverted-divider-background;\r\n    }\r\n    .ui.vertical.inverted.menu .item:before {\r\n      background: $menu-inverted-vertical-divider-background;\r\n    }\r\n\r\n    /* Sub Menu */\r\n    .ui.vertical.inverted.menu .menu .item,\r\n    .ui.vertical.inverted.menu .menu .item a:not(.ui) {\r\n      color: $menu-inverted-sub-color;\r\n    }\r\n\r\n    /* Header */\r\n    .ui.inverted.menu .header.item {\r\n      margin: 0;\r\n      background: $menu-inverted-header-background;\r\n      box-shadow: none;\r\n    }\r\n\r\n    /* Disabled */\r\n    .ui.ui.inverted.menu .item.disabled {\r\n      color: $inverted-disabled-text-color;\r\n    }\r\n\r\n    /*--- Hover ---*/\r\n    .ui.link.inverted.menu .item:hover,\r\n    .ui.inverted.menu .dropdown.item:hover,\r\n    .ui.inverted.menu .link.item:hover,\r\n    .ui.inverted.menu a.item:hover {\r\n      background: $menu-inverted-hover-background;\r\n      color: $menu-inverted-hover-color;\r\n    }\r\n    .ui.vertical.inverted.menu .item .menu a.item:hover,\r\n    .ui.vertical.inverted.menu .item .menu .link.item:hover {\r\n      background: $menu-inverted-sub-background;\r\n      color: $menu-inverted-sub-hover-color;\r\n    }\r\n\r\n    /*--- Pressed ---*/\r\n    .ui.inverted.menu a.item:active,\r\n    .ui.inverted.menu .link.item:active{\r\n      background: $menu-inverted-pressed-background;\r\n      color: $menu-inverted-pressed-color;\r\n    }\r\n\r\n    /*--- Active ---*/\r\n    .ui.inverted.menu .active.item {\r\n      background: $menu-inverted-active-background;\r\n      color: $menu-inverted-active-color !important;\r\n    }\r\n    .ui.inverted.vertical.menu .item .menu .active.item {\r\n      background: $menu-inverted-sub-active-background;\r\n      color: $menu-inverted-sub-active-color;\r\n    }\r\n    .ui.inverted.pointing.menu .active.item:after {\r\n      background: $menu-inverted-arrow-active-color;\r\n      margin: 0 !important;\r\n      box-shadow: none !important;\r\n      border: none !important;\r\n    }\r\n\r\n    /*--- Active Hover ---*/\r\n    .ui.inverted.menu .active.item:hover {\r\n      background: $menu-inverted-active-hover-background;\r\n      color: $menu-inverted-active-hover-color !important;\r\n    }\r\n    .ui.inverted.pointing.menu .active.item:hover:after {\r\n      background: $menu-inverted-arrow-active-hover-color;\r\n    }\r\n\r\n    .ui.ui.ui.inverted.pointing.menu .active.item:after{\r\n      background-color: inherit;\r\n    }\r\n  }\r\n\r\n\r\n  /*--------------\r\n      Floated\r\n  ---------------*/\r\n\r\n  .ui.floated.menu {\r\n    float: left;\r\n    margin: 0 $menu-floated-distance 0 0;\r\n  }\r\n  .ui.floated.menu .item:last-child:before {\r\n    display: none;\r\n  }\r\n\r\n  .ui.right.floated.menu {\r\n    float: right;\r\n    margin: 0 0 0 $menu-floated-distance;\r\n  }\r\n\r\n  @if $use-menu-variation-inverted {\r\n    /*--------------\r\n        Inverted\r\n    ---------------*/\r\n    @each $key, $value in $colors {\r\n      $color: $key;\r\n      $c: map-get($value, color);\r\n      $h: map-get($value, hover);\r\n\r\n      @if not ($color == secondary) {\r\n        .ui.ui.inverted.menu .#{$key + \"\"}.active.item,\r\n        .ui.ui.inverted.#{$key + \"\"}.menu {\r\n          background-color: $c;\r\n        }\r\n        .ui.inverted.#{$key + \"\"}.menu .item:before {\r\n          background-color: $menu-inverted-colored-divider-background;\r\n        }\r\n        .ui.ui.inverted.#{$key + \"\"}.menu .active.item {\r\n          background-color: $menu-inverted-colored-active-background;\r\n        }\r\n        .ui.inverted.pointing.#{$key + \"\"}.menu .active.item {\r\n          background-color: $h;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  /*--------------\r\n      Fitted\r\n  ---------------*/\r\n\r\n  .ui.fitted.menu .item,\r\n  .ui.fitted.menu .item .menu .item,\r\n  .ui.menu .fitted.item {\r\n    padding: 0;\r\n  }\r\n  .ui.horizontally.fitted.menu .item,\r\n  .ui.horizontally.fitted.menu .item .menu .item,\r\n  .ui.menu .horizontally.fitted.item {\r\n    padding-top: $menu-item-vertical-padding;\r\n    padding-bottom: $menu-item-vertical-padding;\r\n  }\r\n  .ui.vertically.fitted.menu .item,\r\n  .ui.vertically.fitted.menu .item .menu .item,\r\n  .ui.menu .vertically.fitted.item {\r\n    padding-left: $menu-item-horizontal-padding;\r\n    padding-right: $menu-item-horizontal-padding;\r\n  }\r\n\r\n  /*--------------\r\n    Borderless\r\n  ---------------*/\r\n\r\n  .ui.borderless.menu .item:before,\r\n  .ui.borderless.menu .item .menu .item:before,\r\n  .ui.menu .borderless.item:before {\r\n    background: none !important;\r\n  }\r\n\r\n  /*-------------------\r\n        Compact\r\n  --------------------*/\r\n\r\n  .ui.compact.menu {\r\n    display: inline-flex;\r\n    margin: 0;\r\n    vertical-align: middle;\r\n  }\r\n  .ui.compact.vertical.menu {\r\n  /* IE hack to make dropdown icons appear inline */\r\n    display: -ms-inline-flexbox !important;\r\n    display: inline-block;\r\n  }\r\n  .ui.compact.menu:not(.secondary) .item:last-child {\r\n    border-radius: 0 $menu-border-radius $menu-border-radius 0;\r\n  }\r\n  .ui.compact.menu .item:last-child:before {\r\n    display: none;\r\n  }\r\n  .ui.compact.vertical.menu {\r\n    width: auto !important;\r\n  }\r\n  .ui.compact.vertical.menu .item:last-child::before {\r\n    display: block;\r\n  }\r\n\r\n  /*-------------------\r\n          Fluid\r\n  --------------------*/\r\n\r\n  .ui.menu.fluid,\r\n  .ui.vertical.menu.fluid {\r\n    width: 100% !important;\r\n  }\r\n\r\n\r\n  /*-------------------\r\n        Evenly Sized\r\n  --------------------*/\r\n\r\n  .ui.item.menu,\r\n  .ui.item.menu .item {\r\n    width: 100%;\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n    text-align: center;\r\n    justify-content: center;\r\n  }\r\n  .ui.attached.item.menu:not(.tabular) {\r\n    margin: 0 $menu-attached-horizontal-offset !important;\r\n  }\r\n\r\n  .ui.item.menu .item:last-child:before {\r\n    display: none;\r\n  }\r\n\r\n  .ui.menu.two.item .item {\r\n    width: 50%;\r\n  }\r\n  .ui.menu.three.item .item {\r\n    width: 33.333%;\r\n  }\r\n  .ui.menu.four.item .item {\r\n    width: 25%;\r\n  }\r\n  .ui.menu.five.item .item {\r\n    width: 20%;\r\n  }\r\n  .ui.menu.six.item .item {\r\n    width: 16.666%;\r\n  }\r\n  .ui.menu.seven.item .item {\r\n    width: 14.285%;\r\n  }\r\n  .ui.menu.eight.item .item {\r\n    width: 12.500%;\r\n  }\r\n  .ui.menu.nine.item .item {\r\n    width: 11.11%;\r\n  }\r\n  .ui.menu.ten.item .item {\r\n    width: 10.0%;\r\n  }\r\n  .ui.menu.eleven.item .item {\r\n    width: 9.09%;\r\n  }\r\n  .ui.menu.twelve.item .item {\r\n    width: 8.333%;\r\n  }\r\n\r\n  /*--------------\r\n      Fixed\r\n  ---------------*/\r\n\r\n  .ui.menu.fixed {\r\n    position: fixed;\r\n    z-index: 101;\r\n    margin: 0;\r\n    width: 100%;\r\n  }\r\n  .ui.menu.fixed,\r\n  .ui.menu.fixed .item:first-child,\r\n  .ui.menu.fixed .item:last-child {\r\n    border-radius: 0 !important;\r\n  }\r\n\r\n  .ui.fixed.menu,\r\n  .ui[class*=\"top fixed\"].menu {\r\n    top: 0;\r\n    left: 0;\r\n    right: auto;\r\n    bottom: auto;\r\n  }\r\n  .ui[class*=\"top fixed\"].menu {\r\n    border-top: none;\r\n    border-left: none;\r\n    border-right: none;\r\n  }\r\n  .ui[class*=\"right fixed\"].menu {\r\n    border-top: none;\r\n    border-bottom: none;\r\n    border-right: none;\r\n    top: 0;\r\n    right: 0;\r\n    left: auto;\r\n    bottom: auto;\r\n    width: auto;\r\n    height: 100%;\r\n  }\r\n  .ui[class*=\"bottom fixed\"].menu {\r\n    border-bottom: none;\r\n    border-left: none;\r\n    border-right: none;\r\n    bottom: 0;\r\n    left: 0;\r\n    top: auto;\r\n    right: auto;\r\n  }\r\n  .ui[class*=\"left fixed\"].menu {\r\n    border-top: none;\r\n    border-bottom: none;\r\n    border-left: none;\r\n    top: 0;\r\n    left: 0;\r\n    right: auto;\r\n    bottom: auto;\r\n    width: auto;\r\n    height: 100%;\r\n  }\r\n\r\n  /* Coupling with Grid */\r\n  .ui.fixed.menu + .ui.grid {\r\n    padding-top: $menu-fixed-preceding-grid-margin;\r\n  }\r\n\r\n\r\n  @if($use-menu-type-pointing) {\r\n    /*-------------------\r\n          Pointing\r\n    --------------------*/\r\n\r\n    .ui.pointing.menu .item:after {\r\n      visibility: hidden;\r\n      position: absolute;\r\n      content: '';\r\n      top: 100%;\r\n      left: 50%;\r\n      transform: translateX(-50%) translateY(-50%) rotate(45deg);\r\n      background: none;\r\n\r\n      margin: ($menu-arrow-border-width / 2) 0 0;\r\n      width: $menu-arrow-size;\r\n      height: $menu-arrow-size;\r\n\r\n      border: none;\r\n      border-bottom: $menu-arrow-border;\r\n      border-right: $menu-arrow-border;\r\n\r\n      z-index: $menu-arrow-z-index;\r\n      transition: $menu-arrow-transition;\r\n    }\r\n    .ui.vertical.pointing.menu .item:after {\r\n      position: absolute;\r\n      top: 50%;\r\n      right: 0;\r\n      bottom: auto;\r\n      left: auto;\r\n\r\n      transform: translateX(50%) translateY(-50%) rotate(45deg);\r\n      margin: 0 (-$menu-arrow-border-width / 2) 0 0;\r\n\r\n      border: none;\r\n      border-top: $menu-arrow-border;\r\n      border-right: $menu-arrow-border;\r\n    }\r\n    .ui.pointing.menu .ui.dropdown .menu .item:after,\r\n    .ui.vertical.pointing.menu .ui.dropdown .menu .item:after {\r\n      display: none;\r\n    }\r\n\r\n    /* Active */\r\n    .ui.pointing.menu .active.item:after {\r\n      visibility: visible;\r\n    }\r\n    .ui.pointing.menu .active.dropdown.item:after {\r\n      visibility: hidden;\r\n    }\r\n\r\n    /* Don't double up pointers */\r\n    .ui.pointing.menu .dropdown.active.item:after,\r\n    .ui.pointing.menu .active.item .menu .active.item:after {\r\n      display: none;\r\n    }\r\n\r\n    /* Colors */\r\n    .ui.pointing.menu .active.item:hover:after {\r\n      background-color: $menu-arrow-hover-color;\r\n    }\r\n    .ui.pointing.menu .active.item:after {\r\n      background-color: $menu-arrow-active-color;\r\n    }\r\n    .ui.pointing.menu .active.item:hover:after {\r\n      background-color: $menu-arrow-active-hover-color;\r\n    }\r\n\r\n    .ui.vertical.pointing.menu .active.item:hover:after {\r\n      background-color: $menu-arrow-vertical-hover-color;\r\n    }\r\n    .ui.vertical.pointing.menu .active.item:after {\r\n      background-color: $menu-arrow-vertical-active-color;\r\n    }\r\n    .ui.vertical.pointing.menu .menu .active.item:after {\r\n      background-color: $menu-arrow-vertical-sub-color;\r\n    }\r\n\r\n    @if($use-menu-variation-inverted) {\r\n      @each $key, $value in $colors {\r\n        @if(index(join($main-colors-names, $use-menu-variation-colors), $key+'')) {\r\n          $color: $key;\r\n          $c: map-get($value, color);\r\n        \r\n          .ui.inverted.pointing.menu .#{$key + \"\"}.active.item:after {\r\n            background-color: $c;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n\r\n  @if($use-menu-variation-attached) {\r\n    /*--------------\r\n        Attached\r\n    ---------------*/\r\n\r\n    /* Middle */\r\n    .ui.attached.menu {\r\n      top: 0;\r\n      bottom: 0;\r\n      border-radius: 0;\r\n      margin: 0 $menu-attached-horizontal-offset;\r\n      width: $menu-attached-width;\r\n      max-width: $menu-attached-width;\r\n      box-shadow: $menu-attached-box-shadow;\r\n    }\r\n    .ui.attached + .ui.attached.menu:not(.top) {\r\n      border-top: none;\r\n    }\r\n\r\n    /* Top */\r\n    .ui[class*=\"top attached\"].menu {\r\n      bottom: 0;\r\n      margin-bottom: 0;\r\n      top: $menu-attached-top-offset;\r\n      margin-top: $menu-vertical-margin;\r\n      border-radius: $menu-border-radius $menu-border-radius 0 0;\r\n    }\r\n    .ui.menu[class*=\"top attached\"]:first-child {\r\n      margin-top: 0;\r\n    }\r\n\r\n    /* Bottom */\r\n    .ui[class*=\"bottom attached\"].menu {\r\n      bottom: 0;\r\n      margin-top: 0;\r\n      top: $menu-attached-bottom-offset;\r\n      margin-bottom: $menu-vertical-margin;\r\n      box-shadow: $menu-attached-bottom-box-shadow;\r\n      border-radius: 0 0 $menu-border-radius $menu-border-radius;\r\n    }\r\n    .ui[class*=\"bottom attached\"].menu:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    /* Attached Menu Item */\r\n    .ui.top.attached.menu > .item:first-child {\r\n      border-radius: $menu-border-radius 0 0 0;\r\n    }\r\n    .ui.bottom.attached.menu > .item:first-child {\r\n      border-radius: 0 0 0 $menu-border-radius;\r\n    }\r\n\r\n    /* Tabular Attached */\r\n    .ui.attached.menu:not(.tabular) {\r\n      border: $menu-attached-border;\r\n    }\r\n    @if $use-menu-variation-inverted {\r\n      .ui.attached.inverted.menu {\r\n        border: none;\r\n      }\r\n    }\r\n    .ui.attached.tabular.menu {\r\n      margin-left: 0;\r\n      margin-right: 0;\r\n      width: 100%;\r\n    }\r\n  }\r\n\r\n  /*--------------\r\n      Sizes\r\n  ---------------*/\r\n\r\n  /* Mini */\r\n  .ui.mini.menu {\r\n    font-size: $menu-mini;\r\n  }\r\n  .ui.mini.vertical.menu:not(.icon) {\r\n    width: $menu-mini-width;\r\n  }\r\n  .ui.mini.menu .dropdown {\r\n    font-size: $menu-mini;\r\n  }\r\n  .ui.mini.menu .dropdown .menu > .item{\r\n    font-size: $menu-mini;\r\n  }\r\n\r\n  /* Tiny */\r\n  .ui.tiny.menu {\r\n    font-size: $menu-tiny;\r\n  }\r\n  .ui.tiny.vertical.menu:not(.icon) {\r\n    width: $menu-tiny-width;\r\n  }\r\n  .ui.tiny.menu .dropdown {\r\n    font-size: $menu-tiny;\r\n  }\r\n  .ui.tiny.menu .dropdown .menu > .item{\r\n    font-size: $menu-tiny;\r\n  }\r\n\r\n  /* Small */\r\n  .ui.small.menu {\r\n    font-size: $menu-small;\r\n  }\r\n  .ui.small.vertical.menu:not(.icon) {\r\n    width: $menu-small-width;\r\n  }\r\n  .ui.small.menu .dropdown {\r\n    font-size: $menu-small;\r\n  }\r\n  .ui.small.menu .dropdown .menu > .item{\r\n    font-size: $menu-small;\r\n  }\r\n\r\n  /* Medium */\r\n  .ui.menu {\r\n    font-size: $medium;\r\n  }\r\n  .ui.vertical.menu {\r\n    width: $menu-medium-width;\r\n  }\r\n\r\n  /* Large */\r\n  .ui.large.menu {\r\n    font-size: $menu-large;\r\n  }\r\n  .ui.large.vertical.menu:not(.icon) {\r\n    width: $menu-large-width;\r\n  }\r\n  .ui.large.menu .dropdown {\r\n    font-size: $menu-large;\r\n  }\r\n  .ui.large.menu .dropdown .menu > .item{\r\n    font-size: $menu-large;\r\n  }\r\n\r\n  /* Huge */\r\n  .ui.huge.menu {\r\n    font-size: $menu-huge;\r\n  }\r\n  .ui.huge.vertical.menu:not(.icon) {\r\n    width: $menu-huge-width;\r\n  }\r\n  .ui.huge.menu .dropdown {\r\n    font-size: $menu-huge;\r\n  }\r\n  .ui.huge.menu .dropdown .menu > .item{\r\n    font-size: $menu-huge;\r\n  }\r\n\r\n  /* Big */\r\n  .ui.big.menu {\r\n    font-size: $menu-big;\r\n  }\r\n  .ui.big.vertical.menu:not(.icon) {\r\n    width: $menu-big-width;\r\n  }\r\n  .ui.big.menu .dropdown {\r\n    font-size: $menu-big;\r\n  }\r\n  .ui.big.menu .dropdown .menu > .item{\r\n    font-size: $menu-big;\r\n  }\r\n\r\n  /* Massive */\r\n  .ui.massive.menu {\r\n    font-size: $menu-massive;\r\n  }\r\n  .ui.massive.vertical.menu:not(.icon) {\r\n    width: $menu-massive-width;\r\n  }\r\n  .ui.massive.menu .dropdown {\r\n    font-size: $menu-massive;\r\n  }\r\n  .ui.massive.menu .dropdown .menu > .item{\r\n    font-size: $menu-massive;\r\n  }\r\n\r\n  @if ($use-dropdown-variation-inverted) {\r\n    /*-------------------\r\n      Inverted dropdowns\r\n    --------------------*/\r\n    .ui.menu .ui.inverted.inverted.dropdown.item .menu {\r\n      background: $menu-inverted-dropdown-background;\r\n      box-shadow: $menu-inverted-dropdown-box-shadow;\r\n    }\r\n\r\n    .ui.menu .ui.inverted.dropdown .menu > .item {\r\n      color: $menu-inverted-dropdown-item-color !important;\r\n    }\r\n\r\n    .ui.menu .ui.inverted.dropdown .menu > .active.item {\r\n      background: $menu-inverted-dropdown-active-item-background !important;\r\n      color: $menu-inverted-dropdown-active-item-color !important;\r\n    }\r\n\r\n    .ui.menu .ui.inverted.dropdown .menu > .item:hover {\r\n      background: $menu-inverted-dropdown-hovered-item-background !important;\r\n      color: $menu-inverted-dropdown-hovered-item-color !important;\r\n    }\r\n\r\n    .ui.menu .ui.inverted.dropdown .menu > .selected.item {\r\n      background: $menu-inverted-dropdown-selected-item-background !important;\r\n      color: $menu-inverted-dropdown-selected-item-color !important;\r\n    }\r\n\r\n    /* Vertical */\r\n    .ui.vertical.menu .inverted.dropdown.item .menu {\r\n      box-shadow: $menu-inverted-dropdown-box-shadow;\r\n    }\r\n  }\r\n}\r\n\r\n@import '../../themes/default/collections/menu.style';","@import '../../themes/default/collections/message.variables';\n\n@if $use-message {\n  /*******************************\n  //@-        Message\n  *******************************/\n\n  .ui.message {\n    position: relative;\n    min-height: 1em;\n    margin: $message-vertical-margin 0;\n    background: $message-background;\n    padding: $message-padding;\n    line-height: $line-height;\n    color: $text-color;\n    transition: $message-transition;\n    border-radius: $message-border-radius;\n    box-shadow: $message-box-shadow;\n  }\n\n  .ui.message:first-child {\n    margin-top: 0;\n  }\n  .ui.message:last-child {\n    margin-bottom: 0;\n  }\n\n\n  /*--------------\n      Content\n  ---------------*/\n\n  /* Header */\n  .ui.message .header {\n    display: $message-header-display;\n    font-family: $header-font;\n    font-weight: $message-header-font-weight;\n    margin: $message-header-margin;\n  }\n\n  /* Default font size */\n  .ui.message .header:not(.ui) {\n    font-size: $message-header-font-size;\n  }\n\n  /* Paragraph */\n  .ui.message p {\n    opacity: $message-text-opacity;\n    margin: $message-paragraph-margin 0;\n  }\n  .ui.message p:first-child {\n    margin-top: 0;\n  }\n  .ui.message p:last-child {\n    margin-bottom: 0;\n  }\n  .ui.message .header + p {\n    margin-top: $message-header-paragraph-distance;\n  }\n\n  /* List */\n  .ui.message .list:not(.ui) {\n    text-align: left;\n    padding: 0;\n    opacity: $message-list-opacity;\n    list-style-position: $message-list-style-position;\n    margin: $message-list-margin 0 0;\n  }\n  .ui.message .list:not(.ui):first-child {\n    margin-top: 0;\n  }\n  .ui.message .list:not(.ui):last-child {\n    margin-bottom: 0;\n  }\n  .ui.message .list:not(.ui) li {\n    position: relative;\n    list-style-type: none;\n    margin: 0 0 $message-list-item-margin $message-list-item-indent;\n    padding: 0;\n  }\n  .ui.message .list:not(.ui) li:before {\n    position: absolute;\n    content: '•';\n    left: -1em;\n    height: 100%;\n    vertical-align: baseline;\n  }\n  .ui.message .list:not(.ui) li:last-child {\n    margin-bottom: 0;\n  }\n\n\n  /* Icon */\n  .ui.message > .icon {\n    margin-right: $message-icon-distance;\n  }\n\n  /* Close Icon */\n  .ui.message > .close.icon {\n    cursor: pointer;\n    position: absolute;\n    margin: 0;\n    top: $message-close-top-distance;\n    right: $message-close-right-distance;\n    opacity: $message-close-opacity;\n    transition: $message-close-transition;\n  }\n  .ui.message > .close.icon:hover {\n    opacity: 1;\n  }\n\n  /* First / Last Element */\n  .ui.message > :first-child {\n    margin-top: 0;\n  }\n  .ui.message > :last-child {\n    margin-bottom: 0;\n  }\n\n  /*******************************\n              Coupling\n  *******************************/\n\n  .ui.dropdown .menu > .message {\n    margin: 0 (-$message-border-width);\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------\n      Visible\n  ---------------*/\n\n  .ui.visible.visible.visible.visible.message {\n    display: block;\n  }\n\n  .ui.icon.visible.visible.visible.visible.message {\n    display: flex;\n  }\n\n  /*--------------\n      Hidden\n  ---------------*/\n\n  .ui.hidden.hidden.hidden.hidden.message {\n    display: none;\n  }\n\n\n  /*******************************\n              Variations\n  *******************************/\n\n  /*--------------\n      Compact\n  ---------------*/\n\n  .ui.compact.message {\n    display: inline-block;\n  }\n  .ui.compact.icon.message {\n    display: inline-flex;\n    width: auto;\n  }\n\n\n  /*--------------\n      Attached\n  ---------------*/\n\n  .ui.attached.message {\n    margin-bottom: $message-attached-y-offset;\n    border-radius: $message-border-radius $message-border-radius 0 0;\n    box-shadow: $message-attached-box-shadow;\n    margin-left: $message-attached-x-offset;\n    margin-right: $message-attached-x-offset;\n  }\n  .ui.attached + .ui.attached.message:not(.top):not(.bottom) {\n    margin-top: $message-attached-y-offset;\n    border-radius: 0;\n  }\n  .ui.bottom.attached.message {\n    margin-top: $message-attached-y-offset;\n    border-radius: 0 0 $message-border-radius $message-border-radius;\n    box-shadow: $message-attached-bottom-box-shadow;\n  }\n  .ui.bottom.attached.message:not(:last-child) {\n    margin-bottom: $message-vertical-margin;\n  }\n  .ui.attached.icon.message {\n    width: auto;\n  }\n\n\n  /*--------------\n        Icon\n  ---------------*/\n\n  .ui.icon.message {\n    display: flex;\n    width: 100%;\n    align-items: center;\n  }\n  .ui.icon.message > .icon:not(.close) {\n    display: block;\n    flex: 0 0 auto;\n    width: auto;\n    line-height: 1;\n    vertical-align: $message-icon-vertical-align;\n    font-size: $message-icon-size;\n    opacity: $message-icon-opacity;\n  }\n  .ui.icon.message > .content {\n    display: block;\n    flex: 1 1 auto;\n    vertical-align: $message-icon-vertical-align;\n  }\n\n\n  .ui.icon.message .icon:not(.close) + .content {\n    padding-left: $message-icon-content-distance;\n  }\n  .ui.icon.message .circular.icon {\n    width: 1em;\n  }\n\n  /*--------------\n      Floating\n  ---------------*/\n\n  .ui.floating.message {\n    box-shadow: $message-floating-box-shadow;\n  }\n\n\n  /*--------------\n      Colors\n  ---------------*/\n\n  @each $key, $value in $message-consequences {\n    @if(index($use-message-variation-consequences, $key+'')) {\n      $color: $key;\n      $bg: map-get($value, background);\n      $hd: map-get($value, header);\n      $bs: map-get($value, boxShadow);\n      $bfs: map-get($value, boxFloatShadow);\n      $t: map-get($value, text);\n\n      .ui.#{$key + \"\"}.message {\n        background-color: $bg;\n        color: $t;\n      }\n\n      .ui.#{$key + \"\"}.message,\n      .ui.attached.#{$key + \"\"}.message {\n        box-shadow: $bs;\n      }\n\n      .ui.floating.#{$key + \"\"}.message {\n          box-shadow: $bfs;\n      }\n\n      .ui.#{$key + \"\"}.message .header {\n        color: $hd;\n      }\n    }\n  }\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-header-variation-colors), $key+'')) {\n      $color: $key;\n      $bg: map-get($value, background);\n      $hd: map-get($value, header);\n      $bs: map-get($value, boxShadow);\n      $bfs: map-get($value, boxFloatShadow);\n      $t: map-get($value, text);\n      $isVeryDark: map-get($value, isVeryDark);\n\n      .ui.#{$key + \"\"}.message {\n        @if not ($isVeryDark) {\n          background-color: $bg;\n          color: $t;\n        }\n        @if ($isVeryDark) {\n          background-color: $black;\n          color: $inverted-text-color;\n        }\n      }\n\n      .ui.#{$key + \"\"}.message,\n      .ui.attached.#{$key + \"\"}.message {\n        @if not ($isVeryDark) {\n          box-shadow: $bs;\n        }\n      }\n\n      .ui.floating.#{$key + \"\"}.message {\n        @if not ($isVeryDark) {\n          box-shadow: $bfs;\n        }\n      }\n\n      .ui.#{$key + \"\"}.message .header {\n        @if not ($isVeryDark) {\n          color: $hd;\n        }\n        @if ($isVeryDark) {\n          color: $inverted-text-color;\n        }\n      }\n    }\n  }\n\n\n  .ui.inverted.message {\n    background-color: $black;\n    color: $inverted-text-color;\n  }\n\n  /*--------------\n      Sizes\n  ---------------*/\n\n  .ui.mini.message {\n    font-size: $relative-mini;\n  }\n  .ui.tiny.message {\n    font-size: $relative-tiny;\n  }\n  .ui.small.message {\n    font-size: $relative-small;\n  }\n  .ui.message {\n    font-size: $relative-medium;\n  }\n  .ui.large.message {\n    font-size: $relative-large;\n  }\n  .ui.big.message {\n    font-size: $relative-big;\n  }\n  .ui.huge.message {\n    font-size: $relative-huge;\n  }\n  .ui.massive.message {\n    font-size: $relative-massive;\n  }\n}\n\n@import '../../themes/default/collections/message.style';","@import '../../themes/default/collections/table.variables';\n\n@if $use-table {\n  /*******************************\n  //@-         Table\n  *******************************/\n\n  /* Prototype */\n  .ui.table {\n    width: 100%;\n    background: $table-background;\n    margin: $table-margin;\n    border: $table-border;\n    box-shadow: $table-box-shadow;\n    border-radius: $table-border-radius;\n    text-align: $table-text-align;\n    vertical-align: $table-vertical-align;\n    color: $table-color;\n    border-collapse: $table-border-collapse;\n    border-spacing: $table-border-spacing;\n  }\n\n  .ui.table:first-child {\n    margin-top: 0;\n  }\n  .ui.table:last-child {\n    margin-bottom: 0;\n  }\n  .ui.table > thead,\n  .ui.table > tbody {\n    text-align: inherit;\n    vertical-align: inherit;\n  }\n\n  /*******************************\n              Parts\n  *******************************/\n\n  /* Table Content */\n  .ui.table th,\n  .ui.table td {\n    transition: $table-transition;\n  }\n\n  /* Headers */\n  .ui.table > thead {\n    box-shadow: $table-header-box-shadow;\n  }\n  .ui.table > thead > tr > th {\n    cursor: auto;\n    background: $table-header-background;\n    text-align: $table-header-align;\n    color: $table-header-color;\n    padding: $table-header-vertical-padding $table-header-horizontal-padding;\n    vertical-align: $table-header-vertical-align;\n    font-style: $table-header-font-style;\n    font-weight: $table-header-font-weight;\n    text-transform: $table-header-text-transform;\n    border-bottom: $table-header-border;\n    border-left: $table-header-divider;\n  }\n\n  .ui.table > thead > tr > th:first-child {\n    border-left: none;\n  }\n\n  .ui.table > thead > tr:first-child > th:first-child {\n    border-radius: $table-border-radius 0 0 0;\n  }\n  .ui.table > thead > tr:first-child > th:last-child {\n    border-radius: 0 $table-border-radius 0 0;\n  }\n  .ui.table > thead > tr:first-child > th:only-child {\n    border-radius: $table-border-radius $table-border-radius 0 0;\n  }\n\n  /* Footer */\n  .ui.table > tfoot {\n    box-shadow: $table-footer-box-shadow;\n  }\n  .ui.table > tfoot > tr > th {\n    cursor: auto;\n    border-top: $table-footer-border;\n    background: $table-footer-background;\n    text-align: $table-footer-align;\n    color: $table-footer-color;\n    padding: $table-footer-vertical-padding $table-footer-horizontal-padding;\n    vertical-align: $table-footer-vertical-align;\n    font-style: $table-footer-font-style;\n    font-weight: $table-footer-font-weight;\n    text-transform: $table-footer-text-transform;\n  }\n  .ui.table > tfoot > tr > th:first-child {\n    border-left: none;\n  }\n  .ui.table > tfoot > tr:first-child > th:first-child {\n    border-radius: 0 0 0 $table-border-radius;\n  }\n  .ui.table > tfoot > tr:first-child > th:last-child {\n    border-radius: 0 0 $table-border-radius 0;\n  }\n  .ui.table > tfoot > tr:first-child > th:only-child {\n    border-radius: 0 0 $table-border-radius $table-border-radius;\n  }\n\n  /* Table Row */\n  .ui.table > tr > td,\n  .ui.table > tbody > tr > td {\n    border-top: $table-row-border;\n  }\n  .ui.table > tr:first-child > td,\n  .ui.table > tbody > tr:first-child > td {\n    border-top: none;\n  }\n\n  /* Repeated tbody */\n  .ui.table > tbody + tbody tr:first-child > td {\n    border-top: $table-row-border;\n  }\n\n  /* Table Cells */\n  .ui.table > tbody > tr > td,\n  .ui.table > tr > td {\n    padding: $table-cell-vertical-padding $table-cell-horizontal-padding;\n    text-align: $table-cell-text-align;\n  }\n\n  /* Icons */\n  .ui.table > .icon {\n    vertical-align: $table-icon-vertical-align;\n  }\n  .ui.table > .icon:only-child {\n    margin: 0;\n  }\n\n  /* Table Segment */\n  .ui.table.segment {\n    padding: 0;\n  }\n  .ui.table.segment:after {\n    display: none;\n  }\n  .ui.table.segment.stacked:after {\n    display: block;\n  }\n\n\n  /* Responsive */\n  @media only screen and (max-width : $largest-mobile-screen) {\n    .ui.table:not(.unstackable) {\n      width: 100%;\n      padding: 0;\n    }\n    .ui.table:not(.unstackable) > thead,\n    .ui.table:not(.unstackable) > thead > tr,\n    .ui.table:not(.unstackable) > tfoot,\n    .ui.table:not(.unstackable) > tfoot > tr,\n    .ui.table:not(.unstackable) > tbody,\n    .ui.table:not(.unstackable) > tr,\n    .ui.table:not(.unstackable) > tbody > tr,\n    .ui.table:not(.unstackable) > tr > th,\n    .ui.table:not(.unstackable) > thead > tr > th,\n    .ui.table:not(.unstackable) > tbody > tr > th,\n    .ui.table:not(.unstackable) > tfoot > tr > th,\n    .ui.table:not(.unstackable) > tr > td,\n    .ui.table:not(.unstackable) > tbody > tr > td {\n      display: block !important;\n      width: auto !important;\n    }\n\n    .ui.table:not(.unstackable) > thead {\n      display: $table-responsive-header-display;\n    }\n    .ui.table:not(.unstackable) > tfoot {\n      display: $table-responsive-footer-display;\n    }\n    .ui.table:not(.unstackable) > tr,\n    .ui.table:not(.unstackable) > thead > tr,\n    .ui.table:not(.unstackable) > tbody > tr,\n    .ui.table:not(.unstackable) > tfoot > tr {\n      padding-top: $table-responsive-row-vertical-padding;\n      padding-bottom: $table-responsive-row-vertical-padding;\n      box-shadow: $table-responsive-row-box-shadow;\n    }\n\n    .ui.ui.ui.ui.table:not(.unstackable) > tr > th,\n    .ui.ui.ui.ui.table:not(.unstackable) > thead > tr > th,\n    .ui.ui.ui.ui.table:not(.unstackable) > tbody > tr > th,\n    .ui.ui.ui.ui.table:not(.unstackable) > tfoot > tr > th,\n    .ui.ui.ui.ui.table:not(.unstackable) > tr > td,\n    .ui.ui.ui.ui.table:not(.unstackable) > tbody > tr > td {\n      background: none;\n      border: none;\n      padding: $table-responsive-cell-vertical-padding $table-responsive-cell-horizontal-padding;\n      box-shadow: $table-responsive-cell-box-shadow;\n    }\n    .ui.table:not(.unstackable) > tr > th:first-child,\n    .ui.table:not(.unstackable) > thead > tr > th:first-child,\n    .ui.table:not(.unstackable) > tbody > tr > th:first-child,\n    .ui.table:not(.unstackable) > tfoot > tr > th:first-child,\n    .ui.table:not(.unstackable) > tr > td:first-child,\n    .ui.table:not(.unstackable) > tbody > tr > td:first-child {\n      font-weight: $table-responsive-cell-header-font-weight;\n    }\n\n    /* Definition Table */\n    .ui.definition.table:not(.unstackable) > thead > tr > th:first-child {\n      box-shadow: none !important;\n    }\n  }\n\n\n  /*******************************\n              Coupling\n  *******************************/\n\n  /* UI Image */\n  .ui.table .collapsing .image,\n  .ui.table .collapsing .image img {\n    max-width: none;\n  }\n\n\n  /*******************************\n              Types\n  *******************************/\n\n  @if($use-table-type-structured) {\n    /*--------------\n        Complex\n    ---------------*/\n\n    .ui.structured.table {\n      border-collapse: collapse;\n    }\n    .ui.structured.table > thead > tr > th {\n      border-left: $table-header-divider;\n      border-right: $table-header-divider;\n    }\n    @if($use-table-variation-sortable) {\n      .ui.structured.sortable.table > thead > tr > th {\n        border-left: $table-sortable-border;\n        border-right: $table-sortable-border;\n      }\n    }\n    @if($use-table-variation-basic){\n      .ui.structured.basic.table > tr > th,\n      .ui.structured.basic.table > thead > tr > th,\n      .ui.structured.basic.table > tbody > tr > th,\n      .ui.structured.basic.table > tfoot > tr > th {\n        border-left: $table-basic-header-divider;\n        border-right: $table-basic-header-divider;\n      }\n    }\n    @if($use-table-variation-celled) {\n      .ui.structured.celled.table > tr > th,\n      .ui.structured.celled.table > thead > tr > th,\n      .ui.structured.celled.table > tbody > tr > th,\n      .ui.structured.celled.table > tfoot > tr > th,\n      .ui.structured.celled.table > tr > td,\n      .ui.structured.celled.table > tbody > tr > td {\n        border-left: $table-cell-border;\n        border-right: $table-cell-border;\n      }\n    }\n  }\n\n  @if($use-table-type-definition) {\n    /*--------------\n      Definition\n    ---------------*/\n\n    .ui.definition.table > thead:not(.full-width) > tr > th:first-child {\n      pointer-events: none;\n      background: $table-definition-header-background;\n      font-weight: $table-definition-header-font-weight;\n      color: $table-definition-header-color;\n      box-shadow: (-$table-colored-border-size-cover) (-$table-colored-border-size) 0 $table-colored-border-size-cover $table-definition-page-background;\n      -moz-transform: scale(1);\n    }\n\n    .ui.definition.table > tfoot:not(.full-width) > tr > th:first-child {\n      pointer-events: none;\n      background: $table-definition-footer-background;\n      font-weight: $table-definition-footer-font-weight;\n      color: $table-definition-footer-color;\n      box-shadow: (-$table-colored-border-size-cover) $table-colored-border-size 0 $table-colored-border-size-cover $table-definition-page-background;\n      -moz-transform: scale(1);\n    }\n\n    /* Highlight Defining Column */\n    .ui.definition.table > tr > td:first-child:not(.ignored),\n    .ui.definition.table > tbody > tr > td:first-child:not(.ignored),\n    .ui.definition.table tr td.definition {\n      background: $table-definition-column-background;\n      font-weight: $table-definition-column-font-weight;\n      color: $table-definition-column-color;\n      text-transform: $table-definition-column-text-transform;\n      box-shadow: $table-definition-column-box-shadow;\n      text-align: $table-definition-column-text-align;\n      font-size: $table-definition-column-font-size;\n      padding-left: $table-definition-column-horizontal-padding;\n      padding-right: $table-definition-column-horizontal-padding;\n    }\n\n\n    /* Fix 2nd Column */\n    .ui.definition.table > thead:not(.full-width) > tr > th:nth-child(2) {\n      border-left: $table-border-width solid $border-color;\n    }\n    .ui.definition.table > tfoot:not(.full-width) > tr > th:nth-child(2) {\n      border-left: $table-border-width solid $border-color;\n    }\n    .ui.definition.table > tr > td:nth-child(2),\n    .ui.definition.table > tbody > tr > td:nth-child(2) {\n      border-left: $table-border-width solid $border-color;\n    }\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------\n      Positive\n  ---------------*/\n\n  .ui.ui.ui.ui.table tr.positive,\n  .ui.ui.table td.positive {\n    box-shadow: $table-positive-box-shadow;\n    background: $positive-background-color;\n    color: $table-positive-color;\n  }\n\n  /*--------------\n      Negative\n  ---------------*/\n\n  .ui.ui.ui.ui.table tr.negative,\n  .ui.ui.table td.negative {\n    box-shadow: $table-negative-box-shadow;\n    background: $negative-background-color;\n    color: $table-negative-color;\n  }\n\n  /*--------------\n        Error\n  ---------------*/\n\n  .ui.ui.ui.ui.table tr.error,\n  .ui.ui.table td.error {\n    box-shadow: $table-error-box-shadow;\n    background: $error-background-color;\n    color: $table-error-color;\n  }\n\n  /*--------------\n      Warning\n  ---------------*/\n\n  .ui.ui.ui.ui.table tr.warning,\n  .ui.ui.table td.warning {\n    box-shadow: $table-warning-box-shadow;\n    background: $warning-background-color;\n    color: $table-warning-color;\n  }\n\n  /*--------------\n      Active\n  ---------------*/\n\n  .ui.ui.ui.ui.table tr.active,\n  .ui.ui.table td.active {\n    box-shadow: $table-active-box-shadow;\n    background: $table-active-background-color;\n    color: $table-active-color;\n  }\n\n\n\n  /*--------------\n      Disabled\n  ---------------*/\n\n  .ui.table tr.disabled td,\n  .ui.table tr td.disabled,\n  .ui.table tr.disabled:hover,\n  .ui.table tr:hover td.disabled {\n    pointer-events: none;\n    color: $disabled-text-color;\n  }\n\n  /*******************************\n            Variations\n  *******************************/\n\n  /*--------------\n      Stackable\n  ---------------*/\n\n  @media only screen and (max-width : $largest-tablet-screen) {\n\n    .ui[class*=\"tablet stackable\"].table,\n    .ui[class*=\"tablet stackable\"].table > thead,\n    .ui[class*=\"tablet stackable\"].table > thead > tr,\n    .ui[class*=\"tablet stackable\"].table > tfoot,\n    .ui[class*=\"tablet stackable\"].table > tfoot > tr,\n    .ui[class*=\"tablet stackable\"].table > tbody,\n    .ui[class*=\"tablet stackable\"].table > tbody > tr,\n    .ui[class*=\"tablet stackable\"].table > tr,\n    .ui[class*=\"tablet stackable\"].table > thead > tr > th,\n    .ui[class*=\"tablet stackable\"].table > tbody > tr > th,\n    .ui[class*=\"tablet stackable\"].table > tfoot > tr > th,\n    .ui[class*=\"tablet stackable\"].table > tr > th,\n    .ui[class*=\"tablet stackable\"].table > tbody > tr > td,\n    .ui[class*=\"tablet stackable\"].table > tr > td  {\n      display: block !important;\n      width: 100% !important;\n    }\n\n    .ui[class*=\"tablet stackable\"].table {\n      padding: 0;\n    }\n    .ui[class*=\"tablet stackable\"].table > thead {\n      display: $table-responsive-header-display;\n    }\n    .ui[class*=\"tablet stackable\"].table > tfoot {\n      display: $table-responsive-footer-display;\n    }\n    .ui[class*=\"tablet stackable\"].table > thead > tr,\n    .ui[class*=\"tablet stackable\"].table > tbody > tr,\n    .ui[class*=\"tablet stackable\"].table > tfoot > tr,\n    .ui[class*=\"tablet stackable\"].table > tr {\n      padding-top: $table-responsive-row-vertical-padding;\n      padding-bottom: $table-responsive-row-vertical-padding;\n      box-shadow: $table-responsive-row-box-shadow;\n    }\n    .ui[class*=\"tablet stackable\"].table > thead > tr > th,\n    .ui[class*=\"tablet stackable\"].table > tbody > tr > th,\n    .ui[class*=\"tablet stackable\"].table > tfoot > tr > th,\n    .ui[class*=\"tablet stackable\"].table > tr > th,\n    .ui[class*=\"tablet stackable\"].table > tbody > tr > td,\n    .ui[class*=\"tablet stackable\"].table > tr > td {\n      background: none;\n      border: none !important;\n      padding: $table-responsive-cell-vertical-padding $table-responsive-cell-horizontal-padding;\n      box-shadow: $table-responsive-cell-box-shadow;\n    }\n\n    /* Definition Table */\n    .ui.definition[class*=\"tablet stackable\"].table > thead > tr > th:first-child {\n      box-shadow: none !important;\n    }\n  }\n\n  /*--------------\n  Text Alignment\n  ---------------*/\n\n  .ui.table[class*=\"left aligned\"],\n  .ui.table [class*=\"left aligned\"] {\n    text-align: left;\n  }\n  .ui.table[class*=\"center aligned\"],\n  .ui.table [class*=\"center aligned\"] {\n    text-align: center;\n  }\n  .ui.table[class*=\"right aligned\"],\n  .ui.table [class*=\"right aligned\"] {\n    text-align: right;\n  }\n\n  /*------------------\n  Vertical Alignment\n  ------------------*/\n\n  .ui.table[class*=\"top aligned\"],\n  .ui.table [class*=\"top aligned\"] {\n    vertical-align: top;\n  }\n  .ui.table[class*=\"middle aligned\"],\n  .ui.table [class*=\"middle aligned\"] {\n    vertical-align: middle;\n  }\n  .ui.table[class*=\"bottom aligned\"],\n  .ui.table [class*=\"bottom aligned\"] {\n    vertical-align: bottom;\n  }\n\n  /*--------------\n      Collapsing\n  ---------------*/\n\n  .ui.table th.collapsing,\n  .ui.table td.collapsing {\n    width: 1px;\n    white-space: nowrap;\n  }\n\n  /*--------------\n      Fixed\n  ---------------*/\n\n  .ui.fixed.table {\n    table-layout: fixed;\n  }\n\n  .ui.fixed.table th,\n  .ui.fixed.table td {\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n\n  /*--------------\n    Selectable\n  ---------------*/\n\n  .ui.ui.selectable.table > tbody > tr:hover,\n  .ui.table tbody tr td.selectable:hover {\n    background: $table-selectable-background;\n    color: $table-selectable-text-color;\n  }\n  @if($use-table-variation-inverted) {\n    .ui.ui.selectable.inverted.table > tbody > tr:hover,\n    .ui.inverted.table tbody tr td.selectable:hover {\n      background: $table-selectable-inverted-background;\n      color: $table-selectable-inverted-text-color;\n    }\n  }\n\n  /* Selectable Cell Link */\n  .ui.table tbody tr td.selectable {\n    padding: 0;\n  }\n  .ui.table tbody tr td.selectable > a:not(.ui) {\n    display: block;\n    color: inherit;\n    padding: $table-cell-vertical-padding $table-cell-horizontal-padding;\n  }\n  .ui.table > tr > td.selectable,\n  .ui.table > tbody > tr > td.selectable,\n  .ui.selectable.table > tbody > tr,\n  .ui.selectable.table > tr {\n    cursor:pointer;\n  }\n\n  /* Other States */\n  .ui.ui.selectable.table tr.error:hover,\n  .ui.table tr td.selectable.error:hover,\n  .ui.selectable.table tr:hover td.error {\n    background: $table-error-background-hover;\n    color: $table-error-color-hover;\n  }\n  .ui.ui.selectable.table tr.warning:hover,\n  .ui.table tr td.selectable.warning:hover,\n  .ui.selectable.table tr:hover td.warning {\n    background: $table-warning-background-hover;\n    color: $table-warning-color-hover;\n  }\n  .ui.ui.selectable.table tr.active:hover,\n  .ui.table tr td.selectable.active:hover,\n  .ui.selectable.table tr:hover td.active {\n    background: $table-active-background-color;\n    color: $table-active-color;\n  }\n  .ui.ui.selectable.table tr.positive:hover,\n  .ui.table tr td.selectable.positive:hover,\n  .ui.selectable.table tr:hover td.positive {\n    background: $table-positive-background-hover;\n    color: $table-positive-color-hover;\n  }\n  .ui.ui.selectable.table tr.negative:hover,\n  .ui.table tr td.selectable.negative:hover,\n  .ui.selectable.table tr:hover td.negative {\n    background: $table-negative-background-hover;\n    color: $table-negative-color-hover;\n  }\n\n\n\n  /*-------------------\n        Attached\n  --------------------*/\n\n  /* Middle */\n  .ui.attached.table {\n    top: 0;\n    bottom: 0;\n    border-radius: 0;\n    margin: 0 $table-attached-horizontal-offset;\n    width: $table-attached-width;\n    max-width: $table-attached-width;\n    box-shadow: $table-attached-box-shadow;\n    border: $table-attached-border;\n  }\n  .ui.attached + .ui.attached.table:not(.top) {\n    border-top: none;\n  }\n\n  /* Top */\n  .ui[class*=\"top attached\"].table {\n    bottom: 0;\n    margin-bottom: 0;\n    top: $table-attached-top-offset;\n    margin-top: $table-vertical-margin;\n    border-radius: $table-border-radius $table-border-radius 0 0;\n  }\n  .ui.table[class*=\"top attached\"]:first-child {\n    margin-top: 0;\n  }\n\n  /* Bottom */\n  .ui[class*=\"bottom attached\"].table {\n    bottom: 0;\n    margin-top: 0;\n    top: $table-attached-bottom-offset;\n    margin-bottom: $table-vertical-margin;\n    box-shadow: $table-attached-bottom-box-shadow;\n    border-radius: 0 0 $table-border-radius $table-border-radius;\n  }\n  .ui[class*=\"bottom attached\"].table:last-child {\n    margin-bottom: 0;\n  }\n\n  /*--------------\n      Striped\n  ---------------*/\n\n  /* Table Striping */\n  .ui.striped.table > tr:nth-child(2n),\n  .ui.striped.table > tbody > tr:nth-child(2n) {\n    background-color: $table-striped-background;\n  }\n\n  @if($use-table-variation-inverted) {\n    /* Stripes */\n    .ui.inverted.striped.table > tr:nth-child(2n),\n    .ui.inverted.striped.table > tbody > tr:nth-child(2n) {\n      background-color: $table-inverted-striped-background;\n    }\n  }\n\n  /* Allow striped active hover */\n  .ui.striped.selectable.selectable.selectable.table tbody tr.active:hover {\n    background: $table-active-background-hover;\n    color: $table-active-color-hover;\n  }\n\n  /*--------------\n    Single Line\n  ---------------*/\n\n  .ui.table[class*=\"single line\"],\n  .ui.table [class*=\"single line\"] {\n    white-space: nowrap;\n  }\n\n  /*-------------------\n        Colors\n  --------------------*/\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-table-variation-colors), $key+'')) {\n      $c: map-get-strict($value, color);\n      $t: map-get-strict($value, text);\n      $ht: map-get-strict($value, hoverText);\n      $b: map-get-strict($value, background);\n      $ht: map-get-strict($value, hoverText);\n      $l: map-get-strict($value, light);\n      $lh: map-get-strict($value, lightHover);\n      $bh: screen($l, $blending-base-color);\n      $r: map-get-strict($value, ribbon);\n      $isDark: map-get-strict($value, isDark);\n      $isVeryDark: map-get-strict($value, isVeryDark);\n\n      .ui.#{$key + \"\"}.table {\n        border-top: $table-colored-border-size solid $c;\n      }\n      @if($use-table-variation-inverted) {\n        .ui.inverted.#{$key + \"\"}.table {\n          background-color: $c;\n          color: $white;\n        }\n      }\n      .ui.ui.ui.ui.table tr.#{$key + \"\"},\n      .ui.ui.table td.#{$key + \"\"} {\n        box-shadow: $table-state-marker-width 0 0 $r inset;\n        @if ($isDark) {\n          background: $l;\n        }\n        @if not ($isDark) {\n          background: $b;\n        }\n        @if ($isVeryDark) {\n          color: $white;\n        }\n        @if not ($isVeryDark) {\n          color: $t;\n        }\n      }\n      .ui.ui.selectable.table tr.#{$key + \"\"}:hover,\n      .ui.table tr td.selectable.#{$key + \"\"}:hover,\n      .ui.selectable.table tr:hover td.#{$key + \"\"} {\n        @if ($isDark) {\n          background: $lh;\n        }\n        @if not ($isDark) {\n          background: $bh;\n        }\n        @if ($isVeryDark) {\n          color: $white;\n        }\n        @if not ($isVeryDark) {\n          color: $ht;\n        }\n      }\n    }\n  }\n\n  /*--------------\n    Column Count\n  ---------------*/\n\n  /* Grid Based */\n  .ui.one.column.table td {\n    width: $one-column;\n  }\n  .ui.two.column.table td {\n    width: $two-column;\n  }\n  .ui.three.column.table td {\n    width: $three-column;\n  }\n  .ui.four.column.table td {\n    width: $four-column;\n  }\n  .ui.five.column.table td {\n    width: $five-column;\n  }\n  .ui.six.column.table td {\n    width: $six-column;\n  }\n  .ui.seven.column.table td {\n    width: $seven-column;\n  }\n  .ui.eight.column.table td {\n    width: $eight-column;\n  }\n  .ui.nine.column.table td {\n    width: $nine-column;\n  }\n  .ui.ten.column.table td {\n    width: $ten-column;\n  }\n  .ui.eleven.column.table td {\n    width: $eleven-column;\n  }\n  .ui.twelve.column.table td {\n    width: $twelve-column;\n  }\n  .ui.thirteen.column.table td {\n    width: $thirteen-column;\n  }\n  .ui.fourteen.column.table td {\n    width: $fourteen-column;\n  }\n  .ui.fifteen.column.table td {\n    width: $fifteen-column;\n  }\n  .ui.sixteen.column.table td {\n    width: $sixteen-column;\n  }\n\n  /* Column Width */\n  .ui.table th.one.wide,\n  .ui.table td.one.wide {\n    width: $one-wide;\n  }\n  .ui.table th.two.wide,\n  .ui.table td.two.wide {\n    width: $two-wide;\n  }\n  .ui.table th.three.wide,\n  .ui.table td.three.wide {\n    width: $three-wide;\n  }\n  .ui.table th.four.wide,\n  .ui.table td.four.wide {\n    width: $four-wide;\n  }\n  .ui.table th.five.wide,\n  .ui.table td.five.wide {\n    width: $five-wide;\n  }\n  .ui.table th.six.wide,\n  .ui.table td.six.wide {\n    width: $six-wide;\n  }\n  .ui.table th.seven.wide,\n  .ui.table td.seven.wide {\n    width: $seven-wide;\n  }\n  .ui.table th.eight.wide,\n  .ui.table td.eight.wide {\n    width: $eight-wide;\n  }\n  .ui.table th.nine.wide,\n  .ui.table td.nine.wide {\n    width: $nine-wide;\n  }\n  .ui.table th.ten.wide,\n  .ui.table td.ten.wide {\n    width: $ten-wide;\n  }\n  .ui.table th.eleven.wide,\n  .ui.table td.eleven.wide {\n    width: $eleven-wide;\n  }\n  .ui.table th.twelve.wide,\n  .ui.table td.twelve.wide {\n    width: $twelve-wide;\n  }\n  .ui.table th.thirteen.wide,\n  .ui.table td.thirteen.wide {\n    width: $thirteen-wide;\n  }\n  .ui.table th.fourteen.wide,\n  .ui.table td.fourteen.wide {\n    width: $fourteen-wide;\n  }\n  .ui.table th.fifteen.wide,\n  .ui.table td.fifteen.wide {\n    width: $fifteen-wide;\n  }\n  .ui.table th.sixteen.wide,\n  .ui.table td.sixteen.wide {\n    width: $sixteen-wide;\n  }\n\n  @if($use-table-variation-sortable) {\n    /*--------------\n        Sortable\n    ---------------*/\n\n    .ui.sortable.table > thead > tr > th {\n      cursor: pointer;\n      white-space: nowrap;\n      border-left: $table-sortable-border;\n      color: $table-sortable-color;\n    }\n    .ui.sortable.table > thead > tr > th:first-child {\n      border-left: none;\n    }\n    .ui.sortable.table thead th.sorted,\n    .ui.sortable.table thead th.sorted:hover {\n      user-select: none;\n    }\n\n    .ui.sortable.table > thead > tr > th:after {\n      display: none;\n      font-style: normal;\n      font-weight: $normal;\n      text-decoration: inherit;\n      content: '';\n      height: 1em;\n      width: $table-sortable-icon-width;\n      opacity: $table-sortable-icon-opacity;\n      margin: 0 0 0 $table-sortable-icon-distance;\n      font-family: $table-sortable-icon-font;\n    }\n    .ui.sortable.table thead th.ascending:after {\n      content: $table-sortable-icon-ascending;\n    }\n    .ui.sortable.table thead th.descending:after {\n      content: $table-sortable-icon-descending;\n    }\n\n    /* Hover */\n    .ui.sortable.table th.disabled:hover {\n      cursor: auto;\n      color: $table-sortable-disabled-color;\n    }\n    .ui.sortable.table > thead > tr > th:hover {\n      background: $table-sortable-hover-background;\n      color: $table-sortable-hover-color;\n    }\n\n    /* Sorted */\n    .ui.sortable.table thead th.sorted {\n      background: $table-sortable-active-background;\n      color: $table-sortable-active-color;\n    }\n    .ui.sortable.table thead th.sorted:after {\n      display: inline-block;\n    }\n\n    /* Sorted Hover */\n    .ui.sortable.table thead th.sorted:hover {\n      background: $table-sortable-active-hover-background;\n      color: $table-sortable-active-hover-color;\n    }\n\n    @if($use-table-variation-inverted) {\n      /* Inverted */\n      .ui.inverted.sortable.table thead th.sorted {\n        background: $table-sortable-inverted-active-background;\n        color: $table-sortable-inverted-active-color;\n      }\n      .ui.inverted.sortable.table > thead > tr > th:hover {\n        background: $table-sortable-inverted-hover-background;\n        color: $table-sortable-inverted-hover-color;\n      }\n      .ui.inverted.sortable.table > thead > tr > th {\n        border-left-color: $table-sortable-inverted-border-color;\n        border-right-color: $table-sortable-inverted-border-color;\n      }\n    }\n  }\n\n\n  @if($use-table-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n\n    /* Text Color */\n    .ui.inverted.table {\n      background: $table-inverted-background;\n      color: $table-inverted-cell-color;\n      border: $table-inverted-border;\n    }\n    .ui.ui.inverted.table > thead > tr > th,\n    .ui.ui.inverted.table > tbody > tr > th,\n    .ui.ui.inverted.table > tfoot > tr > th,\n    .ui.ui.inverted.table > tr > th {\n      background-color: $table-inverted-header-background;\n      border-color: $table-inverted-header-border-color;\n      color: $table-inverted-header-color;\n    }\n    .ui.inverted.table > tbody > tr > td,\n    .ui.inverted.table > tr > td {\n      border-color: $table-inverted-cell-border-color;\n    }\n\n    .ui.inverted.table tr.disabled td,\n    .ui.inverted.table tr td.disabled,\n    .ui.inverted.table tr.disabled:hover td,\n    .ui.inverted.table tr:hover td.disabled {\n      pointer-events: none;\n      color: $inverted-disabled-text-color;\n    }\n    .ui.inverted.table tr td.disabled:not([class=\"disabled\"]),\n    .ui.inverted.table tr.disabled:not([class=\"disabled\"]) td,\n    .ui.inverted.table tr.disabled td[class]:not(.disabled),\n    .ui.inverted.table tr:hover td.disabled:not([class=\"disabled\"]) {\n      color: $disabled-text-color;\n    }\n    /* Definition */\n    .ui.inverted.definition.table > tfoot:not(.full-width) > tr > th:first-child,\n    .ui.inverted.definition.table > thead:not(.full-width) > tr > th:first-child {\n      background: $table-definition-page-background;\n    }\n    .ui.inverted.definition.table > tbody > tr > td:first-child,\n    .ui.inverted.definition.table > tr > td:first-child {\n      background: $table-inverted-definition-column-background;\n      color: $table-inverted-definition-column-color;\n    }\n  }\n\n  /*--------------\n    Collapsing\n  ---------------*/\n\n  .ui.collapsing.table {\n    width: auto;\n  }\n\n  @if($use-table-variation-basic) {\n    /*--------------\n          Basic\n    ---------------*/\n\n    .ui.basic.table {\n      background: $table-basic-background;\n      border: $table-basic-border;\n      box-shadow: $table-basic-box-shadow;\n    }\n    .ui.basic.table > thead,\n    .ui.basic.table > tfoot {\n      box-shadow: none;\n    }\n    .ui.basic.table > thead > tr > th,\n    .ui.basic.table > tbody > tr > th,\n    .ui.basic.table > tfoot > tr > th,\n    .ui.basic.table > tr > th {\n      background: $table-basic-header-background;\n      border-left: $table-basic-header-divider;\n    }\n    /*! .ui.basic.table > tbody > tr {\n      border-bottom: $table-basic-cell-border;\n    } */\n    .ui.basic.table > tbody > tr > td,\n    .ui.basic.table > tr > td {\n      background: $table-basic-cell-background;\n    }\n    .ui.basic.striped.table > tbody > tr:nth-child(2n) {\n      background-color: $table-basic-striped-background;\n    }\n\n    /* Very Basic */\n    .ui[class*=\"very basic\"].table {\n      border: none;\n    }\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tr > th,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > thead > tr > th,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tbody > tr > th,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tfoot > tr > th,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tr > td,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tbody > tr > td {\n      padding: $table-basic-cell-padding;\n    }\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tr > th:first-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > thead > tr > th:first-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tbody > tr > th:first-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tfoot > tr > th:first-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tr > td:first-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tbody > tr > td:first-child {\n      padding-left: 0;\n    }\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tr > th:last-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > thead > tr > th:last-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tbody > tr > th:last-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tfoot > tr > th:last-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tr > td:last-child,\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > tbody > tr > td:last-child {\n      padding-right: 0;\n    }\n    .ui[class*=\"very basic\"].table:not(.sortable):not(.striped) > thead > tr:first-child > th {\n      padding-top: 0;\n    }\n  }\n\n  @if($use-table-variation-celled) {\n    /*--------------\n        Celled\n    ---------------*/\n\n    .ui.celled.table > tr > th,\n    .ui.celled.table > thead > tr > th,\n    .ui.celled.table > tbody > tr > th,\n    .ui.celled.table > tfoot > tr > th,\n    .ui.celled.table > tr > td,\n    .ui.celled.table > tbody > tr > td {\n      border-left: $table-cell-border;\n    }\n    @if($use-table-variation-inverted) {\n      .ui.inverted.celled.table > tbody > tr > td,\n      .ui.inverted.celled.table > tr > td {\n        border-left: $table-inverted-cell-border;\n      }\n    }\n    .ui.celled.table > tr > th:first-child,\n    .ui.celled.table > thead > tr > th:first-child,\n    .ui.celled.table > tbody > tr > th:first-child,\n    .ui.celled.table > tfoot > tr > th:first-child,\n    .ui.celled.table > tr > td:first-child,\n    .ui.celled.table > tbody > tr > td:first-child {\n      border-left: none;\n    }\n  }\n\n  @if($use-table-variation-padded) {\n    /*--------------\n        Padded\n    ---------------*/\n\n    .ui.padded.table > tr > th,\n    .ui.padded.table > thead > tr > th,\n    .ui.padded.table > tbody > tr > th,\n    .ui.padded.table > tfoot > tr > th {\n      padding-left: $table-padded-horizontal-padding;\n      padding-right: $table-padded-horizontal-padding;\n    }\n    .ui.padded.table > tr > th,\n    .ui.padded.table > thead > tr > th,\n    .ui.padded.table > tbody > tr > th,\n    .ui.padded.table > tfoot > tr > th,\n    .ui.padded.table > tr > td,\n    .ui.padded.table > tbody > tr > td {\n      padding: $table-padded-vertical-padding $table-padded-horizontal-padding;\n    }\n\n    /* Very */\n    .ui[class*=\"very padded\"].table > tr > th,\n    .ui[class*=\"very padded\"].table > thead > tr > th,\n    .ui[class*=\"very padded\"].table > tbody > tr > th,\n    .ui[class*=\"very padded\"].table > tfoot > tr > th {\n      padding-left: $table-very-padded-horizontal-padding;\n      padding-right: $table-very-padded-horizontal-padding;\n    }\n    .ui[class*=\"very padded\"].table > tr > td,\n    .ui[class*=\"very padded\"].table > tbody > tr > td {\n      padding: $table-very-padded-vertical-padding $table-very-padded-horizontal-padding;\n    }\n  }\n\n  @if($use-table-variation-compact) {\n    /*--------------\n        Compact\n    ---------------*/\n\n    .ui.compact.table > tr > th,\n    .ui.compact.table > thead > tr > th,\n    .ui.compact.table > tbody > tr > th,\n    .ui.compact.table > tfoot > tr > th {\n      padding-left: $table-compact-horizontal-padding;\n      padding-right: $table-compact-horizontal-padding;\n    }\n    .ui.compact.table > tr > td,\n    .ui.compact.table > tbody > tr > td {\n      padding: $table-compact-vertical-padding $table-compact-horizontal-padding;\n    }\n\n    /* Very */\n    .ui[class*=\"very compact\"].table > tr > th,\n    .ui[class*=\"very compact\"].table > thead > tr > th,\n    .ui[class*=\"very compact\"].table > tbody > tr > th,\n    .ui[class*=\"very compact\"].table > tfoot > tr > th {\n      padding-left: $table-very-compact-horizontal-padding;\n      padding-right: $table-very-compact-horizontal-padding;\n    }\n    .ui[class*=\"very compact\"].table > tr > td,\n    .ui[class*=\"very compact\"].table > tbody > tr > td {\n      padding: $table-very-compact-vertical-padding $table-very-compact-horizontal-padding;\n    }\n  }\n\n  /*--------------\n        Sizes\n  ---------------*/\n\n  /* Small */\n  .ui.small.table {\n    font-size: $table-small;\n  }\n\n  /* Standard */\n  .ui.table {\n    font-size: $table-medium;\n  }\n\n  /* Large */\n  .ui.large.table {\n    font-size: $table-large;\n  }\n}\n\n@import '../../themes/default/collections/table.style';","@import '../../themes/default/views/ad.variables';\n\n@if $use-ad {\n  /*******************************\n  //@-     Advertisement\n  *******************************/\n\n  .ui.ad {\n    display: block;\n    overflow: $ad-overflow;\n    margin: $ad-margin;\n  }\n\n  .ui.ad:first-child {\n    margin: 0;\n  }\n\n  .ui.ad:last-child {\n    margin: 0;\n  }\n\n  .ui.ad iframe {\n    margin: 0;\n    padding: 0;\n    border: none;\n    overflow: hidden;\n  }\n\n  /*--------------\n      Common\n  ---------------*/\n\n  /* Leaderboard */\n  .ui.leaderboard.ad {\n    width: 728px;\n    height: 90px;\n  }\n\n  /* Medium Rectangle */\n  .ui[class*=\"medium rectangle\"].ad {\n    width: 300px;\n    height: 250px;\n  }\n\n  /* Large Rectangle */\n  .ui[class*=\"large rectangle\"].ad {\n    width: 336px;\n    height: 280px;\n  }\n  /* Half Page */\n  .ui[class*=\"half page\"].ad {\n    width: 300px;\n    height: 600px;\n  }\n\n  /*--------------\n      Square\n  ---------------*/\n\n  /* Square */\n  .ui.square.ad {\n    width: 250px;\n    height: 250px;\n  }\n\n  /* Small Square */\n  .ui[class*=\"small square\"].ad {\n    width: 200px;\n    height: 200px;\n  }\n\n  /*--------------\n      Rectangle\n  ---------------*/\n\n  /* Small Rectangle */\n  .ui[class*=\"small rectangle\"].ad {\n    width: 180px;\n    height: 150px;\n  }\n\n  /* Vertical Rectangle */\n  .ui[class*=\"vertical rectangle\"].ad {\n    width: 240px;\n    height: 400px;\n  }\n\n  /*--------------\n      Button\n  ---------------*/\n\n  .ui.button.ad {\n    width: 120px;\n    height: 90px;\n  }\n  .ui[class*=\"square button\"].ad {\n    width: 125px;\n    height: 125px;\n  }\n  .ui[class*=\"small button\"].ad {\n    width: 120px;\n    height: 60px;\n  }\n\n  /*--------------\n    Skyscrapers\n  ---------------*/\n\n  /* Skyscraper */\n  .ui.skyscraper.ad {\n    width: 120px;\n    height: 600px;\n  }\n\n  /* Wide Skyscraper */\n  .ui[class*=\"wide skyscraper\"].ad {\n    width: 160px;\n  }\n\n  /*--------------\n      Banners\n  ---------------*/\n\n  /* Banner */\n  .ui.banner.ad {\n    width: 468px;\n    height: 60px;\n  }\n\n  /* Vertical Banner */\n  .ui[class*=\"vertical banner\"].ad {\n    width: 120px;\n    height: 240px;\n  }\n\n  /* Top Banner */\n  .ui[class*=\"top banner\"].ad {\n    width: 930px;\n    height: 180px;\n  }\n\n  /* Half Banner */\n  .ui[class*=\"half banner\"].ad {\n    width: 234px;\n    height: 60px;\n  }\n\n  /*--------------\n      Boards\n  ---------------*/\n\n  /* Leaderboard */\n  .ui[class*=\"large leaderboard\"].ad {\n    width: 970px;\n    height: 90px;\n  }\n\n  /* Billboard */\n  .ui.billboard.ad {\n    width: 970px;\n    height: 250px;\n  }\n\n  /*--------------\n      Panorama\n  ---------------*/\n\n  /* Panorama */\n  .ui.panorama.ad {\n    width: 980px;\n    height: 120px;\n  }\n\n  /*--------------\n      Netboard\n  ---------------*/\n\n  /* Netboard */\n  .ui.netboard.ad {\n    width: 580px;\n    height: 400px;\n  }\n\n\n\n  /*--------------\n      Mobile\n  ---------------*/\n\n  /* Large Mobile Banner */\n  .ui[class*=\"large mobile banner\"].ad {\n    width: 320px;\n    height: 100px;\n  }\n\n  /* Mobile Leaderboard */\n  .ui[class*=\"mobile leaderboard\"].ad {\n    width: 320px;\n    height: 50px;\n  }\n\n  /*******************************\n              Types\n  *******************************/\n\n  /* Mobile Sizes */\n  .ui.mobile.ad {\n    display: none;\n  }\n\n  @media only screen and (max-width : $largest-mobile-screen) {\n    .ui.mobile.ad {\n      display: block;\n    }\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  .ui.centered.ad {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .ui.test.ad {\n    position: relative;\n    background: $ad-test-background;\n  }\n  .ui.test.ad:after {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 100%;\n    text-align: center;\n    transform: translateX(-50%) translateY(-50%);\n\n    content: $ad-test-text;\n    color: $ad-test-color;\n    font-size: $ad-test-font-size;\n    font-weight: $ad-test-font-weight;\n  }\n  .ui.mobile.test.ad:after {\n    font-size: $ad-test-mobile-font-size;\n  }\n  .ui.test.ad[data-text]:after {\n    content: attr(data-text);\n  }\n}\n\n@import '../../themes/default/views/ad.style';","@import '../../themes/default/views/card.variables';\n\n@if $use-card {\n  /*******************************\n  //@-        Standard\n  *******************************/\n\n  /*--------------\n        Card\n  ---------------*/\n\n  .ui.cards > .card,\n  .ui.card {\n    max-width: 100%;\n    position: relative;\n    display: $card-display;\n    flex-direction: column;\n\n    width: $card-width;\n    min-height: $card-min-height;\n    background: $card-background;\n    padding: $card-padding;\n\n    border: $card-border;\n    border-radius: $card-border-radius;\n    box-shadow: $card-box-shadow;\n    transition: $card-transition;\n    z-index: $card-z-index;\n    word-wrap: break-word;\n  }\n  .ui.card {\n    margin: $card-margin;\n  }\n\n  .ui.cards > .card a,\n  .ui.card a {\n    cursor: pointer;\n  }\n\n  .ui.card:first-child {\n    margin-top: 0;\n  }\n  .ui.card:last-child {\n    margin-bottom: 0;\n  }\n\n  /*--------------\n        Cards\n  ---------------*/\n\n  .ui.cards {\n    display: $card-group-super-display;\n    margin: $card-group-card-margin;\n    flex-wrap: wrap;\n  }\n\n  .ui.cards > .card {\n    display: $card-group-display;\n    margin: $card-group-margin;\n    float: $card-group-float;\n  }\n\n  /* Clearing */\n  .ui.cards:after,\n  .ui.card:after {\n    display: block;\n    content: ' ';\n    height: 0;\n    clear: both;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n\n  /* Consecutive Card Groups Preserve Row Spacing */\n  .ui.cards ~ .ui.cards {\n    margin-top: $card-consecutive-group-distance;\n  }\n\n\n  /*--------------\n    Rounded Edges\n  ---------------*/\n\n  .ui.cards > .card > :first-child,\n  .ui.card > :first-child {\n    border-radius: $card-border-radius $card-border-radius 0 0 !important;\n    border-top: none !important;\n  }\n\n  .ui.cards > .card > :last-child,\n  .ui.card > :last-child {\n    border-radius: 0 0 $card-border-radius $card-border-radius !important;\n  }\n\n  .ui.cards > .card > :only-child,\n  .ui.card > :only-child {\n    border-radius: $card-border-radius !important;\n  }\n\n  /*--------------\n      Images\n  ---------------*/\n\n  .ui.cards > .card > .image,\n  .ui.card > .image {\n    position: relative;\n    display: block;\n    flex: 0 0 auto;\n    padding: $card-image-padding;\n    background: $card-image-background;\n  }\n  .ui.cards > .card > .image > img,\n  .ui.card > .image > img {\n    display: block;\n    width: 100%;\n    height: auto;\n    border-radius: inherit;\n  }\n  .ui.cards > .card > .image:not(.ui) > img,\n  .ui.card > .image:not(.ui) > img {\n    border: $card-image-border;\n  }\n\n  /*--------------\n      Content\n  ---------------*/\n\n  .ui.cards > .card > .content,\n  .ui.card > .content {\n    flex-grow: 1;\n    border: $card-content-border;\n    border-top: $card-content-divider;\n    background: $card-content-background;\n    margin: $card-content-margin;\n    padding: $card-content-padding;\n    box-shadow: $card-content-box-shadow;\n    font-size: $card-content-font-size;\n    border-radius: $card-content-border-radius;\n  }\n\n  .ui.cards > .card > .content:after,\n  .ui.card > .content:after {\n    display: block;\n    content: ' ';\n    height: 0;\n    clear: both;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n  .ui.cards > .card > .content > .header,\n  .ui.card > .content > .header {\n    display: block;\n    margin: $card-header-margin;\n    font-family: $header-font;\n    color: $card-header-color;\n  }\n\n  /* Default Header Size */\n  .ui.cards > .card > .content > .header:not(.ui),\n  .ui.card > .content > .header:not(.ui) {\n    font-weight: $card-header-font-weight;\n    font-size: $card-header-font-size;\n    margin-top: $card-header-line-height-offset;\n    line-height: $header-line-height;\n  }\n\n  .ui.cards > .card > .content > .meta + .description,\n  .ui.cards > .card > .content > .header + .description,\n  .ui.card > .content > .meta + .description,\n  .ui.card > .content > .header + .description  {\n    margin-top: $card-description-distance;\n  }\n\n  /*----------------\n  Floated Content\n  -----------------*/\n\n  .ui.cards > .card  [class*=\"left floated\"],\n  .ui.card [class*=\"left floated\"] {\n    float: left;\n  }\n  .ui.cards > .card [class*=\"right floated\"],\n  .ui.card [class*=\"right floated\"] {\n    float: right;\n  }\n\n  /*--------------\n      Aligned\n  ---------------*/\n\n  .ui.cards > .card  [class*=\"left aligned\"],\n  .ui.card [class*=\"left aligned\"] {\n    text-align: left;\n  }\n  .ui.cards > .card [class*=\"center aligned\"],\n  .ui.card [class*=\"center aligned\"] {\n    text-align: center;\n  }\n  .ui.cards > .card [class*=\"right aligned\"],\n  .ui.card [class*=\"right aligned\"] {\n    text-align: right;\n  }\n\n\n  /*--------------\n    Content Image\n  ---------------*/\n\n  .ui.cards > .card .content img,\n  .ui.card .content img {\n    display: inline-block;\n    vertical-align: $card-content-image-vertical-align;\n    width: $card-content-image-width;\n  }\n  .ui.cards > .card img.avatar,\n  .ui.cards > .card .avatar img,\n  .ui.card img.avatar,\n  .ui.card .avatar img {\n    width: $card-avatar-size;\n    height: $card-avatar-size;\n    border-radius: $card-avatar-border-radius;\n  }\n\n\n  /*--------------\n    Description\n  ---------------*/\n\n  .ui.cards > .card > .content > .description,\n  .ui.card > .content > .description {\n    clear: both;\n    color: $card-description-color;\n  }\n\n  /*--------------\n      Paragraph\n  ---------------*/\n\n  .ui.cards > .card > .content p,\n  .ui.card > .content p {\n    margin: 0 0 $card-paragraph-distance;\n  }\n  .ui.cards > .card > .content p:last-child,\n  .ui.card > .content p:last-child {\n    margin-bottom: 0;\n  }\n\n  /*--------------\n        Meta\n  ---------------*/\n\n  .ui.cards > .card .meta,\n  .ui.card .meta {\n    font-size: $card-meta-font-size;\n    color: $card-meta-color;\n  }\n  .ui.cards > .card .meta *,\n  .ui.card .meta * {\n    margin-right: $card-meta-spacing;\n  }\n  .ui.cards > .card .meta :last-child,\n  .ui.card .meta :last-child {\n    margin-right: 0;\n  }\n\n  .ui.cards > .card .meta [class*=\"right floated\"],\n  .ui.card .meta [class*=\"right floated\"] {\n    margin-right: 0;\n    margin-left: $card-meta-spacing;\n  }\n\n  /*--------------\n        Links\n  ---------------*/\n\n  /* Generic */\n  .ui.cards > .card > .content a:not(.ui),\n  .ui.card > .content a:not(.ui) {\n    color: $card-content-link-color;\n    transition: $card-content-link-transition;\n  }\n  .ui.cards > .card > .content a:not(.ui):hover,\n  .ui.card > .content a:not(.ui):hover {\n    color: $card-content-link-hover-color;\n  }\n\n  /* Header */\n  .ui.cards > .card > .content > a.header,\n  .ui.card > .content > a.header {\n    color: $card-header-link-color;\n  }\n  .ui.cards > .card > .content > a.header:hover,\n  .ui.card > .content > a.header:hover {\n    color: $card-header-link-hover-color;\n  }\n\n  /* Meta */\n  .ui.cards > .card .meta > a:not(.ui),\n  .ui.card .meta > a:not(.ui) {\n    color: $card-meta-link-color;\n  }\n  .ui.cards > .card .meta > a:not(.ui):hover,\n  .ui.card .meta > a:not(.ui):hover {\n    color: $card-meta-link-hover-color;\n  }\n\n  /*--------------\n      Buttons\n  ---------------*/\n\n  .ui.cards > .card > .buttons,\n  .ui.card > .buttons,\n  .ui.cards > .card > .button,\n  .ui.card > .button {\n    margin: $card-button-margin;\n    width: $card-button-width;\n    &:last-child {\n      margin-bottom: -$card-border-width;\n    }\n  }\n\n  /*--------------\n        Dimmer\n  ---------------*/\n\n  .ui.cards > .card .dimmer,\n  .ui.card .dimmer {\n    background-color: $card-dimmer-color;\n    z-index: $card-dimmer-z-index;\n  }\n\n  /*--------------\n      Labels\n  ---------------*/\n\n  /*-----Star----- */\n\n  /* Icon */\n  .ui.cards > .card > .content .star.icon,\n  .ui.card > .content .star.icon {\n    cursor: pointer;\n    opacity: $card-action-opacity;\n    transition: $card-action-transition;\n  }\n  .ui.cards > .card > .content .star.icon:hover,\n  .ui.card > .content .star.icon:hover {\n    opacity: $card-action-hover-opacity;\n    color: $card-star-color;\n  }\n  .ui.cards > .card > .content .active.star.icon,\n  .ui.card > .content .active.star.icon {\n    color: $card-star-active-color;\n  }\n\n  /*-----Like----- */\n\n  /* Icon */\n  .ui.cards > .card > .content .like.icon,\n  .ui.card > .content .like.icon {\n    cursor: pointer;\n    opacity: $card-action-opacity;\n    transition: $card-action-transition;\n  }\n  .ui.cards > .card > .content .like.icon:hover,\n  .ui.card > .content .like.icon:hover {\n    opacity: $card-action-hover-opacity;\n    color: $card-like-color;\n  }\n  .ui.cards > .card > .content .active.like.icon,\n  .ui.card > .content .active.like.icon {\n    color: $card-like-active-color;\n  }\n\n  /*----------------\n    Extra Content\n  -----------------*/\n\n  .ui.cards > .card > .extra,\n  .ui.card > .extra {\n    max-width: 100%;\n    min-height: 0 !important;\n    flex-grow: 0;\n    border-top: $card-extra-divider !important;\n    position: $card-extra-position;\n    background: $card-extra-background;\n    width: $card-extra-width;\n    margin: $card-extra-margin;\n    padding: $card-extra-padding;\n    top: $card-extra-top;\n    left: $card-extra-left;\n    color: $card-extra-color;\n    box-shadow: $card-extra-box-shadow;\n    transition: $card-extra-transition;\n  }\n  .ui.cards > .card > .extra a:not(.ui),\n  .ui.card > .extra a:not(.ui) {\n    color: $card-extra-link-color;\n  }\n  .ui.cards > .card > .extra a:not(.ui):hover,\n  .ui.card > .extra a:not(.ui):hover {\n    color: $card-extra-link-hover-color;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  /*-------------------\n        Horizontal\n  --------------------*/\n\n  .ui.horizontal.cards > .card,\n  .ui.card.horizontal {\n    flex-direction: row;\n    flex-wrap: wrap;\n    min-width: $card-horizontal-min-width;\n    width: $card-horizontal-width;\n    max-width: 100%;\n  }\n\n  .ui.horizontal.cards > .card > .image,\n  .ui.card.horizontal > .image {\n    border-radius: $default-border-radius 0 0 $default-border-radius;\n    width: $card-horizontal-image-width;\n  }\n\n  .ui.horizontal.cards > .card > .image > img,\n  .ui.card.horizontal > .image > img {\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center;\n    justify-content: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -moz-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    border-radius: $default-border-radius 0 0 $default-border-radius;\n  }\n  .ui.horizontal.cards > .card > .content, .ui.horizontal.card > .content {\n    flex-basis: 1px;\n  }\n  .ui.horizontal.cards > .card > .extra, .ui.horizontal.card > .extra {\n    flex-basis: 100%;\n  }\n\n  /*-------------------\n        Raised\n  --------------------*/\n\n  .ui.raised.cards > .card,\n  .ui.raised.card {\n    box-shadow: $card-raised-shadow;\n  }\n  .ui.raised.cards a.card:hover,\n  .ui.link.cards .raised.card:hover,\n  a.ui.raised.card:hover,\n  .ui.link.raised.card:hover {\n    box-shadow: $card-raised-shadow-hover;\n  }\n\n  /*-------------------\n        Centered\n  --------------------*/\n\n  .ui.centered.cards {\n    justify-content: center;\n  }\n  .ui.centered.card {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  /*-------------------\n          Fluid\n  --------------------*/\n\n  .ui.fluid.card {\n    width: 100%;\n    max-width: 9999px;\n  }\n\n  /*-------------------\n          Link\n  --------------------*/\n\n  .ui.cards a.card,\n  .ui.link.cards .card,\n  a.ui.card,\n  .ui.link.card {\n    transform: none;\n  }\n\n\n  .ui.cards a.card:hover,\n  .ui.link.cards .card:not(.icon):hover,\n  a.ui.card:hover,\n  .ui.link.card:hover {\n    cursor: pointer;\n    z-index: $card-link-hover-z-index;\n    background: $card-link-hover-background;\n    border: $card-link-hover-border;\n    box-shadow: $card-link-hover-box-shadow;\n    transform: $card-link-hover-transform;\n  }\n\n  /*-------------------\n        Colors\n  --------------------*/\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-card-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $h: map-get($value, hover);\n      $l: map-get($value, light);\n      $lh: map-get($value, lightHover);\n\n      .ui.#{$key + \"\"}.cards > .card,\n      .ui.cards > .#{$key + \"\"}.card,\n      .ui.#{$key + \"\"}.card {\n        box-shadow:\n                $card-border-shadow,\n                0 $card-colored-shadow-distance 0 0 $c,\n                $card-shadow-box-shadow\n      ;\n        &:hover {\n        box-shadow:\n                $card-border-shadow,\n                0 $card-colored-shadow-distance 0 0 $h,\n                $card-shadow-hover-box-shadow;\n        }\n      }\n\n      @if($use-card-variation-inverted) {\n        .ui.inverted.#{$key + \"\"}.cards > .card,\n        .ui.inverted.cards > .#{$key + \"\"}.card,\n        .ui.inverted.#{$key + \"\"}.card {\n          box-shadow:\n                  0 $card-shadow-distance 3px 0 $solid-white-border-color,\n                  0 $card-colored-shadow-distance 0 0 $l,\n                  0 0 0 $card-border-width $solid-white-border-color;\n          &:hover {\n          box-shadow:\n                  0 $card-shadow-distance 3px 0 $solid-white-border-color,\n                  0 $card-colored-shadow-distance 0 0 $lh,\n                  0 0 0 $card-border-width $solid-white-border-color;\n          }\n        }\n      }\n    }\n  }\n\n  /*--------------\n    Card Count\n  ---------------*/\n\n  .ui.one.cards {\n    margin-left: $card-one-offset;\n    margin-right: $card-one-offset;\n  }\n  .ui.one.cards > .card {\n    width: $card-one;\n  }\n\n  .ui.two.cards {\n    margin-left: $card-two-offset;\n    margin-right: $card-two-offset;\n  }\n  .ui.two.cards > .card {\n    width: $card-two;\n    margin-left: $card-two-spacing;\n    margin-right: $card-two-spacing;\n  }\n\n  .ui.three.cards {\n    margin-left: $card-three-offset;\n    margin-right: $card-three-offset;\n  }\n  .ui.three.cards > .card {\n    width: $card-three;\n    margin-left: $card-three-spacing;\n    margin-right: $card-three-spacing;\n  }\n\n  .ui.four.cards {\n    margin-left: $card-four-offset;\n    margin-right: $card-four-offset;\n  }\n  .ui.four.cards > .card {\n    width: $card-four;\n    margin-left: $card-four-spacing;\n    margin-right: $card-four-spacing;\n  }\n\n  .ui.five.cards {\n    margin-left: $card-five-offset;\n    margin-right: $card-five-offset;\n  }\n  .ui.five.cards > .card {\n    width: $card-five;\n    margin-left: $card-five-spacing;\n    margin-right: $card-five-spacing;\n  }\n\n  .ui.six.cards {\n    margin-left: $card-six-offset;\n    margin-right: $card-six-offset;\n  }\n  .ui.six.cards > .card {\n    width: $card-six;\n    margin-left: $card-six-spacing;\n    margin-right: $card-six-spacing;\n  }\n\n  .ui.seven.cards {\n    margin-left: $card-seven-offset;\n    margin-right: $card-seven-offset;\n  }\n  .ui.seven.cards > .card {\n    width: $card-seven;\n    margin-left: $card-seven-spacing;\n    margin-right: $card-seven-spacing;\n  }\n\n  .ui.eight.cards {\n    margin-left: $card-eight-offset;\n    margin-right: $card-eight-offset;\n  }\n  .ui.eight.cards > .card {\n    width: $card-eight;\n    margin-left: $card-eight-spacing;\n    margin-right: $card-eight-spacing;\n    font-size: 11px;\n  }\n\n  .ui.nine.cards {\n    margin-left: $card-nine-offset;\n    margin-right: $card-nine-offset;\n  }\n  .ui.nine.cards > .card {\n    width: $card-nine;\n    margin-left: $card-nine-spacing;\n    margin-right: $card-nine-spacing;\n    font-size: 10px;\n  }\n\n  .ui.ten.cards {\n    margin-left: $card-ten-offset;\n    margin-right: $card-ten-offset;\n  }\n  .ui.ten.cards > .card {\n    width: $card-ten;\n    margin-left: $card-ten-spacing;\n    margin-right: $card-ten-spacing;\n  }\n\n\n  /*-------------------\n        Doubling\n  --------------------*/\n\n  /* Mobile Only */\n  @media only screen and (max-width : $largest-mobile-screen) {\n    .ui.two.doubling.cards {\n      margin-left: $card-one-offset;\n      margin-right: $card-one-offset;\n    }\n    .ui.two.doubling.cards > .card {\n      width: $card-one;\n      margin-left: $card-one-spacing;\n      margin-right: $card-one-spacing;\n    }\n    .ui.three.doubling.cards {\n      margin-left: $card-two-offset;\n      margin-right: $card-two-offset;\n    }\n    .ui.three.doubling.cards > .card {\n      width: $card-two;\n      margin-left: $card-two-spacing;\n      margin-right: $card-two-spacing;\n    }\n    .ui.four.doubling.cards {\n      margin-left: $card-two-offset;\n      margin-right: $card-two-offset;\n    }\n    .ui.four.doubling.cards > .card {\n      width: $card-two;\n      margin-left: $card-two-spacing;\n      margin-right: $card-two-spacing;\n    }\n    .ui.five.doubling.cards {\n      margin-left: $card-two-offset;\n      margin-right: $card-two-offset;\n    }\n    .ui.five.doubling.cards > .card {\n      width: $card-two;\n      margin-left: $card-two-spacing;\n      margin-right: $card-two-spacing;\n    }\n    .ui.six.doubling.cards {\n      margin-left: $card-two-offset;\n      margin-right: $card-two-offset;\n    }\n    .ui.six.doubling.cards > .card {\n      width: $card-two;\n      margin-left: $card-two-spacing;\n      margin-right: $card-two-spacing;\n    }\n    .ui.seven.doubling.cards {\n      margin-left: $card-three-offset;\n      margin-right: $card-three-offset;\n    }\n    .ui.seven.doubling.cards > .card {\n      width: $card-three;\n      margin-left: $card-three-spacing;\n      margin-right: $card-three-spacing;\n    }\n    .ui.eight.doubling.cards {\n      margin-left: $card-three-offset;\n      margin-right: $card-three-offset;\n    }\n    .ui.eight.doubling.cards > .card {\n      width: $card-three;\n      margin-left: $card-three-spacing;\n      margin-right: $card-three-spacing;\n    }\n    .ui.nine.doubling.cards {\n      margin-left: $card-three-offset;\n      margin-right: $card-three-offset;\n    }\n    .ui.nine.doubling.cards > .card {\n      width: $card-three;\n      margin-left: $card-three-spacing;\n      margin-right: $card-three-spacing;\n    }\n    .ui.ten.doubling.cards {\n      margin-left: $card-three-offset;\n      margin-right: $card-three-offset;\n    }\n    .ui.ten.doubling.cards > .card {\n      width: $card-three;\n      margin-left: $card-three-spacing;\n      margin-right: $card-three-spacing;\n    }\n  }\n\n  /* Tablet Only */\n  @media only screen and (min-width : $tablet-breakpoint) and (max-width : $largest-tablet-screen) {\n    .ui.two.doubling.cards {\n      margin-left: $card-one-offset;\n      margin-right: $card-one-offset;\n    }\n    .ui.two.doubling.cards > .card {\n      width: $card-one;\n      margin-left: $card-one-spacing;\n      margin-right: $card-one-spacing;\n    }\n    .ui.three.doubling.cards {\n      margin-left: $card-two-offset;\n      margin-right: $card-two-offset;\n    }\n    .ui.three.doubling.cards > .card {\n      width: $card-two;\n      margin-left: $card-two-spacing;\n      margin-right: $card-two-spacing;\n    }\n    .ui.four.doubling.cards {\n      margin-left: $card-two-offset;\n      margin-right: $card-two-offset;\n    }\n    .ui.four.doubling.cards > .card {\n      width: $card-two;\n      margin-left: $card-two-spacing;\n      margin-right: $card-two-spacing;\n    }\n    .ui.five.doubling.cards {\n      margin-left: $card-three-offset;\n      margin-right: $card-three-offset;\n    }\n    .ui.five.doubling.cards > .card {\n      width: $card-three;\n      margin-left: $card-three-spacing;\n      margin-right: $card-three-spacing;\n    }\n    .ui.six.doubling.cards {\n      margin-left: $card-three-offset;\n      margin-right: $card-three-offset;\n    }\n    .ui.six.doubling.cards > .card {\n      width: $card-three;\n      margin-left: $card-three-spacing;\n      margin-right: $card-three-spacing;\n    }\n    .ui.eight.doubling.cards {\n      margin-left: $card-three-offset;\n      margin-right: $card-three-offset;\n    }\n    .ui.eight.doubling.cards > .card {\n      width: $card-three;\n      margin-left: $card-three-spacing;\n      margin-right: $card-three-spacing;\n    }\n    .ui.eight.doubling.cards {\n      margin-left: $card-four-offset;\n      margin-right: $card-four-offset;\n    }\n    .ui.eight.doubling.cards > .card {\n      width: $card-four;\n      margin-left: $card-four-spacing;\n      margin-right: $card-four-spacing;\n    }\n    .ui.nine.doubling.cards {\n      margin-left: $card-four-offset;\n      margin-right: $card-four-offset;\n    }\n    .ui.nine.doubling.cards > .card {\n      width: $card-four;\n      margin-left: $card-four-spacing;\n      margin-right: $card-four-spacing;\n    }\n    .ui.ten.doubling.cards {\n      margin-left: $card-five-offset;\n      margin-right: $card-five-offset;\n    }\n    .ui.ten.doubling.cards > .card {\n      width: $card-five;\n      margin-left: $card-five-spacing;\n      margin-right: $card-five-spacing;\n    }\n  }\n\n  /*-------------------\n        Stackable\n  --------------------*/\n\n  @media only screen and (max-width : $largest-mobile-screen) {\n    .ui.stackable.cards {\n      display: block !important;\n    }\n    .ui.stackable.cards .card:first-child {\n      margin-top: 0 !important;\n    }\n    .ui.stackable.cards > .card {\n      display: block !important;\n      height: auto !important;\n      margin: $card-stackable-row-spacing $card-stackable-spacing;\n      padding: 0 !important;\n      width: $card-stackable-margin !important;\n    }\n  }\n\n  /*--------------\n        Size\n  ---------------*/\n\n  .ui.cards > .card {\n    font-size: $card-medium;\n  }\n\n  @if($use-card-variation-inverted) {\n    /*-----------------\n          Inverted\n    ------------------*/\n\n    .ui.inverted.cards > .card,\n    .ui.inverted.card {\n      background: $card-inverted-background;\n      box-shadow: $card-inverted-box-shadow;\n    }\n\n    /* Content */\n    .ui.inverted.cards > .card > .content,\n    .ui.inverted.card > .content {\n      border-top: $card-inverted-content-divider;\n    }\n\n    /* Header */\n    .ui.inverted.cards > .card > .content > .header,\n    .ui.inverted.card > .content > .header {\n      color: $card-inverted-header-color;\n    }\n\n    /* Description */\n    .ui.inverted.cards > .card > .content > .description,\n    .ui.inverted.card > .content > .description {\n      color: $card-inverted-description-color;\n    }\n\n    /* Meta */\n    .ui.inverted.cards > .card .meta,\n    .ui.inverted.card .meta {\n      color: $card-inverted-meta-color;\n    }\n    .ui.inverted.cards > .card .meta > a:not(.ui),\n    .ui.inverted.card .meta > a:not(.ui) {\n      color: $card-inverted-meta-link-color;\n    }\n    .ui.inverted.cards > .card .meta > a:not(.ui):hover,\n    .ui.inverted.card .meta > a:not(.ui):hover {\n      color: $card-inverted-meta-link-hover-color;\n    }\n\n    /* Extra */\n    .ui.inverted.cards > .card > .extra,\n    .ui.inverted.card > .extra {\n      border-top: $card-inverted-extra-divider !important;\n      color: $card-inverted-extra-color;\n    }\n    .ui.inverted.cards > .card > .extra a:not(.ui),\n    .ui.inverted.card > .extra a:not(.ui) {\n      color: $card-inverted-extra-link-color;\n    }\n    .ui.inverted.cards > .card > .extra a:not(.ui):hover,\n    .ui.inverted.card > .extra a:not(.ui):hover {\n      color: $card-extra-link-hover-color;\n    }\n\n    /* Link card(s) */\n    .ui.inverted.cards a.card:hover,\n    .ui.inverted.link.cards .card:not(.icon):hover,\n    a.inverted.ui.card:hover,\n    .ui.inverted.link.card:hover {\n      background: $card-inverted-link-hover-background;\n    }\n  }\n}\n\n@import '../../themes/default/views/card.style';","@import '../../themes/default/views/comment.variables';\n\n@if $use-comment {\n  /*******************************\n  //@-        Standard\n  *******************************/\n\n\n  /*--------------\n      Comments\n  ---------------*/\n\n  .ui.comments {\n    margin: $comment-super-margin;\n    max-width: $comment-max-width;\n  }\n\n  .ui.comments:first-child {\n    margin-top: 0;\n  }\n  .ui.comments:last-child {\n    margin-bottom: 0;\n  }\n\n  /*--------------\n      Comment\n  ---------------*/\n\n  .ui.comments .comment {\n    position: relative;\n    background: $comment-background;\n    margin: $comment-margin;\n    padding: $comment-padding;\n    border: $comment-border;\n    border-top: $comment-divider;\n    line-height: $comment-line-height;\n  }\n  .ui.comments .comment:first-child {\n    margin-top: $comment-first-margin;\n    padding-top: $comment-first-padding;\n  }\n\n\n  /*--------------------\n      Nested Comments\n  ---------------------*/\n\n  .ui.comments .comment > .comments {\n    margin: $comment-nested-comments-margin;\n    padding: $comment-nested-comments-padding;\n  }\n  .ui.comments .comment > .comments:before{\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n  .ui.comments .comment > .comments .comment {\n    border: $comment-nested-border;\n    border-top: $comment-nested-divider;\n    background: $comment-nested-background;\n  }\n\n  /*--------------\n      Avatar\n  ---------------*/\n\n  .ui.comments .comment .avatar {\n    display: $comment-avatar-display;\n    width: $comment-avatar-width;\n    height: $comment-avatar-height;\n    float: $comment-avatar-float;\n    margin: $comment-avatar-margin;\n  }\n  .ui.comments .comment img.avatar,\n  .ui.comments .comment .avatar img {\n    display: block;\n    margin: 0 auto;\n    width: 100%;\n    height: 100%;\n    border-radius: $comment-avatar-border-radius;\n  }\n\n  /*--------------\n      Content\n  ---------------*/\n\n  .ui.comments .comment > .content {\n    display: block;\n  }\n  /* If there is an avatar move content over */\n  .ui.comments .comment > .avatar ~ .content {\n    margin-left: $comment-content-margin;\n  }\n\n  /*--------------\n      Author\n  ---------------*/\n\n  .ui.comments .comment .author {\n    font-size: $comment-author-font-size;\n    color: $comment-author-color;\n    font-weight: $comment-author-font-weight;\n  }\n  .ui.comments .comment a.author {\n    cursor: pointer;\n  }\n  .ui.comments .comment a.author:hover {\n    color: $comment-author-hover-color;\n  }\n\n  /*--------------\n      Metadata\n  ---------------*/\n\n  .ui.comments .comment .metadata {\n    display: $comment-metadata-display;\n    margin-left: $comment-metadata-spacing;\n    color: $comment-metadata-color;\n    font-size: $comment-metadata-font-size;\n  }\n  .ui.comments .comment .metadata > * {\n    display: inline-block;\n    margin: 0 $comment-metadata-content-spacing 0 0;\n  }\n  .ui.comments .comment .metadata > :last-child {\n    margin-right: 0;\n  }\n\n  /*--------------------\n      Comment Text\n  ---------------------*/\n\n  .ui.comments .comment .text {\n    margin: $comment-text-margin;\n    font-size: $comment-text-font-size;\n    word-wrap: $comment-text-word-wrap;\n    color: $text-color;\n    line-height: $comment-text-line-height;\n  }\n\n\n  /*--------------------\n      User Actions\n  ---------------------*/\n\n  .ui.comments .comment .actions {\n    font-size: $comment-action-font-size;\n  }\n  .ui.comments .comment .actions a {\n    cursor: pointer;\n    display: inline-block;\n    margin: 0 $comment-action-content-distance 0 0;\n    color: $comment-action-link-color;\n  }\n  .ui.comments .comment .actions a:last-child {\n    margin-right: 0;\n  }\n  .ui.comments .comment .actions a.active,\n  .ui.comments .comment .actions a:hover {\n    color: $comment-action-link-hover-color;\n  }\n\n  /*--------------------\n        Reply Form\n  ---------------------*/\n\n  .ui.comments > .reply.form {\n    margin-top: $comment-super-reply-distance;\n  }\n  .ui.comments .comment .reply.form {\n    width: 100%;\n    margin-top: $comment-reply-distance;\n  }\n  .ui.comments .reply.form textarea {\n    font-size: $comment-reply-font-size;\n    height: $comment-reply-height;\n  }\n\n  /*******************************\n              State\n  *******************************/\n\n  .ui.collapsed.comments,\n  .ui.comments .collapsed.comments,\n  .ui.comments .collapsed.comment {\n    display: none;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  /*--------------------\n          Threaded\n  ---------------------*/\n\n  .ui.threaded.comments .comment > .comments {\n    margin: $comment-threaded-margin;\n    padding: $comment-threaded-padding;\n    box-shadow: $comment-threaded-box-shadow;\n  }\n\n  /*--------------------\n          Minimal\n  ---------------------*/\n\n  .ui.minimal.comments .comment .actions {\n    opacity: 0;\n    position: $comment-minimal-action-position;\n    top: $comment-minimal-action-top;\n    right: $comment-minimal-action-right;\n    left: $comment-minimal-action-left;\n    transition: $comment-minimal-transition;\n    transition-delay: $comment-minimal-transition-delay;\n  }\n  .ui.minimal.comments .comment > .content:hover > .actions {\n    opacity: 1;\n  }\n\n\n  /*-------------------\n          Sizes\n  --------------------*/\n\n  .ui.mini.comments {\n    font-size: $mini;\n  }\n  .ui.tiny.comments {\n    font-size: $tiny;\n  }\n  .ui.small.comments {\n    font-size: $small;\n  }\n  .ui.comments {\n    font-size: $medium;\n  }\n  .ui.large.comments {\n    font-size: $large;\n  }\n  .ui.big.comments {\n    font-size: $big;\n  }\n  .ui.huge.comments {\n    font-size: $huge;\n  }\n  .ui.massive.comments {\n    font-size: $massive;\n  }\n\n  @if($use-comment-variation-inverted) {\n    /*-------------------\n            Inverted\n    --------------------*/\n    .ui.inverted.comments .comment {\n      background-color: $black;\n    }\n\n    .ui.inverted.comments .comment .author,\n    .ui.inverted.comments .comment .text {\n      color: $inverted-text-color;\n    }\n\n    .ui.inverted.comments .comment .metadata,\n    .ui.inverted.comments .comment .actions a {\n      color: $inverted-light-text-color;\n    }\n\n    .ui.inverted.comments .comment a.author:hover,\n    .ui.inverted.comments .comment .actions a.active,\n    .ui.inverted.comments .comment .actions a:hover {\n      color: $inverted-hovered-text-color;\n    }\n\n    .ui.inverted.threaded.comments .comment > .comments {\n      box-shadow: -1px 0 0 $solid-white-border-color;\n    }\n  }\n}\n\n@import '../../themes/default/views/comment.style';","@import '../../themes/default/views/feed.variables';\n\n@if $use-feed {\n  /*******************************\n  //@-      Activity Feed\n  *******************************/\n\n  .ui.feed {\n    margin: $feed-margin;\n  }\n  .ui.feed:first-child {\n    margin-top: 0;\n  }\n  .ui.feed:last-child {\n    margin-bottom: 0;\n  }\n\n\n  /*******************************\n              Content\n  *******************************/\n\n  /* Event */\n  .ui.feed > .event {\n    display: flex;\n    flex-direction: row;\n    width: $feed-event-width;\n    padding: $feed-event-padding;\n    margin: $feed-event-margin;\n    background: $feed-event-background;\n    border-top: $feed-event-divider;\n  }\n  .ui.feed > .event:first-child {\n    border-top: 0;\n    padding-top: 0;\n  }\n  .ui.feed > .event:last-child {\n    padding-bottom: 0;\n  }\n\n  /* Event Label */\n  .ui.feed > .event > .label {\n    display: block;\n    flex: 0 0 auto;\n    width: $feed-label-width;\n    height: $feed-label-height;\n    align-self: $feed-label-align-self;\n    text-align: $feed-label-text-align;\n  }\n  .ui.feed > .event > .label .icon {\n    opacity: $feed-icon-label-opacity;\n    font-size: $feed-icon-label-size;\n    width: $feed-icon-label-width;\n    padding: $feed-icon-label-padding;\n    background: $feed-icon-label-background;\n    border: $feed-icon-label-border;\n    border-radius: $feed-icon-label-border-radius;\n    color: $feed-icon-label-color;\n  }\n  .ui.feed > .event > .label img {\n    width: $feed-image-label-width;\n    height: $feed-image-label-height;\n    border-radius: $feed-image-label-border-radius;\n  }\n  .ui.feed > .event > .label + .content {\n    margin: $feed-labeled-content-margin;\n  }\n\n  /*--------------\n      Content\n  ---------------*/\n\n  /* Content */\n  .ui.feed > .event > .content {\n    display: block;\n    flex: 1 1 auto;\n    align-self: $feed-content-align-self;\n    text-align: $feed-content-text-align;\n    word-wrap: $feed-content-word-wrap;\n  }\n  .ui.feed > .event:last-child > .content {\n    padding-bottom: $feed-last-labeled-content-padding;\n  }\n\n  /* Link */\n  .ui.feed > .event > .content a {\n    cursor: pointer;\n  }\n\n  /*--------------\n        Date\n  ---------------*/\n\n  .ui.feed > .event > .content .date {\n    margin: $feed-date-margin;\n    padding: $feed-date-padding;\n    color: $feed-date-color;\n    font-weight: $feed-date-font-weight;\n    font-size: $feed-date-font-size;\n    font-style: $feed-date-font-style;\n  }\n\n  /*--------------\n      Summary\n  ---------------*/\n\n  .ui.feed > .event > .content .summary {\n    margin: $feed-summary-margin;\n    font-size: $feed-summary-font-size;\n    font-weight: $feed-summary-font-weight;\n    color: $feed-summary-color;\n  }\n\n  /* Summary Image */\n  .ui.feed > .event > .content .summary img {\n    display: inline-block;\n    width: $feed-summary-image-width;\n    height: $feed-summary-image-height;\n    margin: $feed-summary-image-margin;\n    border-radius: $feed-summary-image-border-radius;\n    vertical-align: $feed-summary-image-vertical-align;\n  }\n  /*--------------\n        User\n  ---------------*/\n\n  .ui.feed > .event > .content .user {\n    display: inline-block;\n    font-weight: $feed-user-font-weight;\n    margin-right: $feed-user-distance;\n    vertical-align: baseline;\n  }\n  .ui.feed > .event > .content .user img {\n    margin: $feed-user-image-margin;\n    width: $feed-user-image-width;\n    height: $feed-user-image-height;\n    vertical-align: $feed-user-image-vertical-align;\n  }\n  /*--------------\n    Inline Date\n  ---------------*/\n\n  /* Date inside Summary */\n  .ui.feed > .event > .content .summary > .date {\n    display: $feed-summary-date-display;\n    float: $feed-summary-date-float;\n    font-weight: $feed-summary-date-font-weight;\n    font-size: $feed-summary-date-font-size;\n    font-style: $feed-summary-date-font-style;\n    margin: $feed-summary-date-margin;\n    padding: $feed-summary-date-padding;\n    color: $feed-summary-date-color;\n  }\n\n  /*--------------\n    Extra Summary\n  ---------------*/\n\n  .ui.feed > .event > .content .extra {\n    margin: $feed-extra-margin;\n    background: $feed-extra-background;\n    padding: $feed-extra-padding;\n    color: $feed-extra-color;\n  }\n\n  /* Images */\n  .ui.feed > .event > .content .extra.images img {\n    display: inline-block;\n    margin: $feed-extra-image-margin;\n    width: $feed-extra-image-width;\n  }\n\n  /* Text */\n  .ui.feed > .event > .content .extra.text {\n    padding: $feed-extra-text-padding;\n    border-left: $feed-extra-text-pointer;\n    font-size: $feed-extra-text-font-size;\n    max-width: $feed-extra-text-max-width;\n    line-height: $feed-extra-text-line-height;\n  }\n\n  /*--------------\n        Meta\n  ---------------*/\n\n  .ui.feed > .event > .content .meta {\n    display: $feed-metadata-display;\n    font-size: $feed-metadata-font-size;\n    margin: $feed-metadata-margin;\n    background: $feed-metadata-background;\n    border: $feed-metadata-border;\n    border-radius: $feed-metadata-border-radius;\n    box-shadow: $feed-metadata-box-shadow;\n    padding: $feed-metadata-padding;\n    color: $feed-metadata-color;\n  }\n\n  .ui.feed > .event > .content .meta > * {\n    position: relative;\n    margin-left: $feed-metadata-element-spacing;\n  }\n  .ui.feed > .event > .content .meta > *:after {\n    content: $feed-metadata-divider;\n    color: $feed-metadata-divider-color;\n    top: 0;\n    left: $feed-metadata-divider-offset;\n    opacity: 1;\n    position: absolute;\n    vertical-align: top;\n  }\n\n  .ui.feed > .event > .content .meta .like {\n    color: $feed-like-color;\n    transition: $feed-like-transition;\n  }\n  .ui.feed > .event > .content .meta .like:hover .icon {\n    color: $feed-like-hover-color;\n  }\n  .ui.feed > .event > .content .meta .active.like .icon {\n    color: $feed-like-active-color;\n  }\n\n  /* First element */\n  .ui.feed > .event > .content .meta > :first-child {\n    margin-left: 0;\n  }\n  .ui.feed > .event > .content .meta > :first-child::after {\n    display: none;\n  }\n\n  /* Action */\n  .ui.feed > .event > .content .meta a,\n  .ui.feed > .event > .content .meta > .icon {\n    cursor: $feed-metadata-action-cursor;\n    opacity: $feed-metadata-action-opacity;\n    color: $feed-metadata-action-color;\n    transition: $feed-metadata-action-transition;\n  }\n  .ui.feed > .event > .content .meta a:hover,\n  .ui.feed > .event > .content .meta a:hover .icon,\n  .ui.feed > .event > .content .meta > .icon:hover {\n    color: $feed-metadata-action-hover-color;\n  }\n\n\n\n  /*******************************\n              Variations\n  *******************************/\n\n  .ui.small.feed {\n    font-size: $small;\n  }\n  .ui.feed {\n    font-size: $medium;\n  }\n  .ui.large.feed {\n    font-size: $large;\n  }\n\n  @if $use-feed-variation-inverted {\n    /*------------------\n          Inverted\n    -------------------*/\n    \n    .ui.inverted.feed > .event {\n      background: $black;\n    }\n    \n    .ui.inverted.feed > .event > .content .date,\n    .ui.inverted.feed > .event > .content .meta .like {\n      color: $inverted-light-text-color;\n    }\n    \n    .ui.inverted.feed > .event > .content .summary,\n    .ui.inverted.feed > .event > .content .extra.text {\n      color: $inverted-text-color;\n    }\n    \n    .ui.inverted.feed > .event > .content .meta .like:hover {\n      color: $inverted-selected-text-color;\n    }\n  }\n}\n\n@import '../../themes/default/views/feed.style';","@import '../../themes/default/views/item.variables';\n\n@if $use-item {\n  /*******************************\n  //@-        Standard\n  *******************************/\n\n  /*--------------\n        Item\n  ---------------*/\n\n  .ui.items > .item {\n    display: $item-display;\n    margin: $item-spacing 0;\n    width: $item-width;\n    min-height: $item-min-height;\n    background: $item-background;\n    padding: $item-padding;\n\n    border: $item-border;\n    border-radius: $item-border-radius;\n    box-shadow: $item-box-shadow;\n    transition: $item-transition;\n    z-index: $item-z-index;\n  }\n  .ui.items > .item a {\n    cursor: pointer;\n  }\n\n  /*--------------\n        Items\n  ---------------*/\n\n  .ui.items {\n    margin: $item-group-margin;\n  }\n\n  .ui.items:first-child {\n    margin-top: 0 !important;\n  }\n  .ui.items:last-child {\n    margin-bottom: 0 !important;\n  }\n\n  /*--------------\n        Item\n  ---------------*/\n\n  .ui.items > .item:after {\n    display: block;\n    content: ' ';\n    height: 0;\n    clear: both;\n    overflow: hidden;\n    visibility: hidden;\n  }\n  .ui.items > .item:first-child {\n    margin-top: 0;\n  }\n  .ui.items > .item:last-child {\n    margin-bottom: 0;\n  }\n\n\n\n  /*--------------\n      Images\n  ---------------*/\n\n  .ui.items > .item > .image {\n    position: relative;\n    flex: 0 0 auto;\n    display: $item-image-display;\n    float: $item-image-float;\n    margin: $item-image-margin;\n    padding: $item-image-padding;\n    max-height: $item-image-max-height;\n    align-self: $item-image-vertical-align;\n  }\n  .ui.items > .item > .image > img {\n    display: block;\n    width: 100%;\n    height: auto;\n    border-radius: $item-image-border-radius;\n    border: $item-image-border;\n  }\n\n  .ui.items > .item > .image:only-child > img {\n    border-radius: $item-border-radius;\n  }\n\n\n  /*--------------\n      Content\n  ---------------*/\n\n  .ui.items > .item > .content {\n    display: block;\n    flex: 1 1 auto;\n    background: $item-content-background;\n    color: $item-content-color;\n    margin: $item-content-margin;\n    padding: $item-content-padding;\n    box-shadow: $item-content-box-shadow;\n    font-size: $item-content-font-size;\n    border: $item-content-border;\n    border-radius: $item-content-border-radius;\n  }\n  .ui.items > .item > .content:after {\n    display: block;\n    content: ' ';\n    height: 0;\n    clear: both;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n  .ui.items > .item > .image + .content {\n    min-width: 0;\n    width: $item-content-width;\n    display: $item-content-display;\n    margin-left: $item-content-offset;\n    align-self: $item-content-vertical-align;\n    padding-left: $item-content-image-distance;\n  }\n\n  .ui.items > .item > .content > .header {\n    display: inline-block;\n    margin: $item-header-margin;\n    font-family: $header-font;\n    font-weight: $item-header-font-weight;\n    color: $item-header-color;\n  }\n  /* Default Header Size */\n  .ui.items > .item > .content > .header:not(.ui) {\n    font-size: $item-header-font-size;\n  }\n\n  /*--------------\n      Floated\n  ---------------*/\n\n  .ui.items > .item [class*=\"left floated\"] {\n    float: left;\n  }\n  .ui.items > .item [class*=\"right floated\"] {\n    float: right;\n  }\n\n\n  /*--------------\n    Content Image\n  ---------------*/\n\n  .ui.items > .item .content img {\n    align-self: $item-content-image-vertical-align;\n    width: $item-content-image-width;\n  }\n  .ui.items > .item img.avatar,\n  .ui.items > .item .avatar img {\n    width: $item-avatar-size;\n    height: $item-avatar-size;\n    border-radius: $item-avatar-border-radius;\n  }\n\n\n  /*--------------\n    Description\n  ---------------*/\n\n  .ui.items > .item > .content > .description {\n    margin-top: $item-description-distance;\n    max-width: $item-description-max-width;\n    font-size: $item-description-font-size;\n    line-height: $item-description-line-height;\n    color: $item-description-color;\n  }\n\n  /*--------------\n      Paragraph\n  ---------------*/\n\n  .ui.items > .item > .content p {\n    margin: 0 0 $item-paragraph-distance;\n  }\n  .ui.items > .item > .content p:last-child {\n    margin-bottom: 0;\n  }\n\n  /*--------------\n        Meta\n  ---------------*/\n\n  .ui.items > .item .meta {\n    margin: $item-meta-margin;\n    font-size: $item-meta-font-size;\n    line-height: $item-meta-line-height;\n    color: $item-meta-color;\n  }\n  .ui.items > .item .meta * {\n    margin-right: $item-meta-spacing;\n  }\n  .ui.items > .item .meta :last-child {\n    margin-right: 0;\n  }\n\n  .ui.items > .item .meta [class*=\"right floated\"] {\n    margin-right: 0;\n    margin-left: $item-meta-spacing;\n  }\n\n  /*--------------\n        Links\n  ---------------*/\n\n  /* Generic */\n  .ui.items > .item > .content a:not(.ui) {\n    color: $item-content-link-color;\n    transition: $item-content-link-transition;\n  }\n  .ui.items > .item > .content a:not(.ui):hover {\n    color: $item-content-link-hover-color;\n  }\n\n  /* Header */\n  .ui.items > .item > .content > a.header {\n    color: $item-header-link-color;\n  }\n  .ui.items > .item > .content > a.header:hover {\n    color: $item-header-link-hover-color;\n  }\n\n  /* Meta */\n  .ui.items > .item .meta > a:not(.ui) {\n    color: $item-meta-link-color;\n  }\n  .ui.items > .item .meta > a:not(.ui):hover {\n    color: $item-meta-link-hover-color;\n  }\n\n\n\n  /*--------------\n      Labels\n  ---------------*/\n\n  /*-----Star----- */\n\n  /* Icon */\n  .ui.items > .item > .content .favorite.icon {\n    cursor: pointer;\n    opacity: $item-action-opacity;\n    transition: $item-action-transition;\n  }\n  .ui.items > .item > .content .favorite.icon:hover {\n    opacity: $item-action-hover-opacity;\n    color: $item-favorite-color;\n  }\n  .ui.items > .item > .content .active.favorite.icon {\n    color: $item-favorite-active-color;\n  }\n\n  /*-----Like----- */\n\n  /* Icon */\n  .ui.items > .item > .content .like.icon {\n    cursor: pointer;\n    opacity: $item-action-opacity;\n    transition: $item-action-transition;\n  }\n  .ui.items > .item > .content .like.icon:hover {\n    opacity: $item-action-hover-opacity;\n    color: $item-like-color;\n  }\n  .ui.items > .item > .content .active.like.icon {\n    color: $item-like-active-color;\n  }\n\n  /*----------------\n    Extra Content\n  -----------------*/\n\n  .ui.items > .item .extra {\n    display: $item-extra-display;\n    position: $item-extra-position;\n    background: $item-extra-background;\n    margin: $item-extra-margin;\n    width: $item-extra-width;\n    padding: $item-extra-padding;\n    top: $item-extra-top;\n    left: $item-extra-left;\n    color: $item-extra-color;\n    box-shadow: $item-extra-box-shadow;\n    transition: $item-extra-transition;\n    border-top: $item-extra-divider;\n  }\n  .ui.items > .item .extra > * {\n    margin: ($item-extra-row-spacing / 2) $item-extra-horizontal-spacing ($item-extra-row-spacing / 2) 0;\n  }\n  .ui.items > .item .extra > [class*=\"right floated\"] {\n    margin: ($item-extra-row-spacing / 2) 0 ($item-extra-row-spacing / 2) $item-extra-horizontal-spacing;\n  }\n\n  .ui.items > .item .extra:after {\n    display: block;\n    content: ' ';\n    height: 0;\n    clear: both;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n\n  /*******************************\n            Responsive\n  *******************************/\n\n  /* Default Image Width */\n  .ui.items > .item > .image:not(.ui) {\n    width: $item-image-width;\n  }\n\n\n  /* Tablet Only */\n  @media only screen and (min-width: $tablet-breakpoint) and (max-width: $largest-tablet-screen) {\n    .ui.items > .item {\n      margin: $item-tablet-spacing 0;\n    }\n    .ui.items > .item > .image:not(.ui) {\n      width: $item-tablet-image-width;\n    }\n    .ui.items > .item > .image + .content {\n      display: block;\n      padding: 0 0 0 $item-tablet-content-image-distance;\n    }\n\n  }\n\n  /* Mobile Only */\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.items:not(.unstackable) > .item {\n      flex-direction: column;\n      margin: $item-mobile-spacing 0;\n    }\n    .ui.items:not(.unstackable) > .item > .image {\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n    }\n    .ui.items:not(.unstackable) > .item > .image,\n    .ui.items:not(.unstackable) > .item > .image > img {\n      max-width: 100% !important;\n      width: $item-mobile-image-width !important;\n      max-height: $item-mobile-image-max-height !important;\n    }\n    .ui.items:not(.unstackable) > .item > .image + .content {\n      display: block;\n      padding: $item-mobile-content-image-distance 0 0;\n    }\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n\n  /*-------------------\n        Aligned\n  --------------------*/\n\n  .ui.items > .item > .image + [class*=\"top aligned\"].content {\n    align-self: flex-start;\n  }\n  .ui.items > .item > .image + [class*=\"middle aligned\"].content {\n    align-self: center;\n  }\n  .ui.items > .item > .image + [class*=\"bottom aligned\"].content {\n    align-self: flex-end;\n  }\n\n\n  /*--------------\n      Relaxed\n  ---------------*/\n\n  .ui.relaxed.items > .item {\n    margin: $item-relaxed-spacing 0;\n  }\n  .ui[class*=\"very relaxed\"].items > .item {\n    margin: $item-very-relaxed-spacing 0;\n  }\n\n\n  /*-------------------\n        Divided\n  --------------------*/\n\n  .ui.divided.items > .item {\n    border-top: $item-divided-border;\n    margin: $item-divided-margin;\n    padding: $item-divided-padding;\n  }\n  .ui.divided.items > .item:first-child {\n    border-top: none;\n    margin-top: $item-divided-first-last-margin !important;\n    padding-top: $item-divided-first-last-padding !important;\n  }\n  .ui.divided.items > .item:last-child {\n    margin-bottom: $item-divided-first-last-margin !important;\n    padding-bottom: $item-divided-first-last-padding !important;\n  }\n\n  /* Relaxed Divided */\n  .ui.relaxed.divided.items > .item {\n    margin: 0;\n    padding: $item-relaxed-spacing 0;\n  }\n  .ui[class*=\"very relaxed\"].divided.items > .item {\n    margin: 0;\n    padding: $item-very-relaxed-spacing 0;\n  }\n\n\n  /*-------------------\n          Link\n  --------------------*/\n\n  .ui.items a.item:hover,\n  .ui.link.items > .item:hover {\n    cursor: pointer;\n  }\n\n  .ui.items a.item:hover .content .header,\n  .ui.link.items > .item:hover .content .header {\n    color: $item-header-link-hover-color;\n  }\n\n\n  /*--------------\n        Size\n  ---------------*/\n\n  .ui.items > .item {\n    font-size: $relative-medium;\n  }\n\n  /*---------------\n    Unstackable\n  ----------------*/\n\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.unstackable.items > .item > .image,\n    .ui.unstackable.items > .item > .image > img {\n      width: $item-unstackable-mobile-image-width !important;\n    }\n  }\n\n\n  @if($use-item-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n    \n    .ui.inverted.items > .item {\n      background: $item-inverted-background;\n    }\n    .ui.inverted.items > .item > .content {\n      background: $item-inverted-content-background;\n      color: $item-inverted-content-color;\n    }\n    .ui.inverted.items > .item .extra {\n      background: $item-inverted-extra-background;\n    }\n    .ui.inverted.items > .item > .content > .header {\n      color: $item-inverted-header-color;\n    }\n    .ui.inverted.items > .item > .content > .description {\n      color: $item-inverted-description-color;\n    }\n    .ui.inverted.items > .item .meta {\n      color: $item-inverted-meta-color;\n    }\n    .ui.inverted.items > .item > .content a:not(.ui) {\n      color: $item-inverted-content-link-color;\n    }\n    .ui.inverted.items > .item > .content a:not(.ui):hover {\n      color: $item-inverted-content-link-hover-color;\n    }\n    .ui.inverted.items > .item > .content > a.header {\n      color: $item-inverted-header-link-color;\n    }\n    .ui.inverted.items > .item > .content > a.header:hover {\n      color: $item-inverted-header-link-hover-color;\n    }\n    .ui.inverted.items > .item .meta > a:not(.ui) {\n      color: $item-inverted-meta-link-color;\n    }\n    .ui.inverted.items > .item .meta > a:not(.ui):hover {\n      color: $item-inverted-meta-link-hover-color;\n    }\n    .ui.inverted.items > .item > .content .favorite.icon:hover {\n      color: $item-inverted-favorite-color;\n    }\n    .ui.inverted.items > .item > .content .active.favorite.icon {\n      color: $item-inverted-favorite-active-color;\n    }\n    .ui.inverted.items > .item > .content .like.icon:hover {\n      color: $item-inverted-like-color;\n    }\n    .ui.inverted.items > .item > .content .active.like.icon {\n      color: $item-inverted-like-active-color;\n    }\n    .ui.inverted.items > .item .extra {\n      color: $item-inverted-extra-color;\n    }\n    .ui.inverted.items a.item:hover .content .header,\n    .ui.inverted.link.items > .item:hover .content .header {\n      color: $item-inverted-header-link-hover-color;\n    }\n    .ui.inverted.divided.items > .item {\n      border-top: $item-inverted-divided-border;\n    }\n    .ui.inverted.divided.items > .item:first-child {\n      border-top: none;\n    }\n  }\n}\n\n@import '../../themes/default/views/item.style';","@import '../../themes/default/views/statistic.variables';\n\n@if $use-statistic {\n  /*******************************\n  //@-       Statistic\n  *******************************/\n\n  /* Standalone */\n  .ui.statistic {\n    display: inline-flex;\n    flex-direction: column;\n    margin: $statistic-margin;\n    max-width: $statistic-max-width;\n  }\n\n  .ui.statistic + .ui.statistic {\n    margin: 0 0 0 $statistic-horizontal-spacing;\n  }\n\n  .ui.statistic:first-child {\n    margin-top: 0;\n  }\n  .ui.statistic:last-child {\n    margin-bottom: 0;\n  }\n\n\n\n  /*******************************\n              Group\n  *******************************/\n\n  /* Grouped */\n  .ui.statistics {\n    display: flex;\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n  .ui.statistics > .statistic {\n    display: inline-flex;\n    flex: 0 1 auto;\n    flex-direction: column;\n    margin: $statistic-element-margin;\n    max-width: $statistic-element-max-width;\n  }\n  .ui.statistics {\n    display: flex;\n    margin: $statistic-group-margin;\n  }\n\n  /* Clearing */\n  .ui.statistics:after {\n    display: block;\n    content: ' ';\n    height: 0;\n    clear: both;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n  .ui.statistics:first-child {\n    margin-top: 0;\n  }\n\n\n  /*******************************\n              Content\n  *******************************/\n\n\n  /*--------------\n        Value\n  ---------------*/\n\n  .ui.statistics .statistic > .value,\n  .ui.statistic > .value {\n    font-family: $statistic-value-font;\n    font-size: $statistic-value-size;\n    font-weight: $statistic-value-font-weight;\n    line-height: $statistic-value-line-height;\n    color: $statistic-value-color;\n    text-transform: $statistic-value-text-transform;\n    text-align: $statistic-text-align;\n  }\n\n  /*--------------\n      Label\n  ---------------*/\n\n  .ui.statistics .statistic > .label,\n  .ui.statistic > .label {\n    font-family: $statistic-label-font;\n    font-size: $statistic-label-size;\n    font-weight: $statistic-label-font-weight;\n    color: $statistic-label-color;\n    text-transform: $statistic-label-text-transform;\n    text-align: $statistic-text-align;\n  }\n\n  /* Top Label */\n  .ui.statistics .statistic > .label ~ .value,\n  .ui.statistic > .label ~ .value {\n    margin-top: $statistic-top-label-distance;\n  }\n\n  /* Bottom Label */\n  .ui.statistics .statistic > .value ~ .label,\n  .ui.statistic > .value ~ .label {\n    margin-top: $statistic-bottom-label-distance;\n  }\n\n\n\n  /*******************************\n              Types\n  *******************************/\n\n  /*--------------\n    Icon Value\n  ---------------*/\n\n  .ui.statistics .statistic > .value .icon,\n  .ui.statistic > .value .icon {\n    opacity: 1;\n    width: auto;\n    margin: 0;\n  }\n\n  /*--------------\n    Text Value\n  ---------------*/\n\n  .ui.statistics .statistic > .text.value,\n  .ui.statistic > .text.value {\n    line-height: $statistic-text-value-line-height;\n    min-height: $statistic-text-value-min-height;\n    font-weight: $statistic-text-value-font-weight;\n    text-align: center;\n  }\n  .ui.statistics .statistic > .text.value + .label,\n  .ui.statistic > .text.value + .label {\n    text-align: center;\n  }\n\n  /*--------------\n    Image Value\n  ---------------*/\n\n  .ui.statistics .statistic > .value img,\n  .ui.statistic > .value img {\n    max-height: $statistic-image-height;\n    vertical-align: $statistic-image-vertical-align;\n  }\n\n\n\n  /*******************************\n              Variations\n  *******************************/\n\n\n  /*--------------\n        Count\n  ---------------*/\n\n\n  .ui.ten.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.ten.statistics .statistic {\n    min-width: $ten-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.nine.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.nine.statistics .statistic {\n    min-width: $nine-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.eight.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.eight.statistics .statistic {\n    min-width: $eight-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.seven.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.seven.statistics .statistic {\n    min-width: $seven-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.six.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.six.statistics .statistic {\n    min-width: $six-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.five.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.five.statistics .statistic {\n    min-width: $five-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.four.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.four.statistics .statistic {\n    min-width: $four-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.three.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.three.statistics .statistic {\n    min-width: $three-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.two.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.two.statistics .statistic {\n    min-width: $two-column;\n    margin: $statistic-item-margin;\n  }\n\n  .ui.one.statistics {\n    margin: $statistic-item-group-margin;\n  }\n  .ui.one.statistics .statistic {\n    min-width: $one-column;\n    margin: $statistic-item-margin;\n  }\n\n\n\n\n  /*--------------\n    Horizontal\n  ---------------*/\n\n  .ui.horizontal.statistic {\n    flex-direction: row;\n    align-items: center;\n  }\n  .ui.horizontal.statistics {\n    flex-direction: column;\n    margin: 0;\n    max-width: none;\n  }\n  .ui.horizontal.statistics .statistic {\n    flex-direction: row;\n    align-items: center;\n    max-width: none;\n    margin: $statistic-horizontal-group-element-margin;\n  }\n\n  .ui.horizontal.statistic > .text.value,\n  .ui.horizontal.statistics > .statistic > .text.value {\n    min-height: 0 !important;\n  }\n  .ui.horizontal.statistics .statistic > .value .icon,\n  .ui.horizontal.statistic > .value .icon {\n    width: $icon-width;\n  }\n\n  .ui.horizontal.statistics .statistic > .value,\n  .ui.horizontal.statistic > .value {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .ui.horizontal.statistics .statistic > .label,\n  .ui.horizontal.statistic > .label {\n    display: inline-block;\n    vertical-align: middle;\n    margin: 0 0 0 $statistic-horizontal-label-distance;\n  }\n\n  @if($use-statistic-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n\n    .ui.inverted.statistics .statistic > .value,\n    .ui.inverted.statistic .value {\n      color: $statistic-inverted-value-color;\n    }\n    .ui.inverted.statistics .statistic > .label,\n    .ui.inverted.statistic .label {\n      color: $statistic-inverted-label-color;\n    }\n  }\n\n\n  /*--------------\n      Colors\n  ---------------*/\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-statistic-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $l: map-get($value, light);\n\n      .ui.#{$key + \"\"}.statistics .statistic > .value,\n      .ui.statistics .#{$key + \"\"}.statistic > .value,\n      .ui.#{$key + \"\"}.statistic > .value {\n        color: $c;\n      }\n      @if($use-statistic-variation-inverted) {\n        .ui.inverted.#{$key + \"\"}.statistics .statistic > .value,\n        .ui.statistics .inverted.#{$key + \"\"}.statistic > .value,\n        .ui.inverted.#{$key + \"\"}.statistic > .value {\n          color: $l;\n        }\n      }\n    }\n  }\n\n  /*--------------\n      Floated\n  ---------------*/\n\n  .ui[class*=\"left floated\"].statistic {\n    float: left;\n    margin: $statistic-left-floated-margin;\n  }\n  .ui[class*=\"right floated\"].statistic {\n    float: right;\n    margin: $statistic-right-floated-margin;\n  }\n  .ui.floated.statistic:last-child {\n    margin-bottom: 0;\n  }\n\n  /*--------------\n      Stackable\n  ---------------*/\n\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.stackable.statistics {\n      width: auto;\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n    }\n    .ui.stackable.statistics > .statistic {\n      width: 100% !important;\n      margin: 0 0 !important;\n      padding: ($statistic-stackable-row-spacing / 2) ($statistic-stackable-gutter / 2) !important;\n    }\n  }\n\n\n  /*--------------\n      Sizes\n  ---------------*/\n\n\n  /* Mini */\n  .ui.mini.statistics .statistic > .value,\n  .ui.mini.statistic > .value {\n    font-size: $statistic-mini-value-size !important;\n  }\n  .ui.mini.horizontal.statistics .statistic > .value,\n  .ui.mini.horizontal.statistic > .value {\n    font-size: $statistic-mini-horizontal-value-size !important;\n  }\n  .ui.mini.statistics .statistic > .text.value,\n  .ui.mini.statistic > .text.value {\n    font-size: $statistic-mini-text-value-size !important;\n  }\n\n\n  /* Tiny */\n  .ui.tiny.statistics .statistic > .value,\n  .ui.tiny.statistic > .value {\n    font-size: $statistic-tiny-value-size !important;\n  }\n  .ui.tiny.horizontal.statistics .statistic > .value,\n  .ui.tiny.horizontal.statistic > .value {\n    font-size: $statistic-tiny-horizontal-value-size !important;\n  }\n  .ui.tiny.statistics .statistic > .text.value,\n  .ui.tiny.statistic > .text.value {\n    font-size: $statistic-tiny-text-value-size !important;\n  }\n\n  /* Small */\n  .ui.small.statistics .statistic > .value,\n  .ui.small.statistic > .value {\n    font-size: $statistic-small-value-size !important;\n  }\n  .ui.small.horizontal.statistics .statistic > .value,\n  .ui.small.horizontal.statistic > .value {\n    font-size: $statistic-small-horizontal-value-size !important;\n  }\n  .ui.small.statistics .statistic > .text.value,\n  .ui.small.statistic > .text.value {\n    font-size: $statistic-small-text-value-size !important;\n  }\n\n  /* Medium */\n  .ui.statistics .statistic > .value,\n  .ui.statistic > .value {\n    font-size: $statistic-value-size !important;\n  }\n  .ui.horizontal.statistics .statistic > .value,\n  .ui.horizontal.statistic > .value {\n    font-size: $statistic-horizontal-value-size !important;\n  }\n  .ui.statistics .statistic > .text.value,\n  .ui.statistic > .text.value {\n    font-size: $statistic-text-value-size !important;\n  }\n\n  /* Large */\n  .ui.large.statistics .statistic > .value,\n  .ui.large.statistic > .value {\n    font-size: $statistic-large-value-size !important;\n  }\n  .ui.large.horizontal.statistics .statistic > .value,\n  .ui.large.horizontal.statistic > .value {\n    font-size: $statistic-large-horizontal-value-size !important;\n  }\n  .ui.large.statistics .statistic > .text.value,\n  .ui.large.statistic > .text.value {\n    font-size: $statistic-large-text-value-size !important;\n  }\n\n  /* Huge */\n  .ui.huge.statistics .statistic > .value,\n  .ui.huge.statistic > .value {\n    font-size: $statistic-huge-value-size !important;\n  }\n  .ui.huge.horizontal.statistics .statistic > .value,\n  .ui.huge.horizontal.statistic > .value {\n    font-size: $statistic-huge-horizontal-value-size !important;\n  }\n  .ui.huge.statistics .statistic > .text.value,\n  .ui.huge.statistic > .text.value {\n    font-size: $statistic-huge-text-value-size !important;\n  }\n}\n\n@import '../../themes/default/views/statistic.style';","@import '../../themes/default/modules/accordion.variables';\r\n\r\n@if $use-accordion {\r\n  /*******************************\r\n  //@-        Accordion\r\n  *******************************/\r\n\r\n  .ui.accordion,\r\n  .ui.accordion .accordion {\r\n    max-width: 100%;\r\n  }\r\n  .ui.accordion .accordion {\r\n    margin: $accordion-child-margin;\r\n    padding: $accordion-child-padding;\r\n  }\r\n\r\n  /* Title */\r\n  .ui.accordion .title,\r\n  .ui.accordion .accordion .title {\r\n    cursor: pointer;\r\n  }\r\n\r\n  /* Default Styling */\r\n  .ui.accordion .title:not(.ui) {\r\n    padding: $accordion-title-padding;\r\n    font-family: $accordion-title-font;\r\n    font-size: $accordion-title-font-size;\r\n    color: $accordion-title-color;\r\n  }\r\n\r\n  /* Default Styling */\r\n  .ui.accordion:not(.styled) .title ~ .content:not(.ui),\r\n  .ui.accordion:not(.styled) .accordion .title ~ .content:not(.ui) {\r\n    margin: $accordion-content-margin;\r\n    padding: $accordion-content-padding;\r\n  }\r\n  .ui.accordion:not(.styled) .title ~ .content:not(.ui):last-child {\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  /* Arrow */\r\n  .ui.accordion .title .dropdown.icon,\r\n  .ui.accordion .accordion .title .dropdown.icon {\r\n    display: $accordion-icon-display;\r\n    float: $accordion-icon-float;\r\n    opacity: $accordion-icon-opacity;\r\n    width: $accordion-icon-width;\r\n    height: $accordion-icon-height;\r\n    margin: $accordion-icon-margin;\r\n    padding: $accordion-icon-padding;\r\n    font-size: $accordion-icon-font-size;\r\n    transition: $accordion-icon-transition;\r\n    vertical-align: $accordion-icon-vertical-align;\r\n    transform: $accordion-icon-transform;\r\n  }\r\n\r\n  /*--------------\r\n      Coupling\r\n  ---------------*/\r\n\r\n  /* Menu */\r\n  .ui.accordion.menu .item .title {\r\n    display: block;\r\n    padding: $accordion-menu-title-padding;\r\n  }\r\n  .ui.accordion.menu .item .title > .dropdown.icon {\r\n    float: $accordion-menu-icon-float;\r\n    margin: $accordion-menu-icon-margin;\r\n    transform: $accordion-menu-icon-transform;\r\n  }\r\n\r\n  /* Header */\r\n  .ui.accordion .ui.header .dropdown.icon {\r\n    font-size: $accordion-icon-font-size;\r\n    margin: $accordion-icon-margin;\r\n  }\r\n\r\n  /*******************************\r\n              States\r\n  *******************************/\r\n\r\n  .ui.accordion .active.title .dropdown.icon,\r\n  .ui.accordion .accordion .active.title .dropdown.icon {\r\n    transform: $accordion-active-icon-transform;\r\n  }\r\n\r\n  .ui.accordion.menu .item .active.title > .dropdown.icon {\r\n    transform: $accordion-active-icon-transform;\r\n  }\r\n\r\n  /*******************************\r\n              Types\r\n  *******************************/\r\n\r\n  /*--------------\r\n      Styled\r\n  ---------------*/\r\n\r\n  .ui.styled.accordion {\r\n    width: $accordion-styled-width;\r\n  }\r\n\r\n  .ui.styled.accordion,\r\n  .ui.styled.accordion .accordion {\r\n    border-radius: $accordion-styled-border-radius;\r\n    background: $accordion-styled-background;\r\n    box-shadow: $accordion-styled-box-shadow;\r\n  }\r\n  .ui.styled.accordion .title,\r\n  .ui.styled.accordion .accordion .title {\r\n    margin: $accordion-styled-title-margin;\r\n    padding: $accordion-styled-title-padding;\r\n    color: $accordion-styled-title-color;\r\n    font-weight: $accordion-styled-title-font-weight;\r\n    border-top: $accordion-styled-title-border;\r\n    transition: $accordion-styled-title-transition;\r\n  }\r\n  .ui.styled.accordion > .title:first-child,\r\n  .ui.styled.accordion .accordion .title:first-child {\r\n    border-top: none;\r\n  }\r\n\r\n\r\n  /* Content */\r\n  .ui.styled.accordion .content,\r\n  .ui.styled.accordion .accordion .content {\r\n    margin: $accordion-styled-content-margin;\r\n    padding: $accordion-styled-content-padding;\r\n  }\r\n  .ui.styled.accordion .accordion .content {\r\n    margin: $accordion-styled-child-content-margin;\r\n    padding: $accordion-styled-child-content-padding;\r\n  }\r\n\r\n\r\n  /* Hover */\r\n  .ui.styled.accordion .title:hover,\r\n  .ui.styled.accordion .active.title,\r\n  .ui.styled.accordion .accordion .title:hover,\r\n  .ui.styled.accordion .accordion .active.title {\r\n    background: $accordion-styled-title-hover-background;\r\n    color: $accordion-styled-title-hover-color;\r\n  }\r\n  .ui.styled.accordion .accordion .title:hover,\r\n  .ui.styled.accordion .accordion .active.title {\r\n    background: $accordion-styled-hover-child-title-background;\r\n    color: $accordion-styled-hover-child-title-color;\r\n  }\r\n\r\n\r\n  /* Active */\r\n  .ui.styled.accordion .active.title {\r\n    background: $accordion-styled-active-title-background;\r\n    color: $accordion-styled-active-title-color;\r\n  }\r\n  .ui.styled.accordion .accordion .active.title {\r\n    background: $accordion-styled-active-child-title-background;\r\n    color: $accordion-styled-active-child-title-color;\r\n  }\r\n\r\n\r\n  /*******************************\r\n              States\r\n  *******************************/\r\n\r\n  /*--------------\r\n    Not Active\r\n  ---------------*/\r\n\r\n  .ui.accordion .title ~ .content:not(.active),\r\n  .ui.accordion .accordion .title ~ .content:not(.active) {\r\n    display: none;\r\n  }\r\n\r\n  /*******************************\r\n            Variations\r\n  *******************************/\r\n\r\n  /*--------------\r\n      Fluid\r\n  ---------------*/\r\n\r\n  .ui.fluid.accordion,\r\n  .ui.fluid.accordion .accordion {\r\n    width: 100%;\r\n  }\r\n\r\n  @if($use-accordion-variation-inverted) {\r\n    /*--------------\r\n        Inverted\r\n    ---------------*/\r\n    \r\n    .ui.inverted.accordion .title:not(.ui) {\r\n      color: $accordion-inverted-title-color;\r\n    }\r\n  }\r\n}\r\n\r\n@import '../../themes/default/modules/accordion.style';","@if $use-accordion {\n  @font-face {\n    font-family: 'Accordion';\n    src:\n      url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfOIKAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zryj6HgAAAFwAAAAyGhlYWT/0IhHAAACOAAAADZoaGVhApkB5wAAAnAAAAAkaG10eAJuABIAAAKUAAAAGGxvY2EAjABWAAACrAAAAA5tYXhwAAgAFgAAArwAAAAgbmFtZfC1n04AAALcAAABPHBvc3QAAwAAAAAEGAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQASAEkAtwFuABMAADc0PwE2FzYXFh0BFAcGJwYvASY1EgaABQgHBQYGBQcIBYAG2wcGfwcBAQcECf8IBAcBAQd/BgYAAAAAAQAAAEkApQFuABMAADcRNDc2MzIfARYVFA8BBiMiJyY1AAUGBwgFgAYGgAUIBwYFWwEACAUGBoAFCAcFgAYGBQcAAAABAAAAAQAAqWYls18PPPUACwIAAAAAAM/9o+4AAAAAz/2j7gAAAAAAtwFuAAAACAACAAAAAAAAAAEAAAHg/+AAAAIAAAAAAAC3AAEAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAQAAAAC3ABIAtwAAAAAAAAAKABQAHgBCAGQAAAABAAAABgAUAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype'),\n      url(data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAASwAAoAAAAABGgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAS0AAAEtFpovuE9TLzIAAAIkAAAAYAAAAGAIIweQY21hcAAAAoQAAABMAAAATA984gpnYXNwAAAC0AAAAAgAAAAIAAAAEGhlYWQAAALYAAAANgAAADb/0IhHaGhlYQAAAxAAAAAkAAAAJAKZAedobXR4AAADNAAAABgAAAAYAm4AEm1heHAAAANMAAAABgAAAAYABlAAbmFtZQAAA1QAAAE8AAABPPC1n05wb3N0AAAEkAAAACAAAAAgAAMAAAEABAQAAQEBB3JhdGluZwABAgABADr4HAL4GwP4GAQeCgAZU/+Lix4KABlT/4uLDAeLa/iU+HQFHQAAAHkPHQAAAH4RHQAAAAkdAAABJBIABwEBBw0PERQZHnJhdGluZ3JhdGluZ3UwdTF1MjB1RjBEOXVGMERBAAACAYkABAAGAQEEBwoNVp38lA78lA78lA77lA773Z33bxWLkI2Qj44I9xT3FAWOj5CNkIuQi4+JjoePiI2Gi4YIi/uUBYuGiYeHiIiHh4mGi4aLho2Ijwj7FPcUBYeOiY+LkAgO+92L5hWL95QFi5CNkI6Oj4+PjZCLkIuQiY6HCPcU+xQFj4iNhouGi4aJh4eICPsU+xQFiIeGiYaLhouHjYePiI6Jj4uQCA74lBT4lBWLDAoAAAAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAEAADfYOJZfDzz1AAsCAAAAAADP/aPuAAAAAM/9o+4AAAAAALcBbgAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAAAtwABAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAEAAAAAtwASALcAAAAAUAAABgAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('woff')\n    ;\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  /* Dropdown Icon */\n  .ui.accordion .title .dropdown.icon,\n  .ui.accordion .accordion .title .dropdown.icon {\n    font-family: Accordion;\n    line-height: 1;\n    backface-visibility: hidden;\n    font-weight: normal;\n    font-style: normal;\n    text-align: center;\n  }\n\n  .ui.accordion .title .dropdown.icon:before,\n  .ui.accordion .accordion .title .dropdown.icon:before {\n    content: '\\f0da'/*rtl:'\\f0d9'*/;\n  }\n}","@import '../../themes/default/modules/calendar.variables';\n\n@if $use-calendar {\n  /*******************************\n  //@-        Popup\n  *******************************/\n\n  .ui.calendar .ui.popup {\n    max-width: none;\n    padding: 0;\n    border: none;\n    user-select: none;\n  }\n\n  /*******************************\n              Calendar\n  *******************************/\n\n  .ui.calendar .calendar:focus {\n    outline: 0;\n  }\n\n  /*******************************\n              Grid\n  *******************************/\n\n  .ui.calendar .ui.popup .ui.grid {\n    display: block;\n    white-space: nowrap;\n  }\n\n  .ui.calendar .ui.popup .ui.grid > .column {\n    width: auto;\n  }\n\n  /*******************************\n              Table\n  *******************************/\n\n  .ui.calendar .ui.table.year,\n  .ui.calendar .ui.table.month,\n  .ui.calendar .ui.table.minute {\n    min-width: 15em;\n  }\n\n  .ui.calendar .ui.table.day {\n    min-width: 18em;\n  }\n\n  .ui.calendar .ui.table.day.andweek {\n    min-width: 22em;\n  }\n\n  .ui.calendar .ui.table.hour {\n    min-width: 20em;\n  }\n\n  .ui.calendar .ui.table tr th,\n  .ui.calendar .ui.table tr td {\n    padding: 0.5em;\n    white-space: nowrap;\n  }\n\n  .ui.calendar .ui.table tr th {\n    border-left: none;\n  }\n\n  .ui.calendar .ui.table tr th .icon {\n    margin: 0;\n  }\n\n  .ui.calendar .ui.table tr:first-child th {\n    position: relative;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .ui.calendar .ui.table.day tr:first-child th {\n    border: none;\n  }\n\n  .ui.calendar .ui.table.day tr:nth-child(2) th {\n    padding-top: 0.2em;\n    padding-bottom: 0.3em;\n  }\n\n  .ui.calendar .ui.table tr td {\n    padding-left: 0.1em;\n    padding-right: 0.1em;\n  }\n\n  .ui.calendar .ui.table tr .link {\n    cursor: pointer;\n  }\n\n  .ui.calendar .ui.table tr .prev.link {\n    width: 14.28571429%;\n    position: absolute;\n    left: 0;\n  }\n\n  .ui.calendar .ui.table tr .next.link {\n    width: 14.28571429%;\n    position: absolute;\n    right: 0;\n  }\n\n  .ui.calendar .ui.table tr .disabled {\n    pointer-events: auto;\n    cursor: default;\n    color: $disabled-text-color;\n  }\n\n  .ui.calendar .ui.table tr .adjacent:not(.disabled) {\n    color: $calendar-adjacent-text-color;\n    background: $calendar-adjacent-background;\n  }\n\n  /*--------------\n      States\n  ---------------*/\n\n  .ui.calendar .ui.table tr td.today {\n    font-weight: $calendar-today-font-weight;\n  }\n\n  .ui.calendar .ui.table tr td.range {\n    background: $calendar-range-background;\n    color: $calendar-range-text-color;\n    box-shadow: $calendar-range-box-shadow;\n  }\n\n  .ui.calendar .ui.table.inverted tr td.range {\n    background: $calendar-range-inverted-background;\n    color: $calendar-range-inverted-text-color;\n    box-shadow: $calendar-range-inverted-box-shadow;\n  }\n\n  .ui.calendar:not(.disabled) .calendar:focus .ui.table tbody tr td.focus,\n  .ui.calendar:not(.disabled) .calendar.active .ui.table tbody tr td.focus {\n    box-shadow: $calendar-focus-box-shadow;\n  }\n\n  .ui.calendar:not(.disabled) .calendar:focus .ui.table.inverted tbody tr td.focus,\n  .ui.calendar:not(.disabled) .calendar.active .ui.table.inverted tbody tr td.focus {\n    box-shadow: $calendar-focus-inverted-box-shadow;\n  }\n\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------------\n          Disabled\n  ---------------------*/\n\n  .ui.disabled.calendar {\n    opacity: $disabled-opacity;\n  }\n\n  .ui.disabled.calendar > .input,\n  .ui.disabled.calendar .ui.table tr .link {\n    pointer-events: none;\n  }\n}\n\n@import '../../themes/default/modules/calendar.style';","@import '../../themes/default/modules/checkbox.variables';\n\n@if $use-checkbox {\n  /*******************************\n  //@-       Checkbox\n  *******************************/\n\n\n  /*--------------\n      Content\n  ---------------*/\n\n  .ui.checkbox {\n    position: relative;\n    display: inline-block;\n    backface-visibility: hidden;\n    outline: none;\n    vertical-align: baseline;\n    font-style: normal;\n\n    min-height: $checkbox-size;\n    font-size: $relative-medium;\n    line-height: $checkbox-line-height;\n    min-width: $checkbox-size;\n  }\n\n  /* HTML Checkbox */\n  .ui.checkbox input[type=\"checkbox\"],\n  .ui.checkbox input[type=\"radio\"] {\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0 !important;\n    outline: none;\n    z-index: 3;\n    width: $checkbox-size;\n    height: $checkbox-size;\n  }\n\n\n  /*--------------\n        Box\n  ---------------*/\n\n\n  .ui.checkbox .box,\n  .ui.checkbox label {\n    cursor: auto;\n    position: relative;\n    display: block;\n    padding-left: $checkbox-label-distance;\n    outline: none;\n    font-size: $checkbox-label-font-size;\n  }\n\n  .ui.checkbox .box:before,\n  .ui.checkbox label:before {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    width: $checkbox-size;\n    height: $checkbox-size;\n    content: '';\n\n    background: $checkbox-background;\n    border-radius: $checkbox-border-radius;\n\n    transition: $checkbox-transition;\n    border: $checkbox-border;\n  }\n\n  /*--------------\n      Checkmark\n  ---------------*/\n\n  .ui.checkbox .box:after,\n  .ui.checkbox label:after {\n    position: absolute;\n    font-size: $checkbox-check-font-size;\n    top: $checkbox-check-top;\n    left: $checkbox-check-left;\n    width: $checkbox-check-size;\n    height: $checkbox-check-size;\n    text-align: center;\n\n    opacity: 0;\n    color: $checkbox-color;\n    transition: $checkbox-transition;\n  }\n\n  /*--------------\n        Label\n  ---------------*/\n\n  /* Inside */\n  .ui.checkbox label,\n  .ui.checkbox + label {\n    color: $checkbox-label-color;\n    transition: $checkbox-label-transition;\n  }\n\n  /* Outside */\n  .ui.checkbox + label {\n    vertical-align: middle;\n  }\n\n\n  /*******************************\n            States\n  *******************************/\n\n\n  /*--------------\n        Hover\n  ---------------*/\n\n  .ui.checkbox .box:hover::before,\n  .ui.checkbox label:hover::before {\n    background: $checkbox-hover-background;\n    border-color: $checkbox-hover-border-color;\n  }\n  .ui.checkbox label:hover,\n  .ui.checkbox + label:hover {\n    color: $checkbox-label-hover-color;\n  }\n\n  /*--------------\n        Down\n  ---------------*/\n\n  .ui.checkbox .box:active::before,\n  .ui.checkbox label:active::before {\n    background: $checkbox-pressed-background;\n    border-color: $checkbox-pressed-border-color;\n  }\n  .ui.checkbox .box:active::after,\n  .ui.checkbox label:active::after {\n    color: $checkbox-pressed-color;\n  }\n  .ui.checkbox input:active ~ label {\n    color: $checkbox-label-pressed-color;\n  }\n\n  /*--------------\n      Focus\n  ---------------*/\n\n  .ui.checkbox input:focus ~ .box:before,\n  .ui.checkbox input:focus ~ label:before {\n    background: $checkbox-focus-background;\n    border-color: $checkbox-focus-border-color;\n  }\n  .ui.checkbox input:focus ~ .box:after,\n  .ui.checkbox input:focus ~ label:after {\n    color: $checkbox-focus-check-color;\n  }\n  .ui.checkbox input:focus ~ label {\n    color: $checkbox-label-focus-color;\n  }\n\n  /*--------------\n      Active\n  ---------------*/\n\n  .ui.checkbox input:checked ~ .box:before,\n  .ui.checkbox input:checked ~ label:before {\n    background: $checkbox-active-background;\n    border-color: $checkbox-active-border-color;\n  }\n  .ui.checkbox input:checked ~ .box:after,\n  .ui.checkbox input:checked ~ label:after {\n    opacity: $checkbox-active-check-opacity;\n    color: $checkbox-active-check-color;\n  }\n\n  /*--------------\n    Indeterminate\n  ---------------*/\n\n  .ui.checkbox input:not([type=radio]):indeterminate ~ .box:before,\n  .ui.checkbox input:not([type=radio]):indeterminate ~ label:before {\n    background: $checkbox-indeterminate-background;\n    border-color: $checkbox-indeterminate-border-color;\n  }\n  .ui.checkbox input:not([type=radio]):indeterminate ~ .box:after,\n  .ui.checkbox input:not([type=radio]):indeterminate ~ label:after {\n    opacity: $checkbox-indeterminate-check-opacity;\n    color: $checkbox-indeterminate-check-color;\n  }\n  .ui.indeterminate.toggle.checkbox {\n    & input:not([type=radio]):indeterminate ~ label:before {\n      background: $checkbox-toggle-center-lane-background;\n    }\n    & input:not([type=radio]) ~ label:after {\n      left: $checkbox-toggle-center-offset;\n    }\n  }\n\n  /*--------------\n    Active Focus\n  ---------------*/\n\n  .ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:before,\n  .ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:before,\n  .ui.checkbox input:checked:focus ~ .box:before,\n  .ui.checkbox input:checked:focus ~ label:before  {\n    background: $checkbox-active-focus-background;\n    border-color: $checkbox-active-focus-border-color;\n  }\n  .ui.checkbox input:not([type=radio]):indeterminate:focus ~ .box:after,\n  .ui.checkbox input:not([type=radio]):indeterminate:focus ~ label:after,\n  .ui.checkbox input:checked:focus ~ .box:after,\n  .ui.checkbox input:checked:focus ~ label:after {\n    color: $checkbox-active-focus-check-color;\n  }\n\n\n  /*--------------\n      Read-Only\n  ---------------*/\n\n  .ui.read-only.checkbox,\n  .ui.read-only.checkbox label {\n    cursor: default;\n  }\n\n\n  /*--------------\n      Disabled\n  ---------------*/\n\n  .ui.disabled.checkbox .box:after,\n  .ui.disabled.checkbox label,\n  .ui.checkbox input[disabled] ~ .box:after,\n  .ui.checkbox input[disabled] ~ label {\n    cursor: default !important;\n    opacity: $checkbox-disabled-opacity;\n    color: $checkbox-disabled-label-color;\n  }\n\n  /*--------------\n      Hidden\n  ---------------*/\n\n  /* Initialized checkbox moves input below element\n  to prevent manually triggering */\n  .ui.checkbox input.hidden {\n    z-index: -1;\n  }\n\n  /* Selectable Label */\n  .ui.checkbox input.hidden + label {\n    cursor: pointer;\n    user-select: none;\n  }\n\n\n  /*******************************\n              Types\n  *******************************/\n\n\n  /*--------------\n      Radio\n  ---------------*/\n\n  .ui.radio.checkbox {\n    min-height: $checkbox-radio-size;\n  }\n\n  .ui.radio.checkbox .box,\n  .ui.radio.checkbox label {\n    padding-left: $checkbox-radio-label-distance;\n  }\n\n  /* Box */\n  .ui.radio.checkbox .box:before,\n  .ui.radio.checkbox label:before {\n    content: '';\n    transform: none;\n\n    width: $checkbox-radio-size;\n    height: $checkbox-radio-size;\n    border-radius: $circular-radius;\n    top: $checkbox-radio-top;\n    left: $checkbox-radio-left;\n  }\n\n  /* Bullet */\n  .ui.radio.checkbox .box:after,\n  .ui.radio.checkbox label:after {\n    border: none;\n    content: '' !important;\n    width: $checkbox-radio-size;\n    height: $checkbox-radio-size;\n    line-height: $checkbox-radio-size;\n  }\n\n  /* Radio Checkbox */\n  .ui.radio.checkbox .box:after,\n  .ui.radio.checkbox label:after {\n    top: $checkbox-bullet-top;\n    left: $checkbox-bullet-left;\n    width: $checkbox-radio-size;\n    height: $checkbox-radio-size;\n    border-radius: $checkbox-bullet-radius;\n    transform: scale($checkbox-bullet-scale);\n    background-color: $checkbox-bullet-color;\n  }\n\n  /* Focus */\n  .ui.radio.checkbox input:focus ~ .box:before,\n  .ui.radio.checkbox input:focus ~ label:before {\n    background-color: $checkbox-radio-focus-background;\n  }\n  .ui.radio.checkbox input:focus ~ .box:after,\n  .ui.radio.checkbox input:focus ~ label:after {\n    background-color: $checkbox-radio-focus-bullet-color;\n  }\n\n  /* Indeterminate */\n  .ui.radio.checkbox input:indeterminate ~ .box:after,\n  .ui.radio.checkbox input:indeterminate ~ label:after {\n    opacity: 0;\n  }\n\n  /* Active */\n  .ui.radio.checkbox input:checked ~ .box:before,\n  .ui.radio.checkbox input:checked ~ label:before {\n    background-color: $checkbox-radio-active-background;\n  }\n  .ui.radio.checkbox input:checked ~ .box:after,\n  .ui.radio.checkbox input:checked ~ label:after {\n    background-color: $checkbox-radio-active-bullet-color;\n  }\n\n  /* Active Focus */\n  .ui.radio.checkbox input:focus:checked ~ .box:before,\n  .ui.radio.checkbox input:focus:checked ~ label:before {\n    background-color: $checkbox-radio-active-focus-background;\n  }\n  .ui.radio.checkbox input:focus:checked ~ .box:after,\n  .ui.radio.checkbox input:focus:checked ~ label:after {\n    background-color: $checkbox-radio-active-focus-bullet-color;\n  }\n\n  @if($use-checkbox-type-slider) {\n    /*--------------\n        Slider\n    ---------------*/\n\n    .ui.slider.checkbox {\n      min-height: $checkbox-slider-height;\n    }\n\n    /* Input */\n    .ui.slider.checkbox input {\n      width: $checkbox-slider-width;\n      height: $checkbox-slider-height;\n    }\n\n    /* Label */\n    .ui.slider.checkbox .box,\n    .ui.slider.checkbox label {\n      padding-left: $checkbox-slider-label-distance;\n      line-height: $checkbox-slider-label-line-height;\n      color: $checkbox-slider-off-label-color;\n    }\n\n    /* Line */\n    .ui.slider.checkbox .box:before,\n    .ui.slider.checkbox label:before {\n      display: block;\n      position: absolute;\n      content: '';\n      transform: none;\n      border: none !important;\n      left: 0;\n      z-index: 1;\n\n      top: $checkbox-slider-line-vertical-offset;\n\n      background-color: $checkbox-slider-line-color;\n      width: $checkbox-slider-line-width;\n      height: $checkbox-slider-line-height;\n\n      border-radius: $checkbox-slider-line-radius;\n      transition: $checkbox-slider-line-transition;\n\n    }\n\n    /* Handle */\n    .ui.slider.checkbox .box:after,\n    .ui.slider.checkbox label:after {\n      background: $checkbox-handle-background;\n      position: absolute;\n      content: '' !important;\n      opacity: 1;\n      z-index: 2;\n\n      border: none;\n      box-shadow: $checkbox-handle-box-shadow;\n      width: $checkbox-slider-handle-size;\n      height: $checkbox-slider-handle-size;\n      top: $checkbox-slider-handle-offset;\n      left: 0;\n      transform: none;\n\n      border-radius: $circular-radius;\n      transition: $checkbox-slider-handle-transition;\n    }\n\n    /* Focus */\n    .ui.slider.checkbox input:focus ~ .box:before,\n    .ui.slider.checkbox input:focus ~ label:before {\n      background-color: $checkbox-toggle-focus-color;\n      border: none;\n    }\n\n    /* Hover */\n    .ui.slider.checkbox .box:hover,\n    .ui.slider.checkbox label:hover {\n      color: $checkbox-slider-hover-label-color;\n    }\n    .ui.slider.checkbox .box:hover::before,\n    .ui.slider.checkbox label:hover::before {\n      background: $checkbox-slider-hover-lane-background;\n    }\n\n    /* Active */\n    .ui.slider.checkbox input:checked ~ .box,\n    .ui.slider.checkbox input:checked ~ label {\n      color: $checkbox-slider-on-label-color !important;\n    }\n    .ui.slider.checkbox input:checked ~ .box:before,\n    .ui.slider.checkbox input:checked ~ label:before {\n      background-color: $checkbox-slider-on-line-color !important;\n    }\n    .ui.slider.checkbox input:checked ~ .box:after,\n    .ui.slider.checkbox input:checked ~ label:after {\n      left: $checkbox-slider-travel-distance;\n    }\n\n    /* Active Focus */\n    .ui.slider.checkbox input:focus:checked ~ .box,\n    .ui.slider.checkbox input:focus:checked ~ label {\n      color: $checkbox-slider-on-focus-label-color !important;\n    }\n    .ui.slider.checkbox input:focus:checked ~ .box:before,\n    .ui.slider.checkbox input:focus:checked ~ label:before {\n      background-color: $checkbox-slider-on-focus-line-color !important;\n    }\n  }\n\n\n  @if($use-checkbox-type-toggle) {\n    /*--------------\n        Toggle\n    ---------------*/\n\n    .ui.toggle.checkbox {\n      min-height: $checkbox-toggle-height;\n    }\n\n    /* Input */\n    .ui.toggle.checkbox input {\n      width: $checkbox-toggle-width;\n      height: $checkbox-toggle-height;\n    }\n\n    /* Label */\n    .ui.toggle.checkbox .box,\n    .ui.toggle.checkbox label {\n      min-height: $checkbox-toggle-handle-size;\n      padding-left: $checkbox-toggle-label-distance;\n      color: $checkbox-toggle-off-label-color;\n    }\n    .ui.toggle.checkbox label {\n      padding-top: $checkbox-toggle-label-offset;\n    }\n\n    /* Switch */\n    .ui.toggle.checkbox .box:before,\n    .ui.toggle.checkbox label:before {\n      display: block;\n      position: absolute;\n      content: '';\n      z-index: 1;\n      transform: none;\n      border: none;\n\n      top: $checkbox-toggle-lane-vertical-offset;\n\n      background: $checkbox-toggle-lane-background;\n      box-shadow: $checkbox-toggle-lane-box-shadow;\n      width: $checkbox-toggle-lane-width;\n      height: $checkbox-toggle-lane-height;\n      border-radius: $checkbox-toggle-handle-radius;\n    }\n\n    /* Handle */\n    .ui.toggle.checkbox .box:after,\n    .ui.toggle.checkbox label:after {\n      background: $checkbox-handle-background;\n      position: absolute;\n      content: '' !important;\n      opacity: 1;\n      z-index: 2;\n\n      border: none;\n      box-shadow: $checkbox-handle-box-shadow;\n      width: $checkbox-toggle-handle-size;\n      height: $checkbox-toggle-handle-size;\n      top: $checkbox-toggle-handle-offset;\n      left: 0;\n\n      border-radius: $circular-radius;\n      transition: $checkbox-toggle-handle-transition;\n    }\n\n    .ui.toggle.checkbox input ~ .box:after,\n    .ui.toggle.checkbox input ~ label:after {\n      left: $checkbox-toggle-off-offset;\n      box-shadow: $checkbox-toggle-off-handle-box-shadow;\n    }\n\n    /* Focus */\n    .ui.toggle.checkbox input:focus ~ .box:before,\n    .ui.toggle.checkbox input:focus ~ label:before {\n      background-color: $checkbox-toggle-focus-color;\n      border: none;\n    }\n\n    /* Hover */\n    .ui.toggle.checkbox .box:hover::before,\n    .ui.toggle.checkbox label:hover::before {\n      background-color: $checkbox-toggle-hover-color;\n      border: none;\n    }\n\n    /* Active */\n    .ui.toggle.checkbox input:checked ~ .box,\n    .ui.toggle.checkbox input:checked ~ label {\n      color: $checkbox-toggle-on-label-color !important;\n    }\n    .ui.toggle.checkbox input:checked ~ .box:before,\n    .ui.toggle.checkbox input:checked ~ label:before {\n      background-color: $checkbox-toggle-on-lane-color !important;\n    }\n    .ui.toggle.checkbox input:checked ~ .box:after,\n    .ui.toggle.checkbox input:checked ~ label:after {\n      left: $checkbox-toggle-on-offset;\n      box-shadow: $checkbox-toggle-on-handle-box-shadow;\n    }\n\n\n    /* Active Focus */\n    .ui.toggle.checkbox input:focus:checked ~ .box,\n    .ui.toggle.checkbox input:focus:checked ~ label {\n      color: $checkbox-toggle-on-focus-label-color !important;\n    }\n    .ui.toggle.checkbox input:focus:checked ~ .box:before,\n    .ui.toggle.checkbox input:focus:checked ~ label:before {\n      background-color: $checkbox-toggle-on-focus-lane-color !important;\n    }\n  }\n\n\n  /*******************************\n              Variations\n  *******************************/\n\n  @if($use-checkbox-variation-fitted) {\n    /*--------------\n        Fitted\n    ---------------*/\n\n    .ui.fitted.checkbox .box,\n    .ui.fitted.checkbox label {\n      padding-left: 0 !important;\n    }\n\n    @if($use-checkbox-type-toggle) {\n      .ui.fitted.toggle.checkbox {\n        width: $checkbox-toggle-width;\n      }\n    }\n\n    @if($use-checkbox-type-slider) {\n      .ui.fitted.slider.checkbox {\n        width: $checkbox-slider-width;\n      }\n    }\n  }\n\n  @if($use-checkbox-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n    .ui.inverted.checkbox label,\n    .ui.inverted.checkbox + label {\n      color: $inverted-text-color !important;\n    }\n\n    /* Hover */\n    .ui.inverted.checkbox .box:hover,\n    .ui.inverted.checkbox label:hover {\n      color: $inverted-hovered-text-color !important;\n    }\n    .ui.inverted.checkbox .box:hover::before,\n    .ui.inverted.checkbox label:hover::before {\n      border-color: $strong-selected-border-color;\n    }\n\n    @if($use-checkbox-type-slider) {\n      /*Slider Label */\n      .ui.inverted.slider.checkbox .box,\n      .ui.inverted.slider.checkbox label {\n        color: $inverted-unselected-text-color;\n      }\n\n      /* Slider Line */\n      .ui.inverted.slider.checkbox .box:before,\n      .ui.inverted.slider.checkbox label:before {\n        background-color: $inverted-unselected-text-color !important;\n      }\n\n      /* Slider Hover */\n      .ui.inverted.slider.checkbox .box:hover::before,\n      .ui.inverted.slider.checkbox label:hover::before {\n        background: $inverted-light-text-color !important;\n      }\n\n      /* Slider Active */\n      .ui.inverted.slider.checkbox input:checked ~ .box,\n      .ui.inverted.slider.checkbox input:checked ~ label {\n        color: $inverted-selected-text-color !important;\n      }\n      .ui.inverted.slider.checkbox input:checked ~ .box:before,\n      .ui.inverted.slider.checkbox input:checked ~ label:before {\n        background-color: $selected-white-border-color !important;\n      }\n\n      /* Slider Active Focus */\n      .ui.inverted.slider.checkbox input:focus:checked ~ .box,\n      .ui.inverted.slider.checkbox input:focus:checked ~ label {\n        color: $inverted-selected-text-color !important;\n      }\n      .ui.inverted.slider.checkbox input:focus:checked ~ .box:before,\n      .ui.inverted.slider.checkbox input:focus:checked ~ label:before {\n        background-color: $selected-white-border-color !important;\n      }\n    }\n\n    @if($use-checkbox-type-toggle) {\n      /* Toggle Switch */\n      .ui.inverted.toggle.checkbox .box:before,\n      .ui.inverted.toggle.checkbox label:before {\n        background-color: $inverted-text-color !important;\n      }\n\n      /* Toggle Hover */\n      .ui.inverted.toggle.checkbox .box:hover::before,\n      .ui.inverted.toggle.checkbox label:hover::before {\n        background: $inverted-hovered-text-color !important;\n      }\n\n      /* Toggle Active */\n      .ui.inverted.toggle.checkbox input:checked ~ .box,\n      .ui.inverted.toggle.checkbox input:checked ~ label {\n        color: $inverted-selected-text-color !important;\n      }\n      .ui.inverted.toggle.checkbox input:checked ~ .box:before,\n      .ui.inverted.toggle.checkbox input:checked ~ label:before {\n        background-color: $checkbox-toggle-on-lane-color !important;\n      }\n\n      /* Toggle Active Focus */\n      .ui.inverted.toggle.checkbox input:focus:checked ~ .box,\n      .ui.inverted.toggle.checkbox input:focus:checked ~ label {\n        color: $inverted-selected-text-color !important;\n      }\n      .ui.inverted.toggle.checkbox input:focus:checked ~ .box:before,\n      .ui.inverted.toggle.checkbox input:focus:checked ~ label:before {\n        background-color: $checkbox-toggle-on-focus-lane-color !important;\n      }\n    }\n  }\n\n  /*--------------------\n          Size\n  ---------------------*/\n\n  @each $key, $value in $checkbox-variation-sizes {\n    @if(index($use-checkbox-variation-size, $key+'')) {\n      $raw: map-get($value, raw);\n      $size: map-get($value, size);\n      $circleScale: map-get($value, circleScale);\n      $circleLeft: map-get($value, circleLeft);\n      \n      .ui.#{$key}.checkbox {\n        font-size: $size;\n      }\n\n      @if ($raw > 1) {\n        .ui.#{$key}.form .checkbox,\n        .ui.#{$key}.checkbox {\n          &:not(.slider):not(.toggle):not(.radio) {\n            &\n            .box:after,\n            .box:before,\n            label:after,\n            label:before {\n              transform: scale($raw);\n              transform-origin:left;\n            }\n          }\n          &.radio {\n            &\n            .box:before,\n            label:before {\n              transform: scale($raw);\n              transform-origin:left;\n            }\n            &\n            .box:after,\n            label:after {\n              transform:scale($circleScale);\n              transform-origin:left;\n              left: $circleLeft;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@import '../../themes/default/modules/checkbox.style';","@if $use-checkbox {\n  @font-face {\n    font-family: 'Checkbox';\n    src:\n      url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBD8AAAC8AAAAYGNtYXAYVtCJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5Zn4huwUAAAF4AAABYGhlYWQGPe1ZAAAC2AAAADZoaGVhB30DyAAAAxAAAAAkaG10eBBKAEUAAAM0AAAAHGxvY2EAmgESAAADUAAAABBtYXhwAAkALwAAA2AAAAAgbmFtZSC8IugAAAOAAAABknBvc3QAAwAAAAAFFAAAACAAAwMTAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADoAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6AL//f//AAAAAAAg6AD//f//AAH/4xgEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAEUAUQO7AvgAGgAAARQHAQYjIicBJjU0PwE2MzIfAQE2MzIfARYVA7sQ/hQQFhcQ/uMQEE4QFxcQqAF2EBcXEE4QAnMWEP4UEBABHRAXFhBOEBCoAXcQEE4QFwAAAAABAAABbgMlAkkAFAAAARUUBwYjISInJj0BNDc2MyEyFxYVAyUQEBf9SRcQEBAQFwK3FxAQAhJtFxAQEBAXbRcQEBAQFwAAAAABAAAASQMlA24ALAAAARUUBwYrARUUBwYrASInJj0BIyInJj0BNDc2OwE1NDc2OwEyFxYdATMyFxYVAyUQEBfuEBAXbhYQEO4XEBAQEBfuEBAWbhcQEO4XEBACEm0XEBDuFxAQEBAX7hAQF20XEBDuFxAQEBAX7hAQFwAAAQAAAAIAAHRSzT9fDzz1AAsEAAAAAADRsdR3AAAAANGx1HcAAAAAA7sDbgAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADuwABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABFAyUAAAMlAAAAAAAAAAoAFAAeAE4AcgCwAAEAAAAHAC0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhWZXJzaW9uIDIuMABWAGUAcgBzAGkAbwBuACAAMgAuADBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhDaGVja2JveABDAGgAZQBjAGsAYgBvAHhSZWd1bGFyAFIAZQBnAHUAbABhAHJDaGVja2JveABDAGgAZQBjAGsAYgBvAHhGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype')\n    ;\n  }\n  \n  /* Checkmark */\n  .ui.checkbox label:after,\n  .ui.checkbox .box:after {\n    font-family: 'Checkbox';\n  }\n  \n  /* Checked */\n  .ui.checkbox input:checked ~ .box:after,\n  .ui.checkbox input:checked ~ label:after {\n    content: '\\e800';\n  }\n  \n  /* Indeterminate */\n  .ui.checkbox input:indeterminate ~ .box:after,\n  .ui.checkbox input:indeterminate ~ label:after {\n    font-size: 12px;\n    content: '\\e801';\n  }\n  \n  \n  /*  UTF Reference\n  .check:before { content: '\\e800'; }\n  .dash:before  { content: '\\e801'; }\n  .plus:before { content: '\\e802'; }\n  */\n}\n","@import '../../themes/default/modules/dimmer.variables';\n\n@if $use-dimmer {\n  /*******************************\n  //@-        Dimmer\n  *******************************/\n\n  .dimmable:not(body) {\n    position: $dimmer-dimmable-position;\n  }\n\n  .ui.dimmer {\n    display: none;\n    position: $dimmer-position;\n    top: 0 !important;\n    left: 0 !important;\n\n    width: 100%;\n    height: 100%;\n\n    text-align: $dimmer-text-align;\n    vertical-align: $dimmer-vertical-align;\n    padding: $dimmer-padding;\n\n    background-color: $dimmer-background-color;\n    opacity: $dimmer-hidden-opacity;\n    line-height: $dimmer-line-height;\n\n    animation-fill-mode: both;\n    animation-duration: $dimmer-duration;\n    transition: $dimmer-transition;\n\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    user-select: none;\n    will-change: opacity;\n    z-index: $dimmer-z-index;\n  }\n\n  /* Dimmer Content */\n  .ui.dimmer > .content {\n    user-select: text;\n    color: $dimmer-text-color;\n  }\n\n\n  /* Loose Coupling */\n  .ui.segment > .ui.dimmer:not(.page) {\n    border-radius: inherit !important;\n  }\n\n  /* Scrollbars */\n  @if ($use-custom-scrollbars) {\n    .ui.dimmer:not(.inverted)::-webkit-scrollbar-track {\n      background: $track-inverted-background;\n    }\n    .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb {\n      background: $thumb-inverted-background;\n    }\n    .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:window-inactive {\n      background: $thumb-inverted-inactive-background;\n    }\n    .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:hover {\n      background: $thumb-inverted-hover-background;\n    }\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  /* Animating */\n  .animating.dimmable:not(body),\n  .dimmed.dimmable:not(body) {\n    overflow: $dimmer-overflow;\n  }\n\n  /* Animating / Active / Visible */\n  .dimmed.dimmable > .ui.animating.dimmer,\n  .dimmed.dimmable > .ui.visible.dimmer,\n  .ui.active.dimmer {\n    display: flex;\n    opacity: $dimmer-visible-opacity;\n  }\n\n  /* Disabled */\n  .ui.disabled.dimmer {\n    width: 0 !important;\n    height: 0 !important;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n\n  /*--------------\n      Legacy\n  ---------------*/\n\n  /* Animating / Active / Visible */\n  .dimmed.dimmable > .ui.animating.legacy.dimmer,\n  .dimmed.dimmable > .ui.visible.legacy.dimmer,\n  .ui.active.legacy.dimmer {\n    display: block;\n  }\n\n  /*--------------\n      Alignment\n  ---------------*/\n\n  .ui[class*=\"top aligned\"].dimmer {\n    justify-content: flex-start;\n  }\n  .ui[class*=\"bottom aligned\"].dimmer {\n    justify-content: flex-end;\n  }\n\n  /*--------------\n        Page\n  ---------------*/\n\n  .ui.page.dimmer {\n    position: $dimmer-page-position;\n    transform-style: $dimmer-transform-style;\n    perspective: $dimmer-perspective;\n    transform-origin: center center;\n  }\n\n  body.animating.in.dimmable,\n  body.dimmed.dimmable {\n    overflow: hidden;\n  }\n\n  body.dimmable > .dimmer {\n    position: fixed;\n  }\n\n  @if($use-dimmer-variation-blurring) {\n    /*--------------\n        Blurring\n    ---------------*/\n\n    .blurring.dimmable > :not(.dimmer) {\n      filter: $dimmer-blurred-start-filter;\n      transition: $dimmer-blurred-transition;\n    }\n    .blurring.dimmed.dimmable > :not(.dimmer):not(.popup) {\n      filter: $dimmer-blurred-end-filter;\n    }\n\n    /* Dimmer Color */\n    .blurring.dimmable > .dimmer {\n      background-color: $dimmer-blurred-background-color;\n    }\n    .blurring.dimmable > .inverted.dimmer {\n      background-color: $dimmer-blurred-inverted-background-color;\n    }\n  }\n\n  /*--------------\n      Aligned\n  ---------------*/\n\n  .ui.dimmer > .top.aligned.content > * {\n    vertical-align: top;\n  }\n  .ui.dimmer > .bottom.aligned.content > * {\n    vertical-align: bottom;\n  }\n\n\n  @if($use-dimmer-variation-shades) {\n    /*--------------\n        Shades\n    ---------------*/\n\n    .medium.medium.medium.medium.medium.dimmer {\n      background-color: $dimmer-medium-background-color;\n    }\n    .light.light.light.light.light.dimmer {\n      background-color: $dimmer-light-background-color;\n    }\n    .very.light.light.light.light.dimmer {\n      background-color: $dimmer-very-light-background-color;\n    }\n  }\n\n  @if($use-dimmer-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n\n    .ui.inverted.dimmer {\n      background-color: $dimmer-inverted-background-color;\n    }\n    .ui.inverted.dimmer > .content,\n    .ui.inverted.dimmer > .content > * {\n      color: $dimmer-inverted-text-color;\n    }\n\n    /*--------------\n    Inverted Shades\n    ---------------*/\n\n    .medium.medium.medium.medium.medium.inverted.dimmer {\n      background-color: $dimmer-medium-inverted-background-color;\n    }\n    .light.light.light.light.light.inverted.dimmer {\n      background-color: $dimmer-light-inverted-background-color;\n    }\n    .very.light.light.light.light.inverted.dimmer {\n      background-color: $dimmer-very-light-inverted-background-color;\n    }\n  }\n\n  /*--------------\n      Simple\n  ---------------*/\n\n  /* Displays without javascript */\n  .ui.simple.dimmer {\n    display: block;\n    overflow: hidden;\n    opacity: 0;\n    width: 0;\n    height: 0;\n    z-index: -100;\n    background-color: $dimmer-simple-start-background-color;\n  }\n  .dimmed.dimmable > .ui.simple.dimmer {\n    overflow: visible;\n    opacity: 1;\n    width: 100%;\n    height: 100%;\n    background-color: $dimmer-simple-end-background-color;\n    z-index: $dimmer-simple-z-index;\n  }\n\n  .ui.simple.inverted.dimmer {\n    background-color: $dimmer-simple-inverted-start-background-color;\n  }\n  .dimmed.dimmable > .ui.simple.inverted.dimmer {\n    background-color: $dimmer-simple-inverted-end-background-color;\n  }\n\n\n  @if($use-dimmer-variation-partially) {\n    /*--------------\n        Partially\n    ----------------*/\n\n    .ui[class*=\"top dimmer\"],\n    .ui[class*=\"center dimmer\"],\n    .ui[class*=\"bottom dimmer\"] {\n      height: auto;\n    }\n    .ui[class*=\"bottom dimmer\"] {\n      top: auto !important;\n      bottom: 0;\n    }\n    .ui[class*=\"center dimmer\"] {\n      top:50% !important;\n      transform: translateY(-50%);\n      -webkit-transform: translateY(calc(-50% - .5px));\n    }\n\n    .ui.segment > .ui[class*=\"top dimmer\"] {\n        border-bottom-left-radius: 0 !important;\n        border-bottom-right-radius: 0 !important;\n    }\n    .ui.segment > .ui[class*=\"center dimmer\"] {\n        border-radius: 0 !important;\n    }\n    .ui.segment > .ui[class*=\"bottom dimmer\"] {\n        border-top-left-radius: 0 !important;\n        border-top-right-radius: 0 !important;\n    }\n\n    .ui[class*=\"center dimmer\"].transition[class*=\"fade up\"].in {\n      animation-name: fadeInUpCenter;\n    }\n    .ui[class*=\"center dimmer\"].transition[class*=\"fade down\"].in {\n      animation-name: fadeInDownCenter;\n    }\n    .ui[class*=\"center dimmer\"].transition[class*=\"fade up\"].out {\n      animation-name: fadeOutUpCenter;\n    }\n    .ui[class*=\"center dimmer\"].transition[class*=\"fade down\"].out {\n      animation-name: fadeOutDownCenter;\n    }\n    .ui[class*=\"center dimmer\"].bounce.transition {\n      animation-name: bounceCenter;\n    }\n    @keyframes fadeInUpCenter {\n      0% {\n        opacity: 0;\n        transform: translateY(-40%);\n        -webkit-transform: translateY(calc(-40% - .5px));\n      }\n      100% {\n        opacity: 1;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(calc(-50% - .5px));\n      }\n    }\n    @keyframes fadeInDownCenter {\n      0% {\n        opacity: 0;\n        transform: translateY(-60%);\n        -webkit-transform: translateY(calc(-60% - .5px));\n      }\n      100% {\n        opacity: 1;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(calc(-50% - .5px));\n      }\n    }\n    @keyframes fadeOutUpCenter {\n      0% {\n        opacity: 1;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(calc(-50% - .5px));\n      }\n      100% {\n        opacity: 0;\n        transform: translateY(-45%);\n        -webkit-transform: translateY(calc(-45% - .5px));\n      }\n    }\n    @keyframes fadeOutDownCenter {\n      0% {\n        opacity: 1;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(calc(-50% - .5px));\n      }\n      100% {\n        opacity: 0;\n        transform: translateY(-55%);\n        -webkit-transform: translateY(calc(-55% - .5px));\n      }\n    }\n    @keyframes bounceCenter {\n      0%, 20%, 50%, 80%, 100% {\n        transform: translateY(-50%);\n        -webkit-transform: translateY(calc(-50% - .5px));\n      }\n      40% {\n        transform: translateY(calc(-50% - 30px));\n      }\n      60% {\n        transform: translateY(calc(-50% - 15px));\n      }\n    }\n  }\n}\n\n@import '../../themes/default/modules/dimmer.style';","@import '../../themes/default/modules/dropdown.variables';\n\n@if $use-dropdown {\n  /*******************************\n  //@-        Dropdown\n  *******************************/\n\n  .ui.dropdown {\n    cursor: pointer;\n    position: relative;\n    display: inline-block;\n    outline: none;\n    text-align: left;\n    transition: $dropdown-transition;\n    user-select: none;\n\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n\n  /*******************************\n              Content\n  *******************************/\n\n  /*--------------\n        Menu\n  ---------------*/\n\n  .ui.dropdown .menu {\n    cursor: auto;\n    position: absolute;\n    display: none;\n    outline: none;\n    top: 100%;\n    min-width: max-content;\n\n    margin: $dropdown-menu-margin;\n    padding: $dropdown-menu-padding;\n    background: $dropdown-menu-background;\n\n    font-size: $relative-medium;\n    text-shadow: none;\n    text-align: $dropdown-menu-text-align;\n\n    box-shadow: $dropdown-menu-box-shadow;\n    border: $dropdown-menu-border;\n    border-radius: $dropdown-menu-border-radius;\n    transition: $dropdown-menu-transition;\n    z-index: $dropdown-menu-z-index;\n    will-change: transform, opacity;\n  }\n\n  .ui.dropdown .menu > * {\n    white-space: nowrap;\n  }\n\n\n  /*--------------\n    Hidden Input\n  ---------------*/\n\n  .ui.dropdown > input:not(.search):first-child,\n  .ui.dropdown > select {\n    display: none !important;\n  }\n\n  /*--------------\n  Dropdown Icon\n  ---------------*/\n\n  .ui.dropdown > .dropdown.icon.icon {\n    position: relative;\n    width: auto;\n    font-size: $dropdown-icon-size;\n    margin: $dropdown-icon-margin;\n  }\n  .ui.dropdown .menu > .item .dropdown.icon {\n    width: auto;\n    float: $dropdown-item-icon-float;\n    margin: $dropdown-item-icon-margin;\n  }\n  .ui.dropdown .menu > .item .dropdown.icon + .text {\n    margin-right: $dropdown-item-icon-distance;\n  }\n\n\n  /*--------------\n        Text\n  ---------------*/\n\n  .ui.dropdown > .text {\n    display: inline-block;\n    transition: $dropdown-text-transition;\n  }\n\n  /*--------------\n      Menu Item\n  ---------------*/\n\n  .ui.dropdown .menu > .item {\n    position: relative;\n    cursor: pointer;\n    display: block;\n    border: $dropdown-item-border;\n    height: $dropdown-item-height;\n    text-align: $dropdown-item-text-align;\n\n    border-top: $dropdown-item-divider;\n    line-height: $dropdown-item-line-height;\n    font-size: $dropdown-item-font-size;\n    color: $dropdown-item-color;\n\n    padding: $dropdown-item-padding !important;\n    text-transform: $dropdown-item-text-transform;\n    font-weight: $dropdown-item-font-weight;\n    box-shadow: $dropdown-item-box-shadow;\n    -webkit-touch-callout: none;\n  }\n  .ui.dropdown .menu > .item:first-child {\n    border-top-width: 0;\n  }\n\n  /*--------------\n    Floated Content\n  ---------------*/\n\n  .ui.dropdown > .text > [class*=\"right floated\"],\n  .ui.dropdown .menu .item > [class*=\"right floated\"] {\n    float: right !important;\n    margin-right: 0 !important;\n    margin-left: $dropdown-floated-distance !important;\n  }\n  .ui.dropdown > .text > [class*=\"left floated\"],\n  .ui.dropdown .menu .item > [class*=\"left floated\"] {\n    float: left !important;\n    margin-left: 0 !important;\n    margin-right: $dropdown-floated-distance !important;\n  }\n\n  .ui.dropdown .menu .item > .icon.floated,\n  .ui.dropdown .menu .item > .flag.floated,\n  .ui.dropdown .menu .item > .image.floated,\n  .ui.dropdown .menu .item > img.floated {\n    margin-top: $dropdown-item-line-height-offset;\n  }\n\n\n  /*--------------\n    Menu Divider\n  ---------------*/\n\n  .ui.dropdown .menu > .header {\n    margin: $dropdown-menu-header-margin;\n    padding: $dropdown-menu-header-padding;\n    font-weight: $dropdown-menu-header-font-weight;\n    text-transform: $dropdown-menu-header-text-transform;\n  }\n  .ui.dropdown .menu > .header:not(.ui) {\n    color: $dropdown-menu-header-color;\n    font-size: $dropdown-menu-header-font-size;\n  }\n  .ui.dropdown .menu > .divider {\n    border-top: $dropdown-menu-divider-border;\n    height: 0;\n    margin: $dropdown-menu-divider-margin;\n  }\n  .ui.dropdown .menu > .horizontal.divider {\n    border-top: none;\n  }\n\n  .ui.dropdown.dropdown .menu > .input {\n    width: auto;\n    display: flex;\n    margin: $dropdown-menu-input-margin;\n    min-width: $dropdown-menu-input-min-width;\n  }\n  .ui.dropdown .menu > .header + .input {\n    margin-top: 0;\n  }\n  .ui.dropdown .menu > .input:not(.transparent) input {\n    padding: $dropdown-menu-input-padding;\n  }\n  .ui.dropdown .menu > .input:not(.transparent) .button,\n  .ui.dropdown .menu > .input:not(.transparent) .icon,\n  .ui.dropdown .menu > .input:not(.transparent) .label {\n    padding-top: $dropdown-menu-input-vertical-padding;\n    padding-bottom: $dropdown-menu-input-vertical-padding;\n  }\n\n  /*-----------------\n    Item Description\n  -------------------*/\n\n  .ui.dropdown > .text > .description,\n  .ui.dropdown .menu > .item > .description {\n    float: $dropdown-item-description-float;\n    margin: $dropdown-item-description-margin;\n    color: $dropdown-item-description-color;\n  }\n\n  /*-----------------\n        Message\n  -------------------*/\n\n  .ui.dropdown .menu > .message {\n    padding: $dropdown-message-padding;\n    font-weight: $dropdown-message-font-weight;\n  }\n  .ui.dropdown .menu > .message:not(.ui) {\n    color: $dropdown-message-color;\n  }\n\n  /*--------------\n      Sub Menu\n  ---------------*/\n\n  .ui.dropdown .menu .menu {\n    top: $dropdown-sub-menu-top;\n    left: $dropdown-sub-menu-left;\n    right: $dropdown-sub-menu-right;\n    margin: $dropdown-sub-menu-margin !important;\n    border-radius: $dropdown-sub-menu-border-radius !important;\n    z-index: $dropdown-sub-menu-z-index !important;\n  }\n\n  /* Hide Arrow */\n  .ui.dropdown .menu .menu:after {\n    display: none;\n  }\n\n  /*--------------\n    Sub Elements\n  ---------------*/\n\n  /* Icons / Flags / Labels / Image */\n  .ui.dropdown > .text > .icon,\n  .ui.dropdown > .text > .label,\n  .ui.dropdown > .text > .flag,\n  .ui.dropdown > .text > img,\n  .ui.dropdown > .text > .image {\n    margin-top: $dropdown-text-line-height-offset;\n  }\n  .ui.dropdown .menu > .item > .icon,\n  .ui.dropdown .menu > .item > .label,\n  .ui.dropdown .menu > .item > .flag,\n  .ui.dropdown .menu > .item > .image,\n  .ui.dropdown .menu > .item > img  {\n    margin-top: $dropdown-item-line-height-offset;\n  }\n\n  .ui.dropdown > .text > .icon,\n  .ui.dropdown > .text > .label,\n  .ui.dropdown > .text > .flag,\n  .ui.dropdown > .text > img,\n  .ui.dropdown > .text > .image,\n  .ui.dropdown .menu > .item > .icon,\n  .ui.dropdown .menu > .item > .label,\n  .ui.dropdown .menu > .item > .flag,\n  .ui.dropdown .menu > .item > .image,\n  .ui.dropdown .menu > .item > img  {\n    margin-left: 0;\n    float: $dropdown-item-element-float;\n    margin-right: $dropdown-item-element-distance;\n  }\n\n  /*--------------\n      Image\n  ---------------*/\n\n  .ui.dropdown > .text > img,\n  .ui.dropdown > .text > .image:not(.icon),\n  .ui.dropdown .menu > .item > .image:not(.icon),\n  .ui.dropdown .menu > .item > img {\n    display: inline-block;\n    vertical-align: top;\n    width: auto;\n    margin-top: $dropdown-menu-image-vertical-margin;\n    margin-bottom: $dropdown-menu-image-vertical-margin;\n    max-height: $dropdown-menu-image-max-height;\n  }\n\n\n  /*******************************\n              Coupling\n  *******************************/\n\n\n  /*--------------\n        Menu\n  ---------------*/\n\n  /* Remove Menu Item Divider */\n  .ui.dropdown .ui.menu > .item:before,\n  .ui.menu .ui.dropdown .menu > .item:before {\n    display: none;\n  }\n\n  /* Prevent Menu Item Border */\n  .ui.menu .ui.dropdown .menu .active.item {\n    border-left: none;\n  }\n\n  /* Automatically float dropdown menu right on last menu item */\n  .ui.menu .right.menu .dropdown:last-child .menu,\n  .ui.menu .right.dropdown.item .menu,\n  .ui.buttons > .ui.dropdown:last-child .menu {\n    left: auto;\n    right: 0;\n  }\n\n  /*--------------\n        Label\n  ---------------*/\n\n  /* Dropdown Menu */\n  .ui.label.dropdown .menu {\n    min-width: 100%;\n  }\n\n  /*--------------\n      Button\n  ---------------*/\n\n  /* No Margin On Icon Button */\n  .ui.dropdown.icon.button > .dropdown.icon {\n    margin: 0;\n  }\n  .ui.button.dropdown .menu {\n    min-width: 100%;\n  }\n\n\n\n  /*******************************\n                Types\n  *******************************/\n  @if($use-dropdown-type-selection) {\n    /*--------------\n        Selection\n    ---------------*/\n\n    /* Displays like a select box */\n    .ui.selection.dropdown {\n      cursor: pointer;\n      word-wrap: break-word;\n      line-height: 1em;\n      white-space: normal;\n      outline: 0;\n      transform: rotateZ(0deg);\n\n      min-width: $dropdown-selection-min-width;\n      min-height: $dropdown-selection-min-height;\n\n      background: $dropdown-selection-background;\n      display: $dropdown-selection-display;\n      padding: $dropdown-selection-padding;\n      color: $dropdown-selection-text-color;\n      box-shadow: $dropdown-selection-box-shadow;\n      border: $dropdown-selection-border;\n      border-radius: $dropdown-selection-border-radius;\n      transition: $dropdown-selection-transition;\n    }\n    .ui.selection.dropdown.visible,\n    .ui.selection.dropdown.active {\n      z-index: $dropdown-selection-z-index;\n    }\n\n    select.ui.dropdown {\n      height: $dropdown-select-height;\n      padding: $dropdown-select-padding;\n      border: $dropdown-select-border;\n      visibility: $dropdown-select-visibility;\n    }\n    .ui.selection.dropdown > .search.icon,\n    .ui.selection.dropdown > .delete.icon,\n    .ui.selection.dropdown > .dropdown.icon {\n      cursor: pointer;\n      position: absolute;\n      width: auto;\n      height: auto;\n      line-height: $dropdown-search-selection-line-height;\n      top: $dropdown-selection-vertical-padding;\n      right: $dropdown-selection-horizontal-padding;\n      z-index: $dropdown-selection-icon-z-index;\n      margin: $dropdown-selection-icon-margin;\n      padding: $dropdown-selection-icon-padding;\n      opacity: $dropdown-selection-icon-opacity;\n      transition: $dropdown-selection-icon-transition;\n    }\n\n    /* Compact */\n    .ui.compact.selection.dropdown {\n      min-width:  0;\n    }\n\n    /*  Selection Menu */\n    .ui.selection.dropdown .menu {\n      overflow-x: hidden;\n      overflow-y: auto;\n      backface-visibility: hidden;\n      -webkit-overflow-scrolling: touch;\n      border-top-width: 0 !important;\n      width: auto;\n      outline: none;\n      margin: 0 (-$dropdown-menu-border-width);\n      min-width: $dropdown-menu-min-width;\n      width: $dropdown-menu-min-width;\n\n      border-radius: $dropdown-selection-menu-border-radius;\n      box-shadow: $dropdown-selection-menu-box-shadow;\n      transition: $dropdown-selection-menu-transition;\n    }\n    .ui.selection.dropdown .menu:after,\n    .ui.selection.dropdown .menu:before {\n      display: none;\n    }\n\n    /*--------------\n        Message\n    ---------------*/\n\n    .ui.selection.dropdown .menu > .message {\n      padding: $dropdown-selection-message-padding;\n    }\n\n    @media only screen and (max-width : $largest-mobile-screen) {\n      .ui.selection.dropdown[class*=\"very short\"] .menu {\n        max-height: $dropdown-selection-mobile-max-menu-height * 0.5;\n      }\n      .ui.selection.dropdown.short .menu {\n        max-height: $dropdown-selection-mobile-max-menu-height * 0.75;\n      }\n      .ui.selection.dropdown .menu {\n        max-height: $dropdown-selection-mobile-max-menu-height;\n      }\n      .ui.selection.dropdown.long .menu {\n        max-height: $dropdown-selection-mobile-max-menu-height * 2;\n      }\n      .ui.selection.dropdown[class*=\"very long\"] .menu {\n        max-height: $dropdown-selection-mobile-max-menu-height * 3;\n      }\n    }\n    @media only screen and (min-width: $tablet-breakpoint) {\n      .ui.selection.dropdown[class*=\"very short\"] .menu {\n        max-height: $dropdown-selection-tablet-max-menu-height * 0.5;\n      }\n      .ui.selection.dropdown.short .menu {\n        max-height: $dropdown-selection-tablet-max-menu-height * 0.75;\n      }\n      .ui.selection.dropdown .menu {\n        max-height: $dropdown-selection-tablet-max-menu-height;\n      }\n      .ui.selection.dropdown.long .menu {\n        max-height: $dropdown-selection-tablet-max-menu-height * 2;\n      }\n      .ui.selection.dropdown[class*=\"very long\"] .menu {\n        max-height: $dropdown-selection-tablet-max-menu-height * 3;\n      }\n    }\n    @media only screen and (min-width: $computer-breakpoint) {\n      .ui.selection.dropdown[class*=\"very short\"] .menu {\n        max-height: $dropdown-selection-computer-max-menu-height * 0.5;\n      }\n      .ui.selection.dropdown.short .menu {\n        max-height: $dropdown-selection-computer-max-menu-height * 0.75;\n      }\n      .ui.selection.dropdown .menu {\n        max-height: $dropdown-selection-computer-max-menu-height;\n      }\n      .ui.selection.dropdown.long .menu {\n        max-height: $dropdown-selection-computer-max-menu-height * 2;\n      }\n      .ui.selection.dropdown[class*=\"very long\"] .menu {\n        max-height: $dropdown-selection-computer-max-menu-height * 3;\n      }\n    }\n    @media only screen and (min-width: $widescreen-monitor-breakpoint) {\n      .ui.selection.dropdown[class*=\"very short\"] .menu {\n        max-height: $dropdown-selection-widescreen-max-menu-height * 0.5;\n      }\n      .ui.selection.dropdown.short .menu {\n        max-height: $dropdown-selection-widescreen-max-menu-height * 0.75;\n      }\n      .ui.selection.dropdown .menu {\n        max-height: $dropdown-selection-widescreen-max-menu-height;\n      }\n      .ui.selection.dropdown.long .menu {\n        max-height: $dropdown-selection-widescreen-max-menu-height * 2;\n      }\n      .ui.selection.dropdown[class*=\"very long\"] .menu {\n        max-height: $dropdown-selection-widescreen-max-menu-height * 3;\n      }\n    }\n\n    /* Menu Item */\n    .ui.selection.dropdown .menu > .item {\n      border-top: $dropdown-selection-item-divider;\n      padding: $dropdown-selection-item-padding !important;\n      white-space: normal;\n      word-wrap: normal;\n    }\n\n    /* User Item */\n    .ui.selection.dropdown .menu > .hidden.addition.item {\n      display: none;\n    }\n\n    /* Hover */\n    .ui.selection.dropdown:hover {\n      border-color: $dropdown-selection-hover-border-color;\n      box-shadow: $dropdown-selection-hover-box-shadow;\n    }\n\n    /* Active */\n    .ui.selection.active.dropdown {\n      border-color: $dropdown-selection-visible-border-color;\n      box-shadow: $dropdown-selection-visible-box-shadow;\n    }\n    .ui.selection.active.dropdown .menu {\n      border-color: $dropdown-selection-visible-border-color;\n      box-shadow: $dropdown-selection-visible-menu-box-shadow;\n    }\n\n    /* Focus */\n    .ui.selection.dropdown:focus {\n      border-color: $dropdown-selection-focus-border-color;\n      box-shadow: $dropdown-selection-focus-box-shadow;\n    }\n    .ui.selection.dropdown:focus .menu {\n      border-color: $dropdown-selection-focus-border-color;\n      box-shadow: $dropdown-selection-focus-menu-box-shadow;\n    }\n\n    /* Visible */\n    .ui.selection.visible.dropdown > .text:not(.default) {\n      font-weight: $dropdown-selection-visible-text-font-weight;\n      color: $dropdown-selection-visible-text-color;\n    }\n\n    /* Visible Hover */\n    .ui.selection.active.dropdown:hover {\n      border-color: $dropdown-selection-active-hover-border-color;\n      box-shadow: $dropdown-selection-active-hover-box-shadow;\n    }\n    .ui.selection.active.dropdown:hover .menu {\n      border-color: $dropdown-selection-active-hover-border-color;\n      box-shadow: $dropdown-selection-active-hover-menu-box-shadow;\n    }\n\n    /* Dropdown Icon */\n    .ui.active.selection.dropdown > .dropdown.icon,\n    .ui.visible.selection.dropdown > .dropdown.icon {\n      opacity: $dropdown-selection-visible-icon-opacity;\n      z-index: 3;\n    }\n\n    /* Connecting Border */\n    .ui.active.selection.dropdown {\n      border-bottom-left-radius: $dropdown-selection-visible-connecting-border !important;\n      border-bottom-right-radius: $dropdown-selection-visible-connecting-border !important;\n    }\n\n    /* Empty Connecting Border */\n    .ui.active.empty.selection.dropdown {\n      border-radius: $dropdown-selection-border-radius !important;\n      box-shadow: $dropdown-selection-box-shadow !important;\n    }\n    .ui.active.empty.selection.dropdown .menu {\n      border: none !important;\n      box-shadow: none !important;\n    }\n  }\n\n  @if($use-dropdown-type-search) {\n    /*--------------\n      Searchable\n    ---------------*/\n\n    /* Search Selection */\n    .ui.search.dropdown {\n      min-width: $dropdown-search-min-width;\n    }\n\n    /* Search Dropdown */\n    .ui.search.dropdown > input.search {\n      background: none transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n      cursor: text;\n      top: 0;\n      left: $dropdown-text-cursor-spacing;\n      width: 100%;\n      outline: none;\n      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n      padding: inherit;\n    }\n\n    /* Text Layering */\n    .ui.search.dropdown > input.search {\n      position: absolute;\n      z-index: 2;\n    }\n    .ui.search.dropdown > .text {\n      cursor: text;\n      position: relative;\n      left: $dropdown-text-cursor-spacing;\n      z-index: 3;\n    }\n\n    /* Search Selection */\n    .ui.search.selection.dropdown > input.search {\n      line-height: $dropdown-search-selection-line-height;\n      padding: $dropdown-search-selection-input-padding;\n    }\n\n    /* Used to size multi select input to character width */\n    .ui.search.selection.dropdown > span.sizer {\n      line-height: $dropdown-search-selection-line-height;\n      padding: $dropdown-search-selection-input-padding;\n      display: none;\n      white-space: pre;\n    }\n\n    /* Active/Visible Search */\n    .ui.search.dropdown.active > input.search,\n    .ui.search.dropdown.visible > input.search {\n      cursor: auto;\n    }\n    .ui.search.dropdown.active > .text,\n    .ui.search.dropdown.visible > .text {\n      pointer-events: none;\n    }\n\n    /* Filtered Text */\n    .ui.active.search.dropdown input.search:focus + .text .icon,\n    .ui.active.search.dropdown input.search:focus + .text .flag {\n      opacity: $dropdown-selection-text-underlay-icon-opacity;\n    }\n    .ui.active.search.dropdown input.search:focus + .text {\n      color: $dropdown-selection-text-underlay-color !important;\n    }\n\n    /* Search Menu */\n    .ui.search.dropdown .menu {\n      overflow-x: hidden;\n      overflow-y: auto;\n      backface-visibility: hidden;\n      -webkit-overflow-scrolling: touch;\n    }\n    @media only screen and (max-width : $largest-mobile-screen) {\n      .ui.search.dropdown .menu {\n        max-height: $dropdown-search-mobile-max-menu-height;\n      }\n    }\n    @media only screen and (min-width: $tablet-breakpoint) {\n      .ui.search.dropdown .menu {\n        max-height: $dropdown-search-tablet-max-menu-height;\n      }\n    }\n    @media only screen and (min-width: $computer-breakpoint) {\n      .ui.search.dropdown .menu {\n        max-height: $dropdown-search-computer-max-menu-height;\n      }\n    }\n    @media only screen and (min-width: $widescreen-monitor-breakpoint) {\n      .ui.search.dropdown .menu {\n        max-height: $dropdown-search-widescreen-max-menu-height;\n      }\n    }\n  }\n\n\n  @if($use-dropdown-type-clearable) {\n    /* Clearable Selection */\n    .ui.dropdown > .remove.icon {\n      cursor: pointer;\n      font-size: $dropdown-icon-size;\n      margin: $dropdown-selection-icon-margin;\n      padding: $dropdown-selection-icon-padding;\n      right: 3em;\n      top: $dropdown-selection-vertical-padding;\n      position: absolute;\n      opacity: 0.6;\n      z-index: $dropdown-selection-icon-z-index;\n    }\n\n    .ui.clearable.dropdown .text,\n    .ui.clearable.dropdown a:last-of-type {\n      margin-right: 1.5em;\n    }\n\n    .ui.dropdown select.noselection ~ .remove.icon,\n    .ui.dropdown input[value=''] ~ .remove.icon,\n    .ui.dropdown input:not([value]) ~ .remove.icon,\n    .ui.dropdown.loading > .remove.icon {\n      display: none;\n    }\n  }\n\n  @if($use-dropdown-type-multiple) {\n    /*--------------\n        Multiple\n    ---------------*/\n\n    /* Multiple Selection */\n    .ui.multiple.dropdown {\n      padding: $dropdown-multiple-selection-padding;\n    }\n    .ui.multiple.dropdown .menu {\n      cursor: auto;\n    }\n\n    /* Multiple Search Selection */\n    .ui.multiple.search.dropdown,\n    .ui.multiple.search.dropdown > input.search {\n      cursor: text;\n    }\n\n    /* Selection Label */\n    .ui.multiple.dropdown > .label {\n      display: inline-block;\n      white-space: normal;\n      font-size: $dropdown-label-size;\n      padding: $dropdown-label-padding;\n      margin: $dropdown-label-margin;\n      box-shadow: $dropdown-label-box-shadow;\n    }\n\n    /* Dropdown Icon */\n    .ui.multiple.dropdown .dropdown.icon {\n      margin: $dropdown-multiple-selection-icon-margin;\n      padding: $dropdown-multiple-selection-icon-padding;\n    }\n\n    /* Text */\n    .ui.multiple.dropdown > .text {\n      position: static;\n      padding: 0;\n      max-width: 100%;\n      margin: $dropdown-multiple-selection-child-margin;\n      line-height: $dropdown-multiple-selection-child-line-height;\n    }\n    .ui.multiple.dropdown > .label ~ input.search {\n      margin-left: $dropdown-multiple-selection-search-after-label-distance !important;\n    }\n    .ui.multiple.dropdown > .label ~ .text {\n      display: none;\n    }\n    .ui.multiple.dropdown > .label:not(.image) > img:not(.centered) {\n      margin-right: $dropdown-item-element-distance;\n    }\n    .ui.multiple.dropdown > .label:not(.image) > img.ui:not(.avatar) {\n      margin-bottom: $dropdown-item-element-bottom-distance;\n    }\n    .ui.multiple.dropdown > .image.label img {\n      margin: $dropdown-image-label-image-margin;\n      height: $dropdown-image-label-height;\n    }\n\n    @if($use-dropdown-type-search) {\n      /*-----------------\n        Multiple Search\n      -----------------*/\n\n      /* Prompt Text */\n      .ui.multiple.search.dropdown > .text {\n        display: inline-block;\n        position: absolute;\n        top: 0;\n        left: 0;\n        padding: inherit;\n        margin: $dropdown-multiple-selection-child-margin;\n        line-height: $dropdown-multiple-selection-child-line-height;\n      }\n\n      .ui.multiple.search.dropdown > .label ~ .text {\n        display: none;\n      }\n\n      /* Search */\n      .ui.multiple.search.dropdown > input.search {\n        position: static;\n        padding: 0;\n        max-width: 100%;\n        margin: $dropdown-multiple-selection-child-margin;\n        width: $dropdown-multiple-selection-search-start-width;\n        line-height: $dropdown-multiple-selection-child-line-height;\n      }\n    }\n  }\n\n  @if($use-dropdown-type-inline) {\n    /*--------------\n        Inline\n    ---------------*/\n\n    .ui.inline.dropdown {\n      cursor: pointer;\n      display: inline-block;\n      color: $dropdown-inline-text-color;\n    }\n    .ui.inline.dropdown .dropdown.icon {\n      margin: $dropdown-inline-icon-margin;\n      vertical-align: baseline;\n    }\n    .ui.inline.dropdown > .text {\n      font-weight: $dropdown-inline-text-font-weight;\n    }\n    .ui.inline.dropdown .menu {\n      cursor: auto;\n      margin-top: $dropdown-inline-menu-distance;\n      border-radius: $dropdown-inline-menu-border-radius;\n    }\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n\n  /*--------------------\n          Active\n  ----------------------*/\n\n  /* Menu Item Active */\n  .ui.dropdown .menu .active.item {\n    background: $dropdown-active-item-background;\n    font-weight: $dropdown-active-item-font-weight;\n    color: $dropdown-active-item-color;\n    box-shadow: $dropdown-active-item-box-shadow;\n    z-index: $dropdown-active-item-z-index;\n  }\n\n\n  /*--------------------\n          Hover\n  ----------------------*/\n\n  /* Menu Item Hover */\n  .ui.dropdown .menu > .item:hover {\n    background: $dropdown-hovered-item-background;\n    color: $dropdown-hovered-item-color;\n    z-index: $dropdown-hovered-z-index;\n  }\n\n  /*--------------------\n        Loading\n  ---------------------*/\n\n  .ui.loading.dropdown > i.icon {\n    height: $relative14px !important;\n  }\n  .ui.loading.selection.dropdown > i.icon {\n    padding: $relative21px $relative18px !important;\n  }\n  .ui.loading.dropdown > i.icon:before {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n\n    margin: $loader-margin;\n    width: $loader-size;\n    height: $loader-size;\n\n    border-radius: $circular-radius;\n    border: $loader-line-width solid $loader-fill-color;\n  }\n  .ui.loading.dropdown > i.icon:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n    box-shadow: 0 0 0 1px transparent;\n\n    margin: $loader-margin;\n    width: $loader-size;\n    height: $loader-size;\n\n    animation: loader $loader-speed infinite linear;\n    border: $loader-line-width solid $loader-line-color;\n    border-radius: $circular-radius;\n\n  }\n\n  /* Coupling */\n  .ui.loading.dropdown.button > i.icon:before,\n  .ui.loading.dropdown.button > i.icon:after {\n    display: none;\n  }\n\n  /*--------------------\n      Default Text\n  ----------------------*/\n\n  .ui.dropdown:not(.button) > .default.text,\n  .ui.default.dropdown:not(.button) > .text {\n    color: $dropdown-default-text-color;\n  }\n  .ui.dropdown:not(.button) > input:focus ~ .default.text,\n  .ui.default.dropdown:not(.button) > input:focus ~ .text {\n    color: $dropdown-default-text-focus-color;\n  }\n  /*--------------------\n          Loading\n  ----------------------*/\n\n  .ui.loading.dropdown > .text {\n    transition: none;\n  }\n\n  /* Used To Check Position */\n  .ui.dropdown .loading.menu {\n    display: block;\n    visibility: hidden;\n    z-index: $dropdown-loading-z-index;\n  }\n  .ui.dropdown > .loading.menu {\n    left: 0 !important;\n    right: auto !important;\n  }\n  .ui.dropdown > .menu .loading.menu {\n    left: 100% !important;\n    right: auto !important;\n  }\n\n  /*--------------------\n      Keyboard Select\n  ----------------------*/\n\n  /* Selected Item */\n  .ui.dropdown.selected,\n  .ui.dropdown .menu .selected.item {\n    background: $dropdown-selected-background;\n    color: $dropdown-selected-color;\n  }\n\n\n  /*--------------------\n      Search Filtered\n  ----------------------*/\n\n  /* Filtered Item */\n  .ui.dropdown > .filtered.text {\n    visibility: hidden;\n  }\n  .ui.dropdown .filtered.item {\n    display: none !important;\n  }\n\n\n  /*--------------------\n          Error\n  ----------------------*/\n\n  .ui.dropdown.error,\n  .ui.dropdown.error > .text,\n  .ui.dropdown.error > .default.text {\n    color: $error-text-color;\n  }\n\n  .ui.selection.dropdown.error {\n    background: $error-background-color;\n    border-color: $error-border-color;\n  }\n  .ui.selection.dropdown.error:hover {\n    border-color: $error-border-color;\n  }\n\n  .ui.dropdown.error > .menu,\n  .ui.dropdown.error > .menu .menu {\n    border-color: $error-border-color;\n  }\n  .ui.dropdown.error > .menu > .item {\n    color: $dropdown-error-item-text-color;\n  }\n  .ui.multiple.selection.error.dropdown > .label {\n    border-color: $error-border-color;\n  }\n\n  /* Item Hover */\n  .ui.dropdown.error > .menu > .item:hover {\n    background-color: $dropdown-error-item-hover-background;\n  }\n\n  /* Item Active */\n  .ui.dropdown.error > .menu .active.item {\n    background-color: $dropdown-error-item-active-background;\n  }\n\n\n  /*--------------------\n          Clear\n  ----------------------*/\n\n  .ui.dropdown > .clear.dropdown.icon {\n    opacity: $dropdown-clearable-icon-opacity;\n    transition: opacity $default-duration $default-easing;\n  }\n  .ui.dropdown > .clear.dropdown.icon:hover {\n    opacity: $dropdown-clearable-icon-active-opacity;\n  }\n\n\n  /*--------------------\n          Disabled\n  ----------------------*/\n\n  /* Disabled */\n  .ui.disabled.dropdown,\n  .ui.dropdown .menu > .disabled.item {\n    cursor: default;\n    pointer-events: none;\n    opacity: $disabled-opacity;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  /*--------------\n      Direction\n  ---------------*/\n\n  /* Flyout Direction */\n  .ui.dropdown .menu {\n    left: 0;\n  }\n\n\n  /* Default Side (Right) */\n  .ui.dropdown .right.menu > .menu,\n  .ui.dropdown .menu .right.menu {\n    left: 100% !important;\n    right: auto !important;\n    border-radius: $dropdown-sub-menu-border-radius !important;\n  }\n\n  /* Leftward Opening Menu */\n  .ui.dropdown > .left.menu {\n    left: auto !important;\n    right: 0 !important;\n  }\n\n  .ui.dropdown > .left.menu .menu,\n  .ui.dropdown .menu .left.menu {\n    left: auto;\n    right: 100%;\n    margin: $dropdown-left-sub-menu-margin !important;\n    border-radius: $dropdown-left-sub-menu-border-radius !important;\n  }\n\n  .ui.dropdown .item .left.dropdown.icon,\n  .ui.dropdown .left.menu .item .dropdown.icon {\n    width: auto;\n    float: $dropdown-left-menu-icon-float;\n    margin: $dropdown-left-menu-icon-margin;\n  }\n  .ui.dropdown .item .left.dropdown.icon,\n  .ui.dropdown .left.menu .item .dropdown.icon {\n    width: auto;\n    float: $dropdown-left-menu-icon-float;\n    margin: $dropdown-left-menu-icon-margin;\n  }\n  .ui.dropdown .item .left.dropdown.icon + .text,\n  .ui.dropdown .left.menu .item .dropdown.icon + .text {\n    margin-left: $dropdown-item-icon-distance;\n    margin-right: 0;\n  }\n\n\n  /*--------------\n      Upward\n  ---------------*/\n\n  /* Upward Main Menu */\n  .ui.upward.dropdown > .menu {\n    top: auto;\n    bottom: 100%;\n    box-shadow: $dropdown-upward-menu-box-shadow;\n    border-radius: $dropdown-upward-menu-border-radius;\n  }\n\n  /* Upward Sub Menu */\n  .ui.dropdown .upward.menu {\n    top: auto !important;\n    bottom: 0 !important;\n  }\n\n  /* Active Upward */\n  .ui.simple.upward.active.dropdown,\n  .ui.simple.upward.dropdown:hover {\n    border-radius: $dropdown-border-radius $dropdown-border-radius 0 0 !important;\n  }\n  .ui.upward.dropdown.button:not(.pointing):not(.floating).active {\n    border-radius: $dropdown-border-radius $dropdown-border-radius 0 0;\n  }\n\n  /* Selection */\n  .ui.upward.selection.dropdown .menu {\n    border-top-width: $dropdown-menu-border-width !important;\n    border-bottom-width: 0 !important;\n    box-shadow: $dropdown-upward-selection-menu-box-shadow;\n  }\n  .ui.upward.selection.dropdown:hover {\n    box-shadow: $dropdown-upward-selection-hover-box-shadow;\n  }\n\n  /* Active Upward */\n  .ui.active.upward.selection.dropdown {\n    border-radius: $dropdown-upward-selection-visible-border-radius !important;\n  }\n\n  /* Visible Upward */\n  .ui.upward.selection.dropdown.visible {\n    box-shadow: $dropdown-upward-selection-visible-box-shadow;\n    border-radius: $dropdown-upward-selection-visible-border-radius !important;\n  }\n\n  /* Visible Hover Upward */\n  .ui.upward.active.selection.dropdown:hover {\n    box-shadow: $dropdown-upward-selection-active-hover-box-shadow;\n  }\n  .ui.upward.active.selection.dropdown:hover .menu {\n    box-shadow: $dropdown-upward-selection-active-hover-menu-box-shadow;\n  }\n\n  /*--------------\n      Scrolling\n  ---------------*/\n\n  /*  Selection Menu */\n  .ui.scrolling.dropdown .menu,\n  .ui.dropdown .scrolling.menu {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .ui.scrolling.dropdown .menu {\n    overflow-x: hidden;\n    overflow-y: auto;\n    backface-visibility: hidden;\n    -webkit-overflow-scrolling: touch;\n    min-width: 100% !important;\n    width: auto !important;\n  }\n\n  .ui.dropdown .scrolling.menu {\n    position: static;\n    overflow-y: auto;\n    border: none;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n    margin: 0 !important;\n    min-width: 100% !important;\n    width: auto !important;\n    border-top: $dropdown-menu-border;\n  }\n  .ui.scrolling.dropdown .menu .item.item.item,\n  .ui.dropdown .scrolling.menu > .item.item.item {\n    border-top: $dropdown-scrolling-menu-item-border;\n  }\n  .ui.scrolling.dropdown .menu .item:first-child,\n  .ui.dropdown .scrolling.menu .item:first-child {\n    border-top: none;\n  }\n  .ui.dropdown > .animating.menu .scrolling.menu,\n  .ui.dropdown > .visible.menu .scrolling.menu {\n    display: block;\n  }\n\n  /* Scrollbar in IE */\n  @media all and (-ms-high-contrast:none) {\n    .ui.scrolling.dropdown .menu,\n    .ui.dropdown .scrolling.menu {\n      min-width: calc(100% - #{$scrollbar-width});\n    }\n  }\n  @media only screen and (max-width : $largest-mobile-screen) {\n    .ui.scrolling.dropdown .menu,\n    .ui.dropdown .scrolling.menu {\n      max-height: $dropdown-scrolling-mobile-max-menu-height;\n    }\n  }\n  @media only screen and (min-width: $tablet-breakpoint) {\n    .ui.scrolling.dropdown .menu,\n    .ui.dropdown .scrolling.menu {\n      max-height: $dropdown-scrolling-tablet-max-menu-height;\n    }\n  }\n  @media only screen and (min-width: $computer-breakpoint) {\n    .ui.scrolling.dropdown .menu,\n    .ui.dropdown .scrolling.menu {\n      max-height: $dropdown-scrolling-computer-max-menu-height;\n    }\n  }\n  @media only screen and (min-width: $widescreen-monitor-breakpoint) {\n    .ui.scrolling.dropdown .menu,\n    .ui.dropdown .scrolling.menu {\n      max-height: $dropdown-scrolling-widescreen-max-menu-height;\n    }\n  }\n\n  @if($use-dropdown-variation-columnar) {\n    /*--------------\n        Columnar\n    ---------------*/\n    .ui.dropdown[class*=\"two column\"] > .menu > .item {\n      display: inline-block;\n      width: 50%;\n    }\n    .ui.dropdown[class*=\"three column\"] > .menu > .item {\n      display: inline-block;\n      width: 33%;\n    }\n    .ui.dropdown[class*=\"four column\"] > .menu > .item {\n      display: inline-block;\n      width: 25%;\n    }\n    .ui.dropdown[class*=\"five column\"] > .menu > .item {\n      display: inline-block;\n      width: 20%;\n    }\n  }\n\n  @if($use-dropdown-type-simple) {\n    /*--------------\n        Simple\n    ---------------*/\n\n    /* Displays without javascript */\n\n    .ui.simple.dropdown .menu:before,\n    .ui.simple.dropdown .menu:after {\n      display: none;\n    }\n    .ui.simple.dropdown .menu {\n      position: absolute;\n      /* IE hack to make dropdown icons appear inline */\n      display: -ms-inline-flexbox !important;\n      display: block;\n      overflow: hidden;\n      top: -9999px;\n      opacity: 0;\n      width: 0;\n      height: 0;\n      transition: $dropdown-simple-transition;\n      margin-top: 0 !important;\n    }\n\n    .ui.simple.active.dropdown,\n    .ui.simple.dropdown:hover {\n      border-bottom-left-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n\n    .ui.simple.active.dropdown > .menu,\n    .ui.simple.dropdown:hover > .menu {\n      overflow: visible;\n      width: auto;\n      height: auto;\n      top: 100%;\n      opacity: 1;\n    }\n    .ui.simple.dropdown > .menu > .item:active > .menu,\n    .ui.simple.dropdown:hover > .menu > .item:hover > .menu {\n      overflow: visible;\n      width: auto;\n      height: auto;\n      top: 0 !important;\n      left: 100% !important;\n      opacity: 1;\n    }\n    .ui.simple.disabled.dropdown:hover .menu {\n      display: none;\n      height: 0;\n      width: 0;\n      overflow: hidden;\n    }\n\n    /* Visible */\n    .ui.simple.visible.dropdown > .menu {\n      display: block;\n    }\n\n    /* Scrolling */\n    .ui.simple.scrolling.active.dropdown > .menu,\n    .ui.simple.scrolling.dropdown:hover > .menu {\n      overflow-x: hidden;\n      overflow-y: auto;\n    }\n  }\n\n  /*--------------\n        Fluid\n  ---------------*/\n\n  .ui.fluid.dropdown {\n    display: block;\n    width: 100% !important;\n    min-width: 0;\n  }\n  .ui.fluid.dropdown > .dropdown.icon {\n    float: right;\n  }\n\n\n  /*--------------\n      Floating\n  ---------------*/\n\n  .ui.floating.dropdown .menu {\n    left: 0;\n    right: auto;\n    box-shadow: $dropdown-floating-menu-box-shadow !important;\n    border-radius: $dropdown-floating-menu-border-radius !important;\n  }\n  .ui.floating.dropdown > .menu {\n    border-radius: $dropdown-floating-menu-border-radius !important;\n  }\n  .ui:not(.upward).floating.dropdown > .menu {\n    margin-top: $dropdown-floating-menu-distance;\n  }\n  .ui.upward.floating.dropdown > .menu {\n    margin-bottom: $dropdown-floating-menu-distance;\n  }\n\n  @if($use-dropdown-type-pointing) {\n    /*--------------\n        Pointing\n    ---------------*/\n\n    .ui.pointing.dropdown > .menu {\n      top: 100%;\n      margin-top: $dropdown-pointing-menu-distance;\n      border-radius: $dropdown-pointing-menu-border-radius;\n    }\n\n    .ui.pointing.dropdown > .menu:not(.hidden):after {\n      top: $dropdown-pointing-arrow-offset;\n      left: 50%;\n      margin: 0 0 0 $dropdown-pointing-arrow-offset;\n      \n      display: block;\n      position: absolute;\n      pointer-events: none;\n      content: '';\n      visibility: visible;\n      transform: rotate(45deg);\n\n      width: $dropdown-pointing-arrow-size;\n      height: $dropdown-pointing-arrow-size;\n      box-shadow: $dropdown-pointing-arrow-box-shadow;\n      background: $dropdown-pointing-arrow-background;\n      z-index: $dropdown-pointing-arrow-z-index;\n    }\n\n    /* Top Left Pointing */\n    .ui.top.left.pointing.dropdown > .menu {\n      top: 100%;\n      bottom: auto;\n      left: 0;\n      right: auto;\n      margin: $dropdown-pointing-arrow-distance-from-edge 0 0;\n    }\n    .ui.top.left.pointing.dropdown > .menu {\n      top: 100%;\n      bottom: auto;\n      left: 0;\n      right: auto;\n      margin: $dropdown-pointing-arrow-distance-from-edge 0 0;\n    }\n    .ui.top.left.pointing.dropdown > .menu:after {\n      top: $dropdown-pointing-arrow-offset;\n      left: $dropdown-pointing-arrow-distance-from-edge;\n      right: auto;\n      margin: 0;\n      transform: rotate(45deg);\n    }\n    /* Top Right Pointing */\n    .ui.top.right.pointing.dropdown > .menu {\n      top: 100%;\n      bottom: auto;\n      right: 0;\n      left: auto;\n      margin: $dropdown-pointing-arrow-distance-from-edge 0 0;\n    }\n    .ui.top.pointing.dropdown > .left.menu:after,\n    .ui.top.right.pointing.dropdown > .menu:after {\n      top: $dropdown-pointing-arrow-offset;\n      left: auto !important;\n      right: $dropdown-pointing-arrow-distance-from-edge !important;\n      margin: 0;\n      transform: rotate(45deg);\n    }\n\n    /* Left Pointing */\n    .ui.left.pointing.dropdown > .menu {\n      top: 0;\n      left: 100%;\n      right: auto;\n      margin: 0 0 0 $dropdown-pointing-arrow-distance-from-edge;\n    }\n    .ui.left.pointing.dropdown > .menu:after {\n      top: 1em;\n      left: $dropdown-pointing-arrow-offset;\n      margin: 0 0 0 0;\n      transform: rotate(-45deg);\n    }\n    .ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu {\n      left: auto !important;\n      right: 100% !important;\n      margin: 0 $dropdown-pointing-arrow-distance-from-edge 0 0;\n    }\n    .ui.left:not(.top):not(.bottom).pointing.dropdown > .left.menu:after {\n      top: 1em;\n      left: auto;\n      right: $dropdown-pointing-arrow-offset;\n      margin: 0 0 0 0;\n      transform: rotate(135deg);\n    }\n\n\n    /* Right Pointing */\n    .ui.right.pointing.dropdown > .menu {\n      top: 0;\n      left: auto;\n      right: 100%;\n      margin: 0 $dropdown-pointing-arrow-distance-from-edge 0 0;\n    }\n    .ui.right.pointing.dropdown > .menu:after {\n      top: 1em;\n      left: auto;\n      right: $dropdown-pointing-arrow-offset;\n      margin: 0 0 0 0;\n      transform: rotate(135deg);\n    }\n\n    /* Bottom Pointing */\n    .ui.bottom.pointing.dropdown > .menu {\n      top: auto;\n      bottom: 100%;\n      left: 0;\n      right: auto;\n      margin: 0 0 $dropdown-pointing-arrow-distance-from-edge ;\n    }\n    .ui.bottom.pointing.dropdown > .menu:after {\n      top: auto;\n      bottom: $dropdown-pointing-arrow-offset;\n      right: auto;\n      margin: 0;\n      transform: rotate(-135deg);\n    }\n    /* Reverse Sub-Menu Direction */\n    .ui.bottom.pointing.dropdown > .menu .menu {\n      top: auto !important;\n      bottom: 0 !important;\n    }\n\n    /* Bottom Left */\n    .ui.bottom.left.pointing.dropdown > .menu {\n      left: 0;\n      right: auto;\n    }\n    .ui.bottom.left.pointing.dropdown > .menu:after {\n      left: $dropdown-pointing-arrow-distance-from-edge;\n      right: auto;\n    }\n\n    /* Bottom Right */\n    .ui.bottom.right.pointing.dropdown > .menu {\n      right: 0;\n      left: auto;\n    }\n    .ui.bottom.right.pointing.dropdown > .menu:after {\n      left: auto;\n      right: $dropdown-pointing-arrow-distance-from-edge;\n    }\n\n    /* Upward pointing */\n    .ui.pointing.upward.dropdown .menu,\n    .ui.top.pointing.upward.dropdown .menu {\n      top: auto !important;\n      bottom: 100% !important;\n      margin: 0 0 $dropdown-pointing-menu-distance;\n      border-radius: $dropdown-pointing-upward-menu-border-radius;\n    }\n    .ui.pointing.upward.dropdown .menu:after,\n    .ui.top.pointing.upward.dropdown .menu:after {\n      top: 100% !important;\n      bottom: auto !important;\n      box-shadow: $dropdown-pointing-upward-arrow-box-shadow;\n      margin: $dropdown-pointing-arrow-offset 0 0;\n    }\n\n    /* Right Pointing Upward */\n    .ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu {\n      top: auto !important;\n      bottom: 0 !important;\n      margin: 0 $dropdown-pointing-arrow-distance-from-edge 0 0;\n    }\n    .ui.right.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {\n      top: auto !important;\n      bottom: 0 !important;\n      margin: 0 0 $dropdown-pointing-arrow-distance-from-edge 0;\n      box-shadow: $dropdown-pointing-arrow-box-shadow;\n    }\n\n\n    /* Left Pointing Upward */\n    .ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu {\n      top: auto !important;\n      bottom: 0 !important;\n      margin: 0 0 0 $dropdown-pointing-arrow-distance-from-edge;\n    }\n    .ui.left.pointing.upward.dropdown:not(.top):not(.bottom) .menu:after {\n      top: auto !important;\n      bottom: 0 !important;\n      margin: 0 0 $dropdown-pointing-arrow-distance-from-edge 0;\n      box-shadow: $dropdown-pointing-arrow-box-shadow;\n    }\n  }\n\n\n  /*--------------------\n          Sizes\n  ---------------------*/\n\n  /* Dropdown Size */\n  .ui.mini.dropdown {\n    font-size: $mini;\n  }\n  .ui.tiny.dropdown {\n    font-size: $tiny;\n  }\n  .ui.small.dropdown {\n    font-size: $small;\n  }\n  .ui.dropdown {\n    font-size: $medium;\n  }\n  .ui.large.dropdown {\n    font-size: $large;\n  }\n  .ui.big.dropdown {\n    font-size: $big;\n  }\n  .ui.huge.dropdown {\n    font-size: $huge;\n  }\n  .ui.massive.dropdown {\n    font-size: $massive;\n  }\n\n  /* Dropdown Item Size */\n  .ui.mini.dropdown .menu > .item {\n    font-size: $mini;\n  }\n  .ui.tiny.dropdown .menu > .item {\n    font-size: $tiny;\n  }\n  .ui.small.dropdown .menu > .item {\n    font-size: $small;\n  }\n  .ui.dropdown .menu > .item {\n    font-size: $medium;\n  }\n  .ui.large.dropdown .menu > .item {\n    font-size: $large;\n  }\n  .ui.big.dropdown .menu > .item {\n    font-size: $big;\n  }\n  .ui.huge.dropdown .menu > .item {\n    font-size: $huge;\n  }\n  .ui.massive.dropdown .menu > .item {\n    font-size: $massive;\n  }\n\n  @if($use-dropdown-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n\n    /* General rules and basic dropdowns */\n    .ui.inverted.dropdown .menu {\n      background: $dropdown-inverted-menu-background;\n      box-shadow: $dropdown-inverted-menu-box-shadow;\n      border: $dropdown-inverted-menu-border;\n    }\n\n    .ui.inverted.dropdown .menu > .item {\n      color: $dropdown-inverted-menu-color;\n    }\n\n    .ui.inverted.dropdown .menu .active.item {\n      background: $dropdown-inverted-active-item-background;\n      color: $dropdown-inverted-active-item-color;\n      box-shadow: $dropdown-inverted-active-item-box-shadow;\n    }\n\n    .ui.inverted.dropdown .menu > .item:hover {\n      background: $dropdown-inverted-hovered-item-background;\n      color: $dropdown-inverted-hovered-item-color;\n    }\n\n    .ui.inverted.dropdown.selected,\n    .ui.inverted.dropdown .menu .selected.item {\n      background: $dropdown-inverted-selected-background;\n      color: $dropdown-inverted-selected-color;\n    }\n\n    .ui.inverted.dropdown .menu > .header {\n      color: $dropdown-inverted-menu-header-color;\n    }\n\n    .ui.inverted.dropdown > .text > .description,\n    .ui.inverted.dropdown .menu > .item > .description {\n      color: $dropdown-inverted-item-description-color;\n    }\n\n    .ui.inverted.dropdown .menu > .divider {\n      border-top: $dropdown-inverted-menu-divider-border;\n    }\n\n    .ui.inverted.dropdown .scrolling.menu {\n      border: none;\n      border-top: $dropdown-inverted-menu-border;\n    }\n\n    .ui.inverted.dropdown:not(.button) > .default.text,\n    .ui.inverted.default.dropdown:not(.button) > .text {\n      color: $dropdown-inverted-default-text-color;\n    }\n    .ui.inverted.dropdown:not(.button) > input:focus ~ .default.text,\n    .ui.inverted.default.dropdown:not(.button) > input:focus ~ .text {\n      color: $dropdown-inverted-default-text-focus-color;\n    }\n\n    @if($use-dropdown-type-search) {\n      .ui.inverted.active.search.dropdown input.search:focus + .text .icon,\n      .ui.inverted.active.search.dropdown input.search:focus + .text .flag {\n        opacity: $dropdown-inverted-selection-text-underlay-icon-opacity;\n      }\n      .ui.inverted.active.search.dropdown input.search:focus + .text {\n        color: $dropdown-inverted-selection-text-underlay-color !important;\n      }\n    }\n\n    @if($use-dropdown-type-selection) {\n      /* Selection */\n      .ui.inverted.selection.dropdown {\n        border: $dropdown-inverted-selection-border;\n        background: $dropdown-inverted-selection-background;\n        color: $dropdown-inverted-selection-text-color;\n      }\n\n      .ui.inverted.selection.dropdown input {\n        color: $dropdown-inverted-selection-input-text-color;\n      }\n\n      .ui.inverted.selection.dropdown:hover {\n        border-color: $dropdown-inverted-selection-hover-border-color;\n        box-shadow: $dropdown-inverted-selection-hover-box-shadow;\n      }\n      .ui.inverted.selection.active.dropdown .menu,\n      .ui.inverted.selection.active.dropdown:hover {\n        border-color: $dropdown-inverted-selection-visible-border-color;\n      }\n\n      .ui.inverted.selection.dropdown .menu > .item {\n        border-top: $dropdown-inverted-selection-item-divider;\n      }\n\n      .ui.inverted.selection.visible.dropdown > .text:not(.default) {\n        color: $dropdown-inverted-selection-visible-text-color;\n      }\n    }\n\n    .ui.inverted.dropdown .menu > .message:not(.ui) {\n      color: $dropdown-inverted-message-color;\n    }\n\n    /* Fixing the border */\n    .ui.inverted.dropdown .menu > .item:first-child {\n      border-top-width: 0;\n    }\n\n    @if($use-dropdown-type-multiple) {\n      /* Labels */\n      .ui.inverted.multiple.dropdown > .label {\n        background-color: $dropdown-inverted-label-background-color;\n        background-image: $dropdown-inverted-label-background-image;\n        color: $dropdown-inverted-label-color;\n        box-shadow: $dropdown-inverted-label-box-shadow;\n      }\n\n      .ui.inverted.multiple.dropdown > .label:hover {\n        background-color: $dropdown-inverted-label-hover-background-color;\n        border-color: $dropdown-inverted-label-hover-background-color;\n\n        background-image: $dropdown-inverted-label-hover-background-image;\n        color: $dropdown-inverted-label-hover-text-color;\n      }\n\n      .ui.inverted.multiple.dropdown > .label > .close.icon,\n      .ui.inverted.multiple.dropdown > .label > .delete.icon {\n        opacity: $dropdown-inverted-label-icon-opacity;\n      }\n\n      .ui.inverted.multiple.dropdown > .label > .close.icon:hover,\n      .ui.inverted.multiple.dropdown > .label > .delete.icon:hover {\n        opacity: $dropdown-inverted-label-icon-hover-opacity;\n      }\n    }\n    /* Selection for form elements */\n    .ui.inverted.dropdown textarea::-webkit-selection,\n    .ui.inverted.dropdown input::-webkit-selection {\n      background-color: $dropdown-inverted-input-highlight-background;\n      color: $dropdown-inverted-input-highlight-color;\n    }\n    .ui.inverted.dropdown textarea::-moz-selection,\n    .ui.inverted.dropdown input::-moz-selection {\n      background-color: $dropdown-inverted-input-highlight-background;\n      color: $dropdown-inverted-input-highlight-color;\n    }\n    .ui.inverted.dropdown textarea::selection,\n    .ui.inverted.dropdown input::selection {\n      background-color: $dropdown-inverted-input-highlight-background;\n      color: $dropdown-inverted-input-highlight-color;\n    }\n\n    /* Scrollbars */\n    .ui.inverted.dropdown .menu::-webkit-scrollbar-track {\n      background: $track-inverted-background;\n    }\n    .ui.inverted.dropdown .menu::-webkit-scrollbar-thumb {\n      background: $thumb-inverted-background;\n    }\n    .ui.inverted.dropdown .menu::-webkit-scrollbar-thumb:window-inactive {\n      background: $thumb-inverted-inactive-background;\n    }\n    .ui.inverted.dropdown .menu::-webkit-scrollbar-thumb:hover {\n      background: $thumb-inverted-hover-background;\n    }\n\n    @if($use-dropdown-type-pointing) {\n      .ui.inverted.pointing.dropdown > .menu:after {\n        background: $dropdown-inverted-pointing-arrow-background;\n        box-shadow: $dropdown-inverted-pointing-arrow-box-shadow;\n      }\n    }\n  }\n}\n\n@import '../../themes/default/modules/dropdown.style';","@if $use-dropdown {\n  /* Dropdown Carets */\n  @font-face {\n    font-family: 'Dropdown';\n    src:\n      url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfuIIAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zjo82LgAAAFwAAABVGhlYWQAQ88bAAACxAAAADZoaGVhAwcB6QAAAvwAAAAkaG10eAS4ABIAAAMgAAAAIGxvY2EBNgDeAAADQAAAABJtYXhwAAoAFgAAA1QAAAAgbmFtZVcZpu4AAAN0AAABRXBvc3QAAwAAAAAEvAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDX//3//wAB/+MPLQADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAIABJQElABMAABM0NzY3BTYXFhUUDwEGJwYvASY1AAUGBwEACAUGBoAFCAcGgAUBEgcGBQEBAQcECQYHfwYBAQZ/BwYAAQAAAG4BJQESABMAADc0PwE2MzIfARYVFAcGIyEiJyY1AAWABgcIBYAGBgUI/wAHBgWABwaABQWABgcHBgUFBgcAAAABABIASQC3AW4AEwAANzQ/ATYXNhcWHQEUBwYnBi8BJjUSBoAFCAcFBgYFBwgFgAbbBwZ/BwEBBwQJ/wgEBwEBB38GBgAAAAABAAAASQClAW4AEwAANxE0NzYzMh8BFhUUDwEGIyInJjUABQYHCAWABgaABQgHBgVbAQAIBQYGgAUIBwWABgYFBwAAAAEAAAABAADZuaKOXw889QALAgAAAAAA0ABHWAAAAADQAEdYAAAAAAElAW4AAAAIAAIAAAAAAAAAAQAAAeD/4AAAAgAAAAAAASUAAQAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAABAAAAASUAAAElAAAAtwASALcAAAAAAAAACgAUAB4AQgBkAIgAqgAAAAEAAAAIABQAAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAOAAAAAQAAAAAAAgAOAEcAAQAAAAAAAwAOACQAAQAAAAAABAAOAFUAAQAAAAAABQAWAA4AAQAAAAAABgAHADIAAQAAAAAACgA0AGMAAwABBAkAAQAOAAAAAwABBAkAAgAOAEcAAwABBAkAAwAOACQAAwABBAkABAAOAFUAAwABBAkABQAWAA4AAwABBAkABgAOADkAAwABBAkACgA0AGMAaQBjAG8AbQBvAG8AbgBWAGUAcgBzAGkAbwBuACAAMQAuADAAaQBjAG8AbQBvAG8Abmljb21vb24AaQBjAG8AbQBvAG8AbgBSAGUAZwB1AGwAYQByAGkAYwBvAG0AbwBvAG4ARgBvAG4AdAAgAGcAZQBuAGUAcgBhAHQAZQBkACAAYgB5ACAASQBjAG8ATQBvAG8AbgAuAAAAAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=) format('truetype'),\n      url(data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAAVwAAoAAAAABSgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAdkAAAHZLDXE/09TLzIAAALQAAAAYAAAAGAIIweQY21hcAAAAzAAAABMAAAATA9+4ghnYXNwAAADfAAAAAgAAAAIAAAAEGhlYWQAAAOEAAAANgAAADYAQ88baGhlYQAAA7wAAAAkAAAAJAMHAelobXR4AAAD4AAAACAAAAAgBLgAEm1heHAAAAQAAAAABgAAAAYACFAAbmFtZQAABAgAAAFFAAABRVcZpu5wb3N0AAAFUAAAACAAAAAgAAMAAAEABAQAAQEBCGljb21vb24AAQIAAQA6+BwC+BsD+BgEHgoAGVP/i4seCgAZU/+LiwwHi2v4lPh0BR0AAACIDx0AAACNER0AAAAJHQAAAdASAAkBAQgPERMWGyAlKmljb21vb25pY29tb29udTB1MXUyMHVGMEQ3dUYwRDh1RjBEOXVGMERBAAACAYkABgAIAgABAAQABwAKAA0AVgCfAOgBL/yUDvyUDvyUDvuUDvtvi/emFYuQjZCOjo+Pj42Qiwj3lIsFkIuQiY6Hj4iNhouGi4aJh4eHCPsU+xQFiIiGiYaLhouHjYeOCPsU9xQFiI+Jj4uQCA77b4v3FBWLkI2Pjo8I9xT3FAWPjo+NkIuQi5CJjogI9xT7FAWPh42Hi4aLhomHh4eIiIaJhosI+5SLBYaLh42HjoiPiY+LkAgO+92d928Vi5CNkI+OCPcU9xQFjo+QjZCLkIuPiY6Hj4iNhouGCIv7lAWLhomHh4iIh4eJhouGi4aNiI8I+xT3FAWHjomPi5AIDvvdi+YVi/eUBYuQjZCOjo+Pj42Qi5CLkImOhwj3FPsUBY+IjYaLhouGiYeHiAj7FPsUBYiHhomGi4aLh42Hj4iOiY+LkAgO+JQU+JQViwwKAAAAAAMCAAGQAAUAAAFMAWYAAABHAUwBZgAAAPUAGQCEAAAAAAAAAAAAAAAAAAAAARAAAAAAAAAAAAAAAAAAAAAAQAAA8NoB4P/g/+AB4AAgAAAAAQAAAAAAAAAAAAAAIAAAAAAAAgAAAAMAAAAUAAMAAQAAABQABAA4AAAACgAIAAIAAgABACDw2v/9//8AAAAAACDw1//9//8AAf/jDy0AAwABAAAAAAAAAAAAAAABAAH//wAPAAEAAAABAAA5emozXw889QALAgAAAAAA0ABHWAAAAADQAEdYAAAAAAElAW4AAAAIAAIAAAAAAAAAAQAAAeD/4AAAAgAAAAAAASUAAQAAAAAAAAAAAAAAAAAAAAgAAAAAAAAAAAAAAAABAAAAASUAAAElAAAAtwASALcAAAAAUAAACAAAAAAADgCuAAEAAAAAAAEADgAAAAEAAAAAAAIADgBHAAEAAAAAAAMADgAkAAEAAAAAAAQADgBVAAEAAAAAAAUAFgAOAAEAAAAAAAYABwAyAAEAAAAAAAoANABjAAMAAQQJAAEADgAAAAMAAQQJAAIADgBHAAMAAQQJAAMADgAkAAMAAQQJAAQADgBVAAMAAQQJAAUAFgAOAAMAAQQJAAYADgA5AAMAAQQJAAoANABjAGkAYwBvAG0AbwBvAG4AVgBlAHIAcwBpAG8AbgAgADEALgAwAGkAYwBvAG0AbwBvAG5pY29tb29uAGkAYwBvAG0AbwBvAG4AUgBlAGcAdQBsAGEAcgBpAGMAbwBtAG8AbwBuAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('woff')\n    ;\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  .ui.dropdown > .dropdown.icon {\n    font-family: 'Dropdown';\n    line-height: 1;\n    height: 1em;\n    width: 1.23em;\n    backface-visibility: hidden;\n    font-weight: normal;\n    font-style: normal;\n    text-align: center;\n  }\n\n  .ui.dropdown > .dropdown.icon {\n    width: auto;\n  }\n  .ui.dropdown > .dropdown.icon:before {\n    content: '\\f0d7';\n  }\n\n  /* Sub Menu */\n  .ui.dropdown .menu .item .dropdown.icon:before {\n    content: '\\f0da'/*rtl:'\\f0d9'*/;\n  }\n\n  .ui.dropdown .item .left.dropdown.icon:before,\n  .ui.dropdown .left.menu .item .dropdown.icon:before {\n    content: \"\\f0d9\"/*rtl:\"\\f0da\"*/;\n  }\n\n  /* Vertical Menu Dropdown */\n  .ui.vertical.menu .dropdown.item > .dropdown.icon:before {\n    content: \"\\f0da\"/*rtl:\"\\f0d9\"*/;\n  }\n\n  /* Icons for Reference\n  .dropdown.down.icon {\n    content: \"\\f0d7\";\n  }\n  .dropdown.up.icon {\n    content: \"\\f0d8\";\n  }\n  .dropdown.left.icon {\n    content: \"\\f0d9\";\n  }\n  .dropdown.icon.icon {\n    content: \"\\f0da\";\n  }\n  */\n}","@import '../../themes/default/modules/embed.variables';\n\n@if $use-embed {\n  /*******************************\n  //@-        Types\n  *******************************/\n\n  .ui.embed {\n    position: relative;\n    max-width: 100%;\n    height: 0;\n    overflow: hidden;\n    background: $embed-background;\n    padding-bottom: $embed-widescreen-ratio;\n  }\n\n  /*-----------------\n    Embedded Content\n  ------------------*/\n\n  .ui.embed iframe,\n  .ui.embed embed,\n  .ui.embed object {\n    position: absolute;\n    border: none;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n  }\n\n  /*-----------------\n        Embed\n  ------------------*/\n\n  .ui.embed > .embed {\n    display: none;\n  }\n\n  /*--------------\n    Placeholder\n  ---------------*/\n\n  .ui.embed > .placeholder {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    display: block;\n    width: 100%;\n    height: 100%;\n    background-color: $embed-placeholder-background;\n  }\n\n  /*--------------\n        Icon\n  ---------------*/\n\n  .ui.embed > .icon {\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 2;\n  }\n  .ui.embed > .icon:after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 3;\n    content: '';\n    background: $embed-placeholder-background;\n    opacity: $embed-placeholder-background-opacity;\n    transition: $embed-placeholder-background-transition;\n  }\n  .ui.embed > .icon:before {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translateX(-50%) translateY(-50%);\n\n    color: $embed-icon-color;\n    font-size: $embed-icon-size;\n    text-shadow: $embed-icon-shadow;\n    transition: $embed-icon-transition;\n    z-index: $embed-icon-z-index;\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------\n      Hover\n  ---------------*/\n\n  .ui.embed .icon:hover:after {\n    background: $embed-hover-placeholder-background;\n    opacity: $embed-hover-placeholder-background-opacity;\n  }\n  .ui.embed .icon:hover:before {\n    color: $embed-hover-icon-color;\n  }\n\n  /*--------------\n      Active\n  ---------------*/\n\n  .ui.active.embed > .icon,\n  .ui.active.embed > .placeholder {\n    display: none;\n  }\n  .ui.active.embed > .embed {\n    display: block;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  .ui.square.embed {\n    padding-bottom: $embed-square-ratio;\n  }\n  .ui[class*=\"4:3\"].embed {\n    padding-bottom: $embed-standard-ratio;\n  }\n  .ui[class*=\"16:9\"].embed {\n    padding-bottom: $embed-widescreen-ratio;\n  }\n  .ui[class*=\"21:9\"].embed {\n    padding-bottom: $embed-ultra-widescreen-ratio;\n  }\n\n}\n\n@import '../../themes/default/modules/embed.style';","@import '../../themes/default/modules/modal.variables';\r\n\r\n@if $use-modal {\r\n  /*******************************\r\n  //@-         Modal\r\n  *******************************/\r\n\r\n  .ui.modal {\r\n    position: absolute;\r\n    display: none;\r\n    z-index: $modal-z-index;\r\n    text-align: left;\r\n\r\n    background: $modal-background;\r\n    border: $modal-border;\r\n    box-shadow: $modal-box-shadow;\r\n    transform-origin: $modal-transform-origin;\r\n\r\n    flex: 0 0 auto;\r\n\r\n    border-radius: $modal-border-radius;\r\n    user-select: text;\r\n    will-change: top, left, margin, transform, opacity;\r\n  }\r\n\r\n  .ui.modal > :first-child:not(.icon):not(.dimmer),\r\n  .ui.modal > .icon:first-child + *,\r\n  .ui.modal > .dimmer:first-child + *:not(.icon),\r\n  .ui.modal > .dimmer:first-child + .icon + * {\r\n    border-top-left-radius: $modal-border-radius;\r\n    border-top-right-radius: $modal-border-radius;\r\n  }\r\n\r\n  .ui.modal > :last-child {\r\n    border-bottom-left-radius: $modal-border-radius;\r\n    border-bottom-right-radius: $modal-border-radius;\r\n  }\r\n\r\n  /*******************************\r\n              Content\r\n  *******************************/\r\n\r\n  /*--------------\r\n      Close\r\n  ---------------*/\r\n\r\n  .ui.modal > .close {\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top: $modal-close-top;\r\n    right: $modal-close-right;\r\n    z-index: 1;\r\n\r\n    opacity: $modal-close-opacity;\r\n    font-size: $modal-close-size;\r\n    color: $modal-close-color;\r\n\r\n    width: $modal-close-hitbox;\r\n    height: $modal-close-hitbox;\r\n    padding: $modal-close-padding;\r\n  }\r\n  .ui.modal > .close:hover {\r\n    opacity: 1;\r\n  }\r\n\r\n  /*--------------\r\n      Header\r\n  ---------------*/\r\n\r\n  .ui.modal > .header {\r\n    display: block;\r\n    font-family: $modal-header-font-family;\r\n    background: $modal-header-background;\r\n    margin: $modal-header-margin;\r\n    padding: $modal-header-padding;\r\n    box-shadow: $modal-header-box-shadow;\r\n\r\n    color: $modal-header-color;\r\n    border-bottom: $modal-header-border;\r\n  }\r\n  .ui.modal > .header:not(.ui) {\r\n    font-size: $modal-header-font-size;\r\n    line-height: $header-line-height;\r\n    font-weight: $modal-header-font-weight;\r\n  }\r\n\r\n  /*--------------\r\n      Content\r\n  ---------------*/\r\n\r\n  .ui.modal > .content {\r\n    display: block;\r\n    width: 100%;\r\n    font-size: $modal-content-font-size;\r\n    line-height: $modal-content-line-height;\r\n    padding: $modal-content-padding;\r\n    background: $modal-content-background;\r\n  }\r\n  .ui.modal > .image.content {\r\n    display: flex;\r\n    flex-direction: row;\r\n  }\r\n\r\n  /* Image */\r\n  .ui.modal > .content > .image {\r\n    display: block;\r\n    flex: 0 1 auto;\r\n    width: $modal-image-width;\r\n    align-self: $modal-image-vertical-align;\r\n    max-width: 100%;\r\n  }\r\n  .ui.modal > [class*=\"top aligned\"] {\r\n    align-self: start;\r\n  }\r\n  .ui.modal > [class*=\"middle aligned\"] {\r\n    align-self: center;\r\n  }\r\n  .ui.modal > [class*=\"stretched\"] {\r\n    align-self: stretch;\r\n  }\r\n\r\n  /* Description */\r\n  .ui.modal > .content > .description {\r\n    display: block;\r\n    flex: 1 0 auto;\r\n    min-width: 0;\r\n    align-self: $modal-description-vertical-align;\r\n  }\r\n\r\n  .ui.modal > .content > .icon + .description,\r\n  .ui.modal > .content > .image + .description {\r\n    flex: 0 1 auto;\r\n    min-width: $modal-description-min-width;\r\n    width: $modal-description-width;\r\n    padding-left: $modal-description-distance;\r\n  }\r\n\r\n  /*rtl:ignore*/\r\n  .ui.modal > .content > .image > i.icon {\r\n    margin: 0;\r\n    opacity: 1;\r\n    width: auto;\r\n    line-height: 1;\r\n    font-size: $modal-image-icon-size;\r\n  }\r\n\r\n  /*--------------\r\n      Actions\r\n  ---------------*/\r\n\r\n  .ui.modal > .actions {\r\n    background: $modal-action-background;\r\n    padding: $modal-action-padding;\r\n    border-top: $modal-action-border;\r\n    text-align: $modal-action-align;\r\n  }\r\n  .ui.modal .actions > .button {\r\n    margin-left: $modal-button-distance;\r\n  }\r\n  .ui.basic.modal > .actions {\r\n    border-top:none;\r\n  }\r\n\r\n  /*-------------------\r\n        Responsive\r\n  --------------------*/\r\n\r\n  /* Modal Width */\r\n  @media only screen and (max-width : $largest-mobile-screen) {\r\n    .ui.modal:not(.fullscreen) {\r\n      width: calc(#{$modal-mobile-width} - 1px);\r\n      margin: $modal-mobile-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $tablet-breakpoint) {\r\n    .ui.modal:not(.fullscreen) {\r\n      width: calc(#{$modal-tablet-width} - 1px);\r\n      margin: $modal-tablet-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $computer-breakpoint) {\r\n    .ui.modal:not(.fullscreen) {\r\n      width: $modal-computer-width;\r\n      margin: $modal-computer-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $large-monitor-breakpoint) {\r\n    .ui.modal:not(.fullscreen) {\r\n      width: $modal-large-monitor-width;\r\n      margin: $modal-large-monitor-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $widescreen-monitor-breakpoint) {\r\n    .ui.modal:not(.fullscreen) {\r\n      width: $modal-widescreen-monitor-width;\r\n      margin: $modal-widescreen-monitor-margin;\r\n    }\r\n  }\r\n\r\n  /* Tablet and Mobile */\r\n  @media only screen and (max-width : $largest-tablet-screen) {\r\n    .ui.modal > .header {\r\n      padding-right: $modal-close-hitbox;\r\n    }\r\n    .ui.modal > .close {\r\n      top: $modal-inner-close-top;\r\n      right: $modal-inner-close-right;\r\n      color: $modal-inner-close-color;\r\n    }\r\n  }\r\n\r\n  /* Mobile */\r\n  @media only screen and (max-width : $largest-mobile-screen) {\r\n\r\n    .ui.modal > .header {\r\n      padding: $modal-mobile-header-padding !important;\r\n      padding-right: $modal-close-hitbox !important;\r\n    }\r\n    .ui.overlay.fullscreen.modal > .content.content.content {\r\n      min-height: $modal-overlay-fullscreen-scrolling-content-max-height-mobile;\r\n    }\r\n    .ui.overlay.fullscreen.modal > .scrolling.content.content.content {\r\n      max-height: $modal-overlay-fullscreen-scrolling-content-max-height-mobile;\r\n    }\r\n    .ui.modal > .content {\r\n      display: block;\r\n      padding: $modal-mobile-content-padding !important;\r\n    }\r\n    .ui.modal > .close {\r\n      top: $modal-mobile-close-top !important;\r\n      right: $modal-mobile-close-right !important;\r\n    }\r\n\r\n    /*rtl:ignore*/\r\n    .ui.modal .image.content {\r\n      flex-direction: column;\r\n    }\r\n    .ui.modal .content > .image {\r\n      display: block;\r\n      max-width: 100%;\r\n      margin: 0 auto !important;\r\n      text-align: center;\r\n      padding: $modal-mobile-image-padding !important;\r\n    }\r\n    .ui.modal > .content > .image > i.icon {\r\n      font-size: $modal-mobile-image-icon-size;\r\n      text-align: center;\r\n    }\r\n\r\n    /*rtl:ignore*/\r\n    .ui.modal .content > .description {\r\n      display: block;\r\n      width: 100% !important;\r\n      margin: 0 !important;\r\n      padding: $modal-mobile-description-padding !important;\r\n      box-shadow: none;\r\n    }\r\n\r\n    /* Let Buttons Stack */\r\n    .ui.modal > .actions {\r\n      padding: $modal-mobile-action-padding !important;\r\n    }\r\n    .ui.modal .actions > .buttons,\r\n    .ui.modal .actions > .button {\r\n      margin-bottom: $modal-mobile-button-distance;\r\n    }\r\n  }\r\n\r\n  /*--------------\r\n      Coupling\r\n  ---------------*/\r\n\r\n  .ui.inverted.dimmer > .ui.modal {\r\n    box-shadow: $modal-inverted-box-shadow;\r\n  }\r\n\r\n  /*******************************\r\n              Types\r\n  *******************************/\r\n\r\n  @if($use-modal-type-basic) {\r\n    .ui.basic.modal {\r\n      background-color: transparent;\r\n      border: none;\r\n      border-radius: 0;\r\n      box-shadow: none !important;\r\n      color: $modal-basic-color;\r\n    }\r\n    .ui.basic.modal > .header,\r\n    .ui.basic.modal > .content,\r\n    .ui.basic.modal > .actions {\r\n      background-color: transparent;\r\n    }\r\n    .ui.basic.modal > .header {\r\n      color: $modal-basic-header-color;\r\n    }\r\n    .ui.basic.modal > .close {\r\n      top: $modal-basic-close-top;\r\n      right: $modal-basic-close-right;\r\n      color: $modal-basic-inner-close-color;\r\n    }\r\n\r\n    .ui.inverted.dimmer > .basic.modal {\r\n      color: $modal-basic-inverted-color;\r\n    }\r\n    .ui.inverted.dimmer > .ui.basic.modal > .header {\r\n      color: $modal-basic-inverted-header-color;\r\n    }\r\n  }\r\n\r\n  /* Resort to margin positioning if legacy */\r\n  .ui.legacy.legacy.modal,\r\n  .ui.legacy.legacy.page.dimmer > .ui.modal {\r\n    left: 50% !important;\r\n  }\r\n  .ui.legacy.legacy.modal:not(.aligned),\r\n  .ui.legacy.legacy.page.dimmer > .ui.modal:not(.aligned) {\r\n    top: 50%;\r\n  }\r\n  .ui.legacy.legacy.page.dimmer > .ui.scrolling.modal:not(.aligned),\r\n  .ui.page.dimmer > .ui.scrolling.legacy.legacy.modal:not(.aligned),\r\n  .ui.top.aligned.legacy.legacy.page.dimmer > .ui.modal:not(.aligned),\r\n  .ui.top.aligned.dimmer > .ui.legacy.legacy.modal:not(.aligned) {\r\n    top: auto;\r\n  }\r\n\r\n  .ui.legacy.overlay.fullscreen.modal {\r\n    margin-top: -$modal-scrolling-margin !important;\r\n  }\r\n\r\n  /*******************************\r\n              States\r\n  *******************************/\r\n\r\n  .ui.loading.modal {\r\n    display: block;\r\n    visibility: hidden;\r\n    z-index: $modal-loading-z-index;\r\n  }\r\n\r\n  .ui.active.modal {\r\n    display: block;\r\n  }\r\n\r\n  /*******************************\r\n            Variations\r\n  *******************************/\r\n\r\n  /*--------------\r\n    Aligned\r\n  ---------------*/\r\n\r\n  .ui.top.aligned.modal {\r\n    top: $modal-top-aligned-margin;\r\n  }\r\n  .ui.bottom.aligned.modal {\r\n    bottom: $modal-bottom-aligned-margin;\r\n  }\r\n\r\n  @media only screen and (max-width : $largest-mobile-screen) {\r\n    .ui.top.aligned.modal {\r\n      top: $modal-mobile-top-aligned-margin;\r\n    }\r\n    .ui.bottom.aligned.modal {\r\n      bottom: $modal-mobile-bottom-aligned-margin;\r\n    }\r\n  }\r\n\r\n\r\n  /*--------------\r\n      Scrolling\r\n  ---------------*/\r\n\r\n  /* Scrolling Dimmer */\r\n  .scrolling.dimmable.dimmed {\r\n    overflow: hidden;\r\n  }\r\n  .scrolling.dimmable > .dimmer {\r\n    justify-content: flex-start;\r\n    position: fixed;\r\n  }\r\n  .scrolling.dimmable.dimmed > .dimmer {\r\n    overflow: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n  .modals.dimmer .ui.scrolling.modal:not(.fullscreen) {\r\n    margin: $modal-scrolling-margin auto;\r\n  }\r\n\r\n  /* Undetached Scrolling */\r\n  .scrolling.undetached.dimmable.dimmed {\r\n    overflow: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n  .scrolling.undetached.dimmable.dimmed > .dimmer {\r\n    overflow: hidden;\r\n  }\r\n  .scrolling.undetached.dimmable .ui.scrolling.modal:not(.fullscreen) {\r\n    position: absolute;\r\n    left: 50%;\r\n    margin-top: $modal-scrolling-margin !important;\r\n  }\r\n\r\n  /* Scrolling Content */\r\n  .ui.modal > .scrolling.content {\r\n    max-height: $modal-scrolling-content-max-height;\r\n    overflow: auto;\r\n  }\r\n  .ui.overlay.fullscreen.modal > .content {\r\n    min-height: $modal-overlay-fullscreen-scrolling-content-max-height;\r\n  }\r\n  .ui.overlay.fullscreen.modal > .scrolling.content {\r\n    max-height: $modal-overlay-fullscreen-scrolling-content-max-height;\r\n  }\r\n\r\n  @if($use-modal-type-fullscreen) {\r\n    /*--------------\r\n      Full Screen\r\n    ---------------*/\r\n\r\n    .ui.fullscreen.modal {\r\n      width: $modal-full-screen-width;\r\n      left: $modal-full-screen-offset;\r\n      margin: $modal-full-screen-margin;\r\n    }\r\n    .ui.overlay.fullscreen.modal {\r\n      width: 100%;\r\n      left: 0;\r\n      margin: 0 auto;\r\n      top: 0;\r\n      border-radius:0;\r\n    }\r\n    .ui.fullscreen.modal > .header {\r\n      padding-right: $modal-close-hitbox;\r\n    }\r\n    .ui.fullscreen.modal > .close {\r\n      top: $modal-inner-close-top;\r\n      right: $modal-inner-close-right;\r\n      color: $modal-inner-close-color;\r\n    }\r\n    .ui.basic.fullscreen.modal > .close {\r\n      color: $modal-basic-inner-close-color;\r\n    }\r\n  }\r\n\r\n  /*--------------\r\n        Size\r\n  ---------------*/\r\n\r\n  .ui.modal {\r\n    font-size: $medium;\r\n  }\r\n\r\n  /* Mini */\r\n  .ui.mini.modal > .header:not(.ui) {\r\n    font-size: $modal-mini-header-size;\r\n  }\r\n\r\n  /* Mini Modal Width */\r\n  @media only screen and (max-width : $largest-mobile-screen) {\r\n    .ui.mini.modal {\r\n      width: $modal-mini-mobile-width;\r\n      margin: $modal-mini-mobile-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $tablet-breakpoint) {\r\n    .ui.mini.modal {\r\n      width: $modal-mini-tablet-width;\r\n      margin: $modal-mini-tablet-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $computer-breakpoint) {\r\n    .ui.mini.modal {\r\n      width: $modal-mini-computer-width;\r\n      margin: $modal-mini-computer-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $large-monitor-breakpoint) {\r\n    .ui.mini.modal {\r\n      width: $modal-mini-large-monitor-width;\r\n      margin: $modal-mini-large-monitor-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $widescreen-monitor-breakpoint) {\r\n    .ui.mini.modal {\r\n      width: $modal-mini-widescreen-monitor-width;\r\n      margin: $modal-mini-widescreen-monitor-margin;\r\n    }\r\n  }\r\n\r\n  /* Tiny */\r\n  .ui.tiny.modal > .header:not(.ui) {\r\n    font-size: $modal-tiny-header-size;\r\n  }\r\n\r\n  /* Tiny Modal Width */\r\n  @media only screen and (max-width : $largest-mobile-screen) {\r\n    .ui.tiny.modal {\r\n      width: $modal-tiny-mobile-width;\r\n      margin: $modal-tiny-mobile-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $tablet-breakpoint) {\r\n    .ui.tiny.modal {\r\n      width: $modal-tiny-tablet-width;\r\n      margin: $modal-tiny-tablet-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $computer-breakpoint) {\r\n    .ui.tiny.modal {\r\n      width: $modal-tiny-computer-width;\r\n      margin: $modal-tiny-computer-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $large-monitor-breakpoint) {\r\n    .ui.tiny.modal {\r\n      width: $modal-tiny-large-monitor-width;\r\n      margin: $modal-tiny-large-monitor-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $widescreen-monitor-breakpoint) {\r\n    .ui.tiny.modal {\r\n      width: $modal-tiny-widescreen-monitor-width;\r\n      margin: $modal-tiny-widescreen-monitor-margin;\r\n    }\r\n  }\r\n\r\n  /* Small */\r\n  .ui.small.modal > .header:not(.ui) {\r\n    font-size: $modal-small-header-size;\r\n  }\r\n\r\n  /* Small Modal Width */\r\n  @media only screen and (max-width : $largest-mobile-screen) {\r\n    .ui.small.modal {\r\n      width: $modal-small-mobile-width;\r\n      margin: $modal-small-mobile-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $tablet-breakpoint) {\r\n    .ui.small.modal {\r\n      width: $modal-small-tablet-width;\r\n      margin: $modal-small-tablet-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $computer-breakpoint) {\r\n    .ui.small.modal {\r\n      width: $modal-small-computer-width;\r\n      margin: $modal-small-computer-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $large-monitor-breakpoint) {\r\n    .ui.small.modal {\r\n      width: $modal-small-large-monitor-width;\r\n      margin: $modal-small-large-monitor-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $widescreen-monitor-breakpoint) {\r\n    .ui.small.modal {\r\n      width: $modal-small-widescreen-monitor-width;\r\n      margin: $modal-small-widescreen-monitor-margin;\r\n    }\r\n  }\r\n\r\n  /* Large Modal Width */\r\n  .ui.large.modal > .header {\r\n    font-size: $modal-large-header-size;\r\n  }\r\n  @media only screen and (max-width : $largest-mobile-screen) {\r\n    .ui.large.modal {\r\n      width: $modal-large-mobile-width;\r\n      margin: $modal-large-mobile-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $tablet-breakpoint) {\r\n    .ui.large.modal {\r\n      width: $modal-large-tablet-width;\r\n      margin: $modal-large-tablet-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $computer-breakpoint) {\r\n    .ui.large.modal {\r\n      width: $modal-large-computer-width;\r\n      margin: $modal-large-computer-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $large-monitor-breakpoint) {\r\n    .ui.large.modal {\r\n      width: $modal-large-large-monitor-width;\r\n      margin: $modal-large-large-monitor-margin;\r\n    }\r\n  }\r\n  @media only screen and (min-width : $widescreen-monitor-breakpoint) {\r\n    .ui.large.modal {\r\n      width: $modal-large-widescreen-monitor-width;\r\n      margin: $modal-large-widescreen-monitor-margin;\r\n    }\r\n  }\r\n\r\n\r\n  @if($use-modal-type-inverted) {\r\n    /*****************************\r\n              Inverted\r\n    *******************************/\r\n\r\n    .ui.inverted.modal {\r\n      background: $modal-inverted-background;\r\n    }\r\n\r\n    .ui.inverted.modal > .header,\r\n    .ui.inverted.modal > .content {\r\n      background: $modal-inverted-background;\r\n      color: $modal-inverted-header-color;\r\n    }\r\n\r\n    .ui.inverted.modal > .actions {\r\n      background: $modal-inverted-action-background;\r\n      border-top: $modal-inverted-action-border;\r\n      color: $modal-inverted-action-color;\r\n    }\r\n\r\n    .ui.inverted.dimmer > .modal > .close {\r\n      color: $modal-inverted-dimmer-close-color;\r\n    }\r\n\r\n\r\n    @media only screen and (max-width: $largest-tablet-screen) {\r\n      .ui.dimmer .inverted.modal > .close {\r\n        color: $modal-inverted-close-color;\r\n      }\r\n    }\r\n\r\n    .ui.inverted.fullscreen.modal > .close {\r\n      color: $modal-inverted-close-color;\r\n    }\r\n  }\r\n}\r\n\r\n@import '../../themes/default/modules/modal.style';","@import '../../themes/default/modules/nag.variables';\n\n@if $use-nag {\n  /*******************************\n  //@-         Nag\n  *******************************/\n\n  .ui.nag {\n    display: none;\n    opacity: $nag-opacity;\n    position: $nag-position;\n\n    top: $nag-top;\n    left: 0;\n    z-index: $nag-z-index;\n\n    min-height: $nag-min-height;\n    width: $nag-width;\n\n    margin: $nag-margin;\n    padding: $nag-padding;\n\n    background: $nag-background;\n    box-shadow: $nag-box-shadow;\n\n    font-size: $nag-font-size;\n    text-align: $nag-text-align;\n    color: $nag-color;\n\n    border-radius: $nag-top-border-radius;\n    transition: $nag-transition;\n  }\n\n  a.ui.nag {\n    cursor: pointer;\n  }\n\n  .ui.nag > .title {\n    display: inline-block;\n    margin: $nag-title-margin;\n    color: $nag-title-color;\n  }\n\n\n  .ui.nag > .close.icon {\n    cursor: pointer;\n    opacity: $nag-close-opacity;\n\n    position: absolute;\n    top: $nag-close-top;\n    right: $nag-close-right;\n\n    font-size: $nag-close-size;\n\n    margin: $nag-close-margin;\n    color: $nag-close-color;\n    transition: $nag-close-transition;\n  }\n\n\n\n  /*******************************\n              States\n  *******************************/\n\n  /* Hover */\n  .ui.nag:hover {\n    background: $nag-hover-background;\n    opacity: $nag-hover-opacity;\n  }\n\n  .ui.nag .close:hover {\n    opacity: $nag-close-hover-opacity;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n\n  /*--------------\n      Static\n  ---------------*/\n\n  .ui.overlay.nag {\n    position: absolute;\n    display: block;\n  }\n\n  /*--------------\n      Fixed\n  ---------------*/\n\n  .ui.fixed.nag {\n    position: fixed;\n  }\n\n  /*--------------\n      Bottom\n  ---------------*/\n\n  .ui.bottom.nags,\n  .ui.bottom.nag {\n    border-radius: $nag-bottom-border-radius;\n    top: auto;\n    bottom: $nag-bottom;\n  }\n\n  /*--------------\n      White\n  ---------------*/\n\n  .ui.inverted.nags .nag,\n  .ui.inverted.nag {\n    background-color: $nag-inverted-background;\n    color: $dark-text-color;\n  }\n  .ui.inverted.nags .nag .close,\n  .ui.inverted.nags .nag .title,\n  .ui.inverted.nag .close,\n  .ui.inverted.nag .title {\n    color: $light-text-color;\n  }\n\n\n  /*******************************\n            Groups\n  *******************************/\n\n  .ui.nags .nag {\n    border-radius: $nag-grouped-border-radius !important;\n  }\n  .ui.nags .nag:last-child {\n    border-radius: $nag-top-border-radius;\n  }\n  .ui.bottom.nags .nag:last-child {\n    border-radius: $nag-bottom-border-radius;\n  }\n}\n\n@import '../../themes/default/modules/nag.style';","@import '../../themes/default/modules/popup.variables';\n\n@if $use-popup {\n  /*******************************\n  //@-        Popup\n  *******************************/\n\n  .ui.popup {\n    display: none;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    /* Fixes content being squished when inline (moz only) */\n    min-width: min-content;\n    z-index: $popup-z-index;\n\n    border: $popup-border;\n    line-height: $line-height;\n    max-width: $popup-max-width;\n    background: $popup-background;\n\n    padding: $popup-vertical-padding $popup-horizontal-padding;\n    font-weight: $popup-font-weight;\n    font-style: $popup-font-style;\n    color: $popup-color;\n\n    border-radius: $popup-border-radius;\n    box-shadow: $popup-box-shadow;\n  }\n  .ui.popup > .header {\n    padding: 0;\n\n    font-family: $header-font;\n    font-size: $popup-header-font-size;\n    line-height: $popup-header-line-height;\n    font-weight: $popup-header-font-weight;\n  }\n  .ui.popup > .header + .content {\n    padding-top: $popup-header-distance;\n  }\n\n  .ui.popup:before {\n    position: absolute;\n    content: '';\n    width: $popup-arrow-size;\n    height: $popup-arrow-size;\n\n    background: $popup-arrow-background;\n    transform: rotate(45deg);\n\n    z-index: $popup-arrow-z-index;\n    box-shadow: $popup-arrow-box-shadow;\n  }\n\n  /*******************************\n              Types\n  *******************************/\n\n  /*--------------\n      Tooltip\n  ---------------*/\n\n  /* Content */\n  [data-tooltip] {\n    position: relative;\n  }\n\n  /* Arrow */\n  [data-tooltip]:before {\n    pointer-events: none;\n    position: absolute;\n    content: '';\n    font-size: $medium;\n    width: $popup-arrow-size;\n    height: $popup-arrow-size;\n\n    background: $popup-tooltip-arrow-background;\n    transform: rotate(45deg);\n\n    z-index: $popup-arrow-z-index;\n    box-shadow: $popup-tooltip-arrow-box-shadow;\n  }\n\n  /* Popup */\n  [data-tooltip]:after {\n    pointer-events: none;\n    content: attr(data-tooltip);\n    position: absolute;\n    text-transform: none;\n    text-align: left;\n    white-space: nowrap;\n\n    font-size: $popup-tooltip-font-size;\n\n    border: $popup-tooltip-border;\n    line-height: $popup-tooltip-line-height;\n    max-width: $popup-tooltip-max-width;\n    background: $popup-tooltip-background;\n\n    padding: $popup-tooltip-padding;\n    font-weight: $popup-tooltip-font-weight;\n    font-style: $popup-tooltip-font-style;\n    color: $popup-tooltip-color;\n\n    border-radius: $popup-tooltip-border-radius;\n    box-shadow: $popup-tooltip-box-shadow;\n    z-index: $popup-tooltip-z-index;\n  }\n\n  /* Default Position (Top Center) */\n  [data-tooltip]:not([data-position]):before {\n    top: auto;\n    right: auto;\n    bottom: 100%;\n    left: 50%;\n    background: $popup-tooltip-arrow-bottom-background;\n    margin-left: $popup-tooltip-arrow-horizontal-offset;\n    margin-bottom: -$popup-tooltip-arrow-vertical-offset;\n  }\n  [data-tooltip]:not([data-position]):after {\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 100%;\n    margin-bottom: $popup-tooltip-distance-away;\n  }\n\n  /* Animation */\n  [data-tooltip]:before,\n  [data-tooltip]:after {\n    pointer-events: none;\n    visibility: hidden;\n  }\n  [data-tooltip]:before {\n    opacity: 0;\n    transform: rotate(45deg) scale(0) !important;\n    transform-origin: center top;\n    transition:\n      all $popup-tooltip-duration $popup-tooltip-easing\n    ;\n  }\n  [data-tooltip]:after {\n    opacity: 1;\n    transform-origin: center bottom;\n    transition:\n      all $popup-tooltip-duration $popup-tooltip-easing\n    ;\n  }\n  [data-tooltip]:hover:before,\n  [data-tooltip]:hover:after {\n    visibility: visible;\n    pointer-events: auto;\n  }\n  [data-tooltip]:hover:before {\n    transform: rotate(45deg) scale(1) !important;\n    opacity: 1;\n  }\n\n  /* Animation Position */\n  [data-tooltip]:after,\n  [data-tooltip][data-position=\"top center\"]:after,\n  [data-tooltip][data-position=\"bottom center\"]:after {\n    transform: translateX(-50%) scale(0) !important;\n  }\n  [data-tooltip]:hover:after,\n  [data-tooltip][data-position=\"bottom center\"]:hover:after {\n    transform: translateX(-50%) scale(1) !important;\n  }\n  [data-tooltip][data-position=\"left center\"]:after,\n  [data-tooltip][data-position=\"right center\"]:after {\n    transform: translateY(-50%) scale(0) !important;\n  }\n  [data-tooltip][data-position=\"left center\"]:hover:after,\n  [data-tooltip][data-position=\"right center\"]:hover:after {\n    transform: translateY(-50%) scale(1) !important;\n  }\n  [data-tooltip][data-position=\"top left\"]:after,\n  [data-tooltip][data-position=\"top right\"]:after,\n  [data-tooltip][data-position=\"bottom left\"]:after,\n  [data-tooltip][data-position=\"bottom right\"]:after {\n    transform: scale(0) !important;\n  }\n  [data-tooltip][data-position=\"top left\"]:hover:after,\n  [data-tooltip][data-position=\"top right\"]:hover:after,\n  [data-tooltip][data-position=\"bottom left\"]:hover:after,\n  [data-tooltip][data-position=\"bottom right\"]:hover:after {\n    transform: scale(1) !important;\n  }\n\n\n  /*--------------\n      Inverted\n  ---------------*/\n\n  /* Arrow */\n  [data-tooltip][data-inverted]:before {\n    box-shadow: none !important;\n  }\n\n  /* Arrow Position */\n  [data-tooltip][data-inverted]:before {\n    background: $popup-inverted-arrow-bottom-background;\n  }\n\n  /* Popup  */\n  [data-tooltip][data-inverted]:after {\n    background: $popup-tooltip-inverted-background;\n    color: $popup-tooltip-inverted-color;\n    border: $popup-tooltip-inverted-border;\n    box-shadow: $popup-tooltip-inverted-box-shadow;\n  }\n  [data-tooltip][data-inverted]:after .header {\n    background: $popup-tooltip-inverted-header-background;\n    color: $popup-tooltip-inverted-header-color;\n  }\n\n  /*--------------\n      Position\n  ---------------*/\n\n  /* Top Center */\n  [data-position=\"top center\"][data-tooltip]:after {\n    top: auto;\n    right: auto;\n    left: 50%;\n    bottom: 100%;\n    transform: translateX(-50%);\n    margin-bottom: $popup-tooltip-distance-away;\n  }\n  [data-position=\"top center\"][data-tooltip]:before {\n    top: auto;\n    right: auto;\n    bottom: 100%;\n    left: 50%;\n    background: $popup-tooltip-arrow-top-background;\n    margin-left: $popup-tooltip-arrow-horizontal-offset;\n    margin-bottom: -$popup-tooltip-arrow-vertical-offset;\n  }\n\n  /* Top Left */\n  [data-position=\"top left\"][data-tooltip]:after {\n    top: auto;\n    right: auto;\n    left: 0;\n    bottom: 100%;\n    margin-bottom: $popup-tooltip-distance-away;\n  }\n  [data-position=\"top left\"][data-tooltip]:before {\n    top: auto;\n    right: auto;\n    bottom: 100%;\n    left: $popup-arrow-distance-from-edge;\n    margin-left: $popup-tooltip-arrow-horizontal-offset;\n    margin-bottom: -$popup-tooltip-arrow-vertical-offset;\n  }\n\n  /* Top Right */\n  [data-position=\"top right\"][data-tooltip]:after {\n    top: auto;\n    left: auto;\n    right: 0;\n    bottom: 100%;\n    margin-bottom: $popup-tooltip-distance-away;\n  }\n  [data-position=\"top right\"][data-tooltip]:before {\n    top: auto;\n    left: auto;\n    bottom: 100%;\n    right: $popup-arrow-distance-from-edge;\n    margin-left: $popup-tooltip-arrow-horizontal-offset;\n    margin-bottom: -$popup-tooltip-arrow-vertical-offset;\n  }\n\n\n  /* Bottom Center */\n  [data-position=\"bottom center\"][data-tooltip]:after {\n    bottom: auto;\n    right: auto;\n    left: 50%;\n    top: 100%;\n    transform: translateX(-50%);\n    margin-top: $popup-tooltip-distance-away;\n  }\n  [data-position=\"bottom center\"][data-tooltip]:before {\n    bottom: auto;\n    right: auto;\n    top: 100%;\n    left: 50%;\n    margin-left: $popup-tooltip-arrow-horizontal-offset;\n    margin-top: -$popup-tooltip-arrow-vertical-offset;\n  }\n\n  /* Bottom Left */\n  [data-position=\"bottom left\"][data-tooltip]:after {\n    left: 0;\n    top: 100%;\n    margin-top: $popup-tooltip-distance-away;\n  }\n  [data-position=\"bottom left\"][data-tooltip]:before {\n    bottom: auto;\n    right: auto;\n    top: 100%;\n    left: $popup-arrow-distance-from-edge;\n    margin-left: $popup-tooltip-arrow-horizontal-offset;\n    margin-top: -$popup-tooltip-arrow-vertical-offset;\n  }\n\n  /* Bottom Right */\n  [data-position=\"bottom right\"][data-tooltip]:after {\n    right: 0;\n    top: 100%;\n    margin-top: $popup-tooltip-distance-away;\n  }\n  [data-position=\"bottom right\"][data-tooltip]:before {\n    bottom: auto;\n    left: auto;\n    top: 100%;\n    right: $popup-arrow-distance-from-edge;\n    margin-left: $popup-tooltip-arrow-vertical-offset;\n    margin-top: -$popup-tooltip-arrow-horizontal-offset;\n  }\n\n  /* Left Center */\n  [data-position=\"left center\"][data-tooltip]:after {\n    right: 100%;\n    top: 50%;\n    margin-right: $popup-tooltip-distance-away;\n    transform: translateY(-50%);\n  }\n  [data-position=\"left center\"][data-tooltip]:before {\n    right: 100%;\n    top: 50%;\n    margin-top: $popup-tooltip-arrow-vertical-offset;\n    margin-right: $popup-tooltip-arrow-horizontal-offset;\n  }\n\n  /* Right Center */\n  [data-position=\"right center\"][data-tooltip]:after {\n    left: 100%;\n    top: 50%;\n    margin-left: $popup-tooltip-distance-away;\n    transform: translateY(-50%);\n  }\n  [data-position=\"right center\"][data-tooltip]:before {\n    left: 100%;\n    top: 50%;\n    margin-top: $popup-tooltip-arrow-horizontal-offset;\n    margin-left: -$popup-tooltip-arrow-vertical-offset;\n  }\n\n  /* Arrow */\n  [data-position~=\"bottom\"][data-tooltip]:before {\n    background: $popup-arrow-top-background;\n    box-shadow: $popup-bottom-arrow-box-shadow;\n  }\n  [data-position=\"left center\"][data-tooltip]:before {\n    background: $popup-arrow-center-background;\n    box-shadow: $popup-left-arrow-box-shadow;\n  }\n  [data-position=\"right center\"][data-tooltip]:before {\n    background: $popup-arrow-center-background;\n    box-shadow: $popup-right-arrow-box-shadow;\n  }\n  [data-position~=\"top\"][data-tooltip]:before {\n    background: $popup-arrow-bottom-background;\n  }\n\n  /* Inverted Arrow Color */\n  [data-inverted][data-position~=\"bottom\"][data-tooltip]:before {\n    background: $popup-inverted-arrow-top-background;\n    box-shadow: $popup-bottom-arrow-box-shadow;\n  }\n  [data-inverted][data-position=\"left center\"][data-tooltip]:before {\n    background: $popup-inverted-arrow-center-background;\n    box-shadow: $popup-left-arrow-box-shadow;\n  }\n  [data-inverted][data-position=\"right center\"][data-tooltip]:before {\n    background: $popup-inverted-arrow-center-background;\n    box-shadow: $popup-right-arrow-box-shadow;\n  }\n  [data-inverted][data-position~=\"top\"][data-tooltip]:before {\n    background: $popup-inverted-arrow-bottom-background;\n  }\n\n  [data-position~=\"bottom\"][data-tooltip]:before {\n    transform-origin: center bottom;\n  }\n  [data-position~=\"bottom\"][data-tooltip]:after {\n    transform-origin: center top;\n  }\n  [data-position=\"left center\"][data-tooltip]:before {\n    transform-origin: top center;\n  }\n  [data-position=\"left center\"][data-tooltip]:after {\n    transform-origin: right center;\n  }\n  [data-position=\"right center\"][data-tooltip]:before {\n    transform-origin: right center;\n  }\n  [data-position=\"right center\"][data-tooltip]:after {\n    transform-origin: left center;\n  }\n\n  /*--------------\n      Size\n  ---------------*/\n\n  [data-tooltip][data-variation~=\"mini\"]:before,\n  [data-tooltip][data-variation~=\"mini\"]:after {\n    font-size: $mini;\n  }\n  [data-tooltip][data-variation~=\"tiny\"]:before,\n  [data-tooltip][data-variation~=\"tiny\"]:after {\n    font-size: $tiny;\n  }\n  [data-tooltip][data-variation~=\"small\"]:before,\n  [data-tooltip][data-variation~=\"small\"]:after {\n    font-size: $small;\n  }\n  [data-tooltip][data-variation~=\"medium\"]:before,\n  [data-tooltip][data-variation~=\"medium\"]:after {\n    font-size: $medium;\n  }\n  [data-tooltip][data-variation~=\"large\"]:before,\n  [data-tooltip][data-variation~=\"large\"]:after {\n    font-size: $large;\n  }\n  [data-tooltip][data-variation~=\"huge\"]:before,\n  [data-tooltip][data-variation~=\"huge\"]:after {\n    font-size: $huge;\n  }\n\n  /*--------------\n      Basic\n  ---------------*/\n  [data-tooltip][data-variation~=\"basic\"]:before {\n    display: none;\n  }\n\n  /*--------------\n      Spacing\n  ---------------*/\n\n  .ui.popup {\n    margin: 0;\n  }\n\n  /* Extending from Top */\n  .ui.top.popup {\n    margin: 0 0 $popup-distance-away;\n  }\n  .ui.top.left.popup {\n    transform-origin: left bottom;\n  }\n  .ui.top.center.popup {\n    transform-origin: center bottom;\n  }\n  .ui.top.right.popup {\n    transform-origin: right bottom;\n  }\n\n  /* Extending from Vertical Center */\n  .ui.left.center.popup {\n    margin: 0 $popup-distance-away 0 0;\n    transform-origin: right 50%;\n  }\n  .ui.right.center.popup {\n    margin: 0 0 0 $popup-distance-away;\n    transform-origin: left 50%;\n  }\n\n  /* Extending from Bottom */\n  .ui.bottom.popup {\n    margin: $popup-distance-away 0 0;\n  }\n  .ui.bottom.left.popup {\n    transform-origin: left top;\n  }\n  .ui.bottom.center.popup {\n    transform-origin: center top;\n  }\n  .ui.bottom.right.popup {\n    transform-origin: right top;\n  }\n\n  /*--------------\n      Pointer\n  ---------------*/\n\n  /*--- Below ---*/\n  .ui.bottom.center.popup:before {\n    margin-left: $popup-arrow-offset;\n    top: $popup-arrow-offset;\n    left: 50%;\n    right: auto;\n    bottom: auto;\n    box-shadow: $popup-bottom-arrow-box-shadow;\n  }\n\n  .ui.bottom.left.popup {\n    margin-left: $popup-box-arrow-offset;\n  }\n  /*rtl:rename*/\n  .ui.bottom.left.popup:before {\n    top: $popup-arrow-offset;\n    left: $popup-arrow-distance-from-edge;\n    right: auto;\n    bottom: auto;\n    margin-left: 0;\n    box-shadow: $popup-bottom-arrow-box-shadow;\n  }\n\n  .ui.bottom.right.popup {\n    margin-right: $popup-box-arrow-offset;\n  }\n  /*rtl:rename*/\n  .ui.bottom.right.popup:before {\n    top: $popup-arrow-offset;\n    right: $popup-arrow-distance-from-edge;\n    bottom: auto;\n    left: auto;\n    margin-left: 0;\n    box-shadow: $popup-bottom-arrow-box-shadow;\n  }\n\n  /*--- Above ---*/\n  .ui.top.center.popup:before {\n    top: auto;\n    right: auto;\n    bottom: $popup-arrow-offset;\n    left: 50%;\n    margin-left: $popup-arrow-offset;\n  }\n  .ui.top.left.popup {\n    margin-left: $popup-box-arrow-offset;\n  }\n  /*rtl:rename*/\n  .ui.top.left.popup:before {\n    bottom: $popup-arrow-offset;\n    left: $popup-arrow-distance-from-edge;\n    top: auto;\n    right: auto;\n    margin-left: 0;\n  }\n  .ui.top.right.popup {\n    margin-right: $popup-box-arrow-offset;\n  }\n  /*rtl:rename*/\n  .ui.top.right.popup:before {\n    bottom: $popup-arrow-offset;\n    right: $popup-arrow-distance-from-edge;\n    top: auto;\n    left: auto;\n    margin-left: 0;\n  }\n\n  /*--- Left Center ---*/\n  /*rtl:rename*/\n  .ui.left.center.popup:before {\n    top: 50%;\n    right: $popup-arrow-offset;\n    bottom: auto;\n    left: auto;\n    margin-top: $popup-arrow-offset;\n    box-shadow: $popup-left-arrow-box-shadow;\n  }\n\n  /*--- Right Center  ---*/\n  /*rtl:rename*/\n  .ui.right.center.popup:before {\n    top: 50%;\n    left: $popup-arrow-offset;\n    bottom: auto;\n    right: auto;\n    margin-top: $popup-arrow-offset;\n    box-shadow: $popup-right-arrow-box-shadow;\n  }\n\n  /* Arrow Color By Location */\n  .ui.bottom.popup:before {\n    background: $popup-arrow-top-background;\n  }\n  .ui.right.center.popup:before,\n  .ui.left.center.popup:before {\n    background: $popup-arrow-center-background;\n  }\n  .ui.top.popup:before {\n    background: $popup-arrow-bottom-background;\n  }\n\n  /* Inverted Arrow Color */\n  .ui.inverted.bottom.popup:before {\n    background: $popup-inverted-arrow-top-background;\n  }\n  .ui.inverted.right.center.popup:before,\n  .ui.inverted.left.center.popup:before {\n    background: $popup-inverted-arrow-center-background;\n  }\n  .ui.inverted.top.popup:before {\n    background: $popup-inverted-arrow-bottom-background;\n  }\n\n\n  /*******************************\n              Coupling\n  *******************************/\n\n  /* Immediate Nested Grid */\n  .ui.popup > .ui.grid:not(.padded) {\n    width: $popup-nested-grid-width;\n    margin: $popup-nested-grid-margin;\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  .ui.loading.popup {\n    display: block;\n    visibility: hidden;\n    z-index: $popup-loading-z-index;\n  }\n\n  .ui.animating.popup,\n  .ui.visible.popup {\n    display: block;\n  }\n\n  .ui.visible.popup {\n    transform: translateZ(0);\n    backface-visibility: hidden;\n  }\n\n\n  /*******************************\n              Variations\n  *******************************/\n\n  /*--------------\n      Basic\n  ---------------*/\n\n  .ui.basic.popup:before {\n    display: none;\n  }\n\n\n  /*--------------\n      Wide\n  ---------------*/\n\n  .ui.wide.popup {\n    max-width: $popup-wide-width;\n  }\n  .ui[class*=\"very wide\"].popup {\n    max-width: $popup-very-wide-width;\n  }\n\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.wide.popup,\n    .ui[class*=\"very wide\"].popup {\n      max-width: $popup-max-width;\n    }\n  }\n\n\n  /*--------------\n      Fluid\n  ---------------*/\n\n  .ui.fluid.popup {\n    width: 100%;\n    max-width: none;\n  }\n\n\n  @if($use-popup-variation-inverted) {\n    /*--------------\n        Colors\n    ---------------*/\n\n    /* Inverted colors  */\n    .ui.inverted.popup {\n      background: $popup-inverted-background;\n      color: $popup-inverted-color;\n      border: $popup-inverted-border;\n      box-shadow: $popup-inverted-box-shadow;\n    }\n    .ui.inverted.popup .header {\n      background-color: $popup-inverted-header-background;\n      color: $popup-inverted-header-color;\n    }\n    .ui.inverted.popup:before {\n      background-color: $popup-inverted-arrow-color;\n      box-shadow: none !important;\n    }\n  }\n\n  /*--------------\n      Flowing\n  ---------------*/\n\n  .ui.flowing.popup {\n    max-width: none;\n  }\n\n\n  /*--------------\n      Sizes\n  ---------------*/\n\n  .ui.mini.popup {\n    font-size: $mini;\n  }\n  .ui.tiny.popup {\n    font-size: $tiny;\n  }\n  .ui.small.popup {\n    font-size: $small;\n  }\n  .ui.popup {\n    font-size: $medium;\n  }\n  .ui.large.popup {\n    font-size: $large;\n  }\n  .ui.huge.popup {\n    font-size: $huge;\n  }\n}\n\n@import '../../themes/default/modules/popup.style';","@import '../../themes/default/modules/progress.variables';\n\n@if $use-progress {\n  /*******************************\n  //@-       Progress\n  *******************************/\n\n  .ui.progress {\n    position: relative;\n    display: block;\n    max-width: 100%;\n    border: $progress-border;\n    margin: $progress-margin;\n    box-shadow: $progress-box-shadow;\n    background: $progress-background;\n    padding: $progress-padding;\n    border-radius: $progress-border-radius;\n  }\n\n  .ui.progress:first-child {\n    margin: $progress-first-margin;\n  }\n  .ui.progress:last-child {\n    margin: $progress-last-margin;\n  }\n\n  /*******************************\n              Content\n  *******************************/\n\n  /* Activity Bar */\n  .ui.progress .bar {\n    display: block;\n    line-height: 1;\n    position: $progress-bar-position;\n    width: $progress-bar-initial-width;\n    min-width: $progress-bar-min-width;\n    background: $progress-bar-background;\n    border-radius: $progress-bar-border-radius;\n    transition: $progress-bar-transition;\n    overflow: hidden;\n  }\n  .ui.ui.ui.progress:not([data-percent]):not(.indeterminate) .bar,\n  .ui.ui.ui.progress[data-percent=\"0\"]:not(.indeterminate) .bar {\n    background:transparent;\n  }\n  .ui.progress[data-percent=\"0\"] .bar .progress {\n    color: $text-color;\n  }\n  @if($use-progress-variation-inverted) {\n    .ui.inverted.progress[data-percent=\"0\"] .bar .progress {\n      color: $inverted-text-color;\n    }\n  }\n\n  /* Percent Complete */\n  .ui.progress .bar > .progress {\n    white-space: nowrap;\n    position: $progress-position;\n    width: $progress-width;\n    font-size: $progress-size;\n    top: $progress-top;\n    right: $progress-right;\n    left: $progress-left;\n    bottom: $progress-bottom;\n    color: $progress-color;\n    text-shadow: $progress-text-shadow;\n    margin-top: $progress-offset;\n    font-weight: $progress-font-weight;\n    text-align: $progress-text-align;\n  }\n\n  /* Label */\n  .ui.progress > .label {\n    position: absolute;\n    width: $progress-label-width;\n    font-size: $progress-label-size;\n    top: $progress-label-top;\n    right: $progress-label-right;\n    left: $progress-label-left;\n    bottom: $progress-label-bottom;\n    color: $progress-label-color;\n    font-weight: $progress-label-font-weight;\n    text-shadow: $progress-label-text-shadow;\n    margin-top: $progress-label-offset;\n    text-align: $progress-label-text-align;\n    transition: $progress-label-transition;\n  }\n\n\n  /*******************************\n              Types\n  *******************************/\n\n\n  /* Indicating */\n  .ui.indicating.progress[data-percent^=\"1\"] .bar,\n  .ui.indicating.progress[data-percent^=\"2\"] .bar {\n    background-color: $progress-indicating-first-color;\n  }\n  .ui.indicating.progress[data-percent^=\"3\"] .bar {\n    background-color: $progress-indicating-second-color;\n  }\n  .ui.indicating.progress[data-percent^=\"4\"] .bar,\n  .ui.indicating.progress[data-percent^=\"5\"] .bar {\n    background-color: $progress-indicating-third-color;\n  }\n  .ui.indicating.progress[data-percent^=\"6\"] .bar {\n    background-color: $progress-indicating-fourth-color;\n  }\n  .ui.indicating.progress[data-percent^=\"7\"] .bar,\n  .ui.indicating.progress[data-percent^=\"8\"] .bar {\n    background-color: $progress-indicating-fifth-color;\n  }\n  .ui.indicating.progress[data-percent^=\"9\"] .bar,\n  .ui.indicating.progress[data-percent^=\"100\"] .bar {\n    background-color: $progress-indicating-sixth-color;\n  }\n\n  /* Indicating Label */\n  .ui.indicating.progress[data-percent^=\"1\"] .label,\n  .ui.indicating.progress[data-percent^=\"2\"] .label {\n    color: $progress-indicating-first-label-color;\n  }\n  .ui.indicating.progress[data-percent^=\"3\"] .label {\n    color: $progress-indicating-second-label-color;\n  }\n  .ui.indicating.progress[data-percent^=\"4\"] .label,\n  .ui.indicating.progress[data-percent^=\"5\"] .label {\n    color: $progress-indicating-third-label-color;\n  }\n  .ui.indicating.progress[data-percent^=\"6\"] .label {\n    color: $progress-indicating-fourth-label-color;\n  }\n  .ui.indicating.progress[data-percent^=\"7\"] .label,\n  .ui.indicating.progress[data-percent^=\"8\"] .label {\n    color: $progress-indicating-fifth-label-color;\n  }\n  .ui.indicating.progress[data-percent^=\"9\"] .label,\n  .ui.indicating.progress[data-percent^=\"100\"] .label {\n    color: $progress-indicating-sixth-label-color;\n  }\n\n  @if($use-progress-variation-inverted) {\n    /* Inverted Indicating Label */\n    .ui.inverted.indicating.progress[data-percent^=\"1\"] .label,\n    .ui.inverted.indicating.progress[data-percent^=\"2\"] .label {\n      color: $progress-inverted-indicating-first-label-color;\n    }\n    .ui.inverted.indicating.progress[data-percent^=\"3\"] .label {\n      color: $progress-inverted-indicating-second-label-color;\n    }\n    .ui.inverted.indicating.progress[data-percent^=\"4\"] .label,\n    .ui.inverted.indicating.progress[data-percent^=\"5\"] .label {\n      color: $progress-inverted-indicating-third-label-color;\n    }\n    .ui.inverted.indicating.progress[data-percent^=\"6\"] .label {\n      color: $progress-inverted-indicating-fourth-label-color;\n    }\n    .ui.inverted.indicating.progress[data-percent^=\"7\"] .label,\n    .ui.inverted.indicating.progress[data-percent^=\"8\"] .label {\n      color: $progress-inverted-indicating-fifth-label-color;\n    }\n    .ui.inverted.indicating.progress[data-percent^=\"9\"] .label,\n    .ui.inverted.indicating.progress[data-percent^=\"100\"] .label {\n      color: $progress-inverted-indicating-sixth-label-color;\n    }\n  }\n\n  /* Single Digits */\n  .ui.indicating.progress[data-percent=\"1\"] .bar,\n  .ui.indicating.progress[data-percent=\"2\"] .bar,\n  .ui.indicating.progress[data-percent=\"3\"] .bar,\n  .ui.indicating.progress[data-percent=\"4\"] .bar,\n  .ui.indicating.progress[data-percent=\"5\"] .bar,\n  .ui.indicating.progress[data-percent=\"6\"] .bar,\n  .ui.indicating.progress[data-percent=\"7\"] .bar,\n  .ui.indicating.progress[data-percent=\"8\"] .bar,\n  .ui.indicating.progress[data-percent=\"9\"] .bar {\n    background-color: $progress-indicating-first-color;\n  }\n  .ui.indicating.progress[data-percent=\"0\"] .label,\n  .ui.indicating.progress[data-percent=\"1\"] .label,\n  .ui.indicating.progress[data-percent=\"2\"] .label,\n  .ui.indicating.progress[data-percent=\"3\"] .label,\n  .ui.indicating.progress[data-percent=\"4\"] .label,\n  .ui.indicating.progress[data-percent=\"5\"] .label,\n  .ui.indicating.progress[data-percent=\"6\"] .label,\n  .ui.indicating.progress[data-percent=\"7\"] .label,\n  .ui.indicating.progress[data-percent=\"8\"] .label,\n  .ui.indicating.progress[data-percent=\"9\"] .label {\n    color: $progress-indicating-first-label-color;\n  }\n\n  @if($use-progress-variation-inverted) {\n    .ui.inverted.indicating.progress[data-percent=\"0\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"1\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"2\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"3\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"4\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"5\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"6\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"7\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"8\"] .label,\n    .ui.inverted.indicating.progress[data-percent=\"9\"] .label {\n      color: $progress-inverted-indicating-first-label-color;\n    }\n  }\n\n  /* Indicating Success */\n  .ui.ui.indicating.progress.success .label {\n    color: $success-header-color;\n  }\n\n  /* Multiple */\n  .ui.multiple.progress {\n    display: flex;\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n\n  /*--------------\n      Success\n  ---------------*/\n\n  .ui.ui.progress.success .bar {\n    background-color: $success-color;\n  }\n  .ui.ui.progress.success .bar,\n  .ui.ui.progress.success .bar::after {\n    animation: none;\n  }\n  .ui.progress.success > .label {\n    color: $success-header-color;\n  }\n\n  /*--------------\n      Warning\n  ---------------*/\n\n  .ui.ui.progress.warning .bar {\n    background-color: $warning-color;\n  }\n  .ui.ui.progress.warning .bar,\n  .ui.ui.progress.warning .bar::after {\n    animation: none;\n  }\n  .ui.progress.warning > .label {\n    color: $warning-header-color;\n  }\n\n  /*--------------\n      Error\n  ---------------*/\n\n  .ui.ui.progress.error .bar {\n    background-color: $error-color;\n  }\n  .ui.ui.progress.error .bar,\n  .ui.ui.progress.error .bar::after {\n    animation: none;\n  }\n  .ui.progress.error > .label {\n    color: $error-header-color;\n  }\n\n  /*--------------\n      Active\n  ---------------*/\n\n  .ui.active.progress .bar {\n    position: relative;\n    min-width: $progress-active-min-width;\n  }\n  .ui.active.progress .bar::after {\n    content: '';\n    opacity: 0;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: $progress-active-pulse-color;\n\n    border-radius: $progress-bar-border-radius;\n\n    animation: progress-active $progress-active-pulse-duration $default-easing infinite;\n    transform-origin: left;\n  }\n  @keyframes progress-active {\n    0% {\n      opacity: $progress-active-pulse-max-opacity;\n      transform: scale(0, 1);\n    }\n    100% {\n      opacity: 0;\n      transform: scale(1);\n    }\n  }\n\n  /*--------------\n      Disabled\n  ---------------*/\n\n  .ui.disabled.progress {\n    opacity: 0.35;\n  }\n  .ui.ui.disabled.progress .bar,\n  .ui.ui.disabled.progress .bar::after {\n    animation: none;\n  }\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  @if($use-progress-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n\n    .ui.inverted.progress {\n      background: $progress-inverted-background;\n      border: $progress-inverted-border;\n    }\n    .ui.inverted.progress .bar {\n      background: $progress-inverted-bar-background;\n    }\n    .ui.inverted.progress .bar > .progress {\n      color: $progress-inverted-color;\n    }\n    .ui.inverted.progress > .label {\n      color: $progress-inverted-label-color;\n    }\n    .ui.inverted.progress.success > .label {\n      color: $success-color;\n    }\n    .ui.inverted.progress.warning > .label {\n      color: $warning-color;\n    }\n    .ui.inverted.progress.error > .label {\n      color: $error-color;\n    }\n  }\n\n  @if($use-progress-variation-attached) {\n    /*--------------\n        Attached\n    ---------------*/\n\n    /* bottom attached */\n    .ui.progress.attached {\n      background: $progress-attached-background;\n      position: relative;\n      border: none;\n      margin: 0;\n    }\n    .ui.progress.attached,\n    .ui.progress.attached .bar {\n      display: block;\n      height: $progress-attached-height;\n      padding: 0;\n      overflow: hidden;\n      border-radius: 0 0 $progress-attached-border-radius $progress-attached-border-radius;\n    }\n    .ui.progress.attached .bar {\n      border-radius: 0;\n    }\n\n    /* top attached */\n    .ui.progress.top.attached,\n    .ui.progress.top.attached .bar {\n      top: 0;\n      border-radius: $progress-attached-border-radius $progress-attached-border-radius 0 0;\n    }\n    .ui.progress.top.attached .bar {\n      border-radius: 0;\n    }\n\n    /* Coupling */\n    .ui.segment > .ui.attached.progress,\n    .ui.card > .ui.attached.progress {\n      position: absolute;\n      top: auto;\n      left: 0;\n      bottom: 100%;\n      width: 100%;\n    }\n    .ui.segment > .ui.bottom.attached.progress,\n    .ui.card > .ui.bottom.attached.progress {\n      top: 100%;\n      bottom: auto;\n    }\n  }\n\n  /*--------------\n      Colors\n  ---------------*/\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-progress-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $l: map-get($value, light);\n\n      .ui.indeterminate.#{$key + \"\"}.progress .bar::before,\n      .ui.#{$key + \"\"}.progress .bar,\n      .ui.progress .#{$key + \"\"}.bar {\n        background-color: $c;\n      }\n      @if($use-progress-variation-inverted) {\n        .ui.inverted.indeterminate.#{$key + \"\"}.progress .bar::before,\n        .ui.#{$key + \"\"}.inverted.progress .bar,\n        .ui.inverted.progress .#{$key + \"\"}.bar {\n          background-color: $l;\n        }\n      }\n    }\n  }\n\n  /*--------------\n      Sizes\n  ---------------*/\n\n  .ui.tiny.progress {\n    font-size: $tiny;\n  }\n  .ui.tiny.progress .bar {\n    height: $progress-tiny-bar-height;\n  }\n\n  .ui.small.progress {\n    font-size: $small;\n  }\n  .ui.small.progress .bar {\n    height: $progress-small-bar-height;\n  }\n\n  .ui.progress {\n    font-size: $medium;\n  }\n  .ui.progress .bar {\n    height: $progress-bar-height;\n  }\n\n  .ui.large.progress {\n    font-size: $large;\n  }\n  .ui.large.progress .bar {\n    height: $progress-large-bar-height;\n  }\n\n  .ui.big.progress {\n    font-size: $big;\n  }\n  .ui.big.progress .bar {\n    height: $progress-big-bar-height;\n  }\n\n  /*---------------\n    Indeterminate\n  ----------------*/\n\n  .ui.indeterminate.progress .bar {\n    width: 100%;\n  }\n  .ui.indeterminate.progress .bar .progress,\n  .ui.progress .bar .centered.progress {\n    text-align: center;\n    position: relative;\n  }\n  .ui.indeterminate.progress .bar::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    border-radius: $progress-bar-border-radius;\n    animation: progress-pulsating $progress-indeterminate-pulse-duration $default-easing infinite;\n    transform-origin: center;\n    width: 100%;\n  }\n  .ui.slow.indeterminate.progress .bar::before {\n    animation-duration: $progress-indeterminate-pulse-duration-slow;\n  }\n  .ui.fast.indeterminate.progress .bar::before {\n    animation-duration: $progress-indeterminate-pulse-duration-fast;\n  }\n  .ui.swinging.indeterminate.progress .bar::before {\n    transform-origin: left;\n    animation-name: progress-swinging;\n  }\n  .ui.sliding.indeterminate.progress .bar::before {\n    transform-origin: left;\n    animation-name: progress-sliding;\n  }\n  .ui.filling.indeterminate.progress .bar::before {\n    animation-name: progress-filling;\n  }\n  .ui.indeterminate.progress:not(.sliding):not(.filling):not(.swinging) .bar::before {\n    background: $progress-indeterminate-pulse-color;\n  }\n  .ui.sliding.indeterminate.progress .bar,\n  .ui.swinging.indeterminate.progress .bar,\n  .ui.filling.indeterminate.progress .bar {\n    background: $progress-background;\n  }\n  @if($use-progress-variation-inverted) {\n    .ui.inverted.sliding.indeterminate.progress .bar,\n    .ui.inverted.swinging.indeterminate.progress .bar,\n    .ui.inverted.filling.indeterminate.progress .bar {\n      background: $progress-inverted-background;\n    }\n    .ui.sliding.indeterminate.progress .bar .progress,\n    .ui.swinging.indeterminate.progress .bar .progress {\n      color: $progress-inverted-color;\n    }\n    .ui.inverted.sliding.indeterminate.progress .bar .progress,\n    .ui.inverted.swinging.indeterminate.progress .bar .progress {\n      color: $progress-color;\n    }\n  }\n\n  @keyframes progress-swinging {\n    0%, 100% {\n      width:10%;\n      left:-25%;\n    }\n    25%, 65% {\n      width:70%;\n    }\n    50% {\n      width: 10%;\n      left:100%;\n    }\n  }\n\n  @keyframes progress-sliding {\n    0% {\n      width:10%;\n      left:-25%;\n    }\n    50% {\n      width:70%;\n    }\n    100% {\n      width:10%;\n      left:100%;\n    }\n  }\n\n  @keyframes progress-filling {\n    0% {\n      transform: scale(0,1);\n    }\n    80% {\n      transform: scale(1);\n      opacity:1;\n    }\n    100% {\n      opacity:0;\n    }\n  }\n\n  @keyframes progress-pulsating {\n    0% {\n      transform: scale(0,1);\n      opacity:0.7;\n    }\n    100% {\n      transform: scale(1);\n      opacity:0;\n    }\n  }\n}\n\n@import '../../themes/default/modules/progress.style';","@import '../../themes/default/modules/rating.variables';\n\n@if $use-rating {\n  /*******************************\n  //@-       Rating\n  *******************************/\n\n  .ui.rating {\n    display: inline-flex;\n    white-space: $rating-white-space;\n    vertical-align: $rating-vertical-align;\n  }\n  .ui.rating:last-child {\n    margin-right: 0;\n  }\n\n  /* Icon */\n  .ui.rating .icon {\n    padding: 0;\n    margin: 0;\n    text-align: center;\n    font-weight: $normal;\n    font-style: normal;\n    flex: 1 0 auto;\n    cursor: $rating-icon-cursor;\n    width: $rating-icon-width;\n    height: $rating-icon-height;\n    transition: $rating-icon-transition;\n    line-height: 1;\n    backface-visibility: hidden;\n  }\n\n\n  /*******************************\n              Types\n  *******************************/\n\n\n  /*-------------------\n        Standard\n  --------------------*/\n\n  /* Inactive Icon */\n  .ui.rating .icon {\n    background: $rating-inactive-background;\n    color: $rating-inactive-color;\n  }\n\n  /* Active Icon */\n  .ui.rating .active.icon {\n    background: $rating-active-background;\n    color: $rating-active-color;\n  }\n\n  /* Selected Icon */\n  .ui.rating .icon.selected,\n  .ui.rating .icon.selected.active {\n    background: $rating-selected-background;\n    color: $rating-selected-color;\n  }\n\n\n  /*--------------\n      Colors\n  -------------- */\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-rating-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $l: map-get($value, light);\n      $h: map-get($value, hover);\n      $lh: map-get($value, lightHover);\n\n      .ui.#{$key + \"\"}.rating .active.icon {\n        color: $l;\n        text-shadow: 0px (-$rating-shadow-width) 0px $c,\n                    (-$rating-shadow-width) 0px 0px $c,\n                    0px $rating-shadow-width 0px $c,\n                    $rating-shadow-width 0px 0px $c;\n      }\n      .ui.#{$key + \"\"}.rating .icon.selected,\n      .ui.#{$key + \"\"}.rating .icon.selected.active {\n        color: $lh;\n        text-shadow: 0px (-$rating-shadow-width) 0px $h,\n                    (-$rating-shadow-width) 0px 0px $h,\n                    0px $rating-shadow-width 0px $h,\n                    $rating-shadow-width 0px 0px $h;\n      }\n    }\n  }\n\n\n\n  /*******************************\n              States\n  *******************************/\n\n  /*-------------------\n        Disabled\n  --------------------*/\n\n  /* disabled rating */\n  .ui.disabled.rating .icon {\n    cursor: default;\n  }\n\n\n  /*-------------------\n    User Interactive\n  --------------------*/\n\n  /* Selected Rating */\n  .ui.rating.selected .active.icon {\n    opacity: $rating-interactive-active-icon-opacity;\n  }\n  .ui.rating.selected .icon.selected,\n  .ui.rating .icon.selected {\n    opacity: $rating-interactive-selected-icon-opacity;\n  }\n\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  .ui.mini.rating {\n    font-size: $mini;\n  }\n  .ui.tiny.rating {\n    font-size: $tiny;\n  }\n  .ui.small.rating {\n    font-size: $small;\n  }\n  .ui.rating {\n    font-size: $medium;\n  }\n  .ui.large.rating {\n    font-size: $large;\n  }\n  .ui.huge.rating {\n    font-size: $huge;\n  }\n  .ui.massive.rating {\n    font-size: $rating-massive;\n  }\n}\n\n@import '../../themes/default/modules/rating.style';","@import '../../themes/default/modules/search.variables';\n\n@if $use-search {\n  /*******************************\n  //@-         Search\n  *******************************/\n\n  .ui.search {\n    position: relative;\n  }\n\n  .ui.search > .prompt {\n    margin: 0;\n    outline: none;\n    -webkit-appearance: none;\n    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);\n\n    text-shadow: none;\n    font-style: normal;\n    font-weight: $normal;\n\n    line-height: $search-prompt-line-height;\n    padding: $search-prompt-padding;\n    font-size: $search-prompt-font-size;\n\n    background: $search-prompt-background;\n    border: $search-prompt-border;\n    color: $search-prompt-color;\n    box-shadow: $search-prompt-box-shadow;\n    transition: $search-prompt-transition;\n  }\n\n  .ui.search .prompt {\n    border-radius: $search-prompt-border-radius;\n  }\n\n\n  /*--------------\n      Icon\n  ---------------*/\n\n  .ui.search .prompt ~ .search.icon {\n    cursor: pointer;\n  }\n\n  /*--------------\n      Results\n  ---------------*/\n\n  .ui.search > .results {\n    display: none;\n\n    position: absolute;\n    top: 100%;\n    left: 0;\n    transform-origin: center top;\n    white-space: normal;\n    text-align: left;\n    text-transform: none;\n\n    background: $search-results-background;\n\n    margin-top: $search-results-distance;\n    width: $search-results-width;\n\n    border-radius: $search-results-border-radius;\n    box-shadow: $search-results-box-shadow;\n    border: $search-results-border;\n    z-index: $search-results-z-index;\n  }\n  .ui.search > .results > :first-child {\n    border-radius: $search-results-border-radius $search-results-border-radius 0 0;\n  }\n  .ui.search > .results > :last-child {\n    border-radius: 0 0 $search-results-border-radius $search-results-border-radius;\n  }\n\n  /*--------------\n      Result\n  ---------------*/\n\n  .ui.search > .results .result {\n    cursor: pointer;\n    display: block;\n    overflow: hidden;\n    font-size: $search-result-font-size;\n    padding: $search-result-padding;\n    color: $search-result-text-color;\n    line-height: $search-result-line-height;\n    border-bottom: $search-result-divider;\n  }\n  .ui.search > .results .result:last-child {\n    border-bottom: $search-result-last-divider !important;\n  }\n\n  /* Image */\n  .ui.search > .results .result .image {\n    float: $search-result-image-float;\n    overflow: hidden;\n    background: $search-result-image-background;\n    width: $search-result-image-width;\n    height: $search-result-image-height;\n    border-radius: $search-result-image-border-radius;\n  }\n  .ui.search > .results .result .image img {\n    display: block;\n    width: auto;\n    height: 100%;\n  }\n\n  /*--------------\n        Info\n  ---------------*/\n\n  .ui.search > .results .result .image + .content {\n    margin: $search-result-image-margin;\n  }\n\n  .ui.search > .results .result .title {\n    margin: $search-result-title-margin;\n    font-family: $search-result-title-font;\n    font-weight: $search-result-title-font-weight;\n    font-size: $search-result-title-font-size;\n    color: $search-result-title-color;\n  }\n  .ui.search > .results .result .description {\n    margin-top: $search-result-description-distance;\n    font-size: $search-result-description-font-size;\n    color: $search-result-description-color;\n  }\n  .ui.search > .results .result .price {\n    float: $search-result-price-float;\n    color: $search-result-price-color;\n  }\n\n  /*--------------\n      Message\n  ---------------*/\n\n  .ui.search > .results > .message {\n    padding: $search-message-vertical-padding $search-message-horizontal-padding;\n  }\n  .ui.search > .results > .message .header {\n    font-family: $header-font;\n    font-size: $search-message-header-font-size;\n    font-weight: $search-message-header-font-weight;\n    color: $search-message-header-color;\n  }\n  .ui.search > .results > .message .description {\n    margin-top: $search-message-description-distance;\n    font-size: $search-message-description-font-size;\n    color: $search-message-description-color;\n  }\n\n  /* View All Results */\n  .ui.search > .results > .action {\n    display: block;\n    border-top: $search-action-border;\n    background: $search-action-background;\n    padding: $search-action-padding;\n    color: $search-action-color;\n    font-weight: $search-action-font-weight;\n    text-align: $search-action-align;\n  }\n\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------------\n        Focus\n  ---------------------*/\n\n  .ui.search > .prompt:focus {\n    border-color: $search-prompt-focus-border-color;\n    background: $search-prompt-focus-background;\n    color: $search-prompt-focus-color;\n  }\n\n  /*--------------------\n        Loading\n  ---------------------*/\n\n  .ui.loading.search .input > i.icon:before {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n\n    margin: $loader-margin;\n    width: $loader-size;\n    height: $loader-size;\n\n    border-radius: $circular-radius;\n    border: $loader-line-width solid $loader-fill-color;\n  }\n  .ui.loading.search .input > i.icon:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n\n    margin: $loader-margin;\n    width: $loader-size;\n    height: $loader-size;\n\n    animation: loader $loader-speed infinite linear;\n    border: $loader-line-width solid $loader-line-color;\n    border-radius: $circular-radius;\n\n    box-shadow: 0 0 0 1px transparent;\n  }\n\n\n  /*--------------\n        Hover\n  ---------------*/\n\n  .ui.search > .results .result:hover,\n  .ui.category.search > .results .category .result:hover {\n    background: $search-result-hover-background;\n  }\n  .ui.search .action:hover:not(div) {\n    background: $search-action-hover-background;\n  }\n\n  /*--------------\n        Active\n  ---------------*/\n\n  .ui.category.search > .results .category.active {\n    background: $search-category-active-background;\n  }\n  .ui.category.search > .results .category.active > .name {\n    color: $search-category-name-active-color;\n  }\n\n  .ui.search > .results .result.active,\n  .ui.category.search > .results .category .result.active {\n    position: relative;\n    border-left-color: $search-result-active-border-left;\n    background: $search-result-active-background;\n    box-shadow: $search-result-active-box-shadow;\n  }\n  .ui.search > .results .result.active .title {\n    color: $search-result-active-title-color;\n  }\n  .ui.search > .results .result.active .description {\n    color: $search-result-active-description-color;\n  }\n\n  /*--------------------\n          Disabled\n  ----------------------*/\n\n  /* Disabled */\n  .ui.disabled.search {\n    cursor: default;\n    pointer-events: none;\n    opacity: $disabled-opacity;\n  }\n\n\n  /*******************************\n            Types\n  *******************************/\n\n  /*--------------\n      Selection\n  ---------------*/\n\n  .ui.search.selection .prompt {\n    border-radius: $search-selection-prompt-border-radius;\n  }\n\n  /* Remove input */\n  .ui.search.selection > .icon.input > .remove.icon {\n    pointer-events: none;\n    position: absolute;\n    left: auto;\n    opacity: 0;\n    color: $search-selection-close-icon-color;\n    top: $search-selection-close-top;\n    right: $search-selection-close-right;\n    transition: $search-selection-close-transition;\n  }\n  .ui.search.selection > .icon.input > .active.remove.icon {\n    cursor: pointer;\n    opacity: $search-selection-close-icon-opacity;\n    pointer-events: auto;\n  }\n  .ui.search.selection > .icon.input:not([class*=\"left icon\"]) > .icon ~ .remove.icon {\n    right: $search-selection-close-icon-input-right;\n  }\n  .ui.search.selection > .icon.input > .remove.icon:hover {\n    opacity: $search-selection-close-icon-hover-opacity;\n    color: $search-selection-close-icon-hover-color;\n  }\n\n\n  /*--------------\n      Category\n  ---------------*/\n\n  .ui.category.search .results {\n    width: $search-category-results-width;\n  }\n\n  .ui.category.search .results.animating,\n  .ui.category.search .results.visible {\n    display: table;\n  }\n\n  /* Category */\n  .ui.category.search > .results .category {\n    display: table-row;\n    background: $search-category-background;\n    box-shadow: $search-category-box-shadow;\n    transition: $search-category-transition;\n  }\n\n  /* Last Category */\n  .ui.category.search > .results .category:last-child {\n    border-bottom: none;\n  }\n\n  /* First / Last */\n  .ui.category.search > .results .category:first-child .name + .result {\n    border-radius: 0 $search-results-border-radius 0 0;\n  }\n  .ui.category.search > .results .category:last-child .result:last-child {\n    border-radius: 0 0 $search-results-border-radius 0;\n  }\n\n  /* Category Result Name */\n  .ui.category.search > .results .category > .name {\n    display: table-cell;\n    text-overflow: ellipsis;\n    width: $search-category-name-width;\n    white-space: $search-category-name-whitespace;\n    background: $search-category-name-background;\n    font-family: $search-category-name-font;\n    font-size: $search-category-name-font-size;\n    padding: $search-category-name-padding;\n    font-weight: $search-category-name-font-weight;\n    color: $search-category-name-color;\n    border-bottom: $search-category-divider;\n  }\n\n  /* Category Result */\n  .ui.category.search > .results .category .results {\n    display: table-cell;\n    background: $search-category-result-background;\n    border-left: $search-category-result-left-border;\n    border-bottom: $search-category-divider;\n  }\n  .ui.category.search > .results .category .result {\n    border-bottom: $search-category-result-divider;\n    transition: $search-category-result-transition;\n    padding: $search-category-result-padding;\n  }\n\n  /*******************************\n            Variations\n  *******************************/\n\n  /*-------------------\n      Left / Right\n  --------------------*/\n\n  .ui[class*=\"left aligned\"].search > .results {\n    right: auto;\n    left: 0;\n  }\n  .ui[class*=\"right aligned\"].search > .results {\n    right: 0;\n    left: auto;\n  }\n\n  /*--------------\n      Fluid\n  ---------------*/\n\n  .ui.fluid.search .results {\n    width: 100%;\n  }\n\n\n  /*--------------\n        Sizes\n  ---------------*/\n\n  .ui.mini.search {\n    font-size: $relative-mini;\n  }\n  .ui.small.search {\n    font-size: $relative-small;\n  }\n  .ui.search {\n    font-size: $relative-medium;\n  }\n  .ui.large.search {\n    font-size: $relative-large;\n  }\n  .ui.big.search {\n    font-size: $relative-big;\n  }\n  .ui.huge.search {\n    font-size: $relative-huge;\n  }\n  .ui.massive.search {\n    font-size: $relative-massive;\n  }\n\n  /*--------------\n        Mobile\n  ---------------*/\n\n  @media only screen and (max-width: $largest-mobile-screen) {\n    .ui.search .results {\n      max-width: $search-mobile-max-width;\n    }\n  }\n}\n\n@import '../../themes/default/modules/search.style';","@import '../../themes/default/modules/shape.variables';\n\n@if $use-shape {\n  /*******************************\n  //@-          Shape\n  *******************************/\n\n  .ui.shape {\n    position: relative;\n    vertical-align: top;\n    display: $shape-display;\n    perspective: $shape-perspective;\n    transition: $shape-transition;\n  }\n\n  .ui.shape .sides {\n    transform-style: preserve-3d;\n  }\n\n  .ui.shape .side {\n    display: none;\n    opacity: 1;\n    width: 100%;\n\n    margin: $shape-side-margin !important;\n    backface-visibility: $shape-backface-visibility;\n  }\n\n  .ui.shape .side * {\n    backface-visibility: visible !important;\n  }\n\n  /*******************************\n              Types\n  *******************************/\n\n  .ui.cube.shape .side {\n    min-width: $shape-cube-size;\n    height: $shape-cube-size;\n\n    padding: $shape-cube-padding;\n\n    background-color: $shape-cube-background;\n    color: $shape-cube-text-color;\n    box-shadow: $shape-cube-box-shadow;\n  }\n  .ui.cube.shape .side > .content {\n    width: 100%;\n    height: 100%;\n    display: table;\n\n    text-align: $shape-cube-text-align;\n    user-select: text;\n  }\n  .ui.cube.shape .side > .content > div {\n    display: table-cell;\n    vertical-align: middle;\n    font-size: $shape-cube-font-size;\n  }\n\n  /*******************************\n            Variations\n  *******************************/\n\n  .ui.text.shape.animating .sides {\n    position: static;\n  }\n  .ui.text.shape .side {\n    white-space: nowrap;\n  }\n  .ui.text.shape .side > * {\n    white-space: normal;\n  }\n\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------\n      Loading\n  ---------------*/\n\n  .ui.loading.shape {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n\n  /*--------------\n      Animating\n  ---------------*/\n\n  .ui.shape .animating.side {\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: block;\n    z-index: $shape-animating-z-index;\n  }\n  .ui.shape .hidden.side {\n    opacity: $shape-hidden-side-opacity;\n  }\n\n\n  /*--------------\n        CSS\n  ---------------*/\n\n  .ui.shape.animating .sides {\n    position: absolute;\n    transition: $shape-transition;\n  }\n  .ui.shape.animating .side {\n    transition: $shape-side-transition;\n  }\n  .ui.shape .animating.side *,\n  .ui.shape.animating .side * {\n    transition: none;\n  }\n\n  /*--------------\n      Active\n  ---------------*/\n\n  .ui.shape .active.side {\n    display: block;\n  }\n}\n\n@import '../../themes/default/modules/shape.style';","@import '../../themes/default/modules/sidebar.variables';\n\n@if $use-sidebar {\n  /*******************************\n  //@-        Sidebar\n  *******************************/\n\n  /* Sidebar Menu */\n  .ui.sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n\n    backface-visibility: hidden;\n    transition: none;\n    will-change: transform;\n    transform: translate3d(0, 0, 0);\n    visibility: hidden;\n    -webkit-overflow-scrolling: touch;\n\n    height: 100% !important;\n    max-height: 100%;\n    border-radius: 0 !important;\n    margin: 0 !important;\n    overflow-y: auto !important;\n    z-index: $sidebar-top-layer;\n  }\n\n  /* GPU Layers for Child Elements */\n  .ui.sidebar > * {\n    backface-visibility: hidden;\n  }\n\n\n  /*--------------\n    Direction\n  ---------------*/\n\n  .ui.left.sidebar {\n    right: auto;\n    left: 0;\n    transform: translate3d(-100%, 0, 0);\n  }\n  .ui.right.sidebar {\n    right: 0 !important;\n    left: auto !important;\n    transform: translate3d(100%, 0, 0);\n  }\n\n  .ui.top.sidebar,\n  .ui.bottom.sidebar {\n    width: 100% !important;\n    height: auto !important;\n  }\n  .ui.top.sidebar {\n    top: 0 !important;\n    bottom: auto !important;\n    transform: translate3d(0, -100%, 0);\n  }\n  .ui.bottom.sidebar {\n    top: auto !important;\n    bottom: 0 !important;\n    transform: translate3d(0, 100%, 0);\n  }\n\n\n  /*--------------\n      Pushable\n  ---------------*/\n\n  .pushable {\n    height: 100%;\n    overflow-x: hidden;\n    padding: 0 !important;\n  }\n\n  /* Whole Page */\n  body.pushable {\n    background: $sidebar-canvas-background;\n    &.dimmed {\n      background: inherit;\n    }\n  }\n\n  /* Page Context */\n  .pushable:not(body) {\n    transform: translate3d(0, 0, 0);\n  }\n  .pushable:not(body) > .ui.sidebar,\n  .pushable:not(body) > .fixed,\n  .pushable:not(body) > .pusher:after {\n    position: absolute;\n  }\n\n\n  /*--------------\n      Fixed\n  ---------------*/\n\n  .pushable > .fixed {\n    position: fixed;\n    backface-visibility: hidden;\n\n    transition: transform $sidebar-duration $sidebar-easing;\n    will-change: transform;\n    z-index: $sidebar-fixed-layer;\n  }\n\n  /*--------------\n      Page\n  ---------------*/\n\n  .pushable > .pusher {\n    position: relative;\n    backface-visibility: hidden;\n    overflow: hidden;\n    min-height: 100%;\n    transition: transform $sidebar-duration $sidebar-easing;\n    z-index: $sidebar-middle-layer;\n\n    /* Pusher should inherit background from context */\n    background: inherit;\n  }\n\n  body.pushable > .pusher {\n    background: $page-background;\n  }\n\n  /*--------------\n      Dimmer\n  ---------------*/\n\n  .pushable > .pusher:after {\n    position: fixed;\n    top: 0;\n    right: 0;\n    content: '';\n    background-color: $sidebar-dimmer-color;\n    overflow: hidden;\n    opacity: 0;\n    transition: $sidebar-dimmer-transition;\n    will-change: opacity;\n    z-index: $sidebar-dimmer-layer;\n  }\n\n  /*--------------\n      Coupling\n  ---------------*/\n\n  .ui.sidebar.menu .item {\n    border-radius: 0 !important;\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------\n      Dimmed\n  ---------------*/\n\n  .pushable > .pusher.dimmed:after {\n    width: 100% !important;\n    height: 100% !important;\n    opacity: 1 !important;\n  }\n\n  /*--------------\n      Animating\n  ---------------*/\n\n  .ui.animating.sidebar {\n    visibility: visible;\n  }\n\n  /*--------------\n      Visible\n  ---------------*/\n\n  .ui.visible.sidebar {\n    visibility: visible;\n    transform: translate3d(0, 0, 0);\n  }\n\n  /* Shadow Direction */\n  .ui.left.visible.sidebar,\n  .ui.right.visible.sidebar {\n    box-shadow: $sidebar-horizontal-box-shadow;\n  }\n  .ui.top.visible.sidebar,\n  .ui.bottom.visible.sidebar {\n    box-shadow: $sidebar-vertical-box-shadow;\n  }\n\n  /* Visible On Load */\n  .ui.visible.left.sidebar ~ .fixed,\n  .ui.visible.left.sidebar ~ .pusher {\n    transform: translate3d($sidebar-width, 0, 0);\n  }\n  .ui.visible.right.sidebar ~ .fixed,\n  .ui.visible.right.sidebar ~ .pusher {\n    transform: translate3d(-$sidebar-width, 0, 0);\n  }\n  .ui.visible.top.sidebar ~ .fixed,\n  .ui.visible.top.sidebar ~ .pusher {\n    transform: translate3d(0, $sidebar-height, 0);\n  }\n  .ui.visible.bottom.sidebar ~ .fixed,\n  .ui.visible.bottom.sidebar ~ .pusher {\n    transform: translate3d(0, -$sidebar-height, 0);\n  }\n\n  /* opposite sides visible forces content overlay */\n  .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .fixed,\n  .ui.visible.left.sidebar ~ .ui.visible.right.sidebar ~ .pusher,\n  .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .fixed,\n  .ui.visible.right.sidebar ~ .ui.visible.left.sidebar ~ .pusher {\n    transform: translate3d(0, 0, 0);\n  }\n\n  /*--------------\n        iOS\n  ---------------*/\n\n\n  /*******************************\n            Variations\n  *******************************/\n\n  /*--------------\n      Width\n  ---------------*/\n\n  /* Left / Right */\n  .ui.thin.left.sidebar,\n  .ui.thin.right.sidebar {\n    width: $sidebar-thin-width;\n  }\n  .ui[class*=\"very thin\"].left.sidebar,\n  .ui[class*=\"very thin\"].right.sidebar {\n    width: $sidebar-very-thin-width;\n  }\n  .ui.left.sidebar,\n  .ui.right.sidebar {\n    width: $sidebar-width;\n  }\n  .ui.wide.left.sidebar,\n  .ui.wide.right.sidebar {\n    width: $sidebar-wide-width;\n  }\n  .ui[class*=\"very wide\"].left.sidebar,\n  .ui[class*=\"very wide\"].right.sidebar {\n    width: $sidebar-very-wide-width;\n  }\n\n  /* Left Visible */\n  .ui.visible.thin.left.sidebar ~ .fixed,\n  .ui.visible.thin.left.sidebar ~ .pusher {\n    transform: translate3d($sidebar-thin-width, 0, 0);\n  }\n  .ui.visible[class*=\"very thin\"].left.sidebar ~ .fixed,\n  .ui.visible[class*=\"very thin\"].left.sidebar ~ .pusher {\n    transform: translate3d($sidebar-very-thin-width, 0, 0);\n  }\n  .ui.visible.wide.left.sidebar ~ .fixed,\n  .ui.visible.wide.left.sidebar ~ .pusher {\n    transform: translate3d($sidebar-wide-width, 0, 0);\n  }\n  .ui.visible[class*=\"very wide\"].left.sidebar ~ .fixed,\n  .ui.visible[class*=\"very wide\"].left.sidebar ~ .pusher {\n    transform: translate3d($sidebar-very-wide-width, 0, 0);\n  }\n\n  /* Right Visible */\n  .ui.visible.thin.right.sidebar ~ .fixed,\n  .ui.visible.thin.right.sidebar ~ .pusher {\n    transform: translate3d(-$sidebar-thin-width, 0, 0);\n  }\n  .ui.visible[class*=\"very thin\"].right.sidebar ~ .fixed,\n  .ui.visible[class*=\"very thin\"].right.sidebar ~ .pusher {\n    transform: translate3d(-$sidebar-very-thin-width, 0, 0);\n  }\n  .ui.visible.wide.right.sidebar ~ .fixed,\n  .ui.visible.wide.right.sidebar ~ .pusher {\n    transform: translate3d(-$sidebar-wide-width, 0, 0);\n  }\n  .ui.visible[class*=\"very wide\"].right.sidebar ~ .fixed,\n  .ui.visible[class*=\"very wide\"].right.sidebar ~ .pusher {\n    transform: translate3d(-$sidebar-very-wide-width, 0, 0);\n  }\n\n\n\n  /*******************************\n            Animations\n  *******************************/\n\n  /*--------------\n      Overlay\n  ---------------*/\n\n  /* Set-up */\n  .ui.overlay.sidebar {\n    z-index: $sidebar-top-layer;\n  }\n\n  /* Initial */\n  .ui.left.overlay.sidebar {\n    transform: translate3d(-100%, 0, 0);\n  }\n  .ui.right.overlay.sidebar {\n    transform: translate3d(100%, 0, 0);\n  }\n  .ui.top.overlay.sidebar {\n    transform: translate3d(0%, -100%, 0);\n  }\n  .ui.bottom.overlay.sidebar {\n    transform: translate3d(0%, 100%, 0);\n  }\n\n  /* Animation */\n  .animating.ui.overlay.sidebar,\n  .ui.visible.overlay.sidebar {\n    transition: transform $sidebar-duration $sidebar-easing;\n  }\n\n  /* End - Sidebar */\n  .ui.visible.left.overlay.sidebar {\n    transform: translate3d(0%, 0, 0);\n  }\n  .ui.visible.right.overlay.sidebar {\n    transform: translate3d(0%, 0, 0);\n  }\n  .ui.visible.top.overlay.sidebar {\n    transform: translate3d(0%, 0, 0);\n  }\n  .ui.visible.bottom.overlay.sidebar {\n    transform: translate3d(0%, 0, 0);\n  }\n\n  /* End - Pusher */\n  .ui.visible.overlay.sidebar ~ .fixed,\n  .ui.visible.overlay.sidebar ~ .pusher {\n    transform: none !important;\n  }\n\n\n\n  /*--------------\n        Push\n  ---------------*/\n\n  /* Initial */\n  .ui.push.sidebar {\n    transition: transform $sidebar-duration $sidebar-easing;\n    z-index: $sidebar-top-layer;\n  }\n\n  /* Sidebar - Initial */\n  .ui.left.push.sidebar {\n    transform: translate3d(-100%, 0, 0);\n  }\n  .ui.right.push.sidebar {\n    transform: translate3d(100%, 0, 0);\n  }\n  .ui.top.push.sidebar {\n    transform: translate3d(0%, -100%, 0);\n  }\n  .ui.bottom.push.sidebar {\n    transform: translate3d(0%, 100%, 0);\n  }\n\n  /* End */\n  .ui.visible.push.sidebar {\n    transform: translate3d(0%, 0, 0);\n  }\n\n\n  /*--------------\n      Uncover\n  ---------------*/\n\n  /* Initial */\n  .ui.uncover.sidebar {\n    transform: translate3d(0, 0, 0);\n    z-index: $sidebar-bottom-layer;\n  }\n\n  /* End */\n  .ui.visible.uncover.sidebar {\n    transform: translate3d(0, 0, 0);\n    transition: transform $sidebar-duration $sidebar-easing;\n  }\n\n\n  /*--------------\n    Slide Along\n  ---------------*/\n\n  /* Initial */\n  .ui.slide.along.sidebar {\n    z-index: $sidebar-bottom-layer;\n  }\n\n  /* Sidebar - Initial */\n  .ui.left.slide.along.sidebar {\n    transform: translate3d(-50%, 0, 0);\n  }\n  .ui.right.slide.along.sidebar {\n    transform: translate3d(50%, 0, 0);\n  }\n  .ui.top.slide.along.sidebar {\n    transform: translate3d(0, -50%, 0);\n  }\n  .ui.bottom.slide.along.sidebar {\n    transform: translate3d(0%, 50%, 0);\n  }\n\n  /* Animation */\n  .ui.animating.slide.along.sidebar {\n    transition: transform $sidebar-duration $sidebar-easing;\n  }\n\n  /* End */\n  .ui.visible.slide.along.sidebar {\n    transform: translate3d(0%, 0, 0);\n  }\n\n\n  /*--------------\n    Slide Out\n  ---------------*/\n\n  /* Initial */\n  .ui.slide.out.sidebar {\n    z-index: $sidebar-bottom-layer;\n  }\n\n  /* Sidebar - Initial */\n  .ui.left.slide.out.sidebar {\n    transform: translate3d(50%, 0, 0);\n  }\n  .ui.right.slide.out.sidebar {\n    transform: translate3d(-50%, 0, 0);\n  }\n  .ui.top.slide.out.sidebar {\n    transform: translate3d(0%, 50%, 0);\n  }\n  .ui.bottom.slide.out.sidebar {\n    transform: translate3d(0%, -50%, 0);\n  }\n\n  /* Animation */\n  .ui.animating.slide.out.sidebar {\n    transition: transform $sidebar-duration $sidebar-easing;\n  }\n\n  /* End */\n  .ui.visible.slide.out.sidebar {\n    transform: translate3d(0%, 0, 0);\n  }\n\n  /*--------------\n    Scale Down\n  ---------------*/\n\n  /* Initial */\n  .ui.scale.down.sidebar {\n    transition: transform $sidebar-duration $sidebar-easing;\n    z-index: $sidebar-top-layer;\n  }\n\n  /* Sidebar - Initial  */\n  .ui.left.scale.down.sidebar {\n    transform: translate3d(-100%, 0, 0);\n  }\n  .ui.right.scale.down.sidebar {\n    transform: translate3d(100%, 0, 0);\n  }\n  .ui.top.scale.down.sidebar {\n    transform: translate3d(0%, -100%, 0);\n  }\n  .ui.bottom.scale.down.sidebar {\n    transform: translate3d(0%, 100%, 0);\n  }\n\n  /* Pusher - Initial */\n  .ui.scale.down.left.sidebar ~ .pusher {\n    transform-origin: 75% 50%;\n  }\n  .ui.scale.down.right.sidebar ~ .pusher {\n    transform-origin: 25% 50%;\n  }\n  .ui.scale.down.top.sidebar ~ .pusher {\n    transform-origin: 50% 75%;\n  }\n  .ui.scale.down.bottom.sidebar ~ .pusher {\n    transform-origin: 50% 25%;\n  }\n\n  /* Animation */\n  .ui.animating.scale.down > .visible.ui.sidebar {\n    transition: transform $sidebar-duration $sidebar-easing;\n  }\n  .ui.visible.scale.down.sidebar ~ .pusher,\n  .ui.animating.scale.down.sidebar ~ .pusher {\n    display: block !important;\n    width: 100%;\n    height: 100%;\n    overflow: hidden !important;\n  }\n\n  /* End */\n  .ui.visible.scale.down.sidebar {\n    transform: translate3d(0, 0, 0);\n  }\n  .ui.visible.scale.down.sidebar ~ .pusher {\n    transform: scale(0.75);\n  }\n}\n\n@import '../../themes/default/modules/sidebar.style';","@import '../../themes/default/modules/slider.variables'; \n\n@if $use-slider {\n  //@-\n\n  .ui.slider:not(.vertical):not(.checkbox) {\n    width: 100%;\n    padding: $slider-padding;\n  }\n\n  .ui.slider:not(.checkbox) {\n    position: relative;\n  }\n\n  .ui.slider:not(.checkbox):focus {\n    outline: 0;\n  }\n\n  .ui.slider .inner {\n    position: relative;\n    z-index: 2;\n  }\n\n  .ui.slider:not(.vertical) .inner {\n    height: $slider-height;\n  }\n\n  .ui.slider .inner:hover {\n    cursor: $slider-hover-pointer;\n  }\n\n  .ui.slider .inner .track {\n    position: absolute;\n    border-radius: $slider-track-border-radius;\n    background-color: $slider-track-color;\n  }\n\n  .ui.slider:not(.vertical) .inner .track {\n    width: 100%;\n    height: $slider-track-height;\n    top: $slider-track-position-top;\n    left: 0;\n  }\n\n  .ui.slider .inner .track-fill {\n    position: absolute;\n    border-radius: $slider-track-fill-border-radius;\n    background-color: $slider-track-fill-color;\n  }\n\n  .ui.slider:not(.vertical) .inner .track-fill {\n    height: $slider-track-fill-height;\n    top: $slider-track-position-top;\n    left: 0;\n  }\n\n  .ui.slider .inner .thumb {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: $slider-thumb-height;\n    width: $slider-thumb-height;\n    background: $slider-thumb-background;\n    border-radius: $slider-thumb-border-radius;\n    box-shadow: $slider-thumb-shadow;\n    transition: $slider-thumb-transition;\n  }\n\n  .ui.slider:not(.disabled) .inner .thumb:hover {\n    cursor: $slider-thumb-hover-pointer;\n    background: $slider-thumb-hover-background;\n  }\n\n  .ui.slider:not(.disabled):focus .inner .thumb {\n    background: $slider-thumb-hover-background;\n  }\n\n\n  /*******************************\n              States\n  *******************************/\n\n\n  /*--------------\n      Disabled\n  ---------------*/\n\n  .ui.disabled.slider:not(.checkbox) {\n    opacity: $slider-disabled-opactiy;\n  }\n\n  .ui.disabled.slider .inner:hover {\n    cursor: auto;\n  }\n\n  .ui.disabled.slider .inner .track-fill {\n    background: $slider-disabled-track-fill-color;\n  }\n\n  @if($use-slider-variation-reversed) {\n    /*--------------\n        Reversed\n    ---------------*/\n\n    .ui.reversed.slider .inner .track-fill {\n      left: auto;\n      right: 0;\n    }\n\n    .ui.reversed.slider .inner .thumb {\n      left: auto;\n      right: 0;\n    }\n\n    .ui.labeled.reversed.slider > .labels .label {\n      transform: translate(-100%, -100%);\n    }\n  }\n\n  /*******************************\n            Variations\n  *******************************/\n\n  @if($use-slider-variation-vertical) {\n    /*--------------\n        Vertical\n    ---------------*/\n\n    .ui.vertical.slider {\n      height: 100%;\n      width: $slider-height;\n      padding: $slider-vertical-padding;\n    }\n\n    .ui.vertical.slider .inner {\n      height: 100%;\n    }\n\n    .ui.vertical.slider .inner .track {\n      height: 100%;\n      width: $slider-track-height;\n      left: $slider-track-position-top;\n      top: 0;\n    }\n\n    .ui.vertical.slider .inner .track-fill {\n      width: $slider-track-fill-height;\n      left: $slider-track-position-top;\n      top: 0;\n    }\n\n    @if($use-slider-variation-reversed) {\n      /* Vertical Reversed */\n      .ui.vertical.reversed.slider .inner .thumb {\n        top: auto;\n        bottom: 0;\n      }\n    \n      .ui.vertical.reversed.slider .inner .track-fill {\n        top: auto;\n        bottom: 0;\n      }\n\n      /* Vertical Reversed Labels */\n      .ui.labeled.vertical.reversed.slider > .labels .label {\n        transform: translate(-100%, 50%);\n      }\n    }\n\n    /* Vertical Labels */\n\n    .ui.labeled.vertical.slider > .labels {\n      width: $slider-label-height;\n      height: auto;\n      left: 50%;\n      top: 0;\n      bottom: 0;\n      transform: translateX(-50%);\n    }\n\n    .ui.labeled.vertical.slider > .labels .label {\n      transform: translate(-100%, -50%);\n    }\n\n    .ui.labeled.vertical.slider > .labels .label:after {\n      width: $slider-label-height;\n      height: $slider-label-width;\n      left: 100%;\n      top: 50%;\n    }\n    .ui.labeled.vertical.slider > .labels .halftick.label:after {\n      width: $slider-label-height / 2;\n      height: $slider-label-width;\n    }\n\n    /* Small Vertical */\n    .ui.slider.small.vertical .inner {\n      width: $slider-small-height;\n    }\n    .ui.slider.small.vertical .inner .track,\n    .ui.slider.small.vertical .inner .track-fill {\n      width: $slider-small-track-height;\n      left: $slider-track-position-top-small;\n    }\n    .ui.small.labeled.vertical.slider> .labels,\n    .ui.small.labeled.vertical.slider> .labels .label:after {\n      width: $slider-small-label-height;\n    }\n    .ui.small.labeled.vertical.slider> .labels .halftick.label:after {\n      width: $slider-small-label-height / 2;\n    }\n    /* Large Vertical */\n    .ui.slider.large.vertical .inner {\n      width: $slider-large-height;\n    }\n    .ui.slider.large.vertical .inner .track,\n    .ui.slider.large.vertical .inner .track-fill {\n      width: $slider-large-track-height;\n      left: $slider-track-position-top-large;\n    }\n    .ui.large.labeled.vertical.slider> .labels,\n    .ui.large.labeled.vertical.slider> .labels .label:after {\n      width: $slider-large-label-height;\n    }\n    .ui.large.labeled.vertical.slider> .labels .halftick.label:after {\n      width: $slider-large-label-height / 2;\n    }\n\n    /* Big Vertical */\n    .ui.slider.big.vertical .inner {\n      width: $slider-big-height;\n    }\n    .ui.slider.big.vertical .inner .track,\n    .ui.slider.big.vertical .inner .track-fill {\n      width: $slider-big-track-height;\n      left: $slider-track-position-top-big;\n    }\n    .ui.big.labeled.vertical.slider> .labels,\n    .ui.big.labeled.vertical.slider> .labels .label:after {\n      width: $slider-big-label-height;\n    }\n    .ui.big.labeled.vertical.slider> .labels .halftick.label:after {\n      width: $slider-big-label-height / 2;\n    }\n  }\n\n  /*--------------\n      Labeled\n  ---------------*/\n\n  .ui.labeled.slider > .labels {\n    height: $slider-label-height;\n    width: auto;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    right: 0;\n  }\n\n  .ui.labeled.slider:not(.vertical) > .labels {\n    transform: translateY(-50%);\n  }\n\n  .ui.labeled.slider > .labels .label {\n    display: inline-flex;\n    position: absolute;\n    transform: translate(-50%, -100%);\n  }\n\n  .ui.labeled.ticked.slider > .labels .label:after {\n    content: ' ';\n    height: $slider-label-height;\n    width: $slider-label-width;\n    background: $slider-label-color;\n    position: absolute;\n    top: 100%;\n    left: 50%;\n  }\n  .ui.labeled.ticked.slider > .labels .halftick.label:after {\n    height: $slider-label-height / 2;\n  }\n\n  /*--------------\n      Hover\n  ---------------*/\n\n  .ui.hover.slider .inner .thumb {\n    opacity: $slider-hover-var-opacity;\n    transition: $slider-hover-opacity-transition;\n  }\n\n  .ui.hover.slider:not(.disabled):hover .inner .thumb, .ui.hover.slider:not(.disabled):focus .inner .thumb {\n    opacity: $slider-hover-var-hover-opacity;\n  }\n\n\n  @if($use-slider-variation-inverted) {\n    /*--------------\n        Inverted\n    ---------------*/\n    .ui.inverted.slider .inner .track-fill {\n      background-color: $slider-inverted-track-fill-color;\n    }\n\n    .ui.inverted.slider .inner .track {\n      background-color: $transparent-white;\n    }\n  }\n\n\n  /*--------------\n      Colors\n  ---------------*/\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-slider-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $l: map-get($value, light);\n      $h: map-get($value, hover);\n      $lh: map-get($value, lightHover);\n\n      /* Standard */\n      .ui.#{$key + \"\"}.slider .inner .track-fill {\n        background-color: $c;\n      }\n\n      /* Basic */\n      .ui.#{$key + \"\"}.slider.basic .inner .thumb {\n        background-color: $c;\n      }\n      .ui.#{$key + \"\"}.slider.basic .inner .thumb:hover,\n      .ui.#{$key + \"\"}.slider.basic:focus .inner .thumb {\n        background-color: $h;\n      }\n      @if($use-slider-variation-inverted) {\n        /* Basic Inverted */\n        .ui.#{$key + \"\"}.inverted.slider.basic .inner .thumb {\n          background-color: $l;\n        }\n        .ui.#{$key + \"\"}.inverted.slider .inner .track-fill {\n          background-color: $l;\n        }\n        .ui.#{$key + \"\"}.inverted.slider.basic .inner .thumb:hover,\n        .ui.#{$key + \"\"}.inverted.slider.basic:focus .inner .thumb {\n          background-color: $lh;\n        }\n      }\n    }\n  }\n\n  /*--------------\n      Basic\n  ---------------*/\n\n  /* Standard */\n  .ui.slider.basic .inner .thumb {\n    background-color: $slider-track-fill-color;\n  }\n  .ui.slider.basic .inner .thumb:hover, .ui.slider.basic:focus .inner .thumb {\n    background-color: $slider-track-fill-color-focus;\n  }\n\n  @if($use-slider-variation-inverted) {\n    /*--------------\n      Basic Inverted\n    ---------------*/\n\n    /* Standard */\n    .ui.inverted.slider.basic .inner .thumb {\n      background-color: $slider-inverted-track-fill-color;\n    }\n    .ui.inverted.slider.basic .inner .thumb:hover, .ui.inverted.slider.basic:focus .inner .thumb {\n      background-color: $slider-inverted-track-fill-color-focus;\n    }\n  }\n\n  /*--------------\n      Sizing\n  ---------------*/\n\n  /* Small */\n  .ui.slider.small .inner .thumb {\n    height: $slider-small-height;\n    width: $slider-small-height;\n  }\n  .ui.slider.small:not(.vertical) .inner {\n    height: $slider-small-height;\n  }\n  .ui.slider.small:not(.vertical) .inner .track,\n  .ui.slider.small:not(.vertical) .inner .track-fill {\n    height: $slider-small-track-height;\n    top: $slider-track-position-top-small;\n  }\n  .ui.small.labeled.slider:not(.vertical) > .labels,\n  .ui.small.labeled.slider:not(.vertical) > .labels .label:after {\n    height: $slider-small-label-height;\n  }\n  .ui.small.labeled.slider:not(.vertical) > .labels .halftick.label:after {\n    height: $slider-small-label-height / 2;\n  }\n\n\n  /* Large */\n  .ui.slider.large .inner .thumb {\n    height: $slider-large-height;\n    width: $slider-large-height;\n  }\n  .ui.slider.large:not(.vertical) .inner {\n    height: $slider-large-height;\n  }\n  .ui.slider.large:not(.vertical) .inner .track,\n  .ui.slider.large:not(.vertical) .inner .track-fill {\n    height: $slider-large-track-height;\n    top: $slider-track-position-top-large;\n  }\n  .ui.large.labeled.slider:not(.vertical) > .labels,\n  .ui.large.labeled.slider:not(.vertical) > .labels .label:after {\n    height: $slider-large-label-height;\n  }\n  .ui.large.labeled.slider:not(.vertical) > .labels .halftick.label:after {\n    height: $slider-large-label-height / 2;\n  }\n\n\n  /* Big */\n  .ui.slider.big .inner .thumb {\n    height: $slider-big-height;\n    width: $slider-big-height;\n  }\n  .ui.slider.big:not(.vertical) .inner {\n    height: $slider-big-height;\n  }\n  .ui.slider.big:not(.vertical) .inner .track,\n  .ui.slider.big:not(.vertical) .inner .track-fill {\n    height: $slider-big-track-height;\n    top: $slider-track-position-top-big;\n  }\n  .ui.big.labeled.slider:not(.vertical) > .labels,\n  .ui.big.labeled.slider:not(.vertical) > .labels .label:after {\n    height: $slider-big-label-height;\n  }\n  .ui.big.labeled.slider:not(.vertical) > .labels .halftick.label:after {\n    height: $slider-big-label-height / 2;\n  }\n}\n\n@import '../../themes/default/modules/slider.style';"," @import '../../themes/default/modules/sticky.variables';\n\n @if $use-sticky {\n  /*******************************\n  //@-        Sticky\n  *******************************/\n\n  .ui.sticky {\n    position: static;\n    transition: $sticky-transition;\n    z-index: $sticky-z-index;\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  /* Bound */\n  .ui.sticky.bound {\n    position: absolute;\n    left: auto;\n    right: auto;\n  }\n\n  /* Fixed */\n  .ui.sticky.fixed {\n    position: fixed;\n    left: auto;\n    right: auto;\n  }\n\n  /* Bound/Fixed Position */\n  .ui.sticky.bound.top,\n  .ui.sticky.fixed.top {\n    top: 0;\n    bottom: auto;\n  }\n  .ui.sticky.bound.bottom,\n  .ui.sticky.fixed.bottom {\n    top: auto;\n    bottom: 0;\n  }\n\n\n  /*******************************\n              Types\n  *******************************/\n\n  .ui.native.sticky {\n    position: -webkit-sticky;\n    position: -moz-sticky;\n    position: -ms-sticky;\n    position: -o-sticky;\n    position: sticky;\n  }\n}\n\n@import '../../themes/default/modules/sticky.style';","@import '../../themes/default/modules/tab.variables';\n\n@if $use-tab {\n  /*******************************\n  //@-       UI Tabs\n  *******************************/\n\n  .ui.tab {\n    display: none;\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n  /*--------------------\n        Active\n  ---------------------*/\n\n  .ui.tab.active,\n  .ui.tab.open {\n    display: block;\n  }\n\n  /*--------------------\n        Loading\n  ---------------------*/\n\n  .ui.tab.loading {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    min-height: $tab-loading-min-height;\n  }\n  .ui.tab.loading * {\n    position: $tab-loading-content-position !important;\n    left: $tab-loading-content-offset !important;\n  }\n\n  .ui.tab.loading:before,\n  .ui.tab.loading.segment:before {\n    position: absolute;\n    content: '';\n    top: $tab-loader-distance-from-top;\n    left: 50%;\n\n    margin: $loader-margin;\n    width: $tab-loader-size;\n    height: $tab-loader-size;\n\n    border-radius: $circular-radius;\n    border: $loader-line-width solid $loader-fill-color;\n  }\n  .ui.tab.loading:after,\n  .ui.tab.loading.segment:after {\n    position: absolute;\n    content: '';\n    top: $tab-loader-distance-from-top;\n    left: 50%;\n\n    margin: $loader-margin;\n    width: $tab-loader-size;\n    height: $tab-loader-size;\n\n    animation: loader $loader-speed infinite linear;\n    border: $loader-line-width solid $loader-line-color;\n    border-radius: $circular-radius;\n\n    box-shadow: 0 0 0 1px transparent;\n  }\n}\n\n@import '../../themes/default/modules/tab.style';","@import '../../themes/default/modules/toast.variables';\n\n@if $use-toast {\n  /*******************************\n  //@-    Toast container\n  *******************************/\n\n  .ui.toast-container {\n      position: fixed;\n      z-index: 9999;\n  }\n\n  .ui.top.right.toast-container {\n      top: $toast-container-distance;\n      right: $toast-container-distance;\n      margin-left: $toast-container-distance;\n  }\n\n  .ui.top.left.toast-container {\n      top: $toast-container-distance;\n      left: $toast-container-distance;\n      margin-right: $toast-container-distance;\n  }\n\n  .ui.top.center.toast-container {\n      left: 50%;\n      transform: translate(-50%, 0);\n      top: $toast-container-distance;\n  }\n\n  .ui.bottom.right.toast-container {\n      bottom: $toast-container-distance;\n      right: $toast-container-distance;\n      margin-left: $toast-container-distance;\n  }\n\n  .ui.bottom.left.toast-container {\n      bottom: $toast-container-distance;\n      left: $toast-container-distance;\n      margin-right: $toast-container-distance;\n  }\n\n  .ui.bottom.center.toast-container {\n      left: 50%;\n      transform: translate(-50%, 0);\n      bottom: $toast-container-distance;\n  }\n\n  /*******************************\n              Toast\n  *******************************/\n\n  .toast {\n      display: block;\n      border-radius: $default-border-radius;\n      padding: $toast-padding;\n      margin: $toast-margin;\n      color: $toast-text-color;\n  }\n\n  .floating.toast,\n  .hoverfloating.toast:hover {\n    box-shadow: $floating-shadow;\n  }\n\n  .hoverfloating.message:hover {\n    box-shadow: 0 0 0 1px inset, $floating-shadow;\n  }\n\n  .center.toast-container .toast-box,\n  .right.toast-container .toast-box {\n      margin-left: auto;\n  }\n\n  .center.toast-container .toast-box {\n      margin-right: auto;\n  }\n\n  .visible.toast-box,\n  .animating.toast-box,\n  .toast-box {\n      display: table !important;\n  }\n\n\n  .toast-container .compact {\n    display: block;\n    width: $toast-width;\n  }\n\n  .toast-container .message,\n  .toast:hover {\n      opacity: $toast-opacity-on-hover;\n      cursor: $toast-cursor-on-hover;\n  }\n\n\n  .icon.toast .content {\n    padding-left: $toast-icon-content-padding;\n  }\n\n  .toast > .content > .header {\n      font-weight: bold;\n  }\n\n  .info.toast {\n      background-color: $toast-info-color;\n  }\n\n  .warning.toast {\n      background-color: $toast-warning-color;\n  }\n\n  .success.toast {\n      background-color: $toast-success-color;\n  }\n\n  .error.toast {\n      background-color: $toast-error-color;\n  }\n\n  .toast-box .info.attached.progress .bar {\n      background: $toast-info-progress-color !important;\n  }\n\n  .toast-box .warning.attached.progress .bar {\n      background: $toast-warning-progress-color !important;\n  }\n\n  .toast-box .success.attached.progress .bar {\n      background: $toast-success-progress-color !important;\n  }\n\n  .toast-box .error.attached.progress .bar {\n      background: $toast-error-progress-color !important;\n  }\n\n  /*--------------\n      Colors\n  -------------- */\n\n  @each $key, $value in $colors {\n    @if(index(join($main-colors-names, $use-toast-variation-colors), $key+'')) {\n      $color: $key;\n      $c: map-get($value, color);\n      $l: map-get($value, light);\n\n      .#{$key + \"\"}.toast {\n        background-color: $c;\n      }\n      @if($use-toast-variation-inverted) {\n        .inverted.#{$key + \"\"}.toast,\n        .toast-box .inverted.#{$key + \"\"}.attached.progress .bar {\n          background-color: $l;\n        }\n      }\n    }\n  }\n\n  @if($use-toast-variation-inverted) {\n    .inverted.toast {\n      color: $toast-inverted-text-color;\n    }\n  }\n  /*--------------\n        Icon\n  ---------------*/\n\n  .icon.toast > .icon:not(.close) {\n      display: inline-block;\n      vertical-align: $toast-icon-vertical-align;\n      font-size: $toast-icon-font-size;\n      position: absolute;\n  }\n\n\n\n  .icon.toast > .content {\n      display: inline-block;\n      vertical-align: $toast-content-vertical-align;\n  }\n\n  /*---------------\n    Progress Bar\n  ----------------*/\n\n  .toast-box .attached.progress .bar {\n      min-width: 0;\n  }\n\n  .toast-box .active.progress .bar:after {\n    animation: progress-active 2s $default-easing infinite !important;\n  }\n\n  .toast-box {\n      margin-bottom: $toast-margin-bottom;\n  }\n\n  .toast-box .toast,\n  .toast-box .message {\n      margin-top: 0;\n      margin-bottom: 0;\n      position: relative;\n  }\n  .toast-box .attached.progress{\n      z-index:1;\n  }\n\n  .toast-box .bottom.attached.progress {\n    margin: -3px 0 $toast-margin-bottom;\n  }\n\n  .toast-box .top.attached.progress {\n    margin: $toast-margin-bottom 0 -3px;\n  }\n\n  /* --------\n  Close Icon\n  -----------*/\n\n  .toast-box .message > .close.icon {\n    top: $toast-close-top-distance;\n    right: $toast-close-right-distance;\n  }\n\n\n  .toast-box .toast>.close.icon {\n    cursor: pointer;\n    position: absolute;\n    margin: 0;\n    top: $toast-close-top-distance;\n    right: $toast-close-right-distance;\n    opacity: $toast-close-opacity;\n    transition: $toast-close-transition;\n  }\n\n  .toast-box .toast > .close.icon:hover {\n    opacity: 1;\n  }\n}\n\n@import '../../themes/default/modules/toast.style';","@import '../../themes/default/modules/transition.variables';\n\n@if $use-transition {\n  /*******************************\n  //@-      Transitions\n  *******************************/\n\n  .transition {\n    animation-iteration-count: 1;\n    animation-duration: $transition-default-duration;\n    animation-timing-function: $transition-default-easing;\n    animation-fill-mode: $transition-default-fill;\n  }\n\n  /*******************************\n              States\n  *******************************/\n\n\n  /* Animating */\n  .animating.transition {\n    backface-visibility: $transition-backface-visibility;\n    visibility: visible !important;\n  }\n\n  /* Loading */\n  .loading.transition {\n    position: absolute;\n    top: -99999px;\n    left: -99999px;\n  }\n\n  /* Hidden */\n  .hidden.transition {\n    display: none;\n    visibility: hidden;\n  }\n\n  /* Visible */\n  .visible.transition {\n    display: block !important;\n    visibility: visible !important;\n  /*  backface-visibility: $transition-backface-visibility;\n    transform: $transition-use3-d-acceleration;*/\n  }\n\n  /* Disabled */\n  .disabled.transition {\n    animation-play-state: paused;\n  }\n\n  /*******************************\n            Variations\n  *******************************/\n\n  .looping.transition {\n    animation-iteration-count: infinite;\n  }\n}\n\n@import '../../themes/default/modules/transition.style';","@if $use-transition {\n  /*******************************\n            Transitions\n  *******************************/\n\n  /*\n    Some transitions adapted from Animate CSS\n    https://github.com/daneden/animate.css\n\n    Additional transitions adapted from Glide\n    by Nick Pettit - https://github.com/nickpettit/glide\n  */\n\n  /*--------------\n      Browse\n  ---------------*/\n\n  .transition.browse {\n    animation-duration: 500ms;\n  }\n  .transition.browse.in {\n    animation-name: browseIn;\n  }\n  .transition.browse.out,\n  .transition.browse.left.out {\n    animation-name: browseOutLeft;\n  }\n  .transition.browse.right.out {\n    animation-name: browseOutRight;\n  }\n\n  /* In */\n  @keyframes browseIn {\n    0% {\n      transform: scale(0.8) translateZ(0px);\n      z-index: -1;\n    }\n    10% {\n      transform: scale(0.8) translateZ(0px);\n      z-index: -1;\n      opacity: 0.7;\n    }\n    80% {\n      transform: scale(1.05) translateZ(0px);\n      opacity: 1;\n      z-index: 999;\n    }\n    100% {\n      transform: scale(1) translateZ(0px);\n      z-index: 999;\n    }\n  }\n\n  /* Out */\n  @keyframes browseOutLeft {\n    0% {\n      z-index: 999;\n      transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n    }\n    50% {\n      z-index: -1;\n      transform: translateX(-105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n    }\n    80% {\n      opacity: 1;\n    }\n    100% {\n      z-index: -1;\n      transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n      opacity: 0;\n    }\n  }\n  @keyframes browseOutRight {\n    0% {\n      z-index: 999;\n      transform: translateX(0%) rotateY(0deg) rotateX(0deg);\n    }\n    50% {\n      z-index: 1;\n      transform: translateX(105%) rotateY(35deg) rotateX(10deg) translateZ(-10px);\n    }\n    80% {\n      opacity: 1;\n    }\n    100% {\n      z-index: 1;\n      transform: translateX(0%) rotateY(0deg) rotateX(0deg) translateZ(-10px);\n      opacity: 0;\n    }\n  }\n\n\n  /*--------------\n      Drop\n  ---------------*/\n\n  .drop.transition {\n    transform-origin: top center;\n    animation-duration: 400ms;\n    animation-timing-function: cubic-bezier(0.34, 1.61, 0.7, 1);\n  }\n  .drop.transition.in {\n    animation-name: dropIn;\n  }\n  .drop.transition.out {\n    animation-name: dropOut;\n  }\n\n  /* Drop */\n  @keyframes dropIn {\n    0% {\n      opacity: 0;\n      transform: scale(0);\n    }\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n  @keyframes dropOut {\n    0% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    100% {\n      opacity: 0;\n      transform: scale(0);\n    }\n  }\n\n  /*--------------\n        Fade\n  ---------------*/\n\n  .transition.fade.in {\n    animation-name: fadeIn;\n  }\n  .transition[class*=\"fade up\"].in {\n    animation-name: fadeInUp;\n  }\n  .transition[class*=\"fade down\"].in {\n    animation-name: fadeInDown;\n  }\n  .transition[class*=\"fade left\"].in {\n    animation-name: fadeInLeft;\n  }\n  .transition[class*=\"fade right\"].in {\n    animation-name: fadeInRight;\n  }\n\n  .transition.fade.out {\n    animation-name: fadeOut;\n  }\n  .transition[class*=\"fade up\"].out {\n    animation-name: fadeOutUp;\n  }\n  .transition[class*=\"fade down\"].out {\n    animation-name: fadeOutDown;\n  }\n  .transition[class*=\"fade left\"].out {\n    animation-name: fadeOutLeft;\n  }\n  .transition[class*=\"fade right\"].out {\n    animation-name: fadeOutRight;\n  }\n\n  /* In */\n  @keyframes fadeIn {\n    0% {\n      opacity: 0;\n    }\n    100% {\n      opacity: 1;\n    }\n  }\n  @keyframes fadeInUp {\n    0% {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0%);\n    }\n  }\n  @keyframes fadeInDown {\n    0% {\n      opacity: 0;\n      transform: translateY(-10%);\n    }\n    100% {\n      opacity: 1;\n      transform: translateY(0%);\n    }\n  }\n  @keyframes fadeInLeft {\n    0% {\n      opacity: 0;\n      transform: translateX(10%);\n    }\n    100% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n  }\n  @keyframes fadeInRight {\n    0% {\n      opacity: 0;\n      transform: translateX(-10%);\n    }\n    100% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n  }\n\n  /* Out */\n  @keyframes fadeOut {\n    0% {\n      opacity: 1;\n    }\n    100% {\n      opacity: 0;\n    }\n  }\n  @keyframes fadeOutUp {\n    0% {\n      opacity: 1;\n      transform: translateY(0%);\n    }\n    100% {\n      opacity: 0;\n      transform: translateY(5%);\n    }\n  }\n  @keyframes fadeOutDown {\n    0% {\n      opacity: 1;\n      transform: translateY(0%);\n    }\n    100% {\n      opacity: 0;\n      transform: translateY(-5%);\n    }\n  }\n  @keyframes fadeOutLeft {\n    0% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(5%);\n    }\n  }\n  @keyframes fadeOutRight {\n    0% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(-5%);\n    }\n  }\n\n  /*--------------\n      Flips\n  ---------------*/\n\n  .flip.transition.in,\n  .flip.transition.out {\n    animation-duration: 600ms;\n  }\n  .horizontal.flip.transition.in {\n    animation-name: horizontalFlipIn;\n  }\n  .horizontal.flip.transition.out {\n    animation-name: horizontalFlipOut;\n  }\n  .vertical.flip.transition.in {\n    animation-name: verticalFlipIn;\n  }\n  .vertical.flip.transition.out {\n    animation-name: verticalFlipOut;\n  }\n\n  /* In */\n  @keyframes horizontalFlipIn {\n    0% {\n      transform: perspective(2000px) rotateY(-90deg);\n      opacity: 0;\n    }\n    100% {\n      transform: perspective(2000px) rotateY(0deg);\n      opacity: 1;\n    }\n  }\n  @keyframes verticalFlipIn {\n    0% {\n      transform: perspective(2000px) rotateX(-90deg);\n      opacity: 0;\n    }\n    100% {\n      transform: perspective(2000px) rotateX(0deg);\n      opacity: 1;\n    }\n  }\n\n  /* Out */\n  @keyframes horizontalFlipOut {\n    0% {\n      transform: perspective(2000px) rotateY(0deg);\n      opacity: 1;\n    }\n    100% {\n      transform: perspective(2000px) rotateY(90deg);\n      opacity: 0;\n    }\n  }\n  @keyframes verticalFlipOut {\n    0% {\n      transform: perspective(2000px) rotateX(0deg);\n      opacity: 1;\n    }\n    100% {\n      transform: perspective(2000px) rotateX(-90deg);\n      opacity: 0;\n    }\n  }\n\n  /*--------------\n        Scale\n  ---------------*/\n\n  .scale.transition.in {\n    animation-name: scaleIn;\n  }\n  .scale.transition.out {\n    animation-name: scaleOut;\n  }\n\n  @keyframes scaleIn {\n    0% {\n      opacity: 0;\n      transform: scale(0.8);\n    }\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n\n  /* Out */\n  @keyframes scaleOut {\n    0% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    100% {\n      opacity: 0;\n      transform: scale(0.9);\n    }\n  }\n\n\n  /*--------------\n        Fly\n  ---------------*/\n\n  /* Inward */\n  .transition.fly {\n    animation-duration: 0.6s;\n    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n  .transition.fly.in {\n    animation-name: flyIn;\n  }\n  .transition[class*=\"fly up\"].in {\n    animation-name: flyInUp;\n  }\n  .transition[class*=\"fly down\"].in {\n    animation-name: flyInDown;\n  }\n  .transition[class*=\"fly left\"].in {\n    animation-name: flyInLeft;\n  }\n  .transition[class*=\"fly right\"].in {\n    animation-name: flyInRight;\n  }\n\n  /* Outward */\n  .transition.fly.out {\n    animation-name: flyOut;\n  }\n  .transition[class*=\"fly up\"].out {\n    animation-name: flyOutUp;\n  }\n  .transition[class*=\"fly down\"].out {\n    animation-name: flyOutDown;\n  }\n  .transition[class*=\"fly left\"].out {\n    animation-name: flyOutLeft;\n  }\n  .transition[class*=\"fly right\"].out {\n    animation-name: flyOutRight;\n  }\n\n  /* In */\n  @keyframes flyIn {\n    0% {\n      opacity: 0;\n      transform: scale3d(.3, .3, .3);\n    }\n    20% {\n      transform: scale3d(1.1, 1.1, 1.1);\n    }\n    40% {\n      transform: scale3d(.9, .9, .9);\n    }\n    60% {\n      opacity: 1;\n      transform: scale3d(1.03, 1.03, 1.03);\n    }\n    80% {\n      transform: scale3d(.97, .97, .97);\n    }\n    100% {\n      opacity: 1;\n      transform: scale3d(1, 1, 1);\n    }\n  }\n  @keyframes flyInUp {\n    0% {\n      opacity: 0;\n      transform: translate3d(0, 1500px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    75% {\n      transform: translate3d(0, 10px, 0);\n    }\n    90% {\n      transform: translate3d(0, -5px, 0);\n    }\n    100% {\n      transform: translate3d(0, 0, 0);\n    }\n  }\n  @keyframes flyInDown {\n    0% {\n      opacity: 0;\n      transform: translate3d(0, -1500px, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, 25px, 0);\n    }\n    75% {\n      transform: translate3d(0, -10px, 0);\n    }\n    90% {\n      transform: translate3d(0, 5px, 0);\n    }\n    100% {\n      transform: none;\n    }\n  }\n  @keyframes flyInLeft {\n    0% {\n      opacity: 0;\n      transform: translate3d(1500px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(-25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(-5px, 0, 0);\n    }\n    100% {\n      transform: none;\n    }\n  }\n  @keyframes flyInRight {\n    0% {\n      opacity: 0;\n      transform: translate3d(-1500px, 0, 0);\n    }\n    60% {\n      opacity: 1;\n      transform: translate3d(25px, 0, 0);\n    }\n    75% {\n      transform: translate3d(-10px, 0, 0);\n    }\n    90% {\n      transform: translate3d(5px, 0, 0);\n    }\n    100% {\n      transform: none;\n    }\n  }\n\n  /* Out */\n  @keyframes flyOut {\n    20% {\n      transform: scale3d(.9, .9, .9);\n    }\n    50%, 55% {\n      opacity: 1;\n      transform: scale3d(1.1, 1.1, 1.1);\n    }\n    100% {\n      opacity: 0;\n      transform: scale3d(.3, .3, .3);\n    }\n  }\n  @keyframes flyOutUp {\n    20% {\n      transform: translate3d(0, 10px, 0);\n    }\n    40%, 45% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0);\n    }\n    100% {\n      opacity: 0;\n      transform: translate3d(0, 2000px, 0);\n    }\n  }\n  @keyframes flyOutDown {\n    20% {\n      transform: translate3d(0, -10px, 0);\n    }\n    40%, 45% {\n      opacity: 1;\n      transform: translate3d(0, 20px, 0);\n    }\n    100% {\n      opacity: 0;\n      transform: translate3d(0, -2000px, 0);\n    }\n  }\n  @keyframes flyOutRight {\n    20% {\n      opacity: 1;\n      transform: translate3d(20px, 0, 0);\n    }\n    100% {\n      opacity: 0;\n      transform: translate3d(-2000px, 0, 0);\n    }\n  }\n  @keyframes flyOutLeft {\n    20% {\n      opacity: 1;\n      transform: translate3d(-20px, 0, 0);\n    }\n    100% {\n      opacity: 0;\n      transform: translate3d(2000px, 0, 0);\n    }\n  }\n\n  /*--------------\n      Slide\n  ---------------*/\n\n  .transition.slide.in,\n  .transition[class*=\"slide down\"].in {\n    animation-name: slideInY;\n    transform-origin: top center;\n  }\n  .transition[class*=\"slide up\"].in {\n    animation-name: slideInY;\n    transform-origin: bottom center;\n  }\n  .transition[class*=\"slide left\"].in {\n    animation-name: slideInX;\n    transform-origin: center right;\n  }\n  .transition[class*=\"slide right\"].in {\n    animation-name: slideInX;\n    transform-origin: center left;\n  }\n\n  .transition.slide.out,\n  .transition[class*=\"slide down\"].out {\n    animation-name: slideOutY;\n    transform-origin: top center;\n  }\n  .transition[class*=\"slide up\"].out {\n    animation-name: slideOutY;\n    transform-origin: bottom center;\n  }\n  .transition[class*=\"slide left\"].out {\n    animation-name: slideOutX;\n    transform-origin: center right;\n  }\n  .transition[class*=\"slide right\"].out {\n    animation-name: slideOutX;\n    transform-origin: center left;\n  }\n\n  /* In */\n  @keyframes slideInY {\n    0% {\n      opacity: 0;\n      transform: scaleY(0);\n    }\n    100% {\n      opacity: 1;\n      transform: scaleY(1);\n    }\n  }\n  @keyframes slideInX {\n    0% {\n      opacity: 0;\n      transform: scaleX(0);\n    }\n    100% {\n      opacity: 1;\n      transform: scaleX(1);\n    }\n  }\n\n  /* Out */\n  @keyframes slideOutY {\n    0% {\n      opacity: 1;\n      transform: scaleY(1);\n    }\n    100% {\n      opacity: 0;\n      transform: scaleY(0);\n    }\n  }\n  @keyframes slideOutX {\n    0% {\n      opacity: 1;\n      transform: scaleX(1);\n    }\n    100% {\n      opacity: 0;\n      transform: scaleX(0);\n    }\n  }\n\n\n  /*--------------\n      Swing\n  ---------------*/\n\n  .transition.swing {\n    animation-duration: 800ms;\n  }\n\n  .transition[class*=\"swing down\"].in {\n    animation-name: swingInX;\n    transform-origin: top center;\n  }\n  .transition[class*=\"swing up\"].in {\n    animation-name: swingInX;\n    transform-origin: bottom center;\n  }\n  .transition[class*=\"swing left\"].in {\n    animation-name: swingInY;\n    transform-origin: center right;\n  }\n  .transition[class*=\"swing right\"].in {\n    animation-name: swingInY;\n    transform-origin: center left;\n  }\n\n  .transition.swing.out,\n  .transition[class*=\"swing down\"].out {\n    animation-name: swingOutX;\n    transform-origin: top center;\n  }\n  .transition[class*=\"swing up\"].out {\n    animation-name: swingOutX;\n    transform-origin: bottom center;\n  }\n  .transition[class*=\"swing left\"].out {\n    animation-name: swingOutY;\n    transform-origin: center right;\n  }\n  .transition[class*=\"swing right\"].out {\n    animation-name: swingOutY;\n    transform-origin: center left;\n  }\n\n  /* In */\n  @keyframes swingInX {\n    0% {\n      transform: perspective(1000px) rotateX(90deg);\n      opacity: 0;\n    }\n    40% {\n      transform: perspective(1000px) rotateX(-30deg);\n      opacity: 1;\n    }\n    60% {\n      transform: perspective(1000px) rotateX(15deg);\n    }\n    80% {\n      transform: perspective(1000px) rotateX(-7.5deg);\n    }\n    100% {\n      transform: perspective(1000px) rotateX(0deg);\n    }\n  }\n  @keyframes swingInY {\n    0% {\n      transform: perspective(1000px) rotateY(-90deg);\n      opacity: 0;\n    }\n    40% {\n      transform: perspective(1000px) rotateY(30deg);\n      opacity: 1;\n    }\n    60% {\n      transform: perspective(1000px) rotateY(-17.5deg);\n    }\n    80% {\n      transform: perspective(1000px) rotateY(7.5deg);\n    }\n    100% {\n      transform: perspective(1000px) rotateY(0deg);\n    }\n  }\n\n  /* Out */\n  @keyframes swingOutX {\n    0% {\n      transform: perspective(1000px) rotateX(0deg);\n    }\n    40% {\n      transform: perspective(1000px) rotateX(-7.5deg);\n    }\n    60% {\n      transform: perspective(1000px) rotateX(17.5deg);\n    }\n    80% {\n      transform: perspective(1000px) rotateX(-30deg);\n      opacity: 1;\n    }\n    100% {\n      transform: perspective(1000px) rotateX(90deg);\n      opacity: 0;\n    }\n  }\n  @keyframes swingOutY {\n    0% {\n      transform: perspective(1000px) rotateY(0deg);\n    }\n    40% {\n      transform: perspective(1000px) rotateY(7.5deg);\n    }\n    60% {\n      transform: perspective(1000px) rotateY(-10deg);\n    }\n    80% {\n      transform: perspective(1000px) rotateY(30deg);\n      opacity: 1;\n    }\n    100% {\n      transform: perspective(1000px) rotateY(-90deg);\n      opacity: 0;\n    }\n  }\n\n\n  /*--------------\n        Zoom\n  ---------------*/\n\n  .transition.zoom.in {\n    animation-name: zoomIn;\n  }\n  .transition.zoom.out {\n    animation-name: zoomOut;\n  }\n  @keyframes zoomIn {\n    0% {\n      opacity: 1;\n      transform: scale(0);\n    }\n    100% {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n  @keyframes zoomOut {\n    0% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    100% {\n      opacity: 1;\n      transform: scale(0);\n    }\n  }\n\n\n  /*******************************\n        Static Animations\n  *******************************/\n\n  /*--------------\n      Emphasis\n  ---------------*/\n\n\n  .flash.transition {\n    animation-duration: 750ms;\n    animation-name: flash;\n  }\n  .shake.transition {\n    animation-duration: 750ms;\n    animation-name: shake;\n  }\n  .bounce.transition {\n    animation-duration: 750ms;\n    animation-name: bounce;\n  }\n  .tada.transition {\n    animation-duration: 750ms;\n    animation-name: tada;\n  }\n  .pulse.transition {\n    animation-duration: 500ms;\n    animation-name: pulse;\n  }\n  .jiggle.transition {\n    animation-duration: 750ms;\n    animation-name: jiggle;\n  }\n  .transition.glow {\n    animation-duration: 2000ms;\n    animation-timing-function: cubic-bezier(0.190, 1.000, 0.220, 1.000);\n  }\n  .transition.glow {\n    animation-name: glow;\n  }\n\n\n  /* Flash */\n  @keyframes flash {\n    0%, 50%, 100% {\n      opacity: 1;\n    }\n    25%, 75% {\n      opacity: 0;\n    }\n  }\n\n  /* Shake */\n  @keyframes shake {\n    0%, 100% {\n      transform: translateX(0);\n    }\n    10%, 30%, 50%, 70%, 90% {\n      transform: translateX(-10px);\n    }\n    20%, 40%, 60%, 80% {\n      transform: translateX(10px);\n    }\n  }\n\n  /* Bounce */\n  @keyframes bounce {\n    0%, 20%, 50%, 80%, 100% {\n      transform: translateY(0);\n    }\n    40% {\n      transform: translateY(-30px);\n    }\n    60% {\n      transform: translateY(-15px);\n    }\n  }\n\n  /* Tada */\n  @keyframes tada {\n    0% {\n      transform: scale(1);\n    }\n    10%, 20% {\n      transform: scale(0.9) rotate(-3deg);\n    }\n    30%, 50%, 70%, 90% {\n      transform: scale(1.1) rotate(3deg);\n    }\n    40%, 60%, 80% {\n      transform: scale(1.1) rotate(-3deg);\n    }\n    100% {\n      transform: scale(1) rotate(0);\n    }\n  }\n\n  /* Pulse */\n  @keyframes pulse {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    50% {\n      transform: scale(0.9);\n      opacity: 0.7;\n    }\n    100% {\n      transform: scale(1);\n      opacity: 1;\n    }\n\n  }\n\n  /* Jiggle */\n  @keyframes jiggle {\n    0% {\n      transform: scale3d(1, 1, 1);\n    }\n    30% {\n      transform: scale3d(1.25, 0.75, 1);\n    }\n    40% {\n      transform: scale3d(0.75, 1.25, 1);\n    }\n    50% {\n      transform: scale3d(1.15, 0.85, 1);\n    }\n    65% {\n      transform: scale3d(.95, 1.05, 1);\n    }\n    75% {\n      transform: scale3d(1.05, .95, 1);\n    }\n    100% {\n      transform: scale3d(1, 1, 1);\n    }\n  }\n\n  /* Glow */\n  @keyframes glow {\n    0% {\n      background-color: #FCFCFD;\n    }\n    30% {\n      background-color: #FFF6CD;\n    }\n    100% {\n      background-color: #FCFCFD;\n    }\n  }\n}\n","$font-name: \"Lato\" !default;\r\n\r\n$header-font: $font-name, \"Helvetica Neue\", Arial, Helvetica, sans-serif !default;\r\n$page-font: $font-name, \"Helvetica Neue\", Arial, Helvetica, sans-serif !default;\r\n\r\n$google-font-name: $font-name !default;\r\n$import-google-fonts: true !default;\r\n$google-font-sizes: \"400,700,400italic,700italic\" !default;\r\n$google-subset: \"latin\" !default;\r\n\r\n$google-protocol: \"https://\" !default;\r\n$google-font-request: \"#{$google-font-name}:#{$google-font-sizes}&subset=#{$google-subset}\" !default;\r\n\r\n$bold: bold !default;\r\n$normal: normal !default;\r\n\r\n// This is the single variable that controls them all */\r\n$em-size: 14px !default;\r\n\r\n// The size of page text  */\r\n$font-size: 14px !default;\r\n\r\n$glyph-width: 1.1em !default;\r\n","$page-background: #ffffff !default;\r\n$page-overflow-x: hidden !default;\r\n// Minimum Mobile Width */\r\n$page-min-width: 320px !default;\r\n","$line-height: 1.4285em !default;\r\n$line-height-offset: (($line-height - 1em) / 2) !default;\r\n$paragraph-margin: 0 0 1em !default;\r\n$paragraph-line-height: $line-height !default;\r\n","//@import \"../colors/all\";\r\n//@import \"./neutral\";\r\n\r\n$text-color: rgba(0, 0, 0, 0.87) !default;\r\n\r\n$primary-text-color: $inverted-text-color !default;\r\n$secondary-text-color: $inverted-text-color !default;\r\n$red-text-color: $red !default;\r\n$orange-text-color: $orange !default;\r\n$yellow-text-color: #b58105 !default; // Yellow text is difficult to read\r\n$olive-text-color: #8abc1e !default; // Olive is difficult to read\r\n$green-text-color: #1ebc30 !default; // Green is difficult to read\r\n$teal-text-color: #10a3a3 !default; // Teal text is difficult to read\r\n$blue-text-color: $blue !default;\r\n$violet-text-color: $violet !default;\r\n$purple-text-color: $purple !default;\r\n$pink-text-color: $pink !default;\r\n$brown-text-color: $brown !default;\r\n$grey-text-color: $grey !default;\r\n$black-text-color: $black !default;\r\n","// @import \"../../../../utils/all\";\r\n// @import \"../fonts/all\";\r\n\r\n$header-font-weight: $bold !default;\r\n$header-line-height: join-value-to-unit((18 / 14), em) !default;\r\n\r\n$h1: join-value-to-unit((28 / 14), rem) !default;\r\n$h2: join-value-to-unit((24 / 14), rem) !default;\r\n$h3: join-value-to-unit((18 / 14), rem) !default;\r\n$h4: join-value-to-unit((15 / 14), rem) !default;\r\n$h5: join-value-to-unit((14 / 14), rem) !default;\r\n","//@import \"./font-size\";\r\n\r\n$header-line-height-offset: ($header-line-height - 1em) / 2 !default;\r\n\r\n// Header Spacing */\r\n$header-top-margin: calc(2rem - #{$header-line-height-offset}) !default;\r\n$header-bottom-margin: 1rem !default;\r\n$header-margin: $header-top-margin 0 $header-bottom-margin !default;\r\n","$link-color: #4183c4 !default;\n","$link-underline: none !default;\r\n","// @import \"./main\";\r\n// @import \"./colored\";\r\n\r\n$link-hover-color: darken(saturate($link-color, 20), 15);\r\n$link-hover-underline: $link-underline;\r\n","$use-custom-scrollbars: true !default;\r\n\r\n// Rendered Scrollbar Width */\r\n$scrollbar-width: 17px !default;\r\n\r\n$custom-scrollbar-width: 5px !default;\r\n$custom-scrollbar-height: 5px !default;\r\n\r\n$track-border-radius: 0 !default;\r\n\r\n$thumb-border-radius: 5px !default;\r\n$thumb-transition: color 0.2s ease !default;\r\n","$track-background: transparent !default;\r\n$thumb-background: rgba(0, 0, 0, 0.1) !default;\r\n$thumb-inactive-background: rgba(0, 0, 0, 0.15) !default;\r\n$thumb-hover-background: rgba(128, 135, 139, 0.8) !default;\r\n","$track-inverted-background: rgba(255, 255, 255, 0.1) !default;\r\n$thumb-inverted-background: rgba(255, 255, 255, 0.25) !default;\r\n$thumb-inverted-inactive-background: rgba(255, 255, 255, 0.15) !default;\r\n$thumb-inverted-hover-background: rgba(255, 255, 255, 0.35) !default;\r\n","//@import \"./colored\";\r\n\r\n$highlight-background: #cce2ff !default;\r\n$highlight-color: $text-color !default;\r\n\r\n$input-highlight-background: rgba(100, 100, 100, 0.4) !default;\r\n$input-highlight-color: $text-color !default;\r\n","\r\n//@-****************************** Button *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n//- Button */\r\n$button-vertical-margin: 0 !default;\r\n$button-horizontal-margin: 0.25em !default;\r\n$button-background-color: #E0E1E2 !default;\r\n$button-background-image: none !default;\r\n$button-background: $button-background-color $button-background-image !default;\r\n$button-line-height: 1em !default;\r\n\r\n//- Button defaults to using same height as input globally */\r\n$button-vertical-padding: $input-vertical-padding !default;\r\n$button-horizontal-padding: 1.5em !default;\r\n\r\n//- Text */\r\n$button-text-transform: none !default;\r\n$button-tap-color: transparent !default;\r\n$button-font-family: $page-font !default;\r\n$button-font-weight: $bold !default;\r\n$button-text-color: rgba(0, 0, 0, 0.6) !default;\r\n$button-text-shadow: none !default;\r\n$button-inverted-text-shadow: $button-text-shadow !default;\r\n$button-border-radius: $default-border-radius !default;\r\n$button-vertical-align: baseline !default;\r\n\r\n//- Internal Shadow */\r\n$button-shadow-distance: 0 !default;\r\n$button-shadow-offset: ($button-shadow-distance / 2) !default;\r\n$button-shadow-box-shadow: 0 (-$button-shadow-distance) 0 0 $border-color inset !default;\r\n\r\n//- Box Shadow */\r\n$button-border-box-shadow-color: transparent !default;\r\n$button-border-box-shadow-width: 1px !default;\r\n$button-border-box-shadow: 0 0 0 $button-border-box-shadow-width $button-border-box-shadow-color inset !default;\r\n$button-box-shadow:\r\n  $button-border-box-shadow,\r\n  $button-shadow-box-shadow\r\n !default;\r\n\r\n//- Icon */\r\n$button-icon-height: auto !default;\r\n$button-icon-opacity: 0.8 !default;\r\n$button-icon-distance: $relative6px !default;\r\n$button-icon-color: '' !default;\r\n$button-icon-transition: opacity $default-duration $default-easing !default;\r\n$button-icon-vertical-align: '' !default;\r\n\r\n$button-icon-margin: 0 $button-icon-distance 0 (-$button-icon-distance / 2) !default;\r\n$button-right-icon-margin: 0 (-$button-icon-distance / 2) 0 $button-icon-distance !default;\r\n\r\n//- Loader */\r\n$button-inverted-loader-fill-color: rgba(0, 0, 0, 0.15) !default;\r\n\r\n$button-transition:\r\n  opacity $default-duration $default-easing,\r\n  background-color $default-duration $default-easing,\r\n  color $default-duration $default-easing,\r\n  box-shadow $default-duration $default-easing,\r\n  background $default-duration $default-easing\r\n !default;\r\n//- $button-will-change: box-shadow, transform, opacity, color, background !default; */\r\n$button-will-change: auto !default;\r\n\r\n//-------------------- Group --------------------*/\r\n\r\n$button-group-box-shadow: none !default;\r\n$button-group-super-box-shadow: $button-box-shadow !default;\r\n$button-vertical-box-shadow: none !default;\r\n$button-group-offset: 0 0 0 0 !default;\r\n$button-vertical-group-offset: 0 0 0 0 !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n//- Hovered */\r\n$button-hover-background-color: #CACBCD !default;\r\n$button-hover-background-image: $button-background-image !default;\r\n$button-hover-box-shadow: $button-box-shadow !default;\r\n$button-hover-color: $hovered-text-color !default;\r\n$button-icon-hover-opacity: 0.85 !default;\r\n\r\n//- Focused */\r\n$button-focus-background-color: $button-hover-background-color !default;\r\n$button-focus-background-image: none !default;\r\n$button-focus-box-shadow: '' !default;\r\n$button-focus-color: $hovered-text-color !default;\r\n$button-icon-focus-opacity: 0.85 !default;\r\n\r\n//- Disabled */\r\n$button-disabled-background-image: none !default;\r\n$button-disabled-box-shadow: none !default;\r\n\r\n//- Pressed Down */\r\n$button-down-background-color: #BABBBC !default;\r\n$button-down-background-image: '' !default;\r\n$button-down-pressed-shadow: none !default;\r\n$button-down-box-shadow:\r\n  $button-border-box-shadow,\r\n  $button-down-pressed-shadow\r\n !default;\r\n$button-down-color: $pressed-text-color !default;\r\n\r\n//- Active */\r\n$button-active-background-color: #C0C1C2 !default;\r\n$button-active-background-image: none !default;\r\n$button-active-color: $selected-text-color !default;\r\n$button-active-box-shadow: $button-border-box-shadow !default;\r\n\r\n//- Active + Hovered */\r\n$button-active-hover-background-color: $button-active-background-color !default;\r\n$button-active-hover-background-image: none !default;\r\n$button-active-hover-color: $button-active-color !default;\r\n$button-active-hover-box-shadow: $button-active-box-shadow !default;\r\n\r\n//- Loading */\r\n$button-loading-opacity: 1 !default;\r\n$button-loading-pointer-events: auto !default;\r\n$button-loading-transition:\r\n  all 0s linear,\r\n  opacity $default-duration $default-easing\r\n !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Or */\r\n$button-or-text: 'or' !default;\r\n\r\n$button-or-gap: 0.3em !default;\r\n$button-or-height: ($button-vertical-padding * 2) + 1em !default;\r\n$button-or-z-index: 3 !default;\r\n\r\n$button-or-circle-distance-to-edge: ($button-vertical-padding) !default;\r\n$button-or-circle-size: $button-or-height - $button-or-circle-distance-to-edge !default;\r\n$button-or-line-height: ($button-or-circle-size) !default;\r\n$button-or-box-shadow: $button-border-box-shadow !default;\r\n\r\n$button-or-vertical-offset: -($button-or-circle-size / 2) !default;\r\n$button-or-horizontal-offset: -($button-or-circle-size / 2) !default;\r\n\r\n$button-or-background-color: $white !default;\r\n$button-or-text-shadow: $button-inverted-text-shadow !default;\r\n$button-or-text-style: $normal !default;\r\n$button-or-text-weight: $bold !default;\r\n$button-or-text-color: $light-text-color !default;\r\n\r\n\r\n$button-or-spacer-height: $button-vertical-padding !default;\r\n$button-or-spacer-color: transparent !default;\r\n\r\n//- Icon */\r\n$button-with-icon-opacity: 0.9 !default;\r\n\r\n//- Labeled */\r\n$button-labeled-label-font-size: $medium !default;\r\n$button-labeled-label-align: center !default;\r\n$button-labeled-label-padding: '' !default;\r\n$button-labeled-label-font-size: $relative-medium !default;\r\n$button-labeled-label-border-color: $border-color !default;\r\n$button-labeled-label-border-offset: -$button-border-box-shadow-width !default;\r\n$button-labeled-tag-label-size: 1.85em !default; //- hypotenuse of triangle */\r\n$button-labeled-icon-margin: 0 !default;\r\n\r\n//- Labeled Icon */\r\n$button-labeled-icon-width: 1em + ($button-vertical-padding * 2) !default;\r\n$button-labeled-icon-background-color: rgba(0, 0, 0, 0.05) !default;\r\n$button-labeled-icon-padding: ($button-horizontal-padding + $button-labeled-icon-width) !default;\r\n$button-labeled-icon-border: transparent !default;\r\n$button-labeled-icon-color: '' !default;\r\n\r\n$button-labeled-icon-left-shadow: -1px 0 0 0 $button-labeled-icon-border inset !default;\r\n$button-labeled-icon-right-shadow: 1px 0 0 0 $button-labeled-icon-border inset !default;\r\n\r\n\r\n//- Inverted */\r\n$button-inverted-border-size: 2px !default;\r\n$button-inverted-text-color: $white !default;\r\n$button-inverted-text-hover-color: $button-hover-color !default;\r\n$button-inverted-group-offset: 0 0 0 (-$button-inverted-border-size) !default;\r\n$button-inverted-vertical-group-offset: 0 0 (-$button-inverted-border-size) 0 !default;\r\n\r\n//- Basic */\r\n$button-basic-border-radius: $button-border-radius !default;\r\n$button-basic-border-size: 1px !default;\r\n$button-basic-text-color: $button-text-color !default;\r\n$button-basic-colored-border-size: 1px !default;\r\n\r\n$button-basic-background: transparent none !default;\r\n$button-basic-font-weight: $normal !default;\r\n$button-basic-border: 1px solid $border-color !default;\r\n$button-basic-box-shadow: 0 0 0 $button-basic-border-size $border-color inset !default;\r\n$button-basic-loading-color: $off-white !default;\r\n$button-basic-text-transform: none !default;\r\n\r\n//- Basic Hover */\r\n$button-basic-hover-background: #FFFFFF !default;\r\n$button-basic-hover-text-color: $hovered-text-color !default;\r\n$button-basic-hover-box-shadow:\r\n  0 0 0 $button-basic-border-size $selected-border-color inset,\r\n  0 0 0 0 $border-color inset\r\n !default;\r\n//- Basic Focus */\r\n$button-basic-focus-background: $button-basic-hover-background !default;\r\n$button-basic-focus-text-color: $button-basic-hover-text-color !default;\r\n$button-basic-focus-box-shadow: $button-basic-hover-box-shadow !default;\r\n\r\n//- Basic Down */\r\n$button-basic-down-background: #F8F8F8 !default;\r\n$button-basic-down-text-color: $pressed-text-color !default;\r\n$button-basic-down-box-shadow:\r\n  0 0 0 $button-basic-border-size rgba(0, 0, 0, 0.15) inset,\r\n  0 1px 4px 0 $border-color inset\r\n !default;\r\n//- Basic Active */\r\n$button-basic-active-background: $transparent-black !default;\r\n$button-basic-active-box-shadow: '' !default;\r\n$button-basic-active-text-color: $selected-text-color !default;\r\n\r\n//- Basic Inverted */\r\n$button-basic-inverted-background: transparent !default;\r\n$button-basic-inverted-focus-background: transparent !default;\r\n$button-basic-inverted-down-background: $transparent-white !default;\r\n$button-basic-inverted-active-background: $transparent-white !default;\r\n\r\n$button-basic-inverted-box-shadow: 0 0 0 $button-inverted-border-size rgba(255, 255, 255, 0.5) inset !default;\r\n$button-basic-inverted-hover-box-shadow: 0 0 0 $button-inverted-border-size rgba(255, 255, 255, 1) inset !default;\r\n$button-basic-inverted-focus-box-shadow: 0 0 0 $button-inverted-border-size rgba(255, 255, 255, 1) inset !default;\r\n$button-basic-inverted-down-box-shadow: 0 0 0 $button-inverted-border-size rgba(255, 255, 255, 0.9) inset !default;\r\n$button-basic-inverted-active-box-shadow: 0 0 0 $button-inverted-border-size rgba(255, 255, 255, 0.7) inset !default;\r\n\r\n$button-basic-inverted-color: $dark-white !default;\r\n$button-basic-inverted-hover-color: $dark-white-hover !default;\r\n$button-basic-inverted-down-color: $dark-white-active !default;\r\n$button-basic-inverted-active-color: $button-inverted-text-color !default;\r\n\r\n\r\n//- Basic Group */\r\n$button-basic-group-border: $button-basic-border-size solid $border-color !default;\r\n$button-basic-group-box-shadow: none !default;\r\n\r\n//--------------  Tertiary -------------*/\r\n$button-tertiary-line-padding: 0.5em !default;\r\n$button-tertiary-line-height: 0.2em !default;\r\n$button-tertiary-text-color: $button-text-color !default;\r\n$button-tertiary-line-color: lighten($button-tertiary-text-color, 20%) !default;\r\n$button-tertiary-with-underline: false !default;\r\n$button-tertiary-with-overline: false !default;\r\n$button-tertiary-background-color: none !default;\r\n\r\n//- Tertiary Hover */\r\n$button-tertiary-hover-color: lighten(fade-in($button-tertiary-text-color, 1), 20%) !default;\r\n$button-tertiary-hover-line-color: lighten($button-tertiary-hover-color, 20%) !default;\r\n$button-tertiary-hover-with-underline: true !default;\r\n$button-tertiary-hover-with-overline: false !default;\r\n$button-tertiary-hover-background-color: none !default;\r\n\r\n//- Tertiary Focus */\r\n$button-tertiary-focus-color: lighten(fade-in($button-tertiary-text-color, 1), 20%) !default;\r\n$button-tertiary-focus-line-color: lighten($button-tertiary-hover-color, 20%) !default;\r\n$button-tertiary-focus-with-underline: true !default;\r\n$button-tertiary-focus-with-overline: false !default;\r\n$button-tertiary-focus-background-color: none !default;\r\n\r\n//- Tertiary Active */\r\n$button-tertiary-active-color: lighten($button-tertiary-hover-color, 20%) !default;\r\n$button-tertiary-active-line-color: lighten($button-tertiary-active-color, 20%) !default;\r\n$button-tertiary-active-with-underline: true !default;\r\n$button-tertiary-active-with-overline: false !default;\r\n$button-tertiary-active-background-color: none !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Colors */\r\n$button-colored-background-image: none !default;\r\n$button-colored-box-shadow: $button-shadow-box-shadow !default;\r\n\r\n//- Colored */\r\n$button-brown-text-color: $button-inverted-text-color !default;\r\n$button-brown-text-shadow: $button-inverted-text-shadow !default;\r\n$button-red-text-color: $button-inverted-text-color !default;\r\n$button-red-text-shadow: $button-inverted-text-shadow !default;\r\n$button-orange-text-color: $button-inverted-text-color !default;\r\n$button-orange-text-shadow: $button-inverted-text-shadow !default;\r\n$button-green-text-color: $button-inverted-text-color !default;\r\n$button-green-text-shadow: $button-inverted-text-shadow !default;\r\n$button-blue-text-color: $button-inverted-text-color !default;\r\n$button-blue-text-shadow: $button-inverted-text-shadow !default;\r\n$button-violet-text-color: $button-inverted-text-color !default;\r\n$button-violet-text-shadow: $button-inverted-text-shadow !default;\r\n$button-purple-text-color: $button-inverted-text-color !default;\r\n$button-purple-text-shadow: $button-inverted-text-shadow !default;\r\n$button-pink-text-color: $button-inverted-text-color !default;\r\n$button-pink-text-shadow: $button-inverted-text-shadow !default;\r\n$button-black-text-color: $button-inverted-text-color !default;\r\n$button-black-text-shadow: $button-inverted-text-shadow !default;\r\n$button-olive-text-color: $button-inverted-text-color !default;\r\n$button-olive-text-shadow: $button-inverted-text-shadow !default;\r\n$button-yellow-text-color: $button-inverted-text-color !default;\r\n$button-yellow-text-shadow: $button-inverted-text-shadow !default;\r\n$button-teal-text-color: $button-inverted-text-color !default;\r\n$button-teal-text-shadow: $button-inverted-text-shadow !default;\r\n$button-grey-text-color: $button-inverted-text-color !default;\r\n$button-grey-text-shadow: $button-inverted-text-shadow !default;\r\n\r\n//- Inverted */\r\n$button-light-brown-text-color: $button-inverted-text-color !default;\r\n$button-light-brown-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-red-text-color: $button-inverted-text-color !default;\r\n$button-light-red-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-orange-text-color: $button-inverted-text-color !default;\r\n$button-light-orange-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-green-text-color: $button-inverted-text-color !default;\r\n$button-light-green-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-blue-text-color: $button-inverted-text-color !default;\r\n$button-light-blue-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-violet-text-color: $button-inverted-text-color !default;\r\n$button-light-violet-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-purple-text-color: $button-inverted-text-color !default;\r\n$button-light-purple-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-pink-text-color: $button-inverted-text-color !default;\r\n$button-light-pink-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-black-text-color: $button-inverted-text-color !default;\r\n$button-light-black-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-olive-text-color: $button-text-color !default;\r\n$button-light-olive-text-shadow: $button-text-shadow !default;\r\n$button-light-yellow-text-color: $button-text-color !default;\r\n$button-light-yellow-text-shadow: $button-text-shadow !default;\r\n$button-light-teal-text-color: $button-text-color !default;\r\n$button-light-teal-text-shadow: $button-text-shadow !default;\r\n$button-light-grey-text-color: $button-text-color !default;\r\n$button-light-grey-text-shadow: $button-text-shadow !default;\r\n\r\n\r\n//- Ordinality */\r\n$button-primary-background-image: $button-colored-background-image !default;\r\n$button-primary-text-color: $button-inverted-text-color !default;\r\n$button-light-primary-text-color: $button-inverted-text-color !default;\r\n$button-primary-text-shadow: $button-inverted-text-shadow !default;\r\n$button-primary-box-shadow: $button-colored-box-shadow !default;\r\n\r\n$button-secondary-background-image: $button-colored-background-image !default;\r\n$button-secondary-text-color: $button-inverted-text-color !default;\r\n$button-secondary-text-shadow: $button-inverted-text-shadow !default;\r\n$button-light-secondary-text-color: $button-inverted-text-color !default;\r\n$button-secondary-box-shadow: $button-colored-box-shadow !default;\r\n\r\n$button-positive-background-image: $button-colored-background-image !default;\r\n$button-positive-text-color: $button-inverted-text-color !default;\r\n$button-positive-text-shadow: $button-inverted-text-shadow !default;\r\n$button-positive-box-shadow: $button-colored-box-shadow !default;\r\n\r\n$button-negative-background-image: $button-colored-background-image !default;\r\n$button-negative-text-color: $button-inverted-text-color !default;\r\n$button-negative-text-shadow: $button-inverted-text-shadow !default;\r\n$button-negative-box-shadow: $button-colored-box-shadow !default;\r\n\r\n//- Compact */\r\n$button-compact-vertical-padding: ($button-vertical-padding * 0.75) !default;\r\n$button-compact-horizontal-padding: ($button-horizontal-padding * 0.75) !default;\r\n\r\n//- Attached */\r\n$button-attached-offset: -1px !default;\r\n$button-attached-box-shadow: 0 0 0 1px $border-color !default;\r\n$button-attached-horizontal-padding: 0.75em !default;\r\n$button-attached-z-index: auto !default;\r\n\r\n//- Floated */\r\n$button-floated-margin: 0.25em !default;\r\n\r\n//- Animated */\r\n$button-animated-vertical-align: middle !default;\r\n$button-animated-z-index: 1 !default;\r\n$button-animation-duration: 0.3s !default;\r\n$button-animation-easing: ease !default;\r\n$button-fade-scale-high: 1.5 !default;\r\n$button-fade-scale-low: 0.75 !default;\r\n\r\n$button-colors-map: (\r\n  primary: (\r\n    color          : $primary-color,\r\n    light          : $light-primary-color,\r\n    border         : $primary-border-color,\r\n    background     : $primary-background,\r\n    header         : $primary-header-color,\r\n    boxShadow      : $button-primary-box-shadow,\r\n    boxFloatShadow : $primary-box-floating-shadow,\r\n    text           : $button-primary-text-color,\r\n    lightText      : $button-light-primary-text-color,\r\n    hoverText      : $primary-hover-text-color,\r\n    focus          : $primary-color-focus,\r\n    lightFocus     : $light-primary-color-focus,\r\n    down           : $primary-color-down,\r\n    lightDown      : $light-primary-color-down,\r\n    active         : $primary-color-active,\r\n    lightActive    : $light-primary-color-active,\r\n    shadow         : $button-primary-text-shadow,\r\n    lightShadow    : $light-primary-text-shadow,\r\n    hover          : $primary-color-hover,\r\n    lightHover     : $light-primary-color-hover,\r\n    ribbon         : $primary-ribbon-shadow,\r\n    invertedRibbon : $primary-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  secondary: (\r\n    color          : $secondary-color,\r\n    light          : $light-secondary-color,\r\n    border         : $secondary-border-color,\r\n    background     : $secondary-background,\r\n    header         : $secondary-header-color,\r\n    boxShadow      : $button-secondary-box-shadow,\r\n    boxFloatShadow : $secondary-box-floating-shadow,\r\n    text           : $button-secondary-text-color,\r\n    lightText      : $button-light-secondary-text-color,\r\n    hoverText      : $secondary-hover-text-color,\r\n    focus          : $secondary-color-focus,\r\n    lightFocus     : $light-secondary-color-focus,\r\n    down           : $secondary-color-down,\r\n    lightDown      : $light-secondary-color-down,\r\n    active         : $secondary-color-active,\r\n    lightActive    : $light-secondary-color-active,\r\n    shadow         : $button-secondary-text-shadow,\r\n    lightShadow    : $light-secondary-text-shadow,\r\n    hover          : $secondary-color-hover,\r\n    lightHover     : $light-secondary-color-hover,\r\n    ribbon         : $secondary-ribbon-shadow,\r\n    invertedRibbon : $secondary-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  red: (\r\n    color          : $red,\r\n    light          : $light-red,\r\n    border         : $red-border-color,\r\n    background     : $red-background,\r\n    header         : $red-header-color,\r\n    boxShadow      : $red-box-shadow,\r\n    boxFloatShadow : $red-box-floating-shadow,\r\n    text           : $button-red-text-color,\r\n    lightText      : $button-light-red-text-color,\r\n    hoverText      : $red-hover-text-color,\r\n    focus          : $red-focus,\r\n    lightFocus     : $light-red-focus,\r\n    down           : $red-down,\r\n    lightDown      : $light-red-down,\r\n    active         : $red-active,\r\n    lightActive    : $light-red-active,\r\n    shadow         : $button-red-text-shadow,\r\n    lightShadow    : $button-light-red-text-shadow,\r\n    hover          : $red-hover,\r\n    lightHover     : $light-red-hover,\r\n    ribbon         : $red-ribbon-shadow,\r\n    invertedRibbon : $red-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  orange: (\r\n    color          : $orange,\r\n    light          : $light-orange,\r\n    border         : $orange-border-color,\r\n    background     : $orange-background,\r\n    header         : $orange-header-color,\r\n    boxShadow      : $orange-box-shadow,\r\n    boxFloatShadow : $orange-box-floating-shadow,\r\n    text           : $button-orange-text-color,\r\n    lightText      : $button-light-orange-text-color,\r\n    hoverText      : $orange-hover-text-color,\r\n    focus          : $orange-focus,\r\n    lightFocus     : $light-orange-focus,\r\n    down           : $orange-down,\r\n    lightDown      : $light-orange-down,\r\n    active         : $orange-active,\r\n    lightActive    : $light-orange-active,\r\n    shadow         : $button-orange-text-shadow,\r\n    lightShadow    : $button-light-orange-text-shadow,\r\n    hover          : $orange-hover,\r\n    lightHover     : $light-orange-hover,\r\n    ribbon         : $orange-ribbon-shadow,\r\n    invertedRibbon : $orange-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  yellow: (\r\n    color          : $yellow,\r\n    light          : $light-yellow,\r\n    border         : $yellow-border-color,\r\n    background     : $yellow-background,\r\n    header         : $yellow-header-color,\r\n    boxShadow      : $yellow-box-shadow,\r\n    boxFloatShadow : $yellow-box-floating-shadow,\r\n    text           : $button-yellow-text-color,\r\n    lightText      : $button-light-yellow-text-color,\r\n    hoverText      : $yellow-hover-text-color,\r\n    focus          : $yellow-focus,\r\n    lightFocus     : $light-yellow-focus,\r\n    down           : $yellow-down,\r\n    lightDown      : $light-yellow-down,\r\n    active         : $yellow-active,\r\n    lightActive    : $light-yellow-active,\r\n    shadow         : $button-yellow-text-shadow,\r\n    lightShadow    : $button-light-yellow-text-shadow,\r\n    hover          : $yellow-hover,\r\n    lightHover     : $light-yellow-hover,\r\n    ribbon         : $yellow-ribbon-shadow,\r\n    invertedRibbon : $yellow-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  olive: (\r\n    color          : $olive,\r\n    light          : $light-olive,\r\n    border         : $olive-border-color,\r\n    background     : $olive-background,\r\n    header         : $olive-header-color,\r\n    boxShadow      : $olive-box-shadow,\r\n    boxFloatShadow : $olive-box-floating-shadow,\r\n    text           : $button-olive-text-color,\r\n    lightText      : $button-light-olive-text-color,\r\n    hoverText      : $olive-hover-text-color,\r\n    focus          : $olive-focus,\r\n    lightFocus     : $light-olive-focus,\r\n    down           : $olive-down,\r\n    lightDown      : $light-olive-down,\r\n    active         : $olive-active,\r\n    lightActive    : $light-olive-active,\r\n    shadow         : $button-olive-text-shadow,\r\n    lightShadow    : $button-light-olive-text-shadow,\r\n    hover          : $olive-hover,\r\n    lightHover     : $light-olive-hover,\r\n    ribbon         : $olive-ribbon-shadow,\r\n    invertedRibbon : $olive-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  green: (\r\n    color          : $green,\r\n    light          : $light-green,\r\n    border         : $green-border-color,\r\n    background     : $green-background,\r\n    header         : $green-header-color,\r\n    boxShadow      : $green-box-shadow,\r\n    boxFloatShadow : $green-box-floating-shadow,\r\n    text           : $button-green-text-color,\r\n    lightText      : $button-light-green-text-color,\r\n    hoverText      : $green-hover-text-color,\r\n    focus          : $green-focus,\r\n    lightFocus     : $light-green-focus,\r\n    down           : $green-down,\r\n    lightDown      : $light-green-down,\r\n    active         : $green-active,\r\n    lightActive    : $light-green-active,\r\n    shadow         : $button-green-text-shadow,\r\n    lightShadow    : $button-light-green-text-shadow,\r\n    hover          : $green-hover,\r\n    lightHover     : $light-green-hover,\r\n    ribbon         : $green-ribbon-shadow,\r\n    invertedRibbon : $green-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  teal: (\r\n    color          : $teal,\r\n    light          : $light-teal,\r\n    border         : $teal-border-color,\r\n    background     : $teal-background,\r\n    header         : $teal-header-color,\r\n    boxShadow      : $teal-box-shadow,\r\n    boxFloatShadow : $teal-box-floating-shadow,\r\n    text           : $button-teal-text-color,\r\n    lightText      : $button-light-teal-text-color,\r\n    hoverText      : $teal-hover-text-color,\r\n    focus          : $teal-focus,\r\n    lightFocus     : $light-teal-focus,\r\n    down           : $teal-down,\r\n    lightDown      : $light-teal-down,\r\n    active         : $teal-active,\r\n    lightActive    : $light-teal-active,\r\n    shadow         : $button-teal-text-shadow,\r\n    lightShadow    : $button-light-teal-text-shadow,\r\n    hover          : $teal-hover,\r\n    lightHover     : $light-teal-hover,\r\n    ribbon         : $teal-ribbon-shadow,\r\n    invertedRibbon : $teal-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  blue: (\r\n    color          : $blue,\r\n    light          : $light-blue,\r\n    border         : $blue-border-color,\r\n    background     : $blue-background,\r\n    header         : $blue-header-color,\r\n    boxShadow      : $blue-box-shadow,\r\n    boxFloatShadow : $blue-box-floating-shadow,\r\n    text           : $button-blue-text-color,\r\n    lightText      : $button-light-blue-text-color,\r\n    hoverText      : $blue-hover-text-color,\r\n    focus          : $blue-focus,\r\n    lightFocus     : $light-blue-focus,\r\n    down           : $blue-down,\r\n    lightDown      : $light-blue-down,\r\n    active         : $blue-active,\r\n    lightActive    : $light-blue-active,\r\n    shadow         : $button-blue-text-shadow,\r\n    lightShadow    : $button-light-blue-text-shadow,\r\n    hover          : $blue-hover,\r\n    lightHover     : $light-blue-hover,\r\n    ribbon         : $blue-ribbon-shadow,\r\n    invertedRibbon : $blue-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  violet: (\r\n    color          : $violet,\r\n    light          : $light-violet,\r\n    border         : $violet-border-color,\r\n    background     : $violet-background,\r\n    header         : $violet-header-color,\r\n    boxShadow      : $violet-box-shadow,\r\n    boxFloatShadow : $violet-box-floating-shadow,\r\n    text           : $button-violet-text-color,\r\n    lightText      : $button-light-violet-text-color,\r\n    hoverText      : $violet-hover-text-color,\r\n    focus          : $violet-focus,\r\n    lightFocus     : $light-violet-focus,\r\n    down           : $violet-down,\r\n    lightDown      : $light-violet-down,\r\n    active         : $violet-active,\r\n    lightActive    : $light-violet-active,\r\n    shadow         : $button-violet-text-shadow,\r\n    lightShadow    : $button-light-violet-text-shadow,\r\n    hover          : $violet-hover,\r\n    lightHover     : $light-violet-hover,\r\n    ribbon         : $violet-ribbon-shadow,\r\n    invertedRibbon : $violet-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  purple: (\r\n    color          : $purple,\r\n    light          : $light-purple,\r\n    border         : $purple-border-color,\r\n    background     : $purple-background,\r\n    header         : $purple-header-color,\r\n    boxShadow      : $purple-box-shadow,\r\n    boxFloatShadow : $purple-box-floating-shadow,\r\n    text           : $button-purple-text-color,\r\n    lightText      : $button-light-purple-text-color,\r\n    hoverText      : $purple-hover-text-color,\r\n    focus          : $purple-focus,\r\n    lightFocus     : $light-purple-focus,\r\n    down           : $purple-down,\r\n    lightDown      : $light-purple-down,\r\n    active         : $purple-active,\r\n    lightActive    : $light-purple-active,\r\n    shadow         : $button-purple-text-shadow,\r\n    lightShadow    : $button-light-purple-text-shadow,\r\n    hover          : $purple-hover,\r\n    lightHover     : $light-purple-hover,\r\n    ribbon         : $purple-ribbon-shadow,\r\n    invertedRibbon : $purple-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  pink: (\r\n    color          : $pink,\r\n    light          : $light-pink,\r\n    border         : $pink-border-color,\r\n    background     : $pink-background,\r\n    header         : $pink-header-color,\r\n    boxShadow      : $pink-box-shadow,\r\n    boxFloatShadow : $pink-box-floating-shadow,\r\n    text           : $button-pink-text-color,\r\n    lightText      : $button-light-pink-text-color,\r\n    hoverText      : $pink-hover-text-color,\r\n    focus          : $pink-focus,\r\n    lightFocus     : $light-pink-focus,\r\n    down           : $pink-down,\r\n    lightDown      : $light-pink-down,\r\n    active         : $pink-active,\r\n    lightActive    : $light-pink-active,\r\n    shadow         : $button-pink-text-shadow,\r\n    lightShadow    : $button-light-pink-text-shadow,\r\n    hover          : $pink-hover,\r\n    lightHover     : $light-pink-hover,\r\n    ribbon         : $pink-ribbon-shadow,\r\n    invertedRibbon : $pink-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  brown: (\r\n    color          : $brown,\r\n    light          : $light-brown,\r\n    border         : $brown-border-color,\r\n    background     : $brown-background,\r\n    header         : $brown-header-color,\r\n    boxShadow      : $brown-box-shadow,\r\n    boxFloatShadow : $brown-box-floating-shadow,\r\n    text           : $button-brown-text-color,\r\n    lightText      : $button-light-brown-text-color,\r\n    hoverText      : $brown-hover-text-color,\r\n    focus          : $brown-focus,\r\n    lightFocus     : $light-brown-focus,\r\n    down           : $brown-down,\r\n    lightDown      : $light-brown-down,\r\n    active         : $brown-active,\r\n    lightActive    : $light-brown-active,\r\n    shadow         : $button-brown-text-shadow,\r\n    lightShadow    : $button-light-brown-text-shadow,\r\n    hover          : $brown-hover,\r\n    lightHover     : $light-brown-hover,\r\n    ribbon         : $brown-ribbon-shadow,\r\n    invertedRibbon : $brown-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  grey: (\r\n    color          : $grey,\r\n    light          : $light-grey,\r\n    border         : $grey-border-color,\r\n    background     : $grey-background,\r\n    header         : $grey-header-color,\r\n    boxShadow      : $grey-box-shadow,\r\n    boxFloatShadow : $grey-box-floating-shadow,\r\n    text           : $button-grey-text-color,\r\n    lightText      : $button-light-grey-text-color,\r\n    hoverText      : $grey-hover-text-color,\r\n    focus          : $grey-focus,\r\n    lightFocus     : $light-grey-focus,\r\n    down           : $grey-down,\r\n    lightDown      : $light-grey-down,\r\n    active         : $grey-active,\r\n    lightActive    : $light-grey-active,\r\n    shadow         : $button-grey-text-shadow,\r\n    lightShadow    : $button-light-grey-text-shadow,\r\n    hover          : $grey-hover,\r\n    lightHover     : $light-grey-hover,\r\n    ribbon         : $grey-ribbon-shadow,\r\n    invertedRibbon : $grey-inverted-ribbon-shadow,\r\n    isDark         : true,\r\n    isVeryDark     : false,\r\n  ),\r\n  black: (\r\n    color          : $black,\r\n    light          : $light-black,\r\n    border         : $black-border-color,\r\n    background     : $black-background,\r\n    header         : $black-header-color,\r\n    boxShadow      : $black-box-shadow,\r\n    boxFloatShadow : $black-box-floating-shadow,\r\n    text           : $button-black-text-color,\r\n    lightText      : $button-light-black-text-color,\r\n    hoverText      : $black-hover-text-color,\r\n    focus          : $black-focus,\r\n    lightFocus     : $light-black-focus,\r\n    down           : $black-down,\r\n    lightDown      : $light-black-down,\r\n    active         : $black-active,\r\n    lightActive    : $light-black-active,\r\n    shadow         : $button-black-text-shadow,\r\n    lightShadow    : $button-light-black-text-shadow,\r\n    hover          : $black-hover,\r\n    lightHover     : $light-black-hover,\r\n    ribbon         : $black-ribbon-shadow,\r\n    invertedRibbon : $black-inverted-ribbon-shadow,\r\n    isDark         : true,\r\n    isVeryDark     : true,\r\n  )\r\n) !default;\r\n\r\n// Functions to obtain new dynamic variables\r\n\r\n@function getTertiaryButtonColorHover($isVeryDark, $h) {\r\n  @if ($isVeryDark) {\r\n    @return lighten($h, 40%);\r\n  }\r\n  @if not($isVeryDark) {\r\n    @return desaturate($h, 20%);\r\n  }\r\n}\r\n\r\n@function getTertiaryButtonColor($isVeryDark, $c) {\r\n  @if ($isVeryDark) {\r\n    @return lighten($c, 20%);\r\n  }\r\n  @if not($isVeryDark) {\r\n    @return saturate($c, 20%);\r\n  }\r\n}\r\n\r\n@function getTertiaryButtonColorFocus($isVeryDark, $f) {\r\n  @if ($isVeryDark) {\r\n    @return lighten($f, 40%);\r\n  }\r\n  @if not($isVeryDark) {\r\n    @return desaturate($f, 20%);\r\n  }\r\n}\r\n\r\n@function getTertiaryButtonColorActive($isVeryDark, $a) {\r\n  @if ($isVeryDark) {\r\n    @return lighten($a, 20%);\r\n  }\r\n  @if not($isVeryDark) {\r\n    @return saturate($a, 20%);\r\n  }\r\n}","//@import \"../../../../utils/all\";\r\n//@import \"./main\";\r\n\r\n$_1px: join-value-to-unit((1 / strip-unit($em-size)), rem) !default;\r\n$_2px: join-value-to-unit((2 / strip-unit($em-size)), rem) !default;\r\n$_3px: join-value-to-unit((3 / strip-unit($em-size)), rem) !default;\r\n$_4px: join-value-to-unit((4 / strip-unit($em-size)), rem) !default;\r\n$_5px: join-value-to-unit((5 / strip-unit($em-size)), rem) !default;\r\n$_6px: join-value-to-unit((6 / strip-unit($em-size)), rem) !default;\r\n$_7px: join-value-to-unit((7 / strip-unit($em-size)), rem) !default;\r\n$_8px: join-value-to-unit((8 / strip-unit($em-size)), rem) !default;\r\n$_9px: join-value-to-unit((9 / strip-unit($em-size)), rem) !default;\r\n$_10px: join-value-to-unit((10 / strip-unit($em-size)), rem) !default;\r\n$_11px: join-value-to-unit((11 / strip-unit($em-size)), rem) !default;\r\n$_12px: join-value-to-unit((12 / strip-unit($em-size)), rem) !default;\r\n$_13px: join-value-to-unit((13 / strip-unit($em-size)), rem) !default;\r\n$_14px: join-value-to-unit((14 / strip-unit($em-size)), rem) !default;\r\n$_15px: join-value-to-unit((15 / strip-unit($em-size)), rem) !default;\r\n$_16px: join-value-to-unit((16 / strip-unit($em-size)), rem) !default;\r\n$_17px: join-value-to-unit((17 / strip-unit($em-size)), rem) !default;\r\n$_18px: join-value-to-unit((18 / strip-unit($em-size)), rem) !default;\r\n$_19px: join-value-to-unit((19 / strip-unit($em-size)), rem) !default;\r\n$_20px: join-value-to-unit((20 / strip-unit($em-size)), rem) !default;\r\n$_21px: join-value-to-unit((21 / strip-unit($em-size)), rem) !default;\r\n$_22px: join-value-to-unit((22 / strip-unit($em-size)), rem) !default;\r\n$_23px: join-value-to-unit((23 / strip-unit($em-size)), rem) !default;\r\n$_24px: join-value-to-unit((24 / strip-unit($em-size)), rem) !default;\r\n$_25px: join-value-to-unit((25 / strip-unit($em-size)), rem) !default;\r\n$_26px: join-value-to-unit((26 / strip-unit($em-size)), rem) !default;\r\n$_27px: join-value-to-unit((27 / strip-unit($em-size)), rem) !default;\r\n$_28px: join-value-to-unit((28 / strip-unit($em-size)), rem) !default;\r\n$_29px: join-value-to-unit((29 / strip-unit($em-size)), rem) !default;\r\n$_30px: join-value-to-unit((30 / strip-unit($em-size)), rem) !default;\r\n$_31px: join-value-to-unit((31 / strip-unit($em-size)), rem) !default;\r\n$_32px: join-value-to-unit((32 / strip-unit($em-size)), rem) !default;\r\n$_33px: join-value-to-unit((33 / strip-unit($em-size)), rem) !default;\r\n$_34px: join-value-to-unit((34 / strip-unit($em-size)), rem) !default;\r\n$_35px: join-value-to-unit((35 / strip-unit($em-size)), rem) !default;\r\n$_36px: join-value-to-unit((36 / strip-unit($em-size)), rem) !default;\r\n$_37px: join-value-to-unit((37 / strip-unit($em-size)), rem) !default;\r\n$_38px: join-value-to-unit((38 / strip-unit($em-size)), rem) !default;\r\n$_39px: join-value-to-unit((39 / strip-unit($em-size)), rem) !default;\r\n$_40px: join-value-to-unit((40 / strip-unit($em-size)), rem) !default;\r\n$_41px: join-value-to-unit((41 / strip-unit($em-size)), rem) !default;\r\n$_42px: join-value-to-unit((42 / strip-unit($em-size)), rem) !default;\r\n$_43px: join-value-to-unit((43 / strip-unit($em-size)), rem) !default;\r\n$_44px: join-value-to-unit((44 / strip-unit($em-size)), rem) !default;\r\n$_45px: join-value-to-unit((45 / strip-unit($em-size)), rem) !default;\r\n$_46px: join-value-to-unit((46 / strip-unit($em-size)), rem) !default;\r\n$_47px: join-value-to-unit((47 / strip-unit($em-size)), rem) !default;\r\n$_48px: join-value-to-unit((48 / strip-unit($em-size)), rem) !default;\r\n$_49px: join-value-to-unit((49 / strip-unit($em-size)), rem) !default;\r\n$_50px: join-value-to-unit((50 / strip-unit($em-size)), rem) !default;\r\n$_51px: join-value-to-unit((51 / strip-unit($em-size)), rem) !default;\r\n$_52px: join-value-to-unit((52 / strip-unit($em-size)), rem) !default;\r\n$_53px: join-value-to-unit((53 / strip-unit($em-size)), rem) !default;\r\n$_54px: join-value-to-unit((54 / strip-unit($em-size)), rem) !default;\r\n$_55px: join-value-to-unit((55 / strip-unit($em-size)), rem) !default;\r\n$_56px: join-value-to-unit((56 / strip-unit($em-size)), rem) !default;\r\n$_57px: join-value-to-unit((57 / strip-unit($em-size)), rem) !default;\r\n$_58px: join-value-to-unit((58 / strip-unit($em-size)), rem) !default;\r\n$_59px: join-value-to-unit((59 / strip-unit($em-size)), rem) !default;\r\n$_60px: join-value-to-unit((60 / strip-unit($em-size)), rem) !default;\r\n$_61px: join-value-to-unit((61 / strip-unit($em-size)), rem) !default;\r\n$_62px: join-value-to-unit((62 / strip-unit($em-size)), rem) !default;\r\n$_63px: join-value-to-unit((63 / strip-unit($em-size)), rem) !default;\r\n$_64px: join-value-to-unit((64 / strip-unit($em-size)), rem) !default;\r\n\r\n$relative1px: join-value-to-unit((1 / strip-unit($em-size)), em) !default;\r\n$relative2px: join-value-to-unit((2 / strip-unit($em-size)), em) !default;\r\n$relative3px: join-value-to-unit((3 / strip-unit($em-size)), em) !default;\r\n$relative4px: join-value-to-unit((4 / strip-unit($em-size)), em) !default;\r\n$relative5px: join-value-to-unit((5 / strip-unit($em-size)), em) !default;\r\n$relative6px: join-value-to-unit((6 / strip-unit($em-size)), em) !default;\r\n$relative7px: join-value-to-unit((7 / strip-unit($em-size)), em) !default;\r\n$relative8px: join-value-to-unit((8 / strip-unit($em-size)), em) !default;\r\n$relative9px: join-value-to-unit((9 / strip-unit($em-size)), em) !default;\r\n$relative10px: join-value-to-unit((10 / strip-unit($em-size)), em) !default;\r\n$relative11px: join-value-to-unit((11 / strip-unit($em-size)), em) !default;\r\n$relative12px: join-value-to-unit((12 / strip-unit($em-size)), em) !default;\r\n$relative13px: join-value-to-unit((13 / strip-unit($em-size)), em) !default;\r\n$relative14px: join-value-to-unit((14 / strip-unit($em-size)), em) !default;\r\n$relative15px: join-value-to-unit((15 / strip-unit($em-size)), em) !default;\r\n$relative16px: join-value-to-unit((16 / strip-unit($em-size)), em) !default;\r\n$relative17px: join-value-to-unit((17 / strip-unit($em-size)), em) !default;\r\n$relative18px: join-value-to-unit((18 / strip-unit($em-size)), em) !default;\r\n$relative19px: join-value-to-unit((19 / strip-unit($em-size)), em) !default;\r\n$relative20px: join-value-to-unit((20 / strip-unit($em-size)), em) !default;\r\n$relative21px: join-value-to-unit((21 / strip-unit($em-size)), em) !default;\r\n$relative22px: join-value-to-unit((22 / strip-unit($em-size)), em) !default;\r\n$relative23px: join-value-to-unit((23 / strip-unit($em-size)), em) !default;\r\n$relative24px: join-value-to-unit((24 / strip-unit($em-size)), em) !default;\r\n$relative25px: join-value-to-unit((25 / strip-unit($em-size)), em) !default;\r\n$relative26px: join-value-to-unit((26 / strip-unit($em-size)), em) !default;\r\n$relative27px: join-value-to-unit((27 / strip-unit($em-size)), em) !default;\r\n$relative28px: join-value-to-unit((28 / strip-unit($em-size)), em) !default;\r\n$relative29px: join-value-to-unit((29 / strip-unit($em-size)), em) !default;\r\n$relative30px: join-value-to-unit((30 / strip-unit($em-size)), em) !default;\r\n$relative31px: join-value-to-unit((31 / strip-unit($em-size)), em) !default;\r\n$relative32px: join-value-to-unit((32 / strip-unit($em-size)), em) !default;\r\n$relative33px: join-value-to-unit((33 / strip-unit($em-size)), em) !default;\r\n$relative34px: join-value-to-unit((34 / strip-unit($em-size)), em) !default;\r\n$relative35px: join-value-to-unit((35 / strip-unit($em-size)), em) !default;\r\n$relative36px: join-value-to-unit((36 / strip-unit($em-size)), em) !default;\r\n$relative37px: join-value-to-unit((37 / strip-unit($em-size)), em) !default;\r\n$relative38px: join-value-to-unit((38 / strip-unit($em-size)), em) !default;\r\n$relative39px: join-value-to-unit((39 / strip-unit($em-size)), em) !default;\r\n$relative40px: join-value-to-unit((40 / strip-unit($em-size)), em) !default;\r\n$relative41px: join-value-to-unit((41 / strip-unit($em-size)), em) !default;\r\n$relative42px: join-value-to-unit((42 / strip-unit($em-size)), em) !default;\r\n$relative43px: join-value-to-unit((43 / strip-unit($em-size)), em) !default;\r\n$relative44px: join-value-to-unit((44 / strip-unit($em-size)), em) !default;\r\n$relative45px: join-value-to-unit((45 / strip-unit($em-size)), em) !default;\r\n$relative46px: join-value-to-unit((46 / strip-unit($em-size)), em) !default;\r\n$relative47px: join-value-to-unit((47 / strip-unit($em-size)), em) !default;\r\n$relative48px: join-value-to-unit((48 / strip-unit($em-size)), em) !default;\r\n$relative49px: join-value-to-unit((49 / strip-unit($em-size)), em) !default;\r\n$relative50px: join-value-to-unit((50 / strip-unit($em-size)), em) !default;\r\n$relative51px: join-value-to-unit((51 / strip-unit($em-size)), em) !default;\r\n$relative52px: join-value-to-unit((52 / strip-unit($em-size)), em) !default;\r\n$relative53px: join-value-to-unit((53 / strip-unit($em-size)), em) !default;\r\n$relative54px: join-value-to-unit((54 / strip-unit($em-size)), em) !default;\r\n$relative55px: join-value-to-unit((55 / strip-unit($em-size)), em) !default;\r\n$relative56px: join-value-to-unit((56 / strip-unit($em-size)), em) !default;\r\n$relative57px: join-value-to-unit((57 / strip-unit($em-size)), em) !default;\r\n$relative58px: join-value-to-unit((58 / strip-unit($em-size)), em) !default;\r\n$relative59px: join-value-to-unit((59 / strip-unit($em-size)), em) !default;\r\n$relative60px: join-value-to-unit((60 / strip-unit($em-size)), em) !default;\r\n$relative61px: join-value-to-unit((61 / strip-unit($em-size)), em) !default;\r\n$relative62px: join-value-to-unit((62 / strip-unit($em-size)), em) !default;\r\n$relative63px: join-value-to-unit((63 / strip-unit($em-size)), em) !default;\r\n$relative64px: join-value-to-unit((64 / strip-unit($em-size)), em) !default;\r\n","$dark-text-color: rgba(0, 0, 0, 0.85) !default;\r\n$muted-text-color: rgba(0, 0, 0, 0.6) !default;\r\n$light-text-color: rgba(0, 0, 0, 0.4) !default;\r\n\r\n$unselected-text-color: rgba(0, 0, 0, 0.4) !default;\r\n$hovered-text-color: rgba(0, 0, 0, 0.8) !default;\r\n$pressed-text-color: rgba(0, 0, 0, 0.9) !default;\r\n$selected-text-color: rgba(0, 0, 0, 0.95) !default;\r\n$disabled-text-color: rgba(0, 0, 0, 0.2) !default;\r\n\r\n$inverted-text-color: rgba(255, 255, 255, 0.9) !default;\r\n$inverted-muted-text-color: rgba(255, 255, 255, 0.8) !default;\r\n$inverted-light-text-color: rgba(255, 255, 255, 0.7) !default;\r\n$inverted-unselected-text-color: rgba(255, 255, 255, 0.5) !default;\r\n$inverted-hovered-text-color: rgba(255, 255, 255, 1) !default;\r\n$inverted-pressed-text-color: rgba(255, 255, 255, 1) !default;\r\n$inverted-selected-text-color: rgba(255, 255, 255, 1) !default;\r\n$inverted-disabled-text-color: rgba(255, 255, 255, 0.2) !default;\r\n","//@import \"./size\";\r\n\r\n$loader-line-width: 0.2em !default;\r\n$loader-offset: (-$loader-size / 2) !default;\r\n$loader-margin: $loader-offset 0 0 $loader-offset !default;\r\n","//@import '../../../../utils/all';\r\n//@import './main';\r\n//@import './sizes';\r\n\r\n// This rounds $size values to the closest pixel then expresses that value in (r)em.\r\n// This ensures all size values round to exact pixels\r\n$mini-raw: (round($mini-size * $em-size) / $em-size);\r\n$tiny-raw: (round($tiny-size * $em-size) / $em-size);\r\n$small-raw: (round($small-size * $em-size) / $em-size);\r\n$medium-raw: (round($medium-size * $em-size) / $em-size);\r\n$large-raw: (round($large-size * $em-size) / $em-size);\r\n$big-raw: (round($big-size * $em-size) / $em-size);\r\n$huge-raw: (round($huge-size * $em-size) / $em-size);\r\n$massive-raw: (round($massive-size * $em-size) / $em-size);\r\n\r\n$mini: join-value-to-unit($mini-raw, rem) !default;\r\n$tiny: join-value-to-unit($tiny-raw, rem) !default;\r\n$small: join-value-to-unit($small-raw, rem) !default;\r\n$medium: join-value-to-unit($medium-raw, rem) !default;\r\n$large: join-value-to-unit($large-raw, rem) !default;\r\n$big: join-value-to-unit($big-raw, rem) !default;\r\n$huge: join-value-to-unit($huge-raw, rem) !default;\r\n$massive: join-value-to-unit($massive-raw, rem) !default;\r\n\r\n// em */\r\n$relative-mini: join-value-to-unit(round($mini-size * strip-unit($em-size)) / strip-unit($em-size), em) !default;\r\n$relative-tiny: join-value-to-unit($tiny-raw, em) !default;\r\n$relative-small: join-value-to-unit($small-raw, em) !default;\r\n$relative-medium: join-value-to-unit($medium-raw, em) !default;\r\n$relative-large: join-value-to-unit($large-raw, em) !default;\r\n$relative-big: join-value-to-unit($big-raw, em) !default;\r\n$relative-huge: join-value-to-unit($huge-raw, em) !default;\r\n$relative-massive: join-value-to-unit($massive-raw, em) !default;\r\n\r\n// rem */\r\n$absolute-mini: join-value-to-unit(round($mini-size * strip-unit($em-size)) / strip-unit($em-size), rem) !default;\r\n$absolute-tiny: join-value-to-unit($tiny-raw, rem) !default;\r\n$absolute-small: join-value-to-unit($small-raw, rem) !default;\r\n$absolute-medium: join-value-to-unit($medium-raw, rem) !default;\r\n$absolute-large: join-value-to-unit($large-raw, rem) !default;\r\n$absolute-big: join-value-to-unit($big-raw, rem) !default;\r\n$absolute-huge: join-value-to-unit($huge-raw, rem) !default;\r\n$absolute-massive: join-value-to-unit($massive-raw, rem) !default;\r\n","//@import \"../fonts/exact-pixels\";\r\n\r\n$circular-radius: 500rem !default;\r\n$relative-border-radius: $relative4px !default;\r\n$absolute-border-radius: $_4px !default;\r\n$default-border-radius: $absolute-border-radius !default;\r\n","$full-black: #000000 !default;\r\n$off-white: #f9fafb !default;\r\n$dark-white: #f3f4f5 !default;\r\n$mid-white: #dcddde !default;\r\n$white: #ffffff !default;\r\n","//@import \"../colors/all\";\r\n\r\n$loader-fill-color: rgba(0, 0, 0, 0.1) !default;\r\n$loader-line-color: $grey !default;\r\n$inverted-loader-fill-color: rgba(255, 255, 255, 0.15) !default;\r\n$inverted-loader-line-color: $white !default;\r\n","$red: #db2828 !default;\r\n$orange: #f2711c !default;\r\n$yellow: #fbbd08 !default;\r\n$olive: #b5cc18 !default;\r\n$green: #21ba45 !default;\r\n$teal: #00b5ad !default;\r\n$blue: #2185d0 !default;\r\n$violet: #6435c9 !default;\r\n$purple: #a333c8 !default;\r\n$pink: #e03997 !default;\r\n$brown: #a5673f !default;\r\n$grey: #767676 !default;\r\n$black: #1b1c1d !default;\r\n\r\n$main-colors-names: \"primary\", \"secondary\";\r\n$consequences-names: \"positive\", \"negative\";\r\n$colors-variations-names: \"red\", \"orange\", \"yellow\", \"olive\", \"green\", \"teal\", \"blue\", \"violet\", \"purple\", \"pink\", \"brown\", \"grey\", \"black\";","$positive-border-color: #a3c293 !default;\r\n$success-border-color: $positive-border-color !default;\r\n\r\n$negative-border-color: #e0b4b4 !default;\r\n$error-border-color: $negative-border-color !default;\r\n\r\n$info-border-color: #a9d5de !default;\r\n$warning-border-color: #c9ba9b !default;\r\n\r\n$disabled-border-color: rgba(34, 36, 38, 0.5) !default;\r\n\r\n$selected-border-color: rgba(34, 36, 38, 0.35) !default;\r\n$selected-white-border-color: rgba(255, 255, 255, 0.8) !default;\r\n$selected-solid-white-border-color: #999999 !default;\r\n","//@import \"../colors/all\";\r\n//@import \"../texts/all\";\r\n\r\n$border-color: rgba(34, 36, 38, 0.15) !default;\r\n\r\n$primary-border-color: $primary-color !default;\r\n$secondary-border-color: $secondary-color !default;\r\n$red-border-color: $red-text-color !default;\r\n$orange-border-color: $orange-text-color !default;\r\n$yellow-border-color: $yellow-text-color !default;\r\n$olive-border-color: $olive-text-color !default;\r\n$green-border-color: $green-text-color !default;\r\n$teal-border-color: $teal-text-color !default;\r\n$blue-border-color: $blue-text-color !default;\r\n$violet-border-color: $violet-text-color !default;\r\n$purple-border-color: $purple-text-color !default;\r\n$pink-border-color: $pink-text-color !default;\r\n$brown-border-color: $brown-text-color !default;\r\n$grey-border-color: $grey-text-color !default;\r\n$black-border-color: $black-text-color !default;\r\n$white-border-color: rgba(255, 255, 255, 0.1) !default;\r\n\r\n$strong-border-color: rgba(34, 36, 38, 0.22) !default;\r\n$strong-selected-border-color: rgba(34, 36, 38, 0.5) !default;\r\n$internal-border-color: rgba(34, 36, 38, 0.1) !default;\r\n\r\n$solid-internal-border-color: #fafafa !default;\r\n$solid-border-color: #d4d4d5 !default;\r\n$solid-selected-border-color: #bcbdbd !default;\r\n$solid-white-border-color: #555555 !default;\r\n","//@import \"./main\";\r\n//@import \"./light\";\r\n\r\n$facebook-color: #3b5998 !default;\r\n$twitter-color: #1da1f2 !default;\r\n$google-plus-color: #dd4b39 !default;\r\n$linked-in-color: #0077b5 !default;\r\n$youtube-color: #ff0000 !default;\r\n$pinterest-color: #bd081c !default;\r\n$vk-color: #45668e !default;\r\n$instagram-color: #49769c !default;\r\n$telegram-color: #0088cc !default;\r\n$whats-app-color: #25d366 !default;\r\n\r\n$primary-color: $blue !default;\r\n$secondary-color: $black !default;\r\n\r\n$light-primary-color: $light-blue !default;\r\n$light-secondary-color: $light-black !default;\r\n\r\n$blending-base-color: #cccccc !default;\r\n","//@import \"../colors/all\";\r\n\r\n$primary-color-hover: saturate(darken($primary-color, 5), 10) !default;\r\n$secondary-color-hover: saturate(lighten($secondary-color, 5), 10) !default;\r\n$light-primary-color-hover: saturate(\r\n  darken($light-primary-color, 10),\r\n  10\r\n) !default;\r\n$light-secondary-color-hover: saturate(\r\n  lighten($light-secondary-color, 10),\r\n  10\r\n) !default;\r\n\r\n$red-hover: saturate(darken($red, 5), 10) !default;\r\n$orange-hover: saturate(darken($orange, 5), 10) !default;\r\n$yellow-hover: saturate(darken($yellow, 5), 10) !default;\r\n$olive-hover: saturate(darken($olive, 5), 10) !default;\r\n$green-hover: saturate(darken($green, 5), 10) !default;\r\n$teal-hover: saturate(darken($teal, 5), 10) !default;\r\n$blue-hover: saturate(darken($blue, 5), 10) !default;\r\n$violet-hover: saturate(darken($violet, 5), 10) !default;\r\n$purple-hover: saturate(darken($purple, 5), 10) !default;\r\n$pink-hover: saturate(darken($pink, 5), 10) !default;\r\n$brown-hover: saturate(darken($brown, 5), 10) !default;\r\n$grey-hover: saturate(darken($grey, 5), 10) !default;\r\n$black-hover: saturate(darken($black, 5), 10) !default;\r\n\r\n$light-red-hover: saturate(darken($light-red, 10), 10) !default;\r\n$light-orange-hover: saturate(darken($light-orange, 10), 10) !default;\r\n$light-yellow-hover: saturate(darken($light-yellow, 10), 10) !default;\r\n$light-olive-hover: saturate(darken($light-olive, 10), 10) !default;\r\n$light-green-hover: saturate(darken($light-green, 10), 10) !default;\r\n$light-teal-hover: saturate(darken($light-teal, 10), 10) !default;\r\n$light-blue-hover: saturate(darken($light-blue, 10), 10) !default;\r\n$light-violet-hover: saturate(darken($light-violet, 10), 10) !default;\r\n$light-purple-hover: saturate(darken($light-purple, 10), 10) !default;\r\n$light-pink-hover: saturate(darken($light-pink, 10), 10) !default;\r\n$light-brown-hover: saturate(darken($light-brown, 10), 10) !default;\r\n$light-grey-hover: saturate(darken($light-grey, 10), 10) !default;\r\n$light-black-hover: saturate(darken($full-black, 10), 10) !default;\r\n\r\n//---  Emotive  ---*/\r\n$positive-color-hover: saturate(darken($positive-color, 5), 10) !default;\r\n$negative-color-hover: saturate(darken($negative-color, 5), 10) !default;\r\n\r\n//---  Brand   ---*/\r\n$facebook-hover-color: saturate(darken($facebook-color, 5), 10) !default;\r\n$twitter-hover-color: saturate(darken($twitter-color, 5), 10) !default;\r\n$google-plus-hover-color: saturate(darken($google-plus-color, 5), 10) !default;\r\n$linked-in-hover-color: saturate(darken($linked-in-color, 5), 10) !default;\r\n$youtube-hover-color: saturate(darken($youtube-color, 5), 10) !default;\r\n$instagram-hover-color: saturate(darken($instagram-color, 5), 10) !default;\r\n$pinterest-hover-color: saturate(darken($pinterest-color, 5), 10) !default;\r\n$vk-hover-color: saturate(darken($vk-color, 5), 10) !default;\r\n$telegram-hover-color: saturate(darken($telegram-color, 5), 10) !default;\r\n$whats-app-hover-color: saturate(darken($whats-app-color, 5), 10) !default;\r\n\r\n//---  Dark Tones  ---*/\r\n$full-black-hover: lighten($full-black, 5) !default;\r\n$black-hover: lighten($black, 5) !default;\r\n$grey-hover: lighten($grey, 5) !default;\r\n\r\n//---  Light Tones  ---*/\r\n$white-hover: darken($white, 5) !default;\r\n$off-white-hover: darken($off-white, 5) !default;\r\n$dark-white-hover: darken($dark-white, 5) !default;\r\n","//@import \"../colors/all\";\r\n\r\n$primary-color-down: darken($primary-color, 10) !default;\r\n$secondary-color-down: lighten($secondary-color, 10) !default;\r\n$light-primary-color-down: darken($light-primary-color, 10) !default;\r\n$light-secondary-color-down: lighten($light-secondary-color, 10) !default;\r\n\r\n$red-down: darken($red, 10) !default;\r\n$orange-down: darken($orange, 10) !default;\r\n$yellow-down: darken($yellow, 10) !default;\r\n$olive-down: darken($olive, 10) !default;\r\n$green-down: darken($green, 10) !default;\r\n$teal-down: darken($teal, 10) !default;\r\n$blue-down: darken($blue, 10) !default;\r\n$violet-down: darken($violet, 10) !default;\r\n$purple-down: darken($purple, 10) !default;\r\n$pink-down: darken($pink, 10) !default;\r\n$brown-down: darken($brown, 10) !default;\r\n\r\n$light-red-down: darken($light-red, 10) !default;\r\n$light-orange-down: darken($light-orange, 10) !default;\r\n$light-yellow-down: darken($light-yellow, 10) !default;\r\n$light-olive-down: darken($light-olive, 10) !default;\r\n$light-green-down: darken($light-green, 10) !default;\r\n$light-teal-down: darken($light-teal, 10) !default;\r\n$light-blue-down: darken($light-blue, 10) !default;\r\n$light-violet-down: darken($light-violet, 10) !default;\r\n$light-purple-down: darken($light-purple, 10) !default;\r\n$light-pink-down: darken($light-pink, 10) !default;\r\n$light-brown-down: darken($light-brown, 10) !default;\r\n$light-grey-down: darken($light-grey, 10) !default;\r\n$light-black-down: darken($full-black, 10) !default;\r\n\r\n//---  Emotive  ---*/\r\n$positive-color-down: darken($positive-color, 10) !default;\r\n$negative-color-down: darken($negative-color, 10) !default;\r\n\r\n//---  Brand   ---*/\r\n$facebook-down-color: darken($facebook-color, 10) !default;\r\n$twitter-down-color: darken($twitter-color, 10) !default;\r\n$google-plus-down-color: darken($google-plus-color, 10) !default;\r\n$linked-in-down-color: darken($linked-in-color, 10) !default;\r\n$youtube-down-color: darken($youtube-color, 10) !default;\r\n$instagram-down-color: darken($instagram-color, 10) !default;\r\n$pinterest-down-color: darken($pinterest-color, 10) !default;\r\n$vk-down-color: darken($vk-color, 10) !default;\r\n$telegram-down-color: darken($telegram-color, 10) !default;\r\n$whats-app-down-color: darken($whats-app-color, 10) !default;\r\n\r\n//---  Dark Tones  ---*/\r\n$full-black-down: lighten($full-black, 10) !default;\r\n$black-down: lighten($black, 10) !default;\r\n$grey-down: lighten($grey, 10) !default;\r\n\r\n//---  Light Tones  ---*/\r\n$white-down: darken($white, 10) !default;\r\n$off-white-down: darken($off-white, 10) !default;\r\n$dark-white-down: darken($dark-white, 10) !default;\r\n","$subtle-transparent-black: rgba(0, 0, 0, 0.03) !default;\r\n$subtle-transparent-black02: rgba(0, 0, 0, 0.02) !default;\r\n$transparent-black: rgba(0, 0, 0, 0.05) !default;\r\n$strong-transparent-black: rgba(0, 0, 0, 0.1) !default;\r\n$very-strong-transparent-black: rgba(0, 0, 0, 0.15) !default;\r\n\r\n$subtle-transparent-white: rgba(255, 255, 255, 0.02) !default;\r\n$transparent-white: rgba(255, 255, 255, 0.08) !default;\r\n$strong-transparent-white: rgba(255, 255, 255, 0.15) !default;\r\n","\r\n//@-****************************** Container *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n//- Minimum Gutter is used to determinethe maximum container width for a given device */\r\n\r\n$container-max-width: 100% !default;\r\n\r\n//- Devices */\r\n$container-mobile-minimum-gutter: 0 !default;\r\n$container-mobile-width: auto !default;\r\n$container-mobile-gutter: 1em !default;\r\n\r\n$container-tablet-minimum-gutter: ($em-size  * 1) !default;\r\n$container-tablet-width: $tablet-breakpoint - ($container-tablet-minimum-gutter * 2) - $scrollbar-width !default;\r\n$container-tablet-gutter: auto !default;\r\n\r\n$container-computer-minimum-gutter: ($em-size  * 1.5) !default;\r\n$container-computer-width: $computer-breakpoint - ($container-computer-minimum-gutter * 2) - $scrollbar-width !default;\r\n$container-computer-gutter: auto !default;\r\n\r\n$container-large-monitor-minimum-gutter: ($em-size  * 2) !default;\r\n$container-large-monitor-width: $large-monitor-breakpoint - ($container-large-monitor-minimum-gutter * 2) - $scrollbar-width !default;\r\n$container-large-monitor-gutter: auto !default;\r\n\r\n//- Coupling (Add Negative Margin to container size) */\r\n$container-grid-gutter-width: 2rem !default;\r\n$container-relaxed-grid-gutter-width: 3rem !default;\r\n$container-very-relaxed-grid-gutter-width: 5rem !default;\r\n\r\n$container-mobile-grid-width: $container-mobile-width !default;\r\n$container-tablet-grid-width:  calc(#{$container-tablet-width} + #{$container-grid-gutter-width}) !default;\r\n$container-computer-grid-width:  calc(#{$container-computer-width} + #{$container-grid-gutter-width}) !default;\r\n$container-large-monitor-grid-width:  calc(#{$container-large-monitor-width} + #{$container-grid-gutter-width}) !default;\r\n\r\n$container-mobile-relaxed-grid-width: $container-mobile-width !default;\r\n$container-tablet-relaxed-grid-width:  calc(#{$container-tablet-width} + #{$container-relaxed-grid-gutter-width}) !default;\r\n$container-computer-relaxed-grid-width:  calc(#{$container-computer-width} + #{$container-relaxed-grid-gutter-width}) !default;\r\n$container-large-monitor-relaxed-grid-width:  calc(#{$container-large-monitor-width} + #{$container-relaxed-grid-gutter-width}) !default;\r\n\r\n$container-mobile-very-relaxed-grid-width: $container-mobile-width !default;\r\n$container-tablet-very-relaxed-grid-width:  calc(#{$container-tablet-width} + #{$container-very-relaxed-grid-gutter-width}) !default;\r\n$container-computer-very-relaxed-grid-width:  calc(#{$container-computer-width} + #{$container-very-relaxed-grid-gutter-width}) !default;\r\n$container-large-monitor-very-relaxed-grid-width:  calc(#{$container-large-monitor-width} + #{$container-very-relaxed-grid-gutter-width}) !default;\r\n\r\n//--------------------  Types --------------------*/\r\n\r\n//- Text */\r\n$container-text-width: 700px !default;\r\n$container-text-font-family: $page-font !default;\r\n$container-text-line-height: 1.5 !default;\r\n$container-text-size: $large !default;\r\n","\r\n//@-****************************** Divider *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$divider-margin: 1rem 0 !default;\r\n\r\n$divider-highlight-width: 1px !default;\r\n$divider-highlight-color: $white-border-color !default;\r\n\r\n$divider-shadow-width: 1px !default;\r\n$divider-shadow-color: $border-color !default;\r\n\r\n//- Text */\r\n$divider-letter-spacing: 0.05em !default;\r\n$divider-font-weight: $bold !default;\r\n$divider-color: $dark-text-color !default;\r\n$divider-text-transform: uppercase !default;\r\n\r\n//--------------------  Coupling --------------------*/\r\n\r\n//- Icon */\r\n$divider-icon-size: 1rem !default;\r\n$divider-icon-margin: 0 !default;\r\n\r\n\r\n//-******************************  Variations *******************************/\r\n\r\n//- Horizontal / Vertical */\r\n$divider-horizontal-margin: '' !default;\r\n$divider-in-horizontal-position-margin: 1em !default;\r\n$divider-horizontal-ruler-offset: calc(-50% - #{$divider-in-horizontal-position-margin}) !default;\r\n\r\n$divider-vertical-margin: 1rem !default;\r\n$divider-vertical-height: calc(100% - #{$divider-vertical-margin}) !default;\r\n\r\n//- Inverted */\r\n$divider-inverted-text-color: $white !default;\r\n$divider-inverted-highlight-color: rgba(255, 255, 255, 0.15) !default;\r\n$divider-inverted-shadow-color: $border-color !default;\r\n\r\n//- Section */\r\n$divider-section-margin: 2rem !default;\r\n\r\n//- Sizes */\r\n$divider-medium: 1rem !default;\r\n","@if $use-divider {\n  .ui.horizontal.divider:before,\n  .ui.horizontal.divider:after {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC');\n  }\n  \n  @media only screen and (max-width : ($tablet-breakpoint - 1px)) {\n    .ui.stackable.grid .ui.vertical.divider:before,\n    .ui.grid .stackable.row .ui.vertical.divider:before,\n    .ui.stackable.grid .ui.vertical.divider:after,\n    .ui.grid .stackable.row .ui.vertical.divider:after {\n      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC');\n    }\n  }\n}","\r\n//@-****************************** Flag *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$flag-sprite-path: \"#{$image-path}/flags.png\" !default;\r\n$flag-width: 16px !default;\r\n$flag-height: 11px !default;\r\n$flag-vertical-align: baseline !default;\r\n$flag-margin: 0.5em !default;","\r\n//@-****************************** Header *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$header-text-transform: none !default;\r\n$header-font-family: $header-font !default;\r\n$header-font-weight: $header-font-weight !default;\r\n$header-line-height: $header-line-height !default;\r\n$header-line-height-offset: $header-line-height-offset !default;\r\n\r\n$header-top-margin: $header-top-margin !default;\r\n$header-bottom-margin: $header-bottom-margin !default;\r\n$header-margin: $header-top-margin 0 $header-bottom-margin !default;\r\n\r\n$header-first-margin: -$header-line-height-offset !default;\r\n$header-last-margin: 0 !default;\r\n$header-horizontal-padding: 0 !default;\r\n$header-vertical-padding: 0 !default;\r\n\r\n//- Sub Heading */\r\n$header-sub-heading-distance: $_2px !default;\r\n$header-sub-heading-font-size: $relative-tiny !default;\r\n$header-sub-heading-font-weight: $bold !default;\r\n$header-sub-heading-text-transform: uppercase !default;\r\n$header-sub-heading-color: '' !default;\r\n\r\n$header-small-sub-heading-size: $relative-mini !default;\r\n$header-large-sub-heading-size: $relative-small !default;\r\n$header-huge-sub-heading-size: $relative-medium !default;\r\n\r\n//- Sub Header */\r\n$header-sub-margin: 0 !default;\r\n$header-sub-line-height: 1.2em !default;\r\n$header-sub-color: $muted-text-color !default;\r\n\r\n//- Icon */\r\n$header-icon-opacity: 1 !default;\r\n$header-icon-size: 1.5em !default;\r\n$header-icon-offset: 0 !default;\r\n$header-icon-margin: 0.75rem !default;\r\n$header-icon-alignment: middle !default;\r\n\r\n//- Image */\r\n$header-image-width: 2.5em !default;\r\n$header-image-height: auto !default;\r\n$header-image-offset: $header-line-height-offset !default;\r\n$header-image-margin: $header-icon-margin !default;\r\n$header-image-alignment: middle !default;\r\n\r\n//- Label */\r\n$header-label-size: '' !default;\r\n$header-label-distance: 0.5rem !default;\r\n$header-label-vertical-align: middle !default;\r\n\r\n//- Content */\r\n$header-content-alignment: top !default;\r\n$header-content-icon-alignment: middle !default;\r\n$header-content-image-alignment: middle !default;\r\n\r\n//- Paragraph after Header */\r\n$header-next-paragraph-distance: 0 !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Sizing */\r\n$header-huge-font-size   : join-value-to-unit($h1, em) !default;\r\n$header-large-font-size  : join-value-to-unit($h2, em) !default;\r\n$header-medium-font-size : join-value-to-unit($h3, em) !default;\r\n$header-small-font-size  : join-value-to-unit($h4, em) !default;\r\n$header-tiny-font-size   : join-value-to-unit($h5, em) !default;\r\n\r\n//- Sub Header */\r\n$header-h1-sub-font-size: $large !default;\r\n$header-h2-sub-font-size: $large !default;\r\n$header-h3-sub-font-size: $medium !default;\r\n$header-h4-sub-font-size: $medium !default;\r\n$header-h5-sub-font-size: $small !default;\r\n\r\n$header-huge-sub-font-size  : $header-h1-sub-font-size !default;\r\n$header-large-sub-font-size : $header-h2-sub-font-size !default;\r\n$header-sub-font-size      : $header-h3-sub-font-size !default;\r\n$header-small-sub-font-size : $header-h4-sub-font-size !default;\r\n$header-tiny-sub-font-size  : $header-h5-sub-font-size !default;\r\n\r\n//- Icon Header */\r\n$header-iconed-icon-size: 3em !default;\r\n$header-iconed-icon-opacity: 1 !default;\r\n$header-iconed-icon-margin: 0.5rem !default;\r\n$header-circular-icon-size: 2em !default;\r\n$header-square-icon-size: 2em !default;\r\n$header-corner-icon-size: calc(#{$header-iconed-icon-size} * 0.45) !default;\r\n\r\n//- No Line Height Offset */\r\n$header-icon-top-margin: 2rem !default;\r\n$header-icon-bottom-margin: $header-bottom-margin !default;\r\n$header-icon-first-margin: 0 !default;\r\n\r\n//- Divided */\r\n$header-divided-border-width: 1px !default;\r\n$header-divided-border: $header-divided-border-width solid $border-color !default;\r\n$header-divided-colored-border-width: 2px !default;\r\n\r\n$header-divided-border-padding: $_3px !default;\r\n$header-divided-sub-padding: $_3px !default;\r\n$header-divided-icon-padding: 0 !default;\r\n\r\n//- Block */\r\n$header-block-background: $dark-white !default;\r\n$header-block-box-shadow: none !default;\r\n$header-block-border-width: 1px !default;\r\n$header-block-border: $header-block-border-width solid $solid-border-color !default;\r\n$header-block-horizontal-padding: $medium !default;\r\n$header-block-vertical-padding: $mini !default;\r\n$header-block-border-radius: $default-border-radius !default;\r\n\r\n$header-tiny-block: $tiny !default;\r\n$header-small-block: $small !default;\r\n$header-medium-block: $medium !default;\r\n$header-large-block: $large !default;\r\n$header-huge-block: $huge !default;\r\n\r\n//- Attached */\r\n$header-attached-offset: -1px !default;\r\n$header-attached-box-shadow: none !default;\r\n$header-attached-border: 1px solid $solid-border-color !default;\r\n$header-attached-vertical-padding: $header-block-vertical-padding !default;\r\n$header-attached-horizontal-padding: $header-block-horizontal-padding !default;\r\n$header-attached-background: $white !default;\r\n$header-attached-border-radius: $header-block-border-radius !default;\r\n\r\n$header-tiny-attached-size: $relative-tiny !default;\r\n$header-small-attached-size: $relative-small !default;\r\n$header-medium-attached-size: $relative-medium !default;\r\n$header-large-attached-size: $relative-large !default;\r\n$header-big-attached-size: $relative-big !default;\r\n$header-huge-attached-size: $relative-huge !default;\r\n\r\n//- Inverted */\r\n$header-inverted-color: $white !default;\r\n$header-inverted-sub-color: $inverted-muted-text-color !default;\r\n$header-inverted-divided-border-color: $white-border-color !default;\r\n$header-inverted-block-background: $light-black $subtle-gradient !default;\r\n$header-inverted-attached-background: $black !default;\r\n\r\n//- Floated */\r\n$header-floated-margin: 0.5em !default;\r\n","$disabled-opacity: 0.45 !default;\n","\r\n//@-******************************  Icon *******************************/\r\n\r\n//---------------  Font Files ---------------*/\r\n\r\n//- Solid Icons */\r\n$icon-font-name: 'icons' !default;\r\n$icon-src:\r\n  url(\"#{$font-path}/#{$icon-font-name}.eot?#iefix\") format('embedded-opentype'),\r\n  url(\"#{$font-path}/#{$icon-font-name}.woff2\") format('woff2'),\r\n  url(\"#{$font-path}/#{$icon-font-name}.woff\") format('woff'),\r\n  url(\"#{$font-path}/#{$icon-font-name}.ttf\") format('truetype'),\r\n  url(\"#{$font-path}/#{$icon-font-name}.svg#icons\") format('svg')\r\n !default;\r\n$icon-fallback-src: url(\"#{$font-path}/#{$icon-font-name}.eot\") !default;\r\n\r\n//- Outline Icons */\r\n$icon-import-outline-icons: true !default;\r\n$icon-outline-font-name: 'outline-icons' !default;\r\n$icon-outline-src:\r\n  url(\"#{$font-path}/#{$icon-outline-font-name}.eot?#iefix\") format('embedded-opentype'),\r\n  url(\"#{$font-path}/#{$icon-outline-font-name}.woff2\") format('woff2'),\r\n  url(\"#{$font-path}/#{$icon-outline-font-name}.woff\") format('woff'),\r\n  url(\"#{$font-path}/#{$icon-outline-font-name}.ttf\") format('truetype'),\r\n  url(\"#{$font-path}/#{$icon-outline-font-name}.svg#icons\") format('svg')\r\n !default;\r\n$icon-outline-fallback-src: url(\"#{$font-path}/#{$icon-outline-font-name}.eot\") !default;\r\n\r\n\r\n\r\n//- Brand Icons */\r\n$icon-import-brand-icons: true !default;\r\n$icon-brand-font-name: 'brand-icons' !default;\r\n$icon-brand-src:\r\n  url(\"#{$font-path}/#{$icon-brand-font-name}.eot?#iefix\") format('embedded-opentype'),\r\n  url(\"#{$font-path}/#{$icon-brand-font-name}.woff2\") format('woff2'),\r\n  url(\"#{$font-path}/#{$icon-brand-font-name}.woff\") format('woff'),\r\n  url(\"#{$font-path}/#{$icon-brand-font-name}.ttf\") format('truetype'),\r\n  url(\"#{$font-path}/#{$icon-brand-font-name}.svg#icons\") format('svg')\r\n !default;\r\n$icon-brand-fallback-src: url(\"#{$font-path}/#{$icon-brand-font-name}.eot\") !default;\r\n\r\n\r\n//---------------  Definition ---------------*/\r\n\r\n//- Icon Variables */\r\n$icon-opacity: 1 !default;\r\n$icon-width: $icon-width !default;\r\n$icon-height: 1em !default;\r\n$icon-distance-from-text: 0.25rem !default;\r\n\r\n\r\n//- Variations */\r\n$icon-link-opacity: 0.8 !default;\r\n$icon-link-duration: 0.3s !default;\r\n$icon-loading-duration: 2s !default;\r\n\r\n$icon-circular-size: 2em !default;\r\n$icon-circular-padding: 0.5em 0 !default;\r\n$icon-circular-shadow: 0 0 0 0.1em rgba(0, 0, 0, 0.1) inset !default;\r\n\r\n$icon-bordered-size: 2em !default;\r\n$icon-bordered-vertical-padding: (($icon-bordered-size - $icon-height) / 2) !default;\r\n$icon-bordered-horizontal-padding: 0 !default;\r\n$icon-bordered-shadow: 0 0 0 0.1em rgba(0, 0, 0, 0.1) inset !default;\r\n\r\n$icon-corner-size: 0.45em !default;\r\n$icon-corner-stroke: 1px !default;\r\n$icon-corner-shadow:\r\n  (-$icon-corner-stroke) (-$icon-corner-stroke) 0 $white,\r\n   $icon-corner-stroke (-$icon-corner-stroke) 0 $white,\r\n  (-$icon-corner-stroke)  $icon-corner-stroke 0 $white,\r\n   $icon-corner-stroke  $icon-corner-stroke 0 $white\r\n !default;\r\n$icon-corner-inverted-shadow:\r\n  (-$icon-corner-stroke) (-$icon-corner-stroke) 0 $black,\r\n   $icon-corner-stroke (-$icon-corner-stroke) 0 $black,\r\n  (-$icon-corner-stroke)  $icon-corner-stroke 0 $black,\r\n   $icon-corner-stroke  $icon-corner-stroke 0 $black\r\n !default;\r\n\r\n$icon-mini: 0.4em !default;\r\n$icon-tiny: 0.5em !default;\r\n$icon-small: 0.75em !default;\r\n$icon-medium: 1em !default;\r\n$icon-large: 1.5em !default;\r\n$icon-big: 2em !default;\r\n$icon-huge: 4em !default;\r\n$icon-massive: 8em !default;\r\n","// Maximum Glyph Width of Icon */\r\n$icon-width: 1.18em !default;\r\n","\r\n//@-****************************** Image *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$image-placeholder-color: transparent !default;\r\n$image-rounded-border-radius: 0.3125em !default;\r\n\r\n$image-horizontal-margin: 0.25rem !default;\r\n$image-vertical-margin: 0.5rem !default;\r\n$image-border: 1px solid rgba(0, 0, 0, 0.1) !default;\r\n\r\n//--------------------  Types --------------------*/\r\n\r\n//- Avatar */\r\n$image-avatar-size: 2em !default;\r\n$image-avatar-margin: 0.25em !default;\r\n\r\n\r\n//--------------------  Variations --------------------*/\r\n\r\n//- Spaced */\r\n$image-spaced-distance: 0.5em !default;\r\n\r\n//- Floated */\r\n$image-floated-horizontal-margin: 1em !default;\r\n$image-floated-vertical-margin: 1em !default;\r\n\r\n//- Size */\r\n$image-mini-width: 35px !default;\r\n$image-tiny-width: 80px !default;\r\n$image-small-width: 150px !default;\r\n$image-medium-width: 300px !default;\r\n$image-large-width: 450px !default;\r\n$image-big-width: 600px !default;\r\n$image-huge-width: 800px !default;\r\n$image-massive-width: 960px !default;\r\n","\r\n//@-****************************** Input *******************************/\r\n\r\n//-------------------- Element --------------------*/\r\n\r\n$input-font: $page-font !default;\r\n$input-vertical-padding: $input-vertical-padding !default;\r\n$input-horizontal-padding: $input-horizontal-padding !default;\r\n\r\n$input-line-height: $input-line-height !default;\r\n$input-line-height-offset: (($input-line-height - 1em) / 2) !default;\r\n\r\n$input-padding: ($input-vertical-padding - $input-line-height-offset) $input-horizontal-padding !default;\r\n\r\n$input-text-align: left !default;\r\n$input-background: $input-background !default;\r\n$input-border-width: 1px !default;\r\n$input-border: $input-border-width solid $border-color !default;\r\n$input-box-shadow: none !default;\r\n\r\n$input-border-radius: $default-border-radius !default;\r\n$input-transition:\r\n  box-shadow $default-duration $default-easing,\r\n  border-color $default-duration $default-easing\r\n !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Icon Input */\r\n$input-icon-width: ($input-vertical-padding * 2) + $glyph-width !default;\r\n$input-icon-opacity: 0.5 !default;\r\n$input-icon-focus-opacity: 1 !default;\r\n$input-icon-offset: -0.5em !default;\r\n\r\n$input-icon-distance: 0 !default;\r\n$input-icon-margin: $input-icon-width + $input-icon-distance !default;\r\n$input-icon-transition: opacity 0.3s $default-easing !default;\r\n\r\n$input-transparent-icon-width: $glyph-width !default;\r\n$input-transparent-icon-margin: 2em !default;\r\n\r\n$input-textarea-icon-height: 3em !default;\r\n$input-transparent-textarea-icon-height: 1.3em !default;\r\n\r\n//- Circular Icon Input */\r\n$input-circular-icon-vertical-offset: 0.35em !default;\r\n$input-circular-icon-horizontal-offset: 0.5em !default;\r\n\r\n//- Labeled Input */\r\n$input-label-corner-top: $input-border-width !default;\r\n$input-label-corner-right: $input-border-width !default;\r\n$input-label-corner-size: $relative9px !default;\r\n$input-label-size: 1em !default;\r\n$input-label-vertical-padding: ($input-vertical-padding - $input-line-height-offset) !default;\r\n\r\n$input-labeled-margin: 2.5em !default;\r\n$input-labeled-icon-itself-margin: 3.25em !default;\r\n$input-labeled-icon-margin: 1.25em !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n//- Placeholder */\r\n$input-placeholder-color: $input-placeholder-color !default;\r\n$input-placeholder-focus-color: $input-placeholder-focus-color !default;\r\n\r\n//- Down */\r\n$input-down-border-color: rgba(0, 0, 0, 0.3) !default;\r\n$input-down-background: #FAFAFA !default;\r\n$input-down-color: $text-color !default;\r\n$input-down-box-shadow: none !default;\r\n\r\n//- Focus */\r\n$input-focus-border-color: $focused-form-border-color !default;\r\n$input-focus-background: $input-background !default;\r\n$input-focus-color: $hovered-text-color !default;\r\n$input-focus-box-shadow: none !default;\r\n\r\n//- Error */\r\n$input-error-background: $negative-background-color !default;\r\n$input-error-color: $negative-text-color !default;\r\n$input-error-border: $negative-border-color !default;\r\n$input-error-box-shadow: none !default;\r\n\r\n$input-placeholder-error-color: lighten($input-error-color, 40) !default;\r\n$input-placeholder-error-focus-color: lighten($input-error-color, 30) !default;\r\n\r\n//- Loader */\r\n$input-inverted-loader-fill-color: rgba(0, 0, 0, 0.15) !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Inverted */\r\n$input-transparent-inverted-placeholder-color: $inverted-unselected-text-color !default;\r\n$input-transparent-inverted-color: $white !default;\r\n\r\n","// @import \"../../../../utils/all\";\r\n// @import \"../colors/all\";\r\n// @import \"../fonts/all\";\r\n// @import \"../texts/all\";\r\n\r\n$input-background: $white !default;\r\n$input-vertical-padding: $relative11px !default;\r\n$input-horizontal-padding: $relative14px !default;\r\n$input-padding: $input-vertical-padding $input-horizontal-padding !default;\r\n\r\n// Input Text Color */\r\n$input-color: $text-color !default;\r\n$input-placeholder-color: lighten($input-color, 75) !default;\r\n$input-placeholder-focus-color: lighten($input-color, 45) !default;\r\n\r\n// Line Height Default For Inputs in Browser (Descenders are 17px at 14px base em) */\r\n$input-line-height: join-value-to-unit((17 / 14), em) !default;\r\n\r\n//-------------------\r\n//   Focused Input\r\n//--------------------*/\r\n\r\n// Used on inputs, textarea etc */\r\n$focused-form-border-color: #85b7d9 !default;\r\n\r\n// Used on dropdowns, other larger blocks */\r\n$focused-form-muted-border-color: #96c8da !default;\r\n","//@import \"./main\";\r\n\r\n// Positive or success */\r\n$positive-color: $green !default;\r\n$positive-background-color: #fcfff5 !default;\r\n$success-background-color: $positive-background-color !default;\r\n$success-color: $positive-color !default;\r\n\r\n// Negative or error*/\r\n$negative-color: $red !default;\r\n$negative-background-color: #fff6f6 !default;\r\n$error-background-color: $negative-background-color !default;\r\n$error-color: $negative-color !default;\r\n\r\n// Info */\r\n$info-color: #31ccec !default;\r\n$info-background-color: #f8ffff !default;\r\n\r\n// Warning */\r\n$warning-color: #f2c037 !default;\r\n$warning-background-color: #fffaf3 !default;\r\n","$positive-text-color: #2c662d !default;\r\n$success-text-color: $positive-text-color !default;\r\n\r\n$negative-text-color: #9f3a38 !default;\r\n$error-text-color: $negative-text-color !default;\r\n\r\n$info-text-color: #276f86 !default;\r\n$warning-text-color: #573a08 !default;\r\n\r\n$disabled-text-color: rgba(40, 40, 40, 0.3) !default;\r\n$inverted-disabled-text-color: rgba(225, 225, 225, 0.3) !default;\r\n","\r\n//@-******************************  Label *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$label-vertical-align: baseline !default;\r\n$label-vertical-margin: 0 !default;\r\n$label-horizontal-margin: $relative2px !default;\r\n$label-background-color: #E8E8E8 !default;\r\n$label-color: $muted-text-color !default;\r\n$label-background-image: none !default;\r\n$label-vertical-padding: 0.5833em !default; //- medium is not $em-size custom value required */\r\n$label-horizontal-padding: 0.833em !default;\r\n$label-border-radius: $absolute-border-radius !default;\r\n$label-text-transform: none !default;\r\n$label-font-weight: $bold !default;\r\n$label-border-width: 1px !default;\r\n$label-border: 0 solid transparent !default;\r\n\r\n$label-line-height-offset: -($label-vertical-padding / 2) !default;\r\n\r\n$label-transition-duration: $default-duration !default;\r\n$label-transition-easing: $default-easing !default;\r\n$label-transition: background $label-transition-duration $label-transition-easing !default;\r\n\r\n//- Group */\r\n$label-group-vertical-margin: 0.5em !default;\r\n$label-group-horizontal-margin: 0.5em !default;\r\n\r\n//-------------------- Parts --------------------*/\r\n\r\n//- Link */\r\n$label-link-opacity: 0.5 !default;\r\n$label-link-transition: $label-transition-duration opacity $label-transition-easing !default;\r\n\r\n//- Icon */\r\n$label-icon-distance: 0.75em !default;\r\n\r\n//- Image */\r\n$label-image-height: (1em + $label-vertical-padding * 2) !default;\r\n\r\n//- Detail */\r\n$label-detail-font-weight: $bold !default;\r\n$label-detail-opacity: 0.8 !default;\r\n$label-detail-icon-distance: 0.25em !default;\r\n$label-detail-margin: 1em !default;\r\n\r\n//- Delete */\r\n$label-delete-opacity: $label-link-opacity !default;\r\n$label-delete-size: $relative-small !default;\r\n$label-delete-margin: 0.5em !default;\r\n$label-delete-transition: background $label-transition-duration $label-transition-easing !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Image Label */\r\n$label-image-background: $label-background-color !default;\r\n$label-image-vertical-padding: $label-vertical-padding !default;\r\n$label-image-horizontal-padding: $label-horizontal-padding !default;\r\n$label-image-text-distance: 0.5em !default;\r\n$label-image-detail-distance: $label-image-text-distance !default;\r\n$label-image-border-radius: $label-border-radius !default;\r\n$label-image-box-shadow: none !default;\r\n$label-image-padding: $label-image-vertical-padding $label-image-horizontal-padding $label-image-vertical-padding $label-image-text-distance !default;\r\n\r\n$label-image-image-margin: (-$label-vertical-padding) $label-image-text-distance (-$label-vertical-padding) (-$label-image-text-distance) !default;\r\n$label-image-image-border-radius: $label-image-border-radius 0 0 $label-image-border-radius !default;\r\n$label-image-image-height: $label-image-height !default;\r\n\r\n$label-image-detail-background: $strong-transparent-black !default;\r\n$label-image-detail-padding: $label-image-vertical-padding $label-image-horizontal-padding !default;\r\n$label-image-detail-margin: (-$label-image-vertical-padding) (-$label-image-horizontal-padding) (-$label-image-vertical-padding) $label-image-detail-distance !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n//- Hover */\r\n$label-hover-background-color: #E0E0E0 !default;\r\n$label-hover-background-image: none !default;\r\n$label-hover-text-color: $hovered-text-color !default;\r\n\r\n//- Active */\r\n$label-active-background-color: #D0D0D0 !default;\r\n$label-active-background-image: none !default;\r\n$label-active-text-color: $selected-text-color !default;\r\n\r\n//- Active Hover */\r\n$label-active-hover-background-color: #C8C8C8 !default;\r\n$label-active-hover-background-image: none !default;\r\n$label-active-hover-text-color: $selected-text-color !default;\r\n\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Basic */\r\n$label-basic-background: none $white !default;\r\n$label-basic-border-width: 1px !default;\r\n$label-basic-border-width-offset: -$label-basic-border-width !default;\r\n$label-basic-border-full-width-offset: calc(100% + #{$label-basic-border-width}) !default;\r\n$label-basic-border: $label-basic-border-width solid $border-color !default;\r\n$label-basic-color: $text-color !default;\r\n$label-basic-box-shadow: none !default;\r\n\r\n$label-basic-hover-background: $label-basic-background !default;\r\n$label-basic-hover-color: $link-hover-color !default;\r\n$label-basic-hover-border: $label-basic-border !default;\r\n$label-basic-hover-box-shadow: $label-basic-box-shadow !default;\r\n\r\n//- Tag */\r\n$label-tag-circle-color: $white !default;\r\n$label-tag-circle-size: 0.5em !default;\r\n$label-tag-horizontal-padding: 1.5em !default;\r\n$label-tag-circle-box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.3) !default;\r\n$label-basic-tag-circle-box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.8) !default;\r\n$label-tag-triangle-right-offset: 100% !default;\r\n$label-tag-triangle-top-offset: 50% !default;\r\n$label-tag-triangle-size: 1.56em !default;\r\n$label-tag-triangle-background-image: none !default;\r\n$label-tag-transition: none !default; //- Avoids error with background: inherit !default; on animation */\r\n\r\n//- Ribbon */\r\n$label-ribbon-triangle-size: 1.2em !default;\r\n$label-basic-ribbon-triangle-size:  calc(#{$label-ribbon-triangle-size} - #{$label-basic-border-width}) !default;\r\n$label-basic-ribbon-triangle-size-offset:  calc(1rem + #{$label-ribbon-triangle-size} - #{$label-basic-border-width}) !default;\r\n$label-ribbon-shadow-color: rgba(0, 0, 0, 0.15) !default;\r\n\r\n$label-ribbon-margin: 1rem !default;\r\n$label-ribbon-offset:  calc(#{-$label-ribbon-margin} - #{$label-ribbon-triangle-size}) !default;\r\n$label-basic-ribbon-offset:  calc(#{$label-vertical-padding} - #{$label-basic-border-width}) !default;\r\n$label-ribbon-distance:  calc(#{$label-ribbon-margin} + #{$label-ribbon-triangle-size}) !default;\r\n$label-right-ribbon-offset:  calc(100% + #{$label-ribbon-margin} + #{$label-ribbon-triangle-size}) !default;\r\n\r\n$label-ribbon-image-top-distance: 1rem !default;\r\n$label-ribbon-image-margin: -0.05rem !default; //- Rounding Offset on Triangle */\r\n$label-ribbon-image-offset:  calc(#{-$label-ribbon-image-margin} - #{$label-ribbon-triangle-size}) !default;\r\n$label-right-ribbon-image-offset:  calc(100% + #{$label-ribbon-image-margin} + #{$label-ribbon-triangle-size}) !default;\r\n\r\n$label-ribbon-table-margin: $relative-medium !default; //- Rounding Offset on Triangle */\r\n$label-ribbon-table-offset:  calc(#{-$label-ribbon-table-margin} - #{$label-ribbon-triangle-size}) !default;\r\n$label-right-ribbon-table-offset:  calc(100% + #{$label-ribbon-table-margin} + #{$label-ribbon-triangle-size}) !default;\r\n\r\n//- Inverted */\r\n$label-inverted-background-color: darken($label-background-color,20) !default;\r\n$label-inverted-background: $black !default;\r\n$label-inverted-box-shadow-size: 2px !default;\r\n$label-inverted-border-size: 1px !default;\r\n\r\n$label-basic-inverted-border-color: rgba(255, 255, 255, 0.5) !default;\r\n\r\n//- Colors */\r\n$label-red-text-color: $white !default;\r\n$label-orange-text-color: $white !default;\r\n$label-yellow-text-color: $white !default;\r\n$label-olive-text-color: $white !default;\r\n$label-green-text-color: $white !default;\r\n$label-teal-text-color: $white !default;\r\n$label-blue-text-color: $white !default;\r\n$label-violet-text-color: $white !default;\r\n$label-purple-text-color: $white !default;\r\n$label-pink-text-color: $white !default;\r\n$label-brown-text-color: $white !default;\r\n$label-grey-text-color: $white !default;\r\n$label-black-text-color: $white !default;\r\n\r\n$label-red-hover-text-color: $white !default;\r\n$label-orange-hover-text-color: $white !default;\r\n$label-yellow-hover-text-color: $white !default;\r\n$label-olive-hover-text-color: $white !default;\r\n$label-green-hover-text-color: $white !default;\r\n$label-teal-hover-text-color: $white !default;\r\n$label-blue-hover-text-color: $white !default;\r\n$label-violet-hover-text-color: $white !default;\r\n$label-purple-hover-text-color: $white !default;\r\n$label-pink-hover-text-color: $white !default;\r\n$label-brown-hover-text-color: $white !default;\r\n$label-grey-hover-text-color: $white !default;\r\n$label-black-hover-text-color: $white !default;\r\n\r\n$label-primary-hover-text-color: $white !default;\r\n$label-secondary-hover-text-color: $white !default;\r\n\r\n$label-primary-text-color: $inverted-text-color !default;\r\n$label-secondary-text-color: $inverted-text-color !default;\r\n\r\n//- Attached */\r\n$label-attached-segment-padding: 2rem !default;\r\n$label-attached-vertical-padding: 0.75em !default;\r\n$label-attached-horizontal-padding: 1em !default;\r\n\r\n$label-attached-corner-border-radius: $_3px !default;\r\n$label-attached-border-radius: $label-border-radius !default;\r\n\r\n//- Corner */\r\n$label-corner-size-ratio: 1 !default;\r\n$label-corner-transition: color $label-transition-duration $label-transition-easing !default;\r\n$label-corner-triangle-size: 4em !default;\r\n$label-corner-triangle-transition: border-color $label-transition-duration $label-transition-easing !default;\r\n$label-corner-triangle-z-index: 1 !default;\r\n\r\n$label-corner-icon-size: $relative-large !default;\r\n$label-corner-icon-top-offset: $relative9px !default;\r\n$label-corner-icon-left-offset: $relative8px !default;\r\n$label-corner-icon-right-offset: $relative8px !default;\r\n\r\n//- Corner Text */\r\n$label-corner-text-width: 3em !default;\r\n$label-corner-text-weight: $bold !default;\r\n$label-corner-text-size: 1em !default;\r\n\r\n//- Horizontal */\r\n$label-horizontal-min-width: 3em !default;\r\n$label-in-horizontal-position-margin: 0.5em !default;\r\n$label-horizontal-vertical-padding: 0.4em !default;\r\n\r\n//- Circular Padding */\r\n$label-circular-padding: 0.5em !default;\r\n$label-circular-min-size: 2em !default;\r\n$label-empty-circle-size: 0.5em !default;\r\n\r\n//- Pointing */\r\n$label-pointing-border-color: inherit !default;\r\n$label-pointing-border-width: $label-border-width !default;\r\n$label-pointing-vertical-distance: 1em !default;\r\n$label-pointing-triangle-size: 0.6666em !default;\r\n$label-pointing-horizontal-distance: $label-pointing-triangle-size !default;\r\n\r\n$label-pointing-triangle-transition: none !default; //- Avoids error with background: inherit !default; on animation */\r\n$label-pointing-triangle-z-index: 2 !default;\r\n\r\n//- Basic Pointing */\r\n$label-basic-pointing-triangle-offset: -$label-pointing-border-width !default;\r\n\r\n//- Floating */\r\n$label-floating-top-offset: -1em !default;\r\n$label-floating-bottom-offset: $label-floating-top-offset !default;\r\n$label-floating-align-offset: 1.2em !default;\r\n$label-floating-z-index: 100 !default;\r\n\r\n//-------------------- Group --------------------*/\r\n\r\n//- Sizing */\r\n$label-mini    : $_9px !default;\r\n$label-tiny    : $_10px !default;\r\n$label-small   : $_11px !default;\r\n$label-medium  : $_12px !default;\r\n$label-large   : $absolute-medium !default;\r\n$label-big     : $absolute-big !default;\r\n$label-huge    : $absolute-huge !default;\r\n$label-massive : $absolute-massive !default;\r\n\r\n$label-colors-map: (\r\n  primary: (\r\n    color          : $primary-color,\r\n    light          : $light-primary-color,\r\n    border         : $primary-border-color,\r\n    background     : $primary-background,\r\n    header         : $primary-header-color,\r\n    boxShadow      : $primary-box-shadow,\r\n    boxFloatShadow : $primary-box-floating-shadow,\r\n    text           : $label-primary-text-color,\r\n    lightText      : $light-primary-text-color,\r\n    hoverText      : $label-primary-hover-text-color,\r\n    focus          : $primary-color-focus,\r\n    lightFocus     : $light-primary-color-focus,\r\n    down           : $primary-color-down,\r\n    lightDown      : $light-primary-color-down,\r\n    active         : $primary-color-active,\r\n    lightActive    : $light-primary-color-active,\r\n    shadow         : $primary-text-shadow,\r\n    lightShadow    : $light-primary-text-shadow,\r\n    hover          : $primary-color-hover,\r\n    lightHover     : $light-primary-color-hover,\r\n    ribbon         : $primary-ribbon-shadow,\r\n    invertedRibbon : $primary-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  secondary: (\r\n    color          : $secondary-color,\r\n    light          : $light-secondary-color,\r\n    border         : $secondary-border-color,\r\n    background     : $secondary-background,\r\n    header         : $secondary-header-color,\r\n    boxShadow      : $secondary-box-shadow,\r\n    boxFloatShadow : $secondary-box-floating-shadow,\r\n    text           : $label-secondary-text-color,\r\n    lightText      : $light-secondary-text-color,\r\n    hoverText      : $label-secondary-hover-text-color,\r\n    focus          : $secondary-color-focus,\r\n    lightFocus     : $light-secondary-color-focus,\r\n    down           : $secondary-color-down,\r\n    lightDown      : $light-secondary-color-down,\r\n    active         : $secondary-color-active,\r\n    lightActive    : $light-secondary-color-active,\r\n    shadow         : $secondary-text-shadow,\r\n    lightShadow    : $light-secondary-text-shadow,\r\n    hover          : $secondary-color-hover,\r\n    lightHover     : $light-secondary-color-hover,\r\n    ribbon         : $secondary-ribbon-shadow,\r\n    invertedRibbon : $secondary-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  red: (\r\n    color          : $red,\r\n    light          : $light-red,\r\n    border         : $red-border-color,\r\n    background     : $red-background,\r\n    header         : $red-header-color,\r\n    boxShadow      : $red-box-shadow,\r\n    boxFloatShadow : $red-box-floating-shadow,\r\n    text           : $label-red-text-color,\r\n    lightText      : $light-red-text-color,\r\n    hoverText      : $label-red-hover-text-color,\r\n    focus          : $red-focus,\r\n    lightFocus     : $light-red-focus,\r\n    down           : $red-down,\r\n    lightDown      : $light-red-down,\r\n    active         : $red-active,\r\n    lightActive    : $light-red-active,\r\n    shadow         : $red-text-shadow,\r\n    lightShadow    : $light-red-text-shadow,\r\n    hover          : $red-hover,\r\n    lightHover     : $light-red-hover,\r\n    ribbon         : $red-ribbon-shadow,\r\n    invertedRibbon : $red-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  orange: (\r\n    color          : $orange,\r\n    light          : $light-orange,\r\n    border         : $orange-border-color,\r\n    background     : $orange-background,\r\n    header         : $orange-header-color,\r\n    boxShadow      : $orange-box-shadow,\r\n    boxFloatShadow : $orange-box-floating-shadow,\r\n    text           : $label-orange-text-color,\r\n    lightText      : $light-orange-text-color,\r\n    hoverText      : $label-orange-hover-text-color,\r\n    focus          : $orange-focus,\r\n    lightFocus     : $light-orange-focus,\r\n    down           : $orange-down,\r\n    lightDown      : $light-orange-down,\r\n    active         : $orange-active,\r\n    lightActive    : $light-orange-active,\r\n    shadow         : $orange-text-shadow,\r\n    lightShadow    : $light-orange-text-shadow,\r\n    hover          : $orange-hover,\r\n    lightHover     : $light-orange-hover,\r\n    ribbon         : $orange-ribbon-shadow,\r\n    invertedRibbon : $orange-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  yellow: (\r\n    color          : $yellow,\r\n    light          : $light-yellow,\r\n    border         : $yellow-border-color,\r\n    background     : $yellow-background,\r\n    header         : $yellow-header-color,\r\n    boxShadow      : $yellow-box-shadow,\r\n    boxFloatShadow : $yellow-box-floating-shadow,\r\n    text           : $label-yellow-text-color,\r\n    lightText      : $light-yellow-text-color,\r\n    hoverText      : $label-yellow-hover-text-color,\r\n    focus          : $yellow-focus,\r\n    lightFocus     : $light-yellow-focus,\r\n    down           : $yellow-down,\r\n    lightDown      : $light-yellow-down,\r\n    active         : $yellow-active,\r\n    lightActive    : $light-yellow-active,\r\n    shadow         : $yellow-text-shadow,\r\n    lightShadow    : $light-yellow-text-shadow,\r\n    hover          : $yellow-hover,\r\n    lightHover     : $light-yellow-hover,\r\n    ribbon         : $yellow-ribbon-shadow,\r\n    invertedRibbon : $yellow-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  olive: (\r\n    color          : $olive,\r\n    light          : $light-olive,\r\n    border         : $olive-border-color,\r\n    background     : $olive-background,\r\n    header         : $olive-header-color,\r\n    boxShadow      : $olive-box-shadow,\r\n    boxFloatShadow : $olive-box-floating-shadow,\r\n    text           : $label-olive-text-color,\r\n    lightText      : $light-olive-text-color,\r\n    hoverText      : $label-olive-hover-text-color,\r\n    focus          : $olive-focus,\r\n    lightFocus     : $light-olive-focus,\r\n    down           : $olive-down,\r\n    lightDown      : $light-olive-down,\r\n    active         : $olive-active,\r\n    lightActive    : $light-olive-active,\r\n    shadow         : $olive-text-shadow,\r\n    lightShadow    : $light-olive-text-shadow,\r\n    hover          : $olive-hover,\r\n    lightHover     : $light-olive-hover,\r\n    ribbon         : $olive-ribbon-shadow,\r\n    invertedRibbon : $olive-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  green: (\r\n    color          : $green,\r\n    light          : $light-green,\r\n    border         : $green-border-color,\r\n    background     : $green-background,\r\n    header         : $green-header-color,\r\n    boxShadow      : $green-box-shadow,\r\n    boxFloatShadow : $green-box-floating-shadow,\r\n    text           : $label-green-text-color,\r\n    lightText      : $light-green-text-color,\r\n    hoverText      : $label-green-hover-text-color,\r\n    focus          : $green-focus,\r\n    lightFocus     : $light-green-focus,\r\n    down           : $green-down,\r\n    lightDown      : $light-green-down,\r\n    active         : $green-active,\r\n    lightActive    : $light-green-active,\r\n    shadow         : $green-text-shadow,\r\n    lightShadow    : $light-green-text-shadow,\r\n    hover          : $green-hover,\r\n    lightHover     : $light-green-hover,\r\n    ribbon         : $green-ribbon-shadow,\r\n    invertedRibbon : $green-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  teal: (\r\n    color          : $teal,\r\n    light          : $light-teal,\r\n    border         : $teal-border-color,\r\n    background     : $teal-background,\r\n    header         : $teal-header-color,\r\n    boxShadow      : $teal-box-shadow,\r\n    boxFloatShadow : $teal-box-floating-shadow,\r\n    text           : $label-teal-text-color,\r\n    lightText      : $light-teal-text-color,\r\n    hoverText      : $label-teal-hover-text-color,\r\n    focus          : $teal-focus,\r\n    lightFocus     : $light-teal-focus,\r\n    down           : $teal-down,\r\n    lightDown      : $light-teal-down,\r\n    active         : $teal-active,\r\n    lightActive    : $light-teal-active,\r\n    shadow         : $teal-text-shadow,\r\n    lightShadow    : $light-teal-text-shadow,\r\n    hover          : $teal-hover,\r\n    lightHover     : $light-teal-hover,\r\n    ribbon         : $teal-ribbon-shadow,\r\n    invertedRibbon : $teal-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  blue: (\r\n    color          : $blue,\r\n    light          : $light-blue,\r\n    border         : $blue-border-color,\r\n    background     : $blue-background,\r\n    header         : $blue-header-color,\r\n    boxShadow      : $blue-box-shadow,\r\n    boxFloatShadow : $blue-box-floating-shadow,\r\n    text           : $label-blue-text-color,\r\n    lightText      : $light-blue-text-color,\r\n    hoverText      : $label-blue-hover-text-color,\r\n    focus          : $blue-focus,\r\n    lightFocus     : $light-blue-focus,\r\n    down           : $blue-down,\r\n    lightDown      : $light-blue-down,\r\n    active         : $blue-active,\r\n    lightActive    : $light-blue-active,\r\n    shadow         : $blue-text-shadow,\r\n    lightShadow    : $light-blue-text-shadow,\r\n    hover          : $blue-hover,\r\n    lightHover     : $light-blue-hover,\r\n    ribbon         : $blue-ribbon-shadow,\r\n    invertedRibbon : $blue-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  violet: (\r\n    color          : $violet,\r\n    light          : $light-violet,\r\n    border         : $violet-border-color,\r\n    background     : $violet-background,\r\n    header         : $violet-header-color,\r\n    boxShadow      : $violet-box-shadow,\r\n    boxFloatShadow : $violet-box-floating-shadow,\r\n    text           : $label-violet-text-color,\r\n    lightText      : $light-violet-text-color,\r\n    hoverText      : $label-violet-hover-text-color,\r\n    focus          : $violet-focus,\r\n    lightFocus     : $light-violet-focus,\r\n    down           : $violet-down,\r\n    lightDown      : $light-violet-down,\r\n    active         : $violet-active,\r\n    lightActive    : $light-violet-active,\r\n    shadow         : $violet-text-shadow,\r\n    lightShadow    : $light-violet-text-shadow,\r\n    hover          : $violet-hover,\r\n    lightHover     : $light-violet-hover,\r\n    ribbon         : $violet-ribbon-shadow,\r\n    invertedRibbon : $violet-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  purple: (\r\n    color          : $purple,\r\n    light          : $light-purple,\r\n    border         : $purple-border-color,\r\n    background     : $purple-background,\r\n    header         : $purple-header-color,\r\n    boxShadow      : $purple-box-shadow,\r\n    boxFloatShadow : $purple-box-floating-shadow,\r\n    text           : $label-purple-text-color,\r\n    lightText      : $light-purple-text-color,\r\n    hoverText      : $label-purple-hover-text-color,\r\n    focus          : $purple-focus,\r\n    lightFocus     : $light-purple-focus,\r\n    down           : $purple-down,\r\n    lightDown      : $light-purple-down,\r\n    active         : $purple-active,\r\n    lightActive    : $light-purple-active,\r\n    shadow         : $purple-text-shadow,\r\n    lightShadow    : $light-purple-text-shadow,\r\n    hover          : $purple-hover,\r\n    lightHover     : $light-purple-hover,\r\n    ribbon         : $purple-ribbon-shadow,\r\n    invertedRibbon : $purple-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  pink: (\r\n    color          : $pink,\r\n    light          : $light-pink,\r\n    border         : $pink-border-color,\r\n    background     : $pink-background,\r\n    header         : $pink-header-color,\r\n    boxShadow      : $pink-box-shadow,\r\n    boxFloatShadow : $pink-box-floating-shadow,\r\n    text           : $label-pink-text-color,\r\n    lightText      : $light-pink-text-color,\r\n    hoverText      : $label-pink-hover-text-color,\r\n    focus          : $pink-focus,\r\n    lightFocus     : $light-pink-focus,\r\n    down           : $pink-down,\r\n    lightDown      : $light-pink-down,\r\n    active         : $pink-active,\r\n    lightActive    : $light-pink-active,\r\n    shadow         : $pink-text-shadow,\r\n    lightShadow    : $light-pink-text-shadow,\r\n    hover          : $pink-hover,\r\n    lightHover     : $light-pink-hover,\r\n    ribbon         : $pink-ribbon-shadow,\r\n    invertedRibbon : $pink-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  brown: (\r\n    color          : $brown,\r\n    light          : $light-brown,\r\n    border         : $brown-border-color,\r\n    background     : $brown-background,\r\n    header         : $brown-header-color,\r\n    boxShadow      : $brown-box-shadow,\r\n    boxFloatShadow : $brown-box-floating-shadow,\r\n    text           : $label-brown-text-color,\r\n    lightText      : $light-brown-text-color,\r\n    hoverText      : $label-brown-hover-text-color,\r\n    focus          : $brown-focus,\r\n    lightFocus     : $light-brown-focus,\r\n    down           : $brown-down,\r\n    lightDown      : $light-brown-down,\r\n    active         : $brown-active,\r\n    lightActive    : $light-brown-active,\r\n    shadow         : $brown-text-shadow,\r\n    lightShadow    : $light-brown-text-shadow,\r\n    hover          : $brown-hover,\r\n    lightHover     : $light-brown-hover,\r\n    ribbon         : $brown-ribbon-shadow,\r\n    invertedRibbon : $brown-inverted-ribbon-shadow,\r\n    isDark         : false,\r\n    isVeryDark     : false,\r\n  ),\r\n  grey: (\r\n    color          : $grey,\r\n    light          : $light-grey,\r\n    border         : $grey-border-color,\r\n    background     : $grey-background,\r\n    header         : $grey-header-color,\r\n    boxShadow      : $grey-box-shadow,\r\n    boxFloatShadow : $grey-box-floating-shadow,\r\n    text           : $label-grey-text-color,\r\n    lightText      : $light-grey-text-color,\r\n    hoverText      : $label-grey-hover-text-color,\r\n    focus          : $grey-focus,\r\n    lightFocus     : $light-grey-focus,\r\n    down           : $grey-down,\r\n    lightDown      : $light-grey-down,\r\n    active         : $grey-active,\r\n    lightActive    : $light-grey-active,\r\n    shadow         : $grey-text-shadow,\r\n    lightShadow    : $light-grey-text-shadow,\r\n    hover          : $grey-hover,\r\n    lightHover     : $light-grey-hover,\r\n    ribbon         : $grey-ribbon-shadow,\r\n    invertedRibbon : $grey-inverted-ribbon-shadow,\r\n    isDark         : true,\r\n    isVeryDark     : false,\r\n  ),\r\n  black: (\r\n    color          : $black,\r\n    light          : $light-black,\r\n    border         : $black-border-color,\r\n    background     : $black-background,\r\n    header         : $black-header-color,\r\n    boxShadow      : $black-box-shadow,\r\n    boxFloatShadow : $black-box-floating-shadow,\r\n    text           : $label-black-text-color,\r\n    lightText      : $light-black-text-color,\r\n    hoverText      : $label-black-hover-text-color,\r\n    focus          : $black-focus,\r\n    lightFocus     : $light-black-focus,\r\n    down           : $black-down,\r\n    lightDown      : $light-black-down,\r\n    active         : $black-active,\r\n    lightActive    : $light-black-active,\r\n    shadow         : $black-text-shadow,\r\n    lightShadow    : $light-black-text-shadow,\r\n    hover          : $black-hover,\r\n    lightHover     : $light-black-hover,\r\n    ribbon         : $black-ribbon-shadow,\r\n    invertedRibbon : $black-inverted-ribbon-shadow,\r\n    isDark         : true,\r\n    isVeryDark     : true,\r\n  )\r\n) !default;","\r\n//@-******************************  List *******************************/\r\n\r\n//--------------------  View --------------------*/\r\n\r\n//- List */\r\n$list-style-type: none !default;\r\n$list-style-position: outside !default;\r\n$list-margin: 1em 0 !default;\r\n$list-vertical-padding: 0 !default;\r\n$list-horizontal-padding: 0 !default;\r\n\r\n//- List Item */\r\n$list-item-vertical-padding: $relative3px !default;\r\n$list-item-horizontal-padding: 0 !default;\r\n$list-item-padding: $list-item-vertical-padding $list-item-horizontal-padding !default;\r\n$list-item-line-height: $relative-large !default;\r\n\r\n//- Sub List */\r\n$list-child-padding: 0.75em 0 0.25em 0.5em !default;\r\n$list-child-indent: 1em !default;\r\n\r\n//- Sub List Item */\r\n$list-child-item-vertical-padding: $relative2px !default;\r\n$list-child-item-horizontal-padding: 0 !default;\r\n$list-child-item-padding: $list-child-item-vertical-padding $list-child-item-horizontal-padding !default;\r\n$list-child-item-line-height: inherit !default;\r\n\r\n//-------------------- Elements --------------------*/\r\n\r\n//- Icon */\r\n$list-icon-distance: $relative4px !default;\r\n$list-icon-offset: 0 !default;\r\n$list-icon-transition: color $default-duration $default-easing !default;\r\n$list-icon-vertical-align: top !default;\r\n$list-icon-content-vertical-align: top !default;\r\n\r\n//- Image */\r\n$list-image-distance: 0.5em !default;\r\n$list-image-align: top !default;\r\n\r\n//- Content */\r\n$list-content-distance: 0.5em !default;\r\n$list-content-line-height: $list-item-line-height !default;\r\n$list-content-line-height-offset: ($list-content-line-height - 1em) / 2 !default;\r\n$list-content-vertical-align: top !default;\r\n$list-content-color: $text-color !default;\r\n\r\n//- Header */\r\n$list-item-header-font-family: $header-font !default;\r\n$list-item-header-font-weight: $bold !default;\r\n$list-item-header-color: $text-color !default;\r\n\r\n//- Description */\r\n$list-item-description-color: rgba(0, 0, 0, 0.7) !default;\r\n\r\n//- Link */\r\n$list-item-link-color: $link-color !default;\r\n$list-item-link-hover-color: $link-hover-color !default;\r\n\r\n//- Header Link */\r\n$list-item-header-link-color: $list-item-link-color !default;\r\n$list-item-header-link-hover-color: $list-item-link-hover-color !default;\r\n\r\n//- Linked Icon */\r\n$list-item-link-icon-color: $light-text-color !default;\r\n$list-item-link-icon-hover-color: $text-color !default;\r\n$list-inverted-icon-link-color: $inverted-light-text-color !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n$list-disabled-color: $disabled-text-color !default;\r\n$list-inverted-disabled-color: $inverted-disabled-text-color !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Float */\r\n$list-float-distance: 1em !default;\r\n$list-left-float-margin: 0 $list-float-distance 0 0 !default;\r\n$list-right-float-margin: 0 0 0 $list-float-distance !default;\r\n\r\n//- Horizontal */\r\n$list-horizontal-spacing: 1em !default;\r\n$list-horizontal-icon-distance: 0.25em !default;\r\n$list-horizontal-vertical-align: middle !default;\r\n\r\n//- Inverted */\r\n$list-inverted-icon-color: $inverted-light-text-color !default;\r\n$list-inverted-header-color: $inverted-text-color !default;\r\n$list-inverted-description-color: $inverted-light-text-color !default;\r\n$list-inverted-item-link-color: $inverted-text-color !default;\r\n$list-inverted-item-link-hover-color: $link-hover-color !default;\r\n$list-inverted-content-color: $inverted-light-text-color !default;\r\n\r\n//- Link List */\r\n$list-link-item-color: $unselected-text-color !default;\r\n$list-link-item-hover-color: $hovered-text-color !default;\r\n$list-link-item-down-color: $pressed-text-color !default;\r\n$list-link-item-active-color: $selected-text-color !default;\r\n$list-link-transition:\r\n  $default-duration color $default-easing\r\n !default;\r\n\r\n//- Inverted Link List */\r\n$list-inverted-link-item-color: $inverted-unselected-text-color !default;\r\n$list-inverted-link-item-hover-color: $inverted-hovered-text-color !default;\r\n$list-inverted-link-item-down-color: $inverted-pressed-text-color !default;\r\n$list-inverted-link-item-active-color: $inverted-selected-text-color !default;\r\n\r\n//- Selection List */\r\n$list-selection-item-margin: 0 !default;\r\n$list-selection-item-border-radius: 0.5em !default;\r\n$list-selection-item-vertical-padding: 0.5em !default;\r\n$list-selection-item-horizontal-padding: 0.5em !default;\r\n$list-selection-transition:\r\n  $default-duration color $default-easing,\r\n  $default-duration padding-left $default-easing,\r\n  $default-duration background-color $default-easing\r\n !default;\r\n\r\n//- Selection List States */\r\n$list-selection-background: transparent !default;\r\n$list-selection-color: $unselected-text-color !default;\r\n$list-selection-hover-background: $subtle-transparent-black !default;\r\n$list-selection-hover-color: $hovered-text-color !default;\r\n$list-selection-down-background: $transparent-black !default;\r\n$list-selection-down-color: $pressed-text-color !default;\r\n$list-selection-active-background: $transparent-black !default;\r\n$list-selection-active-color: $selected-text-color !default;\r\n\r\n//- Inverted Selection List */\r\n$list-inverted-selection-background: transparent !default;\r\n$list-inverted-selection-color: $inverted-unselected-text-color !default;\r\n$list-inverted-selection-hover-background: $subtle-transparent-white !default;\r\n$list-inverted-selection-hover-color: $inverted-hovered-text-color !default;\r\n$list-inverted-selection-down-background: $transparent-white !default;\r\n$list-inverted-selection-down-color: $inverted-pressed-text-color !default;\r\n$list-inverted-selection-active-background: $transparent-white !default;\r\n$list-inverted-selection-active-color: $inverted-selected-text-color !default;\r\n\r\n//- Animated List */\r\n$list-animated-duration: 0.25s !default;\r\n$list-animated-delay: 0.1s !default;\r\n$list-animated-transition:\r\n  $list-animated-duration color $default-easing $list-animated-delay,\r\n  $list-animated-duration padding-left $default-easing $list-animated-delay,\r\n  $list-animated-duration background-color $default-easing $list-animated-delay\r\n !default;\r\n$list-animated-indent: 1em !default;\r\n\r\n//- Bulleted */\r\n$list-bullet-distance: 1.25rem !default;\r\n$list-bullet-offset: -$list-bullet-distance !default;\r\n\r\n$list-bullet-opacity: 1 !default;\r\n$list-bullet-character: '•' !default;\r\n$list-bullet-color: inherit !default;\r\n$list-bullet-link-color: $text-color !default;\r\n$list-bullet-vertical-align: top !default;\r\n$list-bullet-child-distance: $list-bullet-distance !default;\r\n\r\n//- Horizontal Bullets */\r\n$list-horizontal-bullet-color: $text-color !default;\r\n$list-horizontal-bullet-spacing: strip-unit($list-bullet-distance) + 0.5em !default;\r\n\r\n//- Ordered List */\r\n$list-ordered-count-name: ordered !default;\r\n$list-ordered-count-separator: \".\" !default;\r\n$list-ordered-count-suffix: \".\" !default;\r\n$list-ordered-count-content: counters($list-ordered-count-name, $list-ordered-count-separator) \" \" !default;\r\n$list-ordered-count-content-suffixed: counters($list-ordered-count-name, $list-ordered-count-separator) $list-ordered-count-suffix !default;\r\n$list-ordered-count-color: $text-color !default;\r\n$list-ordered-count-distance: 1.25rem !default;\r\n$list-ordered-count-opacity: 0.8 !default;\r\n$list-ordered-count-text-align: right !default;\r\n$list-ordered-count-vertical-align: middle !default;\r\n\r\n$list-ordered-child-count-distance: 1em !default;\r\n$list-ordered-child-count-offset: -2em !default;\r\n\r\n$list-ordered-inverted-count-color: $inverted-light-text-color !default;\r\n\r\n//- Horizontal Ordered */\r\n$list-horizontal-ordered-count-distance: 0.5em !default;\r\n\r\n//- Divided */\r\n$list-divided-border-width: 1px !default;\r\n$list-divided-border: $list-divided-border-width solid $border-color !default;\r\n$list-divided-inverted-border-color: $white-border-color !default;\r\n$list-divided-child-border: none !default;\r\n$list-divided-child-item-border: none !default;\r\n\r\n//- Divided Horizontal */\r\n$list-horizontal-divided-spacing: ($list-horizontal-spacing / 2) !default;\r\n$list-horizontal-divided-line-height: 0.6 !default;\r\n\r\n//- Divided */\r\n$list-celled-border-width: 1px !default;\r\n$list-celled-border: $list-celled-border-width solid $border-color !default;\r\n$list-celled-inverted-border: $white-border-color !default;\r\n$list-celled-horizontal-padding: 0.5em !default;\r\n$list-celled-child-border: none !default;\r\n$list-celled-child-item-border: none !default;\r\n\r\n//- Divided Horizontal */\r\n$list-horizontal-celled-spacing: ($list-horizontal-spacing / 2) !default;\r\n$list-horizontal-celled-line-height: 0.6 !default;\r\n\r\n//- Relaxed */\r\n$list-relaxed-item-vertical-padding: $relative6px !default;\r\n$list-relaxed-child-item-vertical-padding: $relative3px !default;\r\n$list-relaxed-header-margin: 0.25rem !default;\r\n$list-relaxed-horizontal-padding: 1rem !default;\r\n\r\n//- Very Relaxed */\r\n$list-very-relaxed-item-vertical-padding: $relative12px !default;\r\n$list-very-relaxed-child-item-vertical-padding: $relative4px !default;\r\n$list-very-relaxed-header-margin: 0.5rem !default;\r\n$list-very-relaxed-horizontal-padding: 1.5rem !default;\r\n\r\n","\r\n//@-******************************  Loader *******************************/\r\n\r\n//- Some global loader styles defined in site.variables */\r\n// $loader-speed\r\n// $loader-line-width\r\n// $loader-fill-color\r\n// $loader-line-color\r\n// $inverted-loader-fill-color\r\n// $inverted-loader-line-color\r\n\r\n//-------------------- Standard --------------------*/\r\n\r\n$loader-top-offset: 50% !default;\r\n$loader-left-offset: 50% !default;\r\n\r\n$loader-shape-border-color: $loader-line-color !default;\r\n$loader-inverted-shape-border-color: $inverted-loader-line-color !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Text */\r\n$loader-text-distance: $relative-mini !default;\r\n$loader-text-color: $text-color !default;\r\n$loader-inverted-text-color: $inverted-text-color !default;\r\n\r\n\r\n//-------------------- States --------------------*/\r\n\r\n$loader-indeterminate-direction: reverse !default;\r\n$loader-indeterminate-speed: (2 * $loader-speed) !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n$loader-inline-vertical-align: middle !default;\r\n$loader-inline-margin: 0 !default;\r\n\r\n//- Exact Sizes (Avoids Rounding Errors) */\r\n$loader-mini    : $_14px !default;\r\n$loader-tiny    : $_16px !default;\r\n$loader-small   : $_24px !default;\r\n$loader-medium  : $_32px !default;\r\n$loader-large   : $_48px !default;\r\n$loader-big     : $_52px !default;\r\n$loader-huge    : $_58px !default;\r\n$loader-massive : $_64px !default;\r\n\r\n$loader-mini-offset: 0 0 0 (-$loader-mini / 2) !default;\r\n$loader-tiny-offset: 0 0 0 (-$loader-tiny / 2) !default;\r\n$loader-small-offset: 0 0 0 (-$loader-small / 2) !default;\r\n$loader-medium-offset: 0 0 0 (-$loader-medium / 2) !default;\r\n$loader-large-offset: 0 0 0 (-$loader-large / 2) !default;\r\n$loader-big-offset: 0 0 0 (-$loader-big / 2) !default;\r\n$loader-huge-offset: 0 0 0 (-$loader-huge / 2) !default;\r\n$loader-massive-offset: 0 0 0 (-$loader-massive / 2) !default;\r\n\r\n$loader-tiny-font-size: $relative-tiny !default;\r\n$loader-mini-font-size: $relative-mini !default;\r\n$loader-small-font-size: $relative-small !default;\r\n$loader-medium-font-size: $relative-medium !default;\r\n$loader-large-font-size: $relative-large !default;\r\n$loader-big-font-size: $relative-big !default;\r\n$loader-huge-font-size: $relative-huge !default;\r\n$loader-massive-font-size: $relative-massive !default;\r\n","$loader-speed-fast: 0.3s !default;\r\n$loader-speed: 0.6s !default;\r\n$loader-speed-slow: 0.9s !default;\r\n","\r\n$placeholder-max-width: 30rem !default;\r\n\r\n//- Variations */\r\n$placeholder-full-line-outdent: 0 !default;\r\n$placeholder-very-long-line-outdent: 10% !default;\r\n$placeholder-long-line-outdent: 35% !default;\r\n$placeholder-medium-line-outdent: 50% !default;\r\n$placeholder-short-line-outdent: 65% !default;\r\n$placeholder-very-short-line-outdent: 80% !default;\r\n\r\n//- Key Content Sizing */\r\n$placeholder-line-margin: $relative12px !default;\r\n$placeholder-header-line-height: $relative9px !default;\r\n$placeholder-line-height: $relative7px !default;\r\n$placeholder-paragraph-line-height: $placeholder-line-height !default;\r\n\r\n$placeholder-spacing: $relative20px !default;\r\n\r\n//- Interval between consecutive placeholders */\r\n$placeholder-animation-interval: 0.15s !default;\r\n\r\n//- Repeated Placeholder */\r\n$placeholder-consecutive-spacing: 2rem !default;\r\n\r\n//- Image */\r\n$placeholder-image-height: 100px !default;\r\n\r\n//- Header Image */\r\n$placeholder-image-width: 3em !default;\r\n$placeholder-image-text-indent: $_10px !default;\r\n\r\n//- Paragraph */\r\n$placeholder-header-line-one-outdent: 20% !default;\r\n$placeholder-header-line-two-outdent: 60% !default;\r\n\r\n$placeholder-line-one-outdent: $placeholder-full-line-outdent !default;\r\n$placeholder-line-two-outdent: $placeholder-medium-line-outdent !default;\r\n$placeholder-line-three-outdent: $placeholder-very-long-line-outdent !default;\r\n$placeholder-line-four-outdent: $placeholder-long-line-outdent !default;\r\n$placeholder-line-five-outdent: $placeholder-short-line-outdent !default;\r\n\r\n\r\n//- Glow Gradient */\r\n$placeholder-loading-animation-duration: 2s !default;\r\n$placeholder-loading-gradient-width: 1200px !default;\r\n$placeholder-loading-gradient: linear-gradient(to right,\r\n  rgba(0, 0, 0, 0.08) 0,\r\n  rgba(0, 0, 0, 0.15) 15%,\r\n  rgba(0, 0, 0, 0.08) 30%\r\n) !default;\r\n$placeholder-inverted-loading-gradient: linear-gradient(to right,\r\n  rgba(255, 255, 255, 0.08) 0,\r\n  rgba(255, 255, 255, 0.14) 15%,\r\n  rgba(255, 255, 255, 0.08) 30%\r\n) !default;\r\n","\r\n//@-****************************** Rail *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$rail-width: 300px !default;\r\n$rail-height: 100% !default;\r\n\r\n$rail-distance: 4rem !default;\r\n$rail-split-distance: ($rail-distance / 2) !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Close */\r\n$rail-close-distance: 2em !default;\r\n$rail-very-close-distance: 1em !default;\r\n\r\n$rail-split-close-distance: ($rail-close-distance / 2) !default;\r\n$rail-split-very-close-distance: ($rail-very-close-distance / 2) !default;\r\n\r\n$rail-close-width:  calc(#{$rail-width} + #{$rail-split-close-distance}) !default;\r\n$rail-very-close-width:  calc(#{$rail-width} + #{$rail-split-very-close-distance}) !default;\r\n\r\n//- Dividing */\r\n$rail-dividing-border: 1px solid $border-color !default;\r\n$rail-dividing-distance: 5rem !default;\r\n$rail-split-dividing-distance: ($rail-dividing-distance / 2) !default;\r\n$rail-dividing-width: strip-unit($rail-split-dividing-distance) + $rail-width !default;\r\n\r\n","\r\n//@-****************************** Reveal *******************************/\r\n\r\n$reveal-transition-delay: 0.1s !default;\r\n$reveal-transition-duration: 0.5s !default;\r\n$reveal-transition-easing: cubic-bezier(0.175, 0.885, 0.320, 1) !default;\r\n$reveal-transition: all $reveal-transition-duration $default-easing $reveal-transition-delay !default;\r\n\r\n$reveal-bottom-z-index: 2 !default;\r\n$reveal-top-z-index: 3 !default;\r\n$reveal-active-z-index: 4 !default;\r\n$reveal-overlay-z-index: 5 !default;\r\n\r\n//- Types */\r\n$reveal-rotate-degrees: 110deg !default;\r\n$reveal-move-transition: transform $reveal-transition-duration $reveal-transition-easing $reveal-transition-delay !default;\r\n$reveal-slide-transition: transform $reveal-transition-duration $default-easing $reveal-transition-delay !default;\r\n","//@import \"../colors/all\";\r\n//@import \"../border/all\";\r\n\r\n// Differentiating Neutrals */\r\n$subtle-gradient: linear-gradient(transparent, $transparent-black) !default;\r\n\r\n// Differentiating Layers */\r\n$subtle-shadow: 0 1px 2px 0 $border-color !default;\r\n\r\n$floating-shadow: 0 0px 0px 0 rgba(34, 36, 38, 0.12),\r\n  0 0px 4px 0 rgba(34, 36, 38, 0.15) !default;\r\n","\r\n//@-****************************** Segment *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$segment-background: $white !default;\r\n$segment-border-width: 1px !default;\r\n$segment-border: $segment-border-width solid $border-color !default;\r\n\r\n$segment-box-shadow: $subtle-shadow !default;\r\n$segment-vertical-padding: 1em !default;\r\n$segment-horizontal-padding: 1em !default;\r\n$segment-padding: $segment-vertical-padding $segment-horizontal-padding !default;\r\n\r\n$segment-vertical-margin: 1rem !default;\r\n$segment-horizontal-margin: 0 !default;\r\n$segment-margin: $segment-vertical-margin $segment-horizontal-margin !default;\r\n$segment-border-radius: $default-border-radius !default;\r\n\r\n//--------------------  Group --------------------*/\r\n\r\n$segment-grouped-super-margin: $segment-margin !default;\r\n$segment-grouped-super-border: $segment-border !default;\r\n$segment-grouped-super-box-shadow: $segment-box-shadow !default;\r\n$segment-grouped-border-radius: $segment-border-radius !default;\r\n\r\n$segment-nested-group-margin: $segment-vertical-margin $segment-vertical-margin !default;\r\n\r\n$segment-grouped-border: none !default;\r\n$segment-grouped-divider: $segment-border !default;\r\n$segment-grouped-margin: 0 !default;\r\n$segment-grouped-width: auto !default;\r\n$segment-grouped-box-shadow: none !default;\r\n\r\n//--------------------  Coupling --------------------*/\r\n\r\n//- Page Grid Segment */\r\n$segment-page-grid-margin: (2 * $segment-vertical-padding) !default;\r\n\r\n//-****************************** Types *******************************/\r\n\r\n//- Placeholder */\r\n$segment-placeholder-background: $off-white !default;\r\n$segment-placeholder-padding: $segment-padding !default;\r\n$segment-placeholder-border-color: $border-color !default;\r\n$segment-placeholder-box-shadow: 0 2px 25px 0 rgba(34, 36, 38, 0.05) inset !default;\r\n$segment-placeholder-min-height: 18rem !default;\r\n$segment-placeholder-content-max-width: 15rem !default;\r\n$segment-placeholder-content-inline-button-margin: 0 $_5px 0 0 !default;\r\n\r\n\r\n//- Piled */\r\n$segment-piled-z-index: auto !default;\r\n$segment-piled-margin: 3em !default;\r\n$segment-piled-box-shadow: '' !default;\r\n$segment-piled-degrees: 1.2deg !default;\r\n$segment-piled-border: $segment-border !default;\r\n\r\n//- Circular */\r\n$segment-circular-padding: 2em !default;\r\n\r\n//- Stacked */\r\n$segment-stacked-height: 6px !default;\r\n$segment-stacked-page-background: $subtle-transparent-black !default;\r\n$segment-stacked-padding: $segment-vertical-padding + (0.4em) !default;\r\n$segment-tall-stacked-padding: $segment-vertical-padding + (0.8em) !default;\r\n\r\n//-****************************** States *******************************/\r\n\r\n//- Loading Dimmer */\r\n$segment-loader-dimmer-color: rgba(255, 255, 255, 0.8) !default;\r\n$segment-loader-inverted-dimmer-color: rgba(0, 0, 0 , 0.85) !default;\r\n$segment-loader-dimmer-z-index: 100 !default;\r\n\r\n//- Loading Spinner */\r\n$segment-loader-size: 3em !default;\r\n$segment-loader-line-z-index: 101 !default;\r\n\r\n\r\n//-****************************** Variations *******************************/\r\n\r\n\r\n//- Raised */\r\n$segment-raised-box-shadow: $floating-shadow !default;\r\n\r\n//- Padded */\r\n$segment-padded-padding: 1.5em !default;\r\n$segment-very-padded-padding: 3em !default;\r\n\r\n//- Attached */\r\n$segment-attached-top-offset: 0 !default;\r\n$segment-attached-bottom-offset: 0 !default;\r\n$segment-attached-horizontal-offset: -$segment-border-width !default;\r\n$segment-attached-width: calc(100% + #{-$segment-attached-horizontal-offset * 2}) !default;\r\n$segment-attached-box-shadow: none !default;\r\n$segment-attached-border: $segment-border-width solid $solid-border-color !default;\r\n$segment-attached-bottom-box-shadow:\r\n  $segment-box-shadow,\r\n  $segment-attached-box-shadow\r\n !default;\r\n\r\n//- Inverted */\r\n$segment-inverted-background: $black !default;\r\n\r\n//- Floated */\r\n$segment-floated-distance: 1em !default;\r\n\r\n//- Basic */\r\n$segment-basic-background: none transparent !default;\r\n$segment-basic-border: none !default;\r\n$segment-basic-box-shadow: none !default;\r\n$segment-basic-border-radius: 0 !default;\r\n\r\n//- Colors */\r\n$segment-colored-border-size: 2px !default;\r\n\r\n//- Ordinality */\r\n$segment-secondary-background: $dark-white !default;\r\n$segment-secondary-color: $muted-text-color !default;\r\n\r\n$segment-tertiary-background:  $mid-white !default;\r\n$segment-tertiary-color: $muted-text-color !default;\r\n\r\n$segment-secondary-inverted-lightness: 0.2 !default;\r\n$segment-secondary-inverted-background:\r\n  lighten($black, ($segment-secondary-inverted-lightness * 100))\r\n  linear-gradient(\r\n    rgba(255, 255, 255, $segment-secondary-inverted-lightness) 0,\r\n    rgba(255, 255, 255, $segment-secondary-inverted-lightness) 100%\r\n  )\r\n !default;\r\n$segment-secondary-inverted-color: $inverted-muted-text-color !default;\r\n\r\n$segment-tertiary-inverted-lightness: 0.35 !default;\r\n$segment-tertiary-inverted-background:\r\n  lighten($black, ($segment-tertiary-inverted-lightness * 100))\r\n  linear-gradient(\r\n    rgba(255, 255, 255, $segment-tertiary-inverted-lightness) 0,\r\n    rgba(255, 255, 255, $segment-tertiary-inverted-lightness) 100%\r\n  )\r\n !default;\r\n$segment-tertiary-inverted-color: $inverted-muted-text-color !default;\r\n","\r\n//@-******************************  Step *******************************/\r\n\r\n//--------------------  Group --------------------*/\r\n\r\n$step-margin: 1em 0 !default;\r\n$step-steps-border-radius: $default-border-radius !default;\r\n$step-steps-background: '' !default;\r\n$step-steps-box-shadow: none !default;\r\n$step-steps-border: 1px solid $border-color !default;\r\n\r\n//-------------------- Element --------------------*/\r\n\r\n$step-vertical-margin: 0 !default;\r\n$step-horizontal-margin: 0 !default;\r\n\r\n$step-arrow-size: $relative-large !default;\r\n$step-vertical-padding: $relative-large !default;\r\n$step-horizontal-padding: 2em !default;\r\n\r\n$step-transition:\r\n  background-color $default-duration $default-easing,\r\n  opacity $default-duration $default-easing,\r\n  color $default-duration $default-easing,\r\n  box-shadow $default-duration $default-easing\r\n !default;\r\n$step-line-height: $relative-large !default;\r\n$step-align-items: center !default;\r\n$step-justify-content: center !default;\r\n$step-background-color: $white !default;\r\n$step-background: $step-background-color !default;\r\n$step-border-radius: 0 !default;\r\n$step-border-width: 1px !default;\r\n$step-box-shadow: none !default;\r\n$step-border: none !default;\r\n$step-divider: $step-border-width solid $border-color !default;\r\n\r\n//- Icon */\r\n$step-icon-distance: 1rem !default;\r\n$step-icon-size: 2.5em !default;\r\n$step-icon-align: middle !default;\r\n\r\n//- Title */\r\n$step-title-font-family: $header-font !default;\r\n$step-title-font-weight: $bold !default;\r\n$step-title-font-size: $relative-large !default;\r\n$step-title-color: $dark-text-color !default;\r\n\r\n//- Description */\r\n$step-description-distance: 0.25em !default;\r\n$step-description-font-size: $relative-small !default;\r\n$step-description-font-weight: $normal !default;\r\n$step-description-color: $text-color !default;\r\n\r\n\r\n//- Arrow */\r\n$step-arrow-background-color: $step-background-color !default;\r\n$step-arrow-top-offset: 50% !default;\r\n$step-arrow-right-offset: 0 !default;\r\n$step-arrow-border-width: 0 $step-border-width $step-border-width 0 !default;\r\n\r\n$step-arrow-display: block !default;\r\n$step-last-arrow-display: none !default;\r\n\r\n$step-active-arrow-display: block !default;\r\n$step-active-last-arrow-display: none !default;\r\n\r\n//- Mobile */\r\n$step-mobile-icon-distance: $step-icon-distance !default;\r\n\r\n//--------------------  Types --------------------*/\r\n\r\n//- Vertical */\r\n$step-vertical-divider: $step-divider !default;\r\n$step-vertical-arrow-top-offset: 50% !default;\r\n$step-vertical-arrow-right-offset: 0 !default;\r\n$step-vertical-arrow-border-width: 0 $step-border-width $step-border-width 0 !default;\r\n\r\n$step-vertical-arrow-display: none !default;\r\n$step-vertical-last-arrow-display: $step-vertical-arrow-display !default;\r\n\r\n$step-vertical-active-arrow-display: block !default;\r\n$step-vertical-active-last-arrow-display: block !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n$step-attached-horizontal-offset: -$step-border-width !default;\r\n$step-attached-vertical-offset: 0 !default;\r\n$step-attached-width: calc(100% + #{-$step-attached-horizontal-offset * 2}) !default;\r\n\r\n$step-ordered-font-family: inherit !default;\r\n$step-ordered-font-weight: $bold !default;\r\n\r\n//--------------------  States --------------------*/\r\n\r\n//- Completed */\r\n$step-completed-color: $positive-color !default;\r\n\r\n//- Hover */\r\n$step-hover-background: $off-white !default;\r\n$step-hover-color: $hovered-text-color !default;\r\n\r\n//- Down */\r\n$step-down-background: $dark-white !default;\r\n$step-down-color: $pressed-text-color !default;\r\n\r\n//- Active */\r\n$step-active-background: $dark-white !default;\r\n$step-active-color: $link-color !default;\r\n$step-active-icon-color: $dark-text-color !default;\r\n\r\n//- Active + Hover */\r\n$step-active-hover-background: $light-grey !default;\r\n$step-active-hover-color: $text-color !default;\r\n\r\n\r\n//- Disabled */\r\n$step-disabled-background: $step-background !default;\r\n$step-disabled-color: $disabled-text-color !default;\r\n\r\n//- Inverted */\r\n$step-inverted-active-background: #333333 !default;\r\n$step-inverted-active-hover-background: #444444 !default;\r\n$step-inverted-hover-background: #3F3F3F !default;\r\n$step-inverted-disabled-background: #222222 !default;\r\n","$light-red: #ff695e !default;\r\n$light-orange: #ff851b !default;\r\n$light-yellow: #ffe21f !default;\r\n$light-olive: #d9e778 !default;\r\n$light-green: #2ecc40 !default;\r\n$light-teal: #6dffff !default;\r\n$light-blue: #54c8ff !default;\r\n$light-violet: #a291fb !default;\r\n$light-purple: #dc73ff !default;\r\n$light-pink: #ff8edf !default;\r\n$light-brown: #d67c1c !default;\r\n$light-grey: #dcddde !default;\r\n$light-black: #545454 !default;\r\n","@if $use-step {\n  @font-face {\n    font-family: 'Step';\n    src:\n      url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype'),\n      url(data:application/font-woff;charset=utf-8;base64,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) format('woff')\n    ;\n  }\n  .ui.steps .step.completed > .icon:before,\n  .ui.ordered.steps .step.completed:before {\n    font-family: 'Step';\n    content: '\\e800'; /* '' */\n  }\n}","\r\n//@-****************************** Text *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n$text-mini: 0.4em !default;\r\n$text-tiny: 0.5em !default;\r\n$text-small: 0.75em !default;\r\n$text-medium: 1em !default;\r\n$text-large: 1.5em !default;\r\n$text-big: 2em !default;\r\n$text-huge: 4em !default;\r\n$text-massive: 8em !default;\r\n\r\n","\r\n//@-****************************** Breadcrumb *******************************/\r\n\r\n//--------------------  Breadcrumb --------------------*/\r\n\r\n$breadcrumb-vertical-margin: 0 !default;\r\n$breadcrumb-display: inline-block !default;\r\n$breadcrumb-vertical-align: middle !default;\r\n\r\n$breadcrumb-divider-spacing: $_3px !default;\r\n$breadcrumb-divider-opacity: 0.7 !default;\r\n$breadcrumb-divider-color: $light-text-color !default;\r\n\r\n$breadcrumb-divider-size: $relative-small !default;\r\n$breadcrumb-divider-vertical-align: baseline !default;\r\n\r\n$breadcrumb-icon-divider-size: $relative-tiny !default;\r\n$breadcrumb-icon-divider-vertical-align: baseline !default;\r\n\r\n$breadcrumb-section-margin: 0 !default;\r\n$breadcrumb-section-padding: 0 !default;\r\n\r\n//- Coupling */\r\n$breadcrumb-segment-padding: $relative-mini $relative-medium !default;\r\n\r\n//- Inverted */\r\n$breadcrumb-inverted-color: $mid-white !default;\r\n$breadcrumb-inverted-active-color: $white !default;\r\n$breadcrumb-inverted-divider-color: $inverted-light-text-color !default;\r\n\r\n//--------------------  States --------------------*/\r\n\r\n$breadcrumb-active-font-weight: $bold !default;\r\n","\r\n//@-******************************  Form *******************************/\r\n\r\n//--------------------  Elements --------------------*/\r\n\r\n//- Form */\r\n$form-gutter-width: 1em !default;\r\n$form-row-distance: 1em !default;\r\n\r\n//- Text */\r\n$form-paragraph-margin: $form-row-distance 0 !default;\r\n\r\n//- Field */\r\n$form-field-margin: 0 0 $form-row-distance !default;\r\n\r\n//- Fields */\r\n$form-fields-margin: 0 (-$form-gutter-width / 2) $form-row-distance !default;\r\n\r\n//- Form Label */\r\n$form-label-distance: $_4px !default;\r\n$form-label-margin: 0 0 $form-label-distance 0 !default;\r\n$form-label-font-size: $relative-small !default;\r\n$form-label-font-weight: $bold !default;\r\n$form-label-text-transform: none !default;\r\n$form-label-color: $text-color !default;\r\n\r\n//- Input */\r\n$form-input-font: $page-font !default;\r\n$form-input-width: 100% !default;\r\n$form-input-font-size: 1em !default;\r\n$form-input-padding: ($input-vertical-padding + ((1em - $input-line-height) / 2)) $input-horizontal-padding !default;\r\n$form-input-border: 1px solid $border-color !default;\r\n$form-input-border-radius: $absolute-border-radius !default;\r\n$form-input-color: $text-color !default;\r\n$form-input-transition:\r\n  color $default-duration $default-easing,\r\n  border-color $default-duration $default-easing\r\n !default;\r\n$form-input-box-shadow: 0 0 0 0 transparent inset !default;\r\n\r\n//- Select */\r\n$form-select-background: $white !default;\r\n$form-select-border-radius: $form-input-border-radius !default;\r\n$form-select-border: $form-input-border !default;\r\n$form-select-padding: 0.62em $input-horizontal-padding !default;\r\n$form-select-box-shadow: $form-input-box-shadow !default;\r\n$form-select-transition: $form-input-transition !default;\r\n$form-select-color: $form-input-color !default;\r\n\r\n//- Text Area */\r\n$form-text-area-padding: $input-vertical-padding $input-horizontal-padding !default;\r\n$form-text-area-height: 12em !default;\r\n$form-text-area-resize: vertical !default;\r\n$form-text-area-line-height: 1.2857 !default;\r\n$form-text-area-min-height: 8em !default;\r\n$form-text-area-max-height: 24em !default;\r\n$form-text-area-background: $input-background !default;\r\n$form-text-area-border: $form-input-border !default;\r\n$form-text-area-font-size: $form-input-font-size !default;\r\n$form-text-area-transition: $form-input-transition !default;\r\n\r\n//- Checkbox */\r\n$form-checkbox-vertical-align: top !default;\r\n$form-checkbox-label-font-size: 1em !default;\r\n$form-checkbox-label-text-transform: $form-label-text-transform !default;\r\n$form-checkbox-label-field-top-margin: 0.7em !default;\r\n$form-checkbox-field-top-margin: 1.2em !default;\r\n$form-checkbox-toggle-field-top-margin: 1em !default;\r\n$form-checkbox-slider-field-top-margin: 1.4em !default;\r\n\r\n//- Errored Input */\r\n$form-error-color: $negative-text-color !default;\r\n$form-error-border: $negative-border-color !default;\r\n$form-error-background: $negative-background-color !default;\r\n\r\n//- Inline Validation Prompt */\r\n$form-prompt-background: $white !default;\r\n$form-prompt-border-color: $form-error-border !default;\r\n$form-prompt-border: 1px solid $form-prompt-border-color !default;\r\n$form-prompt-text-color: $form-error-color !default;\r\n$form-inline-prompt-margin: -0.25em 0 -0.5em 0.5em !default;\r\n$form-inline-prompt-border-width: 1px !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n//- Focus */\r\n$form-input-focus-pointer-size: 0 !default;\r\n\r\n//- Input Focus */\r\n$form-input-focus-background: $input-background !default;\r\n$form-input-focus-border-color: $focused-form-border-color !default;\r\n$form-input-focus-color: $selected-text-color !default;\r\n$form-input-focus-box-shadow: $form-input-focus-pointer-size 0 0 0 $selected-border-color inset !default;\r\n$form-input-focus-border-radius: $form-input-border-radius !default;\r\n\r\n//- Text Area Focus */\r\n$form-text-area-focus-background: $form-input-focus-background !default;\r\n$form-text-area-focus-border-color: $form-input-focus-border-color !default;\r\n$form-text-area-focus-color: $form-input-focus-color !default;\r\n$form-text-area-focus-box-shadow: $form-input-focus-box-shadow !default;\r\n$form-text-area-focus-border-radius: $form-input-focus-border-radius !default;\r\n\r\n//- Disabled */\r\n$form-disabled-label-opacity: $disabled-opacity !default;\r\n\r\n//- Errored Input */\r\n$form-transparent-error-color: $form-error-color !default;\r\n$form-transparent-error-background: $form-error-background !default;\r\n$form-transparent-padding: $form-input-padding !default;\r\n\r\n//- AutoFill */\r\n$form-input-auto-fill-background: #FFFFF0 !default;\r\n$form-input-auto-fill-border: #E5DFA1 !default;\r\n$form-input-auto-fill-focus-background: $form-input-auto-fill-background !default;\r\n$form-input-auto-fill-focus-border: #D5C315 !default;\r\n$form-input-auto-fill-error-background: #FFFAF0 !default;\r\n$form-input-auto-fill-error-border: #E0B4B4 !default;\r\n\r\n\r\n//- Input Error */\r\n$form-input-error-border-radius: '' !default;\r\n$form-input-error-box-shadow: none !default;\r\n\r\n//- Dropdown Error */\r\n$form-dropdown-error-hover-background: #FBE7E7 !default;\r\n$form-dropdown-error-selected-background: $form-dropdown-error-hover-background !default;\r\n$form-dropdown-error-active-background: #FDCFCF !default;\r\n$form-dropdown-error-label-background: #EACBCB !default;\r\n$form-dropdown-error-label-color: $error-text-color !default;\r\n\r\n//- Focused Error */\r\n$form-input-error-focus-background: $negative-background-color !default;\r\n$form-input-error-focus-color: $negative-text-color !default;\r\n$form-input-error-focus-border: $negative-border-color !default;\r\n$form-input-error-focus-box-shadow: none !default;\r\n\r\n//- Placeholder Error */\r\n$form-input-error-placeholder-color: lighten($form-error-color, 40) !default;\r\n$form-input-error-placeholder-focus-color: lighten($form-error-color, 30) !default;\r\n\r\n//- Loading Dimmer */\r\n$form-loader-dimmer-color: rgba(255, 255, 255, 0.8) !default;\r\n$form-loader-inverted-dimmer-color: rgba(0, 0, 0 , 0.85) !default;\r\n$form-loader-dimmer-z-index: 100 !default;\r\n\r\n//- Loading Spinner */\r\n$form-loader-size: 3em !default;\r\n$form-loader-line-z-index: 101 !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Required */\r\n$form-required-content: '*' !default;\r\n$form-required-color: $negative-color !default;\r\n$form-required-vertical-offset: -0.2em !default;\r\n$form-required-distance: 0.2em !default;\r\n$form-required-margin: $form-required-vertical-offset 0 0 $form-required-distance !default;\r\n\r\n//- Inverted */\r\n$form-inverted-input-background: $input-background !default;\r\n$form-inverted-input-border-color: $white-border-color !default;\r\n$form-inverted-input-box-shadow: $form-input-box-shadow !default;\r\n$form-inverted-input-color: $form-input-color !default;\r\n$form-inverted-label-color: $inverted-text-color !default;\r\n$form-inverted-input-box-shadow: none !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Grouped Fields */\r\n$form-grouped-margin: $form-field-margin !default;\r\n$form-grouped-field-margin: 0.5em 0 !default;\r\n\r\n$form-grouped-label-distance: $form-label-distance !default;\r\n$form-grouped-label-color: $form-label-color !default;\r\n$form-grouped-label-margin: $form-label-margin !default;\r\n$form-grouped-label-font-size: $form-label-font-size !default;\r\n$form-grouped-label-font-weight: $form-label-font-weight !default;\r\n$form-grouped-label-text-transform: $form-label-text-transform !default;\r\n\r\n\r\n//- Inline */\r\n$form-inline-input-size: $relative-medium !default;\r\n\r\n$form-inline-label-distance: $relative-tiny !default;\r\n$form-inline-label-color: $form-label-color !default;\r\n$form-inline-label-font-size: $form-label-font-size !default;\r\n$form-inline-label-font-weight: $form-label-font-weight !default;\r\n$form-inline-label-text-transform: $form-label-text-transform !default;\r\n\r\n$form-grouped-inline-label-margin: 0.035714em 1em 0 0 !default;\r\n\r\n//--------------------  Groups --------------------*/\r\n\r\n$form-inline-fields-margin: 0 1em 0 0 !default;\r\n","$column-count: 16 !default;\r\n\r\n$one-wide: (1 / $column-count * 100%) !default;\r\n$two-wide: (2 / $column-count * 100%) !default;\r\n$three-wide: (3 / $column-count * 100%) !default;\r\n$four-wide: (4 / $column-count * 100%) !default;\r\n$five-wide: (5 / $column-count * 100%) !default;\r\n$six-wide: (6 / $column-count * 100%) !default;\r\n$seven-wide: (7 / $column-count * 100%) !default;\r\n$eight-wide: (8 / $column-count * 100%) !default;\r\n$nine-wide: (9 / $column-count * 100%) !default;\r\n$ten-wide: (10 / $column-count * 100%) !default;\r\n$eleven-wide: (11 / $column-count * 100%) !default;\r\n$twelve-wide: (12 / $column-count * 100%) !default;\r\n$thirteen-wide: (13 / $column-count * 100%) !default;\r\n$fourteen-wide: (14 / $column-count * 100%) !default;\r\n$fifteen-wide: (15 / $column-count * 100%) !default;\r\n$sixteen-wide: (16 / $column-count * 100%) !default;\r\n\r\n$one-column: (1 / 1 * 100%) !default;\r\n$two-column: (1 / 2 * 100%) !default;\r\n$three-column: (1 / 3 * 100%) !default;\r\n$four-column: (1 / 4 * 100%) !default;\r\n$five-column: (1 / 5 * 100%) !default;\r\n$six-column: (1 / 6 * 100%) !default;\r\n$seven-column: (1 / 7 * 100%) !default;\r\n$eight-column: (1 / 8 * 100%) !default;\r\n$nine-column: (1 / 9 * 100%) !default;\r\n$ten-column: (1 / 10 * 100%) !default;\r\n$eleven-column: (1 / 11 * 100%) !default;\r\n$twelve-column: (1 / 12 * 100%) !default;\r\n$thirteen-column: (1 / 13 * 100%) !default;\r\n$fourteen-column: (1 / 14 * 100%) !default;\r\n$fifteen-column: (1 / 15 * 100%) !default;\r\n$sixteen-column: (1 / 16 * 100%) !default;\r\n","\r\n//@-******************************  Grid *******************************/\r\n\r\n//- Inherited From Site */\r\n\r\n// $mobile-breakpoint\r\n// $tablet-breakpoint\r\n// $computer-breakpoint\r\n// $large-monitor-breakpoint\r\n// $widescreen-monitor-breakpoint\r\n\r\n//-****************************** Grid *******************************/\r\n\r\n$grid-min-width: 320px !default;\r\n\r\n$grid-gutter-width: 2rem !default;\r\n$grid-row-spacing: 2rem !default;\r\n\r\n$grid-table-width: calc(100% + #{$grid-gutter-width}) !default;\r\n$grid-column-max-image-width: 100% !default;\r\n\r\n$grid-consecutive-distance: ($grid-row-spacing / 2) !default;\r\n\r\n//-******************************  Variations *******************************/\r\n\r\n//---------------  Relaxed ---------------*/\r\n\r\n$grid-relaxed-gutter-width: 3rem !default;\r\n$grid-very-relaxed-gutter-width: 5rem !default;\r\n\r\n//---------------  Divided ---------------*/\r\n\r\n$grid-divided-border: -1px 0 0 0 $border-color !default;\r\n$grid-vertically-divided-border: 0 -1px 0 0 $border-color !default;\r\n\r\n$grid-divided-inverted-border: -1px 0 0 0 $white-border-color !default;\r\n$grid-vertically-divided-inverted-border: 0 -1px 0 0 $white-border-color !default;\r\n\r\n//--------------- Celled ---------------*/\r\n\r\n$grid-celled-margin: 1em 0 !default;\r\n$grid-celled-width: 1px !default;\r\n$grid-celled-border-color: $solid-border-color !default;\r\n\r\n$grid-celled-padding: 1em !default;\r\n$grid-celled-relaxed-padding: 1.5em !default;\r\n$grid-celled-very-relaxed-padding: 2em !default;\r\n\r\n$grid-celled-divider: 0 0 0 $grid-celled-width $grid-celled-border-color !default;\r\n$grid-celled-row-divider: 0 (-$grid-celled-width) 0 0 $grid-celled-border-color !default;\r\n$grid-celled-column-divider: (-$grid-celled-width) 0 0 0 $grid-celled-border-color !default;\r\n\r\n\r\n//--------------- Stackable ---------------*/\r\n\r\n$grid-stackable-row-spacing: $grid-row-spacing !default;\r\n$grid-stackable-gutter: $grid-gutter-width !default;\r\n$grid-stackable-mobile-border: 1px solid $border-color !default;\r\n$grid-stackable-inverted-mobile-border: 1px solid $white-border-color !default;\r\n\r\n//--------------- Compact ---------------*/\r\n$grid-compact-gutter-width: $grid-gutter-width / 2 !default;\r\n$grid-compact-row-spacing: $grid-row-spacing / 2 !default;\r\n$grid-compact-celled-relaxed-padding: $grid-celled-relaxed-padding / 2 !default;\r\n$grid-compact-celled-very-relaxed-padding: $grid-celled-very-relaxed-padding / 2 !default;\r\n\r\n//------------------- Very Compact ------------------*/\r\n$grid-very-compact-gutter-width: $grid-compact-gutter-width / 2 !default;\r\n$grid-very-compact-row-spacing: $grid-compact-row-spacing / 2 !default;\r\n$grid-very-compact-celled-relaxed-padding: $grid-compact-celled-relaxed-padding / 2 !default;\r\n$grid-very-compact-celled-very-relaxed-padding: $grid-compact-celled-very-relaxed-padding / 2 !default;\r\n\r\n\r\n//-******************************  Legacy *******************************/\r\n\r\n//---------------  Page ---------------*/\r\n\r\n//- Legacy (DO NOT USE)  */\r\n$grid-mobile-width: auto !default;\r\n$grid-mobile-margin: 0 !default;\r\n$grid-mobile-gutter: 0 !default;\r\n\r\n$grid-tablet-width: auto !default;\r\n$grid-tablet-margin: 0 !default;\r\n$grid-tablet-gutter: 2em !default;\r\n\r\n$grid-computer-width: auto !default;\r\n$grid-computer-margin: 0 !default;\r\n$grid-computer-gutter: 3% !default;\r\n\r\n$grid-large-monitor-width: auto !default;\r\n$grid-large-monitor-margin: 0 !default;\r\n$grid-large-monitor-gutter: 15% !default;\r\n\r\n$grid-widescreen-monitor-width: auto !default;\r\n$grid-widescreen-margin: 0 !default;\r\n$grid-widescreen-monitor-gutter: 23% !default;\r\n","\r\n//@-******************************  Menu *******************************/\r\n\r\n//-------------------- Collection --------------------*/\r\n\r\n//- Menu Item */\r\n$menu-item-vertical-padding: $relative-small !default;\r\n$menu-item-horizontal-padding: $relative-large !default;\r\n$menu-item-text-transform: none !default;\r\n$menu-item-transition:\r\n  background $default-duration $default-easing,\r\n  box-shadow $default-duration $default-easing,\r\n  color $default-duration $default-easing\r\n !default;\r\n$menu-item-font-weight: $normal !default;\r\n$menu-item-text-color: $text-color !default;\r\n\r\n//- Menu */\r\n$menu-vertical-margin: $medium !default;\r\n$menu-horizontal-margin: 0 !default;\r\n$menu-margin: $menu-vertical-margin $menu-horizontal-margin !default;\r\n$menu-background: #FFFFFF !default;\r\n$menu-font-family: $page-font !default;\r\n$menu-item-background: none !default;\r\n$menu-font-weight: $normal !default;\r\n$menu-border-width: 1px !default;\r\n$menu-border: $menu-border-width solid $border-color !default;\r\n$menu-box-shadow: $subtle-shadow !default;\r\n$menu-border-radius: $default-border-radius !default;\r\n$menu-min-height: ($menu-item-vertical-padding * 2) + 1em !default;\r\n\r\n//- Divider */\r\n$menu-divider-size: 1px !default;\r\n$menu-divider-background: $internal-border-color !default;\r\n\r\n//- Sub Menu */\r\n$menu-sub-distance: 0.5em !default;\r\n$menu-sub-margin: $menu-sub-distance (-$menu-item-horizontal-padding) 0 !default;\r\n$menu-sub-font-size: $relative-tiny !default;\r\n$menu-sub-text-color: rgba(0, 0, 0, 0.5) !default;\r\n\r\n$menu-sub-indent: 0 !default;\r\n$menu-sub-horizontal-padding: ($menu-item-horizontal-padding / $tiny-size) + $menu-sub-indent !default;\r\n$menu-sub-vertical-padding: 0.5em !default;\r\n\r\n//- Text Item */\r\n$menu-text-line-height: 1.3 !default;\r\n\r\n//--------------- Elements ---------------*/\r\n\r\n//- Icon */\r\n$menu-icon-float: none !default;\r\n$menu-icon-margin: 0 $relative5px 0 0 !default;\r\n$menu-icon-opacity: 0.9 !default;\r\n\r\n//- Dropdown Icon */\r\n$menu-dropdown-icon-float: right !default;\r\n$menu-dropdown-icon-distance: 1em !default;\r\n\r\n//- Header */\r\n$menu-header-background: '' !default;\r\n$menu-header-weight: $bold !default;\r\n$menu-header-text-transform: $normal !default;\r\n\r\n//- Vertical Icon */\r\n$menu-vertical-icon-float: right !default;\r\n$menu-vertical-icon-margin: 0 0 0 0.5em !default;\r\n\r\n//- Vertical Header */\r\n$menu-vertical-header-margin: 0 0 0.5em !default;\r\n$menu-vertical-header-font-size: $relative-medium !default;\r\n$menu-vertical-header-font-weight: $bold !default;\r\n\r\n//- Pointing Arrow */\r\n$menu-arrow-size: $relative8px !default;\r\n$menu-arrow-border-width: 1px !default;\r\n$menu-arrow-border: $menu-arrow-border-width solid $solid-border-color !default;\r\n$menu-arrow-transition: background $default-duration $default-easing !default;\r\n$menu-arrow-z-index: 2 !default;\r\n\r\n$menu-arrow-hover-color: #F2F2F2 !default;\r\n$menu-arrow-active-color: $menu-arrow-hover-color !default;\r\n$menu-arrow-active-hover-color: $menu-arrow-active-color !default;\r\n\r\n$menu-arrow-vertical-hover-color: $menu-arrow-hover-color !default;\r\n$menu-arrow-vertical-active-color: $menu-arrow-active-color !default;\r\n$menu-arrow-vertical-sub-color: $white !default;\r\n\r\n//--------------- Couplings ---------------*/\r\n\r\n//- Button */\r\n$menu-button-size: $relative-medium !default;\r\n$menu-button-offset: 0 !default;\r\n$menu-button-margin: -0.5em 0 !default;\r\n$menu-button-vertical-padding: $relative-mini !default;\r\n\r\n//- Input */\r\n$menu-input-size: $relative-medium !default;\r\n$menu-input-vertical-margin: -0.5em !default;\r\n$menu-input-offset: 0 !default;\r\n$menu-input-vertical-padding: $relative8px !default;\r\n\r\n//- Image */\r\n$menu-image-margin: -0.3em 0 !default;\r\n$menu-image-width: 2.5em !default;\r\n$menu-vertical-image-width: auto !default;\r\n\r\n//- Label */\r\n$menu-label-offset: -0.15em !default;\r\n$menu-label-background: #999999 !default;\r\n$menu-label-text-color: $white !default;\r\n\r\n$menu-label-text-margin: 1em !default;\r\n$menu-label-vertical-padding: 0.3em !default;\r\n$menu-circular-label-vertical-padding: 0.5em !default; //- has to be equal to @circularPadding from label.less */\r\n$menu-label-horizontal-padding: $relative-mini !default;\r\n\r\n$menu-label-and-icon-float: none !default;\r\n$menu-label-and-icon-margin: 0 0.5em 0 0 !default;\r\n\r\n//- Image Label */\r\n$menu-image-label-text-distance: 0.8em !default;\r\n$menu-image-label-vertical-padding: 0.2833em !default; //- Calculates as: @verticalLabel (from label.less) - $menu-label-vertical-padding (from here) */\r\n$menu-image-label-height: (1em + $menu-image-label-vertical-padding * 2) !default;  //- Logic adopted from label.less */\r\n$menu-image-label-image-margin: (-$menu-image-label-vertical-padding) $menu-image-label-text-distance (-$menu-image-label-vertical-padding) (-$menu-image-label-text-distance) !default;\r\n\r\n//- Dropdown in Menu */\r\n$menu-dropdown-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08) !default;\r\n\r\n$menu-dropdown-background: #FFFFFF !default;\r\n$menu-dropdown-distance: 0 !default;\r\n$menu-dropdown-border-radius: $menu-border-radius !default;\r\n\r\n$menu-dropdown-item-font-size: $relative-medium !default;\r\n$menu-dropdown-item-padding: $relative-mini $relative-large !default;\r\n$menu-dropdown-item-background: transparent !default;\r\n$menu-dropdown-item-color: $text-color !default;\r\n$menu-dropdown-item-text-transform: none !default;\r\n$menu-dropdown-item-font-weight: $normal !default;\r\n$menu-dropdown-item-box-shadow: none !default;\r\n$menu-dropdown-item-transition: none !default;\r\n\r\n$menu-dropdown-item-icon-float: none !default;\r\n$menu-dropdown-item-icon-font-size: $relative-medium !default;\r\n$menu-dropdown-item-icon-margin: 0 0.75em 0 0 !default;\r\n\r\n$menu-dropdown-hovered-item-background: $transparent-black !default;\r\n$menu-dropdown-hovered-item-color: $selected-text-color !default;\r\n\r\n//- Dropdown Variations */\r\n$menu-dropdown-vertical-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08) !default;\r\n$menu-secondary-dropdown-distance: $relative5px !default;\r\n$menu-pointing-dropdown-distance: 0.75em !default;\r\n$menu-inverted-selection-dropdown-color: $inverted-text-color !default;\r\n\r\n//---------------  States ---------------*/\r\n\r\n//- Hovered Item */\r\n$menu-hover-item-background: $subtle-transparent-black !default;\r\n$menu-hover-item-text-color: $selected-text-color !default;\r\n\r\n//- Pressed Item */\r\n$menu-pressed-item-background: $subtle-transparent-black !default;\r\n$menu-pressed-item-text-color: $menu-hover-item-text-color !default;\r\n\r\n\r\n//- Active Item */\r\n$menu-active-item-background: $transparent-black !default;\r\n$menu-active-item-text-color: $selected-text-color !default;\r\n$menu-active-item-font-weight: $normal !default;\r\n$menu-active-icon-opacity: 1 !default;\r\n$menu-active-item-box-shadow: none !default;\r\n\r\n//- Active Hovered Item */\r\n$menu-active-hover-item-background: $transparent-black !default;\r\n$menu-active-hover-item-color: $selected-text-color !default;\r\n\r\n//- Selected Dropdown */\r\n$menu-dropdown-selected-item-background: $transparent-black !default;\r\n$menu-dropdown-selected-item-color: $selected-text-color !default;\r\n\r\n//- Active Dropdown */\r\n$menu-dropdown-active-item-background: $subtle-transparent-black !default;\r\n$menu-dropdown-active-item-color: $selected-text-color !default;\r\n$menu-dropdown-active-item-font-weight: $bold !default;\r\n\r\n//- Active Sub Menu */\r\n$menu-sub-active-background: transparent !default;\r\n$menu-sub-active-text-color: $menu-active-item-text-color !default;\r\n$menu-sub-active-font-weight: $bold !default;\r\n\r\n\r\n//---------------  Types ---------------*/\r\n\r\n//- Vertical */\r\n$menu-vertical-box-shadow: $menu-box-shadow !default;\r\n$menu-vertical-pointer-width: 2px !default;\r\n$menu-vertical-background: #FFFFFF !default;\r\n$menu-vertical-item-background: none !default;\r\n$menu-vertical-divider-background: $menu-divider-background !default;\r\n\r\n$menu-vertical-active-box-shadow: none !default;\r\n\r\n\r\n//- Secondary */\r\n$menu-secondary-background: none !default;\r\n$menu-secondary-item-spacing: $relative5px !default;\r\n$menu-secondary-margin: 0 (-$menu-secondary-item-spacing) !default;\r\n$menu-secondary-item-background: none !default;\r\n$menu-secondary-item-margin: 0 $menu-secondary-item-spacing !default;\r\n$menu-secondary-item-vertical-padding: $relative-mini !default;\r\n$menu-secondary-item-horizontal-padding: $relative-small !default;\r\n$menu-secondary-item-padding: $relative-mini $relative-small !default;\r\n$menu-secondary-item-border-radius: $default-border-radius !default;\r\n$menu-secondary-item-transition: color $default-duration $default-easing !default;\r\n$menu-secondary-item-color: $unselected-text-color !default;\r\n\r\n$menu-secondary-hover-item-background: $transparent-black !default;\r\n$menu-secondary-hover-item-color: $selected-text-color !default;\r\n\r\n$menu-secondary-active-item-background: $transparent-black !default;\r\n$menu-secondary-active-item-color: $selected-text-color !default;\r\n$menu-secondary-active-hover-item-background: $transparent-black !default;\r\n$menu-secondary-active-hover-item-color: $selected-text-color !default;\r\n\r\n$menu-secondary-active-hovered-item-background: $transparent-black !default;\r\n$menu-secondary-active-hovered-item-color: $selected-text-color !default;\r\n\r\n$menu-secondary-header-background: none transparent !default;\r\n$menu-secondary-header-border: none !default;\r\n\r\n$menu-secondary-item-vertical-spacing: $menu-secondary-item-spacing !default;\r\n$menu-secondary-vertical-item-margin: 0 0 $menu-secondary-item-vertical-spacing !default;\r\n$menu-secondary-vertical-item-border-radius: $default-border-radius !default;\r\n\r\n$menu-secondary-sub-menu-margin: 0 (-$menu-secondary-item-horizontal-padding) !default;\r\n$menu-secondary-sub-menu-item-margin: 0 !default;\r\n$menu-secondary-sub-horizontal-padding: ($menu-item-horizontal-padding / $tiny-size) + $menu-sub-indent !default;\r\n$menu-secondary-sub-menu-item-padding: $relative7px $menu-secondary-sub-horizontal-padding !default;\r\n\r\n//- Pointing */\r\n$menu-secondary-pointing-border-width: 2px !default;\r\n$menu-secondary-pointing-border-color: $border-color !default;\r\n$menu-secondary-pointing-item-vertical-padding: $relative-tiny !default;\r\n$menu-secondary-pointing-item-horizontal-padding: $relative-large !default;\r\n\r\n$menu-secondary-pointing-hover-text-color: $text-color !default;\r\n\r\n$menu-secondary-pointing-active-border-color: currentColor !default;\r\n$menu-secondary-pointing-active-text-color: $selected-text-color !default;\r\n$menu-secondary-pointing-active-font-weight: $bold !default;\r\n\r\n$menu-secondary-pointing-active-dropdown-border-color: transparent !default;\r\n\r\n$menu-secondary-pointing-active-hover-border-color: $menu-secondary-pointing-active-border-color !default;\r\n$menu-secondary-pointing-active-hover-text-color: $menu-secondary-pointing-active-text-color !default;\r\n\r\n$menu-secondary-pointing-header-color: $dark-text-color !default;\r\n$menu-secondary-vertical-pointing-item-margin: 0 (-$menu-secondary-pointing-border-width) 0 0 !default;\r\n\r\n//- Inverted Secondary */\r\n$menu-secondary-inverted-color: $inverted-light-text-color !default;\r\n\r\n$menu-secondary-inverted-hover-background: $transparent-white !default;\r\n$menu-secondary-inverted-hover-color: $inverted-selected-text-color !default;\r\n\r\n$menu-secondary-inverted-active-background: $strong-transparent-white !default;\r\n$menu-secondary-inverted-active-color: $inverted-selected-text-color !default;\r\n\r\n//- Inverted Pointing */\r\n$menu-secondary-pointing-inverted-border-color: $white-border-color !default;\r\n$menu-secondary-pointing-inverted-item-text-color: $inverted-text-color !default;\r\n$menu-secondary-pointing-inverted-item-header-color: $white !default;\r\n$menu-secondary-pointing-inverted-item-hover-text-color: $inverted-selected-text-color !default;\r\n$menu-secondary-pointing-inverted-active-border-color: $white !default;\r\n$menu-secondary-pointing-inverted-active-color: $inverted-selected-text-color !default;\r\n\r\n\r\n//- Tiered */\r\n$menu-tiered-active-item-background: #FCFCFC !default;\r\n$menu-tiered-active-background: #FCFCFC !default;\r\n\r\n$menu-tiered-sub-text-transform: $normal !default;\r\n$menu-tiered-sub-font-weight: $normal !default;\r\n\r\n$menu-tiered-sub-color: $light-text-color !default;\r\n\r\n$menu-tiered-sub-hover-background: none transparent !default;\r\n$menu-tiered-sub-hover-color: $hovered-text-color !default;\r\n\r\n$menu-tiered-sub-active-background: none transparent !default;\r\n$menu-tiered-sub-active-color: $selected-text-color !default;\r\n\r\n$menu-tiered-inverted-sub-background: rgba(0, 0, 0, 0.2) !default;\r\n\r\n\r\n//- Icon */\r\n$menu-icon-text-align: center !default;\r\n$menu-icon-item-color: $black !default;\r\n$menu-icon-inverted-item-color: $white !default;\r\n\r\n\r\n//- Tabular */\r\n$menu-tabular-border-color: $solid-border-color !default;\r\n$menu-tabular-background-color: transparent !default;\r\n$menu-tabular-background: none $menu-tabular-background-color !default;\r\n$menu-tabular-border-width: 1px !default;\r\n$menu-tabular-opposite-border-width: $menu-tabular-border-width + 1px !default;\r\n$menu-tabular-vertical-padding: $menu-item-vertical-padding !default;\r\n$menu-tabular-horizontal-padding: $relative-huge !default;\r\n$menu-tabular-border-radius: $default-border-radius !default;\r\n$menu-tabular-text-color: $menu-item-text-color !default;\r\n\r\n$menu-tabular-hovered-text-color: $hovered-text-color !default;\r\n\r\n$menu-tabular-vertical-background: none $menu-tabular-background-color !default;\r\n\r\n$menu-tabular-fluid-offset: 1px !default;\r\n$menu-tabular-fluid-width: calc(100% + #{$menu-tabular-fluid-offset * 2}) !default;\r\n\r\n$menu-tabular-active-background: none $white !default;\r\n$menu-tabular-active-color: $selected-text-color !default;\r\n$menu-tabular-active-box-shadow: none !default;\r\n$menu-tabular-active-weight: $bold !default;\r\n\r\n\r\n\r\n//- Pagination */\r\n$menu-pagination-min-width: 3em !default;\r\n$menu-pagination-active-background: $transparent-black !default;\r\n$menu-pagination-active-text-color: $selected-text-color !default;\r\n\r\n//- Labeled Icon */\r\n$menu-labeled-icon-item-horizontal-padding: $relative-massive !default;\r\n$menu-labeled-icon-size: $relative-massive !default;\r\n$menu-labeled-icon-min-width: 6em !default;\r\n$menu-labeled-icon-text-margin: 0.5rem !default;\r\n\r\n\r\n//- Text */\r\n$menu-text-item-spacing: $relative7px !default;\r\n$menu-text-margin: $relative-medium -($menu-text-item-spacing) !default;\r\n$menu-text-item-color: $muted-text-color !default;\r\n$menu-text-item-font-weight: $normal !default;\r\n$menu-text-item-margin: 0 0 !default;\r\n$menu-text-item-padding: $relative5px $menu-text-item-spacing !default;\r\n$menu-text-item-transition: opacity $default-duration $default-easing !default;\r\n\r\n$menu-text-sub-menu-margin: 0 !default;\r\n$menu-text-sub-menu-item-margin: 0 !default;\r\n$menu-text-sub-menu-item-padding: $relative7px 0 !default;\r\n\r\n$menu-text-active-item-font-weight: $normal !default;\r\n$menu-text-active-item-color: $selected-text-color !default;\r\n\r\n$menu-text-header-size: $relative-small !default;\r\n$menu-text-header-color: $dark-text-color !default;\r\n$menu-text-header-font-weight: $bold !default;\r\n$menu-text-header-text-transform: uppercase !default;\r\n\r\n$menu-text-vertical-margin: $relative-medium 0 !default;\r\n$menu-text-vertical-header-margin: $relative8px 0 $relative10px !default;\r\n$menu-text-vertical-item-margin: $relative8px 0 !default;\r\n\r\n$menu-text-vertical-icon-float: none !default;\r\n$menu-text-vertical-icon-margin: $menu-icon-margin !default;\r\n\r\n\r\n//---------------  Variations ---------------*/\r\n\r\n//- Inverted */\r\n$menu-inverted-background: $black !default;\r\n$menu-inverted-box-shadow: none !default;\r\n$menu-inverted-border: 0 solid transparent !default;\r\n$menu-inverted-header-background: transparent !default;\r\n\r\n$menu-inverted-item-background: transparent !default;\r\n$menu-inverted-item-text-color: $inverted-text-color !default;\r\n\r\n//- Inverted Sub Menu */\r\n$menu-inverted-sub-background: transparent !default;\r\n$menu-inverted-sub-color: $inverted-unselected-text-color !default;\r\n\r\n//- Inverted Hover */\r\n$menu-inverted-hover-background: $transparent-white !default;\r\n$menu-inverted-hover-color: $inverted-selected-text-color !default;\r\n\r\n$menu-inverted-sub-hover-background: transparent !default;\r\n$menu-inverted-sub-hover-color: $inverted-selected-text-color !default;\r\n\r\n//- Pressed */\r\n$menu-inverted-pressed-background: $transparent-white !default;\r\n$menu-inverted-pressed-color: $inverted-selected-text-color !default;\r\n\r\n//- Inverted Active */\r\n$menu-inverted-arrow-active-color: #3D3E3F !default;\r\n$menu-inverted-active-background: $menu-inverted-arrow-active-color !default;\r\n$menu-inverted-active-color: $inverted-selected-text-color !default;\r\n\r\n//- Inverted Active Hover*/\r\n$menu-inverted-active-hover-background: $menu-inverted-active-background !default;\r\n$menu-inverted-active-hover-color: $white !default;\r\n$menu-inverted-arrow-active-hover-color: $menu-inverted-arrow-active-color !default;\r\n\r\n$menu-inverted-sub-active-background: transparent !default;\r\n$menu-inverted-sub-active-color: $white !default;\r\n\r\n//- Inverted Menu Divider */\r\n$menu-inverted-divider-background: rgba(255, 255, 255, 0.08) !default;\r\n$menu-inverted-vertical-divider-background: $menu-inverted-divider-background !default;\r\n\r\n//- Inverted Colored */\r\n$menu-inverted-colored-divider-background: $menu-divider-background !default;\r\n$menu-inverted-colored-active-background: $strong-transparent-black !default;\r\n\r\n//- Fixed */\r\n$menu-fixed-preceding-grid-margin: 2.75rem !default;\r\n\r\n//- Floated */\r\n$menu-floated-distance: 0.5rem !default;\r\n\r\n//- Attached */\r\n$menu-attached-top-offset: 0 !default;\r\n$menu-attached-bottom-offset: 0 !default;\r\n$menu-attached-horizontal-offset: -$menu-border-width !default;\r\n$menu-attached-width: calc(100% + #{-$menu-attached-horizontal-offset * 2}) !default;\r\n$menu-attached-box-shadow: none !default;\r\n$menu-attached-border: $menu-border-width solid $solid-border-color !default;\r\n$menu-attached-bottom-box-shadow:\r\n  $menu-box-shadow,\r\n  $menu-attached-box-shadow\r\n !default;\r\n\r\n//- Resize large sizes */\r\n$menu-mini: $_11px !default;\r\n$menu-tiny: $_12px !default;\r\n$menu-small: $_13px !default;\r\n$menu-large: $_15px !default;\r\n$menu-big: $_16px !default;\r\n$menu-huge: $_17px !default;\r\n$menu-massive: $_18px !default;\r\n\r\n//- Sizes */\r\n$menu-mini-width: 9rem !default;\r\n$menu-tiny-width: 11rem !default;\r\n$menu-small-width: 13rem !default;\r\n$menu-medium-width: 15rem !default;\r\n$menu-large-width: 18rem !default;\r\n$menu-big-width: 20rem !default;\r\n$menu-huge-width: 22rem !default;\r\n$menu-massive-width: 25rem !default;\r\n\r\n\r\n//-------------------- Inverted dropdowns --------------------*/\r\n$menu-inverted-dropdown-background: $black !default;\r\n$menu-inverted-dropdown-box-shadow: none !default;\r\n\r\n$menu-inverted-dropdown-item-color: $inverted-muted-text-color !default;\r\n\r\n$menu-inverted-dropdown-hovered-item-background: $transparent-white !default;\r\n$menu-inverted-dropdown-hovered-item-color: $menu-inverted-dropdown-item-color !default;\r\n\r\n$menu-inverted-dropdown-active-item-background: transparent !default;\r\n$menu-inverted-dropdown-active-item-color: $menu-inverted-dropdown-item-color !default;\r\n\r\n$menu-inverted-dropdown-selected-item-background: $strong-transparent-white !default;\r\n$menu-inverted-dropdown-selected-item-color: $menu-inverted-dropdown-item-color !default;\r\n","\r\n//@-****************************** Message *******************************/\r\n\r\n// $text-color\r\n\r\n//--------------------  Elements --------------------*/\r\n\r\n$message-vertical-margin: 1em !default;\r\n$message-vertical-padding: 1em !default;\r\n$message-horizontal-padding: 1.5em !default;\r\n$message-padding: $message-vertical-padding $message-horizontal-padding !default;\r\n$message-background: #F8F8F9 !default;\r\n$message-line-height-offset: (($line-height - 1em) / 2) !default;\r\n\r\n$message-border-radius: $default-border-radius !default;\r\n$message-border-width: 1px !default;\r\n$message-border-shadow: 0 0 0 $message-border-width $strong-border-color inset !default;\r\n$message-shadow-shadow: 0 0 0 0 rgba(0, 0, 0, 0) !default;\r\n$message-box-shadow:\r\n  $message-border-shadow,\r\n  $message-shadow-shadow\r\n !default;\r\n\r\n$message-transition:\r\n  opacity $default-duration $default-easing,\r\n  color $default-duration $default-easing,\r\n  background $default-duration $default-easing,\r\n  box-shadow $default-duration $default-easing\r\n !default;\r\n\r\n//- Header */\r\n$message-header-font-size: $relative-large !default;\r\n$message-header-font-weight: $bold !default;\r\n$message-header-display: block !default;\r\n$message-header-distance: 0 !default;\r\n$message-header-margin: (-$header-line-height-offset) 0 $message-header-distance 0 !default;\r\n$message-header-paragraph-distance: 0.25em !default;\r\n\r\n//- Paragraph */\r\n$message-text-opacity: 0.85 !default;\r\n$message-paragraph-margin: 0.75em !default;\r\n\r\n//- List */\r\n$message-list-opacity: 0.85 !default;\r\n$message-list-style-position: inside !default;\r\n$message-list-margin: 0.5em !default;\r\n$message-list-item-indent: 1em !default;\r\n$message-list-item-margin: 0.3em !default;\r\n\r\n//- Icon */\r\n$message-icon-distance: 0.6em !default;\r\n\r\n//- Close Icon */\r\n$message-close-top-distance: $message-vertical-padding - $message-line-height-offset !default;\r\n$message-close-right-distance: 0.5em !default;\r\n$message-close-opacity: 0.7 !default;\r\n$message-close-transition: opacity $default-duration $default-easing !default;\r\n\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Icon Message */\r\n$message-icon-size: 3em !default;\r\n$message-icon-opacity: 0.8 !default;\r\n$message-icon-content-distance: 0 !default;\r\n$message-icon-vertical-align: middle !default;\r\n\r\n//- Attached */\r\n$message-attached-x-offset: -1px !default;\r\n$message-attached-y-offset: -1px !default;\r\n$message-attached-box-shadow: 0 0 0 $message-border-width $border-color inset !default;\r\n$message-attached-bottom-box-shadow:\r\n  $message-attached-box-shadow,\r\n  $subtle-shadow\r\n !default;\r\n\r\n//- Floating */\r\n$message-floating-box-shadow:\r\n  $message-border-shadow,\r\n  $floating-shadow\r\n !default;\r\n\r\n//- Colors */\r\n$message-red-box-shadow:\r\n  0 0 0 $message-border-width $red-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-red-box-floating-shadow:\r\n  0 0 0 $message-border-width $red-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-orange-box-shadow:\r\n  0 0 0 $message-border-width $orange-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-orange-box-floating-shadow:\r\n  0 0 0 $message-border-width $orange-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-yellow-box-shadow:\r\n  0 0 0 $message-border-width $yellow-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-yellow-box-floating-shadow:\r\n   0 0 0 $message-border-width $yellow-border-color inset,\r\n   $floating-shadow\r\n !default;\r\n$message-olive-box-shadow:\r\n  0 0 0 $message-border-width $olive-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-olive-box-floating-shadow:\r\n  0 0 0 $message-border-width $olive-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-green-box-shadow:\r\n  0 0 0 $message-border-width $green-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-green-box-floating-shadow:\r\n  0 0 0 $message-border-width $green-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-teal-box-shadow:\r\n  0 0 0 $message-border-width $teal-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-teal-box-floating-shadow:\r\n  0 0 0 $message-border-width $teal-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-blue-box-shadow:\r\n  0 0 0 $message-border-width $blue-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-blue-box-floating-shadow:\r\n  0 0 0 $message-border-width $blue-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-violet-box-shadow:\r\n  0 0 0 $message-border-width $violet-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-violet-box-floating-shadow:\r\n  0 0 0 $message-border-width $violet-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-purple-box-shadow:\r\n  0 0 0 $message-border-width $purple-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-purple-box-floating-shadow:\r\n  0 0 0 $message-border-width $purple-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-pink-box-shadow:\r\n  0 0 0 $message-border-width $pink-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-pink-box-floating-shadow:\r\n  0 0 0 $message-border-width $pink-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-brown-box-shadow:\r\n  0 0 0 $message-border-width $brown-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-brown-box-floating-shadow:\r\n  0 0 0 $message-border-width $brown-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n\r\n//- Warning / Positive / Negative / Info */\r\n$message-positive-box-shadow:\r\n  0 0 0 $message-border-width $positive-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-positive-box-floating-shadow:\r\n  0 0 0 $message-border-width $positive-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-negative-box-shadow:\r\n  0 0 0 $message-border-width $negative-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-negative-box-floating-shadow:\r\n  0 0 0 $message-border-width $negative-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-info-box-shadow:\r\n  0 0 0 $message-border-width $info-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-info-box-floating-shadow:\r\n  0 0 0 $message-border-width $info-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-warning-box-shadow:\r\n  0 0 0 $message-border-width $warning-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-warning-box-floating-shadow:\r\n  0 0 0 $message-border-width $warning-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-error-box-shadow:\r\n  0 0 0 $message-border-width $error-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-error-box-floating-shadow:\r\n  0 0 0 $message-border-width $error-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n$message-success-box-shadow:\r\n  0 0 0 $message-border-width $success-border-color inset,\r\n  $message-shadow-shadow\r\n !default;\r\n$message-success-box-floating-shadow:\r\n  0 0 0 $message-border-width $success-border-color inset,\r\n  $floating-shadow\r\n !default;\r\n\r\n\r\n$message-consequences: (\r\n  positive: (\r\n    background     : $positive-background-color,\r\n    header         : $positive-header-color,\r\n    boxShadow      : $message-positive-box-shadow,\r\n    boxFloatShadow : $message-positive-box-floating-shadow,\r\n    text           : $positive-text-color,\r\n  ),\r\n  negative: (\r\n    background     : $negative-background-color,\r\n    header         : $negative-header-color,\r\n    boxShadow      : $message-negative-box-shadow,\r\n    boxFloatShadow : $message-negative-box-floating-shadow,\r\n    text           : $negative-text-color,\r\n  ),\r\n  info: (\r\n    background     : $info-background-color,\r\n    header         : $info-header-color,\r\n    boxShadow      : $message-info-box-shadow,\r\n    boxFloatShadow : $message-info-box-floating-shadow,\r\n    text           : $info-text-color,\r\n  ),\r\n  warning: (\r\n    background     : $warning-background-color,\r\n    header         : $warning-header-color,\r\n    boxShadow      : $message-warning-box-shadow,\r\n    boxFloatShadow : $message-warning-box-floating-shadow,\r\n    text           : $warning-text-color,\r\n  ),\r\n  error: (\r\n    background     : $error-background-color,\r\n    header         : $error-header-color,\r\n    boxShadow      : $message-error-box-shadow,\r\n    boxFloatShadow : $message-error-box-floating-shadow,\r\n    text           : $error-text-color,\r\n  ),\r\n  success: (\r\n    background     : $success-background-color,\r\n    header         : $success-header-color,\r\n    boxShadow      : $message-success-box-shadow,\r\n    boxFloatShadow : $message-success-box-floating-shadow,\r\n    text           : $success-text-color,\r\n  ),\r\n) !default;\r\n","\r\n//@-******************************  Table *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$table-vertical-margin: 1em !default;\r\n$table-horizontal-margin: 0 !default;\r\n$table-margin: $table-vertical-margin $table-horizontal-margin !default;\r\n$table-border-collapse: separate !default;\r\n$table-border-spacing: 0 !default;\r\n$table-border-radius: $default-border-radius !default;\r\n$table-transition:\r\n  background $default-duration $default-easing,\r\n  color $default-duration $default-easing\r\n !default;\r\n$table-background: $white !default;\r\n$table-color: $text-color !default;\r\n$table-border-width: 1px !default;\r\n$table-border: $table-border-width solid $border-color !default;\r\n$table-box-shadow: none !default;\r\n$table-text-align: left !default;\r\n$table-vertical-align: middle !default;\r\n\r\n//---------------  Parts ---------------*/\r\n\r\n//- Table Row */\r\n$table-row-border: 1px solid $internal-border-color !default;\r\n\r\n//- Table Cell */\r\n$table-cell-vertical-padding: $relative-mini !default;\r\n$table-cell-horizontal-padding: $relative-mini !default;\r\n$table-cell-vertical-align: inherit !default;\r\n$table-cell-text-align: inherit !default;\r\n$table-cell-border: 1px solid $internal-border-color !default;\r\n\r\n//- Table Header */\r\n$table-header-border: 1px solid $internal-border-color !default;\r\n$table-header-divider: none !default;\r\n$table-header-background: $off-white !default;\r\n$table-header-align: inherit !default;\r\n$table-header-vertical-align: inherit !default;\r\n$table-header-color: $text-color !default;\r\n$table-header-vertical-padding: $relative-small !default;\r\n$table-header-horizontal-padding: $table-cell-horizontal-padding !default;\r\n$table-header-font-style: none !default;\r\n$table-header-font-weight: $bold !default;\r\n$table-header-text-transform: none !default;\r\n$table-header-box-shadow: none !default;\r\n\r\n//- Table Footer */\r\n$table-footer-box-shadow: none !default;\r\n$table-footer-border: 1px solid $border-color !default;\r\n$table-footer-divider: none !default;\r\n$table-footer-background: $off-white !default;\r\n$table-footer-align: inherit !default;\r\n$table-footer-vertical-align: middle !default;\r\n$table-footer-color: $text-color !default;\r\n$table-footer-vertical-padding: $table-cell-vertical-padding !default;\r\n$table-footer-horizontal-padding: $table-cell-horizontal-padding !default;\r\n$table-footer-font-style: $normal !default;\r\n$table-footer-font-weight: $normal !default;\r\n$table-footer-text-transform: none !default;\r\n\r\n//- Responsive Size */\r\n$table-responsive-header-display: block !default;\r\n$table-responsive-footer-display: block !default;\r\n$table-responsive-row-vertical-padding: 1em !default;\r\n$table-responsive-row-box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1) inset !important !default;\r\n$table-responsive-cell-vertical-padding: 0.25em !default;\r\n$table-responsive-cell-horizontal-padding: 0.75em !default;\r\n$table-responsive-cell-box-shadow: none !important !default;\r\n$table-responsive-cell-header-font-weight: $bold !default;\r\n\r\n//--------------------  Types --------------------*/\r\n\r\n//- Definition */\r\n$table-definition-page-background: $white !default;\r\n\r\n$table-definition-header-background: $white !default;\r\n$table-definition-header-color: $unselected-text-color !default;\r\n$table-definition-header-font-weight: $normal !default;\r\n\r\n$table-definition-footer-background: $table-definition-header-background !default;\r\n$table-definition-footer-color: $table-definition-header-color !default;\r\n$table-definition-footer-font-weight: $table-definition-header-font-weight !default;\r\n\r\n$table-definition-column-background: $subtle-transparent-black !default;\r\n$table-definition-column-font-weight: $bold !default;\r\n$table-definition-column-color: $selected-text-color !default;\r\n$table-definition-column-font-size: $relative-medium !default;\r\n$table-definition-column-text-transform: '' !default;\r\n$table-definition-column-box-shadow: '' !default;\r\n$table-definition-column-text-align: '' !default;\r\n$table-definition-column-horizontal-padding: '' !default;\r\n\r\n\r\n//--------------- Couplings ---------------*/\r\n\r\n$table-icon-vertical-align: baseline !default;\r\n\r\n//---------------  States ---------------*/\r\n\r\n$table-state-marker-width: 0 !default;\r\n\r\n//- Positive */\r\n$table-positive-color: $positive-text-color !default;\r\n$table-positive-box-shadow: $table-state-marker-width 0 0 $positive-border-color inset !default;\r\n$table-positive-background-hover: darken($positive-background-color, 3) !default;\r\n$table-positive-color-hover: darken($table-positive-color, 3) !default;\r\n\r\n//- Negative */\r\n$table-negative-color: $negative-text-color !default;\r\n$table-negative-box-shadow: $table-state-marker-width 0 0 $negative-border-color inset !default;\r\n$table-negative-background-hover: darken($negative-background-color, 3) !default;\r\n$table-negative-color-hover: darken($table-negative-color, 3) !default;\r\n\r\n//- Error */\r\n$table-error-color: $error-text-color !default;\r\n$table-error-box-shadow: $table-state-marker-width 0 0 $error-border-color inset !default;\r\n$table-error-background-hover: darken($error-background-color, 3) !default;\r\n$table-error-color-hover: darken($table-error-color, 3) !default;\r\n\r\n//- Warning */\r\n$table-warning-color: $warning-text-color !default;\r\n$table-warning-box-shadow: $table-state-marker-width 0 0 $warning-border-color inset !default;\r\n$table-warning-background-hover: darken($warning-background-color, 3) !default;\r\n$table-warning-color-hover: darken($table-warning-color, 3) !default;\r\n\r\n//- Active */\r\n$table-active-color: $text-color !default;\r\n$table-active-background-color: #E0E0E0 !default;\r\n$table-active-box-shadow: $table-state-marker-width 0 0 $table-active-color inset !default;\r\n\r\n$table-active-background-hover: #EFEFEF !default;\r\n$table-active-color-hover: $selected-text-color !default;\r\n\r\n//---------------  Types ---------------*/\r\n\r\n//- Attached */\r\n$table-attached-top-offset: 0 !default;\r\n$table-attached-bottom-offset: 0 !default;\r\n$table-attached-horizontal-offset: -$table-border-width !default;\r\n$table-attached-width: calc(100% + #{-$table-attached-horizontal-offset * 2}) !default;\r\n$table-attached-box-shadow: none !default;\r\n$table-attached-border: $table-border-width solid $solid-border-color !default;\r\n$table-attached-bottom-box-shadow:\r\n  $table-box-shadow,\r\n  $table-attached-box-shadow\r\n !default;\r\n\r\n//- Striped */\r\n$table-striped-background: rgba(0, 0, 50, 0.02) !default;\r\n$table-inverted-striped-background: rgba(255, 255, 255, 0.05) !default;\r\n\r\n//- Selectable */\r\n$table-selectable-background: $transparent-black !default;\r\n$table-selectable-text-color: $selected-text-color !default;\r\n$table-selectable-inverted-background: $transparent-white !default;\r\n$table-selectable-inverted-text-color: $inverted-selected-text-color !default;\r\n\r\n//- Sortable */\r\n$table-sortable-background: '' !default;\r\n$table-sortable-color: $text-color !default;\r\n\r\n$table-sortable-border: 1px solid $border-color !default;\r\n$table-sortable-icon-width: auto !default;\r\n$table-sortable-icon-distance: 0.5em !default;\r\n$table-sortable-icon-opacity: 0.8 !default;\r\n$table-sortable-icon-font: 'Icons' !default;\r\n$table-sortable-icon-ascending: '\\f0d8' !default;\r\n$table-sortable-icon-descending: '\\f0d7' !default;\r\n$table-sortable-disabled-color: $disabled-text-color !default;\r\n\r\n$table-sortable-hover-background: $transparent-black !default;\r\n$table-sortable-hover-color: $hovered-text-color !default;\r\n\r\n$table-sortable-active-background: $transparent-black !default;\r\n$table-sortable-active-color: $selected-text-color !default;\r\n\r\n$table-sortable-active-hover-background: $transparent-black !default;\r\n$table-sortable-active-hover-color: $selected-text-color !default;\r\n\r\n$table-sortable-inverted-border-color: transparent !default;\r\n$table-sortable-inverted-hover-background: $transparent-white $subtle-gradient !default;\r\n$table-sortable-inverted-hover-color: $inverted-hovered-text-color !default;\r\n$table-sortable-inverted-active-background: $strong-transparent-white $subtle-gradient !default;\r\n$table-sortable-inverted-active-color: $inverted-selected-text-color !default;\r\n\r\n//- Colors */\r\n$table-colored-border-size: 0.2em !default;\r\n$table-colored-border-radius: 0 0 $table-border-radius $table-border-radius !default;\r\n$table-colored-border-size-cover: $table-colored-border-size / 2 !default;\r\n\r\n//- Inverted */\r\n$table-inverted-background: #333333 !default;\r\n$table-inverted-border: none !default;\r\n$table-inverted-cell-border: 1px solid $white-border-color !default;\r\n$table-inverted-cell-border-color: $white-border-color !default;\r\n$table-inverted-cell-color: $inverted-text-color !default;\r\n\r\n$table-inverted-header-background: $very-strong-transparent-black !default;\r\n$table-inverted-header-color: $inverted-text-color !default;\r\n$table-inverted-header-border-color: $table-inverted-cell-border-color !default;\r\n\r\n$table-inverted-definition-column-background: $subtle-transparent-white !default;\r\n$table-inverted-definition-column-color: $inverted-selected-text-color !default;\r\n$table-inverted-definition-column-font-weight: $bold !default;\r\n\r\n//- Basic */\r\n$table-basic-background: transparent !default;\r\n$table-basic-border: $border-color !default;\r\n$table-basic-box-shadow: none !default;\r\n\r\n$table-basic-header-background: transparent !default;\r\n$table-basic-cell-background: transparent !default;\r\n$table-basic-header-divider: none !default;\r\n$table-basic-cell-border: 1px solid rgba(0, 0, 0, 0.1) !default;\r\n$table-basic-cell-padding: '' !default;\r\n$table-basic-striped-background: $transparent-black !default;\r\n\r\n//- Padded */\r\n$table-padded-vertical-padding: 1em !default;\r\n$table-padded-horizontal-padding: 1em !default;\r\n$table-very-padded-vertical-padding: 1.5em !default;\r\n$table-very-padded-horizontal-padding: 1.5em !default;\r\n\r\n//- Compact */\r\n$table-compact-vertical-padding: 0.5em !default;\r\n$table-compact-horizontal-padding: 0.7em !default;\r\n$table-very-compact-vertical-padding: 0.4em !default;\r\n$table-very-compact-horizontal-padding: 0.6em !default;\r\n\r\n\r\n//- Sizes */\r\n$table-small: 0.9em !default;\r\n$table-medium: 1em !default;\r\n$table-large: 1.1em !default;\r\n","\r\n//@-****************************** Advertisement *******************************/\r\n\r\n$ad-margin: 1em 0 !default;\r\n$ad-overflow: hidden !default;\r\n\r\n$ad-test-background: $light-black !default;\r\n$ad-test-color: $white !default;\r\n$ad-test-font-weight: $bold !default;\r\n$ad-test-text: 'Ad' !default;\r\n$ad-test-font-size: $relative-medium !default;\r\n$ad-test-mobile-font-size: $relative-tiny !default;\r\n","\r\n//@-******************************  Card *******************************/\r\n\r\n//--------------------  View --------------------*/\r\n\r\n//- Shadow */\r\n$card-shadow-distance: 1px !default;\r\n$card-shadow-box-shadow: 0 $card-shadow-distance 3px 0 $solid-border-color !default;\r\n\r\n//- Card */\r\n$card-font-family: $page-font !default;\r\n$card-display: flex !default;\r\n$card-background: $white !default;\r\n$card-border-radius: $default-border-radius !default;\r\n$card-margin: 1em 0 !default;\r\n$card-min-height: 0 !default;\r\n$card-padding: 0 !default;\r\n$card-width: 290px !default;\r\n$card-border-width: 1px !default;\r\n$card-border-shadow: 0 0 0 $card-border-width $solid-border-color !default;\r\n$card-box-shadow:\r\n  $card-shadow-box-shadow,\r\n  $card-border-shadow\r\n !default;\r\n$card-border: none !default;\r\n$card-z-index: '' !default;\r\n$card-transition:\r\n  box-shadow $default-duration $default-easing,\r\n  transform $default-duration $default-easing\r\n !default;\r\n\r\n//- Card Group */\r\n$card-horizontal-spacing: 1em !default;\r\n$card-row-spacing: 1.75em !default;\r\n\r\n$card-group-card-margin: (-$card-row-spacing / 2) (-$card-horizontal-spacing / 2) !default;\r\n$card-group-super-display: flex !default;\r\n\r\n$card-group-float: none !default;\r\n$card-group-display: flex !default;\r\n$card-group-margin: ($card-row-spacing / 2) ($card-horizontal-spacing / 2) !default;\r\n\r\n//- Consecutive Cards */\r\n$card-consecutive-group-distance: ($card-row-spacing / 2) !default;\r\n\r\n//--------------------  Content --------------------*/\r\n\r\n\r\n//- Image */\r\n$card-image-background: $transparent-black !default;\r\n$card-image-padding: 0 !default;\r\n$card-image-border: none !default;\r\n$card-image-box-shadow: none !default;\r\n$card-image-border: none !default;\r\n\r\n//- Content */\r\n$card-content-divider: $card-border-width solid $internal-border-color !default;\r\n$card-content-margin: 0 !default;\r\n$card-content-background: none !default;\r\n$card-content-padding: 1em 1em !default;\r\n$card-content-font-size: 1em !default;\r\n$card-content-border-radius: 0 !default;\r\n$card-content-box-shadow: none !default;\r\n$card-content-border: none !default;\r\n\r\n\r\n//- Header */\r\n$card-header-margin: '' !default;\r\n$card-header-font-weight: $bold !default;\r\n$card-header-font-size: $relative-big !default;\r\n$card-header-line-height-offset: -($line-height - 1em) / 2 !default;\r\n$card-header-color: $dark-text-color !default;\r\n\r\n//- Metadata */\r\n$card-meta-font-size: $relative-medium !default;\r\n$card-meta-spacing: 0.3em !default;\r\n$card-meta-color: $light-text-color !default;\r\n\r\n//- Icons */\r\n$card-action-opacity: 0.75 !default;\r\n$card-action-hover-opacity: 1 !default;\r\n$card-action-transition: color $default-duration $default-easing !default;\r\n\r\n$card-star-color: #FFB70A !default;\r\n$card-star-active-color: #FFE623 !default;\r\n\r\n$card-like-color: #FF2733 !default;\r\n$card-like-active-color: #FF2733 !default;\r\n\r\n//- Links */\r\n$card-content-link-color: '' !default;\r\n$card-content-link-hover-color: '' !default;\r\n$card-content-link-transition: color $default-duration $default-easing !default;\r\n\r\n$card-header-link-color: $card-header-color !default;\r\n$card-header-link-hover-color: $link-hover-color !default;\r\n\r\n$card-meta-link-color: $light-text-color !default;\r\n$card-meta-link-hover-color: $text-color !default;\r\n\r\n//- Description */\r\n$card-description-distance: 0.5em !default;\r\n$card-description-color: rgba(0, 0, 0, 0.68) !default;\r\n\r\n//- Content Image */\r\n$card-content-image-width: '' !default;\r\n$card-content-image-vertical-align: middle !default;\r\n\r\n//- Avatar Image */\r\n$card-avatar-size: 2em !default;\r\n$card-avatar-border-radius: $circular-radius !default;\r\n\r\n//- Paragraph */\r\n$card-paragraph-distance: 0.5em !default;\r\n\r\n//- Dimmer */\r\n$card-dimmer-z-index: 10 !default;\r\n$card-dimmer-color: '' !default;\r\n\r\n//- Additional Content */\r\n$card-extra-divider: 1px solid rgba(0, 0, 0, 0.05) !default;\r\n$card-extra-background: none !default;\r\n$card-extra-position: static !default;\r\n$card-extra-width: auto !default;\r\n$card-extra-top: 0 !default;\r\n$card-extra-left: 0 !default;\r\n$card-extra-margin: 0 0 !default;\r\n$card-extra-padding: 0.75em 1em !default;\r\n$card-extra-box-shadow: none !default;\r\n$card-extra-color: $light-text-color !default;\r\n$card-extra-transition: color $default-duration $default-easing !default;\r\n\r\n//- Extra Links */\r\n$card-extra-link-color: $unselected-text-color !default;\r\n$card-extra-link-hover-color: $link-hover-color !default;\r\n\r\n//- Buttons */\r\n$card-button-margin: 0 (-$card-border-width) !default;\r\n$card-button-width: calc(100% + #{$card-border-width * 2}) !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Link */\r\n$card-link-hover-background: $white !default;\r\n$card-link-hover-border: $card-border !default;\r\n$card-link-hover-z-index: 5 !default;\r\n$card-link-hover-raise-distance: 3px !default;\r\n$card-link-hover-transform: translateY(-$card-link-hover-raise-distance) !default;\r\n\r\n$card-shadow-hover-box-shadow: 0 $card-shadow-distance $card-link-hover-raise-distance 0 $solid-selected-border-color !default;\r\n$card-link-hover-box-shadow:\r\n  $card-shadow-hover-box-shadow,\r\n  $card-border-shadow\r\n !default;\r\n\r\n//- Horizontal */\r\n$card-horizontal-min-width: 400px !default;\r\n$card-horizontal-width: 400px !default;\r\n$card-horizontal-image-width: 150px !default;\r\n\r\n//- Raised */\r\n$card-raised-shadow:\r\n  $card-border-shadow,\r\n  $floating-shadow\r\n !default;\r\n$card-raised-shadow-hover:\r\n  $card-border-shadow,\r\n  $floating-shadow-hover\r\n !default;\r\n\r\n//- Card Count */\r\n$card-wide-spacing: 1em !default;\r\n$card-spacing: 0.75em !default;\r\n$card-small-spacing: 0.5em !default;\r\n\r\n$card-one-spacing: 0 !default;\r\n$card-two-spacing: $card-wide-spacing !default;\r\n$card-three-spacing: $card-wide-spacing !default;\r\n$card-four-spacing: $card-spacing !default;\r\n$card-five-spacing: $card-spacing !default;\r\n$card-six-spacing: $card-spacing !default;\r\n$card-seven-spacing: $card-small-spacing !default;\r\n$card-eight-spacing: $card-small-spacing !default;\r\n$card-nine-spacing: $card-small-spacing !default;\r\n$card-ten-spacing: $card-small-spacing !default;\r\n\r\n$card-one: $one-column !default;\r\n$card-one-offset: 0 !default;\r\n$card-two:  calc(#{$two-column} - #{$card-two-spacing * 2}) !default;\r\n$card-two-offset: -$card-two-spacing !default;\r\n$card-three:  calc(#{$three-column} - #{$card-three-spacing * 2}) !default;\r\n$card-three-offset: -$card-three-spacing !default;\r\n$card-four:  calc(#{$four-column} - #{$card-four-spacing * 2}) !default;\r\n$card-four-offset: -$card-four-spacing !default;\r\n$card-five:  calc(#{$five-column} - #{$card-five-spacing * 2}) !default;\r\n$card-five-offset: -$card-five-spacing !default;\r\n$card-six:  calc(#{$six-column} - #{$card-six-spacing * 2}) !default;\r\n$card-six-offset: -$card-six-spacing !default;\r\n$card-seven:  calc(#{$seven-column} - #{$card-seven-spacing * 2}) !default;\r\n$card-seven-offset: -$card-seven-spacing !default;\r\n$card-eight:  calc(#{$eight-column} - #{$card-seven-spacing * 2}) !default;\r\n$card-eight-offset: -$card-seven-spacing !default;\r\n$card-nine:  calc(#{$nine-column} - #{$card-nine-spacing * 2}) !default;\r\n$card-nine-offset: -$card-nine-spacing !default;\r\n$card-ten:  calc(#{$ten-column} - #{$card-ten-spacing * 2}) !default;\r\n$card-ten-offset: -$card-ten-spacing !default;\r\n\r\n//- Stackable */\r\n$card-stackable-row-spacing: 1em !default;\r\n$card-stackable-spacing: 1em !default;\r\n$card-stackable-margin:  calc(#{$one-column} - #{$card-stackable-spacing * 2}) !default;\r\n\r\n//- Sizes */\r\n$card-medium: 1em !default;\r\n\r\n//- Colored */\r\n$card-colored-shadow-distance: 2px !default;\r\n\r\n//- Inverted */\r\n$card-inverted-background: $black !default;\r\n$card-inverted-content-divider: $card-border-width solid rgba(255, 255, 255, 0.15) !default;\r\n$card-inverted-header-color: $inverted-text-color !default;\r\n$card-inverted-description-color: $inverted-muted-text-color !default;\r\n$card-inverted-meta-color: $inverted-light-text-color !default;\r\n$card-inverted-meta-link-color: $inverted-light-text-color !default;\r\n$card-inverted-meta-link-hover-color: $inverted-hovered-text-color !default;\r\n$card-inverted-extra-color: $inverted-light-text-color !default;\r\n$card-inverted-extra-link-color: $inverted-unselected-text-color !default;\r\n$card-inverted-extra-divider: 1px solid rgba(255, 255, 255, 0.15) !default;\r\n$card-inverted-link-hover-background: $black !default;\r\n$card-inverted-box-shadow:\r\n  0 $card-shadow-distance 3px 0 $solid-white-border-color,\r\n  0 0 0 $card-border-width $solid-white-border-color\r\n !default;\r\n","\r\n//@-****************************** Comments *******************************/\r\n\r\n\r\n//--------------------  View --------------------*/\r\n\r\n$comment-max-width: 650px !default;\r\n$comment-super-margin: 1.5em 0 !default;\r\n\r\n//-------------------- Elements --------------------*/\r\n\r\n//- Comment */\r\n$comment-background: none !default;\r\n$comment-margin: 0.5em 0 0 !default;\r\n$comment-padding: 0.5em 0 0 !default;\r\n$comment-divider: none !default;\r\n$comment-border: none !default;\r\n$comment-line-height: 1.2 !default;\r\n$comment-first-margin: 0 !default;\r\n$comment-first-padding: 0 !default;\r\n\r\n//- Nested Comment */\r\n$comment-nested-comments-margin: 0 0 0.5em 0.5em !default;\r\n$comment-nested-comments-padding: 1em 0 1em 1em !default;\r\n\r\n$comment-nested-divider: none !default;\r\n$comment-nested-border: none !default;\r\n$comment-nested-background: none !default;\r\n\r\n//- Avatar */\r\n$comment-avatar-display: block !default;\r\n$comment-avatar-float: left !default;\r\n$comment-avatar-width: 2.5em !default;\r\n$comment-avatar-height: auto !default;\r\n$comment-avatar-spacing: 1em !default;\r\n$comment-avatar-margin: ($comment-line-height - 1em) 0 0 !default;\r\n$comment-avatar-border-radius: 0.25rem !default;\r\n\r\n//- Content */\r\n$comment-content-margin: $comment-avatar-width + $comment-avatar-spacing !default;\r\n\r\n//- Author */\r\n$comment-author-font-size: 1em !default;\r\n$comment-author-color: $text-color !default;\r\n$comment-author-hover-color: $link-hover-color !default;\r\n$comment-author-font-weight: $bold !default;\r\n\r\n//- Metadata */\r\n$comment-metadata-display: inline-block !default;\r\n$comment-metadata-font-size: 0.875em !default;\r\n$comment-metadata-spacing: 0.5em !default;\r\n$comment-metadata-content-spacing: 0.5em !default;\r\n$comment-metadata-color: $light-text-color !default;\r\n\r\n//- Text */\r\n$comment-text-font-size: 1em !default;\r\n$comment-text-margin: 0.25em 0 0.5em !default;\r\n$comment-text-word-wrap: break-word !default;\r\n$comment-text-line-height: 1.3 !default;\r\n\r\n//- Actions */\r\n$comment-action-font-size: 0.875em !default;\r\n$comment-action-content-distance: 0.75em !default;\r\n$comment-action-link-color: $unselected-text-color !default;\r\n$comment-action-link-hover-color: $hovered-text-color !default;\r\n\r\n//- Reply */\r\n$comment-super-reply-distance: 1em !default;\r\n$comment-reply-height: 12em !default;\r\n$comment-reply-font-size: 1em !default;\r\n\r\n$comment-reply-distance: $comment-super-reply-distance !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Threaded */\r\n$comment-threaded-margin: -1.5em 0 -1em  ($comment-avatar-width / 2) !default;\r\n$comment-threaded-padding: 3em 0 2em 2.25em !default;\r\n$comment-threaded-box-shadow: -1px 0 0 $border-color !default;\r\n\r\n\r\n//- Minimal */\r\n$comment-minimal-action-position: absolute !default;\r\n$comment-minimal-action-top: 0 !default;\r\n$comment-minimal-action-right: 0 !default;\r\n$comment-minimal-action-left: auto !default;\r\n\r\n$comment-minimal-transition-delay: 0.1s !default;\r\n$comment-minimal-easing: $default-easing !default;\r\n$comment-minimal-duration: 0.2s !default;\r\n$comment-minimal-transition: opacity $comment-minimal-duration $comment-minimal-easing !default;\r\n","\r\n//@-******************************  Feed *******************************/\r\n\r\n//-------------------- Feed --------------------*/\r\n\r\n$feed-margin: 1em 0 !default;\r\n\r\n//-------------------- Elements --------------------*/\r\n\r\n//- Event */\r\n$feed-event-width: 100% !default;\r\n$feed-event-padding: $_3px 0 !default;\r\n$feed-event-margin: 0 !default;\r\n$feed-event-background: none !default;\r\n$feed-event-divider: none !default;\r\n\r\n//- Event Label */\r\n$feed-label-width: 2.5em !default;\r\n$feed-label-height: auto !default;\r\n$feed-label-align-self: stretch !default;\r\n$feed-label-text-align: left !default;\r\n\r\n//- Icon Label */\r\n$feed-icon-label-opacity: 1 !default;\r\n$feed-icon-label-width: 100% !default;\r\n$feed-icon-label-size: 1.5em !default;\r\n$feed-icon-label-padding: 0.25em !default;\r\n$feed-icon-label-background: none !default;\r\n$feed-icon-label-border-radius: none !default;\r\n$feed-icon-label-border: none !default;\r\n$feed-icon-label-color: rgba(0, 0, 0, 0.6) !default;\r\n\r\n//- Image Label */\r\n$feed-image-label-width: 100% !default;\r\n$feed-image-label-height: auto !default;\r\n$feed-image-label-border-radius: $circular-radius !default;\r\n\r\n//- Content w/ Label */\r\n$feed-labeled-content-margin: 0.5em 0 $relative5px $relative-large !default;\r\n$feed-last-labeled-content-padding: 0 !default;\r\n\r\n//- Content */\r\n$feed-content-align-self: stretch !default;\r\n$feed-content-text-align: left !default;\r\n$feed-content-word-wrap: break-word !default;\r\n\r\n//- Date */\r\n$feed-date-margin: -0.5rem 0 0 !default;\r\n$feed-date-padding: 0 !default;\r\n$feed-date-color: $light-text-color !default;\r\n$feed-date-font-size: $relative-medium !default;\r\n$feed-date-font-weight: $normal !default;\r\n$feed-date-font-style: $normal !default;\r\n\r\n//- Summary */\r\n$feed-summary-margin: 0 !default;\r\n$feed-summary-font-size: $relative-medium !default;\r\n$feed-summary-font-weight: $bold !default;\r\n$feed-summary-color: $text-color !default;\r\n\r\n//- Summary Image */\r\n$feed-summary-image-width: auto !default;\r\n$feed-summary-image-height: 10em !default;\r\n$feed-summary-image-margin: -0.25em 0.25em 0 0 !default;\r\n$feed-summary-image-vertical-align: middle !default;\r\n$feed-summary-image-border-radius: 0.25em !default;\r\n\r\n//- Summary Date */\r\n$feed-summary-date-display: inline-block !default;\r\n$feed-summary-date-float: none !default;\r\n$feed-summary-date-margin: 0 0 0 0.5em !default;\r\n$feed-summary-date-padding: 0 !default;\r\n$feed-summary-date-font-size: $relative-tiny !default;\r\n$feed-summary-date-font-weight: $feed-date-font-weight !default;\r\n$feed-summary-date-font-style: $feed-date-font-style !default;\r\n$feed-summary-date-color: $feed-date-color !default;\r\n\r\n//- User */\r\n$feed-user-font-weight: $bold !default;\r\n$feed-user-distance: 0 !default;\r\n$feed-user-image-width: $feed-summary-image-width !default;\r\n$feed-user-image-height: $feed-summary-image-height !default;\r\n$feed-user-image-margin: $feed-summary-image-margin !default;\r\n$feed-user-image-vertical-align: $feed-summary-image-vertical-align !default;\r\n\r\n//- Extra Summary Data */\r\n$feed-extra-margin: 0.5em 0 0 !default;\r\n$feed-extra-background: none !default;\r\n$feed-extra-padding: 0 !default;\r\n$feed-extra-color: $text-color !default;\r\n\r\n//- Extra Images */\r\n$feed-extra-image-margin: 0 0.25em 0 0 !default;\r\n$feed-extra-image-width: 6em !default;\r\n\r\n//- Extra Text */\r\n$feed-extra-text-padding: 0 !default;\r\n$feed-extra-text-pointer: none !default;\r\n$feed-extra-text-font-size: $relative-medium !default;\r\n$feed-extra-text-line-height: $line-height !default;\r\n$feed-extra-text-max-width: 500px !default;\r\n\r\n//- Metadata Group */\r\n$feed-metadata-display: inline-block !default;\r\n$feed-metadata-font-size: $relative-tiny !default;\r\n$feed-metadata-margin: 0.5em 0 0 !default;\r\n$feed-metadata-background: none !default;\r\n$feed-metadata-border: none !default;\r\n$feed-metadata-border-radius: 0 !default;\r\n$feed-metadata-box-shadow: none !default;\r\n$feed-metadata-padding: 0 !default;\r\n$feed-metadata-color: rgba(0, 0, 0, 0.6) !default;\r\n\r\n$feed-metadata-element-spacing: 0.75em !default;\r\n\r\n//- Like */\r\n$feed-like-color: '' !default;\r\n$feed-like-hover-color: #FF2733 !default;\r\n$feed-like-active-color: #EF404A !default;\r\n$feed-like-transition: 0.2s color ease !default;\r\n\r\n//- Metadata Divider */\r\n$feed-metadata-divider: '' !default;\r\n$feed-metadata-divider-color: rgba(0, 0, 0, 0.2) !default;\r\n$feed-metadata-divider-offset: -1em !default;\r\n\r\n$feed-metadata-action-cursor: pointer !default;\r\n$feed-metadata-action-opacity: 1 !default;\r\n$feed-metadata-action-color: rgba(0, 0, 0, 0.5) !default;\r\n$feed-metadata-action-transition: color $default-duration $default-easing !default;\r\n\r\n$feed-metadata-action-hover-color: $selected-text-color !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n","\r\n//@-******************************  Item *******************************/\r\n\r\n//--------------------  View --------------------*/\r\n\r\n//- Group */\r\n$item-group-margin: 1.5em 0 !default;\r\n\r\n//- Item */\r\n$item-display: flex !default;\r\n$item-background: transparent !default;\r\n$item-border-radius: 0 !default;\r\n$item-min-height: 0 !default;\r\n$item-padding: 0 !default;\r\n$item-width: 100% !default;\r\n$item-box-shadow: none !default;\r\n$item-border: none !default;\r\n$item-z-index: '' !default;\r\n$item-transition: box-shadow $default-duration $default-easing !default;\r\n\r\n//- Responsive */\r\n$item-spacing: 1em !default;\r\n$item-image-width: 175px !default;\r\n$item-content-image-distance: 1.5em !default;\r\n\r\n$item-tablet-spacing: 1em !default;\r\n$item-tablet-image-width: 150px !default;\r\n$item-tablet-content-image-distance: 1em !default;\r\n\r\n$item-mobile-spacing: 2em !default;\r\n$item-mobile-image-width: auto !default;\r\n$item-mobile-image-max-height: 250px !default;\r\n$item-mobile-content-image-distance: 1.5em !default;\r\n\r\n\r\n//--------------------  Content --------------------*/\r\n\r\n//- Image */\r\n$item-image-display: block !default;\r\n$item-image-float: none !default;\r\n$item-image-max-height: '' !default;\r\n$item-image-vertical-align: start !default;\r\n$item-image-margin: 0 !default;\r\n$item-image-padding: 0 !default;\r\n$item-image-border: none !default;\r\n$item-image-border-radius: 0.125rem !default;\r\n$item-image-box-shadow: none !default;\r\n$item-image-border: none !default;\r\n\r\n//- Content */\r\n$item-content-display: block !default;\r\n$item-content-vertical-align: start !default;\r\n\r\n$item-content-width: auto !default;\r\n$item-content-offset: 0 !default;\r\n$item-content-background: none !default;\r\n$item-content-margin: 0 !default;\r\n$item-content-padding: 0 !default;\r\n$item-content-font-size: 1em !default;\r\n$item-content-border: none !default;\r\n$item-content-border-radius: 0 !default;\r\n$item-content-box-shadow: none !default;\r\n$item-content-color: $text-color !default;\r\n\r\n//- Header */\r\n$item-header-margin: (-$line-height-offset) 0 0 !default;\r\n$item-header-font-weight: $bold !default;\r\n$item-header-font-size: $relative-big !default;\r\n$item-header-color: $dark-text-color !default;\r\n\r\n//- Metadata */\r\n$item-meta-margin: 0.5em 0 0.5em !default;\r\n$item-meta-font-size: 1em !default;\r\n$item-meta-line-height: 1em !default;\r\n$item-meta-spacing: 0.3em !default;\r\n$item-meta-color: rgba(0, 0, 0, 0.6) !default;\r\n\r\n//- Icons */\r\n$item-action-opacity: 0.75 !default;\r\n$item-action-hover-opacity: 1 !default;\r\n$item-action-transition: color $default-duration $default-easing !default;\r\n\r\n//- Actions */\r\n$item-favorite-color: #FFB70A !default;\r\n$item-favorite-active-color: #FFE623 !default;\r\n$item-like-color: #FF2733 !default;\r\n$item-like-active-color: #FF2733 !default;\r\n\r\n//- Links */\r\n$item-header-link-color: $item-header-color !default;\r\n$item-header-link-hover-color: $link-hover-color !default;\r\n$item-meta-link-color: $light-text-color !default;\r\n$item-meta-link-hover-color: $text-color !default;\r\n$item-content-link-color: '' !default;\r\n$item-content-link-hover-color: '' !default;\r\n$item-content-link-transition: color $default-duration $default-easing !default;\r\n\r\n\r\n//- Description */\r\n$item-description-distance: 0.6em !default;\r\n$item-description-max-width: auto !default;\r\n$item-description-font-size: 1em !default;\r\n$item-description-line-height: $line-height !default;\r\n$item-description-color: $text-color !default;\r\n\r\n//- Content Image */\r\n$item-content-image-width: '' !default;\r\n$item-content-image-vertical-align: center !default;\r\n\r\n//- Avatar Image */\r\n$item-avatar-size: $item-content-image-width !default;\r\n$item-avatar-border-radius: $circular-radius !default;\r\n\r\n//- Paragraph */\r\n$item-paragraph-distance: 0.5em !default;\r\n\r\n//- Additional Content */\r\n$item-extra-divider: none !default;\r\n$item-extra-horizontal-spacing: 0.5rem !default;\r\n$item-extra-row-spacing: 0.5rem !default;\r\n\r\n$item-extra-background: none !default;\r\n$item-extra-display: block !default;\r\n$item-extra-position: relative !default;\r\n$item-extra-margin: (1rem - $item-extra-row-spacing) 0 0 !default;\r\n$item-extra-top: 0 !default;\r\n$item-extra-left: 0 !default;\r\n$item-extra-width: 100% !default;\r\n$item-extra-padding: 0 0 0 !default;\r\n$item-extra-box-shadow: none !default;\r\n$item-extra-color: $light-text-color !default;\r\n$item-extra-transition: color $default-duration $default-easing !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Relaxed */\r\n$item-relaxed-spacing: 1.5em !default;\r\n$item-very-relaxed-spacing: 2em !default;\r\n\r\n//- Divided */\r\n$item-divided-border: 1px solid $border-color !default;\r\n$item-divided-margin: 0 !default;\r\n$item-divided-padding: 1em 0 !default;\r\n\r\n$item-divided-first-last-margin: 0 !default;\r\n$item-divided-first-last-padding: 0 !default;\r\n\r\n\r\n//- Unstackable */\r\n$item-unstackable-mobile-image-width: 125px !default;\r\n\r\n//- Inverted */\r\n$item-inverted-background: $item-background !default;\r\n$item-inverted-content-background: $item-content-background !default;\r\n$item-inverted-extra-background: $item-extra-background !default;\r\n$item-inverted-header-color: $inverted-text-color !default;\r\n$item-inverted-header-link-color: $item-inverted-header-color !default;\r\n$item-inverted-header-link-hover-color: $inverted-hovered-text-color !default;\r\n$item-inverted-meta-link-color: $inverted-light-text-color !default;\r\n$item-inverted-meta-link-hover-color: $inverted-text-color !default;\r\n$item-inverted-content-color: $inverted-text-color !default;\r\n$item-inverted-content-link-color: lighten(saturate($link-color, 30), 25) !default;\r\n$item-inverted-content-link-hover-color: $link-color !default;\r\n$item-inverted-extra-color: $inverted-light-text-color !default;\r\n$item-inverted-description-color: $inverted-text-color !default;\r\n$item-inverted-meta-color: rgba(255, 255, 255, 0.8) !default;\r\n$item-inverted-like-color: lighten($item-like-color,10) !default;\r\n$item-inverted-like-active-color: lighten($item-like-active-color,10) !default;\r\n$item-inverted-favorite-color: lighten($item-favorite-color,10) !default;\r\n$item-inverted-favorite-active-color: lighten($item-favorite-active-color,10) !default;\r\n$item-inverted-divided-border: 1px solid $white-border-color !default;\r\n","\r\n//@-******************************  Statistic *******************************/\r\n\r\n//--------------------  View --------------------*/\r\n\r\n$statistic-vertical-margin: 1em !default;\r\n$statistic-margin: $statistic-vertical-margin 0 !default;\r\n$statistic-text-align: center !default;\r\n$statistic-max-width: none !default;\r\n\r\n//- Group */\r\n$statistic-horizontal-spacing: 1.5em !default;\r\n$statistic-row-spacing: 1em !default;\r\n$statistic-group-margin: $statistic-vertical-margin (-$statistic-horizontal-spacing) (-$statistic-row-spacing) !default;\r\n\r\n//- Group Element */\r\n$statistic-element-margin: 0 $statistic-horizontal-spacing $statistic-row-spacing !default;\r\n$statistic-element-max-width: $statistic-max-width !default;\r\n\r\n//--------------------  Content --------------------*/\r\n\r\n//- Value */\r\n$statistic-value-font: $page-font !default;\r\n$statistic-value-font-weight: $normal !default;\r\n$statistic-value-line-height: 1em !default;\r\n$statistic-value-color: $black !default;\r\n$statistic-value-text-transform: uppercase !default;\r\n\r\n//- Label */\r\n$statistic-label-size: $relative-medium !default;\r\n$statistic-top-label-distance: 0 !default;\r\n$statistic-bottom-label-distance: 0 !default;\r\n$statistic-label-font: $header-font !default;\r\n$statistic-label-font-weight: $bold !default;\r\n$statistic-label-color: $text-color !default;\r\n$statistic-label-line-height: $relative-large !default;\r\n$statistic-label-text-transform: uppercase !default;\r\n\r\n//- Text */\r\n$statistic-text-value-line-height: 1em !default;\r\n$statistic-text-value-min-height: 2em !default;\r\n$statistic-text-value-font-weight: $bold !default;\r\n\r\n//- Label Image */\r\n$statistic-image-height: 3rem !default;\r\n$statistic-image-vertical-align: baseline !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n$statistic-horizontal-group-element-margin: 1em 0 !default;\r\n$statistic-horizontal-label-distance: 0.75em !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Floated */\r\n$statistic-left-floated-margin: 0 2em 1em 0 !default;\r\n$statistic-right-floated-margin: 0 0 1em 2em !default;\r\n\r\n//- Inverted */\r\n$statistic-inverted-value-color: $white !default;\r\n$statistic-inverted-label-color: $inverted-text-color !default;\r\n\r\n//- Item Width */\r\n$statistic-item-group-margin: 0 0 (-$statistic-row-spacing) !default;\r\n$statistic-item-margin: 0 0 $statistic-row-spacing !default;\r\n\r\n//- Stackable */\r\n$statistic-stackable-row-spacing: 2rem !default;\r\n$statistic-stackable-gutter: 2rem !default;\r\n\r\n//- Size */\r\n$statistic-mini-text-value-size: 1rem !default;\r\n$statistic-mini-value-size: 1.5rem !default;\r\n$statistic-mini-horizontal-value-size: 1.5rem !default;\r\n\r\n$statistic-tiny-text-value-size: 1rem !default;\r\n$statistic-tiny-value-size: 2rem !default;\r\n$statistic-tiny-horizontal-value-size: 2rem !default;\r\n\r\n$statistic-small-text-value-size: 1rem !default;\r\n$statistic-small-value-size: 3rem !default;\r\n$statistic-small-horizontal-value-size: 2rem !default;\r\n\r\n$statistic-text-value-size: 2rem !default;\r\n$statistic-value-size: 4rem !default;\r\n$statistic-horizontal-value-size: 3rem !default;\r\n\r\n$statistic-large-text-value-size: 2.5rem !default;\r\n$statistic-large-value-size: 5rem !default;\r\n$statistic-large-horizontal-value-size: 4rem !default;\r\n\r\n$statistic-huge-text-value-size: 2.5rem !default;\r\n$statistic-huge-value-size: 6rem !default;\r\n$statistic-huge-horizontal-value-size: 5rem !default;\r\n","\r\n//@-******************************  Accordion *******************************/\r\n\r\n$accordion-box-shadow: none !default;\r\n\r\n//- Title */\r\n$accordion-title-font: $header-font !default;\r\n$accordion-title-padding: 0.5em 0 !default;\r\n$accordion-title-font-size: 1em !default;\r\n$accordion-title-color: $text-color !default;\r\n\r\n//- Icon */\r\n$accordion-icon-opacity: 1 !default;\r\n$accordion-icon-font-size: 1em !default;\r\n$accordion-icon-float: none !default;\r\n$accordion-icon-width: 1.25em !default;\r\n$accordion-icon-height: 1em !default;\r\n$accordion-icon-display: inline-block !default;\r\n$accordion-icon-margin: 0 0.25rem 0 0 !default;\r\n$accordion-icon-padding: 0 !default;\r\n$accordion-icon-transition:\r\n  transform $default-duration $default-easing,\r\n  opacity $default-duration $default-easing\r\n !default;\r\n$accordion-icon-vertical-align: baseline !default;\r\n$accordion-icon-transform: none !default;\r\n\r\n//- Child Accordion */\r\n$accordion-child-margin: 1em 0 0 !default;\r\n$accordion-child-padding: 0 !default;\r\n\r\n//- Content */\r\n$accordion-content-margin: '' !default;\r\n$accordion-content-padding: 0.5em 0 1em !default;\r\n\r\n//--------------------  Coupling --------------------*/\r\n\r\n$accordion-menu-title-padding: 0 !default;\r\n$accordion-menu-icon-float: right !default;\r\n$accordion-menu-icon-margin: $line-height-offset 0 0 1em !default;\r\n$accordion-menu-icon-transform: rotate(180deg) !default;\r\n\r\n\r\n//--------------------  States --------------------*/\r\n\r\n$accordion-active-icon-transform: rotate(90deg) !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Styled */\r\n$accordion-styled-width: 600px !default;\r\n$accordion-styled-background: $white !default;\r\n$accordion-styled-border-radius: $default-border-radius !default;\r\n$accordion-styled-box-shadow:\r\n  $subtle-shadow,\r\n  0 0 0 1px $border-color\r\n !default;\r\n\r\n//- Content */\r\n$accordion-styled-content-margin: 0 !default;\r\n$accordion-styled-content-padding: 0.5em 1em 1.5em !default;\r\n\r\n//- Child Content */\r\n$accordion-styled-child-content-margin: 0 !default;\r\n$accordion-styled-child-content-padding: $accordion-styled-content-padding !default;\r\n\r\n//- Styled Title */\r\n$accordion-styled-title-margin: 0 !default;\r\n$accordion-styled-title-padding: 0.75em 1em !default;\r\n$accordion-styled-title-font-weight: $bold !default;\r\n$accordion-styled-title-color: $unselected-text-color !default;\r\n$accordion-styled-title-transition: background-color $default-duration $default-easing !default;\r\n$accordion-styled-title-border: 1px solid $border-color !default;\r\n$accordion-styled-title-transition:\r\n  background $default-duration $default-easing,\r\n  color $default-duration $default-easing\r\n !default;\r\n\r\n//- Styled Title States */\r\n$accordion-styled-title-hover-background: transparent !default;\r\n$accordion-styled-title-hover-color: $text-color !default;\r\n$accordion-styled-active-title-background: transparent !default;\r\n$accordion-styled-active-title-color: $selected-text-color !default;\r\n\r\n//- Styled Child Title States */\r\n$accordion-styled-hover-child-title-background: $accordion-styled-title-hover-background !default;\r\n$accordion-styled-hover-child-title-color: $accordion-styled-title-hover-color !default;\r\n$accordion-styled-active-child-title-background: $accordion-styled-active-title-background !default;\r\n$accordion-styled-active-child-title-color: $accordion-styled-active-title-color !default;\r\n\r\n//- Inverted */\r\n$accordion-inverted-title-color: $inverted-text-color !default;\r\n\r\n","\r\n//@-******************************  Calendar *******************************/\r\n\r\n$calendar-focus-box-shadow: inset 0 0 0 1px $focused-form-border-color !default;\r\n$calendar-focus-inverted-box-shadow: inset 0 0 0 1px $focused-form-border-color !default;\r\n\r\n$calendar-today-font-weight: bold !default;\r\n\r\n$calendar-range-background: $transparent-black !default;\r\n$calendar-range-text-color: $selected-text-color !default;\r\n$calendar-range-box-shadow: none !default;\r\n$calendar-range-inverted-background: $transparent-white !default;\r\n$calendar-range-inverted-text-color: $inverted-selected-text-color !default;\r\n$calendar-range-inverted-box-shadow: none !default;\r\n\r\n$calendar-adjacent-text-color: $muted-text-color !default;\r\n$calendar-adjacent-background: $subtle-transparent-black !default;\r\n","\r\n//@-****************************** Checkbox *******************************/\r\n\r\n$checkbox-size: 17px !default;\r\n$checkbox-color: $text-color !default;\r\n$checkbox-line-height: $checkbox-size !default;\r\n\r\n\r\n//- Label */\r\n$checkbox-label-distance: 1.85714em !default; //- 26px @ 14/em */\r\n\r\n//- Checkbox */\r\n$checkbox-background: $white !default;\r\n$checkbox-border: 1px solid $solid-border-color !default;\r\n$checkbox-border-radius: $_3px !default;\r\n$checkbox-transition:\r\n  border $default-duration $default-easing,\r\n  opacity $default-duration $default-easing,\r\n  transform $default-duration $default-easing,\r\n  box-shadow $default-duration $default-easing\r\n !default;\r\n\r\n//- Checkmark */\r\n$checkbox-check-font-size: 14px !default;\r\n$checkbox-check-top: 0 !default;\r\n$checkbox-check-left: 0 !default;\r\n$checkbox-check-size: $checkbox-size !default;\r\n\r\n//- Label */\r\n$checkbox-label-font-size: $relative-medium !default;\r\n$checkbox-label-color: $text-color !default;\r\n$checkbox-label-transition: color $default-duration $default-easing !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n//- Hover */\r\n$checkbox-hover-background: $checkbox-background !default;\r\n$checkbox-hover-border-color: $selected-border-color !default;\r\n$checkbox-label-hover-color: $hovered-text-color !default;\r\n\r\n//- Pressed */\r\n$checkbox-pressed-background: $off-white !default;\r\n$checkbox-pressed-border-color: $selected-border-color !default;\r\n$checkbox-pressed-color: $selected-text-color !default;\r\n$checkbox-label-pressed-color: $selected-text-color !default;\r\n\r\n//- Focus */\r\n$checkbox-focus-background: $white !default;\r\n$checkbox-focus-border-color: $focused-form-muted-border-color !default;\r\n$checkbox-focus-check-color: $selected-text-color !default;\r\n$checkbox-label-focus-color: $selected-text-color !default;\r\n\r\n//- Active */\r\n$checkbox-label-active-color: $selected-text-color !default;\r\n$checkbox-active-background: $white !default;\r\n$checkbox-active-border-color: $selected-border-color !default;\r\n$checkbox-active-check-color: $selected-text-color !default;\r\n$checkbox-active-check-opacity: 1 !default;\r\n\r\n//- Active Focus */\r\n$checkbox-active-focus-background: $white !default;\r\n$checkbox-active-focus-border-color: $checkbox-focus-border-color !default;\r\n$checkbox-active-focus-check-color: $selected-text-color !default;\r\n\r\n//- Indeterminate */\r\n$checkbox-indeterminate-background: $checkbox-active-background !default;\r\n$checkbox-indeterminate-border-color: $checkbox-active-border-color !default;\r\n$checkbox-indeterminate-check-opacity: 1 !default;\r\n$checkbox-indeterminate-check-color: $checkbox-active-check-color !default;\r\n\r\n//- Disabled */\r\n$checkbox-disabled-opacity: 0.5 !default;\r\n$checkbox-disabled-label-color: rgba(0, 0, 0, 1) !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Radio */\r\n//- Uses px to avoid rounding issues with circles */\r\n\r\n$checkbox-radio-size: 15px !default;\r\n$checkbox-radio-top: 1px !default;\r\n$checkbox-radio-left: 0 !default;\r\n$checkbox-radio-label-distance: $checkbox-label-distance !default;\r\n\r\n$checkbox-bullet-top: 1px !default;\r\n$checkbox-bullet-left: 0 !default;\r\n$checkbox-bullet-scale: (7 / 15) !default; //- 7px as unitless value from radio size */\r\n$checkbox-bullet-color: $text-color !default;\r\n$checkbox-bullet-radius: $circular-radius !default;\r\n\r\n$checkbox-radio-focus-background: $checkbox-focus-background !default;\r\n$checkbox-radio-focus-bullet-color: $checkbox-focus-check-color !default;\r\n\r\n$checkbox-radio-active-background: $checkbox-active-background !default;\r\n$checkbox-radio-active-bullet-color: $checkbox-active-check-color !default;\r\n\r\n$checkbox-radio-active-focus-background: $checkbox-active-focus-background !default;\r\n$checkbox-radio-active-focus-bullet-color: $checkbox-active-focus-check-color !default;\r\n\r\n//- Slider & Toggle Handle */\r\n$checkbox-handle-background: $white $subtle-gradient !default;\r\n$checkbox-handle-box-shadow:\r\n  $subtle-shadow,\r\n  0 0 0 1px $border-color inset\r\n !default;\r\n\r\n//- Slider */\r\n$checkbox-slider-handle-size: 1.5rem !default;\r\n$checkbox-slider-line-width: 3.5rem !default;\r\n$checkbox-slider-transition-duration: 0.3s !default;\r\n\r\n$checkbox-slider-handle-offset: (1rem - $checkbox-slider-handle-size) / 2 !default;\r\n$checkbox-slider-handle-transition: left $checkbox-slider-transition-duration $default-easing !default;\r\n\r\n$checkbox-slider-width: $checkbox-slider-line-width !default;\r\n$checkbox-slider-height: ($checkbox-slider-handle-size + $checkbox-slider-handle-offset) !default;\r\n\r\n$checkbox-slider-line-height: $_3px !default;\r\n$checkbox-slider-line-vertical-offset: 0.4rem !default;\r\n$checkbox-slider-line-color: $transparent-black !default;\r\n$checkbox-slider-line-radius: $circular-radius !default;\r\n$checkbox-slider-line-transition: background $checkbox-slider-transition-duration $default-easing !default;\r\n\r\n$checkbox-slider-travel-distance: $checkbox-slider-line-width - $checkbox-slider-handle-size !default;\r\n\r\n$checkbox-slider-label-distance: $checkbox-slider-line-width + 1rem !default;\r\n$checkbox-slider-off-label-color: $unselected-text-color !default;\r\n\r\n$checkbox-slider-label-line-height: 1rem !default;\r\n\r\n//- Slider States */\r\n$checkbox-slider-hover-lane-background: $very-strong-transparent-black !default;\r\n$checkbox-slider-hover-label-color: $hovered-text-color !default;\r\n\r\n$checkbox-slider-on-line-color: $light-black !default;\r\n$checkbox-slider-on-label-color: $selected-text-color !default;\r\n\r\n$checkbox-slider-on-focus-line-color: $light-black-focus !default;\r\n$checkbox-slider-on-focus-label-color: $checkbox-slider-on-label-color !default;\r\n\r\n\r\n\r\n//- Toggle */\r\n$checkbox-toggle-lane-width: 3.5rem !default;\r\n$checkbox-toggle-handle-size: 1.5rem !default;\r\n$checkbox-toggle-transition-duration: 0.2s !default;\r\n\r\n$checkbox-toggle-width: $checkbox-toggle-lane-width !default;\r\n$checkbox-toggle-height: $checkbox-toggle-handle-size !default;\r\n\r\n$checkbox-toggle-handle-radius: $circular-radius !default;\r\n$checkbox-toggle-handle-offset: 0 !default;\r\n$checkbox-toggle-handle-transition:\r\n  background $checkbox-slider-transition-duration $default-easing,\r\n  left $checkbox-slider-transition-duration $default-easing\r\n !default;\r\n\r\n$checkbox-toggle-lane-background: $transparent-black !default;\r\n$checkbox-toggle-lane-height: $checkbox-toggle-handle-size !default;\r\n$checkbox-toggle-lane-box-shadow: none !default;\r\n$checkbox-toggle-lane-vertical-offset: 0 !default;\r\n$checkbox-toggle-off-offset: -0.05rem !default;\r\n$checkbox-toggle-on-offset: ($checkbox-toggle-lane-width - $checkbox-toggle-handle-size) + 0.15rem !default;\r\n$checkbox-toggle-center-offset: $checkbox-toggle-on-offset / 2 !default;\r\n$checkbox-toggle-center-lane-background: $very-strong-transparent-black !default;\r\n\r\n$checkbox-toggle-label-distance: $checkbox-toggle-lane-width + 1rem !default;\r\n$checkbox-toggle-label-line-height: 1.5rem !default;\r\n$checkbox-toggle-label-offset: 0.15em !default;\r\n\r\n\r\n$checkbox-toggle-focus-color: $very-strong-transparent-black !default;\r\n$checkbox-toggle-hover-color: $checkbox-toggle-focus-color !default;\r\n\r\n$checkbox-toggle-off-label-color: $checkbox-color !default;\r\n$checkbox-toggle-off-handle-box-shadow: $checkbox-handle-box-shadow !default;\r\n\r\n$checkbox-toggle-on-label-color: $selected-text-color !default;\r\n$checkbox-toggle-on-lane-color: $primary-color !default;\r\n\r\n$checkbox-toggle-on-handle-box-shadow: $checkbox-handle-box-shadow !default;\r\n\r\n$checkbox-toggle-on-focus-lane-color: $primary-color-focus !default;\r\n$checkbox-toggle-on-focus-label-color: $checkbox-toggle-on-label-color !default;\r\n\r\n\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Inverted */\r\n$checkbox-inverted-hover-background: $black !default;\r\n\r\n$checkbox-mini-size: $relative-mini !default;\r\n$checkbox-mini-circle-scale: $mini-raw / 2 !default;\r\n$checkbox-mini-circle-left: join-value-to-unit(($mini-raw - $checkbox-mini-circle-scale) / 2 + 0.05 , em) !default;\r\n$checkbox-tiny-size: $relative-tiny !default;\r\n$checkbox-tiny-circle-scale: $tiny-raw / 2 !default;\r\n$checkbox-tiny-circle-left: join-value-to-unit(($tiny-raw - $checkbox-tiny-circle-scale) / 2 + 0.05 , em) !default;\r\n$checkbox-small-size: $relative-small !default;\r\n$checkbox-small-circle-scale: $small-raw / 2 !default;\r\n$checkbox-small-circle-left: join-value-to-unit(($small-raw - $checkbox-small-circle-scale) / 2 + 0.05 , em) !default;\r\n$checkbox-large-size: $relative-large !default;\r\n$checkbox-large-circle-scale: $large-raw / 2 !default;\r\n$checkbox-large-circle-left: join-value-to-unit(($large-raw - $checkbox-large-circle-scale) / 2 + 0.05 , em) !default;\r\n$checkbox-big-size: $relative-big !default;\r\n$checkbox-big-circle-scale: $big-raw / 2 !default;\r\n$checkbox-big-circle-left: join-value-to-unit(($big-raw - $checkbox-big-circle-scale) / 2 + 0.05 , em) !default;\r\n$checkbox-huge-size: $relative-huge !default;\r\n$checkbox-huge-circle-scale: $huge-raw / 2 !default;\r\n$checkbox-huge-circle-left: join-value-to-unit(($huge-raw - $checkbox-huge-circle-scale) / 2 + 0.05 , em) !default;\r\n$checkbox-massive-size: $relative-massive !default;\r\n$checkbox-massive-circle-scale: $massive-raw / 2 !default;\r\n$checkbox-massive-circle-left: join-value-to-unit(($massive-raw - $checkbox-massive-circle-scale) / 2 + 0.05 , em) !default;\r\n\r\n\r\n//- Size */\r\n$checkbox-variation-sizes: (\r\n  mini: (\r\n    raw: $mini-raw,\r\n    size: $checkbox-mini-size,\r\n    circleScale: $checkbox-mini-circle-scale,\r\n    circleLeft: $checkbox-mini-circle-left\r\n  ),\r\n  tiny: (\r\n    raw: $tiny-raw,\r\n    size: $checkbox-tiny-size,\r\n    circleScale: $checkbox-tiny-circle-scale,\r\n    circleLeft: $checkbox-tiny-circle-left\r\n  ),\r\n  small: (\r\n    raw: $small-raw,\r\n    size: $checkbox-small-size,\r\n    circleScale: $checkbox-small-circle-scale,\r\n    circleLeft: $checkbox-small-circle-left\r\n  ),\r\n  large: (\r\n    raw: $large-raw,\r\n    size: $checkbox-large-size,\r\n    circleScale: $checkbox-large-circle-scale,\r\n    circleLeft: $checkbox-large-circle-left\r\n  ),\r\n  big: (\r\n    raw: $big-raw,\r\n    size: $checkbox-big-size,\r\n    circleScale: $checkbox-big-circle-scale,\r\n    circleLeft: $checkbox-big-circle-left\r\n  ),\r\n  huge: (\r\n    raw: $huge-raw,\r\n    size: $checkbox-huge-size,\r\n    circleScale: $checkbox-huge-circle-scale,\r\n    circleLeft: $checkbox-huge-circle-left\r\n  ),\r\n  massive: (\r\n    raw: $massive-raw,\r\n    size: $checkbox-massive-size,\r\n    circleScale: $checkbox-massive-circle-scale,\r\n    circleLeft: $checkbox-massive-circle-left\r\n  )\r\n) !default;","\r\n//@-****************************** Dimmer *******************************/\r\n\r\n$dimmer-dimmable-position: relative !default;\r\n$dimmer-position: absolute !default;\r\n\r\n$dimmer-background-color: rgba(0, 0, 0 , 0.85) !default;\r\n$dimmer-line-height: 1 !default;\r\n$dimmer-perspective: 2000px !default;\r\n$dimmer-padding: 1em !default;\r\n\r\n$dimmer-duration: 0.5s !default;\r\n$dimmer-transition:\r\n  background-color $dimmer-duration linear\r\n !default;\r\n$dimmer-z-index: 1000 !default;\r\n$dimmer-text-align: center !default;\r\n$dimmer-vertical-align: middle !default;\r\n$dimmer-text-color: $white !default;\r\n$dimmer-overflow: hidden !default;\r\n\r\n$dimmer-blurred-start-filter: initial !default;\r\n$dimmer-blurred-end-filter: blur(5px) grayscale(0.7) !default;\r\n$dimmer-blurred-transition: 800ms filter $default-easing !default;\r\n\r\n$dimmer-blurred-background-color: rgba(0, 0, 0, 0.6) !default;\r\n$dimmer-blurred-inverted-background-color: rgba(255, 255, 255, 0.6) !default;\r\n\r\n//- Hidden (Default) */\r\n$dimmer-hidden-opacity: 0 !default;\r\n\r\n//- Visible */\r\n$dimmer-visible-opacity: 1 !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Page Dimmer*/\r\n$dimmer-transform-style: '' !default;\r\n$dimmer-page-position: fixed !default;\r\n\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Inverted */\r\n$dimmer-inverted-background-color: rgba(255, 255, 255, 0.85) !default;\r\n$dimmer-inverted-text-color: $full-black !default;\r\n\r\n//- Simple */\r\n$dimmer-simple-z-index: 1 !default;\r\n$dimmer-simple-start-background-color: rgba(0, 0, 0, 0) !default;\r\n$dimmer-simple-end-background-color: $dimmer-background-color !default;\r\n$dimmer-simple-inverted-start-background-color: rgba(255, 255, 255, 0) !default;\r\n$dimmer-simple-inverted-end-background-color: $dimmer-inverted-background-color !default;\r\n\r\n//- Intensity */\r\n$dimmer-very-light-background-color: rgba(0,0,0,.25) !default;\r\n$dimmer-light-background-color: rgba(0,0,0,.45) !default;\r\n$dimmer-medium-background-color: rgba(0,0,0,.65) !default;\r\n$dimmer-very-light-inverted-background-color: rgba(255,255,255,.25) !default;\r\n$dimmer-light-inverted-background-color: rgba(255,255,255,.45) !default;\r\n$dimmer-medium-inverted-background-color: rgba(255,255,255,.65) !default;","\r\n//@-****************************** Dropdown *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$dropdown-transition: box-shadow $default-duration $default-easing, width $default-duration $default-easing !default;\r\n$dropdown-border-radius: $default-border-radius !default;\r\n\r\n$dropdown-raised-shadow: 0 2px 3px 0 $border-color !default;\r\n\r\n//--------------------  Content --------------------*/\r\n\r\n//- Icon */\r\n$dropdown-icon-size: $relative12px !default;\r\n$dropdown-icon-margin: 0 0 0 1em !default;\r\n\r\n//- Current Text */\r\n$dropdown-text-transition: none !default;\r\n\r\n//- Menu */\r\n$dropdown-menu-background: #ffffff !default;\r\n$dropdown-menu-margin: 0 !default;\r\n$dropdown-menu-padding: 0 0 !default;\r\n$dropdown-menu-top: 100% !default;\r\n$dropdown-menu-text-align: left !default;\r\n\r\n$dropdown-menu-border-width: 1px !default;\r\n$dropdown-menu-border-color: $border-color !default;\r\n$dropdown-menu-border: $dropdown-menu-border-width solid $dropdown-menu-border-color !default;\r\n$dropdown-menu-box-shadow: $dropdown-raised-shadow !default;\r\n$dropdown-menu-border-radius: $dropdown-border-radius !default;\r\n$dropdown-menu-transition: opacity $default-duration $default-easing !default;\r\n$dropdown-menu-min-width: calc(100% + #{$dropdown-menu-border-width * 2}) !default;\r\n$dropdown-menu-z-index: 11 !default;\r\n\r\n//- Text */\r\n$dropdown-text-line-height: 1em !default;\r\n$dropdown-text-line-height-offset: ($dropdown-text-line-height - 1em) !default;\r\n$dropdown-text-cursor-spacing: 1px !default;\r\n\r\n//- Menu Item */\r\n$dropdown-item-font-size: $medium !default;\r\n$dropdown-item-text-align: left !default;\r\n$dropdown-item-border: none !default;\r\n$dropdown-item-height: auto !default;\r\n$dropdown-item-divider: none !default;\r\n$dropdown-item-color: $text-color !default;\r\n$dropdown-item-vertical-padding: $mini !default;\r\n$dropdown-item-horizontal-padding: $large !default;\r\n$dropdown-item-padding: $dropdown-item-vertical-padding $dropdown-item-horizontal-padding !default;\r\n$dropdown-item-font-weight: $normal !default;\r\n$dropdown-item-line-height: 1em !default;\r\n$dropdown-item-line-height-offset: ($dropdown-item-line-height - 1em) !default;\r\n$dropdown-item-text-transform: none !default;\r\n$dropdown-item-box-shadow: none !default;\r\n\r\n//- Sub Menu */\r\n$dropdown-sub-menu-top: 0 !default;\r\n$dropdown-sub-menu-left: 100% !default;\r\n$dropdown-sub-menu-right: auto !default;\r\n$dropdown-sub-menu-distance-away: -0.5em !default;\r\n$dropdown-sub-menu-margin: 0 0 0 $dropdown-sub-menu-distance-away !default;\r\n$dropdown-sub-menu-border-radius: $dropdown-border-radius !default;\r\n$dropdown-sub-menu-z-index: 21 !default;\r\n\r\n//- Menu Header */\r\n$dropdown-menu-header-color: $dark-text-color !default;\r\n$dropdown-menu-header-font-size: $relative11px !default;\r\n$dropdown-menu-header-font-weight: $bold !default;\r\n$dropdown-menu-header-text-transform: uppercase !default;\r\n$dropdown-menu-header-margin: 1rem 0 0.75rem !default;\r\n$dropdown-menu-header-padding: 0 $dropdown-item-horizontal-padding !default;\r\n\r\n//- Menu Divider */\r\n$dropdown-menu-divider-margin: 0.5em 0 !default;\r\n$dropdown-menu-divider-color: $internal-border-color !default;\r\n$dropdown-menu-divider-size: 1px !default;\r\n$dropdown-menu-divider-border: $dropdown-menu-divider-size solid $dropdown-menu-divider-color !default;\r\n\r\n//- Menu Input */\r\n$dropdown-menu-input-margin: $large $mini !default;\r\n$dropdown-menu-input-min-width: 10rem !default;\r\n$dropdown-menu-input-vertical-padding: 0.5em !default;\r\n$dropdown-menu-input-horizontal-padding: $input-horizontal-padding !default;\r\n$dropdown-menu-input-padding: $dropdown-menu-input-vertical-padding $dropdown-menu-input-horizontal-padding !default;\r\n\r\n//- Menu Image */\r\n$dropdown-menu-image-max-height: 2em !default;\r\n$dropdown-menu-image-vertical-margin: -($dropdown-menu-image-max-height - 1em) / 2 !default;\r\n\r\n//- Item Sub-Element */\r\n$dropdown-item-element-float: none !default;\r\n$dropdown-item-element-distance: $mini !default;\r\n$dropdown-item-element-bottom-distance: $dropdown-item-element-distance / 2 !default;\r\n\r\n//- Sub-Menu Dropdown Icon */\r\n$dropdown-item-icon-distance: 1em !default;\r\n$dropdown-item-icon-float: right !default;\r\n$dropdown-item-icon-margin: $dropdown-item-line-height-offset 0 0 $dropdown-item-icon-distance !default;\r\n\r\n//- Description */\r\n$dropdown-item-description-float: right !default;\r\n$dropdown-item-description-margin: 0 0 0 1em !default;\r\n$dropdown-item-description-color: $light-text-color !default;\r\n\r\n//-------------  Selection --------------*/\r\n\r\n$dropdown-selection-min-width: 14em !default;\r\n$dropdown-selection-vertical-padding: $input-vertical-padding !default;\r\n$dropdown-selection-horizontal-padding: $input-horizontal-padding !default;\r\n$dropdown-selection-border-em-width: $relative1px !default;\r\n$dropdown-selection-min-height: $input-line-height + ($dropdown-selection-vertical-padding * 2) -\r\n  $dropdown-selection-border-em-width !default;\r\n$dropdown-selection-background: $input-background !default;\r\n$dropdown-selection-display: inline-block !default;\r\n$dropdown-selection-icon-distance: $input-horizontal-padding + ($glyph-width * 2) !default;\r\n$dropdown-selection-padding: $dropdown-selection-vertical-padding $dropdown-selection-icon-distance\r\n  $dropdown-selection-vertical-padding $dropdown-selection-horizontal-padding !default;\r\n$dropdown-selection-z-index: 10 !default;\r\n\r\n$dropdown-selection-item-horizontal-padding: $dropdown-item-horizontal-padding !default;\r\n$dropdown-selection-item-vertical-padding: $dropdown-item-vertical-padding !default;\r\n$dropdown-selection-item-padding: $dropdown-selection-item-vertical-padding $dropdown-selection-item-horizontal-padding !default;\r\n$dropdown-selection-item-divider: 1px solid $solid-internal-border-color !default;\r\n$dropdown-selection-message-padding: $dropdown-selection-item-padding !default;\r\n\r\n//- <select> */\r\n$dropdown-select-border: 1px solid $border-color !default;\r\n$dropdown-select-padding: 0.5em !default;\r\n$dropdown-select-visibility: visible !default;\r\n$dropdown-select-height: 38px !default;\r\n\r\n$dropdown-selection-text-color: $text-color !default;\r\n\r\n$dropdown-selection-text-underlay-icon-opacity: $disabled-opacity !default;\r\n$dropdown-selection-text-underlay-color: $input-placeholder-focus-color !default;\r\n\r\n$dropdown-selection-box-shadow: none !default;\r\n$dropdown-selection-border-color: $border-color !default;\r\n$dropdown-selection-border: 1px solid $dropdown-selection-border-color !default;\r\n$dropdown-selection-border-radius: $dropdown-border-radius !default;\r\n\r\n$dropdown-selection-icon-opacity: 0.8 !default;\r\n$dropdown-selection-icon-z-index: 3 !default;\r\n$dropdown-selection-icon-hitbox: $dropdown-selection-vertical-padding !default;\r\n$dropdown-selection-icon-margin: -$dropdown-selection-icon-hitbox !default;\r\n$dropdown-selection-icon-padding: join-value-to-unit($dropdown-selection-icon-hitbox / $dropdown-icon-size, em) !default;\r\n$dropdown-selection-icon-transition: opacity $default-duration $default-easing !default;\r\n\r\n$dropdown-selection-menu-border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius !default;\r\n$dropdown-selection-menu-box-shadow: $dropdown-raised-shadow !default;\r\n$dropdown-selection-menu-item-box-shadow: none !default;\r\n\r\n$dropdown-selection-transition: $dropdown-transition !default;\r\n$dropdown-selection-menu-transition: $dropdown-menu-transition !default;\r\n\r\n//- Message */\r\n$dropdown-message-padding: $dropdown-selection-item-padding !default;\r\n$dropdown-message-font-weight: $normal !default;\r\n$dropdown-message-color: $unselected-text-color !default;\r\n\r\n//- Floated Content */\r\n$dropdown-floated-distance: 1em !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Responsive */\r\n$dropdown-selection-mobile-max-items: 3 !default;\r\n$dropdown-selection-tablet-max-items: 4 !default;\r\n$dropdown-selection-computer-max-items: 6 !default;\r\n$dropdown-selection-widescreen-max-items: 8 !default;\r\n\r\n//- Derived */\r\n$dropdown-selected-border-em-width: 0.1em !default; //- 1px / em size */\r\n$dropdown-selection-item-height: strip-unit($dropdown-selection-item-vertical-padding * 2) + $dropdown-item-line-height +\r\n  $dropdown-selected-border-em-width !default;\r\n$dropdown-selection-mobile-max-menu-height: ($dropdown-selection-item-height * $dropdown-selection-mobile-max-items) !default;\r\n$dropdown-selection-tablet-max-menu-height: ($dropdown-selection-item-height * $dropdown-selection-tablet-max-items) !default;\r\n$dropdown-selection-computer-max-menu-height: (\r\n  $dropdown-selection-item-height * $dropdown-selection-computer-max-items\r\n) !default;\r\n$dropdown-selection-widescreen-max-menu-height: (\r\n  $dropdown-selection-item-height * $dropdown-selection-widescreen-max-items\r\n) !default;\r\n\r\n//- Hover */\r\n$dropdown-selection-hover-border-color: $selected-border-color !default;\r\n$dropdown-selection-hover-box-shadow: none !default;\r\n\r\n//- Focus */\r\n$dropdown-selection-focus-border-color: $focused-form-muted-border-color !default;\r\n$dropdown-selection-focus-box-shadow: none !default;\r\n$dropdown-selection-focus-menu-box-shadow: $dropdown-raised-shadow !default;\r\n\r\n//- Visible */\r\n$dropdown-selection-visible-text-font-weight: $normal !default;\r\n$dropdown-selection-visible-text-color: $hovered-text-color !default;\r\n\r\n$dropdown-selection-visible-border-color: $focused-form-muted-border-color !default;\r\n$dropdown-selection-visible-box-shadow: $dropdown-raised-shadow !default;\r\n$dropdown-selection-visible-menu-box-shadow: $dropdown-raised-shadow !default;\r\n\r\n//- Visible Hover */\r\n$dropdown-selection-active-hover-border-color: $focused-form-muted-border-color !default;\r\n$dropdown-selection-active-hover-box-shadow: $dropdown-selection-visible-box-shadow !default;\r\n$dropdown-selection-active-hover-menu-box-shadow: $dropdown-selection-visible-menu-box-shadow !default;\r\n\r\n$dropdown-selection-visible-connecting-border: 0 !default;\r\n$dropdown-selection-visible-icon-opacity: '' !default;\r\n\r\n//---------------  Search --------------*/\r\n\r\n$dropdown-search-min-width: '' !default;\r\n\r\n//- Search Selection */\r\n$dropdown-search-selection-line-height: $input-line-height !default;\r\n$dropdown-search-selection-line-height-offset: (($dropdown-search-selection-line-height - 1em) / 2) !default;\r\n$dropdown-search-selection-vertical-padding: (\r\n  $dropdown-selection-vertical-padding - $dropdown-search-selection-line-height-offset\r\n) !default;\r\n$dropdown-search-selection-horizontal-padding: $dropdown-selection-horizontal-padding !default;\r\n$dropdown-search-selection-input-padding: $dropdown-search-selection-vertical-padding $dropdown-selection-icon-distance\r\n  $dropdown-search-selection-vertical-padding $dropdown-search-selection-horizontal-padding !default;\r\n\r\n$dropdown-search-mobile-max-menu-height: $dropdown-selection-mobile-max-menu-height !default;\r\n$dropdown-search-tablet-max-menu-height: $dropdown-selection-tablet-max-menu-height !default;\r\n$dropdown-search-computer-max-menu-height: $dropdown-selection-computer-max-menu-height !default;\r\n$dropdown-search-widescreen-max-menu-height: $dropdown-selection-widescreen-max-menu-height !default;\r\n\r\n//- Inline */\r\n$dropdown-inline-icon-margin: 0 $relative3px 0 $relative3px !default;\r\n$dropdown-inline-text-color: inherit !default;\r\n$dropdown-inline-text-font-weight: $bold !default;\r\n$dropdown-inline-menu-distance: $relative3px !default;\r\n$dropdown-inline-menu-border-radius: $dropdown-border-radius !default;\r\n\r\n//--------------- Multiple --------------*/\r\n\r\n//- Split Actual Padding Between Child and Parent (allows for label spacing) */\r\n$dropdown-multiple-selection-vertical-padding: ($dropdown-search-selection-vertical-padding * (1/3)) !default;\r\n$dropdown-multiple-selection-left-padding: $relative5px !default;\r\n$dropdown-multiple-selection-right-padding: $dropdown-selection-icon-distance !default;\r\n$dropdown-multiple-selection-padding: $dropdown-multiple-selection-vertical-padding\r\n  $dropdown-multiple-selection-right-padding $dropdown-multiple-selection-vertical-padding\r\n  $dropdown-multiple-selection-left-padding !default;\r\n\r\n//- Child Elements */\r\n$dropdown-multiple-selection-child-vertical-margin: ($dropdown-search-selection-vertical-padding * (2/3)) !default;\r\n$dropdown-multiple-selection-child-left-margin: ($input-horizontal-padding - $dropdown-multiple-selection-left-padding) !default;\r\n$dropdown-multiple-selection-child-margin: $dropdown-multiple-selection-child-vertical-margin 0\r\n  $dropdown-multiple-selection-child-vertical-margin $dropdown-multiple-selection-child-left-margin !default;\r\n$dropdown-multiple-selection-child-line-height: $relative17px !default;\r\n$dropdown-multiple-selection-search-start-width: ($glyph-width * 2) !default;\r\n\r\n//- Dropdown Icon */\r\n$dropdown-multiple-selection-icon-margin: '' !default;\r\n$dropdown-multiple-selection-icon-padding: '' !default;\r\n\r\n$dropdown-multiple-selection-search-after-label-distance: $relative2px !default;\r\n\r\n//- Selection Label */\r\n$dropdown-label-size: $relative-medium !default;\r\n$dropdown-label-horizontal-margin: $_4px !default;\r\n$dropdown-label-vertical-margin: $_2px !default;\r\n$dropdown-label-margin: $dropdown-label-vertical-margin $dropdown-label-horizontal-margin\r\n  $dropdown-label-vertical-margin 0 !default;\r\n$dropdown-label-border-width: 1px !default;\r\n$dropdown-label-box-shadow: 0 0 0 $dropdown-label-border-width $border-color inset !default;\r\n\r\n$dropdown-label-vertical-padding: $relative5px !default;\r\n$dropdown-label-horizontal-padding: $relative-mini !default;\r\n$dropdown-label-padding: $dropdown-label-vertical-padding $dropdown-label-horizontal-padding !default;\r\n\r\n$dropdown-image-label-height: (1em + $dropdown-label-vertical-padding * 2) !default; //- Logic adopted from label.less */\r\n$dropdown-image-label-image-margin: (-$dropdown-label-vertical-padding) $dropdown-label-horizontal-padding (-$dropdown-label-vertical-padding) (-$dropdown-label-horizontal-padding) !default;\r\n\r\n//--------------------  States --------------------*/\r\n\r\n//- Hovered */\r\n$dropdown-hovered-item-background: $transparent-black !default;\r\n$dropdown-hovered-item-color: $selected-text-color !default;\r\n$dropdown-hovered-z-index: $dropdown-menu-z-index + 2 !default;\r\n\r\n//- Default Text */\r\n$dropdown-default-text-color: $input-placeholder-color !default;\r\n$dropdown-default-text-focus-color: $input-placeholder-focus-color !default;\r\n\r\n//- Loading */\r\n$dropdown-loading-z-index: -1 !default;\r\n\r\n//- Active Menu Item */\r\n$dropdown-active-item-z-index: $dropdown-menu-z-index + 1 !default;\r\n$dropdown-active-item-background: transparent !default;\r\n$dropdown-active-item-box-shadow: none !default;\r\n$dropdown-active-item-font-weight: $bold !default;\r\n$dropdown-active-item-color: $selected-text-color !default;\r\n\r\n//- Selected */\r\n$dropdown-selected-background: $subtle-transparent-black !default;\r\n$dropdown-selected-color: $selected-text-color !default;\r\n\r\n//- Error */\r\n$dropdown-error-label-background: #eacbcb !default;\r\n$dropdown-error-label-color: $error-text-color !default;\r\n\r\n$dropdown-error-item-text-color: $error-text-color !default;\r\n$dropdown-error-item-hover-background: #fff2f2 !default;\r\n$dropdown-error-item-active-background: #fdcfcf !default;\r\n\r\n//- Clearable */\r\n$dropdown-clearable-icon-opacity: 0.8 !default;\r\n$dropdown-clearable-icon-active-opacity: 1 !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Scrolling */\r\n$dropdown-scrolling-menu-width: 100% !default;\r\n$dropdown-scrolling-menu-item-border: none !default;\r\n$dropdown-scrolling-menu-right-item-padding: calc(#{$dropdown-item-horizontal-padding} + #{$scrollbar-width}) !default;\r\n\r\n$dropdown-scrolling-mobile-max-items: 4 !default;\r\n$dropdown-scrolling-tablet-max-items: 6 !default;\r\n$dropdown-scrolling-computer-max-items: 8 !default;\r\n$dropdown-scrolling-widescreen-max-items: 12 !default;\r\n\r\n$dropdown-scrolling-border-em-width: 0 !default; //- 0 / em size */\r\n$dropdown-scrolling-item-height: strip-unit($dropdown-item-vertical-padding * 2) + $dropdown-item-line-height +\r\n  $dropdown-scrolling-border-em-width !default;\r\n$dropdown-scrolling-mobile-max-menu-height: ($dropdown-scrolling-item-height * $dropdown-scrolling-mobile-max-items) !default;\r\n$dropdown-scrolling-tablet-max-menu-height: ($dropdown-scrolling-item-height * $dropdown-scrolling-tablet-max-items) !default;\r\n$dropdown-scrolling-computer-max-menu-height: (\r\n  $dropdown-scrolling-item-height * $dropdown-scrolling-computer-max-items\r\n) !default;\r\n$dropdown-scrolling-widescreen-max-menu-height: (\r\n  $dropdown-scrolling-item-height * $dropdown-selection-widescreen-max-items\r\n) !default;\r\n\r\n//- Upward */\r\n$dropdown-upward-selection-visible-border-radius: $dropdown-selection-visible-connecting-border\r\n  $dropdown-selection-visible-connecting-border $dropdown-border-radius $dropdown-border-radius !default;\r\n$dropdown-upward-menu-box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08) !default;\r\n$dropdown-upward-selection-menu-box-shadow: 0 -2px 3px 0 rgba(0, 0, 0, 0.08) !default;\r\n$dropdown-upward-menu-border-radius: $dropdown-border-radius $dropdown-border-radius 0 0 !default;\r\n$dropdown-upward-selection-hover-box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.05) !default;\r\n$dropdown-upward-selection-visible-box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.08) !default;\r\n$dropdown-upward-selection-active-hover-box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.05) !default;\r\n$dropdown-upward-selection-active-hover-menu-box-shadow: 0 -2px 3px 0 rgba(0, 0, 0, 0.08) !default;\r\n\r\n//- Flyout Direction */\r\n$dropdown-left-menu-icon-float: left !default;\r\n$dropdown-left-menu-icon-margin: $dropdown-item-line-height-offset 0 0 0 !default;\r\n\r\n//- Left */\r\n$dropdown-left-sub-menu-border-radius: $dropdown-border-radius !default;\r\n$dropdown-left-sub-menu-margin: 0 $dropdown-sub-menu-distance-away 0 0 !default;\r\n\r\n//- Simple */\r\n$dropdown-simple-transition-duration: $default-duration !default;\r\n$dropdown-simple-transition: opacity $dropdown-simple-transition-duration $default-easing !default;\r\n\r\n//- Floating */\r\n$dropdown-floating-menu-distance: 0.5em !default;\r\n$dropdown-floating-menu-box-shadow: $floating-shadow !default;\r\n$dropdown-floating-menu-border-radius: $dropdown-border-radius !default;\r\n\r\n//- Pointing */\r\n$dropdown-pointing-arrow-size: $relative7px !default;\r\n$dropdown-pointing-arrow-offset: -($dropdown-pointing-arrow-size / 2) !default;\r\n$dropdown-pointing-arrow-distance-from-edge: 1em !default;\r\n\r\n$dropdown-pointing-arrow-background: $white !default;\r\n$dropdown-pointing-arrow-z-index: 2 !default;\r\n$dropdown-pointing-arrow-box-shadow: (-$dropdown-menu-border-width) (-$dropdown-menu-border-width) 0 0 $dropdown-menu-border-color !default;\r\n\r\n$dropdown-pointing-menu-distance: $mini !default;\r\n$dropdown-pointing-menu-border-radius: $dropdown-border-radius !default;\r\n\r\n//- Pointing Upward */\r\n$dropdown-pointing-upward-menu-border-radius: $dropdown-border-radius !default;\r\n$dropdown-pointing-upward-arrow-box-shadow: $dropdown-menu-border-width $dropdown-menu-border-width 0 0\r\n  $dropdown-menu-border-color !default;\r\n\r\n//--------------- Inverted ---------------*/\r\n\r\n//- General rules and basic dropdowns */\r\n$dropdown-inverted-menu-background: $black !default;\r\n$dropdown-inverted-menu-color: $inverted-muted-text-color !default;\r\n$dropdown-inverted-menu-border-color: $strong-transparent-white !default;\r\n$dropdown-inverted-menu-border: 1px solid $dropdown-inverted-menu-border-color !default;\r\n$dropdown-inverted-menu-box-shadow: none !default;\r\n\r\n$dropdown-inverted-pointing-arrow-background: $black !default;\r\n$dropdown-inverted-pointing-arrow-box-shadow: (-$dropdown-menu-border-width) (-$dropdown-menu-border-width) 0 0 $dropdown-inverted-menu-border-color !default;\r\n\r\n$dropdown-inverted-hovered-item-background: $transparent-white !default;\r\n$dropdown-inverted-hovered-item-color: $dropdown-inverted-menu-color !default;\r\n\r\n$dropdown-inverted-active-item-background: transparent !default;\r\n$dropdown-inverted-active-item-color: $dropdown-inverted-menu-color !default;\r\n$dropdown-inverted-active-item-box-shadow: none !default;\r\n\r\n$dropdown-inverted-selected-background: $strong-transparent-white !default;\r\n$dropdown-inverted-selected-color: $dropdown-inverted-menu-color !default;\r\n\r\n$dropdown-inverted-menu-header-color: $white !default;\r\n$dropdown-inverted-item-description-color: $inverted-unselected-text-color !default;\r\n\r\n$dropdown-inverted-menu-divider-border: $dropdown-menu-divider-size solid $strong-transparent-white !default;\r\n\r\n//- Selection */\r\n$dropdown-inverted-selection-border-color: $strong-transparent-white !default;\r\n$dropdown-inverted-selection-border: 1px solid $dropdown-inverted-selection-border-color !default;\r\n$dropdown-inverted-selection-background: $black !default;\r\n$dropdown-inverted-selection-text-color: $dropdown-inverted-menu-color !default;\r\n$dropdown-inverted-selection-input-text-color: $white !default;\r\n\r\n$dropdown-inverted-selection-hover-border-color: rgba(255, 255, 255, 0.25) !default;\r\n$dropdown-inverted-selection-hover-box-shadow: none !default;\r\n\r\n$dropdown-inverted-default-text-color: $inverted-unselected-text-color !default;\r\n$dropdown-inverted-default-text-focus-color: $inverted-light-text-color !default;\r\n\r\n$dropdown-inverted-selection-visible-text-color: $inverted-text-color !default;\r\n\r\n$dropdown-inverted-selection-text-underlay-icon-opacity: 0.45 !default;\r\n$dropdown-inverted-selection-text-underlay-color: $inverted-light-text-color !default;\r\n\r\n$dropdown-inverted-selection-item-divider: 1px solid #242526 !default;\r\n$dropdown-inverted-selection-visible-border-color: $strong-transparent-white !default;\r\n\r\n$dropdown-inverted-message-color: $inverted-unselected-text-color !default;\r\n\r\n$dropdown-inverted-input-highlight-background: rgba(255, 255, 255, 0.25) !default;\r\n$dropdown-inverted-input-highlight-color: $inverted-muted-text-color !default;\r\n\r\n//- Multiple */\r\n//-$dropdown-inverted-label-background-color: rgba(255, 255, 255, 0.06) !default; $dropdown-inverted-label-background-image: none !default; $dropdown-inverted-label-color: rgba(255, 255, 255, 0.6) !default; $dropdown-inverted-label-box-shadow: 0 0 0 $dropdown-label-border-width rgba(255, 255, 255, 0.16) inset !default;  $dropdown-inverted-label-hover-background-color: rgba(255, 255, 255, 0.12) !default; $dropdown-inverted-label-hover-background-image: none !default; $dropdown-inverted-label-hover-text-color: rgba(255, 255, 255, 0.7) !default;*/\r\n\r\n$dropdown-inverted-label-background-color: rgba(255, 255, 255, 0.7) !default;\r\n$dropdown-inverted-label-background-image: none !default;\r\n$dropdown-inverted-label-color: rgba(0, 0, 0, 1) !default;\r\n$dropdown-inverted-label-box-shadow: 0 0 0 $dropdown-label-border-width rgba(255, 255, 255, 0) inset !default;\r\n\r\n$dropdown-inverted-label-hover-background-color: rgba(255, 255, 255, 0.9) !default;\r\n$dropdown-inverted-label-hover-background-image: none !default;\r\n$dropdown-inverted-label-hover-text-color: $dropdown-inverted-label-color !default;\r\n\r\n$dropdown-inverted-label-icon-opacity: 0.6 !default;\r\n$dropdown-inverted-label-icon-hover-opacity: 0.8 !default;\r\n","\r\n//@-******************************  Video *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n//- Simple */\r\n$embed-background: $light-grey !default;\r\n$embed-transition-duration: 0.5s !default;\r\n$embed-transition-easing: $default-easing !default;\r\n\r\n//- Placeholder */\r\n$embed-placeholder-underlay: $embed-background !default;\r\n\r\n//- Placeholder Overlayed Background */\r\n$embed-placeholder-background: radial-gradient(transparent 45%, rgba(0, 0, 0, 0.3)) !default;\r\n$embed-placeholder-background-opacity: 0.5 !default;\r\n$embed-placeholder-background-transition: opacity $embed-transition-duration $embed-transition-easing !default;\r\n\r\n//- Icon */\r\n$embed-icon-background: $very-strong-transparent-black !default;\r\n$embed-icon-size: 6rem !default;\r\n$embed-icon-transition:\r\n  opacity $embed-transition-duration $embed-transition-easing,\r\n  color $embed-transition-duration $embed-transition-easing\r\n !default;\r\n$embed-icon-color: $white !default;\r\n$embed-icon-shadow:\r\n  0 2px 10px rgba(34, 36, 38, 0.2)\r\n !default;\r\n$embed-icon-z-index: 10 !default;\r\n\r\n//--------------------  States --------------------*/\r\n\r\n//- Hover */\r\n$embed-hover-placeholder-background: $embed-placeholder-background !default;\r\n$embed-hover-placeholder-background-opacity: 1 !default;\r\n$embed-hover-icon-color: $white !default;\r\n\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Aspect Ratios */\r\n$embed-square-ratio: (1/1) * 100% !default;\r\n$embed-widescreen-ratio: (9/16) * 100% !default;\r\n$embed-ultra-widescreen-ratio: (9/21) * 100% !default;\r\n$embed-standard-ratio: (3/4) * 100% !default;\r\n","\r\n//@-******************************  Modal *******************************/\r\n//- Image / Description */\r\n$modal-image-width: '' !default;\r\n$modal-image-icon-size: 8rem !default;\r\n$modal-image-vertical-align: start !default;\r\n\r\n$modal-description-distance: 2em !default;\r\n$modal-description-min-width: '' !default;\r\n$modal-description-width: auto !default;\r\n$modal-description-vertical-align: start !default;\r\n\r\n//- Modal Actions */\r\n$modal-action-border: 1px solid $border-color !default;\r\n$modal-action-background: $off-white !default;\r\n$modal-action-padding: 1rem 1rem !default;\r\n$modal-action-align: right !default;\r\n\r\n$modal-button-distance: 0.75em !default;\r\n\r\n$modal-background: $white !default;\r\n$modal-border: none !default;\r\n$modal-z-index: 1001 !default;\r\n$modal-border-radius: $default-border-radius !default;\r\n$modal-transform-origin: 50% 25% !default;\r\n$modal-box-shadow:\r\n  1px 3px 3px 0 rgba(0, 0, 0, 0.2),\r\n  1px 3px 15px 2px rgba(0, 0, 0, 0.2)\r\n !default;\r\n\r\n//- Close Icon */\r\n$modal-close-opacity: 0.8 !default;\r\n$modal-close-size: 1.25em !default;\r\n$modal-close-color: $white !default;\r\n\r\n$modal-close-hitbox: 2.25rem !default;\r\n$modal-close-distance: 0.25rem !default;\r\n$modal-close-hit-box-offset: ($modal-close-hitbox - 1rem) / 2 !default;\r\n$modal-close-padding: $modal-close-hit-box-offset 0 0 0 !default;\r\n$modal-close-top: -($modal-close-distance + $modal-close-hitbox) !default;\r\n$modal-close-right: -($modal-close-distance + $modal-close-hitbox) !default;\r\n\r\n//- Header */\r\n$modal-header-margin: 0 !default;\r\n$modal-header-vertical-padding: 1.25rem !default;\r\n$modal-header-horizontal-padding: 1.5rem !default;\r\n$modal-header-padding: $modal-header-vertical-padding $modal-header-horizontal-padding !default;\r\n$modal-header-background: $white !default;\r\n$modal-header-color: $dark-text-color !default;\r\n$modal-header-font-size: $huge !default;\r\n$modal-header-box-shadow: none !default;\r\n$modal-header-font-weight: $bold !default;\r\n$modal-header-font-family: $header-font !default;\r\n$modal-header-border: 1px solid $border-color !default;\r\n\r\n//- Content */\r\n$modal-content-font-size: 1em !default;\r\n$modal-content-padding: 1.5rem !default;\r\n$modal-content-line-height: 1.4 !default;\r\n$modal-content-background: #FFFFFF !default;\r\n\r\n\r\n//- Inner Close Position (Tablet/Mobile) */\r\n$modal-inner-close-top: (strip-unit($modal-header-vertical-padding - $modal-close-hit-box-offset) + ($line-height - 1em)) !default;\r\n$modal-inner-close-right: 1rem !default;\r\n$modal-inner-close-color: $text-color !default;\r\n\r\n//- Mobile Positions */\r\n$modal-mobile-header-padding: 0.75rem 1rem !default;\r\n$modal-mobile-content-padding: 1rem !default;\r\n$modal-mobile-image-padding: 0 0 1rem !default;\r\n$modal-mobile-description-padding: 1rem 0  !default;\r\n$modal-mobile-button-distance: 1rem !default;\r\n$modal-mobile-action-padding: 1rem 1rem (1rem - $modal-mobile-button-distance) !default;\r\n$modal-mobile-image-icon-size: 5rem !default;\r\n$modal-mobile-close-top: 0.5rem !default;\r\n$modal-mobile-close-right: 0.5rem !default;\r\n\r\n//- Responsive Widths */\r\n$modal-mobile-width: 95% !default;\r\n$modal-tablet-width: 88% !default;\r\n$modal-computer-width: 850px !default;\r\n$modal-large-monitor-width: 900px !default;\r\n$modal-widescreen-monitor-width: 950px !default;\r\n\r\n$modal-mobile-margin: 0 0 0 0 !default;\r\n$modal-tablet-margin: 0 0 0 0 !default;\r\n$modal-computer-margin: 0 0 0 0 !default;\r\n$modal-large-monitor-margin: 0 0 0 0 !default;\r\n$modal-widescreen-monitor-margin: 0 0 0 0 !default;\r\n\r\n$modal-full-screen-width: 95% !default;\r\n$modal-full-screen-offset: (100% - $modal-full-screen-width) / 2 !default;\r\n$modal-full-screen-margin: 1em auto !default;\r\n\r\n//- Coupling */\r\n$modal-inverted-box-shadow: 1px 3px 10px 2px rgba(0, 0, 0, 0.2) !default;\r\n\r\n//--------------------  States --------------------*/\r\n\r\n$modal-loading-z-index: -1 !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Basic */\r\n$modal-basic-header-color: $white !default;\r\n$modal-basic-color: $white !default;\r\n$modal-basic-close-top: 1rem !default;\r\n$modal-basic-close-right: 1.5rem !default;\r\n$modal-basic-inner-close-color: $white !default;\r\n\r\n$modal-basic-inverted-color: $text-color !default;\r\n$modal-basic-inverted-header-color: $dark-text-color !default;\r\n\r\n//- Aligned */\r\n$modal-top-aligned-margin: 5vh !default;\r\n$modal-mobile-top-aligned-margin: 1rem !default;\r\n$modal-bottom-aligned-margin: $modal-top-aligned-margin !default;\r\n$modal-mobile-bottom-aligned-margin: $modal-mobile-top-aligned-margin !default;\r\n\r\n//- Scrolling Margin */\r\n$modal-scrolling-margin: 1rem !default;\r\n$modal-mobile-scrolling-margin: $modal-mobile-top-aligned-margin !default;\r\n\r\n//- Scrolling Content */\r\n$modal-scrolling-content-max-height: calc(80vh - 10rem) !default;\r\n$modal-overlay-fullscreen-scrolling-content-max-height: calc(100vh - 9.1rem) !default;\r\n$modal-overlay-fullscreen-scrolling-content-max-height-mobile: calc(100vh - 8.1rem) !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Size Widths */\r\n$modal-mini-ratio: 0.4 !default;\r\n$modal-tiny-ratio: 0.6 !default;\r\n$modal-small-ratio: 0.8 !default;\r\n$modal-large-ratio: 1.2 !default;\r\n\r\n//- Derived Responsive Sizes */\r\n$modal-mini-header-size: 1.3em !default;\r\n$modal-mini-mobile-width: $modal-mobile-width !default;\r\n$modal-mini-tablet-width: ($modal-tablet-width * $modal-mini-ratio) !default;\r\n$modal-mini-computer-width: ($modal-computer-width * $modal-mini-ratio) !default;\r\n$modal-mini-large-monitor-width: ($modal-large-monitor-width * $modal-mini-ratio) !default;\r\n$modal-mini-widescreen-monitor-width: ($modal-widescreen-monitor-width * $modal-mini-ratio) !default;\r\n\r\n$modal-mini-mobile-margin: 0 0 0 0 !default;\r\n$modal-mini-tablet-margin: 0 0 0 0 !default;\r\n$modal-mini-computer-margin: 0 0 0 0 !default;\r\n$modal-mini-large-monitor-margin: 0 0 0 0 !default;\r\n$modal-mini-widescreen-monitor-margin: 0 0 0 0 !default;\r\n\r\n$modal-tiny-header-size: 1.3em !default;\r\n$modal-tiny-mobile-width: $modal-mobile-width !default;\r\n$modal-tiny-tablet-width: ($modal-tablet-width * $modal-tiny-ratio) !default;\r\n$modal-tiny-computer-width: ($modal-computer-width * $modal-tiny-ratio) !default;\r\n$modal-tiny-large-monitor-width: ($modal-large-monitor-width * $modal-tiny-ratio) !default;\r\n$modal-tiny-widescreen-monitor-width: ($modal-widescreen-monitor-width * $modal-tiny-ratio) !default;\r\n\r\n$modal-tiny-mobile-margin: 0 0 0 0 !default;\r\n$modal-tiny-tablet-margin: 0 0 0 0 !default;\r\n$modal-tiny-computer-margin: 0 0 0 0 !default;\r\n$modal-tiny-large-monitor-margin: 0 0 0 0 !default;\r\n$modal-tiny-widescreen-monitor-margin: 0 0 0 0 !default;\r\n\r\n$modal-small-header-size: 1.3em !default;\r\n$modal-small-mobile-width: $modal-mobile-width !default;\r\n$modal-small-tablet-width: ($modal-tablet-width * $modal-small-ratio) !default;\r\n$modal-small-computer-width: ($modal-computer-width * $modal-small-ratio) !default;\r\n$modal-small-large-monitor-width: ($modal-large-monitor-width * $modal-small-ratio) !default;\r\n$modal-small-widescreen-monitor-width: ($modal-widescreen-monitor-width * $modal-small-ratio) !default;\r\n\r\n$modal-small-mobile-margin: 0 0 0 0 !default;\r\n$modal-small-tablet-margin: 0 0 0 0 !default;\r\n$modal-small-computer-margin: 0 0 0 0 !default;\r\n$modal-small-large-monitor-margin: 0 0 0 0 !default;\r\n$modal-small-widescreen-monitor-margin: 0 0 0 0 !default;\r\n\r\n$modal-large-header-size: 1.6em !default;\r\n$modal-large-mobile-width: $modal-mobile-width !default;\r\n$modal-large-tablet-width: $modal-tablet-width !default;\r\n$modal-large-computer-width: ($modal-computer-width * $modal-large-ratio) !default;\r\n$modal-large-large-monitor-width: ($modal-large-monitor-width * $modal-large-ratio) !default;\r\n$modal-large-widescreen-monitor-width: ($modal-widescreen-monitor-width * $modal-large-ratio) !default;\r\n\r\n$modal-large-mobile-margin: 0 0 0 0 !default;\r\n$modal-large-tablet-margin: 0 0 0 0 !default;\r\n$modal-large-computer-margin: 0 0 0 0 !default;\r\n$modal-large-large-monitor-margin: 0 0 0 0 !default;\r\n$modal-large-widescreen-monitor-margin: 0 0 0 0 !default;\r\n\r\n//-------------------- Inverted --------------------*/\r\n$modal-inverted-background: rgba(0,0,0,.9) !default;\r\n$modal-inverted-close-color: $white !default;\r\n$modal-inverted-header-color: $white !default;\r\n$modal-inverted-header-background-color: $dark-text-color !default;\r\n$modal-inverted-action-background: #191A1B !default;\r\n$modal-inverted-action-border: 1px solid rgba(34, 36, 38, 0.85) !default;\r\n$modal-inverted-action-color: $white !default;\r\n$modal-inverted-dimmer-close-color: rgba(0,0,0,.85) !default;\r\n","\r\n//@-******************************  Nag *******************************/\r\n\r\n//---------------  Collection ---------------*/\r\n\r\n$nag-position: relative !default;\r\n$nag-width: 100% !default;\r\n$nag-z-index: 999 !default;\r\n$nag-margin: 0 !default;\r\n\r\n$nag-background: #555555 !default;\r\n$nag-opacity: 0.95 !default;\r\n$nag-min-height: 0 !default;\r\n$nag-padding: 0.75em 1em !default;\r\n$nag-line-height: 1em !default;\r\n$nag-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2) !default;\r\n\r\n$nag-font-size: 1rem !default;\r\n$nag-text-align: center !default;\r\n$nag-color: $text-color !default;\r\n\r\n$nag-transition: 0.2s background ease !default;\r\n\r\n\r\n//--------------- Elements ---------------*/\r\n\r\n//- Title */\r\n$nag-title-color: $white !default;\r\n$nag-title-margin: 0 0.5em !default;\r\n\r\n$nag-close-size: 1em !default;\r\n$nag-close-margin: (-$nag-close-size / 2) 0 0 !default;\r\n$nag-close-top: 50% !default;\r\n$nag-close-right: 1em !default;\r\n$nag-close-color: $white !default;\r\n$nag-close-transition: opacity 0.2s ease !default;\r\n$nag-close-opacity: 0.4 !default;\r\n\r\n\r\n//--------------- States ---------------*/\r\n\r\n//- Hover */\r\n$nag-hover-background: $nag-background !default;\r\n$nag-hover-opacity: 1 !default;\r\n\r\n$nag-close-hover-opacity: 1 !default;\r\n\r\n//---------------  Variations ---------------*/\r\n\r\n//- Top / Bottom */\r\n$nag-top: 0 !default;\r\n$nag-bottom: 0 !default;\r\n$nag-border-radius: $default-border-radius !default;\r\n$nag-top-border-radius: 0 0 $nag-border-radius $nag-border-radius !default;\r\n$nag-bottom-border-radius: $nag-border-radius $nag-border-radius 0 0 !default;\r\n\r\n//- Inverted */\r\n$nag-inverted-background: $dark-white !default;\r\n\r\n//--------------- Plural ---------------*/\r\n\r\n$nag-grouped-border-radius: 0 !default;\r\n\r\n","\r\n//@-******************************  Popup *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$popup-z-index: 1900 !default;\r\n$popup-background: $white !default;\r\n\r\n$popup-max-width: 250px !default;\r\n$popup-border-color: $solid-border-color !default;\r\n$popup-border-width: 1px !default;\r\n$popup-box-shadow: $floating-shadow !default;\r\n$popup-color: $text-color !default;\r\n\r\n$popup-vertical-padding: 0.833em !default;\r\n$popup-horizontal-padding: 1em !default;\r\n$popup-font-weight: $normal !default;\r\n$popup-font-style: $normal !default;\r\n$popup-border-radius: $default-border-radius !default;\r\n\r\n//--------------------  Parts --------------------*/\r\n\r\n//- Placement */\r\n$popup-arrow-size: $relative10px !default;\r\n$popup-arrow-width: 1em !default;\r\n$popup-arrow-distance-from-edge: 1em !default;\r\n$popup-box-arrow-offset: 0 !default;\r\n$popup-distance-away: $popup-arrow-size !default;\r\n\r\n\r\n//- Header */\r\n$popup-header-font-family: $header-font !default;\r\n$popup-header-font-weight: $bold !default;\r\n$popup-header-font-size: $relative-large !default;\r\n$popup-header-distance: $relative7px !default;\r\n$popup-header-line-height: 1.2 !default;\r\n\r\n//- Content Border */\r\n$popup-border: $popup-border-width solid $popup-border-color !default;\r\n\r\n//- Arrow */\r\n$popup-arrow-background: $popup-background !default;\r\n$popup-arrow-z-index: 1901 !default;\r\n$popup-arrow-jitter: 0.05em !default;\r\n$popup-arrow-offset: -($popup-arrow-size / 2) + $popup-arrow-jitter !default;\r\n\r\n$popup-arrow-stroke: $popup-border-width !default;\r\n$popup-arrow-color: darken($popup-border-color, 10) !default;\r\n\r\n//- Arrow color by position */\r\n$popup-arrow-top-background: $popup-arrow-background !default;\r\n$popup-arrow-center-background: $popup-arrow-background !default;\r\n$popup-arrow-bottom-background: $popup-arrow-background !default;\r\n\r\n$popup-arrow-box-shadow: $popup-arrow-stroke $popup-arrow-stroke 0 0 $popup-arrow-color !default;\r\n$popup-left-arrow-box-shadow: $popup-arrow-stroke (-$popup-arrow-stroke) 0 0 $popup-arrow-color !default;\r\n$popup-right-arrow-box-shadow: (-$popup-arrow-stroke) $popup-arrow-stroke 0 0 $popup-arrow-color !default;\r\n$popup-bottom-arrow-box-shadow: (-$popup-arrow-stroke) (-$popup-arrow-stroke) 0 0 $popup-arrow-color !default;\r\n\r\n//--------------------  Types --------------------*/\r\n\r\n//- Tooltip */\r\n$popup-tooltip-background: $popup-background !default;\r\n$popup-tooltip-border-radius: $popup-border-radius !default;\r\n$popup-tooltip-padding: $popup-vertical-padding $popup-horizontal-padding !default;\r\n$popup-tooltip-font-weight: $popup-font-weight !default;\r\n$popup-tooltip-font-style: $popup-font-style !default;\r\n$popup-tooltip-color: $popup-color !default;\r\n$popup-tooltip-border: $popup-border !default;\r\n$popup-tooltip-box-shadow: $popup-box-shadow !default;\r\n$popup-tooltip-max-width: none !default;\r\n$popup-tooltip-font-size: $medium !default;\r\n$popup-tooltip-line-height: $line-height !default;\r\n$popup-tooltip-distance-away: $relative7px !default;\r\n$popup-tooltip-z-index: 1900 !default;\r\n$popup-tooltip-duration: $default-duration !default;\r\n$popup-tooltip-easing: $default-easing !default;\r\n\r\n//--------------------  Variations --------------------*/\r\n\r\n//- Wide */\r\n$popup-wide-width: 350px !default;\r\n$popup-very-wide-width: 550px !default;\r\n\r\n//- Inverted */\r\n$popup-inverted-background: $black !default;\r\n$popup-inverted-color: $white !default;\r\n$popup-inverted-border: none !default;\r\n$popup-inverted-box-shadow: none !default;\r\n\r\n$popup-inverted-header-background: none !default;\r\n$popup-inverted-header-color: $white !default;\r\n$popup-inverted-arrow-color: $popup-inverted-background !default;\r\n\r\n//- Arrow color by position */\r\n$popup-inverted-arrow-top-background: $popup-inverted-background !default;\r\n$popup-inverted-arrow-center-background: $popup-inverted-background !default;\r\n$popup-inverted-arrow-bottom-background: $popup-inverted-background !default;\r\n\r\n//- Inverted */\r\n$popup-tooltip-inverted-background: $popup-inverted-background !default;\r\n$popup-tooltip-inverted-color: $popup-inverted-color !default;\r\n$popup-tooltip-inverted-border: $popup-inverted-border !default;\r\n$popup-tooltip-inverted-box-shadow: $popup-inverted-box-shadow !default;\r\n$popup-tooltip-inverted-header-background: $popup-inverted-header-background !default;\r\n$popup-tooltip-inverted-header-color: $popup-inverted-header-color !default;\r\n\r\n//- Arrow */\r\n$popup-tooltip-arrow-vertical-offset: -$_2px !default;\r\n$popup-tooltip-arrow-horizontal-offset: -$_1px !default;\r\n$popup-tooltip-arrow-box-shadow: $popup-arrow-box-shadow !default;\r\n$popup-tooltip-arrow-background: $popup-arrow-background !default;\r\n$popup-tooltip-arrow-top-background: $popup-arrow-top-background !default;\r\n$popup-tooltip-arrow-center-background: $popup-arrow-center-background !default;\r\n$popup-tooltip-arrow-bottom-background: $popup-arrow-bottom-background !default;\r\n\r\n//--------------------  Coupling --------------------*/\r\n\r\n//- Grid Inside Popup */\r\n$popup-nested-grid-margin: (-0.7rem) (-0.875rem) !default; //- (padding * $medium) */\r\n$popup-nested-grid-width: calc(100% + 1.75rem) !default;\r\n\r\n//--------------------  States --------------------*/\r\n\r\n$popup-loading-z-index: -1 !default;\r\n\r\n","\r\n//@-****************************** Progress *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n//- Label */\r\n$progress-label-width: 100% !default;\r\n$progress-label-height: 1.5em !default;\r\n$progress-label-size: 1em !default;\r\n$progress-label-position: absolute !default;\r\n$progress-label-top: 100% !default;\r\n$progress-label-left: 0 !default;\r\n$progress-label-right: auto !default;\r\n$progress-label-bottom: auto !default;\r\n$progress-label-offset: ($progress-label-height - 1.3em) !default;\r\n$progress-label-color: $text-color !default;\r\n$progress-label-text-shadow: none !default;\r\n$progress-label-font-weight: $bold !default;\r\n$progress-label-text-align: center !default;\r\n$progress-label-transition: color 0.4s $default-easing !default;\r\n\r\n$progress-vertical-spacing: 1em !default;\r\n$progress-margin: $progress-vertical-spacing 0 ($progress-label-height + $progress-vertical-spacing) !default;\r\n$progress-first-margin: 0 0 ($progress-label-height + $progress-vertical-spacing) !default;\r\n$progress-last-margin: 0 0 ($progress-label-height) !default;\r\n\r\n$progress-background: $strong-transparent-black !default;\r\n$progress-border: none !default;\r\n$progress-box-shadow: none !default;\r\n$progress-padding: 0 !default;\r\n$progress-border-radius: $default-border-radius !default;\r\n\r\n//- Bar */\r\n$progress-bar-position: relative !default;\r\n$progress-bar-height: 1.75em !default;\r\n$progress-bar-background: #888888 !default;\r\n$progress-bar-border-radius: $progress-border-radius !default;\r\n$progress-bar-transition-easing: $default-easing !default;\r\n$progress-bar-transition-duration: $default-duration !default;\r\n$progress-bar-transition:\r\n  width $progress-bar-transition-duration $progress-bar-transition-easing,\r\n  background-color $progress-bar-transition-duration $progress-bar-transition-easing\r\n !default;\r\n$progress-bar-initial-width: 0 !default;\r\n$progress-bar-min-width: 2em !default;\r\n\r\n//- Progress Bar Label */\r\n$progress-width: auto !default;\r\n$progress-size: $relative-small !default;\r\n$progress-position: absolute !default;\r\n$progress-top: 50% !default;\r\n$progress-right: 0.5em !default;\r\n$progress-left: auto !default;\r\n$progress-bottom: auto !default;\r\n$progress-offset: -0.5em !default;\r\n$progress-color: $inverted-light-text-color !default;\r\n$progress-text-shadow: none !default;\r\n$progress-font-weight: $bold !default;\r\n$progress-text-align: left !default;\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n$progress-indicating-first-color: #D95C5C !default;\r\n$progress-indicating-second-color: #EFBC72 !default;\r\n$progress-indicating-third-color: #E6BB48 !default;\r\n$progress-indicating-fourth-color: #DDC928 !default;\r\n$progress-indicating-fifth-color: #B4D95C !default;\r\n$progress-indicating-sixth-color: #66DA81 !default;\r\n\r\n$progress-indicating-first-label-color: $text-color !default;\r\n$progress-indicating-second-label-color: $text-color !default;\r\n$progress-indicating-third-label-color: $text-color !default;\r\n$progress-indicating-fourth-label-color: $text-color !default;\r\n$progress-indicating-fifth-label-color: $text-color !default;\r\n$progress-indicating-sixth-label-color: $text-color !default;\r\n\r\n$progress-inverted-indicating-first-label-color: $inverted-text-color !default;\r\n$progress-inverted-indicating-second-label-color: $inverted-text-color !default;\r\n$progress-inverted-indicating-third-label-color: $inverted-text-color !default;\r\n$progress-inverted-indicating-fourth-label-color: $inverted-text-color !default;\r\n$progress-inverted-indicating-fifth-label-color: $inverted-text-color !default;\r\n$progress-inverted-indicating-sixth-label-color: $inverted-text-color !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n//- Active */\r\n$progress-active-pulse-color: $white !default;\r\n$progress-active-pulse-max-opacity: 0.3 !default;\r\n$progress-active-pulse-duration: 2s !default;\r\n$progress-active-min-width: $progress-bar-min-width !default;\r\n\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Attached */\r\n$progress-attached-background: transparent !default;\r\n$progress-attached-height: 0.2rem !default;\r\n$progress-attached-border-radius: $progress-border-radius !default;\r\n\r\n//- Inverted */\r\n$progress-inverted-background: $transparent-white !default;\r\n$progress-inverted-border: none !default;\r\n$progress-inverted-bar-background: $progress-bar-background !default;\r\n$progress-inverted-color: $black !default;\r\n$progress-inverted-label-color: $white !default;\r\n\r\n//- Sizing */\r\n$progress-tiny-bar-height: 0.5em !default;\r\n$progress-small-bar-height: 1em !default;\r\n$progress-large-bar-height: 2.5em !default;\r\n$progress-big-bar-height: 3.5em !default;\r\n\r\n//- Indeterminate */\r\n$progress-indeterminate-pulse-color: $white !default;\r\n$progress-indeterminate-pulse-duration: $progress-active-pulse-duration !default;\r\n$progress-indeterminate-pulse-duration-slow: 4s !default;\r\n$progress-indeterminate-pulse-duration-fast: 1s !default;\r\n","$positive-header-color: #1a531b !default;\r\n$success-header-color: $positive-header-color !default;\r\n\r\n$negative-header-color: #912d2b !default;\r\n$error-header-color: $negative-header-color !default;\r\n\r\n$info-header-color: #0e566c !default;\r\n\r\n$warning-header-color: #794b02 !default;\r\n","\r\n//@-******************************  Rating *******************************/\r\n\r\n$rating-margin: 0 $relative-mini !default;\r\n$rating-white-space: nowrap !default;\r\n$rating-vertical-align: baseline !default;\r\n\r\n$rating-icon-cursor: pointer !default;\r\n$rating-icon-width: 1.25em !default;\r\n$rating-icon-height: auto !default;\r\n$rating-icon-transition:\r\n  opacity $default-duration $default-easing,\r\n  background $default-duration $default-easing,\r\n  text-shadow $default-duration $default-easing,\r\n  color $default-duration $default-easing\r\n !default;\r\n\r\n\r\n//-------------------- Types --------------------*/\r\n\r\n//- Standard */\r\n$rating-inactive-background: transparent !default;\r\n$rating-inactive-color: rgba(0, 0, 0, 0.15) !default;\r\n\r\n$rating-selected-background: $rating-inactive-background !default;\r\n$rating-selected-color: $text-color !default;\r\n\r\n$rating-active-background: $rating-inactive-background !default;\r\n$rating-active-color: $dark-text-color !default;\r\n\r\n$rating-shadow-width: 1px !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n$rating-interactive-active-icon-opacity: 1 !default;\r\n$rating-interactive-selected-icon-opacity: 1 !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n$rating-massive: 2rem !default;\r\n","\r\n//@-****************************** Search *******************************/\r\n\r\n//- Search Prompt */\r\n$search-prompt-background: $input-background !default;\r\n$search-prompt-vertical-padding: $input-vertical-padding !default;\r\n$search-prompt-horizontal-padding: $input-horizontal-padding !default;\r\n$search-prompt-line-height: $input-line-height !default;\r\n$search-prompt-font-size: $relative-medium !default;\r\n$search-prompt-padding: ($search-prompt-vertical-padding + ((1em - $search-prompt-line-height) / 2)) $search-prompt-horizontal-padding !default;\r\n$search-prompt-border: 1px solid $border-color !default;\r\n$search-prompt-border-radius: $circular-radius !default;\r\n$search-prompt-color: $text-color !default;\r\n$search-prompt-transition:\r\n  background-color $default-duration $default-easing,\r\n  color $default-duration $default-easing,\r\n  box-shadow $default-duration $default-easing,\r\n  border-color $default-duration $default-easing\r\n !default;\r\n$search-prompt-box-shadow: 0 0 0 0 transparent inset !default;\r\n\r\n//- Mobile */\r\n$search-mobile-max-width: calc(100vw - 2rem) !default;\r\n\r\n//- Result Box */\r\n$search-results-width: 18em !default;\r\n$search-results-background: #FFFFFF !default;\r\n$search-results-distance: 0.5em !default;\r\n$search-results-border-radius: $default-border-radius !default;\r\n$search-results-border: 1px solid $solid-border-color !default;\r\n$search-results-box-shadow: $floating-shadow !default;\r\n\r\n//- Result */\r\n$search-result-font-size: 1em !default;\r\n$search-result-vertical-padding: $relative-tiny !default;\r\n$search-result-horizontal-padding: $relative-large !default;\r\n$search-result-padding: $search-result-vertical-padding $search-result-horizontal-padding !default;\r\n$search-result-text-color: $text-color !default;\r\n$search-result-line-height: 1.33 !default;\r\n$search-result-divider: 1px solid $internal-border-color !default;\r\n$search-result-last-divider: none !default;\r\n\r\n//- Result Image */\r\n$search-result-image-float: right !default;\r\n$search-result-image-background: none !default;\r\n$search-result-image-width: 5em !default;\r\n$search-result-image-height: 3em !default;\r\n$search-result-image-border-radius: 0.25em !default;\r\n$search-result-image-margin: 0 6em 0 0 !default;\r\n\r\n//- Result Content */\r\n$search-result-title-font: $header-font !default;\r\n$search-result-title-margin: (-$header-line-height-offset) 0 0 !default;\r\n$search-result-title-font-weight: $bold !default;\r\n$search-result-title-font-size: $relative-medium !default;\r\n$search-result-title-color: $dark-text-color !default;\r\n\r\n//- Description */\r\n$search-result-description-font-size: $relative-small !default;\r\n$search-result-description-distance: 0 !default;\r\n$search-result-description-color: $light-text-color !default;\r\n\r\n//- Price */\r\n$search-result-price-float: right !default;\r\n$search-result-price-color: $green !default;\r\n\r\n//- Special Message */\r\n$search-message-vertical-padding: 1em !default;\r\n$search-message-horizontal-padding: 1em !default;\r\n$search-message-header-font-size: $medium !default;\r\n$search-message-header-font-weight: $bold !default;\r\n$search-message-header-color: $text-color !default;\r\n$search-message-description-distance: 0.25rem !default;\r\n$search-message-description-font-size: 1em !default;\r\n$search-message-description-color: $text-color !default;\r\n\r\n//- All Results Link */\r\n$search-action-border: none !default;\r\n$search-action-background: $dark-white !default;\r\n$search-action-padding: $relative-small $relative-medium !default;\r\n$search-action-color: $text-color !default;\r\n$search-action-font-weight: $bold !default;\r\n$search-action-align: center !default;\r\n\r\n\r\n//-****************************** States *******************************/\r\n\r\n//- Focus */\r\n$search-prompt-focus-background: $search-prompt-background !default;\r\n$search-prompt-focus-border-color: $selected-border-color !default;\r\n$search-prompt-focus-color: $selected-text-color !default;\r\n\r\n//- Hover */\r\n$search-result-hover-background: $off-white !default;\r\n$search-action-hover-background: #E0E0E0 !default;\r\n\r\n//- Loading */\r\n$search-inverted-loader-fill-color: rgba(0, 0, 0, 0.15) !default;\r\n\r\n//- Active Category */\r\n$search-category-active-background: $dark-white !default;\r\n$search-category-name-active-color: $text-color !default;\r\n\r\n//- Active Result */\r\n$search-result-active-border-left: $internal-border-color !default;\r\n$search-result-active-background: $dark-white !default;\r\n$search-result-active-box-shadow: none !default;\r\n$search-result-active-title-color: $dark-text-color !default;\r\n$search-result-active-description-color: $dark-text-color !default;\r\n$search-results-z-index: 998 !default;\r\n\r\n\r\n//-****************************** Types *******************************/\r\n\r\n//- Selection */\r\n$search-selection-prompt-border-radius: $default-border-radius !default;\r\n\r\n$search-selection-close-top: 0 !default;\r\n$search-selection-close-transition:\r\n  color $default-duration $default-easing,\r\n  opacity $default-duration $default-easing\r\n !default;\r\n$search-selection-close-right: 0 !default;\r\n$search-selection-close-icon-opacity: 0.8 !default;\r\n$search-selection-close-icon-color: '' !default;\r\n$search-selection-close-icon-hover-opacity: 1 !default;\r\n$search-selection-close-icon-hover-color: $red !default;\r\n\r\n$search-selection-close-icon-input-right: 1.85714em !default;\r\n\r\n//- Category */\r\n$search-category-background: $dark-white !default;\r\n$search-category-box-shadow: none !default;\r\n$search-category-divider: 1px solid $internal-border-color !default;\r\n$search-category-transition:\r\n  background $default-duration $default-easing,\r\n  border-color $default-duration $default-easing\r\n !default;\r\n\r\n$search-category-results-width: 28em !default;\r\n\r\n$search-category-result-background: $white !default;\r\n$search-category-result-left-border: 1px solid $border-color !default;\r\n$search-category-result-divider: $search-result-divider !default;\r\n$search-category-result-last-divider: none !default;\r\n$search-category-result-padding: $search-result-padding !default;\r\n$search-category-result-transition: $search-category-transition !default;\r\n\r\n$search-category-name-width: 100px !default;\r\n$search-category-name-background: transparent !default;\r\n$search-category-name-font: $page-font !default;\r\n$search-category-name-font-size: 1em !default;\r\n$search-category-name-whitespace: nowrap !default;\r\n$search-category-name-padding: 0.4em 1em !default;\r\n$search-category-name-font-weight: $bold !default;\r\n$search-category-name-color: $light-text-color !default;\r\n","\r\n//@-******************************  Shape *******************************/\r\n\r\n$shape-display: inline-block !default;\r\n\r\n//- Animating */\r\n$shape-perspective: 2000px !default;\r\n\r\n$shape-duration: 0.6s !default;\r\n$shape-easing: ease-in-out !default;\r\n\r\n$shape-hidden-side-opacity: 0.6 !default;\r\n$shape-animating-z-index: 100 !default;\r\n\r\n$shape-transition:\r\n  transform $shape-duration $shape-easing,\r\n  left $shape-duration $shape-easing,\r\n  width $shape-duration $shape-easing,\r\n  height $shape-duration $shape-easing\r\n !default;\r\n$shape-side-transition: opacity $shape-duration $shape-easing !default;\r\n$shape-backface-visibility: hidden !default;\r\n\r\n//- Side */\r\n$shape-side-margin: 0 !default;\r\n\r\n//--------------- Types ---------------*/\r\n\r\n//- Cube */\r\n$shape-cube-size: 15em !default;\r\n$shape-cube-background: #E6E6E6 !default;\r\n$shape-cube-padding: 2em !default;\r\n$shape-cube-text-color: $text-color !default;\r\n$shape-cube-box-shadow: 0 0 2px rgba(0, 0, 0, 0.3) !default;\r\n\r\n$shape-cube-text-align: center !default;\r\n$shape-cube-font-size: 2em !default;\r\n","\r\n//@-******************************  Sidebar *******************************/\r\n\r\n//--------------------  Content --------------------*/\r\n\r\n//- Animation */\r\n$sidebar-perspective: 1500px !default;\r\n$sidebar-duration: 500ms !default;\r\n$sidebar-easing: $default-easing !default;\r\n\r\n//- Dimmer */\r\n$sidebar-dimmer-color: rgba(0, 0, 0, 0.4) !default;\r\n$sidebar-dimmer-transition: opacity $sidebar-duration !default;\r\n\r\n//- Color below page */\r\n$sidebar-canvas-background: $light-black !default;\r\n\r\n//- Shadow */\r\n$sidebar-box-shadow: 0 0 20px $border-color !default;\r\n$sidebar-horizontal-box-shadow: $sidebar-box-shadow !default;\r\n$sidebar-vertical-box-shadow: $sidebar-box-shadow !default;\r\n\r\n//- Layering */\r\n$sidebar-bottom-layer: 1 !default;\r\n$sidebar-middle-layer: 2 !default;\r\n$sidebar-fixed-layer: 101 !default;\r\n$sidebar-top-layer: 102 !default;\r\n$sidebar-dimmer-layer: 1000 !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Width */\r\n$sidebar-very-thin-width: 60px !default;\r\n$sidebar-thin-width: 150px !default;\r\n$sidebar-width: 260px !default;\r\n$sidebar-wide-width: 350px !default;\r\n$sidebar-very-wide-width: 475px !default;\r\n\r\n//- Height */\r\n$sidebar-height: 36px !default;\r\n","\r\n//@-****************************** Slider Variables *******************************/\r\n\r\n//--------------------  Element --------------------*/\r\n\r\n$slider-height        : 1.5em !default;\r\n$slider-hover-pointer  : auto !default;\r\n$slider-padding       : 1em .5em !default;\r\n\r\n//- Track */\r\n$slider-track-height        : .4em !default;\r\n$slider-track-position-top   : ($slider-height / 2) - ($slider-track-height / 2) !default;\r\n$slider-background         : #ccc !default;\r\n$slider-track-border-radius  : 4px !default;\r\n$slider-track-color         : $transparent-black !default;\r\n\r\n//- Track Fill */\r\n$slider-track-fill-height             : $slider-track-height !default;\r\n$slider-track-fill-color              : $black !default;\r\n$slider-track-fill-color-focus         : $black-hover !default;\r\n$slider-inverted-track-fill-color      : $light-black !default;\r\n$slider-inverted-track-fill-color-focus : $light-black-hover !default;\r\n$slider-track-fill-border-radius       : $slider-track-border-radius !default;\r\n\r\n//- Thumb */\r\n$slider-thumb-height              : $slider-height !default;\r\n$slider-thumb-border-radius        : 100% !default;\r\n$slider-thumb-background          : $white $subtle-gradient !default;\r\n$slider-thumb-shadow              : $subtle-shadow, 0 0 0 1px $border-color inset !default;\r\n$slider-thumb-transition-duration  : 0.3s !default;\r\n$slider-thumb-transition          : background $slider-thumb-transition-duration $default-easing !default;\r\n\r\n//- Thumb Hover */\r\n$slider-thumb-hover-pointer    : pointer !default;\r\n$slider-thumb-hover-background : $white-hover $subtle-gradient !default;\r\n\r\n//-------------------- States --------------------*/\r\n\r\n//- Disabled */\r\n$slider-disabled-opactiy        : .5 !default;\r\n$slider-disabled-track-fill-color : $slider-background !default;\r\n\r\n//-------------------- Variations --------------------*/\r\n\r\n//- Vertical */\r\n$slider-vertical-padding : .5em 1em !default;\r\n\r\n//- Labeled */\r\n$slider-label-height  : $slider-height !default;\r\n$slider-label-width   : 1px !default;\r\n$slider-label-color   : $slider-background !default;\r\n\r\n//- Hover */\r\n$slider-hover-var-opacity                 : 0 !default;\r\n$slider-hover-var-hover-opacity            : 1 !default;\r\n$slider-hover-opacity-transition-duration  : 0.2s !default;\r\n$slider-hover-opacity-transition          : opacity $slider-hover-opacity-transition-duration linear !default;\r\n\r\n//- Sizing */\r\n$slider-small-height            : 1em !default;\r\n$slider-small-label-height       : $slider-small-height !default;\r\n$slider-small-track-height       : 0.3em !default;\r\n$slider-track-position-top-small  : ($slider-small-height / 2) - ($slider-small-track-height / 2) !default;\r\n\r\n$slider-large-height            : 2em !default;\r\n$slider-large-label-height       : $slider-large-height !default;\r\n$slider-large-track-height       : 0.5em !default;\r\n$slider-track-position-top-large  : ($slider-large-height / 2) - ($slider-large-track-height / 2) !default;\r\n\r\n$slider-big-height              : 2.5em !default;\r\n$slider-big-label-height         : $slider-big-height !default;\r\n$slider-big-track-height         : 0.6em !default;\r\n$slider-track-position-top-big    : ($slider-big-height / 2) - ($slider-big-track-height / 2) !default;\r\n","\r\n//@-****************************** Sticky *******************************/\r\n\r\n$sticky-transition-duration: $default-duration !default;\r\n$sticky-transition: none !default;\r\n$sticky-z-index: 800 !default;","\r\n//@-****************************** Tab *******************************/\r\n\r\n//- Loading */\r\n$tab-loading-min-height: 250px !default;\r\n$tab-loading-content-position: relative !default;\r\n$tab-loading-content-offset: -10000px !default;\r\n\r\n$tab-loader-distance-from-top: 50% !default;\r\n$tab-loader-size: 2.5em !default;\r\n","\r\n//@-****************************** Toast *******************************/\r\n\r\n//- Container */\r\n$toast-container-distance: $relative12px !default;\r\n\r\n//- Toast */\r\n$toast-width: 300px !default;\r\n$toast-border-radius: $default-border-radius !default;\r\n$toast-padding: $input-padding !default;\r\n$toast-margin-bottom: 6px !default;\r\n$toast-margin: 0 0 $toast-margin-bottom !default;\r\n$toast-text-color: $inverted-text-color !default;\r\n$toast-inverted-text-color: $text-color !default;\r\n\r\n//- on Hover */\r\n$toast-opacity-on-hover: 1 !default;\r\n$toast-cursor-on-hover: pointer !default;\r\n\r\n//- Color variations */\r\n$toast-info-color: $info-color !default;\r\n$toast-warning-color: $warning-color !default;\r\n$toast-error-color: $error-color !default;\r\n$toast-success-color: $success-color !default;\r\n\r\n//- Icon */\r\n$toast-icon-content-padding: 3em !default;\r\n$toast-icon-vertical-align: middle !default;\r\n$toast-icon-font-size: 1.5em !default;\r\n\r\n//- Content */\r\n$toast-content-vertical-align: middle !default;\r\n\r\n//- Progressbar Colors */\r\n$toast-info-progress-color: darken($toast-info-color,15) !default;\r\n$toast-warning-progress-color: darken($toast-warning-color,15) !default;\r\n$toast-error-progress-color: darken($toast-error-color,15) !default;\r\n$toast-success-progress-color: darken($toast-success-color,15) !default;\r\n\r\n//- Close Icon */\r\n$toast-close-top-distance: 0.3em !default;\r\n$toast-close-right-distance: 0.3em !default;\r\n$toast-close-opacity: 0.7 !default;\r\n$toast-close-transition: opacity $default-duration $default-easing !default;\r\n","\r\n//@-****************************** Transition *******************************/\r\n\r\n$transition-default-easing: $default-easing !default;\r\n$transition-default-fill: both !default;\r\n$transition-default-duration: 300ms !default;\r\n\r\n$transition-use3-d-acceleration: translateZ(0) !default;\r\n$transition-backface-visibility: hidden !default;","$default-duration: 0.1s !default;\r\n$default-easing: ease !default;\r\n","$black: #000000;\n$white: #ffffff;\n$semi-transparent-white: #ffffff22;\n\n$blue: #003662;\n$blue-light: #285274;\n$blue-bright: #e7f5ff;\n$blue-links: #0296ff;\n\n$red: #e52330;\n$red-dark: #940e19;\n\n$green: #c7cd04;\n$green-dark: #9D9f20;\n$green-light: #edf6ea;\n\n$purple-light: #f8f1fa;\n\n$orange-dark: #ff6600;\n$orange-light: #fff4e7;\n\n$tint-editorial: $blue-bright;\n$tint-opinions: $green-light;\n$tint-misc: $purple-light;\n$tint-advertorial: $orange-light;\n\n$link-color: var(--bodytext-link-color);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
